(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],2:[function(require,module,exports){
/*
* Project: Bootstrap Notify = v3.1.3
* Description: Turns standard Bootstrap alerts into "Growl-like" notifications.
* Author: Mouse0270 aka Robert McIntosh
* License: MIT License
* Website: https://github.com/mouse0270/bootstrap-growl
*/
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {
	// Create the defaults once
	var defaults = {
			element: 'body',
			position: null,
			type: "info",
			allow_dismiss: true,
			newest_on_top: false,
			showProgressbar: false,
			placement: {
				from: "top",
				align: "right"
			},
			offset: 20,
			spacing: 10,
			z_index: 1031,
			delay: 5000,
			timer: 1000,
			url_target: '_blank',
			mouse_over: null,
			animate: {
				enter: 'animated fadeInDown',
				exit: 'animated fadeOutUp'
			},
			onShow: null,
			onShown: null,
			onClose: null,
			onClosed: null,
			icon_type: 'class',
			template: '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">&times;</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
		};

	String.format = function() {
		var str = arguments[0];
		for (var i = 1; i < arguments.length; i++) {
			str = str.replace(RegExp("\\{" + (i - 1) + "\\}", "gm"), arguments[i]);
		}
		return str;
	};

	function Notify ( element, content, options ) {
		// Setup Content of Notify
		var content = {
			content: {
				message: typeof content == 'object' ? content.message : content,
				title: content.title ? content.title : '',
				icon: content.icon ? content.icon : '',
				url: content.url ? content.url : '#',
				target: content.target ? content.target : '-'
			}
		};

		options = $.extend(true, {}, content, options);
		this.settings = $.extend(true, {}, defaults, options);
		this._defaults = defaults;
		if (this.settings.content.target == "-") {
			this.settings.content.target = this.settings.url_target;
		}
		this.animations = {
			start: 'webkitAnimationStart oanimationstart MSAnimationStart animationstart',
			end: 'webkitAnimationEnd oanimationend MSAnimationEnd animationend'
		}

		if (typeof this.settings.offset == 'number') {
		    this.settings.offset = {
		    	x: this.settings.offset,
		    	y: this.settings.offset
		    };
		}

		this.init();
	};

	$.extend(Notify.prototype, {
		init: function () {
			var self = this;

			this.buildNotify();
			if (this.settings.content.icon) {
				this.setIcon();
			}
			if (this.settings.content.url != "#") {
				this.styleURL();
			}
			this.styleDismiss();
			this.placement();
			this.bind();

			this.notify = {
				$ele: this.$ele,
				update: function(command, update) {
					var commands = {};
					if (typeof command == "string") {
						commands[command] = update;
					}else{
						commands = command;
					}
					for (var command in commands) {
						switch (command) {
							case "type":
								this.$ele.removeClass('alert-' + self.settings.type);
								this.$ele.find('[data-notify="progressbar"] > .progress-bar').removeClass('progress-bar-' + self.settings.type);
								self.settings.type = commands[command];
								this.$ele.addClass('alert-' + commands[command]).find('[data-notify="progressbar"] > .progress-bar').addClass('progress-bar-' + commands[command]);
								break;
							case "icon":
								var $icon = this.$ele.find('[data-notify="icon"]');
								if (self.settings.icon_type.toLowerCase() == 'class') {
									$icon.removeClass(self.settings.content.icon).addClass(commands[command]);
								}else{
									if (!$icon.is('img')) {
										$icon.find('img');
									}
									$icon.attr('src', commands[command]);
								}
								break;
							case "progress":
								var newDelay = self.settings.delay - (self.settings.delay * (commands[command] / 100));
								this.$ele.data('notify-delay', newDelay);
								this.$ele.find('[data-notify="progressbar"] > div').attr('aria-valuenow', commands[command]).css('width', commands[command] + '%');
								break;
							case "url":
								this.$ele.find('[data-notify="url"]').attr('href', commands[command]);
								break;
							case "target":
								this.$ele.find('[data-notify="url"]').attr('target', commands[command]);
								break;
							default:
								this.$ele.find('[data-notify="' + command +'"]').html(commands[command]);
						};
					}
					var posX = this.$ele.outerHeight() + parseInt(self.settings.spacing) + parseInt(self.settings.offset.y);
					self.reposition(posX);
				},
				close: function() {
					self.close();
				}
			};
		},
		buildNotify: function () {
			var content = this.settings.content;
			this.$ele = $(String.format(this.settings.template, this.settings.type, content.title, content.message, content.url, content.target));
			this.$ele.attr('data-notify-position', this.settings.placement.from + '-' + this.settings.placement.align);
			if (!this.settings.allow_dismiss) {
				this.$ele.find('[data-notify="dismiss"]').css('display', 'none');
			}
			if ((this.settings.delay <= 0 && !this.settings.showProgressbar) || !this.settings.showProgressbar) {
				this.$ele.find('[data-notify="progressbar"]').remove();
			}
		},
		setIcon: function() {
			if (this.settings.icon_type.toLowerCase() == 'class') {
				this.$ele.find('[data-notify="icon"]').addClass(this.settings.content.icon);
			}else{
				if (this.$ele.find('[data-notify="icon"]').is('img')) {
					this.$ele.find('[data-notify="icon"]').attr('src', this.settings.content.icon);
				}else{
					this.$ele.find('[data-notify="icon"]').append('<img src="'+this.settings.content.icon+'" alt="Notify Icon" />');
				}
			}
		},
		styleDismiss: function() {
			this.$ele.find('[data-notify="dismiss"]').css({
				position: 'absolute',
				right: '10px',
				top: '5px',
				zIndex: this.settings.z_index + 2
			});
		},
		styleURL: function() {
			this.$ele.find('[data-notify="url"]').css({
				backgroundImage: 'url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)',
				height: '100%',
				left: '0px',
				position: 'absolute',
				top: '0px',
				width: '100%',
				zIndex: this.settings.z_index + 1
			});
		},
		placement: function() {
			var self = this,
				offsetAmt = this.settings.offset.y,
				css = {
					display: 'inline-block',
					margin: '0px auto',
					position: this.settings.position ?  this.settings.position : (this.settings.element === 'body' ? 'fixed' : 'absolute'),
					transition: 'all .5s ease-in-out',
					zIndex: this.settings.z_index
				},
				hasAnimation = false,
				settings = this.settings;

			$('[data-notify-position="' + this.settings.placement.from + '-' + this.settings.placement.align + '"]:not([data-closing="true"])').each(function() {
				return offsetAmt = Math.max(offsetAmt, parseInt($(this).css(settings.placement.from)) +  parseInt($(this).outerHeight()) +  parseInt(settings.spacing));
			});
			if (this.settings.newest_on_top == true) {
				offsetAmt = this.settings.offset.y;
			}
			css[this.settings.placement.from] = offsetAmt+'px';

			switch (this.settings.placement.align) {
				case "left":
				case "right":
					css[this.settings.placement.align] = this.settings.offset.x+'px';
					break;
				case "center":
					css.left = 0;
					css.right = 0;
					break;
			}
			this.$ele.css(css).addClass(this.settings.animate.enter);
			$.each(Array('webkit-', 'moz-', 'o-', 'ms-', ''), function(index, prefix) {
				self.$ele[0].style[prefix+'AnimationIterationCount'] = 1;
			});

			$(this.settings.element).append(this.$ele);

			if (this.settings.newest_on_top == true) {
				offsetAmt = (parseInt(offsetAmt)+parseInt(this.settings.spacing)) + this.$ele.outerHeight();
				this.reposition(offsetAmt);
			}

			if ($.isFunction(self.settings.onShow)) {
				self.settings.onShow.call(this.$ele);
			}

			this.$ele.one(this.animations.start, function(event) {
				hasAnimation = true;
			}).one(this.animations.end, function(event) {
				if ($.isFunction(self.settings.onShown)) {
					self.settings.onShown.call(this);
				}
			});

			setTimeout(function() {
				if (!hasAnimation) {
					if ($.isFunction(self.settings.onShown)) {
						self.settings.onShown.call(this);
					}
				}
			}, 600);
		},
		bind: function() {
			var self = this;

			this.$ele.find('[data-notify="dismiss"]').on('click', function() {
				self.close();
			})

			this.$ele.mouseover(function(e) {
				$(this).data('data-hover', "true");
			}).mouseout(function(e) {
				$(this).data('data-hover', "false");
			});
			this.$ele.data('data-hover', "false");

			if (this.settings.delay > 0) {
				self.$ele.data('notify-delay', self.settings.delay);
				var timer = setInterval(function() {
					var delay = parseInt(self.$ele.data('notify-delay')) - self.settings.timer;
					if ((self.$ele.data('data-hover') === 'false' && self.settings.mouse_over == "pause") || self.settings.mouse_over != "pause") {
						var percent = ((self.settings.delay - delay) / self.settings.delay) * 100;
						self.$ele.data('notify-delay', delay);
						self.$ele.find('[data-notify="progressbar"] > div').attr('aria-valuenow', percent).css('width', percent + '%');
					}
					if (delay <= -(self.settings.timer)) {
						clearInterval(timer);
						self.close();
					}
				}, self.settings.timer);
			}
		},
		close: function() {
			var self = this,
				$successors = null,
				posX = parseInt(this.$ele.css(this.settings.placement.from)),
				hasAnimation = false;

			this.$ele.data('closing', 'true').addClass(this.settings.animate.exit);
			self.reposition(posX);

			if ($.isFunction(self.settings.onClose)) {
				self.settings.onClose.call(this.$ele);
			}

			this.$ele.one(this.animations.start, function(event) {
				hasAnimation = true;
			}).one(this.animations.end, function(event) {
				$(this).remove();
				if ($.isFunction(self.settings.onClosed)) {
					self.settings.onClosed.call(this);
				}
			});

			setTimeout(function() {
				if (!hasAnimation) {
					self.$ele.remove();
					if (self.settings.onClosed) {
						self.settings.onClosed(self.$ele);
					}
				}
			}, 600);
		},
		reposition: function(posX) {
			var self = this,
				notifies = '[data-notify-position="' + this.settings.placement.from + '-' + this.settings.placement.align + '"]:not([data-closing="true"])',
				$elements = this.$ele.nextAll(notifies);
			if (this.settings.newest_on_top == true) {
				$elements = this.$ele.prevAll(notifies);
			}
			$elements.each(function() {
				$(this).css(self.settings.placement.from, posX);
				posX = (parseInt(posX)+parseInt(self.settings.spacing)) + $(this).outerHeight();
			});
		}
	});

	$.notify = function ( content, options ) {
		var plugin = new Notify( this, content, options );
		return plugin.notify;
	};
	$.notifyDefaults = function( options ) {
		defaults = $.extend(true, {}, defaults, options);
		return defaults;
	};
	$.notifyClose = function( command ) {
		if (typeof command === "undefined" || command == "all") {
			$('[data-notify]').find('[data-notify="dismiss"]').trigger('click');
		}else{
			$('[data-notify-position="'+command+'"]').find('[data-notify="dismiss"]').trigger('click');
		}
	};

}));

},{"jquery":14}],3:[function(require,module,exports){
/*!
 * Bootstrap-select v1.13.18 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2020 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */

(function (root, factory) {
  if (root === undefined && window !== undefined) root = window;
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(["jquery"], function (a0) {
      return (factory(a0));
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(root["jQuery"]);
  }
}(this, function (jQuery) {

(function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ];

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', 'tabindex', 'style', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

  function allowedAttribute (attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml (unsafeElements, whiteList, sanitizeFn) {
    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeElements);
    }

    var whitelistKeys = Object.keys(whiteList);

    for (var i = 0, len = unsafeElements.length; i < len; i++) {
      var elements = unsafeElements[i].querySelectorAll('*');

      for (var j = 0, len2 = elements.length; j < len2; j++) {
        var el = elements[j];
        var elName = el.nodeName.toLowerCase();

        if (whitelistKeys.indexOf(elName) === -1) {
          el.parentNode.removeChild(el);

          continue;
        }

        var attributeList = [].slice.call(el.attributes);
        var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);

        for (var k = 0, len3 = attributeList.length; k < len3; k++) {
          var attr = attributeList[k];

          if (!allowedAttribute(attr, whitelistedAttributes)) {
            el.removeAttribute(attr.nodeName);
          }
        }
      }
    }
  }

  // Polyfill for browsers with no classList support
  // Remove in v2
  if (!('classList' in document.createElement('_'))) {
    (function (view) {
      if (!('Element' in view)) return;

      var classListProp = 'classList',
          protoProp = 'prototype',
          elemCtrProto = view.Element[protoProp],
          objCtr = Object,
          classListGetter = function () {
            var $elem = $(this);

            return {
              add: function (classes) {
                classes = Array.prototype.slice.call(arguments).join(' ');
                return $elem.addClass(classes);
              },
              remove: function (classes) {
                classes = Array.prototype.slice.call(arguments).join(' ');
                return $elem.removeClass(classes);
              },
              toggle: function (classes, force) {
                return $elem.toggleClass(classes, force);
              },
              contains: function (classes) {
                return $elem.hasClass(classes);
              }
            }
          };

      if (objCtr.defineProperty) {
        var classListPropDesc = {
          get: classListGetter,
          enumerable: true,
          configurable: true
        };
        try {
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        } catch (ex) { // IE 8 doesn't support enumerable:true
          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
          if (ex.number === undefined || ex.number === -0x7FF5EC54) {
            classListPropDesc.enumerable = false;
            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
          }
        }
      } else if (objCtr[protoProp].__defineGetter__) {
        elemCtrProto.__defineGetter__(classListProp, classListGetter);
      }
    }(window));
  }

  var testElement = document.createElement('_');

  testElement.classList.add('c1', 'c2');

  if (!testElement.classList.contains('c2')) {
    var _add = DOMTokenList.prototype.add,
        _remove = DOMTokenList.prototype.remove;

    DOMTokenList.prototype.add = function () {
      Array.prototype.forEach.call(arguments, _add.bind(this));
    }

    DOMTokenList.prototype.remove = function () {
      Array.prototype.forEach.call(arguments, _remove.bind(this));
    }
  }

  testElement.classList.toggle('c3', false);

  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
  // support the second argument.
  if (testElement.classList.contains('c3')) {
    var _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function (token, force) {
      if (1 in arguments && !this.contains(token) === !force) {
        return force;
      } else {
        return _toggle.call(this, token);
      }
    };
  }

  testElement = null;

  // shallow array comparison
  function isEqual (array1, array2) {
    return array1.length === array2.length && array1.every(function (element, index) {
      return element === array2[index];
    });
  };

  // <editor-fold desc="Shims">
  if (!String.prototype.startsWith) {
    (function () {
      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result = $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {
        }
        return result;
      }());
      var toString = {}.toString;
      var startsWith = function (search) {
        if (this == null) {
          throw new TypeError();
        }
        var string = String(this);
        if (search && toString.call(search) == '[object RegExp]') {
          throw new TypeError();
        }
        var stringLength = string.length;
        var searchString = String(search);
        var searchLength = searchString.length;
        var position = arguments.length > 1 ? arguments[1] : undefined;
        // `ToInteger`
        var pos = position ? Number(position) : 0;
        if (pos != pos) { // better `isNaN`
          pos = 0;
        }
        var start = Math.min(Math.max(pos, 0), stringLength);
        // Avoid the `indexOf` call if no match is possible
        if (searchLength + start > stringLength) {
          return false;
        }
        var index = -1;
        while (++index < searchLength) {
          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
            return false;
          }
        }
        return true;
      };
      if (defineProperty) {
        defineProperty(String.prototype, 'startsWith', {
          'value': startsWith,
          'configurable': true,
          'writable': true
        });
      } else {
        String.prototype.startsWith = startsWith;
      }
    }());
  }

  if (!Object.keys) {
    Object.keys = function (
      o, // object
      k, // key
      r  // result array
    ) {
      // initialize object and result
      r = [];
      // iterate over object keys
      for (k in o) {
        // fill result array with non-prototypical keys
        r.hasOwnProperty.call(o, k) && r.push(k);
      }
      // return result
      return r;
    };
  }

  if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty('selectedOptions')) {
    Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', {
      get: function () {
        return this.querySelectorAll(':checked');
      }
    });
  }

  function getSelectedOptions (select, ignoreDisabled) {
    var selectedOptions = select.selectedOptions,
        options = [],
        opt;

    if (ignoreDisabled) {
      for (var i = 0, len = selectedOptions.length; i < len; i++) {
        opt = selectedOptions[i];

        if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
          options.push(opt);
        }
      }

      return options;
    }

    return selectedOptions;
  }

  // much faster than $.val()
  function getSelectValues (select, selectedOptions) {
    var value = [],
        options = selectedOptions || select.selectedOptions,
        opt;

    for (var i = 0, len = options.length; i < len; i++) {
      opt = options[i];

      if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
        value.push(opt.value);
      }
    }

    if (!select.multiple) {
      return !value.length ? null : value[0];
    }

    return value;
  }

  // set data-selected on select element if the value has been programmatically selected
  // prior to initialization of bootstrap-select
  // * consider removing or replacing an alternative method *
  var valHooks = {
    useDefault: false,
    _set: $.valHooks.select.set
  };

  $.valHooks.select.set = function (elem, value) {
    if (value && !valHooks.useDefault) $(elem).data('selected', true);

    return valHooks._set.apply(this, arguments);
  };

  var changedArguments = null;

  var EventIsSupported = (function () {
    try {
      new Event('change');
      return true;
    } catch (e) {
      return false;
    }
  })();

  $.fn.triggerNative = function (eventName) {
    var el = this[0],
        event;

    if (el.dispatchEvent) { // for modern browsers & IE9+
      if (EventIsSupported) {
        // For modern browsers
        event = new Event(eventName, {
          bubbles: true
        });
      } else {
        // For IE since it doesn't support Event constructor
        event = document.createEvent('Event');
        event.initEvent(eventName, true, false);
      }

      el.dispatchEvent(event);
    } else if (el.fireEvent) { // for IE8
      event = document.createEventObject();
      event.eventType = eventName;
      el.fireEvent('on' + eventName, event);
    } else {
      // fall back to jQuery.trigger
      this.trigger(eventName);
    }
  };
  // </editor-fold>

  function stringSearch (li, searchString, method, normalize) {
    var stringTypes = [
          'display',
          'subtext',
          'tokens'
        ],
        searchSuccess = false;

    for (var i = 0; i < stringTypes.length; i++) {
      var stringType = stringTypes[i],
          string = li[stringType];

      if (string) {
        string = string.toString();

        // Strip HTML tags. This isn't perfect, but it's much faster than any other method
        if (stringType === 'display') {
          string = string.replace(/<[^>]+>/g, '');
        }

        if (normalize) string = normalizeToBase(string);
        string = string.toUpperCase();

        if (method === 'contains') {
          searchSuccess = string.indexOf(searchString) >= 0;
        } else {
          searchSuccess = string.startsWith(searchString);
        }

        if (searchSuccess) break;
      }
    }

    return searchSuccess;
  }

  function toInteger (value) {
    return parseInt(value, 10) || 0;
  }

  // Borrowed from Lodash (_.deburr)
  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to compose unicode character classes. */
  var rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboMarksExtendedRange = '\\u1ab0-\\u1aff',
      rsComboMarksSupplementRange = '\\u1dc0-\\u1dff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;

  /** Used to compose unicode capture groups. */
  var rsCombo = '[' + rsComboRange + ']';

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  function deburrLetter (key) {
    return deburredLetters[key];
  };

  function normalizeToBase (string) {
    string = string.toString();
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
  }

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function (map) {
    var escaper = function (match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + Object.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function (string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };

  var htmlEscape = createEscaper(escapeMap);

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var keyCodeMap = {
    32: ' ',
    48: '0',
    49: '1',
    50: '2',
    51: '3',
    52: '4',
    53: '5',
    54: '6',
    55: '7',
    56: '8',
    57: '9',
    59: ';',
    65: 'A',
    66: 'B',
    67: 'C',
    68: 'D',
    69: 'E',
    70: 'F',
    71: 'G',
    72: 'H',
    73: 'I',
    74: 'J',
    75: 'K',
    76: 'L',
    77: 'M',
    78: 'N',
    79: 'O',
    80: 'P',
    81: 'Q',
    82: 'R',
    83: 'S',
    84: 'T',
    85: 'U',
    86: 'V',
    87: 'W',
    88: 'X',
    89: 'Y',
    90: 'Z',
    96: '0',
    97: '1',
    98: '2',
    99: '3',
    100: '4',
    101: '5',
    102: '6',
    103: '7',
    104: '8',
    105: '9'
  };

  var keyCodes = {
    ESCAPE: 27, // KeyboardEvent.which value for Escape (Esc) key
    ENTER: 13, // KeyboardEvent.which value for Enter key
    SPACE: 32, // KeyboardEvent.which value for space key
    TAB: 9, // KeyboardEvent.which value for tab key
    ARROW_UP: 38, // KeyboardEvent.which value for up arrow key
    ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
  }

  var version = {
    success: false,
    major: '3'
  };

  try {
    version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
    version.major = version.full[0];
    version.success = true;
  } catch (err) {
    // do nothing
  }

  var selectId = 0;

  var EVENT_KEY = '.bs.select';

  var classNames = {
    DISABLED: 'disabled',
    DIVIDER: 'divider',
    SHOW: 'open',
    DROPUP: 'dropup',
    MENU: 'dropdown-menu',
    MENURIGHT: 'dropdown-menu-right',
    MENULEFT: 'dropdown-menu-left',
    // to-do: replace with more advanced template/customization options
    BUTTONCLASS: 'btn-default',
    POPOVERHEADER: 'popover-title',
    ICONBASE: 'glyphicon',
    TICKICON: 'glyphicon-ok'
  }

  var Selector = {
    MENU: '.' + classNames.MENU
  }

  var elementTemplates = {
    div: document.createElement('div'),
    span: document.createElement('span'),
    i: document.createElement('i'),
    subtext: document.createElement('small'),
    a: document.createElement('a'),
    li: document.createElement('li'),
    whitespace: document.createTextNode('\u00A0'),
    fragment: document.createDocumentFragment()
  }

  elementTemplates.noResults = elementTemplates.li.cloneNode(false);
  elementTemplates.noResults.className = 'no-results';

  elementTemplates.a.setAttribute('role', 'option');
  elementTemplates.a.className = 'dropdown-item';

  elementTemplates.subtext.className = 'text-muted';

  elementTemplates.text = elementTemplates.span.cloneNode(false);
  elementTemplates.text.className = 'text';

  elementTemplates.checkMark = elementTemplates.span.cloneNode(false);

  var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + '|' + keyCodes.ARROW_DOWN);
  var REGEXP_TAB_OR_ESCAPE = new RegExp('^' + keyCodes.TAB + '$|' + keyCodes.ESCAPE);

  var generateOption = {
    li: function (content, classes, optgroup) {
      var li = elementTemplates.li.cloneNode(false);

      if (content) {
        if (content.nodeType === 1 || content.nodeType === 11) {
          li.appendChild(content);
        } else {
          li.innerHTML = content;
        }
      }

      if (typeof classes !== 'undefined' && classes !== '') li.className = classes;
      if (typeof optgroup !== 'undefined' && optgroup !== null) li.classList.add('optgroup-' + optgroup);

      return li;
    },

    a: function (text, classes, inline) {
      var a = elementTemplates.a.cloneNode(true);

      if (text) {
        if (text.nodeType === 11) {
          a.appendChild(text);
        } else {
          a.insertAdjacentHTML('beforeend', text);
        }
      }

      if (typeof classes !== 'undefined' && classes !== '') a.classList.add.apply(a.classList, classes.split(/\s+/));
      if (inline) a.setAttribute('style', inline);

      return a;
    },

    text: function (options, useFragment) {
      var textElement = elementTemplates.text.cloneNode(false),
          subtextElement,
          iconElement;

      if (options.content) {
        textElement.innerHTML = options.content;
      } else {
        textElement.textContent = options.text;

        if (options.icon) {
          var whitespace = elementTemplates.whitespace.cloneNode(false);

          // need to use <i> for icons in the button to prevent a breaking change
          // note: switch to span in next major release
          iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
          iconElement.className = this.options.iconBase + ' ' + options.icon;

          elementTemplates.fragment.appendChild(iconElement);
          elementTemplates.fragment.appendChild(whitespace);
        }

        if (options.subtext) {
          subtextElement = elementTemplates.subtext.cloneNode(false);
          subtextElement.textContent = options.subtext;
          textElement.appendChild(subtextElement);
        }
      }

      if (useFragment === true) {
        while (textElement.childNodes.length > 0) {
          elementTemplates.fragment.appendChild(textElement.childNodes[0]);
        }
      } else {
        elementTemplates.fragment.appendChild(textElement);
      }

      return elementTemplates.fragment;
    },

    label: function (options) {
      var textElement = elementTemplates.text.cloneNode(false),
          subtextElement,
          iconElement;

      textElement.innerHTML = options.display;

      if (options.icon) {
        var whitespace = elementTemplates.whitespace.cloneNode(false);

        iconElement = elementTemplates.span.cloneNode(false);
        iconElement.className = this.options.iconBase + ' ' + options.icon;

        elementTemplates.fragment.appendChild(iconElement);
        elementTemplates.fragment.appendChild(whitespace);
      }

      if (options.subtext) {
        subtextElement = elementTemplates.subtext.cloneNode(false);
        subtextElement.textContent = options.subtext;
        textElement.appendChild(subtextElement);
      }

      elementTemplates.fragment.appendChild(textElement);

      return elementTemplates.fragment;
    }
  }

  function showNoResults (searchMatch, searchValue) {
    if (!searchMatch.length) {
      elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace('{0}', '"' + htmlEscape(searchValue) + '"');
      this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
    }
  }

  var Selectpicker = function (element, options) {
    var that = this;

    // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
    if (!valHooks.useDefault) {
      $.valHooks.select.set = valHooks._set;
      valHooks.useDefault = true;
    }

    this.$element = $(element);
    this.$newElement = null;
    this.$button = null;
    this.$menu = null;
    this.options = options;
    this.selectpicker = {
      main: {},
      search: {},
      current: {}, // current changes if a search is in progress
      view: {},
      isSearching: false,
      keydown: {
        keyHistory: '',
        resetKeyHistory: {
          start: function () {
            return setTimeout(function () {
              that.selectpicker.keydown.keyHistory = '';
            }, 800);
          }
        }
      }
    };

    this.sizeInfo = {};

    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
    // data-attribute)
    if (this.options.title === null) {
      this.options.title = this.$element.attr('title');
    }

    // Format window padding
    var winPad = this.options.windowPadding;
    if (typeof winPad === 'number') {
      this.options.windowPadding = [winPad, winPad, winPad, winPad];
    }

    // Expose public methods
    this.val = Selectpicker.prototype.val;
    this.render = Selectpicker.prototype.render;
    this.refresh = Selectpicker.prototype.refresh;
    this.setStyle = Selectpicker.prototype.setStyle;
    this.selectAll = Selectpicker.prototype.selectAll;
    this.deselectAll = Selectpicker.prototype.deselectAll;
    this.destroy = Selectpicker.prototype.destroy;
    this.remove = Selectpicker.prototype.remove;
    this.show = Selectpicker.prototype.show;
    this.hide = Selectpicker.prototype.hide;

    this.init();
  };

  Selectpicker.VERSION = '1.13.18';

  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
  Selectpicker.DEFAULTS = {
    noneSelectedText: 'Nothing selected',
    noneResultsText: 'No results matched {0}',
    countSelectedText: function (numSelected, numTotal) {
      return (numSelected == 1) ? '{0} item selected' : '{0} items selected';
    },
    maxOptionsText: function (numAll, numGroup) {
      return [
        (numAll == 1) ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
        (numGroup == 1) ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
      ];
    },
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    doneButton: false,
    doneButtonText: 'Close',
    multipleSeparator: ', ',
    styleBase: 'btn',
    style: classNames.BUTTONCLASS,
    size: 'auto',
    title: null,
    selectedTextFormat: 'values',
    width: false,
    container: false,
    hideDisabled: false,
    showSubtext: false,
    showIcon: true,
    showContent: true,
    dropupAuto: true,
    header: false,
    liveSearch: false,
    liveSearchPlaceholder: null,
    liveSearchNormalize: false,
    liveSearchStyle: 'contains',
    actionsBox: false,
    iconBase: classNames.ICONBASE,
    tickIcon: classNames.TICKICON,
    showTick: false,
    template: {
      caret: '<span class="caret"></span>'
    },
    maxOptions: false,
    mobile: false,
    selectOnTab: false,
    dropdownAlignRight: false,
    windowPadding: 0,
    virtualScroll: 600,
    display: false,
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist
  };

  Selectpicker.prototype = {

    constructor: Selectpicker,

    init: function () {
      var that = this,
          id = this.$element.attr('id'),
          element = this.$element[0],
          form = element.form;

      selectId++;
      this.selectId = 'bs-select-' + selectId;

      element.classList.add('bs-select-hidden');

      this.multiple = this.$element.prop('multiple');
      this.autofocus = this.$element.prop('autofocus');

      if (element.classList.contains('show-tick')) {
        this.options.showTick = true;
      }

      this.$newElement = this.createDropdown();
      this.buildData();
      this.$element
        .after(this.$newElement)
        .prependTo(this.$newElement);

      // ensure select is associated with form element if it got unlinked after moving it inside newElement
      if (form && element.form === null) {
        if (!form.id) form.id = 'form-' + this.selectId;
        element.setAttribute('form', form.id);
      }

      this.$button = this.$newElement.children('button');
      this.$menu = this.$newElement.children(Selector.MENU);
      this.$menuInner = this.$menu.children('.inner');
      this.$searchbox = this.$menu.find('input');

      element.classList.remove('bs-select-hidden');

      if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);

      if (typeof id !== 'undefined') {
        this.$button.attr('data-id', id);
      }

      this.checkDisabled();
      this.clickListener();

      if (this.options.liveSearch) {
        this.liveSearchListener();
        this.focusedParent = this.$searchbox[0];
      } else {
        this.focusedParent = this.$menuInner[0];
      }

      this.setStyle();
      this.render();
      this.setWidth();
      if (this.options.container) {
        this.selectPosition();
      } else {
        this.$element.on('hide' + EVENT_KEY, function () {
          if (that.isVirtual()) {
            // empty menu on close
            var menuInner = that.$menuInner[0],
                emptyMenu = menuInner.firstChild.cloneNode(false);

            // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
            menuInner.scrollTop = 0;
          }
        });
      }
      this.$menu.data('this', this);
      this.$newElement.data('this', this);
      if (this.options.mobile) this.mobile();

      this.$newElement.on({
        'hide.bs.dropdown': function (e) {
          that.$element.trigger('hide' + EVENT_KEY, e);
        },
        'hidden.bs.dropdown': function (e) {
          that.$element.trigger('hidden' + EVENT_KEY, e);
        },
        'show.bs.dropdown': function (e) {
          that.$element.trigger('show' + EVENT_KEY, e);
        },
        'shown.bs.dropdown': function (e) {
          that.$element.trigger('shown' + EVENT_KEY, e);
        }
      });

      if (element.hasAttribute('required')) {
        this.$element.on('invalid' + EVENT_KEY, function () {
          that.$button[0].classList.add('bs-invalid');

          that.$element
            .on('shown' + EVENT_KEY + '.invalid', function () {
              that.$element
                .val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                .off('shown' + EVENT_KEY + '.invalid');
            })
            .on('rendered' + EVENT_KEY, function () {
              // if select is no longer invalid, remove the bs-invalid class
              if (this.validity.valid) that.$button[0].classList.remove('bs-invalid');
              that.$element.off('rendered' + EVENT_KEY);
            });

          that.$button.on('blur' + EVENT_KEY, function () {
            that.$element.trigger('focus').trigger('blur');
            that.$button.off('blur' + EVENT_KEY);
          });
        });
      }

      setTimeout(function () {
        that.buildList();
        that.$element.trigger('loaded' + EVENT_KEY);
      });
    },

    createDropdown: function () {
      // Options
      // If we are multiple or showTick option is set, then add the show-tick class
      var showTick = (this.multiple || this.options.showTick) ? ' show-tick' : '',
          multiselectable = this.multiple ? ' aria-multiselectable="true"' : '',
          inputGroup = '',
          autofocus = this.autofocus ? ' autofocus' : '';

      if (version.major < 4 && this.$element.parent().hasClass('input-group')) {
        inputGroup = ' input-group-btn';
      }

      // Elements
      var drop,
          header = '',
          searchbox = '',
          actionsbox = '',
          donebutton = '';

      if (this.options.header) {
        header =
          '<div class="' + classNames.POPOVERHEADER + '">' +
            '<button type="button" class="close" aria-hidden="true">&times;</button>' +
              this.options.header +
          '</div>';
      }

      if (this.options.liveSearch) {
        searchbox =
          '<div class="bs-searchbox">' +
            '<input type="search" class="form-control" autocomplete="off"' +
              (
                this.options.liveSearchPlaceholder === null ? ''
                :
                ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"'
              ) +
              ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' +
          '</div>';
      }

      if (this.multiple && this.options.actionsBox) {
        actionsbox =
          '<div class="bs-actionsbox">' +
            '<div class="btn-group btn-group-sm btn-block">' +
              '<button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' +
                this.options.selectAllText +
              '</button>' +
              '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' +
                this.options.deselectAllText +
              '</button>' +
            '</div>' +
          '</div>';
      }

      if (this.multiple && this.options.doneButton) {
        donebutton =
          '<div class="bs-donebutton">' +
            '<div class="btn-group btn-block">' +
              '<button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' +
                this.options.doneButtonText +
              '</button>' +
            '</div>' +
          '</div>';
      }

      drop =
        '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' +
          '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === 'static' ? 'data-display="static"' : '') + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' +
            '<div class="filter-option">' +
              '<div class="filter-option-inner">' +
                '<div class="filter-option-inner-inner"></div>' +
              '</div> ' +
            '</div>' +
            (
              version.major === '4' ? ''
              :
              '<span class="bs-caret">' +
                this.options.template.caret +
              '</span>'
            ) +
          '</button>' +
          '<div class="' + classNames.MENU + ' ' + (version.major === '4' ? '' : classNames.SHOW) + '">' +
            header +
            searchbox +
            actionsbox +
            '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + '>' +
                '<ul class="' + classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '') + '" role="presentation">' +
                '</ul>' +
            '</div>' +
            donebutton +
          '</div>' +
        '</div>';

      return $(drop);
    },

    setPositionData: function () {
      this.selectpicker.view.canHighlight = [];
      this.selectpicker.view.size = 0;
      this.selectpicker.view.firstHighlightIndex = false;

      for (var i = 0; i < this.selectpicker.current.data.length; i++) {
        var li = this.selectpicker.current.data[i],
            canHighlight = true;

        if (li.type === 'divider') {
          canHighlight = false;
          li.height = this.sizeInfo.dividerHeight;
        } else if (li.type === 'optgroup-label') {
          canHighlight = false;
          li.height = this.sizeInfo.dropdownHeaderHeight;
        } else {
          li.height = this.sizeInfo.liHeight;
        }

        if (li.disabled) canHighlight = false;

        this.selectpicker.view.canHighlight.push(canHighlight);

        if (canHighlight) {
          this.selectpicker.view.size++;
          li.posinset = this.selectpicker.view.size;
          if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
        }

        li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
      }
    },

    isVirtual: function () {
      return (this.options.virtualScroll !== false) && (this.selectpicker.main.elements.length >= this.options.virtualScroll) || this.options.virtualScroll === true;
    },

    createView: function (isSearching, setSize, refresh) {
      var that = this,
          scrollTop = 0,
          active = [],
          selected,
          prevActive;

      this.selectpicker.isSearching = isSearching;
      this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;

      this.setPositionData();

      if (setSize) {
        if (refresh) {
          scrollTop = this.$menuInner[0].scrollTop;
        } else if (!that.multiple) {
          var element = that.$element[0],
              selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;

          if (typeof selectedIndex === 'number' && that.options.size !== false) {
            var selectedData = that.selectpicker.main.data[selectedIndex],
                position = selectedData && selectedData.position;

            if (position) {
              scrollTop = position - ((that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2);
            }
          }
        }
      }

      scroll(scrollTop, true);

      this.$menuInner.off('scroll.createView').on('scroll.createView', function (e, updateValue) {
        if (!that.noScroll) scroll(this.scrollTop, updateValue);
        that.noScroll = false;
      });

      function scroll (scrollTop, init) {
        var size = that.selectpicker.current.elements.length,
            chunks = [],
            chunkSize,
            chunkCount,
            firstChunk,
            lastChunk,
            currentChunk,
            prevPositions,
            positionIsDifferent,
            previousElements,
            menuIsDifferent = true,
            isVirtual = that.isVirtual();

        that.selectpicker.view.scrollTop = scrollTop;

        chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
        chunkCount = Math.round(size / chunkSize) || 1; // number of chunks

        for (var i = 0; i < chunkCount; i++) {
          var endOfChunk = (i + 1) * chunkSize;

          if (i === chunkCount - 1) {
            endOfChunk = size;
          }

          chunks[i] = [
            (i) * chunkSize + (!i ? 0 : 1),
            endOfChunk
          ];

          if (!size) break;

          if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) {
            currentChunk = i;
          }
        }

        if (currentChunk === undefined) currentChunk = 0;

        prevPositions = [that.selectpicker.view.position0, that.selectpicker.view.position1];

        // always display previous, current, and next chunks
        firstChunk = Math.max(0, currentChunk - 1);
        lastChunk = Math.min(chunkCount - 1, currentChunk + 1);

        that.selectpicker.view.position0 = isVirtual === false ? 0 : (Math.max(0, chunks[firstChunk][0]) || 0);
        that.selectpicker.view.position1 = isVirtual === false ? size : (Math.min(size, chunks[lastChunk][1]) || 0);

        positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;

        if (that.activeIndex !== undefined) {
          prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
          active = that.selectpicker.main.elements[that.activeIndex];
          selected = that.selectpicker.main.elements[that.selectedIndex];

          if (init) {
            if (that.activeIndex !== that.selectedIndex) {
              that.defocusItem(active);
            }
            that.activeIndex = undefined;
          }

          if (that.activeIndex && that.activeIndex !== that.selectedIndex) {
            that.defocusItem(selected);
          }
        }

        if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) {
          that.defocusItem(prevActive);
        }

        if (init || positionIsDifferent) {
          previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];

          if (isVirtual === false) {
            that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
          } else {
            that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
          }

          that.setOptionStatus();

          // if searching, check to make sure the list has actually been updated before updating DOM
          // this prevents unnecessary repaints
          if (isSearching || (isVirtual === false && init)) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);

          // if virtual scroll is disabled and not searching,
          // menu should never need to be updated more than once
          if ((init || isVirtual === true) && menuIsDifferent) {
            var menuInner = that.$menuInner[0],
                menuFragment = document.createDocumentFragment(),
                emptyMenu = menuInner.firstChild.cloneNode(false),
                marginTop,
                marginBottom,
                elements = that.selectpicker.view.visibleElements,
                toSanitize = [];

            // replace the existing UL with an empty one - this is faster than $.empty()
            menuInner.replaceChild(emptyMenu, menuInner.firstChild);

            for (var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++) {
              var element = elements[i],
                  elText,
                  elementData;

              if (that.options.sanitize) {
                elText = element.lastChild;

                if (elText) {
                  elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];

                  if (elementData && elementData.content && !elementData.sanitized) {
                    toSanitize.push(elText);
                    elementData.sanitized = true;
                  }
                }
              }

              menuFragment.appendChild(element);
            }

            if (that.options.sanitize && toSanitize.length) {
              sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
            }

            if (isVirtual === true) {
              marginTop = (that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position);
              marginBottom = (that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position);

              menuInner.firstChild.style.marginTop = marginTop + 'px';
              menuInner.firstChild.style.marginBottom = marginBottom + 'px';
            } else {
              menuInner.firstChild.style.marginTop = 0;
              menuInner.firstChild.style.marginBottom = 0;
            }

            menuInner.firstChild.appendChild(menuFragment);

            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
            // switch to ResizeObserver with increased browser support
            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
              var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;

              if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) {
                menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
              } else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
                // set to 0 to get actual width of menu
                that.$menu[0].style.minWidth = 0;

                var actualMenuWidth = menuInner.firstChild.offsetWidth;

                if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
                  that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
                  menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
                }

                // reset to default CSS styling
                that.$menu[0].style.minWidth = '';
              }
            }
          }
        }

        that.prevActiveIndex = that.activeIndex;

        if (!that.options.liveSearch) {
          that.$menuInner.trigger('focus');
        } else if (isSearching && init) {
          var index = 0,
              newActive;

          if (!that.selectpicker.view.canHighlight[index]) {
            index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
          }

          newActive = that.selectpicker.view.visibleElements[index];

          that.defocusItem(that.selectpicker.view.currentActive);

          that.activeIndex = (that.selectpicker.current.data[index] || {}).index;

          that.focusItem(newActive);
        }
      }

      $(window)
        .off('resize' + EVENT_KEY + '.' + this.selectId + '.createView')
        .on('resize' + EVENT_KEY + '.' + this.selectId + '.createView', function () {
          var isActive = that.$newElement.hasClass(classNames.SHOW);

          if (isActive) scroll(that.$menuInner[0].scrollTop);
        });
    },

    focusItem: function (li, liData, noStyle) {
      if (li) {
        liData = liData || this.selectpicker.main.data[this.activeIndex];
        var a = li.firstChild;

        if (a) {
          a.setAttribute('aria-setsize', this.selectpicker.view.size);
          a.setAttribute('aria-posinset', liData.posinset);

          if (noStyle !== true) {
            this.focusedParent.setAttribute('aria-activedescendant', a.id);
            li.classList.add('active');
            a.classList.add('active');
          }
        }
      }
    },

    defocusItem: function (li) {
      if (li) {
        li.classList.remove('active');
        if (li.firstChild) li.firstChild.classList.remove('active');
      }
    },

    setPlaceholder: function () {
      var that = this,
          updateIndex = false;

      if (this.options.title && !this.multiple) {
        if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement('option');

        // this option doesn't create a new <li> element, but does add a new option at the start,
        // so startIndex should increase to prevent having to check every option for the bs-title-option class
        updateIndex = true;

        var element = this.$element[0],
            selectTitleOption = false,
            titleNotAppended = !this.selectpicker.view.titleOption.parentNode,
            selectedIndex = element.selectedIndex,
            selectedOption = element.options[selectedIndex],
            navigation = window.performance && window.performance.getEntriesByType('navigation'),
            // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
            isNotBackForward = (navigation && navigation.length) ? navigation[0].type !== 'back_forward' : window.performance.navigation.type !== 2;

        if (titleNotAppended) {
          // Use native JS to prepend option (faster)
          this.selectpicker.view.titleOption.className = 'bs-title-option';
          this.selectpicker.view.titleOption.value = '';

          // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
          // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
          // if so, the select will have the data-selected attribute
          selectTitleOption = !selectedOption || (selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data('selected') === undefined);
        }

        if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) {
          element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
        }

        // Set selected *after* appending to select,
        // otherwise the option doesn't get selected in IE
        // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
        if (selectTitleOption && isNotBackForward) {
          element.selectedIndex = 0;
        } else if (document.readyState !== 'complete') {
          // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
          // wait for that value to be set, then run render again
          window.addEventListener('pageshow', function () {
            if (that.selectpicker.view.displayedValue !== element.value) that.render();
          });
        }
      }

      return updateIndex;
    },

    buildData: function () {
      var optionSelector = ':not([hidden]):not([data-hidden="true"])',
          mainData = [],
          optID = 0,
          startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop

      if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

      var selectOptions = this.$element[0].querySelectorAll('select > *' + optionSelector);

      function addDivider (config) {
        var previousData = mainData[mainData.length - 1];

        // ensure optgroup doesn't create back-to-back dividers
        if (
          previousData &&
          previousData.type === 'divider' &&
          (previousData.optID || config.optID)
        ) {
          return;
        }

        config = config || {};
        config.type = 'divider';

        mainData.push(config);
      }

      function addOption (option, config) {
        config = config || {};

        config.divider = option.getAttribute('data-divider') === 'true';

        if (config.divider) {
          addDivider({
            optID: config.optID
          });
        } else {
          var liIndex = mainData.length,
              cssText = option.style.cssText,
              inlineStyle = cssText ? htmlEscape(cssText) : '',
              optionClass = (option.className || '') + (config.optgroupClass || '');

          if (config.optID) optionClass = 'opt ' + optionClass;

          config.optionClass = optionClass.trim();
          config.inlineStyle = inlineStyle;
          config.text = option.textContent;

          config.content = option.getAttribute('data-content');
          config.tokens = option.getAttribute('data-tokens');
          config.subtext = option.getAttribute('data-subtext');
          config.icon = option.getAttribute('data-icon');

          option.liIndex = liIndex;

          config.display = config.content || config.text;
          config.type = 'option';
          config.index = liIndex;
          config.option = option;
          config.selected = !!option.selected;
          config.disabled = config.disabled || !!option.disabled;

          mainData.push(config);
        }
      }

      function addOptgroup (index, selectOptions) {
        var optgroup = selectOptions[index],
            // skip placeholder option
            previous = index - 1 < startIndex ? false : selectOptions[index - 1],
            next = selectOptions[index + 1],
            options = optgroup.querySelectorAll('option' + optionSelector);

        if (!options.length) return;

        var config = {
              display: htmlEscape(optgroup.label),
              subtext: optgroup.getAttribute('data-subtext'),
              icon: optgroup.getAttribute('data-icon'),
              type: 'optgroup-label',
              optgroupClass: ' ' + (optgroup.className || '')
            },
            headerIndex,
            lastIndex;

        optID++;

        if (previous) {
          addDivider({ optID: optID });
        }

        config.optID = optID;

        mainData.push(config);

        for (var j = 0, len = options.length; j < len; j++) {
          var option = options[j];

          if (j === 0) {
            headerIndex = mainData.length - 1;
            lastIndex = headerIndex + len;
          }

          addOption(option, {
            headerIndex: headerIndex,
            lastIndex: lastIndex,
            optID: config.optID,
            optgroupClass: config.optgroupClass,
            disabled: optgroup.disabled
          });
        }

        if (next) {
          addDivider({ optID: optID });
        }
      }

      for (var len = selectOptions.length, i = startIndex; i < len; i++) {
        var item = selectOptions[i];

        if (item.tagName !== 'OPTGROUP') {
          addOption(item, {});
        } else {
          addOptgroup(i, selectOptions);
        }
      }

      this.selectpicker.main.data = this.selectpicker.current.data = mainData;
    },

    buildList: function () {
      var that = this,
          selectData = this.selectpicker.main.data,
          mainElements = [],
          widestOptionLength = 0;

      if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
        elementTemplates.checkMark.className = this.options.iconBase + ' ' + that.options.tickIcon + ' check-mark';
        elementTemplates.a.appendChild(elementTemplates.checkMark);
      }

      function buildElement (item) {
        var liElement,
            combinedLength = 0;

        switch (item.type) {
          case 'divider':
            liElement = generateOption.li(
              false,
              classNames.DIVIDER,
              (item.optID ? item.optID + 'div' : undefined)
            );

            break;

          case 'option':
            liElement = generateOption.li(
              generateOption.a(
                generateOption.text.call(that, item),
                item.optionClass,
                item.inlineStyle
              ),
              '',
              item.optID
            );

            if (liElement.firstChild) {
              liElement.firstChild.id = that.selectId + '-' + item.index;
            }

            break;

          case 'optgroup-label':
            liElement = generateOption.li(
              generateOption.label.call(that, item),
              'dropdown-header' + item.optgroupClass,
              item.optID
            );

            break;
        }

        item.element = liElement;
        mainElements.push(liElement);

        // count the number of characters in the option - not perfect, but should work in most cases
        if (item.display) combinedLength += item.display.length;
        if (item.subtext) combinedLength += item.subtext.length;
        // if there is an icon, ensure this option's width is checked
        if (item.icon) combinedLength += 1;

        if (combinedLength > widestOptionLength) {
          widestOptionLength = combinedLength;

          // guess which option is the widest
          // use this when calculating menu width
          // not perfect, but it's fast, and the width will be updating accordingly when scrolling
          that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
        }
      }

      for (var len = selectData.length, i = 0; i < len; i++) {
        var item = selectData[i];

        buildElement(item);
      }

      this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
    },

    findLis: function () {
      return this.$menuInner.find('.inner > li');
    },

    render: function () {
      var that = this,
          element = this.$element[0],
          // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
          placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0,
          selectedOptions = getSelectedOptions(element, this.options.hideDisabled),
          selectedCount = selectedOptions.length,
          button = this.$button[0],
          buttonInner = button.querySelector('.filter-option-inner-inner'),
          multipleSeparator = document.createTextNode(this.options.multipleSeparator),
          titleFragment = elementTemplates.fragment.cloneNode(false),
          showCount,
          countMax,
          hasContent = false;

      button.classList.toggle('bs-placeholder', that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));

      if (!that.multiple && selectedOptions.length === 1) {
        that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
      }

      if (this.options.selectedTextFormat === 'static') {
        titleFragment = generateOption.text.call(this, { text: this.options.title }, true);
      } else {
        showCount = this.multiple && this.options.selectedTextFormat.indexOf('count') !== -1 && selectedCount > 1;

        // determine if the number of selected options will be shown (showCount === true)
        if (showCount) {
          countMax = this.options.selectedTextFormat.split('>');
          showCount = (countMax.length > 1 && selectedCount > countMax[1]) || (countMax.length === 1 && selectedCount >= 2);
        }

        // only loop through all selected options if the count won't be shown
        if (showCount === false) {
          if (!placeholderSelected) {
            for (var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++) {
              if (selectedIndex < 50) {
                var option = selectedOptions[selectedIndex],
                    thisData = this.selectpicker.main.data[option.liIndex],
                    titleOptions = {};

                if (this.multiple && selectedIndex > 0) {
                  titleFragment.appendChild(multipleSeparator.cloneNode(false));
                }

                if (option.title) {
                  titleOptions.text = option.title;
                } else if (thisData) {
                  if (thisData.content && that.options.showContent) {
                    titleOptions.content = thisData.content.toString();
                    hasContent = true;
                  } else {
                    if (that.options.showIcon) {
                      titleOptions.icon = thisData.icon;
                    }
                    if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = ' ' + thisData.subtext;
                    titleOptions.text = option.textContent.trim();
                  }
                }

                titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
              } else {
                break;
              }
            }

            // add ellipsis
            if (selectedCount > 49) {
              titleFragment.appendChild(document.createTextNode('...'));
            }
          }
        } else {
          var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
          if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

          // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
          var totalCount = this.$element[0].querySelectorAll('select > option' + optionSelector + ', optgroup' + optionSelector + ' option' + optionSelector).length,
              tr8nText = (typeof this.options.countSelectedText === 'function') ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;

          titleFragment = generateOption.text.call(this, {
            text: tr8nText.replace('{0}', selectedCount.toString()).replace('{1}', totalCount.toString())
          }, true);
        }
      }

      if (this.options.title == undefined) {
        // use .attr to ensure undefined is returned if title attribute is not set
        this.options.title = this.$element.attr('title');
      }

      // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
      if (!titleFragment.childNodes.length) {
        titleFragment = generateOption.text.call(this, {
          text: typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText
        }, true);
      }

      // strip all HTML tags and trim the result, then unescape any escaped tags
      button.title = titleFragment.textContent.replace(/<[^>]*>?/g, '').trim();

      if (this.options.sanitize && hasContent) {
        sanitizeHtml([titleFragment], that.options.whiteList, that.options.sanitizeFn);
      }

      buttonInner.innerHTML = '';
      buttonInner.appendChild(titleFragment);

      if (version.major < 4 && this.$newElement[0].classList.contains('bs3-has-addon')) {
        var filterExpand = button.querySelector('.filter-expand'),
            clone = buttonInner.cloneNode(true);

        clone.className = 'filter-expand';

        if (filterExpand) {
          button.replaceChild(clone, filterExpand);
        } else {
          button.appendChild(clone);
        }
      }

      this.$element.trigger('rendered' + EVENT_KEY);
    },

    /**
     * @param [style]
     * @param [status]
     */
    setStyle: function (newStyle, status) {
      var button = this.$button[0],
          newElement = this.$newElement[0],
          style = this.options.style.trim(),
          buttonClass;

      if (this.$element.attr('class')) {
        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ''));
      }

      if (version.major < 4) {
        newElement.classList.add('bs3');

        if (newElement.parentNode.classList && newElement.parentNode.classList.contains('input-group') &&
            (newElement.previousElementSibling || newElement.nextElementSibling) &&
            (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains('input-group-addon')
        ) {
          newElement.classList.add('bs3-has-addon');
        }
      }

      if (newStyle) {
        buttonClass = newStyle.trim();
      } else {
        buttonClass = style;
      }

      if (status == 'add') {
        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
      } else if (status == 'remove') {
        if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(' '));
      } else {
        if (style) button.classList.remove.apply(button.classList, style.split(' '));
        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
      }
    },

    liHeight: function (refresh) {
      if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;

      var newElement = elementTemplates.div.cloneNode(false),
          menu = elementTemplates.div.cloneNode(false),
          menuInner = elementTemplates.div.cloneNode(false),
          menuInnerInner = document.createElement('ul'),
          divider = elementTemplates.li.cloneNode(false),
          dropdownHeader = elementTemplates.li.cloneNode(false),
          li,
          a = elementTemplates.a.cloneNode(false),
          text = elementTemplates.span.cloneNode(false),
          header = this.options.header && this.$menu.find('.' + classNames.POPOVERHEADER).length > 0 ? this.$menu.find('.' + classNames.POPOVERHEADER)[0].cloneNode(true) : null,
          search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null,
          actions = this.options.actionsBox && this.multiple && this.$menu.find('.bs-actionsbox').length > 0 ? this.$menu.find('.bs-actionsbox')[0].cloneNode(true) : null,
          doneButton = this.options.doneButton && this.multiple && this.$menu.find('.bs-donebutton').length > 0 ? this.$menu.find('.bs-donebutton')[0].cloneNode(true) : null,
          firstOption = this.$element.find('option')[0];

      this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;

      text.className = 'text';
      a.className = 'dropdown-item ' + (firstOption ? firstOption.className : '');
      newElement.className = this.$menu[0].parentNode.className + ' ' + classNames.SHOW;
      newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
      if (this.options.width === 'auto') menu.style.minWidth = 0;
      menu.className = classNames.MENU + ' ' + classNames.SHOW;
      menuInner.className = 'inner ' + classNames.SHOW;
      menuInnerInner.className = classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '');
      divider.className = classNames.DIVIDER;
      dropdownHeader.className = 'dropdown-header';

      text.appendChild(document.createTextNode('\u200b'));

      if (this.selectpicker.current.data.length) {
        for (var i = 0; i < this.selectpicker.current.data.length; i++) {
          var data = this.selectpicker.current.data[i];
          if (data.type === 'option') {
            li = data.element;
            break;
          }
        }
      } else {
        li = elementTemplates.li.cloneNode(false);
        a.appendChild(text);
        li.appendChild(a);
      }

      dropdownHeader.appendChild(text.cloneNode(true));

      if (this.selectpicker.view.widestOption) {
        menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
      }

      menuInnerInner.appendChild(li);
      menuInnerInner.appendChild(divider);
      menuInnerInner.appendChild(dropdownHeader);
      if (header) menu.appendChild(header);
      if (search) {
        var input = document.createElement('input');
        search.className = 'bs-searchbox';
        input.className = 'form-control';
        search.appendChild(input);
        menu.appendChild(search);
      }
      if (actions) menu.appendChild(actions);
      menuInner.appendChild(menuInnerInner);
      menu.appendChild(menuInner);
      if (doneButton) menu.appendChild(doneButton);
      newElement.appendChild(menu);

      document.body.appendChild(newElement);

      var liHeight = li.offsetHeight,
          dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0,
          headerHeight = header ? header.offsetHeight : 0,
          searchHeight = search ? search.offsetHeight : 0,
          actionsHeight = actions ? actions.offsetHeight : 0,
          doneButtonHeight = doneButton ? doneButton.offsetHeight : 0,
          dividerHeight = $(divider).outerHeight(true),
          // fall back to jQuery if getComputedStyle is not supported
          menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false,
          menuWidth = menu.offsetWidth,
          $menu = menuStyle ? null : $(menu),
          menuPadding = {
            vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css('paddingTop')) +
                  toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css('paddingBottom')) +
                  toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css('borderTopWidth')) +
                  toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css('borderBottomWidth')),
            horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css('paddingLeft')) +
                  toInteger(menuStyle ? menuStyle.paddingRight : $menu.css('paddingRight')) +
                  toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css('borderLeftWidth')) +
                  toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css('borderRightWidth'))
          },
          menuExtras = {
            vert: menuPadding.vert +
                  toInteger(menuStyle ? menuStyle.marginTop : $menu.css('marginTop')) +
                  toInteger(menuStyle ? menuStyle.marginBottom : $menu.css('marginBottom')) + 2,
            horiz: menuPadding.horiz +
                  toInteger(menuStyle ? menuStyle.marginLeft : $menu.css('marginLeft')) +
                  toInteger(menuStyle ? menuStyle.marginRight : $menu.css('marginRight')) + 2
          },
          scrollBarWidth;

      menuInner.style.overflowY = 'scroll';

      scrollBarWidth = menu.offsetWidth - menuWidth;

      document.body.removeChild(newElement);

      this.sizeInfo.liHeight = liHeight;
      this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
      this.sizeInfo.headerHeight = headerHeight;
      this.sizeInfo.searchHeight = searchHeight;
      this.sizeInfo.actionsHeight = actionsHeight;
      this.sizeInfo.doneButtonHeight = doneButtonHeight;
      this.sizeInfo.dividerHeight = dividerHeight;
      this.sizeInfo.menuPadding = menuPadding;
      this.sizeInfo.menuExtras = menuExtras;
      this.sizeInfo.menuWidth = menuWidth;
      this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
      this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
      this.sizeInfo.scrollBarWidth = scrollBarWidth;
      this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;

      this.setPositionData();
    },

    getSelectPosition: function () {
      var that = this,
          $window = $(window),
          pos = that.$newElement.offset(),
          $container = $(that.options.container),
          containerPos;

      if (that.options.container && $container.length && !$container.is('body')) {
        containerPos = $container.offset();
        containerPos.top += parseInt($container.css('borderTopWidth'));
        containerPos.left += parseInt($container.css('borderLeftWidth'));
      } else {
        containerPos = { top: 0, left: 0 };
      }

      var winPad = that.options.windowPadding;

      this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
      this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
      this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
      this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
      this.sizeInfo.selectOffsetTop -= winPad[0];
      this.sizeInfo.selectOffsetLeft -= winPad[3];
    },

    setMenuSize: function (isAuto) {
      this.getSelectPosition();

      var selectWidth = this.sizeInfo.selectWidth,
          liHeight = this.sizeInfo.liHeight,
          headerHeight = this.sizeInfo.headerHeight,
          searchHeight = this.sizeInfo.searchHeight,
          actionsHeight = this.sizeInfo.actionsHeight,
          doneButtonHeight = this.sizeInfo.doneButtonHeight,
          divHeight = this.sizeInfo.dividerHeight,
          menuPadding = this.sizeInfo.menuPadding,
          menuInnerHeight,
          menuHeight,
          divLength = 0,
          minHeight,
          _minHeight,
          maxHeight,
          menuInnerMinHeight,
          estimate,
          isDropup;

      if (this.options.dropupAuto) {
        // Get the estimated height of the menu without scrollbars.
        // This is useful for smaller menus, where there might be plenty of room
        // below the button without setting dropup, but we can't know
        // the exact height of the menu until createView is called later
        estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;

        isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;

        // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
        if (this.selectpicker.isSearching === true) {
          isDropup = this.selectpicker.dropup;
        }

        this.$newElement.toggleClass(classNames.DROPUP, isDropup);
        this.selectpicker.dropup = isDropup;
      }

      if (this.options.size === 'auto') {
        _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
        menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
        minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
        menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);

        if (this.$newElement.hasClass(classNames.DROPUP)) {
          menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
        }

        maxHeight = menuHeight;
        menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
        for (var i = 0; i < this.options.size; i++) {
          if (this.selectpicker.current.data[i].type === 'divider') divLength++;
        }

        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
        menuInnerHeight = menuHeight - menuPadding.vert;
        maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
        minHeight = menuInnerMinHeight = '';
      }

      this.$menu.css({
        'max-height': maxHeight + 'px',
        'overflow': 'hidden',
        'min-height': minHeight + 'px'
      });

      this.$menuInner.css({
        'max-height': menuInnerHeight + 'px',
        'overflow-y': 'auto',
        'min-height': menuInnerMinHeight + 'px'
      });

      // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
      this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);

      if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
        this.sizeInfo.hasScrollBar = true;
        this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
      }

      if (this.options.dropdownAlignRight === 'auto') {
        this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < (this.sizeInfo.totalMenuWidth - selectWidth));
      }

      if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
    },

    setSize: function (refresh) {
      this.liHeight(refresh);

      if (this.options.header) this.$menu.css('padding-top', 0);

      if (this.options.size !== false) {
        var that = this,
            $window = $(window);

        this.setMenuSize();

        if (this.options.liveSearch) {
          this.$searchbox
            .off('input.setMenuSize propertychange.setMenuSize')
            .on('input.setMenuSize propertychange.setMenuSize', function () {
              return that.setMenuSize();
            });
        }

        if (this.options.size === 'auto') {
          $window
            .off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize')
            .on('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize', function () {
              return that.setMenuSize();
            });
        } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
          $window.off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize');
        }
      }

      this.createView(false, true, refresh);
    },

    setWidth: function () {
      var that = this;

      if (this.options.width === 'auto') {
        requestAnimationFrame(function () {
          that.$menu.css('min-width', '0');

          that.$element.on('loaded' + EVENT_KEY, function () {
            that.liHeight();
            that.setMenuSize();

            // Get correct width if element is hidden
            var $selectClone = that.$newElement.clone().appendTo('body'),
                btnWidth = $selectClone.css('width', 'auto').children('button').outerWidth();

            $selectClone.remove();

            // Set width to whatever's larger, button title or longest option
            that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
            that.$newElement.css('width', that.sizeInfo.selectWidth + 'px');
          });
        });
      } else if (this.options.width === 'fit') {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '').addClass('fit-width');
      } else if (this.options.width) {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', this.options.width);
      } else {
        // Remove inline min-width/width so width can be changed
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '');
      }
      // Remove fit-width class if width is changed programmatically
      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
        this.$newElement[0].classList.remove('fit-width');
      }
    },

    selectPosition: function () {
      this.$bsContainer = $('<div class="bs-container" />');

      var that = this,
          $container = $(this.options.container),
          pos,
          containerPos,
          actualHeight,
          getPlacement = function ($element) {
            var containerPosition = {},
                // fall back to dropdown's default display setting if display is not manually set
                display = that.options.display || (
                  // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
                  $.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display
                  : false
                );

            that.$bsContainer.addClass($element.attr('class').replace(/form-control|fit-width/gi, '')).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
            pos = $element.offset();

            if (!$container.is('body')) {
              containerPos = $container.offset();
              containerPos.top += parseInt($container.css('borderTopWidth')) - $container.scrollTop();
              containerPos.left += parseInt($container.css('borderLeftWidth')) - $container.scrollLeft();
            } else {
              containerPos = { top: 0, left: 0 };
            }

            actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;

            // Bootstrap 4+ uses Popper for menu positioning
            if (version.major < 4 || display === 'static') {
              containerPosition.top = pos.top - containerPos.top + actualHeight;
              containerPosition.left = pos.left - containerPos.left;
            }

            containerPosition.width = $element[0].offsetWidth;

            that.$bsContainer.css(containerPosition);
          };

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (that.isDisabled()) {
          return;
        }

        getPlacement(that.$newElement);

        that.$bsContainer
          .appendTo(that.options.container)
          .toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW))
          .append(that.$menu);
      });

      $(window)
        .off('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId)
        .on('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId, function () {
          var isActive = that.$newElement.hasClass(classNames.SHOW);

          if (isActive) getPlacement(that.$newElement);
        });

      this.$element.on('hide' + EVENT_KEY, function () {
        that.$menu.data('height', that.$menu.height());
        that.$bsContainer.detach();
      });
    },

    setOptionStatus: function (selectedOnly) {
      var that = this;

      that.noScroll = false;

      if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) {
        for (var i = 0; i < that.selectpicker.view.visibleElements.length; i++) {
          var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0],
              option = liData.option;

          if (option) {
            if (selectedOnly !== true) {
              that.setDisabled(
                liData.index,
                liData.disabled
              );
            }

            that.setSelected(
              liData.index,
              option.selected
            );
          }
        }
      }
    },

    /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     */
    setSelected: function (index, selected) {
      var li = this.selectpicker.main.elements[index],
          liData = this.selectpicker.main.data[index],
          activeIndexIsSet = this.activeIndex !== undefined,
          thisIsActive = this.activeIndex === index,
          prevActive,
          a,
          // if current option is already active
          // OR
          // if the current option is being selected, it's NOT multiple, and
          // activeIndex is undefined:
          //  - when the menu is first being opened, OR
          //  - after a search has been performed, OR
          //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
          keepActive = thisIsActive || (selected && !this.multiple && !activeIndexIsSet);

      liData.selected = selected;

      a = li.firstChild;

      if (selected) {
        this.selectedIndex = index;
      }

      li.classList.toggle('selected', selected);

      if (keepActive) {
        this.focusItem(li, liData);
        this.selectpicker.view.currentActive = li;
        this.activeIndex = index;
      } else {
        this.defocusItem(li);
      }

      if (a) {
        a.classList.toggle('selected', selected);

        if (selected) {
          a.setAttribute('aria-selected', true);
        } else {
          if (this.multiple) {
            a.setAttribute('aria-selected', false);
          } else {
            a.removeAttribute('aria-selected');
          }
        }
      }

      if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
        prevActive = this.selectpicker.main.elements[this.prevActiveIndex];

        this.defocusItem(prevActive);
      }
    },

    /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     */
    setDisabled: function (index, disabled) {
      var li = this.selectpicker.main.elements[index],
          a;

      this.selectpicker.main.data[index].disabled = disabled;

      a = li.firstChild;

      li.classList.toggle(classNames.DISABLED, disabled);

      if (a) {
        if (version.major === '4') a.classList.toggle(classNames.DISABLED, disabled);

        if (disabled) {
          a.setAttribute('aria-disabled', disabled);
          a.setAttribute('tabindex', -1);
        } else {
          a.removeAttribute('aria-disabled');
          a.setAttribute('tabindex', 0);
        }
      }
    },

    isDisabled: function () {
      return this.$element[0].disabled;
    },

    checkDisabled: function () {
      if (this.isDisabled()) {
        this.$newElement[0].classList.add(classNames.DISABLED);
        this.$button.addClass(classNames.DISABLED).attr('aria-disabled', true);
      } else {
        if (this.$button[0].classList.contains(classNames.DISABLED)) {
          this.$newElement[0].classList.remove(classNames.DISABLED);
          this.$button.removeClass(classNames.DISABLED).attr('aria-disabled', false);
        }
      }
    },

    clickListener: function () {
      var that = this,
          $document = $(document);

      $document.data('spaceSelect', false);

      this.$button.on('keyup', function (e) {
        if (/(32)/.test(e.keyCode.toString(10)) && $document.data('spaceSelect')) {
          e.preventDefault();
          $document.data('spaceSelect', false);
        }
      });

      this.$newElement.on('show.bs.dropdown', function () {
        if (version.major > 3 && !that.dropdown) {
          that.dropdown = that.$button.data('bs.dropdown');
          that.dropdown._menu = that.$menu[0];
        }
      });

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (!that.$newElement.hasClass(classNames.SHOW)) {
          that.setSize();
        }
      });

      function setFocus () {
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$menuInner.trigger('focus');
        }
      }

      function checkPopperExists () {
        if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) {
          setFocus();
        } else {
          requestAnimationFrame(checkPopperExists);
        }
      }

      this.$element.on('shown' + EVENT_KEY, function () {
        if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) {
          that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
        }

        if (version.major > 3) {
          requestAnimationFrame(checkPopperExists);
        } else {
          setFocus();
        }
      });

      // ensure posinset and setsize are correct before selecting an option via a click
      this.$menuInner.on('mouseenter', 'li a', function (e) {
        var hoverLi = this.parentElement,
            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
            index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi),
            hoverData = that.selectpicker.current.data[index + position0];

        that.focusItem(hoverLi, hoverData, true);
      });

      this.$menuInner.on('click', 'li a', function (e, retainActive) {
        var $this = $(this),
            element = that.$element[0],
            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
            clickedData = that.selectpicker.current.data[$this.parent().index() + position0],
            clickedIndex = clickedData.index,
            prevValue = getSelectValues(element),
            prevIndex = element.selectedIndex,
            prevOption = element.options[prevIndex],
            triggerChange = true;

        // Don't close on multi choice menu
        if (that.multiple && that.options.maxOptions !== 1) {
          e.stopPropagation();
        }

        e.preventDefault();

        // Don't run if the select is disabled
        if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
          var option = clickedData.option,
              $option = $(option),
              state = option.selected,
              $optgroup = $option.parent('optgroup'),
              $optgroupOptions = $optgroup.find('option'),
              maxOptions = that.options.maxOptions,
              maxOptionsGrp = $optgroup.data('maxOptions') || false;

          if (clickedIndex === that.activeIndex) retainActive = true;

          if (!retainActive) {
            that.prevActiveIndex = that.activeIndex;
            that.activeIndex = undefined;
          }

          if (!that.multiple) { // Deselect all others if not multi select box
            if (prevOption) prevOption.selected = false;
            option.selected = true;
            that.setSelected(clickedIndex, true);
          } else { // Toggle the one we have chosen if we are multi select.
            option.selected = !state;

            that.setSelected(clickedIndex, !state);
            that.focusedParent.focus();

            if (maxOptions !== false || maxOptionsGrp !== false) {
              var maxReached = maxOptions < getSelectedOptions(element).length,
                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;

              if ((maxOptions && maxReached) || (maxOptionsGrp && maxReachedGrp)) {
                if (maxOptions && maxOptions == 1) {
                  element.selectedIndex = -1;
                  option.selected = true;
                  that.setOptionStatus(true);
                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                  for (var i = 0; i < $optgroupOptions.length; i++) {
                    var _option = $optgroupOptions[i];
                    _option.selected = false;
                    that.setSelected(_option.liIndex, false);
                  }

                  option.selected = true;
                  that.setSelected(clickedIndex, true);
                } else {
                  var maxOptionsText = typeof that.options.maxOptionsText === 'string' ? [that.options.maxOptionsText, that.options.maxOptionsText] : that.options.maxOptionsText,
                      maxOptionsArr = typeof maxOptionsText === 'function' ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText,
                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
                      $notify = $('<div class="notify"></div>');
                  // If {var} is set in array, replace it
                  /** @deprecated */
                  if (maxOptionsArr[2]) {
                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                  }

                  option.selected = false;

                  that.$menu.append($notify);

                  if (maxOptions && maxReached) {
                    $notify.append($('<div>' + maxTxt + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReached' + EVENT_KEY);
                  }

                  if (maxOptionsGrp && maxReachedGrp) {
                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReachedGrp' + EVENT_KEY);
                  }

                  setTimeout(function () {
                    that.setSelected(clickedIndex, false);
                  }, 10);

                  $notify[0].classList.add('fadeOut');

                  setTimeout(function () {
                    $notify.remove();
                  }, 1050);
                }
              }
            }
          }

          if (!that.multiple || (that.multiple && that.options.maxOptions === 1)) {
            that.$button.trigger('focus');
          } else if (that.options.liveSearch) {
            that.$searchbox.trigger('focus');
          }

          // Trigger select 'change'
          if (triggerChange) {
            if (that.multiple || prevIndex !== element.selectedIndex) {
              // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
              changedArguments = [option.index, $option.prop('selected'), prevValue];
              that.$element
                .triggerNative('change');
            }
          }
        }
      });

      this.$menu.on('click', 'li.' + classNames.DISABLED + ' a, .' + classNames.POPOVERHEADER + ', .' + classNames.POPOVERHEADER + ' :not(.close)', function (e) {
        if (e.currentTarget == this) {
          e.preventDefault();
          e.stopPropagation();
          if (that.options.liveSearch && !$(e.target).hasClass('close')) {
            that.$searchbox.trigger('focus');
          } else {
            that.$button.trigger('focus');
          }
        }
      });

      this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$button.trigger('focus');
        }
      });

      this.$menu.on('click', '.' + classNames.POPOVERHEADER + ' .close', function () {
        that.$button.trigger('click');
      });

      this.$searchbox.on('click', function (e) {
        e.stopPropagation();
      });

      this.$menu.on('click', '.actions-btn', function (e) {
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$button.trigger('focus');
        }

        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('bs-select-all')) {
          that.selectAll();
        } else {
          that.deselectAll();
        }
      });

      this.$button
        .on('focus' + EVENT_KEY, function (e) {
          var tabindex = that.$element[0].getAttribute('tabindex');

          // only change when button is actually focused
          if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
            // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
            this.setAttribute('tabindex', tabindex);
            // set element's tabindex to -1 to allow for reverse tabbing
            that.$element[0].setAttribute('tabindex', -1);
            that.selectpicker.view.tabindex = tabindex;
          }
        })
        .on('blur' + EVENT_KEY, function (e) {
          // revert everything to original tabindex
          if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
            that.$element[0].setAttribute('tabindex', that.selectpicker.view.tabindex);
            this.setAttribute('tabindex', -1);
            that.selectpicker.view.tabindex = undefined;
          }
        });

      this.$element
        .on('change' + EVENT_KEY, function () {
          that.render();
          that.$element.trigger('changed' + EVENT_KEY, changedArguments);
          changedArguments = null;
        })
        .on('focus' + EVENT_KEY, function () {
          if (!that.options.mobile) that.$button[0].focus();
        });
    },

    liveSearchListener: function () {
      var that = this;

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (!!that.$searchbox.val()) {
          that.$searchbox.val('');
          that.selectpicker.search.previousValue = undefined;
        }
      });

      this.$searchbox.on('click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api', function (e) {
        e.stopPropagation();
      });

      this.$searchbox.on('input propertychange', function () {
        var searchValue = that.$searchbox[0].value;

        that.selectpicker.search.elements = [];
        that.selectpicker.search.data = [];

        if (searchValue) {
          var i,
              searchMatch = [],
              q = searchValue.toUpperCase(),
              cache = {},
              cacheArr = [],
              searchStyle = that._searchStyle(),
              normalizeSearch = that.options.liveSearchNormalize;

          if (normalizeSearch) q = normalizeToBase(q);

          for (var i = 0; i < that.selectpicker.main.data.length; i++) {
            var li = that.selectpicker.main.data[i];

            if (!cache[i]) {
              cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
            }

            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
              if (li.headerIndex > 0) {
                cache[li.headerIndex - 1] = true;
                cacheArr.push(li.headerIndex - 1);
              }

              cache[li.headerIndex] = true;
              cacheArr.push(li.headerIndex);

              cache[li.lastIndex + 1] = true;
            }

            if (cache[i] && li.type !== 'optgroup-label') cacheArr.push(i);
          }

          for (var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++) {
            var index = cacheArr[i],
                prevIndex = cacheArr[i - 1],
                li = that.selectpicker.main.data[index],
                liPrev = that.selectpicker.main.data[prevIndex];

            if (li.type !== 'divider' || (li.type === 'divider' && liPrev && liPrev.type !== 'divider' && cacheLen - 1 !== i)) {
              that.selectpicker.search.data.push(li);
              searchMatch.push(that.selectpicker.main.elements[index]);
            }
          }

          that.activeIndex = undefined;
          that.noScroll = true;
          that.$menuInner.scrollTop(0);
          that.selectpicker.search.elements = searchMatch;
          that.createView(true);
          showNoResults.call(that, searchMatch, searchValue);
        } else if (that.selectpicker.search.previousValue) { // for IE11 (#2402)
          that.$menuInner.scrollTop(0);
          that.createView(false);
        }

        that.selectpicker.search.previousValue =  searchValue;
      });
    },

    _searchStyle: function () {
      return this.options.liveSearchStyle || 'contains';
    },

    val: function (value) {
      var element = this.$element[0];

      if (typeof value !== 'undefined') {
        var prevValue = getSelectValues(element);

        changedArguments = [null, null, prevValue];

        this.$element
          .val(value)
          .trigger('changed' + EVENT_KEY, changedArguments);

        if (this.$newElement.hasClass(classNames.SHOW)) {
          if (this.multiple) {
            this.setOptionStatus(true);
          } else {
            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;

            if (typeof liSelectedIndex === 'number') {
              this.setSelected(this.selectedIndex, false);
              this.setSelected(liSelectedIndex, true);
            }
          }
        }

        this.render();

        changedArguments = null;

        return this.$element;
      } else {
        return this.$element.val();
      }
    },

    changeAll: function (status) {
      if (!this.multiple) return;
      if (typeof status === 'undefined') status = true;

      var element = this.$element[0],
          previousSelected = 0,
          currentSelected = 0,
          prevValue = getSelectValues(element);

      element.classList.add('bs-select-hidden');

      for (var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++) {
        var liData = data[i],
            option = liData.option;

        if (option && !liData.disabled && liData.type !== 'divider') {
          if (liData.selected) previousSelected++;
          option.selected = status;
          if (status === true) currentSelected++;
        }
      }

      element.classList.remove('bs-select-hidden');

      if (previousSelected === currentSelected) return;

      this.setOptionStatus();

      changedArguments = [null, null, prevValue];

      this.$element
        .triggerNative('change');
    },

    selectAll: function () {
      return this.changeAll(true);
    },

    deselectAll: function () {
      return this.changeAll(false);
    },

    toggle: function (e) {
      e = e || window.event;

      if (e) e.stopPropagation();

      this.$button.trigger('click.bs.dropdown.data-api');
    },

    keydown: function (e) {
      var $this = $(this),
          isToggle = $this.hasClass('dropdown-toggle'),
          $parent = isToggle ? $this.closest('.dropdown') : $this.closest(Selector.MENU),
          that = $parent.data('this'),
          $items = that.findLis(),
          index,
          isActive,
          liActive,
          activeLi,
          offset,
          updateScroll = false,
          downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab,
          isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab,
          scrollTop = that.$menuInner[0].scrollTop,
          isVirtual = that.isVirtual(),
          position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;

      // do nothing if a function key is pressed
      if (e.which >= 112 && e.which <= 123) return;

      isActive = that.$newElement.hasClass(classNames.SHOW);

      if (
        !isActive &&
        (
          isArrowKey ||
          (e.which >= 48 && e.which <= 57) ||
          (e.which >= 96 && e.which <= 105) ||
          (e.which >= 65 && e.which <= 90)
        )
      ) {
        that.$button.trigger('click.bs.dropdown.data-api');

        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
          return;
        }
      }

      if (e.which === keyCodes.ESCAPE && isActive) {
        e.preventDefault();
        that.$button.trigger('click.bs.dropdown.data-api').trigger('focus');
      }

      if (isArrowKey) { // if up or down
        if (!$items.length) return;

        liActive = that.selectpicker.main.elements[that.activeIndex];
        index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;

        if (index !== -1) {
          that.defocusItem(liActive);
        }

        if (e.which === keyCodes.ARROW_UP) { // up
          if (index !== -1) index--;
          if (index + position0 < 0) index += $items.length;

          if (!that.selectpicker.view.canHighlight[index + position0]) {
            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
            if (index === -1) index = $items.length - 1;
          }
        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
          index++;
          if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;

          if (!that.selectpicker.view.canHighlight[index + position0]) {
            index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
          }
        }

        e.preventDefault();

        var liActiveIndex = position0 + index;

        if (e.which === keyCodes.ARROW_UP) { // up
          // scroll to bottom and highlight last option
          if (position0 === 0 && index === $items.length - 1) {
            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;

            liActiveIndex = that.selectpicker.current.elements.length - 1;
          } else {
            activeLi = that.selectpicker.current.data[liActiveIndex];
            offset = activeLi.position - activeLi.height;

            updateScroll = offset < scrollTop;
          }
        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
          // scroll to top and highlight first option
          if (index === that.selectpicker.view.firstHighlightIndex) {
            that.$menuInner[0].scrollTop = 0;

            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
          } else {
            activeLi = that.selectpicker.current.data[liActiveIndex];
            offset = activeLi.position - that.sizeInfo.menuInnerHeight;

            updateScroll = offset > scrollTop;
          }
        }

        liActive = that.selectpicker.current.elements[liActiveIndex];

        that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;

        that.focusItem(liActive);

        that.selectpicker.view.currentActive = liActive;

        if (updateScroll) that.$menuInner[0].scrollTop = offset;

        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          $this.trigger('focus');
        }
      } else if (
        (!$this.is('input') && !REGEXP_TAB_OR_ESCAPE.test(e.which)) ||
        (e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory)
      ) {
        var searchMatch,
            matches = [],
            keyHistory;

        e.preventDefault();

        that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];

        if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
        that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();

        keyHistory = that.selectpicker.keydown.keyHistory;

        // if all letters are the same, set keyHistory to just the first character when searching
        if (/^(.)\1+$/.test(keyHistory)) {
          keyHistory = keyHistory.charAt(0);
        }

        // find matches
        for (var i = 0; i < that.selectpicker.current.data.length; i++) {
          var li = that.selectpicker.current.data[i],
              hasMatch;

          hasMatch = stringSearch(li, keyHistory, 'startsWith', true);

          if (hasMatch && that.selectpicker.view.canHighlight[i]) {
            matches.push(li.index);
          }
        }

        if (matches.length) {
          var matchIndex = 0;

          $items.removeClass('active').find('a').removeClass('active');

          // either only one key has been pressed or they are all the same key
          if (keyHistory.length === 1) {
            matchIndex = matches.indexOf(that.activeIndex);

            if (matchIndex === -1 || matchIndex === matches.length - 1) {
              matchIndex = 0;
            } else {
              matchIndex++;
            }
          }

          searchMatch = matches[matchIndex];

          activeLi = that.selectpicker.main.data[searchMatch];

          if (scrollTop - activeLi.position > 0) {
            offset = activeLi.position - activeLi.height;
            updateScroll = true;
          } else {
            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
            // if the option is already visible at the current scroll position, just keep it the same
            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
          }

          liActive = that.selectpicker.main.elements[searchMatch];

          that.activeIndex = matches[matchIndex];

          that.focusItem(liActive);

          if (liActive) liActive.firstChild.focus();

          if (updateScroll) that.$menuInner[0].scrollTop = offset;

          $this.trigger('focus');
        }
      }

      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
      if (
        isActive &&
        (
          (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory) ||
          e.which === keyCodes.ENTER ||
          (e.which === keyCodes.TAB && that.options.selectOnTab)
        )
      ) {
        if (e.which !== keyCodes.SPACE) e.preventDefault();

        if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
          that.$menuInner.find('.active a').trigger('click', true); // retain active class
          $this.trigger('focus');

          if (!that.options.liveSearch) {
            // Prevent screen from scrolling if the user hits the spacebar
            e.preventDefault();
            // Fixes spacebar selection of dropdown items in FF & IE
            $(document).data('spaceSelect', true);
          }
        }
      }
    },

    mobile: function () {
      // ensure mobile is set to true if mobile function is called after init
      this.options.mobile = true;
      this.$element[0].classList.add('mobile-device');
    },

    refresh: function () {
      // update options if data attributes have been changed
      var config = $.extend({}, this.options, this.$element.data());
      this.options = config;

      this.checkDisabled();
      this.buildData();
      this.setStyle();
      this.render();
      this.buildList();
      this.setWidth();

      this.setSize(true);

      this.$element.trigger('refreshed' + EVENT_KEY);
    },

    hide: function () {
      this.$newElement.hide();
    },

    show: function () {
      this.$newElement.show();
    },

    remove: function () {
      this.$newElement.remove();
      this.$element.remove();
    },

    destroy: function () {
      this.$newElement.before(this.$element).remove();

      if (this.$bsContainer) {
        this.$bsContainer.remove();
      } else {
        this.$menu.remove();
      }

      if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) {
        this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
      }

      this.$element
        .off(EVENT_KEY)
        .removeData('selectpicker')
        .removeClass('bs-select-hidden selectpicker');

      $(window).off(EVENT_KEY + '.' + this.selectId);
    }
  };

  // SELECTPICKER PLUGIN DEFINITION
  // ==============================
  function Plugin (option) {
    // get the args of the outer function..
    var args = arguments;
    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
    // to get lost/corrupted in android 2.3 and IE9 #715 #775
    var _option = option;

    [].shift.apply(args);

    // if the version was not set successfully
    if (!version.success) {
      // try to retreive it again
      try {
        version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
      } catch (err) {
        // fall back to use BootstrapVersion if set
        if (Selectpicker.BootstrapVersion) {
          version.full = Selectpicker.BootstrapVersion.split(' ')[0].split('.');
        } else {
          version.full = [version.major, '0', '0'];

          console.warn(
            'There was an issue retrieving Bootstrap\'s version. ' +
            'Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. ' +
            'If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.',
            err
          );
        }
      }

      version.major = version.full[0];
      version.success = true;
    }

    if (version.major === '4') {
      // some defaults need to be changed if using Bootstrap 4
      // check to see if they have already been manually changed before forcing them to update
      var toUpdate = [];

      if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({ name: 'style', className: 'BUTTONCLASS' });
      if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({ name: 'iconBase', className: 'ICONBASE' });
      if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({ name: 'tickIcon', className: 'TICKICON' });

      classNames.DIVIDER = 'dropdown-divider';
      classNames.SHOW = 'show';
      classNames.BUTTONCLASS = 'btn-light';
      classNames.POPOVERHEADER = 'popover-header';
      classNames.ICONBASE = '';
      classNames.TICKICON = 'bs-ok-default';

      for (var i = 0; i < toUpdate.length; i++) {
        var option = toUpdate[i];
        Selectpicker.DEFAULTS[option.name] = classNames[option.className];
      }
    }

    var value;
    var chain = this.each(function () {
      var $this = $(this);
      if ($this.is('select')) {
        var data = $this.data('selectpicker'),
            options = typeof _option == 'object' && _option;

        if (!data) {
          var dataAttributes = $this.data();

          for (var dataAttr in dataAttributes) {
            if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
              delete dataAttributes[dataAttr];
            }
          }

          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
          config.template = $.extend({}, Selectpicker.DEFAULTS.template, ($.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}), dataAttributes.template, options.template);
          $this.data('selectpicker', (data = new Selectpicker(this, config)));
        } else if (options) {
          for (var i in options) {
            if (Object.prototype.hasOwnProperty.call(options, i)) {
              data.options[i] = options[i];
            }
          }
        }

        if (typeof _option == 'string') {
          if (data[_option] instanceof Function) {
            value = data[_option].apply(data, args);
          } else {
            value = data.options[_option];
          }
        }
      }
    });

    if (typeof value !== 'undefined') {
      // noinspection JSUnusedAssignment
      return value;
    } else {
      return chain;
    }
  }

  var old = $.fn.selectpicker;
  $.fn.selectpicker = Plugin;
  $.fn.selectpicker.Constructor = Selectpicker;

  // SELECTPICKER NO CONFLICT
  // ========================
  $.fn.selectpicker.noConflict = function () {
    $.fn.selectpicker = old;
    return this;
  };

  // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
  function keydownHandler () {
    if ($.fn.dropdown) {
      // wait to define until function is called in case Bootstrap isn't loaded yet
      var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
      return bootstrapKeydown.apply(this, arguments);
    }
  }

  $(document)
    .off('keydown.bs.dropdown.data-api')
    .on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler)
    .on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > .dropdown-menu', keydownHandler)
    .on('keydown' + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown)
    .on('focusin.modal', '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function (e) {
      e.stopPropagation();
    });

  // SELECTPICKER DATA-API
  // =====================
  $(window).on('load' + EVENT_KEY + '.data-api', function () {
    $('.selectpicker').each(function () {
      var $selectpicker = $(this);
      Plugin.call($selectpicker, $selectpicker.data());
    })
  });
})(jQuery);


}));

},{"jquery":14}],4:[function(require,module,exports){
/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // https://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.4.1'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    selector    = selector === '#' ? [] : selector
    var $parent = $(document).find(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.4.1'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.4.1'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      if (typeof $next === 'object' && $next.length) {
        $next[0].offsetWidth // force reflow
      }
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    if (href) {
      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
    }

    var target  = $this.attr('data-target') || href
    var $target = $(document).find(target)

    if (!$target.hasClass('carousel')) return

    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.4.1'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(document).find(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(document).find(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.4.1'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector !== '#' ? $(document).find(selector) : null

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options
    this.$body = $(document.body)
    this.$element = $(element)
    this.$dialog = this.$element.find('.modal-dialog')
    this.$backdrop = null
    this.isShown = null
    this.originalBodyPad = null
    this.scrollbarWidth = 0
    this.ignoreBackdropClick = false
    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION = '3.4.1'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
          this.$element[0] !== e.target &&
          !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    var scrollbarWidth = this.scrollbarWidth
    if (this.bodyIsOverflowing) {
      this.$body.css('padding-right', bodyPad + scrollbarWidth)
      $(this.fixedContent).each(function (index, element) {
        var actualPadding = element.style.paddingRight
        var calculatedPadding = $(element).css('padding-right')
        $(element)
          .data('padding-right', actualPadding)
          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
      })
    }
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
    $(this.fixedContent).each(function (index, element) {
      var padding = $(element).data('padding-right')
      $(element).removeData('padding-right')
      element.style.paddingRight = padding ? padding : ''
    })
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
    var href = $this.attr('href')
    var target = $this.attr('data-target') ||
      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7

    var $target = $(document).find(target)
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ]

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml)
    }

    // IE 8 and below don't support createHTMLDocument
    if (!document.implementation || !document.implementation.createHTMLDocument) {
      return unsafeHtml
    }

    var createdDocument = document.implementation.createHTMLDocument('sanitization')
    createdDocument.body.innerHTML = unsafeHtml

    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
    var elements = $(createdDocument.body).find('*')

    for (var i = 0, len = elements.length; i < len; i++) {
      var el = elements[i]
      var elName = el.nodeName.toLowerCase()

      if ($.inArray(elName, whitelistKeys) === -1) {
        el.parentNode.removeChild(el)

        continue
      }

      var attributeList = $.map(el.attributes, function (el) { return el })
      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])

      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
          el.removeAttribute(attributeList[j].nodeName)
        }
      }
    }

    return createdDocument.body.innerHTML
  }

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.4.1'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    },
    sanitize : true,
    sanitizeFn : null,
    whiteList : DefaultWhitelist
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    var dataAttributes = this.$element.data()

    for (var dataAttr in dataAttributes) {
      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
        delete dataAttributes[dataAttr]
      }
    }

    options = $.extend({}, this.getDefaults(), dataAttributes, options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    if (options.sanitize) {
      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    if (this.options.html) {
      if (this.options.sanitize) {
        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
      }

      $tip.find('.tooltip-inner').html(title)
    } else {
      $tip.find('.tooltip-inner').text(title)
    }

    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }

  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
  }

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.4.1'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    if (this.options.html) {
      var typeContent = typeof content

      if (this.options.sanitize) {
        title = this.sanitizeHtml(title)

        if (typeContent === 'string') {
          content = this.sanitizeHtml(content)
        }
      }

      $tip.find('.popover-title').html(title)
      $tip.find('.popover-content').children().detach().end()[
        typeContent === 'string' ? 'html' : 'append'
      ](content)
    } else {
      $tip.find('.popover-title').text(title)
      $tip.find('.popover-content').children().detach().end().text(content)
    }

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
        o.content.call($e[0]) :
        o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.4.1'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.4.1'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(document).find(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
        .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
          .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#affix
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)

    this.$target = target
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.4.1'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

},{}],5:[function(require,module,exports){

},{}],6:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"base64-js":1,"buffer":6,"ieee754":9}],7:[function(require,module,exports){
(function (Buffer){(function (){
/* build: `node build.js modules=ALL exclude=gestures,accessors requirejs minifier=uglifyjs` */
/*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */

var fabric = fabric || { version: '3.6.6' };
if (typeof exports !== 'undefined') {
  exports.fabric = fabric;
}
/* _AMD_START_ */
else if (typeof define === 'function' && define.amd) {
  define([], function() { return fabric; });
}
/* _AMD_END_ */
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (document instanceof (typeof HTMLDocument !== 'undefined' ? HTMLDocument : Document)) {
    fabric.document = document;
  }
  else {
    fabric.document = document.implementation.createHTMLDocument('');
  }
  fabric.window = window;
}
else {
  // assume we're running under node.js when document/window are not present
  var jsdom = require('jsdom');
  var virtualWindow = new jsdom.JSDOM(
    decodeURIComponent('%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E'),
    {
      features: {
        FetchExternalResources: ['img']
      },
      resources: 'usable'
    }).window;
  fabric.document = virtualWindow.document;
  fabric.jsdomImplForWrapper = require('jsdom/lib/jsdom/living/generated/utils').implForWrapper;
  fabric.nodeCanvas = require('jsdom/lib/jsdom/utils').Canvas;
  fabric.window = virtualWindow;
  DOMParser = fabric.window.DOMParser;
}

/**
 * True when in environment that supports touch events
 * @type boolean
 */
fabric.isTouchSupported = 'ontouchstart' in fabric.window || 'ontouchstart' in fabric.document ||
  (fabric.window && fabric.window.navigator && fabric.window.navigator.maxTouchPoints > 0);

/**
 * True when in environment that's probably Node.js
 * @type boolean
 */
fabric.isLikelyNode = typeof Buffer !== 'undefined' &&
                      typeof window === 'undefined';

/* _FROM_SVG_START_ */
/**
 * Attributes parsed from all SVG elements
 * @type array
 */
fabric.SHARED_ATTRIBUTES = [
  'display',
  'transform',
  'fill', 'fill-opacity', 'fill-rule',
  'opacity',
  'stroke', 'stroke-dasharray', 'stroke-linecap', 'stroke-dashoffset',
  'stroke-linejoin', 'stroke-miterlimit',
  'stroke-opacity', 'stroke-width',
  'id', 'paint-order', 'vector-effect',
  'instantiated_by_use', 'clip-path'
];
/* _FROM_SVG_END_ */

/**
 * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
 */
fabric.DPI = 96;
fabric.reNum = '(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)';
fabric.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/ig;
fabric.reNonWord = /[ \n\.,;!\?\-]/;
fabric.fontPaths = { };
fabric.iMatrix = [1, 0, 0, 1, 0, 0];
fabric.svgNS = 'http://www.w3.org/2000/svg';

/**
 * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
 * @since 1.7.14
 * @type Number
 * @default
 */
fabric.perfLimitSizeTotal = 2097152;

/**
 * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
 * @since 1.7.14
 * @type Number
 * @default
 */
fabric.maxCacheSideLimit = 4096;

/**
 * Lowest pixel limit for cache canvases, set at 256PX
 * @since 1.7.14
 * @type Number
 * @default
 */
fabric.minCacheSideLimit = 256;

/**
 * Cache Object for widths of chars in text rendering.
 */
fabric.charWidthsCache = { };

/**
 * if webgl is enabled and available, textureSize will determine the size
 * of the canvas backend
 * @since 2.0.0
 * @type Number
 * @default
 */
fabric.textureSize = 2048;

/**
 * When 'true', style information is not retained when copy/pasting text, making
 * pasted text use destination style.
 * Defaults to 'false'.
 * @type Boolean
 * @default
 */
fabric.disableStyleCopyPaste = false;

/**
 * Enable webgl for filtering picture is available
 * A filtering backend will be initialized, this will both take memory and
 * time since a default 2048x2048 canvas will be created for the gl context
 * @since 2.0.0
 * @type Boolean
 * @default
 */
fabric.enableGLFiltering = true;

/**
 * Device Pixel Ratio
 * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
 */
fabric.devicePixelRatio = fabric.window.devicePixelRatio ||
                          fabric.window.webkitDevicePixelRatio ||
                          fabric.window.mozDevicePixelRatio ||
                          1;
/**
 * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
 * which is unitless and not rendered equally across browsers.
 *
 * Values that work quite well (as of October 2017) are:
 * - Chrome: 1.5
 * - Edge: 1.75
 * - Firefox: 0.9
 * - Safari: 0.95
 *
 * @since 2.0.0
 * @type Number
 * @default 1
 */
fabric.browserShadowBlurConstant = 1;

/**
 * This object contains the result of arc to beizer conversion for faster retrieving if the same arc needs to be converted again.
 * It was an internal variable, is accessible since version 2.3.4
 */
fabric.arcToSegmentsCache = { };

/**
 * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
 * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
 * you do not get any speed benefit and you get a big object in memory.
 * The object was a private variable before, while now is appended to the lib so that you have access to it and you
 * can eventually clear it.
 * It was an internal variable, is accessible since version 2.3.4
 */
fabric.boundsOfCurveCache = { };

/**
 * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
 * @default true
 */
fabric.cachesBoundsOfCurve = true;

/**
 * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
 * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
 * this has to be set before instantiating the filtering backend ( before filtering the first image )
 * @type Boolean
 * @default false
 */
fabric.forceGLPutImageData = false;

fabric.initFilterBackend = function() {
  if (fabric.enableGLFiltering && fabric.isWebglSupported && fabric.isWebglSupported(fabric.textureSize)) {
    console.log('max texture size: ' + fabric.maxTextureSize);
    return (new fabric.WebglFilterBackend({ tileSize: fabric.textureSize }));
  }
  else if (fabric.Canvas2dFilterBackend) {
    return (new fabric.Canvas2dFilterBackend());
  }
};


if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // ensure globality even if entire library were function wrapped (as in Meteor.js packaging system)
  window.fabric = fabric;
}


(function() {

  /**
   * @private
   * @param {String} eventName
   * @param {Function} handler
   */
  function _removeEventListener(eventName, handler) {
    if (!this.__eventListeners[eventName]) {
      return;
    }
    var eventListener = this.__eventListeners[eventName];
    if (handler) {
      eventListener[eventListener.indexOf(handler)] = false;
    }
    else {
      fabric.util.array.fill(eventListener, false);
    }
  }

  /**
   * Observes specified event
   * @deprecated `observe` deprecated since 0.8.34 (use `on` instead)
   * @memberOf fabric.Observable
   * @alias on
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Self} thisArg
   * @chainable
   */
  function observe(eventName, handler) {
    if (!this.__eventListeners) {
      this.__eventListeners = { };
    }
    // one object with key/value pairs was passed
    if (arguments.length === 1) {
      for (var prop in eventName) {
        this.on(prop, eventName[prop]);
      }
    }
    else {
      if (!this.__eventListeners[eventName]) {
        this.__eventListeners[eventName] = [];
      }
      this.__eventListeners[eventName].push(handler);
    }
    return this;
  }

  /**
   * Stops event observing for a particular event handler. Calling this method
   * without arguments removes all handlers for all events
   * @deprecated `stopObserving` deprecated since 0.8.34 (use `off` instead)
   * @memberOf fabric.Observable
   * @alias off
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function to be deleted from EventListeners
   * @return {Self} thisArg
   * @chainable
   */
  function stopObserving(eventName, handler) {
    if (!this.__eventListeners) {
      return this;
    }

    // remove all key/value pairs (event name -> event handler)
    if (arguments.length === 0) {
      for (eventName in this.__eventListeners) {
        _removeEventListener.call(this, eventName);
      }
    }
    // one object with key/value pairs was passed
    else if (arguments.length === 1 && typeof arguments[0] === 'object') {
      for (var prop in eventName) {
        _removeEventListener.call(this, prop, eventName[prop]);
      }
    }
    else {
      _removeEventListener.call(this, eventName, handler);
    }
    return this;
  }

  /**
   * Fires event with an optional options object
   * @deprecated `fire` deprecated since 1.0.7 (use `trigger` instead)
   * @memberOf fabric.Observable
   * @alias trigger
   * @param {String} eventName Event name to fire
   * @param {Object} [options] Options object
   * @return {Self} thisArg
   * @chainable
   */
  function fire(eventName, options) {
    if (!this.__eventListeners) {
      return this;
    }

    var listenersForEvent = this.__eventListeners[eventName];
    if (!listenersForEvent) {
      return this;
    }

    for (var i = 0, len = listenersForEvent.length; i < len; i++) {
      listenersForEvent[i] && listenersForEvent[i].call(this, options || { });
    }
    this.__eventListeners[eventName] = listenersForEvent.filter(function(value) {
      return value !== false;
    });
    return this;
  }

  /**
   * @namespace fabric.Observable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
   * @see {@link http://fabricjs.com/events|Events demo}
   */
  fabric.Observable = {
    observe: observe,
    stopObserving: stopObserving,
    fire: fire,

    on: observe,
    off: stopObserving,
    trigger: fire
  };
})();


/**
 * @namespace fabric.Collection
 */
fabric.Collection = {

  _objects: [],

  /**
   * Adds objects to collection, Canvas or Group, then renders canvas
   * (if `renderOnAddRemove` is not `false`).
   * in case of Group no changes to bounding box are made.
   * Objects should be instances of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the add method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */
  add: function () {
    this._objects.push.apply(this._objects, arguments);
    if (this._onObjectAdded) {
      for (var i = 0, length = arguments.length; i < length; i++) {
        this._onObjectAdded(arguments[i]);
      }
    }
    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },

  /**
   * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
   * An object should be an instance of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the insertAt method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {Object} object Object to insert
   * @param {Number} index Index to insert object at
   * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
   * @return {Self} thisArg
   * @chainable
   */
  insertAt: function (object, index, nonSplicing) {
    var objects = this._objects;
    if (nonSplicing) {
      objects[index] = object;
    }
    else {
      objects.splice(index, 0, object);
    }
    this._onObjectAdded && this._onObjectAdded(object);
    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },

  /**
   * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */
  remove: function() {
    var objects = this._objects,
        index, somethingRemoved = false;

    for (var i = 0, length = arguments.length; i < length; i++) {
      index = objects.indexOf(arguments[i]);

      // only call onObjectRemoved if an object was actually removed
      if (index !== -1) {
        somethingRemoved = true;
        objects.splice(index, 1);
        this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
      }
    }

    this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
    return this;
  },

  /**
   * Executes given function for each object in this group
   * @param {Function} callback
   *                   Callback invoked with current object as first argument,
   *                   index - as second and an array of all objects - as third.
   *                   Callback is invoked in a context of Global Object (e.g. `window`)
   *                   when no `context` argument is given
   *
   * @param {Object} context Context (aka thisObject)
   * @return {Self} thisArg
   * @chainable
   */
  forEachObject: function(callback, context) {
    var objects = this.getObjects();
    for (var i = 0, len = objects.length; i < len; i++) {
      callback.call(context, objects[i], i, objects);
    }
    return this;
  },

  /**
   * Returns an array of children objects of this instance
   * Type parameter introduced in 1.3.10
   * since 2.3.5 this method return always a COPY of the array;
   * @param {String} [type] When specified, only objects of this type are returned
   * @return {Array}
   */
  getObjects: function(type) {
    if (typeof type === 'undefined') {
      return this._objects.concat();
    }
    return this._objects.filter(function(o) {
      return o.type === type;
    });
  },

  /**
   * Returns object at specified index
   * @param {Number} index
   * @return {Self} thisArg
   */
  item: function (index) {
    return this._objects[index];
  },

  /**
   * Returns true if collection contains no objects
   * @return {Boolean} true if collection is empty
   */
  isEmpty: function () {
    return this._objects.length === 0;
  },

  /**
   * Returns a size of a collection (i.e: length of an array containing its objects)
   * @return {Number} Collection size
   */
  size: function() {
    return this._objects.length;
  },

  /**
   * Returns true if collection contains an object
   * @param {Object} object Object to check against
   * @return {Boolean} `true` if collection contains an object
   */
  contains: function(object) {
    return this._objects.indexOf(object) > -1;
  },

  /**
   * Returns number representation of a collection complexity
   * @return {Number} complexity
   */
  complexity: function () {
    return this._objects.reduce(function (memo, current) {
      memo += current.complexity ? current.complexity() : 0;
      return memo;
    }, 0);
  }
};


/**
 * @namespace fabric.CommonMethods
 */
fabric.CommonMethods = {

  /**
   * Sets object's properties from options
   * @param {Object} [options] Options object
   */
  _setOptions: function(options) {
    for (var prop in options) {
      this.set(prop, options[prop]);
    }
  },

  /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Gradient to
   */
  _initGradient: function(filler, property) {
    if (filler && filler.colorStops && !(filler instanceof fabric.Gradient)) {
      this.set(property, new fabric.Gradient(filler));
    }
  },

  /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Pattern to
   * @param {Function} [callback] callback to invoke after pattern load
   */
  _initPattern: function(filler, property, callback) {
    if (filler && filler.source && !(filler instanceof fabric.Pattern)) {
      this.set(property, new fabric.Pattern(filler, callback));
    }
    else {
      callback && callback();
    }
  },

  /**
   * @private
   * @param {Object} [options] Options object
   */
  _initClipping: function(options) {
    if (!options.clipTo || typeof options.clipTo !== 'string') {
      return;
    }

    var functionBody = fabric.util.getFunctionBody(options.clipTo);
    if (typeof functionBody !== 'undefined') {
      this.clipTo = new Function('ctx', functionBody);
    }
  },

  /**
   * @private
   */
  _setObject: function(obj) {
    for (var prop in obj) {
      this._set(prop, obj[prop]);
    }
  },

  /**
   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
   * @return {fabric.Object} thisArg
   * @chainable
   */
  set: function(key, value) {
    if (typeof key === 'object') {
      this._setObject(key);
    }
    else {
      if (typeof value === 'function' && key !== 'clipTo') {
        this._set(key, value(this.get(key)));
      }
      else {
        this._set(key, value);
      }
    }
    return this;
  },

  _set: function(key, value) {
    this[key] = value;
  },

  /**
   * Toggles specified property from `true` to `false` or from `false` to `true`
   * @param {String} property Property to toggle
   * @return {fabric.Object} thisArg
   * @chainable
   */
  toggle: function(property) {
    var value = this.get(property);
    if (typeof value === 'boolean') {
      this.set(property, !value);
    }
    return this;
  },

  /**
   * Basic getter
   * @param {String} property Property name
   * @return {*} value of a property
   */
  get: function(property) {
    return this[property];
  }
};


(function(global) {

  var sqrt = Math.sqrt,
      atan2 = Math.atan2,
      pow = Math.pow,
      PiBy180 = Math.PI / 180,
      PiBy2 = Math.PI / 2;

  /**
   * @namespace fabric.util
   */
  fabric.util = {

    /**
     * Calculate the cos of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */
    cos: function(angle) {
      if (angle === 0) { return 1; }
      if (angle < 0) {
        // cos(a) = cos(-a)
        angle = -angle;
      }
      var angleSlice = angle / PiBy2;
      switch (angleSlice) {
        case 1: case 3: return 0;
        case 2: return -1;
      }
      return Math.cos(angle);
    },

    /**
     * Calculate the sin of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */
    sin: function(angle) {
      if (angle === 0) { return 0; }
      var angleSlice = angle / PiBy2, sign = 1;
      if (angle < 0) {
        // sin(-a) = -sin(a)
        sign = -1;
      }
      switch (angleSlice) {
        case 1: return sign;
        case 2: return 0;
        case 3: return -sign;
      }
      return Math.sin(angle);
    },

    /**
     * Removes value from an array.
     * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
     * @static
     * @memberOf fabric.util
     * @param {Array} array
     * @param {*} value
     * @return {Array} original array
     */
    removeFromArray: function(array, value) {
      var idx = array.indexOf(value);
      if (idx !== -1) {
        array.splice(idx, 1);
      }
      return array;
    },

    /**
     * Returns random number between 2 specified ones.
     * @static
     * @memberOf fabric.util
     * @param {Number} min lower limit
     * @param {Number} max upper limit
     * @return {Number} random value (between min and max)
     */
    getRandomInt: function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    /**
     * Transforms degrees to radians.
     * @static
     * @memberOf fabric.util
     * @param {Number} degrees value in degrees
     * @return {Number} value in radians
     */
    degreesToRadians: function(degrees) {
      return degrees * PiBy180;
    },

    /**
     * Transforms radians to degrees.
     * @static
     * @memberOf fabric.util
     * @param {Number} radians value in radians
     * @return {Number} value in degrees
     */
    radiansToDegrees: function(radians) {
      return radians / PiBy180;
    },

    /**
     * Rotates `point` around `origin` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {fabric.Point} point The point to rotate
     * @param {fabric.Point} origin The origin of the rotation
     * @param {Number} radians The radians of the angle for the rotation
     * @return {fabric.Point} The new rotated point
     */
    rotatePoint: function(point, origin, radians) {
      point.subtractEquals(origin);
      var v = fabric.util.rotateVector(point, radians);
      return new fabric.Point(v.x, v.y).addEquals(origin);
    },

    /**
     * Rotates `vector` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {Object} vector The vector to rotate (x and y)
     * @param {Number} radians The radians of the angle for the rotation
     * @return {Object} The new rotated point
     */
    rotateVector: function(vector, radians) {
      var sin = fabric.util.sin(radians),
          cos = fabric.util.cos(radians),
          rx = vector.x * cos - vector.y * sin,
          ry = vector.x * sin + vector.y * cos;
      return {
        x: rx,
        y: ry
      };
    },

    /**
     * Apply transform t to point p
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Point} p The point to transform
     * @param  {Array} t The transform
     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
     * @return {fabric.Point} The transformed point
     */
    transformPoint: function(p, t, ignoreOffset) {
      if (ignoreOffset) {
        return new fabric.Point(
          t[0] * p.x + t[2] * p.y,
          t[1] * p.x + t[3] * p.y
        );
      }
      return new fabric.Point(
        t[0] * p.x + t[2] * p.y + t[4],
        t[1] * p.x + t[3] * p.y + t[5]
      );
    },

    /**
     * Returns coordinates of points's bounding rectangle (left, top, width, height)
     * @param {Array} points 4 points array
     * @param {Array} [transform] an array of 6 numbers representing a 2x3 transform matrix
     * @return {Object} Object with left, top, width, height properties
     */
    makeBoundingBoxFromPoints: function(points, transform) {
      if (transform) {
        for (var i = 0; i < points.length; i++) {
          points[i] = fabric.util.transformPoint(points[i], transform);
        }
      }
      var xPoints = [points[0].x, points[1].x, points[2].x, points[3].x],
          minX = fabric.util.array.min(xPoints),
          maxX = fabric.util.array.max(xPoints),
          width = maxX - minX,
          yPoints = [points[0].y, points[1].y, points[2].y, points[3].y],
          minY = fabric.util.array.min(yPoints),
          maxY = fabric.util.array.max(yPoints),
          height = maxY - minY;

      return {
        left: minX,
        top: minY,
        width: width,
        height: height
      };
    },

    /**
     * Invert transformation t
     * @static
     * @memberOf fabric.util
     * @param {Array} t The transform
     * @return {Array} The inverted transform
     */
    invertTransform: function(t) {
      var a = 1 / (t[0] * t[3] - t[1] * t[2]),
          r = [a * t[3], -a * t[1], -a * t[2], a * t[0]],
          o = fabric.util.transformPoint({ x: t[4], y: t[5] }, r, true);
      r[4] = -o.x;
      r[5] = -o.y;
      return r;
    },

    /**
     * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
     * @static
     * @memberOf fabric.util
     * @param {Number|String} number number to operate on
     * @param {Number} fractionDigits number of fraction digits to "leave"
     * @return {Number}
     */
    toFixed: function(number, fractionDigits) {
      return parseFloat(Number(number).toFixed(fractionDigits));
    },

    /**
     * Converts from attribute value to pixel value if applicable.
     * Returns converted pixels or original value not converted.
     * @param {Number|String} value number to operate on
     * @param {Number} fontSize
     * @return {Number|String}
     */
    parseUnit: function(value, fontSize) {
      var unit = /\D{0,2}$/.exec(value),
          number = parseFloat(value);
      if (!fontSize) {
        fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
      }
      switch (unit[0]) {
        case 'mm':
          return number * fabric.DPI / 25.4;

        case 'cm':
          return number * fabric.DPI / 2.54;

        case 'in':
          return number * fabric.DPI;

        case 'pt':
          return number * fabric.DPI / 72; // or * 4 / 3

        case 'pc':
          return number * fabric.DPI / 72 * 12; // or * 16

        case 'em':
          return number * fontSize;

        default:
          return number;
      }
    },

    /**
     * Function which always returns `false`.
     * @static
     * @memberOf fabric.util
     * @return {Boolean}
     */
    falseFunction: function() {
      return false;
    },

    /**
     * Returns klass "Class" object of given namespace
     * @memberOf fabric.util
     * @param {String} type Type of object (eg. 'circle')
     * @param {String} namespace Namespace to get klass "Class" object from
     * @return {Object} klass "Class"
     */
    getKlass: function(type, namespace) {
      // capitalize first letter only
      type = fabric.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
      return fabric.util.resolveNamespace(namespace)[type];
    },

    /**
     * Returns array of attributes for given svg that fabric parses
     * @memberOf fabric.util
     * @param {String} type Type of svg element (eg. 'circle')
     * @return {Array} string names of supported attributes
     */
    getSvgAttributes: function(type) {
      var attributes = [
        'instantiated_by_use',
        'style',
        'id',
        'class'
      ];
      switch (type) {
        case 'linearGradient':
          attributes = attributes.concat(['x1', 'y1', 'x2', 'y2', 'gradientUnits', 'gradientTransform']);
          break;
        case 'radialGradient':
          attributes = attributes.concat(['gradientUnits', 'gradientTransform', 'cx', 'cy', 'r', 'fx', 'fy', 'fr']);
          break;
        case 'stop':
          attributes = attributes.concat(['offset', 'stop-color', 'stop-opacity']);
          break;
      }
      return attributes;
    },

    /**
     * Returns object of given namespace
     * @memberOf fabric.util
     * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
     * @return {Object} Object for given namespace (default fabric)
     */
    resolveNamespace: function(namespace) {
      if (!namespace) {
        return fabric;
      }

      var parts = namespace.split('.'),
          len = parts.length, i,
          obj = global || fabric.window;

      for (i = 0; i < len; ++i) {
        obj = obj[parts[i]];
      }

      return obj;
    },

    /**
     * Loads image element from given url and passes it to a callback
     * @memberOf fabric.util
     * @param {String} url URL representing an image
     * @param {Function} callback Callback; invoked with loaded image
     * @param {*} [context] Context to invoke callback in
     * @param {Object} [crossOrigin] crossOrigin value to set image element to
     */
    loadImage: function(url, callback, context, crossOrigin) {
      if (!url) {
        callback && callback.call(context, url);
        return;
      }

      var img = fabric.util.createImage();

      /** @ignore */
      var onLoadCallback = function () {
        callback && callback.call(context, img);
        img = img.onload = img.onerror = null;
      };

      img.onload = onLoadCallback;
      /** @ignore */
      img.onerror = function() {
        fabric.log('Error loading ' + img.src);
        callback && callback.call(context, null, true);
        img = img.onload = img.onerror = null;
      };

      // data-urls appear to be buggy with crossOrigin
      // https://github.com/kangax/fabric.js/commit/d0abb90f1cd5c5ef9d2a94d3fb21a22330da3e0a#commitcomment-4513767
      // see https://code.google.com/p/chromium/issues/detail?id=315152
      //     https://bugzilla.mozilla.org/show_bug.cgi?id=935069
      if (url.indexOf('data') !== 0 && crossOrigin) {
        img.crossOrigin = crossOrigin;
      }

      // IE10 / IE11-Fix: SVG contents from data: URI
      // will only be available if the IMG is present
      // in the DOM (and visible)
      if (url.substring(0,14) === 'data:image/svg') {
        img.onload = null;
        fabric.util.loadImageInDom(img, onLoadCallback);
      }

      img.src = url;
    },

    /**
     * Attaches SVG image with data: URL to the dom
     * @memberOf fabric.util
     * @param {Object} img Image object with data:image/svg src
     * @param {Function} callback Callback; invoked with loaded image
     * @return {Object} DOM element (div containing the SVG image)
     */
    loadImageInDom: function(img, onLoadCallback) {
      var div = fabric.document.createElement('div');
      div.style.width = div.style.height = '1px';
      div.style.left = div.style.top = '-100%';
      div.style.position = 'absolute';
      div.appendChild(img);
      fabric.document.querySelector('body').appendChild(div);
      /**
       * Wrap in function to:
       *   1. Call existing callback
       *   2. Cleanup DOM
       */
      img.onload = function () {
        onLoadCallback();
        div.parentNode.removeChild(div);
        div = null;
      };
    },

    /**
     * Creates corresponding fabric instances from their object representations
     * @static
     * @memberOf fabric.util
     * @param {Array} objects Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * @param {String} namespace Namespace to get klass "Class" object from
     * @param {Function} reviver Method for further parsing of object elements,
     * called after each fabric object created.
     */
    enlivenObjects: function(objects, callback, namespace, reviver) {
      objects = objects || [];

      var enlivenedObjects = [],
          numLoadedObjects = 0,
          numTotalObjects = objects.length;

      function onLoaded() {
        if (++numLoadedObjects === numTotalObjects) {
          callback && callback(enlivenedObjects.filter(function(obj) {
            // filter out undefined objects (objects that gave error)
            return obj;
          }));
        }
      }

      if (!numTotalObjects) {
        callback && callback(enlivenedObjects);
        return;
      }

      objects.forEach(function (o, index) {
        // if sparse array
        if (!o || !o.type) {
          onLoaded();
          return;
        }
        var klass = fabric.util.getKlass(o.type, namespace);
        klass.fromObject(o, function (obj, error) {
          error || (enlivenedObjects[index] = obj);
          reviver && reviver(o, obj, error);
          onLoaded();
        });
      });
    },

    /**
     * Create and wait for loading of patterns
     * @static
     * @memberOf fabric.util
     * @param {Array} patterns Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * called after each fabric object created.
     */
    enlivenPatterns: function(patterns, callback) {
      patterns = patterns || [];

      function onLoaded() {
        if (++numLoadedPatterns === numPatterns) {
          callback && callback(enlivenedPatterns);
        }
      }

      var enlivenedPatterns = [],
          numLoadedPatterns = 0,
          numPatterns = patterns.length;

      if (!numPatterns) {
        callback && callback(enlivenedPatterns);
        return;
      }

      patterns.forEach(function (p, index) {
        if (p && p.source) {
          new fabric.Pattern(p, function(pattern) {
            enlivenedPatterns[index] = pattern;
            onLoaded();
          });
        }
        else {
          enlivenedPatterns[index] = p;
          onLoaded();
        }
      });
    },

    /**
     * Groups SVG elements (usually those retrieved from SVG document)
     * @static
     * @memberOf fabric.util
     * @param {Array} elements SVG elements to group
     * @param {Object} [options] Options object
     * @param {String} path Value to set sourcePath to
     * @return {fabric.Object|fabric.Group}
     */
    groupSVGElements: function(elements, options, path) {
      var object;
      if (elements && elements.length === 1) {
        return elements[0];
      }
      if (options) {
        if (options.width && options.height) {
          options.centerPoint = {
            x: options.width / 2,
            y: options.height / 2
          };
        }
        else {
          delete options.width;
          delete options.height;
        }
      }
      object = new fabric.Group(elements, options);
      if (typeof path !== 'undefined') {
        object.sourcePath = path;
      }
      return object;
    },

    /**
     * Populates an object with properties of another object
     * @static
     * @memberOf fabric.util
     * @param {Object} source Source object
     * @param {Object} destination Destination object
     * @return {Array} properties Properties names to include
     */
    populateWithProperties: function(source, destination, properties) {
      if (properties && Object.prototype.toString.call(properties) === '[object Array]') {
        for (var i = 0, len = properties.length; i < len; i++) {
          if (properties[i] in source) {
            destination[properties[i]] = source[properties[i]];
          }
        }
      }
    },

    /**
     * Draws a dashed line between two points
     *
     * This method is used to draw dashed line around selection area.
     * See <a href="http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas">dotted stroke in canvas</a>
     *
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x  start x coordinate
     * @param {Number} y start y coordinate
     * @param {Number} x2 end x coordinate
     * @param {Number} y2 end y coordinate
     * @param {Array} da dash array pattern
     */
    drawDashedLine: function(ctx, x, y, x2, y2, da) {
      var dx = x2 - x,
          dy = y2 - y,
          len = sqrt(dx * dx + dy * dy),
          rot = atan2(dy, dx),
          dc = da.length,
          di = 0,
          draw = true;

      ctx.save();
      ctx.translate(x, y);
      ctx.moveTo(0, 0);
      ctx.rotate(rot);

      x = 0;
      while (len > x) {
        x += da[di++ % dc];
        if (x > len) {
          x = len;
        }
        ctx[draw ? 'lineTo' : 'moveTo'](x, 0);
        draw = !draw;
      }

      ctx.restore();
    },

    /**
     * Creates canvas element
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */
    createCanvasElement: function() {
      return fabric.document.createElement('canvas');
    },

    /**
     * Creates a canvas element that is a copy of another and is also painted
     * @param {CanvasElement} canvas to copy size and content of
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */
    copyCanvasElement: function(canvas) {
      var newCanvas = fabric.util.createCanvasElement();
      newCanvas.width = canvas.width;
      newCanvas.height = canvas.height;
      newCanvas.getContext('2d').drawImage(canvas, 0, 0);
      return newCanvas;
    },

    /**
     * since 2.6.0 moved from canvas instance to utility.
     * @param {CanvasElement} canvasEl to copy size and content of
     * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
     * @param {Number} quality <= 1 and > 0
     * @static
     * @memberOf fabric.util
     * @return {String} data url
     */
    toDataURL: function(canvasEl, format, quality) {
      return canvasEl.toDataURL('image/' + format, quality);
    },

    /**
     * Creates image element (works on client and node)
     * @static
     * @memberOf fabric.util
     * @return {HTMLImageElement} HTML image element
     */
    createImage: function() {
      return fabric.document.createElement('img');
    },

    /**
     * @static
     * @memberOf fabric.util
     * @deprecated since 2.0.0
     * @param {fabric.Object} receiver Object implementing `clipTo` method
     * @param {CanvasRenderingContext2D} ctx Context to clip
     */
    clipContext: function(receiver, ctx) {
      ctx.save();
      ctx.beginPath();
      receiver.clipTo(ctx);
      ctx.clip();
    },

    /**
     * Multiply matrix A by matrix B to nest transformations
     * @static
     * @memberOf fabric.util
     * @param  {Array} a First transformMatrix
     * @param  {Array} b Second transformMatrix
     * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
     * @return {Array} The product of the two transform matrices
     */
    multiplyTransformMatrices: function(a, b, is2x2) {
      // Matrix multiply a * b
      return [
        a[0] * b[0] + a[2] * b[1],
        a[1] * b[0] + a[3] * b[1],
        a[0] * b[2] + a[2] * b[3],
        a[1] * b[2] + a[3] * b[3],
        is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
        is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
      ];
    },

    /**
     * Decomposes standard 2x3 matrix into transform components
     * @static
     * @memberOf fabric.util
     * @param  {Array} a transformMatrix
     * @return {Object} Components of transform
     */
    qrDecompose: function(a) {
      var angle = atan2(a[1], a[0]),
          denom = pow(a[0], 2) + pow(a[1], 2),
          scaleX = sqrt(denom),
          scaleY = (a[0] * a[3] - a[2] * a [1]) / scaleX,
          skewX = atan2(a[0] * a[2] + a[1] * a [3], denom);
      return {
        angle: angle  / PiBy180,
        scaleX: scaleX,
        scaleY: scaleY,
        skewX: skewX / PiBy180,
        skewY: 0,
        translateX: a[4],
        translateY: a[5]
      };
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle] angle in degrees
     * @return {Number[]} transform matrix
     */
    calcRotateMatrix: function(options) {
      if (!options.angle) {
        return fabric.iMatrix.concat();
      }
      var theta = fabric.util.degreesToRadians(options.angle),
          cos = fabric.util.cos(theta),
          sin = fabric.util.sin(theta);
      return [cos, sin, -sin, cos, 0, 0];
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet.
     * is called DimensionsTransformMatrix because those properties are the one that influence
     * the size of the resulting box of the object.
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @return {Number[]} transform matrix
     */
    calcDimensionsMatrix: function(options) {
      var scaleX = typeof options.scaleX === 'undefined' ? 1 : options.scaleX,
          scaleY = typeof options.scaleY === 'undefined' ? 1 : options.scaleY,
          scaleMatrix = [
            options.flipX ? -scaleX : scaleX,
            0,
            0,
            options.flipY ? -scaleY : scaleY,
            0,
            0],
          multiply = fabric.util.multiplyTransformMatrices,
          degreesToRadians = fabric.util.degreesToRadians;
      if (options.skewX) {
        scaleMatrix = multiply(
          scaleMatrix,
          [1, 0, Math.tan(degreesToRadians(options.skewX)), 1],
          true);
      }
      if (options.skewY) {
        scaleMatrix = multiply(
          scaleMatrix,
          [1, Math.tan(degreesToRadians(options.skewY)), 0, 1],
          true);
      }
      return scaleMatrix;
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle]
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.translateX]
     * @param  {Number} [options.translateY]
     * @return {Number[]} transform matrix
     */
    composeMatrix: function(options) {
      var matrix = [1, 0, 0, 1, options.translateX || 0, options.translateY || 0],
          multiply = fabric.util.multiplyTransformMatrices;
      if (options.angle) {
        matrix = multiply(matrix, fabric.util.calcRotateMatrix(options));
      }
      if (options.scaleX || options.scaleY || options.skewX || options.skewY || options.flipX || options.flipY) {
        matrix = multiply(matrix, fabric.util.calcDimensionsMatrix(options));
      }
      return matrix;
    },

    /**
     * Returns a transform matrix that has the same effect of scaleX, scaleY and skewX.
     * Is deprecated for composeMatrix. Please do not use it.
     * @static
     * @deprecated since 3.4.0
     * @memberOf fabric.util
     * @param  {Number} scaleX
     * @param  {Number} scaleY
     * @param  {Number} skewX
     * @return {Number[]} transform matrix
     */
    customTransformMatrix: function(scaleX, scaleY, skewX) {
      return fabric.util.composeMatrix({ scaleX: scaleX, scaleY: scaleY, skewX: skewX });
    },

    /**
     * reset an object transform state to neutral. Top and left are not accounted for
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to transform
     */
    resetObjectTransform: function (target) {
      target.scaleX = 1;
      target.scaleY = 1;
      target.skewX = 0;
      target.skewY = 0;
      target.flipX = false;
      target.flipY = false;
      target.rotate(0);
    },

    /**
     * Extract Object transform values
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to read from
     * @return {Object} Components of transform
     */
    saveObjectTransform: function (target) {
      return {
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        angle: target.angle,
        left: target.left,
        flipX: target.flipX,
        flipY: target.flipY,
        top: target.top
      };
    },

    /**
     * Returns string representation of function body
     * @param {Function} fn Function to get body of
     * @return {String} Function body
     */
    getFunctionBody: function(fn) {
      return (String(fn).match(/function[^{]*\{([\s\S]*)\}/) || {})[1];
    },

    /**
     * Returns true if context has transparent pixel
     * at specified location (taking tolerance into account)
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x x coordinate
     * @param {Number} y y coordinate
     * @param {Number} tolerance Tolerance
     */
    isTransparent: function(ctx, x, y, tolerance) {

      // If tolerance is > 0 adjust start coords to take into account.
      // If moves off Canvas fix to 0
      if (tolerance > 0) {
        if (x > tolerance) {
          x -= tolerance;
        }
        else {
          x = 0;
        }
        if (y > tolerance) {
          y -= tolerance;
        }
        else {
          y = 0;
        }
      }

      var _isTransparent = true, i, temp,
          imageData = ctx.getImageData(x, y, (tolerance * 2) || 1, (tolerance * 2) || 1),
          l = imageData.data.length;

      // Split image data - for tolerance > 1, pixelDataSize = 4;
      for (i = 3; i < l; i += 4) {
        temp = imageData.data[i];
        _isTransparent = temp <= 0;
        if (_isTransparent === false) {
          break; // Stop if colour found
        }
      }

      imageData = null;

      return _isTransparent;
    },

    /**
     * Parse preserveAspectRatio attribute from element
     * @param {string} attribute to be parsed
     * @return {Object} an object containing align and meetOrSlice attribute
     */
    parsePreserveAspectRatioAttribute: function(attribute) {
      var meetOrSlice = 'meet', alignX = 'Mid', alignY = 'Mid',
          aspectRatioAttrs = attribute.split(' '), align;

      if (aspectRatioAttrs && aspectRatioAttrs.length) {
        meetOrSlice = aspectRatioAttrs.pop();
        if (meetOrSlice !== 'meet' && meetOrSlice !== 'slice') {
          align = meetOrSlice;
          meetOrSlice = 'meet';
        }
        else if (aspectRatioAttrs.length) {
          align = aspectRatioAttrs.pop();
        }
      }
      //divide align in alignX and alignY
      alignX = align !== 'none' ? align.slice(1, 4) : 'none';
      alignY = align !== 'none' ? align.slice(5, 8) : 'none';
      return {
        meetOrSlice: meetOrSlice,
        alignX: alignX,
        alignY: alignY
      };
    },

    /**
     * Clear char widths cache for the given font family or all the cache if no
     * fontFamily is specified.
     * Use it if you know you are loading fonts in a lazy way and you are not waiting
     * for custom fonts to load properly when adding text objects to the canvas.
     * If a text object is added when its own font is not loaded yet, you will get wrong
     * measurement and so wrong bounding boxes.
     * After the font cache is cleared, either change the textObject text content or call
     * initDimensions() to trigger a recalculation
     * @memberOf fabric.util
     * @param {String} [fontFamily] font family to clear
     */
    clearFabricFontCache: function(fontFamily) {
      fontFamily = (fontFamily || '').toLowerCase();
      if (!fontFamily) {
        fabric.charWidthsCache = { };
      }
      else if (fabric.charWidthsCache[fontFamily]) {
        delete fabric.charWidthsCache[fontFamily];
      }
    },

    /**
     * Given current aspect ratio, determines the max width and height that can
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Number} ar aspect ratio
     * @param {Number} maximumArea Maximum area you want to achieve
     * @return {Object.x} Limited dimensions by X
     * @return {Object.y} Limited dimensions by Y
     */
    limitDimsByArea: function(ar, maximumArea) {
      var roughWidth = Math.sqrt(maximumArea * ar),
          perfLimitSizeY = Math.floor(maximumArea / roughWidth);
      return { x: Math.floor(roughWidth), y: perfLimitSizeY };
    },

    capValue: function(min, value, max) {
      return Math.max(min, Math.min(value, max));
    },

    /**
     * Finds the scale for the object source to fit inside the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to fit into destination
     */
    findScaleToFit: function(source, destination) {
      return Math.min(destination.width / source.width, destination.height / source.height);
    },

    /**
     * Finds the scale for the object source to cover entirely the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to cover destination
     */
    findScaleToCover: function(source, destination) {
      return Math.max(destination.width / source.width, destination.height / source.height);
    },

    /**
     * given an array of 6 number returns something like `"matrix(...numbers)"`
     * @memberOf fabric.util
     * @param {Array} trasnform an array with 6 numbers
     * @return {String} transform matrix for svg
     * @return {Object.y} Limited dimensions by Y
     */
    matrixToSVG: function(transform) {
      return 'matrix(' + transform.map(function(value) {
        return fabric.util.toFixed(value, fabric.Object.NUM_FRACTION_DIGITS);
      }).join(' ') + ')';
    }
  };
})(typeof exports !== 'undefined' ? exports : this);


(function() {

  var _join = Array.prototype.join;

  /* Adapted from http://dxr.mozilla.org/mozilla-central/source/content/svg/content/src/nsSVGPathDataParser.cpp
   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
   * http://mozilla.org/MPL/2.0/
   */
  function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
    var argsString = _join.call(arguments);
    if (fabric.arcToSegmentsCache[argsString]) {
      return fabric.arcToSegmentsCache[argsString];
    }

    var PI = Math.PI, th = rotateX * PI / 180,
        sinTh = fabric.util.sin(th),
        cosTh = fabric.util.cos(th),
        fromX = 0, fromY = 0;

    rx = Math.abs(rx);
    ry = Math.abs(ry);

    var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5,
        py = -cosTh * toY * 0.5 + sinTh * toX * 0.5,
        rx2 = rx * rx, ry2 = ry * ry, py2 = py * py, px2 = px * px,
        pl = rx2 * ry2 - rx2 * py2 - ry2 * px2,
        root = 0;

    if (pl < 0) {
      var s = Math.sqrt(1 - pl / (rx2 * ry2));
      rx *= s;
      ry *= s;
    }
    else {
      root = (large === sweep ? -1.0 : 1.0) *
              Math.sqrt( pl / (rx2 * py2 + ry2 * px2));
    }

    var cx = root * rx * py / ry,
        cy = -root * ry * px / rx,
        cx1 = cosTh * cx - sinTh * cy + toX * 0.5,
        cy1 = sinTh * cx + cosTh * cy + toY * 0.5,
        mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry),
        dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);

    if (sweep === 0 && dtheta > 0) {
      dtheta -= 2 * PI;
    }
    else if (sweep === 1 && dtheta < 0) {
      dtheta += 2 * PI;
    }

    // Convert into cubic bezier segments <= 90deg
    var segments = Math.ceil(Math.abs(dtheta / PI * 2)),
        result = [], mDelta = dtheta / segments,
        mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2),
        th3 = mTheta + mDelta;

    for (var i = 0; i < segments; i++) {
      result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
      fromX = result[i][4];
      fromY = result[i][5];
      mTheta = th3;
      th3 += mDelta;
    }
    fabric.arcToSegmentsCache[argsString] = result;
    return result;
  }

  function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
    var costh2 = fabric.util.cos(th2),
        sinth2 = fabric.util.sin(th2),
        costh3 = fabric.util.cos(th3),
        sinth3 = fabric.util.sin(th3),
        toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1,
        toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1,
        cp1X = fromX + mT * ( -cosTh * rx * sinth2 - sinTh * ry * costh2),
        cp1Y = fromY + mT * ( -sinTh * rx * sinth2 + cosTh * ry * costh2),
        cp2X = toX + mT * ( cosTh * rx * sinth3 + sinTh * ry * costh3),
        cp2Y = toY + mT * ( sinTh * rx * sinth3 - cosTh * ry * costh3);

    return [
      cp1X, cp1Y,
      cp2X, cp2Y,
      toX, toY
    ];
  }

  /*
   * Private
   */
  function calcVectorAngle(ux, uy, vx, vy) {
    var ta = Math.atan2(uy, ux),
        tb = Math.atan2(vy, vx);
    if (tb >= ta) {
      return tb - ta;
    }
    else {
      return 2 * Math.PI - (ta - tb);
    }
  }

  /**
   * Draws arc
   * @param {CanvasRenderingContext2D} ctx
   * @param {Number} fx
   * @param {Number} fy
   * @param {Array} coords
   */
  fabric.util.drawArc = function(ctx, fx, fy, coords) {
    var rx = coords[0],
        ry = coords[1],
        rot = coords[2],
        large = coords[3],
        sweep = coords[4],
        tx = coords[5],
        ty = coords[6],
        segs = [[], [], [], []],
        segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

    for (var i = 0, len = segsNorm.length; i < len; i++) {
      segs[i][0] = segsNorm[i][0] + fx;
      segs[i][1] = segsNorm[i][1] + fy;
      segs[i][2] = segsNorm[i][2] + fx;
      segs[i][3] = segsNorm[i][3] + fy;
      segs[i][4] = segsNorm[i][4] + fx;
      segs[i][5] = segsNorm[i][5] + fy;
      ctx.bezierCurveTo.apply(ctx, segs[i]);
    }
  };

  /**
   * Calculate bounding box of a elliptic-arc
   * @param {Number} fx start point of arc
   * @param {Number} fy
   * @param {Number} rx horizontal radius
   * @param {Number} ry vertical radius
   * @param {Number} rot angle of horizontal axe
   * @param {Number} large 1 or 0, whatever the arc is the big or the small on the 2 points
   * @param {Number} sweep 1 or 0, 1 clockwise or counterclockwise direction
   * @param {Number} tx end point of arc
   * @param {Number} ty
   */
  fabric.util.getBoundsOfArc = function(fx, fy, rx, ry, rot, large, sweep, tx, ty) {

    var fromX = 0, fromY = 0, bound, bounds = [],
        segs = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

    for (var i = 0, len = segs.length; i < len; i++) {
      bound = getBoundsOfCurve(fromX, fromY, segs[i][0], segs[i][1], segs[i][2], segs[i][3], segs[i][4], segs[i][5]);
      bounds.push({ x: bound[0].x + fx, y: bound[0].y + fy });
      bounds.push({ x: bound[1].x + fx, y: bound[1].y + fy });
      fromX = segs[i][4];
      fromY = segs[i][5];
    }
    return bounds;
  };

  /**
   * Calculate bounding box of a beziercurve
   * @param {Number} x0 starting point
   * @param {Number} y0
   * @param {Number} x1 first control point
   * @param {Number} y1
   * @param {Number} x2 secondo control point
   * @param {Number} y2
   * @param {Number} x3 end of beizer
   * @param {Number} y3
   */
  // taken from http://jsbin.com/ivomiq/56/edit  no credits available for that.
  function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
    var argsString;
    if (fabric.cachesBoundsOfCurve) {
      argsString = _join.call(arguments);
      if (fabric.boundsOfCurveCache[argsString]) {
        return fabric.boundsOfCurveCache[argsString];
      }
    }

    var sqrt = Math.sqrt,
        min = Math.min, max = Math.max,
        abs = Math.abs, tvalues = [],
        bounds = [[], []],
        a, b, c, t, t1, t2, b2ac, sqrtb2ac;

    b = 6 * x0 - 12 * x1 + 6 * x2;
    a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
    c = 3 * x1 - 3 * x0;

    for (var i = 0; i < 2; ++i) {
      if (i > 0) {
        b = 6 * y0 - 12 * y1 + 6 * y2;
        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
        c = 3 * y1 - 3 * y0;
      }

      if (abs(a) < 1e-12) {
        if (abs(b) < 1e-12) {
          continue;
        }
        t = -c / b;
        if (0 < t && t < 1) {
          tvalues.push(t);
        }
        continue;
      }
      b2ac = b * b - 4 * c * a;
      if (b2ac < 0) {
        continue;
      }
      sqrtb2ac = sqrt(b2ac);
      t1 = (-b + sqrtb2ac) / (2 * a);
      if (0 < t1 && t1 < 1) {
        tvalues.push(t1);
      }
      t2 = (-b - sqrtb2ac) / (2 * a);
      if (0 < t2 && t2 < 1) {
        tvalues.push(t2);
      }
    }

    var x, y, j = tvalues.length, jlen = j, mt;
    while (j--) {
      t = tvalues[j];
      mt = 1 - t;
      x = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
      bounds[0][j] = x;

      y = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
      bounds[1][j] = y;
    }

    bounds[0][jlen] = x0;
    bounds[1][jlen] = y0;
    bounds[0][jlen + 1] = x3;
    bounds[1][jlen + 1] = y3;
    var result = [
      {
        x: min.apply(null, bounds[0]),
        y: min.apply(null, bounds[1])
      },
      {
        x: max.apply(null, bounds[0]),
        y: max.apply(null, bounds[1])
      }
    ];
    if (fabric.cachesBoundsOfCurve) {
      fabric.boundsOfCurveCache[argsString] = result;
    }
    return result;
  }

  fabric.util.getBoundsOfCurve = getBoundsOfCurve;

})();


(function() {

  var slice = Array.prototype.slice;

  /**
   * Invokes method on all items in a given array
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} method Name of a method to invoke
   * @return {Array}
   */
  function invoke(array, method) {
    var args = slice.call(arguments, 2), result = [];
    for (var i = 0, len = array.length; i < len; i++) {
      result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
    }
    return result;
  }

  /**
   * Finds maximum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */
  function max(array, byProperty) {
    return find(array, byProperty, function(value1, value2) {
      return value1 >= value2;
    });
  }

  /**
   * Finds minimum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */
  function min(array, byProperty) {
    return find(array, byProperty, function(value1, value2) {
      return value1 < value2;
    });
  }

  /**
   * @private
   */
  function fill(array, value) {
    var k = array.length;
    while (k--) {
      array[k] = value;
    }
    return array;
  }

  /**
   * @private
   */
  function find(array, byProperty, condition) {
    if (!array || array.length === 0) {
      return;
    }

    var i = array.length - 1,
        result = byProperty ? array[i][byProperty] : array[i];
    if (byProperty) {
      while (i--) {
        if (condition(array[i][byProperty], result)) {
          result = array[i][byProperty];
        }
      }
    }
    else {
      while (i--) {
        if (condition(array[i], result)) {
          result = array[i];
        }
      }
    }
    return result;
  }

  /**
   * @namespace fabric.util.array
   */
  fabric.util.array = {
    fill: fill,
    invoke: invoke,
    min: min,
    max: max
  };

})();


(function() {
  /**
   * Copies all enumerable properties of one js object to another
   * this does not and cannot compete with generic utils.
   * Does not clone or extend fabric.Object subclasses.
   * This is mostly for internal use and has extra handling for fabricJS objects
   * it skips the canvas property in deep cloning.
   * @memberOf fabric.util.object
   * @param {Object} destination Where to copy to
   * @param {Object} source Where to copy from
   * @return {Object}
   */

  function extend(destination, source, deep) {
    // JScript DontEnum bug is not taken care of
    // the deep clone is for internal use, is not meant to avoid
    // javascript traps or cloning html element or self referenced objects.
    if (deep) {
      if (!fabric.isLikelyNode && source instanceof Element) {
        // avoid cloning deep images, canvases,
        destination = source;
      }
      else if (source instanceof Array) {
        destination = [];
        for (var i = 0, len = source.length; i < len; i++) {
          destination[i] = extend({ }, source[i], deep);
        }
      }
      else if (source && typeof source === 'object') {
        for (var property in source) {
          if (property === 'canvas') {
            destination[property] = extend({ }, source[property]);
          }
          else if (source.hasOwnProperty(property)) {
            destination[property] = extend({ }, source[property], deep);
          }
        }
      }
      else {
        // this sounds odd for an extend but is ok for recursive use
        destination = source;
      }
    }
    else {
      for (var property in source) {
        destination[property] = source[property];
      }
    }
    return destination;
  }

  /**
   * Creates an empty object and copies all enumerable properties of another object to it
   * @memberOf fabric.util.object
   * TODO: this function return an empty object if you try to clone null
   * @param {Object} object Object to clone
   * @return {Object}
   */
  function clone(object, deep) {
    return extend({ }, object, deep);
  }

  /** @namespace fabric.util.object */
  fabric.util.object = {
    extend: extend,
    clone: clone
  };
  fabric.util.object.extend(fabric.util, fabric.Observable);
})();


(function() {

  /**
   * Camelizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to camelize
   * @return {String} Camelized version of a string
   */
  function camelize(string) {
    return string.replace(/-+(.)?/g, function(match, character) {
      return character ? character.toUpperCase() : '';
    });
  }

  /**
   * Capitalizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to capitalize
   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
   * and other letters stay untouched, if false first letter is capitalized
   * and other letters are converted to lowercase.
   * @return {String} Capitalized version of a string
   */
  function capitalize(string, firstLetterOnly) {
    return string.charAt(0).toUpperCase() +
      (firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
  }

  /**
   * Escapes XML in a string
   * @memberOf fabric.util.string
   * @param {String} string String to escape
   * @return {String} Escaped version of a string
   */
  function escapeXml(string) {
    return string.replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /**
   * Divide a string in the user perceived single units
   * @memberOf fabric.util.string
   * @param {String} textstring String to escape
   * @return {Array} array containing the graphemes
   */
  function graphemeSplit(textstring) {
    var i = 0, chr, graphemes = [];
    for (i = 0, chr; i < textstring.length; i++) {
      if ((chr = getWholeChar(textstring, i)) === false) {
        continue;
      }
      graphemes.push(chr);
    }
    return graphemes;
  }

  // taken from mdn in the charAt doc page.
  function getWholeChar(str, i) {
    var code = str.charCodeAt(i);

    if (isNaN(code)) {
      return ''; // Position not found
    }
    if (code < 0xD800 || code > 0xDFFF) {
      return str.charAt(i);
    }

    // High surrogate (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xD800 <= code && code <= 0xDBFF) {
      if (str.length <= (i + 1)) {
        throw 'High surrogate without following low surrogate';
      }
      var next = str.charCodeAt(i + 1);
      if (0xDC00 > next || next > 0xDFFF) {
        throw 'High surrogate without following low surrogate';
      }
      return str.charAt(i) + str.charAt(i + 1);
    }
    // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
    if (i === 0) {
      throw 'Low surrogate without preceding high surrogate';
    }
    var prev = str.charCodeAt(i - 1);

    // (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xD800 > prev || prev > 0xDBFF) {
      throw 'Low surrogate without preceding high surrogate';
    }
    // We can pass over low surrogates now as the second component
    // in a pair which we have already processed
    return false;
  }


  /**
   * String utilities
   * @namespace fabric.util.string
   */
  fabric.util.string = {
    camelize: camelize,
    capitalize: capitalize,
    escapeXml: escapeXml,
    graphemeSplit: graphemeSplit
  };
})();


(function() {

  var slice = Array.prototype.slice, emptyFunction = function() { },

      IS_DONTENUM_BUGGY = (function() {
        for (var p in { toString: 1 }) {
          if (p === 'toString') {
            return false;
          }
        }
        return true;
      })(),

      /** @ignore */
      addMethods = function(klass, source, parent) {
        for (var property in source) {

          if (property in klass.prototype &&
              typeof klass.prototype[property] === 'function' &&
              (source[property] + '').indexOf('callSuper') > -1) {

            klass.prototype[property] = (function(property) {
              return function() {

                var superclass = this.constructor.superclass;
                this.constructor.superclass = parent;
                var returnValue = source[property].apply(this, arguments);
                this.constructor.superclass = superclass;

                if (property !== 'initialize') {
                  return returnValue;
                }
              };
            })(property);
          }
          else {
            klass.prototype[property] = source[property];
          }

          if (IS_DONTENUM_BUGGY) {
            if (source.toString !== Object.prototype.toString) {
              klass.prototype.toString = source.toString;
            }
            if (source.valueOf !== Object.prototype.valueOf) {
              klass.prototype.valueOf = source.valueOf;
            }
          }
        }
      };

  function Subclass() { }

  function callSuper(methodName) {
    var parentMethod = null,
        _this = this;

    // climb prototype chain to find method not equal to callee's method
    while (_this.constructor.superclass) {
      var superClassMethod = _this.constructor.superclass.prototype[methodName];
      if (_this[methodName] !== superClassMethod) {
        parentMethod = superClassMethod;
        break;
      }
      // eslint-disable-next-line
      _this = _this.constructor.superclass.prototype;
    }

    if (!parentMethod) {
      return console.log('tried to callSuper ' + methodName + ', method not found in prototype chain', this);
    }

    return (arguments.length > 1)
      ? parentMethod.apply(this, slice.call(arguments, 1))
      : parentMethod.call(this);
  }

  /**
   * Helper for creation of "classes".
   * @memberOf fabric.util
   * @param {Function} [parent] optional "Class" to inherit from
   * @param {Object} [properties] Properties shared by all instances of this class
   *                  (be careful modifying objects defined here as this would affect all instances)
   */
  function createClass() {
    var parent = null,
        properties = slice.call(arguments, 0);

    if (typeof properties[0] === 'function') {
      parent = properties.shift();
    }
    function klass() {
      this.initialize.apply(this, arguments);
    }

    klass.superclass = parent;
    klass.subclasses = [];

    if (parent) {
      Subclass.prototype = parent.prototype;
      klass.prototype = new Subclass();
      parent.subclasses.push(klass);
    }
    for (var i = 0, length = properties.length; i < length; i++) {
      addMethods(klass, properties[i], parent);
    }
    if (!klass.prototype.initialize) {
      klass.prototype.initialize = emptyFunction;
    }
    klass.prototype.constructor = klass;
    klass.prototype.callSuper = callSuper;
    return klass;
  }

  fabric.util.createClass = createClass;
})();


(function () {
  // since ie10 or ie9 can use addEventListener but they do not support options, i need to check
  var couldUseAttachEvent = !!fabric.document.createElement('div').attachEvent;
  /**
   * Adds an event listener to an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */
  fabric.util.addListener = function(element, eventName, handler, options) {
    element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
  };

  /**
   * Removes an event listener from an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */
  fabric.util.removeListener = function(element, eventName, handler, options) {
    element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
  };

  function getTouchInfo(event) {
    var touchProp = event.changedTouches;
    if (touchProp && touchProp[0]) {
      return touchProp[0];
    }
    return event;
  }

  fabric.util.getPointer = function(event) {
    var element = event.target,
        scroll = fabric.util.getScrollLeftTop(element),
        _evt = getTouchInfo(event);
    return {
      x: _evt.clientX + scroll.left,
      y: _evt.clientY + scroll.top
    };
  };
})();


(function () {

  /**
   * Cross-browser wrapper for setting element's style
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {Object} styles
   * @return {HTMLElement} Element that was passed as a first argument
   */
  function setStyle(element, styles) {
    var elementStyle = element.style;
    if (!elementStyle) {
      return element;
    }
    if (typeof styles === 'string') {
      element.style.cssText += ';' + styles;
      return styles.indexOf('opacity') > -1
        ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1])
        : element;
    }
    for (var property in styles) {
      if (property === 'opacity') {
        setOpacity(element, styles[property]);
      }
      else {
        var normalizedProperty = (property === 'float' || property === 'cssFloat')
          ? (typeof elementStyle.styleFloat === 'undefined' ? 'cssFloat' : 'styleFloat')
          : property;
        elementStyle[normalizedProperty] = styles[property];
      }
    }
    return element;
  }

  var parseEl = fabric.document.createElement('div'),
      supportsOpacity = typeof parseEl.style.opacity === 'string',
      supportsFilters = typeof parseEl.style.filter === 'string',
      reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,

      /** @ignore */
      setOpacity = function (element) { return element; };

  if (supportsOpacity) {
    /** @ignore */
    setOpacity = function(element, value) {
      element.style.opacity = value;
      return element;
    };
  }
  else if (supportsFilters) {
    /** @ignore */
    setOpacity = function(element, value) {
      var es = element.style;
      if (element.currentStyle && !element.currentStyle.hasLayout) {
        es.zoom = 1;
      }
      if (reOpacity.test(es.filter)) {
        value = value >= 0.9999 ? '' : ('alpha(opacity=' + (value * 100) + ')');
        es.filter = es.filter.replace(reOpacity, value);
      }
      else {
        es.filter += ' alpha(opacity=' + (value * 100) + ')';
      }
      return element;
    };
  }

  fabric.util.setStyle = setStyle;

})();


(function() {

  var _slice = Array.prototype.slice;

  /**
   * Takes id and returns an element with that id (if one exists in a document)
   * @memberOf fabric.util
   * @param {String|HTMLElement} id
   * @return {HTMLElement|null}
   */
  function getById(id) {
    return typeof id === 'string' ? fabric.document.getElementById(id) : id;
  }

  var sliceCanConvertNodelists,
      /**
       * Converts an array-like object (e.g. arguments or NodeList) to an array
       * @memberOf fabric.util
       * @param {Object} arrayLike
       * @return {Array}
       */
      toArray = function(arrayLike) {
        return _slice.call(arrayLike, 0);
      };

  try {
    sliceCanConvertNodelists = toArray(fabric.document.childNodes) instanceof Array;
  }
  catch (err) { }

  if (!sliceCanConvertNodelists) {
    toArray = function(arrayLike) {
      var arr = new Array(arrayLike.length), i = arrayLike.length;
      while (i--) {
        arr[i] = arrayLike[i];
      }
      return arr;
    };
  }

  /**
   * Creates specified element with specified attributes
   * @memberOf fabric.util
   * @param {String} tagName Type of an element to create
   * @param {Object} [attributes] Attributes to set on an element
   * @return {HTMLElement} Newly created element
   */
  function makeElement(tagName, attributes) {
    var el = fabric.document.createElement(tagName);
    for (var prop in attributes) {
      if (prop === 'class') {
        el.className = attributes[prop];
      }
      else if (prop === 'for') {
        el.htmlFor = attributes[prop];
      }
      else {
        el.setAttribute(prop, attributes[prop]);
      }
    }
    return el;
  }

  /**
   * Adds class to an element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to add class to
   * @param {String} className Class to add to an element
   */
  function addClass(element, className) {
    if (element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') === -1) {
      element.className += (element.className ? ' ' : '') + className;
    }
  }

  /**
   * Wraps element with another element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to wrap
   * @param {HTMLElement|String} wrapper Element to wrap with
   * @param {Object} [attributes] Attributes to set on a wrapper
   * @return {HTMLElement} wrapper
   */
  function wrapElement(element, wrapper, attributes) {
    if (typeof wrapper === 'string') {
      wrapper = makeElement(wrapper, attributes);
    }
    if (element.parentNode) {
      element.parentNode.replaceChild(wrapper, element);
    }
    wrapper.appendChild(element);
    return wrapper;
  }

  /**
   * Returns element scroll offsets
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to operate on
   * @return {Object} Object with left/top values
   */
  function getScrollLeftTop(element) {

    var left = 0,
        top = 0,
        docElement = fabric.document.documentElement,
        body = fabric.document.body || {
          scrollLeft: 0, scrollTop: 0
        };

    // While loop checks (and then sets element to) .parentNode OR .host
    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
    //  but the .parentNode of a root ShadowDOM node will always be null, instead
    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
    while (element && (element.parentNode || element.host)) {

      // Set element to element parent, or 'host' in case of ShadowDOM
      element = element.parentNode || element.host;

      if (element === fabric.document) {
        left = body.scrollLeft || docElement.scrollLeft || 0;
        top = body.scrollTop ||  docElement.scrollTop || 0;
      }
      else {
        left += element.scrollLeft || 0;
        top += element.scrollTop || 0;
      }

      if (element.nodeType === 1 && element.style.position === 'fixed') {
        break;
      }
    }

    return { left: left, top: top };
  }

  /**
   * Returns offset for a given element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get offset for
   * @return {Object} Object with "left" and "top" properties
   */
  function getElementOffset(element) {
    var docElem,
        doc = element && element.ownerDocument,
        box = { left: 0, top: 0 },
        offset = { left: 0, top: 0 },
        scrollLeftTop,
        offsetAttributes = {
          borderLeftWidth: 'left',
          borderTopWidth:  'top',
          paddingLeft:     'left',
          paddingTop:      'top'
        };

    if (!doc) {
      return offset;
    }

    for (var attr in offsetAttributes) {
      offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
    }

    docElem = doc.documentElement;
    if ( typeof element.getBoundingClientRect !== 'undefined' ) {
      box = element.getBoundingClientRect();
    }

    scrollLeftTop = getScrollLeftTop(element);

    return {
      left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
      top: box.top + scrollLeftTop.top - (docElem.clientTop || 0)  + offset.top
    };
  }

  /**
   * Returns style attribute value of a given element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get style attribute for
   * @param {String} attr Style attribute to get for element
   * @return {String} Style attribute value of the given element.
   */
  var getElementStyle;
  if (fabric.document.defaultView && fabric.document.defaultView.getComputedStyle) {
    getElementStyle = function(element, attr) {
      var style = fabric.document.defaultView.getComputedStyle(element, null);
      return style ? style[attr] : undefined;
    };
  }
  else {
    getElementStyle = function(element, attr) {
      var value = element.style[attr];
      if (!value && element.currentStyle) {
        value = element.currentStyle[attr];
      }
      return value;
    };
  }

  (function () {
    var style = fabric.document.documentElement.style,
        selectProp = 'userSelect' in style
          ? 'userSelect'
          : 'MozUserSelect' in style
            ? 'MozUserSelect'
            : 'WebkitUserSelect' in style
              ? 'WebkitUserSelect'
              : 'KhtmlUserSelect' in style
                ? 'KhtmlUserSelect'
                : '';

    /**
     * Makes element unselectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make unselectable
     * @return {HTMLElement} Element that was passed in
     */
    function makeElementUnselectable(element) {
      if (typeof element.onselectstart !== 'undefined') {
        element.onselectstart = fabric.util.falseFunction;
      }
      if (selectProp) {
        element.style[selectProp] = 'none';
      }
      else if (typeof element.unselectable === 'string') {
        element.unselectable = 'on';
      }
      return element;
    }

    /**
     * Makes element selectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make selectable
     * @return {HTMLElement} Element that was passed in
     */
    function makeElementSelectable(element) {
      if (typeof element.onselectstart !== 'undefined') {
        element.onselectstart = null;
      }
      if (selectProp) {
        element.style[selectProp] = '';
      }
      else if (typeof element.unselectable === 'string') {
        element.unselectable = '';
      }
      return element;
    }

    fabric.util.makeElementUnselectable = makeElementUnselectable;
    fabric.util.makeElementSelectable = makeElementSelectable;
  })();

  (function() {

    /**
     * Inserts a script element with a given url into a document; invokes callback, when that script is finished loading
     * @memberOf fabric.util
     * @param {String} url URL of a script to load
     * @param {Function} callback Callback to execute when script is finished loading
     */
    function getScript(url, callback) {
      var headEl = fabric.document.getElementsByTagName('head')[0],
          scriptEl = fabric.document.createElement('script'),
          loading = true;

      /** @ignore */
      scriptEl.onload = /** @ignore */ scriptEl.onreadystatechange = function(e) {
        if (loading) {
          if (typeof this.readyState === 'string' &&
              this.readyState !== 'loaded' &&
              this.readyState !== 'complete') {
            return;
          }
          loading = false;
          callback(e || fabric.window.event);
          scriptEl = scriptEl.onload = scriptEl.onreadystatechange = null;
        }
      };
      scriptEl.src = url;
      headEl.appendChild(scriptEl);
      // causes issue in Opera
      // headEl.removeChild(scriptEl);
    }

    fabric.util.getScript = getScript;
  })();

  function getNodeCanvas(element) {
    var impl = fabric.jsdomImplForWrapper(element);
    return impl._canvas || impl._image;
  };

  function cleanUpJsdomNode(element) {
    if (!fabric.isLikelyNode) {
      return;
    }
    var impl = fabric.jsdomImplForWrapper(element);
    if (impl) {
      impl._image = null;
      impl._canvas = null;
      // unsure if necessary
      impl._currentSrc = null;
      impl._attributes = null;
      impl._classList = null;
    }
  }

  fabric.util.getById = getById;
  fabric.util.toArray = toArray;
  fabric.util.makeElement = makeElement;
  fabric.util.addClass = addClass;
  fabric.util.wrapElement = wrapElement;
  fabric.util.getScrollLeftTop = getScrollLeftTop;
  fabric.util.getElementOffset = getElementOffset;
  fabric.util.getElementStyle = getElementStyle;
  fabric.util.getNodeCanvas = getNodeCanvas;
  fabric.util.cleanUpJsdomNode = cleanUpJsdomNode;

})();


(function() {

  function addParamToUrl(url, param) {
    return url + (/\?/.test(url) ? '&' : '?') + param;
  }

  function emptyFn() { }

  /**
   * Cross-browser abstraction for sending XMLHttpRequest
   * @memberOf fabric.util
   * @param {String} url URL to send XMLHttpRequest to
   * @param {Object} [options] Options object
   * @param {String} [options.method="GET"]
   * @param {String} [options.parameters] parameters to append to url in GET or in body
   * @param {String} [options.body] body to send with POST or PUT request
   * @param {Function} options.onComplete Callback to invoke when request is completed
   * @return {XMLHttpRequest} request
   */
  function request(url, options) {
    options || (options = { });

    var method = options.method ? options.method.toUpperCase() : 'GET',
        onComplete = options.onComplete || function() { },
        xhr = new fabric.window.XMLHttpRequest(),
        body = options.body || options.parameters;

    /** @ignore */
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        onComplete(xhr);
        xhr.onreadystatechange = emptyFn;
      }
    };

    if (method === 'GET') {
      body = null;
      if (typeof options.parameters === 'string') {
        url = addParamToUrl(url, options.parameters);
      }
    }

    xhr.open(method, url, true);

    if (method === 'POST' || method === 'PUT') {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }

    xhr.send(body);
    return xhr;
  }

  fabric.util.request = request;
})();


/**
 * Wrapper around `console.log` (when available)
 * @param {*} [values] Values to log
 */
fabric.log = console.log;

/**
 * Wrapper around `console.warn` (when available)
 * @param {*} [values] Values to log as a warning
 */
fabric.warn = console.warn;


(function() {

  function noop() {
    return false;
  }

  function defaultEasing(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  }

  /**
   * Changes value from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Number} [options.startValue=0] Starting value
   * @param {Number} [options.endValue=100] Ending value
   * @param {Number} [options.byValue=100] Value to modify the property by
   * @param {Function} [options.easing] Easing function
   * @param {Number} [options.duration=500] Duration of change (in ms)
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   */
  function animate(options) {

    requestAnimFrame(function(timestamp) {
      options || (options = { });

      var start = timestamp || +new Date(),
          duration = options.duration || 500,
          finish = start + duration, time,
          onChange = options.onChange || noop,
          abort = options.abort || noop,
          onComplete = options.onComplete || noop,
          easing = options.easing || defaultEasing,
          startValue = 'startValue' in options ? options.startValue : 0,
          endValue = 'endValue' in options ? options.endValue : 100,
          byValue = options.byValue || endValue - startValue;

      options.onStart && options.onStart();

      (function tick(ticktime) {
        // TODO: move abort call after calculation
        // and pass (current,valuePerc, timePerc) as arguments
        time = ticktime || +new Date();
        var currentTime = time > finish ? duration : (time - start),
            timePerc = currentTime / duration,
            current = easing(currentTime, startValue, byValue, duration),
            valuePerc = Math.abs((current - startValue) / byValue);
        if (abort()) {
          onComplete(endValue, 1, 1);
          return;
        }
        if (time > finish) {
          onChange(endValue, 1, 1);
          onComplete(endValue, 1, 1);
          return;
        }
        else {
          onChange(current, valuePerc, timePerc);
          requestAnimFrame(tick);
        }
      })(start);
    });
  }

  var _requestAnimFrame = fabric.window.requestAnimationFrame       ||
                          fabric.window.webkitRequestAnimationFrame ||
                          fabric.window.mozRequestAnimationFrame    ||
                          fabric.window.oRequestAnimationFrame      ||
                          fabric.window.msRequestAnimationFrame     ||
                          function(callback) {
                            return fabric.window.setTimeout(callback, 1000 / 60);
                          };

  var _cancelAnimFrame = fabric.window.cancelAnimationFrame || fabric.window.clearTimeout;

  /**
   * requestAnimationFrame polyfill based on http://paulirish.com/2011/requestanimationframe-for-smart-animating/
   * In order to get a precise start time, `requestAnimFrame` should be called as an entry into the method
   * @memberOf fabric.util
   * @param {Function} callback Callback to invoke
   * @param {DOMElement} element optional Element to associate with animation
   */
  function requestAnimFrame() {
    return _requestAnimFrame.apply(fabric.window, arguments);
  }

  function cancelAnimFrame() {
    return _cancelAnimFrame.apply(fabric.window, arguments);
  }

  fabric.util.animate = animate;
  fabric.util.requestAnimFrame = requestAnimFrame;
  fabric.util.cancelAnimFrame = cancelAnimFrame;
})();


(function() {
  // Calculate an in-between color. Returns a "rgba()" string.
  // Credit: Edwin Martin <edwin@bitstorm.org>
  //         http://www.bitstorm.org/jquery/color-animation/jquery.animate-colors.js
  function calculateColor(begin, end, pos) {
    var color = 'rgba('
        + parseInt((begin[0] + pos * (end[0] - begin[0])), 10) + ','
        + parseInt((begin[1] + pos * (end[1] - begin[1])), 10) + ','
        + parseInt((begin[2] + pos * (end[2] - begin[2])), 10);

    color += ',' + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
    color += ')';
    return color;
  }

  /**
   * Changes the color from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {String} fromColor The starting color in hex or rgb(a) format.
   * @param {String} toColor The starting color in hex or rgb(a) format.
   * @param {Number} [duration] Duration of change (in ms).
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Function} [options.colorEasing] Easing function. Note that this function only take two arguments (currentTime, duration). Thus the regular animation easing functions cannot be used.
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   */
  function animateColor(fromColor, toColor, duration, options) {
    var startColor = new fabric.Color(fromColor).getSource(),
        endColor = new fabric.Color(toColor).getSource();

    options = options || {};

    fabric.util.animate(fabric.util.object.extend(options, {
      duration: duration || 500,
      startValue: startColor,
      endValue: endColor,
      byValue: endColor,
      easing: function (currentTime, startValue, byValue, duration) {
        var posValue = options.colorEasing
          ? options.colorEasing(currentTime, duration)
          : 1 - Math.cos(currentTime / duration * (Math.PI / 2));
        return calculateColor(startValue, byValue, posValue);
      }
    }));
  }

  fabric.util.animateColor = animateColor;

})();


(function() {

  function normalize(a, c, p, s) {
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    }
    else {
      //handle the 0/0 case:
      if (c === 0 && a === 0) {
        s = p / (2 * Math.PI) * Math.asin(1);
      }
      else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
    }
    return { a: a, c: c, p: p, s: s };
  }

  function elastic(opts, t, d) {
    return opts.a *
      Math.pow(2, 10 * (t -= 1)) *
      Math.sin( (t * d - opts.s) * (2 * Math.PI) / opts.p );
  }

  /**
   * Cubic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }

  /**
   * Cubic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t * t + b;
    }
    return c / 2 * ((t -= 2) * t * t + 2) + b;
  }

  /**
   * Quartic easing in
   * @memberOf fabric.util.ease
   */
  function easeInQuart(t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  }

  /**
   * Quartic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutQuart(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  }

  /**
   * Quartic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutQuart(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t * t * t + b;
    }
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
  }

  /**
   * Quintic easing in
   * @memberOf fabric.util.ease
   */
  function easeInQuint(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  }

  /**
   * Quintic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutQuint(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  }

  /**
   * Quintic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutQuint(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t * t * t * t + b;
    }
    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
  }

  /**
   * Sinusoidal easing in
   * @memberOf fabric.util.ease
   */
  function easeInSine(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  }

  /**
   * Sinusoidal easing out
   * @memberOf fabric.util.ease
   */
  function easeOutSine(t, b, c, d) {
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  }

  /**
   * Sinusoidal easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutSine(t, b, c, d) {
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  }

  /**
   * Exponential easing in
   * @memberOf fabric.util.ease
   */
  function easeInExpo(t, b, c, d) {
    return (t === 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  }

  /**
   * Exponential easing out
   * @memberOf fabric.util.ease
   */
  function easeOutExpo(t, b, c, d) {
    return (t === d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  }

  /**
   * Exponential easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutExpo(t, b, c, d) {
    if (t === 0) {
      return b;
    }
    if (t === d) {
      return b + c;
    }
    t /= d / 2;
    if (t < 1) {
      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    }
    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
  }

  /**
   * Circular easing in
   * @memberOf fabric.util.ease
   */
  function easeInCirc(t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  }

  /**
   * Circular easing out
   * @memberOf fabric.util.ease
   */
  function easeOutCirc(t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  }

  /**
   * Circular easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutCirc(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    }
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  }

  /**
   * Elastic easing in
   * @memberOf fabric.util.ease
   */
  function easeInElastic(t, b, c, d) {
    var s = 1.70158, p = 0, a = c;
    if (t === 0) {
      return b;
    }
    t /= d;
    if (t === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    var opts = normalize(a, c, p, s);
    return -elastic(opts, t, d) + b;
  }

  /**
   * Elastic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutElastic(t, b, c, d) {
    var s = 1.70158, p = 0, a = c;
    if (t === 0) {
      return b;
    }
    t /= d;
    if (t === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    var opts = normalize(a, c, p, s);
    return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) + opts.c + b;
  }

  /**
   * Elastic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutElastic(t, b, c, d) {
    var s = 1.70158, p = 0, a = c;
    if (t === 0) {
      return b;
    }
    t /= d / 2;
    if (t === 2) {
      return b + c;
    }
    if (!p) {
      p = d * (0.3 * 1.5);
    }
    var opts = normalize(a, c, p, s);
    if (t < 1) {
      return -0.5 * elastic(opts, t, d) + b;
    }
    return opts.a * Math.pow(2, -10 * (t -= 1)) *
      Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) * 0.5 + opts.c + b;
  }

  /**
   * Backwards easing in
   * @memberOf fabric.util.ease
   */
  function easeInBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  }

  /**
   * Backwards easing out
   * @memberOf fabric.util.ease
   */
  function easeOutBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  }

  /**
   * Backwards easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }
    t /= d / 2;
    if (t < 1) {
      return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
    }
    return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
  }

  /**
   * Bouncing easing in
   * @memberOf fabric.util.ease
   */
  function easeInBounce(t, b, c, d) {
    return c - easeOutBounce (d - t, 0, c, d) + b;
  }

  /**
   * Bouncing easing out
   * @memberOf fabric.util.ease
   */
  function easeOutBounce(t, b, c, d) {
    if ((t /= d) < (1 / 2.75)) {
      return c * (7.5625 * t * t) + b;
    }
    else if (t < (2 / 2.75)) {
      return c * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75) + b;
    }
    else if (t < (2.5 / 2.75)) {
      return c * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375) + b;
    }
    else {
      return c * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375) + b;
    }
  }

  /**
   * Bouncing easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutBounce(t, b, c, d) {
    if (t < d / 2) {
      return easeInBounce (t * 2, 0, c, d) * 0.5 + b;
    }
    return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
  }

  /**
   * Easing functions
   * See <a href="http://gizma.com/easing/">Easing Equations by Robert Penner</a>
   * @namespace fabric.util.ease
   */
  fabric.util.ease = {

    /**
     * Quadratic easing in
     * @memberOf fabric.util.ease
     */
    easeInQuad: function(t, b, c, d) {
      return c * (t /= d) * t + b;
    },

    /**
     * Quadratic easing out
     * @memberOf fabric.util.ease
     */
    easeOutQuad: function(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },

    /**
     * Quadratic easing in and out
     * @memberOf fabric.util.ease
     */
    easeInOutQuad: function(t, b, c, d) {
      t /= (d / 2);
      if (t < 1) {
        return c / 2 * t * t + b;
      }
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    },

    /**
     * Cubic easing in
     * @memberOf fabric.util.ease
     */
    easeInCubic: function(t, b, c, d) {
      return c * (t /= d) * t * t + b;
    },

    easeOutCubic: easeOutCubic,
    easeInOutCubic: easeInOutCubic,
    easeInQuart: easeInQuart,
    easeOutQuart: easeOutQuart,
    easeInOutQuart: easeInOutQuart,
    easeInQuint: easeInQuint,
    easeOutQuint: easeOutQuint,
    easeInOutQuint: easeInOutQuint,
    easeInSine: easeInSine,
    easeOutSine: easeOutSine,
    easeInOutSine: easeInOutSine,
    easeInExpo: easeInExpo,
    easeOutExpo: easeOutExpo,
    easeInOutExpo: easeInOutExpo,
    easeInCirc: easeInCirc,
    easeOutCirc: easeOutCirc,
    easeInOutCirc: easeInOutCirc,
    easeInElastic: easeInElastic,
    easeOutElastic: easeOutElastic,
    easeInOutElastic: easeInOutElastic,
    easeInBack: easeInBack,
    easeOutBack: easeOutBack,
    easeInOutBack: easeInOutBack,
    easeInBounce: easeInBounce,
    easeOutBounce: easeOutBounce,
    easeInOutBounce: easeInOutBounce
  };

})();


(function(global) {

  'use strict';

  /**
   * @name fabric
   * @namespace
   */

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      toFixed = fabric.util.toFixed,
      parseUnit = fabric.util.parseUnit,
      multiplyTransformMatrices = fabric.util.multiplyTransformMatrices,

      svgValidTagNames = ['path', 'circle', 'polygon', 'polyline', 'ellipse', 'rect', 'line',
        'image', 'text'],
      svgViewBoxElements = ['symbol', 'image', 'marker', 'pattern', 'view', 'svg'],
      svgInvalidAncestors = ['pattern', 'defs', 'symbol', 'metadata', 'clipPath', 'mask', 'desc'],
      svgValidParents = ['symbol', 'g', 'a', 'svg', 'clipPath', 'defs'],

      attributesMap = {
        cx:                   'left',
        x:                    'left',
        r:                    'radius',
        cy:                   'top',
        y:                    'top',
        display:              'visible',
        visibility:           'visible',
        transform:            'transformMatrix',
        'fill-opacity':       'fillOpacity',
        'fill-rule':          'fillRule',
        'font-family':        'fontFamily',
        'font-size':          'fontSize',
        'font-style':         'fontStyle',
        'font-weight':        'fontWeight',
        'letter-spacing':     'charSpacing',
        'paint-order':        'paintFirst',
        'stroke-dasharray':   'strokeDashArray',
        'stroke-dashoffset':  'strokeDashOffset',
        'stroke-linecap':     'strokeLineCap',
        'stroke-linejoin':    'strokeLineJoin',
        'stroke-miterlimit':  'strokeMiterLimit',
        'stroke-opacity':     'strokeOpacity',
        'stroke-width':       'strokeWidth',
        'text-decoration':    'textDecoration',
        'text-anchor':        'textAnchor',
        opacity:              'opacity',
        'clip-path':          'clipPath',
        'clip-rule':          'clipRule',
        'vector-effect':      'strokeUniform'
      },

      colorAttributes = {
        stroke: 'strokeOpacity',
        fill:   'fillOpacity'
      },

      fSize = 'font-size', cPath = 'clip-path';

  fabric.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
  fabric.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
  fabric.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
  fabric.svgValidParentsRegEx = getSvgRegex(svgValidParents);

  fabric.cssRules = { };
  fabric.gradientDefs = { };
  fabric.clipPaths = { };

  function normalizeAttr(attr) {
    // transform attribute names
    if (attr in attributesMap) {
      return attributesMap[attr];
    }
    return attr;
  }

  function normalizeValue(attr, value, parentAttributes, fontSize) {
    var isArray = Object.prototype.toString.call(value) === '[object Array]',
        parsed;

    if ((attr === 'fill' || attr === 'stroke') && value === 'none') {
      value = '';
    }
    else if (attr === 'vector-effect') {
      value = value === 'non-scaling-stroke';
    }
    else if (attr === 'strokeDashArray') {
      if (value === 'none') {
        value = null;
      }
      else {
        value = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
      }
    }
    else if (attr === 'transformMatrix') {
      if (parentAttributes && parentAttributes.transformMatrix) {
        value = multiplyTransformMatrices(
          parentAttributes.transformMatrix, fabric.parseTransformAttribute(value));
      }
      else {
        value = fabric.parseTransformAttribute(value);
      }
    }
    else if (attr === 'visible') {
      value = value !== 'none' && value !== 'hidden';
      // display=none on parent element always takes precedence over child element
      if (parentAttributes && parentAttributes.visible === false) {
        value = false;
      }
    }
    else if (attr === 'opacity') {
      value = parseFloat(value);
      if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') {
        value *= parentAttributes.opacity;
      }
    }
    else if (attr === 'textAnchor' /* text-anchor */) {
      value = value === 'start' ? 'left' : value === 'end' ? 'right' : 'center';
    }
    else if (attr === 'charSpacing') {
      // parseUnit returns px and we convert it to em
      parsed = parseUnit(value, fontSize) / fontSize * 1000;
    }
    else if (attr === 'paintFirst') {
      var fillIndex = value.indexOf('fill');
      var strokeIndex = value.indexOf('stroke');
      var value = 'fill';
      if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) {
        value = 'stroke';
      }
      else if (fillIndex === -1 && strokeIndex > -1) {
        value = 'stroke';
      }
    }
    else if (attr === 'href' || attr === 'xlink:href') {
      return value;
    }
    else {
      parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
    }

    return (!isArray && isNaN(parsed) ? value : parsed);
  }

  /**
    * @private
    */
  function getSvgRegex(arr) {
    return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
  }

  /**
   * @private
   * @param {Object} attributes Array of attributes to parse
   */
  function _setStrokeFillOpacity(attributes) {
    for (var attr in colorAttributes) {

      if (typeof attributes[colorAttributes[attr]] === 'undefined' || attributes[attr] === '') {
        continue;
      }

      if (typeof attributes[attr] === 'undefined') {
        if (!fabric.Object.prototype[attr]) {
          continue;
        }
        attributes[attr] = fabric.Object.prototype[attr];
      }

      if (attributes[attr].indexOf('url(') === 0) {
        continue;
      }

      var color = new fabric.Color(attributes[attr]);
      attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
    }
    return attributes;
  }

  /**
   * @private
   */
  function _getMultipleNodes(doc, nodeNames) {
    var nodeName, nodeArray = [], nodeList, i, len;
    for (i = 0, len = nodeNames.length; i < len; i++) {
      nodeName = nodeNames[i];
      nodeList = doc.getElementsByTagName(nodeName);
      nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
    }
    return nodeArray;
  }

  /**
   * Parses "transform" attribute, returning an array of values
   * @static
   * @function
   * @memberOf fabric
   * @param {String} attributeValue String containing attribute value
   * @return {Array} Array of 6 elements representing transformation matrix
   */
  fabric.parseTransformAttribute = (function() {
    function rotateMatrix(matrix, args) {
      var cos = fabric.util.cos(args[0]), sin = fabric.util.sin(args[0]),
          x = 0, y = 0;
      if (args.length === 3) {
        x = args[1];
        y = args[2];
      }

      matrix[0] = cos;
      matrix[1] = sin;
      matrix[2] = -sin;
      matrix[3] = cos;
      matrix[4] = x - (cos * x - sin * y);
      matrix[5] = y - (sin * x + cos * y);
    }

    function scaleMatrix(matrix, args) {
      var multiplierX = args[0],
          multiplierY = (args.length === 2) ? args[1] : args[0];

      matrix[0] = multiplierX;
      matrix[3] = multiplierY;
    }

    function skewMatrix(matrix, args, pos) {
      matrix[pos] = Math.tan(fabric.util.degreesToRadians(args[0]));
    }

    function translateMatrix(matrix, args) {
      matrix[4] = args[0];
      if (args.length === 2) {
        matrix[5] = args[1];
      }
    }

    // identity matrix
    var iMatrix = fabric.iMatrix,

        // == begin transform regexp
        number = fabric.reNum,

        commaWsp = '(?:\\s+,?\\s*|,\\s*)',

        skewX = '(?:(skewX)\\s*\\(\\s*(' + number + ')\\s*\\))',

        skewY = '(?:(skewY)\\s*\\(\\s*(' + number + ')\\s*\\))',

        rotate = '(?:(rotate)\\s*\\(\\s*(' + number + ')(?:' +
                    commaWsp + '(' + number + ')' +
                    commaWsp + '(' + number + '))?\\s*\\))',

        scale = '(?:(scale)\\s*\\(\\s*(' + number + ')(?:' +
                    commaWsp + '(' + number + '))?\\s*\\))',

        translate = '(?:(translate)\\s*\\(\\s*(' + number + ')(?:' +
                    commaWsp + '(' + number + '))?\\s*\\))',

        matrix = '(?:(matrix)\\s*\\(\\s*' +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' +
                  '\\s*\\))',

        transform = '(?:' +
                    matrix + '|' +
                    translate + '|' +
                    scale + '|' +
                    rotate + '|' +
                    skewX + '|' +
                    skewY +
                    ')',

        transforms = '(?:' + transform + '(?:' + commaWsp + '*' + transform + ')*' + ')',

        transformList = '^\\s*(?:' + transforms + '?)\\s*$',

        // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
        reTransformList = new RegExp(transformList),
        // == end transform regexp

        reTransform = new RegExp(transform, 'g');

    return function(attributeValue) {

      // start with identity matrix
      var matrix = iMatrix.concat(),
          matrices = [];

      // return if no argument was given or
      // an argument does not match transform attribute regexp
      if (!attributeValue || (attributeValue && !reTransformList.test(attributeValue))) {
        return matrix;
      }

      attributeValue.replace(reTransform, function(match) {

        var m = new RegExp(transform).exec(match).filter(function (match) {
              // match !== '' && match != null
              return (!!match);
            }),
            operation = m[1],
            args = m.slice(2).map(parseFloat);

        switch (operation) {
          case 'translate':
            translateMatrix(matrix, args);
            break;
          case 'rotate':
            args[0] = fabric.util.degreesToRadians(args[0]);
            rotateMatrix(matrix, args);
            break;
          case 'scale':
            scaleMatrix(matrix, args);
            break;
          case 'skewX':
            skewMatrix(matrix, args, 2);
            break;
          case 'skewY':
            skewMatrix(matrix, args, 1);
            break;
          case 'matrix':
            matrix = args;
            break;
        }

        // snapshot current matrix into matrices array
        matrices.push(matrix.concat());
        // reset
        matrix = iMatrix.concat();
      });

      var combinedMatrix = matrices[0];
      while (matrices.length > 1) {
        matrices.shift();
        combinedMatrix = fabric.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
      }
      return combinedMatrix;
    };
  })();

  /**
   * @private
   */
  function parseStyleString(style, oStyle) {
    var attr, value;
    style.replace(/;\s*$/, '').split(';').forEach(function (chunk) {
      var pair = chunk.split(':');

      attr = pair[0].trim().toLowerCase();
      value =  pair[1].trim();

      oStyle[attr] = value;
    });
  }

  /**
   * @private
   */
  function parseStyleObject(style, oStyle) {
    var attr, value;
    for (var prop in style) {
      if (typeof style[prop] === 'undefined') {
        continue;
      }

      attr = prop.toLowerCase();
      value = style[prop];

      oStyle[attr] = value;
    }
  }

  /**
   * @private
   */
  function getGlobalStylesForElement(element, svgUid) {
    var styles = { };
    for (var rule in fabric.cssRules[svgUid]) {
      if (elementMatchesRule(element, rule.split(' '))) {
        for (var property in fabric.cssRules[svgUid][rule]) {
          styles[property] = fabric.cssRules[svgUid][rule][property];
        }
      }
    }
    return styles;
  }

  /**
   * @private
   */
  function elementMatchesRule(element, selectors) {
    var firstMatching, parentMatching = true;
    //start from rightmost selector.
    firstMatching = selectorMatches(element, selectors.pop());
    if (firstMatching && selectors.length) {
      parentMatching = doesSomeParentMatch(element, selectors);
    }
    return firstMatching && parentMatching && (selectors.length === 0);
  }

  function doesSomeParentMatch(element, selectors) {
    var selector, parentMatching = true;
    while (element.parentNode && element.parentNode.nodeType === 1 && selectors.length) {
      if (parentMatching) {
        selector = selectors.pop();
      }
      element = element.parentNode;
      parentMatching = selectorMatches(element, selector);
    }
    return selectors.length === 0;
  }

  /**
   * @private
   */
  function selectorMatches(element, selector) {
    var nodeName = element.nodeName,
        classNames = element.getAttribute('class'),
        id = element.getAttribute('id'), matcher, i;
    // i check if a selector matches slicing away part from it.
    // if i get empty string i should match
    matcher = new RegExp('^' + nodeName, 'i');
    selector = selector.replace(matcher, '');
    if (id && selector.length) {
      matcher = new RegExp('#' + id + '(?![a-zA-Z\\-]+)', 'i');
      selector = selector.replace(matcher, '');
    }
    if (classNames && selector.length) {
      classNames = classNames.split(' ');
      for (i = classNames.length; i--;) {
        matcher = new RegExp('\\.' + classNames[i] + '(?![a-zA-Z\\-]+)', 'i');
        selector = selector.replace(matcher, '');
      }
    }
    return selector.length === 0;
  }

  /**
   * @private
   * to support IE8 missing getElementById on SVGdocument and on node xmlDOM
   */
  function elementById(doc, id) {
    var el;
    doc.getElementById && (el = doc.getElementById(id));
    if (el) {
      return el;
    }
    var node, i, len, nodelist = doc.getElementsByTagName('*');
    for (i = 0, len = nodelist.length; i < len; i++) {
      node = nodelist[i];
      if (id === node.getAttribute('id')) {
        return node;
      }
    }
  }

  /**
   * @private
   */
  function parseUseDirectives(doc) {
    var nodelist = _getMultipleNodes(doc, ['use', 'svg:use']), i = 0;
    while (nodelist.length && i < nodelist.length) {
      var el = nodelist[i],
          xlink = (el.getAttribute('xlink:href') || el.getAttribute('href')).substr(1),
          x = el.getAttribute('x') || 0,
          y = el.getAttribute('y') || 0,
          el2 = elementById(doc, xlink).cloneNode(true),
          currentTrans = (el2.getAttribute('transform') || '') + ' translate(' + x + ', ' + y + ')',
          parentNode, oldLength = nodelist.length, attr, j, attrs, len, namespace = fabric.svgNS;

      applyViewboxTransform(el2);
      if (/^svg$/i.test(el2.nodeName)) {
        var el3 = el2.ownerDocument.createElementNS(namespace, 'g');
        for (j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++) {
          attr = attrs.item(j);
          el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
        }
        // el2.firstChild != null
        while (el2.firstChild) {
          el3.appendChild(el2.firstChild);
        }
        el2 = el3;
      }

      for (j = 0, attrs = el.attributes, len = attrs.length; j < len; j++) {
        attr = attrs.item(j);
        if (attr.nodeName === 'x' || attr.nodeName === 'y' ||
          attr.nodeName === 'xlink:href' || attr.nodeName === 'href') {
          continue;
        }

        if (attr.nodeName === 'transform') {
          currentTrans = attr.nodeValue + ' ' + currentTrans;
        }
        else {
          el2.setAttribute(attr.nodeName, attr.nodeValue);
        }
      }

      el2.setAttribute('transform', currentTrans);
      el2.setAttribute('instantiated_by_use', '1');
      el2.removeAttribute('id');
      parentNode = el.parentNode;
      parentNode.replaceChild(el2, el);
      // some browsers do not shorten nodelist after replaceChild (IE8)
      if (nodelist.length === oldLength) {
        i++;
      }
    }
  }

  // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
  // matches, e.g.: +14.56e-12, etc.
  var reViewBoxAttrValue = new RegExp(
    '^' +
    '\\s*(' + fabric.reNum + '+)\\s*,?' +
    '\\s*(' + fabric.reNum + '+)\\s*,?' +
    '\\s*(' + fabric.reNum + '+)\\s*,?' +
    '\\s*(' + fabric.reNum + '+)\\s*' +
    '$'
  );

  /**
   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
   */
  function applyViewboxTransform(element) {

    var viewBoxAttr = element.getAttribute('viewBox'),
        scaleX = 1,
        scaleY = 1,
        minX = 0,
        minY = 0,
        viewBoxWidth, viewBoxHeight, matrix, el,
        widthAttr = element.getAttribute('width'),
        heightAttr = element.getAttribute('height'),
        x = element.getAttribute('x') || 0,
        y = element.getAttribute('y') || 0,
        preserveAspectRatio = element.getAttribute('preserveAspectRatio') || '',
        missingViewBox = (!viewBoxAttr || !fabric.svgViewBoxElementsRegEx.test(element.nodeName)
                           || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue))),
        missingDimAttr = (!widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%'),
        toBeParsed = missingViewBox && missingDimAttr,
        parsedDim = { }, translateMatrix = '', widthDiff = 0, heightDiff = 0;

    parsedDim.width = 0;
    parsedDim.height = 0;
    parsedDim.toBeParsed = toBeParsed;

    if (toBeParsed) {
      return parsedDim;
    }

    if (missingViewBox) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr);
      return parsedDim;
    }
    minX = -parseFloat(viewBoxAttr[1]);
    minY = -parseFloat(viewBoxAttr[2]);
    viewBoxWidth = parseFloat(viewBoxAttr[3]);
    viewBoxHeight = parseFloat(viewBoxAttr[4]);
    parsedDim.minX = minX;
    parsedDim.minY = minY;
    parsedDim.viewBoxWidth = viewBoxWidth;
    parsedDim.viewBoxHeight = viewBoxHeight;
    if (!missingDimAttr) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr);
      scaleX = parsedDim.width / viewBoxWidth;
      scaleY = parsedDim.height / viewBoxHeight;
    }
    else {
      parsedDim.width = viewBoxWidth;
      parsedDim.height = viewBoxHeight;
    }

    // default is to preserve aspect ratio
    preserveAspectRatio = fabric.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);
    if (preserveAspectRatio.alignX !== 'none') {
      //translate all container for the effect of Mid, Min, Max
      if (preserveAspectRatio.meetOrSlice === 'meet') {
        scaleY = scaleX = (scaleX > scaleY ? scaleY : scaleX);
        // calculate additional translation to move the viewbox
      }
      if (preserveAspectRatio.meetOrSlice === 'slice') {
        scaleY = scaleX = (scaleX > scaleY ? scaleX : scaleY);
        // calculate additional translation to move the viewbox
      }
      widthDiff = parsedDim.width - viewBoxWidth * scaleX;
      heightDiff = parsedDim.height - viewBoxHeight * scaleX;
      if (preserveAspectRatio.alignX === 'Mid') {
        widthDiff /= 2;
      }
      if (preserveAspectRatio.alignY === 'Mid') {
        heightDiff /= 2;
      }
      if (preserveAspectRatio.alignX === 'Min') {
        widthDiff = 0;
      }
      if (preserveAspectRatio.alignY === 'Min') {
        heightDiff = 0;
      }
    }

    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) {
      return parsedDim;
    }

    if (x || y) {
      translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
    }

    matrix = translateMatrix + ' matrix(' + scaleX +
                  ' 0' +
                  ' 0 ' +
                  scaleY + ' ' +
                  (minX * scaleX + widthDiff) + ' ' +
                  (minY * scaleY + heightDiff) + ') ';
    parsedDim.viewboxTransform = fabric.parseTransformAttribute(matrix);
    if (element.nodeName === 'svg') {
      el = element.ownerDocument.createElementNS(fabric.svgNS, 'g');
      // element.firstChild != null
      while (element.firstChild) {
        el.appendChild(element.firstChild);
      }
      element.appendChild(el);
    }
    else {
      el = element;
      matrix = el.getAttribute('transform') + matrix;
    }
    el.setAttribute('transform', matrix);
    return parsedDim;
  }

  function hasAncestorWithNodeName(element, nodeName) {
    while (element && (element = element.parentNode)) {
      if (element.nodeName && nodeName.test(element.nodeName.replace('svg:', ''))
        && !element.getAttribute('instantiated_by_use')) {
        return true;
      }
    }
    return false;
  }

  /**
   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
   * @static
   * @function
   * @memberOf fabric
   * @param {SVGDocument} doc SVG document to parse
   * @param {Function} callback Callback to call when parsing is finished;
   * It's being passed an array of elements (parsed from a document).
   * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
   * @param {Object} [parsingOptions] options for parsing document
   * @param {String} [parsingOptions.crossOrigin] crossOrigin settings
   */
  fabric.parseSVGDocument = function(doc, callback, reviver, parsingOptions) {
    if (!doc) {
      return;
    }

    parseUseDirectives(doc);

    var svgUid =  fabric.Object.__uid++, i, len,
        options = applyViewboxTransform(doc),
        descendants = fabric.util.toArray(doc.getElementsByTagName('*'));
    options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
    options.svgUid = svgUid;

    if (descendants.length === 0 && fabric.isLikelyNode) {
      // we're likely in node, where "o3-xml" library fails to gEBTN("*")
      // https://github.com/ajaxorg/node-o3-xml/issues/21
      descendants = doc.selectNodes('//*[name(.)!="svg"]');
      var arr = [];
      for (i = 0, len = descendants.length; i < len; i++) {
        arr[i] = descendants[i];
      }
      descendants = arr;
    }

    var elements = descendants.filter(function(el) {
      applyViewboxTransform(el);
      return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', '')) &&
            !hasAncestorWithNodeName(el, fabric.svgInvalidAncestorsRegEx); // http://www.w3.org/TR/SVG/struct.html#DefsElement
    });

    if (!elements || (elements && !elements.length)) {
      callback && callback([], {});
      return;
    }
    var clipPaths = { };
    descendants.filter(function(el) {
      return el.nodeName.replace('svg:', '') === 'clipPath';
    }).forEach(function(el) {
      var id = el.getAttribute('id');
      clipPaths[id] = fabric.util.toArray(el.getElementsByTagName('*')).filter(function(el) {
        return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', ''));
      });
    });
    fabric.gradientDefs[svgUid] = fabric.getGradientDefs(doc);
    fabric.cssRules[svgUid] = fabric.getCSSRules(doc);
    fabric.clipPaths[svgUid] = clipPaths;
    // Precedence of rules:   style > class > attribute
    fabric.parseElements(elements, function(instances, elements) {
      if (callback) {
        callback(instances, options, elements, descendants);
        delete fabric.gradientDefs[svgUid];
        delete fabric.cssRules[svgUid];
        delete fabric.clipPaths[svgUid];
      }
    }, clone(options), reviver, parsingOptions);
  };

  function recursivelyParseGradientsXlink(doc, gradient) {
    var gradientsAttrs = ['gradientTransform', 'x1', 'x2', 'y1', 'y2', 'gradientUnits', 'cx', 'cy', 'r', 'fx', 'fy'],
        xlinkAttr = 'xlink:href',
        xLink = gradient.getAttribute(xlinkAttr).substr(1),
        referencedGradient = elementById(doc, xLink);
    if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) {
      recursivelyParseGradientsXlink(doc, referencedGradient);
    }
    gradientsAttrs.forEach(function(attr) {
      if (referencedGradient && !gradient.hasAttribute(attr) && referencedGradient.hasAttribute(attr)) {
        gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
      }
    });
    if (!gradient.children.length) {
      var referenceClone = referencedGradient.cloneNode(true);
      while (referenceClone.firstChild) {
        gradient.appendChild(referenceClone.firstChild);
      }
    }
    gradient.removeAttribute(xlinkAttr);
  }

  var reFontDeclaration = new RegExp(
    '(normal|italic)?\\s*(normal|small-caps)?\\s*' +
    '(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(' +
      fabric.reNum +
    '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + fabric.reNum + '))?\\s+(.*)');

  extend(fabric, {
    /**
     * Parses a short font declaration, building adding its properties to a style object
     * @static
     * @function
     * @memberOf fabric
     * @param {String} value font declaration
     * @param {Object} oStyle definition
     */
    parseFontDeclaration: function(value, oStyle) {
      var match = value.match(reFontDeclaration);

      if (!match) {
        return;
      }
      var fontStyle = match[1],
          // font variant is not used
          // fontVariant = match[2],
          fontWeight = match[3],
          fontSize = match[4],
          lineHeight = match[5],
          fontFamily = match[6];

      if (fontStyle) {
        oStyle.fontStyle = fontStyle;
      }
      if (fontWeight) {
        oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
      }
      if (fontSize) {
        oStyle.fontSize = parseUnit(fontSize);
      }
      if (fontFamily) {
        oStyle.fontFamily = fontFamily;
      }
      if (lineHeight) {
        oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
      }
    },

    /**
     * Parses an SVG document, returning all of the gradient declarations found in it
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
     */
    getGradientDefs: function(doc) {
      var tagArray = [
            'linearGradient',
            'radialGradient',
            'svg:linearGradient',
            'svg:radialGradient'],
          elList = _getMultipleNodes(doc, tagArray),
          el, j = 0, gradientDefs = { };
      j = elList.length;
      while (j--) {
        el = elList[j];
        if (el.getAttribute('xlink:href')) {
          recursivelyParseGradientsXlink(doc, el);
        }
        gradientDefs[el.getAttribute('id')] = el;
      }
      return gradientDefs;
    },

    /**
     * Returns an object of attributes' name/value, given element and an array of attribute names;
     * Parses parent "g" nodes recursively upwards.
     * @static
     * @memberOf fabric
     * @param {DOMElement} element Element to parse
     * @param {Array} attributes Array of attributes to parse
     * @return {Object} object containing parsed attributes' names/values
     */
    parseAttributes: function(element, attributes, svgUid) {

      if (!element) {
        return;
      }

      var value,
          parentAttributes = { },
          fontSize, parentFontSize;

      if (typeof svgUid === 'undefined') {
        svgUid = element.getAttribute('svgUid');
      }
      // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
      if (element.parentNode && fabric.svgValidParentsRegEx.test(element.parentNode.nodeName)) {
        parentAttributes = fabric.parseAttributes(element.parentNode, attributes, svgUid);
      }

      var ownAttributes = attributes.reduce(function(memo, attr) {
        value = element.getAttribute(attr);
        if (value) { // eslint-disable-line
          memo[attr] = value;
        }
        return memo;
      }, { });
      // add values parsed from style, which take precedence over attributes
      // (see: http://www.w3.org/TR/SVG/styling.html#UsingPresentationAttributes)
      var cssAttrs = extend(
        getGlobalStylesForElement(element, svgUid),
        fabric.parseStyleAttribute(element)
      );
      ownAttributes = extend(
        ownAttributes,
        cssAttrs
      );
      if (cssAttrs[cPath]) {
        element.setAttribute(cPath, cssAttrs[cPath]);
      }
      fontSize = parentFontSize = parentAttributes.fontSize || fabric.Text.DEFAULT_SVG_FONT_SIZE;
      if (ownAttributes[fSize]) {
        // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
        ownAttributes[fSize] = fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
      }

      var normalizedAttr, normalizedValue, normalizedStyle = {};
      for (var attr in ownAttributes) {
        normalizedAttr = normalizeAttr(attr);
        normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
        normalizedStyle[normalizedAttr] = normalizedValue;
      }
      if (normalizedStyle && normalizedStyle.font) {
        fabric.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
      }
      var mergedAttrs = extend(parentAttributes, normalizedStyle);
      return fabric.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
    },

    /**
     * Transforms an array of svg elements to corresponding fabric.* instances
     * @static
     * @memberOf fabric
     * @param {Array} elements Array of elements to parse
     * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
     * @param {Object} [options] Options object
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     */
    parseElements: function(elements, callback, options, reviver, parsingOptions) {
      new fabric.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
    },

    /**
     * Parses "style" attribute, retuning an object with values
     * @static
     * @memberOf fabric
     * @param {SVGElement} element Element to parse
     * @return {Object} Objects with values parsed from style attribute of an element
     */
    parseStyleAttribute: function(element) {
      var oStyle = { },
          style = element.getAttribute('style');

      if (!style) {
        return oStyle;
      }

      if (typeof style === 'string') {
        parseStyleString(style, oStyle);
      }
      else {
        parseStyleObject(style, oStyle);
      }

      return oStyle;
    },

    /**
     * Parses "points" attribute, returning an array of values
     * @static
     * @memberOf fabric
     * @param {String} points points attribute string
     * @return {Array} array of points
     */
    parsePointsAttribute: function(points) {

      // points attribute is required and must not be empty
      if (!points) {
        return null;
      }

      // replace commas with whitespace and remove bookending whitespace
      points = points.replace(/,/g, ' ').trim();

      points = points.split(/\s+/);
      var parsedPoints = [], i, len;

      for (i = 0, len = points.length; i < len; i += 2) {
        parsedPoints.push({
          x: parseFloat(points[i]),
          y: parseFloat(points[i + 1])
        });
      }

      // odd number of points is an error
      // if (parsedPoints.length % 2 !== 0) {
      //   return null;
      // }

      return parsedPoints;
    },

    /**
     * Returns CSS rules for a given SVG document
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} CSS rules of this document
     */
    getCSSRules: function(doc) {
      var styles = doc.getElementsByTagName('style'), i, len,
          allRules = { }, rules;

      // very crude parsing of style contents
      for (i = 0, len = styles.length; i < len; i++) {
        // <style/> could produce `undefined`, covering this case with ''
        var styleContents = styles[i].textContent || '';

        // remove comments
        styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, '');
        if (styleContents.trim() === '') {
          continue;
        }
        rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
        rules = rules.map(function(rule) { return rule.trim(); });
        // eslint-disable-next-line no-loop-func
        rules.forEach(function(rule) {

          var match = rule.match(/([\s\S]*?)\s*\{([^}]*)\}/),
              ruleObj = { }, declaration = match[2].trim(),
              propertyValuePairs = declaration.replace(/;$/, '').split(/\s*;\s*/);

          for (i = 0, len = propertyValuePairs.length; i < len; i++) {
            var pair = propertyValuePairs[i].split(/\s*:\s*/),
                property = pair[0],
                value = pair[1];
            ruleObj[property] = value;
          }
          rule = match[1];
          rule.split(',').forEach(function(_rule) {
            _rule = _rule.replace(/^svg/i, '').trim();
            if (_rule === '') {
              return;
            }
            if (allRules[_rule]) {
              fabric.util.object.extend(allRules[_rule], ruleObj);
            }
            else {
              allRules[_rule] = fabric.util.object.clone(ruleObj);
            }
          });
        });
      }
      return allRules;
    },

    /**
     * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
     * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
     * @memberOf fabric
     * @param {String} url
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */
    loadSVGFromURL: function(url, callback, reviver, options) {

      url = url.replace(/^\n\s*/, '').trim();
      new fabric.util.request(url, {
        method: 'get',
        onComplete: onComplete
      });

      function onComplete(r) {

        var xml = r.responseXML;
        if (xml && !xml.documentElement && fabric.window.ActiveXObject && r.responseText) {
          xml = new ActiveXObject('Microsoft.XMLDOM');
          xml.async = 'false';
          //IE chokes on DOCTYPE
          xml.loadXML(r.responseText.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, ''));
        }
        if (!xml || !xml.documentElement) {
          callback && callback(null);
          return false;
        }

        fabric.parseSVGDocument(xml.documentElement, function (results, _options, elements, allElements) {
          callback && callback(results, _options, elements, allElements);
        }, reviver, options);
      }
    },

    /**
     * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
     * @memberOf fabric
     * @param {String} string
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */
    loadSVGFromString: function(string, callback, reviver, options) {
      string = string.trim();
      var doc;
      if (typeof fabric.window.DOMParser !== 'undefined') {
        var parser = new fabric.window.DOMParser();
        if (parser && parser.parseFromString) {
          doc = parser.parseFromString(string, 'text/xml');
        }
      }
      else if (fabric.window.ActiveXObject) {
        doc = new ActiveXObject('Microsoft.XMLDOM');
        doc.async = 'false';
        // IE chokes on DOCTYPE
        doc.loadXML(string.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, ''));
      }

      fabric.parseSVGDocument(doc.documentElement, function (results, _options, elements, allElements) {
        callback(results, _options, elements, allElements);
      }, reviver, options);
    }
  });

})(typeof exports !== 'undefined' ? exports : this);


fabric.ElementsParser = function(elements, callback, options, reviver, parsingOptions, doc) {
  this.elements = elements;
  this.callback = callback;
  this.options = options;
  this.reviver = reviver;
  this.svgUid = (options && options.svgUid) || 0;
  this.parsingOptions = parsingOptions;
  this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
  this.doc = doc;
};

(function(proto) {
  proto.parse = function() {
    this.instances = new Array(this.elements.length);
    this.numElements = this.elements.length;
    this.createObjects();
  };

  proto.createObjects = function() {
    var _this = this;
    this.elements.forEach(function(element, i) {
      element.setAttribute('svgUid', _this.svgUid);
      _this.createObject(element, i);
    });
  };

  proto.findTag = function(el) {
    return fabric[fabric.util.string.capitalize(el.tagName.replace('svg:', ''))];
  };

  proto.createObject = function(el, index) {
    var klass = this.findTag(el);
    if (klass && klass.fromElement) {
      try {
        klass.fromElement(el, this.createCallback(index, el), this.options);
      }
      catch (err) {
        fabric.log(err);
      }
    }
    else {
      this.checkIfDone();
    }
  };

  proto.createCallback = function(index, el) {
    var _this = this;
    return function(obj) {
      var _options;
      _this.resolveGradient(obj, el, 'fill');
      _this.resolveGradient(obj, el, 'stroke');
      if (obj instanceof fabric.Image && obj._originalElement) {
        _options = obj.parsePreserveAspectRatioAttribute(el);
      }
      obj._removeTransformMatrix(_options);
      _this.resolveClipPath(obj, el);
      _this.reviver && _this.reviver(el, obj);
      _this.instances[index] = obj;
      _this.checkIfDone();
    };
  };

  proto.extractPropertyDefinition = function(obj, property, storage) {
    var value = obj[property], regex = this.regexUrl;
    if (!regex.test(value)) {
      return;
    }
    regex.lastIndex = 0;
    var id = regex.exec(value)[1];
    regex.lastIndex = 0;
    return fabric[storage][this.svgUid][id];
  };

  proto.resolveGradient = function(obj, el, property) {
    var gradientDef = this.extractPropertyDefinition(obj, property, 'gradientDefs');
    if (gradientDef) {
      var opacityAttr = el.getAttribute(property + '-opacity');
      var gradient = fabric.Gradient.fromElement(gradientDef, obj, opacityAttr, this.options);
      obj.set(property, gradient);
    }
  };

  proto.createClipPathCallback = function(obj, container) {
    return function(_newObj) {
      _newObj._removeTransformMatrix();
      _newObj.fillRule = _newObj.clipRule;
      container.push(_newObj);
    };
  };

  proto.resolveClipPath = function(obj, usingElement) {
    var clipPath = this.extractPropertyDefinition(obj, 'clipPath', 'clipPaths'),
        element, klass, objTransformInv, container, gTransform, options;
    if (clipPath) {
      container = [];
      objTransformInv = fabric.util.invertTransform(obj.calcTransformMatrix());
      // move the clipPath tag as sibling to the real element that is using it
      var clipPathTag = clipPath[0].parentNode;
      var clipPathOwner = usingElement;
      while (clipPathOwner.parentNode && clipPathOwner.getAttribute('clip-path') !== obj.clipPath) {
        clipPathOwner = clipPathOwner.parentNode;
      }
      clipPathOwner.parentNode.appendChild(clipPathTag);
      for (var i = 0; i < clipPath.length; i++) {
        element = clipPath[i];
        klass = this.findTag(element);
        klass.fromElement(
          element,
          this.createClipPathCallback(obj, container),
          this.options
        );
      }
      if (container.length === 1) {
        clipPath = container[0];
      }
      else {
        clipPath = new fabric.Group(container);
      }
      gTransform = fabric.util.multiplyTransformMatrices(
        objTransformInv,
        clipPath.calcTransformMatrix()
      );
      if (clipPath.clipPath) {
        this.resolveClipPath(clipPath, clipPathOwner);
      }
      var options = fabric.util.qrDecompose(gTransform);
      clipPath.flipX = false;
      clipPath.flipY = false;
      clipPath.set('scaleX', options.scaleX);
      clipPath.set('scaleY', options.scaleY);
      clipPath.angle = options.angle;
      clipPath.skewX = options.skewX;
      clipPath.skewY = 0;
      clipPath.setPositionByOrigin({ x: options.translateX, y: options.translateY }, 'center', 'center');
      obj.clipPath = clipPath;
    }
    else {
      // if clip-path does not resolve to any element, delete the property.
      delete obj.clipPath;
    }
  };

  proto.checkIfDone = function() {
    if (--this.numElements === 0) {
      this.instances = this.instances.filter(function(el) {
        // eslint-disable-next-line no-eq-null, eqeqeq
        return el != null;
      });
      this.callback(this.instances, this.elements);
    }
  };
})(fabric.ElementsParser.prototype);


(function(global) {

  'use strict';

  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Point) {
    fabric.warn('fabric.Point is already defined');
    return;
  }

  fabric.Point = Point;

  /**
   * Point class
   * @class fabric.Point
   * @memberOf fabric
   * @constructor
   * @param {Number} x
   * @param {Number} y
   * @return {fabric.Point} thisArg
   */
  function Point(x, y) {
    this.x = x;
    this.y = y;
  }

  Point.prototype = /** @lends fabric.Point.prototype */ {

    type: 'point',

    constructor: Point,

    /**
     * Adds another point to this one and returns another one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point instance with added values
     */
    add: function (that) {
      return new Point(this.x + that.x, this.y + that.y);
    },

    /**
     * Adds another point to this one
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */
    addEquals: function (that) {
      this.x += that.x;
      this.y += that.y;
      return this;
    },

    /**
     * Adds value to this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point} new Point with added value
     */
    scalarAdd: function (scalar) {
      return new Point(this.x + scalar, this.y + scalar);
    },

    /**
     * Adds value to this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    scalarAddEquals: function (scalar) {
      this.x += scalar;
      this.y += scalar;
      return this;
    },

    /**
     * Subtracts another point from this point and returns a new one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point object with subtracted values
     */
    subtract: function (that) {
      return new Point(this.x - that.x, this.y - that.y);
    },

    /**
     * Subtracts another point from this point
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */
    subtractEquals: function (that) {
      this.x -= that.x;
      this.y -= that.y;
      return this;
    },

    /**
     * Subtracts value from this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    scalarSubtract: function (scalar) {
      return new Point(this.x - scalar, this.y - scalar);
    },

    /**
     * Subtracts value from this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    scalarSubtractEquals: function (scalar) {
      this.x -= scalar;
      this.y -= scalar;
      return this;
    },

    /**
     * Multiplies this point by a value and returns a new one
     * TODO: rename in scalarMultiply in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    multiply: function (scalar) {
      return new Point(this.x * scalar, this.y * scalar);
    },

    /**
     * Multiplies this point by a value
     * TODO: rename in scalarMultiplyEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    multiplyEquals: function (scalar) {
      this.x *= scalar;
      this.y *= scalar;
      return this;
    },

    /**
     * Divides this point by a value and returns a new one
     * TODO: rename in scalarDivide in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    divide: function (scalar) {
      return new Point(this.x / scalar, this.y / scalar);
    },

    /**
     * Divides this point by a value
     * TODO: rename in scalarDivideEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    divideEquals: function (scalar) {
      this.x /= scalar;
      this.y /= scalar;
      return this;
    },

    /**
     * Returns true if this point is equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    eq: function (that) {
      return (this.x === that.x && this.y === that.y);
    },

    /**
     * Returns true if this point is less than another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    lt: function (that) {
      return (this.x < that.x && this.y < that.y);
    },

    /**
     * Returns true if this point is less than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    lte: function (that) {
      return (this.x <= that.x && this.y <= that.y);
    },

    /**

     * Returns true if this point is greater another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    gt: function (that) {
      return (this.x > that.x && this.y > that.y);
    },

    /**
     * Returns true if this point is greater than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    gte: function (that) {
      return (this.x >= that.x && this.y >= that.y);
    },

    /**
     * Returns new point which is the result of linear interpolation with this one and another one
     * @param {fabric.Point} that
     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
     * @return {fabric.Point}
     */
    lerp: function (that, t) {
      if (typeof t === 'undefined') {
        t = 0.5;
      }
      t = Math.max(Math.min(1, t), 0);
      return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
    },

    /**
     * Returns distance from this point and another one
     * @param {fabric.Point} that
     * @return {Number}
     */
    distanceFrom: function (that) {
      var dx = this.x - that.x,
          dy = this.y - that.y;
      return Math.sqrt(dx * dx + dy * dy);
    },

    /**
     * Returns the point between this point and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    midPointFrom: function (that) {
      return this.lerp(that);
    },

    /**
     * Returns a new point which is the min of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    min: function (that) {
      return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
    },

    /**
     * Returns a new point which is the max of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    max: function (that) {
      return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
    },

    /**
     * Returns string representation of this point
     * @return {String}
     */
    toString: function () {
      return this.x + ',' + this.y;
    },

    /**
     * Sets x/y of this point
     * @param {Number} x
     * @param {Number} y
     * @chainable
     */
    setXY: function (x, y) {
      this.x = x;
      this.y = y;
      return this;
    },

    /**
     * Sets x of this point
     * @param {Number} x
     * @chainable
     */
    setX: function (x) {
      this.x = x;
      return this;
    },

    /**
     * Sets y of this point
     * @param {Number} y
     * @chainable
     */
    setY: function (y) {
      this.y = y;
      return this;
    },

    /**
     * Sets x/y of this point from another point
     * @param {fabric.Point} that
     * @chainable
     */
    setFromPoint: function (that) {
      this.x = that.x;
      this.y = that.y;
      return this;
    },

    /**
     * Swaps x/y of this point and another point
     * @param {fabric.Point} that
     */
    swap: function (that) {
      var x = this.x,
          y = this.y;
      this.x = that.x;
      this.y = that.y;
      that.x = x;
      that.y = y;
    },

    /**
     * return a cloned instance of the point
     * @return {fabric.Point}
     */
    clone: function () {
      return new Point(this.x, this.y);
    }
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */
  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Intersection) {
    fabric.warn('fabric.Intersection is already defined');
    return;
  }

  /**
   * Intersection class
   * @class fabric.Intersection
   * @memberOf fabric
   * @constructor
   */
  function Intersection(status) {
    this.status = status;
    this.points = [];
  }

  fabric.Intersection = Intersection;

  fabric.Intersection.prototype = /** @lends fabric.Intersection.prototype */ {

    constructor: Intersection,

    /**
     * Appends a point to intersection
     * @param {fabric.Point} point
     * @return {fabric.Intersection} thisArg
     * @chainable
     */
    appendPoint: function (point) {
      this.points.push(point);
      return this;
    },

    /**
     * Appends points to intersection
     * @param {Array} points
     * @return {fabric.Intersection} thisArg
     * @chainable
     */
    appendPoints: function (points) {
      this.points = this.points.concat(points);
      return this;
    }
  };

  /**
   * Checks if one line intersects another
   * TODO: rename in intersectSegmentSegment
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {fabric.Point} b1
   * @param {fabric.Point} b2
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectLineLine = function (a1, a2, b1, b2) {
    var result,
        uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),
        ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),
        uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
    if (uB !== 0) {
      var ua = uaT / uB,
          ub = ubT / uB;
      if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
        result = new Intersection('Intersection');
        result.appendPoint(new fabric.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
      }
      else {
        result = new Intersection();
      }
    }
    else {
      if (uaT === 0 || ubT === 0) {
        result = new Intersection('Coincident');
      }
      else {
        result = new Intersection('Parallel');
      }
    }
    return result;
  };

  /**
   * Checks if line intersects polygon
   * TODO: rename in intersectSegmentPolygon
   * fix detection of coincident
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {Array} points
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectLinePolygon = function(a1, a2, points) {
    var result = new Intersection(),
        length = points.length,
        b1, b2, inter, i;

    for (i = 0; i < length; i++) {
      b1 = points[i];
      b2 = points[(i + 1) % length];
      inter = Intersection.intersectLineLine(a1, a2, b1, b2);

      result.appendPoints(inter.points);
    }
    if (result.points.length > 0) {
      result.status = 'Intersection';
    }
    return result;
  };

  /**
   * Checks if polygon intersects another polygon
   * @static
   * @param {Array} points1
   * @param {Array} points2
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectPolygonPolygon = function (points1, points2) {
    var result = new Intersection(),
        length = points1.length, i;

    for (i = 0; i < length; i++) {
      var a1 = points1[i],
          a2 = points1[(i + 1) % length],
          inter = Intersection.intersectLinePolygon(a1, a2, points2);

      result.appendPoints(inter.points);
    }
    if (result.points.length > 0) {
      result.status = 'Intersection';
    }
    return result;
  };

  /**
   * Checks if polygon intersects rectangle
   * @static
   * @param {Array} points
   * @param {fabric.Point} r1
   * @param {fabric.Point} r2
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectPolygonRectangle = function (points, r1, r2) {
    var min = r1.min(r2),
        max = r1.max(r2),
        topRight = new fabric.Point(max.x, min.y),
        bottomLeft = new fabric.Point(min.x, max.y),
        inter1 = Intersection.intersectLinePolygon(min, topRight, points),
        inter2 = Intersection.intersectLinePolygon(topRight, max, points),
        inter3 = Intersection.intersectLinePolygon(max, bottomLeft, points),
        inter4 = Intersection.intersectLinePolygon(bottomLeft, min, points),
        result = new Intersection();

    result.appendPoints(inter1.points);
    result.appendPoints(inter2.points);
    result.appendPoints(inter3.points);
    result.appendPoints(inter4.points);

    if (result.points.length > 0) {
      result.status = 'Intersection';
    }
    return result;
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Color) {
    fabric.warn('fabric.Color is already defined.');
    return;
  }

  /**
   * Color class
   * The purpose of {@link fabric.Color} is to abstract and encapsulate common color operations;
   * {@link fabric.Color} is a constructor and creates instances of {@link fabric.Color} objects.
   *
   * @class fabric.Color
   * @param {String} color optional in hex or rgb(a) or hsl format or from known color list
   * @return {fabric.Color} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors}
   */
  function Color(color) {
    if (!color) {
      this.setSource([0, 0, 0, 1]);
    }
    else {
      this._tryParsingColor(color);
    }
  }

  fabric.Color = Color;

  fabric.Color.prototype = /** @lends fabric.Color.prototype */ {

    /**
     * @private
     * @param {String|Array} color Color value to parse
     */
    _tryParsingColor: function(color) {
      var source;

      if (color in Color.colorNameMap) {
        color = Color.colorNameMap[color];
      }

      if (color === 'transparent') {
        source = [255, 255, 255, 0];
      }

      if (!source) {
        source = Color.sourceFromHex(color);
      }
      if (!source) {
        source = Color.sourceFromRgb(color);
      }
      if (!source) {
        source = Color.sourceFromHsl(color);
      }
      if (!source) {
        //if color is not recognize let's make black as canvas does
        source = [0, 0, 0, 1];
      }
      if (source) {
        this.setSource(source);
      }
    },

    /**
     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
     * @private
     * @param {Number} r Red color value
     * @param {Number} g Green color value
     * @param {Number} b Blue color value
     * @return {Array} Hsl color
     */
    _rgbToHsl: function(r, g, b) {
      r /= 255; g /= 255; b /= 255;

      var h, s, l,
          max = fabric.util.array.max([r, g, b]),
          min = fabric.util.array.min([r, g, b]);

      l = (max + min) / 2;

      if (max === min) {
        h = s = 0; // achromatic
      }
      else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }

      return [
        Math.round(h * 360),
        Math.round(s * 100),
        Math.round(l * 100)
      ];
    },

    /**
     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @return {Array}
     */
    getSource: function() {
      return this._source;
    },

    /**
     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @param {Array} source
     */
    setSource: function(source) {
      this._source = source;
    },

    /**
     * Returns color representation in RGB format
     * @return {String} ex: rgb(0-255,0-255,0-255)
     */
    toRgb: function() {
      var source = this.getSource();
      return 'rgb(' + source[0] + ',' + source[1] + ',' + source[2] + ')';
    },

    /**
     * Returns color representation in RGBA format
     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
     */
    toRgba: function() {
      var source = this.getSource();
      return 'rgba(' + source[0] + ',' + source[1] + ',' + source[2] + ',' + source[3] + ')';
    },

    /**
     * Returns color representation in HSL format
     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
     */
    toHsl: function() {
      var source = this.getSource(),
          hsl = this._rgbToHsl(source[0], source[1], source[2]);

      return 'hsl(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%)';
    },

    /**
     * Returns color representation in HSLA format
     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
     */
    toHsla: function() {
      var source = this.getSource(),
          hsl = this._rgbToHsl(source[0], source[1], source[2]);

      return 'hsla(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%,' + source[3] + ')';
    },

    /**
     * Returns color representation in HEX format
     * @return {String} ex: FF5555
     */
    toHex: function() {
      var source = this.getSource(), r, g, b;

      r = source[0].toString(16);
      r = (r.length === 1) ? ('0' + r) : r;

      g = source[1].toString(16);
      g = (g.length === 1) ? ('0' + g) : g;

      b = source[2].toString(16);
      b = (b.length === 1) ? ('0' + b) : b;

      return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
    },

    /**
     * Returns color representation in HEXA format
     * @return {String} ex: FF5555CC
     */
    toHexa: function() {
      var source = this.getSource(), a;

      a = Math.round(source[3] * 255);
      a = a.toString(16);
      a = (a.length === 1) ? ('0' + a) : a;

      return this.toHex() + a.toUpperCase();
    },

    /**
     * Gets value of alpha channel for this color
     * @return {Number} 0-1
     */
    getAlpha: function() {
      return this.getSource()[3];
    },

    /**
     * Sets value of alpha channel for this color
     * @param {Number} alpha Alpha value 0-1
     * @return {fabric.Color} thisArg
     */
    setAlpha: function(alpha) {
      var source = this.getSource();
      source[3] = alpha;
      this.setSource(source);
      return this;
    },

    /**
     * Transforms color to its grayscale representation
     * @return {fabric.Color} thisArg
     */
    toGrayscale: function() {
      var source = this.getSource(),
          average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10),
          currentAlpha = source[3];
      this.setSource([average, average, average, currentAlpha]);
      return this;
    },

    /**
     * Transforms color to its black and white representation
     * @param {Number} threshold
     * @return {fabric.Color} thisArg
     */
    toBlackWhite: function(threshold) {
      var source = this.getSource(),
          average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0),
          currentAlpha = source[3];

      threshold = threshold || 127;

      average = (Number(average) < Number(threshold)) ? 0 : 255;
      this.setSource([average, average, average, currentAlpha]);
      return this;
    },

    /**
     * Overlays color with another color
     * @param {String|fabric.Color} otherColor
     * @return {fabric.Color} thisArg
     */
    overlayWith: function(otherColor) {
      if (!(otherColor instanceof Color)) {
        otherColor = new Color(otherColor);
      }

      var result = [],
          alpha = this.getAlpha(),
          otherAlpha = 0.5,
          source = this.getSource(),
          otherSource = otherColor.getSource(), i;

      for (i = 0; i < 3; i++) {
        result.push(Math.round((source[i] * (1 - otherAlpha)) + (otherSource[i] * otherAlpha)));
      }

      result[3] = alpha;
      this.setSource(result);
      return this;
    }
  };

  /**
   * Regex matching color in RGB or RGBA formats (ex: rgb(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
   * @static
   * @field
   * @memberOf fabric.Color
   */
  // eslint-disable-next-line max-len
  fabric.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;

  /**
   * Regex matching color in HSL or HSLA formats (ex: hsl(200, 80%, 10%), hsla(300, 50%, 80%, 0.5), hsla( 300 , 50% , 80% , 0.5 ))
   * @static
   * @field
   * @memberOf fabric.Color
   */
  fabric.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;

  /**
   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
   * @static
   * @field
   * @memberOf fabric.Color
   */
  fabric.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;

  /**
   * Map of the 148 color names with HEX code
   * @static
   * @field
   * @memberOf fabric.Color
   * @see: https://www.w3.org/TR/css3-color/#svg-color
   */
  fabric.Color.colorNameMap = {
    aliceblue:            '#F0F8FF',
    antiquewhite:         '#FAEBD7',
    aqua:                 '#00FFFF',
    aquamarine:           '#7FFFD4',
    azure:                '#F0FFFF',
    beige:                '#F5F5DC',
    bisque:               '#FFE4C4',
    black:                '#000000',
    blanchedalmond:       '#FFEBCD',
    blue:                 '#0000FF',
    blueviolet:           '#8A2BE2',
    brown:                '#A52A2A',
    burlywood:            '#DEB887',
    cadetblue:            '#5F9EA0',
    chartreuse:           '#7FFF00',
    chocolate:            '#D2691E',
    coral:                '#FF7F50',
    cornflowerblue:       '#6495ED',
    cornsilk:             '#FFF8DC',
    crimson:              '#DC143C',
    cyan:                 '#00FFFF',
    darkblue:             '#00008B',
    darkcyan:             '#008B8B',
    darkgoldenrod:        '#B8860B',
    darkgray:             '#A9A9A9',
    darkgrey:             '#A9A9A9',
    darkgreen:            '#006400',
    darkkhaki:            '#BDB76B',
    darkmagenta:          '#8B008B',
    darkolivegreen:       '#556B2F',
    darkorange:           '#FF8C00',
    darkorchid:           '#9932CC',
    darkred:              '#8B0000',
    darksalmon:           '#E9967A',
    darkseagreen:         '#8FBC8F',
    darkslateblue:        '#483D8B',
    darkslategray:        '#2F4F4F',
    darkslategrey:        '#2F4F4F',
    darkturquoise:        '#00CED1',
    darkviolet:           '#9400D3',
    deeppink:             '#FF1493',
    deepskyblue:          '#00BFFF',
    dimgray:              '#696969',
    dimgrey:              '#696969',
    dodgerblue:           '#1E90FF',
    firebrick:            '#B22222',
    floralwhite:          '#FFFAF0',
    forestgreen:          '#228B22',
    fuchsia:              '#FF00FF',
    gainsboro:            '#DCDCDC',
    ghostwhite:           '#F8F8FF',
    gold:                 '#FFD700',
    goldenrod:            '#DAA520',
    gray:                 '#808080',
    grey:                 '#808080',
    green:                '#008000',
    greenyellow:          '#ADFF2F',
    honeydew:             '#F0FFF0',
    hotpink:              '#FF69B4',
    indianred:            '#CD5C5C',
    indigo:               '#4B0082',
    ivory:                '#FFFFF0',
    khaki:                '#F0E68C',
    lavender:             '#E6E6FA',
    lavenderblush:        '#FFF0F5',
    lawngreen:            '#7CFC00',
    lemonchiffon:         '#FFFACD',
    lightblue:            '#ADD8E6',
    lightcoral:           '#F08080',
    lightcyan:            '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray:            '#D3D3D3',
    lightgrey:            '#D3D3D3',
    lightgreen:           '#90EE90',
    lightpink:            '#FFB6C1',
    lightsalmon:          '#FFA07A',
    lightseagreen:        '#20B2AA',
    lightskyblue:         '#87CEFA',
    lightslategray:       '#778899',
    lightslategrey:       '#778899',
    lightsteelblue:       '#B0C4DE',
    lightyellow:          '#FFFFE0',
    lime:                 '#00FF00',
    limegreen:            '#32CD32',
    linen:                '#FAF0E6',
    magenta:              '#FF00FF',
    maroon:               '#800000',
    mediumaquamarine:     '#66CDAA',
    mediumblue:           '#0000CD',
    mediumorchid:         '#BA55D3',
    mediumpurple:         '#9370DB',
    mediumseagreen:       '#3CB371',
    mediumslateblue:      '#7B68EE',
    mediumspringgreen:    '#00FA9A',
    mediumturquoise:      '#48D1CC',
    mediumvioletred:      '#C71585',
    midnightblue:         '#191970',
    mintcream:            '#F5FFFA',
    mistyrose:            '#FFE4E1',
    moccasin:             '#FFE4B5',
    navajowhite:          '#FFDEAD',
    navy:                 '#000080',
    oldlace:              '#FDF5E6',
    olive:                '#808000',
    olivedrab:            '#6B8E23',
    orange:               '#FFA500',
    orangered:            '#FF4500',
    orchid:               '#DA70D6',
    palegoldenrod:        '#EEE8AA',
    palegreen:            '#98FB98',
    paleturquoise:        '#AFEEEE',
    palevioletred:        '#DB7093',
    papayawhip:           '#FFEFD5',
    peachpuff:            '#FFDAB9',
    peru:                 '#CD853F',
    pink:                 '#FFC0CB',
    plum:                 '#DDA0DD',
    powderblue:           '#B0E0E6',
    purple:               '#800080',
    rebeccapurple:        '#663399',
    red:                  '#FF0000',
    rosybrown:            '#BC8F8F',
    royalblue:            '#4169E1',
    saddlebrown:          '#8B4513',
    salmon:               '#FA8072',
    sandybrown:           '#F4A460',
    seagreen:             '#2E8B57',
    seashell:             '#FFF5EE',
    sienna:               '#A0522D',
    silver:               '#C0C0C0',
    skyblue:              '#87CEEB',
    slateblue:            '#6A5ACD',
    slategray:            '#708090',
    slategrey:            '#708090',
    snow:                 '#FFFAFA',
    springgreen:          '#00FF7F',
    steelblue:            '#4682B4',
    tan:                  '#D2B48C',
    teal:                 '#008080',
    thistle:              '#D8BFD8',
    tomato:               '#FF6347',
    turquoise:            '#40E0D0',
    violet:               '#EE82EE',
    wheat:                '#F5DEB3',
    white:                '#FFFFFF',
    whitesmoke:           '#F5F5F5',
    yellow:               '#FFFF00',
    yellowgreen:          '#9ACD32'
  };

  /**
   * @private
   * @param {Number} p
   * @param {Number} q
   * @param {Number} t
   * @return {Number}
   */
  function hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
      return q;
    }
    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
  }

  /**
   * Returns new color object, when given a color in RGB format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
   * @return {fabric.Color}
   */
  fabric.Color.fromRgb = function(color) {
    return Color.fromSource(Color.sourceFromRgb(color));
  };

  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
   * @return {Array} source
   */
  fabric.Color.sourceFromRgb = function(color) {
    var match = color.match(Color.reRGBa);
    if (match) {
      var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1),
          g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1),
          b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);

      return [
        parseInt(r, 10),
        parseInt(g, 10),
        parseInt(b, 10),
        match[4] ? parseFloat(match[4]) : 1
      ];
    }
  };

  /**
   * Returns new color object, when given a color in RGBA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */
  fabric.Color.fromRgba = Color.fromRgb;

  /**
   * Returns new color object, when given a color in HSL format
   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
   * @memberOf fabric.Color
   * @return {fabric.Color}
   */
  fabric.Color.fromHsl = function(color) {
    return Color.fromSource(Color.sourceFromHsl(color));
  };

  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
   * @memberOf fabric.Color
   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
   * @return {Array} source
   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
   */
  fabric.Color.sourceFromHsl = function(color) {
    var match = color.match(Color.reHSLa);
    if (!match) {
      return;
    }

    var h = (((parseFloat(match[1]) % 360) + 360) % 360) / 360,
        s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1),
        l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1),
        r, g, b;

    if (s === 0) {
      r = g = b = l;
    }
    else {
      var q = l <= 0.5 ? l * (s + 1) : l + s - l * s,
          p = l * 2 - q;

      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [
      Math.round(r * 255),
      Math.round(g * 255),
      Math.round(b * 255),
      match[4] ? parseFloat(match[4]) : 1
    ];
  };

  /**
   * Returns new color object, when given a color in HSLA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */
  fabric.Color.fromHsla = Color.fromHsl;

  /**
   * Returns new color object, when given a color in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color Color value ex: FF5555
   * @return {fabric.Color}
   */
  fabric.Color.fromHex = function(color) {
    return Color.fromSource(Color.sourceFromHex(color));
  };

  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
   * @return {Array} source
   */
  fabric.Color.sourceFromHex = function(color) {
    if (color.match(Color.reHex)) {
      var value = color.slice(color.indexOf('#') + 1),
          isShortNotation = (value.length === 3 || value.length === 4),
          isRGBa = (value.length === 8 || value.length === 4),
          r = isShortNotation ? (value.charAt(0) + value.charAt(0)) : value.substring(0, 2),
          g = isShortNotation ? (value.charAt(1) + value.charAt(1)) : value.substring(2, 4),
          b = isShortNotation ? (value.charAt(2) + value.charAt(2)) : value.substring(4, 6),
          a = isRGBa ? (isShortNotation ? (value.charAt(3) + value.charAt(3)) : value.substring(6, 8)) : 'FF';

      return [
        parseInt(r, 16),
        parseInt(g, 16),
        parseInt(b, 16),
        parseFloat((parseInt(a, 16) / 255).toFixed(2))
      ];
    }
  };

  /**
   * Returns new color object, when given color in array representation (ex: [200, 100, 100, 0.5])
   * @static
   * @memberOf fabric.Color
   * @param {Array} source
   * @return {fabric.Color}
   */
  fabric.Color.fromSource = function(source) {
    var oColor = new Color();
    oColor.setSource(source);
    return oColor;
  };

})(typeof exports !== 'undefined' ? exports : this);


(function() {

  /* _FROM_SVG_START_ */
  function getColorStop(el, multiplier) {
    var style = el.getAttribute('style'),
        offset = el.getAttribute('offset') || 0,
        color, colorAlpha, opacity, i;

    // convert percents to absolute values
    offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
    offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;
    if (style) {
      var keyValuePairs = style.split(/\s*;\s*/);

      if (keyValuePairs[keyValuePairs.length - 1] === '') {
        keyValuePairs.pop();
      }

      for (i = keyValuePairs.length; i--; ) {

        var split = keyValuePairs[i].split(/\s*:\s*/),
            key = split[0].trim(),
            value = split[1].trim();

        if (key === 'stop-color') {
          color = value;
        }
        else if (key === 'stop-opacity') {
          opacity = value;
        }
      }
    }

    if (!color) {
      color = el.getAttribute('stop-color') || 'rgb(0,0,0)';
    }
    if (!opacity) {
      opacity = el.getAttribute('stop-opacity');
    }

    color = new fabric.Color(color);
    colorAlpha = color.getAlpha();
    opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
    opacity *= colorAlpha * multiplier;

    return {
      offset: offset,
      color: color.toRgb(),
      opacity: opacity
    };
  }

  function getLinearCoords(el) {
    return {
      x1: el.getAttribute('x1') || 0,
      y1: el.getAttribute('y1') || 0,
      x2: el.getAttribute('x2') || '100%',
      y2: el.getAttribute('y2') || 0
    };
  }

  function getRadialCoords(el) {
    return {
      x1: el.getAttribute('fx') || el.getAttribute('cx') || '50%',
      y1: el.getAttribute('fy') || el.getAttribute('cy') || '50%',
      r1: 0,
      x2: el.getAttribute('cx') || '50%',
      y2: el.getAttribute('cy') || '50%',
      r2: el.getAttribute('r') || '50%'
    };
  }
  /* _FROM_SVG_END_ */

  var clone = fabric.util.object.clone;

  /**
   * Gradient class
   * @class fabric.Gradient
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
   * @see {@link fabric.Gradient#initialize} for constructor definition
   */
  fabric.Gradient = fabric.util.createClass(/** @lends fabric.Gradient.prototype */ {

    /**
     * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */
    offsetX: 0,

    /**
     * Vertical offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */
    offsetY: 0,

    /**
     * A transform matrix to apply to the gradient before painting.
     * Imported from svg gradients, is not applied with the current transform in the center.
     * Before this transform is applied, the origin point is at the top left corner of the object
     * plus the addition of offsetY and offsetX.
     * @type Number[]
     * @default null
     */
    gradientTransform: null,

    /**
     * coordinates units for coords.
     * If `pixels`, the number of coords are in the same unit of width / height.
     * If set as `percentage` the coords are still a number, but 1 means 100% of width
     * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
     * allowed values pixels or percentage.
     * @type String
     * @default 'pixels'
     */
    gradientUnits: 'pixels',

    /**
     * Gradient type linear or radial
     * @type String
     * @default 'pixels'
     */
    type: 'linear',

    /**
     * Constructor
     * @param {Object} options Options object with type, coords, gradientUnits and colorStops
     * @param {Object} [options.type] gradient type linear or radial
     * @param {Object} [options.gradientUnits] gradient units
     * @param {Object} [options.offsetX] SVG import compatibility
     * @param {Object} [options.offsetY] SVG import compatibility
     * @param {Object[]} options.colorStops contains the colorstops.
     * @param {Object} options.coords contains the coords of the gradient
     * @param {Number} [options.coords.x1] X coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.y1] Y coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.x2] X coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.y2] Y coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.r1] only for radial gradient, radius of the inner circle
     * @param {Number} [options.coords.r2] only for radial gradient, radius of the external circle
     * @return {fabric.Gradient} thisArg
     */
    initialize: function(options) {
      options || (options = { });
      options.coords || (options.coords = { });

      var coords, _this = this;

      // sets everything, then coords and colorstops get sets again
      Object.keys(options).forEach(function(option) {
        _this[option] = options[option];
      });

      if (this.id) {
        this.id += '_' + fabric.Object.__uid++;
      }
      else {
        this.id = fabric.Object.__uid++;
      }

      coords = {
        x1: options.coords.x1 || 0,
        y1: options.coords.y1 || 0,
        x2: options.coords.x2 || 0,
        y2: options.coords.y2 || 0
      };

      if (this.type === 'radial') {
        coords.r1 = options.coords.r1 || 0;
        coords.r2 = options.coords.r2 || 0;
      }

      this.coords = coords;
      this.colorStops = options.colorStops.slice();
    },

    /**
     * Adds another colorStop
     * @param {Object} colorStop Object with offset and color
     * @return {fabric.Gradient} thisArg
     */
    addColorStop: function(colorStops) {
      for (var position in colorStops) {
        var color = new fabric.Color(colorStops[position]);
        this.colorStops.push({
          offset: parseFloat(position),
          color: color.toRgb(),
          opacity: color.getAlpha()
        });
      }
      return this;
    },

    /**
     * Returns object representation of a gradient
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object}
     */
    toObject: function(propertiesToInclude) {
      var object = {
        type: this.type,
        coords: this.coords,
        colorStops: this.colorStops,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        gradientUnits: this.gradientUnits,
        gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
      };
      fabric.util.populateWithProperties(this, object, propertiesToInclude);

      return object;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of an gradient
     * @param {Object} object Object to create a gradient for
     * @return {String} SVG representation of an gradient (linear/radial)
     */
    toSVG: function(object, options) {
      var coords = clone(this.coords, true), i, len, options = options || {},
          markup, commonAttributes, colorStops = clone(this.colorStops, true),
          needsSwap = coords.r1 > coords.r2,
          transform = this.gradientTransform ? this.gradientTransform.concat() : fabric.iMatrix.concat(),
          offsetX = -this.offsetX, offsetY = -this.offsetY,
          withViewport = !!options.additionalTransform,
          gradientUnits = this.gradientUnits === 'pixels' ? 'userSpaceOnUse' : 'objectBoundingBox';
      // colorStops must be sorted ascending
      colorStops.sort(function(a, b) {
        return a.offset - b.offset;
      });

      if (gradientUnits === 'objectBoundingBox') {
        offsetX /= object.width;
        offsetY /= object.height;
      }
      else {
        offsetX += object.width / 2;
        offsetY += object.height / 2;
      }
      if (object.type === 'path') {
        offsetX -= object.pathOffset.x;
        offsetY -= object.pathOffset.y;
      }


      transform[4] -= offsetX;
      transform[5] -= offsetY;

      commonAttributes = 'id="SVGID_' + this.id +
                     '" gradientUnits="' + gradientUnits + '"';
      commonAttributes += ' gradientTransform="' + (withViewport ?
        options.additionalTransform + ' ' : '') + fabric.util.matrixToSVG(transform) + '" ';

      if (this.type === 'linear') {
        markup = [
          '<linearGradient ',
          commonAttributes,
          ' x1="', coords.x1,
          '" y1="', coords.y1,
          '" x2="', coords.x2,
          '" y2="', coords.y2,
          '">\n'
        ];
      }
      else if (this.type === 'radial') {
        // svg radial gradient has just 1 radius. the biggest.
        markup = [
          '<radialGradient ',
          commonAttributes,
          ' cx="', needsSwap ? coords.x1 : coords.x2,
          '" cy="', needsSwap ? coords.y1 : coords.y2,
          '" r="', needsSwap ? coords.r1 : coords.r2,
          '" fx="', needsSwap ? coords.x2 : coords.x1,
          '" fy="', needsSwap ? coords.y2 : coords.y1,
          '">\n'
        ];
      }

      if (this.type === 'radial') {
        if (needsSwap) {
          // svg goes from internal to external radius. if radius are inverted, swap color stops.
          colorStops = colorStops.concat();
          colorStops.reverse();
          for (i = 0, len = colorStops.length; i < len; i++) {
            colorStops[i].offset = 1 - colorStops[i].offset;
          }
        }
        var minRadius = Math.min(coords.r1, coords.r2);
        if (minRadius > 0) {
          // i have to shift all colorStops and add new one in 0.
          var maxRadius = Math.max(coords.r1, coords.r2),
              percentageShift = minRadius / maxRadius;
          for (i = 0, len = colorStops.length; i < len; i++) {
            colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
          }
        }
      }

      for (i = 0, len = colorStops.length; i < len; i++) {
        var colorStop = colorStops[i];
        markup.push(
          '<stop ',
          'offset="', (colorStop.offset * 100) + '%',
          '" style="stop-color:', colorStop.color,
          (typeof colorStop.opacity !== 'undefined' ? ';stop-opacity: ' + colorStop.opacity : ';'),
          '"/>\n'
        );
      }

      markup.push((this.type === 'linear' ? '</linearGradient>\n' : '</radialGradient>\n'));

      return markup.join('');
    },
    /* _TO_SVG_END_ */

    /**
     * Returns an instance of CanvasGradient
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Object} object the fabric.Object for which the gradient is
     * @return {CanvasGradient}
     */
    toLive: function(ctx, object) {
      var gradient, coords = fabric.util.object.clone(this.coords), i, len,
          x1 = coords.x1, y1 = coords.y1, x2 = coords.x2, y2 = coords.y2,
          stops = this.colorStops;

      if (!this.type) {
        return;
      }

      if (object instanceof fabric.Text && this.gradientUnits === 'percentage') {
        x1 *= object.width;
        y1 *= object.height;
        x2 *= object.width;
        y2 *= object.height;
      }
      if (this.type === 'linear') {
        gradient = ctx.createLinearGradient(x1, y1, x2, y2);
      }
      else if (this.type === 'radial') {
        gradient = ctx.createRadialGradient(x1, y1, coords.r1, x2, y2, coords.r2);
      }
      for (i = 0, len = stops.length; i < len; i++) {
        var color = stops[i].color,
            opacity = stops[i].opacity,
            offset = stops[i].offset;

        if (typeof opacity !== 'undefined') {
          color = new fabric.Color(color).setAlpha(opacity).toRgba();
        }
        gradient.addColorStop(offset, color);
      }

      return gradient;
    }
  });

  fabric.util.object.extend(fabric.Gradient, {

    /* _FROM_SVG_START_ */
    /**
     * Returns {@link fabric.Gradient} instance from an SVG element
     * @static
     * @memberOf fabric.Gradient
     * @param {SVGGradientElement} el SVG gradient element
     * @param {fabric.Object} instance
     * @param {String} opacityAttr A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
     * @param {Object} svgOptions an object containing the size of the SVG in order to parse correctly graidents
     * that uses gradientUnits as 'userSpaceOnUse' and percentages.
     * @param {Object.number} viewBoxWidth width part of the viewBox attribute on svg
     * @param {Object.number} viewBoxHeight height part of the viewBox attribute on svg
     * @param {Object.number} width width part of the svg tag if viewBox is not specified
     * @param {Object.number} height height part of the svg tag if viewBox is not specified
     * @return {fabric.Gradient} Gradient instance
     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
     */
    fromElement: function(el, instance, opacityAttr, svgOptions) {
      /**
       *  @example:
       *
       *  <linearGradient id="linearGrad1">
       *    <stop offset="0%" stop-color="white"/>
       *    <stop offset="100%" stop-color="black"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <linearGradient id="linearGrad2">
       *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
       *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad1">
       *    <stop offset="0%" stop-color="white" stop-opacity="1" />
       *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
       *    <stop offset="100%" stop-color="white" stop-opacity="1" />
       *  </radialGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad2">
       *    <stop offset="0" stop-color="rgb(255,255,255)" />
       *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
       *    <stop offset="1" stop-color="rgb(255,255,255)" />
       *  </radialGradient>
       *
       */

      var multiplier = parseFloat(opacityAttr) / (/%$/.test(opacityAttr) ? 100 : 1);
      multiplier = multiplier < 0 ? 0 : multiplier > 1 ? 1 : multiplier;
      if (isNaN(multiplier)) {
        multiplier = 1;
      }

      var colorStopEls = el.getElementsByTagName('stop'),
          type,
          gradientUnits = el.getAttribute('gradientUnits') === 'userSpaceOnUse' ?
            'pixels' : 'percentage',
          gradientTransform = el.getAttribute('gradientTransform') || '',
          colorStops = [],
          coords, i, offsetX = 0, offsetY = 0,
          transformMatrix;
      if (el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT') {
        type = 'linear';
        coords = getLinearCoords(el);
      }
      else {
        type = 'radial';
        coords = getRadialCoords(el);
      }

      for (i = colorStopEls.length; i--; ) {
        colorStops.push(getColorStop(colorStopEls[i], multiplier));
      }

      transformMatrix = fabric.parseTransformAttribute(gradientTransform);

      __convertPercentUnitsToValues(instance, coords, svgOptions, gradientUnits);

      if (gradientUnits === 'pixels') {
        offsetX = -instance.left;
        offsetY = -instance.top;
      }

      var gradient = new fabric.Gradient({
        id: el.getAttribute('id'),
        type: type,
        coords: coords,
        colorStops: colorStops,
        gradientUnits: gradientUnits,
        gradientTransform: transformMatrix,
        offsetX: offsetX,
        offsetY: offsetY,
      });

      return gradient;
    },
    /* _FROM_SVG_END_ */

    /**
     * Returns {@link fabric.Gradient} instance from its object representation
     * this function is uniquely used by Object.setGradient and is deprecated with it.
     * @static
     * @deprecated since 3.4.0
     * @memberOf fabric.Gradient
     * @param {Object} obj
     * @param {Object} [options] Options object
     */
    forObject: function(obj, options) {
      options || (options = { });
      __convertPercentUnitsToValues(obj, options.coords, options.gradientUnits, {
        // those values are to avoid errors. this function is uniquely used by
        viewBoxWidth: 100,
        viewBoxHeight: 100,
      });
      return new fabric.Gradient(options);
    }
  });

  /**
   * @private
   */
  function __convertPercentUnitsToValues(instance, options, svgOptions, gradientUnits) {
    var propValue, finalValue;
    Object.keys(options).forEach(function(prop) {
      propValue = options[prop];
      if (propValue === 'Infinity') {
        finalValue = 1;
      }
      else if (propValue === '-Infinity') {
        finalValue = 0;
      }
      else {
        finalValue = parseFloat(options[prop], 10);
        if (typeof propValue === 'string' && /^(\d+\.\d+)%|(\d+)%$/.test(propValue)) {
          finalValue *= 0.01;
          if (gradientUnits === 'pixels') {
            // then we need to fix those percentages here in svg parsing
            if (prop === 'x1' || prop === 'x2' || prop === 'r2') {
              finalValue *= svgOptions.viewBoxWidth || svgOptions.width;
            }
            if (prop === 'y1' || prop === 'y2') {
              finalValue *= svgOptions.viewBoxHeight || svgOptions.height;
            }
          }
        }
      }
      options[prop] = finalValue;
    });
  }
})();


(function() {

  'use strict';

  var toFixed = fabric.util.toFixed;

  /**
   * Pattern class
   * @class fabric.Pattern
   * @see {@link http://fabricjs.com/patterns|Pattern demo}
   * @see {@link http://fabricjs.com/dynamic-patterns|DynamicPattern demo}
   * @see {@link fabric.Pattern#initialize} for constructor definition
   */


  fabric.Pattern = fabric.util.createClass(/** @lends fabric.Pattern.prototype */ {

    /**
     * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
     * @type String
     * @default
     */
    repeat: 'repeat',

    /**
     * Pattern horizontal offset from object's left/top corner
     * @type Number
     * @default
     */
    offsetX: 0,

    /**
     * Pattern vertical offset from object's left/top corner
     * @type Number
     * @default
     */
    offsetY: 0,

    /**
     * crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @type String
     * @default
     */
    crossOrigin: '',

    /**
     * transform matrix to change the pattern, imported from svgs.
     * @type Array
     * @default
     */
    patternTransform: null,

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @param {Function} [callback] function to invoke after callback init.
     * @return {fabric.Pattern} thisArg
     */
    initialize: function(options, callback) {
      options || (options = { });

      this.id = fabric.Object.__uid++;
      this.setOptions(options);
      if (!options.source || (options.source && typeof options.source !== 'string')) {
        callback && callback(this);
        return;
      }
      // function string
      if (typeof fabric.util.getFunctionBody(options.source) !== 'undefined') {
        this.source = new Function(fabric.util.getFunctionBody(options.source));
        callback && callback(this);
      }
      else {
        // img src string
        var _this = this;
        this.source = fabric.util.createImage();
        fabric.util.loadImage(options.source, function(img) {
          _this.source = img;
          callback && callback(_this);
        }, null, this.crossOrigin);
      }
    },

    /**
     * Returns object representation of a pattern
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of a pattern instance
     */
    toObject: function(propertiesToInclude) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          source, object;

      // callback
      if (typeof this.source === 'function') {
        source = String(this.source);
      }
      // <img> element
      else if (typeof this.source.src === 'string') {
        source = this.source.src;
      }
      // <canvas> element
      else if (typeof this.source === 'object' && this.source.toDataURL) {
        source = this.source.toDataURL();
      }

      object = {
        type: 'pattern',
        source: source,
        repeat: this.repeat,
        crossOrigin: this.crossOrigin,
        offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
        offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
        patternTransform: this.patternTransform ? this.patternTransform.concat() : null
      };
      fabric.util.populateWithProperties(this, object, propertiesToInclude);

      return object;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of a pattern
     * @param {fabric.Object} object
     * @return {String} SVG representation of a pattern
     */
    toSVG: function(object) {
      var patternSource = typeof this.source === 'function' ? this.source() : this.source,
          patternWidth = patternSource.width / object.width,
          patternHeight = patternSource.height / object.height,
          patternOffsetX = this.offsetX / object.width,
          patternOffsetY = this.offsetY / object.height,
          patternImgSrc = '';
      if (this.repeat === 'repeat-x' || this.repeat === 'no-repeat') {
        patternHeight = 1;
        if (patternOffsetY) {
          patternHeight += Math.abs(patternOffsetY);
        }
      }
      if (this.repeat === 'repeat-y' || this.repeat === 'no-repeat') {
        patternWidth = 1;
        if (patternOffsetX) {
          patternWidth += Math.abs(patternOffsetX);
        }

      }
      if (patternSource.src) {
        patternImgSrc = patternSource.src;
      }
      else if (patternSource.toDataURL) {
        patternImgSrc = patternSource.toDataURL();
      }

      return '<pattern id="SVGID_' + this.id +
                    '" x="' + patternOffsetX +
                    '" y="' + patternOffsetY +
                    '" width="' + patternWidth +
                    '" height="' + patternHeight + '">\n' +
               '<image x="0" y="0"' +
                      ' width="' + patternSource.width +
                      '" height="' + patternSource.height +
                      '" xlink:href="' + patternImgSrc +
               '"></image>\n' +
             '</pattern>\n';
    },
    /* _TO_SVG_END_ */

    setOptions: function(options) {
      for (var prop in options) {
        this[prop] = options[prop];
      }
    },

    /**
     * Returns an instance of CanvasPattern
     * @param {CanvasRenderingContext2D} ctx Context to create pattern
     * @return {CanvasPattern}
     */
    toLive: function(ctx) {
      var source = typeof this.source === 'function' ? this.source() : this.source;

      // if the image failed to load, return, and allow rest to continue loading
      if (!source) {
        return '';
      }

      // if an image
      if (typeof source.src !== 'undefined') {
        if (!source.complete) {
          return '';
        }
        if (source.naturalWidth === 0 || source.naturalHeight === 0) {
          return '';
        }
      }
      return ctx.createPattern(source, this.repeat);
    }
  });
})();


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      toFixed = fabric.util.toFixed;

  if (fabric.Shadow) {
    fabric.warn('fabric.Shadow is already defined.');
    return;
  }

  /**
   * Shadow class
   * @class fabric.Shadow
   * @see {@link http://fabricjs.com/shadows|Shadow demo}
   * @see {@link fabric.Shadow#initialize} for constructor definition
   */
  fabric.Shadow = fabric.util.createClass(/** @lends fabric.Shadow.prototype */ {

    /**
     * Shadow color
     * @type String
     * @default
     */
    color: 'rgb(0,0,0)',

    /**
     * Shadow blur
     * @type Number
     */
    blur: 0,

    /**
     * Shadow horizontal offset
     * @type Number
     * @default
     */
    offsetX: 0,

    /**
     * Shadow vertical offset
     * @type Number
     * @default
     */
    offsetY: 0,

    /**
     * Whether the shadow should affect stroke operations
     * @type Boolean
     * @default
     */
    affectStroke: false,

    /**
     * Indicates whether toObject should include default values
     * @type Boolean
     * @default
     */
    includeDefaultValues: true,

    /**
     * When `false`, the shadow will scale with the object.
     * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
     * default to false
     * @type Boolean
     * @default
     */
    nonScaling: false,

    /**
     * Constructor
     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
     * @return {fabric.Shadow} thisArg
     */
    initialize: function(options) {

      if (typeof options === 'string') {
        options = this._parseShadow(options);
      }

      for (var prop in options) {
        this[prop] = options[prop];
      }

      this.id = fabric.Object.__uid++;
    },

    /**
     * @private
     * @param {String} shadow Shadow value to parse
     * @return {Object} Shadow object with color, offsetX, offsetY and blur
     */
    _parseShadow: function(shadow) {
      var shadowStr = shadow.trim(),
          offsetsAndBlur = fabric.Shadow.reOffsetsAndBlur.exec(shadowStr) || [],
          color = shadowStr.replace(fabric.Shadow.reOffsetsAndBlur, '') || 'rgb(0,0,0)';

      return {
        color: color.trim(),
        offsetX: parseInt(offsetsAndBlur[1], 10) || 0,
        offsetY: parseInt(offsetsAndBlur[2], 10) || 0,
        blur: parseInt(offsetsAndBlur[3], 10) || 0
      };
    },

    /**
     * Returns a string representation of an instance
     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
     * @return {String} Returns CSS3 text-shadow declaration
     */
    toString: function() {
      return [this.offsetX, this.offsetY, this.blur, this.color].join('px ');
    },

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of a shadow
     * @param {fabric.Object} object
     * @return {String} SVG representation of a shadow
     */
    toSVG: function(object) {
      var fBoxX = 40, fBoxY = 40, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          offset = fabric.util.rotateVector(
            { x: this.offsetX, y: this.offsetY },
            fabric.util.degreesToRadians(-object.angle)),
          BLUR_BOX = 20, color = new fabric.Color(this.color);

      if (object.width && object.height) {
        //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
        // we add some extra space to filter box to contain the blur ( 20 )
        fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
        fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
      }
      if (object.flipX) {
        offset.x *= -1;
      }
      if (object.flipY) {
        offset.y *= -1;
      }

      return (
        '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" ' +
          'x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" ' + '>\n' +
          '\t<feGaussianBlur in="SourceAlpha" stdDeviation="' +
            toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n' +
          '\t<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) +
          '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n' +
          '\t<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n' +
          '\t<feComposite in2="oBlur" operator="in" />\n' +
          '\t<feMerge>\n' +
            '\t\t<feMergeNode></feMergeNode>\n' +
            '\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n' +
          '\t</feMerge>\n' +
        '</filter>\n');
    },
    /* _TO_SVG_END_ */

    /**
     * Returns object representation of a shadow
     * @return {Object} Object representation of a shadow instance
     */
    toObject: function() {
      if (this.includeDefaultValues) {
        return {
          color: this.color,
          blur: this.blur,
          offsetX: this.offsetX,
          offsetY: this.offsetY,
          affectStroke: this.affectStroke,
          nonScaling: this.nonScaling
        };
      }
      var obj = { }, proto = fabric.Shadow.prototype;

      ['color', 'blur', 'offsetX', 'offsetY', 'affectStroke', 'nonScaling'].forEach(function(prop) {
        if (this[prop] !== proto[prop]) {
          obj[prop] = this[prop];
        }
      }, this);

      return obj;
    }
  });

  /**
   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
   * @static
   * @field
   * @memberOf fabric.Shadow
   */
  // eslint-disable-next-line max-len
  fabric.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/;

})(typeof exports !== 'undefined' ? exports : this);


(function () {

  'use strict';

  if (fabric.StaticCanvas) {
    fabric.warn('fabric.StaticCanvas is already defined.');
    return;
  }

  // aliases for faster resolution
  var extend = fabric.util.object.extend,
      getElementOffset = fabric.util.getElementOffset,
      removeFromArray = fabric.util.removeFromArray,
      toFixed = fabric.util.toFixed,
      transformPoint = fabric.util.transformPoint,
      invertTransform = fabric.util.invertTransform,
      getNodeCanvas = fabric.util.getNodeCanvas,
      createCanvasElement = fabric.util.createCanvasElement,

      CANVAS_INIT_ERROR = new Error('Could not initialize `canvas` element');

  /**
   * Static canvas class
   * @class fabric.StaticCanvas
   * @mixes fabric.Collection
   * @mixes fabric.Observable
   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
   * @see {@link fabric.StaticCanvas#initialize} for constructor definition
   * @fires before:render
   * @fires after:render
   * @fires canvas:cleared
   * @fires object:added
   * @fires object:removed
   */
  fabric.StaticCanvas = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.StaticCanvas.prototype */ {

    /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(el, options) {
      options || (options = { });
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);
      this._initStatic(el, options);
    },

    /**
     * Background color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
     * @type {(String|fabric.Pattern)}
     * @default
     */
    backgroundColor: '',

    /**
     * Background image of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setBackgroundImage}.
     * <b>Backwards incompatibility note:</b> The "backgroundImageOpacity"
     * and "backgroundImageStretch" properties are deprecated since 1.3.9.
     * Use {@link fabric.Image#opacity}, {@link fabric.Image#width} and {@link fabric.Image#height}.
     * since 2.4.0 image caching is active, please when putting an image as background, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */
    backgroundImage: null,

    /**
     * Overlay color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
     * @since 1.3.9
     * @type {(String|fabric.Pattern)}
     * @default
     */
    overlayColor: '',

    /**
     * Overlay image of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setOverlayImage}.
     * <b>Backwards incompatibility note:</b> The "overlayImageLeft"
     * and "overlayImageTop" properties are deprecated since 1.3.9.
     * Use {@link fabric.Image#left} and {@link fabric.Image#top}.
     * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */
    overlayImage: null,

    /**
     * Indicates whether toObject/toDatalessObject should include default values
     * if set to false, takes precedence over the object value.
     * @type Boolean
     * @default
     */
    includeDefaultValues: true,

    /**
     * Indicates whether objects' state should be saved
     * @type Boolean
     * @default
     */
    stateful: false,

    /**
     * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
     * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
     * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
     * since the renders are quequed and executed one per frame.
     * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
     * Left default to true to do not break documentation and old app, fiddles.
     * @type Boolean
     * @default
     */
    renderOnAddRemove: true,

    /**
     * Function that determines clipping of entire canvas area
     * Being passed context as first argument.
     * If you are using code minification, ctx argument can be minified/manglied you should use
     * as a workaround `var ctx = arguments[0];` in the function;
     * See clipping canvas area in {@link https://github.com/kangax/fabric.js/wiki/FAQ}
     * @deprecated since 2.0.0
     * @type Function
     * @default
     */
    clipTo: null,

    /**
     * Indicates whether object controls (borders/controls) are rendered above overlay image
     * @type Boolean
     * @default
     */
    controlsAboveOverlay: false,

    /**
     * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
     * @type Boolean
     * @default
     */
    allowTouchScrolling: false,

    /**
     * Indicates whether this canvas will use image smoothing, this is on by default in browsers
     * @type Boolean
     * @default
     */
    imageSmoothingEnabled: true,

    /**
     * The transformation (in the format of Canvas transform) which focuses the viewport
     * @type Array
     * @default
     */
    viewportTransform: fabric.iMatrix.concat(),

    /**
     * if set to false background image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    backgroundVpt: true,

    /**
     * if set to false overlya image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    overlayVpt: true,

    /**
     * Callback; invoked right before object is about to be scaled/rotated
     * @deprecated since 2.3.0
     * Use before:transform event
     */
    onBeforeScaleRotate: function () {
      /* NOOP */
    },

    /**
     * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
     * @type Boolean
     * @default
     */
    enableRetinaScaling: true,

    /**
     * Describe canvas element extension over design
     * properties are tl,tr,bl,br.
     * if canvas is not zoomed/panned those points are the four corner of canvas
     * if canvas is viewportTransformed you those points indicate the extension
     * of canvas element in plain untrasformed coordinates
     * The coordinates get updated with @method calcViewportBoundaries.
     * @memberOf fabric.StaticCanvas.prototype
     */
    vptCoords: { },

    /**
     * Based on vptCoords and object.aCoords, skip rendering of objects that
     * are not included in current viewport.
     * May greatly help in applications with crowded canvas and use of zoom/pan
     * If One of the corner of the bounding box of the object is on the canvas
     * the objects get rendered.
     * @memberOf fabric.StaticCanvas.prototype
     * @type Boolean
     * @default
     */
    skipOffscreen: true,

    /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the canvas has rendered, and the context is placed in the
     * top left corner of the canvas.
     * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
     * @type fabric.Object
     */
    clipPath: undefined,

    /**
     * @private
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     */
    _initStatic: function(el, options) {
      var cb = this.requestRenderAllBound;
      this._objects = [];
      this._createLowerCanvas(el);
      this._initOptions(options);
      this._setImageSmoothing();
      // only initialize retina scaling once
      if (!this.interactive) {
        this._initRetinaScaling();
      }

      if (options.overlayImage) {
        this.setOverlayImage(options.overlayImage, cb);
      }
      if (options.backgroundImage) {
        this.setBackgroundImage(options.backgroundImage, cb);
      }
      if (options.backgroundColor) {
        this.setBackgroundColor(options.backgroundColor, cb);
      }
      if (options.overlayColor) {
        this.setOverlayColor(options.overlayColor, cb);
      }
      this.calcOffset();
    },

    /**
     * @private
     */
    _isRetinaScaling: function() {
      return (fabric.devicePixelRatio !== 1 && this.enableRetinaScaling);
    },

    /**
     * @private
     * @return {Number} retinaScaling if applied, otherwise 1;
     */
    getRetinaScaling: function() {
      return this._isRetinaScaling() ? fabric.devicePixelRatio : 1;
    },

    /**
     * @private
     */
    _initRetinaScaling: function() {
      if (!this._isRetinaScaling()) {
        return;
      }
      var scaleRatio = fabric.devicePixelRatio;
      this.__initRetinaScaling(scaleRatio, this.lowerCanvasEl, this.contextContainer);
      if (this.upperCanvasEl) {
        this.__initRetinaScaling(scaleRatio, this.upperCanvasEl, this.contextTop);
      }
    },

    __initRetinaScaling: function(scaleRatio, canvas, context) {
      canvas.setAttribute('width', this.width * scaleRatio);
      canvas.setAttribute('height', this.height * scaleRatio);
      context.scale(scaleRatio, scaleRatio);
    },


    /**
     * Calculates canvas element offset relative to the document
     * This method is also attached as "resize" event handler of window
     * @return {fabric.Canvas} instance
     * @chainable
     */
    calcOffset: function () {
      this._offset = getElementOffset(this.lowerCanvasEl);
      return this;
    },

    /**
     * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
     * @param {Function} callback callback to invoke when image is loaded and set as an overlay
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
     * @example <caption>Normal overlayImage with left/top = 0</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage with different properties</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage loaded from cross-origin</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */
    setOverlayImage: function (image, callback, options) {
      return this.__setBgOverlayImage('overlayImage', image, callback, options);
    },

    /**
     * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
     * @param {Function} callback Callback to invoke when image is loaded and set as background
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
     * @example <caption>Normal backgroundImage with left/top = 0</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage with different properties</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage loaded from cross-origin</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */
    // TODO: fix stretched examples
    setBackgroundImage: function (image, callback, options) {
      return this.__setBgOverlayImage('backgroundImage', image, callback, options);
    },

    /**
     * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
     * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
     * @param {Function} callback Callback to invoke when foreground color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
     * @example <caption>Normal overlayColor - color value</caption>
     * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */
    setOverlayColor: function(overlayColor, callback) {
      return this.__setBgOverlayColor('overlayColor', overlayColor, callback);
    },

    /**
     * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
     * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
     * @param {Function} callback Callback to invoke when background color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
     * @example <caption>Normal backgroundColor - color value</caption>
     * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */
    setBackgroundColor: function(backgroundColor, callback) {
      return this.__setBgOverlayColor('backgroundColor', backgroundColor, callback);
    },

    /**
     * @private
     * @see {@link http://www.whatwg.org/specs/web-apps/current-work/multipage/the-canvas-element.html#dom-context-2d-imagesmoothingenabled|WhatWG Canvas Standard}
     */
    _setImageSmoothing: function() {
      var ctx = this.getContext();

      ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled
        || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
      ctx.imageSmoothingEnabled = this.imageSmoothingEnabled;
    },

    /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
     * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
     * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
     * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
     */
    __setBgOverlayImage: function(property, image, callback, options) {
      if (typeof image === 'string') {
        fabric.util.loadImage(image, function(img) {
          if (img) {
            var instance = new fabric.Image(img, options);
            this[property] = instance;
            instance.canvas = this;
          }
          callback && callback(img);
        }, this, options && options.crossOrigin);
      }
      else {
        options && image.setOptions(options);
        this[property] = image;
        image && (image.canvas = this);
        callback && callback(image);
      }

      return this;
    },

    /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
     * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
     * @param {(Object|String|null)} color Object with pattern information, color value or null
     * @param {Function} [callback] Callback is invoked when color is set
     */
    __setBgOverlayColor: function(property, color, callback) {
      this[property] = color;
      this._initGradient(color, property);
      this._initPattern(color, property, callback);
      return this;
    },

    /**
     * @private
     */
    _createCanvasElement: function() {
      var element = createCanvasElement();
      if (!element) {
        throw CANVAS_INIT_ERROR;
      }
      if (!element.style) {
        element.style = { };
      }
      if (typeof element.getContext === 'undefined') {
        throw CANVAS_INIT_ERROR;
      }
      return element;
    },

    /**
     * @private
     * @param {Object} [options] Options object
     */
    _initOptions: function (options) {
      var lowerCanvasEl = this.lowerCanvasEl;
      this._setOptions(options);

      this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
      this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;

      if (!this.lowerCanvasEl.style) {
        return;
      }

      lowerCanvasEl.width = this.width;
      lowerCanvasEl.height = this.height;

      lowerCanvasEl.style.width = this.width + 'px';
      lowerCanvasEl.style.height = this.height + 'px';

      this.viewportTransform = this.viewportTransform.slice();
    },

    /**
     * Creates a bottom canvas
     * @private
     * @param {HTMLElement} [canvasEl]
     */
    _createLowerCanvas: function (canvasEl) {
      // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
      if (canvasEl && canvasEl.getContext) {
        this.lowerCanvasEl = canvasEl;
      }
      else {
        this.lowerCanvasEl = fabric.util.getById(canvasEl) || this._createCanvasElement();
      }

      fabric.util.addClass(this.lowerCanvasEl, 'lower-canvas');

      if (this.interactive) {
        this._applyCanvasStyle(this.lowerCanvasEl);
      }

      this.contextContainer = this.lowerCanvasEl.getContext('2d');
    },

    /**
     * Returns canvas width (in px)
     * @return {Number}
     */
    getWidth: function () {
      return this.width;
    },

    /**
     * Returns canvas height (in px)
     * @return {Number}
     */
    getHeight: function () {
      return this.height;
    },

    /**
     * Sets width of this canvas instance
     * @param {Number|String} value                         Value to set width to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setWidth: function (value, options) {
      return this.setDimensions({ width: value }, options);
    },

    /**
     * Sets height of this canvas instance
     * @param {Number|String} value                         Value to set height to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setHeight: function (value, options) {
      return this.setDimensions({ height: value }, options);
    },

    /**
     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
     * @param {Object}        dimensions                    Object with width/height properties
     * @param {Number|String} [dimensions.width]            Width of canvas element
     * @param {Number|String} [dimensions.height]           Height of canvas element
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    setDimensions: function (dimensions, options) {
      var cssValue;

      options = options || {};

      for (var prop in dimensions) {
        cssValue = dimensions[prop];

        if (!options.cssOnly) {
          this._setBackstoreDimension(prop, dimensions[prop]);
          cssValue += 'px';
          this.hasLostContext = true;
        }

        if (!options.backstoreOnly) {
          this._setCssDimension(prop, cssValue);
        }
      }
      if (this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles();
      }
      this._initRetinaScaling();
      this._setImageSmoothing();
      this.calcOffset();

      if (!options.cssOnly) {
        this.requestRenderAll();
      }

      return this;
    },

    /**
     * Helper for setting width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {Number} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    _setBackstoreDimension: function (prop, value) {
      this.lowerCanvasEl[prop] = value;

      if (this.upperCanvasEl) {
        this.upperCanvasEl[prop] = value;
      }

      if (this.cacheCanvasEl) {
        this.cacheCanvasEl[prop] = value;
      }

      this[prop] = value;

      return this;
    },

    /**
     * Helper for setting css width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {String} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    _setCssDimension: function (prop, value) {
      this.lowerCanvasEl.style[prop] = value;

      if (this.upperCanvasEl) {
        this.upperCanvasEl.style[prop] = value;
      }

      if (this.wrapperEl) {
        this.wrapperEl.style[prop] = value;
      }

      return this;
    },

    /**
     * Returns canvas zoom level
     * @return {Number}
     */
    getZoom: function () {
      return this.viewportTransform[0];
    },

    /**
     * Sets viewport transform of this canvas instance
     * @param {Array} vpt the transform in the form of context.transform
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setViewportTransform: function (vpt) {
      var activeObject = this._activeObject, object, ignoreVpt = false, skipAbsolute = true, i, len;
      this.viewportTransform = vpt;
      for (i = 0, len = this._objects.length; i < len; i++) {
        object = this._objects[i];
        object.group || object.setCoords(ignoreVpt, skipAbsolute);
      }
      if (activeObject && activeObject.type === 'activeSelection') {
        activeObject.setCoords(ignoreVpt, skipAbsolute);
      }
      this.calcViewportBoundaries();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Sets zoom level of this canvas instance, zoom centered around point
     * @param {fabric.Point} point to zoom with respect to
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    zoomToPoint: function (point, value) {
      // TODO: just change the scale, preserve other transformations
      var before = point, vpt = this.viewportTransform.slice(0);
      point = transformPoint(point, invertTransform(this.viewportTransform));
      vpt[0] = value;
      vpt[3] = value;
      var after = transformPoint(point, vpt);
      vpt[4] += before.x - after.x;
      vpt[5] += before.y - after.y;
      return this.setViewportTransform(vpt);
    },

    /**
     * Sets zoom level of this canvas instance
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setZoom: function (value) {
      this.zoomToPoint(new fabric.Point(0, 0), value);
      return this;
    },

    /**
     * Pan viewport so as to place point at top left corner of canvas
     * @param {fabric.Point} point to move to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    absolutePan: function (point) {
      var vpt = this.viewportTransform.slice(0);
      vpt[4] = -point.x;
      vpt[5] = -point.y;
      return this.setViewportTransform(vpt);
    },

    /**
     * Pans viewpoint relatively
     * @param {fabric.Point} point (position vector) to move by
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    relativePan: function (point) {
      return this.absolutePan(new fabric.Point(
        -point.x - this.viewportTransform[4],
        -point.y - this.viewportTransform[5]
      ));
    },

    /**
     * Returns &lt;canvas> element corresponding to this instance
     * @return {HTMLCanvasElement}
     */
    getElement: function () {
      return this.lowerCanvasEl;
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was added
     */
    _onObjectAdded: function(obj) {
      this.stateful && obj.setupState();
      obj._set('canvas', this);
      obj.setCoords();
      this.fire('object:added', { target: obj });
      obj.fire('added');
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */
    _onObjectRemoved: function(obj) {
      this.fire('object:removed', { target: obj });
      obj.fire('removed');
      delete obj.canvas;
    },

    /**
     * Clears specified context of canvas element
     * @param {CanvasRenderingContext2D} ctx Context to clear
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clearContext: function(ctx) {
      ctx.clearRect(0, 0, this.width, this.height);
      return this;
    },

    /**
     * Returns context of canvas where objects are drawn
     * @return {CanvasRenderingContext2D}
     */
    getContext: function () {
      return this.contextContainer;
    },

    /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clear: function () {
      this._objects.length = 0;
      this.backgroundImage = null;
      this.overlayImage = null;
      this.backgroundColor = '';
      this.overlayColor = '';
      if (this._hasITextHandlers) {
        this.off('mouse:up', this._mouseUpITextHandler);
        this._iTextInstances = null;
        this._hasITextHandlers = false;
      }
      this.clearContext(this.contextContainer);
      this.fire('canvas:cleared');
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Renders the canvas
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAll: function () {
      var canvasToDrawOn = this.contextContainer;
      this.renderCanvas(canvasToDrawOn, this._objects);
      return this;
    },

    /**
     * Function created to be instance bound at initialization
     * used in requestAnimationFrame rendering
     * Let the fabricJS call it. If you call it manually you could have more
     * animationFrame stacking on to of each other
     * for an imperative rendering, use canvas.renderAll
     * @private
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAndReset: function() {
      this.isRendering = 0;
      this.renderAll();
    },

    /**
     * Append a renderAll request to next animation frame.
     * unless one is already in progress, in that case nothing is done
     * a boolean flag will avoid appending more.
     * @return {fabric.Canvas} instance
     * @chainable
     */
    requestRenderAll: function () {
      if (!this.isRendering) {
        this.isRendering = fabric.util.requestAnimFrame(this.renderAndResetBound);
      }
      return this;
    },

    /**
     * Calculate the position of the 4 corner of canvas with current viewportTransform.
     * helps to determinate when an object is in the current rendering viewport using
     * object absolute coordinates ( aCoords )
     * @return {Object} points.tl
     * @chainable
     */
    calcViewportBoundaries: function() {
      var points = { }, width = this.width, height = this.height,
          iVpt = invertTransform(this.viewportTransform);
      points.tl = transformPoint({ x: 0, y: 0 }, iVpt);
      points.br = transformPoint({ x: width, y: height }, iVpt);
      points.tr = new fabric.Point(points.br.x, points.tl.y);
      points.bl = new fabric.Point(points.tl.x, points.br.y);
      this.vptCoords = points;
      return points;
    },

    cancelRequestedRender: function() {
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }
    },

    /**
     * Renders background, objects, overlay and controls.
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} objects to render
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderCanvas: function(ctx, objects) {
      var v = this.viewportTransform, path = this.clipPath;
      this.cancelRequestedRender();
      this.calcViewportBoundaries();
      this.clearContext(ctx);
      this.fire('before:render', { ctx: ctx, });
      if (this.clipTo) {
        fabric.util.clipContext(this, ctx);
      }
      this._renderBackground(ctx);

      ctx.save();
      //apply viewport transform once for all rendering process
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      this._renderObjects(ctx, objects);
      ctx.restore();
      if (!this.controlsAboveOverlay && this.interactive) {
        this.drawControls(ctx);
      }
      if (this.clipTo) {
        ctx.restore();
      }
      if (path) {
        path.canvas = this;
        // needed to setup a couple of variables
        path.shouldCache();
        path._transformDone = true;
        path.renderCache({ forClipping: true });
        this.drawClipPathOnCanvas(ctx);
      }
      this._renderOverlay(ctx);
      if (this.controlsAboveOverlay && this.interactive) {
        this.drawControls(ctx);
      }
      this.fire('after:render', { ctx: ctx, });
    },

    /**
     * Paint the cached clipPath on the lowerCanvasEl
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawClipPathOnCanvas: function(ctx) {
      var v = this.viewportTransform, path = this.clipPath;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4;
      ctx.globalCompositeOperation = 'destination-in';
      path.transform(ctx);
      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} objects to render
     */
    _renderObjects: function(ctx, objects) {
      var i, len;
      for (i = 0, len = objects.length; i < len; ++i) {
        objects[i] && objects[i].render(ctx);
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {string} property 'background' or 'overlay'
     */
    _renderBackgroundOrOverlay: function(ctx, property) {
      var fill = this[property + 'Color'], object = this[property + 'Image'],
          v = this.viewportTransform, needsVpt = this[property + 'Vpt'];
      if (!fill && !object) {
        return;
      }
      if (fill) {
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.width, 0);
        ctx.lineTo(this.width, this.height);
        ctx.lineTo(0, this.height);
        ctx.closePath();
        ctx.fillStyle = fill.toLive
          ? fill.toLive(ctx, this)
          : fill;
        if (needsVpt) {
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        }
        ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
        var m = fill.gradientTransform || fill.patternTransform;
        m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        ctx.fill();
        ctx.restore();
      }
      if (object) {
        ctx.save();
        if (needsVpt) {
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        }
        object.render(ctx);
        ctx.restore();
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground: function(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'background');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderOverlay: function(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'overlay');
    },

    /**
     * Returns coordinates of a center of canvas.
     * Returned value is an object with top and left properties
     * @return {Object} object with "top" and "left" number values
     */
    getCenter: function () {
      return {
        top: this.height / 2,
        left: this.width / 2
      };
    },

    /**
     * Centers object horizontally in the canvas
     * @param {fabric.Object} object Object to center horizontally
     * @return {fabric.Canvas} thisArg
     */
    centerObjectH: function (object) {
      return this._centerObject(object, new fabric.Point(this.getCenter().left, object.getCenterPoint().y));
    },

    /**
     * Centers object vertically in the canvas
     * @param {fabric.Object} object Object to center vertically
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    centerObjectV: function (object) {
      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, this.getCenter().top));
    },

    /**
     * Centers object vertically and horizontally in the canvas
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    centerObject: function(object) {
      var center = this.getCenter();

      return this._centerObject(object, new fabric.Point(center.left, center.top));
    },

    /**
     * Centers object vertically and horizontally in the viewport
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObject: function(object) {
      var vpCenter = this.getVpCenter();

      return this._centerObject(object, vpCenter);
    },

    /**
     * Centers object horizontally in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObjectH: function(object) {
      var vpCenter = this.getVpCenter();
      this._centerObject(object, new fabric.Point(vpCenter.x, object.getCenterPoint().y));
      return this;
    },

    /**
     * Centers object Vertically in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObjectV: function(object) {
      var vpCenter = this.getVpCenter();

      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, vpCenter.y));
    },

    /**
     * Calculate the point in canvas that correspond to the center of actual viewport.
     * @return {fabric.Point} vpCenter, viewport center
     * @chainable
     */
    getVpCenter: function() {
      var center = this.getCenter(),
          iVpt = invertTransform(this.viewportTransform);
      return transformPoint({ x: center.left, y: center.top }, iVpt);
    },

    /**
     * @private
     * @param {fabric.Object} object Object to center
     * @param {fabric.Point} center Center point
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    _centerObject: function(object, center) {
      object.setPositionByOrigin(center, 'center', 'center');
      object.setCoords();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Returs dataless JSON representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {String} json string
     */
    toDatalessJSON: function (propertiesToInclude) {
      return this.toDatalessObject(propertiesToInclude);
    },

    /**
     * Returns object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function (propertiesToInclude) {
      return this._toObjectMethod('toObject', propertiesToInclude);
    },

    /**
     * Returns dataless object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function (propertiesToInclude) {
      return this._toObjectMethod('toDatalessObject', propertiesToInclude);
    },

    /**
     * @private
     */
    _toObjectMethod: function (methodName, propertiesToInclude) {

      var clipPath = this.clipPath, data = {
        version: fabric.version,
        objects: this._toObjects(methodName, propertiesToInclude),
      };
      if (clipPath) {
        data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
      }
      extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));

      fabric.util.populateWithProperties(this, data, propertiesToInclude);

      return data;
    },

    /**
     * @private
     */
    _toObjects: function(methodName, propertiesToInclude) {
      return this._objects.filter(function(object) {
        return !object.excludeFromExport;
      }).map(function(instance) {
        return this._toObject(instance, methodName, propertiesToInclude);
      }, this);
    },

    /**
     * @private
     */
    _toObject: function(instance, methodName, propertiesToInclude) {
      var originalValue;

      if (!this.includeDefaultValues) {
        originalValue = instance.includeDefaultValues;
        instance.includeDefaultValues = false;
      }

      var object = instance[methodName](propertiesToInclude);
      if (!this.includeDefaultValues) {
        instance.includeDefaultValues = originalValue;
      }
      return object;
    },

    /**
     * @private
     */
    __serializeBgOverlay: function(methodName, propertiesToInclude) {
      var data = { }, bgImage = this.backgroundImage, overlay = this.overlayImage;

      if (this.backgroundColor) {
        data.background = this.backgroundColor.toObject
          ? this.backgroundColor.toObject(propertiesToInclude)
          : this.backgroundColor;
      }

      if (this.overlayColor) {
        data.overlay = this.overlayColor.toObject
          ? this.overlayColor.toObject(propertiesToInclude)
          : this.overlayColor;
      }
      if (bgImage && !bgImage.excludeFromExport) {
        data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
      }
      if (overlay && !overlay.excludeFromExport) {
        data.overlayImage = this._toObject(overlay, methodName, propertiesToInclude);
      }

      return data;
    },

    /* _TO_SVG_START_ */
    /**
     * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
     * a zoomed canvas will then produce zoomed SVG output.
     * @type Boolean
     * @default
     */
    svgViewportTransformation: true,

    /**
     * Returns SVG representation of canvas
     * @function
     * @param {Object} [options] Options object for SVG output
     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
     * @param {Object} [options.viewBox] SVG viewbox object
     * @param {Number} [options.viewBox.x] x-cooridnate of viewbox
     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
     * @param {Number} [options.viewBox.width] Width of viewbox
     * @param {Number} [options.viewBox.height] Height of viewbox
     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
     * @param {String} [options.width] desired width of svg with or without units
     * @param {String} [options.height] desired height of svg with or without units
     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
     * @return {String} SVG string
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
     * @example <caption>Normal SVG output</caption>
     * var svg = canvas.toSVG();
     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
     * var svg = canvas.toSVG({suppressPreamble: true});
     * @example <caption>SVG output with viewBox attribute</caption>
     * var svg = canvas.toSVG({
     *   viewBox: {
     *     x: 100,
     *     y: 100,
     *     width: 200,
     *     height: 300
     *   }
     * });
     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
     * @example <caption>Modify SVG output with reviver function</caption>
     * var svg = canvas.toSVG(null, function(svg) {
     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
     * });
     */
    toSVG: function(options, reviver) {
      options || (options = { });
      options.reviver = reviver;
      var markup = [];

      this._setSVGPreamble(markup, options);
      this._setSVGHeader(markup, options);
      if (this.clipPath) {
        markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
      }
      this._setSVGBgOverlayColor(markup, 'background');
      this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);
      this._setSVGObjects(markup, reviver);
      if (this.clipPath) {
        markup.push('</g>\n');
      }
      this._setSVGBgOverlayColor(markup, 'overlay');
      this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);

      markup.push('</svg>');

      return markup.join('');
    },

    /**
     * @private
     */
    _setSVGPreamble: function(markup, options) {
      if (options.suppressPreamble) {
        return;
      }
      markup.push(
        '<?xml version="1.0" encoding="', (options.encoding || 'UTF-8'), '" standalone="no" ?>\n',
        '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ',
        '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n'
      );
    },

    /**
     * @private
     */
    _setSVGHeader: function(markup, options) {
      var width = options.width || this.width,
          height = options.height || this.height,
          vpt, viewBox = 'viewBox="0 0 ' + this.width + ' ' + this.height + '" ',
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

      if (options.viewBox) {
        viewBox = 'viewBox="' +
                options.viewBox.x + ' ' +
                options.viewBox.y + ' ' +
                options.viewBox.width + ' ' +
                options.viewBox.height + '" ';
      }
      else {
        if (this.svgViewportTransformation) {
          vpt = this.viewportTransform;
          viewBox = 'viewBox="' +
                  toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
                  toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + ' ' +
                  toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
                  toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
        }
      }

      markup.push(
        '<svg ',
        'xmlns="http://www.w3.org/2000/svg" ',
        'xmlns:xlink="http://www.w3.org/1999/xlink" ',
        'version="1.1" ',
        'width="', width, '" ',
        'height="', height, '" ',
        viewBox,
        'xml:space="preserve">\n',
        '<desc>Created with Fabric.js ', fabric.version, '</desc>\n',
        '<defs>\n',
        this.createSVGFontFacesMarkup(),
        this.createSVGRefElementsMarkup(),
        this.createSVGClipPathMarkup(options),
        '</defs>\n'
      );
    },

    createSVGClipPathMarkup: function(options) {
      var clipPath = this.clipPath;
      if (clipPath) {
        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
        return  '<clipPath id="' + clipPath.clipPathId + '" >\n' +
          this.clipPath.toClipPathSVG(options.reviver) +
          '</clipPath>\n';
      }
      return '';
    },

    /**
     * Creates markup containing SVG referenced elements like patterns, gradients etc.
     * @return {String}
     */
    createSVGRefElementsMarkup: function() {
      var _this = this,
          markup = ['background', 'overlay'].map(function(prop) {
            var fill = _this[prop + 'Color'];
            if (fill && fill.toLive) {
              var shouldTransform = _this[prop + 'Vpt'], vpt = _this.viewportTransform,
                  object = {
                    width: _this.width / (shouldTransform ? vpt[0] : 1),
                    height: _this.height / (shouldTransform ? vpt[3] : 1)
                  };
              return fill.toSVG(
                object,
                { additionalTransform: shouldTransform ? fabric.util.matrixToSVG(vpt) : '' }
              );
            }
          });
      return markup.join('');
    },

    /**
     * Creates markup containing SVG font faces,
     * font URLs for font faces must be collected by developers
     * and are not extracted from the DOM by fabricjs
     * @param {Array} objects Array of fabric objects
     * @return {String}
     */
    createSVGFontFacesMarkup: function() {
      var markup = '', fontList = { }, obj, fontFamily,
          style, row, rowIndex, _char, charIndex, i, len,
          fontPaths = fabric.fontPaths, objects = [];

      this._objects.forEach(function add(object) {
        objects.push(object);
        if (object._objects) {
          object._objects.forEach(add);
        }
      });

      for (i = 0, len = objects.length; i < len; i++) {
        obj = objects[i];
        fontFamily = obj.fontFamily;
        if (obj.type.indexOf('text') === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) {
          continue;
        }
        fontList[fontFamily] = true;
        if (!obj.styles) {
          continue;
        }
        style = obj.styles;
        for (rowIndex in style) {
          row = style[rowIndex];
          for (charIndex in row) {
            _char = row[charIndex];
            fontFamily = _char.fontFamily;
            if (!fontList[fontFamily] && fontPaths[fontFamily]) {
              fontList[fontFamily] = true;
            }
          }
        }
      }

      for (var j in fontList) {
        markup += [
          '\t\t@font-face {\n',
          '\t\t\tfont-family: \'', j, '\';\n',
          '\t\t\tsrc: url(\'', fontPaths[j], '\');\n',
          '\t\t}\n'
        ].join('');
      }

      if (markup) {
        markup = [
          '\t<style type="text/css">',
          '<![CDATA[\n',
          markup,
          ']]>',
          '</style>\n'
        ].join('');
      }

      return markup;
    },

    /**
     * @private
     */
    _setSVGObjects: function(markup, reviver) {
      var instance, i, len, objects = this._objects;
      for (i = 0, len = objects.length; i < len; i++) {
        instance = objects[i];
        if (instance.excludeFromExport) {
          continue;
        }
        this._setSVGObject(markup, instance, reviver);
      }
    },

    /**
     * @private
     */
    _setSVGObject: function(markup, instance, reviver) {
      markup.push(instance.toSVG(reviver));
    },

    /**
     * @private
     */
    _setSVGBgOverlayImage: function(markup, property, reviver) {
      if (this[property] && !this[property].excludeFromExport && this[property].toSVG) {
        markup.push(this[property].toSVG(reviver));
      }
    },

    /**
     * @private
     */
    _setSVGBgOverlayColor: function(markup, property) {
      var filler = this[property + 'Color'], vpt = this.viewportTransform, finalWidth = this.width,
          finalHeight = this.height;
      if (!filler) {
        return;
      }
      if (filler.toLive) {
        var repeat = filler.repeat, iVpt = fabric.util.invertTransform(vpt), shouldInvert = this[property + 'Vpt'],
            additionalTransform = shouldInvert ? fabric.util.matrixToSVG(iVpt) : '';
        markup.push(
          '<rect transform="' + additionalTransform + ' translate(', finalWidth / 2, ',', finalHeight / 2, ')"',
          ' x="', filler.offsetX - finalWidth / 2,
          '" y="', filler.offsetY - finalHeight / 2, '" ',
          'width="',
          (repeat === 'repeat-y' || repeat === 'no-repeat'
            ? filler.source.width
            : finalWidth ),
          '" height="',
          (repeat === 'repeat-x' || repeat === 'no-repeat'
            ? filler.source.height
            : finalHeight),
          '" fill="url(#SVGID_' + filler.id + ')"',
          '></rect>\n'
        );
      }
      else {
        markup.push(
          '<rect x="0" y="0" width="100%" height="100%" ',
          'fill="', filler, '"',
          '></rect>\n'
        );
      }
    },
    /* _TO_SVG_END_ */

    /**
     * Moves an object or the objects of a multiple selection
     * to the bottom of the stack of drawn objects
     * @param {fabric.Object} object Object to send to back
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    sendToBack: function (object) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, objs;
      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = objs.length; i--;) {
          obj = objs[i];
          removeFromArray(this._objects, obj);
          this._objects.unshift(obj);
        }
      }
      else {
        removeFromArray(this._objects, object);
        this._objects.unshift(object);
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Moves an object or the objects of a multiple selection
     * to the top of the stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    bringToFront: function (object) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, objs;
      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = 0; i < objs.length; i++) {
          obj = objs[i];
          removeFromArray(this._objects, obj);
          this._objects.push(obj);
        }
      }
      else {
        removeFromArray(this._objects, object);
        this._objects.push(object);
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Moves an object or a selection down in stack of drawn objects
     * An optional paramter, intersecting allowes to move the object in behind
     * the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    sendBackwards: function (object, intersecting) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, idx, newIdx, objs, objsMoved = 0;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = 0; i < objs.length; i++) {
          obj = objs[i];
          idx = this._objects.indexOf(obj);
          if (idx > 0 + objsMoved) {
            newIdx = idx - 1;
            removeFromArray(this._objects, obj);
            this._objects.splice(newIdx, 0, obj);
          }
          objsMoved++;
        }
      }
      else {
        idx = this._objects.indexOf(object);
        if (idx !== 0) {
          // if object is not on the bottom of stack
          newIdx = this._findNewLowerIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);
          this._objects.splice(newIdx, 0, object);
        }
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * @private
     */
    _findNewLowerIndex: function(object, idx, intersecting) {
      var newIdx, i;

      if (intersecting) {
        newIdx = idx;

        // traverse down the stack looking for the nearest intersecting object
        for (i = idx - 1; i >= 0; --i) {

          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
                               object.isContainedWithinObject(this._objects[i]) ||
                               this._objects[i].isContainedWithinObject(object);

          if (isIntersecting) {
            newIdx = i;
            break;
          }
        }
      }
      else {
        newIdx = idx - 1;
      }

      return newIdx;
    },

    /**
     * Moves an object or a selection up in stack of drawn objects
     * An optional paramter, intersecting allowes to move the object in front
     * of the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    bringForward: function (object, intersecting) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, idx, newIdx, objs, objsMoved = 0;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = objs.length; i--;) {
          obj = objs[i];
          idx = this._objects.indexOf(obj);
          if (idx < this._objects.length - 1 - objsMoved) {
            newIdx = idx + 1;
            removeFromArray(this._objects, obj);
            this._objects.splice(newIdx, 0, obj);
          }
          objsMoved++;
        }
      }
      else {
        idx = this._objects.indexOf(object);
        if (idx !== this._objects.length - 1) {
          // if object is not on top of stack (last item in an array)
          newIdx = this._findNewUpperIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);
          this._objects.splice(newIdx, 0, object);
        }
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * @private
     */
    _findNewUpperIndex: function(object, idx, intersecting) {
      var newIdx, i, len;

      if (intersecting) {
        newIdx = idx;

        // traverse up the stack looking for the nearest intersecting object
        for (i = idx + 1, len = this._objects.length; i < len; ++i) {

          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
                               object.isContainedWithinObject(this._objects[i]) ||
                               this._objects[i].isContainedWithinObject(object);

          if (isIntersecting) {
            newIdx = i;
            break;
          }
        }
      }
      else {
        newIdx = idx + 1;
      }

      return newIdx;
    },

    /**
     * Moves an object to specified level in stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @param {Number} index Position to move to
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    moveTo: function (object, index) {
      removeFromArray(this._objects, object);
      this._objects.splice(index, 0, object);
      return this.renderOnAddRemove && this.requestRenderAll();
    },

    /**
     * Clears a canvas element and dispose objects
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    dispose: function () {
      // cancel eventually ongoing renders
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }
      this.forEachObject(function(object) {
        object.dispose && object.dispose();
      });
      this._objects = [];
      if (this.backgroundImage && this.backgroundImage.dispose) {
        this.backgroundImage.dispose();
      }
      this.backgroundImage = null;
      if (this.overlayImage && this.overlayImage.dispose) {
        this.overlayImage.dispose();
      }
      this.overlayImage = null;
      this._iTextInstances = null;
      this.contextContainer = null;
      fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
      this.lowerCanvasEl = undefined;
      return this;
    },

    /**
     * Returns a string representation of an instance
     * @return {String} string representation of an instance
     */
    toString: function () {
      return '#<fabric.Canvas (' + this.complexity() + '): ' +
               '{ objects: ' + this._objects.length + ' }>';
    }
  });

  extend(fabric.StaticCanvas.prototype, fabric.Observable);
  extend(fabric.StaticCanvas.prototype, fabric.Collection);
  extend(fabric.StaticCanvas.prototype, fabric.DataURLExporter);

  extend(fabric.StaticCanvas, /** @lends fabric.StaticCanvas */ {

    /**
     * @static
     * @type String
     * @default
     */
    EMPTY_JSON: '{"objects": [], "background": "white"}',

    /**
     * Provides a way to check support of some of the canvas methods
     * (either those of HTMLCanvasElement itself, or rendering context)
     *
     * @param {String} methodName Method to check support for;
     *                            Could be one of "setLineDash"
     * @return {Boolean | null} `true` if method is supported (or at least exists),
     *                          `null` if canvas element or context can not be initialized
     */
    supports: function (methodName) {
      var el = createCanvasElement();

      if (!el || !el.getContext) {
        return null;
      }

      var ctx = el.getContext('2d');
      if (!ctx) {
        return null;
      }

      switch (methodName) {

        case 'setLineDash':
          return typeof ctx.setLineDash !== 'undefined';

        default:
          return null;
      }
    }
  });

  /**
   * Returns JSON representation of canvas
   * @function
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {String} JSON string
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
   * @example <caption>JSON without additional properties</caption>
   * var json = canvas.toJSON();
   * @example <caption>JSON with additional properties included</caption>
   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY', 'lockUniScaling']);
   * @example <caption>JSON without default values</caption>
   * canvas.includeDefaultValues = false;
   * var json = canvas.toJSON();
   */
  fabric.StaticCanvas.prototype.toJSON = fabric.StaticCanvas.prototype.toObject;

  if (fabric.isLikelyNode) {
    fabric.StaticCanvas.prototype.createPNGStream = function() {
      var impl = getNodeCanvas(this.lowerCanvasEl);
      return impl && impl.createPNGStream();
    };
    fabric.StaticCanvas.prototype.createJPEGStream = function(opts) {
      var impl = getNodeCanvas(this.lowerCanvasEl);
      return impl && impl.createJPEGStream(opts);
    };
  }
})();


/**
 * BaseBrush class
 * @class fabric.BaseBrush
 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
 */
fabric.BaseBrush = fabric.util.createClass(/** @lends fabric.BaseBrush.prototype */ {

  /**
   * Color of a brush
   * @type String
   * @default
   */
  color: 'rgb(0, 0, 0)',

  /**
   * Width of a brush, has to be a Number, no string literals
   * @type Number
   * @default
   */
  width: 1,

  /**
   * Shadow object representing shadow of this shape.
   * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
   * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
   * @type fabric.Shadow
   * @default
   */
  shadow: null,

  /**
   * Line endings style of a brush (one of "butt", "round", "square")
   * @type String
   * @default
   */
  strokeLineCap: 'round',

  /**
   * Corner style of a brush (one of "bevel", "round", "miter")
   * @type String
   * @default
   */
  strokeLineJoin: 'round',

  /**
   * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
   * @type Number
   * @default
   */
  strokeMiterLimit:         10,

  /**
   * Stroke Dash Array.
   * @type Array
   * @default
   */
  strokeDashArray: null,

  /**
   * Sets shadow of an object
   * @param {Object|String} [options] Options object or string (e.g. "2px 2px 10px rgba(0,0,0,0.2)")
   * @return {fabric.Object} thisArg
   * @chainable
   */
  setShadow: function(options) {
    this.shadow = new fabric.Shadow(options);
    return this;
  },

  /**
   * Sets brush styles
   * @private
   */
  _setBrushStyles: function() {
    var ctx = this.canvas.contextTop;
    ctx.strokeStyle = this.color;
    ctx.lineWidth = this.width;
    ctx.lineCap = this.strokeLineCap;
    ctx.miterLimit = this.strokeMiterLimit;
    ctx.lineJoin = this.strokeLineJoin;
    if (fabric.StaticCanvas.supports('setLineDash')) {
      ctx.setLineDash(this.strokeDashArray || []);
    }
  },

  /**
   * Sets the transformation on given context
   * @param {RenderingContext2d} ctx context to render on
   * @private
   */
  _saveAndTransform: function(ctx) {
    var v = this.canvas.viewportTransform;
    ctx.save();
    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
  },

  /**
   * Sets brush shadow styles
   * @private
   */
  _setShadow: function() {
    if (!this.shadow) {
      return;
    }

    var canvas = this.canvas,
        shadow = this.shadow,
        ctx = canvas.contextTop,
        zoom = canvas.getZoom();
    if (canvas && canvas._isRetinaScaling()) {
      zoom *= fabric.devicePixelRatio;
    }

    ctx.shadowColor = shadow.color;
    ctx.shadowBlur = shadow.blur * zoom;
    ctx.shadowOffsetX = shadow.offsetX * zoom;
    ctx.shadowOffsetY = shadow.offsetY * zoom;
  },

  needsFullRender: function() {
    var color = new fabric.Color(this.color);
    return color.getAlpha() < 1 || !!this.shadow;
  },

  /**
   * Removes brush shadow styles
   * @private
   */
  _resetShadow: function() {
    var ctx = this.canvas.contextTop;

    ctx.shadowColor = '';
    ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
  }
});


(function() {
  /**
   * PencilBrush class
   * @class fabric.PencilBrush
   * @extends fabric.BaseBrush
   */
  fabric.PencilBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.PencilBrush.prototype */ {

    /**
     * Discard points that are less than `decimate` pixel distant from each other
     * @type Number
     * @default 0.4
     */
    decimate: 0.4,

    /**
     * Constructor
     * @param {fabric.Canvas} canvas
     * @return {fabric.PencilBrush} Instance of a pencil brush
     */
    initialize: function(canvas) {
      this.canvas = canvas;
      this._points = [];
    },

    /**
     * Invoked inside on mouse down and mouse move
     * @param {Object} pointer
     */
    _drawSegment: function (ctx, p1, p2) {
      var midPoint = p1.midPointFrom(p2);
      ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
      return midPoint;
    },

    /**
     * Inovoked on mouse down
     * @param {Object} pointer
     */
    onMouseDown: function(pointer, options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return;
      }
      this._prepareForDrawing(pointer);
      // capture coordinates immediately
      // this allows to draw dots (when movement never occurs)
      this._captureDrawingPath(pointer);
      this._render();
    },

    /**
     * Inovoked on mouse move
     * @param {Object} pointer
     */
    onMouseMove: function(pointer, options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return;
      }
      if (this._captureDrawingPath(pointer) && this._points.length > 1) {
        if (this.needsFullRender()) {
          // redraw curve
          // clear top canvas
          this.canvas.clearContext(this.canvas.contextTop);
          this._render();
        }
        else {
          var points = this._points, length = points.length, ctx = this.canvas.contextTop;
          // draw the curve update
          this._saveAndTransform(ctx);
          if (this.oldEnd) {
            ctx.beginPath();
            ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
          }
          this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
          ctx.stroke();
          ctx.restore();
        }
      }
    },

    /**
     * Invoked on mouse up
     */
    onMouseUp: function(options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return true;
      }
      this.oldEnd = undefined;
      this._finalizeAndAddPath();
      return false;
    },

    /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */
    _prepareForDrawing: function(pointer) {

      var p = new fabric.Point(pointer.x, pointer.y);

      this._reset();
      this._addPoint(p);
      this.canvas.contextTop.moveTo(p.x, p.y);
    },

    /**
     * @private
     * @param {fabric.Point} point Point to be added to points array
     */
    _addPoint: function(point) {
      if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) {
        return false;
      }
      this._points.push(point);
      return true;
    },

    /**
     * Clear points array and set contextTop canvas style.
     * @private
     */
    _reset: function() {
      this._points = [];
      this._setBrushStyles();
      this._setShadow();
    },

    /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */
    _captureDrawingPath: function(pointer) {
      var pointerPoint = new fabric.Point(pointer.x, pointer.y);
      return this._addPoint(pointerPoint);
    },

    /**
     * Draw a smooth path on the topCanvas using quadraticCurveTo
     * @private
     */
    _render: function() {
      var ctx  = this.canvas.contextTop, i, len,
          p1 = this._points[0],
          p2 = this._points[1];

      this._saveAndTransform(ctx);
      ctx.beginPath();
      //if we only have 2 points in the path and they are the same
      //it means that the user only clicked the canvas without moving the mouse
      //then we should be drawing a dot. A path isn't drawn between two identical dots
      //that's why we set them apart a bit
      if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
        var width = this.width / 1000;
        p1 = new fabric.Point(p1.x, p1.y);
        p2 = new fabric.Point(p2.x, p2.y);
        p1.x -= width;
        p2.x += width;
      }
      ctx.moveTo(p1.x, p1.y);

      for (i = 1, len = this._points.length; i < len; i++) {
        // we pick the point between pi + 1 & pi + 2 as the
        // end point and p1 as our control point.
        this._drawSegment(ctx, p1, p2);
        p1 = this._points[i];
        p2 = this._points[i + 1];
      }
      // Draw last line as a straight line while
      // we wait for the next point to be able to calculate
      // the bezier control point
      ctx.lineTo(p1.x, p1.y);
      ctx.stroke();
      ctx.restore();
    },

    /**
     * Converts points to SVG path
     * @param {Array} points Array of points
     * @return {String} SVG path
     */
    convertPointsToSVGPath: function(points) {
      var path = [], i, width = this.width / 1000,
          p1 = new fabric.Point(points[0].x, points[0].y),
          p2 = new fabric.Point(points[1].x, points[1].y),
          len = points.length, multSignX = 1, multSignY = 0, manyPoints = len > 2;

      if (manyPoints) {
        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
      }
      path.push('M ', p1.x - multSignX * width, ' ', p1.y - multSignY * width, ' ');
      for (i = 1; i < len; i++) {
        if (!p1.eq(p2)) {
          var midPoint = p1.midPointFrom(p2);
          // p1 is our bezier control point
          // midpoint is our endpoint
          // start point is p(i-1) value.
          path.push('Q ', p1.x, ' ', p1.y, ' ', midPoint.x, ' ', midPoint.y, ' ');
        }
        p1 = points[i];
        if ((i + 1) < points.length) {
          p2 = points[i + 1];
        }
      }
      if (manyPoints) {
        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
      }
      path.push('L ', p1.x + multSignX * width, ' ', p1.y + multSignY * width);
      return path;
    },

    /**
     * Creates fabric.Path object to add on canvas
     * @param {String} pathData Path data
     * @return {fabric.Path} Path to add on canvas
     */
    createPath: function(pathData) {
      var path = new fabric.Path(pathData, {
        fill: null,
        stroke: this.color,
        strokeWidth: this.width,
        strokeLineCap: this.strokeLineCap,
        strokeMiterLimit: this.strokeMiterLimit,
        strokeLineJoin: this.strokeLineJoin,
        strokeDashArray: this.strokeDashArray,
      });
      if (this.shadow) {
        this.shadow.affectStroke = true;
        path.setShadow(this.shadow);
      }

      return path;
    },

    /**
     * Decimate poins array with the decimate value
     */
    decimatePoints: function(points, distance) {
      if (points.length <= 2) {
        return points;
      }
      var zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2),
          i, l = points.length - 1, lastPoint = points[0], newPoints = [lastPoint],
          cDistance;
      for (i = 1; i < l; i++) {
        cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
        if (cDistance >= adjustedDistance) {
          lastPoint = points[i];
          newPoints.push(lastPoint);
        }
      }
      if (newPoints.length === 1) {
        newPoints.push(new fabric.Point(newPoints[0].x, newPoints[0].y));
      }
      return newPoints;
    },

    /**
     * On mouseup after drawing the path on contextTop canvas
     * we use the points captured to create an new fabric path object
     * and add it to the fabric canvas.
     */
    _finalizeAndAddPath: function() {
      var ctx = this.canvas.contextTop;
      ctx.closePath();
      if (this.decimate) {
        this._points = this.decimatePoints(this._points, this.decimate);
      }
      var pathData = this.convertPointsToSVGPath(this._points).join('');
      if (pathData === 'M 0 0 Q 0 0 0 0 L 0 0') {
        // do not create 0 width/height paths, as they are
        // rendered inconsistently across browsers
        // Firefox 4, for example, renders a dot,
        // whereas Chrome 10 renders nothing
        this.canvas.requestRenderAll();
        return;
      }

      var path = this.createPath(pathData);
      this.canvas.clearContext(this.canvas.contextTop);
      this.canvas.add(path);
      this.canvas.requestRenderAll();
      path.setCoords();
      this._resetShadow();


      // fire event 'path' created
      this.canvas.fire('path:created', { path: path });
    }
  });
})();


/**
 * CircleBrush class
 * @class fabric.CircleBrush
 */
fabric.CircleBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.CircleBrush.prototype */ {

  /**
   * Width of a brush
   * @type Number
   * @default
   */
  width: 10,

  /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.CircleBrush} Instance of a circle brush
   */
  initialize: function(canvas) {
    this.canvas = canvas;
    this.points = [];
  },

  /**
   * Invoked inside on mouse down and mouse move
   * @param {Object} pointer
   */
  drawDot: function(pointer) {
    var point = this.addPoint(pointer),
        ctx = this.canvas.contextTop;
    this._saveAndTransform(ctx);
    this.dot(ctx, point);
    ctx.restore();
  },

  dot: function(ctx, point) {
    ctx.fillStyle = point.fill;
    ctx.beginPath();
    ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
    ctx.closePath();
    ctx.fill();
  },

  /**
   * Invoked on mouse down
   */
  onMouseDown: function(pointer) {
    this.points.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);
    this._setShadow();
    this.drawDot(pointer);
  },

  /**
   * Render the full state of the brush
   * @private
   */
  _render: function() {
    var ctx  = this.canvas.contextTop, i, len,
        points = this.points;
    this._saveAndTransform(ctx);
    for (i = 0, len = points.length; i < len; i++) {
      this.dot(ctx, points[i]);
    }
    ctx.restore();
  },

  /**
   * Invoked on mouse move
   * @param {Object} pointer
   */
  onMouseMove: function(pointer) {
    if (this.needsFullRender()) {
      this.canvas.clearContext(this.canvas.contextTop);
      this.addPoint(pointer);
      this._render();
    }
    else {
      this.drawDot(pointer);
    }
  },

  /**
   * Invoked on mouse up
   */
  onMouseUp: function() {
    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove, i, len;
    this.canvas.renderOnAddRemove = false;

    var circles = [];

    for (i = 0, len = this.points.length; i < len; i++) {
      var point = this.points[i],
          circle = new fabric.Circle({
            radius: point.radius,
            left: point.x,
            top: point.y,
            originX: 'center',
            originY: 'center',
            fill: point.fill
          });

      this.shadow && circle.setShadow(this.shadow);

      circles.push(circle);
    }
    var group = new fabric.Group(circles);
    group.canvas = this.canvas;

    this.canvas.add(group);
    this.canvas.fire('path:created', { path: group });

    this.canvas.clearContext(this.canvas.contextTop);
    this._resetShadow();
    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
    this.canvas.requestRenderAll();
  },

  /**
   * @param {Object} pointer
   * @return {fabric.Point} Just added pointer point
   */
  addPoint: function(pointer) {
    var pointerPoint = new fabric.Point(pointer.x, pointer.y),

        circleRadius = fabric.util.getRandomInt(
          Math.max(0, this.width - 20), this.width + 20) / 2,

        circleColor = new fabric.Color(this.color)
          .setAlpha(fabric.util.getRandomInt(0, 100) / 100)
          .toRgba();

    pointerPoint.radius = circleRadius;
    pointerPoint.fill = circleColor;

    this.points.push(pointerPoint);

    return pointerPoint;
  }
});


/**
 * SprayBrush class
 * @class fabric.SprayBrush
 */
fabric.SprayBrush = fabric.util.createClass( fabric.BaseBrush, /** @lends fabric.SprayBrush.prototype */ {

  /**
   * Width of a spray
   * @type Number
   * @default
   */
  width:              10,

  /**
   * Density of a spray (number of dots per chunk)
   * @type Number
   * @default
   */
  density:            20,

  /**
   * Width of spray dots
   * @type Number
   * @default
   */
  dotWidth:           1,

  /**
   * Width variance of spray dots
   * @type Number
   * @default
   */
  dotWidthVariance:   1,

  /**
   * Whether opacity of a dot should be random
   * @type Boolean
   * @default
   */
  randomOpacity:        false,

  /**
   * Whether overlapping dots (rectangles) should be removed (for performance reasons)
   * @type Boolean
   * @default
   */
  optimizeOverlapping:  true,

  /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.SprayBrush} Instance of a spray brush
   */
  initialize: function(canvas) {
    this.canvas = canvas;
    this.sprayChunks = [];
  },

  /**
   * Invoked on mouse down
   * @param {Object} pointer
   */
  onMouseDown: function(pointer) {
    this.sprayChunks.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);
    this._setShadow();

    this.addSprayChunk(pointer);
    this.render(this.sprayChunkPoints);
  },

  /**
   * Invoked on mouse move
   * @param {Object} pointer
   */
  onMouseMove: function(pointer) {
    this.addSprayChunk(pointer);
    this.render(this.sprayChunkPoints);
  },

  /**
   * Invoked on mouse up
   */
  onMouseUp: function() {
    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
    this.canvas.renderOnAddRemove = false;

    var rects = [];

    for (var i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
      var sprayChunk = this.sprayChunks[i];

      for (var j = 0, jlen = sprayChunk.length; j < jlen; j++) {

        var rect = new fabric.Rect({
          width: sprayChunk[j].width,
          height: sprayChunk[j].width,
          left: sprayChunk[j].x + 1,
          top: sprayChunk[j].y + 1,
          originX: 'center',
          originY: 'center',
          fill: this.color
        });
        rects.push(rect);
      }
    }

    if (this.optimizeOverlapping) {
      rects = this._getOptimizedRects(rects);
    }

    var group = new fabric.Group(rects);
    this.shadow && group.setShadow(this.shadow);
    this.canvas.add(group);
    this.canvas.fire('path:created', { path: group });

    this.canvas.clearContext(this.canvas.contextTop);
    this._resetShadow();
    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
    this.canvas.requestRenderAll();
  },

  /**
   * @private
   * @param {Array} rects
   */
  _getOptimizedRects: function(rects) {

    // avoid creating duplicate rects at the same coordinates
    var uniqueRects = { }, key, i, len;

    for (i = 0, len = rects.length; i < len; i++) {
      key = rects[i].left + '' + rects[i].top;
      if (!uniqueRects[key]) {
        uniqueRects[key] = rects[i];
      }
    }
    var uniqueRectsArray = [];
    for (key in uniqueRects) {
      uniqueRectsArray.push(uniqueRects[key]);
    }

    return uniqueRectsArray;
  },

  /**
   * Render new chunk of spray brush
   */
  render: function(sprayChunk) {
    var ctx = this.canvas.contextTop, i, len;
    ctx.fillStyle = this.color;

    this._saveAndTransform(ctx);

    for (i = 0, len = sprayChunk.length; i < len; i++) {
      var point = sprayChunk[i];
      if (typeof point.opacity !== 'undefined') {
        ctx.globalAlpha = point.opacity;
      }
      ctx.fillRect(point.x, point.y, point.width, point.width);
    }
    ctx.restore();
  },

  /**
   * Render all spray chunks
   */
  _render: function() {
    var ctx = this.canvas.contextTop, i, ilen;
    ctx.fillStyle = this.color;

    this._saveAndTransform(ctx);

    for (i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
      this.render(this.sprayChunks[i]);
    }
    ctx.restore();
  },

  /**
   * @param {Object} pointer
   */
  addSprayChunk: function(pointer) {
    this.sprayChunkPoints = [];

    var x, y, width, radius = this.width / 2, i;

    for (i = 0; i < this.density; i++) {

      x = fabric.util.getRandomInt(pointer.x - radius, pointer.x + radius);
      y = fabric.util.getRandomInt(pointer.y - radius, pointer.y + radius);

      if (this.dotWidthVariance) {
        width = fabric.util.getRandomInt(
          // bottom clamp width to 1
          Math.max(1, this.dotWidth - this.dotWidthVariance),
          this.dotWidth + this.dotWidthVariance);
      }
      else {
        width = this.dotWidth;
      }

      var point = new fabric.Point(x, y);
      point.width = width;

      if (this.randomOpacity) {
        point.opacity = fabric.util.getRandomInt(0, 100) / 100;
      }

      this.sprayChunkPoints.push(point);
    }

    this.sprayChunks.push(this.sprayChunkPoints);
  }
});


/**
 * PatternBrush class
 * @class fabric.PatternBrush
 * @extends fabric.BaseBrush
 */
fabric.PatternBrush = fabric.util.createClass(fabric.PencilBrush, /** @lends fabric.PatternBrush.prototype */ {

  getPatternSrc: function() {

    var dotWidth = 20,
        dotDistance = 5,
        patternCanvas = fabric.util.createCanvasElement(),
        patternCtx = patternCanvas.getContext('2d');

    patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;

    patternCtx.fillStyle = this.color;
    patternCtx.beginPath();
    patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
    patternCtx.closePath();
    patternCtx.fill();

    return patternCanvas;
  },

  getPatternSrcFunction: function() {
    return String(this.getPatternSrc).replace('this.color', '"' + this.color + '"');
  },

  /**
   * Creates "pattern" instance property
   */
  getPattern: function() {
    return this.canvas.contextTop.createPattern(this.source || this.getPatternSrc(), 'repeat');
  },

  /**
   * Sets brush styles
   */
  _setBrushStyles: function() {
    this.callSuper('_setBrushStyles');
    this.canvas.contextTop.strokeStyle = this.getPattern();
  },

  /**
   * Creates path
   */
  createPath: function(pathData) {
    var path = this.callSuper('createPath', pathData),
        topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);

    path.stroke = new fabric.Pattern({
      source: this.source || this.getPatternSrcFunction(),
      offsetX: -topLeft.x,
      offsetY: -topLeft.y
    });
    return path;
  }
});


(function() {

  var getPointer = fabric.util.getPointer,
      degreesToRadians = fabric.util.degreesToRadians,
      radiansToDegrees = fabric.util.radiansToDegrees,
      atan2 = Math.atan2,
      abs = Math.abs,
      supportLineDash = fabric.StaticCanvas.supports('setLineDash'),

      STROKE_OFFSET = 0.5;

  /**
   * Canvas class
   * @class fabric.Canvas
   * @extends fabric.StaticCanvas
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
   * @see {@link fabric.Canvas#initialize} for constructor definition
   *
   * @fires object:modified at the end of a transform or any change when statefull is true
   * @fires object:rotated at the end of a rotation transform
   * @fires object:scaled at the end of a scale transform
   * @fires object:moved at the end of translation transform
   * @fires object:skewed at the end of a skew transform
   * @fires object:rotating while an object is being rotated from the control
   * @fires object:scaling while an object is being scaled by controls
   * @fires object:moving while an object is being dragged
   * @fires object:skewing while an object is being skewed from the controls
   * @fires object:selected this event is deprecated. use selection:created
   *
   * @fires before:transform before a transform is is started
   * @fires before:selection:cleared
   * @fires selection:cleared
   * @fires selection:updated
   * @fires selection:created
   *
   * @fires path:created after a drawing operation ends and the path is added
   * @fires mouse:down
   * @fires mouse:move
   * @fires mouse:up
   * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
   * @fires mouse:move:before on mouse move, before the inner fabric logic runs
   * @fires mouse:up:before on mouse up, before the inner fabric logic runs
   * @fires mouse:over
   * @fires mouse:out
   * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   * @fires after:render at the end of the render process, receives the context in the callback
   * @fires before:render at start the render process, receives the context in the callback
   *
   */
  fabric.Canvas = fabric.util.createClass(fabric.StaticCanvas, /** @lends fabric.Canvas.prototype */ {

    /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(el, options) {
      options || (options = { });
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);
      this._initStatic(el, options);
      this._initInteractive();
      this._createCacheCanvas();
    },

    /**
     * When true, objects can be transformed by one side (unproportionally)
     * @type Boolean
     * @default
     */
    uniScaleTransform:      false,

    /**
     * Indicates which key enable unproportional scaling
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */
    uniScaleKey:           'shiftKey',

    /**
     * When true, objects use center point as the origin of scale transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredScaling:        false,

    /**
     * When true, objects use center point as the origin of rotate transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredRotation:       false,

    /**
     * Indicates which key enable centered Transform
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */
    centeredKey:           'altKey',

    /**
     * Indicates which key enable alternate action on corner
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */
    altActionKey:           'shiftKey',

    /**
     * Indicates that canvas is interactive. This property should not be changed.
     * @type Boolean
     * @default
     */
    interactive:            true,

    /**
     * Indicates whether group selection should be enabled
     * @type Boolean
     * @default
     */
    selection:              true,

    /**
     * Indicates which key or keys enable multiple click selection
     * Pass value as a string or array of strings
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or empty or containing any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.2
     * @type String|Array
     * @default
     */
    selectionKey:           'shiftKey',

    /**
     * Indicates which key enable alternative selection
     * in case of target overlapping with active object
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * For a series of reason that come from the general expectations on how
     * things should work, this feature works only for preserveObjectStacking true.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.5
     * @type null|String
     * @default
     */
    altSelectionKey:           null,

    /**
     * Color of selection
     * @type String
     * @default
     */
    selectionColor:         'rgba(100, 100, 255, 0.3)', // blue

    /**
     * Default dash array pattern
     * If not empty the selection border is dashed
     * @type Array
     */
    selectionDashArray:     [],

    /**
     * Color of the border of selection (usually slightly darker than color of selection itself)
     * @type String
     * @default
     */
    selectionBorderColor:   'rgba(255, 255, 255, 0.3)',

    /**
     * Width of a line used in object/group selection
     * @type Number
     * @default
     */
    selectionLineWidth:     1,

    /**
     * Select only shapes that are fully contained in the dragged selection rectangle.
     * @type Boolean
     * @default
     */
    selectionFullyContained: false,

    /**
     * Default cursor value used when hovering over an object on canvas
     * @type String
     * @default
     */
    hoverCursor:            'move',

    /**
     * Default cursor value used when moving an object on canvas
     * @type String
     * @default
     */
    moveCursor:             'move',

    /**
     * Default cursor value used for the entire canvas
     * @type String
     * @default
     */
    defaultCursor:          'default',

    /**
     * Cursor value used during free drawing
     * @type String
     * @default
     */
    freeDrawingCursor:      'crosshair',

    /**
     * Cursor value used for rotation point
     * @type String
     * @default
     */
    rotationCursor:         'crosshair',

    /**
     * Cursor value used for disabled elements ( corners with disabled action )
     * @type String
     * @since 2.0.0
     * @default
     */
    notAllowedCursor:         'not-allowed',

    /**
     * Default element class that's given to wrapper (div) element of canvas
     * @type String
     * @default
     */
    containerClass:         'canvas-container',

    /**
     * When true, object detection happens on per-pixel basis rather than on per-bounding-box
     * @type Boolean
     * @default
     */
    perPixelTargetFind:     false,

    /**
     * Number of pixels around target pixel to tolerate (consider active) during object detection
     * @type Number
     * @default
     */
    targetFindTolerance:    0,

    /**
     * When true, target detection is skipped when hovering over canvas. This can be used to improve performance.
     * @type Boolean
     * @default
     */
    skipTargetFind:         false,

    /**
     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
     * After mousedown, mousemove creates a shape,
     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
     * @type Boolean
     * @default
     */
    isDrawingMode:          false,

    /**
     * Indicates whether objects should remain in current stack position when selected.
     * When false objects are brought to top and rendered as part of the selection group
     * @type Boolean
     * @default
     */
    preserveObjectStacking: false,

    /**
     * Indicates the angle that an object will lock to while rotating.
     * @type Number
     * @since 1.6.7
     * @default
     */
    snapAngle: 0,

    /**
     * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
     * When `null`, the snapThreshold will default to the snapAngle.
     * @type null|Number
     * @since 1.6.7
     * @default
     */
    snapThreshold: null,

    /**
     * Indicates if the right click on canvas can output the context menu or not
     * @type Boolean
     * @since 1.6.5
     * @default
     */
    stopContextMenu: false,

    /**
     * Indicates if the canvas can fire right click events
     * @type Boolean
     * @since 1.6.5
     * @default
     */
    fireRightClick: false,

    /**
     * Indicates if the canvas can fire middle click events
     * @type Boolean
     * @since 1.7.8
     * @default
     */
    fireMiddleClick: false,

    /**
     * Keep track of the subTargets for Mouse Events
     * @type fabric.Object[]
     */
    targets: [],

    /**
     * Keep track of the hovered target
     * @type fabric.Object
     * @private
     */
    _hoveredTarget: null,

    /**
     * hold the list of nested targets hovered
     * @type fabric.Object[]
     * @private
     */
    _hoveredTargets: [],

    /**
     * @private
     */
    _initInteractive: function() {
      this._currentTransform = null;
      this._groupSelector = null;
      this._initWrapperElement();
      this._createUpperCanvas();
      this._initEventListeners();

      this._initRetinaScaling();

      this.freeDrawingBrush = fabric.PencilBrush && new fabric.PencilBrush(this);

      this.calcOffset();
    },

    /**
     * Divides objects in two groups, one to render immediately
     * and one to render as activeGroup.
     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
     */
    _chooseObjectsToRender: function() {
      var activeObjects = this.getActiveObjects(),
          object, objsToRender, activeGroupObjects;

      if (activeObjects.length > 0 && !this.preserveObjectStacking) {
        objsToRender = [];
        activeGroupObjects = [];
        for (var i = 0, length = this._objects.length; i < length; i++) {
          object = this._objects[i];
          if (activeObjects.indexOf(object) === -1 ) {
            objsToRender.push(object);
          }
          else {
            activeGroupObjects.push(object);
          }
        }
        if (activeObjects.length > 1) {
          this._activeObject._objects = activeGroupObjects;
        }
        objsToRender.push.apply(objsToRender, activeGroupObjects);
      }
      else {
        objsToRender = this._objects;
      }
      return objsToRender;
    },

    /**
     * Renders both the top canvas and the secondary container canvas.
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAll: function () {
      if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
        this.clearContext(this.contextTop);
        this.contextTopDirty = false;
      }
      if (this.hasLostContext) {
        this.renderTopLayer(this.contextTop);
      }
      var canvasToDrawOn = this.contextContainer;
      this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
      return this;
    },

    renderTopLayer: function(ctx) {
      ctx.save();
      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._render();
        this.contextTopDirty = true;
      }
      // we render the top context - last object
      if (this.selection && this._groupSelector) {
        this._drawSelection(ctx);
        this.contextTopDirty = true;
      }
      ctx.restore();
    },

    /**
     * Method to render only the top canvas.
     * Also used to render the group selection box.
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    renderTop: function () {
      var ctx = this.contextTop;
      this.clearContext(ctx);
      this.renderTopLayer(ctx);
      this.fire('after:render');
      return this;
    },

    /**
     * Resets the current transform to its original values and chooses the type of resizing based on the event
     * @private
     */
    _resetCurrentTransform: function() {
      var t = this._currentTransform;

      t.target.set({
        scaleX: t.original.scaleX,
        scaleY: t.original.scaleY,
        skewX: t.original.skewX,
        skewY: t.original.skewY,
        left: t.original.left,
        top: t.original.top
      });

      if (this._shouldCenterTransform(t.target)) {
        if (t.originX !== 'center') {
          if (t.originX === 'right') {
            t.mouseXSign = -1;
          }
          else {
            t.mouseXSign = 1;
          }
        }
        if (t.originY !== 'center') {
          if (t.originY === 'bottom') {
            t.mouseYSign = -1;
          }
          else {
            t.mouseYSign = 1;
          }
        }

        t.originX = 'center';
        t.originY = 'center';
      }
      else {
        t.originX = t.original.originX;
        t.originY = t.original.originY;
      }
    },

    /**
     * Checks if point is contained within an area of given object
     * @param {Event} e Event object
     * @param {fabric.Object} target Object to test against
     * @param {Object} [point] x,y object of point coordinates we want to check.
     * @return {Boolean} true if point is contained within an area of given object
     */
    containsPoint: function (e, target, point) {
      var ignoreZoom = true,
          pointer = point || this.getPointer(e, ignoreZoom),
          xy;

      if (target.group && target.group === this._activeObject && target.group.type === 'activeSelection') {
        xy = this._normalizePointer(target.group, pointer);
      }
      else {
        xy = { x: pointer.x, y: pointer.y };
      }
      // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
      // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
      return (target.containsPoint(xy) || target._findTargetCorner(pointer));
    },

    /**
     * @private
     */
    _normalizePointer: function (object, pointer) {
      var m = object.calcTransformMatrix(),
          invertedM = fabric.util.invertTransform(m),
          vptPointer = this.restorePointerVpt(pointer);
      return fabric.util.transformPoint(vptPointer, invertedM);
    },

    /**
     * Returns true if object is transparent at a certain location
     * @param {fabric.Object} target Object to check
     * @param {Number} x Left coordinate
     * @param {Number} y Top coordinate
     * @return {Boolean}
     */
    isTargetTransparent: function (target, x, y) {
      // in case the target is the activeObject, we cannot execute this optimization
      // because we need to draw controls too.
      if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
        var normalizedPointer = this._normalizePointer(target, {x: x, y: y}),
            targetRelativeX = Math.max(target.cacheTranslationX + (normalizedPointer.x * target.zoomX), 0),
            targetRelativeY = Math.max(target.cacheTranslationY + (normalizedPointer.y * target.zoomY), 0);

        var isTransparent = fabric.util.isTransparent(
          target._cacheContext, Math.round(targetRelativeX), Math.round(targetRelativeY), this.targetFindTolerance);

        return isTransparent;
      }

      var ctx = this.contextCache,
          originalColor = target.selectionBackgroundColor, v = this.viewportTransform;

      target.selectionBackgroundColor = '';

      this.clearContext(ctx);

      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      target.render(ctx);
      ctx.restore();

      target === this._activeObject && target._renderControls(ctx, {
        hasBorders: false,
        transparentCorners: false
      }, {
        hasBorders: false,
      });

      target.selectionBackgroundColor = originalColor;

      var isTransparent = fabric.util.isTransparent(
        ctx, x, y, this.targetFindTolerance);

      return isTransparent;
    },

    /**
     * takes an event and determins if selection key has been pressed
     * @private
     * @param {Event} e Event object
     */
    _isSelectionKeyPressed: function(e) {
      var selectionKeyPressed = false;

      if (Object.prototype.toString.call(this.selectionKey) === '[object Array]') {
        selectionKeyPressed = !!this.selectionKey.find(function(key) { return e[key] === true; });
      }
      else {
        selectionKeyPressed = e[this.selectionKey];
      }

      return selectionKeyPressed;
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _shouldClearSelection: function (e, target) {
      var activeObjects = this.getActiveObjects(),
          activeObject = this._activeObject;

      return (
        !target
        ||
        (target &&
          activeObject &&
          activeObjects.length > 1 &&
          activeObjects.indexOf(target) === -1 &&
          activeObject !== target &&
          !this._isSelectionKeyPressed(e))
        ||
        (target && !target.evented)
        ||
        (target &&
          !target.selectable &&
          activeObject &&
          activeObject !== target)
      );
    },

    /**
     * centeredScaling from object can't override centeredScaling from canvas.
     * this should be fixed, since object setting should take precedence over canvas.
     * @private
     * @param {fabric.Object} target
     */
    _shouldCenterTransform: function (target) {
      if (!target) {
        return;
      }

      var t = this._currentTransform,
          centerTransform;

      if (t.action === 'scale' || t.action === 'scaleX' || t.action === 'scaleY') {
        centerTransform = this.centeredScaling || target.centeredScaling;
      }
      else if (t.action === 'rotate') {
        centerTransform = this.centeredRotation || target.centeredRotation;
      }

      return centerTransform ? !t.altKey : t.altKey;
    },

    /**
     * @private
     */
    _getOriginFromCorner: function(target, corner) {
      var origin = {
        x: target.originX,
        y: target.originY
      };

      if (corner === 'ml' || corner === 'tl' || corner === 'bl') {
        origin.x = 'right';
      }
      else if (corner === 'mr' || corner === 'tr' || corner === 'br') {
        origin.x = 'left';
      }

      if (corner === 'tl' || corner === 'mt' || corner === 'tr') {
        origin.y = 'bottom';
      }
      else if (corner === 'bl' || corner === 'mb' || corner === 'br') {
        origin.y = 'top';
      }

      return origin;
    },

    /**
     * @private
     * @param {Boolean} alreadySelected true if target is already selected
     * @param {String} corner a string representing the corner ml, mr, tl ...
     * @param {Event} e Event object
     * @param {fabric.Object} [target] inserted back to help overriding. Unused
     */
    _getActionFromCorner: function(alreadySelected, corner, e /* target */) {
      if (!corner || !alreadySelected) {
        return 'drag';
      }

      switch (corner) {
        case 'mtr':
          return 'rotate';
        case 'ml':
        case 'mr':
          return e[this.altActionKey] ? 'skewY' : 'scaleX';
        case 'mt':
        case 'mb':
          return e[this.altActionKey] ? 'skewX' : 'scaleY';
        default:
          return 'scale';
      }
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _setupCurrentTransform: function (e, target, alreadySelected) {
      if (!target) {
        return;
      }

      var pointer = this.getPointer(e),
          corner = target._findTargetCorner(this.getPointer(e, true)),
          action = this._getActionFromCorner(alreadySelected, corner, e, target),
          origin = this._getOriginFromCorner(target, corner);

      this._currentTransform = {
        target: target,
        action: action,
        corner: corner,
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        // used by transation
        offsetX: pointer.x - target.left,
        offsetY: pointer.y - target.top,
        originX: origin.x,
        originY: origin.y,
        ex: pointer.x,
        ey: pointer.y,
        lastX: pointer.x,
        lastY: pointer.y,
        // unsure they are usefull anymore.
        // left: target.left,
        // top: target.top,
        theta: degreesToRadians(target.angle),
        // end of unsure
        width: target.width * target.scaleX,
        mouseXSign: 1,
        mouseYSign: 1,
        shiftKey: e.shiftKey,
        altKey: e[this.centeredKey],
        original: fabric.util.saveObjectTransform(target),
      };

      this._currentTransform.original.originX = origin.x;
      this._currentTransform.original.originY = origin.y;

      this._resetCurrentTransform();
      this._beforeTransform(e);
    },

    /**
     * Translates object by "setting" its left/top
     * @private
     * @param {Number} x pointer's x coordinate
     * @param {Number} y pointer's y coordinate
     * @return {Boolean} true if the translation occurred
     */
    _translateObject: function (x, y) {
      var transform = this._currentTransform,
          target = transform.target,
          newLeft = x - transform.offsetX,
          newTop = y - transform.offsetY,
          moveX = !target.get('lockMovementX') && target.left !== newLeft,
          moveY = !target.get('lockMovementY') && target.top !== newTop;

      moveX && target.set('left', newLeft);
      moveY && target.set('top', newTop);
      return moveX || moveY;
    },

    /**
     * Check if we are increasing a positive skew or lower it,
     * checking mouse direction and pressed corner.
     * @private
     */
    _changeSkewTransformOrigin: function(mouseMove, t, by) {
      var property = 'originX', origins = { 0: 'center' },
          skew = t.target.skewX, originA = 'left', originB = 'right',
          corner = t.corner === 'mt' || t.corner === 'ml' ? 1 : -1,
          flipSign = 1;

      mouseMove = mouseMove > 0 ? 1 : -1;
      if (by === 'y') {
        skew = t.target.skewY;
        originA = 'top';
        originB = 'bottom';
        property = 'originY';
      }
      origins[-1] = originA;
      origins[1] = originB;

      t.target.flipX && (flipSign *= -1);
      t.target.flipY && (flipSign *= -1);

      if (skew === 0) {
        t.skewSign = -corner * mouseMove * flipSign;
        t[property] = origins[-mouseMove];
      }
      else {
        skew = skew > 0 ? 1 : -1;
        t.skewSign = skew;
        t[property] = origins[skew * corner * flipSign];
      }
    },

    /**
     * Skew object by mouse events
     * @private
     * @param {Number} x pointer's x coordinate
     * @param {Number} y pointer's y coordinate
     * @param {String} by Either 'x' or 'y'
     * @return {Boolean} true if the skewing occurred
     */
    _skewObject: function (x, y, by) {
      var t = this._currentTransform,
          target = t.target, skewed = false,
          lockSkewingX = target.get('lockSkewingX'),
          lockSkewingY = target.get('lockSkewingY');

      if ((lockSkewingX && by === 'x') || (lockSkewingY && by === 'y')) {
        return false;
      }

      // Get the constraint point
      var center = target.getCenterPoint(),
          actualMouseByCenter = target.toLocalPoint(new fabric.Point(x, y), 'center', 'center')[by],
          lastMouseByCenter = target.toLocalPoint(new fabric.Point(t.lastX, t.lastY), 'center', 'center')[by],
          actualMouseByOrigin, constraintPosition, dim = target._getTransformedDimensions();

      this._changeSkewTransformOrigin(actualMouseByCenter - lastMouseByCenter, t, by);
      actualMouseByOrigin = target.toLocalPoint(new fabric.Point(x, y), t.originX, t.originY)[by];
      constraintPosition = target.translateToOriginPoint(center, t.originX, t.originY);
      // Actually skew the object
      skewed = this._setObjectSkew(actualMouseByOrigin, t, by, dim);
      t.lastX = x;
      t.lastY = y;
      // Make sure the constraints apply
      target.setPositionByOrigin(constraintPosition, t.originX, t.originY);
      return skewed;
    },

    /**
     * Set object skew
     * @private
     * @return {Boolean} true if the skewing occurred
     */
    _setObjectSkew: function(localMouse, transform, by, _dim) {
      var target = transform.target, newValue, skewed = false,
          skewSign = transform.skewSign, newDim, dimNoSkew,
          otherBy, _otherBy, _by, newDimMouse, skewX, skewY;

      if (by === 'x') {
        otherBy = 'y';
        _otherBy = 'Y';
        _by = 'X';
        skewX = 0;
        skewY = target.skewY;
      }
      else {
        otherBy = 'x';
        _otherBy = 'X';
        _by = 'Y';
        skewX = target.skewX;
        skewY = 0;
      }

      dimNoSkew = target._getTransformedDimensions(skewX, skewY);
      newDimMouse = 2 * Math.abs(localMouse) - dimNoSkew[by];
      if (newDimMouse <= 2) {
        newValue = 0;
      }
      else {
        newValue = skewSign * Math.atan((newDimMouse / target['scale' + _by]) /
                                        (dimNoSkew[otherBy] / target['scale' + _otherBy]));
        newValue = fabric.util.radiansToDegrees(newValue);
      }
      skewed = target['skew' + _by] !== newValue;
      target.set('skew' + _by, newValue);
      if (target['skew' + _otherBy] !== 0) {
        newDim = target._getTransformedDimensions();
        newValue = (_dim[otherBy] / newDim[otherBy]) * target['scale' + _otherBy];
        target.set('scale' + _otherBy, newValue);
      }
      return skewed;
    },

    /**
     * Scales object by invoking its scaleX/scaleY methods
     * @private
     * @param {Number} x pointer's x coordinate
     * @param {Number} y pointer's y coordinate
     * @param {String} by Either 'x' or 'y' - specifies dimension constraint by which to scale an object.
     *                    When not provided, an object is scaled by both dimensions equally
     * @return {Boolean} true if the scaling occurred
     */
    _scaleObject: function (x, y, by) {
      var t = this._currentTransform,
          target = t.target,
          lockScalingX = target.lockScalingX,
          lockScalingY = target.lockScalingY,
          lockScalingFlip = target.lockScalingFlip;

      if (lockScalingX && lockScalingY) {
        return false;
      }

      // Get the constraint point
      var constraintPosition = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY),
          localMouse = target.toLocalPoint(new fabric.Point(x, y), t.originX, t.originY),
          dim = target._getTransformedDimensions(), scaled = false;

      this._setLocalMouse(localMouse, t);

      // Actually scale the object
      scaled = this._setObjectScale(localMouse, t, lockScalingX, lockScalingY, by, lockScalingFlip, dim);

      // Make sure the constraints apply
      target.setPositionByOrigin(constraintPosition, t.originX, t.originY);
      return scaled;
    },

    /**
     * @private
     * @return {Boolean} true if the scaling occurred
     */
    _setObjectScale: function(localMouse, transform, lockScalingX, lockScalingY, by, lockScalingFlip, _dim) {
      var target = transform.target, forbidScalingX = false, forbidScalingY = false, scaled = false,
          scaleX = localMouse.x * target.scaleX / _dim.x,
          scaleY = localMouse.y * target.scaleY / _dim.y,
          changeX = target.scaleX !== scaleX,
          changeY = target.scaleY !== scaleY;

      transform.newScaleX = scaleX;
      transform.newScaleY = scaleY;
      if (fabric.Textbox && by === 'x' && target instanceof fabric.Textbox) {
        var w = target.width * (localMouse.x / _dim.x);
        if (w >= target.getMinWidth()) {
          scaled = w !== target.width;
          target.set('width', w);
          return scaled;
        }
        return false;
      }

      if (lockScalingFlip && scaleX <= 0 && scaleX < target.scaleX) {
        forbidScalingX = true;
        localMouse.x = 0;
      }

      if (lockScalingFlip && scaleY <= 0 && scaleY < target.scaleY) {
        forbidScalingY = true;
        localMouse.y = 0;
      }

      if (by === 'equally' && !lockScalingX && !lockScalingY) {
        scaled = this._scaleObjectEqually(localMouse, target, transform, _dim);
      }
      else if (!by) {
        forbidScalingX || lockScalingX || (target.set('scaleX', scaleX) && (scaled = scaled || changeX));
        forbidScalingY || lockScalingY || (target.set('scaleY', scaleY) && (scaled = scaled || changeY));
      }
      else if (by === 'x' && !target.get('lockUniScaling')) {
        forbidScalingX || lockScalingX || (target.set('scaleX', scaleX) && (scaled = changeX));
      }
      else if (by === 'y' && !target.get('lockUniScaling')) {
        forbidScalingY || lockScalingY || (target.set('scaleY', scaleY) && (scaled = changeY));
      }
      forbidScalingX || forbidScalingY || this._flipObject(transform, by);
      return scaled;
    },

    /**
     * @private
     * @return {Boolean} true if the scaling occurred
     */
    _scaleObjectEqually: function(localMouse, target, transform, _dim) {

      var dist = localMouse.y + localMouse.x,
          lastDist = _dim.y * transform.original.scaleY / target.scaleY +
                     _dim.x * transform.original.scaleX / target.scaleX,
          scaled, signX = localMouse.x < 0 ? -1 : 1,
          signY = localMouse.y < 0 ? -1 : 1, newScaleX, newScaleY;

      // We use transform.scaleX/Y instead of target.scaleX/Y
      // because the object may have a min scale and we'll loose the proportions
      newScaleX = signX * Math.abs(transform.original.scaleX * dist / lastDist);
      newScaleY = signY * Math.abs(transform.original.scaleY * dist / lastDist);
      scaled = newScaleX !== target.scaleX || newScaleY !== target.scaleY;
      target.set('scaleX', newScaleX);
      target.set('scaleY', newScaleY);
      return scaled;
    },

    /**
     * @private
     */
    _flipObject: function(transform, by) {
      if (transform.newScaleX < 0 && by !== 'y') {
        if (transform.originX === 'left') {
          transform.originX = 'right';
        }
        else if (transform.originX === 'right') {
          transform.originX = 'left';
        }
      }

      if (transform.newScaleY < 0 && by !== 'x') {
        if (transform.originY === 'top') {
          transform.originY = 'bottom';
        }
        else if (transform.originY === 'bottom') {
          transform.originY = 'top';
        }
      }
    },

    /**
     * @private
     */
    _setLocalMouse: function(localMouse, t) {
      var target = t.target, zoom = this.getZoom(),
          padding = target.padding / zoom;

      if (t.originX === 'right') {
        localMouse.x *= -1;
      }
      else if (t.originX === 'center') {
        localMouse.x *= t.mouseXSign * 2;
        if (localMouse.x < 0) {
          t.mouseXSign = -t.mouseXSign;
        }
      }

      if (t.originY === 'bottom') {
        localMouse.y *= -1;
      }
      else if (t.originY === 'center') {
        localMouse.y *= t.mouseYSign * 2;
        if (localMouse.y < 0) {
          t.mouseYSign = -t.mouseYSign;
        }
      }

      // adjust the mouse coordinates when dealing with padding
      if (abs(localMouse.x) > padding) {
        if (localMouse.x < 0) {
          localMouse.x += padding;
        }
        else {
          localMouse.x -= padding;
        }
      }
      else { // mouse is within the padding, set to 0
        localMouse.x = 0;
      }

      if (abs(localMouse.y) > padding) {
        if (localMouse.y < 0) {
          localMouse.y += padding;
        }
        else {
          localMouse.y -= padding;
        }
      }
      else {
        localMouse.y = 0;
      }
    },

    /**
     * Rotates object by invoking its rotate method
     * @private
     * @param {Number} x pointer's x coordinate
     * @param {Number} y pointer's y coordinate
     * @return {Boolean} true if the rotation occurred
     */
    _rotateObject: function (x, y) {

      var t = this._currentTransform,
          target = t.target, constraintPosition,
          constraintPosition = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);

      if (target.lockRotation) {
        return false;
      }

      var lastAngle = atan2(t.ey - constraintPosition.y, t.ex - constraintPosition.x),
          curAngle = atan2(y - constraintPosition.y, x - constraintPosition.x),
          angle = radiansToDegrees(curAngle - lastAngle + t.theta),
          hasRotated = true;

      if (target.snapAngle > 0) {
        var snapAngle  = target.snapAngle,
            snapThreshold  = target.snapThreshold || snapAngle,
            rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle,
            leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;

        if (Math.abs(angle - leftAngleLocked) < snapThreshold) {
          angle = leftAngleLocked;
        }
        else if (Math.abs(angle - rightAngleLocked) < snapThreshold) {
          angle = rightAngleLocked;
        }
      }

      // normalize angle to positive value
      if (angle < 0) {
        angle = 360 + angle;
      }
      angle %= 360;

      if (target.angle === angle) {
        hasRotated = false;
      }
      else {
        // rotation only happen here
        target.angle = angle;
        // Make sure the constraints apply
        target.setPositionByOrigin(constraintPosition, t.originX, t.originY);
      }

      return hasRotated;
    },

    /**
     * Set the cursor type of the canvas element
     * @param {String} value Cursor type of the canvas element.
     * @see http://www.w3.org/TR/css3-ui/#cursor
     */
    setCursor: function (value) {
      this.upperCanvasEl.style.cursor = value;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx to draw the selection on
     */
    _drawSelection: function (ctx) {
      var groupSelector = this._groupSelector,
          left = groupSelector.left,
          top = groupSelector.top,
          aleft = abs(left),
          atop = abs(top);

      if (this.selectionColor) {
        ctx.fillStyle = this.selectionColor;

        ctx.fillRect(
          groupSelector.ex - ((left > 0) ? 0 : -left),
          groupSelector.ey - ((top > 0) ? 0 : -top),
          aleft,
          atop
        );
      }

      if (!this.selectionLineWidth || !this.selectionBorderColor) {
        return;
      }
      ctx.lineWidth = this.selectionLineWidth;
      ctx.strokeStyle = this.selectionBorderColor;

      // selection border
      if (this.selectionDashArray.length > 1 && !supportLineDash) {

        var px = groupSelector.ex + STROKE_OFFSET - ((left > 0) ? 0 : aleft),
            py = groupSelector.ey + STROKE_OFFSET - ((top > 0) ? 0 : atop);

        ctx.beginPath();

        fabric.util.drawDashedLine(ctx, px, py, px + aleft, py, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px, py + atop - 1, px + aleft, py + atop - 1, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px, py, px, py + atop, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px + aleft - 1, py, px + aleft - 1, py + atop, this.selectionDashArray);

        ctx.closePath();
        ctx.stroke();
      }
      else {
        fabric.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
        ctx.strokeRect(
          groupSelector.ex + STROKE_OFFSET - ((left > 0) ? 0 : aleft),
          groupSelector.ey + STROKE_OFFSET - ((top > 0) ? 0 : atop),
          aleft,
          atop
        );
      }
    },

    /**
     * Method that determines what object we are clicking on
     * the skipGroup parameter is for internal use, is needed for shift+click action
     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
     * or the outside part of the corner.
     * @param {Event} e mouse event
     * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
     * @return {fabric.Object} the target found
     */
    findTarget: function (e, skipGroup) {
      if (this.skipTargetFind) {
        return;
      }

      var ignoreZoom = true,
          pointer = this.getPointer(e, ignoreZoom),
          activeObject = this._activeObject,
          aObjects = this.getActiveObjects(),
          activeTarget, activeTargetSubs;

      // first check current group (if one exists)
      // active group does not check sub targets like normal groups.
      // if active group just exits.
      this.targets = [];

      if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
        return activeObject;
      }
      // if we hit the corner of an activeObject, let's return that.
      if (aObjects.length === 1 && activeObject._findTargetCorner(pointer)) {
        return activeObject;
      }
      if (aObjects.length === 1 &&
        activeObject === this._searchPossibleTargets([activeObject], pointer)) {
        if (!this.preserveObjectStacking) {
          return activeObject;
        }
        else {
          activeTarget = activeObject;
          activeTargetSubs = this.targets;
          this.targets = [];
        }
      }
      var target = this._searchPossibleTargets(this._objects, pointer);
      if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
        target = activeTarget;
        this.targets = activeTargetSubs;
      }
      return target;
    },

    /**
     * Checks point is inside the object.
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @param {fabric.Object} obj Object to test against
     * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
     * @return {Boolean} true if point is contained within an area of given object
     * @private
     */
    _checkTarget: function(pointer, obj, globalPointer) {
      if (obj &&
          obj.visible &&
          obj.evented &&
          this.containsPoint(null, obj, pointer)){
        if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
          var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);
          if (!isTransparent) {
            return true;
          }
        }
        else {
          return true;
        }
      }
    },

    /**
     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
     * @param {Array} [objects] objects array to look into
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @return {fabric.Object} object that contains pointer
     * @private
     */
    _searchPossibleTargets: function(objects, pointer) {
      // Cache all targets where their bounding box contains point.
      var target, i = objects.length, subTarget;
      // Do not check for currently grouped objects, since we check the parent group itself.
      // until we call this function specifically to search inside the activeGroup
      while (i--) {
        var objToCheck = objects[i];
        var pointerToUse = objToCheck.group && objToCheck.group.type !== 'activeSelection' ?
          this._normalizePointer(objToCheck.group, pointer) : pointer;
        if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
          target = objects[i];
          if (target.subTargetCheck && target instanceof fabric.Group) {
            subTarget = this._searchPossibleTargets(target._objects, pointer);
            subTarget && this.targets.push(subTarget);
          }
          break;
        }
      }
      return target;
    },

    /**
     * Returns pointer coordinates without the effect of the viewport
     * @param {Object} pointer with "x" and "y" number values
     * @return {Object} object with "x" and "y" number values
     */
    restorePointerVpt: function(pointer) {
      return fabric.util.transformPoint(
        pointer,
        fabric.util.invertTransform(this.viewportTransform)
      );
    },

    /**
     * Returns pointer coordinates relative to canvas.
     * Can return coordinates with or without viewportTransform.
     * ignoreZoom false gives back coordinates that represent
     * the point clicked on canvas element.
     * ignoreZoom true gives back coordinates after being processed
     * by the viewportTransform ( sort of coordinates of what is displayed
     * on the canvas where you are clicking.
     * ignoreZoom true = HTMLElement coordinates relative to top,left
     * ignoreZoom false, default = fabric space coordinates, the same used for shape position
     * To interact with your shapes top and left you want to use ignoreZoom true
     * most of the time, while ignoreZoom false will give you coordinates
     * compatible with the object.oCoords system.
     * of the time.
     * @param {Event} e
     * @param {Boolean} ignoreZoom
     * @return {Object} object with "x" and "y" number values
     */
    getPointer: function (e, ignoreZoom) {
      // return cached values if we are in the event processing chain
      if (this._absolutePointer && !ignoreZoom) {
        return this._absolutePointer;
      }
      if (this._pointer && ignoreZoom) {
        return this._pointer;
      }

      var pointer = getPointer(e),
          upperCanvasEl = this.upperCanvasEl,
          bounds = upperCanvasEl.getBoundingClientRect(),
          boundsWidth = bounds.width || 0,
          boundsHeight = bounds.height || 0,
          cssScale;

      if (!boundsWidth || !boundsHeight ) {
        if ('top' in bounds && 'bottom' in bounds) {
          boundsHeight = Math.abs( bounds.top - bounds.bottom );
        }
        if ('right' in bounds && 'left' in bounds) {
          boundsWidth = Math.abs( bounds.right - bounds.left );
        }
      }

      this.calcOffset();
      pointer.x = pointer.x - this._offset.left;
      pointer.y = pointer.y - this._offset.top;
      if (!ignoreZoom) {
        pointer = this.restorePointerVpt(pointer);
      }

      var retinaScaling = this.getRetinaScaling();
      if (retinaScaling !== 1) {
        pointer.x /= retinaScaling;
        pointer.y /= retinaScaling;
      }

      if (boundsWidth === 0 || boundsHeight === 0) {
        // If bounds are not available (i.e. not visible), do not apply scale.
        cssScale = { width: 1, height: 1 };
      }
      else {
        cssScale = {
          width: upperCanvasEl.width / boundsWidth,
          height: upperCanvasEl.height / boundsHeight
        };
      }

      return {
        x: pointer.x * cssScale.width,
        y: pointer.y * cssScale.height
      };
    },

    /**
     * @private
     * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
     */
    _createUpperCanvas: function () {
      var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ''),
          lowerCanvasEl = this.lowerCanvasEl, upperCanvasEl = this.upperCanvasEl;

      // there is no need to create a new upperCanvas element if we have already one.
      if (upperCanvasEl) {
        upperCanvasEl.className = '';
      }
      else {
        upperCanvasEl = this._createCanvasElement();
        this.upperCanvasEl = upperCanvasEl;
      }
      fabric.util.addClass(upperCanvasEl, 'upper-canvas ' + lowerCanvasClass);

      this.wrapperEl.appendChild(upperCanvasEl);

      this._copyCanvasStyle(lowerCanvasEl, upperCanvasEl);
      this._applyCanvasStyle(upperCanvasEl);
      this.contextTop = upperCanvasEl.getContext('2d');
    },

    /**
     * @private
     */
    _createCacheCanvas: function () {
      this.cacheCanvasEl = this._createCanvasElement();
      this.cacheCanvasEl.setAttribute('width', this.width);
      this.cacheCanvasEl.setAttribute('height', this.height);
      this.contextCache = this.cacheCanvasEl.getContext('2d');
    },

    /**
     * @private
     */
    _initWrapperElement: function () {
      this.wrapperEl = fabric.util.wrapElement(this.lowerCanvasEl, 'div', {
        'class': this.containerClass
      });
      fabric.util.setStyle(this.wrapperEl, {
        width: this.width + 'px',
        height: this.height + 'px',
        position: 'relative'
      });
      fabric.util.makeElementUnselectable(this.wrapperEl);
    },

    /**
     * @private
     * @param {HTMLElement} element canvas element to apply styles on
     */
    _applyCanvasStyle: function (element) {
      var width = this.width || element.width,
          height = this.height || element.height;

      fabric.util.setStyle(element, {
        position: 'absolute',
        width: width + 'px',
        height: height + 'px',
        left: 0,
        top: 0,
        'touch-action': this.allowTouchScrolling ? 'manipulation' : 'none',
        '-ms-touch-action': this.allowTouchScrolling ? 'manipulation' : 'none'
      });
      element.width = width;
      element.height = height;
      fabric.util.makeElementUnselectable(element);
    },

    /**
     * Copy the entire inline style from one element (fromEl) to another (toEl)
     * @private
     * @param {Element} fromEl Element style is copied from
     * @param {Element} toEl Element copied style is applied to
     */
    _copyCanvasStyle: function (fromEl, toEl) {
      toEl.style.cssText = fromEl.style.cssText;
    },

    /**
     * Returns context of canvas where object selection is drawn
     * @return {CanvasRenderingContext2D}
     */
    getSelectionContext: function() {
      return this.contextTop;
    },

    /**
     * Returns &lt;canvas> element on which object selection is drawn
     * @return {HTMLCanvasElement}
     */
    getSelectionElement: function () {
      return this.upperCanvasEl;
    },

    /**
     * Returns currently active object
     * @return {fabric.Object} active object
     */
    getActiveObject: function () {
      return this._activeObject;
    },

    /**
     * Returns an array with the current selected objects
     * @return {fabric.Object} active object
     */
    getActiveObjects: function () {
      var active = this._activeObject;
      if (active) {
        if (active.type === 'activeSelection' && active._objects) {
          return active._objects.slice(0);
        }
        else {
          return [active];
        }
      }
      return [];
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */
    _onObjectRemoved: function(obj) {
      // removing active object should fire "selection:cleared" events
      if (obj === this._activeObject) {
        this.fire('before:selection:cleared', { target: obj });
        this._discardActiveObject();
        this.fire('selection:cleared', { target: obj });
        obj.fire('deselected');
      }
      if (obj === this._hoveredTarget){
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }
      this.callSuper('_onObjectRemoved', obj);
    },

    /**
     * @private
     * Compares the old activeObject with the current one and fires correct events
     * @param {fabric.Object} obj old activeObject
     */
    _fireSelectionEvents: function(oldObjects, e) {
      var somethingChanged = false, objects = this.getActiveObjects(),
          added = [], removed = [], opt = { e: e };
      oldObjects.forEach(function(oldObject) {
        if (objects.indexOf(oldObject) === -1) {
          somethingChanged = true;
          oldObject.fire('deselected', opt);
          removed.push(oldObject);
        }
      });
      objects.forEach(function(object) {
        if (oldObjects.indexOf(object) === -1) {
          somethingChanged = true;
          object.fire('selected', opt);
          added.push(object);
        }
      });
      if (oldObjects.length > 0 && objects.length > 0) {
        opt.selected = added;
        opt.deselected = removed;
        // added for backward compatibility
        opt.updated = added[0] || removed[0];
        opt.target = this._activeObject;
        somethingChanged && this.fire('selection:updated', opt);
      }
      else if (objects.length > 0) {
        // deprecated event
        if (objects.length === 1) {
          opt.target = added[0];
          this.fire('object:selected', opt);
        }
        opt.selected = added;
        // added for backward compatibility
        opt.target = this._activeObject;
        this.fire('selection:created', opt);
      }
      else if (oldObjects.length > 0) {
        opt.deselected = removed;
        this.fire('selection:cleared', opt);
      }
    },

    /**
     * Sets given object as the only active object on canvas
     * @param {fabric.Object} object Object to set as an active one
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    setActiveObject: function (object, e) {
      var currentActives = this.getActiveObjects();
      this._setActiveObject(object, e);
      this._fireSelectionEvents(currentActives, e);
      return this;
    },

    /**
     * @private
     * @param {Object} object to set as active
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {Boolean} true if the selection happened
     */
    _setActiveObject: function(object, e) {
      if (this._activeObject === object) {
        return false;
      }
      if (!this._discardActiveObject(e, object)) {
        return false;
      }
      if (object.onSelect({ e: e })) {
        return false;
      }
      this._activeObject = object;
      return true;
    },

    /**
     * @private
     */
    _discardActiveObject: function(e, object) {
      var obj = this._activeObject;
      if (obj) {
        // onDeselect return TRUE to cancel selection;
        if (obj.onDeselect({ e: e, object: object })) {
          return false;
        }
        this._activeObject = null;
      }
      return true;
    },

    /**
     * Discards currently active object and fire events. If the function is called by fabric
     * as a consequence of a mouse event, the event is passed as a parameter and
     * sent to the fire function for the custom events. When used as a method the
     * e param does not have any application.
     * @param {event} e
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    discardActiveObject: function (e) {
      var currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
      if (currentActives.length) {
        this.fire('before:selection:cleared', { target: activeObject, e: e });
      }
      this._discardActiveObject(e);
      this._fireSelectionEvents(currentActives, e);
      return this;
    },

    /**
     * Clears a canvas element and removes all event listeners
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    dispose: function () {
      var wrapper = this.wrapperEl;
      this.removeListeners();
      wrapper.removeChild(this.upperCanvasEl);
      wrapper.removeChild(this.lowerCanvasEl);
      this.contextCache = null;
      this.contextTop = null;
      ['upperCanvasEl', 'cacheCanvasEl'].forEach((function(element) {
        fabric.util.cleanUpJsdomNode(this[element]);
        this[element] = undefined;
      }).bind(this));
      if (wrapper.parentNode) {
        wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
      }
      delete this.wrapperEl;
      fabric.StaticCanvas.prototype.dispose.call(this);
      return this;
    },

    /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clear: function () {
      // this.discardActiveGroup();
      this.discardActiveObject();
      this.clearContext(this.contextTop);
      return this.callSuper('clear');
    },

    /**
     * Draws objects' controls (borders/controls)
     * @param {CanvasRenderingContext2D} ctx Context to render controls on
     */
    drawControls: function(ctx) {
      var activeObject = this._activeObject;

      if (activeObject) {
        activeObject._renderControls(ctx);
      }
    },

    /**
     * @private
     */
    _toObject: function(instance, methodName, propertiesToInclude) {
      //If the object is part of the current selection group, it should
      //be transformed appropriately
      //i.e. it should be serialised as it would appear if the selection group
      //were to be destroyed.
      var originalProperties = this._realizeGroupTransformOnObject(instance),
          object = this.callSuper('_toObject', instance, methodName, propertiesToInclude);
      //Undo the damage we did by changing all of its properties
      this._unwindGroupTransformOnObject(instance, originalProperties);
      return object;
    },

    /**
     * Realises an object's group transformation on it
     * @private
     * @param {fabric.Object} [instance] the object to transform (gets mutated)
     * @returns the original values of instance which were changed
     */
    _realizeGroupTransformOnObject: function(instance) {
      if (instance.group && instance.group.type === 'activeSelection' && this._activeObject === instance.group) {
        var layoutProps = ['angle', 'flipX', 'flipY', 'left', 'scaleX', 'scaleY', 'skewX', 'skewY', 'top'];
        //Copy all the positionally relevant properties across now
        var originalValues = {};
        layoutProps.forEach(function(prop) {
          originalValues[prop] = instance[prop];
        });
        this._activeObject.realizeTransform(instance);
        return originalValues;
      }
      else {
        return null;
      }
    },

    /**
     * Restores the changed properties of instance
     * @private
     * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
     * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
     */
    _unwindGroupTransformOnObject: function(instance, originalValues) {
      if (originalValues) {
        instance.set(originalValues);
      }
    },

    /**
     * @private
     */
    _setSVGObject: function(markup, instance, reviver) {
      //If the object is in a selection group, simulate what would happen to that
      //object when the group is deselected
      var originalProperties = this._realizeGroupTransformOnObject(instance);
      this.callSuper('_setSVGObject', markup, instance, reviver);
      this._unwindGroupTransformOnObject(instance, originalProperties);
    },

    setViewportTransform: function (vpt) {
      if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) {
        this._activeObject.clearContextTop();
      }
      fabric.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
    }
  });

  // copying static properties manually to work around Opera's bug,
  // where "prototype" property is enumerable and overrides existing prototype
  for (var prop in fabric.StaticCanvas) {
    if (prop !== 'prototype') {
      fabric.Canvas[prop] = fabric.StaticCanvas[prop];
    }
  }
})();


(function() {

  var cursorOffset = {
        mt: 0, // n
        tr: 1, // ne
        mr: 2, // e
        br: 3, // se
        mb: 4, // s
        bl: 5, // sw
        ml: 6, // w
        tl: 7 // nw
      },
      addListener = fabric.util.addListener,
      removeListener = fabric.util.removeListener,
      RIGHT_CLICK = 3, MIDDLE_CLICK = 2, LEFT_CLICK = 1,
      addEventOptions = { passive: false };

  function checkClick(e, value) {
    return e.button && (e.button === value - 1);
  }

  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {

    /**
     * Map of cursor style values for each of the object controls
     * @private
     */
    cursorMap: [
      'n-resize',
      'ne-resize',
      'e-resize',
      'se-resize',
      's-resize',
      'sw-resize',
      'w-resize',
      'nw-resize'
    ],

    /**
     * Contains the id of the touch event that owns the fabric transform
     * @type Number
     * @private
     */
    mainTouchId: null,

    /**
     * Adds mouse listeners to canvas
     * @private
     */
    _initEventListeners: function () {
      // in case we initialized the class twice. This should not happen normally
      // but in some kind of applications where the canvas element may be changed
      // this is a workaround to having double listeners.
      this.removeListeners();
      this._bindEvents();
      this.addOrRemove(addListener, 'add');
    },

    /**
     * return an event prefix pointer or mouse.
     * @private
     */
    _getEventPrefix: function () {
      return this.enablePointerEvents ? 'pointer' : 'mouse';
    },

    addOrRemove: function(functor, eventjsFunctor) {
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      functor(fabric.window, 'resize', this._onResize);
      functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
      functor(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      functor(canvasElement, eventTypePrefix + 'out', this._onMouseOut);
      functor(canvasElement, eventTypePrefix + 'enter', this._onMouseEnter);
      functor(canvasElement, 'wheel', this._onMouseWheel);
      functor(canvasElement, 'contextmenu', this._onContextMenu);
      functor(canvasElement, 'dblclick', this._onDoubleClick);
      functor(canvasElement, 'dragover', this._onDragOver);
      functor(canvasElement, 'dragenter', this._onDragEnter);
      functor(canvasElement, 'dragleave', this._onDragLeave);
      functor(canvasElement, 'drop', this._onDrop);
      if (!this.enablePointerEvents) {
        functor(canvasElement, 'touchstart', this._onTouchStart, addEventOptions);
      }
      if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
        eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
        eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
        eventjs[eventjsFunctor](canvasElement, 'orientation', this._onOrientationChange);
        eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
        eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
      }
    },

    /**
     * Removes all event listeners
     */
    removeListeners: function() {
      this.addOrRemove(removeListener, 'remove');
      // if you dispose on a mouseDown, before mouse up, you need to clean document to...
      var eventTypePrefix = this._getEventPrefix();
      removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
    },

    /**
     * @private
     */
    _bindEvents: function() {
      if (this.eventsBound) {
        // for any reason we pass here twice we do not want to bind events twice.
        return;
      }
      this._onMouseDown = this._onMouseDown.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseUp = this._onMouseUp.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onGesture = this._onGesture.bind(this);
      this._onDrag = this._onDrag.bind(this);
      this._onShake = this._onShake.bind(this);
      this._onLongPress = this._onLongPress.bind(this);
      this._onOrientationChange = this._onOrientationChange.bind(this);
      this._onMouseWheel = this._onMouseWheel.bind(this);
      this._onMouseOut = this._onMouseOut.bind(this);
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onContextMenu = this._onContextMenu.bind(this);
      this._onDoubleClick = this._onDoubleClick.bind(this);
      this._onDragOver = this._onDragOver.bind(this);
      this._onDragEnter = this._simpleEventHandler.bind(this, 'dragenter');
      this._onDragLeave = this._simpleEventHandler.bind(this, 'dragleave');
      this._onDrop = this._simpleEventHandler.bind(this, 'drop');
      this.eventsBound = true;
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js gesture
     * @param {Event} [self] Inner Event object
     */
    _onGesture: function(e, self) {
      this.__onTransformGesture && this.__onTransformGesture(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js drag
     * @param {Event} [self] Inner Event object
     */
    _onDrag: function(e, self) {
      this.__onDrag && this.__onDrag(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on wheel event
     */
    _onMouseWheel: function(e) {
      this.__onMouseWheel(e);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseOut: function(e) {
      var target = this._hoveredTarget;
      this.fire('mouse:out', { target: target, e: e });
      this._hoveredTarget = null;
      target && target.fire('mouseout', { e: e });

      var _this = this;
      this._hoveredTargets.forEach(function(_target){
        _this.fire('mouse:out', { target: target, e: e });
        _target && target.fire('mouseout', { e: e });
      });
      this._hoveredTargets = [];

      if (this._iTextInstances) {
        this._iTextInstances.forEach(function(obj) {
          if (obj.isEditing) {
            obj.hiddenTextarea.focus();
          }
        });
      }
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseenter
     */
    _onMouseEnter: function(e) {
      // This find target and consequent 'mouse:over' is used to
      // clear old instances on hovered target.
      // calling findTarget has the side effect of killing target.__corner.
      // as a short term fix we are not firing this if we are currently transforming.
      // as a long term fix we need to separate the action of finding a target with the
      // side effects we added to it.
      if (!this.currentTransform && !this.findTarget(e)) {
        this.fire('mouse:over', { target: null, e: e });
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js orientation change
     * @param {Event} [self] Inner Event object
     */
    _onOrientationChange: function(e, self) {
      this.__onOrientationChange && this.__onOrientationChange(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */
    _onShake: function(e, self) {
      this.__onShake && this.__onShake(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */
    _onLongPress: function(e, self) {
      this.__onLongPress && this.__onLongPress(e, self);
    },

    /**
     * prevent default to allow drop event to be fired
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     */
    _onDragOver: function(e) {
      e.preventDefault();
      var target = this._simpleEventHandler('dragover', e);
      this._fireEnterLeaveEvents(target, e);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onContextMenu: function (e) {
      if (this.stopContextMenu) {
        e.stopPropagation();
        e.preventDefault();
      }
      return false;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onDoubleClick: function (e) {
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'dblclick');
      this._resetTransformEventData(e);
    },

    /**
     * Return a the id of an event.
     * returns either the pointerId or the identifier or 0 for the mouse event
     * @private
     * @param {Event} evt Event object
     */
    getPointerId: function(evt) {
      var changedTouches = evt.changedTouches;

      if (changedTouches) {
        return changedTouches[0] && changedTouches[0].identifier;
      }

      if (this.enablePointerEvents) {
        return evt.pointerId;
      }

      return -1;
    },

    /**
     * Determines if an event has the id of the event that is considered main
     * @private
     * @param {evt} event Event object
     */
    _isMainEvent: function(evt) {
      if (evt.isPrimary === true) {
        return true;
      }
      if (evt.isPrimary === false) {
        return false;
      }
      if (evt.type === 'touchend' && evt.touches.length === 0) {
        return true;
      }
      if (evt.changedTouches) {
        return evt.changedTouches[0].identifier === this.mainTouchId;
      }
      return true;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchStart: function(e) {
      e.preventDefault();
      if (this.mainTouchId === null) {
        this.mainTouchId = this.getPointerId(e);
      }
      this.__onMouseDown(e);
      this._resetTransformEventData();
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      addListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      addListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
      // Unbind mousedown to prevent double triggers from touch devices
      removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDown: function (e) {
      this.__onMouseDown(e);
      this._resetTransformEventData();
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      removeListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      addListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
      addListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchEnd: function(e) {
      if (e.touches.length > 0) {
        // if there are still touches stop here
        return;
      }
      this.__onMouseUp(e);
      this._resetTransformEventData();
      this.mainTouchId = null;
      var eventTypePrefix = this._getEventPrefix();
      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
      var _this = this;
      if (this._willAddMouseDown) {
        clearTimeout(this._willAddMouseDown);
      }
      this._willAddMouseDown = setTimeout(function() {
        // Wait 400ms before rebinding mousedown to prevent double triggers
        // from touch devices
        addListener(_this.upperCanvasEl, eventTypePrefix + 'down', _this._onMouseDown);
        _this._willAddMouseDown = 0;
      }, 400);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUp: function (e) {
      this.__onMouseUp(e);
      this._resetTransformEventData();
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      if (this._isMainEvent(e)) {
        removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
        removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
        addListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      }
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMove: function (e) {
      !this.allowTouchScrolling && e.preventDefault && e.preventDefault();
      this.__onMouseMove(e);
    },

    /**
     * @private
     */
    _onResize: function () {
      this.calcOffset();
    },

    /**
     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
     * @private
     * @param {Object} target
     */
    _shouldRender: function(target) {
      var activeObject = this._activeObject;

      if (
        !!activeObject !== !!target ||
        (activeObject && target && (activeObject !== target))
      ) {
        // this covers: switch of target, from target to no target, selection of target
        // multiSelection with key and mouse
        return true;
      }
      else if (activeObject && activeObject.isEditing) {
        // if we mouse up/down over a editing textbox a cursor change,
        // there is no need to re render
        return false;
      }
      return false;
    },

    /**
     * Method that defines the actions when mouse is released on canvas.
     * The method resets the currentTransform parameters, store the image corner
     * position in the image object and render the canvas on top.
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseUp: function (e) {
      var target, transform = this._currentTransform,
          groupSelector = this._groupSelector, shouldRender = false,
          isClick = (!groupSelector || (groupSelector.left === 0 && groupSelector.top === 0));
      this._cacheTransformEventData(e);
      target = this._target;
      this._handleEvent(e, 'up:before');
      // if right/middle click just fire events and return
      // target undefined will make the _handleEvent search the target
      if (checkClick(e, RIGHT_CLICK)) {
        if (this.fireRightClick) {
          this._handleEvent(e, 'up', RIGHT_CLICK, isClick);
        }
        return;
      }

      if (checkClick(e, MIDDLE_CLICK)) {
        if (this.fireMiddleClick) {
          this._handleEvent(e, 'up', MIDDLE_CLICK, isClick);
        }
        this._resetTransformEventData();
        return;
      }

      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this._onMouseUpInDrawingMode(e);
        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }
      if (transform) {
        this._finalizeCurrentTransform(e);
        shouldRender = transform.actionPerformed;
      }

      if (!isClick) {
        this._maybeGroupObjects(e);
        shouldRender || (shouldRender = this._shouldRender(target));
      }
      if (target) {
        target.isMoving = false;
      }
      this._setCursorFromEvent(e, target);
      this._handleEvent(e, 'up', LEFT_CLICK, isClick);
      this._groupSelector = null;
      this._currentTransform = null;
      // reset the target information about which corner is selected
      target && (target.__corner = 0);
      if (shouldRender) {
        this.requestRenderAll();
      }
      else if (!isClick) {
        this.renderTop();
      }
    },

    /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @return {Fabric.Object} target return the the target found, for internal reasons.
     */
    _simpleEventHandler: function(eventType, e) {
      var target = this.findTarget(e),
          targets = this.targets,
          options = {
            e: e,
            target: target,
            subTargets: targets,
          };
      this.fire(eventType, options);
      target && target.fire(eventType, options);
      if (!targets) {
        return target;
      }
      for (var i = 0; i < targets.length; i++) {
        targets[i].fire(eventType, options);
      }
      return target;
    },

    /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @param {fabric.Object} targetObj receiving event
     * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
     * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
     */
    _handleEvent: function(e, eventType, button, isClick) {
      var target = this._target,
          targets = this.targets || [],
          options = {
            e: e,
            target: target,
            subTargets: targets,
            button: button || LEFT_CLICK,
            isClick: isClick || false,
            pointer: this._pointer,
            absolutePointer: this._absolutePointer,
            transform: this._currentTransform
          };
      this.fire('mouse:' + eventType, options);
      target && target.fire('mouse' + eventType, options);
      for (var i = 0; i < targets.length; i++) {
        targets[i].fire('mouse' + eventType, options);
      }
    },

    /**
     * @private
     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
     */
    _finalizeCurrentTransform: function(e) {

      var transform = this._currentTransform,
          target = transform.target,
          eventName,
          options = {
            e: e,
            target: target,
            transform: transform,
          };

      if (target._scaling) {
        target._scaling = false;
      }

      target.setCoords();

      if (transform.actionPerformed || (this.stateful && target.hasStateChanged())) {
        if (transform.actionPerformed) {
          eventName = this._addEventOptions(options, transform);
          this._fire(eventName, options);
        }
        this._fire('modified', options);
      }
    },

    /**
     * Mutate option object in order to add by property and give back the event name.
     * @private
     * @param {Object} options to mutate
     * @param {Object} transform to inspect action from
     */
    _addEventOptions: function(options, transform) {
      // we can probably add more details at low cost
      // scale change, rotation changes, translation changes
      var eventName, by;
      switch (transform.action) {
        case 'scaleX':
          eventName = 'scaled';
          by = 'x';
          break;
        case 'scaleY':
          eventName = 'scaled';
          by = 'y';
          break;
        case 'skewX':
          eventName = 'skewed';
          by = 'x';
          break;
        case 'skewY':
          eventName = 'skewed';
          by = 'y';
          break;
        case 'scale':
          eventName = 'scaled';
          by = 'equally';
          break;
        case 'rotate':
          eventName = 'rotated';
          break;
        case 'drag':
          eventName = 'moved';
          break;
      }
      options.by = by;
      return eventName;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDownInDrawingMode: function(e) {
      this._isCurrentlyDrawing = true;
      if (this.getActiveObject()) {
        this.discardActiveObject(e).requestRenderAll();
      }
      if (this.clipTo) {
        fabric.util.clipContext(this, this.contextTop);
      }
      var pointer = this.getPointer(e);
      this.freeDrawingBrush.onMouseDown(pointer, { e: e, pointer: pointer });
      this._handleEvent(e, 'down');
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMoveInDrawingMode: function(e) {
      if (this._isCurrentlyDrawing) {
        var pointer = this.getPointer(e);
        this.freeDrawingBrush.onMouseMove(pointer, { e: e, pointer: pointer });
      }
      this.setCursor(this.freeDrawingCursor);
      this._handleEvent(e, 'move');
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUpInDrawingMode: function(e) {
      if (this.clipTo) {
        this.contextTop.restore();
      }
      var pointer = this.getPointer(e);
      this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({ e: e, pointer: pointer });
      this._handleEvent(e, 'up');
    },

    /**
     * Method that defines the actions when mouse is clicked on canvas.
     * The method inits the currentTransform parameters and renders all the
     * canvas so the current image can be placed on the top canvas and the rest
     * in on the container one.
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    __onMouseDown: function (e) {
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'down:before');
      var target = this._target;
      // if right click just fire events
      if (checkClick(e, RIGHT_CLICK)) {
        if (this.fireRightClick) {
          this._handleEvent(e, 'down', RIGHT_CLICK);
        }
        return;
      }

      if (checkClick(e, MIDDLE_CLICK)) {
        if (this.fireMiddleClick) {
          this._handleEvent(e, 'down', MIDDLE_CLICK);
        }
        return;
      }

      if (this.isDrawingMode) {
        this._onMouseDownInDrawingMode(e);
        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }

      // ignore if some object is being transformed at this moment
      if (this._currentTransform) {
        return;
      }

      var pointer = this._pointer;
      // save pointer for check in __onMouseUp event
      this._previousPointer = pointer;
      var shouldRender = this._shouldRender(target),
          shouldGroup = this._shouldGroup(e, target);
      if (this._shouldClearSelection(e, target)) {
        this.discardActiveObject(e);
      }
      else if (shouldGroup) {
        this._handleGrouping(e, target);
        target = this._activeObject;
      }

      if (this.selection && (!target ||
        (!target.selectable && !target.isEditing && target !== this._activeObject))) {
        this._groupSelector = {
          ex: pointer.x,
          ey: pointer.y,
          top: 0,
          left: 0
        };
      }

      if (target) {
        var alreadySelected = target === this._activeObject;
        if (target.selectable) {
          this.setActiveObject(target, e);
        }
        if (target === this._activeObject && (target.__corner || !shouldGroup)) {
          this._setupCurrentTransform(e, target, alreadySelected);
        }
      }
      this._handleEvent(e, 'down');
      // we must renderAll so that we update the visuals
      (shouldRender || shouldGroup) && this.requestRenderAll();
    },

    /**
     * reset cache form common information needed during event processing
     * @private
     */
    _resetTransformEventData: function() {
      this._target = null;
      this._pointer = null;
      this._absolutePointer = null;
    },

    /**
     * Cache common information needed during event processing
     * @private
     * @param {Event} e Event object fired on event
     */
    _cacheTransformEventData: function(e) {
      // reset in order to avoid stale caching
      this._resetTransformEventData();
      this._pointer = this.getPointer(e, true);
      this._absolutePointer = this.restorePointerVpt(this._pointer);
      this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
    },

    /**
     * @private
     */
    _beforeTransform: function(e) {
      var t = this._currentTransform;
      this.stateful && t.target.saveState();
      this.fire('before:transform', {
        e: e,
        transform: t,
      });
      // determine if it's a drag or rotate case
      if (t.corner) {
        this.onBeforeScaleRotate(t.target);
      }
    },

    /**
     * Method that defines the actions when mouse is hovering the canvas.
     * The currentTransform parameter will define whether the user is rotating/scaling/translating
     * an image or neither of them (only hovering). A group selection is also possible and would cancel
     * all any other type of action.
     * In case of an image transformation only the top canvas will be rendered.
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    __onMouseMove: function (e) {
      this._handleEvent(e, 'move:before');
      this._cacheTransformEventData(e);
      var target, pointer;

      if (this.isDrawingMode) {
        this._onMouseMoveInDrawingMode(e);
        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }

      var groupSelector = this._groupSelector;

      // We initially clicked in an empty area, so we draw a box for multiple selection
      if (groupSelector) {
        pointer = this._pointer;

        groupSelector.left = pointer.x - groupSelector.ex;
        groupSelector.top = pointer.y - groupSelector.ey;

        this.renderTop();
      }
      else if (!this._currentTransform) {
        target = this.findTarget(e) || null;
        this._setCursorFromEvent(e, target);
        this._fireOverOutEvents(target, e);
      }
      else {
        this._transformObject(e);
      }
      this._handleEvent(e, 'move');
      this._resetTransformEventData();
    },

    /**
     * Manage the mouseout, mouseover events for the fabric object on the canvas
     * @param {Fabric.Object} target the target where the target from the mousemove event
     * @param {Event} e Event object fired on mousemove
     * @private
     */
    _fireOverOutEvents: function(target, e) {
      var _hoveredTarget = this._hoveredTarget,
          _hoveredTargets = this._hoveredTargets, targets = this.targets,
          length = Math.max(_hoveredTargets.length, targets.length);

      this.fireSyntheticInOutEvents(target, e, {
        oldTarget: _hoveredTarget,
        evtOut: 'mouseout',
        canvasEvtOut: 'mouse:out',
        evtIn: 'mouseover',
        canvasEvtIn: 'mouse:over',
      });
      for (var i = 0; i < length; i++){
        this.fireSyntheticInOutEvents(targets[i], e, {
          oldTarget: _hoveredTargets[i],
          evtOut: 'mouseout',
          evtIn: 'mouseover',
        });
      }
      this._hoveredTarget = target;
      this._hoveredTargets = this.targets.concat();
    },

    /**
     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the onDrag event
     * @param {Event} e Event object fired on ondrag
     * @private
     */
    _fireEnterLeaveEvents: function(target, e) {
      var _draggedoverTarget = this._draggedoverTarget,
          _hoveredTargets = this._hoveredTargets, targets = this.targets,
          length = Math.max(_hoveredTargets.length, targets.length);

      this.fireSyntheticInOutEvents(target, e, {
        oldTarget: _draggedoverTarget,
        evtOut: 'dragleave',
        evtIn: 'dragenter',
      });
      for (var i = 0; i < length; i++) {
        this.fireSyntheticInOutEvents(targets[i], e, {
          oldTarget: _hoveredTargets[i],
          evtOut: 'dragleave',
          evtIn: 'dragenter',
        });
      }
      this._draggedoverTarget = target;
    },

    /**
     * Manage the synthetic in/out events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the supported events
     * @param {Event} e Event object fired
     * @param {Object} config configuration for the function to work
     * @param {String} config.targetName property on the canvas where the old target is stored
     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
     * @param {String} config.evtOut name of the event to fire for out
     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
     * @param {String} config.evtIn name of the event to fire for in
     * @private
     */
    fireSyntheticInOutEvents: function(target, e, config) {
      var inOpt, outOpt, oldTarget = config.oldTarget, outFires, inFires,
          targetChanged = oldTarget !== target, canvasEvtIn = config.canvasEvtIn, canvasEvtOut = config.canvasEvtOut;
      if (targetChanged) {
        inOpt = { e: e, target: target, previousTarget: oldTarget };
        outOpt = { e: e, target: oldTarget, nextTarget: target };
      }
      inFires = target && targetChanged;
      outFires = oldTarget && targetChanged;
      if (outFires) {
        canvasEvtOut && this.fire(canvasEvtOut, outOpt);
        oldTarget.fire(config.evtOut, outOpt);
      }
      if (inFires) {
        canvasEvtIn && this.fire(canvasEvtIn, inOpt);
        target.fire(config.evtIn, inOpt);
      }
    },

    /**
     * Method that defines actions when an Event Mouse Wheel
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseWheel: function(e) {
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'wheel');
      this._resetTransformEventData();
    },

    /**
     * @private
     * @param {Event} e Event fired on mousemove
     */
    _transformObject: function(e) {
      var pointer = this.getPointer(e),
          transform = this._currentTransform;

      transform.reset = false;
      transform.target.isMoving = true;
      transform.shiftKey = e.shiftKey;
      transform.altKey = e[this.centeredKey];

      this._beforeScaleTransform(e, transform);
      this._performTransformAction(e, transform, pointer);

      transform.actionPerformed && this.requestRenderAll();
    },

    /**
     * @private
     */
    _performTransformAction: function(e, transform, pointer) {
      var x = pointer.x,
          y = pointer.y,
          action = transform.action,
          actionPerformed = false,
          options = {
            target: transform.target,
            e: e,
            transform: transform,
            pointer: pointer
          };

      if (action === 'rotate') {
        (actionPerformed = this._rotateObject(x, y)) && this._fire('rotating', options);
      }
      else if (action === 'scale') {
        (actionPerformed = this._onScale(e, transform, x, y)) && this._fire('scaling', options);
      }
      else if (action === 'scaleX') {
        (actionPerformed = this._scaleObject(x, y, 'x')) && this._fire('scaling', options);
      }
      else if (action === 'scaleY') {
        (actionPerformed = this._scaleObject(x, y, 'y')) && this._fire('scaling', options);
      }
      else if (action === 'skewX') {
        (actionPerformed = this._skewObject(x, y, 'x')) && this._fire('skewing', options);
      }
      else if (action === 'skewY') {
        (actionPerformed = this._skewObject(x, y, 'y')) && this._fire('skewing', options);
      }
      else {
        actionPerformed = this._translateObject(x, y);
        if (actionPerformed) {
          this._fire('moving', options);
          this.setCursor(options.target.moveCursor || this.moveCursor);
        }
      }
      transform.actionPerformed = transform.actionPerformed || actionPerformed;
    },

    /**
     * @private
     */
    _fire: function(eventName, options) {
      this.fire('object:' + eventName, options);
      options.target.fire(eventName, options);
    },

    /**
     * @private
     */
    _beforeScaleTransform: function(e, transform) {
      if (transform.action === 'scale' || transform.action === 'scaleX' || transform.action === 'scaleY') {
        var centerTransform = this._shouldCenterTransform(transform.target);

        // Switch from a normal resize to center-based
        if ((centerTransform && (transform.originX !== 'center' || transform.originY !== 'center')) ||
           // Switch from center-based resize to normal one
           (!centerTransform && transform.originX === 'center' && transform.originY === 'center')
        ) {
          this._resetCurrentTransform();
          transform.reset = true;
        }
      }
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {Object} transform current transform
     * @param {Number} x mouse position x from origin
     * @param {Number} y mouse position y from origin
     * @return {Boolean} true if the scaling occurred
     */
    _onScale: function(e, transform, x, y) {
      if (this._isUniscalePossible(e, transform.target)) {
        transform.currentAction = 'scale';
        return this._scaleObject(x, y);
      }
      else {
        // Switch from a normal resize to proportional
        if (!transform.reset && transform.currentAction === 'scale') {
          this._resetCurrentTransform();
        }

        transform.currentAction = 'scaleEqually';
        return this._scaleObject(x, y, 'equally');
      }
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target current target
     * @return {Boolean} true if unproportional scaling is possible
     */
    _isUniscalePossible: function(e, target) {
      return (e[this.uniScaleKey] || this.uniScaleTransform) && !target.get('lockUniScaling');
    },

    /**
     * Sets the cursor depending on where the canvas is being hovered.
     * Note: very buggy in Opera
     * @param {Event} e Event object
     * @param {Object} target Object that the mouse is hovering, if so.
     */
    _setCursorFromEvent: function (e, target) {
      if (!target) {
        this.setCursor(this.defaultCursor);
        return false;
      }
      var hoverCursor = target.hoverCursor || this.hoverCursor,
          activeSelection = this._activeObject && this._activeObject.type === 'activeSelection' ?
            this._activeObject : null,
          // only show proper corner when group selection is not active
          corner = (!activeSelection || !activeSelection.contains(target))
                    && target._findTargetCorner(this.getPointer(e, true));

      if (!corner) {
        if (target.subTargetCheck){
          // hoverCursor should come from top-most subTarget,
          // so we walk the array backwards
          this.targets.concat().reverse().map(function(_target){
            hoverCursor = _target.hoverCursor || hoverCursor;
          });
        }
        this.setCursor(hoverCursor);
      }
      else {
        this.setCursor(this.getCornerCursor(corner, target, e));
      }
    },

    /**
     * @private
     */
    getCornerCursor: function(corner, target, e) {
      if (this.actionIsDisabled(corner, target, e)) {
        return this.notAllowedCursor;
      }
      else if (corner in cursorOffset) {
        return this._getRotatedCornerCursor(corner, target, e);
      }
      else if (corner === 'mtr' && target.hasRotatingPoint) {
        return this.rotationCursor;
      }
      else {
        return this.defaultCursor;
      }
    },

    actionIsDisabled: function(corner, target, e) {
      if (corner === 'mt' || corner === 'mb') {
        return e[this.altActionKey] ? target.lockSkewingX : target.lockScalingY;
      }
      else if (corner === 'ml' || corner === 'mr') {
        return e[this.altActionKey] ? target.lockSkewingY : target.lockScalingX;
      }
      else if (corner === 'mtr') {
        return target.lockRotation;
      }
      else {
        return this._isUniscalePossible(e, target) ?
          target.lockScalingX && target.lockScalingY : target.lockScalingX || target.lockScalingY;
      }
    },

    /**
     * @private
     */
    _getRotatedCornerCursor: function(corner, target, e) {
      var n = Math.round((target.angle % 360) / 45);

      if (n < 0) {
        n += 8; // full circle ahead
      }
      n += cursorOffset[corner];
      if (e[this.altActionKey] && cursorOffset[corner] % 2 === 0) {
        //if we are holding shift and we are on a mx corner...
        n += 2;
      }
      // normalize n to be from 0 to 7
      n %= 8;

      return this.cursorMap[n];
    }
  });
})();


(function() {

  var min = Math.min,
      max = Math.max;

  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     * @return {Boolean}
     */
    _shouldGroup: function(e, target) {
      var activeObject = this._activeObject;
      return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection &&
            (activeObject !== target || activeObject.type === 'activeSelection') && !target.onSelect({ e: e });
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _handleGrouping: function (e, target) {
      var activeObject = this._activeObject;
      // avoid multi select when shift click on a corner
      if (activeObject.__corner) {
        return;
      }
      if (target === activeObject) {
        // if it's a group, find target again, using activeGroup objects
        target = this.findTarget(e, true);
        // if even object is not found or we are on activeObjectCorner, bail out
        if (!target || !target.selectable) {
          return;
        }
      }
      if (activeObject && activeObject.type === 'activeSelection') {
        this._updateActiveSelection(target, e);
      }
      else {
        this._createActiveSelection(target, e);
      }
    },

    /**
     * @private
     */
    _updateActiveSelection: function(target, e) {
      var activeSelection = this._activeObject,
          currentActiveObjects = activeSelection._objects.slice(0);
      if (activeSelection.contains(target)) {
        activeSelection.removeWithUpdate(target);
        this._hoveredTarget = target;
        this._hoveredTargets = this.targets.concat();
        if (activeSelection.size() === 1) {
          // activate last remaining object
          this._setActiveObject(activeSelection.item(0), e);
        }
      }
      else {
        activeSelection.addWithUpdate(target);
        this._hoveredTarget = activeSelection;
        this._hoveredTargets = this.targets.concat();
      }
      this._fireSelectionEvents(currentActiveObjects, e);
    },

    /**
     * @private
     */
    _createActiveSelection: function(target, e) {
      var currentActives = this.getActiveObjects(), group = this._createGroup(target);
      this._hoveredTarget = group;
      // ISSUE 4115: should we consider subTargets here?
      // this._hoveredTargets = [];
      // this._hoveredTargets = this.targets.concat();
      this._setActiveObject(group, e);
      this._fireSelectionEvents(currentActives, e);
    },

    /**
     * @private
     * @param {Object} target
     */
    _createGroup: function(target) {
      var objects = this._objects,
          isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target),
          groupObjects = isActiveLower
            ? [this._activeObject, target]
            : [target, this._activeObject];
      this._activeObject.isEditing && this._activeObject.exitEditing();
      return new fabric.ActiveSelection(groupObjects, {
        canvas: this
      });
    },

    /**
     * @private
     * @param {Event} e mouse event
     */
    _groupSelectedObjects: function (e) {

      var group = this._collectObjects(e),
          aGroup;

      // do not create group for 1 element only
      if (group.length === 1) {
        this.setActiveObject(group[0], e);
      }
      else if (group.length > 1) {
        aGroup = new fabric.ActiveSelection(group.reverse(), {
          canvas: this
        });
        this.setActiveObject(aGroup, e);
      }
    },

    /**
     * @private
     */
    _collectObjects: function(e) {
      var group = [],
          currentObject,
          x1 = this._groupSelector.ex,
          y1 = this._groupSelector.ey,
          x2 = x1 + this._groupSelector.left,
          y2 = y1 + this._groupSelector.top,
          selectionX1Y1 = new fabric.Point(min(x1, x2), min(y1, y2)),
          selectionX2Y2 = new fabric.Point(max(x1, x2), max(y1, y2)),
          allowIntersect = !this.selectionFullyContained,
          isClick = x1 === x2 && y1 === y2;
      // we iterate reverse order to collect top first in case of click.
      for (var i = this._objects.length; i--; ) {
        currentObject = this._objects[i];

        if (!currentObject || !currentObject.selectable || !currentObject.visible) {
          continue;
        }

        if ((allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2)) ||
            currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2) ||
            (allowIntersect && currentObject.containsPoint(selectionX1Y1)) ||
            (allowIntersect && currentObject.containsPoint(selectionX2Y2))
        ) {
          group.push(currentObject);
          // only add one object if it's a click
          if (isClick) {
            break;
          }
        }
      }

      if (group.length > 1) {
        group = group.filter(function(object) {
          return !object.onSelect({ e: e });
        });
      }

      return group;
    },

    /**
     * @private
     */
    _maybeGroupObjects: function(e) {
      if (this.selection && this._groupSelector) {
        this._groupSelectedObjects(e);
      }
      this.setCursor(this.defaultCursor);
      // clear selection and current transformation
      this._groupSelector = null;
    }
  });

})();


(function () {
  fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

    /**
     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
     * @param {Object} [options] Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
     * @example <caption>Generate jpeg dataURL with lower quality</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'jpeg',
     *   quality: 0.8
     * });
     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   left: 100,
     *   top: 100,
     *   width: 200,
     *   height: 200
     * });
     * @example <caption>Generate double scaled png dataURL</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   multiplier: 2
     * });
     */
    toDataURL: function (options) {
      options || (options = { });

      var format = options.format || 'png',
          quality = options.quality || 1,
          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1),
          canvasEl = this.toCanvasElement(multiplier, options);
      return fabric.util.toDataURL(canvasEl, format, quality);
    },

    /**
     * Create a new HTMLCanvas element painted with the current canvas content.
     * No need to resize the actual one or repaint it.
     * Will transfer object ownership to a new canvas, paint it, and set everything back.
     * This is an intermediary step used to get to a dataUrl but also it is useful to
     * create quick image copies of a canvas without passing for the dataUrl string
     * @param {Number} [multiplier] a zoom factor.
     * @param {Object} [cropping] Cropping informations
     * @param {Number} [cropping.left] Cropping left offset.
     * @param {Number} [cropping.top] Cropping top offset.
     * @param {Number} [cropping.width] Cropping width.
     * @param {Number} [cropping.height] Cropping height.
     */
    toCanvasElement: function(multiplier, cropping) {
      multiplier = multiplier || 1;
      cropping = cropping || { };
      var scaledWidth = (cropping.width || this.width) * multiplier,
          scaledHeight = (cropping.height || this.height) * multiplier,
          zoom = this.getZoom(),
          originalWidth = this.width,
          originalHeight = this.height,
          newZoom = zoom * multiplier,
          vp = this.viewportTransform,
          translateX = (vp[4] - (cropping.left || 0)) * multiplier,
          translateY = (vp[5] - (cropping.top || 0)) * multiplier,
          originalInteractive = this.interactive,
          newVp = [newZoom, 0, 0, newZoom, translateX, translateY],
          originalRetina = this.enableRetinaScaling,
          canvasEl = fabric.util.createCanvasElement(),
          originalContextTop = this.contextTop;
      canvasEl.width = scaledWidth;
      canvasEl.height = scaledHeight;
      this.contextTop = null;
      this.enableRetinaScaling = false;
      this.interactive = false;
      this.viewportTransform = newVp;
      this.width = scaledWidth;
      this.height = scaledHeight;
      this.calcViewportBoundaries();
      this.renderCanvas(canvasEl.getContext('2d'), this._objects);
      this.viewportTransform = vp;
      this.width = originalWidth;
      this.height = originalHeight;
      this.calcViewportBoundaries();
      this.interactive = originalInteractive;
      this.enableRetinaScaling = originalRetina;
      this.contextTop = originalContextTop;
      return canvasEl;
    },
  });

})();


fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

  /**
   * Populates canvas with data from the specified dataless JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toDatalessJSON}
   * @deprecated since 1.2.2
   * @param {String|Object} json JSON string or object
   * @param {Function} callback Callback, invoked when json is parsed
   *                            and corresponding objects (e.g: {@link fabric.Image})
   *                            are initialized
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @return {fabric.Canvas} instance
   * @chainable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   */
  loadFromDatalessJSON: function (json, callback, reviver) {
    return this.loadFromJSON(json, callback, reviver);
  },

  /**
   * Populates canvas with data from the specified JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
   * @param {String|Object} json JSON string or object
   * @param {Function} callback Callback, invoked when json is parsed
   *                            and corresponding objects (e.g: {@link fabric.Image})
   *                            are initialized
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @return {fabric.Canvas} instance
   * @chainable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
   * @example <caption>loadFromJSON</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
   * @example <caption>loadFromJSON with reviver</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
   *   // `o` = json object
   *   // `object` = fabric.Object instance
   *   // ... do some stuff ...
   * });
   */
  loadFromJSON: function (json, callback, reviver) {
    if (!json) {
      return;
    }

    // serialize if it wasn't already
    var serialized = (typeof json === 'string')
      ? JSON.parse(json)
      : fabric.util.object.clone(json);

    var _this = this,
        clipPath = serialized.clipPath,
        renderOnAddRemove = this.renderOnAddRemove;

    this.renderOnAddRemove = false;

    delete serialized.clipPath;

    this._enlivenObjects(serialized.objects, function (enlivenedObjects) {
      _this.clear();
      _this._setBgOverlay(serialized, function () {
        if (clipPath) {
          _this._enlivenObjects([clipPath], function (enlivenedCanvasClip) {
            _this.clipPath = enlivenedCanvasClip[0];
            _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
          });
        }
        else {
          _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
        }
      });
    }, reviver);
    return this;
  },

  /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Array} restored canvas objects
   * @param {Function} cached renderOnAddRemove callback
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */
  __setupCanvas: function(serialized, enlivenedObjects, renderOnAddRemove, callback) {
    var _this = this;
    enlivenedObjects.forEach(function(obj, index) {
      // we splice the array just in case some custom classes restored from JSON
      // will add more object to canvas at canvas init.
      _this.insertAt(obj, index);
    });
    this.renderOnAddRemove = renderOnAddRemove;
    // remove parts i cannot set as options
    delete serialized.objects;
    delete serialized.backgroundImage;
    delete serialized.overlayImage;
    delete serialized.background;
    delete serialized.overlay;
    // this._initOptions does too many things to just
    // call it. Normally loading an Object from JSON
    // create the Object instance. Here the Canvas is
    // already an instance and we are just loading things over it
    this._setOptions(serialized);
    this.renderAll();
    callback && callback();
  },

  /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */
  _setBgOverlay: function(serialized, callback) {
    var loaded = {
      backgroundColor: false,
      overlayColor: false,
      backgroundImage: false,
      overlayImage: false
    };

    if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
      callback && callback();
      return;
    }

    var cbIfLoaded = function () {
      if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) {
        callback && callback();
      }
    };

    this.__setBgOverlay('backgroundImage', serialized.backgroundImage, loaded, cbIfLoaded);
    this.__setBgOverlay('overlayImage', serialized.overlayImage, loaded, cbIfLoaded);
    this.__setBgOverlay('backgroundColor', serialized.background, loaded, cbIfLoaded);
    this.__setBgOverlay('overlayColor', serialized.overlay, loaded, cbIfLoaded);
  },

  /**
   * @private
   * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
   * @param {(Object|String)} value Value to set
   * @param {Object} loaded Set loaded property to true if property is set
   * @param {Object} callback Callback function to invoke after property is set
   */
  __setBgOverlay: function(property, value, loaded, callback) {
    var _this = this;

    if (!value) {
      loaded[property] = true;
      callback && callback();
      return;
    }

    if (property === 'backgroundImage' || property === 'overlayImage') {
      fabric.util.enlivenObjects([value], function(enlivedObject){
        _this[property] = enlivedObject[0];
        loaded[property] = true;
        callback && callback();
      });
    }
    else {
      this['set' + fabric.util.string.capitalize(property, true)](value, function() {
        loaded[property] = true;
        callback && callback();
      });
    }
  },

  /**
   * @private
   * @param {Array} objects
   * @param {Function} callback
   * @param {Function} [reviver]
   */
  _enlivenObjects: function (objects, callback, reviver) {
    if (!objects || objects.length === 0) {
      callback && callback([]);
      return;
    }

    fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
      callback && callback(enlivenedObjects);
    }, null, reviver);
  },

  /**
   * @private
   * @param {String} format
   * @param {Function} callback
   */
  _toDataURL: function (format, callback) {
    this.clone(function (clone) {
      callback(clone.toDataURL(format));
    });
  },

  /**
   * @private
   * @param {String} format
   * @param {Number} multiplier
   * @param {Function} callback
   */
  _toDataURLWithMultiplier: function (format, multiplier, callback) {
    this.clone(function (clone) {
      callback(clone.toDataURLWithMultiplier(format, multiplier));
    });
  },

  /**
   * Clones canvas instance
   * @param {Object} [callback] Receives cloned instance as a first argument
   * @param {Array} [properties] Array of properties to include in the cloned canvas and children
   */
  clone: function (callback, properties) {
    var data = JSON.stringify(this.toJSON(properties));
    this.cloneWithoutData(function(clone) {
      clone.loadFromJSON(data, function() {
        callback && callback(clone);
      });
    });
  },

  /**
   * Clones canvas instance without cloning existing data.
   * This essentially copies canvas dimensions, clipping properties, etc.
   * but leaves data empty (so that you can populate it with your own)
   * @param {Object} [callback] Receives cloned instance as a first argument
   */
  cloneWithoutData: function(callback) {
    var el = fabric.util.createCanvasElement();

    el.width = this.width;
    el.height = this.height;

    var clone = new fabric.Canvas(el);
    clone.clipTo = this.clipTo;
    if (this.backgroundImage) {
      clone.setBackgroundImage(this.backgroundImage.src, function() {
        clone.renderAll();
        callback && callback(clone);
      });
      clone.backgroundImageOpacity = this.backgroundImageOpacity;
      clone.backgroundImageStretch = this.backgroundImageStretch;
    }
    else {
      callback && callback(clone);
    }
  }
});


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      toFixed = fabric.util.toFixed,
      capitalize = fabric.util.string.capitalize,
      degreesToRadians = fabric.util.degreesToRadians,
      supportsLineDash = fabric.StaticCanvas.supports('setLineDash'),
      objectCaching = !fabric.isLikelyNode,
      ALIASING_LIMIT = 2;

  if (fabric.Object) {
    return;
  }

  /**
   * Root object class from which all 2d shape classes inherit from
   * @class fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
   * @see {@link fabric.Object#initialize} for constructor definition
   *
   * @fires added
   * @fires removed
   *
   * @fires selected
   * @fires deselected
   * @fires modified
   * @fires modified
   * @fires moved
   * @fires scaled
   * @fires rotated
   * @fires skewed
   *
   * @fires rotating
   * @fires scaling
   * @fires moving
   * @fires skewing
   *
   * @fires mousedown
   * @fires mouseup
   * @fires mouseover
   * @fires mouseout
   * @fires mousewheel
   * @fires mousedblclick
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   */
  fabric.Object = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.Object.prototype */ {

    /**
     * Type of an object (rect, circle, path, etc.).
     * Note that this property is meant to be read-only and not meant to be modified.
     * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
     * @type String
     * @default
     */
    type:                     'object',

    /**
     * Horizontal origin of transformation of an object (one of "left", "right", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */
    originX:                  'left',

    /**
     * Vertical origin of transformation of an object (one of "top", "bottom", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */
    originY:                  'top',

    /**
     * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
     * @type Number
     * @default
     */
    top:                      0,

    /**
     * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
     * @type Number
     * @default
     */
    left:                     0,

    /**
     * Object width
     * @type Number
     * @default
     */
    width:                    0,

    /**
     * Object height
     * @type Number
     * @default
     */
    height:                   0,

    /**
     * Object scale factor (horizontal)
     * @type Number
     * @default
     */
    scaleX:                   1,

    /**
     * Object scale factor (vertical)
     * @type Number
     * @default
     */
    scaleY:                   1,

    /**
     * When true, an object is rendered as flipped horizontally
     * @type Boolean
     * @default
     */
    flipX:                    false,

    /**
     * When true, an object is rendered as flipped vertically
     * @type Boolean
     * @default
     */
    flipY:                    false,

    /**
     * Opacity of an object
     * @type Number
     * @default
     */
    opacity:                  1,

    /**
     * Angle of rotation of an object (in degrees)
     * @type Number
     * @default
     */
    angle:                    0,

    /**
     * Angle of skew on x axes of an object (in degrees)
     * @type Number
     * @default
     */
    skewX:                    0,

    /**
     * Angle of skew on y axes of an object (in degrees)
     * @type Number
     * @default
     */
    skewY:                    0,

    /**
     * Size of object's controlling corners (in pixels)
     * @type Number
     * @default
     */
    cornerSize:               13,

    /**
     * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
     * @type Boolean
     * @default
     */
    transparentCorners:       true,

    /**
     * Default cursor value used when hovering over this object on canvas
     * @type String
     * @default
     */
    hoverCursor:              null,

    /**
     * Default cursor value used when moving this object on canvas
     * @type String
     * @default
     */
    moveCursor:               null,

    /**
     * Padding between object and its controlling borders (in pixels)
     * @type Number
     * @default
     */
    padding:                  0,

    /**
     * Color of controlling borders of an object (when it's active)
     * @type String
     * @default
     */
    borderColor:              'rgba(102,153,255,0.75)',

    /**
     * Array specifying dash pattern of an object's borders (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */
    borderDashArray:          null,

    /**
     * Color of controlling corners of an object (when it's active)
     * @type String
     * @default
     */
    cornerColor:              'rgba(102,153,255,0.5)',

    /**
     * Color of controlling corners of an object (when it's active and transparentCorners false)
     * @since 1.6.2
     * @type String
     * @default
     */
    cornerStrokeColor:        null,

    /**
     * Specify style of control, 'rect' or 'circle'
     * @since 1.6.2
     * @type String
     */
    cornerStyle:          'rect',

    /**
     * Array specifying dash pattern of an object's control (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */
    cornerDashArray:          null,

    /**
     * When true, this object will use center point as the origin of transformation
     * when being scaled via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredScaling:          false,

    /**
     * When true, this object will use center point as the origin of transformation
     * when being rotated via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredRotation:         true,

    /**
     * Color of object's fill
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    fill:                     'rgb(0,0,0)',

    /**
     * Fill rule used to fill an object
     * accepted values are nonzero, evenodd
     * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
     * @type String
     * @default
     */
    fillRule:                 'nonzero',

    /**
     * Composite rule used for canvas globalCompositeOperation
     * @type String
     * @default
     */
    globalCompositeOperation: 'source-over',

    /**
     * Background color of an object.
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    backgroundColor:          '',

    /**
     * Selection Background color of an object. colored layer behind the object when it is active.
     * does not mix good with globalCompositeOperation methods.
     * @type String
     * @default
     */
    selectionBackgroundColor:          '',

    /**
     * When defined, an object is rendered via stroke and this property specifies its color
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    stroke:                   null,

    /**
     * Width of a stroke used to render this object
     * @type Number
     * @default
     */
    strokeWidth:              1,

    /**
     * Array specifying dash pattern of an object's stroke (stroke must be defined)
     * @type Array
     */
    strokeDashArray:          null,

    /**
     * Line offset of an object's stroke
     * @type Number
     * @default
     */
    strokeDashOffset: 0,

    /**
     * Line endings style of an object's stroke (one of "butt", "round", "square")
     * @type String
     * @default
     */
    strokeLineCap:            'butt',

    /**
     * Corner style of an object's stroke (one of "bevil", "round", "miter")
     * @type String
     * @default
     */
    strokeLineJoin:           'miter',

    /**
     * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
     * @type Number
     * @default
     */
    strokeMiterLimit:         4,

    /**
     * Shadow object representing shadow of this shape
     * @type fabric.Shadow
     * @default
     */
    shadow:                   null,

    /**
     * Opacity of object's controlling borders when object is active and moving
     * @type Number
     * @default
     */
    borderOpacityWhenMoving:  0.4,

    /**
     * Scale factor of object's controlling borders
     * bigger number will make a thicker border
     * border is 1, so this is basically a border tickness
     * since there is no way to change the border itself.
     * @type Number
     * @default
     */
    borderScaleFactor:        1,

    /**
     * Transform matrix (similar to SVG's transform matrix)
     * This property has been depreacted. Since caching and and qrDecompose this
     * property can be handled with the standard top,left,scaleX,scaleY,angle and skewX.
     * A documentation example on how to parse and merge a transformMatrix will be provided before
     * completely removing it in fabric 4.0
     * If you are starting a project now, DO NOT use it.
     * @deprecated since 3.2.0
     * @type Array
     */
    transformMatrix:          null,

    /**
     * Minimum allowed scale value of an object
     * @type Number
     * @default
     */
    minScaleLimit:            0,

    /**
     * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
     * But events still fire on it.
     * @type Boolean
     * @default
     */
    selectable:               true,

    /**
     * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
     * @type Boolean
     * @default
     */
    evented:                  true,

    /**
     * When set to `false`, an object is not rendered on canvas
     * @type Boolean
     * @default
     */
    visible:                  true,

    /**
     * When set to `false`, object's controls are not displayed and can not be used to manipulate object
     * @type Boolean
     * @default
     */
    hasControls:              true,

    /**
     * When set to `false`, object's controlling borders are not rendered
     * @type Boolean
     * @default
     */
    hasBorders:               true,

    /**
     * When set to `false`, object's controlling rotating point will not be visible or selectable
     * @type Boolean
     * @default
     */
    hasRotatingPoint:         true,

    /**
     * Offset for object's controlling rotating point (when enabled via `hasRotatingPoint`)
     * @type Number
     * @default
     */
    rotatingPointOffset:      40,

    /**
     * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
     * @type Boolean
     * @default
     */
    perPixelTargetFind:       false,

    /**
     * When `false`, default object's values are not included in its serialization
     * @type Boolean
     * @default
     */
    includeDefaultValues:     true,

    /**
     * Function that determines clipping of an object (context is passed as a first argument).
     * If you are using code minification, ctx argument can be minified/manglied you should use
     * as a workaround `var ctx = arguments[0];` in the function;
     * Note that context origin is at the object's center point (not left/top corner)
     * @deprecated since 2.0.0
     * @type Function
     */
    clipTo:                   null,

    /**
     * When `true`, object horizontal movement is locked
     * @type Boolean
     * @default
     */
    lockMovementX:            false,

    /**
     * When `true`, object vertical movement is locked
     * @type Boolean
     * @default
     */
    lockMovementY:            false,

    /**
     * When `true`, object rotation is locked
     * @type Boolean
     * @default
     */
    lockRotation:             false,

    /**
     * When `true`, object horizontal scaling is locked
     * @type Boolean
     * @default
     */
    lockScalingX:             false,

    /**
     * When `true`, object vertical scaling is locked
     * @type Boolean
     * @default
     */
    lockScalingY:             false,

    /**
     * When `true`, object non-uniform scaling is locked
     * @type Boolean
     * @default
     */
    lockUniScaling:           false,

    /**
     * When `true`, object horizontal skewing is locked
     * @type Boolean
     * @default
     */
    lockSkewingX:             false,

    /**
     * When `true`, object vertical skewing is locked
     * @type Boolean
     * @default
     */
    lockSkewingY:             false,

    /**
     * When `true`, object cannot be flipped by scaling into negative values
     * @type Boolean
     * @default
     */
    lockScalingFlip:          false,

    /**
     * When `true`, object is not exported in OBJECT/JSON
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    excludeFromExport:        false,

    /**
     * When `true`, object is cached on an additional canvas.
     * When `false`, object is not cached unless necessary ( clipPath )
     * default to true
     * @since 1.7.0
     * @type Boolean
     * @default true
     */
    objectCaching:            objectCaching,

    /**
     * When `true`, object properties are checked for cache invalidation. In some particular
     * situation you may want this to be disabled ( spray brush, very big, groups)
     * or if your application does not allow you to modify properties for groups child you want
     * to disable it for groups.
     * default to false
     * since 1.7.0
     * @type Boolean
     * @default false
     */
    statefullCache:            false,

    /**
     * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
     * too much and will be redrawn with correct details at the end of scaling.
     * this setting is performance and application dependant.
     * default to true
     * since 1.7.0
     * @type Boolean
     * @default true
     */
    noScaleCache:              true,

    /**
     * When `false`, the stoke width will scale with the object.
     * When `true`, the stroke will always match the exact pixel size entered for stroke width.
     * default to false
     * @since 2.6.0
     * @type Boolean
     * @default false
     * @type Boolean
     * @default false
     */
    strokeUniform:              false,

    /**
     * When set to `true`, object's cache will be rerendered next render call.
     * since 1.7.0
     * @type Boolean
     * @default true
     */
    dirty:                true,

    /**
     * keeps the value of the last hovered corner during mouse move.
     * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
     * It should be private, but there is no harm in using it as
     * a read-only property.
     * @type number|string|any
     * @default 0
     */
    __corner: 0,

    /**
     * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
     * @type String
     * @default
     */
    paintFirst:           'fill',

    /**
     * List of properties to consider when checking if state
     * of an object is changed (fabric.Object#hasStateChanged)
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: (
      'top left width height scaleX scaleY flipX flipY originX originY transformMatrix ' +
      'stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit ' +
      'angle opacity fill globalCompositeOperation shadow clipTo visible backgroundColor ' +
      'skewX skewY fillRule paintFirst clipPath strokeUniform'
    ).split(' '),

    /**
     * List of properties to consider when checking if cache needs refresh
     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
     * and refreshed at the next render
     * @type Array
     */
    cacheProperties: (
      'fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform' +
      ' strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath'
    ).split(' '),

    /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the object has rendered, and the context is placed in the center
     * of the object cacheCanvas.
     * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
     * @type fabric.Object
     */
    clipPath: undefined,

    /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will make the object clip to the outside of the clipPath
     * since 2.4.0
     * @type boolean
     * @default false
     */
    inverted: false,

    /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will have its top and left relative to canvas, and will
     * not be influenced by the object transform. This will make the clipPath relative
     * to the canvas, but clipping just a particular object.
     * WARNING this is beta, this feature may change or be renamed.
     * since 2.4.0
     * @type boolean
     * @default false
     */
    absolutePositioned: false,

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      if (options) {
        this.setOptions(options);
      }
    },

    /**
     * Create a the canvas used to keep the cached copy of the object
     * @private
     */
    _createCacheCanvas: function() {
      this._cacheProperties = {};
      this._cacheCanvas = fabric.util.createCanvasElement();
      this._cacheContext = this._cacheCanvas.getContext('2d');
      this._updateCacheCanvas();
      // if canvas gets created, is empty, so dirty.
      this.dirty = true;
    },

    /**
     * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
     * and each side do not cross fabric.cacheSideLimit
     * those numbers are configurable so that you can get as much detail as you want
     * making bargain with performances.
     * @param {Object} dims
     * @param {Object} dims.width width of canvas
     * @param {Object} dims.height height of canvas
     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _limitCacheSize: function(dims) {
      var perfLimitSizeTotal = fabric.perfLimitSizeTotal,
          width = dims.width, height = dims.height,
          max = fabric.maxCacheSideLimit, min = fabric.minCacheSideLimit;
      if (width <= max && height <= max && width * height <= perfLimitSizeTotal) {
        if (width < min) {
          dims.width = min;
        }
        if (height < min) {
          dims.height = min;
        }
        return dims;
      }
      var ar = width / height, limitedDims = fabric.util.limitDimsByArea(ar, perfLimitSizeTotal),
          capValue = fabric.util.capValue,
          x = capValue(min, limitedDims.x, max),
          y = capValue(min, limitedDims.y, max);
      if (width > x) {
        dims.zoomX /= width / x;
        dims.width = x;
        dims.capped = true;
      }
      if (height > y) {
        dims.zoomY /= height / y;
        dims.height = y;
        dims.capped = true;
      }
      return dims;
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @return {Object}.x width of object to be cached
     * @return {Object}.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function() {
      var objectScale = this.getTotalObjectScaling(),
          // caculate dimensions without skewing
          dim = this._getTransformedDimensions(0, 0),
          neededX = dim.x * objectScale.scaleX / this.scaleX,
          neededY = dim.y * objectScale.scaleY / this.scaleY;
      return {
        // for sure this ALIASING_LIMIT is slightly creating problem
        // in situation in which the cache canvas gets an upper limit
        // also objectScale contains already scaleX and scaleY
        width: neededX + ALIASING_LIMIT,
        height: neededY + ALIASING_LIMIT,
        zoomX: objectScale.scaleX,
        zoomY: objectScale.scaleY,
        x: neededX,
        y: neededY
      };
    },

    /**
     * Update width and height of the canvas for cache
     * returns true or false if canvas needed resize.
     * @private
     * @return {Boolean} true if the canvas has been resized
     */
    _updateCacheCanvas: function() {
      var targetCanvas = this.canvas;
      if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
        var target = targetCanvas._currentTransform.target,
            action = targetCanvas._currentTransform.action;
        if (this === target && action.slice && action.slice(0, 5) === 'scale') {
          return false;
        }
      }
      var canvas = this._cacheCanvas,
          dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
          minCacheSize = fabric.minCacheSideLimit,
          width = dims.width, height = dims.height, drawingWidth, drawingHeight,
          zoomX = dims.zoomX, zoomY = dims.zoomY,
          dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight,
          zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY,
          shouldRedraw = dimensionsChanged || zoomChanged,
          additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
      if (dimensionsChanged) {
        var canvasWidth = this._cacheCanvas.width,
            canvasHeight = this._cacheCanvas.height,
            sizeGrowing = width > canvasWidth || height > canvasHeight,
            sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) &&
              canvasWidth > minCacheSize && canvasHeight > minCacheSize;
        shouldResizeCanvas = sizeGrowing || sizeShrinking;
        if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
          additionalWidth = width * 0.1;
          additionalHeight = height * 0.1;
        }
      }
      if (shouldRedraw) {
        if (shouldResizeCanvas) {
          canvas.width = Math.ceil(width + additionalWidth);
          canvas.height = Math.ceil(height + additionalHeight);
        }
        else {
          this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
          this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
        }
        drawingWidth = dims.x / 2;
        drawingHeight = dims.y / 2;
        this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
        this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
        this.cacheWidth = width;
        this.cacheHeight = height;
        this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
        this._cacheContext.scale(zoomX, zoomY);
        this.zoomX = zoomX;
        this.zoomY = zoomY;
        return true;
      }
      return false;
    },

    /**
     * Sets object's properties from options
     * @param {Object} [options] Options object
     */
    setOptions: function(options) {
      this._setOptions(options);
      this._initGradient(options.fill, 'fill');
      this._initGradient(options.stroke, 'stroke');
      this._initClipping(options);
      this._initPattern(options.fill, 'fill');
      this._initPattern(options.stroke, 'stroke');
    },

    /**
     * Transforms context when rendering an object
     * @param {CanvasRenderingContext2D} ctx Context
     */
    transform: function(ctx) {
      var m;
      if (this.group && !this.group._transformDone) {
        m = this.calcTransformMatrix();
      }
      else {
        m = this.calcOwnMatrix();
      }
      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    },

    /**
     * Returns an object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,

          object = {
            type:                     this.type,
            version:                  fabric.version,
            originX:                  this.originX,
            originY:                  this.originY,
            left:                     toFixed(this.left, NUM_FRACTION_DIGITS),
            top:                      toFixed(this.top, NUM_FRACTION_DIGITS),
            width:                    toFixed(this.width, NUM_FRACTION_DIGITS),
            height:                   toFixed(this.height, NUM_FRACTION_DIGITS),
            fill:                     (this.fill && this.fill.toObject) ? this.fill.toObject() : this.fill,
            stroke:                   (this.stroke && this.stroke.toObject) ? this.stroke.toObject() : this.stroke,
            strokeWidth:              toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
            strokeDashArray:          this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
            strokeLineCap:            this.strokeLineCap,
            strokeDashOffset:         this.strokeDashOffset,
            strokeLineJoin:           this.strokeLineJoin,
            // TODO: add this before release
            // strokeUniform:            this.strokeUniform,
            strokeMiterLimit:         toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
            scaleX:                   toFixed(this.scaleX, NUM_FRACTION_DIGITS),
            scaleY:                   toFixed(this.scaleY, NUM_FRACTION_DIGITS),
            angle:                    toFixed(this.angle, NUM_FRACTION_DIGITS),
            flipX:                    this.flipX,
            flipY:                    this.flipY,
            opacity:                  toFixed(this.opacity, NUM_FRACTION_DIGITS),
            shadow:                   (this.shadow && this.shadow.toObject) ? this.shadow.toObject() : this.shadow,
            visible:                  this.visible,
            clipTo:                   this.clipTo && String(this.clipTo),
            backgroundColor:          this.backgroundColor,
            fillRule:                 this.fillRule,
            paintFirst:               this.paintFirst,
            globalCompositeOperation: this.globalCompositeOperation,
            transformMatrix:          this.transformMatrix ? this.transformMatrix.concat() : null,
            skewX:                    toFixed(this.skewX, NUM_FRACTION_DIGITS),
            skewY:                    toFixed(this.skewY, NUM_FRACTION_DIGITS),
          };

      if (this.clipPath) {
        object.clipPath = this.clipPath.toObject(propertiesToInclude);
        object.clipPath.inverted = this.clipPath.inverted;
        object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
      }

      fabric.util.populateWithProperties(this, object, propertiesToInclude);
      if (!this.includeDefaultValues) {
        object = this._removeDefaultValues(object);
      }

      return object;
    },

    /**
     * Returns (dataless) object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toDatalessObject: function(propertiesToInclude) {
      // will be overwritten by subclasses
      return this.toObject(propertiesToInclude);
    },

    /**
     * @private
     * @param {Object} object
     */
    _removeDefaultValues: function(object) {
      var prototype = fabric.util.getKlass(object.type).prototype,
          stateProperties = prototype.stateProperties;
      stateProperties.forEach(function(prop) {
        if (prop === 'left' || prop === 'top') {
          return;
        }
        if (object[prop] === prototype[prop]) {
          delete object[prop];
        }
        var isArray = Object.prototype.toString.call(object[prop]) === '[object Array]' &&
                      Object.prototype.toString.call(prototype[prop]) === '[object Array]';

        // basically a check for [] === []
        if (isArray && object[prop].length === 0 && prototype[prop].length === 0) {
          delete object[prop];
        }
      });

      return object;
    },

    /**
     * Returns a string representation of an instance
     * @return {String}
     */
    toString: function() {
      return '#<fabric.' + capitalize(this.type) + '>';
    },

    /**
     * Return the object scale factor counting also the group scaling
     * @return {Object} object with scaleX and scaleY properties
     */
    getObjectScaling: function() {
      var options = fabric.util.qrDecompose(this.calcTransformMatrix());
      return { scaleX: Math.abs(options.scaleX), scaleY: Math.abs(options.scaleY) };
    },

    /**
     * Return the object scale factor counting also the group scaling, zoom and retina
     * @return {Object} object with scaleX and scaleY properties
     */
    getTotalObjectScaling: function() {
      var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
      if (this.canvas) {
        var zoom = this.canvas.getZoom();
        var retina = this.canvas.getRetinaScaling();
        scaleX *= zoom * retina;
        scaleY *= zoom * retina;
      }
      return { scaleX: scaleX, scaleY: scaleY };
    },

    /**
     * Return the object opacity counting also the group property
     * @return {Number}
     */
    getObjectOpacity: function() {
      var opacity = this.opacity;
      if (this.group) {
        opacity *= this.group.getObjectOpacity();
      }
      return opacity;
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Object} thisArg
     */
    _set: function(key, value) {
      var shouldConstrainValue = (key === 'scaleX' || key === 'scaleY'),
          isChanged = this[key] !== value, groupNeedsUpdate = false;

      if (shouldConstrainValue) {
        value = this._constrainScale(value);
      }
      if (key === 'scaleX' && value < 0) {
        this.flipX = !this.flipX;
        value *= -1;
      }
      else if (key === 'scaleY' && value < 0) {
        this.flipY = !this.flipY;
        value *= -1;
      }
      else if (key === 'shadow' && value && !(value instanceof fabric.Shadow)) {
        value = new fabric.Shadow(value);
      }
      else if (key === 'dirty' && this.group) {
        this.group.set('dirty', value);
      }

      this[key] = value;

      if (isChanged) {
        groupNeedsUpdate = this.group && this.group.isOnACache();
        if (this.cacheProperties.indexOf(key) > -1) {
          this.dirty = true;
          groupNeedsUpdate && this.group.set('dirty', true);
        }
        else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) {
          this.group.set('dirty', true);
        }
      }

      return this;
    },

    /**
     * This callback function is called by the parent group of an object every
     * time a non-delegated property changes on the group. It is passed the key
     * and value as parameters. Not adding in this function's signature to avoid
     * Travis build error about unused variables.
     */
    setOnGroup: function() {
      // implemented by sub-classes, as needed.
    },

    /**
     * Retrieves viewportTransform from Object's canvas if possible
     * @method getViewportTransform
     * @memberOf fabric.Object.prototype
     * @return {Array}
     */
    getViewportTransform: function() {
      if (this.canvas && this.canvas.viewportTransform) {
        return this.canvas.viewportTransform;
      }
      return fabric.iMatrix.concat();
    },

    /*
     * @private
     * return if the object would be visible in rendering
     * @memberOf fabric.Object.prototype
     * @return {Boolean}
     */
    isNotVisible: function() {
      return this.opacity === 0 ||
        (this.width === 0 && this.height === 0 && this.strokeWidth === 0) ||
        !this.visible;
    },

    /**
     * Renders an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function(ctx) {
      // do not render if width/height are zeros or object is not visible
      if (this.isNotVisible()) {
        return;
      }
      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }
      ctx.save();
      this._setupCompositeOperation(ctx);
      this.drawSelectionBackground(ctx);
      this.transform(ctx);
      this._setOpacity(ctx);
      this._setShadow(ctx, this);
      if (this.transformMatrix) {
        ctx.transform.apply(ctx, this.transformMatrix);
      }
      this.clipTo && fabric.util.clipContext(this, ctx);
      if (this.shouldCache()) {
        this.renderCache();
        this.drawCacheOnCanvas(ctx);
      }
      else {
        this._removeCacheCanvas();
        this.dirty = false;
        this.drawObject(ctx);
        if (this.objectCaching && this.statefullCache) {
          this.saveState({ propertySet: 'cacheProperties' });
        }
      }
      this.clipTo && ctx.restore();
      ctx.restore();
    },

    renderCache: function(options) {
      options = options || {};
      if (!this._cacheCanvas) {
        this._createCacheCanvas();
      }
      if (this.isCacheDirty()) {
        this.statefullCache && this.saveState({ propertySet: 'cacheProperties' });
        this.drawObject(this._cacheContext, options.forClipping);
        this.dirty = false;
      }
    },

    /**
     * Remove cacheCanvas and its dimensions from the objects
     */
    _removeCacheCanvas: function() {
      this._cacheCanvas = null;
      this.cacheWidth = 0;
      this.cacheHeight = 0;
    },

    /**
     * return true if the object will draw a stroke
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an aproximation and be fast.
     * wrote to avoid extra caching, it has to return true when stroke happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the stroke is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasStroke: function() {
      return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
    },

    /**
     * return true if the object will draw a fill
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an aproximation and be fast.
     * wrote to avoid extra caching, it has to return true when fill happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the fill is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasFill: function() {
      return this.fill && this.fill !== 'transparent';
    },

    /**
     * When set to `true`, force the object to have its own cache, even if it is inside a group
     * it may be needed when your object behave in a particular way on the cache and always needs
     * its own isolated canvas to render correctly.
     * Created to be overridden
     * since 1.7.12
     * @returns Boolean
     */
    needsItsOwnCache: function() {
      if (this.paintFirst === 'stroke' &&
        this.hasFill() && this.hasStroke() && typeof this.shadow === 'object') {
        return true;
      }
      if (this.clipPath) {
        return true;
      }
      return false;
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
     * @return {Boolean}
     */
    shouldCache: function() {
      this.ownCaching = this.needsItsOwnCache() || (
        this.objectCaching &&
        (!this.group || !this.group.isOnACache())
      );
      return this.ownCaching;
    },

    /**
     * Check if this object or a child object will cast a shadow
     * used by Group.shouldCache to know if child has a shadow recursively
     * @return {Boolean}
     */
    willDrawShadow: function() {
      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    },

    /**
     * Execute the drawing operation for an object clipPath
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawClipPathOnCache: function(ctx) {
      var path = this.clipPath;
      ctx.save();
      // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4
      if (path.inverted) {
        ctx.globalCompositeOperation = 'destination-out';
      }
      else {
        ctx.globalCompositeOperation = 'destination-in';
      }
      //ctx.scale(1 / 2, 1 / 2);
      if (path.absolutePositioned) {
        var m = fabric.util.invertTransform(this.calcTransformMatrix());
        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      }
      path.transform(ctx);
      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
      ctx.restore();
    },

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function(ctx, forClipping) {
      var originalFill = this.fill, originalStroke = this.stroke;
      if (forClipping) {
        this.fill = 'black';
        this.stroke = '';
        this._setClippingProperties(ctx);
      }
      else {
        this._renderBackground(ctx);
        this._setStrokeStyles(ctx, this);
        this._setFillStyles(ctx, this);
      }
      this._render(ctx);
      this._drawClipPath(ctx);
      this.fill = originalFill;
      this.stroke = originalStroke;
    },

    _drawClipPath: function(ctx) {
      var path = this.clipPath;
      if (!path) { return; }
      // needed to setup a couple of variables
      // path canvas gets overridden with this one.
      // TODO find a better solution?
      path.canvas = this.canvas;
      path.shouldCache();
      path._transformDone = true;
      path.renderCache({ forClipping: true });
      this.drawClipPathOnCache(ctx);
    },

    /**
     * Paint the cached copy of the object on the target context.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawCacheOnCanvas: function(ctx) {
      ctx.scale(1 / this.zoomX, 1 / this.zoomY);
      ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    },

    /**
     * Check if cache is dirty
     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
     * on parent canvas.
     */
    isCacheDirty: function(skipCanvas) {
      if (this.isNotVisible()) {
        return false;
      }
      if (this._cacheCanvas && !skipCanvas && this._updateCacheCanvas()) {
        // in this case the context is already cleared.
        return true;
      }
      else {
        if (this.dirty ||
          (this.clipPath && this.clipPath.absolutePositioned) ||
          (this.statefullCache && this.hasStateChanged('cacheProperties'))
        ) {
          if (this._cacheCanvas && !skipCanvas) {
            var width = this.cacheWidth / this.zoomX;
            var height = this.cacheHeight / this.zoomY;
            this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
          }
          return true;
        }
      }
      return false;
    },

    /**
     * Draws a background for the object big as its untransformed dimensions
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground: function(ctx) {
      if (!this.backgroundColor) {
        return;
      }
      var dim = this._getNonTransformedDimensions();
      ctx.fillStyle = this.backgroundColor;

      ctx.fillRect(
        -dim.x / 2,
        -dim.y / 2,
        dim.x,
        dim.y
      );
      // if there is background color no other shadows
      // should be casted
      this._removeShadow(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setOpacity: function(ctx) {
      if (this.group && !this.group._transformDone) {
        ctx.globalAlpha = this.getObjectOpacity();
      }
      else {
        ctx.globalAlpha *= this.opacity;
      }
    },

    _setStrokeStyles: function(ctx, decl) {
      if (decl.stroke) {
        ctx.lineWidth = decl.strokeWidth;
        ctx.lineCap = decl.strokeLineCap;
        ctx.lineDashOffset = decl.strokeDashOffset;
        ctx.lineJoin = decl.strokeLineJoin;
        ctx.miterLimit = decl.strokeMiterLimit;
        ctx.strokeStyle = decl.stroke.toLive
          ? decl.stroke.toLive(ctx, this)
          : decl.stroke;
      }
    },

    _setFillStyles: function(ctx, decl) {
      if (decl.fill) {
        ctx.fillStyle = decl.fill.toLive
          ? decl.fill.toLive(ctx, this)
          : decl.fill;
      }
    },

    _setClippingProperties: function(ctx) {
      ctx.globalAlpha = 1;
      ctx.strokeStyle = 'transparent';
      ctx.fillStyle = '#000000';
    },

    /**
     * @private
     * Sets line dash
     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
     * @param {Array} dashArray array representing dashes
     * @param {Function} alternative function to call if browser does not support lineDash
     */
    _setLineDash: function(ctx, dashArray, alternative) {
      if (!dashArray || dashArray.length === 0) {
        return;
      }
      // Spec requires the concatenation of two copies the dash list when the number of elements is odd
      if (1 & dashArray.length) {
        dashArray.push.apply(dashArray, dashArray);
      }
      if (supportsLineDash) {
        ctx.setLineDash(dashArray);
      }
      else {
        alternative && alternative(ctx);
      }
    },

    /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     */
    _renderControls: function(ctx, styleOverride) {
      var vpt = this.getViewportTransform(),
          matrix = this.calcTransformMatrix(),
          options, drawBorders, drawControls;
      styleOverride = styleOverride || { };
      drawBorders = typeof styleOverride.hasBorders !== 'undefined' ? styleOverride.hasBorders : this.hasBorders;
      drawControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls;
      matrix = fabric.util.multiplyTransformMatrices(vpt, matrix);
      options = fabric.util.qrDecompose(matrix);
      ctx.save();
      ctx.translate(options.translateX, options.translateY);
      ctx.lineWidth = 1 * this.borderScaleFactor;
      if (!this.group) {
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      }
      if (styleOverride.forActiveSelection) {
        ctx.rotate(degreesToRadians(options.angle));
        drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
      }
      else {
        ctx.rotate(degreesToRadians(this.angle));
        drawBorders && this.drawBorders(ctx, styleOverride);
      }
      drawControls && this.drawControls(ctx, styleOverride);
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setShadow: function(ctx) {
      if (!this.shadow) {
        return;
      }

      var shadow = this.shadow, canvas = this.canvas, scaling,
          multX = (canvas && canvas.viewportTransform[0]) || 1,
          multY = (canvas && canvas.viewportTransform[3]) || 1;
      if (shadow.nonScaling) {
        scaling = { scaleX: 1, scaleY: 1 };
      }
      else {
        scaling = this.getObjectScaling();
      }
      if (canvas && canvas._isRetinaScaling()) {
        multX *= fabric.devicePixelRatio;
        multY *= fabric.devicePixelRatio;
      }
      ctx.shadowColor = shadow.color;
      ctx.shadowBlur = shadow.blur * fabric.browserShadowBlurConstant *
        (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
      ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
      ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _removeShadow: function(ctx) {
      if (!this.shadow) {
        return;
      }

      ctx.shadowColor = '';
      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} filler fabric.Pattern or fabric.Gradient
     * @return {Object} offset.offsetX offset for text rendering
     * @return {Object} offset.offsetY offset for text rendering
     */
    _applyPatternGradientTransform: function(ctx, filler) {
      if (!filler || !filler.toLive) {
        return { offsetX: 0, offsetY: 0 };
      }
      var t = filler.gradientTransform || filler.patternTransform;
      var offsetX = -this.width / 2 + filler.offsetX || 0,
          offsetY = -this.height / 2 + filler.offsetY || 0;

      if (filler.gradientUnits === 'percentage') {
        ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
      }
      else {
        ctx.transform(1, 0, 0, 1, offsetX, offsetY);
      }
      if (t) {
        ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
      }
      return { offsetX: offsetX, offsetY: offsetY };
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderPaintInOrder: function(ctx) {
      if (this.paintFirst === 'stroke') {
        this._renderStroke(ctx);
        this._renderFill(ctx);
      }
      else {
        this._renderFill(ctx);
        this._renderStroke(ctx);
      }
    },

    /**
     * @private
     * function that actually render something on the context.
     * empty here to allow Obects to work on tests to benchmark fabric functionalites
     * not related to rendering
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(/* ctx */) {

    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderFill: function(ctx) {
      if (!this.fill) {
        return;
      }

      ctx.save();
      this._applyPatternGradientTransform(ctx, this.fill);
      if (this.fillRule === 'evenodd') {
        ctx.fill('evenodd');
      }
      else {
        ctx.fill();
      }
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderStroke: function(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }

      ctx.save();
      if (this.strokeUniform && this.group) {
        var scaling = this.getObjectScaling();
        ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
      }
      else if (this.strokeUniform) {
        ctx.scale(1 / this.scaleX, 1 / this.scaleY);
      }
      this._setLineDash(ctx, this.strokeDashArray, this._renderDashedStroke);
      if (this.stroke.toLive && this.stroke.gradientUnits === 'percentage') {
        // need to transform gradient in a pattern.
        // this is a slow process. If you are hitting this codepath, and the object
        // is not using caching, you should consider switching it on.
        // we need a canvas as big as the current object caching canvas.
        this._applyPatternForTransformedGradient(ctx, this.stroke);
      }
      else {
        this._applyPatternGradientTransform(ctx, this.stroke);
      }
      ctx.stroke();
      ctx.restore();
    },

    /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drwabacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Gradient} filler a fabric gradient instance
     */
    _applyPatternForTransformedGradient: function(ctx, filler) {
      var dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
          pCanvas = fabric.util.createCanvasElement(), pCtx, retinaScaling = this.canvas.getRetinaScaling(),
          width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling;
      pCanvas.width = width;
      pCanvas.height = height;
      pCtx = pCanvas.getContext('2d');
      pCtx.beginPath(); pCtx.moveTo(0, 0); pCtx.lineTo(width, 0); pCtx.lineTo(width, height);
      pCtx.lineTo(0, height); pCtx.closePath();
      pCtx.translate(width / 2, height / 2);
      pCtx.scale(
        dims.zoomX / this.scaleX / retinaScaling,
        dims.zoomY / this.scaleY / retinaScaling
      );
      this._applyPatternGradientTransform(pCtx, filler);
      pCtx.fillStyle = filler.toLive(ctx);
      pCtx.fill();
      ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
      ctx.scale(
        retinaScaling * this.scaleX / dims.zoomX,
        retinaScaling * this.scaleY / dims.zoomY
      );
      ctx.strokeStyle = pCtx.createPattern(pCanvas, 'no-repeat');
    },

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */
    _findCenterFromElement: function() {
      return { x: this.left + this.width / 2, y: this.top + this.height / 2 };
    },

    /**
     * This function is an helper for svg import. it decompose the transformMatrix
     * and assign properties to object.
     * untransformed coordinates
     * @private
     * @chainable
     */
    _assignTransformMatrixProps: function() {
      if (this.transformMatrix) {
        var options = fabric.util.qrDecompose(this.transformMatrix);
        this.flipX = false;
        this.flipY = false;
        this.set('scaleX', options.scaleX);
        this.set('scaleY', options.scaleY);
        this.angle = options.angle;
        this.skewX = options.skewX;
        this.skewY = 0;
      }
    },

    /**
     * This function is an helper for svg import. it removes the transform matrix
     * and set to object properties that fabricjs can handle
     * @private
     * @param {Object} preserveAspectRatioOptions
     * @return {thisArg}
     */
    _removeTransformMatrix: function(preserveAspectRatioOptions) {
      var center = this._findCenterFromElement();
      if (this.transformMatrix) {
        this._assignTransformMatrixProps();
        center = fabric.util.transformPoint(center, this.transformMatrix);
      }
      this.transformMatrix = null;
      if (preserveAspectRatioOptions) {
        this.scaleX *= preserveAspectRatioOptions.scaleX;
        this.scaleY *= preserveAspectRatioOptions.scaleY;
        this.cropX = preserveAspectRatioOptions.cropX;
        this.cropY = preserveAspectRatioOptions.cropY;
        center.x += preserveAspectRatioOptions.offsetLeft;
        center.y += preserveAspectRatioOptions.offsetTop;
        this.width = preserveAspectRatioOptions.width;
        this.height = preserveAspectRatioOptions.height;
      }
      this.setPositionByOrigin(center, 'center', 'center');
    },

    /**
     * Clones an instance, using a callback method will work for every object.
     * @param {Function} callback Callback is invoked with a clone as a first argument
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     */
    clone: function(callback, propertiesToInclude) {
      var objectForm = this.toObject(propertiesToInclude);
      if (this.constructor.fromObject) {
        this.constructor.fromObject(objectForm, callback);
      }
      else {
        fabric.Object._fromObject('Object', objectForm, callback);
      }
    },

    /**
     * Creates an instance of fabric.Image out of an object
     * could make use of both toDataUrl or toCanvasElement.
     * @param {Function} callback callback, invoked with an instance as a first argument
     * @param {Object} [options] for clone as image, passed to toDataURL
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {fabric.Object} thisArg
     */
    cloneAsImage: function(callback, options) {
      var canvasEl = this.toCanvasElement(options);
      if (callback) {
        callback(new fabric.Image(canvasEl));
      }
      return this;
    },

    /**
     * Converts an object into a HTMLCanvas element
     * @param {Object} options Options object
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {HTMLCanvasElement} Returns DOM element <canvas> with the fabric.Object
     */
    toCanvasElement: function(options) {
      options || (options = { });

      var utils = fabric.util, origParams = utils.saveObjectTransform(this),
          originalGroup = this.group,
          originalShadow = this.shadow, abs = Math.abs,
          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.devicePixelRatio : 1);
      delete this.group;
      if (options.withoutTransform) {
        utils.resetObjectTransform(this);
      }
      if (options.withoutShadow) {
        this.shadow = null;
      }

      var el = fabric.util.createCanvasElement(),
          // skip canvas zoom and calculate with setCoords now.
          boundingRect = this.getBoundingRect(true, true),
          shadow = this.shadow, scaling,
          shadowOffset = { x: 0, y: 0 }, shadowBlur,
          width, height;

      if (shadow) {
        shadowBlur = shadow.blur;
        if (shadow.nonScaling) {
          scaling = { scaleX: 1, scaleY: 1 };
        }
        else {
          scaling = this.getObjectScaling();
        }
        // consider non scaling shadow.
        shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * (abs(scaling.scaleX));
        shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * (abs(scaling.scaleY));
      }
      width = boundingRect.width + shadowOffset.x;
      height = boundingRect.height + shadowOffset.y;
      // if the current width/height is not an integer
      // we need to make it so.
      el.width = Math.ceil(width);
      el.height = Math.ceil(height);
      var canvas = new fabric.StaticCanvas(el, {
        enableRetinaScaling: false,
        renderOnAddRemove: false,
        skipOffscreen: false,
      });
      if (options.format === 'jpeg') {
        canvas.backgroundColor = '#fff';
      }
      this.setPositionByOrigin(new fabric.Point(canvas.width / 2, canvas.height / 2), 'center', 'center');

      var originalCanvas = this.canvas;
      canvas.add(this);
      var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
      this.shadow = originalShadow;
      this.set('canvas', originalCanvas);
      if (originalGroup) {
        this.group = originalGroup;
      }
      this.set(origParams).setCoords();
      // canvas.dispose will call image.dispose that will nullify the elements
      // since this canvas is a simple element for the process, we remove references
      // to objects in this way in order to avoid object trashing.
      canvas._objects = [];
      canvas.dispose();
      canvas = null;

      return canvasEl;
    },

    /**
     * Converts an object into a data-url-like string
     * @param {Object} options Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     */
    toDataURL: function(options) {
      options || (options = { });
      return fabric.util.toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
    },

    /**
     * Returns true if specified type is identical to the type of an instance
     * @param {String} type Type to check against
     * @return {Boolean}
     */
    isType: function(type) {
      return this.type === type;
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance (is 1 unless subclassed)
     */
    complexity: function() {
      return 1;
    },

    /**
     * Returns a JSON representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} JSON
     */
    toJSON: function(propertiesToInclude) {
      // delegate, not alias
      return this.toObject(propertiesToInclude);
    },

    /**
     * Sets gradient (fill or stroke) of an object
     * percentages for x1,x2,y1,y2,r1,r2 together with gradientUnits 'pixels', are not supported.
     * <b>Backwards incompatibility note:</b> This method was named "setGradientFill" until v1.1.0
     * @param {String} property Property name 'stroke' or 'fill'
     * @param {Object} [options] Options object
     * @param {String} [options.type] Type of gradient 'radial' or 'linear'
     * @param {Number} [options.x1=0] x-coordinate of start point
     * @param {Number} [options.y1=0] y-coordinate of start point
     * @param {Number} [options.x2=0] x-coordinate of end point
     * @param {Number} [options.y2=0] y-coordinate of end point
     * @param {Number} [options.r1=0] Radius of start point (only for radial gradients)
     * @param {Number} [options.r2=0] Radius of end point (only for radial gradients)
     * @param {Object} [options.colorStops] Color stops object eg. {0: 'ff0000', 1: '000000'}
     * @param {Object} [options.gradientTransform] transformMatrix for gradient
     * @return {fabric.Object} thisArg
     * @chainable
     * @deprecated since 3.4.0
     * @see {@link http://jsfiddle.net/fabricjs/58y8b/|jsFiddle demo}
     * @example <caption>Set linear gradient</caption>
     * object.setGradient('fill', {
     *   type: 'linear',
     *   x1: -object.width / 2,
     *   y1: 0,
     *   x2: object.width / 2,
     *   y2: 0,
     *   colorStops: {
     *     0: 'red',
     *     0.5: '#005555',
     *     1: 'rgba(0,0,255,0.5)'
     *   }
     * });
     * canvas.renderAll();
     * @example <caption>Set radial gradient</caption>
     * object.setGradient('fill', {
     *   type: 'radial',
     *   x1: 0,
     *   y1: 0,
     *   x2: 0,
     *   y2: 0,
     *   r1: object.width / 2,
     *   r2: 10,
     *   colorStops: {
     *     0: 'red',
     *     0.5: '#005555',
     *     1: 'rgba(0,0,255,0.5)'
     *   }
     * });
     * canvas.renderAll();
     */
    setGradient: function(property, options) {
      options || (options = { });

      var gradient = { colorStops: [] };

      gradient.type = options.type || (options.r1 || options.r2 ? 'radial' : 'linear');
      gradient.coords = {
        x1: options.x1,
        y1: options.y1,
        x2: options.x2,
        y2: options.y2
      };
      gradient.gradientUnits = options.gradientUnits || 'pixels';
      if (options.r1 || options.r2) {
        gradient.coords.r1 = options.r1;
        gradient.coords.r2 = options.r2;
      }

      gradient.gradientTransform = options.gradientTransform;
      fabric.Gradient.prototype.addColorStop.call(gradient, options.colorStops);

      return this.set(property, fabric.Gradient.forObject(this, gradient));
    },

    /**
     * Sets pattern fill of an object
     * @param {Object} options Options object
     * @param {(String|HTMLImageElement)} options.source Pattern source
     * @param {String} [options.repeat=repeat] Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
     * @param {Number} [options.offsetX=0] Pattern horizontal offset from object's left/top corner
     * @param {Number} [options.offsetY=0] Pattern vertical offset from object's left/top corner
     * @param {Function} [callback] Callback to invoke when image set as a pattern
     * @return {fabric.Object} thisArg
     * @chainable
     * @deprecated since 3.5.0
     * @see {@link http://jsfiddle.net/fabricjs/QT3pa/|jsFiddle demo}
     * @example <caption>Set pattern</caption>
     * object.setPatternFill({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat'
     * },canvas.renderAll.bind(canvas));
     */
    setPatternFill: function(options, callback) {
      return this.set('fill', new fabric.Pattern(options, callback));
    },

    /**
     * Sets {@link fabric.Object#shadow|shadow} of an object
     * @param {Object|String} [options] Options object or string (e.g. "2px 2px 10px rgba(0,0,0,0.2)")
     * @param {String} [options.color=rgb(0,0,0)] Shadow color
     * @param {Number} [options.blur=0] Shadow blur
     * @param {Number} [options.offsetX=0] Shadow horizontal offset
     * @param {Number} [options.offsetY=0] Shadow vertical offset
     * @return {fabric.Object} thisArg
     * @chainable
     * @deprecated since 3.5.0
     * @see {@link http://jsfiddle.net/fabricjs/7gvJG/|jsFiddle demo}
     * @example <caption>Set shadow with string notation</caption>
     * object.setShadow('2px 2px 10px rgba(0,0,0,0.2)');
     * canvas.renderAll();
     * @example <caption>Set shadow with object notation</caption>
     * object.setShadow({
     *   color: 'red',
     *   blur: 10,
     *   offsetX: 20,
     *   offsetY: 20
     * });
     * canvas.renderAll();
     */
    setShadow: function(options) {
      return this.set('shadow', options ? new fabric.Shadow(options) : null);
    },

    /**
     * Sets "color" of an instance (alias of `set('fill', &hellip;)`)
     * @param {String} color Color value
     * @return {fabric.Object} thisArg
     * @deprecated since 3.5.0
     * @chainable
     */
    setColor: function(color) {
      this.set('fill', color);
      return this;
    },

    /**
     * Sets "angle" of an instance with centered rotation
     * @param {Number} angle Angle value (in degrees)
     * @return {fabric.Object} thisArg
     * @chainable
     */
    rotate: function(angle) {
      var shouldCenterOrigin = (this.originX !== 'center' || this.originY !== 'center') && this.centeredRotation;

      if (shouldCenterOrigin) {
        this._setOriginToCenter();
      }

      this.set('angle', angle);

      if (shouldCenterOrigin) {
        this._resetOrigin();
      }

      return this;
    },

    /**
     * Centers object horizontally on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    centerH: function () {
      this.canvas && this.canvas.centerObjectH(this);
      return this;
    },

    /**
     * Centers object horizontally on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenterH: function () {
      this.canvas && this.canvas.viewportCenterObjectH(this);
      return this;
    },

    /**
     * Centers object vertically on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    centerV: function () {
      this.canvas && this.canvas.centerObjectV(this);
      return this;
    },

    /**
     * Centers object vertically on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenterV: function () {
      this.canvas && this.canvas.viewportCenterObjectV(this);
      return this;
    },

    /**
     * Centers object vertically and horizontally on canvas to which is was added last
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    center: function () {
      this.canvas && this.canvas.centerObject(this);
      return this;
    },

    /**
     * Centers object on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenter: function () {
      this.canvas && this.canvas.viewportCenterObject(this);
      return this;
    },

    /**
     * Returns coordinates of a pointer relative to an object
     * @param {Event} e Event to operate upon
     * @param {Object} [pointer] Pointer to operate upon (instead of event)
     * @return {Object} Coordinates of a pointer (x, y)
     */
    getLocalPointer: function(e, pointer) {
      pointer = pointer || this.canvas.getPointer(e);
      var pClicked = new fabric.Point(pointer.x, pointer.y),
          objectLeftTop = this._getLeftTopCoords();
      if (this.angle) {
        pClicked = fabric.util.rotatePoint(
          pClicked, objectLeftTop, degreesToRadians(-this.angle));
      }
      return {
        x: pClicked.x - objectLeftTop.x,
        y: pClicked.y - objectLeftTop.y
      };
    },

    /**
     * Sets canvas globalCompositeOperation for specific object
     * custom composition operation for the particular object can be specified using globalCompositeOperation property
     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
     */
    _setupCompositeOperation: function (ctx) {
      if (this.globalCompositeOperation) {
        ctx.globalCompositeOperation = this.globalCompositeOperation;
      }
    }
  });

  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Object);

  extend(fabric.Object.prototype, fabric.Observable);

  /**
   * Defines the number of fraction digits to use when serializing object values.
   * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
   * @static
   * @memberOf fabric.Object
   * @constant
   * @type Number
   */
  fabric.Object.NUM_FRACTION_DIGITS = 2;

  fabric.Object._fromObject = function(className, object, callback, extraParam) {
    var klass = fabric[className];
    object = clone(object, true);
    fabric.util.enlivenPatterns([object.fill, object.stroke], function(patterns) {
      if (typeof patterns[0] !== 'undefined') {
        object.fill = patterns[0];
      }
      if (typeof patterns[1] !== 'undefined') {
        object.stroke = patterns[1];
      }
      fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
        object.clipPath = enlivedProps[0];
        var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
        callback && callback(instance);
      });
    });
  };

  /**
   * Unique id used internally when creating SVG elements
   * @static
   * @memberOf fabric.Object
   * @type Number
   */
  fabric.Object.__uid = 0;
})(typeof exports !== 'undefined' ? exports : this);


(function() {

  var degreesToRadians = fabric.util.degreesToRadians,
      originXOffset = {
        left: -0.5,
        center: 0,
        right: 0.5
      },
      originYOffset = {
        top: -0.5,
        center: 0,
        bottom: 0.5
      };

  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

    /**
     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToGivenOrigin: function(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
      var x = point.x,
          y = point.y,
          offsetX, offsetY, dim;

      if (typeof fromOriginX === 'string') {
        fromOriginX = originXOffset[fromOriginX];
      }
      else {
        fromOriginX -= 0.5;
      }

      if (typeof toOriginX === 'string') {
        toOriginX = originXOffset[toOriginX];
      }
      else {
        toOriginX -= 0.5;
      }

      offsetX = toOriginX - fromOriginX;

      if (typeof fromOriginY === 'string') {
        fromOriginY = originYOffset[fromOriginY];
      }
      else {
        fromOriginY -= 0.5;
      }

      if (typeof toOriginY === 'string') {
        toOriginY = originYOffset[toOriginY];
      }
      else {
        toOriginY -= 0.5;
      }

      offsetY = toOriginY - fromOriginY;

      if (offsetX || offsetY) {
        dim = this._getTransformedDimensions();
        x = point.x + offsetX * dim.x;
        y = point.y + offsetY * dim.y;
      }

      return new fabric.Point(x, y);
    },

    /**
     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToCenterPoint: function(point, originX, originY) {
      var p = this.translateToGivenOrigin(point, originX, originY, 'center', 'center');
      if (this.angle) {
        return fabric.util.rotatePoint(p, point, degreesToRadians(this.angle));
      }
      return p;
    },

    /**
     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
     * @param {fabric.Point} center The point which corresponds to center of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToOriginPoint: function(center, originX, originY) {
      var p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
      if (this.angle) {
        return fabric.util.rotatePoint(p, center, degreesToRadians(this.angle));
      }
      return p;
    },

    /**
     * Returns the real center coordinates of the object
     * @return {fabric.Point}
     */
    getCenterPoint: function() {
      var leftTop = new fabric.Point(this.left, this.top);
      return this.translateToCenterPoint(leftTop, this.originX, this.originY);
    },

    /**
     * Returns the coordinates of the object based on center coordinates
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @return {fabric.Point}
     */
    // getOriginPoint: function(center) {
    //   return this.translateToOriginPoint(center, this.originX, this.originY);
    // },

    /**
     * Returns the coordinates of the object as if it has a different origin
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    getPointByOrigin: function(originX, originY) {
      var center = this.getCenterPoint();
      return this.translateToOriginPoint(center, originX, originY);
    },

    /**
     * Returns the point in local coordinates
     * @param {fabric.Point} point The point relative to the global coordinate system
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    toLocalPoint: function(point, originX, originY) {
      var center = this.getCenterPoint(),
          p, p2;

      if (typeof originX !== 'undefined' && typeof originY !== 'undefined' ) {
        p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
      }
      else {
        p = new fabric.Point(this.left, this.top);
      }

      p2 = new fabric.Point(point.x, point.y);
      if (this.angle) {
        p2 = fabric.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
      }
      return p2.subtractEquals(p);
    },

    /**
     * Returns the point in global coordinates
     * @param {fabric.Point} The point relative to the local coordinate system
     * @return {fabric.Point}
     */
    // toGlobalPoint: function(point) {
    //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
    // },

    /**
     * Sets the position of the object taking into consideration the object's origin
     * @param {fabric.Point} pos The new position of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {void}
     */
    setPositionByOrigin: function(pos, originX, originY) {
      var center = this.translateToCenterPoint(pos, originX, originY),
          position = this.translateToOriginPoint(center, this.originX, this.originY);
      this.set('left', position.x);
      this.set('top', position.y);
    },

    /**
     * @param {String} to One of 'left', 'center', 'right'
     */
    adjustPosition: function(to) {
      var angle = degreesToRadians(this.angle),
          hypotFull = this.getScaledWidth(),
          xFull = fabric.util.cos(angle) * hypotFull,
          yFull = fabric.util.sin(angle) * hypotFull,
          offsetFrom, offsetTo;

      //TODO: this function does not consider mixed situation like top, center.
      if (typeof this.originX === 'string') {
        offsetFrom = originXOffset[this.originX];
      }
      else {
        offsetFrom = this.originX - 0.5;
      }
      if (typeof to === 'string') {
        offsetTo = originXOffset[to];
      }
      else {
        offsetTo = to - 0.5;
      }
      this.left += xFull * (offsetTo - offsetFrom);
      this.top += yFull * (offsetTo - offsetFrom);
      this.setCoords();
      this.originX = to;
    },

    /**
     * Sets the origin/position of the object to it's center point
     * @private
     * @return {void}
     */
    _setOriginToCenter: function() {
      this._originalOriginX = this.originX;
      this._originalOriginY = this.originY;

      var center = this.getCenterPoint();

      this.originX = 'center';
      this.originY = 'center';

      this.left = center.x;
      this.top = center.y;
    },

    /**
     * Resets the origin/position of the object to it's original origin
     * @private
     * @return {void}
     */
    _resetOrigin: function() {
      var originPoint = this.translateToOriginPoint(
        this.getCenterPoint(),
        this._originalOriginX,
        this._originalOriginY);

      this.originX = this._originalOriginX;
      this.originY = this._originalOriginY;

      this.left = originPoint.x;
      this.top = originPoint.y;

      this._originalOriginX = null;
      this._originalOriginY = null;
    },

    /**
     * @private
     */
    _getLeftTopCoords: function() {
      return this.translateToOriginPoint(this.getCenterPoint(), 'left', 'top');
    },
  });

})();


(function() {

  function getCoords(coords) {
    return [
      new fabric.Point(coords.tl.x, coords.tl.y),
      new fabric.Point(coords.tr.x, coords.tr.y),
      new fabric.Point(coords.br.x, coords.br.y),
      new fabric.Point(coords.bl.x, coords.bl.y)
    ];
  }

  var degreesToRadians = fabric.util.degreesToRadians,
      multiplyMatrices = fabric.util.multiplyTransformMatrices,
      transformPoint = fabric.util.transformPoint;

  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

    /**
     * Describe object's corner position in canvas element coordinates.
     * properties are tl,mt,tr,ml,mr,bl,mb,br,mtr for the main controls.
     * each property is an object with x, y and corner.
     * The `corner` property contains in a similar manner the 4 points of the
     * interactive area of the corner.
     * The coordinates depends from this properties: width, height, scaleX, scaleY
     * skewX, skewY, angle, strokeWidth, viewportTransform, top, left, padding.
     * The coordinates get updated with @method setCoords.
     * You can calculate them without updating with @method calcCoords;
     * @memberOf fabric.Object.prototype
     */
    oCoords: null,

    /**
     * Describe object's corner position in canvas object absolute coordinates
     * properties are tl,tr,bl,br and describe the four main corner.
     * each property is an object with x, y, instance of Fabric.Point.
     * The coordinates depends from this properties: width, height, scaleX, scaleY
     * skewX, skewY, angle, strokeWidth, top, left.
     * Those coordinates are useful to understand where an object is. They get updated
     * with oCoords but they do not need to be updated when zoom or panning change.
     * The coordinates get updated with @method setCoords.
     * You can calculate them without updating with @method calcCoords(true);
     * @memberOf fabric.Object.prototype
     */
    aCoords: null,

    /**
     * storage for object transform matrix
     */
    ownMatrixCache: null,

    /**
     * storage for object full transform matrix
     */
    matrixCache: null,

    /**
     * return correct set of coordinates for intersection
     */
    getCoords: function(absolute, calculate) {
      if (!this.oCoords) {
        this.setCoords();
      }
      var coords = absolute ? this.aCoords : this.oCoords;
      return getCoords(calculate ? this.calcCoords(absolute) : coords);
    },

    /**
     * Checks if object intersects with an area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with an area formed by 2 points
     */
    intersectsWithRect: function(pointTL, pointBR, absolute, calculate) {
      var coords = this.getCoords(absolute, calculate),
          intersection = fabric.Intersection.intersectPolygonRectangle(
            coords,
            pointTL,
            pointBR
          );
      return intersection.status === 'Intersection';
    },

    /**
     * Checks if object intersects with another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with another object
     */
    intersectsWithObject: function(other, absolute, calculate) {
      var intersection = fabric.Intersection.intersectPolygonPolygon(
        this.getCoords(absolute, calculate),
        other.getCoords(absolute, calculate)
      );

      return intersection.status === 'Intersection'
        || other.isContainedWithinObject(this, absolute, calculate)
        || this.isContainedWithinObject(other, absolute, calculate);
    },

    /**
     * Checks if object is fully contained within area of another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area of another object
     */
    isContainedWithinObject: function(other, absolute, calculate) {
      var points = this.getCoords(absolute, calculate),
          i = 0, lines = other._getImageLines(
            calculate ? other.calcCoords(absolute) : absolute ? other.aCoords : other.oCoords
          );
      for (; i < 4; i++) {
        if (!other.containsPoint(points[i], lines)) {
          return false;
        }
      }
      return true;
    },

    /**
     * Checks if object is fully contained within area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area formed by 2 points
     */
    isContainedWithinRect: function(pointTL, pointBR, absolute, calculate) {
      var boundingRect = this.getBoundingRect(absolute, calculate);

      return (
        boundingRect.left >= pointTL.x &&
        boundingRect.left + boundingRect.width <= pointBR.x &&
        boundingRect.top >= pointTL.y &&
        boundingRect.top + boundingRect.height <= pointBR.y
      );
    },

    /**
     * Checks if point is inside the object
     * @param {fabric.Point} point Point to check against
     * @param {Object} [lines] object returned from @method _getImageLines
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if point is inside the object
     */
    containsPoint: function(point, lines, absolute, calculate) {
      var lines = lines || this._getImageLines(
            calculate ? this.calcCoords(absolute) : absolute ? this.aCoords : this.oCoords
          ),
          xPoints = this._findCrossPoints(point, lines);

      // if xPoints is odd then point is inside the object
      return (xPoints !== 0 && xPoints % 2 === 1);
    },

    /**
     * Checks if object is contained within the canvas with current viewportTransform
     * the check is done stopping at first point that appears on screen
     * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
     * @return {Boolean} true if object is fully or partially contained within canvas
     */
    isOnScreen: function(calculate) {
      if (!this.canvas) {
        return false;
      }
      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
      var points = this.getCoords(true, calculate), point;
      for (var i = 0; i < 4; i++) {
        point = points[i];
        if (point.x <= pointBR.x && point.x >= pointTL.x && point.y <= pointBR.y && point.y >= pointTL.y) {
          return true;
        }
      }
      // no points on screen, check intersection with absolute coordinates
      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
        return true;
      }
      return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
    },

    /**
     * Checks if the object contains the midpoint between canvas extremities
     * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
     * @private
     * @param {Fabric.Point} pointTL Top Left point
     * @param {Fabric.Point} pointBR Top Right point
     * @param {Boolean} calculate use coordinates of current position instead of .oCoords
     * @return {Boolean} true if the object contains the point
     */
    _containsCenterOfCanvas: function(pointTL, pointBR, calculate) {
      // worst case scenario the object is so big that contains the screen
      var centerPoint = { x: (pointTL.x + pointBR.x) / 2, y: (pointTL.y + pointBR.y) / 2 };
      if (this.containsPoint(centerPoint, null, true, calculate)) {
        return true;
      }
      return false;
    },

    /**
     * Checks if object is partially contained within the canvas with current viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is partially contained within canvas
     */
    isPartiallyOnScreen: function(calculate) {
      if (!this.canvas) {
        return false;
      }
      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
        return true;
      }
      return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
    },

    /**
     * Method that returns an object with the object edges in it, given the coordinates of the corners
     * @private
     * @param {Object} oCoords Coordinates of the object corners
     */
    _getImageLines: function(oCoords) {
      return {
        topline: {
          o: oCoords.tl,
          d: oCoords.tr
        },
        rightline: {
          o: oCoords.tr,
          d: oCoords.br
        },
        bottomline: {
          o: oCoords.br,
          d: oCoords.bl
        },
        leftline: {
          o: oCoords.bl,
          d: oCoords.tl
        }
      };
    },

    /**
     * Helper method to determine how many cross points are between the 4 object edges
     * and the horizontal line determined by a point on canvas
     * @private
     * @param {fabric.Point} point Point to check
     * @param {Object} lines Coordinates of the object being evaluated
     */
    // remove yi, not used but left code here just in case.
    _findCrossPoints: function(point, lines) {
      var b1, b2, a1, a2, xi, // yi,
          xcount = 0,
          iLine;

      for (var lineKey in lines) {
        iLine = lines[lineKey];
        // optimisation 1: line below point. no cross
        if ((iLine.o.y < point.y) && (iLine.d.y < point.y)) {
          continue;
        }
        // optimisation 2: line above point. no cross
        if ((iLine.o.y >= point.y) && (iLine.d.y >= point.y)) {
          continue;
        }
        // optimisation 3: vertical line case
        if ((iLine.o.x === iLine.d.x) && (iLine.o.x >= point.x)) {
          xi = iLine.o.x;
          // yi = point.y;
        }
        // calculate the intersection point
        else {
          b1 = 0;
          b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
          a1 = point.y - b1 * point.x;
          a2 = iLine.o.y - b2 * iLine.o.x;

          xi = -(a1 - a2) / (b1 - b2);
          // yi = a1 + b1 * xi;
        }
        // dont count xi < point.x cases
        if (xi >= point.x) {
          xcount += 1;
        }
        // optimisation 4: specific for square images
        if (xcount === 2) {
          break;
        }
      }
      return xcount;
    },

    /**
     * Returns coordinates of object's bounding rectangle (left, top, width, height)
     * the box is intended as aligned to axis of canvas.
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
     * @return {Object} Object with left, top, width, height properties
     */
    getBoundingRect: function(absolute, calculate) {
      var coords = this.getCoords(absolute, calculate);
      return fabric.util.makeBoundingBoxFromPoints(coords);
    },

    /**
     * Returns width of an object's bounding box counting transformations
     * before 2.0 it was named getWidth();
     * @return {Number} width value
     */
    getScaledWidth: function() {
      return this._getTransformedDimensions().x;
    },

    /**
     * Returns height of an object bounding box counting transformations
     * before 2.0 it was named getHeight();
     * @return {Number} height value
     */
    getScaledHeight: function() {
      return this._getTransformedDimensions().y;
    },

    /**
     * Makes sure the scale is valid and modifies it if necessary
     * @private
     * @param {Number} value
     * @return {Number}
     */
    _constrainScale: function(value) {
      if (Math.abs(value) < this.minScaleLimit) {
        if (value < 0) {
          return -this.minScaleLimit;
        }
        else {
          return this.minScaleLimit;
        }
      }
      else if (value === 0) {
        return 0.0001;
      }
      return value;
    },

    /**
     * Scales an object (equally by x and y)
     * @param {Number} value Scale factor
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scale: function(value) {
      this._set('scaleX', value);
      this._set('scaleY', value);
      return this.setCoords();
    },

    /**
     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New width value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scaleToWidth: function(value, absolute) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
      return this.scale(value / this.width / boundingRectFactor);
    },

    /**
     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New height value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scaleToHeight: function(value, absolute) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
      return this.scale(value / this.height / boundingRectFactor);
    },

    /**
     * Calculates and returns the .coords of an object.
     * @return {Object} Object with tl, tr, br, bl ....
     * @chainable
     */
    calcCoords: function(absolute) {
      var rotateMatrix = this._calcRotateMatrix(),
          translateMatrix = this._calcTranslateMatrix(),
          startMatrix = multiplyMatrices(translateMatrix, rotateMatrix),
          vpt = this.getViewportTransform(),
          finalMatrix = absolute ? startMatrix : multiplyMatrices(vpt, startMatrix),
          dim = this._getTransformedDimensions(),
          w = dim.x / 2, h = dim.y / 2,
          tl = transformPoint({ x: -w, y: -h }, finalMatrix),
          tr = transformPoint({ x: w, y: -h }, finalMatrix),
          bl = transformPoint({ x: -w, y: h }, finalMatrix),
          br = transformPoint({ x: w, y: h }, finalMatrix);
      if (!absolute) {
        var padding = this.padding, angle = degreesToRadians(this.angle),
            cos = fabric.util.cos(angle), sin = fabric.util.sin(angle),
            cosP = cos * padding, sinP = sin * padding, cosPSinP = cosP + sinP,
            cosPMinusSinP = cosP - sinP;
        if (padding) {
          tl.x -= cosPMinusSinP;
          tl.y -= cosPSinP;
          tr.x += cosPSinP;
          tr.y -= cosPMinusSinP;
          bl.x -= cosPSinP;
          bl.y += cosPMinusSinP;
          br.x += cosPMinusSinP;
          br.y += cosPSinP;
        }
        var ml  = new fabric.Point((tl.x + bl.x) / 2, (tl.y + bl.y) / 2),
            mt  = new fabric.Point((tr.x + tl.x) / 2, (tr.y + tl.y) / 2),
            mr  = new fabric.Point((br.x + tr.x) / 2, (br.y + tr.y) / 2),
            mb  = new fabric.Point((br.x + bl.x) / 2, (br.y + bl.y) / 2),
            mtr = new fabric.Point(mt.x + sin * this.rotatingPointOffset, mt.y - cos * this.rotatingPointOffset);
      }

      // if (!absolute) {
      //   var canvas = this.canvas;
      //   setTimeout(function() {
      //     canvas.contextTop.clearRect(0, 0, 700, 700);
      //     canvas.contextTop.fillStyle = 'green';
      //     canvas.contextTop.fillRect(mb.x, mb.y, 3, 3);
      //     canvas.contextTop.fillRect(bl.x, bl.y, 3, 3);
      //     canvas.contextTop.fillRect(br.x, br.y, 3, 3);
      //     canvas.contextTop.fillRect(tl.x, tl.y, 3, 3);
      //     canvas.contextTop.fillRect(tr.x, tr.y, 3, 3);
      //     canvas.contextTop.fillRect(ml.x, ml.y, 3, 3);
      //     canvas.contextTop.fillRect(mr.x, mr.y, 3, 3);
      //     canvas.contextTop.fillRect(mt.x, mt.y, 3, 3);
      //     canvas.contextTop.fillRect(mtr.x, mtr.y, 3, 3);
      //   }, 50);
      // }

      var coords = {
        // corners
        tl: tl, tr: tr, br: br, bl: bl,
      };
      if (!absolute) {
        // middle
        coords.ml = ml;
        coords.mt = mt;
        coords.mr = mr;
        coords.mb = mb;
        // rotating point
        coords.mtr = mtr;
      }
      return coords;
    },

    /**
     * Sets corner position coordinates based on current angle, width and height.
     * See {@link https://github.com/kangax/fabric.js/wiki/When-to-call-setCoords|When-to-call-setCoords}
     * @param {Boolean} [ignoreZoom] set oCoords with or without the viewport transform.
     * @param {Boolean} [skipAbsolute] skip calculation of aCoords, useful in setViewportTransform
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setCoords: function(ignoreZoom, skipAbsolute) {
      this.oCoords = this.calcCoords(ignoreZoom);
      if (!skipAbsolute) {
        this.aCoords = this.calcCoords(true);
      }

      // set coordinates of the draggable boxes in the corners used to scale/rotate the image
      ignoreZoom || (this._setCornerCoords && this._setCornerCoords());

      return this;
    },

    /**
     * calculate rotation matrix of an object
     * @return {Array} rotation matrix for the object
     */
    _calcRotateMatrix: function() {
      return fabric.util.calcRotateMatrix(this);
    },

    /**
     * calculate the translation matrix for an object transform
     * @return {Array} rotation matrix for the object
     */
    _calcTranslateMatrix: function() {
      var center = this.getCenterPoint();
      return [1, 0, 0, 1, center.x, center.y];
    },

    transformMatrixKey: function(skipGroup) {
      var sep = '_', prefix = '';
      if (!skipGroup && this.group) {
        prefix = this.group.transformMatrixKey(skipGroup) + sep;
      };
      return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY +
        sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY +
        sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
    },

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties.
     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
     * @return {Array} transform matrix for the object
     */
    calcTransformMatrix: function(skipGroup) {
      if (skipGroup) {
        return this.calcOwnMatrix();
      }
      var key = this.transformMatrixKey(), cache = this.matrixCache || (this.matrixCache = {});
      if (cache.key === key) {
        return cache.value;
      }
      var matrix = this.calcOwnMatrix();
      if (this.group) {
        matrix = multiplyMatrices(this.group.calcTransformMatrix(), matrix);
      }
      cache.key = key;
      cache.value = matrix;
      return matrix;
    },

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties, this matrix does not include the group transformation
     * @return {Array} transform matrix for the object
     */
    calcOwnMatrix: function() {
      var key = this.transformMatrixKey(true), cache = this.ownMatrixCache || (this.ownMatrixCache = {});
      if (cache.key === key) {
        return cache.value;
      }
      var tMatrix = this._calcTranslateMatrix();
      this.translateX = tMatrix[4];
      this.translateY = tMatrix[5];
      cache.key = key;
      cache.value = fabric.util.composeMatrix(this);
      return cache.value;
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     * @deprecated since 3.4.0, please use fabric.util._calcDimensionsTransformMatrix
     * not including or including flipX, flipY to emulate the flipping boolean
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _calcDimensionsTransformMatrix: function(skewX, skewY, flipping) {
      return fabric.util.calcDimensionsMatrix({
        skewX: skewX,
        skewY: skewY,
        scaleX: this.scaleX * (flipping && this.flipX ? -1 : 1),
        scaleY: this.scaleY * (flipping && this.flipY ? -1 : 1)
      });
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _getNonTransformedDimensions: function() {
      var strokeWidth = this.strokeWidth,
          w = this.width + strokeWidth,
          h = this.height + strokeWidth;
      return { x: w, y: h };
    },

    /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * The skewX and skewY parameters are used in the skewing logic path and
     * do not provide something useful to common use cases.
     * @param {Number} [skewX], a value to override current skewX
     * @param {Number} [skewY], a value to override current skewY
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _getTransformedDimensions: function(skewX, skewY) {
      if (typeof skewX === 'undefined') {
        skewX = this.skewX;
      }
      if (typeof skewY === 'undefined') {
        skewY = this.skewY;
      }
      var dimensions = this._getNonTransformedDimensions(), dimX, dimY,
          noSkew = skewX === 0 && skewY === 0;

      if (this.strokeUniform) {
        dimX = this.width;
        dimY = this.height;
      }
      else {
        dimX = dimensions.x;
        dimY = dimensions.y;
      }
      if (noSkew) {
        return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
      }
      else {
        dimX /= 2;
        dimY /= 2;
      }
      var points = [
            {
              x: -dimX,
              y: -dimY
            },
            {
              x: dimX,
              y: -dimY
            },
            {
              x: -dimX,
              y: dimY
            },
            {
              x: dimX,
              y: dimY
            }],
          transformMatrix = fabric.util.calcDimensionsMatrix({
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: skewX,
            skewY: skewY,
          }),
          bbox = fabric.util.makeBoundingBoxFromPoints(points, transformMatrix);
      return this._finalizeDimensions(bbox.width, bbox.height);
    },

    /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param Number width width of the bbox
     * @param Number height height of the bbox
     * @private
     * @return {Object} .x finalized width dimension
     * @return {Object} .y finalized height dimension
     */
    _finalizeDimensions: function(width, height) {
      return this.strokeUniform ?
        { x: width + this.strokeWidth, y: height + this.strokeWidth }
        :
        { x: width, y: height };
    },
    /*
     * Calculate object dimensions for controls, including padding and canvas zoom.
     * private
     */
    _calculateCurrentDimensions: function()  {
      var vpt = this.getViewportTransform(),
          dim = this._getTransformedDimensions(),
          p = fabric.util.transformPoint(dim, vpt, true);

      return p.scalarAdd(2 * this.padding);
    },
  });
})();


fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

  /**
   * Moves an object to the bottom of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */
  sendToBack: function() {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
    }
    else if (this.canvas) {
      this.canvas.sendToBack(this);
    }
    return this;
  },

  /**
   * Moves an object to the top of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */
  bringToFront: function() {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
    }
    else if (this.canvas) {
      this.canvas.bringToFront(this);
    }
    return this;
  },

  /**
   * Moves an object down in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  sendBackwards: function(intersecting) {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
    }
    else if (this.canvas) {
      this.canvas.sendBackwards(this, intersecting);
    }
    return this;
  },

  /**
   * Moves an object up in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  bringForward: function(intersecting) {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
    }
    else if (this.canvas) {
      this.canvas.bringForward(this, intersecting);
    }
    return this;
  },

  /**
   * Moves an object to specified level in stack of drawn objects
   * @param {Number} index New position of object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  moveTo: function(index) {
    if (this.group && this.group.type !== 'activeSelection') {
      fabric.StaticCanvas.prototype.moveTo.call(this.group, this, index);
    }
    else if (this.canvas) {
      this.canvas.moveTo(this, index);
    }
    return this;
  }
});


/* _TO_SVG_START_ */
(function() {
  function getSvgColorString(prop, value) {
    if (!value) {
      return prop + ': none; ';
    }
    else if (value.toLive) {
      return prop + ': url(#SVGID_' + value.id + '); ';
    }
    else {
      var color = new fabric.Color(value),
          str = prop + ': ' + color.toRgb() + '; ',
          opacity = color.getAlpha();
      if (opacity !== 1) {
        //change the color in rgb + opacity
        str += prop + '-opacity: ' + opacity.toString() + '; ';
      }
      return str;
    }
  }

  var toFixed = fabric.util.toFixed;

  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles: function(skipShadow) {

      var fillRule = this.fillRule ? this.fillRule : 'nonzero',
          strokeWidth = this.strokeWidth ? this.strokeWidth : '0',
          strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : 'none',
          strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0',
          strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt',
          strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter',
          strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4',
          opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1',
          visibility = this.visible ? '' : ' visibility: hidden;',
          filter = skipShadow ? '' : this.getSvgFilter(),
          fill = getSvgColorString('fill', this.fill),
          stroke = getSvgColorString('stroke', this.stroke);

      return [
        stroke,
        'stroke-width: ', strokeWidth, '; ',
        'stroke-dasharray: ', strokeDashArray, '; ',
        'stroke-linecap: ', strokeLineCap, '; ',
        'stroke-dashoffset: ', strokeDashOffset, '; ',
        'stroke-linejoin: ', strokeLineJoin, '; ',
        'stroke-miterlimit: ', strokeMiterLimit, '; ',
        fill,
        'fill-rule: ', fillRule, '; ',
        'opacity: ', opacity, ';',
        filter,
        visibility
      ].join('');
    },

    /**
     * Returns styles-string for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
     * @return {String}
     */
    getSvgSpanStyles: function(style, useWhiteSpace) {
      var term = '; ';
      var fontFamily = style.fontFamily ?
        'font-family: ' + (((style.fontFamily.indexOf('\'') === -1 && style.fontFamily.indexOf('"') === -1) ?
          '\'' + style.fontFamily  + '\'' : style.fontFamily)) + term : '';
      var strokeWidth = style.strokeWidth ? 'stroke-width: ' + style.strokeWidth + term : '',
          fontFamily = fontFamily,
          fontSize = style.fontSize ? 'font-size: ' + style.fontSize + 'px' + term : '',
          fontStyle = style.fontStyle ? 'font-style: ' + style.fontStyle + term : '',
          fontWeight = style.fontWeight ? 'font-weight: ' + style.fontWeight + term : '',
          fill = style.fill ? getSvgColorString('fill', style.fill) : '',
          stroke = style.stroke ? getSvgColorString('stroke', style.stroke) : '',
          textDecoration = this.getSvgTextDecoration(style),
          deltaY = style.deltaY ? 'baseline-shift: ' + (-style.deltaY) + '; ' : '';
      if (textDecoration) {
        textDecoration = 'text-decoration: ' + textDecoration + term;
      }

      return [
        stroke,
        strokeWidth,
        fontFamily,
        fontSize,
        fontStyle,
        fontWeight,
        textDecoration,
        fill,
        deltaY,
        useWhiteSpace ? 'white-space: pre; ' : ''
      ].join('');
    },

    /**
     * Returns text-decoration property for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @return {String}
     */
    getSvgTextDecoration: function(style) {
      return ['overline', 'underline', 'line-through'].filter(function(decoration) {
        return style[decoration.replace('-', '')];
      }).join(' ');
    },

    /**
     * Returns filter for svg shadow
     * @return {String}
     */
    getSvgFilter: function() {
      return this.shadow ? 'filter: url(#SVGID_' + this.shadow.id + ');' : '';
    },

    /**
     * Returns id attribute for svg output
     * @return {String}
     */
    getSvgCommons: function() {
      return [
        this.id ? 'id="' + this.id + '" ' : '',
        this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : '',
      ].join('');
    },

    /**
     * Returns transform-string for svg-export
     * @param {Boolean} use the full transform or the single object one.
     * @return {String}
     */
    getSvgTransform: function(full, additionalTransform) {
      var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(),
          svgTransform = 'transform="' + fabric.util.matrixToSVG(transform);
      return svgTransform +
        (additionalTransform || '') + this.getSvgTransformMatrix() + '" ';
    },

    /**
     * Returns transform-string for svg-export from the transform matrix of single elements
     * @return {String}
     */
    getSvgTransformMatrix: function() {
      return this.transformMatrix ? ' ' + fabric.util.matrixToSVG(this.transformMatrix) : '';
    },

    _setSVGBg: function(textBgRects) {
      if (this.backgroundColor) {
        var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
        textBgRects.push(
          '\t\t<rect ',
          this._getFillAttributes(this.backgroundColor),
          ' x="',
          toFixed(-this.width / 2, NUM_FRACTION_DIGITS),
          '" y="',
          toFixed(-this.height / 2, NUM_FRACTION_DIGITS),
          '" width="',
          toFixed(this.width, NUM_FRACTION_DIGITS),
          '" height="',
          toFixed(this.height, NUM_FRACTION_DIGITS),
          '"></rect>\n');
      }
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function(reviver) {
      return this._createBaseSVGMarkup(this._toSVG(reviver), { reviver: reviver });
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function(reviver) {
      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), { reviver: reviver });
    },

    /**
     * @private
     */
    _createBaseClipPathSVGMarkup: function(objectMarkup, options) {
      options = options || {};
      var reviver = options.reviver,
          additionalTransform = options.additionalTransform || '',
          commonPieces = [
            this.getSvgTransform(true, additionalTransform),
            this.getSvgCommons(),
          ].join(''),
          // insert commons in the markup, style and svgCommons
          index = objectMarkup.indexOf('COMMON_PARTS');
      objectMarkup[index] = commonPieces;
      return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
    },

    /**
     * @private
     */
    _createBaseSVGMarkup: function(objectMarkup, options) {
      options = options || {};
      var noStyle = options.noStyle,
          reviver = options.reviver,
          styleInfo = noStyle ? '' : 'style="' + this.getSvgStyles() + '" ',
          shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : '',
          clipPath = this.clipPath,
          vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '',
          absoluteClipPath = clipPath && clipPath.absolutePositioned,
          stroke = this.stroke, fill = this.fill, shadow = this.shadow,
          commonPieces, markup = [], clipPathMarkup,
          // insert commons in the markup, style and svgCommons
          index = objectMarkup.indexOf('COMMON_PARTS'),
          additionalTransform = options.additionalTransform;
      if (clipPath) {
        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
        clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' +
          clipPath.toClipPathSVG(reviver) +
          '</clipPath>\n';
      }
      if (absoluteClipPath) {
        markup.push(
          '<g ', shadowInfo, this.getSvgCommons(), ' >\n'
        );
      }
      markup.push(
        '<g ',
        this.getSvgTransform(false),
        !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '',
        ' >\n'
      );
      commonPieces = [
        styleInfo,
        vectorEffect,
        noStyle ? '' : this.addPaintOrder(), ' ',
        additionalTransform ? 'transform="' + additionalTransform + '" ' : '',
      ].join('');
      objectMarkup[index] = commonPieces;
      if (fill && fill.toLive) {
        markup.push(fill.toSVG(this));
      }
      if (stroke && stroke.toLive) {
        markup.push(stroke.toSVG(this));
      }
      if (shadow) {
        markup.push(shadow.toSVG(this));
      }
      if (clipPath) {
        markup.push(clipPathMarkup);
      }
      markup.push(objectMarkup.join(''));
      markup.push('</g>\n');
      absoluteClipPath && markup.push('</g>\n');
      return reviver ? reviver(markup.join('')) : markup.join('');
    },

    addPaintOrder: function() {
      return this.paintFirst !== 'fill' ? ' paint-order="' + this.paintFirst + '" ' : '';
    }
  });
})();
/* _TO_SVG_END_ */


(function() {

  var extend = fabric.util.object.extend,
      originalSet = 'stateProperties';

  /*
    Depends on `stateProperties`
  */
  function saveProps(origin, destination, props) {
    var tmpObj = { }, deep = true;
    props.forEach(function(prop) {
      tmpObj[prop] = origin[prop];
    });
    extend(origin[destination], tmpObj, deep);
  }

  function _isEqual(origValue, currentValue, firstPass) {
    if (origValue === currentValue) {
      // if the objects are identical, return
      return true;
    }
    else if (Array.isArray(origValue)) {
      if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) {
        return false;
      }
      for (var i = 0, len = origValue.length; i < len; i++) {
        if (!_isEqual(origValue[i], currentValue[i])) {
          return false;
        }
      }
      return true;
    }
    else if (origValue && typeof origValue === 'object') {
      var keys = Object.keys(origValue), key;
      if (!currentValue ||
          typeof currentValue !== 'object' ||
          (!firstPass && keys.length !== Object.keys(currentValue).length)
      ) {
        return false;
      }
      for (var i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        // since clipPath is in the statefull cache list and the clipPath objects
        // would be iterated as an object, this would lead to possible infinite recursion
        if (key === 'canvas') {
          continue;
        }
        if (!_isEqual(origValue[key], currentValue[key])) {
          return false;
        }
      }
      return true;
    }
  }


  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

    /**
     * Returns true if object state (one of its state properties) was changed
     * @param {String} [propertySet] optional name for the set of property we want to save
     * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
     */
    hasStateChanged: function(propertySet) {
      propertySet = propertySet || originalSet;
      var dashedPropertySet = '_' + propertySet;
      if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) {
        return true;
      }
      return !_isEqual(this[dashedPropertySet], this, true);
    },

    /**
     * Saves state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */
    saveState: function(options) {
      var propertySet = options && options.propertySet || originalSet,
          destination = '_' + propertySet;
      if (!this[destination]) {
        return this.setupState(options);
      }
      saveProps(this, destination, this[propertySet]);
      if (options && options.stateProperties) {
        saveProps(this, destination, options.stateProperties);
      }
      return this;
    },

    /**
     * Setups state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */
    setupState: function(options) {
      options = options || { };
      var propertySet = options.propertySet || originalSet;
      options.propertySet = propertySet;
      this['_' + propertySet] = { };
      this.saveState(options);
      return this;
    }
  });
})();


(function() {

  var degreesToRadians = fabric.util.degreesToRadians;

  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

    /**
     * The object interactivity controls.
     * @private
     */
    _controlsVisibility: null,

    /**
     * Determines which corner has been clicked
     * @private
     * @param {Object} pointer The pointer indicating the mouse position
     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
     */
    _findTargetCorner: function(pointer) {
      // objects in group, anykind, are not self modificable,
      // must not return an hovered corner.
      if (!this.hasControls || this.group || (!this.canvas || this.canvas._activeObject !== this)) {
        return false;
      }

      var ex = pointer.x,
          ey = pointer.y,
          xPoints,
          lines;
      this.__corner = 0;
      for (var i in this.oCoords) {

        if (!this.isControlVisible(i)) {
          continue;
        }

        if (i === 'mtr' && !this.hasRotatingPoint) {
          continue;
        }

        if (this.get('lockUniScaling') &&
           (i === 'mt' || i === 'mr' || i === 'mb' || i === 'ml')) {
          continue;
        }

        lines = this._getImageLines(this.oCoords[i].corner);

        // debugging

        // canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
        // canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);

        // canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
        // canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);

        // canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
        // canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);

        // canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
        // canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);

        xPoints = this._findCrossPoints({ x: ex, y: ey }, lines);
        if (xPoints !== 0 && xPoints % 2 === 1) {
          this.__corner = i;
          return i;
        }
      }
      return false;
    },

    /**
     * Sets the coordinates of the draggable boxes in the corners of
     * the image used to scale/rotate it.
     * @private
     */
    _setCornerCoords: function() {
      var coords = this.oCoords,
          newTheta = degreesToRadians(45 - this.angle),
          /* Math.sqrt(2 * Math.pow(this.cornerSize, 2)) / 2, */
          /* 0.707106 stands for sqrt(2)/2 */
          cornerHypotenuse = this.cornerSize * 0.707106,
          cosHalfOffset = cornerHypotenuse * fabric.util.cos(newTheta),
          sinHalfOffset = cornerHypotenuse * fabric.util.sin(newTheta),
          x, y;

      for (var point in coords) {
        x = coords[point].x;
        y = coords[point].y;
        coords[point].corner = {
          tl: {
            x: x - sinHalfOffset,
            y: y - cosHalfOffset
          },
          tr: {
            x: x + cosHalfOffset,
            y: y - sinHalfOffset
          },
          bl: {
            x: x - cosHalfOffset,
            y: y + sinHalfOffset
          },
          br: {
            x: x + sinHalfOffset,
            y: y + cosHalfOffset
          }
        };
      }
    },

    /**
     * Draws a colored layer behind the object, inside its selection borders.
     * Requires public options: padding, selectionBackgroundColor
     * this function is called when the context is transformed
     * has checks to be skipped when the object is on a staticCanvas
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawSelectionBackground: function(ctx) {
      if (!this.selectionBackgroundColor ||
        (this.canvas && !this.canvas.interactive) ||
        (this.canvas && this.canvas._activeObject !== this)
      ) {
        return this;
      }
      ctx.save();
      var center = this.getCenterPoint(), wh = this._calculateCurrentDimensions(),
          vpt = this.canvas.viewportTransform;
      ctx.translate(center.x, center.y);
      ctx.scale(1 / vpt[0], 1 / vpt[3]);
      ctx.rotate(degreesToRadians(this.angle));
      ctx.fillStyle = this.selectionBackgroundColor;
      ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
      ctx.restore();
      return this;
    },

    /**
     * Draws borders of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawBorders: function(ctx, styleOverride) {
      styleOverride = styleOverride || {};
      var wh = this._calculateCurrentDimensions(),
          strokeWidth = this.borderScaleFactor,
          width = wh.x + strokeWidth,
          height = wh.y + strokeWidth,
          drawRotatingPoint = typeof styleOverride.hasRotatingPoint !== 'undefined' ?
            styleOverride.hasRotatingPoint : this.hasRotatingPoint,
          hasControls = typeof styleOverride.hasControls !== 'undefined' ?
            styleOverride.hasControls : this.hasControls,
          rotatingPointOffset = typeof styleOverride.rotatingPointOffset !== 'undefined' ?
            styleOverride.rotatingPointOffset : this.rotatingPointOffset;

      ctx.save();
      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);

      ctx.strokeRect(
        -width / 2,
        -height / 2,
        width,
        height
      );

      if (drawRotatingPoint && this.isControlVisible('mtr') && hasControls) {

        var rotateHeight = -height / 2;

        ctx.beginPath();
        ctx.moveTo(0, rotateHeight);
        ctx.lineTo(0, rotateHeight - rotatingPointOffset);
        ctx.stroke();
      }

      ctx.restore();
      return this;
    },

    /**
     * Draws borders of an object's bounding box when it is inside a group.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {object} options object representing current object parameters
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawBordersInGroup: function(ctx, options, styleOverride) {
      styleOverride = styleOverride || {};
      var p = { x: this.width, y: this.height },
          matrix = fabric.util.composeMatrix({
            scaleX: options.scaleX,
            scaleY: options.scaleY,
            skewX: options.skewX
          }),
          wh = fabric.util.transformPoint(p, matrix),
          strokeWidth = this.strokeWidth,
          borderScaleFactor = this.borderScaleFactor,
          width =
            wh.x + strokeWidth * (this.strokeUniform ? this.canvas.getZoom() : options.scaleX) + borderScaleFactor,
          height =
            wh.y + strokeWidth * (this.strokeUniform ? this.canvas.getZoom() : options.scaleY) + borderScaleFactor;
      ctx.save();
      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);
      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;

      ctx.strokeRect(
        -width / 2,
        -height / 2,
        width,
        height
      );

      ctx.restore();
      return this;
    },

    /**
     * Draws corners of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: cornerSize, padding
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawControls: function(ctx, styleOverride) {
      styleOverride = styleOverride || {};
      var wh = this._calculateCurrentDimensions(),
          width = wh.x,
          height = wh.y,
          scaleOffset = styleOverride.cornerSize || this.cornerSize,
          left = -(width + scaleOffset) / 2,
          top = -(height + scaleOffset) / 2,
          transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ?
            styleOverride.transparentCorners : this.transparentCorners,
          hasRotatingPoint = typeof styleOverride.hasRotatingPoint !== 'undefined' ?
            styleOverride.hasRotatingPoint : this.hasRotatingPoint,
          methodName = transparentCorners ? 'stroke' : 'fill';

      ctx.save();
      ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
      if (!this.transparentCorners) {
        ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
      }
      this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray, null);

      // top-left
      this._drawControl('tl', ctx, methodName,
        left,
        top, styleOverride);

      // top-right
      this._drawControl('tr', ctx, methodName,
        left + width,
        top, styleOverride);

      // bottom-left
      this._drawControl('bl', ctx, methodName,
        left,
        top + height, styleOverride);

      // bottom-right
      this._drawControl('br', ctx, methodName,
        left + width,
        top + height, styleOverride);

      if (!this.get('lockUniScaling')) {

        // middle-top
        this._drawControl('mt', ctx, methodName,
          left + width / 2,
          top, styleOverride);

        // middle-bottom
        this._drawControl('mb', ctx, methodName,
          left + width / 2,
          top + height, styleOverride);

        // middle-right
        this._drawControl('mr', ctx, methodName,
          left + width,
          top + height / 2, styleOverride);

        // middle-left
        this._drawControl('ml', ctx, methodName,
          left,
          top + height / 2, styleOverride);
      }

      // middle-top-rotate
      if (hasRotatingPoint) {
        this._drawControl('mtr', ctx, methodName,
          left + width / 2,
          top - this.rotatingPointOffset, styleOverride);
      }

      ctx.restore();

      return this;
    },

    /**
     * @private
     */
    _drawControl: function(control, ctx, methodName, left, top, styleOverride) {
      styleOverride = styleOverride || {};
      if (!this.isControlVisible(control)) {
        return;
      }
      var size = this.cornerSize, stroke = !this.transparentCorners && this.cornerStrokeColor;
      switch (styleOverride.cornerStyle || this.cornerStyle) {
        case 'circle':
          ctx.beginPath();
          ctx.arc(left + size / 2, top + size / 2, size / 2, 0, 2 * Math.PI, false);
          ctx[methodName]();
          if (stroke) {
            ctx.stroke();
          }
          break;
        default:
          this.transparentCorners || ctx.clearRect(left, top, size, size);
          ctx[methodName + 'Rect'](left, top, size, size);
          if (stroke) {
            ctx.strokeRect(left, top, size, size);
          }
      }
    },

    /**
     * Returns true if the specified control is visible, false otherwise.
     * @param {String} controlName The name of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @returns {Boolean} true if the specified control is visible, false otherwise
     */
    isControlVisible: function(controlName) {
      return this._getControlsVisibility()[controlName];
    },

    /**
     * Sets the visibility of the specified control.
     * @param {String} controlName The name of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @param {Boolean} visible true to set the specified control visible, false otherwise
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setControlVisible: function(controlName, visible) {
      this._getControlsVisibility()[controlName] = visible;
      return this;
    },

    /**
     * Sets the visibility state of object controls.
     * @param {Object} [options] Options object
     * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
     * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
     * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
     * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
     * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
     * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
     * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
     * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
     * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setControlsVisibility: function(options) {
      options || (options = { });

      for (var p in options) {
        this.setControlVisible(p, options[p]);
      }
      return this;
    },

    /**
     * Returns the instance of the control visibility set for this object.
     * @private
     * @returns {Object}
     */
    _getControlsVisibility: function() {
      if (!this._controlsVisibility) {
        this._controlsVisibility = {
          tl: true,
          tr: true,
          br: true,
          bl: true,
          ml: true,
          mt: true,
          mr: true,
          mb: true,
          mtr: true
        };
      }
      return this._controlsVisibility;
    },

    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to deselect this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */
    onDeselect: function() {
      // implemented by sub-classes, as needed.
    },


    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to select this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */
    onSelect: function() {
      // implemented by sub-classes, as needed.
    }
  });
})();


fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

  /**
   * Animation duration (in ms) for fx* methods
   * @type Number
   * @default
   */
  FX_DURATION: 500,

  /**
   * Centers object horizontally with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxCenterObjectH: function (object, callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.left,
      endValue: this.getCenter().left,
      duration: this.FX_DURATION,
      onChange: function(value) {
        object.set('left', value);
        _this.requestRenderAll();
        onChange();
      },
      onComplete: function() {
        object.setCoords();
        onComplete();
      }
    });

    return this;
  },

  /**
   * Centers object vertically with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxCenterObjectV: function (object, callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.top,
      endValue: this.getCenter().top,
      duration: this.FX_DURATION,
      onChange: function(value) {
        object.set('top', value);
        _this.requestRenderAll();
        onChange();
      },
      onComplete: function() {
        object.setCoords();
        onComplete();
      }
    });

    return this;
  },

  /**
   * Same as `fabric.Canvas#remove` but animated
   * @param {fabric.Object} object Object to remove
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxRemove: function (object, callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.opacity,
      endValue: 0,
      duration: this.FX_DURATION,
      onChange: function(value) {
        object.set('opacity', value);
        _this.requestRenderAll();
        onChange();
      },
      onComplete: function () {
        _this.remove(object);
        onComplete();
      }
    });

    return this;
  }
});

fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
  /**
   * Animates object's properties
   * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
   * @param {Number|Object} value Value to animate property to (if string was given first) or options object
   * @return {fabric.Object} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
   * @chainable
   *
   * As object — multiple properties
   *
   * object.animate({ left: ..., top: ... });
   * object.animate({ left: ..., top: ... }, { duration: ... });
   *
   * As string — one property
   *
   * object.animate('left', ...);
   * object.animate('left', { duration: ... });
   *
   */
  animate: function() {
    if (arguments[0] && typeof arguments[0] === 'object') {
      var propsToAnimate = [], prop, skipCallbacks;
      for (prop in arguments[0]) {
        propsToAnimate.push(prop);
      }
      for (var i = 0, len = propsToAnimate.length; i < len; i++) {
        prop = propsToAnimate[i];
        skipCallbacks = i !== len - 1;
        this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks);
      }
    }
    else {
      this._animate.apply(this, arguments);
    }
    return this;
  },

  /**
   * @private
   * @param {String} property Property to animate
   * @param {String} to Value to animate to
   * @param {Object} [options] Options object
   * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
   */
  _animate: function(property, to, options, skipCallbacks) {
    var _this = this, propPair;

    to = to.toString();

    if (!options) {
      options = { };
    }
    else {
      options = fabric.util.object.clone(options);
    }

    if (~property.indexOf('.')) {
      propPair = property.split('.');
    }

    var currentValue = propPair
      ? this.get(propPair[0])[propPair[1]]
      : this.get(property);

    if (!('from' in options)) {
      options.from = currentValue;
    }

    if (~to.indexOf('=')) {
      to = currentValue + parseFloat(to.replace('=', ''));
    }
    else {
      to = parseFloat(to);
    }

    fabric.util.animate({
      startValue: options.from,
      endValue: to,
      byValue: options.by,
      easing: options.easing,
      duration: options.duration,
      abort: options.abort && function() {
        return options.abort.call(_this);
      },
      onChange: function(value, valueProgress, timeProgress) {
        if (propPair) {
          _this[propPair[0]][propPair[1]] = value;
        }
        else {
          _this.set(property, value);
        }
        if (skipCallbacks) {
          return;
        }
        options.onChange && options.onChange(value, valueProgress, timeProgress);
      },
      onComplete: function(value, valueProgress, timeProgress) {
        if (skipCallbacks) {
          return;
        }

        _this.setCoords();
        options.onComplete && options.onComplete(value, valueProgress, timeProgress);
      }
    });
  }
});


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      coordProps = { x1: 1, x2: 1, y1: 1, y2: 1 },
      supportsLineDash = fabric.StaticCanvas.supports('setLineDash');

  if (fabric.Line) {
    fabric.warn('fabric.Line is already defined');
    return;
  }

  /**
   * Line class
   * @class fabric.Line
   * @extends fabric.Object
   * @see {@link fabric.Line#initialize} for constructor definition
   */
  fabric.Line = fabric.util.createClass(fabric.Object, /** @lends fabric.Line.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'line',

    /**
     * x value or first line edge
     * @type Number
     * @default
     */
    x1: 0,

    /**
     * y value or first line edge
     * @type Number
     * @default
     */
    y1: 0,

    /**
     * x value or second line edge
     * @type Number
     * @default
     */
    x2: 0,

    /**
     * y value or second line edge
     * @type Number
     * @default
     */
    y2: 0,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('x1', 'x2', 'y1', 'y2'),

    /**
     * Constructor
     * @param {Array} [points] Array of points
     * @param {Object} [options] Options object
     * @return {fabric.Line} thisArg
     */
    initialize: function(points, options) {
      if (!points) {
        points = [0, 0, 0, 0];
      }

      this.callSuper('initialize', options);

      this.set('x1', points[0]);
      this.set('y1', points[1]);
      this.set('x2', points[2]);
      this.set('y2', points[3]);

      this._setWidthHeight(options);
    },

    /**
     * @private
     * @param {Object} [options] Options
     */
    _setWidthHeight: function(options) {
      options || (options = { });

      this.width = Math.abs(this.x2 - this.x1);
      this.height = Math.abs(this.y2 - this.y1);

      this.left = 'left' in options
        ? options.left
        : this._getLeftToOriginX();

      this.top = 'top' in options
        ? options.top
        : this._getTopToOriginY();
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     */
    _set: function(key, value) {
      this.callSuper('_set', key, value);
      if (typeof coordProps[key] !== 'undefined') {
        this._setWidthHeight();
      }
      return this;
    },

    /**
     * @private
     * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
     */
    _getLeftToOriginX: makeEdgeToOriginGetter(
      { // property names
        origin: 'originX',
        axis1: 'x1',
        axis2: 'x2',
        dimension: 'width'
      },
      { // possible values of origin
        nearest: 'left',
        center: 'center',
        farthest: 'right'
      }
    ),

    /**
     * @private
     * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
     */
    _getTopToOriginY: makeEdgeToOriginGetter(
      { // property names
        origin: 'originY',
        axis1: 'y1',
        axis2: 'y2',
        dimension: 'height'
      },
      { // possible values of origin
        nearest: 'top',
        center: 'center',
        farthest: 'bottom'
      }
    ),

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      ctx.beginPath();

      if (!this.strokeDashArray || this.strokeDashArray && supportsLineDash) {
        // move from center (of virtual box) to its left/top corner
        // we can't assume x1, y1 is top left and x2, y2 is bottom right
        var p = this.calcLinePoints();
        ctx.moveTo(p.x1, p.y1);
        ctx.lineTo(p.x2, p.y2);
      }

      ctx.lineWidth = this.strokeWidth;

      // TODO: test this
      // make sure setting "fill" changes color of a line
      // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
      var origStrokeStyle = ctx.strokeStyle;
      ctx.strokeStyle = this.stroke || ctx.fillStyle;
      this.stroke && this._renderStroke(ctx);
      ctx.strokeStyle = origStrokeStyle;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var p = this.calcLinePoints();

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, p.x1, p.y1, p.x2, p.y2, this.strokeDashArray);
      ctx.closePath();
    },

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */
    _findCenterFromElement: function() {
      return {
        x: (this.x1 + this.x2) / 2,
        y: (this.y1 + this.y2) / 2,
      };
    },

    /**
     * Returns object representation of an instance
     * @methd toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), this.calcLinePoints());
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     */
    _getNonTransformedDimensions: function() {
      var dim = this.callSuper('_getNonTransformedDimensions');
      if (this.strokeLineCap === 'butt') {
        if (this.width === 0) {
          dim.y -= this.strokeWidth;
        }
        if (this.height === 0) {
          dim.x -= this.strokeWidth;
        }
      }
      return dim;
    },

    /**
     * Recalculates line points given width and height
     * @private
     */
    calcLinePoints: function() {
      var xMult = this.x1 <= this.x2 ? -1 : 1,
          yMult = this.y1 <= this.y2 ? -1 : 1,
          x1 = (xMult * this.width * 0.5),
          y1 = (yMult * this.height * 0.5),
          x2 = (xMult * this.width * -0.5),
          y2 = (yMult * this.height * -0.5);

      return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
      };
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var p = this.calcLinePoints();
      return [
        '<line ', 'COMMON_PARTS',
        'x1="', p.x1,
        '" y1="', p.y1,
        '" x2="', p.x2,
        '" y2="', p.y2,
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Line.fromElement})
   * @static
   * @memberOf fabric.Line
   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
   */
  fabric.Line.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x1 y1 x2 y2'.split(' '));

  /**
   * Returns fabric.Line instance from an SVG element
   * @static
   * @memberOf fabric.Line
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} [callback] callback function invoked after parsing
   */
  fabric.Line.fromElement = function(element, callback, options) {
    options = options || { };
    var parsedAttributes = fabric.parseAttributes(element, fabric.Line.ATTRIBUTE_NAMES),
        points = [
          parsedAttributes.x1 || 0,
          parsedAttributes.y1 || 0,
          parsedAttributes.x2 || 0,
          parsedAttributes.y2 || 0
        ];
    callback(new fabric.Line(points, extend(parsedAttributes, options)));
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Line instance from an object representation
   * @static
   * @memberOf fabric.Line
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */
  fabric.Line.fromObject = function(object, callback) {
    function _callback(instance) {
      delete instance.points;
      callback && callback(instance);
    };
    var options = clone(object, true);
    options.points = [object.x1, object.y1, object.x2, object.y2];
    fabric.Object._fromObject('Line', options, _callback, 'points');
  };

  /**
   * Produces a function that calculates distance from canvas edge to Line origin.
   */
  function makeEdgeToOriginGetter(propertyNames, originValues) {
    var origin = propertyNames.origin,
        axis1 = propertyNames.axis1,
        axis2 = propertyNames.axis2,
        dimension = propertyNames.dimension,
        nearest = originValues.nearest,
        center = originValues.center,
        farthest = originValues.farthest;

    return function() {
      switch (this.get(origin)) {
        case nearest:
          return Math.min(this.get(axis1), this.get(axis2));
        case center:
          return Math.min(this.get(axis1), this.get(axis2)) + (0.5 * this.get(dimension));
        case farthest:
          return Math.max(this.get(axis1), this.get(axis2));
      }
    };

  }

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      pi = Math.PI;

  if (fabric.Circle) {
    fabric.warn('fabric.Circle is already defined.');
    return;
  }

  /**
   * Circle class
   * @class fabric.Circle
   * @extends fabric.Object
   * @see {@link fabric.Circle#initialize} for constructor definition
   */
  fabric.Circle = fabric.util.createClass(fabric.Object, /** @lends fabric.Circle.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'circle',

    /**
     * Radius of this circle
     * @type Number
     * @default
     */
    radius: 0,

    /**
     * Start angle of the circle, moving clockwise
     * deprectated type, this should be in degree, this was an oversight.
     * probably will change to degrees in next major version
     * @type Number
     * @default 0
     */
    startAngle: 0,

    /**
     * End angle of the circle
     * deprectated type, this should be in degree, this was an oversight.
     * probably will change to degrees in next major version
     * @type Number
     * @default 2Pi
     */
    endAngle: pi * 2,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('radius', 'startAngle', 'endAngle'),

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Circle} thisArg
     */
    _set: function(key, value) {
      this.callSuper('_set', key, value);

      if (key === 'radius') {
        this.setRadius(value);
      }

      return this;
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['radius', 'startAngle', 'endAngle'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var svgString, x = 0, y = 0,
          angle = (this.endAngle - this.startAngle) % ( 2 * pi);

      if (angle === 0) {
        svgString = [
          '<circle ', 'COMMON_PARTS',
          'cx="' + x + '" cy="' + y + '" ',
          'r="', this.radius,
          '" />\n'
        ];
      }
      else {
        var startX = fabric.util.cos(this.startAngle) * this.radius,
            startY = fabric.util.sin(this.startAngle) * this.radius,
            endX = fabric.util.cos(this.endAngle) * this.radius,
            endY = fabric.util.sin(this.endAngle) * this.radius,
            largeFlag = angle > pi ? '1' : '0';
        svgString = [
          '<path d="M ' + startX + ' ' + startY,
          ' A ' + this.radius + ' ' + this.radius,
          ' 0 ', +largeFlag + ' 1', ' ' + endX + ' ' + endY,
          '" ', 'COMMON_PARTS', ' />\n'
        ];
      }
      return svgString;
    },
    /* _TO_SVG_END_ */

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render: function(ctx) {
      ctx.beginPath();
      ctx.arc(
        0,
        0,
        this.radius,
        this.startAngle,
        this.endAngle, false);
      this._renderPaintInOrder(ctx);
    },

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusX: function() {
      return this.get('radius') * this.get('scaleX');
    },

    /**
     * Returns vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusY: function() {
      return this.get('radius') * this.get('scaleY');
    },

    /**
     * Sets radius of an object (and updates width accordingly)
     * @return {fabric.Circle} thisArg
     */
    setRadius: function(value) {
      this.radius = value;
      return this.set('width', value * 2).set('height', value * 2);
    },
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Circle.fromElement})
   * @static
   * @memberOf fabric.Circle
   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
   */
  fabric.Circle.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy r'.split(' '));

  /**
   * Returns {@link fabric.Circle} instance from an SVG element
   * @static
   * @memberOf fabric.Circle
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @param {Object} [options] Options object
   * @throws {Error} If value of `r` attribute is missing or invalid
   */
  fabric.Circle.fromElement = function(element, callback) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Circle.ATTRIBUTE_NAMES);

    if (!isValidRadius(parsedAttributes)) {
      throw new Error('value of `r` attribute is required and can not be negative');
    }

    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
    callback(new fabric.Circle(parsedAttributes));
  };

  /**
   * @private
   */
  function isValidRadius(attributes) {
    return (('radius' in attributes) && (attributes.radius >= 0));
  }
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Circle} instance from an object representation
   * @static
   * @memberOf fabric.Circle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {Object} Instance of fabric.Circle
   */
  fabric.Circle.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Circle', object, callback);
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Triangle) {
    fabric.warn('fabric.Triangle is already defined');
    return;
  }

  /**
   * Triangle class
   * @class fabric.Triangle
   * @extends fabric.Object
   * @return {fabric.Triangle} thisArg
   * @see {@link fabric.Triangle#initialize} for constructor definition
   */
  fabric.Triangle = fabric.util.createClass(fabric.Object, /** @lends fabric.Triangle.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'triangle',

    /**
     * Width is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */
    width: 100,

    /**
     * Height is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */
    height: 100,

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2;

      ctx.beginPath();
      ctx.moveTo(-widthBy2, heightBy2);
      ctx.lineTo(0, -heightBy2);
      ctx.lineTo(widthBy2, heightBy2);
      ctx.closePath();

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2;

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, -widthBy2, heightBy2, 0, -heightBy2, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, 0, -heightBy2, widthBy2, heightBy2, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, widthBy2, heightBy2, -widthBy2, heightBy2, this.strokeDashArray);
      ctx.closePath();
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2,
          points = [
            -widthBy2 + ' ' + heightBy2,
            '0 ' + -heightBy2,
            widthBy2 + ' ' + heightBy2
          ].join(',');
      return [
        '<polygon ', 'COMMON_PARTS',
        'points="', points,
        '" />'
      ];
    },
    /* _TO_SVG_END_ */
  });

  /**
   * Returns {@link fabric.Triangle} instance from an object representation
   * @static
   * @memberOf fabric.Triangle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */
  fabric.Triangle.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Triangle', object, callback);
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      piBy2   = Math.PI * 2;

  if (fabric.Ellipse) {
    fabric.warn('fabric.Ellipse is already defined.');
    return;
  }

  /**
   * Ellipse class
   * @class fabric.Ellipse
   * @extends fabric.Object
   * @return {fabric.Ellipse} thisArg
   * @see {@link fabric.Ellipse#initialize} for constructor definition
   */
  fabric.Ellipse = fabric.util.createClass(fabric.Object, /** @lends fabric.Ellipse.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'ellipse',

    /**
     * Horizontal radius
     * @type Number
     * @default
     */
    rx:   0,

    /**
     * Vertical radius
     * @type Number
     * @default
     */
    ry:   0,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {fabric.Ellipse} thisArg
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      this.set('rx', options && options.rx || 0);
      this.set('ry', options && options.ry || 0);
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Ellipse} thisArg
     */
    _set: function(key, value) {
      this.callSuper('_set', key, value);
      switch (key) {

        case 'rx':
          this.rx = value;
          this.set('width', value * 2);
          break;

        case 'ry':
          this.ry = value;
          this.set('height', value * 2);
          break;

      }
      return this;
    },

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRx: function() {
      return this.get('rx') * this.get('scaleX');
    },

    /**
     * Returns Vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRy: function() {
      return this.get('ry') * this.get('scaleY');
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      return [
        '<ellipse ', 'COMMON_PARTS',
        'cx="0" cy="0" ',
        'rx="', this.rx,
        '" ry="', this.ry,
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render: function(ctx) {
      ctx.beginPath();
      ctx.save();
      ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
      ctx.arc(
        0,
        0,
        this.rx,
        0,
        piBy2,
        false);
      ctx.restore();
      this._renderPaintInOrder(ctx);
    },
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Ellipse.fromElement})
   * @static
   * @memberOf fabric.Ellipse
   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
   */
  fabric.Ellipse.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy rx ry'.split(' '));

  /**
   * Returns {@link fabric.Ellipse} instance from an SVG element
   * @static
   * @memberOf fabric.Ellipse
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @return {fabric.Ellipse}
   */
  fabric.Ellipse.fromElement = function(element, callback) {

    var parsedAttributes = fabric.parseAttributes(element, fabric.Ellipse.ATTRIBUTE_NAMES);

    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
    callback(new fabric.Ellipse(parsedAttributes));
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Ellipse} instance from an object representation
   * @static
   * @memberOf fabric.Ellipse
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {fabric.Ellipse}
   */
  fabric.Ellipse.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Ellipse', object, callback);
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend;

  if (fabric.Rect) {
    fabric.warn('fabric.Rect is already defined');
    return;
  }

  /**
   * Rectangle class
   * @class fabric.Rect
   * @extends fabric.Object
   * @return {fabric.Rect} thisArg
   * @see {@link fabric.Rect#initialize} for constructor definition
   */
  fabric.Rect = fabric.util.createClass(fabric.Object, /** @lends fabric.Rect.prototype */ {

    /**
     * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('rx', 'ry'),

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'rect',

    /**
     * Horizontal border radius
     * @type Number
     * @default
     */
    rx:   0,

    /**
     * Vertical border radius
     * @type Number
     * @default
     */
    ry:   0,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      this._initRxRy();
    },

    /**
     * Initializes rx/ry attributes
     * @private
     */
    _initRxRy: function() {
      if (this.rx && !this.ry) {
        this.ry = this.rx;
      }
      else if (this.ry && !this.rx) {
        this.rx = this.ry;
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {

      // 1x1 case (used in spray brush) optimization was removed because
      // with caching and higher zoom level this makes more damage than help

      var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0,
          ry = this.ry ? Math.min(this.ry, this.height / 2) : 0,
          w = this.width,
          h = this.height,
          x = -this.width / 2,
          y = -this.height / 2,
          isRounded = rx !== 0 || ry !== 0,
          /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */
          k = 1 - 0.5522847498;
      ctx.beginPath();

      ctx.moveTo(x + rx, y);

      ctx.lineTo(x + w - rx, y);
      isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);

      ctx.lineTo(x + w, y + h - ry);
      isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);

      ctx.lineTo(x + rx, y + h);
      isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);

      ctx.lineTo(x, y + ry);
      isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);

      ctx.closePath();

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var x = -this.width / 2,
          y = -this.height / 2,
          w = this.width,
          h = this.height;

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
      ctx.closePath();
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var x = -this.width / 2, y = -this.height / 2;
      return [
        '<rect ', 'COMMON_PARTS',
        'x="', x, '" y="', y,
        '" rx="', this.rx, '" ry="', this.ry,
        '" width="', this.width, '" height="', this.height,
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Rect.fromElement`)
   * @static
   * @memberOf fabric.Rect
   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
   */
  fabric.Rect.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y rx ry width height'.split(' '));

  /**
   * Returns {@link fabric.Rect} instance from an SVG element
   * @static
   * @memberOf fabric.Rect
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Rect.fromElement = function(element, callback, options) {
    if (!element) {
      return callback(null);
    }
    options = options || { };

    var parsedAttributes = fabric.parseAttributes(element, fabric.Rect.ATTRIBUTE_NAMES);

    parsedAttributes.left = parsedAttributes.left || 0;
    parsedAttributes.top  = parsedAttributes.top  || 0;
    parsedAttributes.height  = parsedAttributes.height || 0;
    parsedAttributes.width  = parsedAttributes.width || 0;
    var rect = new fabric.Rect(extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
    rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
    callback(rect);
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Rect} instance from an object representation
   * @static
   * @memberOf fabric.Rect
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Rect instance is created
   */
  fabric.Rect.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Rect', object, callback);
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      min = fabric.util.array.min,
      max = fabric.util.array.max,
      toFixed = fabric.util.toFixed;

  if (fabric.Polyline) {
    fabric.warn('fabric.Polyline is already defined');
    return;
  }

  /**
   * Polyline class
   * @class fabric.Polyline
   * @extends fabric.Object
   * @see {@link fabric.Polyline#initialize} for constructor definition
   */
  fabric.Polyline = fabric.util.createClass(fabric.Object, /** @lends fabric.Polyline.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'polyline',

    /**
     * Points array
     * @type Array
     * @default
     */
    points: null,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('points'),

    /**
     * Constructor
     * @param {Array} points Array of points (where each point is an object with x and y)
     * @param {Object} [options] Options object
     * @return {fabric.Polyline} thisArg
     * @example
     * var poly = new fabric.Polyline([
     *     { x: 10, y: 10 },
     *     { x: 50, y: 30 },
     *     { x: 40, y: 70 },
     *     { x: 60, y: 50 },
     *     { x: 100, y: 150 },
     *     { x: 40, y: 100 }
     *   ], {
     *   stroke: 'red',
     *   left: 100,
     *   top: 100
     * });
     */
    initialize: function(points, options) {
      options = options || {};
      this.points = points || [];
      this.callSuper('initialize', options);
      this._setPositionDimensions(options);
    },

    _setPositionDimensions: function(options) {
      var calcDim = this._calcDimensions(options), correctLeftTop;
      this.width = calcDim.width;
      this.height = calcDim.height;
      if (!options.fromSVG) {
        correctLeftTop = this.translateToGivenOrigin(
          { x: calcDim.left - this.strokeWidth / 2, y: calcDim.top - this.strokeWidth / 2 },
          'left',
          'top',
          this.originX,
          this.originY
        );
      }
      if (typeof options.left === 'undefined') {
        this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
      }
      if (typeof options.top === 'undefined') {
        this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
      }
      this.pathOffset = {
        x: calcDim.left + this.width / 2,
        y: calcDim.top + this.height / 2
      };
    },

    /**
     * Calculate the polygon min and max point from points array,
     * returning an object with left, top, widht, height to measure the
     * polygon size
     * @return {Object} object.left X coordinate of the polygon leftmost point
     * @return {Object} object.top Y coordinate of the polygon topmost point
     * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
     * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
     * @private
     */
    _calcDimensions: function() {

      var points = this.points,
          minX = min(points, 'x') || 0,
          minY = min(points, 'y') || 0,
          maxX = max(points, 'x') || 0,
          maxY = max(points, 'y') || 0,
          width = (maxX - minX),
          height = (maxY - minY);

      return {
        left: minX,
        top: minY,
        width: width,
        height: height
      };
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), {
        points: this.points.concat()
      });
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y,
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

      for (var i = 0, len = this.points.length; i < len; i++) {
        points.push(
          toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',',
          toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' '
        );
      }
      return [
        '<' + this.type + ' ', 'COMMON_PARTS',
        'points="', points.join(''),
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */


    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    commonRender: function(ctx) {
      var point, len = this.points.length,
          x = this.pathOffset.x,
          y = this.pathOffset.y;

      if (!len || isNaN(this.points[len - 1].y)) {
        // do not draw if no points or odd points
        // NaN comes from parseFloat of a empty string in parser
        return false;
      }
      ctx.beginPath();
      ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
      for (var i = 0; i < len; i++) {
        point = this.points[i];
        ctx.lineTo(point.x - x, point.y - y);
      }
      return true;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      if (!this.commonRender(ctx)) {
        return;
      }
      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var p1, p2;

      ctx.beginPath();
      for (var i = 0, len = this.points.length; i < len; i++) {
        p1 = this.points[i];
        p2 = this.points[i + 1] || p1;
        fabric.util.drawDashedLine(ctx, p1.x, p1.y, p2.x, p2.y, this.strokeDashArray);
      }
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance
     */
    complexity: function() {
      return this.get('points').length;
    }
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Polyline.fromElement})
   * @static
   * @memberOf fabric.Polyline
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
   */
  fabric.Polyline.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();

  /**
   * Returns fabric.Polyline instance from an SVG element
   * @static
   * @memberOf fabric.Polyline
   * @param {SVGElement} element Element to parser
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Polyline.fromElementGenerator = function(_class) {
    return function(element, callback, options) {
      if (!element) {
        return callback(null);
      }
      options || (options = { });

      var points = fabric.parsePointsAttribute(element.getAttribute('points')),
          parsedAttributes = fabric.parseAttributes(element, fabric[_class].ATTRIBUTE_NAMES);
      parsedAttributes.fromSVG = true;
      callback(new fabric[_class](points, extend(parsedAttributes, options)));
    };
  };

  fabric.Polyline.fromElement = fabric.Polyline.fromElementGenerator('Polyline');

  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Polyline instance from an object representation
   * @static
   * @memberOf fabric.Polyline
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */
  fabric.Polyline.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Polyline', object, callback, 'points');
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Polygon) {
    fabric.warn('fabric.Polygon is already defined');
    return;
  }

  /**
   * Polygon class
   * @class fabric.Polygon
   * @extends fabric.Polyline
   * @see {@link fabric.Polygon#initialize} for constructor definition
   */
  fabric.Polygon = fabric.util.createClass(fabric.Polyline, /** @lends fabric.Polygon.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'polygon',

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      if (!this.commonRender(ctx)) {
        return;
      }
      ctx.closePath();
      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      this.callSuper('_renderDashedStroke', ctx);
      ctx.closePath();
    },
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Polygon.fromElement`)
   * @static
   * @memberOf fabric.Polygon
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolygonElement
   */
  fabric.Polygon.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();

  /**
   * Returns {@link fabric.Polygon} instance from an SVG element
   * @static
   * @memberOf fabric.Polygon
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Polygon.fromElement = fabric.Polyline.fromElementGenerator('Polygon');
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Polygon instance from an object representation
   * @static
   * @memberOf fabric.Polygon
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */
  fabric.Polygon.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Polygon', object, callback, 'points');
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      min = fabric.util.array.min,
      max = fabric.util.array.max,
      extend = fabric.util.object.extend,
      _toString = Object.prototype.toString,
      drawArc = fabric.util.drawArc,
      toFixed = fabric.util.toFixed,
      commandLengths = {
        m: 2,
        l: 2,
        h: 1,
        v: 1,
        c: 6,
        s: 4,
        q: 4,
        t: 2,
        a: 7
      },
      repeatedCommands = {
        m: 'l',
        M: 'L'
      };

  if (fabric.Path) {
    fabric.warn('fabric.Path is already defined');
    return;
  }

  /**
   * Path class
   * @class fabric.Path
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#path_and_pathgroup}
   * @see {@link fabric.Path#initialize} for constructor definition
   */
  fabric.Path = fabric.util.createClass(fabric.Object, /** @lends fabric.Path.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'path',

    /**
     * Array of path points
     * @type Array
     * @default
     */
    path: null,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('path', 'fillRule'),

    stateProperties: fabric.Object.prototype.stateProperties.concat('path'),

    /**
     * Constructor
     * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
     * @param {Object} [options] Options object
     * @return {fabric.Path} thisArg
     */
    initialize: function(path, options) {
      options = options || { };
      this.callSuper('initialize', options);

      if (!path) {
        path = [];
      }

      var fromArray = _toString.call(path) === '[object Array]';

      this.path = fromArray
        ? path
        // one of commands (m,M,l,L,q,Q,c,C,etc.) followed by non-command characters (i.e. command values)
        : path.match && path.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);

      if (!this.path) {
        return;
      }

      if (!fromArray) {
        this.path = this._parsePath();
      }

      fabric.Polyline.prototype._setPositionDimensions.call(this, options);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _renderPathCommands: function(ctx) {
      var current, // current instruction
          previous = null,
          subpathStartX = 0,
          subpathStartY = 0,
          x = 0, // current x
          y = 0, // current y
          controlX = 0, // current control point x
          controlY = 0, // current control point y
          tempX,
          tempY,
          l = -this.pathOffset.x,
          t = -this.pathOffset.y;

      ctx.beginPath();

      for (var i = 0, len = this.path.length; i < len; ++i) {

        current = this.path[i];

        switch (current[0]) { // first letter

          case 'l': // lineto, relative
            x += current[1];
            y += current[2];
            ctx.lineTo(x + l, y + t);
            break;

          case 'L': // lineto, absolute
            x = current[1];
            y = current[2];
            ctx.lineTo(x + l, y + t);
            break;

          case 'h': // horizontal lineto, relative
            x += current[1];
            ctx.lineTo(x + l, y + t);
            break;

          case 'H': // horizontal lineto, absolute
            x = current[1];
            ctx.lineTo(x + l, y + t);
            break;

          case 'v': // vertical lineto, relative
            y += current[1];
            ctx.lineTo(x + l, y + t);
            break;

          case 'V': // verical lineto, absolute
            y = current[1];
            ctx.lineTo(x + l, y + t);
            break;

          case 'm': // moveTo, relative
            x += current[1];
            y += current[2];
            subpathStartX = x;
            subpathStartY = y;
            ctx.moveTo(x + l, y + t);
            break;

          case 'M': // moveTo, absolute
            x = current[1];
            y = current[2];
            subpathStartX = x;
            subpathStartY = y;
            ctx.moveTo(x + l, y + t);
            break;

          case 'c': // bezierCurveTo, relative
            tempX = x + current[5];
            tempY = y + current[6];
            controlX = x + current[3];
            controlY = y + current[4];
            ctx.bezierCurveTo(
              x + current[1] + l, // x1
              y + current[2] + t, // y1
              controlX + l, // x2
              controlY + t, // y2
              tempX + l,
              tempY + t
            );
            x = tempX;
            y = tempY;
            break;

          case 'C': // bezierCurveTo, absolute
            x = current[5];
            y = current[6];
            controlX = current[3];
            controlY = current[4];
            ctx.bezierCurveTo(
              current[1] + l,
              current[2] + t,
              controlX + l,
              controlY + t,
              x + l,
              y + t
            );
            break;

          case 's': // shorthand cubic bezierCurveTo, relative

            // transform to absolute x,y
            tempX = x + current[3];
            tempY = y + current[4];

            if (previous[0].match(/[CcSs]/) === null) {
              // If there is no previous command or if the previous command was not a C, c, S, or s,
              // the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control points
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }

            ctx.bezierCurveTo(
              controlX + l,
              controlY + t,
              x + current[1] + l,
              y + current[2] + t,
              tempX + l,
              tempY + t
            );
            // set control point to 2nd one of this command
            // "... the first control point is assumed to be
            // the reflection of the second control point on
            // the previous command relative to the current point."
            controlX = x + current[1];
            controlY = y + current[2];

            x = tempX;
            y = tempY;
            break;

          case 'S': // shorthand cubic bezierCurveTo, absolute
            tempX = current[3];
            tempY = current[4];
            if (previous[0].match(/[CcSs]/) === null) {
              // If there is no previous command or if the previous command was not a C, c, S, or s,
              // the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control points
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }
            ctx.bezierCurveTo(
              controlX + l,
              controlY + t,
              current[1] + l,
              current[2] + t,
              tempX + l,
              tempY + t
            );
            x = tempX;
            y = tempY;

            // set control point to 2nd one of this command
            // "... the first control point is assumed to be
            // the reflection of the second control point on
            // the previous command relative to the current point."
            controlX = current[1];
            controlY = current[2];

            break;

          case 'q': // quadraticCurveTo, relative
            // transform to absolute x,y
            tempX = x + current[3];
            tempY = y + current[4];

            controlX = x + current[1];
            controlY = y + current[2];

            ctx.quadraticCurveTo(
              controlX + l,
              controlY + t,
              tempX + l,
              tempY + t
            );
            x = tempX;
            y = tempY;
            break;

          case 'Q': // quadraticCurveTo, absolute
            tempX = current[3];
            tempY = current[4];

            ctx.quadraticCurveTo(
              current[1] + l,
              current[2] + t,
              tempX + l,
              tempY + t
            );
            x = tempX;
            y = tempY;
            controlX = current[1];
            controlY = current[2];
            break;

          case 't': // shorthand quadraticCurveTo, relative

            // transform to absolute x,y
            tempX = x + current[1];
            tempY = y + current[2];

            if (previous[0].match(/[QqTt]/) === null) {
              // If there is no previous command or if the previous command was not a Q, q, T or t,
              // assume the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control point
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }

            ctx.quadraticCurveTo(
              controlX + l,
              controlY + t,
              tempX + l,
              tempY + t
            );
            x = tempX;
            y = tempY;

            break;

          case 'T':
            tempX = current[1];
            tempY = current[2];

            if (previous[0].match(/[QqTt]/) === null) {
              // If there is no previous command or if the previous command was not a Q, q, T or t,
              // assume the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control point
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }
            ctx.quadraticCurveTo(
              controlX + l,
              controlY + t,
              tempX + l,
              tempY + t
            );
            x = tempX;
            y = tempY;
            break;

          case 'a':
            // TODO: optimize this
            drawArc(ctx, x + l, y + t, [
              current[1],
              current[2],
              current[3],
              current[4],
              current[5],
              current[6] + x + l,
              current[7] + y + t
            ]);
            x += current[6];
            y += current[7];
            break;

          case 'A':
            // TODO: optimize this
            drawArc(ctx, x + l, y + t, [
              current[1],
              current[2],
              current[3],
              current[4],
              current[5],
              current[6] + l,
              current[7] + t
            ]);
            x = current[6];
            y = current[7];
            break;

          case 'z':
          case 'Z':
            x = subpathStartX;
            y = subpathStartY;
            ctx.closePath();
            break;
        }
        previous = current;
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _render: function(ctx) {
      this._renderPathCommands(ctx);
      this._renderPaintInOrder(ctx);
    },

    /**
     * Returns string representation of an instance
     * @return {String} string representation of an instance
     */
    toString: function() {
      return '#<fabric.Path (' + this.complexity() +
        '): { "top": ' + this.top + ', "left": ' + this.left + ' }>';
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), {
        path: this.path.map(function(item) { return item.slice(); }),
      });
    },

    /**
     * Returns dataless object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function(propertiesToInclude) {
      var o = this.toObject(['sourcePath'].concat(propertiesToInclude));
      if (o.sourcePath) {
        delete o.path;
      }
      return o;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var path = this.path.map(function(path) {
        return path.join(' ');
      }).join(' ');
      return [
        '<path ', 'COMMON_PARTS',
        'd="', path,
        '" stroke-linecap="round" ',
        '/>\n'
      ];
    },

    _getOffsetTransform: function() {
      var digits = fabric.Object.NUM_FRACTION_DIGITS;
      return ' translate(' + toFixed(-this.pathOffset.x, digits) + ', ' +
          toFixed(-this.pathOffset.y, digits) + ')';
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function(reviver) {
      var additionalTransform = this._getOffsetTransform();
      return '\t' + this._createBaseClipPathSVGMarkup(
        this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform }
      );
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function(reviver) {
      var additionalTransform = this._getOffsetTransform();
      return this._createBaseSVGMarkup(this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform  });
    },
    /* _TO_SVG_END_ */

    /**
     * Returns number representation of an instance complexity
     * @return {Number} complexity of this instance
     */
    complexity: function() {
      return this.path.length;
    },

    /**
     * @private
     */
    _parsePath: function() {
      var result = [],
          coords = [],
          currentPath,
          parsed,
          re = fabric.rePathCommand,
          match,
          coordsStr;

      for (var i = 0, coordsParsed, len = this.path.length; i < len; i++) {
        currentPath = this.path[i];

        coordsStr = currentPath.slice(1).trim();
        coords.length = 0;

        while ((match = re.exec(coordsStr))) {
          coords.push(match[0]);
        }

        coordsParsed = [currentPath.charAt(0)];

        for (var j = 0, jlen = coords.length; j < jlen; j++) {
          parsed = parseFloat(coords[j]);
          if (!isNaN(parsed)) {
            coordsParsed.push(parsed);
          }
        }

        var command = coordsParsed[0],
            commandLength = commandLengths[command.toLowerCase()],
            repeatedCommand = repeatedCommands[command] || command;

        if (coordsParsed.length - 1 > commandLength) {
          for (var k = 1, klen = coordsParsed.length; k < klen; k += commandLength) {
            result.push([command].concat(coordsParsed.slice(k, k + commandLength)));
            command = repeatedCommand;
          }
        }
        else {
          result.push(coordsParsed);
        }
      }

      return result;
    },

    /**
     * @private
     */
    _calcDimensions: function() {

      var aX = [],
          aY = [],
          current, // current instruction
          previous = null,
          subpathStartX = 0,
          subpathStartY = 0,
          x = 0, // current x
          y = 0, // current y
          controlX = 0, // current control point x
          controlY = 0, // current control point y
          tempX,
          tempY,
          bounds;

      for (var i = 0, len = this.path.length; i < len; ++i) {

        current = this.path[i];

        switch (current[0]) { // first letter

          case 'l': // lineto, relative
            x += current[1];
            y += current[2];
            bounds = [];
            break;

          case 'L': // lineto, absolute
            x = current[1];
            y = current[2];
            bounds = [];
            break;

          case 'h': // horizontal lineto, relative
            x += current[1];
            bounds = [];
            break;

          case 'H': // horizontal lineto, absolute
            x = current[1];
            bounds = [];
            break;

          case 'v': // vertical lineto, relative
            y += current[1];
            bounds = [];
            break;

          case 'V': // verical lineto, absolute
            y = current[1];
            bounds = [];
            break;

          case 'm': // moveTo, relative
            x += current[1];
            y += current[2];
            subpathStartX = x;
            subpathStartY = y;
            bounds = [];
            break;

          case 'M': // moveTo, absolute
            x = current[1];
            y = current[2];
            subpathStartX = x;
            subpathStartY = y;
            bounds = [];
            break;

          case 'c': // bezierCurveTo, relative
            tempX = x + current[5];
            tempY = y + current[6];
            controlX = x + current[3];
            controlY = y + current[4];
            bounds = fabric.util.getBoundsOfCurve(x, y,
              x + current[1], // x1
              y + current[2], // y1
              controlX, // x2
              controlY, // y2
              tempX,
              tempY
            );
            x = tempX;
            y = tempY;
            break;

          case 'C': // bezierCurveTo, absolute
            controlX = current[3];
            controlY = current[4];
            bounds = fabric.util.getBoundsOfCurve(x, y,
              current[1],
              current[2],
              controlX,
              controlY,
              current[5],
              current[6]
            );
            x = current[5];
            y = current[6];
            break;

          case 's': // shorthand cubic bezierCurveTo, relative

            // transform to absolute x,y
            tempX = x + current[3];
            tempY = y + current[4];

            if (previous[0].match(/[CcSs]/) === null) {
              // If there is no previous command or if the previous command was not a C, c, S, or s,
              // the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control points
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }

            bounds = fabric.util.getBoundsOfCurve(x, y,
              controlX,
              controlY,
              x + current[1],
              y + current[2],
              tempX,
              tempY
            );
            // set control point to 2nd one of this command
            // "... the first control point is assumed to be
            // the reflection of the second control point on
            // the previous command relative to the current point."
            controlX = x + current[1];
            controlY = y + current[2];
            x = tempX;
            y = tempY;
            break;

          case 'S': // shorthand cubic bezierCurveTo, absolute
            tempX = current[3];
            tempY = current[4];
            if (previous[0].match(/[CcSs]/) === null) {
              // If there is no previous command or if the previous command was not a C, c, S, or s,
              // the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control points
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }
            bounds = fabric.util.getBoundsOfCurve(x, y,
              controlX,
              controlY,
              current[1],
              current[2],
              tempX,
              tempY
            );
            x = tempX;
            y = tempY;
            // set control point to 2nd one of this command
            // "... the first control point is assumed to be
            // the reflection of the second control point on
            // the previous command relative to the current point."
            controlX = current[1];
            controlY = current[2];
            break;

          case 'q': // quadraticCurveTo, relative
            // transform to absolute x,y
            tempX = x + current[3];
            tempY = y + current[4];
            controlX = x + current[1];
            controlY = y + current[2];
            bounds = fabric.util.getBoundsOfCurve(x, y,
              controlX,
              controlY,
              controlX,
              controlY,
              tempX,
              tempY
            );
            x = tempX;
            y = tempY;
            break;

          case 'Q': // quadraticCurveTo, absolute
            controlX = current[1];
            controlY = current[2];
            bounds = fabric.util.getBoundsOfCurve(x, y,
              controlX,
              controlY,
              controlX,
              controlY,
              current[3],
              current[4]
            );
            x = current[3];
            y = current[4];
            break;

          case 't': // shorthand quadraticCurveTo, relative
            // transform to absolute x,y
            tempX = x + current[1];
            tempY = y + current[2];
            if (previous[0].match(/[QqTt]/) === null) {
              // If there is no previous command or if the previous command was not a Q, q, T or t,
              // assume the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control point
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }

            bounds = fabric.util.getBoundsOfCurve(x, y,
              controlX,
              controlY,
              controlX,
              controlY,
              tempX,
              tempY
            );
            x = tempX;
            y = tempY;

            break;

          case 'T':
            tempX = current[1];
            tempY = current[2];

            if (previous[0].match(/[QqTt]/) === null) {
              // If there is no previous command or if the previous command was not a Q, q, T or t,
              // assume the control point is coincident with the current point
              controlX = x;
              controlY = y;
            }
            else {
              // calculate reflection of previous control point
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            }
            bounds = fabric.util.getBoundsOfCurve(x, y,
              controlX,
              controlY,
              controlX,
              controlY,
              tempX,
              tempY
            );
            x = tempX;
            y = tempY;
            break;

          case 'a':
            // TODO: optimize this
            bounds = fabric.util.getBoundsOfArc(x, y,
              current[1],
              current[2],
              current[3],
              current[4],
              current[5],
              current[6] + x,
              current[7] + y
            );
            x += current[6];
            y += current[7];
            break;

          case 'A':
            // TODO: optimize this
            bounds = fabric.util.getBoundsOfArc(x, y,
              current[1],
              current[2],
              current[3],
              current[4],
              current[5],
              current[6],
              current[7]
            );
            x = current[6];
            y = current[7];
            break;

          case 'z':
          case 'Z':
            x = subpathStartX;
            y = subpathStartY;
            break;
        }
        previous = current;
        bounds.forEach(function (point) {
          aX.push(point.x);
          aY.push(point.y);
        });
        aX.push(x);
        aY.push(y);
      }

      var minX = min(aX) || 0,
          minY = min(aY) || 0,
          maxX = max(aX) || 0,
          maxY = max(aY) || 0,
          deltaX = maxX - minX,
          deltaY = maxY - minY;

      return {
        left: minX,
        top: minY,
        width: deltaX,
        height: deltaY
      };
    }
  });

  /**
   * Creates an instance of fabric.Path from an object
   * @static
   * @memberOf fabric.Path
   * @param {Object} object
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */
  fabric.Path.fromObject = function(object, callback) {
    if (typeof object.sourcePath === 'string') {
      var pathUrl = object.sourcePath;
      fabric.loadSVGFromURL(pathUrl, function (elements) {
        var path = elements[0];
        path.setOptions(object);
        callback && callback(path);
      });
    }
    else {
      fabric.Object._fromObject('Path', object, callback, 'path');
    }
  };

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Path.fromElement`)
   * @static
   * @memberOf fabric.Path
   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
   */
  fabric.Path.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(['d']);

  /**
   * Creates an instance of fabric.Path from an SVG <path> element
   * @static
   * @memberOf fabric.Path
   * @param {SVGElement} element to parse
   * @param {Function} callback Callback to invoke when an fabric.Path instance is created
   * @param {Object} [options] Options object
   * @param {Function} [callback] Options callback invoked after parsing is finished
   */
  fabric.Path.fromElement = function(element, callback, options) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Path.ATTRIBUTE_NAMES);
    parsedAttributes.fromSVG = true;
    callback(new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)));
  };
  /* _FROM_SVG_END_ */

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      min = fabric.util.array.min,
      max = fabric.util.array.max;

  if (fabric.Group) {
    return;
  }

  /**
   * Group class
   * @class fabric.Group
   * @extends fabric.Object
   * @mixes fabric.Collection
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.Group#initialize} for constructor definition
   */
  fabric.Group = fabric.util.createClass(fabric.Object, fabric.Collection, /** @lends fabric.Group.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'group',

    /**
     * Width of stroke
     * @type Number
     * @default
     */
    strokeWidth: 0,

    /**
     * Indicates if click, mouseover, mouseout events & hoverCursor should also check for subtargets
     * @type Boolean
     * @default
     */
    subTargetCheck: false,

    /**
     * Groups are container, do not render anything on theyr own, ence no cache properties
     * @type Array
     * @default
     */
    cacheProperties: [],

    /**
     * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
     * available setting this boolean to true.
     * @type Boolean
     * @since 2.0.0
     * @default
     */
    useSetOnGroup: false,

    /**
     * Constructor
     * @param {Object} objects Group objects
     * @param {Object} [options] Options object
     * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
     * @return {Object} thisArg
     */
    initialize: function(objects, options, isAlreadyGrouped) {
      options = options || {};
      this._objects = [];
      // if objects enclosed in a group have been grouped already,
      // we cannot change properties of objects.
      // Thus we need to set options to group without objects,
      isAlreadyGrouped && this.callSuper('initialize', options);
      this._objects = objects || [];
      for (var i = this._objects.length; i--; ) {
        this._objects[i].group = this;
      }

      if (!isAlreadyGrouped) {
        var center = options && options.centerPoint;
        // we want to set origins before calculating the bounding box.
        // so that the topleft can be set with that in mind.
        // if specific top and left are passed, are overwritten later
        // with the callSuper('initialize', options)
        if (options.originX !== undefined) {
          this.originX = options.originX;
        }
        if (options.originY !== undefined) {
          this.originY = options.originY;
        }
        // if coming from svg i do not want to calc bounds.
        // i assume width and height are passed along options
        center || this._calcBounds();
        this._updateObjectsCoords(center);
        delete options.centerPoint;
        this.callSuper('initialize', options);
      }
      else {
        this._updateObjectsACoords();
      }

      this.setCoords();
    },

    /**
     * @private
     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
     */
    _updateObjectsACoords: function() {
      var ignoreZoom = true, skipAbsolute = true;
      for (var i = this._objects.length; i--; ){
        this._objects[i].setCoords(ignoreZoom, skipAbsolute);
      }
    },

    /**
     * @private
     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
     */
    _updateObjectsCoords: function(center) {
      var center = center || this.getCenterPoint();
      for (var i = this._objects.length; i--; ){
        this._updateObjectCoords(this._objects[i], center);
      }
    },

    /**
     * @private
     * @param {Object} object
     * @param {fabric.Point} center, current center of group.
     */
    _updateObjectCoords: function(object, center) {
      var objectLeft = object.left,
          objectTop = object.top,
          ignoreZoom = true, skipAbsolute = true;

      object.set({
        left: objectLeft - center.x,
        top: objectTop - center.y
      });
      object.group = this;
      object.setCoords(ignoreZoom, skipAbsolute);
    },

    /**
     * Returns string represenation of a group
     * @return {String}
     */
    toString: function() {
      return '#<fabric.Group: (' + this.complexity() + ')>';
    },

    /**
     * Adds an object to a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */
    addWithUpdate: function(object) {
      this._restoreObjectsState();
      fabric.util.resetObjectTransform(this);
      if (object) {
        this._objects.push(object);
        object.group = this;
        object._set('canvas', this.canvas);
      }
      this._calcBounds();
      this._updateObjectsCoords();
      this.setCoords();
      this.dirty = true;
      return this;
    },

    /**
     * Removes an object from a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */
    removeWithUpdate: function(object) {
      this._restoreObjectsState();
      fabric.util.resetObjectTransform(this);

      this.remove(object);
      this._calcBounds();
      this._updateObjectsCoords();
      this.setCoords();
      this.dirty = true;
      return this;
    },

    /**
     * @private
     */
    _onObjectAdded: function(object) {
      this.dirty = true;
      object.group = this;
      object._set('canvas', this.canvas);
    },

    /**
     * @private
     */
    _onObjectRemoved: function(object) {
      this.dirty = true;
      delete object.group;
    },

    /**
     * @private
     */
    _set: function(key, value) {
      var i = this._objects.length;
      if (this.useSetOnGroup) {
        while (i--) {
          this._objects[i].setOnGroup(key, value);
        }
      }
      if (key === 'canvas') {
        while (i--) {
          this._objects[i]._set(key, value);
        }
      }
      fabric.Object.prototype._set.call(this, key, value);
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var _includeDefaultValues = this.includeDefaultValues;
      var objsToObject = this._objects.map(function(obj) {
        var originalDefaults = obj.includeDefaultValues;
        obj.includeDefaultValues = _includeDefaultValues;
        var _obj = obj.toObject(propertiesToInclude);
        obj.includeDefaultValues = originalDefaults;
        return _obj;
      });
      var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
      obj.objects = objsToObject;
      return obj;
    },

    /**
     * Returns object representation of an instance, in dataless mode.
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function(propertiesToInclude) {
      var objsToObject, sourcePath = this.sourcePath;
      if (sourcePath) {
        objsToObject = sourcePath;
      }
      else {
        var _includeDefaultValues = this.includeDefaultValues;
        objsToObject = this._objects.map(function(obj) {
          var originalDefaults = obj.includeDefaultValues;
          obj.includeDefaultValues = _includeDefaultValues;
          var _obj = obj.toDatalessObject(propertiesToInclude);
          obj.includeDefaultValues = originalDefaults;
          return _obj;
        });
      }
      var obj = fabric.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
      obj.objects = objsToObject;
      return obj;
    },

    /**
     * Renders instance on a given context
     * @param {CanvasRenderingContext2D} ctx context to render instance on
     */
    render: function(ctx) {
      this._transformDone = true;
      this.callSuper('render', ctx);
      this._transformDone = false;
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group is already cached.
     * @return {Boolean}
     */
    shouldCache: function() {
      var ownCache = fabric.Object.prototype.shouldCache.call(this);
      if (ownCache) {
        for (var i = 0, len = this._objects.length; i < len; i++) {
          if (this._objects[i].willDrawShadow()) {
            this.ownCaching = false;
            return false;
          }
        }
      }
      return ownCache;
    },

    /**
     * Check if this object or a child object will cast a shadow
     * @return {Boolean}
     */
    willDrawShadow: function() {
      if (fabric.Object.prototype.willDrawShadow.call(this)) {
        return true;
      }
      for (var i = 0, len = this._objects.length; i < len; i++) {
        if (this._objects[i].willDrawShadow()) {
          return true;
        }
      }
      return false;
    },

    /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache: function() {
      return this.ownCaching || (this.group && this.group.isOnACache());
    },

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function(ctx) {
      for (var i = 0, len = this._objects.length; i < len; i++) {
        this._objects[i].render(ctx);
      }
      this._drawClipPath(ctx);
    },

    /**
     * Check if cache is dirty
     */
    isCacheDirty: function(skipCanvas) {
      if (this.callSuper('isCacheDirty', skipCanvas)) {
        return true;
      }
      if (!this.statefullCache) {
        return false;
      }
      for (var i = 0, len = this._objects.length; i < len; i++) {
        if (this._objects[i].isCacheDirty(true)) {
          if (this._cacheCanvas) {
            // if this group has not a cache canvas there is nothing to clean
            var x = this.cacheWidth / this.zoomX, y = this.cacheHeight / this.zoomY;
            this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
          }
          return true;
        }
      }
      return false;
    },

    /**
     * Retores original state of each of group objects (original state is that which was before group was created).
     * @private
     * @return {fabric.Group} thisArg
     * @chainable
     */
    _restoreObjectsState: function() {
      this._objects.forEach(this._restoreObjectState, this);
      return this;
    },

    /**
     * Realises the transform from this group onto the supplied object
     * i.e. it tells you what would happen if the supplied object was in
     * the group, and then the group was destroyed. It mutates the supplied
     * object.
     * @param {fabric.Object} object
     * @return {fabric.Object} transformedObject
     */
    realizeTransform: function(object) {
      var matrix = object.calcTransformMatrix(),
          options = fabric.util.qrDecompose(matrix),
          center = new fabric.Point(options.translateX, options.translateY);
      object.flipX = false;
      object.flipY = false;
      object.set('scaleX', options.scaleX);
      object.set('scaleY', options.scaleY);
      object.skewX = options.skewX;
      object.skewY = options.skewY;
      object.angle = options.angle;
      object.setPositionByOrigin(center, 'center', 'center');
      return object;
    },

    /**
     * Restores original state of a specified object in group
     * @private
     * @param {fabric.Object} object
     * @return {fabric.Group} thisArg
     */
    _restoreObjectState: function(object) {
      this.realizeTransform(object);
      object.setCoords();
      delete object.group;
      return this;
    },

    /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */
    destroy: function() {
      // when group is destroyed objects needs to get a repaint to be eventually
      // displayed on canvas.
      this._objects.forEach(function(object) {
        object.set('dirty', true);
      });
      return this._restoreObjectsState();
    },

    /**
     * make a group an active selection, remove the group from canvas
     * the group has to be on canvas for this to work.
     * @return {fabric.ActiveSelection} thisArg
     * @chainable
     */
    toActiveSelection: function() {
      if (!this.canvas) {
        return;
      }
      var objects = this._objects, canvas = this.canvas;
      this._objects = [];
      var options = this.toObject();
      delete options.objects;
      var activeSelection = new fabric.ActiveSelection([]);
      activeSelection.set(options);
      activeSelection.type = 'activeSelection';
      canvas.remove(this);
      objects.forEach(function(object) {
        object.group = activeSelection;
        object.dirty = true;
        canvas.add(object);
      });
      activeSelection.canvas = canvas;
      activeSelection._objects = objects;
      canvas._activeObject = activeSelection;
      activeSelection.setCoords();
      return activeSelection;
    },

    /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */
    ungroupOnCanvas: function() {
      return this._restoreObjectsState();
    },

    /**
     * Sets coordinates of all objects inside group
     * @return {fabric.Group} thisArg
     * @chainable
     */
    setObjectsCoords: function() {
      var ignoreZoom = true, skipAbsolute = true;
      this.forEachObject(function(object) {
        object.setCoords(ignoreZoom, skipAbsolute);
      });
      return this;
    },

    /**
     * @private
     */
    _calcBounds: function(onlyWidthHeight) {
      var aX = [],
          aY = [],
          o, prop,
          props = ['tr', 'br', 'bl', 'tl'],
          i = 0, iLen = this._objects.length,
          j, jLen = props.length,
          ignoreZoom = true;

      for ( ; i < iLen; ++i) {
        o = this._objects[i];
        o.setCoords(ignoreZoom);
        for (j = 0; j < jLen; j++) {
          prop = props[j];
          aX.push(o.oCoords[prop].x);
          aY.push(o.oCoords[prop].y);
        }
      }

      this._getBounds(aX, aY, onlyWidthHeight);
    },

    /**
     * @private
     */
    _getBounds: function(aX, aY, onlyWidthHeight) {
      var minXY = new fabric.Point(min(aX), min(aY)),
          maxXY = new fabric.Point(max(aX), max(aY)),
          top = minXY.y || 0, left = minXY.x || 0,
          width = (maxXY.x - minXY.x) || 0,
          height = (maxXY.y - minXY.y) || 0;
      this.width = width;
      this.height = height;
      if (!onlyWidthHeight) {
        // the bounding box always finds the topleft most corner.
        // whatever is the group origin, we set up here the left/top position.
        this.setPositionByOrigin({ x: left, y: top }, 'left', 'top');
      }
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    _toSVG: function(reviver) {
      var svgString = ['<g ', 'COMMON_PARTS', ' >\n'];

      for (var i = 0, len = this._objects.length; i < len; i++) {
        svgString.push('\t\t', this._objects[i].toSVG(reviver));
      }
      svgString.push('</g>\n');
      return svgString;
    },

    /**
     * Returns styles-string for svg-export, specific version for group
     * @return {String}
     */
    getSvgStyles: function() {
      var opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ?
            'opacity: ' + this.opacity + ';' : '',
          visibility = this.visible ? '' : ' visibility: hidden;';
      return [
        opacity,
        this.getSvgFilter(),
        visibility
      ].join('');
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function(reviver) {
      var svgString = [];

      for (var i = 0, len = this._objects.length; i < len; i++) {
        svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
      }

      return this._createBaseClipPathSVGMarkup(svgString, { reviver: reviver });
    },
    /* _TO_SVG_END_ */
  });

  /**
   * Returns {@link fabric.Group} instance from an object representation
   * @static
   * @memberOf fabric.Group
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an group instance is created
   */
  fabric.Group.fromObject = function(object, callback) {
    var objects = object.objects,
        options = fabric.util.object.clone(object, true);
    delete options.objects;
    if (typeof objects === 'string') {
      // it has to be an url or something went wrong.
      fabric.loadSVGFromURL(objects, function (elements) {
        var group = fabric.util.groupSVGElements(elements, object, objects);
        group.set(options);
        callback && callback(group);
      });
      return;
    }
    fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
      fabric.util.enlivenObjects([object.clipPath], function(enlivedClipPath) {
        var options = fabric.util.object.clone(object, true);
        options.clipPath = enlivedClipPath[0];
        delete options.objects;
        callback && callback(new fabric.Group(enlivenedObjects, options, true));
      });
    });
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.ActiveSelection) {
    return;
  }

  /**
   * Group class
   * @class fabric.ActiveSelection
   * @extends fabric.Group
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.ActiveSelection#initialize} for constructor definition
   */
  fabric.ActiveSelection = fabric.util.createClass(fabric.Group, /** @lends fabric.ActiveSelection.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'activeSelection',

    /**
     * Constructor
     * @param {Object} objects ActiveSelection objects
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(objects, options) {
      options = options || {};
      this._objects = objects || [];
      for (var i = this._objects.length; i--; ) {
        this._objects[i].group = this;
      }

      if (options.originX) {
        this.originX = options.originX;
      }
      if (options.originY) {
        this.originY = options.originY;
      }
      this._calcBounds();
      this._updateObjectsCoords();
      fabric.Object.prototype.initialize.call(this, options);
      this.setCoords();
    },

    /**
     * Change te activeSelection to a normal group,
     * High level function that automatically adds it to canvas as
     * active object. no events fired.
     * @since 2.0.0
     * @return {fabric.Group}
     */
    toGroup: function() {
      var objects = this._objects.concat();
      this._objects = [];
      var options = fabric.Object.prototype.toObject.call(this);
      var newGroup = new fabric.Group([]);
      delete options.type;
      newGroup.set(options);
      objects.forEach(function(object) {
        object.canvas.remove(object);
        object.group = newGroup;
      });
      newGroup._objects = objects;
      if (!this.canvas) {
        return newGroup;
      }
      var canvas = this.canvas;
      canvas.add(newGroup);
      canvas._activeObject = newGroup;
      newGroup.setCoords();
      return newGroup;
    },

    /**
     * If returns true, deselection is cancelled.
     * @since 2.0.0
     * @return {Boolean} [cancel]
     */
    onDeselect: function() {
      this.destroy();
      return false;
    },

    /**
     * Returns string representation of a group
     * @return {String}
     */
    toString: function() {
      return '#<fabric.ActiveSelection: (' + this.complexity() + ')>';
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * @return {Boolean}
     */
    shouldCache: function() {
      return false;
    },

    /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache: function() {
      return false;
    },

    /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     * @param {Object} [childrenOverride] properties to override the children overrides
     */
    _renderControls: function(ctx, styleOverride, childrenOverride) {
      ctx.save();
      ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      this.callSuper('_renderControls', ctx, styleOverride);
      childrenOverride = childrenOverride || { };
      if (typeof childrenOverride.hasControls === 'undefined') {
        childrenOverride.hasControls = false;
      }
      if (typeof childrenOverride.hasRotatingPoint === 'undefined') {
        childrenOverride.hasRotatingPoint = false;
      }
      childrenOverride.forActiveSelection = true;
      for (var i = 0, len = this._objects.length; i < len; i++) {
        this._objects[i]._renderControls(ctx, childrenOverride);
      }
      ctx.restore();
    },
  });

  /**
   * Returns {@link fabric.ActiveSelection} instance from an object representation
   * @static
   * @memberOf fabric.ActiveSelection
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an ActiveSelection instance is created
   */
  fabric.ActiveSelection.fromObject = function(object, callback) {
    fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
      delete object.objects;
      callback && callback(new fabric.ActiveSelection(enlivenedObjects, object, true));
    });
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var extend = fabric.util.object.extend;

  if (!global.fabric) {
    global.fabric = { };
  }

  if (global.fabric.Image) {
    fabric.warn('fabric.Image is already defined.');
    return;
  }

  /**
   * Image class
   * @class fabric.Image
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
   * @see {@link fabric.Image#initialize} for constructor definition
   */
  fabric.Image = fabric.util.createClass(fabric.Object, /** @lends fabric.Image.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'image',

    /**
     * crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @type String
     * @default
     */
    crossOrigin: '',

    /**
     * Width of a stroke.
     * For image quality a stroke multiple of 2 gives better results.
     * @type Number
     * @default
     */
    strokeWidth: 0,

    /**
     * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
     * This allows for relative urls as image src.
     * @since 2.7.0
     * @type Boolean
     * @default
     */
    srcFromAttribute: false,

    /**
     * private
     * contains last value of scaleX to detect
     * if the Image got resized after the last Render
     * @type Number
     */
    _lastScaleX: 1,

    /**
     * private
     * contains last value of scaleY to detect
     * if the Image got resized after the last Render
     * @type Number
     */
    _lastScaleY: 1,

    /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */
    _filterScalingX: 1,

    /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */
    _filterScalingY: 1,

    /**
     * minimum scale factor under which any resizeFilter is triggered to resize the image
     * 0 will disable the automatic resize. 1 will trigger automatically always.
     * number bigger than 1 are not implemented yet.
     * @type Number
     */
    minimumScaleTrigger: 0.5,

    /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('cropX', 'cropY'),

    /**
     * key used to retrieve the texture representing this image
     * @since 2.0.0
     * @type String
     * @default
     */
    cacheKey: '',

    /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */
    cropX: 0,

    /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */
    cropY: 0,

    /**
     * Constructor
     * @param {HTMLImageElement | String} element Image element
     * @param {Object} [options] Options object
     * @param {function} [callback] callback function to call after eventual filters applied.
     * @return {fabric.Image} thisArg
     */
    initialize: function(element, options) {
      options || (options = { });
      this.filters = [];
      this.cacheKey = 'texture' + fabric.Object.__uid++;
      this.callSuper('initialize', options);
      this._initElement(element, options);
    },

    /**
     * Returns image element which this instance if based on
     * @return {HTMLImageElement} Image element
     */
    getElement: function() {
      return this._element || {};
    },

    /**
     * Sets image element for this instance to a specified one.
     * If filters defined they are applied to new image.
     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
     * @param {HTMLImageElement} element
     * @param {Object} [options] Options object
     * @return {fabric.Image} thisArg
     * @chainable
     */
    setElement: function(element, options) {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + '_filtered');
      this._element = element;
      this._originalElement = element;
      this._initConfig(options);
      if (this.filters.length !== 0) {
        this.applyFilters();
      }
      // resizeFilters work on the already filtered copy.
      // we need to apply resizeFilters AFTER normal filters.
      // applyResizeFilters is run more often than normal fiters
      // and is triggered by user interactions rather than dev code
      if (this.resizeFilter) {
        this.applyResizeFilters();
      }
      return this;
    },

    /**
     * Delete a single texture if in webgl mode
     */
    removeTexture: function(key) {
      var backend = fabric.filterBackend;
      if (backend && backend.evictCachesForKey) {
        backend.evictCachesForKey(key);
      }
    },

    /**
     * Delete textures, reference to elements and eventually JSDOM cleanup
     */
    dispose: function() {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + '_filtered');
      this._cacheContext = undefined;
      ['_originalElement', '_element', '_filteredEl', '_cacheCanvas'].forEach((function(element) {
        fabric.util.cleanUpJsdomNode(this[element]);
        this[element] = undefined;
      }).bind(this));
    },

    /**
     * Sets crossOrigin value (on an instance and corresponding image element)
     * @return {fabric.Image} thisArg
     * @chainable
     */
    setCrossOrigin: function(value) {
      this.crossOrigin = value;
      this._element.crossOrigin = value;

      return this;
    },

    /**
     * Returns original size of an image
     * @return {Object} Object with "width" and "height" properties
     */
    getOriginalSize: function() {
      var element = this.getElement();
      return {
        width: element.naturalWidth || element.width,
        height: element.naturalHeight || element.height
      };
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _stroke: function(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }
      var w = this.width / 2, h = this.height / 2;
      ctx.beginPath();
      ctx.moveTo(-w, -h);
      ctx.lineTo(w, -h);
      ctx.lineTo(w, h);
      ctx.lineTo(-w, h);
      ctx.lineTo(-w, -h);
      ctx.closePath();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var x = -this.width / 2,
          y = -this.height / 2,
          w = this.width,
          h = this.height;

      ctx.save();
      this._setStrokeStyles(ctx, this);

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
      ctx.closePath();
      ctx.restore();
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var filters = [];

      this.filters.forEach(function(filterObj) {
        if (filterObj) {
          filters.push(filterObj.toObject());
        }
      });
      var object = extend(
        this.callSuper(
          'toObject',
          ['crossOrigin', 'cropX', 'cropY'].concat(propertiesToInclude)
        ), {
          src: this.getSrc(),
          filters: filters,
        });
      if (this.resizeFilter) {
        object.resizeFilter = this.resizeFilter.toObject();
      }
      return object;
    },

    /**
     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,hight.
     * @return {Boolean}
     */
    hasCrop: function() {
      return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var svgString = [], imageMarkup = [], strokeSvg,
          x = -this.width / 2, y = -this.height / 2, clipPath = '';
      if (this.hasCrop()) {
        var clipPathId = fabric.Object.__uid++;
        svgString.push(
          '<clipPath id="imageCrop_' + clipPathId + '">\n',
          '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n',
          '</clipPath>\n'
        );
        clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
      }
      imageMarkup.push('\t<image ', 'COMMON_PARTS', 'xlink:href="', this.getSvgSrc(true),
        '" x="', x - this.cropX, '" y="', y - this.cropY,
        // we're essentially moving origin of transformation from top/left corner to the center of the shape
        // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
        // so that object's center aligns with container's left/top
        '" width="', this._element.width || this._element.naturalWidth,
        '" height="', this._element.height || this._element.height,
        '"', clipPath,
        '></image>\n');

      if (this.stroke || this.strokeDashArray) {
        var origFill = this.fill;
        this.fill = null;
        strokeSvg = [
          '\t<rect ',
          'x="', x, '" y="', y,
          '" width="', this.width, '" height="', this.height,
          '" style="', this.getSvgStyles(),
          '"/>\n'
        ];
        this.fill = origFill;
      }
      if (this.paintFirst !== 'fill') {
        svgString = svgString.concat(strokeSvg, imageMarkup);
      }
      else {
        svgString = svgString.concat(imageMarkup, strokeSvg);
      }
      return svgString;
    },
    /* _TO_SVG_END_ */

    /**
     * Returns source of an image
     * @param {Boolean} filtered indicates if the src is needed for svg
     * @return {String} Source of an image
     */
    getSrc: function(filtered) {
      var element = filtered ? this._element : this._originalElement;
      if (element) {
        if (element.toDataURL) {
          return element.toDataURL();
        }

        if (this.srcFromAttribute) {
          return element.getAttribute('src');
        }
        else {
          return element.src;
        }
      }
      else {
        return this.src || '';
      }
    },

    /**
     * Sets source of an image
     * @param {String} src Source string (URL)
     * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
     * @param {Object} [options] Options object
     * @return {fabric.Image} thisArg
     * @chainable
     */
    setSrc: function(src, callback, options) {
      fabric.util.loadImage(src, function(img) {
        this.setElement(img, options);
        this._setWidthHeight();
        callback && callback(this);
      }, this, options && options.crossOrigin);
      return this;
    },

    /**
     * Returns string representation of an instance
     * @return {String} String representation of an instance
     */
    toString: function() {
      return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
    },

    applyResizeFilters: function() {
      var filter = this.resizeFilter,
          minimumScale = this.minimumScaleTrigger,
          objectScale = this.getTotalObjectScaling(),
          scaleX = objectScale.scaleX,
          scaleY = objectScale.scaleY,
          elementToFilter = this._filteredEl || this._originalElement;
      if (this.group) {
        this.set('dirty', true);
      }
      if (!filter || (scaleX > minimumScale && scaleY > minimumScale)) {
        this._element = elementToFilter;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        this._lastScaleX = scaleX;
        this._lastScaleY = scaleY;
        return;
      }
      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }
      var canvasEl = fabric.util.createCanvasElement(),
          cacheKey = this._filteredEl ? (this.cacheKey + '_filtered') : this.cacheKey,
          sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
      canvasEl.width = sourceWidth;
      canvasEl.height = sourceHeight;
      this._element = canvasEl;
      this._lastScaleX = filter.scaleX = scaleX;
      this._lastScaleY = filter.scaleY = scaleY;
      fabric.filterBackend.applyFilters(
        [filter], elementToFilter, sourceWidth, sourceHeight, this._element, cacheKey);
      this._filterScalingX = canvasEl.width / this._originalElement.width;
      this._filterScalingY = canvasEl.height / this._originalElement.height;
    },

    /**
     * Applies filters assigned to this image (from "filters" array) or from filter param
     * @method applyFilters
     * @param {Array} filters to be applied
     * @param {Boolean} forResizing specify if the filter operation is a resize operation
     * @return {thisArg} return the fabric.Image object
     * @chainable
     */
    applyFilters: function(filters) {

      filters = filters || this.filters || [];
      filters = filters.filter(function(filter) { return filter && !filter.isNeutralState(); });
      this.set('dirty', true);

      // needs to clear out or WEBGL will not resize correctly
      this.removeTexture(this.cacheKey + '_filtered');

      if (filters.length === 0) {
        this._element = this._originalElement;
        this._filteredEl = null;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        return this;
      }

      var imgElement = this._originalElement,
          sourceWidth = imgElement.naturalWidth || imgElement.width,
          sourceHeight = imgElement.naturalHeight || imgElement.height;

      if (this._element === this._originalElement) {
        // if the element is the same we need to create a new element
        var canvasEl = fabric.util.createCanvasElement();
        canvasEl.width = sourceWidth;
        canvasEl.height = sourceHeight;
        this._element = canvasEl;
        this._filteredEl = canvasEl;
      }
      else {
        // clear the existing element to get new filter data
        // also dereference the eventual resized _element
        this._element = this._filteredEl;
        this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
        // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
        this._lastScaleX = 1;
        this._lastScaleY = 1;
      }
      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }
      fabric.filterBackend.applyFilters(
        filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
      if (this._originalElement.width !== this._element.width ||
        this._originalElement.height !== this._element.height) {
        this._filterScalingX = this._element.width / this._originalElement.width;
        this._filterScalingY = this._element.height / this._originalElement.height;
      }
      return this;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
        this.applyResizeFilters();
      }
      this._stroke(ctx);
      this._renderPaintInOrder(ctx);
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * This is the special image version where we would like to avoid caching where possible.
     * Essentially images do not benefit from caching. They may require caching, and in that
     * case we do it. Also caching an image usually ends in a loss of details.
     * A full performance audit should be done.
     * @return {Boolean}
     */
    shouldCache: function() {
      return this.needsItsOwnCache();
    },

    _renderFill: function(ctx) {
      var elementToDraw = this._element;
      if (!elementToDraw) {
        return;
      }
      var scaleX = this._filterScalingX, scaleY = this._filterScalingY,
          w = this.width, h = this.height, min = Math.min, max = Math.max,
          // crop values cannot be lesser than 0.
          cropX = max(this.cropX, 0), cropY = max(this.cropY, 0),
          elWidth = elementToDraw.naturalWidth || elementToDraw.width,
          elHeight = elementToDraw.naturalHeight || elementToDraw.height,
          sX = cropX * scaleX,
          sY = cropY * scaleY,
          // the width height cannot exceed element width/height, starting from the crop offset.
          sW = min(w * scaleX, elWidth - sX),
          sH = min(h * scaleY, elHeight - sY),
          x = -w / 2, y = -h / 2,
          maxDestW = min(w, elWidth / scaleX - cropX),
          maxDestH = min(h, elHeight / scaleX - cropY);

      elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    },

    /**
     * needed to check if image needs resize
     * @private
     */
    _needsResize: function() {
      var scale = this.getTotalObjectScaling();
      return (scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY);
    },

    /**
     * @private
     */
    _resetWidthHeight: function() {
      this.set(this.getOriginalSize());
    },

    /**
     * The Image class's initialization method. This method is automatically
     * called by the constructor.
     * @private
     * @param {HTMLImageElement|String} element The element representing the image
     * @param {Object} [options] Options object
     */
    _initElement: function(element, options) {
      this.setElement(fabric.util.getById(element), options);
      fabric.util.addClass(this.getElement(), fabric.Image.CSS_CANVAS);
    },

    /**
     * @private
     * @param {Object} [options] Options object
     */
    _initConfig: function(options) {
      options || (options = { });
      this.setOptions(options);
      this._setWidthHeight(options);
      if (this._element && this.crossOrigin) {
        this._element.crossOrigin = this.crossOrigin;
      }
    },

    /**
     * @private
     * @param {Array} filters to be initialized
     * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
     */
    _initFilters: function(filters, callback) {
      if (filters && filters.length) {
        fabric.util.enlivenObjects(filters, function(enlivenedObjects) {
          callback && callback(enlivenedObjects);
        }, 'fabric.Image.filters');
      }
      else {
        callback && callback();
      }
    },

    /**
     * @private
     * Set the width and the height of the image object, using the element or the
     * options.
     * @param {Object} [options] Object with width/height properties
     */
    _setWidthHeight: function(options) {
      options || (options = { });
      var el = this.getElement();
      this.width = options.width || el.naturalWidth || el.width || 0;
      this.height = options.height || el.naturalHeight || el.height || 0;
    },

    /**
     * Calculate offset for center and scale factor for the image in order to respect
     * the preserveAspectRatio attribute
     * @private
     * @return {Object}
     */
    parsePreserveAspectRatioAttribute: function() {
      var pAR = fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''),
          rWidth = this._element.width, rHeight = this._element.height,
          scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0,
          offset, pWidth = this.width, pHeight = this.height, parsedAttributes = { width: pWidth, height: pHeight };
      if (pAR && (pAR.alignX !== 'none' || pAR.alignY !== 'none')) {
        if (pAR.meetOrSlice === 'meet') {
          scaleX = scaleY = fabric.util.findScaleToFit(this._element, parsedAttributes);
          offset = (pWidth - rWidth * scaleX) / 2;
          if (pAR.alignX === 'Min') {
            offsetLeft = -offset;
          }
          if (pAR.alignX === 'Max') {
            offsetLeft = offset;
          }
          offset = (pHeight - rHeight * scaleY) / 2;
          if (pAR.alignY === 'Min') {
            offsetTop = -offset;
          }
          if (pAR.alignY === 'Max') {
            offsetTop = offset;
          }
        }
        if (pAR.meetOrSlice === 'slice') {
          scaleX = scaleY = fabric.util.findScaleToCover(this._element, parsedAttributes);
          offset = rWidth - pWidth / scaleX;
          if (pAR.alignX === 'Mid') {
            cropX = offset / 2;
          }
          if (pAR.alignX === 'Max') {
            cropX = offset;
          }
          offset = rHeight - pHeight / scaleY;
          if (pAR.alignY === 'Mid') {
            cropY = offset / 2;
          }
          if (pAR.alignY === 'Max') {
            cropY = offset;
          }
          rWidth = pWidth / scaleX;
          rHeight = pHeight / scaleY;
        }
      }
      else {
        scaleX = pWidth / rWidth;
        scaleY = pHeight / rHeight;
      }
      return {
        width: rWidth,
        height: rHeight,
        scaleX: scaleX,
        scaleY: scaleY,
        offsetLeft: offsetLeft,
        offsetTop: offsetTop,
        cropX: cropX,
        cropY: cropY
      };
    }
  });

  /**
   * Default CSS class name for canvas
   * @static
   * @type String
   * @default
   */
  fabric.Image.CSS_CANVAS = 'canvas-img';

  /**
   * Alias for getSrc
   * @static
   */
  fabric.Image.prototype.getSvgSrc = fabric.Image.prototype.getSrc;

  /**
   * Creates an instance of fabric.Image from its object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} callback Callback to invoke when an image instance is created
   */
  fabric.Image.fromObject = function(_object, callback) {
    var object = fabric.util.object.clone(_object);
    fabric.util.loadImage(object.src, function(img, error) {
      if (error) {
        callback && callback(null, error);
        return;
      }
      fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
        object.filters = filters || [];
        fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function(resizeFilters) {
          object.resizeFilter = resizeFilters[0];
          fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
            object.clipPath = enlivedProps[0];
            var image = new fabric.Image(img, object);
            callback(image);
          });
        });
      });
    }, null, object.crossOrigin);
  };

  /**
   * Creates an instance of fabric.Image from an URL string
   * @static
   * @param {String} url URL to create an image from
   * @param {Function} [callback] Callback to invoke when image is created (newly created image is passed as a first argument)
   * @param {Object} [imgOptions] Options object
   */
  fabric.Image.fromURL = function(url, callback, imgOptions) {
    fabric.util.loadImage(url, function(img) {
      callback && callback(new fabric.Image(img, imgOptions));
    }, null, imgOptions && imgOptions.crossOrigin);
  };

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Image.fromElement})
   * @static
   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
   */
  fabric.Image.ATTRIBUTE_NAMES =
    fabric.SHARED_ATTRIBUTES.concat('x y width height preserveAspectRatio xlink:href crossOrigin'.split(' '));

  /**
   * Returns {@link fabric.Image} instance from an SVG element
   * @static
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} callback Callback to execute when fabric.Image object is created
   * @return {fabric.Image} Instance of fabric.Image
   */
  fabric.Image.fromElement = function(element, callback, options) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Image.ATTRIBUTE_NAMES);
    fabric.Image.fromURL(parsedAttributes['xlink:href'], callback,
      extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
  };
  /* _FROM_SVG_END_ */

})(typeof exports !== 'undefined' ? exports : this);


fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

  /**
   * @private
   * @return {Number} angle value
   */
  _getAngleValueForStraighten: function() {
    var angle = this.angle % 360;
    if (angle > 0) {
      return Math.round((angle - 1) / 90) * 90;
    }
    return Math.round(angle / 90) * 90;
  },

  /**
   * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
   * @return {fabric.Object} thisArg
   * @chainable
   */
  straighten: function() {
    this.rotate(this._getAngleValueForStraighten());
    return this;
  },

  /**
   * Same as {@link fabric.Object.prototype.straighten} but with animation
   * @param {Object} callbacks Object with callback functions
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Object} thisArg
   * @chainable
   */
  fxStraighten: function(callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: this.get('angle'),
      endValue: this._getAngleValueForStraighten(),
      duration: this.FX_DURATION,
      onChange: function(value) {
        _this.rotate(value);
        onChange();
      },
      onComplete: function() {
        _this.setCoords();
        onComplete();
      },
    });

    return this;
  }
});

fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

  /**
   * Straightens object, then rerenders canvas
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  straightenObject: function (object) {
    object.straighten();
    this.requestRenderAll();
    return this;
  },

  /**
   * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxStraightenObject: function (object) {
    object.fxStraighten({
      onChange: this.requestRenderAllBound
    });
    return this;
  }
});


(function() {

  'use strict';

  /**
   * Tests if webgl supports certain precision
   * @param {WebGL} Canvas WebGL context to test on
   * @param {String} Precision to test can be any of following: 'lowp', 'mediump', 'highp'
   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
   */
  function testPrecision(gl, precision){
    var fragmentSource = 'precision ' + precision + ' float;\nvoid main(){}';
    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fragmentShader, fragmentSource);
    gl.compileShader(fragmentShader);
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      return false;
    }
    return true;
  }

  /**
   * Indicate whether this filtering backend is supported by the user's browser.
   * @param {Number} tileSize check if the tileSize is supported
   * @returns {Boolean} Whether the user's browser supports WebGL.
   */
  fabric.isWebglSupported = function(tileSize) {
    if (fabric.isLikelyNode) {
      return false;
    }
    tileSize = tileSize || fabric.WebglFilterBackend.prototype.tileSize;
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    var isSupported = false;
    // eslint-disable-next-line
    if (gl) {
      fabric.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
      isSupported = fabric.maxTextureSize >= tileSize;
      var precisions = ['highp', 'mediump', 'lowp'];
      for (var i = 0; i < 3; i++){
        if (testPrecision(gl, precisions[i])){
          fabric.webGlPrecision = precisions[i];
          break;
        };
      }
    }
    this.isSupported = isSupported;
    return isSupported;
  };

  fabric.WebglFilterBackend = WebglFilterBackend;

  /**
   * WebGL filter backend.
   */
  function WebglFilterBackend(options) {
    if (options && options.tileSize) {
      this.tileSize = options.tileSize;
    }
    this.setupGLContext(this.tileSize, this.tileSize);
    this.captureGPUInfo();
  };

  WebglFilterBackend.prototype = /** @lends fabric.WebglFilterBackend.prototype */ {

    tileSize: 2048,

    /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you problably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/
    resources: {

    },

    /**
     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
     */
    setupGLContext: function(width, height) {
      this.dispose();
      this.createWebGLCanvas(width, height);
      // eslint-disable-next-line
      this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
      this.chooseFastestCopyGLTo2DMethod(width, height);
    },

    /**
     * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
     * putImageData is faster than drawImage for that specific operation.
     */
    chooseFastestCopyGLTo2DMethod: function(width, height) {
      var canMeasurePerf = typeof window.performance !== 'undefined', canUseImageData;
      try {
        new ImageData(1, 1);
        canUseImageData = true;
      }
      catch (e) {
        canUseImageData = false;
      }
      // eslint-disable-next-line no-undef
      var canUseArrayBuffer = typeof ArrayBuffer !== 'undefined';
      // eslint-disable-next-line no-undef
      var canUseUint8Clamped = typeof Uint8ClampedArray !== 'undefined';

      if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) {
        return;
      }

      var targetCanvas = fabric.util.createCanvasElement();
      // eslint-disable-next-line no-undef
      var imageBuffer = new ArrayBuffer(width * height * 4);
      if (fabric.forceGLPutImageData) {
        this.imageBuffer = imageBuffer;
        this.copyGLTo2D = copyGLTo2DPutImageData;
        return;
      }
      var testContext = {
        imageBuffer: imageBuffer,
        destinationWidth: width,
        destinationHeight: height,
        targetCanvas: targetCanvas
      };
      var startTime, drawImageTime, putImageDataTime;
      targetCanvas.width = width;
      targetCanvas.height = height;

      startTime = window.performance.now();
      copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
      drawImageTime = window.performance.now() - startTime;

      startTime = window.performance.now();
      copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
      putImageDataTime = window.performance.now() - startTime;

      if (drawImageTime > putImageDataTime) {
        this.imageBuffer = imageBuffer;
        this.copyGLTo2D = copyGLTo2DPutImageData;
      }
      else {
        this.copyGLTo2D = copyGLTo2DDrawImage;
      }
    },

    /**
     * Create a canvas element and associated WebGL context and attaches them as
     * class properties to the GLFilterBackend class.
     */
    createWebGLCanvas: function(width, height) {
      var canvas = fabric.util.createCanvasElement();
      canvas.width = width;
      canvas.height = height;
      var glOptions = {
            alpha: true,
            premultipliedAlpha: false,
            depth: false,
            stencil: false,
            antialias: false
          },
          gl = canvas.getContext('webgl', glOptions);
      if (!gl) {
        gl = canvas.getContext('experimental-webgl', glOptions);
      }
      if (!gl) {
        return;
      }
      gl.clearColor(0, 0, 0, 0);
      // this canvas can fire webglcontextlost and webglcontextrestored
      this.canvas = canvas;
      this.gl = gl;
    },

    /**
     * Attempts to apply the requested filters to the source provided, drawing the filtered output
     * to the provided target canvas.
     *
     * @param {Array} filters The filters to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
     * @param {Number} width The width of the source input.
     * @param {Number} height The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
     * omitted, caching will be skipped.
     */
    applyFilters: function(filters, source, width, height, targetCanvas, cacheKey) {
      var gl = this.gl;
      var cachedTexture;
      if (cacheKey) {
        cachedTexture = this.getCachedTexture(cacheKey, source);
      }
      var pipelineState = {
        originalWidth: source.width || source.originalWidth,
        originalHeight: source.height || source.originalHeight,
        sourceWidth: width,
        sourceHeight: height,
        destinationWidth: width,
        destinationHeight: height,
        context: gl,
        sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
        targetTexture: this.createTexture(gl, width, height),
        originalTexture: cachedTexture ||
          this.createTexture(gl, width, height, !cachedTexture && source),
        passes: filters.length,
        webgl: true,
        aPosition: this.aPosition,
        programCache: this.programCache,
        pass: 0,
        filterBackend: this,
        targetCanvas: targetCanvas
      };
      var tempFbo = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
      filters.forEach(function(filter) { filter && filter.applyTo(pipelineState); });
      resizeCanvasIfNeeded(pipelineState);
      this.copyGLTo2D(gl, pipelineState);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.deleteTexture(pipelineState.sourceTexture);
      gl.deleteTexture(pipelineState.targetTexture);
      gl.deleteFramebuffer(tempFbo);
      targetCanvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
      return pipelineState;
    },

    /**
     * Detach event listeners, remove references, and clean up caches.
     */
    dispose: function() {
      if (this.canvas) {
        this.canvas = null;
        this.gl = null;
      }
      this.clearWebGLCaches();
    },

    /**
     * Wipe out WebGL-related caches.
     */
    clearWebGLCaches: function() {
      this.programCache = {};
      this.textureCache = {};
    },

    /**
     * Create a WebGL texture object.
     *
     * Accepts specific dimensions to initialize the textuer to or a source image.
     *
     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
     * @param {Number} width The width to initialize the texture at.
     * @param {Number} height The height to initialize the texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
     * @returns {WebGLTexture}
     */
    createTexture: function(gl, width, height, textureImageSource) {
      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      if (textureImageSource) {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
      }
      else {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
      }
      return texture;
    },

    /**
     * Can be optionally used to get a texture from the cache array
     *
     * If an existing texture is not found, a new texture is created and cached.
     *
     * @param {String} uniqueId A cache key to use to find an existing texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
     * texture cache entry if one does not already exist.
     */
    getCachedTexture: function(uniqueId, textureImageSource) {
      if (this.textureCache[uniqueId]) {
        return this.textureCache[uniqueId];
      }
      else {
        var texture = this.createTexture(
          this.gl, textureImageSource.width, textureImageSource.height, textureImageSource);
        this.textureCache[uniqueId] = texture;
        return texture;
      }
    },

    /**
     * Clear out cached resources related to a source image that has been
     * filtered previously.
     *
     * @param {String} cacheKey The cache key provided when the source image was filtered.
     */
    evictCachesForKey: function(cacheKey) {
      if (this.textureCache[cacheKey]) {
        this.gl.deleteTexture(this.textureCache[cacheKey]);
        delete this.textureCache[cacheKey];
      }
    },

    copyGLTo2D: copyGLTo2DDrawImage,

    /**
     * Attempt to extract GPU information strings from a WebGL context.
     *
     * Useful information when debugging or blacklisting specific GPUs.
     *
     * @returns {Object} A GPU info object with renderer and vendor strings.
     */
    captureGPUInfo: function() {
      if (this.gpuInfo) {
        return this.gpuInfo;
      }
      var gl = this.gl, gpuInfo = { renderer: '', vendor: '' };
      if (!gl) {
        return gpuInfo;
      }
      var ext = gl.getExtension('WEBGL_debug_renderer_info');
      if (ext) {
        var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
        var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
        if (renderer) {
          gpuInfo.renderer = renderer.toLowerCase();
        }
        if (vendor) {
          gpuInfo.vendor = vendor.toLowerCase();
        }
      }
      this.gpuInfo = gpuInfo;
      return gpuInfo;
    },
  };
})();

function resizeCanvasIfNeeded(pipelineState) {
  var targetCanvas = pipelineState.targetCanvas,
      width = targetCanvas.width, height = targetCanvas.height,
      dWidth = pipelineState.destinationWidth,
      dHeight = pipelineState.destinationHeight;

  if (width !== dWidth || height !== dHeight) {
    targetCanvas.width = dWidth;
    targetCanvas.height = dHeight;
  }
}

/**
 * Copy an input WebGL canvas on to an output 2D canvas.
 *
 * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
 * desired output image appearing in the bottom-left corner of the WebGL canvas.
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */
function copyGLTo2DDrawImage(gl, pipelineState) {
  var glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas,
      ctx = targetCanvas.getContext('2d');
  ctx.translate(0, targetCanvas.height); // move it down again
  ctx.scale(1, -1); // vertical flip
  // where is my image on the big glcanvas?
  var sourceY = glCanvas.height - targetCanvas.height;
  ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0,
    targetCanvas.width, targetCanvas.height);
}

/**
 * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
 * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */
function copyGLTo2DPutImageData(gl, pipelineState) {
  var targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d'),
      dWidth = pipelineState.destinationWidth,
      dHeight = pipelineState.destinationHeight,
      numBytes = dWidth * dHeight * 4;

  // eslint-disable-next-line no-undef
  var u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
  // eslint-disable-next-line no-undef
  var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);

  gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
  var imgData = new ImageData(u8Clamped, dWidth, dHeight);
  ctx.putImageData(imgData, 0, 0);
}


(function() {

  'use strict';

  var noop = function() {};

  fabric.Canvas2dFilterBackend = Canvas2dFilterBackend;

  /**
   * Canvas 2D filter backend.
   */
  function Canvas2dFilterBackend() {};

  Canvas2dFilterBackend.prototype = /** @lends fabric.Canvas2dFilterBackend.prototype */ {
    evictCachesForKey: noop,
    dispose: noop,
    clearWebGLCaches: noop,

    /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/
    resources: {

    },

    /**
     * Apply a set of filters against a source image and draw the filtered output
     * to the provided destination canvas.
     *
     * @param {EnhancedFilter} filters The filter to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
     * @param {Number} sourceWidth The width of the source input.
     * @param {Number} sourceHeight The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     */
    applyFilters: function(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
      var ctx = targetCanvas.getContext('2d');
      ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
      var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      var pipelineState = {
        sourceWidth: sourceWidth,
        sourceHeight: sourceHeight,
        imageData: imageData,
        originalEl: sourceElement,
        originalImageData: originalImageData,
        canvasEl: targetCanvas,
        ctx: ctx,
        filterBackend: this,
      };
      filters.forEach(function(filter) { filter.applyTo(pipelineState); });
      if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
        targetCanvas.width = pipelineState.imageData.width;
        targetCanvas.height = pipelineState.imageData.height;
      }
      ctx.putImageData(pipelineState.imageData, 0, 0);
      return pipelineState;
    },

  };
})();


/**
 * @namespace fabric.Image.filters
 * @memberOf fabric.Image
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#image_filters}
 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
 */
fabric.Image = fabric.Image || { };
fabric.Image.filters = fabric.Image.filters || { };

/**
 * Root filter class from which all filter classes inherit from
 * @class fabric.Image.filters.BaseFilter
 * @memberOf fabric.Image.filters
 */
fabric.Image.filters.BaseFilter = fabric.util.createClass(/** @lends fabric.Image.filters.BaseFilter.prototype */ {

  /**
   * Filter type
   * @param {String} type
   * @default
   */
  type: 'BaseFilter',

  /**
   * Array of attributes to send with buffers. do not modify
   * @private
   */

  vertexSource: 'attribute vec2 aPosition;\n' +
    'varying vec2 vTexCoord;\n' +
    'void main() {\n' +
      'vTexCoord = aPosition;\n' +
      'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
    '}',

  fragmentSource: 'precision highp float;\n' +
    'varying vec2 vTexCoord;\n' +
    'uniform sampler2D uTexture;\n' +
    'void main() {\n' +
      'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
    '}',

  /**
   * Constructor
   * @param {Object} [options] Options object
   */
  initialize: function(options) {
    if (options) {
      this.setOptions(options);
    }
  },

  /**
   * Sets filter's properties from options
   * @param {Object} [options] Options object
   */
  setOptions: function(options) {
    for (var prop in options) {
      this[prop] = options[prop];
    }
  },

  /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */
  createProgram: function(gl, fragmentSource, vertexSource) {
    fragmentSource = fragmentSource || this.fragmentSource;
    vertexSource = vertexSource || this.vertexSource;
    if (fabric.webGlPrecision !== 'highp'){
      fragmentSource = fragmentSource.replace(
        /precision highp float/g,
        'precision ' + fabric.webGlPrecision + ' float'
      );
    }
    var vertexShader = gl.createShader(gl.VERTEX_SHADER);
    gl.shaderSource(vertexShader, vertexSource);
    gl.compileShader(vertexShader);
    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
      throw new Error(
        // eslint-disable-next-line prefer-template
        'Vertex shader compile error for ' + this.type + ': ' +
        gl.getShaderInfoLog(vertexShader)
      );
    }

    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fragmentShader, fragmentSource);
    gl.compileShader(fragmentShader);
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      throw new Error(
        // eslint-disable-next-line prefer-template
        'Fragment shader compile error for ' + this.type + ': ' +
        gl.getShaderInfoLog(fragmentShader)
      );
    }

    var program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      throw new Error(
        // eslint-disable-next-line prefer-template
        'Shader link error for "${this.type}" ' +
        gl.getProgramInfoLog(program)
      );
    }

    var attributeLocations = this.getAttributeLocations(gl, program);
    var uniformLocations = this.getUniformLocations(gl, program) || { };
    uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
    uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
    return {
      program: program,
      attributeLocations: attributeLocations,
      uniformLocations: uniformLocations
    };
  },

  /**
   * Return a map of attribute names to WebGLAttributeLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
   * @returns {Object} A map of attribute names to attribute locations.
   */
  getAttributeLocations: function(gl, program) {
    return {
      aPosition: gl.getAttribLocation(program, 'aPosition'),
    };
  },

  /**
   * Return a map of uniform names to WebGLUniformLocation objects.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
   * @returns {Object} A map of uniform names to uniform locations.
   */
  getUniformLocations: function (/* gl, program */) {
    // in case i do not need any special uniform i need to return an empty object
    return { };
  },

  /**
   * Send attribute data from this filter to its shader program on the GPU.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} attributeLocations A map of shader attribute names to their locations.
   */
  sendAttributeData: function(gl, attributeLocations, aPositionData) {
    var attributeLocation = attributeLocations.aPosition;
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.enableVertexAttribArray(attributeLocation);
    gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
    gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
  },

  _setupFrameBuffer: function(options) {
    var gl = options.context, width, height;
    if (options.passes > 1) {
      width = options.destinationWidth;
      height = options.destinationHeight;
      if (options.sourceWidth !== width || options.sourceHeight !== height) {
        gl.deleteTexture(options.targetTexture);
        options.targetTexture = options.filterBackend.createTexture(gl, width, height);
      }
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D,
        options.targetTexture, 0);
    }
    else {
      // draw last filter on canvas and not to framebuffer.
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.finish();
    }
  },

  _swapTextures: function(options) {
    options.passes--;
    options.pass++;
    var temp = options.targetTexture;
    options.targetTexture = options.sourceTexture;
    options.sourceTexture = temp;
  },

  /**
   * Generic isNeutral implementation for one parameter based filters.
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * Other filters may need their own verison ( ColorMatrix, HueRotation, gamma, ComposedFilter )
   * @param {Object} options
   **/
  isNeutralState: function(/* options */) {
    var main = this.mainParameter,
        _class = fabric.Image.filters[this.type].prototype;
    if (main) {
      if (Array.isArray(_class[main])) {
        for (var i = _class[main].length; i--;) {
          if (this[main][i] !== _class[main][i]) {
            return false;
          }
        }
        return true;
      }
      else {
        return _class[main] === this[main];
      }
    }
    else {
      return false;
    }
  },

  /**
   * Apply this filter to the input image data provided.
   *
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyTo: function(options) {
    if (options.webgl) {
      this._setupFrameBuffer(options);
      this.applyToWebGL(options);
      this._swapTextures(options);
    }
    else {
      this.applyTo2d(options);
    }
  },

  /**
   * Retrieves the cached shader.
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  retrieveShader: function(options) {
    if (!options.programCache.hasOwnProperty(this.type)) {
      options.programCache[this.type] = this.createProgram(options.context);
    }
    return options.programCache[this.type];
  },

  /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyToWebGL: function(options) {
    var gl = options.context;
    var shader = this.retrieveShader(options);
    if (options.pass === 0 && options.originalTexture) {
      gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
    }
    else {
      gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
    }
    gl.useProgram(shader.program);
    this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);

    gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
    gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);

    this.sendUniformData(gl, shader.uniformLocations);
    gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  },

  bindAdditionalTexture: function(gl, texture, textureUnit) {
    gl.activeTexture(textureUnit);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // reset active texture to 0 as usual
    gl.activeTexture(gl.TEXTURE0);
  },

  unbindAdditionalTexture: function(gl, textureUnit) {
    gl.activeTexture(textureUnit);
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.activeTexture(gl.TEXTURE0);
  },

  getMainParameter: function() {
    return this[this.mainParameter];
  },

  setMainParameter: function(value) {
    this[this.mainParameter] = value;
  },

  /**
   * Send uniform data from this filter to its shader program on the GPU.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} uniformLocations A map of shader uniform names to their locations.
   */
  sendUniformData: function(/* gl, uniformLocations */) {
    // Intentionally left blank.  Override me in subclasses.
  },

  /**
   * If needed by a 2d filter, this functions can create an helper canvas to be used
   * remember that options.targetCanvas is available for use till end of chain.
   */
  createHelpLayer: function(options) {
    if (!options.helpLayer) {
      var helpLayer = document.createElement('canvas');
      helpLayer.width = options.sourceWidth;
      helpLayer.height = options.sourceHeight;
      options.helpLayer = helpLayer;
    }
  },

  /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */
  toObject: function() {
    var object = { type: this.type }, mainP = this.mainParameter;
    if (mainP) {
      object[mainP] = this[mainP];
    }
    return object;
  },

  /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */
  toJSON: function() {
    // delegate, not alias
    return this.toObject();
  }
});

fabric.Image.filters.BaseFilter.fromObject = function(object, callback) {
  var filter = new fabric.Image.filters[object.type](object);
  callback && callback(filter);
  return filter;
};


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Color Matrix filter class
   * @class fabric.Image.filters.ColorMatrix
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.ColorMatrix#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @see {@Link http://www.webwasp.co.uk/tutorials/219/Color_Matrix_Filter.php}
   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl}
   * @example <caption>Kodachrome filter</caption>
   * var filter = new fabric.Image.filters.ColorMatrix({
   *  matrix: [
       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
       0, 0, 0, 1, 0
      ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.ColorMatrix = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.ColorMatrix.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'ColorMatrix',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'varying vec2 vTexCoord;\n' +
      'uniform mat4 uColorMatrix;\n' +
      'uniform vec4 uConstants;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'color *= uColorMatrix;\n' +
        'color += uConstants;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Colormatrix for pixels.
     * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
     * outside the -1, 1 range.
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Array} matrix array of 20 numbers.
     * @default
     */
    matrix: [
      1, 0, 0, 0, 0,
      0, 1, 0, 0, 0,
      0, 0, 1, 0, 0,
      0, 0, 0, 1, 0
    ],

    mainParameter: 'matrix',

    /**
     * Lock the colormatrix on the color part, skipping alpha, manly for non webgl scenario
     * to save some calculation
     */
    colorsOnly: true,

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      // create a new array instead mutating the prototype with push
      this.matrix = this.matrix.slice(0);
    },

    /**
     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data,
          iLen = data.length,
          m = this.matrix,
          r, g, b, a, i, colorsOnly = this.colorsOnly;

      for (i = 0; i < iLen; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];
        if (colorsOnly) {
          data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
        }
        else {
          a = data[i + 3];
          data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
          data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uColorMatrix: gl.getUniformLocation(program, 'uColorMatrix'),
        uConstants: gl.getUniformLocation(program, 'uConstants'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var m = this.matrix,
          matrix = [
            m[0], m[1], m[2], m[3],
            m[5], m[6], m[7], m[8],
            m[10], m[11], m[12], m[13],
            m[15], m[16], m[17], m[18]
          ],
          constants = [m[4], m[9], m[14], m[19]];
      gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
      gl.uniform4fv(uniformLocations.uConstants, constants);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] function to invoke after filter creation
   * @return {fabric.Image.filters.ColorMatrix} Instance of fabric.Image.filters.ColorMatrix
   */
  fabric.Image.filters.ColorMatrix.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Brightness filter class
   * @class fabric.Image.filters.Brightness
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Brightness#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Brightness({
   *   brightness: 0.05
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Brightness = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Brightness.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Brightness',

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uBrightness;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'color.rgb += uBrightness;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Brightness value, from -1 to 1.
     * translated to -255 to 255 for 2d
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Number} brightness
     * @default
     */
    brightness: 0,

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'brightness',

    /**
    * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
    *
    * @param {Object} options
    * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
    */
    applyTo2d: function(options) {
      if (this.brightness === 0) {
        return;
      }
      var imageData = options.imageData,
          data = imageData.data, i, len = data.length,
          brightness = Math.round(this.brightness * 255);
      for (i = 0; i < len; i += 4) {
        data[i] = data[i] + brightness;
        data[i + 1] = data[i + 1] + brightness;
        data[i + 2] = data[i + 2] + brightness;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uBrightness: gl.getUniformLocation(program, 'uBrightness'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBrightness, this.brightness);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Brightness} Instance of fabric.Image.filters.Brightness
   */
  fabric.Image.filters.Brightness.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
   * @class fabric.Image.filters.Convolute
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Convolute#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example <caption>Sharpen filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 0, -1,  0,
   *            -1,  5, -1,
   *             0, -1,  0 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Blur filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter with opaqueness</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   opaque: true,
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.Convolute = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Convolute.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Convolute',

    /*
     * Opaque value (true/false)
     */
    opaque: false,

    /*
     * matrix for the filter, max 9x9
     */
    matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: {
      Convolute_3_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[9];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_3_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[9];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
      Convolute_5_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[25];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_5_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[25];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
      Convolute_7_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[49];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_7_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[49];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
      Convolute_9_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[81];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_9_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[81];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
    },

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Convolute.prototype
     * @param {Object} [options] Options object
     * @param {Boolean} [options.opaque=false] Opaque value (true/false)
     * @param {Array} [options.matrix] Filter matrix
     */


    /**
    * Retrieves the cached shader.
    * @param {Object} options
    * @param {WebGLRenderingContext} options.context The GL context used for rendering.
    * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
    */
    retrieveShader: function(options) {
      var size = Math.sqrt(this.matrix.length);
      var cacheKey = this.type + '_' + size + '_' + (this.opaque ? 1 : 0);
      var shaderSource = this.fragmentSource[cacheKey];
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data,
          weights = this.matrix,
          side = Math.round(Math.sqrt(weights.length)),
          halfSide = Math.floor(side / 2),
          sw = imageData.width,
          sh = imageData.height,
          output = options.ctx.createImageData(sw, sh),
          dst = output.data,
          // go through the destination image pixels
          alphaFac = this.opaque ? 1 : 0,
          r, g, b, a, dstOff,
          scx, scy, srcOff, wt,
          x, y, cx, cy;

      for (y = 0; y < sh; y++) {
        for (x = 0; x < sw; x++) {
          dstOff = (y * sw + x) * 4;
          // calculate the weighed sum of the source image pixels that
          // fall under the convolution matrix
          r = 0; g = 0; b = 0; a = 0;

          for (cy = 0; cy < side; cy++) {
            for (cx = 0; cx < side; cx++) {
              scy = y + cy - halfSide;
              scx = x + cx - halfSide;

              // eslint-disable-next-line max-depth
              if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) {
                continue;
              }

              srcOff = (scy * sw + scx) * 4;
              wt = weights[cy * side + cx];

              r += data[srcOff] * wt;
              g += data[srcOff + 1] * wt;
              b += data[srcOff + 2] * wt;
              // eslint-disable-next-line max-depth
              if (!alphaFac) {
                a += data[srcOff + 3] * wt;
              }
            }
          }
          dst[dstOff] = r;
          dst[dstOff + 1] = g;
          dst[dstOff + 2] = b;
          if (!alphaFac) {
            dst[dstOff + 3] = a;
          }
          else {
            dst[dstOff + 3] = data[dstOff + 3];
          }
        }
      }
      options.imageData = output;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uMatrix: gl.getUniformLocation(program, 'uMatrix'),
        uOpaque: gl.getUniformLocation(program, 'uOpaque'),
        uHalfSize: gl.getUniformLocation(program, 'uHalfSize'),
        uSize: gl.getUniformLocation(program, 'uSize'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return extend(this.callSuper('toObject'), {
        opaque: this.opaque,
        matrix: this.matrix
      });
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Convolute} Instance of fabric.Image.filters.Convolute
   */
  fabric.Image.filters.Convolute.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Grayscale image filter class
   * @class fabric.Image.filters.Grayscale
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Grayscale();
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Grayscale = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Grayscale.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Grayscale',

    fragmentSource: {
      average: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'float average = (color.r + color.b + color.g) / 3.0;\n' +
          'gl_FragColor = vec4(average, average, average, color.a);\n' +
        '}',
      lightness: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform int uMode;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
          'float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n' +
          'gl_FragColor = vec4(average, average, average, col.a);\n' +
        '}',
      luminosity: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform int uMode;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
          'float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n' +
          'gl_FragColor = vec4(average, average, average, col.a);\n' +
        '}',
    },


    /**
     * Grayscale mode, between 'average', 'lightness', 'luminosity'
     * @param {String} type
     * @default
     */
    mode: 'average',

    mainParameter: 'mode',

    /**
     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, i,
          len = data.length, value,
          mode = this.mode;
      for (i = 0; i < len; i += 4) {
        if (mode === 'average') {
          value = (data[i] + data[i + 1] + data[i + 2]) / 3;
        }
        else if (mode === 'lightness') {
          value = (Math.min(data[i], data[i + 1], data[i + 2]) +
            Math.max(data[i], data[i + 1], data[i + 2])) / 2;
        }
        else if (mode === 'luminosity') {
          value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
        }
        data[i] = value;
        data[i + 1] = value;
        data[i + 2] = value;
      }
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var cacheKey = this.type + '_' + this.mode;
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        var shaderSource = this.fragmentSource[this.mode];
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uMode: gl.getUniformLocation(program, 'uMode'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      // default average mode.
      var mode = 1;
      gl.uniform1i(uniformLocations.uMode, mode);
    },

    /**
     * Grayscale filter isNeutralState implementation
     * The filter is never neutral
     * on the image
     **/
    isNeutralState: function() {
      return false;
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Grayscale} Instance of fabric.Image.filters.Grayscale
   */
  fabric.Image.filters.Grayscale.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Invert filter class
   * @class fabric.Image.filters.Invert
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Invert();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */
  filters.Invert = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Invert.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Invert',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform int uInvert;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'if (uInvert == 1) {\n' +
          'gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n' +
        '} else {\n' +
          'gl_FragColor = color;\n' +
        '}\n' +
      '}',

    /**
     * Filter invert. if false, does nothing
     * @param {Boolean} invert
     * @default
     */
    invert: true,

    mainParameter: 'invert',

    /**
     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, i,
          len = data.length;
      for (i = 0; i < len; i += 4) {
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
      }
    },

    /**
     * Invert filter isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/
    isNeutralState: function() {
      return !this.invert;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uInvert: gl.getUniformLocation(program, 'uInvert'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1i(uniformLocations.uInvert, this.invert);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Invert} Instance of fabric.Image.filters.Invert
   */
  fabric.Image.filters.Invert.fromObject = fabric.Image.filters.BaseFilter.fromObject;


})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Noise filter class
   * @class fabric.Image.filters.Noise
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Noise#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Noise({
   *   noise: 700
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.Noise = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Noise.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Noise',

    /**
     * Fragment source for the noise program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uStepH;\n' +
      'uniform float uNoise;\n' +
      'uniform float uSeed;\n' +
      'varying vec2 vTexCoord;\n' +
      'float rand(vec2 co, float seed, float vScale) {\n' +
        'return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n' +
      '}\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'noise',

    /**
     * Noise value, from
     * @param {Number} noise
     * @default
     */
    noise: 0,

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      if (this.noise === 0) {
        return;
      }
      var imageData = options.imageData,
          data = imageData.data, i, len = data.length,
          noise = this.noise, rand;

      for (i = 0, len = data.length; i < len; i += 4) {

        rand = (0.5 - Math.random()) * noise;

        data[i] += rand;
        data[i + 1] += rand;
        data[i + 2] += rand;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uNoise: gl.getUniformLocation(program, 'uNoise'),
        uSeed: gl.getUniformLocation(program, 'uSeed'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
      gl.uniform1f(uniformLocations.uSeed, Math.random());
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return extend(this.callSuper('toObject'), {
        noise: this.noise
      });
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Noise} Instance of fabric.Image.filters.Noise
   */
  fabric.Image.filters.Noise.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Pixelate filter class
   * @class fabric.Image.filters.Pixelate
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Pixelate#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Pixelate({
   *   blocksize: 8
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Pixelate = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Pixelate.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Pixelate',

    blocksize: 4,

    mainParameter: 'blocksize',

    /**
     * Fragment source for the Pixelate program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uBlocksize;\n' +
      'uniform float uStepW;\n' +
      'uniform float uStepH;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'float blockW = uBlocksize * uStepW;\n' +
        'float blockH = uBlocksize * uStepW;\n' +
        'int posX = int(vTexCoord.x / blockW);\n' +
        'int posY = int(vTexCoord.y / blockH);\n' +
        'float fposX = float(posX);\n' +
        'float fposY = float(posY);\n' +
        'vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n' +
        'vec4 color = texture2D(uTexture, squareCoords);\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data,
          iLen = imageData.height,
          jLen = imageData.width,
          index, i, j, r, g, b, a,
          _i, _j, _iLen, _jLen;

      for (i = 0; i < iLen; i += this.blocksize) {
        for (j = 0; j < jLen; j += this.blocksize) {

          index = (i * 4) * jLen + (j * 4);

          r = data[index];
          g = data[index + 1];
          b = data[index + 2];
          a = data[index + 3];

          _iLen = Math.min(i + this.blocksize, iLen);
          _jLen = Math.min(j + this.blocksize, jLen);
          for (_i = i; _i < _iLen; _i++) {
            for (_j = j; _j < _jLen; _j++) {
              index = (_i * 4) * jLen + (_j * 4);
              data[index] = r;
              data[index + 1] = g;
              data[index + 2] = b;
              data[index + 3] = a;
            }
          }
        }
      }
    },

    /**
     * Indicate when the filter is not gonna apply changes to the image
     **/
    isNeutralState: function() {
      return this.blocksize === 1;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uBlocksize: gl.getUniformLocation(program, 'uBlocksize'),
        uStepW: gl.getUniformLocation(program, 'uStepW'),
        uStepH: gl.getUniformLocation(program, 'uStepH'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Pixelate} Instance of fabric.Image.filters.Pixelate
   */
  fabric.Image.filters.Pixelate.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Remove white filter class
   * @class fabric.Image.filters.RemoveColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.RemoveColor#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.RemoveColor({
   *   threshold: 0.2,
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.RemoveColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.RemoveColor.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'RemoveColor',

    /**
     * Color to remove, in any format understood by fabric.Color.
     * @param {String} type
     * @default
     */
    color: '#FFFFFF',

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec4 uLow;\n' +
      'uniform vec4 uHigh;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
        'if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n' +
          'gl_FragColor.a = 0.0;\n' +
        '}\n' +
      '}',

    /**
     * distance to actual color, as value up or down from each r,g,b
     * between 0 and 1
     **/
    distance: 0.02,

    /**
     * For color to remove inside distance, use alpha channel for a smoother deletion
     * NOT IMPLEMENTED YET
     **/
    useAlpha: false,

    /**
     * Constructor
     * @memberOf fabric.Image.filters.RemoveWhite.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.color=#RRGGBB] Threshold value
     * @param {Number} [options.distance=10] Distance value
     */

    /**
     * Applies filter to canvas element
     * @param {Object} canvasEl Canvas element to apply filter to
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, i,
          distance = this.distance * 255,
          r, g, b,
          source = new fabric.Color(this.color).getSource(),
          lowC = [
            source[0] - distance,
            source[1] - distance,
            source[2] - distance,
          ],
          highC = [
            source[0] + distance,
            source[1] + distance,
            source[2] + distance,
          ];


      for (i = 0; i < data.length; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];

        if (r > lowC[0] &&
            g > lowC[1] &&
            b > lowC[2] &&
            r < highC[0] &&
            g < highC[1] &&
            b < highC[2]) {
          data[i + 3] = 0;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uLow: gl.getUniformLocation(program, 'uLow'),
        uHigh: gl.getUniformLocation(program, 'uHigh'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var source = new fabric.Color(this.color).getSource(),
          distance = parseFloat(this.distance),
          lowC = [
            0 + source[0] / 255 - distance,
            0 + source[1] / 255 - distance,
            0 + source[2] / 255 - distance,
            1
          ],
          highC = [
            source[0] / 255 + distance,
            source[1] / 255 + distance,
            source[2] / 255 + distance,
            1
          ];
      gl.uniform4fv(uniformLocations.uLow, lowC);
      gl.uniform4fv(uniformLocations.uHigh, highC);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return extend(this.callSuper('toObject'), {
        color: this.color,
        distance: this.distance
      });
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.RemoveColor} Instance of fabric.Image.filters.RemoveWhite
   */
  fabric.Image.filters.RemoveColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  var matrices = {
    Brownie: [
      0.59970,0.34553,-0.27082,0,0.186,
      -0.03770,0.86095,0.15059,0,-0.1449,
      0.24113,-0.07441,0.44972,0,-0.02965,
      0,0,0,1,0
    ],
    Vintage: [
      0.62793,0.32021,-0.03965,0,0.03784,
      0.02578,0.64411,0.03259,0,0.02926,
      0.04660,-0.08512,0.52416,0,0.02023,
      0,0,0,1,0
    ],
    Kodachrome: [
      1.12855,-0.39673,-0.03992,0,0.24991,
      -0.16404,1.08352,-0.05498,0,0.09698,
      -0.16786,-0.56034,1.60148,0,0.13972,
      0,0,0,1,0
    ],
    Technicolor: [
      1.91252,-0.85453,-0.09155,0,0.04624,
      -0.30878,1.76589,-0.10601,0,-0.27589,
      -0.23110,-0.75018,1.84759,0,0.12137,
      0,0,0,1,0
    ],
    Polaroid: [
      1.438,-0.062,-0.062,0,0,
      -0.122,1.378,-0.122,0,0,
      -0.016,-0.016,1.483,0,0,
      0,0,0,1,0
    ],
    Sepia: [
      0.393, 0.769, 0.189, 0, 0,
      0.349, 0.686, 0.168, 0, 0,
      0.272, 0.534, 0.131, 0, 0,
      0, 0, 0, 1, 0
    ],
    BlackWhite: [
      1.5, 1.5, 1.5, 0, -1,
      1.5, 1.5, 1.5, 0, -1,
      1.5, 1.5, 1.5, 0, -1,
      0, 0, 0, 1, 0,
    ]
  };

  for (var key in matrices) {
    filters[key] = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.Sepia.prototype */ {

      /**
       * Filter type
       * @param {String} type
       * @default
       */
      type: key,

      /**
       * Colormatrix for the effect
       * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
       * outside the -1, 1 range.
       * @param {Array} matrix array of 20 numbers.
       * @default
       */
      matrix: matrices[key],

      /**
       * Lock the matrix export for this kind of static, parameter less filters.
       */
      mainParameter: false,
      /**
       * Lock the colormatrix on the color part, skipping alpha
       */
      colorsOnly: true,

    });
    fabric.Image.filters[key].fromObject = fabric.Image.filters.BaseFilter.fromObject;
  }
})(typeof exports !== 'undefined' ? exports : this);


(function(global) {
  'use strict';

  var fabric = global.fabric,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Color Blend filter class
   * @class fabric.Image.filter.BlendColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.BlendColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blend.prototype */ {
    type: 'BlendColor',

    /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/
    color: '#F95C63',

    /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     **/
    mode: 'multiply',

    /**
     * alpha value. represent the strength of the blend color operation.
     **/
    alpha: 1,

    /**
     * Fragment source for the Multiply program
     */
    fragmentSource: {
      multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
      screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
      add: 'gl_FragColor.rgb += uColor.rgb;\n',
      diff: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
      subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
      lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
      darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
      exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
      overlay: 'if (uColor.r < 0.5) {\n' +
          'gl_FragColor.r *= 2.0 * uColor.r;\n' +
        '} else {\n' +
          'gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n' +
        '}\n' +
        'if (uColor.g < 0.5) {\n' +
          'gl_FragColor.g *= 2.0 * uColor.g;\n' +
        '} else {\n' +
          'gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n' +
        '}\n' +
        'if (uColor.b < 0.5) {\n' +
          'gl_FragColor.b *= 2.0 * uColor.b;\n' +
        '} else {\n' +
          'gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n' +
        '}\n',
      tint: 'gl_FragColor.rgb *= (1.0 - uColor.a);\n' +
        'gl_FragColor.rgb += uColor.rgb;\n',
    },

    /**
     * build the fragment source for the filters, joining the common part with
     * the specific one.
     * @param {String} mode the mode of the filter, a key of this.fragmentSource
     * @return {String} the source to be compiled
     * @private
     */
    buildSource: function(mode) {
      return 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform vec4 uColor;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'gl_FragColor = color;\n' +
          'if (color.a > 0.0) {\n' +
            this.fragmentSource[mode] +
          '}\n' +
        '}';
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var cacheKey = this.type + '_' + this.mode, shaderSource;
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        shaderSource = this.buildSource(this.mode);
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, iLen = data.length,
          tr, tg, tb,
          r, g, b,
          source, alpha1 = 1 - this.alpha;

      source = new fabric.Color(this.color).getSource();
      tr = source[0] * this.alpha;
      tg = source[1] * this.alpha;
      tb = source[2] * this.alpha;

      for (var i = 0; i < iLen; i += 4) {

        r = data[i];
        g = data[i + 1];
        b = data[i + 2];

        switch (this.mode) {
          case 'multiply':
            data[i] = r * tr / 255;
            data[i + 1] = g * tg / 255;
            data[i + 2] = b * tb / 255;
            break;
          case 'screen':
            data[i] = 255 - (255 - r) * (255 - tr) / 255;
            data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
            data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
            break;
          case 'add':
            data[i] = r + tr;
            data[i + 1] = g + tg;
            data[i + 2] = b + tb;
            break;
          case 'diff':
          case 'difference':
            data[i] = Math.abs(r - tr);
            data[i + 1] = Math.abs(g - tg);
            data[i + 2] = Math.abs(b - tb);
            break;
          case 'subtract':
            data[i] = r - tr;
            data[i + 1] = g - tg;
            data[i + 2] = b - tb;
            break;
          case 'darken':
            data[i] = Math.min(r, tr);
            data[i + 1] = Math.min(g, tg);
            data[i + 2] = Math.min(b, tb);
            break;
          case 'lighten':
            data[i] = Math.max(r, tr);
            data[i + 1] = Math.max(g, tg);
            data[i + 2] = Math.max(b, tb);
            break;
          case 'overlay':
            data[i] = tr < 128 ? (2 * r * tr / 255) : (255 - 2 * (255 - r) * (255 - tr) / 255);
            data[i + 1] = tg < 128 ? (2 * g * tg / 255) : (255 - 2 * (255 - g) * (255 - tg) / 255);
            data[i + 2] = tb < 128 ? (2 * b * tb / 255) : (255 - 2 * (255 - b) * (255 - tb) / 255);
            break;
          case 'exclusion':
            data[i] = tr + r - ((2 * tr * r) / 255);
            data[i + 1] = tg + g - ((2 * tg * g) / 255);
            data[i + 2] = tb + b - ((2 * tb * b) / 255);
            break;
          case 'tint':
            data[i] = tr + r * alpha1;
            data[i + 1] = tg + g * alpha1;
            data[i + 2] = tb + b * alpha1;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uColor: gl.getUniformLocation(program, 'uColor'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var source = new fabric.Color(this.color).getSource();
      source[0] = this.alpha * source[0] / 255;
      source[1] = this.alpha * source[1] / 255;
      source[2] = this.alpha * source[2] / 255;
      source[3] = this.alpha;
      gl.uniform4fv(uniformLocations.uColor, source);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return {
        type: this.type,
        color: this.color,
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.BlendColor} Instance of fabric.Image.filters.BlendColor
   */
  fabric.Image.filters.BlendColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {
  'use strict';

  var fabric = global.fabric,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Image Blend filter class
   * @class fabric.Image.filter.BlendImage
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.BlendImage = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.BlendImage.prototype */ {
    type: 'BlendImage',

    /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/
    image: null,

    /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     **/
    mode: 'multiply',

    /**
     * alpha value. represent the strength of the blend image operation.
     * not implemented.
     **/
    alpha: 1,

    vertexSource: 'attribute vec2 aPosition;\n' +
      'varying vec2 vTexCoord;\n' +
      'varying vec2 vTexCoord2;\n' +
      'uniform mat3 uTransformMatrix;\n' +
      'void main() {\n' +
        'vTexCoord = aPosition;\n' +
        'vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n' +
        'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
      '}',

    /**
     * Fragment source for the Multiply program
     */
    fragmentSource: {
      multiply: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform sampler2D uImage;\n' +
        'uniform vec4 uColor;\n' +
        'varying vec2 vTexCoord;\n' +
        'varying vec2 vTexCoord2;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
          'color.rgba *= color2.rgba;\n' +
          'gl_FragColor = color;\n' +
        '}',
      mask: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform sampler2D uImage;\n' +
        'uniform vec4 uColor;\n' +
        'varying vec2 vTexCoord;\n' +
        'varying vec2 vTexCoord2;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
          'color.a = color2.a;\n' +
          'gl_FragColor = color;\n' +
        '}',
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var cacheKey = this.type + '_' + this.mode;
      var shaderSource = this.fragmentSource[this.mode];
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    applyToWebGL: function(options) {
      // load texture to blend.
      var gl = options.context,
          texture = this.createTexture(options.filterBackend, this.image);
      this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
      this.callSuper('applyToWebGL', options);
      this.unbindAdditionalTexture(gl, gl.TEXTURE1);
    },

    createTexture: function(backend, image) {
      return backend.getCachedTexture(image.cacheKey, image._element);
    },

    /**
     * Calculate a transformMatrix to adapt the image to blend over
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    calculateMatrix: function() {
      var image = this.image,
          width = image._element.width,
          height = image._element.height;
      return [
        1 / image.scaleX, 0, 0,
        0, 1 / image.scaleY, 0,
        -image.left / width, -image.top / height, 1
      ];
    },

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          resources = options.filterBackend.resources,
          data = imageData.data, iLen = data.length,
          width = imageData.width,
          height = imageData.height,
          tr, tg, tb, ta,
          r, g, b, a,
          canvas1, context, image = this.image, blendData;

      if (!resources.blendImage) {
        resources.blendImage = fabric.util.createCanvasElement();
      }
      canvas1 = resources.blendImage;
      context = canvas1.getContext('2d');
      if (canvas1.width !== width || canvas1.height !== height) {
        canvas1.width = width;
        canvas1.height = height;
      }
      else {
        context.clearRect(0, 0, width, height);
      }
      context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
      context.drawImage(image._element, 0, 0, width, height);
      blendData = context.getImageData(0, 0, width, height).data;
      for (var i = 0; i < iLen; i += 4) {

        r = data[i];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];

        tr = blendData[i];
        tg = blendData[i + 1];
        tb = blendData[i + 2];
        ta = blendData[i + 3];

        switch (this.mode) {
          case 'multiply':
            data[i] = r * tr / 255;
            data[i + 1] = g * tg / 255;
            data[i + 2] = b * tb / 255;
            data[i + 3] = a * ta / 255;
            break;
          case 'mask':
            data[i + 3] = ta;
            break;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uTransformMatrix: gl.getUniformLocation(program, 'uTransformMatrix'),
        uImage: gl.getUniformLocation(program, 'uImage'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var matrix = this.calculateMatrix();
      gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
      gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return {
        type: this.type,
        image: this.image && this.image.toObject(),
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} callback to be invoked after filter creation
   * @return {fabric.Image.filters.BlendImage} Instance of fabric.Image.filters.BlendImage
   */
  fabric.Image.filters.BlendImage.fromObject = function(object, callback) {
    fabric.Image.fromObject(object.image, function(image) {
      var options = fabric.util.object.clone(object);
      options.image = image;
      callback(new fabric.Image.filters.BlendImage(options));
    });
  };

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }), pow = Math.pow, floor = Math.floor,
      sqrt = Math.sqrt, abs = Math.abs, round = Math.round, sin = Math.sin,
      ceil = Math.ceil,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Resize image filter class
   * @class fabric.Image.filters.Resize
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Resize();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */
  filters.Resize = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Resize.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Resize',

    /**
     * Resize type
     * for webgl resizeType is just lanczos, for canvas2d can be:
     * bilinear, hermite, sliceHack, lanczos.
     * @param {String} resizeType
     * @default
     */
    resizeType: 'hermite',

    /**
     * Scale factor for resizing, x axis
     * @param {Number} scaleX
     * @default
     */
    scaleX: 1,

    /**
     * Scale factor for resizing, y axis
     * @param {Number} scaleY
     * @default
     */
    scaleY: 1,

    /**
     * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
     * @param {Number} lanczosLobes
     * @default
     */
    lanczosLobes: 3,


    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uDelta: gl.getUniformLocation(program, 'uDelta'),
        uTaps: gl.getUniformLocation(program, 'uTaps'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
      gl.uniform1fv(uniformLocations.uTaps, this.taps);
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var filterWindow = this.getFilterWindow(), cacheKey = this.type + '_' + filterWindow;
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        var fragmentShader = this.generateShader(filterWindow);
        options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
      }
      return options.programCache[cacheKey];
    },

    getFilterWindow: function() {
      var scale = this.tempScale;
      return Math.ceil(this.lanczosLobes / scale);
    },

    getTaps: function() {
      var lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale,
          filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
      for (var i = 1; i <= filterWindow; i++) {
        taps[i - 1] = lobeFunction(i * scale);
      }
      return taps;
    },

    /**
     * Generate vertex and shader sources from the necessary steps numbers
     * @param {Number} filterWindow
     */
    generateShader: function(filterWindow) {
      var offsets = new Array(filterWindow),
          fragmentShader = this.fragmentSourceTOP, filterWindow;

      for (var i = 1; i <= filterWindow; i++) {
        offsets[i - 1] = i + '.0 * uDelta';
      }

      fragmentShader += 'uniform float uTaps[' + filterWindow + '];\n';
      fragmentShader += 'void main() {\n';
      fragmentShader += '  vec4 color = texture2D(uTexture, vTexCoord);\n';
      fragmentShader += '  float sum = 1.0;\n';

      offsets.forEach(function(offset, i) {
        fragmentShader += '  color += texture2D(uTexture, vTexCoord + ' + offset + ') * uTaps[' + i + '];\n';
        fragmentShader += '  color += texture2D(uTexture, vTexCoord - ' + offset + ') * uTaps[' + i + '];\n';
        fragmentShader += '  sum += 2.0 * uTaps[' + i + '];\n';
      });
      fragmentShader += '  gl_FragColor = color / sum;\n';
      fragmentShader += '}';
      return fragmentShader;
    },

    fragmentSourceTOP: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec2 uDelta;\n' +
      'varying vec2 vTexCoord;\n',

    /**
     * Apply the resize filter to the image
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo: function(options) {
      if (options.webgl) {
        options.passes++;
        this.width = options.sourceWidth;
        this.horizontal = true;
        this.dW = Math.round(this.width * this.scaleX);
        this.dH = options.sourceHeight;
        this.tempScale = this.dW / this.width;
        this.taps = this.getTaps();
        options.destinationWidth = this.dW;
        this._setupFrameBuffer(options);
        this.applyToWebGL(options);
        this._swapTextures(options);
        options.sourceWidth = options.destinationWidth;

        this.height = options.sourceHeight;
        this.horizontal = false;
        this.dH = Math.round(this.height * this.scaleY);
        this.tempScale = this.dH / this.height;
        this.taps = this.getTaps();
        options.destinationHeight = this.dH;
        this._setupFrameBuffer(options);
        this.applyToWebGL(options);
        this._swapTextures(options);
        options.sourceHeight = options.destinationHeight;
      }
      else {
        this.applyTo2d(options);
      }
    },

    isNeutralState: function() {
      return this.scaleX === 1 && this.scaleY === 1;
    },

    lanczosCreate: function(lobes) {
      return function(x) {
        if (x >= lobes || x <= -lobes) {
          return 0.0;
        }
        if (x < 1.19209290E-07 && x > -1.19209290E-07) {
          return 1.0;
        }
        x *= Math.PI;
        var xx = x / lobes;
        return (sin(x) / x) * sin(xx) / xx;
      };
    },

    /**
     * Applies filter to canvas element
     * @memberOf fabric.Image.filters.Resize.prototype
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} scaleX
     * @param {Number} scaleY
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          scaleX = this.scaleX,
          scaleY = this.scaleY;

      this.rcpScaleX = 1 / scaleX;
      this.rcpScaleY = 1 / scaleY;

      var oW = imageData.width, oH = imageData.height,
          dW = round(oW * scaleX), dH = round(oH * scaleY),
          newData;

      if (this.resizeType === 'sliceHack') {
        newData = this.sliceByTwo(options, oW, oH, dW, dH);
      }
      else if (this.resizeType === 'hermite') {
        newData = this.hermiteFastResize(options, oW, oH, dW, dH);
      }
      else if (this.resizeType === 'bilinear') {
        newData = this.bilinearFiltering(options, oW, oH, dW, dH);
      }
      else if (this.resizeType === 'lanczos') {
        newData = this.lanczosResize(options, oW, oH, dW, dH);
      }
      options.imageData = newData;
    },

    /**
     * Filter sliceByTwo
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    sliceByTwo: function(options, oW, oH, dW, dH) {
      var imageData = options.imageData,
          mult = 0.5, doneW = false, doneH = false, stepW = oW * mult,
          stepH = oH * mult, resources = fabric.filterBackend.resources,
          tmpCanvas, ctx, sX = 0, sY = 0, dX = oW, dY = 0;
      if (!resources.sliceByTwo) {
        resources.sliceByTwo = document.createElement('canvas');
      }
      tmpCanvas = resources.sliceByTwo;
      if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
        tmpCanvas.width = oW * 1.5;
        tmpCanvas.height = oH;
      }
      ctx = tmpCanvas.getContext('2d');
      ctx.clearRect(0, 0, oW * 1.5, oH);
      ctx.putImageData(imageData, 0, 0);

      dW = floor(dW);
      dH = floor(dH);

      while (!doneW || !doneH) {
        oW = stepW;
        oH = stepH;
        if (dW < floor(stepW * mult)) {
          stepW = floor(stepW * mult);
        }
        else {
          stepW = dW;
          doneW = true;
        }
        if (dH < floor(stepH * mult)) {
          stepH = floor(stepH * mult);
        }
        else {
          stepH = dH;
          doneH = true;
        }
        ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
        sX = dX;
        sY = dY;
        dY += stepH;
      }
      return ctx.getImageData(sX, sY, dW, dH);
    },

    /**
     * Filter lanczosResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    lanczosResize: function(options, oW, oH, dW, dH) {

      function process(u) {
        var v, i, weight, idx, a, red, green,
            blue, alpha, fX, fY;
        center.x = (u + 0.5) * ratioX;
        icenter.x = floor(center.x);
        for (v = 0; v < dH; v++) {
          center.y = (v + 0.5) * ratioY;
          icenter.y = floor(center.y);
          a = 0; red = 0; green = 0; blue = 0; alpha = 0;
          for (i = icenter.x - range2X; i <= icenter.x + range2X; i++) {
            if (i < 0 || i >= oW) {
              continue;
            }
            fX = floor(1000 * abs(i - center.x));
            if (!cacheLanc[fX]) {
              cacheLanc[fX] = { };
            }
            for (var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++) {
              if (j < 0 || j >= oH) {
                continue;
              }
              fY = floor(1000 * abs(j - center.y));
              if (!cacheLanc[fX][fY]) {
                cacheLanc[fX][fY] = lanczos(sqrt(pow(fX * rcpRatioX, 2) + pow(fY * rcpRatioY, 2)) / 1000);
              }
              weight = cacheLanc[fX][fY];
              if (weight > 0) {
                idx = (j * oW + i) * 4;
                a += weight;
                red += weight * srcData[idx];
                green += weight * srcData[idx + 1];
                blue += weight * srcData[idx + 2];
                alpha += weight * srcData[idx + 3];
              }
            }
          }
          idx = (v * dW + u) * 4;
          destData[idx] = red / a;
          destData[idx + 1] = green / a;
          destData[idx + 2] = blue / a;
          destData[idx + 3] = alpha / a;
        }

        if (++u < dW) {
          return process(u);
        }
        else {
          return destImg;
        }
      }

      var srcData = options.imageData.data,
          destImg = options.ctx.createImageData(dW, dH),
          destData = destImg.data,
          lanczos = this.lanczosCreate(this.lanczosLobes),
          ratioX = this.rcpScaleX, ratioY = this.rcpScaleY,
          rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY,
          range2X = ceil(ratioX * this.lanczosLobes / 2),
          range2Y = ceil(ratioY * this.lanczosLobes / 2),
          cacheLanc = { }, center = { }, icenter = { };

      return process(0);
    },

    /**
     * bilinearFiltering
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    bilinearFiltering: function(options, oW, oH, dW, dH) {
      var a, b, c, d, x, y, i, j, xDiff, yDiff, chnl,
          color, offset = 0, origPix, ratioX = this.rcpScaleX,
          ratioY = this.rcpScaleY,
          w4 = 4 * (oW - 1), img = options.imageData,
          pixels = img.data, destImage = options.ctx.createImageData(dW, dH),
          destPixels = destImage.data;
      for (i = 0; i < dH; i++) {
        for (j = 0; j < dW; j++) {
          x = floor(ratioX * j);
          y = floor(ratioY * i);
          xDiff = ratioX * j - x;
          yDiff = ratioY * i - y;
          origPix = 4 * (y * oW + x);

          for (chnl = 0; chnl < 4; chnl++) {
            a = pixels[origPix + chnl];
            b = pixels[origPix + 4 + chnl];
            c = pixels[origPix + w4 + chnl];
            d = pixels[origPix + w4 + 4 + chnl];
            color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) +
                    c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
            destPixels[offset++] = color;
          }
        }
      }
      return destImage;
    },

    /**
     * hermiteFastResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    hermiteFastResize: function(options, oW, oH, dW, dH) {
      var ratioW = this.rcpScaleX, ratioH = this.rcpScaleY,
          ratioWHalf = ceil(ratioW / 2),
          ratioHHalf = ceil(ratioH / 2),
          img = options.imageData, data = img.data,
          img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
      for (var j = 0; j < dH; j++) {
        for (var i = 0; i < dW; i++) {
          var x2 = (i + j * dW) * 4, weight = 0, weights = 0, weightsAlpha = 0,
              gxR = 0, gxG = 0, gxB = 0, gxA = 0, centerY = (j + 0.5) * ratioH;
          for (var yy = floor(j * ratioH); yy < (j + 1) * ratioH; yy++) {
            var dy = abs(centerY - (yy + 0.5)) / ratioHHalf,
                centerX = (i + 0.5) * ratioW, w0 = dy * dy;
            for (var xx = floor(i * ratioW); xx < (i + 1) * ratioW; xx++) {
              var dx = abs(centerX - (xx + 0.5)) / ratioWHalf,
                  w = sqrt(w0 + dx * dx);
              /* eslint-disable max-depth */
              if (w > 1 && w < -1) {
                continue;
              }
              //hermite filter
              weight = 2 * w * w * w - 3 * w * w + 1;
              if (weight > 0) {
                dx = 4 * (xx + yy * oW);
                //alpha
                gxA += weight * data[dx + 3];
                weightsAlpha += weight;
                //colors
                if (data[dx + 3] < 255) {
                  weight = weight * data[dx + 3] / 250;
                }
                gxR += weight * data[dx];
                gxG += weight * data[dx + 1];
                gxB += weight * data[dx + 2];
                weights += weight;
              }
              /* eslint-enable max-depth */
            }
          }
          data2[x2] = gxR / weights;
          data2[x2 + 1] = gxG / weights;
          data2[x2 + 2] = gxB / weights;
          data2[x2 + 3] = gxA / weightsAlpha;
        }
      }
      return img2;
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return {
        type: this.type,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        resizeType: this.resizeType,
        lanczosLobes: this.lanczosLobes
      };
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Resize} Instance of fabric.Image.filters.Resize
   */
  fabric.Image.filters.Resize.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Contrast filter class
   * @class fabric.Image.filters.Contrast
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Contrast#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Contrast({
   *   contrast: 0.25
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Contrast = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Contrast.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Contrast',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uContrast;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n' +
        'color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * contrast value, range from -1 to 1.
     * @param {Number} contrast
     * @default 0
     */
    contrast: 0,

    mainParameter: 'contrast',

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Contrast.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
     */

    /**
      * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
      *
      * @param {Object} options
      * @param {ImageData} options.imageData The Uint8Array to be filtered.
      */
    applyTo2d: function(options) {
      if (this.contrast === 0) {
        return;
      }
      var imageData = options.imageData, i, len,
          data = imageData.data, len = data.length,
          contrast = Math.floor(this.contrast * 255),
          contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));

      for (i = 0; i < len; i += 4) {
        data[i] = contrastF * (data[i] - 128) + 128;
        data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
        data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uContrast: gl.getUniformLocation(program, 'uContrast'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uContrast, this.contrast);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Contrast} Instance of fabric.Image.filters.Contrast
   */
  fabric.Image.filters.Contrast.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Saturate filter class
   * @class fabric.Image.filters.Saturation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Saturation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Saturation({
   *   saturation: 100
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Saturation = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Saturation.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Saturation',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uSaturation;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'float rgMax = max(color.r, color.g);\n' +
        'float rgbMax = max(rgMax, color.b);\n' +
        'color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n' +
        'color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n' +
        'color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n' +
        'gl_FragColor = color;\n' +
      '}',

    saturation: 0,

    mainParameter: 'saturation',

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Saturate.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
     */

    /**
     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      if (this.saturation === 0) {
        return;
      }
      var imageData = options.imageData,
          data = imageData.data, len = data.length,
          adjust = -this.saturation, i, max;

      for (i = 0; i < len; i += 4) {
        max = Math.max(data[i], data[i + 1], data[i + 2]);
        data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
        data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
        data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uSaturation: gl.getUniformLocation(program, 'uSaturation'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Saturation} Instance of fabric.Image.filters.Saturate
   */
  fabric.Image.filters.Saturation.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Blur filter class
   * @class fabric.Image.filters.Blur
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Blur#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Blur({
   *   blur: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.Blur = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blur.prototype */ {

    type: 'Blur',

    /*
'gl_FragColor = vec4(0.0);',
'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
*/

    /* eslint-disable max-len */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec2 uDelta;\n' +
      'varying vec2 vTexCoord;\n' +
      'const float nSamples = 15.0;\n' +
      'vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n' +
      'float random(vec3 scale) {\n' +
        /* use the fragment position for a different seed per-pixel */
        'return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n' +
      '}\n' +
      'void main() {\n' +
        'vec4 color = vec4(0.0);\n' +
        'float total = 0.0;\n' +
        'float offset = random(v3offset);\n' +
        'for (float t = -nSamples; t <= nSamples; t++) {\n' +
          'float percent = (t + offset - 0.5) / nSamples;\n' +
          'float weight = 1.0 - abs(percent);\n' +
          'color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\n' +
          'total += weight;\n' +
        '}\n' +
        'gl_FragColor = color / total;\n' +
      '}',
    /* eslint-enable max-len */

    /**
     * blur value, in percentage of image dimensions.
     * specific to keep the image blur constant at different resolutions
     * range bewteen 0 and 1.
     */
    blur: 0,

    mainParameter: 'blur',

    applyTo: function(options) {
      if (options.webgl) {
        // this aspectRatio is used to give the same blur to vertical and horizontal
        this.aspectRatio = options.sourceWidth / options.sourceHeight;
        options.passes++;
        this._setupFrameBuffer(options);
        this.horizontal = true;
        this.applyToWebGL(options);
        this._swapTextures(options);
        this._setupFrameBuffer(options);
        this.horizontal = false;
        this.applyToWebGL(options);
        this._swapTextures(options);
      }
      else {
        this.applyTo2d(options);
      }
    },

    applyTo2d: function(options) {
      // paint canvasEl with current image data.
      //options.ctx.putImageData(options.imageData, 0, 0);
      options.imageData = this.simpleBlur(options);
    },

    simpleBlur: function(options) {
      var resources = options.filterBackend.resources, canvas1, canvas2,
          width = options.imageData.width,
          height = options.imageData.height;

      if (!resources.blurLayer1) {
        resources.blurLayer1 = fabric.util.createCanvasElement();
        resources.blurLayer2 = fabric.util.createCanvasElement();
      }
      canvas1 = resources.blurLayer1;
      canvas2 = resources.blurLayer2;
      if (canvas1.width !== width || canvas1.height !== height) {
        canvas2.width = canvas1.width = width;
        canvas2.height = canvas1.height = height;
      }
      var ctx1 = canvas1.getContext('2d'),
          ctx2 = canvas2.getContext('2d'),
          nSamples = 15,
          random, percent, j, i,
          blur = this.blur * 0.06 * 0.5;

      // load first canvas
      ctx1.putImageData(options.imageData, 0, 0);
      ctx2.clearRect(0, 0, width, height);

      for (i = -nSamples; i <= nSamples; i++) {
        random = (Math.random() - 0.5) / 4;
        percent = i / nSamples;
        j = blur * percent * width + random;
        ctx2.globalAlpha = 1 - Math.abs(percent);
        ctx2.drawImage(canvas1, j, random);
        ctx1.drawImage(canvas2, 0, 0);
        ctx2.globalAlpha = 1;
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
      }
      for (i = -nSamples; i <= nSamples; i++) {
        random = (Math.random() - 0.5) / 4;
        percent = i / nSamples;
        j = blur * percent * height + random;
        ctx2.globalAlpha = 1 - Math.abs(percent);
        ctx2.drawImage(canvas1, random, j);
        ctx1.drawImage(canvas2, 0, 0);
        ctx2.globalAlpha = 1;
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
      }
      options.ctx.drawImage(canvas1, 0, 0);
      var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
      ctx1.globalAlpha = 1;
      ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
      return newImageData;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        delta: gl.getUniformLocation(program, 'uDelta'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var delta = this.chooseRightDelta();
      gl.uniform2fv(uniformLocations.delta, delta);
    },

    /**
     * choose right value of image percentage to blur with
     * @returns {Array} a numeric array with delta values
     */
    chooseRightDelta: function() {
      var blurScale = 1, delta = [0, 0], blur;
      if (this.horizontal) {
        if (this.aspectRatio > 1) {
          // image is wide, i want to shrink radius horizontal
          blurScale = 1 / this.aspectRatio;
        }
      }
      else {
        if (this.aspectRatio < 1) {
          // image is tall, i want to shrink radius vertical
          blurScale = this.aspectRatio;
        }
      }
      blur = blurScale * this.blur * 0.12;
      if (this.horizontal) {
        delta[0] = blur;
      }
      else {
        delta[1] = blur;
      }
      return delta;
    },
  });

  /**
   * Deserialize a JSON definition of a BlurFilter into a concrete instance.
   */
  filters.Blur.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Gamma filter class
   * @class fabric.Image.filters.Gamma
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Gamma#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Gamma({
   *   brightness: 200
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Gamma = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Gamma.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Gamma',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec3 uGamma;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'vec3 correction = (1.0 / uGamma);\n' +
        'color.r = pow(color.r, correction.r);\n' +
        'color.g = pow(color.g, correction.g);\n' +
        'color.b = pow(color.b, correction.b);\n' +
        'gl_FragColor = color;\n' +
        'gl_FragColor.rgb *= color.a;\n' +
      '}',

    /**
     * Gamma array value, from 0.01 to 2.2.
     * @param {Array} gamma
     * @default
     */
    gamma: [1, 1, 1],

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'gamma',

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      this.gamma = [1, 1, 1];
      filters.BaseFilter.prototype.initialize.call(this, options);
    },

    /**
     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData, data = imageData.data,
          gamma = this.gamma, len = data.length,
          rInv = 1 / gamma[0], gInv = 1 / gamma[1],
          bInv = 1 / gamma[2], i;

      if (!this.rVals) {
        // eslint-disable-next-line
        this.rVals = new Uint8Array(256);
        // eslint-disable-next-line
        this.gVals = new Uint8Array(256);
        // eslint-disable-next-line
        this.bVals = new Uint8Array(256);
      }

      // This is an optimization - pre-compute a look-up table for each color channel
      // instead of performing these pow calls for each pixel in the image.
      for (i = 0, len = 256; i < len; i++) {
        this.rVals[i] = Math.pow(i / 255, rInv) * 255;
        this.gVals[i] = Math.pow(i / 255, gInv) * 255;
        this.bVals[i] = Math.pow(i / 255, bInv) * 255;
      }
      for (i = 0, len = data.length; i < len; i += 4) {
        data[i] = this.rVals[data[i]];
        data[i + 1] = this.gVals[data[i + 1]];
        data[i + 2] = this.bVals[data[i + 2]];
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uGamma: gl.getUniformLocation(program, 'uGamma'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform3fv(uniformLocations.uGamma, this.gamma);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Gamma} Instance of fabric.Image.filters.Gamma
   */
  fabric.Image.filters.Gamma.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * A container class that knows how to apply a sequence of filters to an input image.
   */
  filters.Composed = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Composed.prototype */ {

    type: 'Composed',

    /**
     * A non sparse array of filters to apply
     */
    subFilters: [],

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      // create a new array instead mutating the prototype with push
      this.subFilters = this.subFilters.slice(0);
    },

    /**
     * Apply this container's filters to the input image provided.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be applied.
     */
    applyTo: function(options) {
      options.passes += this.subFilters.length - 1;
      this.subFilters.forEach(function(filter) {
        filter.applyTo(options);
      });
    },

    /**
     * Serialize this filter into JSON.
     *
     * @returns {Object} A JSON representation of this filter.
     */
    toObject: function() {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        subFilters: this.subFilters.map(function(filter) { return filter.toObject(); }),
      });
    },

    isNeutralState: function() {
      return !this.subFilters.some(function(filter) { return !filter.isNeutralState(); });
    }
  });

  /**
   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
   */
  fabric.Image.filters.Composed.fromObject = function(object, callback) {
    var filters = object.subFilters || [],
        subFilters = filters.map(function(filter) {
          return new fabric.Image.filters[filter.type](filter);
        }),
        instance = new fabric.Image.filters.Composed({ subFilters: subFilters });
    callback && callback(instance);
    return instance;
  };
})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * HueRotation filter class
   * @class fabric.Image.filters.HueRotation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.HueRotation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.HueRotation({
   *   rotation: -0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.HueRotation = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.HueRotation.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'HueRotation',

    /**
     * HueRotation value, from -1 to 1.
     * the unit is radians
     * @param {Number} myParameter
     * @default
     */
    rotation: 0,

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'rotation',

    calculateMatrix: function() {
      var rad = this.rotation * Math.PI, cos = fabric.util.cos(rad), sin = fabric.util.sin(rad),
          aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sin, OneMinusCos = 1 - cos;
      this.matrix = [
        1, 0, 0, 0, 0,
        0, 1, 0, 0, 0,
        0, 0, 1, 0, 0,
        0, 0, 0, 1, 0
      ];
      this.matrix[0] = cos + OneMinusCos / 3;
      this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[6] = cos + aThird * OneMinusCos;
      this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[12] = cos + aThird * OneMinusCos;
    },

    /**
     * HueRotation isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/
    isNeutralState: function(options) {
      this.calculateMatrix();
      return filters.BaseFilter.prototype.isNeutralState.call(this, options);
    },

    /**
     * Apply this filter to the input image data provided.
     *
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo: function(options) {
      this.calculateMatrix();
      filters.BaseFilter.prototype.applyTo.call(this, options);
    },

  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.HueRotation} Instance of fabric.Image.filters.HueRotation
   */
  fabric.Image.filters.HueRotation.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})(typeof exports !== 'undefined' ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      clone = fabric.util.object.clone;

  if (fabric.Text) {
    fabric.warn('fabric.Text is already defined');
    return;
  }

  /**
   * Text class
   * @class fabric.Text
   * @extends fabric.Object
   * @return {fabric.Text} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
   * @see {@link fabric.Text#initialize} for constructor definition
   */
  fabric.Text = fabric.util.createClass(fabric.Object, /** @lends fabric.Text.prototype */ {

    /**
     * Properties which when set cause object to change dimensions
     * @type Array
     * @private
     */
    _dimensionAffectingProps: [
      'fontSize',
      'fontWeight',
      'fontFamily',
      'fontStyle',
      'lineHeight',
      'text',
      'charSpacing',
      'textAlign',
      'styles',
    ],

    /**
     * @private
     */
    _reNewline: /\r?\n/,

    /**
     * Use this regular expression to filter for whitespaces that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reSpacesAndTabs: /[ \t\r]/g,

    /**
     * Use this regular expression to filter for whitespace that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reSpaceAndTab: /[ \t\r]/,

    /**
     * Use this regular expression to filter consecutive groups of non spaces.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reWords: /\S+/g,

    /**
     * Type of an object
     * @type String
     * @default
     */
    type:                 'text',

    /**
     * Font size (in pixels)
     * @type Number
     * @default
     */
    fontSize:             40,

    /**
     * Font weight (e.g. bold, normal, 400, 600, 800)
     * @type {(Number|String)}
     * @default
     */
    fontWeight:           'normal',

    /**
     * Font family
     * @type String
     * @default
     */
    fontFamily:           'Times New Roman',

    /**
     * Text decoration underline.
     * @type Boolean
     * @default
     */
    underline:       false,

    /**
     * Text decoration overline.
     * @type Boolean
     * @default
     */
    overline:       false,

    /**
     * Text decoration linethrough.
     * @type Boolean
     * @default
     */
    linethrough:       false,

    /**
     * Text alignment. Possible values: "left", "center", "right", "justify",
     * "justify-left", "justify-center" or "justify-right".
     * @type String
     * @default
     */
    textAlign:            'left',

    /**
     * Font style . Possible values: "", "normal", "italic" or "oblique".
     * @type String
     * @default
     */
    fontStyle:            'normal',

    /**
     * Line height
     * @type Number
     * @default
     */
    lineHeight:           1.16,

    /**
     * Superscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */
    superscript: {
      size:      0.60, // fontSize factor
      baseline: -0.35  // baseline-shift factor (upwards)
    },

    /**
     * Subscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */
    subscript: {
      size:      0.60, // fontSize factor
      baseline:  0.11  // baseline-shift factor (downwards)
    },

    /**
     * Background color of text lines
     * @type String
     * @default
     */
    textBackgroundColor:  '',

    /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('fontFamily',
      'fontWeight',
      'fontSize',
      'text',
      'underline',
      'overline',
      'linethrough',
      'textAlign',
      'fontStyle',
      'lineHeight',
      'textBackgroundColor',
      'charSpacing',
      'styles'),

    /**
     * List of properties to consider when checking if cache needs refresh
     * @type Array
     */
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('fontFamily',
      'fontWeight',
      'fontSize',
      'text',
      'underline',
      'overline',
      'linethrough',
      'textAlign',
      'fontStyle',
      'lineHeight',
      'textBackgroundColor',
      'charSpacing',
      'styles'),

    /**
     * When defined, an object is rendered via stroke and this property specifies its color.
     * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
     * @type String
     * @default
     */
    stroke:               null,

    /**
     * Shadow object representing shadow of this shape.
     * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
     * @type fabric.Shadow
     * @default
     */
    shadow:               null,

    /**
     * @private
     */
    _fontSizeFraction: 0.222,

    /**
     * @private
     */
    offsets: {
      underline: 0.10,
      linethrough: -0.315,
      overline: -0.88
    },

    /**
     * Text Line proportion to font Size (in pixels)
     * @type Number
     * @default
     */
    _fontSizeMult:             1.13,

    /**
     * additional space between characters
     * expressed in thousands of em unit
     * @type Number
     * @default
     */
    charSpacing:             0,

    /**
     * Object containing character styles - top-level properties -> line numbers,
     * 2nd-level properties - charater numbers
     * @type Object
     * @default
     */
    styles: null,

    /**
     * Reference to a context to measure text char or couple of chars
     * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
     * once created it will be referenced on fabric._measuringContext to avoide creating a canvas for every
     * text object created.
     * @type {CanvasRenderingContext2D}
     * @default
     */
    _measuringContext: null,

    /**
     * Baseline shift, stlyes only, keep at 0 for the main text object
     * @type {Number}
     * @default
     */
    deltaY: 0,

    /**
     * Array of properties that define a style unit (of 'styles').
     * @type {Array}
     * @default
     */
    _styleProperties: [
      'stroke',
      'strokeWidth',
      'fill',
      'fontFamily',
      'fontSize',
      'fontWeight',
      'fontStyle',
      'underline',
      'overline',
      'linethrough',
      'deltaY',
      'textBackgroundColor',
    ],

    /**
     * contains characters bounding boxes
     */
    __charBounds: [],

    /**
     * use this size when measuring text. To avoid IE11 rounding errors
     * @type {Number}
     * @default
     * @readonly
     * @private
     */
    CACHE_FONT_SIZE: 400,

    /**
     * contains the min text width to avoid getting 0
     * @type {Number}
     * @default
     */
    MIN_TEXT_WIDTH: 2,

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */
    initialize: function(text, options) {
      this.styles = options ? (options.styles || { }) : { };
      this.text = text;
      this.__skipDimension = true;
      this.callSuper('initialize', options);
      this.__skipDimension = false;
      this.initDimensions();
      this.setCoords();
      this.setupState({ propertySet: '_dimensionAffectingProps' });
    },

    /**
     * Return a contex for measurement of text string.
     * if created it gets stored for reuse
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */
    getMeasuringContext: function() {
      // if we did not return we have to measure something.
      if (!fabric._measuringContext) {
        fabric._measuringContext = this.canvas && this.canvas.contextCache ||
          fabric.util.createCanvasElement().getContext('2d');
      }
      return fabric._measuringContext;
    },

    /**
     * @private
     * Divides text into lines of text and lines of graphemes.
     */
    _splitText: function() {
      var newLines = this._splitTextIntoLines(this.text);
      this.textLines = newLines.lines;
      this._textLines = newLines.graphemeLines;
      this._unwrappedTextLines = newLines._unwrappedLines;
      this._text = newLines.graphemeText;
      return newLines;
    },

    /**
     * Initialize or update text dimensions.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     */
    initDimensions: function() {
      if (this.__skipDimension) {
        return;
      }
      this._splitText();
      this._clearCache();
      this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
      if (this.textAlign.indexOf('justify') !== -1) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      }
      this.height = this.calcTextHeight();
      this.saveState({ propertySet: '_dimensionAffectingProps' });
    },

    /**
     * Enlarge space boxes and shift the others
     */
    enlargeSpaces: function() {
      var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        if (this.textAlign !== 'justify' && (i === len - 1 || this.isEndOfWrapping(i))) {
          continue;
        }
        accumulatedSpace = 0;
        line = this._textLines[i];
        currentLineWidth = this.getLineWidth(i);
        if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
          numberOfSpaces = spaces.length;
          diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
          for (var j = 0, jlen = line.length; j <= jlen; j++) {
            charBound = this.__charBounds[i][j];
            if (this._reSpaceAndTab.test(line[j])) {
              charBound.width += diffSpace;
              charBound.kernedWidth += diffSpace;
              charBound.left += accumulatedSpace;
              accumulatedSpace += diffSpace;
            }
            else {
              charBound.left += accumulatedSpace;
            }
          }
        }
      }
    },

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @return {Boolean}
     */
    isEndOfWrapping: function(lineIndex) {
      return lineIndex === this._textLines.length - 1;
    },

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * It return always for text and Itext.
     * @return Number
     */
    missingNewlineOffset: function() {
      return 1;
    },

    /**
     * Returns string representation of an instance
     * @return {String} String representation of text object
     */
    toString: function() {
      return '#<fabric.Text (' + this.complexity() +
        '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @param {Object} dim.x width of object to be cached
     * @param {Object} dim.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function() {
      var dims = this.callSuper('_getCacheCanvasDimensions');
      var fontSize = this.fontSize;
      dims.width += fontSize * dims.zoomX;
      dims.height += fontSize * dims.zoomY;
      return dims;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      this._setTextStyles(ctx);
      this._renderTextLinesBackground(ctx);
      this._renderTextDecoration(ctx, 'underline');
      this._renderText(ctx);
      this._renderTextDecoration(ctx, 'overline');
      this._renderTextDecoration(ctx, 'linethrough');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderText: function(ctx) {
      if (this.paintFirst === 'stroke') {
        this._renderTextStroke(ctx);
        this._renderTextFill(ctx);
      }
      else {
        this._renderTextFill(ctx);
        this._renderTextStroke(ctx);
      }
    },

    /**
     * Set the font parameter of the context with the object properties or with charStyle
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [charStyle] object with font style properties
     * @param {String} [charStyle.fontFamily] Font Family
     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
     * @param {String} [charStyle.fontWeight] Font weight
     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
     */
    _setTextStyles: function(ctx, charStyle, forMeasuring) {
      ctx.textBaseline = 'alphabetic';
      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    },

    /**
     * calculate and return the text Width measuring each line.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {Number} Maximum width of fabric.Text object
     */
    calcTextWidth: function() {
      var maxWidth = this.getLineWidth(0);

      for (var i = 1, len = this._textLines.length; i < len; i++) {
        var currentLineWidth = this.getLineWidth(i);
        if (currentLineWidth > maxWidth) {
          maxWidth = currentLineWidth;
        }
      }
      return maxWidth;
    },

    /**
     * @private
     * @param {String} method Method name ("fillText" or "strokeText")
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Text to render
     * @param {Number} left Left position of text
     * @param {Number} top Top position of text
     * @param {Number} lineIndex Index of a line in a text
     */
    _renderTextLine: function(method, ctx, line, left, top, lineIndex) {
      this._renderChars(method, ctx, line, left, top, lineIndex);
    },

    /**
     * Renders the text background for lines, taking care of style
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextLinesBackground: function(ctx) {
      if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) {
        return;
      }
      var lineTopOffset = 0, heightOfLine,
          lineLeftOffset, originalFill = ctx.fillStyle,
          line, lastColor,
          leftOffset = this._getLeftOffset(),
          topOffset = this._getTopOffset(),
          boxStart = 0, boxWidth = 0, charBox, currentColor;

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        heightOfLine = this.getHeightOfLine(i);
        if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
          lineTopOffset += heightOfLine;
          continue;
        }
        line = this._textLines[i];
        lineLeftOffset = this._getLineLeftOffset(i);
        boxWidth = 0;
        boxStart = 0;
        lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
        for (var j = 0, jlen = line.length; j < jlen; j++) {
          charBox = this.__charBounds[i][j];
          currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
          if (currentColor !== lastColor) {
            ctx.fillStyle = lastColor;
            lastColor && ctx.fillRect(
              leftOffset + lineLeftOffset + boxStart,
              topOffset + lineTopOffset,
              boxWidth,
              heightOfLine / this.lineHeight
            );
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastColor = currentColor;
          }
          else {
            boxWidth += charBox.kernedWidth;
          }
        }
        if (currentColor) {
          ctx.fillStyle = currentColor;
          ctx.fillRect(
            leftOffset + lineLeftOffset + boxStart,
            topOffset + lineTopOffset,
            boxWidth,
            heightOfLine / this.lineHeight
          );
        }
        lineTopOffset += heightOfLine;
      }
      ctx.fillStyle = originalFill;
      // if there is text background color no
      // other shadows should be casted
      this._removeShadow(ctx);
    },

    /**
     * @private
     * @param {Object} decl style declaration for cache
     * @param {String} decl.fontFamily fontFamily
     * @param {String} decl.fontStyle fontStyle
     * @param {String} decl.fontWeight fontWeight
     * @return {Object} reference to cache
     */
    getFontCache: function(decl) {
      var fontFamily = decl.fontFamily.toLowerCase();
      if (!fabric.charWidthsCache[fontFamily]) {
        fabric.charWidthsCache[fontFamily] = { };
      }
      var cache = fabric.charWidthsCache[fontFamily],
          cacheProp = decl.fontStyle.toLowerCase() + '_' + (decl.fontWeight + '').toLowerCase();
      if (!cache[cacheProp]) {
        cache[cacheProp] = { };
      }
      return cache[cacheProp];
    },

    /**
     * apply all the character style to canvas for rendering
     * @private
     * @param {String} _char
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} [decl]
     */
    _applyCharStyles: function(method, ctx, lineIndex, charIndex, styleDeclaration) {

      this._setFillStyles(ctx, styleDeclaration);
      this._setStrokeStyles(ctx, styleDeclaration);

      ctx.font = this._getFontDeclaration(styleDeclaration);
    },

    /**
     * measure and return the width of a single character.
     * possibly overridden to accommodate different measure logic or
     * to hook some external lib for character measurement
     * @private
     * @param {String} _char, char to be measured
     * @param {Object} charStyle style of char to be measured
     * @param {String} [previousChar] previous char
     * @param {Object} [prevCharStyle] style of previous char
     */
    _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
      // first i try to return from cache
      var fontCache = this.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle),
          previousFontDeclaration = this._getFontDeclaration(prevCharStyle), couple = previousChar + _char,
          stylesAreEqual = fontDeclaration === previousFontDeclaration, width, coupleWidth, previousWidth,
          fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE, kernedWidth;

      if (previousChar && fontCache[previousChar] !== undefined) {
        previousWidth = fontCache[previousChar];
      }
      if (fontCache[_char] !== undefined) {
        kernedWidth = width = fontCache[_char];
      }
      if (stylesAreEqual && fontCache[couple] !== undefined) {
        coupleWidth = fontCache[couple];
        kernedWidth = coupleWidth - previousWidth;
      }
      if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
        var ctx = this.getMeasuringContext();
        // send a TRUE to specify measuring font size CACHE_FONT_SIZE
        this._setTextStyles(ctx, charStyle, true);
      }
      if (width === undefined) {
        kernedWidth = width = ctx.measureText(_char).width;
        fontCache[_char] = width;
      }
      if (previousWidth === undefined && stylesAreEqual && previousChar) {
        previousWidth = ctx.measureText(previousChar).width;
        fontCache[previousChar] = previousWidth;
      }
      if (stylesAreEqual && coupleWidth === undefined) {
        // we can measure the kerning couple and subtract the width of the previous character
        coupleWidth = ctx.measureText(couple).width;
        fontCache[couple] = coupleWidth;
        kernedWidth = coupleWidth - previousWidth;
      }
      return { width: width * fontMultiplier, kernedWidth: kernedWidth * fontMultiplier };
    },

    /**
     * Computes height of character at given position
     * @param {Number} line the line index number
     * @param {Number} _char the character index number
     * @return {Number} fontSize of the character
     */
    getHeightOfChar: function(line, _char) {
      return this.getValueOfPropertyAt(line, _char, 'fontSize');
    },

    /**
     * measure a text line measuring all characters.
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */
    measureLine: function(lineIndex) {
      var lineInfo = this._measureLine(lineIndex);
      if (this.charSpacing !== 0) {
        lineInfo.width -= this._getWidthOfCharSpacing();
      }
      if (lineInfo.width < 0) {
        lineInfo.width = 0;
      }
      return lineInfo;
    },

    /**
     * measure every grapheme of a line, populating __charBounds
     * @param {Number} lineIndex
     * @return {Object} object.width total width of characters
     * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
     */
    _measureLine: function(lineIndex) {
      var width = 0, i, grapheme, line = this._textLines[lineIndex], prevGrapheme,
          graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length);

      this.__charBounds[lineIndex] = lineBounds;
      for (i = 0; i < line.length; i++) {
        grapheme = line[i];
        graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
        lineBounds[i] = graphemeInfo;
        width += graphemeInfo.kernedWidth;
        prevGrapheme = grapheme;
      }
      // this latest bound box represent the last character of the line
      // to simplify cursor handling in interactive mode.
      lineBounds[i] = {
        left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
        width: 0,
        kernedWidth: 0,
        height: this.fontSize
      };
      return { width: width, numOfSpaces: numOfSpaces };
    },

    /**
     * Measure and return the info of a single grapheme.
     * needs the the info of previous graphemes already filled
     * @private
     * @param {String} grapheme to be measured
     * @param {Number} lineIndex index of the line where the char is
     * @param {Number} charIndex position in the line
     * @param {String} [prevGrapheme] character preceding the one to be measured
     */
    _getGraphemeBox: function(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
      var style = this.getCompleteStyleDeclaration(lineIndex, charIndex),
          prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : { },
          info = this._measureChar(grapheme, style, prevGrapheme, prevStyle),
          kernedWidth = info.kernedWidth,
          width = info.width, charSpacing;

      if (this.charSpacing !== 0) {
        charSpacing = this._getWidthOfCharSpacing();
        width += charSpacing;
        kernedWidth += charSpacing;
      }

      var box = {
        width: width,
        left: 0,
        height: style.fontSize,
        kernedWidth: kernedWidth,
        deltaY: style.deltaY,
      };
      if (charIndex > 0 && !skipLeft) {
        var previousBox = this.__charBounds[lineIndex][charIndex - 1];
        box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
      }
      return box;
    },

    /**
     * Calculate height of line at 'lineIndex'
     * @param {Number} lineIndex index of line to calculate
     * @return {Number}
     */
    getHeightOfLine: function(lineIndex) {
      if (this.__lineHeights[lineIndex]) {
        return this.__lineHeights[lineIndex];
      }

      var line = this._textLines[lineIndex],
          // char 0 is measured before the line cycle because it nneds to char
          // emptylines
          maxHeight = this.getHeightOfChar(lineIndex, 0);
      for (var i = 1, len = line.length; i < len; i++) {
        maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
      }

      return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
    },

    /**
     * Calculate text box height
     */
    calcTextHeight: function() {
      var lineHeight, height = 0;
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        lineHeight = this.getHeightOfLine(i);
        height += (i === len - 1 ? lineHeight / this.lineHeight : lineHeight);
      }
      return height;
    },

    /**
     * @private
     * @return {Number} Left offset
     */
    _getLeftOffset: function() {
      return -this.width / 2;
    },

    /**
     * @private
     * @return {Number} Top offset
     */
    _getTopOffset: function() {
      return -this.height / 2;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} filler fabric.Pattern or fabric.Gradient
     * @return {Object} offset.offsetX offset for text rendering
     * @return {Object} offset.offsetY offset for text rendering
     */
    _applyPatternGradientTransform: function(ctx, filler) {
      if (!filler || !filler.toLive) {
        return { offsetX: 0, offsetY: 0 };
      }
      var offsetX = -this.width / 2 + filler.offsetX || 0,
          offsetY = -this.height / 2 + filler.offsetY || 0;

      ctx.transform(1, 0, 0, 1, offsetX, offsetY);
      return { offsetX: offsetX, offsetY: offsetY };
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} method Method name ("fillText" or "strokeText")
     */
    _renderTextCommon: function(ctx, method) {
      ctx.save();
      var lineHeights = 0, left = this._getLeftOffset(), top = this._getTopOffset(),
          offsets = this._applyPatternGradientTransform(ctx, method === 'fillText' ? this.fill : this.stroke);
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        var heightOfLine = this.getHeightOfLine(i),
            maxHeight = heightOfLine / this.lineHeight,
            leftOffset = this._getLineLeftOffset(i);
        this._renderTextLine(
          method,
          ctx,
          this._textLines[i],
          left + leftOffset - offsets.offsetX,
          top + lineHeights + maxHeight - offsets.offsetY,
          i
        );
        lineHeights += heightOfLine;
      }
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextFill: function(ctx) {
      if (!this.fill && !this.styleHas('fill')) {
        return;
      }

      this._renderTextCommon(ctx, 'fillText');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextStroke: function(ctx) {
      if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }

      ctx.save();
      this._setLineDash(ctx, this.strokeDashArray);
      ctx.beginPath();
      this._renderTextCommon(ctx, 'strokeText');
      ctx.closePath();
      ctx.restore();
    },

    /**
     * @private
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Content of the line
     * @param {Number} left
     * @param {Number} top
     * @param {Number} lineIndex
     * @param {Number} charOffset
     */
    _renderChars: function(method, ctx, line, left, top, lineIndex) {
      // set proper line offset
      var lineHeight = this.getHeightOfLine(lineIndex),
          isJustify = this.textAlign.indexOf('justify') !== -1,
          actualStyle,
          nextStyle,
          charsToRender = '',
          charBox,
          boxWidth = 0,
          timeToRender,
          shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex);

      ctx.save();
      top -= lineHeight * this._fontSizeFraction / this.lineHeight;
      if (shortCut) {
        // render all the line in one pass without checking
        this._renderChar(method, ctx, lineIndex, 0, this.textLines[lineIndex], left, top, lineHeight);
        ctx.restore();
        return;
      }
      for (var i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];
        if (boxWidth === 0) {
          left += charBox.kernedWidth - charBox.width;
          boxWidth += charBox.width;
        }
        else {
          boxWidth += charBox.kernedWidth;
        }
        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }
        if (!timeToRender) {
          // if we have charSpacing, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = this._hasStyleChanged(actualStyle, nextStyle);
        }
        if (timeToRender) {
          this._renderChar(method, ctx, lineIndex, i, charsToRender, left, top, lineHeight);
          charsToRender = '';
          actualStyle = nextStyle;
          left += boxWidth;
          boxWidth = 0;
        }
      }
      ctx.restore();
    },

    /**
     * @private
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {String} _char
     * @param {Number} left Left coordinate
     * @param {Number} top Top coordinate
     * @param {Number} lineHeight Height of the line
     */
    _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
      var decl = this._getStyleDeclaration(lineIndex, charIndex),
          fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex),
          shouldFill = method === 'fillText' && fullDecl.fill,
          shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth;

      if (!shouldStroke && !shouldFill) {
        return;
      }
      decl && ctx.save();

      this._applyCharStyles(method, ctx, lineIndex, charIndex, fullDecl);

      if (decl && decl.textBackgroundColor) {
        this._removeShadow(ctx);
      }
      if (decl && decl.deltaY) {
        top += decl.deltaY;
      }

      shouldFill && ctx.fillText(_char, left, top);
      shouldStroke && ctx.strokeText(_char, left, top);
      decl && ctx.restore();
    },

    /**
     * Turns the character into a 'superior figure' (i.e. 'superscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    setSuperscript: function(start, end) {
      return this._setScript(start, end, this.superscript);
    },

    /**
     * Turns the character into an 'inferior figure' (i.e. 'subscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    setSubscript: function(start, end) {
      return this._setScript(start, end, this.subscript);
    },

    /**
     * Applies 'schema' at given position
     * @private
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @param {Number} schema
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    _setScript: function(start, end, schema) {
      var loc = this.get2DCursorLocation(start, true),
          fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'),
          dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'),
          style = { fontSize: fontSize * schema.size, deltaY: dy + fontSize * schema.baseline };
      this.setSelectionStyles(style, start, end);
      return this;
    },

    /**
     * @private
     * @param {Object} prevStyle
     * @param {Object} thisStyle
     */
    _hasStyleChanged: function(prevStyle, thisStyle) {
      return prevStyle.fill !== thisStyle.fill ||
              prevStyle.stroke !== thisStyle.stroke ||
              prevStyle.strokeWidth !== thisStyle.strokeWidth ||
              prevStyle.fontSize !== thisStyle.fontSize ||
              prevStyle.fontFamily !== thisStyle.fontFamily ||
              prevStyle.fontWeight !== thisStyle.fontWeight ||
              prevStyle.fontStyle !== thisStyle.fontStyle ||
              prevStyle.deltaY !== thisStyle.deltaY;
    },

    /**
     * @private
     * @param {Object} prevStyle
     * @param {Object} thisStyle
     */
    _hasStyleChangedForSvg: function(prevStyle, thisStyle) {
      return this._hasStyleChanged(prevStyle, thisStyle) ||
        prevStyle.overline !== thisStyle.overline ||
        prevStyle.underline !== thisStyle.underline ||
        prevStyle.linethrough !== thisStyle.linethrough;
    },

    /**
     * @private
     * @param {Number} lineIndex index text line
     * @return {Number} Line left offset
     */
    _getLineLeftOffset: function(lineIndex) {
      var lineWidth = this.getLineWidth(lineIndex);
      if (this.textAlign === 'center') {
        return (this.width - lineWidth) / 2;
      }
      if (this.textAlign === 'right') {
        return this.width - lineWidth;
      }
      if (this.textAlign === 'justify-center' && this.isEndOfWrapping(lineIndex)) {
        return (this.width - lineWidth) / 2;
      }
      if (this.textAlign === 'justify-right' && this.isEndOfWrapping(lineIndex)) {
        return this.width - lineWidth;
      }
      return 0;
    },

    /**
     * @private
     */
    _clearCache: function() {
      this.__lineWidths = [];
      this.__lineHeights = [];
      this.__charBounds = [];
    },

    /**
     * @private
     */
    _shouldClearDimensionCache: function() {
      var shouldClear = this._forceClearCache;
      shouldClear || (shouldClear = this.hasStateChanged('_dimensionAffectingProps'));
      if (shouldClear) {
        this.dirty = true;
        this._forceClearCache = false;
      }
      return shouldClear;
    },

    /**
     * Measure a single line given its index. Used to calculate the initial
     * text bounding box. The values are calculated and stored in __lineWidths cache.
     * @private
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */
    getLineWidth: function(lineIndex) {
      if (this.__lineWidths[lineIndex]) {
        return this.__lineWidths[lineIndex];
      }

      var width, line = this._textLines[lineIndex], lineInfo;

      if (line === '') {
        width = 0;
      }
      else {
        lineInfo = this.measureLine(lineIndex);
        width = lineInfo.width;
      }
      this.__lineWidths[lineIndex] = width;
      return width;
    },

    _getWidthOfCharSpacing: function() {
      if (this.charSpacing !== 0) {
        return this.fontSize * this.charSpacing / 1000;
      }
      return 0;
    },

    /**
     * Retrieves the value of property at given character position
     * @param {Number} lineIndex the line number
     * @param {Number} charIndex the charater number
     * @param {String} property the property name
     * @returns the value of 'property'
     */
    getValueOfPropertyAt: function(lineIndex, charIndex, property) {
      var charStyle = this._getStyleDeclaration(lineIndex, charIndex);
      if (charStyle && typeof charStyle[property] !== 'undefined') {
        return charStyle[property];
      }
      return this[property];
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextDecoration: function(ctx, type) {
      if (!this[type] && !this.styleHas(type)) {
        return;
      }
      var heightOfLine, size, _size,
          lineLeftOffset, dy, _dy,
          line, lastDecoration,
          leftOffset = this._getLeftOffset(),
          topOffset = this._getTopOffset(), top,
          boxStart, boxWidth, charBox, currentDecoration,
          maxHeight, currentFill, lastFill,
          charSpacing = this._getWidthOfCharSpacing();

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        heightOfLine = this.getHeightOfLine(i);
        if (!this[type] && !this.styleHas(type, i)) {
          topOffset += heightOfLine;
          continue;
        }
        line = this._textLines[i];
        maxHeight = heightOfLine / this.lineHeight;
        lineLeftOffset = this._getLineLeftOffset(i);
        boxStart = 0;
        boxWidth = 0;
        lastDecoration = this.getValueOfPropertyAt(i, 0, type);
        lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
        top = topOffset + maxHeight * (1 - this._fontSizeFraction);
        size = this.getHeightOfChar(i, 0);
        dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
        for (var j = 0, jlen = line.length; j < jlen; j++) {
          charBox = this.__charBounds[i][j];
          currentDecoration = this.getValueOfPropertyAt(i, j, type);
          currentFill = this.getValueOfPropertyAt(i, j, 'fill');
          _size = this.getHeightOfChar(i, j);
          _dy = this.getValueOfPropertyAt(i, j, 'deltaY');
          if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy) &&
              boxWidth > 0) {
            ctx.fillStyle = lastFill;
            lastDecoration && lastFill && ctx.fillRect(
              leftOffset + lineLeftOffset + boxStart,
              top + this.offsets[type] * size + dy,
              boxWidth,
              this.fontSize / 15
            );
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastDecoration = currentDecoration;
            lastFill = currentFill;
            size = _size;
            dy = _dy;
          }
          else {
            boxWidth += charBox.kernedWidth;
          }
        }
        ctx.fillStyle = currentFill;
        currentDecoration && currentFill && ctx.fillRect(
          leftOffset + lineLeftOffset + boxStart,
          top + this.offsets[type] * size + dy,
          boxWidth - charSpacing,
          this.fontSize / 15
        );
        topOffset += heightOfLine;
      }
      // if there is text background color no
      // other shadows should be casted
      this._removeShadow(ctx);
    },

    /**
     * return font declaration string for canvas context
     * @param {Object} [styleObject] object
     * @returns {String} font declaration formatted for canvas context.
     */
    _getFontDeclaration: function(styleObject, forMeasuring) {
      var style = styleObject || this, family = this.fontFamily,
          fontIsGeneric = fabric.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
      var fontFamily = family === undefined ||
      family.indexOf('\'') > -1 || family.indexOf(',') > -1 ||
      family.indexOf('"') > -1 || fontIsGeneric
        ? style.fontFamily : '"' + style.fontFamily + '"';
      return [
        // node-canvas needs "weight style", while browsers need "style weight"
        // verify if this can be fixed in JSDOM
        (fabric.isLikelyNode ? style.fontWeight : style.fontStyle),
        (fabric.isLikelyNode ? style.fontStyle : style.fontWeight),
        forMeasuring ? this.CACHE_FONT_SIZE + 'px' : style.fontSize + 'px',
        fontFamily
      ].join(' ');
    },

    /**
     * Renders text instance on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function(ctx) {
      // do not render if object is not visible
      if (!this.visible) {
        return;
      }
      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }
      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
      }
      this.callSuper('render', ctx);
    },

    /**
     * Returns the text as an array of lines.
     * @param {String} text text to split
     * @returns {Array} Lines in the text
     */
    _splitTextIntoLines: function(text) {
      var lines = text.split(this._reNewline),
          newLines = new Array(lines.length),
          newLine = ['\n'],
          newText = [];
      for (var i = 0; i < lines.length; i++) {
        newLines[i] = fabric.util.string.graphemeSplit(lines[i]);
        newText = newText.concat(newLines[i], newLine);
      }
      newText.pop();
      return { _unwrappedLines: newLines, lines: lines, graphemeText: newText, graphemeLines: newLines };
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var additionalProperties = [
        'text',
        'fontSize',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'lineHeight',
        'underline',
        'overline',
        'linethrough',
        'textAlign',
        'textBackgroundColor',
        'charSpacing',
      ].concat(propertiesToInclude);
      var obj = this.callSuper('toObject', additionalProperties);
      obj.styles = clone(this.styles, true);
      return obj;
    },

    /**
     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
     * @return {fabric.Object} thisArg
     * @chainable
     */
    set: function(key, value) {
      this.callSuper('set', key, value);
      var needsDims = false;
      if (typeof key === 'object') {
        for (var _key in key) {
          needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
        }
      }
      else {
        needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
      }
      if (needsDims) {
        this.initDimensions();
        this.setCoords();
      }
      return this;
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity
     */
    complexity: function() {
      return 1;
    }
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Text.fromElement})
   * @static
   * @memberOf fabric.Text
   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
   */
  fabric.Text.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(
    'x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor'.split(' '));

  /**
   * Default SVG font size
   * @static
   * @memberOf fabric.Text
   */
  fabric.Text.DEFAULT_SVG_FONT_SIZE = 16;

  /**
   * Returns fabric.Text instance from an SVG element (<b>not yet implemented</b>)
   * @static
   * @memberOf fabric.Text
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Text.fromElement = function(element, callback, options) {
    if (!element) {
      return callback(null);
    }

    var parsedAttributes = fabric.parseAttributes(element, fabric.Text.ATTRIBUTE_NAMES),
        parsedAnchor = parsedAttributes.textAnchor || 'left';
    options = fabric.util.object.extend((options ? clone(options) : { }), parsedAttributes);

    options.top = options.top || 0;
    options.left = options.left || 0;
    if (parsedAttributes.textDecoration) {
      var textDecoration = parsedAttributes.textDecoration;
      if (textDecoration.indexOf('underline') !== -1) {
        options.underline = true;
      }
      if (textDecoration.indexOf('overline') !== -1) {
        options.overline = true;
      }
      if (textDecoration.indexOf('line-through') !== -1) {
        options.linethrough = true;
      }
      delete options.textDecoration;
    }
    if ('dx' in parsedAttributes) {
      options.left += parsedAttributes.dx;
    }
    if ('dy' in parsedAttributes) {
      options.top += parsedAttributes.dy;
    }
    if (!('fontSize' in options)) {
      options.fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
    }

    var textContent = '';

    // The XML is not properly parsed in IE9 so a workaround to get
    // textContent is through firstChild.data. Another workaround would be
    // to convert XML loaded from a file to be converted using DOMParser (same way loadSVGFromString() does)
    if (!('textContent' in element)) {
      if ('firstChild' in element && element.firstChild !== null) {
        if ('data' in element.firstChild && element.firstChild.data !== null) {
          textContent = element.firstChild.data;
        }
      }
    }
    else {
      textContent = element.textContent;
    }

    textContent = textContent.replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' ');
    var originalStrokeWidth = options.strokeWidth;
    options.strokeWidth = 0;

    var text = new fabric.Text(textContent, options),
        textHeightScaleFactor = text.getScaledHeight() / text.height,
        lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height,
        scaledDiff = lineHeightDiff * textHeightScaleFactor,
        textHeight = text.getScaledHeight() + scaledDiff,
        offX = 0;
    /*
      Adjust positioning:
        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
        fabric output by default at top, left.
    */
    if (parsedAnchor === 'center') {
      offX = text.getScaledWidth() / 2;
    }
    if (parsedAnchor === 'right') {
      offX = text.getScaledWidth();
    }
    text.set({
      left: text.left - offX,
      top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
      strokeWidth: typeof originalStrokeWidth !== 'undefined' ? originalStrokeWidth : 1,
    });
    callback(text);
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Text instance from an object representation
   * @static
   * @memberOf fabric.Text
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Text instance is created
   */
  fabric.Text.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Text', object, callback, 'text');
  };

  fabric.Text.genericFonts = ['sans-serif', 'serif', 'cursive', 'fantasy', 'monospace'];

  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Text);

})(typeof exports !== 'undefined' ? exports : this);


(function() {
  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles: function(lineIndex) {
      if (!this.styles) {
        return true;
      }
      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return true;
      }
      var obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
      for (var p1 in obj) {
        for (var p2 in obj[p1]) {
          // eslint-disable-next-line no-unused-vars
          for (var p3 in obj[p1][p2]) {
            return false;
          }
        }
      }
      return true;
    },

    /**
     * Returns true if object has a style property or has it ina specified line
     * This function is used to detect if a text will use a particular property or not.
     * @param {String} property to check for
     * @param {Number} lineIndex to check the style on
     * @return {Boolean}
     */
    styleHas: function(property, lineIndex) {
      if (!this.styles || !property || property === '') {
        return false;
      }
      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return false;
      }
      var obj = typeof lineIndex === 'undefined' ? this.styles : { 0: this.styles[lineIndex] };
      // eslint-disable-next-line
      for (var p1 in obj) {
        // eslint-disable-next-line
        for (var p2 in obj[p1]) {
          if (typeof obj[p1][p2][property] !== 'undefined') {
            return true;
          }
        }
      }
      return false;
    },

    /**
     * Check if characters in a text have a value for a property
     * whose value matches the textbox's value for that property.  If so,
     * the character-level property is deleted.  If the character
     * has no other properties, then it is also deleted.  Finally,
     * if the line containing that character has no other characters
     * then it also is deleted.
     *
     * @param {string} property The property to compare between characters and text.
     */
    cleanStyle: function(property) {
      if (!this.styles || !property || property === '') {
        return false;
      }
      var obj = this.styles, stylesCount = 0, letterCount, stylePropertyValue,
          allStyleObjectPropertiesMatch = true, graphemeCount = 0, styleObject;
      // eslint-disable-next-line
      for (var p1 in obj) {
        letterCount = 0;
        // eslint-disable-next-line
        for (var p2 in obj[p1]) {
          var styleObject = obj[p1][p2],
              stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);

          stylesCount++;

          if (stylePropertyHasBeenSet) {
            if (!stylePropertyValue) {
              stylePropertyValue = styleObject[property];
            }
            else if (styleObject[property] !== stylePropertyValue) {
              allStyleObjectPropertiesMatch = false;
            }

            if (styleObject[property] === this[property]) {
              delete styleObject[property];
            }
          }
          else {
            allStyleObjectPropertiesMatch = false;
          }

          if (Object.keys(styleObject).length !== 0) {
            letterCount++;
          }
          else {
            delete obj[p1][p2];
          }
        }

        if (letterCount === 0) {
          delete obj[p1];
        }
      }
      // if every grapheme has the same style set then
      // delete those styles and set it on the parent
      for (var i = 0; i < this._textLines.length; i++) {
        graphemeCount += this._textLines[i].length;
      }
      if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
        this[property] = stylePropertyValue;
        this.removeStyle(property);
      }
    },

    /**
     * Remove a style property or properties from all individual character styles
     * in a text object.  Deletes the character style object if it contains no other style
     * props.  Deletes a line style object if it contains no other character styles.
     *
     * @param {String} props The property to remove from character styles.
     */
    removeStyle: function(property) {
      if (!this.styles || !property || property === '') {
        return;
      }
      var obj = this.styles, line, lineNum, charNum;
      for (lineNum in obj) {
        line = obj[lineNum];
        for (charNum in line) {
          delete line[charNum][property];
          if (Object.keys(line[charNum]).length === 0) {
            delete line[charNum];
          }
        }
        if (Object.keys(line).length === 0) {
          delete obj[lineNum];
        }
      }
    },

    /**
     * @private
     */
    _extendStyles: function(index, styles) {
      var loc = this.get2DCursorLocation(index);

      if (!this._getLineStyle(loc.lineIndex)) {
        this._setLineStyle(loc.lineIndex);
      }

      if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) {
        this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
      }

      fabric.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
    },

    /**
     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. usefull to manage styles.
     */
    get2DCursorLocation: function(selectionStart, skipWrapping) {
      if (typeof selectionStart === 'undefined') {
        selectionStart = this.selectionStart;
      }
      var lines = skipWrapping ? this._unwrappedTextLines : this._textLines,
          len = lines.length;
      for (var i = 0; i < len; i++) {
        if (selectionStart <= lines[i].length) {
          return {
            lineIndex: i,
            charIndex: selectionStart
          };
        }
        selectionStart -= lines[i].length + this.missingNewlineOffset(i);
      }
      return {
        lineIndex: i - 1,
        charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
      };
    },

    /**
     * Gets style of a current selection/cursor (at the start position)
     * if startIndex or endIndex are not provided, slectionStart or selectionEnd will be used.
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @param {Boolean} [complete] get full style or not
     * @return {Array} styles an array with one, zero or more Style objects
     */
    getSelectionStyles: function(startIndex, endIndex, complete) {
      if (typeof startIndex === 'undefined') {
        startIndex = this.selectionStart || 0;
      }
      if (typeof endIndex === 'undefined') {
        endIndex = this.selectionEnd || startIndex;
      }
      var styles = [];
      for (var i = startIndex; i < endIndex; i++) {
        styles.push(this.getStyleAtPosition(i, complete));
      }
      return styles;
    },

    /**
     * Gets style of a current selection/cursor position
     * @param {Number} position  to get styles at
     * @param {Boolean} [complete] full style if true
     * @return {Object} style Style object at a specified index
     * @private
     */
    getStyleAtPosition: function(position, complete) {
      var loc = this.get2DCursorLocation(position),
          style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) :
            this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
      return style || {};
    },

    /**
     * Sets style of a current selection, if no selection exist, do not set anything.
     * @param {Object} [styles] Styles object
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @return {fabric.IText} thisArg
     * @chainable
     */
    setSelectionStyles: function(styles, startIndex, endIndex) {
      if (typeof startIndex === 'undefined') {
        startIndex = this.selectionStart || 0;
      }
      if (typeof endIndex === 'undefined') {
        endIndex = this.selectionEnd || startIndex;
      }
      for (var i = startIndex; i < endIndex; i++) {
        this._extendStyles(i, styles);
      }
      /* not included in _extendStyles to avoid clearing cache more than once */
      this._forceClearCache = true;
      return this;
    },

    /**
     * get the reference, not a clone, of the style object for a given character
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {Object} style object
     */
    _getStyleDeclaration: function(lineIndex, charIndex) {
      var lineStyle = this.styles && this.styles[lineIndex];
      if (!lineStyle) {
        return null;
      }
      return lineStyle[charIndex];
    },

    /**
     * return a new object that contains all the style property for a character
     * the object returned is newly created
     * @param {Number} lineIndex of the line where the character is
     * @param {Number} charIndex position of the character on the line
     * @return {Object} style object
     */
    getCompleteStyleDeclaration: function(lineIndex, charIndex) {
      var style = this._getStyleDeclaration(lineIndex, charIndex) || { },
          styleObject = { }, prop;
      for (var i = 0; i < this._styleProperties.length; i++) {
        prop = this._styleProperties[i];
        styleObject[prop] = typeof style[prop] === 'undefined' ? this[prop] : style[prop];
      }
      return styleObject;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration: function(lineIndex, charIndex, style) {
      this.styles[lineIndex][charIndex] = style;
    },

    /**
     *
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration: function(lineIndex, charIndex) {
      delete this.styles[lineIndex][charIndex];
    },

    /**
     * @param {Number} lineIndex
     * @return {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle: function(lineIndex) {
      return !!this.styles[lineIndex];
    },

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @private
     */
    _setLineStyle: function(lineIndex) {
      this.styles[lineIndex] = {};
    },

    /**
     * @param {Number} lineIndex
     * @private
     */
    _deleteLineStyle: function(lineIndex) {
      delete this.styles[lineIndex];
    }
  });
})();


(function() {

  function parseDecoration(object) {
    if (object.textDecoration) {
      object.textDecoration.indexOf('underline') > -1 && (object.underline = true);
      object.textDecoration.indexOf('line-through') > -1 && (object.linethrough = true);
      object.textDecoration.indexOf('overline') > -1 && (object.overline = true);
      delete object.textDecoration;
    }
  }

  /**
   * IText class (introduced in <b>v1.4</b>) Events are also fired with "text:"
   * prefix when observing canvas.
   * @class fabric.IText
   * @extends fabric.Text
   * @mixes fabric.Observable
   *
   * @fires changed
   * @fires selection:changed
   * @fires editing:entered
   * @fires editing:exited
   *
   * @return {fabric.IText} thisArg
   * @see {@link fabric.IText#initialize} for constructor definition
   *
   * <p>Supported key combinations:</p>
   * <pre>
   *   Move cursor:                    left, right, up, down
   *   Select character:               shift + left, shift + right
   *   Select text vertically:         shift + up, shift + down
   *   Move cursor by word:            alt + left, alt + right
   *   Select words:                   shift + alt + left, shift + alt + right
   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
   *   Jump to start/end of text:      cmd + up, cmd + down
   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
   *   Delete character:               backspace
   *   Delete word:                    alt + backspace
   *   Delete line:                    cmd + backspace
   *   Forward delete:                 delete
   *   Copy text:                      ctrl/cmd + c
   *   Paste text:                     ctrl/cmd + v
   *   Cut text:                       ctrl/cmd + x
   *   Select entire text:             ctrl/cmd + a
   *   Quit editing                    tab or esc
   * </pre>
   *
   * <p>Supported mouse/touch combination</p>
   * <pre>
   *   Position cursor:                click/touch
   *   Create selection:               click/touch & drag
   *   Create selection:               click & shift + click
   *   Select word:                    double click
   *   Select line:                    triple click
   * </pre>
   */
  fabric.IText = fabric.util.createClass(fabric.Text, fabric.Observable, /** @lends fabric.IText.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'i-text',

    /**
     * Index where text selection starts (or where cursor is when there is no selection)
     * @type Number
     * @default
     */
    selectionStart: 0,

    /**
     * Index where text selection ends
     * @type Number
     * @default
     */
    selectionEnd: 0,

    /**
     * Color of text selection
     * @type String
     * @default
     */
    selectionColor: 'rgba(17,119,255,0.3)',

    /**
     * Indicates whether text is in editing mode
     * @type Boolean
     * @default
     */
    isEditing: false,

    /**
     * Indicates whether a text can be edited
     * @type Boolean
     * @default
     */
    editable: true,

    /**
     * Border color of text object while it's in editing mode
     * @type String
     * @default
     */
    editingBorderColor: 'rgba(102,153,255,0.25)',

    /**
     * Width of cursor (in px)
     * @type Number
     * @default
     */
    cursorWidth: 2,

    /**
     * Color of default cursor (when not overwritten by character style)
     * @type String
     * @default
     */
    cursorColor: '#333',

    /**
     * Delay between cursor blink (in ms)
     * @type Number
     * @default
     */
    cursorDelay: 1000,

    /**
     * Duration of cursor fadein (in ms)
     * @type Number
     * @default
     */
    cursorDuration: 600,

    /**
     * Indicates whether internal text char widths can be cached
     * @type Boolean
     * @default
     */
    caching: true,

    /**
     * @private
     */
    _reSpace: /\s|\n/,

    /**
     * @private
     */
    _currentCursorOpacity: 0,

    /**
     * @private
     */
    _selectionDirection: null,

    /**
     * @private
     */
    _abortCursorAnimation: false,

    /**
     * @private
     */
    __widthOfSpace: [],

    /**
     * Helps determining when the text is in composition, so that the cursor
     * rendering is altered.
     */
    inCompositionMode: false,

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.IText} thisArg
     */
    initialize: function(text, options) {
      this.callSuper('initialize', text, options);
      this.initBehavior();
    },

    /**
     * Sets selection start (left boundary of a selection)
     * @param {Number} index Index to set selection start to
     */
    setSelectionStart: function(index) {
      index = Math.max(index, 0);
      this._updateAndFire('selectionStart', index);
    },

    /**
     * Sets selection end (right boundary of a selection)
     * @param {Number} index Index to set selection end to
     */
    setSelectionEnd: function(index) {
      index = Math.min(index, this.text.length);
      this._updateAndFire('selectionEnd', index);
    },

    /**
     * @private
     * @param {String} property 'selectionStart' or 'selectionEnd'
     * @param {Number} index new position of property
     */
    _updateAndFire: function(property, index) {
      if (this[property] !== index) {
        this._fireSelectionChanged();
        this[property] = index;
      }
      this._updateTextarea();
    },

    /**
     * Fires the even of selection changed
     * @private
     */
    _fireSelectionChanged: function() {
      this.fire('selection:changed');
      this.canvas && this.canvas.fire('text:selection:changed', { target: this });
    },

    /**
     * Initialize text dimensions. Render all text on given context
     * or on a offscreen canvas to get the text width with measureText.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     * @private
     */
    initDimensions: function() {
      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();
      this.callSuper('initDimensions');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function(ctx) {
      this.clearContextTop();
      this.callSuper('render', ctx);
      // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
      // the correct position but not at every cursor animation.
      this.cursorOffsetCache = { };
      this.renderCursorOrSelection();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      this.callSuper('_render', ctx);
    },

    /**
     * Prepare and clean the contextTop
     */
    clearContextTop: function(skipRestore) {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }
      var ctx = this.canvas.contextTop, v = this.canvas.viewportTransform;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      this.transform(ctx);
      this.transformMatrix && ctx.transform.apply(ctx, this.transformMatrix);
      this._clearTextArea(ctx);
      skipRestore || ctx.restore();
    },

    /**
     * Renders cursor or selection (depending on what exists)
     * it does on the contextTop. If contextTop is not available, do nothing.
     */
    renderCursorOrSelection: function() {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }
      var boundaries = this._getCursorBoundaries(),
          ctx = this.canvas.contextTop;
      this.clearContextTop(true);
      if (this.selectionStart === this.selectionEnd) {
        this.renderCursor(boundaries, ctx);
      }
      else {
        this.renderSelection(boundaries, ctx);
      }
      ctx.restore();
    },

    _clearTextArea: function(ctx) {
      // we add 4 pixel, to be sure to do not leave any pixel out
      var width = this.width + 4, height = this.height + 4;
      ctx.clearRect(-width / 2, -height / 2, width, height);
    },

    /**
     * Returns cursor boundaries (left, top, leftOffset, topOffset)
     * @private
     * @param {Array} chars Array of characters
     * @param {String} typeOfBoundaries
     */
    _getCursorBoundaries: function(position) {

      // left/top are left/top of entire text box
      // leftOffset/topOffset are offset from that left/top point of a text box

      if (typeof position === 'undefined') {
        position = this.selectionStart;
      }

      var left = this._getLeftOffset(),
          top = this._getTopOffset(),
          offsets = this._getCursorBoundariesOffsets(position);

      return {
        left: left,
        top: top,
        leftOffset: offsets.left,
        topOffset: offsets.top
      };
    },

    /**
     * @private
     */
    _getCursorBoundariesOffsets: function(position) {
      if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) {
        return this.cursorOffsetCache;
      }
      var lineLeftOffset,
          lineIndex,
          charIndex,
          topOffset = 0,
          leftOffset = 0,
          boundaries,
          cursorPosition = this.get2DCursorLocation(position);
      charIndex = cursorPosition.charIndex;
      lineIndex = cursorPosition.lineIndex;
      for (var i = 0; i < lineIndex; i++) {
        topOffset += this.getHeightOfLine(i);
      }
      lineLeftOffset = this._getLineLeftOffset(lineIndex);
      var bound = this.__charBounds[lineIndex][charIndex];
      bound && (leftOffset = bound.left);
      if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) {
        leftOffset -= this._getWidthOfCharSpacing();
      }
      boundaries = {
        top: topOffset,
        left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0),
      };
      this.cursorOffsetCache = boundaries;
      return this.cursorOffsetCache;
    },

    /**
     * Renders cursor
     * @param {Object} boundaries
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderCursor: function(boundaries, ctx) {
      var cursorLocation = this.get2DCursorLocation(),
          lineIndex = cursorLocation.lineIndex,
          charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0,
          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'),
          multiplier = this.scaleX * this.canvas.getZoom(),
          cursorWidth = this.cursorWidth / multiplier,
          topOffset = boundaries.topOffset,
          dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');

      topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight
        - charHeight * (1 - this._fontSizeFraction);

      if (this.inCompositionMode) {
        this.renderSelection(boundaries, ctx);
      }

      ctx.fillStyle = this.getValueOfPropertyAt(lineIndex, charIndex, 'fill');
      ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
      ctx.fillRect(
        boundaries.left + boundaries.leftOffset - cursorWidth / 2,
        topOffset + boundaries.top + dy,
        cursorWidth,
        charHeight);
    },

    /**
     * Renders text selection
     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderSelection: function(boundaries, ctx) {

      var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
          selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd,
          isJustify = this.textAlign.indexOf('justify') !== -1,
          start = this.get2DCursorLocation(selectionStart),
          end = this.get2DCursorLocation(selectionEnd),
          startLine = start.lineIndex,
          endLine = end.lineIndex,
          startChar = start.charIndex < 0 ? 0 : start.charIndex,
          endChar = end.charIndex < 0 ? 0 : end.charIndex;

      for (var i = startLine; i <= endLine; i++) {
        var lineOffset = this._getLineLeftOffset(i) || 0,
            lineHeight = this.getHeightOfLine(i),
            realLineHeight = 0, boxStart = 0, boxEnd = 0;

        if (i === startLine) {
          boxStart = this.__charBounds[startLine][startChar].left;
        }
        if (i >= startLine && i < endLine) {
          boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
        }
        else if (i === endLine) {
          if (endChar === 0) {
            boxEnd = this.__charBounds[endLine][endChar].left;
          }
          else {
            var charSpacing = this._getWidthOfCharSpacing();
            boxEnd = this.__charBounds[endLine][endChar - 1].left
              + this.__charBounds[endLine][endChar - 1].width - charSpacing;
          }
        }
        realLineHeight = lineHeight;
        if (this.lineHeight < 1 || (i === endLine && this.lineHeight > 1)) {
          lineHeight /= this.lineHeight;
        }
        if (this.inCompositionMode) {
          ctx.fillStyle = this.compositionColor || 'black';
          ctx.fillRect(
            boundaries.left + lineOffset + boxStart,
            boundaries.top + boundaries.topOffset + lineHeight,
            boxEnd - boxStart,
            1);
        }
        else {
          ctx.fillStyle = this.selectionColor;
          ctx.fillRect(
            boundaries.left + lineOffset + boxStart,
            boundaries.top + boundaries.topOffset,
            boxEnd - boxStart,
            lineHeight);
        }


        boundaries.topOffset += realLineHeight;
      }
    },

    /**
     * High level function to know the height of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns fontSize of char at the current cursor
     * Unused from the library, is for the end user
     * @return {Number} Character font size
     */
    getCurrentCharFontSize: function() {
      var cp = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
    },

    /**
     * High level function to know the color of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns color (fill) of char at the current cursor
     * Unused from the library, is for the end user
     * @return {String} Character color (fill)
     */
    getCurrentCharColor: function() {
      var cp = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(cp.l, cp.c, 'fill');
    },

    /**
     * Returns the cursor position for the getCurrent.. functions
     * @private
     */
    _getCurrentCharIndex: function() {
      var cursorPosition = this.get2DCursorLocation(this.selectionStart, true),
          charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
      return { l: cursorPosition.lineIndex, c: charIndex };
    }
  });

  /**
   * Returns fabric.IText instance from an object representation
   * @static
   * @memberOf fabric.IText
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as argument
   */
  fabric.IText.fromObject = function(object, callback) {
    parseDecoration(object);
    if (object.styles) {
      for (var i in object.styles) {
        for (var j in object.styles[i]) {
          parseDecoration(object.styles[i][j]);
        }
      }
    }
    fabric.Object._fromObject('IText', object, callback, 'text');
  };
})();


(function() {

  var clone = fabric.util.object.clone;

  fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {

    /**
     * Initializes all the interactive behavior of IText
     */
    initBehavior: function() {
      this.initAddedHandler();
      this.initRemovedHandler();
      this.initCursorSelectionHandlers();
      this.initDoubleClickSimulation();
      this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
    },

    onDeselect: function() {
      this.isEditing && this.exitEditing();
      this.selected = false;
    },

    /**
     * Initializes "added" event handler
     */
    initAddedHandler: function() {
      var _this = this;
      this.on('added', function() {
        var canvas = _this.canvas;
        if (canvas) {
          if (!canvas._hasITextHandlers) {
            canvas._hasITextHandlers = true;
            _this._initCanvasHandlers(canvas);
          }
          canvas._iTextInstances = canvas._iTextInstances || [];
          canvas._iTextInstances.push(_this);
        }
      });
    },

    initRemovedHandler: function() {
      var _this = this;
      this.on('removed', function() {
        var canvas = _this.canvas;
        if (canvas) {
          canvas._iTextInstances = canvas._iTextInstances || [];
          fabric.util.removeFromArray(canvas._iTextInstances, _this);
          if (canvas._iTextInstances.length === 0) {
            canvas._hasITextHandlers = false;
            _this._removeCanvasHandlers(canvas);
          }
        }
      });
    },

    /**
     * register canvas event to manage exiting on other instances
     * @private
     */
    _initCanvasHandlers: function(canvas) {
      canvas._mouseUpITextHandler = function() {
        if (canvas._iTextInstances) {
          canvas._iTextInstances.forEach(function(obj) {
            obj.__isMousedown = false;
          });
        }
      };
      canvas.on('mouse:up', canvas._mouseUpITextHandler);
    },

    /**
     * remove canvas event to manage exiting on other instances
     * @private
     */
    _removeCanvasHandlers: function(canvas) {
      canvas.off('mouse:up', canvas._mouseUpITextHandler);
    },

    /**
     * @private
     */
    _tick: function() {
      this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, '_onTickComplete');
    },

    /**
     * @private
     */
    _animateCursor: function(obj, targetOpacity, duration, completeMethod) {

      var tickState;

      tickState = {
        isAborted: false,
        abort: function() {
          this.isAborted = true;
        },
      };

      obj.animate('_currentCursorOpacity', targetOpacity, {
        duration: duration,
        onComplete: function() {
          if (!tickState.isAborted) {
            obj[completeMethod]();
          }
        },
        onChange: function() {
          // we do not want to animate a selection, only cursor
          if (obj.canvas && obj.selectionStart === obj.selectionEnd) {
            obj.renderCursorOrSelection();
          }
        },
        abort: function() {
          return tickState.isAborted;
        }
      });
      return tickState;
    },

    /**
     * @private
     */
    _onTickComplete: function() {

      var _this = this;

      if (this._cursorTimeout1) {
        clearTimeout(this._cursorTimeout1);
      }
      this._cursorTimeout1 = setTimeout(function() {
        _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, '_tick');
      }, 100);
    },

    /**
     * Initializes delayed cursor
     */
    initDelayedCursor: function(restart) {
      var _this = this,
          delay = restart ? 0 : this.cursorDelay;

      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this._cursorTimeout2 = setTimeout(function() {
        _this._tick();
      }, delay);
    },

    /**
     * Aborts cursor animation and clears all timeouts
     */
    abortCursorAnimation: function() {
      var shouldClear = this._currentTickState || this._currentTickCompleteState,
          canvas = this.canvas;
      this._currentTickState && this._currentTickState.abort();
      this._currentTickCompleteState && this._currentTickCompleteState.abort();

      clearTimeout(this._cursorTimeout1);
      clearTimeout(this._cursorTimeout2);

      this._currentCursorOpacity = 0;
      // to clear just itext area we need to transform the context
      // it may not be worth it
      if (shouldClear && canvas) {
        canvas.clearContext(canvas.contextTop || canvas.contextContainer);
      }

    },

    /**
     * Selects entire text
     * @return {fabric.IText} thisArg
     * @chainable
     */
    selectAll: function() {
      this.selectionStart = 0;
      this.selectionEnd = this._text.length;
      this._fireSelectionChanged();
      this._updateTextarea();
      return this;
    },

    /**
     * Returns selected text
     * @return {String}
     */
    getSelectedText: function() {
      return this._text.slice(this.selectionStart, this.selectionEnd).join('');
    },

    /**
     * Find new selection index representing start of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryLeft: function(startFrom) {
      var offset = 0, index = startFrom - 1;

      // remove space before cursor first
      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index--;
        }
      }
      while (/\S/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }

      return startFrom - offset;
    },

    /**
     * Find new selection index representing end of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryRight: function(startFrom) {
      var offset = 0, index = startFrom;

      // remove space after cursor first
      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index++;
        }
      }
      while (/\S/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }

      return startFrom + offset;
    },

    /**
     * Find new selection index representing start of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryLeft: function(startFrom) {
      var offset = 0, index = startFrom - 1;

      while (!/\n/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }

      return startFrom - offset;
    },

    /**
     * Find new selection index representing end of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryRight: function(startFrom) {
      var offset = 0, index = startFrom;

      while (!/\n/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }

      return startFrom + offset;
    },

    /**
     * Finds index corresponding to beginning or end of a word
     * @param {Number} selectionStart Index of a character
     * @param {Number} direction 1 or -1
     * @return {Number} Index of the beginning or end of a word
     */
    searchWordBoundary: function(selectionStart, direction) {
      var text = this._text,
          index     = this._reSpace.test(text[selectionStart]) ? selectionStart - 1 : selectionStart,
          _char     = text[index],
          // wrong
          reNonWord = fabric.reNonWord;

      while (!reNonWord.test(_char) && index > 0 && index < text.length) {
        index += direction;
        _char = text[index];
      }
      if (reNonWord.test(_char)) {
        index += direction === 1 ? 0 : 1;
      }
      return index;
    },

    /**
     * Selects a word based on the index
     * @param {Number} selectionStart Index of a character
     */
    selectWord: function(selectionStart) {
      selectionStart = selectionStart || this.selectionStart;
      var newSelectionStart = this.searchWordBoundary(selectionStart, -1), /* search backwards */
          newSelectionEnd = this.searchWordBoundary(selectionStart, 1); /* search forward */

      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;
      this._fireSelectionChanged();
      this._updateTextarea();
      this.renderCursorOrSelection();
    },

    /**
     * Selects a line based on the index
     * @param {Number} selectionStart Index of a character
     * @return {fabric.IText} thisArg
     * @chainable
     */
    selectLine: function(selectionStart) {
      selectionStart = selectionStart || this.selectionStart;
      var newSelectionStart = this.findLineBoundaryLeft(selectionStart),
          newSelectionEnd = this.findLineBoundaryRight(selectionStart);

      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;
      this._fireSelectionChanged();
      this._updateTextarea();
      return this;
    },

    /**
     * Enters editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */
    enterEditing: function(e) {
      if (this.isEditing || !this.editable) {
        return;
      }

      if (this.canvas) {
        this.canvas.calcOffset();
        this.exitEditingOnOthers(this.canvas);
      }

      this.isEditing = true;

      this.initHiddenTextarea(e);
      this.hiddenTextarea.focus();
      this.hiddenTextarea.value = this.text;
      this._updateTextarea();
      this._saveEditingProps();
      this._setEditingProps();
      this._textBeforeEdit = this.text;

      this._tick();
      this.fire('editing:entered');
      this._fireSelectionChanged();
      if (!this.canvas) {
        return this;
      }
      this.canvas.fire('text:editing:entered', { target: this });
      this.initMouseMoveHandler();
      this.canvas.requestRenderAll();
      return this;
    },

    exitEditingOnOthers: function(canvas) {
      if (canvas._iTextInstances) {
        canvas._iTextInstances.forEach(function(obj) {
          obj.selected = false;
          if (obj.isEditing) {
            obj.exitEditing();
          }
        });
      }
    },

    /**
     * Initializes "mousemove" event handler
     */
    initMouseMoveHandler: function() {
      this.canvas.on('mouse:move', this.mouseMoveHandler);
    },

    /**
     * @private
     */
    mouseMoveHandler: function(options) {
      if (!this.__isMousedown || !this.isEditing) {
        return;
      }

      var newSelectionStart = this.getSelectionStartFromPointer(options.e),
          currentStart = this.selectionStart,
          currentEnd = this.selectionEnd;
      if (
        (newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd)
        &&
        (currentStart === newSelectionStart || currentEnd === newSelectionStart)
      ) {
        return;
      }
      if (newSelectionStart > this.__selectionStartOnMouseDown) {
        this.selectionStart = this.__selectionStartOnMouseDown;
        this.selectionEnd = newSelectionStart;
      }
      else {
        this.selectionStart = newSelectionStart;
        this.selectionEnd = this.__selectionStartOnMouseDown;
      }
      if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
        this.restartCursorIfNeeded();
        this._fireSelectionChanged();
        this._updateTextarea();
        this.renderCursorOrSelection();
      }
    },

    /**
     * @private
     */
    _setEditingProps: function() {
      this.hoverCursor = 'text';

      if (this.canvas) {
        this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
      }

      this.borderColor = this.editingBorderColor;
      this.hasControls = this.selectable = false;
      this.lockMovementX = this.lockMovementY = true;
    },

    /**
     * convert from textarea to grapheme indexes
     */
    fromStringToGraphemeSelection: function(start, end, text) {
      var smallerTextStart = text.slice(0, start),
          graphemeStart = fabric.util.string.graphemeSplit(smallerTextStart).length;
      if (start === end) {
        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
      }
      var smallerTextEnd = text.slice(start, end),
          graphemeEnd = fabric.util.string.graphemeSplit(smallerTextEnd).length;
      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
    },

    /**
     * convert from fabric to textarea values
     */
    fromGraphemeToStringSelection: function(start, end, _text) {
      var smallerTextStart = _text.slice(0, start),
          graphemeStart = smallerTextStart.join('').length;
      if (start === end) {
        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
      }
      var smallerTextEnd = _text.slice(start, end),
          graphemeEnd = smallerTextEnd.join('').length;
      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
    },

    /**
     * @private
     */
    _updateTextarea: function() {
      this.cursorOffsetCache = { };
      if (!this.hiddenTextarea) {
        return;
      }
      if (!this.inCompositionMode) {
        var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
        this.hiddenTextarea.selectionStart = newSelection.selectionStart;
        this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
      }
      this.updateTextareaPosition();
    },

    /**
     * @private
     */
    updateFromTextArea: function() {
      if (!this.hiddenTextarea) {
        return;
      }
      this.cursorOffsetCache = { };
      this.text = this.hiddenTextarea.value;
      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }
      var newSelection = this.fromStringToGraphemeSelection(
        this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
      this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
      if (!this.inCompositionMode) {
        this.selectionStart = newSelection.selectionStart;
      }
      this.updateTextareaPosition();
    },

    /**
     * @private
     */
    updateTextareaPosition: function() {
      if (this.selectionStart === this.selectionEnd) {
        var style = this._calcTextareaPosition();
        this.hiddenTextarea.style.left = style.left;
        this.hiddenTextarea.style.top = style.top;
      }
    },

    /**
     * @private
     * @return {Object} style contains style for hiddenTextarea
     */
    _calcTextareaPosition: function() {
      if (!this.canvas) {
        return { x: 1, y: 1 };
      }
      var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart,
          boundaries = this._getCursorBoundaries(desiredPosition),
          cursorLocation = this.get2DCursorLocation(desiredPosition),
          lineIndex = cursorLocation.lineIndex,
          charIndex = cursorLocation.charIndex,
          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight,
          leftOffset = boundaries.leftOffset,
          m = this.calcTransformMatrix(),
          p = {
            x: boundaries.left + leftOffset,
            y: boundaries.top + boundaries.topOffset + charHeight
          },
          retinaScaling = this.canvas.getRetinaScaling(),
          upperCanvas = this.canvas.upperCanvasEl,
          upperCanvasWidth = upperCanvas.width / retinaScaling,
          upperCanvasHeight = upperCanvas.height / retinaScaling,
          maxWidth = upperCanvasWidth - charHeight,
          maxHeight = upperCanvasHeight - charHeight,
          scaleX = upperCanvas.clientWidth / upperCanvasWidth,
          scaleY = upperCanvas.clientHeight / upperCanvasHeight;

      p = fabric.util.transformPoint(p, m);
      p = fabric.util.transformPoint(p, this.canvas.viewportTransform);
      p.x *= scaleX;
      p.y *= scaleY;
      if (p.x < 0) {
        p.x = 0;
      }
      if (p.x > maxWidth) {
        p.x = maxWidth;
      }
      if (p.y < 0) {
        p.y = 0;
      }
      if (p.y > maxHeight) {
        p.y = maxHeight;
      }

      // add canvas offset on document
      p.x += this.canvas._offset.left;
      p.y += this.canvas._offset.top;

      return { left: p.x + 'px', top: p.y + 'px', fontSize: charHeight + 'px', charHeight: charHeight };
    },

    /**
     * @private
     */
    _saveEditingProps: function() {
      this._savedProps = {
        hasControls: this.hasControls,
        borderColor: this.borderColor,
        lockMovementX: this.lockMovementX,
        lockMovementY: this.lockMovementY,
        hoverCursor: this.hoverCursor,
        selectable: this.selectable,
        defaultCursor: this.canvas && this.canvas.defaultCursor,
        moveCursor: this.canvas && this.canvas.moveCursor
      };
    },

    /**
     * @private
     */
    _restoreEditingProps: function() {
      if (!this._savedProps) {
        return;
      }

      this.hoverCursor = this._savedProps.hoverCursor;
      this.hasControls = this._savedProps.hasControls;
      this.borderColor = this._savedProps.borderColor;
      this.selectable = this._savedProps.selectable;
      this.lockMovementX = this._savedProps.lockMovementX;
      this.lockMovementY = this._savedProps.lockMovementY;

      if (this.canvas) {
        this.canvas.defaultCursor = this._savedProps.defaultCursor;
        this.canvas.moveCursor = this._savedProps.moveCursor;
      }
    },

    /**
     * Exits from editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */
    exitEditing: function() {
      var isTextChanged = (this._textBeforeEdit !== this.text);
      var hiddenTextarea = this.hiddenTextarea;
      this.selected = false;
      this.isEditing = false;

      this.selectionEnd = this.selectionStart;

      if (hiddenTextarea) {
        hiddenTextarea.blur && hiddenTextarea.blur();
        hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
      }
      this.hiddenTextarea = null;
      this.abortCursorAnimation();
      this._restoreEditingProps();
      this._currentCursorOpacity = 0;
      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }
      this.fire('editing:exited');
      isTextChanged && this.fire('modified');
      if (this.canvas) {
        this.canvas.off('mouse:move', this.mouseMoveHandler);
        this.canvas.fire('text:editing:exited', { target: this });
        isTextChanged && this.canvas.fire('object:modified', { target: this });
      }
      return this;
    },

    /**
     * @private
     */
    _removeExtraneousStyles: function() {
      for (var prop in this.styles) {
        if (!this._textLines[prop]) {
          delete this.styles[prop];
        }
      }
    },

    /**
     * remove and reflow a style block from start to end.
     * @param {Number} start linear start position for removal (included in removal)
     * @param {Number} end linear end position for removal ( excluded from removal )
     */
    removeStyleFromTo: function(start, end) {
      var cursorStart = this.get2DCursorLocation(start, true),
          cursorEnd = this.get2DCursorLocation(end, true),
          lineStart = cursorStart.lineIndex,
          charStart = cursorStart.charIndex,
          lineEnd = cursorEnd.lineIndex,
          charEnd = cursorEnd.charIndex,
          i, styleObj;
      if (lineStart !== lineEnd) {
        // step1 remove the trailing of lineStart
        if (this.styles[lineStart]) {
          for (i = charStart; i < this._unwrappedTextLines[lineStart].length; i++) {
            delete this.styles[lineStart][i];
          }
        }
        // step2 move the trailing of lineEnd to lineStart if needed
        if (this.styles[lineEnd]) {
          for (i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++) {
            styleObj = this.styles[lineEnd][i];
            if (styleObj) {
              this.styles[lineStart] || (this.styles[lineStart] = { });
              this.styles[lineStart][charStart + i - charEnd] = styleObj;
            }
          }
        }
        // step3 detects lines will be completely removed.
        for (i = lineStart + 1; i <= lineEnd; i++) {
          delete this.styles[i];
        }
        // step4 shift remaining lines.
        this.shiftLineStyles(lineEnd, lineStart - lineEnd);
      }
      else {
        // remove and shift left on the same line
        if (this.styles[lineStart]) {
          styleObj = this.styles[lineStart];
          var diff = charEnd - charStart, numericChar, _char;
          for (i = charStart; i < charEnd; i++) {
            delete styleObj[i];
          }
          for (_char in this.styles[lineStart]) {
            numericChar = parseInt(_char, 10);
            if (numericChar >= charEnd) {
              styleObj[numericChar - diff] = styleObj[_char];
              delete styleObj[_char];
            }
          }
        }
      }
    },

    /**
     * Shifts line styles up or down
     * @param {Number} lineIndex Index of a line
     * @param {Number} offset Can any number?
     */
    shiftLineStyles: function(lineIndex, offset) {
      // shift all line styles by offset upward or downward
      // do not clone deep. we need new array, not new style objects
      var clonedStyles = clone(this.styles);
      for (var line in this.styles) {
        var numericLine = parseInt(line, 10);
        if (numericLine > lineIndex) {
          this.styles[numericLine + offset] = clonedStyles[numericLine];
          if (!clonedStyles[numericLine - offset]) {
            delete this.styles[numericLine];
          }
        }
      }
    },

    restartCursorIfNeeded: function() {
      if (!this._currentTickState || this._currentTickState.isAborted
        || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted
      ) {
        this.initDelayedCursor();
      }
    },

    /**
     * Handle insertion of more consecutive style lines for when one or more
     * newlines gets added to the text. Since current style needs to be shifted
     * first we shift the current style of the number lines needed, then we add
     * new lines from the last to the first.
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} qty number of lines to add
     * @param {Array} copiedStyle Array of objects styles
     */
    insertNewlineStyleObject: function(lineIndex, charIndex, qty, copiedStyle) {
      var currentCharStyle,
          newLineStyles = {},
          somethingAdded = false,
          isEndOfLine = this._unwrappedTextLines[lineIndex].length === charIndex;

      qty || (qty = 1);
      this.shiftLineStyles(lineIndex, qty);
      if (this.styles[lineIndex]) {
        currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
      }
      // we clone styles of all chars
      // after cursor onto the current line
      for (var index in this.styles[lineIndex]) {
        var numIndex = parseInt(index, 10);
        if (numIndex >= charIndex) {
          somethingAdded = true;
          newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
          // remove lines from the previous line since they're on a new line now
          if (!(isEndOfLine && charIndex === 0)) {
            delete this.styles[lineIndex][index];
          }
        }
      }
      var styleCarriedOver = false;
      if (somethingAdded && !isEndOfLine) {
        // if is end of line, the extra style we copied
        // is probably not something we want
        this.styles[lineIndex + qty] = newLineStyles;
        styleCarriedOver = true;
      }
      if (styleCarriedOver) {
        // skip the last line of since we already prepared it.
        qty--;
      }
      // for the all the lines or all the other lines
      // we clone current char style onto the next (otherwise empty) line
      while (qty > 0) {
        if (copiedStyle && copiedStyle[qty - 1]) {
          this.styles[lineIndex + qty] = { 0: clone(copiedStyle[qty - 1]) };
        }
        else if (currentCharStyle) {
          this.styles[lineIndex + qty] = { 0: clone(currentCharStyle) };
        }
        else {
          delete this.styles[lineIndex + qty];
        }
        qty--;
      }
      this._forceClearCache = true;
    },

    /**
     * Inserts style object for a given line/char index
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} quantity number Style object to insert, if given
     * @param {Array} copiedStyle array of style objects
     */
    insertCharStyleObject: function(lineIndex, charIndex, quantity, copiedStyle) {
      if (!this.styles) {
        this.styles = {};
      }
      var currentLineStyles       = this.styles[lineIndex],
          currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};

      quantity || (quantity = 1);
      // shift all char styles by quantity forward
      // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
      for (var index in currentLineStylesCloned) {
        var numericIndex = parseInt(index, 10);
        if (numericIndex >= charIndex) {
          currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
          // only delete the style if there was nothing moved there
          if (!currentLineStylesCloned[numericIndex - quantity]) {
            delete currentLineStyles[numericIndex];
          }
        }
      }
      this._forceClearCache = true;
      if (copiedStyle) {
        while (quantity--) {
          if (!Object.keys(copiedStyle[quantity]).length) {
            continue;
          }
          if (!this.styles[lineIndex]) {
            this.styles[lineIndex] = {};
          }
          this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
        }
        return;
      }
      if (!currentLineStyles) {
        return;
      }
      var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
      while (newStyle && quantity--) {
        this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
      }
    },

    /**
     * Inserts style object(s)
     * @param {Array} insertedText Characters at the location where style is inserted
     * @param {Number} start cursor index for inserting style
     * @param {Array} [copiedStyle] array of style objects to insert.
     */
    insertNewStyleBlock: function(insertedText, start, copiedStyle) {
      var cursorLoc = this.get2DCursorLocation(start, true),
          addedLines = [0], linesLength = 0;
      // get an array of how many char per lines are being added.
      for (var i = 0; i < insertedText.length; i++) {
        if (insertedText[i] === '\n') {
          linesLength++;
          addedLines[linesLength] = 0;
        }
        else {
          addedLines[linesLength]++;
        }
      }
      // for the first line copy the style from the current char position.
      if (addedLines[0] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
      }
      linesLength && this.insertNewlineStyleObject(
        cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
      for (var i = 1; i < linesLength; i++) {
        if (addedLines[i] > 0) {
          this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
        }
        else if (copiedStyle) {
          this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
        }
        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
      }
      // we use i outside the loop to get it like linesLength
      if (addedLines[i] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
      }
    },

    /**
     * Set the selectionStart and selectionEnd according to the new position of cursor
     * mimic the key - mouse navigation when shift is pressed.
     */
    setSelectionStartEndWithShift: function(start, end, newSelection) {
      if (newSelection <= start) {
        if (end === start) {
          this._selectionDirection = 'left';
        }
        else if (this._selectionDirection === 'right') {
          this._selectionDirection = 'left';
          this.selectionEnd = start;
        }
        this.selectionStart = newSelection;
      }
      else if (newSelection > start && newSelection < end) {
        if (this._selectionDirection === 'right') {
          this.selectionEnd = newSelection;
        }
        else {
          this.selectionStart = newSelection;
        }
      }
      else {
        // newSelection is > selection start and end
        if (end === start) {
          this._selectionDirection = 'right';
        }
        else if (this._selectionDirection === 'left') {
          this._selectionDirection = 'right';
          this.selectionStart = end;
        }
        this.selectionEnd = newSelection;
      }
    },

    setSelectionInBoundaries: function() {
      var length = this.text.length;
      if (this.selectionStart > length) {
        this.selectionStart = length;
      }
      else if (this.selectionStart < 0) {
        this.selectionStart = 0;
      }
      if (this.selectionEnd > length) {
        this.selectionEnd = length;
      }
      else if (this.selectionEnd < 0) {
        this.selectionEnd = 0;
      }
    }
  });
})();


fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
  /**
   * Initializes "dbclick" event handler
   */
  initDoubleClickSimulation: function() {

    // for double click
    this.__lastClickTime = +new Date();

    // for triple click
    this.__lastLastClickTime = +new Date();

    this.__lastPointer = { };

    this.on('mousedown', this.onMouseDown);
  },

  /**
   * Default event handler to simulate triple click
   * @private
   */
  onMouseDown: function(options) {
    if (!this.canvas) {
      return;
    }
    this.__newClickTime = +new Date();
    var newPointer = options.pointer;
    if (this.isTripleClick(newPointer)) {
      this.fire('tripleclick', options);
      this._stopEvent(options.e);
    }
    this.__lastLastClickTime = this.__lastClickTime;
    this.__lastClickTime = this.__newClickTime;
    this.__lastPointer = newPointer;
    this.__lastIsEditing = this.isEditing;
    this.__lastSelected = this.selected;
  },

  isTripleClick: function(newPointer) {
    return this.__newClickTime - this.__lastClickTime < 500 &&
        this.__lastClickTime - this.__lastLastClickTime < 500 &&
        this.__lastPointer.x === newPointer.x &&
        this.__lastPointer.y === newPointer.y;
  },

  /**
   * @private
   */
  _stopEvent: function(e) {
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
  },

  /**
   * Initializes event handlers related to cursor or selection
   */
  initCursorSelectionHandlers: function() {
    this.initMousedownHandler();
    this.initMouseupHandler();
    this.initClicks();
  },

  /**
   * Default handler for double click, select a word
   */
  doubleClickHandler: function(options) {
    if (!this.isEditing) {
      return;
    }
    this.selectWord(this.getSelectionStartFromPointer(options.e));
  },

  /**
   * Default handler for triple click, select a line
   */
  tripleClickHandler: function(options) {
    if (!this.isEditing) {
      return;
    }
    this.selectLine(this.getSelectionStartFromPointer(options.e));
  },

  /**
   * Initializes double and triple click event handlers
   */
  initClicks: function() {
    this.on('mousedblclick', this.doubleClickHandler);
    this.on('tripleclick', this.tripleClickHandler);
  },

  /**
   * Default event handler for the basic functionalities needed on _mouseDown
   * can be overridden to do something different.
   * Scope of this implementation is: find the click position, set selectionStart
   * find selectionEnd, initialize the drawing of either cursor or selection area
   */
  _mouseDownHandler: function(options) {
    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
      return;
    }

    this.__isMousedown = true;

    if (this.selected) {
      this.setCursorByClick(options.e);
    }

    if (this.isEditing) {
      this.__selectionStartOnMouseDown = this.selectionStart;
      if (this.selectionStart === this.selectionEnd) {
        this.abortCursorAnimation();
      }
      this.renderCursorOrSelection();
    }
  },

  /**
   * Default event handler for the basic functionalities needed on mousedown:before
   * can be overridden to do something different.
   * Scope of this implementation is: verify the object is already selected when mousing down
   */
  _mouseDownHandlerBefore: function(options) {
    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
      return;
    }
    // we want to avoid that an object that was selected and then becomes unselectable,
    // may trigger editing mode in some way.
    this.selected = this === this.canvas._activeObject;
  },

  /**
   * Initializes "mousedown" event handler
   */
  initMousedownHandler: function() {
    this.on('mousedown', this._mouseDownHandler);
    this.on('mousedown:before', this._mouseDownHandlerBefore);
  },

  /**
   * Initializes "mouseup" event handler
   */
  initMouseupHandler: function() {
    this.on('mouseup', this.mouseUpHandler);
  },

  /**
   * standard hander for mouse up, overridable
   * @private
   */
  mouseUpHandler: function(options) {
    this.__isMousedown = false;
    if (!this.editable || this.group ||
      (options.transform && options.transform.actionPerformed) ||
      (options.e.button && options.e.button !== 1)) {
      return;
    }

    if (this.canvas) {
      var currentActive = this.canvas._activeObject;
      if (currentActive && currentActive !== this) {
        // avoid running this logic when there is an active object
        // this because is possible with shift click and fast clicks,
        // to rapidly deselect and reselect this object and trigger an enterEdit
        return;
      }
    }

    if (this.__lastSelected && !this.__corner) {
      this.selected = false;
      this.__lastSelected = false;
      this.enterEditing(options.e);
      if (this.selectionStart === this.selectionEnd) {
        this.initDelayedCursor(true);
      }
      else {
        this.renderCursorOrSelection();
      }
    }
    else {
      this.selected = true;
    }
  },

  /**
   * Changes cursor location in a text depending on passed pointer (x/y) object
   * @param {Event} e Event object
   */
  setCursorByClick: function(e) {
    var newSelection = this.getSelectionStartFromPointer(e),
        start = this.selectionStart, end = this.selectionEnd;
    if (e.shiftKey) {
      this.setSelectionStartEndWithShift(start, end, newSelection);
    }
    else {
      this.selectionStart = newSelection;
      this.selectionEnd = newSelection;
    }
    if (this.isEditing) {
      this._fireSelectionChanged();
      this._updateTextarea();
    }
  },

  /**
   * Returns index of a character corresponding to where an object was clicked
   * @param {Event} e Event object
   * @return {Number} Index of a character
   */
  getSelectionStartFromPointer: function(e) {
    var mouseOffset = this.getLocalPointer(e),
        prevWidth = 0,
        width = 0,
        height = 0,
        charIndex = 0,
        lineIndex = 0,
        lineLeftOffset,
        line;

    for (var i = 0, len = this._textLines.length; i < len; i++) {
      if (height <= mouseOffset.y) {
        height += this.getHeightOfLine(i) * this.scaleY;
        lineIndex = i;
        if (i > 0) {
          charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
        }
      }
      else {
        break;
      }
    }
    lineLeftOffset = this._getLineLeftOffset(lineIndex);
    width = lineLeftOffset * this.scaleX;
    line = this._textLines[lineIndex];
    for (var j = 0, jlen = line.length; j < jlen; j++) {
      prevWidth = width;
      // i removed something about flipX here, check.
      width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;
      if (width <= mouseOffset.x) {
        charIndex++;
      }
      else {
        break;
      }
    }
    return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
  },

  /**
   * @private
   */
  _getNewSelectionStartFromOffset: function(mouseOffset, prevWidth, width, index, jlen) {
    // we need Math.abs because when width is after the last char, the offset is given as 1, while is 0
    var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth,
        distanceBtwNextCharAndCursor = width - mouseOffset.x,
        offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor ||
          distanceBtwNextCharAndCursor < 0 ? 0 : 1,
        newSelectionStart = index + offset;
    // if object is horizontally flipped, mirror cursor location from the end
    if (this.flipX) {
      newSelectionStart = jlen - newSelectionStart;
    }

    if (newSelectionStart > this._text.length) {
      newSelectionStart = this._text.length;
    }

    return newSelectionStart;
  }
});


fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {

  /**
   * Initializes hidden textarea (needed to bring up keyboard in iOS)
   */
  initHiddenTextarea: function() {
    this.hiddenTextarea = fabric.document.createElement('textarea');
    this.hiddenTextarea.setAttribute('autocapitalize', 'off');
    this.hiddenTextarea.setAttribute('autocorrect', 'off');
    this.hiddenTextarea.setAttribute('autocomplete', 'off');
    this.hiddenTextarea.setAttribute('spellcheck', 'false');
    this.hiddenTextarea.setAttribute('data-fabric-hiddentextarea', '');
    this.hiddenTextarea.setAttribute('wrap', 'off');
    var style = this._calcTextareaPosition();
    // line-height: 1px; was removed from the style to fix this:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
    this.hiddenTextarea.style.cssText = 'position: absolute; top: ' + style.top +
    '; left: ' + style.left + '; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;' +
    ' paddingｰtop: ' + style.fontSize + ';';
    fabric.document.body.appendChild(this.hiddenTextarea);

    fabric.util.addListener(this.hiddenTextarea, 'keydown', this.onKeyDown.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'keyup', this.onKeyUp.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'input', this.onInput.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'copy', this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'cut', this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'paste', this.paste.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionstart', this.onCompositionStart.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionupdate', this.onCompositionUpdate.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionend', this.onCompositionEnd.bind(this));

    if (!this._clickHandlerInitialized && this.canvas) {
      fabric.util.addListener(this.canvas.upperCanvasEl, 'click', this.onClick.bind(this));
      this._clickHandlerInitialized = true;
    }
  },

  /**
   * For functionalities on keyDown
   * Map a special key to a function of the instance/prototype
   * If you need different behaviour for ESC or TAB or arrows, you have to change
   * this map setting the name of a function that you build on the fabric.Itext or
   * your prototype.
   * the map change will affect all Instances unless you need for only some text Instances
   * in that case you have to clone this object and assign your Instance.
   * this.keysMap = fabric.util.object.clone(this.keysMap);
   * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
   */
  keysMap: {
    9:  'exitEditing',
    27: 'exitEditing',
    33: 'moveCursorUp',
    34: 'moveCursorDown',
    35: 'moveCursorRight',
    36: 'moveCursorLeft',
    37: 'moveCursorLeft',
    38: 'moveCursorUp',
    39: 'moveCursorRight',
    40: 'moveCursorDown',
  },

  /**
   * For functionalities on keyUp + ctrl || cmd
   */
  ctrlKeysMapUp: {
    67: 'copy',
    88: 'cut'
  },

  /**
   * For functionalities on keyDown + ctrl || cmd
   */
  ctrlKeysMapDown: {
    65: 'selectAll'
  },

  onClick: function() {
    // No need to trigger click event here, focus is enough to have the keyboard appear on Android
    this.hiddenTextarea && this.hiddenTextarea.focus();
  },

  /**
   * Handles keyup event
   * @param {Event} e Event object
   */
  onKeyDown: function(e) {
    if (!this.isEditing || this.inCompositionMode) {
      return;
    }
    if (e.keyCode in this.keysMap) {
      this[this.keysMap[e.keyCode]](e);
    }
    else if ((e.keyCode in this.ctrlKeysMapDown) && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapDown[e.keyCode]](e);
    }
    else {
      return;
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    if (e.keyCode >= 33 && e.keyCode <= 40) {
      // if i press an arrow key just update selection
      this.clearContextTop();
      this.renderCursorOrSelection();
    }
    else {
      this.canvas && this.canvas.requestRenderAll();
    }
  },

  /**
   * Handles keyup event
   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
   * if a copy/cut event fired, keyup is dismissed
   * @param {Event} e Event object
   */
  onKeyUp: function(e) {
    if (!this.isEditing || this._copyDone || this.inCompositionMode) {
      this._copyDone = false;
      return;
    }
    if ((e.keyCode in this.ctrlKeysMapUp) && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapUp[e.keyCode]](e);
    }
    else {
      return;
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    this.canvas && this.canvas.requestRenderAll();
  },

  /**
   * Handles onInput event
   * @param {Event} e Event object
   */
  onInput: function(e) {
    var fromPaste = this.fromPaste;
    this.fromPaste = false;
    e && e.stopPropagation();
    if (!this.isEditing) {
      return;
    }
    // decisions about style changes.
    var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText,
        charCount = this._text.length,
        nextCharCount = nextText.length,
        removedText, insertedText,
        charDiff = nextCharCount - charCount,
        selectionStart = this.selectionStart, selectionEnd = this.selectionEnd,
        selection = selectionStart !== selectionEnd,
        copiedStyle, removeFrom, removeTo;
    if (this.hiddenTextarea.value === '') {
      this.styles = { };
      this.updateFromTextArea();
      this.fire('changed');
      if (this.canvas) {
        this.canvas.fire('text:changed', { target: this });
        this.canvas.requestRenderAll();
      }
      return;
    }

    var textareaSelection = this.fromStringToGraphemeSelection(
      this.hiddenTextarea.selectionStart,
      this.hiddenTextarea.selectionEnd,
      this.hiddenTextarea.value
    );
    var backDelete = selectionStart > textareaSelection.selectionStart;

    if (selection) {
      removedText = this._text.slice(selectionStart, selectionEnd);
      charDiff += selectionEnd - selectionStart;
    }
    else if (nextCharCount < charCount) {
      if (backDelete) {
        removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
      }
      else {
        removedText = this._text.slice(selectionStart, selectionStart - charDiff);
      }
    }
    var copiedStyle;
    insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
    if (removedText && removedText.length) {
      if (insertedText.length) {
        // let's copy some style before deleting.
        // we want to copy the style before the cursor OR the style at the cursor if selection
        // is bigger than 0.
        copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, true);
        // now duplicate the style one for each inserted text.
        copiedStyle = insertedText.map(function() {
          // this return an array of references, but that is fine since we are
          // copying the style later.
          return copiedStyle[0];
        });
      }
      if (selection) {
        removeFrom = selectionStart;
        removeTo = selectionEnd;
      }
      else if (backDelete) {
        // detect differencies between forwardDelete and backDelete
        removeFrom = selectionEnd - removedText.length;
        removeTo = selectionEnd;
      }
      else {
        removeFrom = selectionEnd;
        removeTo = selectionEnd + removedText.length;
      }
      this.removeStyleFromTo(removeFrom, removeTo);
    }
    if (insertedText.length) {
      if (fromPaste && insertedText.join('') === fabric.copiedText && !fabric.disableStyleCopyPaste) {
        copiedStyle = fabric.copiedTextStyle;
      }
      this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
    }
    this.updateFromTextArea();
    this.fire('changed');
    if (this.canvas) {
      this.canvas.fire('text:changed', { target: this });
      this.canvas.requestRenderAll();
    }
  },
  /**
   * Composition start
   */
  onCompositionStart: function() {
    this.inCompositionMode = true;
  },

  /**
   * Composition end
   */
  onCompositionEnd: function() {
    this.inCompositionMode = false;
  },

  // /**
  //  * Composition update
  //  */
  onCompositionUpdate: function(e) {
    this.compositionStart = e.target.selectionStart;
    this.compositionEnd = e.target.selectionEnd;
    this.updateTextareaPosition();
  },

  /**
   * Copies selected text
   * @param {Event} e Event object
   */
  copy: function() {
    if (this.selectionStart === this.selectionEnd) {
      //do not cut-copy if no selection
      return;
    }

    fabric.copiedText = this.getSelectedText();
    if (!fabric.disableStyleCopyPaste) {
      fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
    }
    else {
      fabric.copiedTextStyle = null;
    }
    this._copyDone = true;
  },

  /**
   * Pastes text
   * @param {Event} e Event object
   */
  paste: function() {
    this.fromPaste = true;
  },

  /**
   * @private
   * @param {Event} e Event object
   * @return {Object} Clipboard data object
   */
  _getClipboardData: function(e) {
    return (e && e.clipboardData) || fabric.window.clipboardData;
  },

  /**
   * Finds the width in pixels before the cursor on the same line
   * @private
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {Number} widthBeforeCursor width before cursor
   */
  _getWidthBeforeCursor: function(lineIndex, charIndex) {
    var widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;

    if (charIndex > 0) {
      bound = this.__charBounds[lineIndex][charIndex - 1];
      widthBeforeCursor += bound.left + bound.width;
    }
    return widthBeforeCursor;
  },

  /**
   * Gets start offset of a selection
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  getDownCursorOffset: function(e, isRight) {
    var selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex;
    // if on last line, down cursor goes to end of line
    if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) {
      // move to the end of a text
      return this._text.length - selectionProp;
    }
    var charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor),
        textAfterCursor = this._textLines[lineIndex].slice(charIndex);
    return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
  },

  /**
   * private
   * Helps finding if the offset should be counted from Start or End
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  _getSelectionForOffset: function(e, isRight) {
    if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) {
      return this.selectionEnd;
    }
    else {
      return this.selectionStart;
    }
  },

  /**
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  getUpCursorOffset: function(e, isRight) {
    var selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex;
    if (lineIndex === 0 || e.metaKey || e.keyCode === 33) {
      // if on first line, up cursor goes to start of line
      return -selectionProp;
    }
    var charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor),
        textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex),
        missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
    // return a negative offset
    return -this._textLines[lineIndex - 1].length
     + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
  },

  /**
   * for a given width it founds the matching character.
   * @private
   */
  _getIndexOnLine: function(lineIndex, width) {

    var line = this._textLines[lineIndex],
        lineLeftOffset = this._getLineLeftOffset(lineIndex),
        widthOfCharsOnLine = lineLeftOffset,
        indexOnLine = 0, charWidth, foundMatch;

    for (var j = 0, jlen = line.length; j < jlen; j++) {
      charWidth = this.__charBounds[lineIndex][j].width;
      widthOfCharsOnLine += charWidth;
      if (widthOfCharsOnLine > width) {
        foundMatch = true;
        var leftEdge = widthOfCharsOnLine - charWidth,
            rightEdge = widthOfCharsOnLine,
            offsetFromLeftEdge = Math.abs(leftEdge - width),
            offsetFromRightEdge = Math.abs(rightEdge - width);

        indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : (j - 1);
        break;
      }
    }

    // reached end
    if (!foundMatch) {
      indexOnLine = line.length - 1;
    }

    return indexOnLine;
  },


  /**
   * Moves cursor down
   * @param {Event} e Event object
   */
  moveCursorDown: function(e) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }
    this._moveCursorUpOrDown('Down', e);
  },

  /**
   * Moves cursor up
   * @param {Event} e Event object
   */
  moveCursorUp: function(e) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }
    this._moveCursorUpOrDown('Up', e);
  },

  /**
   * Moves cursor up or down, fires the events
   * @param {String} direction 'Up' or 'Down'
   * @param {Event} e Event object
   */
  _moveCursorUpOrDown: function(direction, e) {
    // getUpCursorOffset
    // getDownCursorOffset
    var action = 'get' + direction + 'CursorOffset',
        offset = this[action](e, this._selectionDirection === 'right');
    if (e.shiftKey) {
      this.moveCursorWithShift(offset);
    }
    else {
      this.moveCursorWithoutShift(offset);
    }
    if (offset !== 0) {
      this.setSelectionInBoundaries();
      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this.initDelayedCursor();
      this._fireSelectionChanged();
      this._updateTextarea();
    }
  },

  /**
   * Moves cursor with shift
   * @param {Number} offset
   */
  moveCursorWithShift: function(offset) {
    var newSelection = this._selectionDirection === 'left'
      ? this.selectionStart + offset
      : this.selectionEnd + offset;
    this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
    return offset !== 0;
  },

  /**
   * Moves cursor up without shift
   * @param {Number} offset
   */
  moveCursorWithoutShift: function(offset) {
    if (offset < 0) {
      this.selectionStart += offset;
      this.selectionEnd = this.selectionStart;
    }
    else {
      this.selectionEnd += offset;
      this.selectionStart = this.selectionEnd;
    }
    return offset !== 0;
  },

  /**
   * Moves cursor left
   * @param {Event} e Event object
   */
  moveCursorLeft: function(e) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }
    this._moveCursorLeftOrRight('Left', e);
  },

  /**
   * @private
   * @return {Boolean} true if a change happened
   */
  _move: function(e, prop, direction) {
    var newValue;
    if (e.altKey) {
      newValue = this['findWordBoundary' + direction](this[prop]);
    }
    else if (e.metaKey || e.keyCode === 35 ||  e.keyCode === 36 ) {
      newValue = this['findLineBoundary' + direction](this[prop]);
    }
    else {
      this[prop] += direction === 'Left' ? -1 : 1;
      return true;
    }
    if (typeof newValue !== undefined && this[prop] !== newValue) {
      this[prop] = newValue;
      return true;
    }
  },

  /**
   * @private
   */
  _moveLeft: function(e, prop) {
    return this._move(e, prop, 'Left');
  },

  /**
   * @private
   */
  _moveRight: function(e, prop) {
    return this._move(e, prop, 'Right');
  },

  /**
   * Moves cursor left without keeping selection
   * @param {Event} e
   */
  moveCursorLeftWithoutShift: function(e) {
    var change = true;
    this._selectionDirection = 'left';

    // only move cursor when there is no selection,
    // otherwise we discard it, and leave cursor on same place
    if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
      change = this._moveLeft(e, 'selectionStart');

    }
    this.selectionEnd = this.selectionStart;
    return change;
  },

  /**
   * Moves cursor left while keeping selection
   * @param {Event} e
   */
  moveCursorLeftWithShift: function(e) {
    if (this._selectionDirection === 'right' && this.selectionStart !== this.selectionEnd) {
      return this._moveLeft(e, 'selectionEnd');
    }
    else if (this.selectionStart !== 0){
      this._selectionDirection = 'left';
      return this._moveLeft(e, 'selectionStart');
    }
  },

  /**
   * Moves cursor right
   * @param {Event} e Event object
   */
  moveCursorRight: function(e) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }
    this._moveCursorLeftOrRight('Right', e);
  },

  /**
   * Moves cursor right or Left, fires event
   * @param {String} direction 'Left', 'Right'
   * @param {Event} e Event object
   */
  _moveCursorLeftOrRight: function(direction, e) {
    var actionName = 'moveCursor' + direction + 'With';
    this._currentCursorOpacity = 1;

    if (e.shiftKey) {
      actionName += 'Shift';
    }
    else {
      actionName += 'outShift';
    }
    if (this[actionName](e)) {
      this.abortCursorAnimation();
      this.initDelayedCursor();
      this._fireSelectionChanged();
      this._updateTextarea();
    }
  },

  /**
   * Moves cursor right while keeping selection
   * @param {Event} e
   */
  moveCursorRightWithShift: function(e) {
    if (this._selectionDirection === 'left' && this.selectionStart !== this.selectionEnd) {
      return this._moveRight(e, 'selectionStart');
    }
    else if (this.selectionEnd !== this._text.length) {
      this._selectionDirection = 'right';
      return this._moveRight(e, 'selectionEnd');
    }
  },

  /**
   * Moves cursor right without keeping selection
   * @param {Event} e Event object
   */
  moveCursorRightWithoutShift: function(e) {
    var changed = true;
    this._selectionDirection = 'right';

    if (this.selectionStart === this.selectionEnd) {
      changed = this._moveRight(e, 'selectionStart');
      this.selectionEnd = this.selectionStart;
    }
    else {
      this.selectionStart = this.selectionEnd;
    }
    return changed;
  },

  /**
   * Removes characters from start/end
   * start/end ar per grapheme position in _text array.
   *
   * @param {Number} start
   * @param {Number} end default to start + 1
   */
  removeChars: function(start, end) {
    if (typeof end === 'undefined') {
      end = start + 1;
    }
    this.removeStyleFromTo(start, end);
    this._text.splice(start, end - start);
    this.text = this._text.join('');
    this.set('dirty', true);
    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }
    this._removeExtraneousStyles();
  },

  /**
   * insert characters at start position, before start position.
   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
   * if style array is provided, it must be as the same length of text in graphemes
   * if end is provided and is bigger than start, old text is replaced.
   * start/end ar per grapheme position in _text array.
   *
   * @param {String} text text to insert
   * @param {Array} style array of style objects
   * @param {Number} start
   * @param {Number} end default to start + 1
   */
  insertChars: function(text, style, start, end) {
    if (typeof end === 'undefined') {
      end = start;
    }
    if (end > start) {
      this.removeStyleFromTo(start, end);
    }
    var graphemes = fabric.util.string.graphemeSplit(text);
    this.insertNewStyleBlock(graphemes, start, style);
    this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
    this.text = this._text.join('');
    this.set('dirty', true);
    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }
    this._removeExtraneousStyles();
  },

});


/* _TO_SVG_START_ */
(function() {
  var toFixed = fabric.util.toFixed,
      multipleSpacesRegex = /  +/g;

  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {

    /**
     * Returns SVG representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    _toSVG: function() {
      var offsets = this._getSVGLeftTopOffsets(),
          textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
      return this._wrapSVGTextAndBg(textAndBg);
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function(reviver) {
      return this._createBaseSVGMarkup(
        this._toSVG(),
        { reviver: reviver, noStyle: true, withShadow: true }
      );
    },

    /**
     * @private
     */
    _getSVGLeftTopOffsets: function() {
      return {
        textLeft: -this.width / 2,
        textTop: -this.height / 2,
        lineTop: this.getHeightOfLine(0)
      };
    },

    /**
     * @private
     */
    _wrapSVGTextAndBg: function(textAndBg) {
      var noShadow = true,
          textDecoration = this.getSvgTextDecoration(this);
      return [
        textAndBg.textBgRects.join(''),
        '\t\t<text xml:space="preserve" ',
        (this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, '\'') + '" ' : ''),
        (this.fontSize ? 'font-size="' + this.fontSize + '" ' : ''),
        (this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : ''),
        (this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : ''),
        (textDecoration ? 'text-decoration="' + textDecoration + '" ' : ''),
        'style="', this.getSvgStyles(noShadow), '"', this.addPaintOrder(), ' >',
        textAndBg.textSpans.join(''),
        '</text>\n'
      ];
    },

    /**
     * @private
     * @param {Number} textTopOffset Text top offset
     * @param {Number} textLeftOffset Text left offset
     * @return {Object}
     */
    _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
      var textSpans = [],
          textBgRects = [],
          height = textTopOffset, lineOffset;
      // bounding-box background
      this._setSVGBg(textBgRects);

      // text and text-background
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        lineOffset = this._getLineLeftOffset(i);
        if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) {
          this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
        }
        this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
        height += this.getHeightOfLine(i);
      }

      return {
        textSpans: textSpans,
        textBgRects: textBgRects
      };
    },

    /**
     * @private
     */
    _createTextCharSpan: function(_char, styleDecl, left, top) {
      var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex),
          styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace),
          fillStyles = styleProps ? 'style="' + styleProps + '"' : '',
          dy = styleDecl.deltaY, dySpan = '',
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
      if (dy) {
        dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
      }
      return [
        '<tspan x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="',
        toFixed(top, NUM_FRACTION_DIGITS), '" ', dySpan,
        fillStyles, '>',
        fabric.util.string.escapeXml(_char),
        '</tspan>'
      ].join('');
    },

    _setSVGTextLineText: function(textSpans, lineIndex, textLeftOffset, textTopOffset) {
      // set proper line offset
      var lineHeight = this.getHeightOfLine(lineIndex),
          isJustify = this.textAlign.indexOf('justify') !== -1,
          actualStyle,
          nextStyle,
          charsToRender = '',
          charBox, style,
          boxWidth = 0,
          line = this._textLines[lineIndex],
          timeToRender;

      textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
      for (var i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];
        if (boxWidth === 0) {
          textLeftOffset += charBox.kernedWidth - charBox.width;
          boxWidth += charBox.width;
        }
        else {
          boxWidth += charBox.kernedWidth;
        }
        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }
        if (!timeToRender) {
          // if we have charSpacing, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = this._hasStyleChangedForSvg(actualStyle, nextStyle);
        }
        if (timeToRender) {
          style = this._getStyleDeclaration(lineIndex, i) || { };
          textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
          charsToRender = '';
          actualStyle = nextStyle;
          textLeftOffset += boxWidth;
          boxWidth = 0;
        }
      }
    },

    _pushTextBgRect: function(textBgRects, color, left, top, width, height) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
      textBgRects.push(
        '\t\t<rect ',
        this._getFillAttributes(color),
        ' x="',
        toFixed(left, NUM_FRACTION_DIGITS),
        '" y="',
        toFixed(top, NUM_FRACTION_DIGITS),
        '" width="',
        toFixed(width, NUM_FRACTION_DIGITS),
        '" height="',
        toFixed(height, NUM_FRACTION_DIGITS),
        '"></rect>\n');
    },

    _setSVGTextLineBg: function(textBgRects, i, leftOffset, textTopOffset) {
      var line = this._textLines[i],
          heightOfLine = this.getHeightOfLine(i) / this.lineHeight,
          boxWidth = 0,
          boxStart = 0,
          charBox, currentColor,
          lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
      for (var j = 0, jlen = line.length; j < jlen; j++) {
        charBox = this.__charBounds[i][j];
        currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
        if (currentColor !== lastColor) {
          lastColor && this._pushTextBgRect(textBgRects, lastColor, leftOffset + boxStart,
            textTopOffset, boxWidth, heightOfLine);
          boxStart = charBox.left;
          boxWidth = charBox.width;
          lastColor = currentColor;
        }
        else {
          boxWidth += charBox.kernedWidth;
        }
      }
      currentColor && this._pushTextBgRect(textBgRects, currentColor, leftOffset + boxStart,
        textTopOffset, boxWidth, heightOfLine);
    },

    /**
     * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
     * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
     *
     * @private
     * @param {*} value
     * @return {String}
     */
    _getFillAttributes: function(value) {
      var fillColor = (value && typeof value === 'string') ? new fabric.Color(value) : '';
      if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) {
        return 'fill="' + value + '"';
      }
      return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
    },

    /**
     * @private
     */
    _getSVGLineTopOffset: function(lineIndex) {
      var lineTopOffset = 0, lastHeight = 0;
      for (var j = 0; j < lineIndex; j++) {
        lineTopOffset += this.getHeightOfLine(j);
      }
      lastHeight = this.getHeightOfLine(j);
      return {
        lineTop: lineTopOffset,
        offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
      };
    },

    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles: function(skipShadow) {
      var svgStyle = fabric.Object.prototype.getSvgStyles.call(this, skipShadow);
      return svgStyle + ' white-space: pre;';
    },
  });
})();
/* _TO_SVG_END_ */


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = {});

  /**
   * Textbox class, based on IText, allows the user to resize the text rectangle
   * and wraps lines automatically. Textboxes have their Y scaling locked, the
   * user can only change width. Height is adjusted automatically based on the
   * wrapping of lines.
   * @class fabric.Textbox
   * @extends fabric.IText
   * @mixes fabric.Observable
   * @return {fabric.Textbox} thisArg
   * @see {@link fabric.Textbox#initialize} for constructor definition
   */
  fabric.Textbox = fabric.util.createClass(fabric.IText, fabric.Observable, {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'textbox',

    /**
     * Minimum width of textbox, in pixels.
     * @type Number
     * @default
     */
    minWidth: 20,

    /**
     * Minimum calculated width of a textbox, in pixels.
     * fixed to 2 so that an empty textbox cannot go to 0
     * and is still selectable without text.
     * @type Number
     * @default
     */
    dynamicMinWidth: 2,

    /**
     * Cached array of text wrapping.
     * @type Array
     */
    __cachedLines: null,

    /**
     * Override standard Object class values
     */
    lockScalingFlip: true,

    /**
     * Override standard Object class values
     * Textbox needs this on false
     */
    noScaleCache: false,

    /**
     * Properties which when set cause object to change dimensions
     * @type Object
     * @private
     */
    _dimensionAffectingProps: fabric.Text.prototype._dimensionAffectingProps.concat('width'),

    /**
     * Use this regular expression to split strings in breakable lines
     * @private
     */
    _wordJoiners: /[ \t\r]/,

    /**
     * Use this boolean property in order to split strings that have no white space concept.
     * this is a cheap way to help with chinese/japaense
     * @type Boolean
     * @since 2.6.0
     */
    splitByGrapheme: false,

    /**
     * Unlike superclass's version of this function, Textbox does not update
     * its width.
     * @private
     * @override
     */
    initDimensions: function() {
      if (this.__skipDimension) {
        return;
      }
      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();
      this._clearCache();
      // clear dynamicMinWidth as it will be different after we re-wrap line
      this.dynamicMinWidth = 0;
      // wrap lines
      this._styleMap = this._generateStyleMap(this._splitText());
      // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
      if (this.dynamicMinWidth > this.width) {
        this._set('width', this.dynamicMinWidth);
      }
      if (this.textAlign.indexOf('justify') !== -1) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      }
      // clear cache and re-calculate height
      this.height = this.calcTextHeight();
      this.saveState({ propertySet: '_dimensionAffectingProps' });
    },

    /**
     * Generate an object that translates the style object so that it is
     * broken up by visual lines (new lines and automatic wrapping).
     * The original text styles object is broken up by actual lines (new lines only),
     * which is only sufficient for Text / IText
     * @private
     */
    _generateStyleMap: function(textInfo) {
      var realLineCount     = 0,
          realLineCharCount = 0,
          charCount         = 0,
          map               = {};

      for (var i = 0; i < textInfo.graphemeLines.length; i++) {
        if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
          realLineCharCount = 0;
          charCount++;
          realLineCount++;
        }
        else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
          // this case deals with space's that are removed from end of lines when wrapping
          realLineCharCount++;
          charCount++;
        }

        map[i] = { line: realLineCount, offset: realLineCharCount };

        charCount += textInfo.graphemeLines[i].length;
        realLineCharCount += textInfo.graphemeLines[i].length;
      }

      return map;
    },

    /**
     * Returns true if object has a style property or has it on a specified line
     * @param {Number} lineIndex
     * @return {Boolean}
     */
    styleHas: function(property, lineIndex) {
      if (this._styleMap && !this.isWrapping) {
        var map = this._styleMap[lineIndex];
        if (map) {
          lineIndex = map.line;
        }
      }
      return fabric.Text.prototype.styleHas.call(this, property, lineIndex);
    },

    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles: function(lineIndex) {
      if (!this.styles) {
        return true;
      }
      var offset = 0, nextLineIndex = lineIndex + 1, nextOffset, obj, shouldLimit = false,
          map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
      if (map) {
        lineIndex = map.line;
        offset = map.offset;
      }
      if (mapNextLine) {
        nextLineIndex = mapNextLine.line;
        shouldLimit = nextLineIndex === lineIndex;
        nextOffset = mapNextLine.offset;
      }
      obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
      for (var p1 in obj) {
        for (var p2 in obj[p1]) {
          if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
            // eslint-disable-next-line no-unused-vars
            for (var p3 in obj[p1][p2]) {
              return false;
            }
          }
        }
      }
      return true;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _getStyleDeclaration: function(lineIndex, charIndex) {
      if (this._styleMap && !this.isWrapping) {
        var map = this._styleMap[lineIndex];
        if (!map) {
          return null;
        }
        lineIndex = map.line;
        charIndex = map.offset + charIndex;
      }
      return this.callSuper('_getStyleDeclaration', lineIndex, charIndex);
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration: function(lineIndex, charIndex, style) {
      var map = this._styleMap[lineIndex];
      lineIndex = map.line;
      charIndex = map.offset + charIndex;

      this.styles[lineIndex][charIndex] = style;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration: function(lineIndex, charIndex) {
      var map = this._styleMap[lineIndex];
      lineIndex = map.line;
      charIndex = map.offset + charIndex;
      delete this.styles[lineIndex][charIndex];
    },

    /**
     * probably broken need a fix
     * Returns the real style line that correspond to the wrapped lineIndex line
     * Used just to verify if the line does exist or not.
     * @param {Number} lineIndex
     * @returns {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle: function(lineIndex) {
      var map = this._styleMap[lineIndex];
      return !!this.styles[map.line];
    },

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @param {Object} style
     * @private
     */
    _setLineStyle: function(lineIndex) {
      var map = this._styleMap[lineIndex];
      this.styles[map.line] = {};
    },

    /**
     * Wraps text using the 'width' property of Textbox. First this function
     * splits text on newlines, so we preserve newlines entered by the user.
     * Then it wraps each line using the width of the Textbox by calling
     * _wrapLine().
     * @param {Array} lines The string array of text that is split into lines
     * @param {Number} desiredWidth width you want to wrap to
     * @returns {Array} Array of lines
     */
    _wrapText: function(lines, desiredWidth) {
      var wrapped = [], i;
      this.isWrapping = true;
      for (i = 0; i < lines.length; i++) {
        wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
      }
      this.isWrapping = false;
      return wrapped;
    },

    /**
     * Helper function to measure a string of text, given its lineIndex and charIndex offset
     * it gets called when charBounds are not available yet.
     * @param {CanvasRenderingContext2D} ctx
     * @param {String} text
     * @param {number} lineIndex
     * @param {number} charOffset
     * @returns {number}
     * @private
     */
    _measureWord: function(word, lineIndex, charOffset) {
      var width = 0, prevGrapheme, skipLeft = true;
      charOffset = charOffset || 0;
      for (var i = 0, len = word.length; i < len; i++) {
        var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
        width += box.kernedWidth;
        prevGrapheme = word[i];
      }
      return width;
    },

    /**
     * Wraps a line of text using the width of the Textbox and a context.
     * @param {Array} line The grapheme array that represent the line
     * @param {Number} lineIndex
     * @param {Number} desiredWidth width you want to wrap the line to
     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
     * @returns {Array} Array of line(s) into which the given text is wrapped
     * to.
     */
    _wrapLine: function(_line, lineIndex, desiredWidth, reservedSpace) {
      var lineWidth = 0,
          splitByGrapheme = this.splitByGrapheme,
          graphemeLines = [],
          line = [],
          // spaces in different languges?
          words = splitByGrapheme ? fabric.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners),
          word = '',
          offset = 0,
          infix = splitByGrapheme ? '' : ' ',
          wordWidth = 0,
          infixWidth = 0,
          largestWordWidth = 0,
          lineJustStarted = true,
          additionalSpace = splitByGrapheme ? 0 : this._getWidthOfCharSpacing(),
          reservedSpace = reservedSpace || 0;
      // fix a difference between split and graphemeSplit
      if (words.length === 0) {
        words.push([]);
      }
      desiredWidth -= reservedSpace;
      for (var i = 0; i < words.length; i++) {
        // if using splitByGrapheme words are already in graphemes.
        word = splitByGrapheme ? words[i] : fabric.util.string.graphemeSplit(words[i]);
        wordWidth = this._measureWord(word, lineIndex, offset);
        offset += word.length;

        lineWidth += infixWidth + wordWidth - additionalSpace;

        if (lineWidth >= desiredWidth && !lineJustStarted) {
          graphemeLines.push(line);
          line = [];
          lineWidth = wordWidth;
          lineJustStarted = true;
        }
        else {
          lineWidth += additionalSpace;
        }

        if (!lineJustStarted && !splitByGrapheme) {
          line.push(infix);
        }
        line = line.concat(word);

        infixWidth = this._measureWord([infix], lineIndex, offset);
        offset++;
        lineJustStarted = false;
        // keep track of largest word
        if (wordWidth > largestWordWidth) {
          largestWordWidth = wordWidth;
        }
      }

      i && graphemeLines.push(line);

      if (largestWordWidth + reservedSpace > this.dynamicMinWidth) {
        this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
      }

      return graphemeLines;
    },

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @param {Number} lineIndex text to split
     * @return {Boolean}
     */
    isEndOfWrapping: function(lineIndex) {
      if (!this._styleMap[lineIndex + 1]) {
        // is last line, return true;
        return true;
      }
      if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) {
        // this is last line before a line break, return true;
        return true;
      }
      return false;
    },

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * @return Number
     */
    missingNewlineOffset: function(lineIndex) {
      if (this.splitByGrapheme) {
        return this.isEndOfWrapping(lineIndex) ? 1 : 0;
      }
      return 1;
    },

    /**
    * Gets lines of text to render in the Textbox. This function calculates
    * text wrapping on the fly every time it is called.
    * @param {String} text text to split
    * @returns {Array} Array of lines in the Textbox.
    * @override
    */
    _splitTextIntoLines: function(text) {
      var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text),
          graphemeLines = this._wrapText(newText.lines, this.width),
          lines = new Array(graphemeLines.length);
      for (var i = 0; i < graphemeLines.length; i++) {
        lines[i] = graphemeLines[i].join('');
      }
      newText.lines = lines;
      newText.graphemeLines = graphemeLines;
      return newText;
    },

    getMinWidth: function() {
      return Math.max(this.minWidth, this.dynamicMinWidth);
    },

    _removeExtraneousStyles: function() {
      var linesToKeep = {};
      for (var prop in this._styleMap) {
        if (this._textLines[prop]) {
          linesToKeep[this._styleMap[prop].line] = 1;
        }
      }
      for (var prop in this.styles) {
        if (!linesToKeep[prop]) {
          delete this.styles[prop];
        }
      }
    },

    /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['minWidth', 'splitByGrapheme'].concat(propertiesToInclude));
    }
  });

  /**
   * Returns fabric.Textbox instance from an object representation
   * @static
   * @memberOf fabric.Textbox
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Textbox instance is created
   */
  fabric.Textbox.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Textbox', object, callback, 'text');
  };
})(typeof exports !== 'undefined' ? exports : this);


}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":6,"jsdom":5,"jsdom/lib/jsdom/living/generated/utils":5,"jsdom/lib/jsdom/utils":5}],8:[function(require,module,exports){
/*
Axis Labels Plugin for flot.
http://github.com/markrcote/flot-axislabels

Original code is Copyright (c) 2010 Xuan Luo.
Original code was released under the GPLv3 license by Xuan Luo, September 2010.
Original code was rereleased under the MIT license by Xuan Luo, April 2012.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

(function ($) {
    var options = {
      axisLabels: {
        show: true
      }
    };

    function canvasSupported() {
        return !!document.createElement('canvas').getContext;
    }

    function canvasTextSupported() {
        if (!canvasSupported()) {
            return false;
        }
        var dummy_canvas = document.createElement('canvas');
        var context = dummy_canvas.getContext('2d');
        return typeof context.fillText == 'function';
    }

    function css3TransitionSupported() {
        var div = document.createElement('div');
        return typeof div.style.MozTransition != 'undefined'    // Gecko
            || typeof div.style.OTransition != 'undefined'      // Opera
            || typeof div.style.webkitTransition != 'undefined' // WebKit
            || typeof div.style.transition != 'undefined';
    }


    function AxisLabel(axisName, position, padding, plot, opts) {
        this.axisName = axisName;
        this.position = position;
        this.padding = padding;
        this.plot = plot;
        this.opts = opts;
        this.width = 0;
        this.height = 0;
    }

    AxisLabel.prototype.cleanup = function() {
    };


    CanvasAxisLabel.prototype = new AxisLabel();
    CanvasAxisLabel.prototype.constructor = CanvasAxisLabel;
    function CanvasAxisLabel(axisName, position, padding, plot, opts) {
        AxisLabel.prototype.constructor.call(this, axisName, position, padding,
                                             plot, opts);
    }

    CanvasAxisLabel.prototype.calculateSize = function() {
        if (!this.opts.axisLabelFontSizePixels)
            this.opts.axisLabelFontSizePixels = 14;
        if (!this.opts.axisLabelFontFamily)
            this.opts.axisLabelFontFamily = 'sans-serif';

        var textWidth = this.opts.axisLabelFontSizePixels + this.padding;
        var textHeight = this.opts.axisLabelFontSizePixels + this.padding;
        if (this.position == 'left' || this.position == 'right') {
            this.width = this.opts.axisLabelFontSizePixels + this.padding;
            this.height = 0;
        } else {
            this.width = 0;
            this.height = this.opts.axisLabelFontSizePixels + this.padding;
        }
    };

    CanvasAxisLabel.prototype.draw = function(box) {
        if (!this.opts.axisLabelColour)
            this.opts.axisLabelColour = 'black';
        var ctx = this.plot.getCanvas().getContext('2d');
        ctx.save();
        ctx.font = this.opts.axisLabelFontSizePixels + 'px ' +
            this.opts.axisLabelFontFamily;
        ctx.fillStyle = this.opts.axisLabelColour;
        var width = ctx.measureText(this.opts.axisLabel).width;
        var height = this.opts.axisLabelFontSizePixels;
        var x, y, angle = 0;
        if (this.position == 'top') {
            x = box.left + box.width/2 - width/2;
            y = box.top + height*0.72;
        } else if (this.position == 'bottom') {
            x = box.left + box.width/2 - width/2;
            y = box.top + box.height - height*0.72;
        } else if (this.position == 'left') {
            x = box.left + height*0.72;
            y = box.height/2 + box.top + width/2;
            angle = -Math.PI/2;
        } else if (this.position == 'right') {
            x = box.left + box.width - height*0.72;
            y = box.height/2 + box.top - width/2;
            angle = Math.PI/2;
        }
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(this.opts.axisLabel, 0, 0);
        ctx.restore();
    };


    HtmlAxisLabel.prototype = new AxisLabel();
    HtmlAxisLabel.prototype.constructor = HtmlAxisLabel;
    function HtmlAxisLabel(axisName, position, padding, plot, opts) {
        AxisLabel.prototype.constructor.call(this, axisName, position,
                                             padding, plot, opts);
        this.elem = null;
    }

    HtmlAxisLabel.prototype.calculateSize = function() {
        var elem = $('<div class="axisLabels" style="position:absolute;">' +
                     this.opts.axisLabel + '</div>');
        this.plot.getPlaceholder().append(elem);
        // store height and width of label itself, for use in draw()
        this.labelWidth = elem.outerWidth(true);
        this.labelHeight = elem.outerHeight(true);
        elem.remove();

        this.width = this.height = 0;
        if (this.position == 'left' || this.position == 'right') {
            this.width = this.labelWidth + this.padding;
        } else {
            this.height = this.labelHeight + this.padding;
        }
    };

    HtmlAxisLabel.prototype.cleanup = function() {
        if (this.elem) {
            this.elem.remove();
        }
    };

    HtmlAxisLabel.prototype.draw = function(box) {
        this.plot.getPlaceholder().find('#' + this.axisName + 'Label').remove();
        this.elem = $('<div id="' + this.axisName +
                      'Label" " class="axisLabels" style="position:absolute;">'
                      + this.opts.axisLabel + '</div>');
        this.plot.getPlaceholder().append(this.elem);
        if (this.position == 'top') {
            this.elem.css('left', box.left + box.width/2 - this.labelWidth/2 +
                          'px');
            this.elem.css('top', box.top + 'px');
        } else if (this.position == 'bottom') {
            this.elem.css('left', box.left + box.width/2 - this.labelWidth/2 +
                          'px');
            this.elem.css('top', box.top + box.height - this.labelHeight +
                          'px');
        } else if (this.position == 'left') {
            this.elem.css('top', box.top + box.height/2 - this.labelHeight/2 +
                          'px');
            this.elem.css('left', box.left + 'px');
        } else if (this.position == 'right') {
            this.elem.css('top', box.top + box.height/2 - this.labelHeight/2 +
                          'px');
            this.elem.css('left', box.left + box.width - this.labelWidth +
                          'px');
        }
    };


    CssTransformAxisLabel.prototype = new HtmlAxisLabel();
    CssTransformAxisLabel.prototype.constructor = CssTransformAxisLabel;
    function CssTransformAxisLabel(axisName, position, padding, plot, opts) {
        HtmlAxisLabel.prototype.constructor.call(this, axisName, position,
                                                 padding, plot, opts);
    }

    CssTransformAxisLabel.prototype.calculateSize = function() {
        HtmlAxisLabel.prototype.calculateSize.call(this);
        this.width = this.height = 0;
        if (this.position == 'left' || this.position == 'right') {
            this.width = this.labelHeight + this.padding;
        } else {
            this.height = this.labelHeight + this.padding;
        }
    };

    CssTransformAxisLabel.prototype.transforms = function(degrees, x, y) {
        var stransforms = {
            '-moz-transform': '',
            '-webkit-transform': '',
            '-o-transform': '',
            '-ms-transform': ''
        };
        if (x != 0 || y != 0) {
            var stdTranslate = ' translate(' + x + 'px, ' + y + 'px)';
            stransforms['-moz-transform'] += stdTranslate;
            stransforms['-webkit-transform'] += stdTranslate;
            stransforms['-o-transform'] += stdTranslate;
            stransforms['-ms-transform'] += stdTranslate;
        }
        if (degrees != 0) {
            var rotation = degrees / 90;
            var stdRotate = ' rotate(' + degrees + 'deg)';
            stransforms['-moz-transform'] += stdRotate;
            stransforms['-webkit-transform'] += stdRotate;
            stransforms['-o-transform'] += stdRotate;
            stransforms['-ms-transform'] += stdRotate;
        }
        var s = 'top: 0; left: 0; ';
        for (var prop in stransforms) {
            if (stransforms[prop]) {
                s += prop + ':' + stransforms[prop] + ';';
            }
        }
        s += ';';
        return s;
    };

    CssTransformAxisLabel.prototype.calculateOffsets = function(box) {
        var offsets = { x: 0, y: 0, degrees: 0 };
        if (this.position == 'bottom') {
            offsets.x = box.left + box.width/2 - this.labelWidth/2;
            offsets.y = box.top + box.height - this.labelHeight;
        } else if (this.position == 'top') {
            offsets.x = box.left + box.width/2 - this.labelWidth/2;
            offsets.y = box.top;
        } else if (this.position == 'left') {
            offsets.degrees = -90;
            offsets.x = box.left - this.labelWidth/2 + this.labelHeight/2;
            offsets.y = box.height/2 + box.top;
        } else if (this.position == 'right') {
            offsets.degrees = 90;
            offsets.x = box.left + box.width - this.labelWidth/2
                        - this.labelHeight/2;
            offsets.y = box.height/2 + box.top;
        }
        offsets.x = Math.round(offsets.x);
        offsets.y = Math.round(offsets.y);

        return offsets;
    };

    CssTransformAxisLabel.prototype.draw = function(box) {
        this.plot.getPlaceholder().find("." + this.axisName + "Label").remove();
        var offsets = this.calculateOffsets(box);
        this.elem = $('<div class="axisLabels ' + this.axisName +
                      'Label" style="position:absolute; ' +
                      this.transforms(offsets.degrees, offsets.x, offsets.y) +
                      '">' + this.opts.axisLabel + '</div>');
        this.plot.getPlaceholder().append(this.elem);
    };


    IeTransformAxisLabel.prototype = new CssTransformAxisLabel();
    IeTransformAxisLabel.prototype.constructor = IeTransformAxisLabel;
    function IeTransformAxisLabel(axisName, position, padding, plot, opts) {
        CssTransformAxisLabel.prototype.constructor.call(this, axisName,
                                                         position, padding,
                                                         plot, opts);
        this.requiresResize = false;
    }

    IeTransformAxisLabel.prototype.transforms = function(degrees, x, y) {
        // I didn't feel like learning the crazy Matrix stuff, so this uses
        // a combination of the rotation transform and CSS positioning.
        var s = '';
        if (degrees != 0) {
            var rotation = degrees/90;
            while (rotation < 0) {
                rotation += 4;
            }
            s += ' filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=' + rotation + '); ';
            // see below
            this.requiresResize = (this.position == 'right');
        }
        if (x != 0) {
            s += 'left: ' + x + 'px; ';
        }
        if (y != 0) {
            s += 'top: ' + y + 'px; ';
        }
        return s;
    };

    IeTransformAxisLabel.prototype.calculateOffsets = function(box) {
        var offsets = CssTransformAxisLabel.prototype.calculateOffsets.call(
                          this, box);
        // adjust some values to take into account differences between
        // CSS and IE rotations.
        if (this.position == 'top') {
            // FIXME: not sure why, but placing this exactly at the top causes
            // the top axis label to flip to the bottom...
            offsets.y = box.top + 1;
        } else if (this.position == 'left') {
            offsets.x = box.left;
            offsets.y = box.height/2 + box.top - this.labelWidth/2;
        } else if (this.position == 'right') {
            offsets.x = box.left + box.width - this.labelHeight;
            offsets.y = box.height/2 + box.top - this.labelWidth/2;
        }
        return offsets;
    };

    IeTransformAxisLabel.prototype.draw = function(box) {
        CssTransformAxisLabel.prototype.draw.call(this, box);
        if (this.requiresResize) {
            this.elem = this.plot.getPlaceholder().find("." + this.axisName +
                                                        "Label");
            // Since we used CSS positioning instead of transforms for
            // translating the element, and since the positioning is done
            // before any rotations, we have to reset the width and height
            // in case the browser wrapped the text (specifically for the
            // y2axis).
            this.elem.css('width', this.labelWidth);
            this.elem.css('height', this.labelHeight);
        }
    };


    function init(plot) {
        plot.hooks.processOptions.push(function (plot, options) {

            if (!options.axisLabels.show)
                return;

            // This is kind of a hack. There are no hooks in Flot between
            // the creation and measuring of the ticks (setTicks, measureTickLabels
            // in setupGrid() ) and the drawing of the ticks and plot box
            // (insertAxisLabels in setupGrid() ).
            //
            // Therefore, we use a trick where we run the draw routine twice:
            // the first time to get the tick measurements, so that we can change
            // them, and then have it draw it again.
            var secondPass = false;

            var axisLabels = {};
            var axisOffsetCounts = { left: 0, right: 0, top: 0, bottom: 0 };

            var defaultPadding = 2;  // padding between axis and tick labels
            plot.hooks.draw.push(function (plot, ctx) {
                var hasAxisLabels = false;
                if (!secondPass) {
                    // MEASURE AND SET OPTIONS
                    $.each(plot.getAxes(), function(axisName, axis) {
                        var opts = axis.options // Flot 0.7
                            || plot.getOptions()[axisName]; // Flot 0.6

                        // Handle redraws initiated outside of this plug-in.
                        if (axisName in axisLabels) {
                            axis.labelHeight = axis.labelHeight -
                                axisLabels[axisName].height;
                            axis.labelWidth = axis.labelWidth -
                                axisLabels[axisName].width;
                            opts.labelHeight = axis.labelHeight;
                            opts.labelWidth = axis.labelWidth;
                            axisLabels[axisName].cleanup();
                            delete axisLabels[axisName];
                        }

                        if (!opts || !opts.axisLabel || !axis.show)
                            return;

                        hasAxisLabels = true;
                        var renderer = null;

                        if (!opts.axisLabelUseHtml &&
                            navigator.appName == 'Microsoft Internet Explorer') {
                            var ua = navigator.userAgent;
                            var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                            if (re.exec(ua) != null) {
                                rv = parseFloat(RegExp.$1);
                            }
                            if (rv >= 9 && !opts.axisLabelUseCanvas && !opts.axisLabelUseHtml) {
                                renderer = CssTransformAxisLabel;
                            } else if (!opts.axisLabelUseCanvas && !opts.axisLabelUseHtml) {
                                renderer = IeTransformAxisLabel;
                            } else if (opts.axisLabelUseCanvas) {
                                renderer = CanvasAxisLabel;
                            } else {
                                renderer = HtmlAxisLabel;
                            }
                        } else {
                            if (opts.axisLabelUseHtml || (!css3TransitionSupported() && !canvasTextSupported()) && !opts.axisLabelUseCanvas) {
                                renderer = HtmlAxisLabel;
                            } else if (opts.axisLabelUseCanvas || !css3TransitionSupported()) {
                                renderer = CanvasAxisLabel;
                            } else {
                                renderer = CssTransformAxisLabel;
                            }
                        }

                        var padding = opts.axisLabelPadding === undefined ?
                                      defaultPadding : opts.axisLabelPadding;

                        axisLabels[axisName] = new renderer(axisName,
                                                            axis.position, padding,
                                                            plot, opts);

                        // flot interprets axis.labelHeight and .labelWidth as
                        // the height and width of the tick labels. We increase
                        // these values to make room for the axis label and
                        // padding.

                        axisLabels[axisName].calculateSize();

                        // AxisLabel.height and .width are the size of the
                        // axis label and padding.
                        // Just set opts here because axis will be sorted out on
                        // the redraw.

                        opts.labelHeight = axis.labelHeight +
                            axisLabels[axisName].height;
                        opts.labelWidth = axis.labelWidth +
                            axisLabels[axisName].width;
                    });

                    // If there are axis labels, re-draw with new label widths and
                    // heights.

                    if (hasAxisLabels) {
                        secondPass = true;
                        plot.setupGrid();
                        plot.draw();
                    }
                } else {
                    secondPass = false;
                    // DRAW
                    $.each(plot.getAxes(), function(axisName, axis) {
                        var opts = axis.options // Flot 0.7
                            || plot.getOptions()[axisName]; // Flot 0.6
                        if (!opts || !opts.axisLabel || !axis.show)
                            return;

                        axisLabels[axisName].draw(axis.box);
                    });
                }
            });
        });
    }


    $.plot.plugins.push({
        init: init,
        options: options,
        name: 'axisLabels',
        version: '2.0'
    });
})(jQuery);

},{}],9:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],10:[function(require,module,exports){
/*
 * jquery.flot.tooltip
 * 
 * description: easy-to-use tooltips for Flot charts
 * version: 0.9.0
 * authors: Krzysztof Urbas @krzysu [myviews.pl],Evan Steinkerchner @Roundaround
 * website: https://github.com/krzysu/flot.tooltip
 * 
 * build on 2016-07-26
 * released under MIT License, 2012
*/ 
(function ($) {
    // plugin options, default values
    var defaultOptions = {
        tooltip: {
            show: false,
            cssClass: "flotTip",
            content: "%s | X: %x | Y: %y",
            // allowed templates are:
            // %s -> series label,
            // %c -> series color,
            // %lx -> x axis label (requires flot-axislabels plugin https://github.com/markrcote/flot-axislabels),
            // %ly -> y axis label (requires flot-axislabels plugin https://github.com/markrcote/flot-axislabels),
            // %x -> X value,
            // %y -> Y value,
            // %x.2 -> precision of X value,
            // %p -> percent
            // %n -> value (not percent) of pie chart
            xDateFormat: null,
            yDateFormat: null,
            monthNames: null,
            dayNames: null,
            shifts: {
                x: 10,
                y: 20
            },
            defaultTheme: true,
            snap: true,
            lines: false,
            clickTips: false,

            // callbacks
            onHover: function (flotItem, $tooltipEl) {},

            $compat: false
        }
    };

    // dummy default options object for legacy code (<0.8.5) - is deleted later
    defaultOptions.tooltipOpts = defaultOptions.tooltip;

    // object
    var FlotTooltip = function (plot) {
        // variables
        this.tipPosition = {x: 0, y: 0};

        this.init(plot);
    };

    // main plugin function
    FlotTooltip.prototype.init = function (plot) {
        var that = this;

        // detect other flot plugins
        var plotPluginsLength = $.plot.plugins.length;
        this.plotPlugins = [];

        if (plotPluginsLength) {
            for (var p = 0; p < plotPluginsLength; p++) {
                this.plotPlugins.push($.plot.plugins[p].name);
            }
        }

        plot.hooks.bindEvents.push(function (plot, eventHolder) {

            // get plot options
            that.plotOptions = plot.getOptions();

            // for legacy (<0.8.5) implementations
            if (typeof(that.plotOptions.tooltip) === 'boolean') {
                that.plotOptions.tooltipOpts.show = that.plotOptions.tooltip;
                that.plotOptions.tooltip = that.plotOptions.tooltipOpts;
                delete that.plotOptions.tooltipOpts;
            }

            // if not enabled return
            if (that.plotOptions.tooltip.show === false || typeof that.plotOptions.tooltip.show === 'undefined') return;

            // shortcut to access tooltip options
            that.tooltipOptions = that.plotOptions.tooltip;

            if (that.tooltipOptions.$compat) {
                that.wfunc = 'width';
                that.hfunc = 'height';
            } else {
                that.wfunc = 'innerWidth';
                that.hfunc = 'innerHeight';
            }

            // create tooltip DOM element
            var $tip = that.getDomElement();

            // bind event
            $( plot.getPlaceholder() ).bind("plothover", plothover);
            if (that.tooltipOptions.clickTips) {
                $( plot.getPlaceholder() ).bind("plotclick", plotclick);
            }
            that.clickmode = false;

            $(eventHolder).bind('mousemove', mouseMove);
        });

        plot.hooks.shutdown.push(function (plot, eventHolder){
            $(plot.getPlaceholder()).unbind("plothover", plothover);
            $(plot.getPlaceholder()).unbind("plotclick", plotclick);
            plot.removeTooltip();
            $(eventHolder).unbind("mousemove", mouseMove);
        });

        function mouseMove(e){
            var pos = {};
            pos.x = e.pageX;
            pos.y = e.pageY;
            plot.setTooltipPosition(pos);
        }

        /**
         *  open the tooltip (if not already open) and freeze it on the current position till the next click
         */
        function plotclick(event, pos, item) {
            if (! that.clickmode) {
                // it is the click activating the clicktip
                plothover(event, pos, item);
                if (that.getDomElement().is(":visible")) {
                    $(plot.getPlaceholder()).unbind("plothover", plothover);
                    that.clickmode = true;
                }
            } else {
                // it is the click deactivating the clicktip
                $( plot.getPlaceholder() ).bind("plothover", plothover);
                plot.hideTooltip();
                that.clickmode = false;
            }
        }

        function plothover(event, pos, item) {
            // Simple distance formula.
            var lineDistance = function (p1x, p1y, p2x, p2y) {
                return Math.sqrt((p2x - p1x) * (p2x - p1x) + (p2y - p1y) * (p2y - p1y));
            };

            // Here is some voodoo magic for determining the distance to a line form a given point {x, y}.
            var dotLineLength = function (x, y, x0, y0, x1, y1, o) {
                if (o && !(o =
                    function (x, y, x0, y0, x1, y1) {
                        if (typeof x0 !== 'undefined') return { x: x0, y: y };
                        else if (typeof y0 !== 'undefined') return { x: x, y: y0 };

                        var left,
                            tg = -1 / ((y1 - y0) / (x1 - x0));

                        return {
                            x: left = (x1 * (x * tg - y + y0) + x0 * (x * -tg + y - y1)) / (tg * (x1 - x0) + y0 - y1),
                            y: tg * left - tg * x + y
                        };
                    } (x, y, x0, y0, x1, y1),
                    o.x >= Math.min(x0, x1) && o.x <= Math.max(x0, x1) && o.y >= Math.min(y0, y1) && o.y <= Math.max(y0, y1))
                ) {
                    var l1 = lineDistance(x, y, x0, y0), l2 = lineDistance(x, y, x1, y1);
                    return l1 > l2 ? l2 : l1;
                } else {
                    var a = y0 - y1, b = x1 - x0, c = x0 * y1 - y0 * x1;
                    return Math.abs(a * x + b * y + c) / Math.sqrt(a * a + b * b);
                }
            };

            if (item) {
                plot.showTooltip(item, that.tooltipOptions.snap ? item : pos);
            } else if (that.plotOptions.series.lines.show && that.tooltipOptions.lines === true) {
                var maxDistance = that.plotOptions.grid.mouseActiveRadius;

                var closestTrace = {
                    distance: maxDistance + 1
                };

                var ttPos = pos;

                $.each(plot.getData(), function (i, series) {
                    var xBeforeIndex = 0,
                        xAfterIndex = -1;

                    // Our search here assumes our data is sorted via the x-axis.
                    // TODO: Improve efficiency somehow - search smaller sets of data.
                    for (var j = 1; j < series.data.length; j++) {
                        if (series.data[j - 1][0] <= pos.x && series.data[j][0] >= pos.x) {
                            xBeforeIndex = j - 1;
                            xAfterIndex = j;
                        }
                    }

                    if (xAfterIndex === -1) {
                        plot.hideTooltip();
                        return;
                    }

                    var pointPrev = { x: series.data[xBeforeIndex][0], y: series.data[xBeforeIndex][1] },
                        pointNext = { x: series.data[xAfterIndex][0], y: series.data[xAfterIndex][1] };

                    var distToLine = dotLineLength(series.xaxis.p2c(pos.x), series.yaxis.p2c(pos.y), series.xaxis.p2c(pointPrev.x),
                        series.yaxis.p2c(pointPrev.y), series.xaxis.p2c(pointNext.x), series.yaxis.p2c(pointNext.y), false);

                    if (distToLine < closestTrace.distance) {

                        var closestIndex = lineDistance(pointPrev.x, pointPrev.y, pos.x, pos.y) <
                            lineDistance(pos.x, pos.y, pointNext.x, pointNext.y) ? xBeforeIndex : xAfterIndex;

                        var pointSize = series.datapoints.pointsize;

                        // Calculate the point on the line vertically closest to our cursor.
                        var pointOnLine = [
                            pos.x,
                            pointPrev.y + ((pointNext.y - pointPrev.y) * ((pos.x - pointPrev.x) / (pointNext.x - pointPrev.x)))
                        ];

                        var item = {
                            datapoint: pointOnLine,
                            dataIndex: closestIndex,
                            series: series,
                            seriesIndex: i
                        };

                        closestTrace = {
                            distance: distToLine,
                            item: item
                        };

                        if (that.tooltipOptions.snap) {
                            ttPos = {
                                pageX: series.xaxis.p2c(pointOnLine[0]),
                                pageY: series.yaxis.p2c(pointOnLine[1])
                            };
                        }
                    }
                });

                if (closestTrace.distance < maxDistance + 1)
                    plot.showTooltip(closestTrace.item, ttPos);
                else
                    plot.hideTooltip();
            } else {
                plot.hideTooltip();
            }
        }

        // Quick little function for setting the tooltip position.
        plot.setTooltipPosition = function (pos) {
            var $tip = that.getDomElement();

            var totalTipWidth = $tip.outerWidth() + that.tooltipOptions.shifts.x;
            var totalTipHeight = $tip.outerHeight() + that.tooltipOptions.shifts.y;
            if ((pos.x - $(window).scrollLeft()) > ($(window)[that.wfunc]() - totalTipWidth)) {
                pos.x -= totalTipWidth;
                pos.x = Math.max(pos.x, 0);
            }
            if ((pos.y - $(window).scrollTop()) > ($(window)[that.hfunc]() - totalTipHeight)) {
                pos.y -= totalTipHeight;
            }

	    /*
	       The section applies the new positioning ONLY if pos.x and pos.y
	       are numbers. If they are undefined or not a number, use the last
	       known numerical position. This hack fixes a bug that kept pie
	       charts from keeping their tooltip positioning.
	     */

            if (isNaN(pos.x)) {
		that.tipPosition.x = that.tipPosition.xPrev;
	    }
	    else {
		that.tipPosition.x = pos.x;
		that.tipPosition.xPrev = pos.x;
	    }
	    if (isNaN(pos.y)) {
		that.tipPosition.y = that.tipPosition.yPrev;
	    }
	    else {
		that.tipPosition.y = pos.y;
		that.tipPosition.yPrev = pos.y;
	    }

        };

        // Quick little function for showing the tooltip.
        plot.showTooltip = function (target, position, targetPosition) {
            var $tip = that.getDomElement();

            // convert tooltip content template to real tipText
            var tipText = that.stringFormat(that.tooltipOptions.content, target);
            if (tipText === '')
                return;

            $tip.html(tipText);
            plot.setTooltipPosition({ x: that.tipPosition.x, y: that.tipPosition.y });
            $tip.css({
                left: that.tipPosition.x + that.tooltipOptions.shifts.x,
                top: that.tipPosition.y + that.tooltipOptions.shifts.y
            }).show();

            // run callback
            if (typeof that.tooltipOptions.onHover === 'function') {
                that.tooltipOptions.onHover(target, $tip);
            }
        };

        // Quick little function for hiding the tooltip.
        plot.hideTooltip = function () {
            that.getDomElement().hide().html('');
        };

        plot.removeTooltip = function() {
            that.getDomElement().remove();
        };
    };

    /**
     * get or create tooltip DOM element
     * @return jQuery object
     */
    FlotTooltip.prototype.getDomElement = function () {
        var $tip = $('<div>');
        if (this.tooltipOptions && this.tooltipOptions.cssClass) {
            $tip = $('.' + this.tooltipOptions.cssClass);

            if( $tip.length === 0 ){
                $tip = $('<div />').addClass(this.tooltipOptions.cssClass);
                $tip.appendTo('body').hide().css({position: 'absolute'});

                if(this.tooltipOptions.defaultTheme) {
                    $tip.css({
                        'background': '#fff',
                        'z-index': '1040',
                        'padding': '0.4em 0.6em',
                        'border-radius': '0.5em',
                        'font-size': '0.8em',
                        'border': '1px solid #111',
                        'display': 'none',
                        'white-space': 'nowrap'
                    });
                }
            }
        }

        return $tip;
    };

    /**
     * core function, create tooltip content
     * @param  {string} content - template with tooltip content
     * @param  {object} item - Flot item
     * @return {string} real tooltip content for current item
     */
    FlotTooltip.prototype.stringFormat = function (content, item) {
        var percentPattern = /%p\.{0,1}(\d{0,})/;
        var seriesPattern = /%s/;
        var colorPattern = /%c/;
        var xLabelPattern = /%lx/; // requires flot-axislabels plugin https://github.com/markrcote/flot-axislabels, will be ignored if plugin isn't loaded
        var yLabelPattern = /%ly/; // requires flot-axislabels plugin https://github.com/markrcote/flot-axislabels, will be ignored if plugin isn't loaded
        var xPattern = /%x\.{0,1}(\d{0,})/;
        var yPattern = /%y\.{0,1}(\d{0,})/;
        var xPatternWithoutPrecision = "%x";
        var yPatternWithoutPrecision = "%y";
        var customTextPattern = "%ct";
	var nPiePattern = "%n";

        var x, y, customText, p, n;

        // for threshold plugin we need to read data from different place
        if (typeof item.series.threshold !== "undefined") {
            x = item.datapoint[0];
            y = item.datapoint[1];
            customText = item.datapoint[2];
	}

	// for CurvedLines plugin we need to read data from different place
	    else if (typeof item.series.curvedLines !== "undefined") {
		x = item.datapoint[0];
		y = item.datapoint[1];
	    }

        else if (typeof item.series.lines !== "undefined" && item.series.lines.steps) {
            x = item.series.datapoints.points[item.dataIndex * 2];
            y = item.series.datapoints.points[item.dataIndex * 2 + 1];
            // TODO: where to find custom text in this variant?
            customText = "";
        } else {
            x = item.series.data[item.dataIndex][0];
            y = item.series.data[item.dataIndex][1];
            customText = item.series.data[item.dataIndex][2];
        }

        // I think this is only in case of threshold plugin
        if (item.series.label === null && item.series.originSeries) {
            item.series.label = item.series.originSeries.label;
        }

        // if it is a function callback get the content string
        if (typeof(content) === 'function') {
            content = content(item.series.label, x, y, item);
        }

        // the case where the passed content is equal to false
        if (typeof(content) === 'boolean' && !content) {
            return '';
        }

        /* replacement of %ct and other multi-character templates must
           precede the replacement of single-character templates
           to avoid conflict between '%c' and '%ct'  and similar substrings
        */
        if (customText) {
            content = content.replace(customTextPattern, customText);
        }

        // percent match for pie charts and stacked percent
        if (typeof (item.series.percent) !== 'undefined') {
            p = item.series.percent;
        } else if (typeof (item.series.percents) !== 'undefined') {
            p = item.series.percents[item.dataIndex];
        }
        if (typeof p === 'number') {
            content = this.adjustValPrecision(percentPattern, content, p);
        }

        // replace %n with number of items represented by slice in pie charts
        if (item.series.hasOwnProperty('pie')) {
            if (typeof item.series.data[0][1] !== 'undefined') {
                n = item.series.data[0][1];
            }
        }
        if (typeof n === 'number') {
            content = content.replace(nPiePattern, n);
        }

        // series match
        if (typeof(item.series.label) !== 'undefined') {
            content = content.replace(seriesPattern, item.series.label);
        } else {
            //remove %s if label is undefined
            content = content.replace(seriesPattern, "");
        }

        // color match
        if (typeof(item.series.color) !== 'undefined') {
            content = content.replace(colorPattern, item.series.color);
        } else {
            //remove %s if color is undefined
            content = content.replace(colorPattern, "");
        }

        // x axis label match
        if (this.hasAxisLabel('xaxis', item)) {
            content = content.replace(xLabelPattern, item.series.xaxis.options.axisLabel);
        } else {
            //remove %lx if axis label is undefined or axislabels plugin not present
            content = content.replace(xLabelPattern, "");
        }

        // y axis label match
        if (this.hasAxisLabel('yaxis', item)) {
            content = content.replace(yLabelPattern, item.series.yaxis.options.axisLabel);
        } else {
            //remove %ly if axis label is undefined or axislabels plugin not present
            content = content.replace(yLabelPattern, "");
        }

        // time mode axes with custom dateFormat
        if (this.isTimeMode('xaxis', item) && this.isXDateFormat(item)) {
            content = content.replace(xPattern, this.timestampToDate(x, this.tooltipOptions.xDateFormat, item.series.xaxis.options));
        }
        if (this.isTimeMode('yaxis', item) && this.isYDateFormat(item)) {
            content = content.replace(yPattern, this.timestampToDate(y, this.tooltipOptions.yDateFormat, item.series.yaxis.options));
        }

        // set precision if defined
        if (typeof x === 'number') {
            content = this.adjustValPrecision(xPattern, content, x);
        }
        if (typeof y === 'number') {
            content = this.adjustValPrecision(yPattern, content, y);
        }

        // change x from number to given label, if given
        if (typeof item.series.xaxis.ticks !== 'undefined') {

            var ticks;
            if (this.hasRotatedXAxisTicks(item)) {
                // xaxis.ticks will be an empty array if tickRotor is being used, but the values are available in rotatedTicks
                ticks = 'rotatedTicks';
            } else {
                ticks = 'ticks';
            }

            // see https://github.com/krzysu/flot.tooltip/issues/65
            var tickIndex = item.dataIndex + item.seriesIndex;

            for (var xIndex in item.series.xaxis[ticks]) {
                if (item.series.xaxis[ticks].hasOwnProperty(tickIndex) && !this.isTimeMode('xaxis', item)) {
                    var valueX = (this.isCategoriesMode('xaxis', item)) ? item.series.xaxis[ticks][tickIndex].label : item.series.xaxis[ticks][tickIndex].v;
                    if (valueX === x) {
                        content = content.replace(xPattern, item.series.xaxis[ticks][tickIndex].label.replace(/\$/g, '$$$$'));
                    }
                }
            }
        }

        // change y from number to given label, if given
        if (typeof item.series.yaxis.ticks !== 'undefined') {
            for (var yIndex in item.series.yaxis.ticks) {
                if (item.series.yaxis.ticks.hasOwnProperty(yIndex)) {
                    var valueY = (this.isCategoriesMode('yaxis', item)) ? item.series.yaxis.ticks[yIndex].label : item.series.yaxis.ticks[yIndex].v;
                    if (valueY === y) {
                        content = content.replace(yPattern, item.series.yaxis.ticks[yIndex].label.replace(/\$/g, '$$$$'));
                    }
                }
            }
        }

        // if no value customization, use tickFormatter by default
        if (typeof item.series.xaxis.tickFormatter !== 'undefined') {
            //escape dollar
            content = content.replace(xPatternWithoutPrecision, item.series.xaxis.tickFormatter(x, item.series.xaxis).replace(/\$/g, '$$'));
        }
        if (typeof item.series.yaxis.tickFormatter !== 'undefined') {
            //escape dollar
            content = content.replace(yPatternWithoutPrecision, item.series.yaxis.tickFormatter(y, item.series.yaxis).replace(/\$/g, '$$'));
        }

        return content;
    };

    // helpers just for readability
    FlotTooltip.prototype.isTimeMode = function (axisName, item) {
        return (typeof item.series[axisName].options.mode !== 'undefined' && item.series[axisName].options.mode === 'time');
    };

    FlotTooltip.prototype.isXDateFormat = function (item) {
        return (typeof this.tooltipOptions.xDateFormat !== 'undefined' && this.tooltipOptions.xDateFormat !== null);
    };

    FlotTooltip.prototype.isYDateFormat = function (item) {
        return (typeof this.tooltipOptions.yDateFormat !== 'undefined' && this.tooltipOptions.yDateFormat !== null);
    };

    FlotTooltip.prototype.isCategoriesMode = function (axisName, item) {
        return (typeof item.series[axisName].options.mode !== 'undefined' && item.series[axisName].options.mode === 'categories');
    };

    //
    FlotTooltip.prototype.timestampToDate = function (tmst, dateFormat, options) {
        var theDate = $.plot.dateGenerator(tmst, options);
        return $.plot.formatDate(theDate, dateFormat, this.tooltipOptions.monthNames, this.tooltipOptions.dayNames);
    };

    //
    FlotTooltip.prototype.adjustValPrecision = function (pattern, content, value) {

        var precision;
        var matchResult = content.match(pattern);
        if( matchResult !== null ) {
            if(RegExp.$1 !== '') {
                precision = RegExp.$1;
                value = value.toFixed(precision);

                // only replace content if precision exists, in other case use thickformater
                content = content.replace(pattern, value);
            }
        }
        return content;
    };

    // other plugins detection below

    // check if flot-axislabels plugin (https://github.com/markrcote/flot-axislabels) is used and that an axis label is given
    FlotTooltip.prototype.hasAxisLabel = function (axisName, item) {
        return ($.inArray('axisLabels', this.plotPlugins) !== -1 && typeof item.series[axisName].options.axisLabel !== 'undefined' && item.series[axisName].options.axisLabel.length > 0);
    };

    // check whether flot-tickRotor, a plugin which allows rotation of X-axis ticks, is being used
    FlotTooltip.prototype.hasRotatedXAxisTicks = function (item) {
        return ($.inArray('tickRotor',this.plotPlugins) !== -1 && typeof item.series.xaxis.rotatedTicks !== 'undefined');
    };

    //
    var init = function (plot) {
      new FlotTooltip(plot);
    };

    // define Flot plugin
    $.plot.plugins.push({
        init: init,
        options: defaultOptions,
        name: 'tooltip',
        version: '0.8.5'
    });

})(jQuery);

},{}],11:[function(require,module,exports){
/* Javascript plotting library for jQuery, version 0.8.3.

Copyright (c) 2007-2014 IOLA and Ole Laursen.
Licensed under the MIT license.

*/

// first an inline dependency, jquery.colorhelpers.js, we inline it here
// for convenience

/* Plugin for jQuery for working with colors.
 *
 * Version 1.1.
 *
 * Inspiration from jQuery color animation plugin by John Resig.
 *
 * Released under the MIT license by Ole Laursen, October 2009.
 *
 * Examples:
 *
 *   $.color.parse("#fff").scale('rgb', 0.25).add('a', -0.5).toString()
 *   var c = $.color.extract($("#mydiv"), 'background-color');
 *   console.log(c.r, c.g, c.b, c.a);
 *   $.color.make(100, 50, 25, 0.4).toString() // returns "rgba(100,50,25,0.4)"
 *
 * Note that .scale() and .add() return the same modified object
 * instead of making a new one.
 *
 * V. 1.1: Fix error handling so e.g. parsing an empty string does
 * produce a color rather than just crashing.
 */
(function($){$.color={};$.color.make=function(r,g,b,a){var o={};o.r=r||0;o.g=g||0;o.b=b||0;o.a=a!=null?a:1;o.add=function(c,d){for(var i=0;i<c.length;++i)o[c.charAt(i)]+=d;return o.normalize()};o.scale=function(c,f){for(var i=0;i<c.length;++i)o[c.charAt(i)]*=f;return o.normalize()};o.toString=function(){if(o.a>=1){return"rgb("+[o.r,o.g,o.b].join(",")+")"}else{return"rgba("+[o.r,o.g,o.b,o.a].join(",")+")"}};o.normalize=function(){function clamp(min,value,max){return value<min?min:value>max?max:value}o.r=clamp(0,parseInt(o.r),255);o.g=clamp(0,parseInt(o.g),255);o.b=clamp(0,parseInt(o.b),255);o.a=clamp(0,o.a,1);return o};o.clone=function(){return $.color.make(o.r,o.b,o.g,o.a)};return o.normalize()};$.color.extract=function(elem,css){var c;do{c=elem.css(css).toLowerCase();if(c!=""&&c!="transparent")break;elem=elem.parent()}while(elem.length&&!$.nodeName(elem.get(0),"body"));if(c=="rgba(0, 0, 0, 0)")c="transparent";return $.color.parse(c)};$.color.parse=function(str){var res,m=$.color.make;if(res=/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(str))return m(parseInt(res[1],10),parseInt(res[2],10),parseInt(res[3],10));if(res=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str))return m(parseInt(res[1],10),parseInt(res[2],10),parseInt(res[3],10),parseFloat(res[4]));if(res=/rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(str))return m(parseFloat(res[1])*2.55,parseFloat(res[2])*2.55,parseFloat(res[3])*2.55);if(res=/rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str))return m(parseFloat(res[1])*2.55,parseFloat(res[2])*2.55,parseFloat(res[3])*2.55,parseFloat(res[4]));if(res=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(str))return m(parseInt(res[1],16),parseInt(res[2],16),parseInt(res[3],16));if(res=/#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(str))return m(parseInt(res[1]+res[1],16),parseInt(res[2]+res[2],16),parseInt(res[3]+res[3],16));var name=$.trim(str).toLowerCase();if(name=="transparent")return m(255,255,255,0);else{res=lookupColors[name]||[0,0,0];return m(res[0],res[1],res[2])}};var lookupColors={aqua:[0,255,255],azure:[240,255,255],beige:[245,245,220],black:[0,0,0],blue:[0,0,255],brown:[165,42,42],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgrey:[169,169,169],darkgreen:[0,100,0],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkviolet:[148,0,211],fuchsia:[255,0,255],gold:[255,215,0],green:[0,128,0],indigo:[75,0,130],khaki:[240,230,140],lightblue:[173,216,230],lightcyan:[224,255,255],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightyellow:[255,255,224],lime:[0,255,0],magenta:[255,0,255],maroon:[128,0,0],navy:[0,0,128],olive:[128,128,0],orange:[255,165,0],pink:[255,192,203],purple:[128,0,128],violet:[128,0,128],red:[255,0,0],silver:[192,192,192],white:[255,255,255],yellow:[255,255,0]}})(jQuery);

// the actual Flot code
(function($) {

	// Cache the prototype hasOwnProperty for faster access

	var hasOwnProperty = Object.prototype.hasOwnProperty;

    // A shim to provide 'detach' to jQuery versions prior to 1.4.  Using a DOM
    // operation produces the same effect as detach, i.e. removing the element
    // without touching its jQuery data.

    // Do not merge this into Flot 0.9, since it requires jQuery 1.4.4+.

    if (!$.fn.detach) {
        $.fn.detach = function() {
            return this.each(function() {
                if (this.parentNode) {
                    this.parentNode.removeChild( this );
                }
            });
        };
    }

	///////////////////////////////////////////////////////////////////////////
	// The Canvas object is a wrapper around an HTML5 <canvas> tag.
	//
	// @constructor
	// @param {string} cls List of classes to apply to the canvas.
	// @param {element} container Element onto which to append the canvas.
	//
	// Requiring a container is a little iffy, but unfortunately canvas
	// operations don't work unless the canvas is attached to the DOM.

	function Canvas(cls, container) {

		var element = container.children("." + cls)[0];

		if (element == null) {

			element = document.createElement("canvas");
			element.className = cls;

			$(element).css({ direction: "ltr", position: "absolute", left: 0, top: 0 })
				.appendTo(container);

			// If HTML5 Canvas isn't available, fall back to [Ex|Flash]canvas

			if (!element.getContext) {
				if (window.G_vmlCanvasManager) {
					element = window.G_vmlCanvasManager.initElement(element);
				} else {
					throw new Error("Canvas is not available. If you're using IE with a fall-back such as Excanvas, then there's either a mistake in your conditional include, or the page has no DOCTYPE and is rendering in Quirks Mode.");
				}
			}
		}

		this.element = element;

		var context = this.context = element.getContext("2d");

		// Determine the screen's ratio of physical to device-independent
		// pixels.  This is the ratio between the canvas width that the browser
		// advertises and the number of pixels actually present in that space.

		// The iPhone 4, for example, has a device-independent width of 320px,
		// but its screen is actually 640px wide.  It therefore has a pixel
		// ratio of 2, while most normal devices have a ratio of 1.

		var devicePixelRatio = window.devicePixelRatio || 1,
			backingStoreRatio =
				context.webkitBackingStorePixelRatio ||
				context.mozBackingStorePixelRatio ||
				context.msBackingStorePixelRatio ||
				context.oBackingStorePixelRatio ||
				context.backingStorePixelRatio || 1;

		this.pixelRatio = devicePixelRatio / backingStoreRatio;

		// Size the canvas to match the internal dimensions of its container

		this.resize(container.width(), container.height());

		// Collection of HTML div layers for text overlaid onto the canvas

		this.textContainer = null;
		this.text = {};

		// Cache of text fragments and metrics, so we can avoid expensively
		// re-calculating them when the plot is re-rendered in a loop.

		this._textCache = {};
	}

	// Resizes the canvas to the given dimensions.
	//
	// @param {number} width New width of the canvas, in pixels.
	// @param {number} width New height of the canvas, in pixels.

	Canvas.prototype.resize = function(width, height) {

		if (width <= 0 || height <= 0) {
			throw new Error("Invalid dimensions for plot, width = " + width + ", height = " + height);
		}

		var element = this.element,
			context = this.context,
			pixelRatio = this.pixelRatio;

		// Resize the canvas, increasing its density based on the display's
		// pixel ratio; basically giving it more pixels without increasing the
		// size of its element, to take advantage of the fact that retina
		// displays have that many more pixels in the same advertised space.

		// Resizing should reset the state (excanvas seems to be buggy though)

		if (this.width != width) {
			element.width = width * pixelRatio;
			element.style.width = width + "px";
			this.width = width;
		}

		if (this.height != height) {
			element.height = height * pixelRatio;
			element.style.height = height + "px";
			this.height = height;
		}

		// Save the context, so we can reset in case we get replotted.  The
		// restore ensure that we're really back at the initial state, and
		// should be safe even if we haven't saved the initial state yet.

		context.restore();
		context.save();

		// Scale the coordinate space to match the display density; so even though we
		// may have twice as many pixels, we still want lines and other drawing to
		// appear at the same size; the extra pixels will just make them crisper.

		context.scale(pixelRatio, pixelRatio);
	};

	// Clears the entire canvas area, not including any overlaid HTML text

	Canvas.prototype.clear = function() {
		this.context.clearRect(0, 0, this.width, this.height);
	};

	// Finishes rendering the canvas, including managing the text overlay.

	Canvas.prototype.render = function() {

		var cache = this._textCache;

		// For each text layer, add elements marked as active that haven't
		// already been rendered, and remove those that are no longer active.

		for (var layerKey in cache) {
			if (hasOwnProperty.call(cache, layerKey)) {

				var layer = this.getTextLayer(layerKey),
					layerCache = cache[layerKey];

				layer.hide();

				for (var styleKey in layerCache) {
					if (hasOwnProperty.call(layerCache, styleKey)) {
						var styleCache = layerCache[styleKey];
						for (var key in styleCache) {
							if (hasOwnProperty.call(styleCache, key)) {

								var positions = styleCache[key].positions;

								for (var i = 0, position; position = positions[i]; i++) {
									if (position.active) {
										if (!position.rendered) {
											layer.append(position.element);
											position.rendered = true;
										}
									} else {
										positions.splice(i--, 1);
										if (position.rendered) {
											position.element.detach();
										}
									}
								}

								if (positions.length == 0) {
									delete styleCache[key];
								}
							}
						}
					}
				}

				layer.show();
			}
		}
	};

	// Creates (if necessary) and returns the text overlay container.
	//
	// @param {string} classes String of space-separated CSS classes used to
	//     uniquely identify the text layer.
	// @return {object} The jQuery-wrapped text-layer div.

	Canvas.prototype.getTextLayer = function(classes) {

		var layer = this.text[classes];

		// Create the text layer if it doesn't exist

		if (layer == null) {

			// Create the text layer container, if it doesn't exist

			if (this.textContainer == null) {
				this.textContainer = $("<div class='flot-text'></div>")
					.css({
						position: "absolute",
						top: 0,
						left: 0,
						bottom: 0,
						right: 0,
						'font-size': "smaller",
						color: "#545454"
					})
					.insertAfter(this.element);
			}

			layer = this.text[classes] = $("<div></div>")
				.addClass(classes)
				.css({
					position: "absolute",
					top: 0,
					left: 0,
					bottom: 0,
					right: 0
				})
				.appendTo(this.textContainer);
		}

		return layer;
	};

	// Creates (if necessary) and returns a text info object.
	//
	// The object looks like this:
	//
	// {
	//     width: Width of the text's wrapper div.
	//     height: Height of the text's wrapper div.
	//     element: The jQuery-wrapped HTML div containing the text.
	//     positions: Array of positions at which this text is drawn.
	// }
	//
	// The positions array contains objects that look like this:
	//
	// {
	//     active: Flag indicating whether the text should be visible.
	//     rendered: Flag indicating whether the text is currently visible.
	//     element: The jQuery-wrapped HTML div containing the text.
	//     x: X coordinate at which to draw the text.
	//     y: Y coordinate at which to draw the text.
	// }
	//
	// Each position after the first receives a clone of the original element.
	//
	// The idea is that that the width, height, and general 'identity' of the
	// text is constant no matter where it is placed; the placements are a
	// secondary property.
	//
	// Canvas maintains a cache of recently-used text info objects; getTextInfo
	// either returns the cached element or creates a new entry.
	//
	// @param {string} layer A string of space-separated CSS classes uniquely
	//     identifying the layer containing this text.
	// @param {string} text Text string to retrieve info for.
	// @param {(string|object)=} font Either a string of space-separated CSS
	//     classes or a font-spec object, defining the text's font and style.
	// @param {number=} angle Angle at which to rotate the text, in degrees.
	//     Angle is currently unused, it will be implemented in the future.
	// @param {number=} width Maximum width of the text before it wraps.
	// @return {object} a text info object.

	Canvas.prototype.getTextInfo = function(layer, text, font, angle, width) {

		var textStyle, layerCache, styleCache, info;

		// Cast the value to a string, in case we were given a number or such

		text = "" + text;

		// If the font is a font-spec object, generate a CSS font definition

		if (typeof font === "object") {
			textStyle = font.style + " " + font.variant + " " + font.weight + " " + font.size + "px/" + font.lineHeight + "px " + font.family;
		} else {
			textStyle = font;
		}

		// Retrieve (or create) the cache for the text's layer and styles

		layerCache = this._textCache[layer];

		if (layerCache == null) {
			layerCache = this._textCache[layer] = {};
		}

		styleCache = layerCache[textStyle];

		if (styleCache == null) {
			styleCache = layerCache[textStyle] = {};
		}

		info = styleCache[text];

		// If we can't find a matching element in our cache, create a new one

		if (info == null) {

			var element = $("<div></div>").html(text)
				.css({
					position: "absolute",
					'max-width': width,
					top: -9999
				})
				.appendTo(this.getTextLayer(layer));

			if (typeof font === "object") {
				element.css({
					font: textStyle,
					color: font.color
				});
			} else if (typeof font === "string") {
				element.addClass(font);
			}

			info = styleCache[text] = {
				width: element.outerWidth(true),
				height: element.outerHeight(true),
				element: element,
				positions: []
			};

			element.detach();
		}

		return info;
	};

	// Adds a text string to the canvas text overlay.
	//
	// The text isn't drawn immediately; it is marked as rendering, which will
	// result in its addition to the canvas on the next render pass.
	//
	// @param {string} layer A string of space-separated CSS classes uniquely
	//     identifying the layer containing this text.
	// @param {number} x X coordinate at which to draw the text.
	// @param {number} y Y coordinate at which to draw the text.
	// @param {string} text Text string to draw.
	// @param {(string|object)=} font Either a string of space-separated CSS
	//     classes or a font-spec object, defining the text's font and style.
	// @param {number=} angle Angle at which to rotate the text, in degrees.
	//     Angle is currently unused, it will be implemented in the future.
	// @param {number=} width Maximum width of the text before it wraps.
	// @param {string=} halign Horizontal alignment of the text; either "left",
	//     "center" or "right".
	// @param {string=} valign Vertical alignment of the text; either "top",
	//     "middle" or "bottom".

	Canvas.prototype.addText = function(layer, x, y, text, font, angle, width, halign, valign) {

		var info = this.getTextInfo(layer, text, font, angle, width),
			positions = info.positions;

		// Tweak the div's position to match the text's alignment

		if (halign == "center") {
			x -= info.width / 2;
		} else if (halign == "right") {
			x -= info.width;
		}

		if (valign == "middle") {
			y -= info.height / 2;
		} else if (valign == "bottom") {
			y -= info.height;
		}

		// Determine whether this text already exists at this position.
		// If so, mark it for inclusion in the next render pass.

		for (var i = 0, position; position = positions[i]; i++) {
			if (position.x == x && position.y == y) {
				position.active = true;
				return;
			}
		}

		// If the text doesn't exist at this position, create a new entry

		// For the very first position we'll re-use the original element,
		// while for subsequent ones we'll clone it.

		position = {
			active: true,
			rendered: false,
			element: positions.length ? info.element.clone() : info.element,
			x: x,
			y: y
		};

		positions.push(position);

		// Move the element to its final position within the container

		position.element.css({
			top: Math.round(y),
			left: Math.round(x),
			'text-align': halign	// In case the text wraps
		});
	};

	// Removes one or more text strings from the canvas text overlay.
	//
	// If no parameters are given, all text within the layer is removed.
	//
	// Note that the text is not immediately removed; it is simply marked as
	// inactive, which will result in its removal on the next render pass.
	// This avoids the performance penalty for 'clear and redraw' behavior,
	// where we potentially get rid of all text on a layer, but will likely
	// add back most or all of it later, as when redrawing axes, for example.
	//
	// @param {string} layer A string of space-separated CSS classes uniquely
	//     identifying the layer containing this text.
	// @param {number=} x X coordinate of the text.
	// @param {number=} y Y coordinate of the text.
	// @param {string=} text Text string to remove.
	// @param {(string|object)=} font Either a string of space-separated CSS
	//     classes or a font-spec object, defining the text's font and style.
	// @param {number=} angle Angle at which the text is rotated, in degrees.
	//     Angle is currently unused, it will be implemented in the future.

	Canvas.prototype.removeText = function(layer, x, y, text, font, angle) {
		if (text == null) {
			var layerCache = this._textCache[layer];
			if (layerCache != null) {
				for (var styleKey in layerCache) {
					if (hasOwnProperty.call(layerCache, styleKey)) {
						var styleCache = layerCache[styleKey];
						for (var key in styleCache) {
							if (hasOwnProperty.call(styleCache, key)) {
								var positions = styleCache[key].positions;
								for (var i = 0, position; position = positions[i]; i++) {
									position.active = false;
								}
							}
						}
					}
				}
			}
		} else {
			var positions = this.getTextInfo(layer, text, font, angle).positions;
			for (var i = 0, position; position = positions[i]; i++) {
				if (position.x == x && position.y == y) {
					position.active = false;
				}
			}
		}
	};

	///////////////////////////////////////////////////////////////////////////
	// The top-level container for the entire plot.

    function Plot(placeholder, data_, options_, plugins) {
        // data is on the form:
        //   [ series1, series2 ... ]
        // where series is either just the data as [ [x1, y1], [x2, y2], ... ]
        // or { data: [ [x1, y1], [x2, y2], ... ], label: "some label", ... }

        var series = [],
            options = {
                // the color theme used for graphs
                colors: ["#edc240", "#afd8f8", "#cb4b4b", "#4da74d", "#9440ed"],
                legend: {
                    show: true,
                    noColumns: 1, // number of colums in legend table
                    labelFormatter: null, // fn: string -> string
                    labelBoxBorderColor: "#ccc", // border color for the little label boxes
                    container: null, // container (as jQuery object) to put legend in, null means default on top of graph
                    position: "ne", // position of default legend container within plot
                    margin: 5, // distance from grid edge to default legend container within plot
                    backgroundColor: null, // null means auto-detect
                    backgroundOpacity: 0.85, // set to 0 to avoid background
                    sorted: null    // default to no legend sorting
                },
                xaxis: {
                    show: null, // null = auto-detect, true = always, false = never
                    position: "bottom", // or "top"
                    mode: null, // null or "time"
                    font: null, // null (derived from CSS in placeholder) or object like { size: 11, lineHeight: 13, style: "italic", weight: "bold", family: "sans-serif", variant: "small-caps" }
                    color: null, // base color, labels, ticks
                    tickColor: null, // possibly different color of ticks, e.g. "rgba(0,0,0,0.15)"
                    transform: null, // null or f: number -> number to transform axis
                    inverseTransform: null, // if transform is set, this should be the inverse function
                    min: null, // min. value to show, null means set automatically
                    max: null, // max. value to show, null means set automatically
                    autoscaleMargin: null, // margin in % to add if auto-setting min/max
                    ticks: null, // either [1, 3] or [[1, "a"], 3] or (fn: axis info -> ticks) or app. number of ticks for auto-ticks
                    tickFormatter: null, // fn: number -> string
                    labelWidth: null, // size of tick labels in pixels
                    labelHeight: null,
                    reserveSpace: null, // whether to reserve space even if axis isn't shown
                    tickLength: null, // size in pixels of ticks, or "full" for whole line
                    alignTicksWithAxis: null, // axis number or null for no sync
                    tickDecimals: null, // no. of decimals, null means auto
                    tickSize: null, // number or [number, "unit"]
                    minTickSize: null // number or [number, "unit"]
                },
                yaxis: {
                    autoscaleMargin: 0.02,
                    position: "left" // or "right"
                },
                xaxes: [],
                yaxes: [],
                series: {
                    points: {
                        show: false,
                        radius: 3,
                        lineWidth: 2, // in pixels
                        fill: true,
                        fillColor: "#ffffff",
                        symbol: "circle" // or callback
                    },
                    lines: {
                        // we don't put in show: false so we can see
                        // whether lines were actively disabled
                        lineWidth: 2, // in pixels
                        fill: false,
                        fillColor: null,
                        steps: false
                        // Omit 'zero', so we can later default its value to
                        // match that of the 'fill' option.
                    },
                    bars: {
                        show: false,
                        lineWidth: 2, // in pixels
                        barWidth: 1, // in units of the x axis
                        fill: true,
                        fillColor: null,
                        align: "left", // "left", "right", or "center"
                        horizontal: false,
                        zero: true
                    },
                    shadowSize: 3,
                    highlightColor: null
                },
                grid: {
                    show: true,
                    aboveData: false,
                    color: "#545454", // primary color used for outline and labels
                    backgroundColor: null, // null for transparent, else color
                    borderColor: null, // set if different from the grid color
                    tickColor: null, // color for the ticks, e.g. "rgba(0,0,0,0.15)"
                    margin: 0, // distance from the canvas edge to the grid
                    labelMargin: 5, // in pixels
                    axisMargin: 8, // in pixels
                    borderWidth: 2, // in pixels
                    minBorderMargin: null, // in pixels, null means taken from points radius
                    markings: null, // array of ranges or fn: axes -> array of ranges
                    markingsColor: "#f4f4f4",
                    markingsLineWidth: 2,
                    // interactive stuff
                    clickable: false,
                    hoverable: false,
                    autoHighlight: true, // highlight in case mouse is near
                    mouseActiveRadius: 10 // how far the mouse can be away to activate an item
                },
                interaction: {
                    redrawOverlayInterval: 1000/60 // time between updates, -1 means in same flow
                },
                hooks: {}
            },
        surface = null,     // the canvas for the plot itself
        overlay = null,     // canvas for interactive stuff on top of plot
        eventHolder = null, // jQuery object that events should be bound to
        ctx = null, octx = null,
        xaxes = [], yaxes = [],
        plotOffset = { left: 0, right: 0, top: 0, bottom: 0},
        plotWidth = 0, plotHeight = 0,
        hooks = {
            processOptions: [],
            processRawData: [],
            processDatapoints: [],
            processOffset: [],
            drawBackground: [],
            drawSeries: [],
            draw: [],
            bindEvents: [],
            drawOverlay: [],
            shutdown: []
        },
        plot = this;

        // public functions
        plot.setData = setData;
        plot.setupGrid = setupGrid;
        plot.draw = draw;
        plot.getPlaceholder = function() { return placeholder; };
        plot.getCanvas = function() { return surface.element; };
        plot.getPlotOffset = function() { return plotOffset; };
        plot.width = function () { return plotWidth; };
        plot.height = function () { return plotHeight; };
        plot.offset = function () {
            var o = eventHolder.offset();
            o.left += plotOffset.left;
            o.top += plotOffset.top;
            return o;
        };
        plot.getData = function () { return series; };
        plot.getAxes = function () {
            var res = {}, i;
            $.each(xaxes.concat(yaxes), function (_, axis) {
                if (axis)
                    res[axis.direction + (axis.n != 1 ? axis.n : "") + "axis"] = axis;
            });
            return res;
        };
        plot.getXAxes = function () { return xaxes; };
        plot.getYAxes = function () { return yaxes; };
        plot.c2p = canvasToAxisCoords;
        plot.p2c = axisToCanvasCoords;
        plot.getOptions = function () { return options; };
        plot.highlight = highlight;
        plot.unhighlight = unhighlight;
        plot.triggerRedrawOverlay = triggerRedrawOverlay;
        plot.pointOffset = function(point) {
            return {
                left: parseInt(xaxes[axisNumber(point, "x") - 1].p2c(+point.x) + plotOffset.left, 10),
                top: parseInt(yaxes[axisNumber(point, "y") - 1].p2c(+point.y) + plotOffset.top, 10)
            };
        };
        plot.shutdown = shutdown;
        plot.destroy = function () {
            shutdown();
            placeholder.removeData("plot").empty();

            series = [];
            options = null;
            surface = null;
            overlay = null;
            eventHolder = null;
            ctx = null;
            octx = null;
            xaxes = [];
            yaxes = [];
            hooks = null;
            highlights = [];
            plot = null;
        };
        plot.resize = function () {
        	var width = placeholder.width(),
        		height = placeholder.height();
            surface.resize(width, height);
            overlay.resize(width, height);
        };

        // public attributes
        plot.hooks = hooks;

        // initialize
        initPlugins(plot);
        parseOptions(options_);
        setupCanvases();
        setData(data_);
        setupGrid();
        draw();
        bindEvents();


        function executeHooks(hook, args) {
            args = [plot].concat(args);
            for (var i = 0; i < hook.length; ++i)
                hook[i].apply(this, args);
        }

        function initPlugins() {

            // References to key classes, allowing plugins to modify them

            var classes = {
                Canvas: Canvas
            };

            for (var i = 0; i < plugins.length; ++i) {
                var p = plugins[i];
                p.init(plot, classes);
                if (p.options)
                    $.extend(true, options, p.options);
            }
        }

        function parseOptions(opts) {

            $.extend(true, options, opts);

            // $.extend merges arrays, rather than replacing them.  When less
            // colors are provided than the size of the default palette, we
            // end up with those colors plus the remaining defaults, which is
            // not expected behavior; avoid it by replacing them here.

            if (opts && opts.colors) {
            	options.colors = opts.colors;
            }

            if (options.xaxis.color == null)
                options.xaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();
            if (options.yaxis.color == null)
                options.yaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();

            if (options.xaxis.tickColor == null) // grid.tickColor for back-compatibility
                options.xaxis.tickColor = options.grid.tickColor || options.xaxis.color;
            if (options.yaxis.tickColor == null) // grid.tickColor for back-compatibility
                options.yaxis.tickColor = options.grid.tickColor || options.yaxis.color;

            if (options.grid.borderColor == null)
                options.grid.borderColor = options.grid.color;
            if (options.grid.tickColor == null)
                options.grid.tickColor = $.color.parse(options.grid.color).scale('a', 0.22).toString();

            // Fill in defaults for axis options, including any unspecified
            // font-spec fields, if a font-spec was provided.

            // If no x/y axis options were provided, create one of each anyway,
            // since the rest of the code assumes that they exist.

            var i, axisOptions, axisCount,
                fontSize = placeholder.css("font-size"),
                fontSizeDefault = fontSize ? +fontSize.replace("px", "") : 13,
                fontDefaults = {
                    style: placeholder.css("font-style"),
                    size: Math.round(0.8 * fontSizeDefault),
                    variant: placeholder.css("font-variant"),
                    weight: placeholder.css("font-weight"),
                    family: placeholder.css("font-family")
                };

            axisCount = options.xaxes.length || 1;
            for (i = 0; i < axisCount; ++i) {

                axisOptions = options.xaxes[i];
                if (axisOptions && !axisOptions.tickColor) {
                    axisOptions.tickColor = axisOptions.color;
                }

                axisOptions = $.extend(true, {}, options.xaxis, axisOptions);
                options.xaxes[i] = axisOptions;

                if (axisOptions.font) {
                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
                    if (!axisOptions.font.color) {
                        axisOptions.font.color = axisOptions.color;
                    }
                    if (!axisOptions.font.lineHeight) {
                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
                    }
                }
            }

            axisCount = options.yaxes.length || 1;
            for (i = 0; i < axisCount; ++i) {

                axisOptions = options.yaxes[i];
                if (axisOptions && !axisOptions.tickColor) {
                    axisOptions.tickColor = axisOptions.color;
                }

                axisOptions = $.extend(true, {}, options.yaxis, axisOptions);
                options.yaxes[i] = axisOptions;

                if (axisOptions.font) {
                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
                    if (!axisOptions.font.color) {
                        axisOptions.font.color = axisOptions.color;
                    }
                    if (!axisOptions.font.lineHeight) {
                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
                    }
                }
            }

            // backwards compatibility, to be removed in future
            if (options.xaxis.noTicks && options.xaxis.ticks == null)
                options.xaxis.ticks = options.xaxis.noTicks;
            if (options.yaxis.noTicks && options.yaxis.ticks == null)
                options.yaxis.ticks = options.yaxis.noTicks;
            if (options.x2axis) {
                options.xaxes[1] = $.extend(true, {}, options.xaxis, options.x2axis);
                options.xaxes[1].position = "top";
                // Override the inherit to allow the axis to auto-scale
                if (options.x2axis.min == null) {
                    options.xaxes[1].min = null;
                }
                if (options.x2axis.max == null) {
                    options.xaxes[1].max = null;
                }
            }
            if (options.y2axis) {
                options.yaxes[1] = $.extend(true, {}, options.yaxis, options.y2axis);
                options.yaxes[1].position = "right";
                // Override the inherit to allow the axis to auto-scale
                if (options.y2axis.min == null) {
                    options.yaxes[1].min = null;
                }
                if (options.y2axis.max == null) {
                    options.yaxes[1].max = null;
                }
            }
            if (options.grid.coloredAreas)
                options.grid.markings = options.grid.coloredAreas;
            if (options.grid.coloredAreasColor)
                options.grid.markingsColor = options.grid.coloredAreasColor;
            if (options.lines)
                $.extend(true, options.series.lines, options.lines);
            if (options.points)
                $.extend(true, options.series.points, options.points);
            if (options.bars)
                $.extend(true, options.series.bars, options.bars);
            if (options.shadowSize != null)
                options.series.shadowSize = options.shadowSize;
            if (options.highlightColor != null)
                options.series.highlightColor = options.highlightColor;

            // save options on axes for future reference
            for (i = 0; i < options.xaxes.length; ++i)
                getOrCreateAxis(xaxes, i + 1).options = options.xaxes[i];
            for (i = 0; i < options.yaxes.length; ++i)
                getOrCreateAxis(yaxes, i + 1).options = options.yaxes[i];

            // add hooks from options
            for (var n in hooks)
                if (options.hooks[n] && options.hooks[n].length)
                    hooks[n] = hooks[n].concat(options.hooks[n]);

            executeHooks(hooks.processOptions, [options]);
        }

        function setData(d) {
            series = parseData(d);
            fillInSeriesOptions();
            processData();
        }

        function parseData(d) {
            var res = [];
            for (var i = 0; i < d.length; ++i) {
                var s = $.extend(true, {}, options.series);

                if (d[i].data != null) {
                    s.data = d[i].data; // move the data instead of deep-copy
                    delete d[i].data;

                    $.extend(true, s, d[i]);

                    d[i].data = s.data;
                }
                else
                    s.data = d[i];
                res.push(s);
            }

            return res;
        }

        function axisNumber(obj, coord) {
            var a = obj[coord + "axis"];
            if (typeof a == "object") // if we got a real axis, extract number
                a = a.n;
            if (typeof a != "number")
                a = 1; // default to first axis
            return a;
        }

        function allAxes() {
            // return flat array without annoying null entries
            return $.grep(xaxes.concat(yaxes), function (a) { return a; });
        }

        function canvasToAxisCoords(pos) {
            // return an object with x/y corresponding to all used axes
            var res = {}, i, axis;
            for (i = 0; i < xaxes.length; ++i) {
                axis = xaxes[i];
                if (axis && axis.used)
                    res["x" + axis.n] = axis.c2p(pos.left);
            }

            for (i = 0; i < yaxes.length; ++i) {
                axis = yaxes[i];
                if (axis && axis.used)
                    res["y" + axis.n] = axis.c2p(pos.top);
            }

            if (res.x1 !== undefined)
                res.x = res.x1;
            if (res.y1 !== undefined)
                res.y = res.y1;

            return res;
        }

        function axisToCanvasCoords(pos) {
            // get canvas coords from the first pair of x/y found in pos
            var res = {}, i, axis, key;

            for (i = 0; i < xaxes.length; ++i) {
                axis = xaxes[i];
                if (axis && axis.used) {
                    key = "x" + axis.n;
                    if (pos[key] == null && axis.n == 1)
                        key = "x";

                    if (pos[key] != null) {
                        res.left = axis.p2c(pos[key]);
                        break;
                    }
                }
            }

            for (i = 0; i < yaxes.length; ++i) {
                axis = yaxes[i];
                if (axis && axis.used) {
                    key = "y" + axis.n;
                    if (pos[key] == null && axis.n == 1)
                        key = "y";

                    if (pos[key] != null) {
                        res.top = axis.p2c(pos[key]);
                        break;
                    }
                }
            }

            return res;
        }

        function getOrCreateAxis(axes, number) {
            if (!axes[number - 1])
                axes[number - 1] = {
                    n: number, // save the number for future reference
                    direction: axes == xaxes ? "x" : "y",
                    options: $.extend(true, {}, axes == xaxes ? options.xaxis : options.yaxis)
                };

            return axes[number - 1];
        }

        function fillInSeriesOptions() {

            var neededColors = series.length, maxIndex = -1, i;

            // Subtract the number of series that already have fixed colors or
            // color indexes from the number that we still need to generate.

            for (i = 0; i < series.length; ++i) {
                var sc = series[i].color;
                if (sc != null) {
                    neededColors--;
                    if (typeof sc == "number" && sc > maxIndex) {
                        maxIndex = sc;
                    }
                }
            }

            // If any of the series have fixed color indexes, then we need to
            // generate at least as many colors as the highest index.

            if (neededColors <= maxIndex) {
                neededColors = maxIndex + 1;
            }

            // Generate all the colors, using first the option colors and then
            // variations on those colors once they're exhausted.

            var c, colors = [], colorPool = options.colors,
                colorPoolSize = colorPool.length, variation = 0;

            for (i = 0; i < neededColors; i++) {

                c = $.color.parse(colorPool[i % colorPoolSize] || "#666");

                // Each time we exhaust the colors in the pool we adjust
                // a scaling factor used to produce more variations on
                // those colors. The factor alternates negative/positive
                // to produce lighter/darker colors.

                // Reset the variation after every few cycles, or else
                // it will end up producing only white or black colors.

                if (i % colorPoolSize == 0 && i) {
                    if (variation >= 0) {
                        if (variation < 0.5) {
                            variation = -variation - 0.2;
                        } else variation = 0;
                    } else variation = -variation;
                }

                colors[i] = c.scale('rgb', 1 + variation);
            }

            // Finalize the series options, filling in their colors

            var colori = 0, s;
            for (i = 0; i < series.length; ++i) {
                s = series[i];

                // assign colors
                if (s.color == null) {
                    s.color = colors[colori].toString();
                    ++colori;
                }
                else if (typeof s.color == "number")
                    s.color = colors[s.color].toString();

                // turn on lines automatically in case nothing is set
                if (s.lines.show == null) {
                    var v, show = true;
                    for (v in s)
                        if (s[v] && s[v].show) {
                            show = false;
                            break;
                        }
                    if (show)
                        s.lines.show = true;
                }

                // If nothing was provided for lines.zero, default it to match
                // lines.fill, since areas by default should extend to zero.

                if (s.lines.zero == null) {
                    s.lines.zero = !!s.lines.fill;
                }

                // setup axes
                s.xaxis = getOrCreateAxis(xaxes, axisNumber(s, "x"));
                s.yaxis = getOrCreateAxis(yaxes, axisNumber(s, "y"));
            }
        }

        function processData() {
            var topSentry = Number.POSITIVE_INFINITY,
                bottomSentry = Number.NEGATIVE_INFINITY,
                fakeInfinity = Number.MAX_VALUE,
                i, j, k, m, length,
                s, points, ps, x, y, axis, val, f, p,
                data, format;

            function updateAxis(axis, min, max) {
                if (min < axis.datamin && min != -fakeInfinity)
                    axis.datamin = min;
                if (max > axis.datamax && max != fakeInfinity)
                    axis.datamax = max;
            }

            $.each(allAxes(), function (_, axis) {
                // init axis
                axis.datamin = topSentry;
                axis.datamax = bottomSentry;
                axis.used = false;
            });

            for (i = 0; i < series.length; ++i) {
                s = series[i];
                s.datapoints = { points: [] };

                executeHooks(hooks.processRawData, [ s, s.data, s.datapoints ]);
            }

            // first pass: clean and copy data
            for (i = 0; i < series.length; ++i) {
                s = series[i];

                data = s.data;
                format = s.datapoints.format;

                if (!format) {
                    format = [];
                    // find out how to copy
                    format.push({ x: true, number: true, required: true });
                    format.push({ y: true, number: true, required: true });

                    if (s.bars.show || (s.lines.show && s.lines.fill)) {
                        var autoscale = !!((s.bars.show && s.bars.zero) || (s.lines.show && s.lines.zero));
                        format.push({ y: true, number: true, required: false, defaultValue: 0, autoscale: autoscale });
                        if (s.bars.horizontal) {
                            delete format[format.length - 1].y;
                            format[format.length - 1].x = true;
                        }
                    }

                    s.datapoints.format = format;
                }

                if (s.datapoints.pointsize != null)
                    continue; // already filled in

                s.datapoints.pointsize = format.length;

                ps = s.datapoints.pointsize;
                points = s.datapoints.points;

                var insertSteps = s.lines.show && s.lines.steps;
                s.xaxis.used = s.yaxis.used = true;

                for (j = k = 0; j < data.length; ++j, k += ps) {
                    p = data[j];

                    var nullify = p == null;
                    if (!nullify) {
                        for (m = 0; m < ps; ++m) {
                            val = p[m];
                            f = format[m];

                            if (f) {
                                if (f.number && val != null) {
                                    val = +val; // convert to number
                                    if (isNaN(val))
                                        val = null;
                                    else if (val == Infinity)
                                        val = fakeInfinity;
                                    else if (val == -Infinity)
                                        val = -fakeInfinity;
                                }

                                if (val == null) {
                                    if (f.required)
                                        nullify = true;

                                    if (f.defaultValue != null)
                                        val = f.defaultValue;
                                }
                            }

                            points[k + m] = val;
                        }
                    }

                    if (nullify) {
                        for (m = 0; m < ps; ++m) {
                            val = points[k + m];
                            if (val != null) {
                                f = format[m];
                                // extract min/max info
                                if (f.autoscale !== false) {
                                    if (f.x) {
                                        updateAxis(s.xaxis, val, val);
                                    }
                                    if (f.y) {
                                        updateAxis(s.yaxis, val, val);
                                    }
                                }
                            }
                            points[k + m] = null;
                        }
                    }
                    else {
                        // a little bit of line specific stuff that
                        // perhaps shouldn't be here, but lacking
                        // better means...
                        if (insertSteps && k > 0
                            && points[k - ps] != null
                            && points[k - ps] != points[k]
                            && points[k - ps + 1] != points[k + 1]) {
                            // copy the point to make room for a middle point
                            for (m = 0; m < ps; ++m)
                                points[k + ps + m] = points[k + m];

                            // middle point has same y
                            points[k + 1] = points[k - ps + 1];

                            // we've added a point, better reflect that
                            k += ps;
                        }
                    }
                }
            }

            // give the hooks a chance to run
            for (i = 0; i < series.length; ++i) {
                s = series[i];

                executeHooks(hooks.processDatapoints, [ s, s.datapoints]);
            }

            // second pass: find datamax/datamin for auto-scaling
            for (i = 0; i < series.length; ++i) {
                s = series[i];
                points = s.datapoints.points;
                ps = s.datapoints.pointsize;
                format = s.datapoints.format;

                var xmin = topSentry, ymin = topSentry,
                    xmax = bottomSentry, ymax = bottomSentry;

                for (j = 0; j < points.length; j += ps) {
                    if (points[j] == null)
                        continue;

                    for (m = 0; m < ps; ++m) {
                        val = points[j + m];
                        f = format[m];
                        if (!f || f.autoscale === false || val == fakeInfinity || val == -fakeInfinity)
                            continue;

                        if (f.x) {
                            if (val < xmin)
                                xmin = val;
                            if (val > xmax)
                                xmax = val;
                        }
                        if (f.y) {
                            if (val < ymin)
                                ymin = val;
                            if (val > ymax)
                                ymax = val;
                        }
                    }
                }

                if (s.bars.show) {
                    // make sure we got room for the bar on the dancing floor
                    var delta;

                    switch (s.bars.align) {
                        case "left":
                            delta = 0;
                            break;
                        case "right":
                            delta = -s.bars.barWidth;
                            break;
                        default:
                            delta = -s.bars.barWidth / 2;
                    }

                    if (s.bars.horizontal) {
                        ymin += delta;
                        ymax += delta + s.bars.barWidth;
                    }
                    else {
                        xmin += delta;
                        xmax += delta + s.bars.barWidth;
                    }
                }

                updateAxis(s.xaxis, xmin, xmax);
                updateAxis(s.yaxis, ymin, ymax);
            }

            $.each(allAxes(), function (_, axis) {
                if (axis.datamin == topSentry)
                    axis.datamin = null;
                if (axis.datamax == bottomSentry)
                    axis.datamax = null;
            });
        }

        function setupCanvases() {

            // Make sure the placeholder is clear of everything except canvases
            // from a previous plot in this container that we'll try to re-use.

            placeholder.css("padding", 0) // padding messes up the positioning
                .children().filter(function(){
                    return !$(this).hasClass("flot-overlay") && !$(this).hasClass('flot-base');
                }).remove();

            if (placeholder.css("position") == 'static')
                placeholder.css("position", "relative"); // for positioning labels and overlay

            surface = new Canvas("flot-base", placeholder);
            overlay = new Canvas("flot-overlay", placeholder); // overlay canvas for interactive features

            ctx = surface.context;
            octx = overlay.context;

            // define which element we're listening for events on
            eventHolder = $(overlay.element).unbind();

            // If we're re-using a plot object, shut down the old one

            var existing = placeholder.data("plot");

            if (existing) {
                existing.shutdown();
                overlay.clear();
            }

            // save in case we get replotted
            placeholder.data("plot", plot);
        }

        function bindEvents() {
            // bind events
            if (options.grid.hoverable) {
                eventHolder.mousemove(onMouseMove);

                // Use bind, rather than .mouseleave, because we officially
                // still support jQuery 1.2.6, which doesn't define a shortcut
                // for mouseenter or mouseleave.  This was a bug/oversight that
                // was fixed somewhere around 1.3.x.  We can return to using
                // .mouseleave when we drop support for 1.2.6.

                eventHolder.bind("mouseleave", onMouseLeave);
            }

            if (options.grid.clickable)
                eventHolder.click(onClick);

            executeHooks(hooks.bindEvents, [eventHolder]);
        }

        function shutdown() {
            if (redrawTimeout)
                clearTimeout(redrawTimeout);

            eventHolder.unbind("mousemove", onMouseMove);
            eventHolder.unbind("mouseleave", onMouseLeave);
            eventHolder.unbind("click", onClick);

            executeHooks(hooks.shutdown, [eventHolder]);
        }

        function setTransformationHelpers(axis) {
            // set helper functions on the axis, assumes plot area
            // has been computed already

            function identity(x) { return x; }

            var s, m, t = axis.options.transform || identity,
                it = axis.options.inverseTransform;

            // precompute how much the axis is scaling a point
            // in canvas space
            if (axis.direction == "x") {
                s = axis.scale = plotWidth / Math.abs(t(axis.max) - t(axis.min));
                m = Math.min(t(axis.max), t(axis.min));
            }
            else {
                s = axis.scale = plotHeight / Math.abs(t(axis.max) - t(axis.min));
                s = -s;
                m = Math.max(t(axis.max), t(axis.min));
            }

            // data point to canvas coordinate
            if (t == identity) // slight optimization
                axis.p2c = function (p) { return (p - m) * s; };
            else
                axis.p2c = function (p) { return (t(p) - m) * s; };
            // canvas coordinate to data point
            if (!it)
                axis.c2p = function (c) { return m + c / s; };
            else
                axis.c2p = function (c) { return it(m + c / s); };
        }

        function measureTickLabels(axis) {

            var opts = axis.options,
                ticks = axis.ticks || [],
                labelWidth = opts.labelWidth || 0,
                labelHeight = opts.labelHeight || 0,
                maxWidth = labelWidth || (axis.direction == "x" ? Math.floor(surface.width / (ticks.length || 1)) : null),
                legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
                layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
                font = opts.font || "flot-tick-label tickLabel";

            for (var i = 0; i < ticks.length; ++i) {

                var t = ticks[i];

                if (!t.label)
                    continue;

                var info = surface.getTextInfo(layer, t.label, font, null, maxWidth);

                labelWidth = Math.max(labelWidth, info.width);
                labelHeight = Math.max(labelHeight, info.height);
            }

            axis.labelWidth = opts.labelWidth || labelWidth;
            axis.labelHeight = opts.labelHeight || labelHeight;
        }

        function allocateAxisBoxFirstPhase(axis) {
            // find the bounding box of the axis by looking at label
            // widths/heights and ticks, make room by diminishing the
            // plotOffset; this first phase only looks at one
            // dimension per axis, the other dimension depends on the
            // other axes so will have to wait

            var lw = axis.labelWidth,
                lh = axis.labelHeight,
                pos = axis.options.position,
                isXAxis = axis.direction === "x",
                tickLength = axis.options.tickLength,
                axisMargin = options.grid.axisMargin,
                padding = options.grid.labelMargin,
                innermost = true,
                outermost = true,
                first = true,
                found = false;

            // Determine the axis's position in its direction and on its side

            $.each(isXAxis ? xaxes : yaxes, function(i, a) {
                if (a && (a.show || a.reserveSpace)) {
                    if (a === axis) {
                        found = true;
                    } else if (a.options.position === pos) {
                        if (found) {
                            outermost = false;
                        } else {
                            innermost = false;
                        }
                    }
                    if (!found) {
                        first = false;
                    }
                }
            });

            // The outermost axis on each side has no margin

            if (outermost) {
                axisMargin = 0;
            }

            // The ticks for the first axis in each direction stretch across

            if (tickLength == null) {
                tickLength = first ? "full" : 5;
            }

            if (!isNaN(+tickLength))
                padding += +tickLength;

            if (isXAxis) {
                lh += padding;

                if (pos == "bottom") {
                    plotOffset.bottom += lh + axisMargin;
                    axis.box = { top: surface.height - plotOffset.bottom, height: lh };
                }
                else {
                    axis.box = { top: plotOffset.top + axisMargin, height: lh };
                    plotOffset.top += lh + axisMargin;
                }
            }
            else {
                lw += padding;

                if (pos == "left") {
                    axis.box = { left: plotOffset.left + axisMargin, width: lw };
                    plotOffset.left += lw + axisMargin;
                }
                else {
                    plotOffset.right += lw + axisMargin;
                    axis.box = { left: surface.width - plotOffset.right, width: lw };
                }
            }

             // save for future reference
            axis.position = pos;
            axis.tickLength = tickLength;
            axis.box.padding = padding;
            axis.innermost = innermost;
        }

        function allocateAxisBoxSecondPhase(axis) {
            // now that all axis boxes have been placed in one
            // dimension, we can set the remaining dimension coordinates
            if (axis.direction == "x") {
                axis.box.left = plotOffset.left - axis.labelWidth / 2;
                axis.box.width = surface.width - plotOffset.left - plotOffset.right + axis.labelWidth;
            }
            else {
                axis.box.top = plotOffset.top - axis.labelHeight / 2;
                axis.box.height = surface.height - plotOffset.bottom - plotOffset.top + axis.labelHeight;
            }
        }

        function adjustLayoutForThingsStickingOut() {
            // possibly adjust plot offset to ensure everything stays
            // inside the canvas and isn't clipped off

            var minMargin = options.grid.minBorderMargin,
                axis, i;

            // check stuff from the plot (FIXME: this should just read
            // a value from the series, otherwise it's impossible to
            // customize)
            if (minMargin == null) {
                minMargin = 0;
                for (i = 0; i < series.length; ++i)
                    minMargin = Math.max(minMargin, 2 * (series[i].points.radius + series[i].points.lineWidth/2));
            }

            var margins = {
                left: minMargin,
                right: minMargin,
                top: minMargin,
                bottom: minMargin
            };

            // check axis labels, note we don't check the actual
            // labels but instead use the overall width/height to not
            // jump as much around with replots
            $.each(allAxes(), function (_, axis) {
                if (axis.reserveSpace && axis.ticks && axis.ticks.length) {
                    if (axis.direction === "x") {
                        margins.left = Math.max(margins.left, axis.labelWidth / 2);
                        margins.right = Math.max(margins.right, axis.labelWidth / 2);
                    } else {
                        margins.bottom = Math.max(margins.bottom, axis.labelHeight / 2);
                        margins.top = Math.max(margins.top, axis.labelHeight / 2);
                    }
                }
            });

            plotOffset.left = Math.ceil(Math.max(margins.left, plotOffset.left));
            plotOffset.right = Math.ceil(Math.max(margins.right, plotOffset.right));
            plotOffset.top = Math.ceil(Math.max(margins.top, plotOffset.top));
            plotOffset.bottom = Math.ceil(Math.max(margins.bottom, plotOffset.bottom));
        }

        function setupGrid() {
            var i, axes = allAxes(), showGrid = options.grid.show;

            // Initialize the plot's offset from the edge of the canvas

            for (var a in plotOffset) {
                var margin = options.grid.margin || 0;
                plotOffset[a] = typeof margin == "number" ? margin : margin[a] || 0;
            }

            executeHooks(hooks.processOffset, [plotOffset]);

            // If the grid is visible, add its border width to the offset

            for (var a in plotOffset) {
                if(typeof(options.grid.borderWidth) == "object") {
                    plotOffset[a] += showGrid ? options.grid.borderWidth[a] : 0;
                }
                else {
                    plotOffset[a] += showGrid ? options.grid.borderWidth : 0;
                }
            }

            $.each(axes, function (_, axis) {
                var axisOpts = axis.options;
                axis.show = axisOpts.show == null ? axis.used : axisOpts.show;
                axis.reserveSpace = axisOpts.reserveSpace == null ? axis.show : axisOpts.reserveSpace;
                setRange(axis);
            });

            if (showGrid) {

                var allocatedAxes = $.grep(axes, function (axis) {
                    return axis.show || axis.reserveSpace;
                });

                $.each(allocatedAxes, function (_, axis) {
                    // make the ticks
                    setupTickGeneration(axis);
                    setTicks(axis);
                    snapRangeToTicks(axis, axis.ticks);
                    // find labelWidth/Height for axis
                    measureTickLabels(axis);
                });

                // with all dimensions calculated, we can compute the
                // axis bounding boxes, start from the outside
                // (reverse order)
                for (i = allocatedAxes.length - 1; i >= 0; --i)
                    allocateAxisBoxFirstPhase(allocatedAxes[i]);

                // make sure we've got enough space for things that
                // might stick out
                adjustLayoutForThingsStickingOut();

                $.each(allocatedAxes, function (_, axis) {
                    allocateAxisBoxSecondPhase(axis);
                });
            }

            plotWidth = surface.width - plotOffset.left - plotOffset.right;
            plotHeight = surface.height - plotOffset.bottom - plotOffset.top;

            // now we got the proper plot dimensions, we can compute the scaling
            $.each(axes, function (_, axis) {
                setTransformationHelpers(axis);
            });

            if (showGrid) {
                drawAxisLabels();
            }

            insertLegend();
        }

        function setRange(axis) {
            var opts = axis.options,
                min = +(opts.min != null ? opts.min : axis.datamin),
                max = +(opts.max != null ? opts.max : axis.datamax),
                delta = max - min;

            if (delta == 0.0) {
                // degenerate case
                var widen = max == 0 ? 1 : 0.01;

                if (opts.min == null)
                    min -= widen;
                // always widen max if we couldn't widen min to ensure we
                // don't fall into min == max which doesn't work
                if (opts.max == null || opts.min != null)
                    max += widen;
            }
            else {
                // consider autoscaling
                var margin = opts.autoscaleMargin;
                if (margin != null) {
                    if (opts.min == null) {
                        min -= delta * margin;
                        // make sure we don't go below zero if all values
                        // are positive
                        if (min < 0 && axis.datamin != null && axis.datamin >= 0)
                            min = 0;
                    }
                    if (opts.max == null) {
                        max += delta * margin;
                        if (max > 0 && axis.datamax != null && axis.datamax <= 0)
                            max = 0;
                    }
                }
            }
            axis.min = min;
            axis.max = max;
        }

        function setupTickGeneration(axis) {
            var opts = axis.options;

            // estimate number of ticks
            var noTicks;
            if (typeof opts.ticks == "number" && opts.ticks > 0)
                noTicks = opts.ticks;
            else
                // heuristic based on the model a*sqrt(x) fitted to
                // some data points that seemed reasonable
                noTicks = 0.3 * Math.sqrt(axis.direction == "x" ? surface.width : surface.height);

            var delta = (axis.max - axis.min) / noTicks,
                dec = -Math.floor(Math.log(delta) / Math.LN10),
                maxDec = opts.tickDecimals;

            if (maxDec != null && dec > maxDec) {
                dec = maxDec;
            }

            var magn = Math.pow(10, -dec),
                norm = delta / magn, // norm is between 1.0 and 10.0
                size;

            if (norm < 1.5) {
                size = 1;
            } else if (norm < 3) {
                size = 2;
                // special case for 2.5, requires an extra decimal
                if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
                    size = 2.5;
                    ++dec;
                }
            } else if (norm < 7.5) {
                size = 5;
            } else {
                size = 10;
            }

            size *= magn;

            if (opts.minTickSize != null && size < opts.minTickSize) {
                size = opts.minTickSize;
            }

            axis.delta = delta;
            axis.tickDecimals = Math.max(0, maxDec != null ? maxDec : dec);
            axis.tickSize = opts.tickSize || size;

            // Time mode was moved to a plug-in in 0.8, and since so many people use it
            // we'll add an especially friendly reminder to make sure they included it.

            if (opts.mode == "time" && !axis.tickGenerator) {
                throw new Error("Time mode requires the flot.time plugin.");
            }

            // Flot supports base-10 axes; any other mode else is handled by a plug-in,
            // like flot.time.js.

            if (!axis.tickGenerator) {

                axis.tickGenerator = function (axis) {

                    var ticks = [],
                        start = floorInBase(axis.min, axis.tickSize),
                        i = 0,
                        v = Number.NaN,
                        prev;

                    do {
                        prev = v;
                        v = start + i * axis.tickSize;
                        ticks.push(v);
                        ++i;
                    } while (v < axis.max && v != prev);
                    return ticks;
                };

				axis.tickFormatter = function (value, axis) {

					var factor = axis.tickDecimals ? Math.pow(10, axis.tickDecimals) : 1;
					var formatted = "" + Math.round(value * factor) / factor;

					// If tickDecimals was specified, ensure that we have exactly that
					// much precision; otherwise default to the value's own precision.

					if (axis.tickDecimals != null) {
						var decimal = formatted.indexOf(".");
						var precision = decimal == -1 ? 0 : formatted.length - decimal - 1;
						if (precision < axis.tickDecimals) {
							return (precision ? formatted : formatted + ".") + ("" + factor).substr(1, axis.tickDecimals - precision);
						}
					}

                    return formatted;
                };
            }

            if ($.isFunction(opts.tickFormatter))
                axis.tickFormatter = function (v, axis) { return "" + opts.tickFormatter(v, axis); };

            if (opts.alignTicksWithAxis != null) {
                var otherAxis = (axis.direction == "x" ? xaxes : yaxes)[opts.alignTicksWithAxis - 1];
                if (otherAxis && otherAxis.used && otherAxis != axis) {
                    // consider snapping min/max to outermost nice ticks
                    var niceTicks = axis.tickGenerator(axis);
                    if (niceTicks.length > 0) {
                        if (opts.min == null)
                            axis.min = Math.min(axis.min, niceTicks[0]);
                        if (opts.max == null && niceTicks.length > 1)
                            axis.max = Math.max(axis.max, niceTicks[niceTicks.length - 1]);
                    }

                    axis.tickGenerator = function (axis) {
                        // copy ticks, scaled to this axis
                        var ticks = [], v, i;
                        for (i = 0; i < otherAxis.ticks.length; ++i) {
                            v = (otherAxis.ticks[i].v - otherAxis.min) / (otherAxis.max - otherAxis.min);
                            v = axis.min + v * (axis.max - axis.min);
                            ticks.push(v);
                        }
                        return ticks;
                    };

                    // we might need an extra decimal since forced
                    // ticks don't necessarily fit naturally
                    if (!axis.mode && opts.tickDecimals == null) {
                        var extraDec = Math.max(0, -Math.floor(Math.log(axis.delta) / Math.LN10) + 1),
                            ts = axis.tickGenerator(axis);

                        // only proceed if the tick interval rounded
                        // with an extra decimal doesn't give us a
                        // zero at end
                        if (!(ts.length > 1 && /\..*0$/.test((ts[1] - ts[0]).toFixed(extraDec))))
                            axis.tickDecimals = extraDec;
                    }
                }
            }
        }

        function setTicks(axis) {
            var oticks = axis.options.ticks, ticks = [];
            if (oticks == null || (typeof oticks == "number" && oticks > 0))
                ticks = axis.tickGenerator(axis);
            else if (oticks) {
                if ($.isFunction(oticks))
                    // generate the ticks
                    ticks = oticks(axis);
                else
                    ticks = oticks;
            }

            // clean up/labelify the supplied ticks, copy them over
            var i, v;
            axis.ticks = [];
            for (i = 0; i < ticks.length; ++i) {
                var label = null;
                var t = ticks[i];
                if (typeof t == "object") {
                    v = +t[0];
                    if (t.length > 1)
                        label = t[1];
                }
                else
                    v = +t;
                if (label == null)
                    label = axis.tickFormatter(v, axis);
                if (!isNaN(v))
                    axis.ticks.push({ v: v, label: label });
            }
        }

        function snapRangeToTicks(axis, ticks) {
            if (axis.options.autoscaleMargin && ticks.length > 0) {
                // snap to ticks
                if (axis.options.min == null)
                    axis.min = Math.min(axis.min, ticks[0].v);
                if (axis.options.max == null && ticks.length > 1)
                    axis.max = Math.max(axis.max, ticks[ticks.length - 1].v);
            }
        }

        function draw() {

            surface.clear();

            executeHooks(hooks.drawBackground, [ctx]);

            var grid = options.grid;

            // draw background, if any
            if (grid.show && grid.backgroundColor)
                drawBackground();

            if (grid.show && !grid.aboveData) {
                drawGrid();
            }

            for (var i = 0; i < series.length; ++i) {
                executeHooks(hooks.drawSeries, [ctx, series[i]]);
                drawSeries(series[i]);
            }

            executeHooks(hooks.draw, [ctx]);

            if (grid.show && grid.aboveData) {
                drawGrid();
            }

            surface.render();

            // A draw implies that either the axes or data have changed, so we
            // should probably update the overlay highlights as well.

            triggerRedrawOverlay();
        }

        function extractRange(ranges, coord) {
            var axis, from, to, key, axes = allAxes();

            for (var i = 0; i < axes.length; ++i) {
                axis = axes[i];
                if (axis.direction == coord) {
                    key = coord + axis.n + "axis";
                    if (!ranges[key] && axis.n == 1)
                        key = coord + "axis"; // support x1axis as xaxis
                    if (ranges[key]) {
                        from = ranges[key].from;
                        to = ranges[key].to;
                        break;
                    }
                }
            }

            // backwards-compat stuff - to be removed in future
            if (!ranges[key]) {
                axis = coord == "x" ? xaxes[0] : yaxes[0];
                from = ranges[coord + "1"];
                to = ranges[coord + "2"];
            }

            // auto-reverse as an added bonus
            if (from != null && to != null && from > to) {
                var tmp = from;
                from = to;
                to = tmp;
            }

            return { from: from, to: to, axis: axis };
        }

        function drawBackground() {
            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            ctx.fillStyle = getColorOrGradient(options.grid.backgroundColor, plotHeight, 0, "rgba(255, 255, 255, 0)");
            ctx.fillRect(0, 0, plotWidth, plotHeight);
            ctx.restore();
        }

        function drawGrid() {
            var i, axes, bw, bc;

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            // draw markings
            var markings = options.grid.markings;
            if (markings) {
                if ($.isFunction(markings)) {
                    axes = plot.getAxes();
                    // xmin etc. is backwards compatibility, to be
                    // removed in the future
                    axes.xmin = axes.xaxis.min;
                    axes.xmax = axes.xaxis.max;
                    axes.ymin = axes.yaxis.min;
                    axes.ymax = axes.yaxis.max;

                    markings = markings(axes);
                }

                for (i = 0; i < markings.length; ++i) {
                    var m = markings[i],
                        xrange = extractRange(m, "x"),
                        yrange = extractRange(m, "y");

                    // fill in missing
                    if (xrange.from == null)
                        xrange.from = xrange.axis.min;
                    if (xrange.to == null)
                        xrange.to = xrange.axis.max;
                    if (yrange.from == null)
                        yrange.from = yrange.axis.min;
                    if (yrange.to == null)
                        yrange.to = yrange.axis.max;

                    // clip
                    if (xrange.to < xrange.axis.min || xrange.from > xrange.axis.max ||
                        yrange.to < yrange.axis.min || yrange.from > yrange.axis.max)
                        continue;

                    xrange.from = Math.max(xrange.from, xrange.axis.min);
                    xrange.to = Math.min(xrange.to, xrange.axis.max);
                    yrange.from = Math.max(yrange.from, yrange.axis.min);
                    yrange.to = Math.min(yrange.to, yrange.axis.max);

                    var xequal = xrange.from === xrange.to,
                        yequal = yrange.from === yrange.to;

                    if (xequal && yequal) {
                        continue;
                    }

                    // then draw
                    xrange.from = Math.floor(xrange.axis.p2c(xrange.from));
                    xrange.to = Math.floor(xrange.axis.p2c(xrange.to));
                    yrange.from = Math.floor(yrange.axis.p2c(yrange.from));
                    yrange.to = Math.floor(yrange.axis.p2c(yrange.to));

                    if (xequal || yequal) {
                        var lineWidth = m.lineWidth || options.grid.markingsLineWidth,
                            subPixel = lineWidth % 2 ? 0.5 : 0;
                        ctx.beginPath();
                        ctx.strokeStyle = m.color || options.grid.markingsColor;
                        ctx.lineWidth = lineWidth;
                        if (xequal) {
                            ctx.moveTo(xrange.to + subPixel, yrange.from);
                            ctx.lineTo(xrange.to + subPixel, yrange.to);
                        } else {
                            ctx.moveTo(xrange.from, yrange.to + subPixel);
                            ctx.lineTo(xrange.to, yrange.to + subPixel);                            
                        }
                        ctx.stroke();
                    } else {
                        ctx.fillStyle = m.color || options.grid.markingsColor;
                        ctx.fillRect(xrange.from, yrange.to,
                                     xrange.to - xrange.from,
                                     yrange.from - yrange.to);
                    }
                }
            }

            // draw the ticks
            axes = allAxes();
            bw = options.grid.borderWidth;

            for (var j = 0; j < axes.length; ++j) {
                var axis = axes[j], box = axis.box,
                    t = axis.tickLength, x, y, xoff, yoff;
                if (!axis.show || axis.ticks.length == 0)
                    continue;

                ctx.lineWidth = 1;

                // find the edges
                if (axis.direction == "x") {
                    x = 0;
                    if (t == "full")
                        y = (axis.position == "top" ? 0 : plotHeight);
                    else
                        y = box.top - plotOffset.top + (axis.position == "top" ? box.height : 0);
                }
                else {
                    y = 0;
                    if (t == "full")
                        x = (axis.position == "left" ? 0 : plotWidth);
                    else
                        x = box.left - plotOffset.left + (axis.position == "left" ? box.width : 0);
                }

                // draw tick bar
                if (!axis.innermost) {
                    ctx.strokeStyle = axis.options.color;
                    ctx.beginPath();
                    xoff = yoff = 0;
                    if (axis.direction == "x")
                        xoff = plotWidth + 1;
                    else
                        yoff = plotHeight + 1;

                    if (ctx.lineWidth == 1) {
                        if (axis.direction == "x") {
                            y = Math.floor(y) + 0.5;
                        } else {
                            x = Math.floor(x) + 0.5;
                        }
                    }

                    ctx.moveTo(x, y);
                    ctx.lineTo(x + xoff, y + yoff);
                    ctx.stroke();
                }

                // draw ticks

                ctx.strokeStyle = axis.options.tickColor;

                ctx.beginPath();
                for (i = 0; i < axis.ticks.length; ++i) {
                    var v = axis.ticks[i].v;

                    xoff = yoff = 0;

                    if (isNaN(v) || v < axis.min || v > axis.max
                        // skip those lying on the axes if we got a border
                        || (t == "full"
                            && ((typeof bw == "object" && bw[axis.position] > 0) || bw > 0)
                            && (v == axis.min || v == axis.max)))
                        continue;

                    if (axis.direction == "x") {
                        x = axis.p2c(v);
                        yoff = t == "full" ? -plotHeight : t;

                        if (axis.position == "top")
                            yoff = -yoff;
                    }
                    else {
                        y = axis.p2c(v);
                        xoff = t == "full" ? -plotWidth : t;

                        if (axis.position == "left")
                            xoff = -xoff;
                    }

                    if (ctx.lineWidth == 1) {
                        if (axis.direction == "x")
                            x = Math.floor(x) + 0.5;
                        else
                            y = Math.floor(y) + 0.5;
                    }

                    ctx.moveTo(x, y);
                    ctx.lineTo(x + xoff, y + yoff);
                }

                ctx.stroke();
            }


            // draw border
            if (bw) {
                // If either borderWidth or borderColor is an object, then draw the border
                // line by line instead of as one rectangle
                bc = options.grid.borderColor;
                if(typeof bw == "object" || typeof bc == "object") {
                    if (typeof bw !== "object") {
                        bw = {top: bw, right: bw, bottom: bw, left: bw};
                    }
                    if (typeof bc !== "object") {
                        bc = {top: bc, right: bc, bottom: bc, left: bc};
                    }

                    if (bw.top > 0) {
                        ctx.strokeStyle = bc.top;
                        ctx.lineWidth = bw.top;
                        ctx.beginPath();
                        ctx.moveTo(0 - bw.left, 0 - bw.top/2);
                        ctx.lineTo(plotWidth, 0 - bw.top/2);
                        ctx.stroke();
                    }

                    if (bw.right > 0) {
                        ctx.strokeStyle = bc.right;
                        ctx.lineWidth = bw.right;
                        ctx.beginPath();
                        ctx.moveTo(plotWidth + bw.right / 2, 0 - bw.top);
                        ctx.lineTo(plotWidth + bw.right / 2, plotHeight);
                        ctx.stroke();
                    }

                    if (bw.bottom > 0) {
                        ctx.strokeStyle = bc.bottom;
                        ctx.lineWidth = bw.bottom;
                        ctx.beginPath();
                        ctx.moveTo(plotWidth + bw.right, plotHeight + bw.bottom / 2);
                        ctx.lineTo(0, plotHeight + bw.bottom / 2);
                        ctx.stroke();
                    }

                    if (bw.left > 0) {
                        ctx.strokeStyle = bc.left;
                        ctx.lineWidth = bw.left;
                        ctx.beginPath();
                        ctx.moveTo(0 - bw.left/2, plotHeight + bw.bottom);
                        ctx.lineTo(0- bw.left/2, 0);
                        ctx.stroke();
                    }
                }
                else {
                    ctx.lineWidth = bw;
                    ctx.strokeStyle = options.grid.borderColor;
                    ctx.strokeRect(-bw/2, -bw/2, plotWidth + bw, plotHeight + bw);
                }
            }

            ctx.restore();
        }

        function drawAxisLabels() {

            $.each(allAxes(), function (_, axis) {
                var box = axis.box,
                    legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
                    layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
                    font = axis.options.font || "flot-tick-label tickLabel",
                    tick, x, y, halign, valign;

                // Remove text before checking for axis.show and ticks.length;
                // otherwise plugins, like flot-tickrotor, that draw their own
                // tick labels will end up with both theirs and the defaults.

                surface.removeText(layer);

                if (!axis.show || axis.ticks.length == 0)
                    return;

                for (var i = 0; i < axis.ticks.length; ++i) {

                    tick = axis.ticks[i];
                    if (!tick.label || tick.v < axis.min || tick.v > axis.max)
                        continue;

                    if (axis.direction == "x") {
                        halign = "center";
                        x = plotOffset.left + axis.p2c(tick.v);
                        if (axis.position == "bottom") {
                            y = box.top + box.padding;
                        } else {
                            y = box.top + box.height - box.padding;
                            valign = "bottom";
                        }
                    } else {
                        valign = "middle";
                        y = plotOffset.top + axis.p2c(tick.v);
                        if (axis.position == "left") {
                            x = box.left + box.width - box.padding;
                            halign = "right";
                        } else {
                            x = box.left + box.padding;
                        }
                    }

                    surface.addText(layer, x, y, tick.label, font, null, null, halign, valign);
                }
            });
        }

        function drawSeries(series) {
            if (series.lines.show)
                drawSeriesLines(series);
            if (series.bars.show)
                drawSeriesBars(series);
            if (series.points.show)
                drawSeriesPoints(series);
        }

        function drawSeriesLines(series) {
            function plotLine(datapoints, xoffset, yoffset, axisx, axisy) {
                var points = datapoints.points,
                    ps = datapoints.pointsize,
                    prevx = null, prevy = null;

                ctx.beginPath();
                for (var i = ps; i < points.length; i += ps) {
                    var x1 = points[i - ps], y1 = points[i - ps + 1],
                        x2 = points[i], y2 = points[i + 1];

                    if (x1 == null || x2 == null)
                        continue;

                    // clip with ymin
                    if (y1 <= y2 && y1 < axisy.min) {
                        if (y2 < axisy.min)
                            continue;   // line segment is outside
                        // compute new intersection point
                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.min;
                    }
                    else if (y2 <= y1 && y2 < axisy.min) {
                        if (y1 < axisy.min)
                            continue;
                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.min;
                    }

                    // clip with ymax
                    if (y1 >= y2 && y1 > axisy.max) {
                        if (y2 > axisy.max)
                            continue;
                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.max;
                    }
                    else if (y2 >= y1 && y2 > axisy.max) {
                        if (y1 > axisy.max)
                            continue;
                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.max;
                    }

                    // clip with xmin
                    if (x1 <= x2 && x1 < axisx.min) {
                        if (x2 < axisx.min)
                            continue;
                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.min;
                    }
                    else if (x2 <= x1 && x2 < axisx.min) {
                        if (x1 < axisx.min)
                            continue;
                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.min;
                    }

                    // clip with xmax
                    if (x1 >= x2 && x1 > axisx.max) {
                        if (x2 > axisx.max)
                            continue;
                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.max;
                    }
                    else if (x2 >= x1 && x2 > axisx.max) {
                        if (x1 > axisx.max)
                            continue;
                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.max;
                    }

                    if (x1 != prevx || y1 != prevy)
                        ctx.moveTo(axisx.p2c(x1) + xoffset, axisy.p2c(y1) + yoffset);

                    prevx = x2;
                    prevy = y2;
                    ctx.lineTo(axisx.p2c(x2) + xoffset, axisy.p2c(y2) + yoffset);
                }
                ctx.stroke();
            }

            function plotLineArea(datapoints, axisx, axisy) {
                var points = datapoints.points,
                    ps = datapoints.pointsize,
                    bottom = Math.min(Math.max(0, axisy.min), axisy.max),
                    i = 0, top, areaOpen = false,
                    ypos = 1, segmentStart = 0, segmentEnd = 0;

                // we process each segment in two turns, first forward
                // direction to sketch out top, then once we hit the
                // end we go backwards to sketch the bottom
                while (true) {
                    if (ps > 0 && i > points.length + ps)
                        break;

                    i += ps; // ps is negative if going backwards

                    var x1 = points[i - ps],
                        y1 = points[i - ps + ypos],
                        x2 = points[i], y2 = points[i + ypos];

                    if (areaOpen) {
                        if (ps > 0 && x1 != null && x2 == null) {
                            // at turning point
                            segmentEnd = i;
                            ps = -ps;
                            ypos = 2;
                            continue;
                        }

                        if (ps < 0 && i == segmentStart + ps) {
                            // done with the reverse sweep
                            ctx.fill();
                            areaOpen = false;
                            ps = -ps;
                            ypos = 1;
                            i = segmentStart = segmentEnd + ps;
                            continue;
                        }
                    }

                    if (x1 == null || x2 == null)
                        continue;

                    // clip x values

                    // clip with xmin
                    if (x1 <= x2 && x1 < axisx.min) {
                        if (x2 < axisx.min)
                            continue;
                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.min;
                    }
                    else if (x2 <= x1 && x2 < axisx.min) {
                        if (x1 < axisx.min)
                            continue;
                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.min;
                    }

                    // clip with xmax
                    if (x1 >= x2 && x1 > axisx.max) {
                        if (x2 > axisx.max)
                            continue;
                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.max;
                    }
                    else if (x2 >= x1 && x2 > axisx.max) {
                        if (x1 > axisx.max)
                            continue;
                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.max;
                    }

                    if (!areaOpen) {
                        // open area
                        ctx.beginPath();
                        ctx.moveTo(axisx.p2c(x1), axisy.p2c(bottom));
                        areaOpen = true;
                    }

                    // now first check the case where both is outside
                    if (y1 >= axisy.max && y2 >= axisy.max) {
                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.max));
                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.max));
                        continue;
                    }
                    else if (y1 <= axisy.min && y2 <= axisy.min) {
                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.min));
                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.min));
                        continue;
                    }

                    // else it's a bit more complicated, there might
                    // be a flat maxed out rectangle first, then a
                    // triangular cutout or reverse; to find these
                    // keep track of the current x values
                    var x1old = x1, x2old = x2;

                    // clip the y values, without shortcutting, we
                    // go through all cases in turn

                    // clip with ymin
                    if (y1 <= y2 && y1 < axisy.min && y2 >= axisy.min) {
                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.min;
                    }
                    else if (y2 <= y1 && y2 < axisy.min && y1 >= axisy.min) {
                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.min;
                    }

                    // clip with ymax
                    if (y1 >= y2 && y1 > axisy.max && y2 <= axisy.max) {
                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.max;
                    }
                    else if (y2 >= y1 && y2 > axisy.max && y1 <= axisy.max) {
                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.max;
                    }

                    // if the x value was changed we got a rectangle
                    // to fill
                    if (x1 != x1old) {
                        ctx.lineTo(axisx.p2c(x1old), axisy.p2c(y1));
                        // it goes to (x1, y1), but we fill that below
                    }

                    // fill triangular section, this sometimes result
                    // in redundant points if (x1, y1) hasn't changed
                    // from previous line to, but we just ignore that
                    ctx.lineTo(axisx.p2c(x1), axisy.p2c(y1));
                    ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));

                    // fill the other rectangle if it's there
                    if (x2 != x2old) {
                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
                        ctx.lineTo(axisx.p2c(x2old), axisy.p2c(y2));
                    }
                }
            }

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);
            ctx.lineJoin = "round";

            var lw = series.lines.lineWidth,
                sw = series.shadowSize;
            // FIXME: consider another form of shadow when filling is turned on
            if (lw > 0 && sw > 0) {
                // draw shadow as a thick and thin line with transparency
                ctx.lineWidth = sw;
                ctx.strokeStyle = "rgba(0,0,0,0.1)";
                // position shadow at angle from the mid of line
                var angle = Math.PI/18;
                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/2), Math.cos(angle) * (lw/2 + sw/2), series.xaxis, series.yaxis);
                ctx.lineWidth = sw/2;
                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/4), Math.cos(angle) * (lw/2 + sw/4), series.xaxis, series.yaxis);
            }

            ctx.lineWidth = lw;
            ctx.strokeStyle = series.color;
            var fillStyle = getFillStyle(series.lines, series.color, 0, plotHeight);
            if (fillStyle) {
                ctx.fillStyle = fillStyle;
                plotLineArea(series.datapoints, series.xaxis, series.yaxis);
            }

            if (lw > 0)
                plotLine(series.datapoints, 0, 0, series.xaxis, series.yaxis);
            ctx.restore();
        }

        function drawSeriesPoints(series) {
            function plotPoints(datapoints, radius, fillStyle, offset, shadow, axisx, axisy, symbol) {
                var points = datapoints.points, ps = datapoints.pointsize;

                for (var i = 0; i < points.length; i += ps) {
                    var x = points[i], y = points[i + 1];
                    if (x == null || x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
                        continue;

                    ctx.beginPath();
                    x = axisx.p2c(x);
                    y = axisy.p2c(y) + offset;
                    if (symbol == "circle")
                        ctx.arc(x, y, radius, 0, shadow ? Math.PI : Math.PI * 2, false);
                    else
                        symbol(ctx, x, y, radius, shadow);
                    ctx.closePath();

                    if (fillStyle) {
                        ctx.fillStyle = fillStyle;
                        ctx.fill();
                    }
                    ctx.stroke();
                }
            }

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            var lw = series.points.lineWidth,
                sw = series.shadowSize,
                radius = series.points.radius,
                symbol = series.points.symbol;

            // If the user sets the line width to 0, we change it to a very 
            // small value. A line width of 0 seems to force the default of 1.
            // Doing the conditional here allows the shadow setting to still be 
            // optional even with a lineWidth of 0.

            if( lw == 0 )
                lw = 0.0001;

            if (lw > 0 && sw > 0) {
                // draw shadow in two steps
                var w = sw / 2;
                ctx.lineWidth = w;
                ctx.strokeStyle = "rgba(0,0,0,0.1)";
                plotPoints(series.datapoints, radius, null, w + w/2, true,
                           series.xaxis, series.yaxis, symbol);

                ctx.strokeStyle = "rgba(0,0,0,0.2)";
                plotPoints(series.datapoints, radius, null, w/2, true,
                           series.xaxis, series.yaxis, symbol);
            }

            ctx.lineWidth = lw;
            ctx.strokeStyle = series.color;
            plotPoints(series.datapoints, radius,
                       getFillStyle(series.points, series.color), 0, false,
                       series.xaxis, series.yaxis, symbol);
            ctx.restore();
        }

        function drawBar(x, y, b, barLeft, barRight, fillStyleCallback, axisx, axisy, c, horizontal, lineWidth) {
            var left, right, bottom, top,
                drawLeft, drawRight, drawTop, drawBottom,
                tmp;

            // in horizontal mode, we start the bar from the left
            // instead of from the bottom so it appears to be
            // horizontal rather than vertical
            if (horizontal) {
                drawBottom = drawRight = drawTop = true;
                drawLeft = false;
                left = b;
                right = x;
                top = y + barLeft;
                bottom = y + barRight;

                // account for negative bars
                if (right < left) {
                    tmp = right;
                    right = left;
                    left = tmp;
                    drawLeft = true;
                    drawRight = false;
                }
            }
            else {
                drawLeft = drawRight = drawTop = true;
                drawBottom = false;
                left = x + barLeft;
                right = x + barRight;
                bottom = b;
                top = y;

                // account for negative bars
                if (top < bottom) {
                    tmp = top;
                    top = bottom;
                    bottom = tmp;
                    drawBottom = true;
                    drawTop = false;
                }
            }

            // clip
            if (right < axisx.min || left > axisx.max ||
                top < axisy.min || bottom > axisy.max)
                return;

            if (left < axisx.min) {
                left = axisx.min;
                drawLeft = false;
            }

            if (right > axisx.max) {
                right = axisx.max;
                drawRight = false;
            }

            if (bottom < axisy.min) {
                bottom = axisy.min;
                drawBottom = false;
            }

            if (top > axisy.max) {
                top = axisy.max;
                drawTop = false;
            }

            left = axisx.p2c(left);
            bottom = axisy.p2c(bottom);
            right = axisx.p2c(right);
            top = axisy.p2c(top);

            // fill the bar
            if (fillStyleCallback) {
                c.fillStyle = fillStyleCallback(bottom, top);
                c.fillRect(left, top, right - left, bottom - top)
            }

            // draw outline
            if (lineWidth > 0 && (drawLeft || drawRight || drawTop || drawBottom)) {
                c.beginPath();

                // FIXME: inline moveTo is buggy with excanvas
                c.moveTo(left, bottom);
                if (drawLeft)
                    c.lineTo(left, top);
                else
                    c.moveTo(left, top);
                if (drawTop)
                    c.lineTo(right, top);
                else
                    c.moveTo(right, top);
                if (drawRight)
                    c.lineTo(right, bottom);
                else
                    c.moveTo(right, bottom);
                if (drawBottom)
                    c.lineTo(left, bottom);
                else
                    c.moveTo(left, bottom);
                c.stroke();
            }
        }

        function drawSeriesBars(series) {
            function plotBars(datapoints, barLeft, barRight, fillStyleCallback, axisx, axisy) {
                var points = datapoints.points, ps = datapoints.pointsize;

                for (var i = 0; i < points.length; i += ps) {
                    if (points[i] == null)
                        continue;
                    drawBar(points[i], points[i + 1], points[i + 2], barLeft, barRight, fillStyleCallback, axisx, axisy, ctx, series.bars.horizontal, series.bars.lineWidth);
                }
            }

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            // FIXME: figure out a way to add shadows (for instance along the right edge)
            ctx.lineWidth = series.bars.lineWidth;
            ctx.strokeStyle = series.color;

            var barLeft;

            switch (series.bars.align) {
                case "left":
                    barLeft = 0;
                    break;
                case "right":
                    barLeft = -series.bars.barWidth;
                    break;
                default:
                    barLeft = -series.bars.barWidth / 2;
            }

            var fillStyleCallback = series.bars.fill ? function (bottom, top) { return getFillStyle(series.bars, series.color, bottom, top); } : null;
            plotBars(series.datapoints, barLeft, barLeft + series.bars.barWidth, fillStyleCallback, series.xaxis, series.yaxis);
            ctx.restore();
        }

        function getFillStyle(filloptions, seriesColor, bottom, top) {
            var fill = filloptions.fill;
            if (!fill)
                return null;

            if (filloptions.fillColor)
                return getColorOrGradient(filloptions.fillColor, bottom, top, seriesColor);

            var c = $.color.parse(seriesColor);
            c.a = typeof fill == "number" ? fill : 0.4;
            c.normalize();
            return c.toString();
        }

        function insertLegend() {

            if (options.legend.container != null) {
                $(options.legend.container).html("");
            } else {
                placeholder.find(".legend").remove();
            }

            if (!options.legend.show) {
                return;
            }

            var fragments = [], entries = [], rowStarted = false,
                lf = options.legend.labelFormatter, s, label;

            // Build a list of legend entries, with each having a label and a color

            for (var i = 0; i < series.length; ++i) {
                s = series[i];
                if (s.label) {
                    label = lf ? lf(s.label, s) : s.label;
                    if (label) {
                        entries.push({
                            label: label,
                            color: s.color
                        });
                    }
                }
            }

            // Sort the legend using either the default or a custom comparator

            if (options.legend.sorted) {
                if ($.isFunction(options.legend.sorted)) {
                    entries.sort(options.legend.sorted);
                } else if (options.legend.sorted == "reverse") {
                	entries.reverse();
                } else {
                    var ascending = options.legend.sorted != "descending";
                    entries.sort(function(a, b) {
                        return a.label == b.label ? 0 : (
                            (a.label < b.label) != ascending ? 1 : -1   // Logical XOR
                        );
                    });
                }
            }

            // Generate markup for the list of entries, in their final order

            for (var i = 0; i < entries.length; ++i) {

                var entry = entries[i];

                if (i % options.legend.noColumns == 0) {
                    if (rowStarted)
                        fragments.push('</tr>');
                    fragments.push('<tr>');
                    rowStarted = true;
                }

                fragments.push(
                    '<td class="legendColorBox"><div style="border:1px solid ' + options.legend.labelBoxBorderColor + ';padding:1px"><div style="width:4px;height:0;border:5px solid ' + entry.color + ';overflow:hidden"></div></div></td>' +
                    '<td class="legendLabel">' + entry.label + '</td>'
                );
            }

            if (rowStarted)
                fragments.push('</tr>');

            if (fragments.length == 0)
                return;

            var table = '<table style="font-size:smaller;color:' + options.grid.color + '">' + fragments.join("") + '</table>';
            if (options.legend.container != null)
                $(options.legend.container).html(table);
            else {
                var pos = "",
                    p = options.legend.position,
                    m = options.legend.margin;
                if (m[0] == null)
                    m = [m, m];
                if (p.charAt(0) == "n")
                    pos += 'top:' + (m[1] + plotOffset.top) + 'px;';
                else if (p.charAt(0) == "s")
                    pos += 'bottom:' + (m[1] + plotOffset.bottom) + 'px;';
                if (p.charAt(1) == "e")
                    pos += 'right:' + (m[0] + plotOffset.right) + 'px;';
                else if (p.charAt(1) == "w")
                    pos += 'left:' + (m[0] + plotOffset.left) + 'px;';
                var legend = $('<div class="legend">' + table.replace('style="', 'style="position:absolute;' + pos +';') + '</div>').appendTo(placeholder);
                if (options.legend.backgroundOpacity != 0.0) {
                    // put in the transparent background
                    // separately to avoid blended labels and
                    // label boxes
                    var c = options.legend.backgroundColor;
                    if (c == null) {
                        c = options.grid.backgroundColor;
                        if (c && typeof c == "string")
                            c = $.color.parse(c);
                        else
                            c = $.color.extract(legend, 'background-color');
                        c.a = 1;
                        c = c.toString();
                    }
                    var div = legend.children();
                    $('<div style="position:absolute;width:' + div.width() + 'px;height:' + div.height() + 'px;' + pos +'background-color:' + c + ';"> </div>').prependTo(legend).css('opacity', options.legend.backgroundOpacity);
                }
            }
        }


        // interactive features

        var highlights = [],
            redrawTimeout = null;

        // returns the data item the mouse is over, or null if none is found
        function findNearbyItem(mouseX, mouseY, seriesFilter) {
            var maxDistance = options.grid.mouseActiveRadius,
                smallestDistance = maxDistance * maxDistance + 1,
                item = null, foundPoint = false, i, j, ps;

            for (i = series.length - 1; i >= 0; --i) {
                if (!seriesFilter(series[i]))
                    continue;

                var s = series[i],
                    axisx = s.xaxis,
                    axisy = s.yaxis,
                    points = s.datapoints.points,
                    mx = axisx.c2p(mouseX), // precompute some stuff to make the loop faster
                    my = axisy.c2p(mouseY),
                    maxx = maxDistance / axisx.scale,
                    maxy = maxDistance / axisy.scale;

                ps = s.datapoints.pointsize;
                // with inverse transforms, we can't use the maxx/maxy
                // optimization, sadly
                if (axisx.options.inverseTransform)
                    maxx = Number.MAX_VALUE;
                if (axisy.options.inverseTransform)
                    maxy = Number.MAX_VALUE;

                if (s.lines.show || s.points.show) {
                    for (j = 0; j < points.length; j += ps) {
                        var x = points[j], y = points[j + 1];
                        if (x == null)
                            continue;

                        // For points and lines, the cursor must be within a
                        // certain distance to the data point
                        if (x - mx > maxx || x - mx < -maxx ||
                            y - my > maxy || y - my < -maxy)
                            continue;

                        // We have to calculate distances in pixels, not in
                        // data units, because the scales of the axes may be different
                        var dx = Math.abs(axisx.p2c(x) - mouseX),
                            dy = Math.abs(axisy.p2c(y) - mouseY),
                            dist = dx * dx + dy * dy; // we save the sqrt

                        // use <= to ensure last point takes precedence
                        // (last generally means on top of)
                        if (dist < smallestDistance) {
                            smallestDistance = dist;
                            item = [i, j / ps];
                        }
                    }
                }

                if (s.bars.show && !item) { // no other point can be nearby

                    var barLeft, barRight;

                    switch (s.bars.align) {
                        case "left":
                            barLeft = 0;
                            break;
                        case "right":
                            barLeft = -s.bars.barWidth;
                            break;
                        default:
                            barLeft = -s.bars.barWidth / 2;
                    }

                    barRight = barLeft + s.bars.barWidth;

                    for (j = 0; j < points.length; j += ps) {
                        var x = points[j], y = points[j + 1], b = points[j + 2];
                        if (x == null)
                            continue;

                        // for a bar graph, the cursor must be inside the bar
                        if (series[i].bars.horizontal ?
                            (mx <= Math.max(b, x) && mx >= Math.min(b, x) &&
                             my >= y + barLeft && my <= y + barRight) :
                            (mx >= x + barLeft && mx <= x + barRight &&
                             my >= Math.min(b, y) && my <= Math.max(b, y)))
                                item = [i, j / ps];
                    }
                }
            }

            if (item) {
                i = item[0];
                j = item[1];
                ps = series[i].datapoints.pointsize;

                return { datapoint: series[i].datapoints.points.slice(j * ps, (j + 1) * ps),
                         dataIndex: j,
                         series: series[i],
                         seriesIndex: i };
            }

            return null;
        }

        function onMouseMove(e) {
            if (options.grid.hoverable)
                triggerClickHoverEvent("plothover", e,
                                       function (s) { return s["hoverable"] != false; });
        }

        function onMouseLeave(e) {
            if (options.grid.hoverable)
                triggerClickHoverEvent("plothover", e,
                                       function (s) { return false; });
        }

        function onClick(e) {
            triggerClickHoverEvent("plotclick", e,
                                   function (s) { return s["clickable"] != false; });
        }

        // trigger click or hover event (they send the same parameters
        // so we share their code)
        function triggerClickHoverEvent(eventname, event, seriesFilter) {
            var offset = eventHolder.offset(),
                canvasX = event.pageX - offset.left - plotOffset.left,
                canvasY = event.pageY - offset.top - plotOffset.top,
            pos = canvasToAxisCoords({ left: canvasX, top: canvasY });

            pos.pageX = event.pageX;
            pos.pageY = event.pageY;

            var item = findNearbyItem(canvasX, canvasY, seriesFilter);

            if (item) {
                // fill in mouse pos for any listeners out there
                item.pageX = parseInt(item.series.xaxis.p2c(item.datapoint[0]) + offset.left + plotOffset.left, 10);
                item.pageY = parseInt(item.series.yaxis.p2c(item.datapoint[1]) + offset.top + plotOffset.top, 10);
            }

            if (options.grid.autoHighlight) {
                // clear auto-highlights
                for (var i = 0; i < highlights.length; ++i) {
                    var h = highlights[i];
                    if (h.auto == eventname &&
                        !(item && h.series == item.series &&
                          h.point[0] == item.datapoint[0] &&
                          h.point[1] == item.datapoint[1]))
                        unhighlight(h.series, h.point);
                }

                if (item)
                    highlight(item.series, item.datapoint, eventname);
            }

            placeholder.trigger(eventname, [ pos, item ]);
        }

        function triggerRedrawOverlay() {
            var t = options.interaction.redrawOverlayInterval;
            if (t == -1) {      // skip event queue
                drawOverlay();
                return;
            }

            if (!redrawTimeout)
                redrawTimeout = setTimeout(drawOverlay, t);
        }

        function drawOverlay() {
            redrawTimeout = null;

            // draw highlights
            octx.save();
            overlay.clear();
            octx.translate(plotOffset.left, plotOffset.top);

            var i, hi;
            for (i = 0; i < highlights.length; ++i) {
                hi = highlights[i];

                if (hi.series.bars.show)
                    drawBarHighlight(hi.series, hi.point);
                else
                    drawPointHighlight(hi.series, hi.point);
            }
            octx.restore();

            executeHooks(hooks.drawOverlay, [octx]);
        }

        function highlight(s, point, auto) {
            if (typeof s == "number")
                s = series[s];

            if (typeof point == "number") {
                var ps = s.datapoints.pointsize;
                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
            }

            var i = indexOfHighlight(s, point);
            if (i == -1) {
                highlights.push({ series: s, point: point, auto: auto });

                triggerRedrawOverlay();
            }
            else if (!auto)
                highlights[i].auto = false;
        }

        function unhighlight(s, point) {
            if (s == null && point == null) {
                highlights = [];
                triggerRedrawOverlay();
                return;
            }

            if (typeof s == "number")
                s = series[s];

            if (typeof point == "number") {
                var ps = s.datapoints.pointsize;
                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
            }

            var i = indexOfHighlight(s, point);
            if (i != -1) {
                highlights.splice(i, 1);

                triggerRedrawOverlay();
            }
        }

        function indexOfHighlight(s, p) {
            for (var i = 0; i < highlights.length; ++i) {
                var h = highlights[i];
                if (h.series == s && h.point[0] == p[0]
                    && h.point[1] == p[1])
                    return i;
            }
            return -1;
        }

        function drawPointHighlight(series, point) {
            var x = point[0], y = point[1],
                axisx = series.xaxis, axisy = series.yaxis,
                highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString();

            if (x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
                return;

            var pointRadius = series.points.radius + series.points.lineWidth / 2;
            octx.lineWidth = pointRadius;
            octx.strokeStyle = highlightColor;
            var radius = 1.5 * pointRadius;
            x = axisx.p2c(x);
            y = axisy.p2c(y);

            octx.beginPath();
            if (series.points.symbol == "circle")
                octx.arc(x, y, radius, 0, 2 * Math.PI, false);
            else
                series.points.symbol(octx, x, y, radius, false);
            octx.closePath();
            octx.stroke();
        }

        function drawBarHighlight(series, point) {
            var highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString(),
                fillStyle = highlightColor,
                barLeft;

            switch (series.bars.align) {
                case "left":
                    barLeft = 0;
                    break;
                case "right":
                    barLeft = -series.bars.barWidth;
                    break;
                default:
                    barLeft = -series.bars.barWidth / 2;
            }

            octx.lineWidth = series.bars.lineWidth;
            octx.strokeStyle = highlightColor;

            drawBar(point[0], point[1], point[2] || 0, barLeft, barLeft + series.bars.barWidth,
                    function () { return fillStyle; }, series.xaxis, series.yaxis, octx, series.bars.horizontal, series.bars.lineWidth);
        }

        function getColorOrGradient(spec, bottom, top, defaultColor) {
            if (typeof spec == "string")
                return spec;
            else {
                // assume this is a gradient spec; IE currently only
                // supports a simple vertical gradient properly, so that's
                // what we support too
                var gradient = ctx.createLinearGradient(0, top, 0, bottom);

                for (var i = 0, l = spec.colors.length; i < l; ++i) {
                    var c = spec.colors[i];
                    if (typeof c != "string") {
                        var co = $.color.parse(defaultColor);
                        if (c.brightness != null)
                            co = co.scale('rgb', c.brightness);
                        if (c.opacity != null)
                            co.a *= c.opacity;
                        c = co.toString();
                    }
                    gradient.addColorStop(i / (l - 1), c);
                }

                return gradient;
            }
        }
    }

    // Add the plot function to the top level of the jQuery object

    $.plot = function(placeholder, data, options) {
        //var t0 = new Date();
        var plot = new Plot($(placeholder), data, options, $.plot.plugins);
        //(window.console ? console.log : alert)("time used (msecs): " + ((new Date()).getTime() - t0.getTime()));
        return plot;
    };

    $.plot.version = "0.8.3";

    $.plot.plugins = [];

    // Also add the plot function as a chainable property

    $.fn.plot = function(data, options) {
        return this.each(function() {
            $.plot(this, data, options);
        });
    };

    // round to nearby lower multiple of base
    function floorInBase(n, base) {
        return base * Math.floor(n / base);
    }

})(jQuery);

},{}],12:[function(require,module,exports){
/* Flot plugin for rendering pie charts.

Copyright (c) 2007-2014 IOLA and Ole Laursen.
Licensed under the MIT license.

The plugin assumes that each series has a single data value, and that each
value is a positive integer or zero.  Negative numbers don't make sense for a
pie chart, and have unpredictable results.  The values do NOT need to be
passed in as percentages; the plugin will calculate the total and per-slice
percentages internally.

* Created by Brian Medendorp

* Updated with contributions from btburnett3, Anthony Aragues and Xavi Ivars

The plugin supports these options:

	series: {
		pie: {
			show: true/false
			radius: 0-1 for percentage of fullsize, or a specified pixel length, or 'auto'
			innerRadius: 0-1 for percentage of fullsize or a specified pixel length, for creating a donut effect
			startAngle: 0-2 factor of PI used for starting angle (in radians) i.e 3/2 starts at the top, 0 and 2 have the same result
			tilt: 0-1 for percentage to tilt the pie, where 1 is no tilt, and 0 is completely flat (nothing will show)
			offset: {
				top: integer value to move the pie up or down
				left: integer value to move the pie left or right, or 'auto'
			},
			stroke: {
				color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#FFF')
				width: integer pixel width of the stroke
			},
			label: {
				show: true/false, or 'auto'
				formatter:  a user-defined function that modifies the text/style of the label text
				radius: 0-1 for percentage of fullsize, or a specified pixel length
				background: {
					color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#000')
					opacity: 0-1
				},
				threshold: 0-1 for the percentage value at which to hide labels (if they're too small)
			},
			combine: {
				threshold: 0-1 for the percentage value at which to combine slices (if they're too small)
				color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#CCC'), if null, the plugin will automatically use the color of the first slice to be combined
				label: any text value of what the combined slice should be labeled
			}
			highlight: {
				opacity: 0-1
			}
		}
	}

More detail and specific examples can be found in the included HTML file.

*/

(function($) {

	// Maximum redraw attempts when fitting labels within the plot

	var REDRAW_ATTEMPTS = 10;

	// Factor by which to shrink the pie when fitting labels within the plot

	var REDRAW_SHRINK = 0.95;

	function init(plot) {

		var canvas = null,
			target = null,
			options = null,
			maxRadius = null,
			centerLeft = null,
			centerTop = null,
			processed = false,
			ctx = null;

		// interactive variables

		var highlights = [];

		// add hook to determine if pie plugin in enabled, and then perform necessary operations

		plot.hooks.processOptions.push(function(plot, options) {
			if (options.series.pie.show) {

				options.grid.show = false;

				// set labels.show

				if (options.series.pie.label.show == "auto") {
					if (options.legend.show) {
						options.series.pie.label.show = false;
					} else {
						options.series.pie.label.show = true;
					}
				}

				// set radius

				if (options.series.pie.radius == "auto") {
					if (options.series.pie.label.show) {
						options.series.pie.radius = 3/4;
					} else {
						options.series.pie.radius = 1;
					}
				}

				// ensure sane tilt

				if (options.series.pie.tilt > 1) {
					options.series.pie.tilt = 1;
				} else if (options.series.pie.tilt < 0) {
					options.series.pie.tilt = 0;
				}
			}
		});

		plot.hooks.bindEvents.push(function(plot, eventHolder) {
			var options = plot.getOptions();
			if (options.series.pie.show) {
				if (options.grid.hoverable) {
					eventHolder.unbind("mousemove").mousemove(onMouseMove);
				}
				if (options.grid.clickable) {
					eventHolder.unbind("click").click(onClick);
				}
			}
		});

		plot.hooks.processDatapoints.push(function(plot, series, data, datapoints) {
			var options = plot.getOptions();
			if (options.series.pie.show) {
				processDatapoints(plot, series, data, datapoints);
			}
		});

		plot.hooks.drawOverlay.push(function(plot, octx) {
			var options = plot.getOptions();
			if (options.series.pie.show) {
				drawOverlay(plot, octx);
			}
		});

		plot.hooks.draw.push(function(plot, newCtx) {
			var options = plot.getOptions();
			if (options.series.pie.show) {
				draw(plot, newCtx);
			}
		});

		function processDatapoints(plot, series, datapoints) {
			if (!processed)	{
				processed = true;
				canvas = plot.getCanvas();
				target = $(canvas).parent();
				options = plot.getOptions();
				plot.setData(combine(plot.getData()));
			}
		}

		function combine(data) {

			var total = 0,
				combined = 0,
				numCombined = 0,
				color = options.series.pie.combine.color,
				newdata = [];

			// Fix up the raw data from Flot, ensuring the data is numeric

			for (var i = 0; i < data.length; ++i) {

				var value = data[i].data;

				// If the data is an array, we'll assume that it's a standard
				// Flot x-y pair, and are concerned only with the second value.

				// Note how we use the original array, rather than creating a
				// new one; this is more efficient and preserves any extra data
				// that the user may have stored in higher indexes.

				if ($.isArray(value) && value.length == 1) {
    				value = value[0];
				}

				if ($.isArray(value)) {
					// Equivalent to $.isNumeric() but compatible with jQuery < 1.7
					if (!isNaN(parseFloat(value[1])) && isFinite(value[1])) {
						value[1] = +value[1];
					} else {
						value[1] = 0;
					}
				} else if (!isNaN(parseFloat(value)) && isFinite(value)) {
					value = [1, +value];
				} else {
					value = [1, 0];
				}

				data[i].data = [value];
			}

			// Sum up all the slices, so we can calculate percentages for each

			for (var i = 0; i < data.length; ++i) {
				total += data[i].data[0][1];
			}

			// Count the number of slices with percentages below the combine
			// threshold; if it turns out to be just one, we won't combine.

			for (var i = 0; i < data.length; ++i) {
				var value = data[i].data[0][1];
				if (value / total <= options.series.pie.combine.threshold) {
					combined += value;
					numCombined++;
					if (!color) {
						color = data[i].color;
					}
				}
			}

			for (var i = 0; i < data.length; ++i) {
				var value = data[i].data[0][1];
				if (numCombined < 2 || value / total > options.series.pie.combine.threshold) {
					newdata.push(
						$.extend(data[i], {     /* extend to allow keeping all other original data values
						                           and using them e.g. in labelFormatter. */
							data: [[1, value]],
							color: data[i].color,
							label: data[i].label,
							angle: value * Math.PI * 2 / total,
							percent: value / (total / 100)
						})
					);
				}
			}

			if (numCombined > 1) {
				newdata.push({
					data: [[1, combined]],
					color: color,
					label: options.series.pie.combine.label,
					angle: combined * Math.PI * 2 / total,
					percent: combined / (total / 100)
				});
			}

			return newdata;
		}

		function draw(plot, newCtx) {

			if (!target) {
				return; // if no series were passed
			}

			var canvasWidth = plot.getPlaceholder().width(),
				canvasHeight = plot.getPlaceholder().height(),
				legendWidth = target.children().filter(".legend").children().width() || 0;

			ctx = newCtx;

			// WARNING: HACK! REWRITE THIS CODE AS SOON AS POSSIBLE!

			// When combining smaller slices into an 'other' slice, we need to
			// add a new series.  Since Flot gives plugins no way to modify the
			// list of series, the pie plugin uses a hack where the first call
			// to processDatapoints results in a call to setData with the new
			// list of series, then subsequent processDatapoints do nothing.

			// The plugin-global 'processed' flag is used to control this hack;
			// it starts out false, and is set to true after the first call to
			// processDatapoints.

			// Unfortunately this turns future setData calls into no-ops; they
			// call processDatapoints, the flag is true, and nothing happens.

			// To fix this we'll set the flag back to false here in draw, when
			// all series have been processed, so the next sequence of calls to
			// processDatapoints once again starts out with a slice-combine.
			// This is really a hack; in 0.9 we need to give plugins a proper
			// way to modify series before any processing begins.

			processed = false;

			// calculate maximum radius and center point

			maxRadius =  Math.min(canvasWidth, canvasHeight / options.series.pie.tilt) / 2;
			centerTop = canvasHeight / 2 + options.series.pie.offset.top;
			centerLeft = canvasWidth / 2;

			if (options.series.pie.offset.left == "auto") {
				if (options.legend.position.match("w")) {
					centerLeft += legendWidth / 2;
				} else {
					centerLeft -= legendWidth / 2;
				}
				if (centerLeft < maxRadius) {
					centerLeft = maxRadius;
				} else if (centerLeft > canvasWidth - maxRadius) {
					centerLeft = canvasWidth - maxRadius;
				}
			} else {
				centerLeft += options.series.pie.offset.left;
			}

			var slices = plot.getData(),
				attempts = 0;

			// Keep shrinking the pie's radius until drawPie returns true,
			// indicating that all the labels fit, or we try too many times.

			do {
				if (attempts > 0) {
					maxRadius *= REDRAW_SHRINK;
				}
				attempts += 1;
				clear();
				if (options.series.pie.tilt <= 0.8) {
					drawShadow();
				}
			} while (!drawPie() && attempts < REDRAW_ATTEMPTS)

			if (attempts >= REDRAW_ATTEMPTS) {
				clear();
				target.prepend("<div class='error'>Could not draw pie with labels contained inside canvas</div>");
			}

			if (plot.setSeries && plot.insertLegend) {
				plot.setSeries(slices);
				plot.insertLegend();
			}

			// we're actually done at this point, just defining internal functions at this point

			function clear() {
				ctx.clearRect(0, 0, canvasWidth, canvasHeight);
				target.children().filter(".pieLabel, .pieLabelBackground").remove();
			}

			function drawShadow() {

				var shadowLeft = options.series.pie.shadow.left;
				var shadowTop = options.series.pie.shadow.top;
				var edge = 10;
				var alpha = options.series.pie.shadow.alpha;
				var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;

				if (radius >= canvasWidth / 2 - shadowLeft || radius * options.series.pie.tilt >= canvasHeight / 2 - shadowTop || radius <= edge) {
					return;	// shadow would be outside canvas, so don't draw it
				}

				ctx.save();
				ctx.translate(shadowLeft,shadowTop);
				ctx.globalAlpha = alpha;
				ctx.fillStyle = "#000";

				// center and rotate to starting position

				ctx.translate(centerLeft,centerTop);
				ctx.scale(1, options.series.pie.tilt);

				//radius -= edge;

				for (var i = 1; i <= edge; i++) {
					ctx.beginPath();
					ctx.arc(0, 0, radius, 0, Math.PI * 2, false);
					ctx.fill();
					radius -= i;
				}

				ctx.restore();
			}

			function drawPie() {

				var startAngle = Math.PI * options.series.pie.startAngle;
				var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;

				// center and rotate to starting position

				ctx.save();
				ctx.translate(centerLeft,centerTop);
				ctx.scale(1, options.series.pie.tilt);
				//ctx.rotate(startAngle); // start at top; -- This doesn't work properly in Opera

				// draw slices

				ctx.save();
				var currentAngle = startAngle;
				for (var i = 0; i < slices.length; ++i) {
					slices[i].startAngle = currentAngle;
					drawSlice(slices[i].angle, slices[i].color, true);
				}
				ctx.restore();

				// draw slice outlines

				if (options.series.pie.stroke.width > 0) {
					ctx.save();
					ctx.lineWidth = options.series.pie.stroke.width;
					currentAngle = startAngle;
					for (var i = 0; i < slices.length; ++i) {
						drawSlice(slices[i].angle, options.series.pie.stroke.color, false);
					}
					ctx.restore();
				}

				// draw donut hole

				drawDonutHole(ctx);

				ctx.restore();

				// Draw the labels, returning true if they fit within the plot

				if (options.series.pie.label.show) {
					return drawLabels();
				} else return true;

				function drawSlice(angle, color, fill) {

					if (angle <= 0 || isNaN(angle)) {
						return;
					}

					if (fill) {
						ctx.fillStyle = color;
					} else {
						ctx.strokeStyle = color;
						ctx.lineJoin = "round";
					}

					ctx.beginPath();
					if (Math.abs(angle - Math.PI * 2) > 0.000000001) {
						ctx.moveTo(0, 0); // Center of the pie
					}

					//ctx.arc(0, 0, radius, 0, angle, false); // This doesn't work properly in Opera
					ctx.arc(0, 0, radius,currentAngle, currentAngle + angle / 2, false);
					ctx.arc(0, 0, radius,currentAngle + angle / 2, currentAngle + angle, false);
					ctx.closePath();
					//ctx.rotate(angle); // This doesn't work properly in Opera
					currentAngle += angle;

					if (fill) {
						ctx.fill();
					} else {
						ctx.stroke();
					}
				}

				function drawLabels() {

					var currentAngle = startAngle;
					var radius = options.series.pie.label.radius > 1 ? options.series.pie.label.radius : maxRadius * options.series.pie.label.radius;

					for (var i = 0; i < slices.length; ++i) {
						if (slices[i].percent >= options.series.pie.label.threshold * 100) {
							if (!drawLabel(slices[i], currentAngle, i)) {
								return false;
							}
						}
						currentAngle += slices[i].angle;
					}

					return true;

					function drawLabel(slice, startAngle, index) {

						if (slice.data[0][1] == 0) {
							return true;
						}

						// format label text

						var lf = options.legend.labelFormatter, text, plf = options.series.pie.label.formatter;

						if (lf) {
							text = lf(slice.label, slice);
						} else {
							text = slice.label;
						}

						if (plf) {
							text = plf(text, slice);
						}

						var halfAngle = ((startAngle + slice.angle) + startAngle) / 2;
						var x = centerLeft + Math.round(Math.cos(halfAngle) * radius);
						var y = centerTop + Math.round(Math.sin(halfAngle) * radius) * options.series.pie.tilt;

						var html = "<span class='pieLabel' id='pieLabel" + index + "' style='position:absolute;top:" + y + "px;left:" + x + "px;'>" + text + "</span>";
						target.append(html);

						var label = target.children("#pieLabel" + index);
						var labelTop = (y - label.height() / 2);
						var labelLeft = (x - label.width() / 2);

						label.css("top", labelTop);
						label.css("left", labelLeft);

						// check to make sure that the label is not outside the canvas

						if (0 - labelTop > 0 || 0 - labelLeft > 0 || canvasHeight - (labelTop + label.height()) < 0 || canvasWidth - (labelLeft + label.width()) < 0) {
							return false;
						}

						if (options.series.pie.label.background.opacity != 0) {

							// put in the transparent background separately to avoid blended labels and label boxes

							var c = options.series.pie.label.background.color;

							if (c == null) {
								c = slice.color;
							}

							var pos = "top:" + labelTop + "px;left:" + labelLeft + "px;";
							$("<div class='pieLabelBackground' style='position:absolute;width:" + label.width() + "px;height:" + label.height() + "px;" + pos + "background-color:" + c + ";'></div>")
								.css("opacity", options.series.pie.label.background.opacity)
								.insertBefore(label);
						}

						return true;
					} // end individual label function
				} // end drawLabels function
			} // end drawPie function
		} // end draw function

		// Placed here because it needs to be accessed from multiple locations

		function drawDonutHole(layer) {
			if (options.series.pie.innerRadius > 0) {

				// subtract the center

				layer.save();
				var innerRadius = options.series.pie.innerRadius > 1 ? options.series.pie.innerRadius : maxRadius * options.series.pie.innerRadius;
				layer.globalCompositeOperation = "destination-out"; // this does not work with excanvas, but it will fall back to using the stroke color
				layer.beginPath();
				layer.fillStyle = options.series.pie.stroke.color;
				layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
				layer.fill();
				layer.closePath();
				layer.restore();

				// add inner stroke

				layer.save();
				layer.beginPath();
				layer.strokeStyle = options.series.pie.stroke.color;
				layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
				layer.stroke();
				layer.closePath();
				layer.restore();

				// TODO: add extra shadow inside hole (with a mask) if the pie is tilted.
			}
		}

		//-- Additional Interactive related functions --

		function isPointInPoly(poly, pt) {
			for(var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
				((poly[i][1] <= pt[1] && pt[1] < poly[j][1]) || (poly[j][1] <= pt[1] && pt[1]< poly[i][1]))
				&& (pt[0] < (poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1]) / (poly[j][1] - poly[i][1]) + poly[i][0])
				&& (c = !c);
			return c;
		}

		function findNearbySlice(mouseX, mouseY) {

			var slices = plot.getData(),
				options = plot.getOptions(),
				radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius,
				x, y;

			for (var i = 0; i < slices.length; ++i) {

				var s = slices[i];

				if (s.pie.show) {

					ctx.save();
					ctx.beginPath();
					ctx.moveTo(0, 0); // Center of the pie
					//ctx.scale(1, options.series.pie.tilt);	// this actually seems to break everything when here.
					ctx.arc(0, 0, radius, s.startAngle, s.startAngle + s.angle / 2, false);
					ctx.arc(0, 0, radius, s.startAngle + s.angle / 2, s.startAngle + s.angle, false);
					ctx.closePath();
					x = mouseX - centerLeft;
					y = mouseY - centerTop;

					if (ctx.isPointInPath) {
						if (ctx.isPointInPath(mouseX - centerLeft, mouseY - centerTop)) {
							ctx.restore();
							return {
								datapoint: [s.percent, s.data],
								dataIndex: 0,
								series: s,
								seriesIndex: i
							};
						}
					} else {

						// excanvas for IE doesn;t support isPointInPath, this is a workaround.

						var p1X = radius * Math.cos(s.startAngle),
							p1Y = radius * Math.sin(s.startAngle),
							p2X = radius * Math.cos(s.startAngle + s.angle / 4),
							p2Y = radius * Math.sin(s.startAngle + s.angle / 4),
							p3X = radius * Math.cos(s.startAngle + s.angle / 2),
							p3Y = radius * Math.sin(s.startAngle + s.angle / 2),
							p4X = radius * Math.cos(s.startAngle + s.angle / 1.5),
							p4Y = radius * Math.sin(s.startAngle + s.angle / 1.5),
							p5X = radius * Math.cos(s.startAngle + s.angle),
							p5Y = radius * Math.sin(s.startAngle + s.angle),
							arrPoly = [[0, 0], [p1X, p1Y], [p2X, p2Y], [p3X, p3Y], [p4X, p4Y], [p5X, p5Y]],
							arrPoint = [x, y];

						// TODO: perhaps do some mathmatical trickery here with the Y-coordinate to compensate for pie tilt?

						if (isPointInPoly(arrPoly, arrPoint)) {
							ctx.restore();
							return {
								datapoint: [s.percent, s.data],
								dataIndex: 0,
								series: s,
								seriesIndex: i
							};
						}
					}

					ctx.restore();
				}
			}

			return null;
		}

		function onMouseMove(e) {
			triggerClickHoverEvent("plothover", e);
		}

		function onClick(e) {
			triggerClickHoverEvent("plotclick", e);
		}

		// trigger click or hover event (they send the same parameters so we share their code)

		function triggerClickHoverEvent(eventname, e) {

			var offset = plot.offset();
			var canvasX = parseInt(e.pageX - offset.left);
			var canvasY =  parseInt(e.pageY - offset.top);
			var item = findNearbySlice(canvasX, canvasY);

			if (options.grid.autoHighlight) {

				// clear auto-highlights

				for (var i = 0; i < highlights.length; ++i) {
					var h = highlights[i];
					if (h.auto == eventname && !(item && h.series == item.series)) {
						unhighlight(h.series);
					}
				}
			}

			// highlight the slice

			if (item) {
				highlight(item.series, eventname);
			}

			// trigger any hover bind events

			var pos = { pageX: e.pageX, pageY: e.pageY };
			target.trigger(eventname, [pos, item]);
		}

		function highlight(s, auto) {
			//if (typeof s == "number") {
			//	s = series[s];
			//}

			var i = indexOfHighlight(s);

			if (i == -1) {
				highlights.push({ series: s, auto: auto });
				plot.triggerRedrawOverlay();
			} else if (!auto) {
				highlights[i].auto = false;
			}
		}

		function unhighlight(s) {
			if (s == null) {
				highlights = [];
				plot.triggerRedrawOverlay();
			}

			//if (typeof s == "number") {
			//	s = series[s];
			//}

			var i = indexOfHighlight(s);

			if (i != -1) {
				highlights.splice(i, 1);
				plot.triggerRedrawOverlay();
			}
		}

		function indexOfHighlight(s) {
			for (var i = 0; i < highlights.length; ++i) {
				var h = highlights[i];
				if (h.series == s)
					return i;
			}
			return -1;
		}

		function drawOverlay(plot, octx) {

			var options = plot.getOptions();

			var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;

			octx.save();
			octx.translate(centerLeft, centerTop);
			octx.scale(1, options.series.pie.tilt);

			for (var i = 0; i < highlights.length; ++i) {
				drawHighlight(highlights[i].series);
			}

			drawDonutHole(octx);

			octx.restore();

			function drawHighlight(series) {

				if (series.angle <= 0 || isNaN(series.angle)) {
					return;
				}

				//octx.fillStyle = parseColor(options.series.pie.highlight.color).scale(null, null, null, options.series.pie.highlight.opacity).toString();
				octx.fillStyle = "rgba(255, 255, 255, " + options.series.pie.highlight.opacity + ")"; // this is temporary until we have access to parseColor
				octx.beginPath();
				if (Math.abs(series.angle - Math.PI * 2) > 0.000000001) {
					octx.moveTo(0, 0); // Center of the pie
				}
				octx.arc(0, 0, radius, series.startAngle, series.startAngle + series.angle / 2, false);
				octx.arc(0, 0, radius, series.startAngle + series.angle / 2, series.startAngle + series.angle, false);
				octx.closePath();
				octx.fill();
			}
		}
	} // end init (plugin body)

	// define pie specific options and their default values

	var options = {
		series: {
			pie: {
				show: false,
				radius: "auto",	// actual radius of the visible pie (based on full calculated radius if <=1, or hard pixel value)
				innerRadius: 0, /* for donut */
				startAngle: 3/2,
				tilt: 1,
				shadow: {
					left: 5,	// shadow left offset
					top: 15,	// shadow top offset
					alpha: 0.02	// shadow alpha
				},
				offset: {
					top: 0,
					left: "auto"
				},
				stroke: {
					color: "#fff",
					width: 1
				},
				label: {
					show: "auto",
					formatter: function(label, slice) {
						return "<div style='font-size:x-small;text-align:center;padding:2px;color:" + slice.color + ";'>" + label + "<br/>" + Math.round(slice.percent) + "%</div>";
					},	// formatter function
					radius: 1,	// radius at which to place the labels (based on full calculated radius if <=1, or hard pixel value)
					background: {
						color: null,
						opacity: 0
					},
					threshold: 0	// percentage at which to hide the label (i.e. the slice is too narrow)
				},
				combine: {
					threshold: -1,	// percentage at which to combine little slices into one larger slice
					color: null,	// color to give the new slice (auto-generated if null)
					label: "Other"	// label to give the new slice
				},
				highlight: {
					//color: "#fff",		// will add this functionality once parseColor is available
					opacity: 0.5
				}
			}
		}
	};

	$.plot.plugins.push({
		init: init,
		options: options,
		name: "pie",
		version: "1.1"
	});

})(jQuery);

},{}],13:[function(require,module,exports){
/* Pretty handling of time axes.

Copyright (c) 2007-2014 IOLA and Ole Laursen.
Licensed under the MIT license.

Set axis.mode to "time" to enable. See the section "Time series data" in
API.txt for details.

*/

(function($) {

	var options = {
		xaxis: {
			timezone: null,		// "browser" for local to the client or timezone for timezone-js
			timeformat: null,	// format string to use
			twelveHourClock: false,	// 12 or 24 time in time mode
			monthNames: null	// list of names of months
		}
	};

	// round to nearby lower multiple of base

	function floorInBase(n, base) {
		return base * Math.floor(n / base);
	}

	// Returns a string with the date d formatted according to fmt.
	// A subset of the Open Group's strftime format is supported.

	function formatDate(d, fmt, monthNames, dayNames) {

		if (typeof d.strftime == "function") {
			return d.strftime(fmt);
		}

		var leftPad = function(n, pad) {
			n = "" + n;
			pad = "" + (pad == null ? "0" : pad);
			return n.length == 1 ? pad + n : n;
		};

		var r = [];
		var escape = false;
		var hours = d.getHours();
		var isAM = hours < 12;

		if (monthNames == null) {
			monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		}

		if (dayNames == null) {
			dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
		}

		var hours12;

		if (hours > 12) {
			hours12 = hours - 12;
		} else if (hours == 0) {
			hours12 = 12;
		} else {
			hours12 = hours;
		}

		for (var i = 0; i < fmt.length; ++i) {

			var c = fmt.charAt(i);

			if (escape) {
				switch (c) {
					case 'a': c = "" + dayNames[d.getDay()]; break;
					case 'b': c = "" + monthNames[d.getMonth()]; break;
					case 'd': c = leftPad(d.getDate()); break;
					case 'e': c = leftPad(d.getDate(), " "); break;
					case 'h':	// For back-compat with 0.7; remove in 1.0
					case 'H': c = leftPad(hours); break;
					case 'I': c = leftPad(hours12); break;
					case 'l': c = leftPad(hours12, " "); break;
					case 'm': c = leftPad(d.getMonth() + 1); break;
					case 'M': c = leftPad(d.getMinutes()); break;
					// quarters not in Open Group's strftime specification
					case 'q':
						c = "" + (Math.floor(d.getMonth() / 3) + 1); break;
					case 'S': c = leftPad(d.getSeconds()); break;
					case 'y': c = leftPad(d.getFullYear() % 100); break;
					case 'Y': c = "" + d.getFullYear(); break;
					case 'p': c = (isAM) ? ("" + "am") : ("" + "pm"); break;
					case 'P': c = (isAM) ? ("" + "AM") : ("" + "PM"); break;
					case 'w': c = "" + d.getDay(); break;
				}
				r.push(c);
				escape = false;
			} else {
				if (c == "%") {
					escape = true;
				} else {
					r.push(c);
				}
			}
		}

		return r.join("");
	}

	// To have a consistent view of time-based data independent of which time
	// zone the client happens to be in we need a date-like object independent
	// of time zones.  This is done through a wrapper that only calls the UTC
	// versions of the accessor methods.

	function makeUtcWrapper(d) {

		function addProxyMethod(sourceObj, sourceMethod, targetObj, targetMethod) {
			sourceObj[sourceMethod] = function() {
				return targetObj[targetMethod].apply(targetObj, arguments);
			};
		};

		var utc = {
			date: d
		};

		// support strftime, if found

		if (d.strftime != undefined) {
			addProxyMethod(utc, "strftime", d, "strftime");
		}

		addProxyMethod(utc, "getTime", d, "getTime");
		addProxyMethod(utc, "setTime", d, "setTime");

		var props = ["Date", "Day", "FullYear", "Hours", "Milliseconds", "Minutes", "Month", "Seconds"];

		for (var p = 0; p < props.length; p++) {
			addProxyMethod(utc, "get" + props[p], d, "getUTC" + props[p]);
			addProxyMethod(utc, "set" + props[p], d, "setUTC" + props[p]);
		}

		return utc;
	};

	// select time zone strategy.  This returns a date-like object tied to the
	// desired timezone

	function dateGenerator(ts, opts) {
		if (opts.timezone == "browser") {
			return new Date(ts);
		} else if (!opts.timezone || opts.timezone == "utc") {
			return makeUtcWrapper(new Date(ts));
		} else if (typeof timezoneJS != "undefined" && typeof timezoneJS.Date != "undefined") {
			var d = new timezoneJS.Date();
			// timezone-js is fickle, so be sure to set the time zone before
			// setting the time.
			d.setTimezone(opts.timezone);
			d.setTime(ts);
			return d;
		} else {
			return makeUtcWrapper(new Date(ts));
		}
	}
	
	// map of app. size of time units in milliseconds

	var timeUnitSize = {
		"second": 1000,
		"minute": 60 * 1000,
		"hour": 60 * 60 * 1000,
		"day": 24 * 60 * 60 * 1000,
		"month": 30 * 24 * 60 * 60 * 1000,
		"quarter": 3 * 30 * 24 * 60 * 60 * 1000,
		"year": 365.2425 * 24 * 60 * 60 * 1000
	};

	// the allowed tick sizes, after 1 year we use
	// an integer algorithm

	var baseSpec = [
		[1, "second"], [2, "second"], [5, "second"], [10, "second"],
		[30, "second"], 
		[1, "minute"], [2, "minute"], [5, "minute"], [10, "minute"],
		[30, "minute"], 
		[1, "hour"], [2, "hour"], [4, "hour"],
		[8, "hour"], [12, "hour"],
		[1, "day"], [2, "day"], [3, "day"],
		[0.25, "month"], [0.5, "month"], [1, "month"],
		[2, "month"]
	];

	// we don't know which variant(s) we'll need yet, but generating both is
	// cheap

	var specMonths = baseSpec.concat([[3, "month"], [6, "month"],
		[1, "year"]]);
	var specQuarters = baseSpec.concat([[1, "quarter"], [2, "quarter"],
		[1, "year"]]);

	function init(plot) {
		plot.hooks.processOptions.push(function (plot, options) {
			$.each(plot.getAxes(), function(axisName, axis) {

				var opts = axis.options;

				if (opts.mode == "time") {
					axis.tickGenerator = function(axis) {

						var ticks = [];
						var d = dateGenerator(axis.min, opts);
						var minSize = 0;

						// make quarter use a possibility if quarters are
						// mentioned in either of these options

						var spec = (opts.tickSize && opts.tickSize[1] ===
							"quarter") ||
							(opts.minTickSize && opts.minTickSize[1] ===
							"quarter") ? specQuarters : specMonths;

						if (opts.minTickSize != null) {
							if (typeof opts.tickSize == "number") {
								minSize = opts.tickSize;
							} else {
								minSize = opts.minTickSize[0] * timeUnitSize[opts.minTickSize[1]];
							}
						}

						for (var i = 0; i < spec.length - 1; ++i) {
							if (axis.delta < (spec[i][0] * timeUnitSize[spec[i][1]]
											  + spec[i + 1][0] * timeUnitSize[spec[i + 1][1]]) / 2
								&& spec[i][0] * timeUnitSize[spec[i][1]] >= minSize) {
								break;
							}
						}

						var size = spec[i][0];
						var unit = spec[i][1];

						// special-case the possibility of several years

						if (unit == "year") {

							// if given a minTickSize in years, just use it,
							// ensuring that it's an integer

							if (opts.minTickSize != null && opts.minTickSize[1] == "year") {
								size = Math.floor(opts.minTickSize[0]);
							} else {

								var magn = Math.pow(10, Math.floor(Math.log(axis.delta / timeUnitSize.year) / Math.LN10));
								var norm = (axis.delta / timeUnitSize.year) / magn;

								if (norm < 1.5) {
									size = 1;
								} else if (norm < 3) {
									size = 2;
								} else if (norm < 7.5) {
									size = 5;
								} else {
									size = 10;
								}

								size *= magn;
							}

							// minimum size for years is 1

							if (size < 1) {
								size = 1;
							}
						}

						axis.tickSize = opts.tickSize || [size, unit];
						var tickSize = axis.tickSize[0];
						unit = axis.tickSize[1];

						var step = tickSize * timeUnitSize[unit];

						if (unit == "second") {
							d.setSeconds(floorInBase(d.getSeconds(), tickSize));
						} else if (unit == "minute") {
							d.setMinutes(floorInBase(d.getMinutes(), tickSize));
						} else if (unit == "hour") {
							d.setHours(floorInBase(d.getHours(), tickSize));
						} else if (unit == "month") {
							d.setMonth(floorInBase(d.getMonth(), tickSize));
						} else if (unit == "quarter") {
							d.setMonth(3 * floorInBase(d.getMonth() / 3,
								tickSize));
						} else if (unit == "year") {
							d.setFullYear(floorInBase(d.getFullYear(), tickSize));
						}

						// reset smaller components

						d.setMilliseconds(0);

						if (step >= timeUnitSize.minute) {
							d.setSeconds(0);
						}
						if (step >= timeUnitSize.hour) {
							d.setMinutes(0);
						}
						if (step >= timeUnitSize.day) {
							d.setHours(0);
						}
						if (step >= timeUnitSize.day * 4) {
							d.setDate(1);
						}
						if (step >= timeUnitSize.month * 2) {
							d.setMonth(floorInBase(d.getMonth(), 3));
						}
						if (step >= timeUnitSize.quarter * 2) {
							d.setMonth(floorInBase(d.getMonth(), 6));
						}
						if (step >= timeUnitSize.year) {
							d.setMonth(0);
						}

						var carry = 0;
						var v = Number.NaN;
						var prev;

						do {

							prev = v;
							v = d.getTime();
							ticks.push(v);

							if (unit == "month" || unit == "quarter") {
								if (tickSize < 1) {

									// a bit complicated - we'll divide the
									// month/quarter up but we need to take
									// care of fractions so we don't end up in
									// the middle of a day

									d.setDate(1);
									var start = d.getTime();
									d.setMonth(d.getMonth() +
										(unit == "quarter" ? 3 : 1));
									var end = d.getTime();
									d.setTime(v + carry * timeUnitSize.hour + (end - start) * tickSize);
									carry = d.getHours();
									d.setHours(0);
								} else {
									d.setMonth(d.getMonth() +
										tickSize * (unit == "quarter" ? 3 : 1));
								}
							} else if (unit == "year") {
								d.setFullYear(d.getFullYear() + tickSize);
							} else {
								d.setTime(v + step);
							}
						} while (v < axis.max && v != prev);

						return ticks;
					};

					axis.tickFormatter = function (v, axis) {

						var d = dateGenerator(v, axis.options);

						// first check global format

						if (opts.timeformat != null) {
							return formatDate(d, opts.timeformat, opts.monthNames, opts.dayNames);
						}

						// possibly use quarters if quarters are mentioned in
						// any of these places

						var useQuarters = (axis.options.tickSize &&
								axis.options.tickSize[1] == "quarter") ||
							(axis.options.minTickSize &&
								axis.options.minTickSize[1] == "quarter");

						var t = axis.tickSize[0] * timeUnitSize[axis.tickSize[1]];
						var span = axis.max - axis.min;
						var suffix = (opts.twelveHourClock) ? " %p" : "";
						var hourCode = (opts.twelveHourClock) ? "%I" : "%H";
						var fmt;

						if (t < timeUnitSize.minute) {
							fmt = hourCode + ":%M:%S" + suffix;
						} else if (t < timeUnitSize.day) {
							if (span < 2 * timeUnitSize.day) {
								fmt = hourCode + ":%M" + suffix;
							} else {
								fmt = "%b %d " + hourCode + ":%M" + suffix;
							}
						} else if (t < timeUnitSize.month) {
							fmt = "%b %d";
						} else if ((useQuarters && t < timeUnitSize.quarter) ||
							(!useQuarters && t < timeUnitSize.year)) {
							if (span < timeUnitSize.year) {
								fmt = "%b";
							} else {
								fmt = "%b %Y";
							}
						} else if (useQuarters && t < timeUnitSize.year) {
							if (span < timeUnitSize.year) {
								fmt = "Q%q";
							} else {
								fmt = "Q%q %Y";
							}
						} else {
							fmt = "%Y";
						}

						var rt = formatDate(d, fmt, opts.monthNames, opts.dayNames);

						return rt;
					};
				}
			});
		});
	}

	$.plot.plugins.push({
		init: init,
		options: options,
		name: 'time',
		version: '1.0'
	});

	// Time-axis support used to be in Flot core, which exposed the
	// formatDate function on the plot object.  Various plugins depend
	// on the function, so we need to re-expose it here.

	$.plot.formatDate = formatDate;
	$.plot.dateGenerator = dateGenerator;

})(jQuery);

},{}],14:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}],15:[function(require,module,exports){
;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    //! moment.js locale configuration

    hooks.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$1 = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar-dz', {
        months: months$1,
        monthsShort: months$1,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm$1 = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals$1 = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize$1 = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm$1(number),
                    str = plurals$1[u][pluralForm$1(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$2 = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar-ly', {
        months: months$2,
        monthsShort: months$2,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize$1('s'),
            ss: pluralize$1('s'),
            m: pluralize$1('m'),
            mm: pluralize$1('m'),
            h: pluralize$1('h'),
            hh: pluralize$1('h'),
            d: pluralize$1('d'),
            dd: pluralize$1('d'),
            M: pluralize$1('M'),
            MM: pluralize$1('M'),
            y: pluralize$1('y'),
            yy: pluralize$1('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$1 = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    hooks.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$1[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$2 = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap$1 = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm$2 = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals$2 = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize$2 = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm$2(number),
                    str = plurals$2[u][pluralForm$2(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$3 = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar', {
        months: months$3,
        monthsShort: months$3,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize$2('s'),
            ss: pluralize$2('s'),
            m: pluralize$2('m'),
            mm: pluralize$2('m'),
            h: pluralize$2('h'),
            hh: pluralize$2('h'),
            d: pluralize$2('d'),
            dd: pluralize$2('d'),
            M: pluralize$2('M'),
            MM: pluralize$2('M'),
            y: pluralize$2('y'),
            yy: pluralize$2('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap$1[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$2[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    hooks.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    hooks.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$3 = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap$2 = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    hooks.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap$2[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$3[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$4 = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap$3 = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    hooks.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap$3[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$4[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$5 = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap$4 = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    hooks.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap$4[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$5[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex$1 =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    hooks.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex$1,
        monthsShortRegex: monthsRegex$1,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    hooks.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$4 = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse$1 = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex$2 =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural$1(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate$1(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    hooks.defineLocale('cs', {
        months: months$4,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex$2,
        monthsShortRegex: monthsRegex$2,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse$1,
        longMonthsParse: monthsParse$1,
        shortMonthsParse: monthsParse$1,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate$1,
            ss: translate$1,
            m: translate$1,
            mm: translate$1,
            h: translate$1,
            hh: translate$1,
            d: translate$1,
            dd: translate$1,
            M: translate$1,
            MM: translate$1,
            y: translate$1,
            yy: translate$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$1,
            mm: '%d Minuten',
            h: processRelativeTime$1,
            hh: '%d Stunden',
            d: processRelativeTime$1,
            dd: processRelativeTime$1,
            w: processRelativeTime$1,
            ww: '%d Wochen',
            M: processRelativeTime$1,
            MM: processRelativeTime$1,
            y: processRelativeTime$1,
            yy: processRelativeTime$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$2,
            mm: '%d Minuten',
            h: processRelativeTime$2,
            hh: '%d Stunden',
            d: processRelativeTime$2,
            dd: processRelativeTime$2,
            w: processRelativeTime$2,
            ww: '%d Wochen',
            M: processRelativeTime$2,
            MM: processRelativeTime$2,
            y: processRelativeTime$2,
            yy: processRelativeTime$2,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$5 = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    hooks.defineLocale('dv', {
        months: months$5,
        monthsShort: months$5,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function isFunction$1(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    hooks.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction$1(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$2 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$3 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$1[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex$3,
        monthsShortRegex: monthsRegex$3,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$2,
        longMonthsParse: monthsParse$2,
        shortMonthsParse: monthsParse$2,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot$1 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$3 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$4 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$2[m.month()];
            } else {
                return monthsShortDot$1[m.month()];
            }
        },
        monthsRegex: monthsRegex$4,
        monthsShortRegex: monthsRegex$4,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$3,
        longMonthsParse: monthsParse$3,
        shortMonthsParse: monthsParse$3,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    //! moment.js locale configuration

    var monthsShortDot$2 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$4 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$5 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$3[m.month()];
            } else {
                return monthsShortDot$2[m.month()];
            }
        },
        monthsRegex: monthsRegex$5,
        monthsShortRegex: monthsRegex$5,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$4,
        longMonthsParse: monthsParse$4,
        shortMonthsParse: monthsParse$4,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot$3 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$4 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$5 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$6 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$3;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$4[m.month()];
            } else {
                return monthsShortDot$3[m.month()];
            }
        },
        monthsRegex: monthsRegex$6,
        monthsShortRegex: monthsRegex$6,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$5,
        longMonthsParse: monthsParse$5,
        shortMonthsParse: monthsParse$5,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    //! moment.js locale configuration

    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime$3,
            ss: processRelativeTime$3,
            m: processRelativeTime$3,
            mm: processRelativeTime$3,
            h: processRelativeTime$3,
            hh: processRelativeTime$3,
            d: processRelativeTime$3,
            dd: '%d päeva',
            M: processRelativeTime$3,
            MM: processRelativeTime$3,
            y: processRelativeTime$3,
            yy: processRelativeTime$3,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$6 = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap$5 = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    hooks.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap$5[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$6[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate$2(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    hooks.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate$2,
            ss: translate$2,
            m: translate$2,
            mm: translate$2,
            h: translate$2,
            hh: translate$2,
            d: translate$2,
            dd: translate$2,
            M: translate$2,
            MM: translate$2,
            y: translate$2,
            yy: translate$2,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsStrictRegex$1 =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex$1 =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex$7 =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse$6 = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    hooks.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex$7,
        monthsShortRegex: monthsRegex$7,
        monthsStrictRegex: monthsStrictRegex$1,
        monthsShortStrictRegex: monthsShortStrictRegex$1,
        monthsParse: monthsParse$6,
        longMonthsParse: monthsParse$6,
        shortMonthsParse: monthsParse$6,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    hooks.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$6 = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort$5 = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays$1 = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    hooks.defineLocale('ga', {
        months: months$6,
        monthsShort: monthsShort$5,
        monthsParseExact: true,
        weekdays: weekdays$1,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$7 = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort$6 = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays$2 = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort$1 = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin$1 = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    hooks.defineLocale('gd', {
        months: months$7,
        monthsShort: monthsShort$6,
        monthsParseExact: true,
        weekdays: weekdays$2,
        weekdaysShort: weekdaysShort$1,
        weekdaysMin: weekdaysMin$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime$4,
            ss: processRelativeTime$4,
            m: processRelativeTime$4,
            mm: processRelativeTime$4,
            h: processRelativeTime$4,
            hh: processRelativeTime$4,
            d: processRelativeTime$4,
            dd: processRelativeTime$4,
            M: processRelativeTime$4,
            MM: processRelativeTime$4,
            y: processRelativeTime$4,
            yy: processRelativeTime$4,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime$5,
            ss: processRelativeTime$5,
            m: processRelativeTime$5,
            mm: processRelativeTime$5,
            h: processRelativeTime$5,
            hh: processRelativeTime$5,
            d: processRelativeTime$5,
            dd: processRelativeTime$5,
            M: processRelativeTime$5,
            MM: processRelativeTime$5,
            y: processRelativeTime$5,
            yy: processRelativeTime$5,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$7 = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap$6 = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    hooks.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap$6[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$7[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$8 = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$7 = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse$7 = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    hooks.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse$7,
        longMonthsParse: monthsParse$7,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$7[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$8[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function translate$3(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    hooks.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate$3,
            m: translate$3,
            mm: translate$3,
            h: translate$3,
            hh: translate$3,
            d: 'dan',
            dd: translate$3,
            M: 'mjesec',
            MM: translate$3,
            y: 'godinu',
            yy: translate$3,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate$4(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    hooks.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate$4,
            ss: translate$4,
            m: translate$4,
            mm: translate$4,
            h: translate$4,
            hh: translate$4,
            d: translate$4,
            dd: translate$4,
            M: translate$4,
            MM: translate$4,
            y: translate$4,
            yy: translate$4,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$2(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate$5(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural$2(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural$2(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural$2(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural$2(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    hooks.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate$5,
            ss: translate$5,
            m: translate$5,
            mm: translate$5,
            h: 'klukkustund',
            hh: translate$5,
            d: translate$5,
            dd: translate$5,
            M: translate$5,
            MM: translate$5,
            y: translate$5,
            yy: translate$5,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    //! moment.js locale configuration

    var suffixes$1 = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    hooks.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$9 = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap$8 = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    hooks.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap$8[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$9[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$a = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap$9 = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    hooks.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap$9[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$a[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    //! moment.js locale configuration

    var symbolMap$b = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap$a = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months$8 = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    hooks.defineLocale('ku', {
        months: months$8,
        monthsShort: months$8,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap$a[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$b[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$2 = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    hooks.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    hooks.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime$6,
            mm: '%d Minutten',
            h: processRelativeTime$6,
            hh: '%d Stonnen',
            d: processRelativeTime$6,
            dd: '%d Deeg',
            M: processRelativeTime$6,
            MM: '%d Méint',
            y: processRelativeTime$6,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate$6(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    hooks.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate$6,
            m: translateSingular,
            mm: translate$6,
            h: translateSingular,
            hh: translate$6,
            d: translateSingular,
            dd: translate$6,
            M: translateSingular,
            MM: translate$6,
            y: translateSingular,
            yy: translate$6,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var units$1 = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format$1(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
        return number + ' ' + format$1(units$1[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format$1(units$1[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    hooks.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural$1,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural$1,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural$1,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural$1,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural$1,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    hooks.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    //! moment.js locale configuration

    function translate$7(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    hooks.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate$7,
            ss: translate$7,
            m: translate$7,
            mm: translate$7,
            h: translate$7,
            hh: translate$7,
            d: translate$7,
            dd: translate$7,
            M: translate$7,
            MM: translate$7,
            y: translate$7,
            yy: translate$7,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$c = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$b = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    hooks.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$b[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$c[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$d = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap$c = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    hooks.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap$c[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$d[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$e = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$d = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    hooks.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$d[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$e[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots$1 =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$1 =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse$8 = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex$8 =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    hooks.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$1[m.month()];
            } else {
                return monthsShortWithDots$1[m.month()];
            }
        },

        monthsRegex: monthsRegex$8,
        monthsShortRegex: monthsRegex$8,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse$8,
        longMonthsParse: monthsParse$8,
        shortMonthsParse: monthsParse$8,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots$2 =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$2 =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse$9 = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex$9 =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    hooks.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$2[m.month()];
            } else {
                return monthsShortWithDots$2[m.month()];
            }
        },

        monthsRegex: monthsRegex$9,
        monthsShortRegex: monthsRegex$9,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse$9,
        longMonthsParse: monthsParse$9,
        shortMonthsParse: monthsParse$9,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    //! moment.js locale configuration

    var symbolMap$f = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap$e = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    hooks.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap$e[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$f[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse$a = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural$3(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate$8(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural$3(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural$3(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural$3(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural$3(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural$3(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural$3(number) ? 'lata' : 'lat');
        }
    }

    hooks.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse$a,
        longMonthsParse: monthsParse$a,
        shortMonthsParse: monthsParse$a,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate$8,
            m: translate$8,
            mm: translate$8,
            h: translate$8,
            hh: translate$8,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate$8,
            M: 'miesiąc',
            MM: translate$8,
            y: 'rok',
            yy: translate$8,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    //! moment.js locale configuration

    hooks.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    hooks.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural$2,
            m: 'un minut',
            mm: relativeTimeWithPlural$2,
            h: 'o oră',
            hh: relativeTimeWithPlural$2,
            d: 'o zi',
            dd: relativeTimeWithPlural$2,
            w: 'o săptămână',
            ww: relativeTimeWithPlural$2,
            M: 'o lună',
            MM: relativeTimeWithPlural$2,
            y: 'un an',
            yy: relativeTimeWithPlural$2,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$4(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural$4(format[key], +number);
        }
    }
    var monthsParse$b = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    hooks.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse$b,
        longMonthsParse: monthsParse$b,
        shortMonthsParse: monthsParse$b,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural$3,
            m: relativeTimeWithPlural$3,
            mm: relativeTimeWithPlural$3,
            h: 'час',
            hh: relativeTimeWithPlural$3,
            d: 'день',
            dd: relativeTimeWithPlural$3,
            w: 'неделя',
            ww: relativeTimeWithPlural$3,
            M: 'месяц',
            MM: relativeTimeWithPlural$3,
            y: 'год',
            yy: relativeTimeWithPlural$3,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$9 = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days$1 = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    hooks.defineLocale('sd', {
        months: months$9,
        monthsShort: months$9,
        weekdays: days$1,
        weekdaysShort: days$1,
        weekdaysMin: days$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    /*jshint -W100*/
    hooks.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    //! moment.js locale configuration

    var months$a =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort$7 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural$5(n) {
        return n > 1 && n < 5;
    }
    function translate$9(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    hooks.defineLocale('sk', {
        months: months$a,
        monthsShort: monthsShort$7,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate$9,
            ss: translate$9,
            m: translate$9,
            mm: translate$9,
            h: translate$9,
            hh: translate$9,
            d: translate$9,
            dd: translate$9,
            M: translate$9,
            MM: translate$9,
            y: translate$9,
            yy: translate$9,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    hooks.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime$7,
            ss: processRelativeTime$7,
            m: processRelativeTime$7,
            mm: processRelativeTime$7,
            h: processRelativeTime$7,
            hh: processRelativeTime$7,
            d: processRelativeTime$7,
            dd: processRelativeTime$7,
            M: processRelativeTime$7,
            MM: processRelativeTime$7,
            y: processRelativeTime$7,
            yy: processRelativeTime$7,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator$1 = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator$1.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator$1.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    hooks.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator$1.translate,
            m: translator$1.translate,
            mm: translator$1.translate,
            h: translator$1.translate,
            hh: translator$1.translate,
            d: translator$1.translate,
            dd: translator$1.translate,
            M: translator$1.translate,
            MM: translator$1.translate,
            y: translator$1.translate,
            yy: translator$1.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator$2 = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator$2.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator$2.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    hooks.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator$2.translate,
            m: translator$2.translate,
            mm: translator$2.translate,
            h: translator$2.translate,
            hh: translator$2.translate,
            d: translator$2.translate,
            dd: translator$2.translate,
            M: translator$2.translate,
            MM: translator$2.translate,
            y: translator$2.translate,
            yy: translator$2.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$g = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap$f = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    hooks.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap$f[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$g[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$3 = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    hooks.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    //! moment.js locale configuration

    var suffixes$4 = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    hooks.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate$a(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    hooks.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate$a,
            m: 'wa’ tup',
            mm: translate$a,
            h: 'wa’ rep',
            hh: translate$a,
            d: 'wa’ jaj',
            dd: translate$a,
            M: 'wa’ jar',
            MM: translate$a,
            y: 'wa’ DIS',
            yy: translate$a,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$5 = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    hooks.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes$5[a] || suffixes$5[b] || suffixes$5[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    hooks.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime$8,
            ss: processRelativeTime$8,
            m: processRelativeTime$8,
            mm: processRelativeTime$8,
            h: processRelativeTime$8,
            hh: processRelativeTime$8,
            d: processRelativeTime$8,
            dd: processRelativeTime$8,
            M: processRelativeTime$8,
            MM: processRelativeTime$8,
            y: processRelativeTime$8,
            yy: processRelativeTime$8,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime$8(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    //! moment.js locale configuration

    hooks.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$6(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural$6(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    hooks.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural$4,
            m: relativeTimeWithPlural$4,
            mm: relativeTimeWithPlural$4,
            h: 'годину',
            hh: relativeTimeWithPlural$4,
            d: 'день',
            dd: relativeTimeWithPlural$4,
            M: 'місяць',
            MM: relativeTimeWithPlural$4,
            y: 'рік',
            yy: relativeTimeWithPlural$4,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$b = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days$2 = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    hooks.defineLocale('ur', {
        months: months$b,
        monthsShort: months$b,
        weekdays: days$2,
        weekdaysShort: days$2,
        weekdaysMin: days$2,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    hooks.locale('en');

    return hooks;

})));

},{}],16:[function(require,module,exports){
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

},{}],17:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],18:[function(require,module,exports){
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Sortable = factory());
}(this, (function () { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var version = "1.15.0";

  function userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) {
      return !! /*@__PURE__*/navigator.userAgent.match(pattern);
    }
  }

  var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
  var Edge = userAgent(/Edge/i);
  var FireFox = userAgent(/firefox/i);
  var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
  var IOS = userAgent(/iP(ad|od|hone)/i);
  var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

  var captureMode = {
    capture: false,
    passive: false
  };

  function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
  }

  function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
  }

  function matches(
  /**HTMLElement*/
  el,
  /**String*/
  selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));

    if (el) {
      try {
        if (el.matches) {
          return el.matches(selector);
        } else if (el.msMatchesSelector) {
          return el.msMatchesSelector(selector);
        } else if (el.webkitMatchesSelector) {
          return el.webkitMatchesSelector(selector);
        }
      } catch (_) {
        return false;
      }
    }

    return false;
  }

  function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
  }

  function closest(
  /**HTMLElement*/
  el,
  /**String*/
  selector,
  /**HTMLElement*/
  ctx, includeCTX) {
    if (el) {
      ctx = ctx || document;

      do {
        if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
          return el;
        }

        if (el === ctx) break;
        /* jshint boss:true */
      } while (el = getParentOrHost(el));
    }

    return null;
  }

  var R_SPACE = /\s+/g;

  function toggleClass(el, name, state) {
    if (el && name) {
      if (el.classList) {
        el.classList[state ? 'add' : 'remove'](name);
      } else {
        var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
        el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
      }
    }
  }

  function css(el, prop, val) {
    var style = el && el.style;

    if (style) {
      if (val === void 0) {
        if (document.defaultView && document.defaultView.getComputedStyle) {
          val = document.defaultView.getComputedStyle(el, '');
        } else if (el.currentStyle) {
          val = el.currentStyle;
        }

        return prop === void 0 ? val : val[prop];
      } else {
        if (!(prop in style) && prop.indexOf('webkit') === -1) {
          prop = '-webkit-' + prop;
        }

        style[prop] = val + (typeof val === 'string' ? '' : 'px');
      }
    }
  }

  function matrix(el, selfOnly) {
    var appliedTransforms = '';

    if (typeof el === 'string') {
      appliedTransforms = el;
    } else {
      do {
        var transform = css(el, 'transform');

        if (transform && transform !== 'none') {
          appliedTransforms = transform + ' ' + appliedTransforms;
        }
        /* jshint boss:true */

      } while (!selfOnly && (el = el.parentNode));
    }

    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */

    return matrixFn && new matrixFn(appliedTransforms);
  }

  function find(ctx, tagName, iterator) {
    if (ctx) {
      var list = ctx.getElementsByTagName(tagName),
          i = 0,
          n = list.length;

      if (iterator) {
        for (; i < n; i++) {
          iterator(list[i], i);
        }
      }

      return list;
    }

    return [];
  }

  function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;

    if (scrollingElement) {
      return scrollingElement;
    } else {
      return document.documentElement;
    }
  }
  /**
   * Returns the "bounding client rect" of given element
   * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
   * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
   * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
   * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
   * @param  {[HTMLElement]} container              The parent the element will be placed in
   * @return {Object}                               The boundingClientRect of el, with specified adjustments
   */


  function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;

    if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
      elRect = el.getBoundingClientRect();
      top = elRect.top;
      left = elRect.left;
      bottom = elRect.bottom;
      right = elRect.right;
      height = elRect.height;
      width = elRect.width;
    } else {
      top = 0;
      left = 0;
      bottom = window.innerHeight;
      right = window.innerWidth;
      height = window.innerHeight;
      width = window.innerWidth;
    }

    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
      // Adjust for translate()
      container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
      // Not needed on <= IE11

      if (!IE11OrLess) {
        do {
          if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
            var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

            top -= containerRect.top + parseInt(css(container, 'border-top-width'));
            left -= containerRect.left + parseInt(css(container, 'border-left-width'));
            bottom = top + elRect.height;
            right = left + elRect.width;
            break;
          }
          /* jshint boss:true */

        } while (container = container.parentNode);
      }
    }

    if (undoScale && el !== window) {
      // Adjust for scale()
      var elMatrix = matrix(container || el),
          scaleX = elMatrix && elMatrix.a,
          scaleY = elMatrix && elMatrix.d;

      if (elMatrix) {
        top /= scaleY;
        left /= scaleX;
        width /= scaleX;
        height /= scaleY;
        bottom = top + height;
        right = left + width;
      }
    }

    return {
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      width: width,
      height: height
    };
  }
  /**
   * Checks if a side of an element is scrolled past a side of its parents
   * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
   * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
   * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
   * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
   */


  function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true),
        elSideVal = getRect(el)[elSide];
    /* jshint boss:true */

    while (parent) {
      var parentSideVal = getRect(parent)[parentSide],
          visible = void 0;

      if (parentSide === 'top' || parentSide === 'left') {
        visible = elSideVal >= parentSideVal;
      } else {
        visible = elSideVal <= parentSideVal;
      }

      if (!visible) return parent;
      if (parent === getWindowScrollingElement()) break;
      parent = getParentAutoScrollElement(parent, false);
    }

    return false;
  }
  /**
   * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
   * and non-draggable elements
   * @param  {HTMLElement} el       The parent element
   * @param  {Number} childNum      The index of the child
   * @param  {Object} options       Parent Sortable's options
   * @return {HTMLElement}          The child at index childNum, or null if not found
   */


  function getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0,
        i = 0,
        children = el.children;

    while (i < children.length) {
      if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
        if (currentChild === childNum) {
          return children[i];
        }

        currentChild++;
      }

      i++;
    }

    return null;
  }
  /**
   * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
   * @param  {HTMLElement} el       Parent element
   * @param  {selector} selector    Any other elements that should be ignored
   * @return {HTMLElement}          The last child, ignoring ghostEl
   */


  function lastChild(el, selector) {
    var last = el.lastElementChild;

    while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
      last = last.previousElementSibling;
    }

    return last || null;
  }
  /**
   * Returns the index of an element within its parent for a selected set of
   * elements
   * @param  {HTMLElement} el
   * @param  {selector} selector
   * @return {number}
   */


  function index(el, selector) {
    var index = 0;

    if (!el || !el.parentNode) {
      return -1;
    }
    /* jshint boss:true */


    while (el = el.previousElementSibling) {
      if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
        index++;
      }
    }

    return index;
  }
  /**
   * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
   * The value is returned in real pixels.
   * @param  {HTMLElement} el
   * @return {Array}             Offsets in the format of [left, top]
   */


  function getRelativeScrollOffset(el) {
    var offsetLeft = 0,
        offsetTop = 0,
        winScroller = getWindowScrollingElement();

    if (el) {
      do {
        var elMatrix = matrix(el),
            scaleX = elMatrix.a,
            scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
      } while (el !== winScroller && (el = el.parentNode));
    }

    return [offsetLeft, offsetTop];
  }
  /**
   * Returns the index of the object within the given array
   * @param  {Array} arr   Array that may or may not hold the object
   * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
   * @return {Number}      The index of the object in the array, or -1
   */


  function indexOfObject(arr, obj) {
    for (var i in arr) {
      if (!arr.hasOwnProperty(i)) continue;

      for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
      }
    }

    return -1;
  }

  function getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;

    do {
      // we don't need to get elem css if it isn't even overflowing in the first place (performance)
      if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);

        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
          if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
          if (gotSelf || includeSelf) return elem;
          gotSelf = true;
        }
      }
      /* jshint boss:true */

    } while (elem = elem.parentNode);

    return getWindowScrollingElement();
  }

  function extend(dst, src) {
    if (dst && src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) {
          dst[key] = src[key];
        }
      }
    }

    return dst;
  }

  function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
  }

  var _throttleTimeout;

  function throttle(callback, ms) {
    return function () {
      if (!_throttleTimeout) {
        var args = arguments,
            _this = this;

        if (args.length === 1) {
          callback.call(_this, args[0]);
        } else {
          callback.apply(_this, args);
        }

        _throttleTimeout = setTimeout(function () {
          _throttleTimeout = void 0;
        }, ms);
      }
    };
  }

  function cancelThrottle() {
    clearTimeout(_throttleTimeout);
    _throttleTimeout = void 0;
  }

  function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
  }

  function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;

    if (Polymer && Polymer.dom) {
      return Polymer.dom(el).cloneNode(true);
    } else if ($) {
      return $(el).clone(true)[0];
    } else {
      return el.cloneNode(true);
    }
  }

  function setRect(el, rect) {
    css(el, 'position', 'absolute');
    css(el, 'top', rect.top);
    css(el, 'left', rect.left);
    css(el, 'width', rect.width);
    css(el, 'height', rect.height);
  }

  function unsetRect(el) {
    css(el, 'position', '');
    css(el, 'top', '');
    css(el, 'left', '');
    css(el, 'width', '');
    css(el, 'height', '');
  }

  var expando = 'Sortable' + new Date().getTime();

  function AnimationStateManager() {
    var animationStates = [],
        animationCallbackId;
    return {
      captureAnimationState: function captureAnimationState() {
        animationStates = [];
        if (!this.options.animation) return;
        var children = [].slice.call(this.el.children);
        children.forEach(function (child) {
          if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
          animationStates.push({
            target: child,
            rect: getRect(child)
          });

          var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


          if (child.thisAnimationDuration) {
            var childMatrix = matrix(child, true);

            if (childMatrix) {
              fromRect.top -= childMatrix.f;
              fromRect.left -= childMatrix.e;
            }
          }

          child.fromRect = fromRect;
        });
      },
      addAnimationState: function addAnimationState(state) {
        animationStates.push(state);
      },
      removeAnimationState: function removeAnimationState(target) {
        animationStates.splice(indexOfObject(animationStates, {
          target: target
        }), 1);
      },
      animateAll: function animateAll(callback) {
        var _this = this;

        if (!this.options.animation) {
          clearTimeout(animationCallbackId);
          if (typeof callback === 'function') callback();
          return;
        }

        var animating = false,
            animationTime = 0;
        animationStates.forEach(function (state) {
          var time = 0,
              target = state.target,
              fromRect = target.fromRect,
              toRect = getRect(target),
              prevFromRect = target.prevFromRect,
              prevToRect = target.prevToRect,
              animatingRect = state.rect,
              targetMatrix = matrix(target, true);

          if (targetMatrix) {
            // Compensate for current animation
            toRect.top -= targetMatrix.f;
            toRect.left -= targetMatrix.e;
          }

          target.toRect = toRect;

          if (target.thisAnimationDuration) {
            // Could also check if animatingRect is between fromRect and toRect
            if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
              // If returning to same place as started from animation and on same axis
              time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
            }
          } // if fromRect != toRect: animate


          if (!isRectEqual(toRect, fromRect)) {
            target.prevFromRect = fromRect;
            target.prevToRect = toRect;

            if (!time) {
              time = _this.options.animation;
            }

            _this.animate(target, animatingRect, toRect, time);
          }

          if (time) {
            animating = true;
            animationTime = Math.max(animationTime, time);
            clearTimeout(target.animationResetTimer);
            target.animationResetTimer = setTimeout(function () {
              target.animationTime = 0;
              target.prevFromRect = null;
              target.fromRect = null;
              target.prevToRect = null;
              target.thisAnimationDuration = null;
            }, time);
            target.thisAnimationDuration = time;
          }
        });
        clearTimeout(animationCallbackId);

        if (!animating) {
          if (typeof callback === 'function') callback();
        } else {
          animationCallbackId = setTimeout(function () {
            if (typeof callback === 'function') callback();
          }, animationTime);
        }

        animationStates = [];
      },
      animate: function animate(target, currentRect, toRect, duration) {
        if (duration) {
          css(target, 'transition', '');
          css(target, 'transform', '');
          var elMatrix = matrix(this.el),
              scaleX = elMatrix && elMatrix.a,
              scaleY = elMatrix && elMatrix.d,
              translateX = (currentRect.left - toRect.left) / (scaleX || 1),
              translateY = (currentRect.top - toRect.top) / (scaleY || 1);
          target.animatingX = !!translateX;
          target.animatingY = !!translateY;
          css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
          this.forRepaintDummy = repaint(target); // repaint

          css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
          css(target, 'transform', 'translate3d(0,0,0)');
          typeof target.animated === 'number' && clearTimeout(target.animated);
          target.animated = setTimeout(function () {
            css(target, 'transition', '');
            css(target, 'transform', '');
            target.animated = false;
            target.animatingX = false;
            target.animatingY = false;
          }, duration);
        }
      }
    };
  }

  function repaint(target) {
    return target.offsetWidth;
  }

  function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
  }

  var plugins = [];
  var defaults = {
    initializeByDefault: true
  };
  var PluginManager = {
    mount: function mount(plugin) {
      // Set default static properties
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option) && !(option in plugin)) {
          plugin[option] = defaults[option];
        }
      }

      plugins.forEach(function (p) {
        if (p.pluginName === plugin.pluginName) {
          throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        }
      });
      plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
      var _this = this;

      this.eventCanceled = false;

      evt.cancel = function () {
        _this.eventCanceled = true;
      };

      var eventNameGlobal = eventName + 'Global';
      plugins.forEach(function (plugin) {
        if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

        if (sortable[plugin.pluginName][eventNameGlobal]) {
          sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
            sortable: sortable
          }, evt));
        } // Only fire plugin event if plugin is enabled in this sortable,
        // and plugin has event defined


        if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
          sortable[plugin.pluginName][eventName](_objectSpread2({
            sortable: sortable
          }, evt));
        }
      });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
      plugins.forEach(function (plugin) {
        var pluginName = plugin.pluginName;
        if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
        var initialized = new plugin(sortable, el, sortable.options);
        initialized.sortable = sortable;
        initialized.options = sortable.options;
        sortable[pluginName] = initialized; // Add default options from plugin

        _extends(defaults, initialized.defaults);
      });

      for (var option in sortable.options) {
        if (!sortable.options.hasOwnProperty(option)) continue;
        var modified = this.modifyOption(sortable, option, sortable.options[option]);

        if (typeof modified !== 'undefined') {
          sortable.options[option] = modified;
        }
      }
    },
    getEventProperties: function getEventProperties(name, sortable) {
      var eventProperties = {};
      plugins.forEach(function (plugin) {
        if (typeof plugin.eventProperties !== 'function') return;

        _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
      });
      return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
      var modifiedValue;
      plugins.forEach(function (plugin) {
        // Plugin must exist on the Sortable
        if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

        if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
          modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        }
      });
      return modifiedValue;
    }
  };

  function dispatchEvent(_ref) {
    var sortable = _ref.sortable,
        rootEl = _ref.rootEl,
        name = _ref.name,
        targetEl = _ref.targetEl,
        cloneEl = _ref.cloneEl,
        toEl = _ref.toEl,
        fromEl = _ref.fromEl,
        oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex,
        oldDraggableIndex = _ref.oldDraggableIndex,
        newDraggableIndex = _ref.newDraggableIndex,
        originalEvent = _ref.originalEvent,
        putSortable = _ref.putSortable,
        extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[expando];
    if (!sortable) return;
    var evt,
        options = sortable.options,
        onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }

    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

    var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));

    for (var option in allEventProperties) {
      evt[option] = allEventProperties[option];
    }

    if (rootEl) {
      rootEl.dispatchEvent(evt);
    }

    if (options[onName]) {
      options[onName].call(sortable, evt);
    }
  }

  var _excluded = ["evt"];

  var pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        originalEvent = _ref.evt,
        data = _objectWithoutProperties(_ref, _excluded);

    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
      dragEl: dragEl,
      parentEl: parentEl,
      ghostEl: ghostEl,
      rootEl: rootEl,
      nextEl: nextEl,
      lastDownEl: lastDownEl,
      cloneEl: cloneEl,
      cloneHidden: cloneHidden,
      dragStarted: moved,
      putSortable: putSortable,
      activeSortable: Sortable.active,
      originalEvent: originalEvent,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex,
      hideGhostForTarget: _hideGhostForTarget,
      unhideGhostForTarget: _unhideGhostForTarget,
      cloneNowHidden: function cloneNowHidden() {
        cloneHidden = true;
      },
      cloneNowShown: function cloneNowShown() {
        cloneHidden = false;
      },
      dispatchSortableEvent: function dispatchSortableEvent(name) {
        _dispatchEvent({
          sortable: sortable,
          name: name,
          originalEvent: originalEvent
        });
      }
    }, data));
  };

  function _dispatchEvent(info) {
    dispatchEvent(_objectSpread2({
      putSortable: putSortable,
      cloneEl: cloneEl,
      targetEl: dragEl,
      rootEl: rootEl,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex
    }, info));
  }

  var dragEl,
      parentEl,
      ghostEl,
      rootEl,
      nextEl,
      lastDownEl,
      cloneEl,
      cloneHidden,
      oldIndex,
      newIndex,
      oldDraggableIndex,
      newDraggableIndex,
      activeGroup,
      putSortable,
      awaitingDragStarted = false,
      ignoreNextClick = false,
      sortables = [],
      tapEvt,
      touchEvt,
      lastDx,
      lastDy,
      tapDistanceLeft,
      tapDistanceTop,
      moved,
      lastTarget,
      lastDirection,
      pastFirstInvertThresh = false,
      isCircumstantialInvert = false,
      targetMoveDistance,
      // For positioning ghost absolutely
  ghostRelativeParent,
      ghostRelativeParentInitialScroll = [],
      // (left, top)
  _silent = false,
      savedInputChecked = [];
  /** @const */

  var documentExists = typeof document !== 'undefined',
      PositionGhostAbsolutely = IOS,
      CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
      // This will not pass for IE9, because IE9 DnD only works on anchors
  supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
      supportCssPointerEvents = function () {
    if (!documentExists) return; // false when <= IE11

    if (IE11OrLess) {
      return false;
    }

    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
  }(),
      _detectDirection = function _detectDirection(el, options) {
    var elCSS = css(el),
        elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
        child1 = getChild(el, 0, options),
        child2 = getChild(el, 1, options),
        firstChildCSS = child1 && css(child1),
        secondChildCSS = child2 && css(child2),
        firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
        secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

    if (elCSS.display === 'flex') {
      return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    }

    if (elCSS.display === 'grid') {
      return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    }

    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
      var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
      return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }

    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
  },
      _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
        dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
        dragElOppLength = vertical ? dragRect.width : dragRect.height,
        targetS1Opp = vertical ? targetRect.left : targetRect.top,
        targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
        targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
  },

  /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */
  _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    sortables.some(function (sortable) {
      var threshold = sortable[expando].options.emptyInsertThreshold;
      if (!threshold || lastChild(sortable)) return;
      var rect = getRect(sortable),
          insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
          insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

      if (insideHorizontally && insideVertically) {
        return ret = sortable;
      }
    });
    return ret;
  },
      _prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
      return function (to, from, dragEl, evt) {
        var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

        if (value == null && (pull || sameGroup)) {
          // Default pull value
          // Default pull and put value if same group
          return true;
        } else if (value == null || value === false) {
          return false;
        } else if (pull && value === 'clone') {
          return value;
        } else if (typeof value === 'function') {
          return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
        } else {
          var otherGroup = (pull ? to : from).options.group.name;
          return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
        }
      };
    }

    var group = {};
    var originalGroup = options.group;

    if (!originalGroup || _typeof(originalGroup) != 'object') {
      originalGroup = {
        name: originalGroup
      };
    }

    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
  },
      _hideGhostForTarget = function _hideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', 'none');
    }
  },
      _unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', '');
    }
  }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


  if (documentExists && !ChromeForAndroid) {
    document.addEventListener('click', function (evt) {
      if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
      }
    }, true);
  }

  var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if (dragEl) {
      evt = evt.touches ? evt.touches[0] : evt;

      var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

      if (nearest) {
        // Create imitation event
        var event = {};

        for (var i in evt) {
          if (evt.hasOwnProperty(i)) {
            event[i] = evt[i];
          }
        }

        event.target = event.rootEl = nearest;
        event.preventDefault = void 0;
        event.stopPropagation = void 0;

        nearest[expando]._onDragOver(event);
      }
    }
  };

  var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if (dragEl) {
      dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
    }
  };
  /**
   * @class  Sortable
   * @param  {HTMLElement}  el
   * @param  {Object}       [options]
   */


  function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) {
      throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
    }

    this.el = el; // root element

    this.options = options = _extends({}, options); // Export instance

    el[expando] = this;
    var defaults = {
      group: null,
      sort: true,
      disabled: false,
      store: null,
      handle: null,
      draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
      swapThreshold: 1,
      // percentage; 0 <= x <= 1
      invertSwap: false,
      // invert always
      invertedSwapThreshold: null,
      // will be set to same as swapThreshold if default
      removeCloneOnHide: true,
      direction: function direction() {
        return _detectDirection(el, this.options);
      },
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      ignore: 'a, img',
      filter: null,
      preventOnFilter: true,
      animation: 0,
      easing: null,
      setData: function setData(dataTransfer, dragEl) {
        dataTransfer.setData('Text', dragEl.textContent);
      },
      dropBubble: false,
      dragoverBubble: false,
      dataIdAttr: 'data-id',
      delay: 0,
      delayOnTouchOnly: false,
      touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
      forceFallback: false,
      fallbackClass: 'sortable-fallback',
      fallbackOnBody: false,
      fallbackTolerance: 0,
      fallbackOffset: {
        x: 0,
        y: 0
      },
      supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && !Safari,
      emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults); // Set default options

    for (var name in defaults) {
      !(name in options) && (options[name] = defaults[name]);
    }

    _prepareGroup(options); // Bind all private methods


    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    } // Setup drag mode


    this.nativeDraggable = options.forceFallback ? false : supportDraggable;

    if (this.nativeDraggable) {
      // Touch start threshold cannot be greater than the native dragstart threshold
      this.options.touchStartThreshold = 1;
    } // Bind events


    if (options.supportPointer) {
      on(el, 'pointerdown', this._onTapStart);
    } else {
      on(el, 'mousedown', this._onTapStart);
      on(el, 'touchstart', this._onTapStart);
    }

    if (this.nativeDraggable) {
      on(el, 'dragover', this);
      on(el, 'dragenter', this);
    }

    sortables.push(this.el); // Restore sorting

    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

    _extends(this, AnimationStateManager());
  }

  Sortable.prototype =
  /** @lends Sortable.prototype */
  {
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
      if (!this.el.contains(target) && target !== this.el) {
        lastTarget = null;
      }
    },
    _getDirection: function _getDirection(evt, target) {
      return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(
    /** Event|TouchEvent */
    evt) {
      if (!evt.cancelable) return;

      var _this = this,
          el = this.el,
          options = this.options,
          preventOnFilter = options.preventOnFilter,
          type = evt.type,
          touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
          target = (touch || evt).target,
          originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
          filter = options.filter;

      _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


      if (dragEl) {
        return;
      }

      if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
        return; // only left button and enabled
      } // cancel dnd if original target is content editable


      if (originalTarget.isContentEditable) {
        return;
      } // Safari ignores further event handling after mousedown


      if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
        return;
      }

      target = closest(target, options.draggable, el, false);

      if (target && target.animated) {
        return;
      }

      if (lastDownEl === target) {
        // Ignoring duplicate `down`
        return;
      } // Get the index of the dragged element within its parent


      oldIndex = index(target);
      oldDraggableIndex = index(target, options.draggable); // Check filter

      if (typeof filter === 'function') {
        if (filter.call(this, evt, target, this)) {
          _dispatchEvent({
            sortable: _this,
            rootEl: originalTarget,
            name: 'filter',
            targetEl: target,
            toEl: el,
            fromEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      } else if (filter) {
        filter = filter.split(',').some(function (criteria) {
          criteria = closest(originalTarget, criteria.trim(), el, false);

          if (criteria) {
            _dispatchEvent({
              sortable: _this,
              rootEl: criteria,
              name: 'filter',
              targetEl: target,
              fromEl: el,
              toEl: el
            });

            pluginEvent('filter', _this, {
              evt: evt
            });
            return true;
          }
        });

        if (filter) {
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      }

      if (options.handle && !closest(originalTarget, options.handle, el, false)) {
        return;
      } // Prepare `dragstart`


      this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(
    /** Event */
    evt,
    /** Touch */
    touch,
    /** HTMLElement */
    target) {
      var _this = this,
          el = _this.el,
          options = _this.options,
          ownerDocument = el.ownerDocument,
          dragStartFn;

      if (target && !dragEl && target.parentNode === el) {
        var dragRect = getRect(target);
        rootEl = el;
        dragEl = target;
        parentEl = dragEl.parentNode;
        nextEl = dragEl.nextSibling;
        lastDownEl = target;
        activeGroup = options.group;
        Sortable.dragged = dragEl;
        tapEvt = {
          target: dragEl,
          clientX: (touch || evt).clientX,
          clientY: (touch || evt).clientY
        };
        tapDistanceLeft = tapEvt.clientX - dragRect.left;
        tapDistanceTop = tapEvt.clientY - dragRect.top;
        this._lastX = (touch || evt).clientX;
        this._lastY = (touch || evt).clientY;
        dragEl.style['will-change'] = 'all';

        dragStartFn = function dragStartFn() {
          pluginEvent('delayEnded', _this, {
            evt: evt
          });

          if (Sortable.eventCanceled) {
            _this._onDrop();

            return;
          } // Delayed drag has been triggered
          // we can re-enable the events: touchmove/mousemove


          _this._disableDelayedDragEvents();

          if (!FireFox && _this.nativeDraggable) {
            dragEl.draggable = true;
          } // Bind the events: dragstart/dragend


          _this._triggerDragStart(evt, touch); // Drag start event


          _dispatchEvent({
            sortable: _this,
            name: 'choose',
            originalEvent: evt
          }); // Chosen item


          toggleClass(dragEl, options.chosenClass, true);
        }; // Disable "draggable"


        options.ignore.split(',').forEach(function (criteria) {
          find(dragEl, criteria.trim(), _disableDraggable);
        });
        on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mouseup', _this._onDrop);
        on(ownerDocument, 'touchend', _this._onDrop);
        on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

        if (FireFox && this.nativeDraggable) {
          this.options.touchStartThreshold = 4;
          dragEl.draggable = true;
        }

        pluginEvent('delayStart', this, {
          evt: evt
        }); // Delay is impossible for native DnD in Edge or IE

        if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
          if (Sortable.eventCanceled) {
            this._onDrop();

            return;
          } // If the user moves the pointer or let go the click or touch
          // before the delay has been reached:
          // disable the delayed drag


          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
          on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
          on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
          options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
          _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
        } else {
          dragStartFn();
        }
      }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
    /** TouchEvent|PointerEvent **/
    e) {
      var touch = e.touches ? e.touches[0] : e;

      if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
        this._disableDelayedDrag();
      }
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
      dragEl && _disableDraggable(dragEl);
      clearTimeout(this._dragStartTimer);

      this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._disableDelayedDrag);
      off(ownerDocument, 'touchend', this._disableDelayedDrag);
      off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
      off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(
    /** Event */
    evt,
    /** Touch */
    touch) {
      touch = touch || evt.pointerType == 'touch' && evt;

      if (!this.nativeDraggable || touch) {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._onTouchMove);
        } else if (touch) {
          on(document, 'touchmove', this._onTouchMove);
        } else {
          on(document, 'mousemove', this._onTouchMove);
        }
      } else {
        on(dragEl, 'dragend', this);
        on(rootEl, 'dragstart', this._onDragStart);
      }

      try {
        if (document.selection) {
          // Timeout neccessary for IE9
          _nextTick(function () {
            document.selection.empty();
          });
        } else {
          window.getSelection().removeAllRanges();
        }
      } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {

      awaitingDragStarted = false;

      if (rootEl && dragEl) {
        pluginEvent('dragStarted', this, {
          evt: evt
        });

        if (this.nativeDraggable) {
          on(document, 'dragover', _checkOutsideTargetEl);
        }

        var options = this.options; // Apply effect

        !fallback && toggleClass(dragEl, options.dragClass, false);
        toggleClass(dragEl, options.ghostClass, true);
        Sortable.active = this;
        fallback && this._appendGhost(); // Drag start event

        _dispatchEvent({
          sortable: this,
          name: 'start',
          originalEvent: evt
        });
      } else {
        this._nulling();
      }
    },
    _emulateDragOver: function _emulateDragOver() {
      if (touchEvt) {
        this._lastX = touchEvt.clientX;
        this._lastY = touchEvt.clientY;

        _hideGhostForTarget();

        var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        var parent = target;

        while (target && target.shadowRoot) {
          target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
          if (target === parent) break;
          parent = target;
        }

        dragEl.parentNode[expando]._isOutsideThisEl(target);

        if (parent) {
          do {
            if (parent[expando]) {
              var inserted = void 0;
              inserted = parent[expando]._onDragOver({
                clientX: touchEvt.clientX,
                clientY: touchEvt.clientY,
                target: target,
                rootEl: parent
              });

              if (inserted && !this.options.dragoverBubble) {
                break;
              }
            }

            target = parent; // store last element
          }
          /* jshint boss:true */
          while (parent = parent.parentNode);
        }

        _unhideGhostForTarget();
      }
    },
    _onTouchMove: function _onTouchMove(
    /**TouchEvent*/
    evt) {
      if (tapEvt) {
        var options = this.options,
            fallbackTolerance = options.fallbackTolerance,
            fallbackOffset = options.fallbackOffset,
            touch = evt.touches ? evt.touches[0] : evt,
            ghostMatrix = ghostEl && matrix(ghostEl, true),
            scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
            scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
            relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
            dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
            dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

        if (!Sortable.active && !awaitingDragStarted) {
          if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
            return;
          }

          this._onDragStart(evt, true);
        }

        if (ghostEl) {
          if (ghostMatrix) {
            ghostMatrix.e += dx - (lastDx || 0);
            ghostMatrix.f += dy - (lastDy || 0);
          } else {
            ghostMatrix = {
              a: 1,
              b: 0,
              c: 0,
              d: 1,
              e: dx,
              f: dy
            };
          }

          var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
          css(ghostEl, 'webkitTransform', cssMatrix);
          css(ghostEl, 'mozTransform', cssMatrix);
          css(ghostEl, 'msTransform', cssMatrix);
          css(ghostEl, 'transform', cssMatrix);
          lastDx = dx;
          lastDy = dy;
          touchEvt = touch;
        }

        evt.cancelable && evt.preventDefault();
      }
    },
    _appendGhost: function _appendGhost() {
      // Bug if using scale(): https://stackoverflow.com/questions/2637058
      // Not being adjusted for
      if (!ghostEl) {
        var container = this.options.fallbackOnBody ? document.body : rootEl,
            rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
            options = this.options; // Position absolutely

        if (PositionGhostAbsolutely) {
          // Get relatively positioned parent
          ghostRelativeParent = container;

          while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
            ghostRelativeParent = ghostRelativeParent.parentNode;
          }

          if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
            if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
            rect.top += ghostRelativeParent.scrollTop;
            rect.left += ghostRelativeParent.scrollLeft;
          } else {
            ghostRelativeParent = getWindowScrollingElement();
          }

          ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
        }

        ghostEl = dragEl.cloneNode(true);
        toggleClass(ghostEl, options.ghostClass, false);
        toggleClass(ghostEl, options.fallbackClass, true);
        toggleClass(ghostEl, options.dragClass, true);
        css(ghostEl, 'transition', '');
        css(ghostEl, 'transform', '');
        css(ghostEl, 'box-sizing', 'border-box');
        css(ghostEl, 'margin', 0);
        css(ghostEl, 'top', rect.top);
        css(ghostEl, 'left', rect.left);
        css(ghostEl, 'width', rect.width);
        css(ghostEl, 'height', rect.height);
        css(ghostEl, 'opacity', '0.8');
        css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
        css(ghostEl, 'zIndex', '100000');
        css(ghostEl, 'pointerEvents', 'none');
        Sortable.ghost = ghostEl;
        container.appendChild(ghostEl); // Set transform-origin

        css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
      }
    },
    _onDragStart: function _onDragStart(
    /**Event*/
    evt,
    /**boolean*/
    fallback) {
      var _this = this;

      var dataTransfer = evt.dataTransfer;
      var options = _this.options;
      pluginEvent('dragStart', this, {
        evt: evt
      });

      if (Sortable.eventCanceled) {
        this._onDrop();

        return;
      }

      pluginEvent('setupClone', this);

      if (!Sortable.eventCanceled) {
        cloneEl = clone(dragEl);
        cloneEl.removeAttribute("id");
        cloneEl.draggable = false;
        cloneEl.style['will-change'] = '';

        this._hideClone();

        toggleClass(cloneEl, this.options.chosenClass, false);
        Sortable.clone = cloneEl;
      } // #1143: IFrame support workaround


      _this.cloneId = _nextTick(function () {
        pluginEvent('clone', _this);
        if (Sortable.eventCanceled) return;

        if (!_this.options.removeCloneOnHide) {
          rootEl.insertBefore(cloneEl, dragEl);
        }

        _this._hideClone();

        _dispatchEvent({
          sortable: _this,
          name: 'clone'
        });
      });
      !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

      if (fallback) {
        ignoreNextClick = true;
        _this._loopId = setInterval(_this._emulateDragOver, 50);
      } else {
        // Undo what was set in _prepareDragStart before drag started
        off(document, 'mouseup', _this._onDrop);
        off(document, 'touchend', _this._onDrop);
        off(document, 'touchcancel', _this._onDrop);

        if (dataTransfer) {
          dataTransfer.effectAllowed = 'move';
          options.setData && options.setData.call(_this, dataTransfer, dragEl);
        }

        on(document, 'drop', _this); // #1276 fix:

        css(dragEl, 'transform', 'translateZ(0)');
      }

      awaitingDragStarted = true;
      _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
      on(document, 'selectstart', _this);
      moved = true;

      if (Safari) {
        css(document.body, 'user-select', 'none');
      }
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(
    /**Event*/
    evt) {
      var el = this.el,
          target = evt.target,
          dragRect,
          targetRect,
          revert,
          options = this.options,
          group = options.group,
          activeSortable = Sortable.active,
          isOwner = activeGroup === group,
          canSort = options.sort,
          fromSortable = putSortable || activeSortable,
          vertical,
          _this = this,
          completedFired = false;

      if (_silent) return;

      function dragOverEvent(name, extra) {
        pluginEvent(name, _this, _objectSpread2({
          evt: evt,
          isOwner: isOwner,
          axis: vertical ? 'vertical' : 'horizontal',
          revert: revert,
          dragRect: dragRect,
          targetRect: targetRect,
          canSort: canSort,
          fromSortable: fromSortable,
          target: target,
          completed: completed,
          onMove: function onMove(target, after) {
            return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
          },
          changed: changed
        }, extra));
      } // Capture animation state


      function capture() {
        dragOverEvent('dragOverAnimationCapture');

        _this.captureAnimationState();

        if (_this !== fromSortable) {
          fromSortable.captureAnimationState();
        }
      } // Return invocation when dragEl is inserted (or completed)


      function completed(insertion) {
        dragOverEvent('dragOverCompleted', {
          insertion: insertion
        });

        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          } else {
            activeSortable._showClone(_this);
          }

          if (_this !== fromSortable) {
            // Set ghost class to new sortable's ghost class
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
            toggleClass(dragEl, options.ghostClass, true);
          }

          if (putSortable !== _this && _this !== Sortable.active) {
            putSortable = _this;
          } else if (_this === Sortable.active && putSortable) {
            putSortable = null;
          } // Animation


          if (fromSortable === _this) {
            _this._ignoreWhileAnimating = target;
          }

          _this.animateAll(function () {
            dragOverEvent('dragOverAnimationComplete');
            _this._ignoreWhileAnimating = null;
          });

          if (_this !== fromSortable) {
            fromSortable.animateAll();
            fromSortable._ignoreWhileAnimating = null;
          }
        } // Null lastTarget if it is not inside a previously swapped element


        if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
          lastTarget = null;
        } // no bubbling and not fallback


        if (!options.dragoverBubble && !evt.rootEl && target !== document) {
          dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


          !insertion && nearestEmptyInsertDetectEvent(evt);
        }

        !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
        return completedFired = true;
      } // Call when dragEl has been inserted


      function changed() {
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);

        _dispatchEvent({
          sortable: _this,
          name: 'change',
          toEl: el,
          newIndex: newIndex,
          newDraggableIndex: newDraggableIndex,
          originalEvent: evt
        });
      }

      if (evt.preventDefault !== void 0) {
        evt.cancelable && evt.preventDefault();
      }

      target = closest(target, options.draggable, el, true);
      dragOverEvent('dragOver');
      if (Sortable.eventCanceled) return completedFired;

      if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
        return completed(false);
      }

      ignoreNextClick = false;

      if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
      : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
        vertical = this._getDirection(evt, target) === 'vertical';
        dragRect = getRect(dragEl);
        dragOverEvent('dragOverValid');
        if (Sortable.eventCanceled) return completedFired;

        if (revert) {
          parentEl = rootEl; // actualization

          capture();

          this._hideClone();

          dragOverEvent('revert');

          if (!Sortable.eventCanceled) {
            if (nextEl) {
              rootEl.insertBefore(dragEl, nextEl);
            } else {
              rootEl.appendChild(dragEl);
            }
          }

          return completed(true);
        }

        var elLastChild = lastChild(el, options.draggable);

        if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
          // Insert to end of list
          // If already at end of list: Do not insert
          if (elLastChild === dragEl) {
            return completed(false);
          } // if there is a last element, it is the target


          if (elLastChild && el === evt.target) {
            target = elLastChild;
          }

          if (target) {
            targetRect = getRect(target);
          }

          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
            capture();

            if (elLastChild && elLastChild.nextSibling) {
              // the last draggable element is not the last node
              el.insertBefore(dragEl, elLastChild.nextSibling);
            } else {
              el.appendChild(dragEl);
            }

            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
          // Insert to start of list
          var firstChild = getChild(el, 0, options, true);

          if (firstChild === dragEl) {
            return completed(false);
          }

          target = firstChild;
          targetRect = getRect(target);

          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
            capture();
            el.insertBefore(dragEl, firstChild);
            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (target.parentNode === el) {
          targetRect = getRect(target);
          var direction = 0,
              targetBeforeFirstSwap,
              differentLevel = dragEl.parentNode !== el,
              differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
              side1 = vertical ? 'top' : 'left',
              scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
              scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

          if (lastTarget !== target) {
            targetBeforeFirstSwap = targetRect[side1];
            pastFirstInvertThresh = false;
            isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
          }

          direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
          var sibling;

          if (direction !== 0) {
            // Check if target is beside dragEl in respective direction (ignoring hidden elements)
            var dragIndex = index(dragEl);

            do {
              dragIndex -= direction;
              sibling = parentEl.children[dragIndex];
            } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
          } // If dragEl is already beside target: Do not insert


          if (direction === 0 || sibling === target) {
            return completed(false);
          }

          lastTarget = target;
          lastDirection = direction;
          var nextSibling = target.nextElementSibling,
              after = false;
          after = direction === 1;

          var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

          if (moveVector !== false) {
            if (moveVector === 1 || moveVector === -1) {
              after = moveVector === 1;
            }

            _silent = true;
            setTimeout(_unsilent, 30);
            capture();

            if (after && !nextSibling) {
              el.appendChild(dragEl);
            } else {
              target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
            } // Undo chrome's scroll adjustment (has no effect on other browsers)


            if (scrolledPastTop) {
              scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
            }

            parentEl = dragEl.parentNode; // actualization
            // must be done before animation

            if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
              targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
            }

            changed();
            return completed(true);
          }
        }

        if (el.contains(dragEl)) {
          return completed(false);
        }
      }

      return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
      off(document, 'mousemove', this._onTouchMove);
      off(document, 'touchmove', this._onTouchMove);
      off(document, 'pointermove', this._onTouchMove);
      off(document, 'dragover', nearestEmptyInsertDetectEvent);
      off(document, 'mousemove', nearestEmptyInsertDetectEvent);
      off(document, 'touchmove', nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._onDrop);
      off(ownerDocument, 'touchend', this._onDrop);
      off(ownerDocument, 'pointerup', this._onDrop);
      off(ownerDocument, 'touchcancel', this._onDrop);
      off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(
    /**Event*/
    evt) {
      var el = this.el,
          options = this.options; // Get the index of the dragged element within its parent

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      pluginEvent('drop', this, {
        evt: evt
      });
      parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      if (Sortable.eventCanceled) {
        this._nulling();

        return;
      }

      awaitingDragStarted = false;
      isCircumstantialInvert = false;
      pastFirstInvertThresh = false;
      clearInterval(this._loopId);
      clearTimeout(this._dragStartTimer);

      _cancelNextTick(this.cloneId);

      _cancelNextTick(this._dragStartId); // Unbind events


      if (this.nativeDraggable) {
        off(document, 'drop', this);
        off(el, 'dragstart', this._onDragStart);
      }

      this._offMoveEvents();

      this._offUpEvents();

      if (Safari) {
        css(document.body, 'user-select', '');
      }

      css(dragEl, 'transform', '');

      if (evt) {
        if (moved) {
          evt.cancelable && evt.preventDefault();
          !options.dropBubble && evt.stopPropagation();
        }

        ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          // Remove clone(s)
          cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
        }

        if (dragEl) {
          if (this.nativeDraggable) {
            off(dragEl, 'dragend', this);
          }

          _disableDraggable(dragEl);

          dragEl.style['will-change'] = ''; // Remove classes
          // ghostClass is added in dragStarted

          if (moved && !awaitingDragStarted) {
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
          }

          toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

          _dispatchEvent({
            sortable: this,
            name: 'unchoose',
            toEl: parentEl,
            newIndex: null,
            newDraggableIndex: null,
            originalEvent: evt
          });

          if (rootEl !== parentEl) {
            if (newIndex >= 0) {
              // Add event
              _dispatchEvent({
                rootEl: parentEl,
                name: 'add',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              }); // Remove event


              _dispatchEvent({
                sortable: this,
                name: 'remove',
                toEl: parentEl,
                originalEvent: evt
              }); // drag from one list and drop into another


              _dispatchEvent({
                rootEl: parentEl,
                name: 'sort',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }

            putSortable && putSortable.save();
          } else {
            if (newIndex !== oldIndex) {
              if (newIndex >= 0) {
                // drag & drop within the same list
                _dispatchEvent({
                  sortable: this,
                  name: 'update',
                  toEl: parentEl,
                  originalEvent: evt
                });

                _dispatchEvent({
                  sortable: this,
                  name: 'sort',
                  toEl: parentEl,
                  originalEvent: evt
                });
              }
            }
          }

          if (Sortable.active) {
            /* jshint eqnull:true */
            if (newIndex == null || newIndex === -1) {
              newIndex = oldIndex;
              newDraggableIndex = oldDraggableIndex;
            }

            _dispatchEvent({
              sortable: this,
              name: 'end',
              toEl: parentEl,
              originalEvent: evt
            }); // Save sorting


            this.save();
          }
        }
      }

      this._nulling();
    },
    _nulling: function _nulling() {
      pluginEvent('nulling', this);
      rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
      savedInputChecked.forEach(function (el) {
        el.checked = true;
      });
      savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent(
    /**Event*/
    evt) {
      switch (evt.type) {
        case 'drop':
        case 'dragend':
          this._onDrop(evt);

          break;

        case 'dragenter':
        case 'dragover':
          if (dragEl) {
            this._onDragOver(evt);

            _globalDragOver(evt);
          }

          break;

        case 'selectstart':
          evt.preventDefault();
          break;
      }
    },

    /**
     * Serializes the item into an array of string.
     * @returns {String[]}
     */
    toArray: function toArray() {
      var order = [],
          el,
          children = this.el.children,
          i = 0,
          n = children.length,
          options = this.options;

      for (; i < n; i++) {
        el = children[i];

        if (closest(el, options.draggable, this.el, false)) {
          order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
      }

      return order;
    },

    /**
     * Sorts the elements according to the array.
     * @param  {String[]}  order  order of the items
     */
    sort: function sort(order, useAnimation) {
      var items = {},
          rootEl = this.el;
      this.toArray().forEach(function (id, i) {
        var el = rootEl.children[i];

        if (closest(el, this.options.draggable, rootEl, false)) {
          items[id] = el;
        }
      }, this);
      useAnimation && this.captureAnimationState();
      order.forEach(function (id) {
        if (items[id]) {
          rootEl.removeChild(items[id]);
          rootEl.appendChild(items[id]);
        }
      });
      useAnimation && this.animateAll();
    },

    /**
     * Save the current sorting
     */
    save: function save() {
      var store = this.options.store;
      store && store.set && store.set(this);
    },

    /**
     * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
     * @param   {HTMLElement}  el
     * @param   {String}       [selector]  default: `options.draggable`
     * @returns {HTMLElement|null}
     */
    closest: function closest$1(el, selector) {
      return closest(el, selector || this.options.draggable, this.el, false);
    },

    /**
     * Set/get option
     * @param   {string} name
     * @param   {*}      [value]
     * @returns {*}
     */
    option: function option(name, value) {
      var options = this.options;

      if (value === void 0) {
        return options[name];
      } else {
        var modifiedValue = PluginManager.modifyOption(this, name, value);

        if (typeof modifiedValue !== 'undefined') {
          options[name] = modifiedValue;
        } else {
          options[name] = value;
        }

        if (name === 'group') {
          _prepareGroup(options);
        }
      }
    },

    /**
     * Destroy
     */
    destroy: function destroy() {
      pluginEvent('destroy', this);
      var el = this.el;
      el[expando] = null;
      off(el, 'mousedown', this._onTapStart);
      off(el, 'touchstart', this._onTapStart);
      off(el, 'pointerdown', this._onTapStart);

      if (this.nativeDraggable) {
        off(el, 'dragover', this);
        off(el, 'dragenter', this);
      } // Remove draggable attributes


      Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
        el.removeAttribute('draggable');
      });

      this._onDrop();

      this._disableDelayedDragEvents();

      sortables.splice(sortables.indexOf(this.el), 1);
      this.el = el = null;
    },
    _hideClone: function _hideClone() {
      if (!cloneHidden) {
        pluginEvent('hideClone', this);
        if (Sortable.eventCanceled) return;
        css(cloneEl, 'display', 'none');

        if (this.options.removeCloneOnHide && cloneEl.parentNode) {
          cloneEl.parentNode.removeChild(cloneEl);
        }

        cloneHidden = true;
      }
    },
    _showClone: function _showClone(putSortable) {
      if (putSortable.lastPutMode !== 'clone') {
        this._hideClone();

        return;
      }

      if (cloneHidden) {
        pluginEvent('showClone', this);
        if (Sortable.eventCanceled) return; // show clone at dragEl or original position

        if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
          rootEl.insertBefore(cloneEl, dragEl);
        } else if (nextEl) {
          rootEl.insertBefore(cloneEl, nextEl);
        } else {
          rootEl.appendChild(cloneEl);
        }

        if (this.options.group.revertClone) {
          this.animate(dragEl, cloneEl);
        }

        css(cloneEl, 'display', '');
        cloneHidden = false;
      }
    }
  };

  function _globalDragOver(
  /**Event*/
  evt) {
    if (evt.dataTransfer) {
      evt.dataTransfer.dropEffect = 'move';
    }

    evt.cancelable && evt.preventDefault();
  }

  function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt,
        sortable = fromEl[expando],
        onMoveFn = sortable.options.onMove,
        retVal; // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent('move', true, true);
    }

    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);

    if (onMoveFn) {
      retVal = onMoveFn.call(sortable, evt, originalEvent);
    }

    return retVal;
  }

  function _disableDraggable(el) {
    el.draggable = false;
  }

  function _unsilent() {
    _silent = false;
  }

  function _ghostIsFirst(evt, vertical, sortable) {
    var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
  }

  function _ghostIsLast(evt, vertical, sortable) {
    var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
  }

  function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
        targetLength = vertical ? targetRect.height : targetRect.width,
        targetS1 = vertical ? targetRect.top : targetRect.left,
        targetS2 = vertical ? targetRect.bottom : targetRect.right,
        invert = false;

    if (!invertSwap) {
      // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
      if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
        // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
        // check if past first invert threshold on side opposite of lastDirection
        if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
          // past first invert threshold, do not restrict inverted threshold to dragEl shadow
          pastFirstInvertThresh = true;
        }

        if (!pastFirstInvertThresh) {
          // dragEl shadow (target move distance shadow)
          if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
          : mouseOnAxis > targetS2 - targetMoveDistance) {
            return -lastDirection;
          }
        } else {
          invert = true;
        }
      } else {
        // Regular
        if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
          return _getInsertDirection(target);
        }
      }
    }

    invert = invert || invertSwap;

    if (invert) {
      // Invert of regular
      if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
        return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
      }
    }

    return 0;
  }
  /**
   * Gets the direction dragEl must be swapped relative to target in order to make it
   * seem that dragEl has been "inserted" into that element's position
   * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
   * @return {Number}                   Direction dragEl must be swapped
   */


  function _getInsertDirection(target) {
    if (index(dragEl) < index(target)) {
      return 1;
    } else {
      return -1;
    }
  }
  /**
   * Generate id
   * @param   {HTMLElement} el
   * @returns {String}
   * @private
   */


  function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent,
        i = str.length,
        sum = 0;

    while (i--) {
      sum += str.charCodeAt(i);
    }

    return sum.toString(36);
  }

  function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;

    while (idx--) {
      var el = inputs[idx];
      el.checked && savedInputChecked.push(el);
    }
  }

  function _nextTick(fn) {
    return setTimeout(fn, 0);
  }

  function _cancelNextTick(id) {
    return clearTimeout(id);
  } // Fixed #973:


  if (documentExists) {
    on(document, 'touchmove', function (evt) {
      if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
        evt.preventDefault();
      }
    });
  } // Export utils


  Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
      return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild
  };
  /**
   * Get the Sortable instance of an element
   * @param  {HTMLElement} element The element
   * @return {Sortable|undefined}         The instance of Sortable
   */

  Sortable.get = function (element) {
    return element[expando];
  };
  /**
   * Mount a plugin to Sortable
   * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
   */


  Sortable.mount = function () {
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function (plugin) {
      if (!plugin.prototype || !plugin.prototype.constructor) {
        throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
      }

      if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
      PluginManager.mount(plugin);
    });
  };
  /**
   * Create sortable instance
   * @param {HTMLElement}  el
   * @param {Object}      [options]
   */


  Sortable.create = function (el, options) {
    return new Sortable(el, options);
  }; // Export


  Sortable.version = version;

  var autoScrolls = [],
      scrollEl,
      scrollRootEl,
      scrolling = false,
      lastAutoScrollX,
      lastAutoScrollY,
      touchEvt$1,
      pointerElemChangedInterval;

  function AutoScrollPlugin() {
    function AutoScroll() {
      this.defaults = {
        scroll: true,
        forceAutoScrollFallback: false,
        scrollSensitivity: 30,
        scrollSpeed: 10,
        bubbleScroll: true
      }; // Bind all private methods

      for (var fn in this) {
        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
          this[fn] = this[fn].bind(this);
        }
      }
    }

    AutoScroll.prototype = {
      dragStarted: function dragStarted(_ref) {
        var originalEvent = _ref.originalEvent;

        if (this.sortable.nativeDraggable) {
          on(document, 'dragover', this._handleAutoScroll);
        } else {
          if (this.options.supportPointer) {
            on(document, 'pointermove', this._handleFallbackAutoScroll);
          } else if (originalEvent.touches) {
            on(document, 'touchmove', this._handleFallbackAutoScroll);
          } else {
            on(document, 'mousemove', this._handleFallbackAutoScroll);
          }
        }
      },
      dragOverCompleted: function dragOverCompleted(_ref2) {
        var originalEvent = _ref2.originalEvent;

        // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
        if (!this.options.dragOverBubble && !originalEvent.rootEl) {
          this._handleAutoScroll(originalEvent);
        }
      },
      drop: function drop() {
        if (this.sortable.nativeDraggable) {
          off(document, 'dragover', this._handleAutoScroll);
        } else {
          off(document, 'pointermove', this._handleFallbackAutoScroll);
          off(document, 'touchmove', this._handleFallbackAutoScroll);
          off(document, 'mousemove', this._handleFallbackAutoScroll);
        }

        clearPointerElemChangedInterval();
        clearAutoScrolls();
        cancelThrottle();
      },
      nulling: function nulling() {
        touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
        autoScrolls.length = 0;
      },
      _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
        this._handleAutoScroll(evt, true);
      },
      _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
        var _this = this;

        var x = (evt.touches ? evt.touches[0] : evt).clientX,
            y = (evt.touches ? evt.touches[0] : evt).clientY,
            elem = document.elementFromPoint(x, y);
        touchEvt$1 = evt; // IE does not seem to have native autoscroll,
        // Edge's autoscroll seems too conditional,
        // MACOS Safari does not have autoscroll,
        // Firefox and Chrome are good

        if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
          autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

          var ogElemScroller = getParentAutoScrollElement(elem, true);

          if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
            pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

            pointerElemChangedInterval = setInterval(function () {
              var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

              if (newElem !== ogElemScroller) {
                ogElemScroller = newElem;
                clearAutoScrolls();
              }

              autoScroll(evt, _this.options, newElem, fallback);
            }, 10);
            lastAutoScrollX = x;
            lastAutoScrollY = y;
          }
        } else {
          // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
          if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
            clearAutoScrolls();
            return;
          }

          autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
        }
      }
    };
    return _extends(AutoScroll, {
      pluginName: 'scroll',
      initializeByDefault: true
    });
  }

  function clearAutoScrolls() {
    autoScrolls.forEach(function (autoScroll) {
      clearInterval(autoScroll.pid);
    });
    autoScrolls = [];
  }

  function clearPointerElemChangedInterval() {
    clearInterval(pointerElemChangedInterval);
  }

  var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX,
        y = (evt.touches ? evt.touches[0] : evt).clientY,
        sens = options.scrollSensitivity,
        speed = options.scrollSpeed,
        winScroller = getWindowScrollingElement();
    var scrollThisInstance = false,
        scrollCustomFn; // New scroll root, set scrollEl

    if (scrollRootEl !== rootEl) {
      scrollRootEl = rootEl;
      clearAutoScrolls();
      scrollEl = options.scroll;
      scrollCustomFn = options.scrollFn;

      if (scrollEl === true) {
        scrollEl = getParentAutoScrollElement(rootEl, true);
      }
    }

    var layersOut = 0;
    var currentParent = scrollEl;

    do {
      var el = currentParent,
          rect = getRect(el),
          top = rect.top,
          bottom = rect.bottom,
          left = rect.left,
          right = rect.right,
          width = rect.width,
          height = rect.height,
          canScrollX = void 0,
          canScrollY = void 0,
          scrollWidth = el.scrollWidth,
          scrollHeight = el.scrollHeight,
          elCSS = css(el),
          scrollPosX = el.scrollLeft,
          scrollPosY = el.scrollTop;

      if (el === winScroller) {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
      } else {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
      }

      var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
      var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

      if (!autoScrolls[layersOut]) {
        for (var i = 0; i <= layersOut; i++) {
          if (!autoScrolls[i]) {
            autoScrolls[i] = {};
          }
        }
      }

      if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
        autoScrolls[layersOut].el = el;
        autoScrolls[layersOut].vx = vx;
        autoScrolls[layersOut].vy = vy;
        clearInterval(autoScrolls[layersOut].pid);

        if (vx != 0 || vy != 0) {
          scrollThisInstance = true;
          /* jshint loopfunc:true */

          autoScrolls[layersOut].pid = setInterval(function () {
            // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
            if (isFallback && this.layer === 0) {
              Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

            }

            var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
            var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

            if (typeof scrollCustomFn === 'function') {
              if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                return;
              }
            }

            scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
          }.bind({
            layer: layersOut
          }), 24);
        }
      }

      layersOut++;
    } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
  }, 30);

  var drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent,
        putSortable = _ref.putSortable,
        dragEl = _ref.dragEl,
        activeSortable = _ref.activeSortable,
        dispatchSortableEvent = _ref.dispatchSortableEvent,
        hideGhostForTarget = _ref.hideGhostForTarget,
        unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();

    if (toSortable && !toSortable.el.contains(target)) {
      dispatchSortableEvent('spill');
      this.onSpill({
        dragEl: dragEl,
        putSortable: putSortable
      });
    }
  };

  function Revert() {}

  Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
      var oldDraggableIndex = _ref2.oldDraggableIndex;
      this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
      var dragEl = _ref3.dragEl,
          putSortable = _ref3.putSortable;
      this.sortable.captureAnimationState();

      if (putSortable) {
        putSortable.captureAnimationState();
      }

      var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

      if (nextSibling) {
        this.sortable.el.insertBefore(dragEl, nextSibling);
      } else {
        this.sortable.el.appendChild(dragEl);
      }

      this.sortable.animateAll();

      if (putSortable) {
        putSortable.animateAll();
      }
    },
    drop: drop
  };

  _extends(Revert, {
    pluginName: 'revertOnSpill'
  });

  function Remove() {}

  Remove.prototype = {
    onSpill: function onSpill(_ref4) {
      var dragEl = _ref4.dragEl,
          putSortable = _ref4.putSortable;
      var parentSortable = putSortable || this.sortable;
      parentSortable.captureAnimationState();
      dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
      parentSortable.animateAll();
    },
    drop: drop
  };

  _extends(Remove, {
    pluginName: 'removeOnSpill'
  });

  var lastSwapEl;

  function SwapPlugin() {
    function Swap() {
      this.defaults = {
        swapClass: 'sortable-swap-highlight'
      };
    }

    Swap.prototype = {
      dragStart: function dragStart(_ref) {
        var dragEl = _ref.dragEl;
        lastSwapEl = dragEl;
      },
      dragOverValid: function dragOverValid(_ref2) {
        var completed = _ref2.completed,
            target = _ref2.target,
            onMove = _ref2.onMove,
            activeSortable = _ref2.activeSortable,
            changed = _ref2.changed,
            cancel = _ref2.cancel;
        if (!activeSortable.options.swap) return;
        var el = this.sortable.el,
            options = this.options;

        if (target && target !== el) {
          var prevSwapEl = lastSwapEl;

          if (onMove(target) !== false) {
            toggleClass(target, options.swapClass, true);
            lastSwapEl = target;
          } else {
            lastSwapEl = null;
          }

          if (prevSwapEl && prevSwapEl !== lastSwapEl) {
            toggleClass(prevSwapEl, options.swapClass, false);
          }
        }

        changed();
        completed(true);
        cancel();
      },
      drop: function drop(_ref3) {
        var activeSortable = _ref3.activeSortable,
            putSortable = _ref3.putSortable,
            dragEl = _ref3.dragEl;
        var toSortable = putSortable || this.sortable;
        var options = this.options;
        lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

        if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
          if (dragEl !== lastSwapEl) {
            toSortable.captureAnimationState();
            if (toSortable !== activeSortable) activeSortable.captureAnimationState();
            swapNodes(dragEl, lastSwapEl);
            toSortable.animateAll();
            if (toSortable !== activeSortable) activeSortable.animateAll();
          }
        }
      },
      nulling: function nulling() {
        lastSwapEl = null;
      }
    };
    return _extends(Swap, {
      pluginName: 'swap',
      eventProperties: function eventProperties() {
        return {
          swapItem: lastSwapEl
        };
      }
    });
  }

  function swapNodes(n1, n2) {
    var p1 = n1.parentNode,
        p2 = n2.parentNode,
        i1,
        i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = index(n1);
    i2 = index(n2);

    if (p1.isEqualNode(p2) && i1 < i2) {
      i2++;
    }

    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
  }

  var multiDragElements = [],
      multiDragClones = [],
      lastMultiDragSelect,
      // for selection with modifier key down (SHIFT)
  multiDragSortable,
      initialFolding = false,
      // Initial multi-drag fold when drag started
  folding = false,
      // Folding any other time
  dragStarted = false,
      dragEl$1,
      clonesFromRect,
      clonesHidden;

  function MultiDragPlugin() {
    function MultiDrag(sortable) {
      // Bind all private methods
      for (var fn in this) {
        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
          this[fn] = this[fn].bind(this);
        }
      }

      if (!sortable.options.avoidImplicitDeselect) {
        if (sortable.options.supportPointer) {
          on(document, 'pointerup', this._deselectMultiDrag);
        } else {
          on(document, 'mouseup', this._deselectMultiDrag);
          on(document, 'touchend', this._deselectMultiDrag);
        }
      }

      on(document, 'keydown', this._checkKeyDown);
      on(document, 'keyup', this._checkKeyUp);
      this.defaults = {
        selectedClass: 'sortable-selected',
        multiDragKey: null,
        avoidImplicitDeselect: false,
        setData: function setData(dataTransfer, dragEl) {
          var data = '';

          if (multiDragElements.length && multiDragSortable === sortable) {
            multiDragElements.forEach(function (multiDragElement, i) {
              data += (!i ? '' : ', ') + multiDragElement.textContent;
            });
          } else {
            data = dragEl.textContent;
          }

          dataTransfer.setData('Text', data);
        }
      };
    }

    MultiDrag.prototype = {
      multiDragKeyDown: false,
      isMultiDrag: false,
      delayStartGlobal: function delayStartGlobal(_ref) {
        var dragged = _ref.dragEl;
        dragEl$1 = dragged;
      },
      delayEnded: function delayEnded() {
        this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
      },
      setupClone: function setupClone(_ref2) {
        var sortable = _ref2.sortable,
            cancel = _ref2.cancel;
        if (!this.isMultiDrag) return;

        for (var i = 0; i < multiDragElements.length; i++) {
          multiDragClones.push(clone(multiDragElements[i]));
          multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
          multiDragClones[i].draggable = false;
          multiDragClones[i].style['will-change'] = '';
          toggleClass(multiDragClones[i], this.options.selectedClass, false);
          multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
        }

        sortable._hideClone();

        cancel();
      },
      clone: function clone(_ref3) {
        var sortable = _ref3.sortable,
            rootEl = _ref3.rootEl,
            dispatchSortableEvent = _ref3.dispatchSortableEvent,
            cancel = _ref3.cancel;
        if (!this.isMultiDrag) return;

        if (!this.options.removeCloneOnHide) {
          if (multiDragElements.length && multiDragSortable === sortable) {
            insertMultiDragClones(true, rootEl);
            dispatchSortableEvent('clone');
            cancel();
          }
        }
      },
      showClone: function showClone(_ref4) {
        var cloneNowShown = _ref4.cloneNowShown,
            rootEl = _ref4.rootEl,
            cancel = _ref4.cancel;
        if (!this.isMultiDrag) return;
        insertMultiDragClones(false, rootEl);
        multiDragClones.forEach(function (clone) {
          css(clone, 'display', '');
        });
        cloneNowShown();
        clonesHidden = false;
        cancel();
      },
      hideClone: function hideClone(_ref5) {
        var _this = this;

        var sortable = _ref5.sortable,
            cloneNowHidden = _ref5.cloneNowHidden,
            cancel = _ref5.cancel;
        if (!this.isMultiDrag) return;
        multiDragClones.forEach(function (clone) {
          css(clone, 'display', 'none');

          if (_this.options.removeCloneOnHide && clone.parentNode) {
            clone.parentNode.removeChild(clone);
          }
        });
        cloneNowHidden();
        clonesHidden = true;
        cancel();
      },
      dragStartGlobal: function dragStartGlobal(_ref6) {
        var sortable = _ref6.sortable;

        if (!this.isMultiDrag && multiDragSortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();
        }

        multiDragElements.forEach(function (multiDragElement) {
          multiDragElement.sortableIndex = index(multiDragElement);
        }); // Sort multi-drag elements

        multiDragElements = multiDragElements.sort(function (a, b) {
          return a.sortableIndex - b.sortableIndex;
        });
        dragStarted = true;
      },
      dragStarted: function dragStarted(_ref7) {
        var _this2 = this;

        var sortable = _ref7.sortable;
        if (!this.isMultiDrag) return;

        if (this.options.sort) {
          // Capture rects,
          // hide multi drag elements (by positioning them absolute),
          // set multi drag elements rects to dragRect,
          // show multi drag elements,
          // animate to rects,
          // unset rects & remove from DOM
          sortable.captureAnimationState();

          if (this.options.animation) {
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              css(multiDragElement, 'position', 'absolute');
            });
            var dragRect = getRect(dragEl$1, false, true, true);
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              setRect(multiDragElement, dragRect);
            });
            folding = true;
            initialFolding = true;
          }
        }

        sortable.animateAll(function () {
          folding = false;
          initialFolding = false;

          if (_this2.options.animation) {
            multiDragElements.forEach(function (multiDragElement) {
              unsetRect(multiDragElement);
            });
          } // Remove all auxiliary multidrag items from el, if sorting enabled


          if (_this2.options.sort) {
            removeMultiDragElements();
          }
        });
      },
      dragOver: function dragOver(_ref8) {
        var target = _ref8.target,
            completed = _ref8.completed,
            cancel = _ref8.cancel;

        if (folding && ~multiDragElements.indexOf(target)) {
          completed(false);
          cancel();
        }
      },
      revert: function revert(_ref9) {
        var fromSortable = _ref9.fromSortable,
            rootEl = _ref9.rootEl,
            sortable = _ref9.sortable,
            dragRect = _ref9.dragRect;

        if (multiDragElements.length > 1) {
          // Setup unfold animation
          multiDragElements.forEach(function (multiDragElement) {
            sortable.addAnimationState({
              target: multiDragElement,
              rect: folding ? getRect(multiDragElement) : dragRect
            });
            unsetRect(multiDragElement);
            multiDragElement.fromRect = dragRect;
            fromSortable.removeAnimationState(multiDragElement);
          });
          folding = false;
          insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
        }
      },
      dragOverCompleted: function dragOverCompleted(_ref10) {
        var sortable = _ref10.sortable,
            isOwner = _ref10.isOwner,
            insertion = _ref10.insertion,
            activeSortable = _ref10.activeSortable,
            parentEl = _ref10.parentEl,
            putSortable = _ref10.putSortable;
        var options = this.options;

        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          }

          initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

          if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
            // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
            var dragRectAbsolute = getRect(dragEl$1, false, true, true);
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
              // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

              parentEl.appendChild(multiDragElement);
            });
            folding = true;
          } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


          if (!isOwner) {
            // Only remove if not folding (folding will remove them anyways)
            if (!folding) {
              removeMultiDragElements();
            }

            if (multiDragElements.length > 1) {
              var clonesHiddenBefore = clonesHidden;

              activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


              if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                multiDragClones.forEach(function (clone) {
                  activeSortable.addAnimationState({
                    target: clone,
                    rect: clonesFromRect
                  });
                  clone.fromRect = clonesFromRect;
                  clone.thisAnimationDuration = null;
                });
              }
            } else {
              activeSortable._showClone(sortable);
            }
          }
        }
      },
      dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
        var dragRect = _ref11.dragRect,
            isOwner = _ref11.isOwner,
            activeSortable = _ref11.activeSortable;
        multiDragElements.forEach(function (multiDragElement) {
          multiDragElement.thisAnimationDuration = null;
        });

        if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
          clonesFromRect = _extends({}, dragRect);
          var dragMatrix = matrix(dragEl$1, true);
          clonesFromRect.top -= dragMatrix.f;
          clonesFromRect.left -= dragMatrix.e;
        }
      },
      dragOverAnimationComplete: function dragOverAnimationComplete() {
        if (folding) {
          folding = false;
          removeMultiDragElements();
        }
      },
      drop: function drop(_ref12) {
        var evt = _ref12.originalEvent,
            rootEl = _ref12.rootEl,
            parentEl = _ref12.parentEl,
            sortable = _ref12.sortable,
            dispatchSortableEvent = _ref12.dispatchSortableEvent,
            oldIndex = _ref12.oldIndex,
            putSortable = _ref12.putSortable;
        var toSortable = putSortable || this.sortable;
        if (!evt) return;
        var options = this.options,
            children = parentEl.children; // Multi-drag selection

        if (!dragStarted) {
          if (options.multiDragKey && !this.multiDragKeyDown) {
            this._deselectMultiDrag();
          }

          toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

          if (!~multiDragElements.indexOf(dragEl$1)) {
            multiDragElements.push(dragEl$1);
            dispatchEvent({
              sortable: sortable,
              rootEl: rootEl,
              name: 'select',
              targetEl: dragEl$1,
              originalEvent: evt
            }); // Modifier activated, select from last to dragEl

            if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
              var lastIndex = index(lastMultiDragSelect),
                  currentIndex = index(dragEl$1);

              if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                // (but previous selection existed)
                var n, i;

                if (currentIndex > lastIndex) {
                  i = lastIndex;
                  n = currentIndex;
                } else {
                  i = currentIndex;
                  n = lastIndex + 1;
                }

                for (; i < n; i++) {
                  if (~multiDragElements.indexOf(children[i])) continue;
                  toggleClass(children[i], options.selectedClass, true);
                  multiDragElements.push(children[i]);
                  dispatchEvent({
                    sortable: sortable,
                    rootEl: rootEl,
                    name: 'select',
                    targetEl: children[i],
                    originalEvent: evt
                  });
                }
              }
            } else {
              lastMultiDragSelect = dragEl$1;
            }

            multiDragSortable = toSortable;
          } else {
            multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
            lastMultiDragSelect = null;
            dispatchEvent({
              sortable: sortable,
              rootEl: rootEl,
              name: 'deselect',
              targetEl: dragEl$1,
              originalEvent: evt
            });
          }
        } // Multi-drag drop


        if (dragStarted && this.isMultiDrag) {
          folding = false; // Do not "unfold" after around dragEl if reverted

          if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
            var dragRect = getRect(dragEl$1),
                multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
            if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
            toSortable.captureAnimationState();

            if (!initialFolding) {
              if (options.animation) {
                dragEl$1.fromRect = dragRect;
                multiDragElements.forEach(function (multiDragElement) {
                  multiDragElement.thisAnimationDuration = null;

                  if (multiDragElement !== dragEl$1) {
                    var rect = folding ? getRect(multiDragElement) : dragRect;
                    multiDragElement.fromRect = rect; // Prepare unfold animation

                    toSortable.addAnimationState({
                      target: multiDragElement,
                      rect: rect
                    });
                  }
                });
              } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
              // properly they must all be removed


              removeMultiDragElements();
              multiDragElements.forEach(function (multiDragElement) {
                if (children[multiDragIndex]) {
                  parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                } else {
                  parentEl.appendChild(multiDragElement);
                }

                multiDragIndex++;
              }); // If initial folding is done, the elements may have changed position because they are now
              // unfolding around dragEl, even though dragEl may not have his index changed, so update event
              // must be fired here as Sortable will not.

              if (oldIndex === index(dragEl$1)) {
                var update = false;
                multiDragElements.forEach(function (multiDragElement) {
                  if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                    update = true;
                    return;
                  }
                });

                if (update) {
                  dispatchSortableEvent('update');
                }
              }
            } // Must be done after capturing individual rects (scroll bar)


            multiDragElements.forEach(function (multiDragElement) {
              unsetRect(multiDragElement);
            });
            toSortable.animateAll();
          }

          multiDragSortable = toSortable;
        } // Remove clones if necessary


        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          multiDragClones.forEach(function (clone) {
            clone.parentNode && clone.parentNode.removeChild(clone);
          });
        }
      },
      nullingGlobal: function nullingGlobal() {
        this.isMultiDrag = dragStarted = false;
        multiDragClones.length = 0;
      },
      destroyGlobal: function destroyGlobal() {
        this._deselectMultiDrag();

        off(document, 'pointerup', this._deselectMultiDrag);
        off(document, 'mouseup', this._deselectMultiDrag);
        off(document, 'touchend', this._deselectMultiDrag);
        off(document, 'keydown', this._checkKeyDown);
        off(document, 'keyup', this._checkKeyUp);
      },
      _deselectMultiDrag: function _deselectMultiDrag(evt) {
        if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

        if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

        if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

        if (evt && evt.button !== 0) return;

        while (multiDragElements.length) {
          var el = multiDragElements[0];
          toggleClass(el, this.options.selectedClass, false);
          multiDragElements.shift();
          dispatchEvent({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: 'deselect',
            targetEl: el,
            originalEvent: evt
          });
        }
      },
      _checkKeyDown: function _checkKeyDown(evt) {
        if (evt.key === this.options.multiDragKey) {
          this.multiDragKeyDown = true;
        }
      },
      _checkKeyUp: function _checkKeyUp(evt) {
        if (evt.key === this.options.multiDragKey) {
          this.multiDragKeyDown = false;
        }
      }
    };
    return _extends(MultiDrag, {
      // Static methods & properties
      pluginName: 'multiDrag',
      utils: {
        /**
         * Selects the provided multi-drag item
         * @param  {HTMLElement} el    The element to be selected
         */
        select: function select(el) {
          var sortable = el.parentNode[expando];
          if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

          if (multiDragSortable && multiDragSortable !== sortable) {
            multiDragSortable.multiDrag._deselectMultiDrag();

            multiDragSortable = sortable;
          }

          toggleClass(el, sortable.options.selectedClass, true);
          multiDragElements.push(el);
        },

        /**
         * Deselects the provided multi-drag item
         * @param  {HTMLElement} el    The element to be deselected
         */
        deselect: function deselect(el) {
          var sortable = el.parentNode[expando],
              index = multiDragElements.indexOf(el);
          if (!sortable || !sortable.options.multiDrag || !~index) return;
          toggleClass(el, sortable.options.selectedClass, false);
          multiDragElements.splice(index, 1);
        }
      },
      eventProperties: function eventProperties() {
        var _this3 = this;

        var oldIndicies = [],
            newIndicies = [];
        multiDragElements.forEach(function (multiDragElement) {
          oldIndicies.push({
            multiDragElement: multiDragElement,
            index: multiDragElement.sortableIndex
          }); // multiDragElements will already be sorted if folding

          var newIndex;

          if (folding && multiDragElement !== dragEl$1) {
            newIndex = -1;
          } else if (folding) {
            newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
          } else {
            newIndex = index(multiDragElement);
          }

          newIndicies.push({
            multiDragElement: multiDragElement,
            index: newIndex
          });
        });
        return {
          items: _toConsumableArray(multiDragElements),
          clones: [].concat(multiDragClones),
          oldIndicies: oldIndicies,
          newIndicies: newIndicies
        };
      },
      optionListeners: {
        multiDragKey: function multiDragKey(key) {
          key = key.toLowerCase();

          if (key === 'ctrl') {
            key = 'Control';
          } else if (key.length > 1) {
            key = key.charAt(0).toUpperCase() + key.substr(1);
          }

          return key;
        }
      }
    });
  }

  function insertMultiDragElements(clonesInserted, rootEl) {
    multiDragElements.forEach(function (multiDragElement, i) {
      var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

      if (target) {
        rootEl.insertBefore(multiDragElement, target);
      } else {
        rootEl.appendChild(multiDragElement);
      }
    });
  }
  /**
   * Insert multi-drag clones
   * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
   * @param  {HTMLElement} rootEl
   */


  function insertMultiDragClones(elementsInserted, rootEl) {
    multiDragClones.forEach(function (clone, i) {
      var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

      if (target) {
        rootEl.insertBefore(clone, target);
      } else {
        rootEl.appendChild(clone);
      }
    });
  }

  function removeMultiDragElements() {
    multiDragElements.forEach(function (multiDragElement) {
      if (multiDragElement === dragEl$1) return;
      multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
  }

  Sortable.mount(new AutoScrollPlugin());
  Sortable.mount(Remove, Revert);

  Sortable.mount(new SwapPlugin());
  Sortable.mount(new MultiDragPlugin());

  return Sortable;

})));

},{}],19:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":17,"timers":19}],20:[function(require,module,exports){
/**
 * tooltipster http://iamceege.github.io/tooltipster/
 * A rockin' custom tooltip jQuery plugin
 * Developed by Caleb Jacob and Louis Ameline
 * MIT license
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(["jquery"], function (a0) {
      return (factory(a0));
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
}(this, function ($) {

// This file will be UMDified by a build task.

var defaults = {
		animation: 'fade',
		animationDuration: 350,
		content: null,
		contentAsHTML: false,
		contentCloning: false,
		debug: true,
		delay: 300,
		delayTouch: [300, 500],
		functionInit: null,
		functionBefore: null,
		functionReady: null,
		functionAfter: null,
		functionFormat: null,
		IEmin: 6,
		interactive: false,
		multiple: false,
		// will default to document.body, or must be an element positioned at (0, 0)
		// in the document, typically like the very top views of an app.
		parent: null,
		plugins: ['sideTip'],
		repositionOnScroll: false,
		restoration: 'none',
		selfDestruction: true,
		theme: [],
		timer: 0,
		trackerInterval: 500,
		trackOrigin: false,
		trackTooltip: false,
		trigger: 'hover',
		triggerClose: {
			click: false,
			mouseleave: false,
			originClick: false,
			scroll: false,
			tap: false,
			touchleave: false
		},
		triggerOpen: {
			click: false,
			mouseenter: false,
			tap: false,
			touchstart: false
		},
		updateAnimation: 'rotate',
		zIndex: 9999999
	},
	// we'll avoid using the 'window' global as a good practice but npm's
	// jquery@<2.1.0 package actually requires a 'window' global, so not sure
	// it's useful at all
	win = (typeof window != 'undefined') ? window : null,
	// env will be proxied by the core for plugins to have access its properties
	env = {
		// detect if this device can trigger touch events. Better have a false
		// positive (unused listeners, that's ok) than a false negative.
		// https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
		// http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
		hasTouchCapability: !!(
			win
			&&	(	'ontouchstart' in win
				||	(win.DocumentTouch && win.document instanceof win.DocumentTouch)
				||	win.navigator.maxTouchPoints
			)
		),
		hasTransitions: transitionSupport(),
		IE: false,
		// don't set manually, it will be updated by a build task after the manifest
		semVer: '4.2.8',
		window: win
	},
	core = function() {
		
		// core variables
		
		// the core emitters
		this.__$emitterPrivate = $({});
		this.__$emitterPublic = $({});
		this.__instancesLatestArr = [];
		// collects plugin constructors
		this.__plugins = {};
		// proxy env variables for plugins who might use them
		this._env = env;
	};

// core methods
core.prototype = {
	
	/**
	 * A function to proxy the public methods of an object onto another
	 *
	 * @param {object} constructor The constructor to bridge
	 * @param {object} obj The object that will get new methods (an instance or the core)
	 * @param {string} pluginName A plugin name for the console log message
	 * @return {core}
	 * @private
	 */
	__bridge: function(constructor, obj, pluginName) {
		
		// if it's not already bridged
		if (!obj[pluginName]) {
			
			var fn = function() {};
			fn.prototype = constructor;
			
			var pluginInstance = new fn();
			
			// the _init method has to exist in instance constructors but might be missing
			// in core constructors
			if (pluginInstance.__init) {
				pluginInstance.__init(obj);
			}
			
			$.each(constructor, function(methodName, fn) {
				
				// don't proxy "private" methods, only "protected" and public ones
				if (methodName.indexOf('__') != 0) {
					
					// if the method does not exist yet
					if (!obj[methodName]) {
						
						obj[methodName] = function() {
							return pluginInstance[methodName].apply(pluginInstance, Array.prototype.slice.apply(arguments));
						};
						
						// remember to which plugin this method corresponds (several plugins may
						// have methods of the same name, we need to be sure)
						obj[methodName].bridged = pluginInstance;
					}
					else if (defaults.debug) {
						
						console.log('The '+ methodName +' method of the '+ pluginName
							+' plugin conflicts with another plugin or native methods');
					}
				}
			});
			
			obj[pluginName] = pluginInstance;
		}
		
		return this;
	},
	
	/**
	 * For mockup in Node env if need be, for testing purposes
	 *
	 * @return {core}
	 * @private
	 */
	__setWindow: function(window) {
		env.window = window;
		return this;
	},
	
	/**
	 * Returns a ruler, a tool to help measure the size of a tooltip under
	 * various settings. Meant for plugins
	 * 
	 * @see Ruler
	 * @return {object} A Ruler instance
	 * @protected
	 */
	_getRuler: function($tooltip) {
		return new Ruler($tooltip);
	},
	
	/**
	 * For internal use by plugins, if needed
	 *
	 * @return {core}
	 * @protected
	 */
	_off: function() {
		this.__$emitterPrivate.off.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * For internal use by plugins, if needed
	 *
	 * @return {core}
	 * @protected
	 */
	_on: function() {
		this.__$emitterPrivate.on.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * For internal use by plugins, if needed
	 *
	 * @return {core}
	 * @protected
	 */
	_one: function() {
		this.__$emitterPrivate.one.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * Returns (getter) or adds (setter) a plugin
	 *
	 * @param {string|object} plugin Provide a string (in the full form
	 * "namespace.name") to use as as getter, an object to use as a setter
	 * @return {object|core}
	 * @protected
	 */
	_plugin: function(plugin) {
		
		var self = this;
		
		// getter
		if (typeof plugin == 'string') {
			
			var pluginName = plugin,
				p = null;
			
			// if the namespace is provided, it's easy to search
			if (pluginName.indexOf('.') > 0) {
				p = self.__plugins[pluginName];
			}
			// otherwise, return the first name that matches
			else {
				$.each(self.__plugins, function(i, plugin) {
					
					if (plugin.name.substring(plugin.name.length - pluginName.length - 1) == '.'+ pluginName) {
						p = plugin;
						return false;
					}
				});
			}
			
			return p;
		}
		// setter
		else {
			
			// force namespaces
			if (plugin.name.indexOf('.') < 0) {
				throw new Error('Plugins must be namespaced');
			}
			
			self.__plugins[plugin.name] = plugin;
			
			// if the plugin has core features
			if (plugin.core) {
				
				// bridge non-private methods onto the core to allow new core methods
				self.__bridge(plugin.core, self, plugin.name);
			}
			
			return this;
		}
	},
	
	/**
	 * Trigger events on the core emitters
	 * 
	 * @returns {core}
	 * @protected
	 */
	_trigger: function() {
		
		var args = Array.prototype.slice.apply(arguments);
		
		if (typeof args[0] == 'string') {
			args[0] = { type: args[0] };
		}
		
		// note: the order of emitters matters
		this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate, args);
		this.__$emitterPublic.trigger.apply(this.__$emitterPublic, args);
		
		return this;
	},
	
	/**
	 * Returns instances of all tooltips in the page or an a given element
	 *
	 * @param {string|HTML object collection} selector optional Use this
	 * parameter to restrict the set of objects that will be inspected
	 * for the retrieval of instances. By default, all instances in the
	 * page are returned.
	 * @return {array} An array of instance objects
	 * @public
	 */
	instances: function(selector) {
		
		var instances = [],
			sel = selector || '.tooltipstered';
		
		$(sel).each(function() {
			
			var $this = $(this),
				ns = $this.data('tooltipster-ns');
			
			if (ns) {
				
				$.each(ns, function(i, namespace) {
					instances.push($this.data(namespace));
				});
			}
		});
		
		return instances;
	},
	
	/**
	 * Returns the Tooltipster objects generated by the last initializing call
	 *
	 * @return {array} An array of instance objects
	 * @public
	 */
	instancesLatest: function() {
		return this.__instancesLatestArr;
	},
	
	/**
	 * For public use only, not to be used by plugins (use ::_off() instead)
	 *
	 * @return {core}
	 * @public
	 */
	off: function() {
		this.__$emitterPublic.off.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * For public use only, not to be used by plugins (use ::_on() instead)
	 *
	 * @return {core}
	 * @public
	 */
	on: function() {
		this.__$emitterPublic.on.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * For public use only, not to be used by plugins (use ::_one() instead)
	 * 
	 * @return {core}
	 * @public
	 */
	one: function() {
		this.__$emitterPublic.one.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * Returns all HTML elements which have one or more tooltips
	 *
	 * @param {string} selector optional Use this to restrict the results
	 * to the descendants of an element
	 * @return {array} An array of HTML elements
	 * @public
	 */
	origins: function(selector) {
		
		var sel = selector ?
			selector +' ' :
			'';
		
		return $(sel +'.tooltipstered').toArray();
	},
	
	/**
	 * Change default options for all future instances
	 *
	 * @param {object} d The options that should be made defaults
	 * @return {core}
	 * @public
	 */
	setDefaults: function(d) {
		$.extend(defaults, d);
		return this;
	},
	
	/**
	 * For users to trigger their handlers on the public emitter
	 * 
	 * @returns {core}
	 * @public
	 */
	triggerHandler: function() {
		this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		return this;
	}
};

// $.tooltipster will be used to call core methods
$.tooltipster = new core();

// the Tooltipster instance class (mind the capital T)
$.Tooltipster = function(element, options) {
	
	// list of instance variables
	
	// stack of custom callbacks provided as parameters to API methods
	this.__callbacks = {
		close: [],
		open: []
	};
	// the schedule time of DOM removal
	this.__closingTime;
	// this will be the user content shown in the tooltip. A capital "C" is used
	// because there is also a method called content()
	this.__Content;
	// for the size tracker
	this.__contentBcr;
	// to disable the tooltip after destruction
	this.__destroyed = false;
	// we can't emit directly on the instance because if a method with the same
	// name as the event exists, it will be called by jQuery. Se we use a plain
	// object as emitter. This emitter is for internal use by plugins,
	// if needed.
	this.__$emitterPrivate = $({});
	// this emitter is for the user to listen to events without risking to mess
	// with our internal listeners
	this.__$emitterPublic = $({});
	this.__enabled = true;
	// the reference to the gc interval
	this.__garbageCollector;
	// various position and size data recomputed before each repositioning
	this.__Geometry;
	// the tooltip position, saved after each repositioning by a plugin
	this.__lastPosition;
	// a unique namespace per instance
	this.__namespace = 'tooltipster-'+ Math.round(Math.random()*1000000);
	this.__options;
	// will be used to support origins in scrollable areas
	this.__$originParents;
	this.__pointerIsOverOrigin = false;
	// to remove themes if needed
	this.__previousThemes = [];
	// the state can be either: appearing, stable, disappearing, closed
	this.__state = 'closed';
	// timeout references
	this.__timeouts = {
		close: [],
		open: null
	};
	// store touch events to be able to detect emulated mouse events
	this.__touchEvents = [];
	// the reference to the tracker interval
	this.__tracker = null;
	// the element to which this tooltip is associated
	this._$origin;
	// this will be the tooltip element (jQuery wrapped HTML element).
	// It's the job of a plugin to create it and append it to the DOM
	this._$tooltip;
	
	// launch
	this.__init(element, options);
};

$.Tooltipster.prototype = {
	
	/**
	 * @param origin
	 * @param options
	 * @private
	 */
	__init: function(origin, options) {
		
		var self = this;
		
		self._$origin = $(origin);
		self.__options = $.extend(true, {}, defaults, options);
		
		// some options may need to be reformatted
		self.__optionsFormat();
		
		// don't run on old IE if asked no to
		if (	!env.IE
			||	env.IE >= self.__options.IEmin
		) {
			
			// note: the content is null (empty) by default and can stay that
			// way if the plugin remains initialized but not fed any content. The
			// tooltip will just not appear.
			
			// let's save the initial value of the title attribute for later
			// restoration if need be.
			var initialTitle = null;
			
			// it will already have been saved in case of multiple tooltips
			if (self._$origin.data('tooltipster-initialTitle') === undefined) {
				
				initialTitle = self._$origin.attr('title');
				
				// we do not want initialTitle to be "undefined" because
				// of how jQuery's .data() method works
				if (initialTitle === undefined) initialTitle = null;
				
				self._$origin.data('tooltipster-initialTitle', initialTitle);
			}
			
			// If content is provided in the options, it has precedence over the
			// title attribute.
			// Note: an empty string is considered content, only 'null' represents
			// the absence of content.
			// Also, an existing title="" attribute will result in an empty string
			// content
			if (self.__options.content !== null) {
				self.__contentSet(self.__options.content);
			}
			else {
				
				var selector = self._$origin.attr('data-tooltip-content'),
					$el;
				
				if (selector){
					$el = $(selector);
				}
				
				if ($el && $el[0]) {
					self.__contentSet($el.first());
				}
				else {
					self.__contentSet(initialTitle);
				}
			}
			
			self._$origin
				// strip the title off of the element to prevent the default tooltips
				// from popping up
				.removeAttr('title')
				// to be able to find all instances on the page later (upon window
				// events in particular)
				.addClass('tooltipstered');
			
			// set listeners on the origin
			self.__prepareOrigin();
			
			// set the garbage collector
			self.__prepareGC();
			
			// init plugins
			$.each(self.__options.plugins, function(i, pluginName) {
				self._plug(pluginName);
			});
			
			// to detect swiping
			if (env.hasTouchCapability) {
				$(env.window.document.body).on('touchmove.'+ self.__namespace +'-triggerOpen', function(event) {
					self._touchRecordEvent(event);
				});
			}
			
			self
				// prepare the tooltip when it gets created. This event must
				// be fired by a plugin
				._on('created', function() {
					self.__prepareTooltip();
				})
				// save position information when it's sent by a plugin
				._on('repositioned', function(e) {
					self.__lastPosition = e.position;
				});
		}
		else {
			self.__options.disabled = true;
		}
	},
	
	/**
	 * Insert the content into the appropriate HTML element of the tooltip
	 * 
	 * @returns {self}
	 * @private
	 */
	__contentInsert: function() {
		
		var self = this,
			$el = self._$tooltip.find('.tooltipster-content'),
			formattedContent = self.__Content,
			format = function(content) {
				formattedContent = content;
			};
		
		self._trigger({
			type: 'format',
			content: self.__Content,
			format: format
		});
		
		if (self.__options.functionFormat) {
			
			formattedContent = self.__options.functionFormat.call(
				self,
				self,
				{ origin: self._$origin[0] },
				self.__Content
			);
		}
		
		if (typeof formattedContent === 'string' && !self.__options.contentAsHTML) {
			$el.text(formattedContent);
		}
		else {
			$el
				.empty()
				.append(formattedContent);
		}
		
		return self;
	},
	
	/**
	 * Save the content, cloning it beforehand if need be
	 * 
	 * @param content
	 * @returns {self}
	 * @private
	 */
	__contentSet: function(content) {
		
		// clone if asked. Cloning the object makes sure that each instance has its
		// own version of the content (in case a same object were provided for several
		// instances)
		// reminder: typeof null === object
		if (content instanceof $ && this.__options.contentCloning) {
			content = content.clone(true);
		}
		
		this.__Content = content;
		
		this._trigger({
			type: 'updated',
			content: content
		});
		
		return this;
	},
	
	/**
	 * Error message about a method call made after destruction
	 * 
	 * @private
	 */
	__destroyError: function() {
		throw new Error('This tooltip has been destroyed and cannot execute your method call.');
	},
	
	/**
	 * Gather all information about dimensions and available space,
	 * called before every repositioning
	 * 
	 * @private
	 * @returns {object}
	 */
	__geometry: function() {
		
		var	self = this,
			$target = self._$origin,
			originIsArea = self._$origin.is('area');
		
		// if this._$origin is a map area, the target we'll need
		// the dimensions of is actually the image using the map,
		// not the area itself
		if (originIsArea) {
			
			var mapName = self._$origin.parent().attr('name');
			
			$target = $('img[usemap="#'+ mapName +'"]');
		}
		
		var bcr = $target[0].getBoundingClientRect(),
			$document = $(env.window.document),
			$window = $(env.window),
			$parent = $target,
			// some useful properties of important elements
			geo = {
				// available space for the tooltip, see down below
				available: {
					document: null,
					window: null
				},
				document: {
					size: {
						height: $document.height(),
						width: $document.width()
					}
				},
				window: {
					scroll: {
						// the second ones are for IE compatibility
						left: env.window.scrollX || env.window.document.documentElement.scrollLeft,
						top: env.window.scrollY || env.window.document.documentElement.scrollTop
					},
					size: {
						height: $window.height(),
						width: $window.width()
					}
				},
				origin: {
					// the origin has a fixed lineage if itself or one of its
					// ancestors has a fixed position
					fixedLineage: false,
					// relative to the document
					offset: {},
					size: {
						height: bcr.bottom - bcr.top,
						width: bcr.right - bcr.left
					},
					usemapImage: originIsArea ? $target[0] : null,
					// relative to the window
					windowOffset: {
						bottom: bcr.bottom,
						left: bcr.left,
						right: bcr.right,
						top: bcr.top
					}
				}
			},
			geoFixed = false;
		
		// if the element is a map area, some properties may need
		// to be recalculated
		if (originIsArea) {
			
			var shape = self._$origin.attr('shape'),
				coords = self._$origin.attr('coords');
			
			if (coords) {
				
				coords = coords.split(',');
				
				$.map(coords, function(val, i) {
					coords[i] = parseInt(val);
				});
			}
			
			// if the image itself is the area, nothing more to do
			if (shape != 'default') {
				
				switch(shape) {
					
					case 'circle':
						
						var circleCenterLeft = coords[0],
							circleCenterTop = coords[1],
							circleRadius = coords[2],
							areaTopOffset = circleCenterTop - circleRadius,
							areaLeftOffset = circleCenterLeft - circleRadius;
						
						geo.origin.size.height = circleRadius * 2;
						geo.origin.size.width = geo.origin.size.height;
						
						geo.origin.windowOffset.left += areaLeftOffset;
						geo.origin.windowOffset.top += areaTopOffset;
						
						break;
					
					case 'rect':
						
						var areaLeft = coords[0],
							areaTop = coords[1],
							areaRight = coords[2],
							areaBottom = coords[3];
						
						geo.origin.size.height = areaBottom - areaTop;
						geo.origin.size.width = areaRight - areaLeft;
						
						geo.origin.windowOffset.left += areaLeft;
						geo.origin.windowOffset.top += areaTop;
						
						break;
					
					case 'poly':
						
						var areaSmallestX = 0,
							areaSmallestY = 0,
							areaGreatestX = 0,
							areaGreatestY = 0,
							arrayAlternate = 'even';
						
						for (var i = 0; i < coords.length; i++) {
							
							var areaNumber = coords[i];
							
							if (arrayAlternate == 'even') {
								
								if (areaNumber > areaGreatestX) {
									
									areaGreatestX = areaNumber;
									
									if (i === 0) {
										areaSmallestX = areaGreatestX;
									}
								}
								
								if (areaNumber < areaSmallestX) {
									areaSmallestX = areaNumber;
								}
								
								arrayAlternate = 'odd';
							}
							else {
								if (areaNumber > areaGreatestY) {
									
									areaGreatestY = areaNumber;
									
									if (i == 1) {
										areaSmallestY = areaGreatestY;
									}
								}
								
								if (areaNumber < areaSmallestY) {
									areaSmallestY = areaNumber;
								}
								
								arrayAlternate = 'even';
							}
						}
						
						geo.origin.size.height = areaGreatestY - areaSmallestY;
						geo.origin.size.width = areaGreatestX - areaSmallestX;
						
						geo.origin.windowOffset.left += areaSmallestX;
						geo.origin.windowOffset.top += areaSmallestY;
						
						break;
				}
			}
		}
		
		// user callback through an event
		var edit = function(r) {
			geo.origin.size.height = r.height,
				geo.origin.windowOffset.left = r.left,
				geo.origin.windowOffset.top = r.top,
				geo.origin.size.width = r.width
		};
		
		self._trigger({
			type: 'geometry',
			edit: edit,
			geometry: {
				height: geo.origin.size.height,
				left: geo.origin.windowOffset.left,
				top: geo.origin.windowOffset.top,
				width: geo.origin.size.width
			}
		});
		
		// calculate the remaining properties with what we got
		
		geo.origin.windowOffset.right = geo.origin.windowOffset.left + geo.origin.size.width;
		geo.origin.windowOffset.bottom = geo.origin.windowOffset.top + geo.origin.size.height;
		
		geo.origin.offset.left = geo.origin.windowOffset.left + geo.window.scroll.left;
		geo.origin.offset.top = geo.origin.windowOffset.top + geo.window.scroll.top;
		geo.origin.offset.bottom = geo.origin.offset.top + geo.origin.size.height;
		geo.origin.offset.right = geo.origin.offset.left + geo.origin.size.width;
		
		// the space that is available to display the tooltip relatively to the document
		geo.available.document = {
			bottom: {
				height: geo.document.size.height - geo.origin.offset.bottom,
				width: geo.document.size.width
			},
			left: {
				height: geo.document.size.height,
				width: geo.origin.offset.left
			},
			right: {
				height: geo.document.size.height,
				width: geo.document.size.width - geo.origin.offset.right
			},
			top: {
				height: geo.origin.offset.top,
				width: geo.document.size.width
			}
		};
		
		// the space that is available to display the tooltip relatively to the viewport
		// (the resulting values may be negative if the origin overflows the viewport)
		geo.available.window = {
			bottom: {
				// the inner max is here to make sure the available height is no bigger
				// than the viewport height (when the origin is off screen at the top).
				// The outer max just makes sure that the height is not negative (when
				// the origin overflows at the bottom).
				height: Math.max(geo.window.size.height - Math.max(geo.origin.windowOffset.bottom, 0), 0),
				width: geo.window.size.width
			},
			left: {
				height: geo.window.size.height,
				width: Math.max(geo.origin.windowOffset.left, 0)
			},
			right: {
				height: geo.window.size.height,
				width: Math.max(geo.window.size.width - Math.max(geo.origin.windowOffset.right, 0), 0)
			},
			top: {
				height: Math.max(geo.origin.windowOffset.top, 0),
				width: geo.window.size.width
			}
		};
		
		while ($parent[0].tagName.toLowerCase() != 'html') {
			
			if ($parent.css('position') == 'fixed') {
				geo.origin.fixedLineage = true;
				break;
			}
			
			$parent = $parent.parent();
		}
		
		return geo;
	},
	
	/**
	 * Some options may need to be formated before being used
	 * 
	 * @returns {self}
	 * @private
	 */
	__optionsFormat: function() {
		
		if (typeof this.__options.animationDuration == 'number') {
			this.__options.animationDuration = [this.__options.animationDuration, this.__options.animationDuration];
		}
		
		if (typeof this.__options.delay == 'number') {
			this.__options.delay = [this.__options.delay, this.__options.delay];
		}
		
		if (typeof this.__options.delayTouch == 'number') {
			this.__options.delayTouch = [this.__options.delayTouch, this.__options.delayTouch];
		}
		
		if (typeof this.__options.theme == 'string') {
			this.__options.theme = [this.__options.theme];
		}
		
		// determine the future parent
		if (this.__options.parent === null) {
			this.__options.parent = $(env.window.document.body);
		}
		else if (typeof this.__options.parent == 'string') {
			this.__options.parent = $(this.__options.parent);
		}
		
		if (this.__options.trigger == 'hover') {
			
			this.__options.triggerOpen = {
				mouseenter: true,
				touchstart: true
			};
			
			this.__options.triggerClose = {
				mouseleave: true,
				originClick: true,
				touchleave: true
			};
		}
		else if (this.__options.trigger == 'click') {
			
			this.__options.triggerOpen = {
				click: true,
				tap: true
			};
			
			this.__options.triggerClose = {
				click: true,
				tap: true
			};
		}
		
		// for the plugins
		this._trigger('options');
		
		return this;
	},
	
	/**
	 * Schedules or cancels the garbage collector task
	 *
	 * @returns {self}
	 * @private
	 */
	__prepareGC: function() {
		
		var self = this;
		
		// in case the selfDestruction option has been changed by a method call
		if (self.__options.selfDestruction) {
			
			// the GC task
			self.__garbageCollector = setInterval(function() {
				
				var now = new Date().getTime();
				
				// forget the old events
				self.__touchEvents = $.grep(self.__touchEvents, function(event, i) {
					// 1 minute
					return now - event.time > 60000;
				});
				
				// auto-destruct if the origin is gone
				if (!bodyContains(self._$origin)) {
					
					self.close(function(){
						self.destroy();
					});
				}
			}, 20000);
		}
		else {
			clearInterval(self.__garbageCollector);
		}
		
		return self;
	},
	
	/**
	 * Sets listeners on the origin if the open triggers require them.
	 * Unlike the listeners set at opening time, these ones
	 * remain even when the tooltip is closed. It has been made a
	 * separate method so it can be called when the triggers are
	 * changed in the options. Closing is handled in _open()
	 * because of the bindings that may be needed on the tooltip
	 * itself
	 *
	 * @returns {self}
	 * @private
	 */
	__prepareOrigin: function() {
		
		var self = this;
		
		// in case we're resetting the triggers
		self._$origin.off('.'+ self.__namespace +'-triggerOpen');
		
		// if the device is touch capable, even if only mouse triggers
		// are asked, we need to listen to touch events to know if the mouse
		// events are actually emulated (so we can ignore them)
		if (env.hasTouchCapability) {
			
			self._$origin.on(
				'touchstart.'+ self.__namespace +'-triggerOpen ' +
				'touchend.'+ self.__namespace +'-triggerOpen ' +
				'touchcancel.'+ self.__namespace +'-triggerOpen',
				function(event){
					self._touchRecordEvent(event);
				}
			);
		}
		
		// mouse click and touch tap work the same way
		if (	self.__options.triggerOpen.click
			||	(self.__options.triggerOpen.tap && env.hasTouchCapability)
		) {
			
			var eventNames = '';
			if (self.__options.triggerOpen.click) {
				eventNames += 'click.'+ self.__namespace +'-triggerOpen ';
			}
			if (self.__options.triggerOpen.tap && env.hasTouchCapability) {
				eventNames += 'touchend.'+ self.__namespace +'-triggerOpen';
			}
			
			self._$origin.on(eventNames, function(event) {
				if (self._touchIsMeaningfulEvent(event)) {
					self._open(event);
				}
			});
		}
		
		// mouseenter and touch start work the same way
		if (	self.__options.triggerOpen.mouseenter
			||	(self.__options.triggerOpen.touchstart && env.hasTouchCapability)
		) {
			
			var eventNames = '';
			if (self.__options.triggerOpen.mouseenter) {
				eventNames += 'mouseenter.'+ self.__namespace +'-triggerOpen ';
			}
			if (self.__options.triggerOpen.touchstart && env.hasTouchCapability) {
				eventNames += 'touchstart.'+ self.__namespace +'-triggerOpen';
			}
			
			self._$origin.on(eventNames, function(event) {
				if (	self._touchIsTouchEvent(event)
					||	!self._touchIsEmulatedEvent(event)
				) {
					self.__pointerIsOverOrigin = true;
					self._openShortly(event);
				}
			});
		}
		
		// info for the mouseleave/touchleave close triggers when they use a delay
		if (	self.__options.triggerClose.mouseleave
			||	(self.__options.triggerClose.touchleave && env.hasTouchCapability)
		) {
			
			var eventNames = '';
			if (self.__options.triggerClose.mouseleave) {
				eventNames += 'mouseleave.'+ self.__namespace +'-triggerOpen ';
			}
			if (self.__options.triggerClose.touchleave && env.hasTouchCapability) {
				eventNames += 'touchend.'+ self.__namespace +'-triggerOpen touchcancel.'+ self.__namespace +'-triggerOpen';
			}
			
			self._$origin.on(eventNames, function(event) {
				
				if (self._touchIsMeaningfulEvent(event)) {
					self.__pointerIsOverOrigin = false;
				}
			});
		}
		
		return self;
	},
	
	/**
	 * Do the things that need to be done only once after the tooltip
	 * HTML element it has been created. It has been made a separate
	 * method so it can be called when options are changed. Remember
	 * that the tooltip may actually exist in the DOM before it is
	 * opened, and present after it has been closed: it's the display
	 * plugin that takes care of handling it.
	 * 
	 * @returns {self}
	 * @private
	 */
	__prepareTooltip: function() {
		
		var self = this,
			p = self.__options.interactive ? 'auto' : '';
		
		// this will be useful to know quickly if the tooltip is in
		// the DOM or not 
		self._$tooltip
			.attr('id', self.__namespace)
			.css({
				// pointer events
				'pointer-events': p,
				zIndex: self.__options.zIndex
			});
		
		// themes
		// remove the old ones and add the new ones
		$.each(self.__previousThemes, function(i, theme) {
			self._$tooltip.removeClass(theme);
		});
		$.each(self.__options.theme, function(i, theme) {
			self._$tooltip.addClass(theme);
		});
		
		self.__previousThemes = $.merge([], self.__options.theme);
		
		return self;
	},
	
	/**
	 * Handles the scroll on any of the parents of the origin (when the
	 * tooltip is open)
	 *
	 * @param {object} event
	 * @returns {self}
	 * @private
	 */
	__scrollHandler: function(event) {
		
		var self = this;
		
		if (self.__options.triggerClose.scroll) {
			self._close(event);
		}
		else {
			
			// if the origin or tooltip have been removed: do nothing, the tracker will
			// take care of it later
			if (bodyContains(self._$origin) && bodyContains(self._$tooltip)) {
				
				var geo = null;
				
				// if the scroll happened on the window
				if (event.target === env.window.document) {
					
					// if the origin has a fixed lineage, window scroll will have no
					// effect on its position nor on the position of the tooltip
					if (!self.__Geometry.origin.fixedLineage) {
						
						// we don't need to do anything unless repositionOnScroll is true
						// because the tooltip will already have moved with the window
						// (and of course with the origin)
						if (self.__options.repositionOnScroll) {
							self.reposition(event);
						}
					}
				}
				// if the scroll happened on another parent of the tooltip, it means
				// that it's in a scrollable area and now needs to have its position
				// adjusted or recomputed, depending ont the repositionOnScroll
				// option. Also, if the origin is partly hidden due to a parent that
				// hides its overflow, we'll just hide (not close) the tooltip.
				else {
					
					geo = self.__geometry();
					
					var overflows = false;
					
					// a fixed position origin is not affected by the overflow hiding
					// of a parent
					if (self._$origin.css('position') != 'fixed') {
						
						self.__$originParents.each(function(i, el) {
							
							var $el = $(el),
								overflowX = $el.css('overflow-x'),
								overflowY = $el.css('overflow-y');
							
							if (overflowX != 'visible' || overflowY != 'visible') {
								
								var bcr = el.getBoundingClientRect();
								
								if (overflowX != 'visible') {
									
									if (	geo.origin.windowOffset.left < bcr.left
										||	geo.origin.windowOffset.right > bcr.right
									) {
										overflows = true;
										return false;
									}
								}
								
								if (overflowY != 'visible') {
									
									if (	geo.origin.windowOffset.top < bcr.top
										||	geo.origin.windowOffset.bottom > bcr.bottom
									) {
										overflows = true;
										return false;
									}
								}
							}
							
							// no need to go further if fixed, for the same reason as above
							if ($el.css('position') == 'fixed') {
								return false;
							}
						});
					}
					
					if (overflows) {
						self._$tooltip.css('visibility', 'hidden');
					}
					else {
						
						self._$tooltip.css('visibility', 'visible');
						
						// reposition
						if (self.__options.repositionOnScroll) {
							self.reposition(event);
						}
						// or just adjust offset
						else {
							
							// we have to use offset and not windowOffset because this way,
							// only the scroll distance of the scrollable areas are taken into
							// account (the scrolltop value of the main window must be
							// ignored since the tooltip already moves with it)
							var offsetLeft = geo.origin.offset.left - self.__Geometry.origin.offset.left,
								offsetTop = geo.origin.offset.top - self.__Geometry.origin.offset.top;
							
							// add the offset to the position initially computed by the display plugin
							self._$tooltip.css({
								left: self.__lastPosition.coord.left + offsetLeft,
								top: self.__lastPosition.coord.top + offsetTop
							});
						}
					}
				}
				
				self._trigger({
					type: 'scroll',
					event: event,
					geo: geo
				});
			}
		}
		
		return self;
	},
	
	/**
	 * Changes the state of the tooltip
	 *
	 * @param {string} state
	 * @returns {self}
	 * @private
	 */
	__stateSet: function(state) {
		
		this.__state = state;
		
		this._trigger({
			type: 'state',
			state: state
		});
		
		return this;
	},
	
	/**
	 * Clear appearance timeouts
	 *
	 * @returns {self}
	 * @private
	 */
	__timeoutsClear: function() {
		
		// there is only one possible open timeout: the delayed opening
		// when the mouseenter/touchstart open triggers are used
		clearTimeout(this.__timeouts.open);
		this.__timeouts.open = null;
		
		// ... but several close timeouts: the delayed closing when the
		// mouseleave close trigger is used and the timer option
		$.each(this.__timeouts.close, function(i, timeout) {
			clearTimeout(timeout);
		});
		this.__timeouts.close = [];
		
		return this;
	},
	
	/**
	 * Start the tracker that will make checks at regular intervals
	 * 
	 * @returns {self}
	 * @private
	 */
	__trackerStart: function() {
		
		var self = this,
			$content = self._$tooltip.find('.tooltipster-content');
		
		// get the initial content size
		if (self.__options.trackTooltip) {
			self.__contentBcr = $content[0].getBoundingClientRect();
		}
		
		self.__tracker = setInterval(function() {
			
			// if the origin or tooltip elements have been removed.
			// Note: we could destroy the instance now if the origin has
			// been removed but we'll leave that task to our garbage collector
			if (!bodyContains(self._$origin) || !bodyContains(self._$tooltip)) {
				self._close();
			}
			// if everything is alright
			else {
				
				// compare the former and current positions of the origin to reposition
				// the tooltip if need be
				if (self.__options.trackOrigin) {
					
					var g = self.__geometry(),
						identical = false;
					
					// compare size first (a change requires repositioning too)
					if (areEqual(g.origin.size, self.__Geometry.origin.size)) {
						
						// for elements that have a fixed lineage (see __geometry()), we track the
						// top and left properties (relative to window)
						if (self.__Geometry.origin.fixedLineage) {
							if (areEqual(g.origin.windowOffset, self.__Geometry.origin.windowOffset)) {
								identical = true;
							}
						}
						// otherwise, track total offset (relative to document)
						else {
							if (areEqual(g.origin.offset, self.__Geometry.origin.offset)) {
								identical = true;
							}
						}
					}
					
					if (!identical) {
						
						// close the tooltip when using the mouseleave close trigger
						// (see https://github.com/iamceege/tooltipster/pull/253)
						if (self.__options.triggerClose.mouseleave) {
							self._close();
						}
						else {
							self.reposition();
						}
					}
				}
				
				if (self.__options.trackTooltip) {
					
					var currentBcr = $content[0].getBoundingClientRect();
					
					if (	currentBcr.height !== self.__contentBcr.height
						||	currentBcr.width !== self.__contentBcr.width
					) {
						self.reposition();
						self.__contentBcr = currentBcr;
					}
				}
			}
		}, self.__options.trackerInterval);
		
		return self;
	},
	
	/**
	 * Closes the tooltip (after the closing delay)
	 * 
	 * @param event
	 * @param callback
	 * @param force Set to true to override a potential refusal of the user's function
	 * @returns {self}
	 * @protected
	 */
	_close: function(event, callback, force) {
		
		var self = this,
			ok = true;
		
		self._trigger({
			type: 'close',
			event: event,
			stop: function() {
				ok = false;
			}
		});
		
		// a destroying tooltip (force == true) may not refuse to close
		if (ok || force) {
			
			// save the method custom callback and cancel any open method custom callbacks
			if (callback) self.__callbacks.close.push(callback);
			self.__callbacks.open = [];
			
			// clear open/close timeouts
			self.__timeoutsClear();
			
			var finishCallbacks = function() {
				
				// trigger any close method custom callbacks and reset them
				$.each(self.__callbacks.close, function(i,c) {
					c.call(self, self, {
						event: event,
						origin: self._$origin[0]
					});
				});
				
				self.__callbacks.close = [];
			};
			
			if (self.__state != 'closed') {
				
				var necessary = true,
					d = new Date(),
					now = d.getTime(),
					newClosingTime = now + self.__options.animationDuration[1];
				
				// the tooltip may already already be disappearing, but if a new
				// call to close() is made after the animationDuration was changed
				// to 0 (for example), we ought to actually close it sooner than
				// previously scheduled. In that case it should be noted that the
				// browser will not adapt the animation duration to the new
				// animationDuration that was set after the start of the closing
				// animation.
				// Note: the same thing could be considered at opening, but is not
				// really useful since the tooltip is actually opened immediately
				// upon a call to _open(). Since it would not make the opening
				// animation finish sooner, its sole impact would be to trigger the
				// state event and the open callbacks sooner than the actual end of
				// the opening animation, which is not great.
				if (self.__state == 'disappearing') {
					
					if (	newClosingTime > self.__closingTime
						// in case closing is actually overdue because the script
						// execution was suspended. See #679
						&&	self.__options.animationDuration[1] > 0
					) {
						necessary = false;
					}
				}
				
				if (necessary) {
					
					self.__closingTime = newClosingTime;
					
					if (self.__state != 'disappearing') {
						self.__stateSet('disappearing');
					}
					
					var finish = function() {
						
						// stop the tracker
						clearInterval(self.__tracker);
						
						// a "beforeClose" option has been asked several times but would
						// probably useless since the content element is still accessible
						// via ::content(), and because people can always use listeners
						// inside their content to track what's going on. For the sake of
						// simplicity, this has been denied. Bur for the rare people who
						// really need the option (for old browsers or for the case where
						// detaching the content is actually destructive, for file or
						// password inputs for example), this event will do the work.
						self._trigger({
							type: 'closing',
							event: event
						});
						
						// unbind listeners which are no longer needed
						
						self._$tooltip
							.off('.'+ self.__namespace +'-triggerClose')
							.removeClass('tooltipster-dying');
						
						// orientationchange, scroll and resize listeners
						$(env.window).off('.'+ self.__namespace +'-triggerClose');
						
						// scroll listeners
						self.__$originParents.each(function(i, el) {
							$(el).off('scroll.'+ self.__namespace +'-triggerClose');
						});
						// clear the array to prevent memory leaks
						self.__$originParents = null;
						
						$(env.window.document.body).off('.'+ self.__namespace +'-triggerClose');
						
						self._$origin.off('.'+ self.__namespace +'-triggerClose');
						
						self._off('dismissable');
						
						// a plugin that would like to remove the tooltip from the
						// DOM when closed should bind on this
						self.__stateSet('closed');
						
						// trigger event
						self._trigger({
							type: 'after',
							event: event
						});
						
						// call our constructor custom callback function
						if (self.__options.functionAfter) {
							self.__options.functionAfter.call(self, self, {
								event: event,
								origin: self._$origin[0]
							});
						}
						
						// call our method custom callbacks functions
						finishCallbacks();
					};
					
					if (env.hasTransitions) {
						
						self._$tooltip.css({
							'-moz-animation-duration': self.__options.animationDuration[1] + 'ms',
							'-ms-animation-duration': self.__options.animationDuration[1] + 'ms',
							'-o-animation-duration': self.__options.animationDuration[1] + 'ms',
							'-webkit-animation-duration': self.__options.animationDuration[1] + 'ms',
							'animation-duration': self.__options.animationDuration[1] + 'ms',
							'transition-duration': self.__options.animationDuration[1] + 'ms'
						});
						
						self._$tooltip
							// clear both potential open and close tasks
							.clearQueue()
							.removeClass('tooltipster-show')
							// for transitions only
							.addClass('tooltipster-dying');
						
						if (self.__options.animationDuration[1] > 0) {
							self._$tooltip.delay(self.__options.animationDuration[1]);
						}
						
						self._$tooltip.queue(finish);
					}
					else {
						
						self._$tooltip
							.stop()
							.fadeOut(self.__options.animationDuration[1], finish);
					}
				}
			}
			// if the tooltip is already closed, we still need to trigger
			// the method custom callbacks
			else {
				finishCallbacks();
			}
		}
		
		return self;
	},
	
	/**
	 * For internal use by plugins, if needed
	 * 
	 * @returns {self}
	 * @protected
	 */
	_off: function() {
		this.__$emitterPrivate.off.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * For internal use by plugins, if needed
	 *
	 * @returns {self}
	 * @protected
	 */
	_on: function() {
		this.__$emitterPrivate.on.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * For internal use by plugins, if needed
	 *
	 * @returns {self}
	 * @protected
	 */
	_one: function() {
		this.__$emitterPrivate.one.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
		return this;
	},
	
	/**
	 * Opens the tooltip right away.
	 *
	 * @param event
	 * @param callback Will be called when the opening animation is over
	 * @returns {self}
	 * @protected
	 */
	_open: function(event, callback) {
		
		var self = this;
		
		// if the destruction process has not begun and if this was not
		// triggered by an unwanted emulated click event
		if (!self.__destroying) {
			
			// check that the origin is still in the DOM
			if (	bodyContains(self._$origin)
				// if the tooltip is enabled
				&&	self.__enabled
			) {
				
				var ok = true;
				
				// if the tooltip is not open yet, we need to call functionBefore.
				// otherwise we can jst go on
				if (self.__state == 'closed') {
					
					// trigger an event. The event.stop function allows the callback
					// to prevent the opening of the tooltip
					self._trigger({
						type: 'before',
						event: event,
						stop: function() {
							ok = false;
						}
					});
					
					if (ok && self.__options.functionBefore) {
						
						// call our custom function before continuing
						ok = self.__options.functionBefore.call(self, self, {
							event: event,
							origin: self._$origin[0]
						});
					}
				}
				
				if (ok !== false) {
					
					// if there is some content
					if (self.__Content !== null) {
						
						// save the method callback and cancel close method callbacks
						if (callback) {
							self.__callbacks.open.push(callback);
						}
						self.__callbacks.close = [];
						
						// get rid of any appearance timeouts
						self.__timeoutsClear();
						
						var extraTime,
							finish = function() {
								
								if (self.__state != 'stable') {
									self.__stateSet('stable');
								}
								
								// trigger any open method custom callbacks and reset them
								$.each(self.__callbacks.open, function(i,c) {
									c.call(self, self, {
										origin: self._$origin[0],
										tooltip: self._$tooltip[0]
									});
								});
								
								self.__callbacks.open = [];
							};
						
						// if the tooltip is already open
						if (self.__state !== 'closed') {
							
							// the timer (if any) will start (or restart) right now
							extraTime = 0;
							
							// if it was disappearing, cancel that
							if (self.__state === 'disappearing') {
								
								self.__stateSet('appearing');
								
								if (env.hasTransitions) {
									
									self._$tooltip
										.clearQueue()
										.removeClass('tooltipster-dying')
										.addClass('tooltipster-show');
									
									if (self.__options.animationDuration[0] > 0) {
										self._$tooltip.delay(self.__options.animationDuration[0]);
									}
									
									self._$tooltip.queue(finish);
								}
								else {
									// in case the tooltip was currently fading out, bring it back
									// to life
									self._$tooltip
										.stop()
										.fadeIn(finish);
								}
							}
							// if the tooltip is already open, we still need to trigger the method
							// custom callback
							else if (self.__state == 'stable') {
								finish();
							}
						}
						// if the tooltip isn't already open, open it
						else {
							
							// a plugin must bind on this and store the tooltip in this._$tooltip
							self.__stateSet('appearing');
							
							// the timer (if any) will start when the tooltip has fully appeared
							// after its transition
							extraTime = self.__options.animationDuration[0];
							
							// insert the content inside the tooltip
							self.__contentInsert();
							
							// reposition the tooltip and attach to the DOM
							self.reposition(event, true);
							
							// animate in the tooltip. If the display plugin wants no css
							// animations, it may override the animation option with a
							// dummy value that will produce no effect
							if (env.hasTransitions) {
								
								// note: there seems to be an issue with start animations which
								// are randomly not played on fast devices in both Chrome and FF,
								// couldn't find a way to solve it yet. It seems that applying
								// the classes before appending to the DOM helps a little, but
								// it messes up some CSS transitions. The issue almost never
								// happens when delay[0]==0 though
								self._$tooltip
									.addClass('tooltipster-'+ self.__options.animation)
									.addClass('tooltipster-initial')
									.css({
										'-moz-animation-duration': self.__options.animationDuration[0] + 'ms',
										'-ms-animation-duration': self.__options.animationDuration[0] + 'ms',
										'-o-animation-duration': self.__options.animationDuration[0] + 'ms',
										'-webkit-animation-duration': self.__options.animationDuration[0] + 'ms',
										'animation-duration': self.__options.animationDuration[0] + 'ms',
										'transition-duration': self.__options.animationDuration[0] + 'ms'
									});
								
								setTimeout(
									function() {
										
										// a quick hover may have already triggered a mouseleave
										if (self.__state != 'closed') {
											
											self._$tooltip
												.addClass('tooltipster-show')
												.removeClass('tooltipster-initial');
											
											if (self.__options.animationDuration[0] > 0) {
												self._$tooltip.delay(self.__options.animationDuration[0]);
											}
											
											self._$tooltip.queue(finish);
										}
									},
									0
								);
							}
							else {
								
								// old browsers will have to live with this
								self._$tooltip
									.css('display', 'none')
									.fadeIn(self.__options.animationDuration[0], finish);
							}
							
							// checks if the origin is removed while the tooltip is open
							self.__trackerStart();
							
							// NOTE: the listeners below have a '-triggerClose' namespace
							// because we'll remove them when the tooltip closes (unlike
							// the '-triggerOpen' listeners). So some of them are actually
							// not about close triggers, rather about positioning.
							
							$(env.window)
								// reposition on resize
								.on('resize.'+ self.__namespace +'-triggerClose', function(e) {
									
									var $ae = $(document.activeElement);
									
									// reposition only if the resize event was not triggered upon the opening
									// of a virtual keyboard due to an input field being focused within the tooltip
									// (otherwise the repositioning would lose the focus)
									if (	(!$ae.is('input') && !$ae.is('textarea'))
										||	!$.contains(self._$tooltip[0], $ae[0])
									) {
										self.reposition(e);
									}
								})
								// same as below for parents
								.on('scroll.'+ self.__namespace +'-triggerClose', function(e) {
									self.__scrollHandler(e);
								});
							
							self.__$originParents = self._$origin.parents();
							
							// scrolling may require the tooltip to be moved or even
							// repositioned in some cases
							self.__$originParents.each(function(i, parent) {
								
								$(parent).on('scroll.'+ self.__namespace +'-triggerClose', function(e) {
									self.__scrollHandler(e);
								});
							});
							
							if (	self.__options.triggerClose.mouseleave
								||	(self.__options.triggerClose.touchleave && env.hasTouchCapability)
							) {
								
								// we use an event to allow users/plugins to control when the mouseleave/touchleave
								// close triggers will come to action. It allows to have more triggering elements
								// than just the origin and the tooltip for example, or to cancel/delay the closing,
								// or to make the tooltip interactive even if it wasn't when it was open, etc.
								self._on('dismissable', function(event) {
									
									if (event.dismissable) {
										
										if (event.delay) {
											
											timeout = setTimeout(function() {
												// event.event may be undefined
												self._close(event.event);
											}, event.delay);
											
											self.__timeouts.close.push(timeout);
										}
										else {
											self._close(event);
										}
									}
									else {
										clearTimeout(timeout);
									}
								});
								
								// now set the listeners that will trigger 'dismissable' events
								var $elements = self._$origin,
									eventNamesIn = '',
									eventNamesOut = '',
									timeout = null;
								
								// if we have to allow interaction, bind on the tooltip too
								if (self.__options.interactive) {
									$elements = $elements.add(self._$tooltip);
								}
								
								if (self.__options.triggerClose.mouseleave) {
									eventNamesIn += 'mouseenter.'+ self.__namespace +'-triggerClose ';
									eventNamesOut += 'mouseleave.'+ self.__namespace +'-triggerClose ';
								}
								if (self.__options.triggerClose.touchleave && env.hasTouchCapability) {
									eventNamesIn += 'touchstart.'+ self.__namespace +'-triggerClose';
									eventNamesOut += 'touchend.'+ self.__namespace +'-triggerClose touchcancel.'+ self.__namespace +'-triggerClose';
								}
								
								$elements
									// close after some time spent outside of the elements
									.on(eventNamesOut, function(event) {
										
										// it's ok if the touch gesture ended up to be a swipe,
										// it's still a "touch leave" situation
										if (	self._touchIsTouchEvent(event)
											||	!self._touchIsEmulatedEvent(event)
										) {
											
											var delay = (event.type == 'mouseleave') ?
												self.__options.delay :
												self.__options.delayTouch;
											
											self._trigger({
												delay: delay[1],
												dismissable: true,
												event: event,
												type: 'dismissable'
											});
										}
									})
									// suspend the mouseleave timeout when the pointer comes back
									// over the elements
									.on(eventNamesIn, function(event) {
										
										// it's also ok if the touch event is a swipe gesture
										if (	self._touchIsTouchEvent(event)
											||	!self._touchIsEmulatedEvent(event)
										) {
											self._trigger({
												dismissable: false,
												event: event,
												type: 'dismissable'
											});
										}
									});
							}
							
							// close the tooltip when the origin gets a mouse click (common behavior of
							// native tooltips)
							if (self.__options.triggerClose.originClick) {
								
								self._$origin.on('click.'+ self.__namespace + '-triggerClose', function(event) {
									
									// we could actually let a tap trigger this but this feature just
									// does not make sense on touch devices
									if (	!self._touchIsTouchEvent(event)
										&&	!self._touchIsEmulatedEvent(event)
									) {
										self._close(event);
									}
								});
							}
							
							// set the same bindings for click and touch on the body to close the tooltip
							if (	self.__options.triggerClose.click
								||	(self.__options.triggerClose.tap && env.hasTouchCapability)
							) {
								
								// don't set right away since the click/tap event which triggered this method
								// (if it was a click/tap) is going to bubble up to the body, we don't want it
								// to close the tooltip immediately after it opened
								setTimeout(function() {
									
									if (self.__state != 'closed') {
										
										var eventNames = '',
											$body = $(env.window.document.body);
										
										if (self.__options.triggerClose.click) {
											eventNames += 'click.'+ self.__namespace +'-triggerClose ';
										}
										if (self.__options.triggerClose.tap && env.hasTouchCapability) {
											eventNames += 'touchend.'+ self.__namespace +'-triggerClose';
										}
										
										$body.on(eventNames, function(event) {
											
											if (self._touchIsMeaningfulEvent(event)) {
												
												self._touchRecordEvent(event);
												
												if (!self.__options.interactive || !$.contains(self._$tooltip[0], event.target)) {
													self._close(event);
												}
											}
										});
										
										// needed to detect and ignore swiping
										if (self.__options.triggerClose.tap && env.hasTouchCapability) {
											
											$body.on('touchstart.'+ self.__namespace +'-triggerClose', function(event) {
												self._touchRecordEvent(event);
											});
										}
									}
								}, 0);
							}
							
							self._trigger('ready');
							
							// call our custom callback
							if (self.__options.functionReady) {
								self.__options.functionReady.call(self, self, {
									origin: self._$origin[0],
									tooltip: self._$tooltip[0]
								});
							}
						}
						
						// if we have a timer set, let the countdown begin
						if (self.__options.timer > 0) {
							
							var timeout = setTimeout(function() {
								self._close();
							}, self.__options.timer + extraTime);
							
							self.__timeouts.close.push(timeout);
						}
					}
				}
			}
		}
		
		return self;
	},
	
	/**
	 * When using the mouseenter/touchstart open triggers, this function will
	 * schedule the opening of the tooltip after the delay, if there is one
	 *
	 * @param event
	 * @returns {self}
	 * @protected
 	 */
	_openShortly: function(event) {
		
		var self = this,
			ok = true;
		
		if (self.__state != 'stable' && self.__state != 'appearing') {
			
			// if a timeout is not already running
			if (!self.__timeouts.open) {
				
				self._trigger({
					type: 'start',
					event: event,
					stop: function() {
						ok = false;
					}
				});
				
				if (ok) {
					
					var delay = (event.type.indexOf('touch') == 0) ?
						self.__options.delayTouch :
						self.__options.delay;
					
					if (delay[0]) {
						
						self.__timeouts.open = setTimeout(function() {
							
							self.__timeouts.open = null;
							
							// open only if the pointer (mouse or touch) is still over the origin.
							// The check on the "meaningful event" can only be made here, after some
							// time has passed (to know if the touch was a swipe or not)
							if (self.__pointerIsOverOrigin && self._touchIsMeaningfulEvent(event)) {
								
								// signal that we go on
								self._trigger('startend');
								
								self._open(event);
							}
							else {
								// signal that we cancel
								self._trigger('startcancel');
							}
						}, delay[0]);
					}
					else {
						// signal that we go on
						self._trigger('startend');
						
						self._open(event);
					}
				}
			}
		}
		
		return self;
	},
	
	/**
	 * Meant for plugins to get their options
	 * 
	 * @param {string} pluginName The name of the plugin that asks for its options
	 * @param {object} defaultOptions The default options of the plugin
	 * @returns {object} The options
	 * @protected
	 */
	_optionsExtract: function(pluginName, defaultOptions) {
		
		var self = this,
			options = $.extend(true, {}, defaultOptions);
		
		// if the plugin options were isolated in a property named after the
		// plugin, use them (prevents conflicts with other plugins)
		var pluginOptions = self.__options[pluginName];
		
		// if not, try to get them as regular options
		if (!pluginOptions){
			
			pluginOptions = {};
			
			$.each(defaultOptions, function(optionName, value) {
				
				var o = self.__options[optionName];
				
				if (o !== undefined) {
					pluginOptions[optionName] = o;
				}
			});
		}
		
		// let's merge the default options and the ones that were provided. We'd want
		// to do a deep copy but not let jQuery merge arrays, so we'll do a shallow
		// extend on two levels, that will be enough if options are not more than 1
		// level deep
		$.each(options, function(optionName, value) {
			
			if (pluginOptions[optionName] !== undefined) {
				
				if ((		typeof value == 'object'
						&&	!(value instanceof Array)
						&&	value != null
					)
					&&
					(		typeof pluginOptions[optionName] == 'object'
						&&	!(pluginOptions[optionName] instanceof Array)
						&&	pluginOptions[optionName] != null
					)
				) {
					$.extend(options[optionName], pluginOptions[optionName]);
				}
				else {
					options[optionName] = pluginOptions[optionName];
				}
			}
		});
		
		return options;
	},
	
	/**
	 * Used at instantiation of the plugin, or afterwards by plugins that activate themselves
	 * on existing instances
	 * 
	 * @param {object} pluginName
	 * @returns {self}
	 * @protected
	 */
	_plug: function(pluginName) {
		
		var plugin = $.tooltipster._plugin(pluginName);
		
		if (plugin) {
			
			// if there is a constructor for instances
			if (plugin.instance) {
				
				// proxy non-private methods on the instance to allow new instance methods
				$.tooltipster.__bridge(plugin.instance, this, plugin.name);
			}
		}
		else {
			throw new Error('The "'+ pluginName +'" plugin is not defined');
		}
		
		return this;
	},
	
	/**
	 * This will return true if the event is a mouse event which was
	 * emulated by the browser after a touch event. This allows us to
	 * really dissociate mouse and touch triggers.
	 * 
	 * There is a margin of error if a real mouse event is fired right
	 * after (within the delay shown below) a touch event on the same
	 * element, but hopefully it should not happen often.
	 * 
	 * @returns {boolean}
	 * @protected
	 */
	_touchIsEmulatedEvent: function(event) {
		
		var isEmulated = false,
			now = new Date().getTime();
		
		for (var i = this.__touchEvents.length - 1; i >= 0; i--) {
			
			var e = this.__touchEvents[i];
			
			// delay, in milliseconds. It's supposed to be 300ms in
			// most browsers (350ms on iOS) to allow a double tap but
			// can be less (check out FastClick for more info)
			if (now - e.time < 500) {
				
				if (e.target === event.target) {
					isEmulated = true;
				}
			}
			else {
				break;
			}
		}
		
		return isEmulated;
	},
	
	/**
	 * Returns false if the event was an emulated mouse event or
	 * a touch event involved in a swipe gesture.
	 * 
	 * @param {object} event
	 * @returns {boolean}
	 * @protected
	 */
	_touchIsMeaningfulEvent: function(event) {
		return (
				(this._touchIsTouchEvent(event) && !this._touchSwiped(event.target))
			||	(!this._touchIsTouchEvent(event) && !this._touchIsEmulatedEvent(event))
		);
	},
	
	/**
	 * Checks if an event is a touch event
	 * 
	 * @param {object} event
	 * @returns {boolean}
	 * @protected
	 */
	_touchIsTouchEvent: function(event){
		return event.type.indexOf('touch') == 0;
	},
	
	/**
	 * Store touch events for a while to detect swiping and emulated mouse events
	 * 
	 * @param {object} event
	 * @returns {self}
	 * @protected
	 */
	_touchRecordEvent: function(event) {
		
		if (this._touchIsTouchEvent(event)) {
			event.time = new Date().getTime();
			this.__touchEvents.push(event);
		}
		
		return this;
	},
	
	/**
	 * Returns true if a swipe happened after the last touchstart event fired on
	 * event.target.
	 * 
	 * We need to differentiate a swipe from a tap before we let the event open
	 * or close the tooltip. A swipe is when a touchmove (scroll) event happens
	 * on the body between the touchstart and the touchend events of an element.
	 * 
	 * @param {object} target The HTML element that may have triggered the swipe
	 * @returns {boolean}
	 * @protected
	 */
	_touchSwiped: function(target) {
		
		var swiped = false;
		
		for (var i = this.__touchEvents.length - 1; i >= 0; i--) {
			
			var e = this.__touchEvents[i];
			
			if (e.type == 'touchmove') {
				swiped = true;
				break;
			}
			else if (
				e.type == 'touchstart'
				&&	target === e.target
			) {
				break;
			}
		}
		
		return swiped;
	},
	
	/**
	 * Triggers an event on the instance emitters
	 * 
	 * @returns {self}
	 * @protected
	 */
	_trigger: function() {
		
		var args = Array.prototype.slice.apply(arguments);
		
		if (typeof args[0] == 'string') {
			args[0] = { type: args[0] };
		}
		
		// add properties to the event
		args[0].instance = this;
		args[0].origin = this._$origin ? this._$origin[0] : null;
		args[0].tooltip = this._$tooltip ? this._$tooltip[0] : null;
		
		// note: the order of emitters matters
		this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate, args);
		$.tooltipster._trigger.apply($.tooltipster, args);
		this.__$emitterPublic.trigger.apply(this.__$emitterPublic, args);
		
		return this;
	},
	
	/**
	 * Deactivate a plugin on this instance
	 * 
	 * @returns {self}
	 * @protected
	 */
	_unplug: function(pluginName) {
		
		var self = this;
		
		// if the plugin has been activated on this instance
		if (self[pluginName]) {
			
			var plugin = $.tooltipster._plugin(pluginName);
			
			// if there is a constructor for instances
			if (plugin.instance) {
				
				// unbridge
				$.each(plugin.instance, function(methodName, fn) {
					
					// if the method exists (privates methods do not) and comes indeed from
					// this plugin (may be missing or come from a conflicting plugin).
					if (	self[methodName]
						&&	self[methodName].bridged === self[pluginName]
					) {
						delete self[methodName];
					}
				});
			}
			
			// destroy the plugin
			if (self[pluginName].__destroy) {
				self[pluginName].__destroy();
			}
			
			// remove the reference to the plugin instance
			delete self[pluginName];
		}
		
		return self;
	},
	
	/**
	 * @see self::_close
	 * @returns {self}
	 * @public
	 */
	close: function(callback) {
		
		if (!this.__destroyed) {
			this._close(null, callback);
		}
		else {
			this.__destroyError();
		}
		
		return this;
	},
	
	/**
	 * Sets or gets the content of the tooltip
	 * 
	 * @returns {mixed|self}
	 * @public
	 */
	content: function(content) {
		
		var self = this;
		
		// getter method
		if (content === undefined) {
			return self.__Content;
		}
		// setter method
		else {
			
			if (!self.__destroyed) {
				
				// change the content
				self.__contentSet(content);
				
				if (self.__Content !== null) {
					
					// update the tooltip if it is open
					if (self.__state !== 'closed') {
						
						// reset the content in the tooltip
						self.__contentInsert();
						
						// reposition and resize the tooltip
						self.reposition();
						
						// if we want to play a little animation showing the content changed
						if (self.__options.updateAnimation) {
							
							if (env.hasTransitions) {
								
								// keep the reference in the local scope
								var animation = self.__options.updateAnimation;
								
								self._$tooltip.addClass('tooltipster-update-'+ animation);
								
								// remove the class after a while. The actual duration of the
								// update animation may be shorter, it's set in the CSS rules
								setTimeout(function() {
									
									if (self.__state != 'closed') {
										
										self._$tooltip.removeClass('tooltipster-update-'+ animation);
									}
								}, 1000);
							}
							else {
								self._$tooltip.fadeTo(200, 0.5, function() {
									if (self.__state != 'closed') {
										self._$tooltip.fadeTo(200, 1);
									}
								});
							}
						}
					}
				}
				else {
					self._close();
				}
			}
			else {
				self.__destroyError();
			}
			
			return self;
		}
	},
	
	/**
	 * Destroys the tooltip
	 * 
	 * @returns {self}
	 * @public
	 */
	destroy: function() {
		
		var self = this;
		
		if (!self.__destroyed) {
			
			if(self.__state != 'closed'){
				
				// no closing delay
				self.option('animationDuration', 0)
					// force closing
					._close(null, null, true);
			}
			else {
				// there might be an open timeout still running
				self.__timeoutsClear();
			}
			
			// send event
			self._trigger('destroy');
			
			self.__destroyed = true;
			
			self._$origin
				.removeData(self.__namespace)
				// remove the open trigger listeners
				.off('.'+ self.__namespace +'-triggerOpen');
			
			// remove the touch listener
			$(env.window.document.body).off('.' + self.__namespace +'-triggerOpen');
			
			var ns = self._$origin.data('tooltipster-ns');
			
			// if the origin has been removed from DOM, its data may
			// well have been destroyed in the process and there would
			// be nothing to clean up or restore
			if (ns) {
				
				// if there are no more tooltips on this element
				if (ns.length === 1) {
					
					// optional restoration of a title attribute
					var title = null;
					if (self.__options.restoration == 'previous') {
						title = self._$origin.data('tooltipster-initialTitle');
					}
					else if (self.__options.restoration == 'current') {
						
						// old school technique to stringify when outerHTML is not supported
						title = (typeof self.__Content == 'string') ?
							self.__Content :
							$('<div></div>').append(self.__Content).html();
					}
					
					if (title) {
						self._$origin.attr('title', title);
					}
					
					// final cleaning
					
					self._$origin.removeClass('tooltipstered');
					
					self._$origin
						.removeData('tooltipster-ns')
						.removeData('tooltipster-initialTitle');
				}
				else {
					// remove the instance namespace from the list of namespaces of
					// tooltips present on the element
					ns = $.grep(ns, function(el, i) {
						return el !== self.__namespace;
					});
					self._$origin.data('tooltipster-ns', ns);
				}
			}
			
			// last event
			self._trigger('destroyed');
			
			// unbind private and public event listeners
			self._off();
			self.off();
			
			// remove external references, just in case
			self.__Content = null;
			self.__$emitterPrivate = null;
			self.__$emitterPublic = null;
			self.__options.parent = null;
			self._$origin = null;
			self._$tooltip = null;
			
			// make sure the object is no longer referenced in there to prevent
			// memory leaks
			$.tooltipster.__instancesLatestArr = $.grep($.tooltipster.__instancesLatestArr, function(el, i) {
				return self !== el;
			});
			
			clearInterval(self.__garbageCollector);
		}
		else {
			self.__destroyError();
		}
		
		// we return the scope rather than true so that the call to
		// .tooltipster('destroy') actually returns the matched elements
		// and applies to all of them
		return self;
	},
	
	/**
	 * Disables the tooltip
	 * 
	 * @returns {self}
	 * @public
	 */
	disable: function() {
		
		if (!this.__destroyed) {
			
			// close first, in case the tooltip would not disappear on
			// its own (no close trigger)
			this._close();
			this.__enabled = false;
			
			return this;
		}
		else {
			this.__destroyError();
		}
		
		return this;
	},
	
	/**
	 * Returns the HTML element of the origin
	 *
	 * @returns {self}
	 * @public
	 */
	elementOrigin: function() {
		
		if (!this.__destroyed) {
			return this._$origin[0];
		}
		else {
			this.__destroyError();
		}
	},
	
	/**
	 * Returns the HTML element of the tooltip
	 *
	 * @returns {self}
	 * @public
	 */
	elementTooltip: function() {
		return this._$tooltip ? this._$tooltip[0] : null;
	},
	
	/**
	 * Enables the tooltip
	 * 
	 * @returns {self}
	 * @public
	 */
	enable: function() {
		this.__enabled = true;
		return this;
	},
	
	/**
	 * Alias, deprecated in 4.0.0
	 * 
	 * @param {function} callback
	 * @returns {self}
	 * @public
	 */
	hide: function(callback) {
		return this.close(callback);
	},
	
	/**
	 * Returns the instance
	 * 
	 * @returns {self}
	 * @public
	 */
	instance: function() {
		return this;
	},
	
	/**
	 * For public use only, not to be used by plugins (use ::_off() instead)
	 * 
	 * @returns {self}
	 * @public
	 */
	off: function() {
		
		if (!this.__destroyed) {
			this.__$emitterPublic.off.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		}
		
		return this;
	},
	
	/**
	 * For public use only, not to be used by plugins (use ::_on() instead)
	 *
	 * @returns {self}
	 * @public
	 */
	on: function() {
		
		if (!this.__destroyed) {
			this.__$emitterPublic.on.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		}
		else {
			this.__destroyError();
		}
		
		return this;
	},
	
	/**
	 * For public use only, not to be used by plugins
	 *
	 * @returns {self}
	 * @public
	 */
	one: function() {
		
		if (!this.__destroyed) {
			this.__$emitterPublic.one.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		}
		else {
			this.__destroyError();
		}
		
		return this;
	},
	
	/**
	 * @see self::_open
	 * @returns {self}
	 * @public
	 */
	open: function(callback) {
		
		if (!this.__destroyed) {
			this._open(null, callback);
		}
		else {
			this.__destroyError();
		}
		
		return this;
	},
	
	/**
	 * Get or set options. For internal use and advanced users only.
	 * 
	 * @param {string} o Option name
	 * @param {mixed} val optional A new value for the option
	 * @return {mixed|self} If val is omitted, the value of the option
	 * is returned, otherwise the instance itself is returned
	 * @public
	 */ 
	option: function(o, val) {
		
		// getter
		if (val === undefined) {
			return this.__options[o];
		}
		// setter
		else {
			
			if (!this.__destroyed) {
				
				// change value
				this.__options[o] = val;
				
				// format
				this.__optionsFormat();
				
				// re-prepare the triggers if needed
				if ($.inArray(o, ['trigger', 'triggerClose', 'triggerOpen']) >= 0) {
					this.__prepareOrigin();
				}
				
				if (o === 'selfDestruction') {
					this.__prepareGC();
				}
			}
			else {
				this.__destroyError();
			}
			
			return this;
		}
	},
	
	/**
	 * This method is in charge of setting the position and size properties of the tooltip.
	 * All the hard work is delegated to the display plugin.
	 * Note: The tooltip may be detached from the DOM at the moment the method is called 
	 * but must be attached by the end of the method call.
	 * 
	 * @param {object} event For internal use only. Defined if an event such as
	 * window resizing triggered the repositioning
	 * @param {boolean} tooltipIsDetached For internal use only. Set this to true if you
	 * know that the tooltip not being in the DOM is not an issue (typically when the
	 * tooltip element has just been created but has not been added to the DOM yet).
	 * @returns {self}
	 * @public
	 */
	reposition: function(event, tooltipIsDetached) {
		
		var self = this;
		
		if (!self.__destroyed) {
			
			// if the tooltip is still open and the origin is still in the DOM
			if (self.__state != 'closed' && bodyContains(self._$origin)) {
				
				// if the tooltip has not been removed from DOM manually (or if it
				// has been detached on purpose)
				if (tooltipIsDetached || bodyContains(self._$tooltip)) {
					
					if (!tooltipIsDetached) {
						// detach in case the tooltip overflows the window and adds
						// scrollbars to it, so __geometry can be accurate
						self._$tooltip.detach();
					}
					
					// refresh the geometry object before passing it as a helper
					self.__Geometry = self.__geometry();
					
					// let a plugin fo the rest
					self._trigger({
						type: 'reposition',
						event: event,
						helper: {
							geo: self.__Geometry
						}
					});
				}
			}
		}
		else {
			self.__destroyError();
		}
		
		return self;
	},
	
	/**
	 * Alias, deprecated in 4.0.0
	 *
	 * @param callback
	 * @returns {self}
	 * @public
	 */
	show: function(callback) {
		return this.open(callback);
	},
	
	/**
	 * Returns some properties about the instance
	 * 
	 * @returns {object}
	 * @public
	 */
	status: function() {
		
		return {
			destroyed: this.__destroyed,
			enabled: this.__enabled,
			open: this.__state !== 'closed',
			state: this.__state
		};
	},
	
	/**
	 * For public use only, not to be used by plugins
	 *
	 * @returns {self}
	 * @public
	 */
	triggerHandler: function() {
		
		if (!this.__destroyed) {
			this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
		}
		else {
			this.__destroyError();
		}
		
		return this;
	}
};

$.fn.tooltipster = function() {
	
	// for using in closures
	var args = Array.prototype.slice.apply(arguments),
		// common mistake: an HTML element can't be in several tooltips at the same time
		contentCloningWarning = 'You are using a single HTML element as content for several tooltips. You probably want to set the contentCloning option to TRUE.';
	
	// this happens with $(sel).tooltipster(...) when $(sel) does not match anything
	if (this.length === 0) {
		
		// still chainable
		return this;
	}
	// this happens when calling $(sel).tooltipster('methodName or options')
	// where $(sel) matches one or more elements
	else {
		
		// method calls
		if (typeof args[0] === 'string') {
			
			var v = '#*$~&';
			
			this.each(function() {
				
				// retrieve the namepaces of the tooltip(s) that exist on that element.
				// We will interact with the first tooltip only.
				var ns = $(this).data('tooltipster-ns'),
					// self represents the instance of the first tooltipster plugin
					// associated to the current HTML object of the loop
					self = ns ? $(this).data(ns[0]) : null;
				
				// if the current element holds a tooltipster instance
				if (self) {
					
					if (typeof self[args[0]] === 'function') {
						
						if (	this.length > 1
							&&	args[0] == 'content'
							&&	(	args[1] instanceof $
								|| (typeof args[1] == 'object' && args[1] != null && args[1].tagName)
							)
							&&	!self.__options.contentCloning
							&&	self.__options.debug
						) {
							console.log(contentCloningWarning);
						}
						
						// note : args[1] and args[2] may not be defined
						var resp = self[args[0]](args[1], args[2]);
					}
					else {
						throw new Error('Unknown method "'+ args[0] +'"');
					}
					
					// if the function returned anything other than the instance
					// itself (which implies chaining, except for the `instance` method)
					if (resp !== self || args[0] === 'instance') {
						
						v = resp;
						
						// return false to stop .each iteration on the first element
						// matched by the selector
						return false;
					}
				}
				else {
					throw new Error('You called Tooltipster\'s "'+ args[0] +'" method on an uninitialized element');
				}
			});
			
			return (v !== '#*$~&') ? v : this;
		}
		// first argument is undefined or an object: the tooltip is initializing
		else {
			
			// reset the array of last initialized objects
			$.tooltipster.__instancesLatestArr = [];
			
			// is there a defined value for the multiple option in the options object ?
			var	multipleIsSet = args[0] && args[0].multiple !== undefined,
				// if the multiple option is set to true, or if it's not defined but
				// set to true in the defaults
				multiple = (multipleIsSet && args[0].multiple) || (!multipleIsSet && defaults.multiple),
				// same for content
				contentIsSet = args[0] && args[0].content !== undefined,
				content = (contentIsSet && args[0].content) || (!contentIsSet && defaults.content),
				// same for contentCloning
				contentCloningIsSet = args[0] && args[0].contentCloning !== undefined,
				contentCloning =
						(contentCloningIsSet && args[0].contentCloning)
					||	(!contentCloningIsSet && defaults.contentCloning),
				// same for debug
				debugIsSet = args[0] && args[0].debug !== undefined,
				debug = (debugIsSet && args[0].debug) || (!debugIsSet && defaults.debug);
			
			if (	this.length > 1
				&&	(	content instanceof $
					|| (typeof content == 'object' && content != null && content.tagName)
				)
				&&	!contentCloning
				&&	debug
			) {
				console.log(contentCloningWarning);
			}
			
			// create a tooltipster instance for each element if it doesn't
			// already have one or if the multiple option is set, and attach the
			// object to it
			this.each(function() {
				
				var go = false,
					$this = $(this),
					ns = $this.data('tooltipster-ns'),
					obj = null;
				
				if (!ns) {
					go = true;
				}
				else if (multiple) {
					go = true;
				}
				else if (debug) {
					console.log('Tooltipster: one or more tooltips are already attached to the element below. Ignoring.');
					console.log(this);
				}
				
				if (go) {
					obj = new $.Tooltipster(this, args[0]);
					
					// save the reference of the new instance
					if (!ns) ns = [];
					ns.push(obj.__namespace);
					$this.data('tooltipster-ns', ns);
					
					// save the instance itself
					$this.data(obj.__namespace, obj);
					
					// call our constructor custom function.
					// we do this here and not in ::init() because we wanted
					// the object to be saved in $this.data before triggering
					// it
					if (obj.__options.functionInit) {
						obj.__options.functionInit.call(obj, obj, {
							origin: this
						});
					}
					
					// and now the event, for the plugins and core emitter
					obj._trigger('init');
				}
				
				$.tooltipster.__instancesLatestArr.push(obj);
			});
			
			return this;
		}
	}
};

// Utilities

/**
 * A class to check if a tooltip can fit in given dimensions
 * 
 * @param {object} $tooltip The jQuery wrapped tooltip element, or a clone of it
 */
function Ruler($tooltip) {
	
	// list of instance variables
	
	this.$container;
	this.constraints = null;
	this.__$tooltip;
	
	this.__init($tooltip);
}

Ruler.prototype = {
	
	/**
	 * Move the tooltip into an invisible div that does not allow overflow to make
	 * size tests. Note: the tooltip may or may not be attached to the DOM at the
	 * moment this method is called, it does not matter.
	 * 
	 * @param {object} $tooltip The object to test. May be just a clone of the
	 * actual tooltip.
	 * @private
	 */
	__init: function($tooltip) {
		
		this.__$tooltip = $tooltip;
		
		this.__$tooltip
			.css({
				// for some reason we have to specify top and left 0
				left: 0,
				// any overflow will be ignored while measuring
				overflow: 'hidden',
				// positions at (0,0) without the div using 100% of the available width
				position: 'absolute',
				top: 0
			})
			// overflow must be auto during the test. We re-set this in case
			// it were modified by the user
			.find('.tooltipster-content')
				.css('overflow', 'auto');
		
		this.$container = $('<div class="tooltipster-ruler"></div>')
			.append(this.__$tooltip)
			.appendTo(env.window.document.body);
	},
	
	/**
	 * Force the browser to redraw (re-render) the tooltip immediately. This is required
	 * when you changed some CSS properties and need to make something with it
	 * immediately, without waiting for the browser to redraw at the end of instructions.
	 *
	 * @see http://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes
	 * @private
	 */
	__forceRedraw: function() {
		
		// note: this would work but for Webkit only
		//this.__$tooltip.close();
		//this.__$tooltip[0].offsetHeight;
		//this.__$tooltip.open();
		
		// works in FF too
		var $p = this.__$tooltip.parent();
		this.__$tooltip.detach();
		this.__$tooltip.appendTo($p);
	},
	
	/**
	 * Set maximum dimensions for the tooltip. A call to ::measure afterwards
	 * will tell us if the content overflows or if it's ok
	 *
	 * @param {int} width
	 * @param {int} height
	 * @return {Ruler}
	 * @public
	 */
	constrain: function(width, height) {
		
		this.constraints = {
			width: width,
			height: height
		};
		
		this.__$tooltip.css({
			// we disable display:flex, otherwise the content would overflow without
			// creating horizontal scrolling (which we need to detect).
			display: 'block',
			// reset any previous height
			height: '',
			// we'll check if horizontal scrolling occurs
			overflow: 'auto',
			// we'll set the width and see what height is generated and if there
			// is horizontal overflow
			width: width
		});
		
		return this;
	},
	
	/**
	 * Reset the tooltip content overflow and remove the test container
	 * 
	 * @returns {Ruler}
	 * @public
	 */
	destroy: function() {
		
		// in case the element was not a clone
		this.__$tooltip
			.detach()
			.find('.tooltipster-content')
				.css({
					// reset to CSS value
					display: '',
					overflow: ''
				});
		
		this.$container.remove();
	},
	
	/**
	 * Removes any constraints
	 * 
	 * @returns {Ruler}
	 * @public
	 */
	free: function() {
		
		this.constraints = null;
		
		// reset to natural size
		this.__$tooltip.css({
			display: '',
			height: '',
			overflow: 'visible',
			width: ''
		});
		
		return this;
	},
	
	/**
	 * Returns the size of the tooltip. When constraints are applied, also returns
	 * whether the tooltip fits in the provided dimensions.
	 * The idea is to see if the new height is small enough and if the content does
	 * not overflow horizontally.
	 *
	 * @param {int} width
	 * @param {int} height
	 * @returns {object} An object with a bool `fits` property and a `size` property
	 * @public
	 */
	measure: function() {
		
		this.__forceRedraw();
		
		var tooltipBcr = this.__$tooltip[0].getBoundingClientRect(),
			result = { size: {
				// bcr.width/height are not defined in IE8- but in this
				// case, bcr.right/bottom will have the same value
				// except in iOS 8+ where tooltipBcr.bottom/right are wrong
				// after scrolling for reasons yet to be determined.
				// tooltipBcr.top/left might not be 0, see issue #514
				height: tooltipBcr.height || (tooltipBcr.bottom - tooltipBcr.top),
				width: tooltipBcr.width || (tooltipBcr.right - tooltipBcr.left)
			}};
		
		if (this.constraints) {
			
			// note: we used to use offsetWidth instead of boundingRectClient but
			// it returned rounded values, causing issues with sub-pixel layouts.
			
			// note2: noticed that the bcrWidth of text content of a div was once
			// greater than the bcrWidth of its container by 1px, causing the final
			// tooltip box to be too small for its content. However, evaluating
			// their widths one against the other (below) surprisingly returned
			// equality. Happened only once in Chrome 48, was not able to reproduce
			// => just having fun with float position values...
			
			var $content = this.__$tooltip.find('.tooltipster-content'),
				height = this.__$tooltip.outerHeight(),
				contentBcr = $content[0].getBoundingClientRect(),
				fits = {
					height: height <= this.constraints.height,
					width: (
						// this condition accounts for min-width property that
						// may apply
						tooltipBcr.width <= this.constraints.width
							// the -1 is here because scrollWidth actually returns
							// a rounded value, and may be greater than bcr.width if
							// it was rounded up. This may cause an issue for contents
							// which actually really overflow  by 1px or so, but that
							// should be rare. Not sure how to solve this efficiently.
							// See http://blogs.msdn.com/b/ie/archive/2012/02/17/sub-pixel-rendering-and-the-css-object-model.aspx
						&&	contentBcr.width >= $content[0].scrollWidth - 1
					)
				};
			
			result.fits = fits.height && fits.width;
		}
		
		// old versions of IE get the width wrong for some reason and it causes
		// the text to be broken to a new line, so we round it up. If the width
		// is the width of the screen though, we can assume it is accurate.
		if (	env.IE
			&&	env.IE <= 11
			&&	result.size.width !== env.window.document.documentElement.clientWidth
		) {
			result.size.width = Math.ceil(result.size.width) + 1;
		}
		
		return result;
	}
};

// quick & dirty compare function, not bijective nor multidimensional
function areEqual(a,b) {
	var same = true;
	$.each(a, function(i, _) {
		if (b[i] === undefined || a[i] !== b[i]) {
			same = false;
			return false;
		}
	});
	return same;
}

/**
 * A fast function to check if an element is still in the DOM. It
 * tries to use an id as ids are indexed by the browser, or falls
 * back to jQuery's `contains` method. May fail if two elements
 * have the same id, but so be it
 *
 * @param {object} $obj A jQuery-wrapped HTML element
 * @return {boolean}
 */
function bodyContains($obj) {
	var id = $obj.attr('id'),
		el = id ? env.window.document.getElementById(id) : null;
	// must also check that the element with the id is the one we want
	return el ? el === $obj[0] : $.contains(env.window.document.body, $obj[0]);
}

// detect IE versions for dirty fixes
var uA = navigator.userAgent.toLowerCase();
if (uA.indexOf('msie') != -1) env.IE = parseInt(uA.split('msie')[1]);
else if (uA.toLowerCase().indexOf('trident') !== -1 && uA.indexOf(' rv:11') !== -1) env.IE = 11;
else if (uA.toLowerCase().indexOf('edge/') != -1) env.IE = parseInt(uA.toLowerCase().split('edge/')[1]);

// detecting support for CSS transitions
function transitionSupport() {
	
	// env.window is not defined yet when this is called
	if (!win) return false;
	
	var b = win.document.body || win.document.documentElement,
		s = b.style,
		p = 'transition',
		v = ['Moz', 'Webkit', 'Khtml', 'O', 'ms'];
	
	if (typeof s[p] == 'string') { return true; }
	
	p = p.charAt(0).toUpperCase() + p.substr(1);
	for (var i=0; i<v.length; i++) {
		if (typeof s[v[i] + p] == 'string') { return true; }
	}
	return false;
}

// we'll return jQuery for plugins not to have to declare it as a dependency,
// but it's done by a build task since it should be included only once at the
// end when we concatenate the main file with a plugin
// sideTip is Tooltipster's default plugin.
// This file will be UMDified by a build task.

var pluginName = 'tooltipster.sideTip';

$.tooltipster._plugin({
	name: pluginName,
	instance: {
		/**
		 * Defaults are provided as a function for an easy override by inheritance
		 *
		 * @return {object} An object with the defaults options
		 * @private
		 */
		__defaults: function() {
			
			return {
				// if the tooltip should display an arrow that points to the origin
				arrow: true,
				// the distance in pixels between the tooltip and the origin
				distance: 6,
				// allows to easily change the position of the tooltip
				functionPosition: null,
				maxWidth: null,
				// used to accomodate the arrow of tooltip if there is one.
				// First to make sure that the arrow target is not too close
				// to the edge of the tooltip, so the arrow does not overflow
				// the tooltip. Secondly when we reposition the tooltip to
				// make sure that it's positioned in such a way that the arrow is
				// still pointing at the target (and not a few pixels beyond it).
				// It should be equal to or greater than half the width of
				// the arrow (by width we mean the size of the side which touches
				// the side of the tooltip).
				minIntersection: 16,
				minWidth: 0,
				// deprecated in 4.0.0. Listed for _optionsExtract to pick it up
				position: null,
				side: 'top',
				// set to false to position the tooltip relatively to the document rather
				// than the window when we open it
				viewportAware: true
			};
		},
		
		/**
		 * Run once: at instantiation of the plugin
		 *
		 * @param {object} instance The tooltipster object that instantiated this plugin
		 * @private
		 */
		__init: function(instance) {
			
			var self = this;
			
			// list of instance variables
			
			self.__instance = instance;
			self.__namespace = 'tooltipster-sideTip-'+ Math.round(Math.random()*1000000);
			self.__previousState = 'closed';
			self.__options;
			
			// initial formatting
			self.__optionsFormat();
			
			self.__instance._on('state.'+ self.__namespace, function(event) {
				
				if (event.state == 'closed') {
					self.__close();
				}
				else if (event.state == 'appearing' && self.__previousState == 'closed') {
					self.__create();
				}
				
				self.__previousState = event.state;
			});
			
			// reformat every time the options are changed
			self.__instance._on('options.'+ self.__namespace, function() {
				self.__optionsFormat();
			});
			
			self.__instance._on('reposition.'+ self.__namespace, function(e) {
				self.__reposition(e.event, e.helper);
			});
		},
		
		/**
		 * Called when the tooltip has closed
		 * 
		 * @private
		 */
		__close: function() {
			
			// detach our content object first, so the next jQuery's remove()
			// call does not unbind its event handlers
			if (this.__instance.content() instanceof $) {
				this.__instance.content().detach();
			}
			
			// remove the tooltip from the DOM
			this.__instance._$tooltip.remove();
			this.__instance._$tooltip = null;
		},
		
		/**
		 * Creates the HTML element of the tooltip.
		 * 
		 * @private
		 */
		__create: function() {
			
			// note: we wrap with a .tooltipster-box div to be able to set a margin on it
			// (.tooltipster-base must not have one)
			var $html = $(
				'<div class="tooltipster-base tooltipster-sidetip">' +
					'<div class="tooltipster-box">' +
						'<div class="tooltipster-content"></div>' +
					'</div>' +
					'<div class="tooltipster-arrow">' +
						'<div class="tooltipster-arrow-uncropped">' +
							'<div class="tooltipster-arrow-border"></div>' +
							'<div class="tooltipster-arrow-background"></div>' +
						'</div>' +
					'</div>' +
				'</div>'
			);
			
			// hide arrow if asked
			if (!this.__options.arrow) {
				$html
					.find('.tooltipster-box')
						.css('margin', 0)
						.end()
					.find('.tooltipster-arrow')
						.hide();
			}
			
			// apply min/max width if asked
			if (this.__options.minWidth) {
				$html.css('min-width', this.__options.minWidth + 'px');
			}
			if (this.__options.maxWidth) {
				$html.css('max-width', this.__options.maxWidth + 'px');
			}
			
			this.__instance._$tooltip = $html;
			
			// tell the instance that the tooltip element has been created
			this.__instance._trigger('created');
		},
		
		/**
		 * Used when the plugin is to be unplugged
		 *
		 * @private
		 */
		__destroy: function() {
			this.__instance._off('.'+ self.__namespace);
		},
		
		/**
		 * (Re)compute this.__options from the options declared to the instance
		 *
		 * @private
		 */
		__optionsFormat: function() {
			
			var self = this;
			
			// get the options
			self.__options = self.__instance._optionsExtract(pluginName, self.__defaults());
			
			// for backward compatibility, deprecated in v4.0.0
			if (self.__options.position) {
				self.__options.side = self.__options.position;
			}
			
			// options formatting
			
			// format distance as a four-cell array if it ain't one yet and then make
			// it an object with top/bottom/left/right properties
			if (typeof self.__options.distance != 'object') {
				self.__options.distance = [self.__options.distance];
			}
			if (self.__options.distance.length < 4) {
				if (self.__options.distance[1] === undefined) self.__options.distance[1] = self.__options.distance[0];
				if (self.__options.distance[2] === undefined) self.__options.distance[2] = self.__options.distance[0];
				if (self.__options.distance[3] === undefined) self.__options.distance[3] = self.__options.distance[1];
			}
			
			self.__options.distance = {
				top: self.__options.distance[0],
				right: self.__options.distance[1],
				bottom: self.__options.distance[2],
				left: self.__options.distance[3]
			};
			
			// let's transform:
			// 'top' into ['top', 'bottom', 'right', 'left']
			// 'right' into ['right', 'left', 'top', 'bottom']
			// 'bottom' into ['bottom', 'top', 'right', 'left']
			// 'left' into ['left', 'right', 'top', 'bottom']
			if (typeof self.__options.side == 'string') {
				
				var opposites = {
					'top': 'bottom',
					'right': 'left',
					'bottom': 'top',
					'left': 'right'
				};
				
				self.__options.side = [self.__options.side, opposites[self.__options.side]];
				
				if (self.__options.side[0] == 'left' || self.__options.side[0] == 'right') {
					self.__options.side.push('top', 'bottom');
				}
				else {
					self.__options.side.push('right', 'left');
				}
			}
			
			// misc
			// disable the arrow in IE6 unless the arrow option was explicitly set to true
			if (	$.tooltipster._env.IE === 6
				&&	self.__options.arrow !== true
			) {
				self.__options.arrow = false;
			}
		},
		
		/**
		 * This method must compute and set the positioning properties of the
		 * tooltip (left, top, width, height, etc.). It must also make sure the
		 * tooltip is eventually appended to its parent (since the element may be
		 * detached from the DOM at the moment the method is called).
		 *
		 * We'll evaluate positioning scenarios to find which side can contain the
		 * tooltip in the best way. We'll consider things relatively to the window
		 * (unless the user asks not to), then to the document (if need be, or if the
		 * user explicitly requires the tests to run on the document). For each
		 * scenario, measures are taken, allowing us to know how well the tooltip
		 * is going to fit. After that, a sorting function will let us know what
		 * the best scenario is (we also allow the user to choose his favorite
		 * scenario by using an event).
		 * 
		 * @param {object} helper An object that contains variables that plugin
		 * creators may find useful (see below)
		 * @param {object} helper.geo An object with many layout properties
		 * about objects of interest (window, document, origin). This should help
		 * plugin users compute the optimal position of the tooltip
		 * @private
		 */
		__reposition: function(event, helper) {
			
			var self = this,
				finalResult,
				// to know where to put the tooltip, we need to know on which point
				// of the x or y axis we should center it. That coordinate is the target
				targets = self.__targetFind(helper),
				testResults = [];
			
			// make sure the tooltip is detached while we make tests on a clone
			self.__instance._$tooltip.detach();
			
			// we could actually provide the original element to the Ruler and
			// not a clone, but it just feels right to keep it out of the
			// machinery.
			var $clone = self.__instance._$tooltip.clone(),
				// start position tests session
				ruler = $.tooltipster._getRuler($clone),
				satisfied = false,
				animation = self.__instance.option('animation');
			
			// an animation class could contain properties that distort the size
			if (animation) {
				$clone.removeClass('tooltipster-'+ animation);
			}
			
			// start evaluating scenarios
			$.each(['window', 'document'], function(i, container) {
				
				var takeTest = null;
				
				// let the user decide to keep on testing or not
				self.__instance._trigger({
					container: container,
					helper: helper,
					satisfied: satisfied,
					takeTest: function(bool) {
						takeTest = bool;
					},
					results: testResults,
					type: 'positionTest'
				});
				
				if (	takeTest == true
					||	(	takeTest != false
						&&	satisfied == false
							// skip the window scenarios if asked. If they are reintegrated by
							// the callback of the positionTest event, they will have to be
							// excluded using the callback of positionTested
						&&	(container != 'window' || self.__options.viewportAware)
					)
				) {
					
					// for each allowed side
					for (var i=0; i < self.__options.side.length; i++) {
						
						var distance = {
								horizontal: 0,
								vertical: 0
							},
							side = self.__options.side[i];
						
						if (side == 'top' || side == 'bottom') {
							distance.vertical = self.__options.distance[side];
						}
						else {
							distance.horizontal = self.__options.distance[side];
						}
						
						// this may have an effect on the size of the tooltip if there are css
						// rules for the arrow or something else
						self.__sideChange($clone, side);
						
						$.each(['natural', 'constrained'], function(i, mode) {
							
							takeTest = null;
							
							// emit an event on the instance
							self.__instance._trigger({
								container: container,
								event: event,
								helper: helper,
								mode: mode,
								results: testResults,
								satisfied: satisfied,
								side: side,
								takeTest: function(bool) {
									takeTest = bool;
								},
								type: 'positionTest'
							});
							
							if (	takeTest == true
								||	(	takeTest != false
									&&	satisfied == false
								)
							) {
								
								var testResult = {
									container: container,
									// we let the distance as an object here, it can make things a little easier
									// during the user's calculations at positionTest/positionTested
									distance: distance,
									// whether the tooltip can fit in the size of the viewport (does not mean
									// that we'll be able to make it initially entirely visible, see 'whole')
									fits: null,
									mode: mode,
									outerSize: null,
									side: side,
									size: null,
									target: targets[side],
									// check if the origin has enough surface on screen for the tooltip to
									// aim at it without overflowing the viewport (this is due to the thickness
									// of the arrow represented by the minIntersection length).
									// If not, the tooltip will have to be partly or entirely off screen in
									// order to stay docked to the origin. This value will stay null when the
									// container is the document, as it is not relevant
									whole: null
								};
								
								// get the size of the tooltip with or without size constraints
								var rulerConfigured = (mode == 'natural') ?
										ruler.free() :
										ruler.constrain(
											helper.geo.available[container][side].width - distance.horizontal,
											helper.geo.available[container][side].height - distance.vertical
										),
									rulerResults = rulerConfigured.measure();
								
								testResult.size = rulerResults.size;
								testResult.outerSize = {
									height: rulerResults.size.height + distance.vertical,
									width: rulerResults.size.width + distance.horizontal
								};
								
								if (mode == 'natural') {
									
									if(		helper.geo.available[container][side].width >= testResult.outerSize.width
										&&	helper.geo.available[container][side].height >= testResult.outerSize.height
									) {
										testResult.fits = true;
									}
									else {
										testResult.fits = false;
									}
								}
								else {
									testResult.fits = rulerResults.fits;
								}
								
								if (container == 'window') {
									
									if (!testResult.fits) {
										testResult.whole = false;
									}
									else {
										if (side == 'top' || side == 'bottom') {
											
											testResult.whole = (
													helper.geo.origin.windowOffset.right >= self.__options.minIntersection
												&&	helper.geo.window.size.width - helper.geo.origin.windowOffset.left >= self.__options.minIntersection
											);
										}
										else {
											testResult.whole = (
													helper.geo.origin.windowOffset.bottom >= self.__options.minIntersection
												&&	helper.geo.window.size.height - helper.geo.origin.windowOffset.top >= self.__options.minIntersection
											);
										}
									}
								}
								
								testResults.push(testResult);
								
								// we don't need to compute more positions if we have one fully on screen
								if (testResult.whole) {
									satisfied = true;
								}
								else {
									// don't run the constrained test unless the natural width was greater
									// than the available width, otherwise it's pointless as we know it
									// wouldn't fit either
									if (	testResult.mode == 'natural'
										&&	(	testResult.fits
											||	testResult.size.width <= helper.geo.available[container][side].width
										)
									) {
										return false;
									}
								}
							}
						});
					}
				}
			});
			
			// the user may eliminate the unwanted scenarios from testResults, but he's
			// not supposed to alter them at this point. functionPosition and the
			// position event serve that purpose.
			self.__instance._trigger({
				edit: function(r) {
					testResults = r;
				},
				event: event,
				helper: helper,
				results: testResults,
				type: 'positionTested'
			});
			
			/**
			 * Sort the scenarios to find the favorite one.
			 * 
			 * The favorite scenario is when we can fully display the tooltip on screen,
			 * even if it means that the middle of the tooltip is no longer centered on
			 * the middle of the origin (when the origin is near the edge of the screen
			 * or even partly off screen). We want the tooltip on the preferred side,
			 * even if it means that we have to use a constrained size rather than a
			 * natural one (as long as it fits). When the origin is off screen at the top
			 * the tooltip will be positioned at the bottom (if allowed), if the origin
			 * is off screen on the right, it will be positioned on the left, etc.
			 * If there are no scenarios where the tooltip can fit on screen, or if the
			 * user does not want the tooltip to fit on screen (viewportAware == false),
			 * we fall back to the scenarios relative to the document.
			 * 
			 * When the tooltip is bigger than the viewport in either dimension, we stop
			 * looking at the window scenarios and consider the document scenarios only,
			 * with the same logic to find on which side it would fit best.
			 * 
			 * If the tooltip cannot fit the document on any side, we force it at the
			 * bottom, so at least the user can scroll to see it.
 			 */
			testResults.sort(function(a, b) {
				
				// best if it's whole (the tooltip fits and adapts to the viewport)
				if (a.whole && !b.whole) {
					return -1;
				}
				else if (!a.whole && b.whole) {
					return 1;
				}
				else if (a.whole && b.whole) {
					
					var ai = self.__options.side.indexOf(a.side),
						bi = self.__options.side.indexOf(b.side);
					
					// use the user's sides fallback array
					if (ai < bi) {
						return -1;
					}
					else if (ai > bi) {
						return 1;
					}
					else {
						// will be used if the user forced the tests to continue
						return a.mode == 'natural' ? -1 : 1;
					}
				}
				else {
					
					// better if it fits
					if (a.fits && !b.fits) {
						return -1;
					}
					else if (!a.fits && b.fits) {
						return 1;
					}
					else if (a.fits && b.fits) {
						
						var ai = self.__options.side.indexOf(a.side),
							bi = self.__options.side.indexOf(b.side);
						
						// use the user's sides fallback array
						if (ai < bi) {
							return -1;
						}
						else if (ai > bi) {
							return 1;
						}
						else {
							// will be used if the user forced the tests to continue
							return a.mode == 'natural' ? -1 : 1;
						}
					}
					else {
						
						// if everything failed, this will give a preference to the case where
						// the tooltip overflows the document at the bottom
						if (	a.container == 'document'
							&&	a.side == 'bottom'
							&&	a.mode == 'natural'
						) {
							return -1;
						}
						else {
							return 1;
						}
					}
				}
			});
			
			finalResult = testResults[0];
			
			
			// now let's find the coordinates of the tooltip relatively to the window
			finalResult.coord = {};
			
			switch (finalResult.side) {
				
				case 'left':
				case 'right':
					finalResult.coord.top = Math.floor(finalResult.target - finalResult.size.height / 2);
					break;
				
				case 'bottom':
				case 'top':
					finalResult.coord.left = Math.floor(finalResult.target - finalResult.size.width / 2);
					break;
			}
			
			switch (finalResult.side) {
				
				case 'left':
					finalResult.coord.left = helper.geo.origin.windowOffset.left - finalResult.outerSize.width;
					break;
				
				case 'right':
					finalResult.coord.left = helper.geo.origin.windowOffset.right + finalResult.distance.horizontal;
					break;
				
				case 'top':
					finalResult.coord.top = helper.geo.origin.windowOffset.top - finalResult.outerSize.height;
					break;
				
				case 'bottom':
					finalResult.coord.top = helper.geo.origin.windowOffset.bottom + finalResult.distance.vertical;
					break;
			}
			
			// if the tooltip can potentially be contained within the viewport dimensions
			// and that we are asked to make it fit on screen
			if (finalResult.container == 'window') {
				
				// if the tooltip overflows the viewport, we'll move it accordingly (then it will
				// not be centered on the middle of the origin anymore). We only move horizontally
				// for top and bottom tooltips and vice versa.
				if (finalResult.side == 'top' || finalResult.side == 'bottom') {
					
					// if there is an overflow on the left
					if (finalResult.coord.left < 0) {
						
						// prevent the overflow unless the origin itself gets off screen (minus the
						// margin needed to keep the arrow pointing at the target)
						if (helper.geo.origin.windowOffset.right - this.__options.minIntersection >= 0) {
							finalResult.coord.left = 0;
						}
						else {
							finalResult.coord.left = helper.geo.origin.windowOffset.right - this.__options.minIntersection - 1;
						}
					}
					// or an overflow on the right
					else if (finalResult.coord.left > helper.geo.window.size.width - finalResult.size.width) {
						
						if (helper.geo.origin.windowOffset.left + this.__options.minIntersection <= helper.geo.window.size.width) {
							finalResult.coord.left = helper.geo.window.size.width - finalResult.size.width;
						}
						else {
							finalResult.coord.left = helper.geo.origin.windowOffset.left + this.__options.minIntersection + 1 - finalResult.size.width;
						}
					}
				}
				else {
					
					// overflow at the top
					if (finalResult.coord.top < 0) {
						
						if (helper.geo.origin.windowOffset.bottom - this.__options.minIntersection >= 0) {
							finalResult.coord.top = 0;
						}
						else {
							finalResult.coord.top = helper.geo.origin.windowOffset.bottom - this.__options.minIntersection - 1;
						}
					}
					// or at the bottom
					else if (finalResult.coord.top > helper.geo.window.size.height - finalResult.size.height) {
						
						if (helper.geo.origin.windowOffset.top + this.__options.minIntersection <= helper.geo.window.size.height) {
							finalResult.coord.top = helper.geo.window.size.height - finalResult.size.height;
						}
						else {
							finalResult.coord.top = helper.geo.origin.windowOffset.top + this.__options.minIntersection + 1 - finalResult.size.height;
						}
					}
				}
			}
			else {
				
				// there might be overflow here too but it's easier to handle. If there has
				// to be an overflow, we'll make sure it's on the right side of the screen
				// (because the browser will extend the document size if there is an overflow
				// on the right, but not on the left). The sort function above has already
				// made sure that a bottom document overflow is preferred to a top overflow,
				// so we don't have to care about it.
				
				// if there is an overflow on the right
				if (finalResult.coord.left > helper.geo.window.size.width - finalResult.size.width) {
					
					// this may actually create on overflow on the left but we'll fix it in a sec
					finalResult.coord.left = helper.geo.window.size.width - finalResult.size.width;
				}
				
				// if there is an overflow on the left
				if (finalResult.coord.left < 0) {
					
					// don't care if it overflows the right after that, we made our best
					finalResult.coord.left = 0;
				}
			}
			
			
			// submit the positioning proposal to the user function which may choose to change
			// the side, size and/or the coordinates
			
			// first, set the rules that corresponds to the proposed side: it may change
			// the size of the tooltip, and the custom functionPosition may want to detect the
			// size of something before making a decision. So let's make things easier for the
			// implementor
			self.__sideChange($clone, finalResult.side);
			
			// add some variables to the helper
			helper.tooltipClone = $clone[0];
			helper.tooltipParent = self.__instance.option('parent').parent[0];
			// move informative values to the helper
			helper.mode = finalResult.mode;
			helper.whole = finalResult.whole;
			// add some variables to the helper for the functionPosition callback (these
			// will also be added to the event fired by self.__instance._trigger but that's
			// ok, we're just being consistent)
			helper.origin = self.__instance._$origin[0];
			helper.tooltip = self.__instance._$tooltip[0];
			
			// leave only the actionable values in there for functionPosition
			delete finalResult.container;
			delete finalResult.fits;
			delete finalResult.mode;
			delete finalResult.outerSize;
			delete finalResult.whole;
			
			// keep only the distance on the relevant side, for clarity
			finalResult.distance = finalResult.distance.horizontal || finalResult.distance.vertical;
			
			// beginners may not be comfortable with the concept of editing the object
			//  passed by reference, so we provide an edit function and pass a clone
			var finalResultClone = $.extend(true, {}, finalResult);
			
			// emit an event on the instance
			self.__instance._trigger({
				edit: function(result) {
					finalResult = result;
				},
				event: event,
				helper: helper,
				position: finalResultClone,
				type: 'position'
			});
			
			if (self.__options.functionPosition) {
				
				var result = self.__options.functionPosition.call(self, self.__instance, helper, finalResultClone);
				
				if (result) finalResult = result;
			}
			
			// end the positioning tests session (the user might have had a
			// use for it during the position event, now it's over)
			ruler.destroy();
			
			// compute the position of the target relatively to the tooltip root
			// element so we can place the arrow and make the needed adjustments
			var arrowCoord,
				maxVal;
			
			if (finalResult.side == 'top' || finalResult.side == 'bottom') {
				
				arrowCoord = {
					prop: 'left',
					val: finalResult.target - finalResult.coord.left
				};
				maxVal = finalResult.size.width - this.__options.minIntersection;
			}
			else {
				
				arrowCoord = {
					prop: 'top',
					val: finalResult.target - finalResult.coord.top
				};
				maxVal = finalResult.size.height - this.__options.minIntersection;
			}
			
			// cannot lie beyond the boundaries of the tooltip, minus the
			// arrow margin
			if (arrowCoord.val < this.__options.minIntersection) {
				arrowCoord.val = this.__options.minIntersection;
			}
			else if (arrowCoord.val > maxVal) {
				arrowCoord.val = maxVal;
			}
			
			var originParentOffset;
			
			// let's convert the window-relative coordinates into coordinates relative to the
			// future positioned parent that the tooltip will be appended to
			if (helper.geo.origin.fixedLineage) {
				
				// same as windowOffset when the position is fixed
				originParentOffset = helper.geo.origin.windowOffset;
			}
			else {
				
				// this assumes that the parent of the tooltip is located at
				// (0, 0) in the document, typically like when the parent is
				// <body>.
				// If we ever allow other types of parent, .tooltipster-ruler
				// will have to be appended to the parent to inherit css style
				// values that affect the display of the text and such.
				originParentOffset = {
					left: helper.geo.origin.windowOffset.left + helper.geo.window.scroll.left,
					top: helper.geo.origin.windowOffset.top + helper.geo.window.scroll.top
				};
			}
			
			finalResult.coord = {
				left: originParentOffset.left + (finalResult.coord.left - helper.geo.origin.windowOffset.left),
				top: originParentOffset.top + (finalResult.coord.top - helper.geo.origin.windowOffset.top)
			};
			
			// set position values on the original tooltip element
			
			self.__sideChange(self.__instance._$tooltip, finalResult.side);
			
			if (helper.geo.origin.fixedLineage) {
				self.__instance._$tooltip
					.css('position', 'fixed');
			}
			else {
				// CSS default
				self.__instance._$tooltip
					.css('position', '');
			}
			
			self.__instance._$tooltip
				.css({
					left: finalResult.coord.left,
					top: finalResult.coord.top,
					// we need to set a size even if the tooltip is in its natural size
					// because when the tooltip is positioned beyond the width of the body
					// (which is by default the width of the window; it will happen when
					// you scroll the window horizontally to get to the origin), its text
					// content will otherwise break lines at each word to keep up with the
					// body overflow strategy.
					height: finalResult.size.height,
					width: finalResult.size.width
				})
				.find('.tooltipster-arrow')
					.css({
						'left': '',
						'top': ''
					})
					.css(arrowCoord.prop, arrowCoord.val);
			
			// append the tooltip HTML element to its parent
			self.__instance._$tooltip.appendTo(self.__instance.option('parent'));
			
			self.__instance._trigger({
				type: 'repositioned',
				event: event,
				position: finalResult
			});
		},
		
		/**
		 * Make whatever modifications are needed when the side is changed. This has
		 * been made an independant method for easy inheritance in custom plugins based
		 * on this default plugin.
		 *
		 * @param {object} $obj
		 * @param {string} side
		 * @private
		 */
		__sideChange: function($obj, side) {
			
			$obj
				.removeClass('tooltipster-bottom')
				.removeClass('tooltipster-left')
				.removeClass('tooltipster-right')
				.removeClass('tooltipster-top')
				.addClass('tooltipster-'+ side);
		},
		
		/**
		 * Returns the target that the tooltip should aim at for a given side.
		 * The calculated value is a distance from the edge of the window
		 * (left edge for top/bottom sides, top edge for left/right side). The
		 * tooltip will be centered on that position and the arrow will be
		 * positioned there (as much as possible).
		 *
		 * @param {object} helper
		 * @return {integer}
		 * @private
		 */
		__targetFind: function(helper) {
			
			var target = {},
				rects = this.__instance._$origin[0].getClientRects();
			
			// these lines fix a Chrome bug (issue #491)
			if (rects.length > 1) {
				var opacity = this.__instance._$origin.css('opacity');
				if(opacity == 1) {
					this.__instance._$origin.css('opacity', 0.99);
					rects = this.__instance._$origin[0].getClientRects();
					this.__instance._$origin.css('opacity', 1);
				}
			}
			
			// by default, the target will be the middle of the origin
			if (rects.length < 2) {
				
				target.top = Math.floor(helper.geo.origin.windowOffset.left + (helper.geo.origin.size.width / 2));
				target.bottom = target.top;
				
				target.left = Math.floor(helper.geo.origin.windowOffset.top + (helper.geo.origin.size.height / 2));
				target.right = target.left;
			}
			// if multiple client rects exist, the element may be text split
			// up into multiple lines and the middle of the origin may not be
			// best option anymore. We need to choose the best target client rect
			else {
				
				// top: the first
				var targetRect = rects[0];
				target.top = Math.floor(targetRect.left + (targetRect.right - targetRect.left) / 2);
		
				// right: the middle line, rounded down in case there is an even
				// number of lines (looks more centered => check out the
				// demo with 4 split lines)
				if (rects.length > 2) {
					targetRect = rects[Math.ceil(rects.length / 2) - 1];
				}
				else {
					targetRect = rects[0];
				}
				target.right = Math.floor(targetRect.top + (targetRect.bottom - targetRect.top) / 2);
		
				// bottom: the last
				targetRect = rects[rects.length - 1];
				target.bottom = Math.floor(targetRect.left + (targetRect.right - targetRect.left) / 2);
		
				// left: the middle line, rounded up
				if (rects.length > 2) {
					targetRect = rects[Math.ceil((rects.length + 1) / 2) - 1];
				}
				else {
					targetRect = rects[rects.length - 1];
				}
				
				target.left = Math.floor(targetRect.top + (targetRect.bottom - targetRect.top) / 2);
			}
			
			return target;
		}
	}
});

/* a build task will add "return $;" here */
return $;

}));

},{"jquery":14}],21:[function(require,module,exports){
// xss-escape
// https://github.com/DubFriend/xss-escape

// https://www.owasp.org/index.php/XSS_(Cross_Site_Scripting)_Prevention_Cheat_Sheet

(function () {
    'use strict';

    var isString = function (data) {
        return typeof data === 'string';
    };

    var isArray = function (value) {
        return toString.call(value) === "[object Array]";
    };

    var isObject = function (value) {
        return !isArray(value) && value instanceof Object;
    };

    var isNumber = function (value) {
        return typeof value === 'number';
    };

    var isBoolean = function (value) {
        return typeof value === 'boolean';
    };

    var charForLoopStrategy = function (unescapedString) {
        var i, character, escapedString = '';

        for(i = 0; i < unescapedString.length; i += 1) {
            character = unescapedString.charAt(i);
            switch(character) {
                case '<':
                    escapedString += '&lt;';
                    break;
                case '>':
                    escapedString += '&gt;';
                    break;
                case '&':
                    escapedString += '&amp;';
                    break;
                case '/':
                    escapedString += '&#x2F;';
                    break;
                case '"':
                    escapedString += '&quot;';
                    break;
                case "'":
                    escapedString += '&#x27;';
                    break;
                default:
                    escapedString += character;
            }
        }

        return escapedString;
    };

    var regexStrategy = function (string) {
        return string
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, "&#x27;")
            .replace(/\//g, '&#x2F;');
    };

    var shiftToRegexStrategyThreshold = 32;

    var xssEscape = function (data, forceStrategy) {
        var escapedData, character, key, i, charArray = [], stringLength;

        if(isString(data)) {
            stringLength = data.length;
            if(forceStrategy === 'charForLoopStrategy') {
                escapedData = charForLoopStrategy(data);
            }
            else if(forceStrategy === 'regexStrategy') {
                escapedData = regexStrategy(data);
            }
            else if(stringLength > shiftToRegexStrategyThreshold) {
                escapedData = regexStrategy(data);
            }
            else {
                escapedData = charForLoopStrategy(data);
            }
        }
        else if(isNumber(data) || isBoolean(data)) {
            escapedData = data;
        }
        else if(isArray(data)) {
            escapedData = [];
            for(i = 0; i < data.length; i += 1) {
                escapedData.push(xssEscape(data[i]));
            }
        }
        else if(isObject(data)) {
            escapedData = {};
            for(key in data) {
                if(data.hasOwnProperty(key)) {
                    escapedData[key] = xssEscape(data[key]);
                }
            }
        }

        return escapedData;
    };

    // use in browser or nodejs
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = xssEscape;
        }
        exports.xssEscape = xssEscape;
    } else {
        this.xssEscape = xssEscape;
    }

}).call(this);
},{}],22:[function(require,module,exports){
// Mediator module (handles event delegation)
var mediator = require('./modules/mediator/mediator');

//External libs
jQuery = require('jquery/dist/jquery');

//External libs
require('bootstrap/dist/js/bootstrap');
require('bootstrap-select/dist/js/bootstrap-select');
require('moment/min/moment-with-locales');
require('daterangepicker');
require('./admin.libOverrides');
require('datetimepicker');
require('jquery.mousewheel');
require('select2');
require('jquery.length-limit');

// Module packages
require('./modules/adminStats/');
require('./modules/ajaxpageload/');
require('./modules/customer/');
require('./modules/collapsibleSection/');
require('./modules/discountHours/');
require('./modules/menu/');
require('./modules/navigation/');
require('./modules/notification/');
require('./modules/notificationTarget/');
require('./modules/feedback/');
require('./modules/form/');
require('./modules/guide/');
require('./modules/pagination/');
require('./modules/reservable/');
require('./modules/reservation/');
require('./modules/reservationHours/');
require('./modules/tablePlan/');
require('./modules/settings/');
require('./modules/noShow/');
require('./modules/stats/');
require('./modules/tableSetup/');
require('./modules/tablePlan/');
require('./modules/user/');
require('./modules/wizard/');
require('./modules/limits');
require('./modules/common');
require('./modules/banner');

// Datepicker locales
require('bootstrap.datepicker.cs');
require('bootstrap.datepicker.de');
require('bootstrap.datepicker.es');
require('bootstrap.datepicker.fr');
require('bootstrap.datepicker.hr');
require('bootstrap.datepicker.hu');
require('bootstrap.datepicker.it');
require('bootstrap.datepicker.nl');
require('bootstrap.datepicker.nl-BE');
require('bootstrap.datepicker.pl');
require('bootstrap.datepicker.pt');
require('bootstrap.datepicker.ro');
require('bootstrap.datepicker.ru');
require('bootstrap.datepicker.tr');
require('bootstrap.datepicker.uk');
require('bootstrap.datepicker.sk');

// Wait for DOM being ready
jQuery(document).ready(function() {

	// Add JS status classes to HTML
	jQuery("html").removeClass("no-js");
	jQuery("html").addClass("js");
	jQuery("html").addClass("domReady");

	// Enable tooltips
	jQuery('[data-toggle="tooltip"]').tooltip();

	// Highlight language codes in debug mode
	jQuery('.langHelper').on('click', function() {
		alert(jQuery(this).attr('title'));
	});

	// Trigger application start (for complete DOM)
	mediator.publish("app:started", jQuery("html"));

});

// application details
window._checkAppVersion = function() {
  var ApplicationDetails = require('./applicationDetails/');
  (new ApplicationDetails()).displayInConsole();
};

},{"./admin.libOverrides":23,"./applicationDetails/":24,"./modules/adminStats/":57,"./modules/ajaxpageload/":59,"./modules/banner":61,"./modules/collapsibleSection/":66,"./modules/common":67,"./modules/customer/":71,"./modules/discountHours/":79,"./modules/feedback/":83,"./modules/form/":93,"./modules/guide/":95,"./modules/limits":102,"./modules/mediator/mediator":103,"./modules/menu/":109,"./modules/navigation/":115,"./modules/noShow/":124,"./modules/notification/":126,"./modules/notificationTarget/":130,"./modules/pagination/":132,"./modules/reservable/":134,"./modules/reservation/":140,"./modules/reservationHours/":149,"./modules/settings/":154,"./modules/stats/":163,"./modules/tablePlan/":169,"./modules/tableSetup/":176,"./modules/user/":182,"./modules/wizard/":196,"bootstrap-select/dist/js/bootstrap-select":3,"bootstrap.datepicker.cs":28,"bootstrap.datepicker.de":29,"bootstrap.datepicker.es":30,"bootstrap.datepicker.fr":31,"bootstrap.datepicker.hr":32,"bootstrap.datepicker.hu":33,"bootstrap.datepicker.it":34,"bootstrap.datepicker.nl":36,"bootstrap.datepicker.nl-BE":35,"bootstrap.datepicker.pl":37,"bootstrap.datepicker.pt":38,"bootstrap.datepicker.ro":39,"bootstrap.datepicker.ru":40,"bootstrap.datepicker.sk":41,"bootstrap.datepicker.tr":42,"bootstrap.datepicker.uk":43,"bootstrap/dist/js/bootstrap":4,"daterangepicker":44,"datetimepicker":27,"jquery.length-limit":47,"jquery.mousewheel":48,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15,"select2":50}],23:[function(require,module,exports){
jQuery = require('jquery/dist/jquery');
var moment = require('moment/min/moment-with-locales');

var DEFAULTS = window.config.DEFAULTS;

// selectpicjer
jQuery.fn.selectpicker.Constructor.DEFAULTS.container = 'body';
jQuery.fn.selectpicker.Constructor.DEFAULTS.iconBase = 'fas';
jQuery.fn.selectpicker.Constructor.DEFAULTS.tickIcon = 'fa-check';
jQuery.fn.selectpicker.Constructor.DEFAULTS.noneSelectedText = DEFAULTS.boostrapSelect.noneSelectedText;
jQuery.fn.selectpicker.Constructor.DEFAULTS.noneResultsText = DEFAULTS.boostrapSelect.noneResultsText;

// moment
moment.defaultFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
moment.locale(DEFAULTS.moment.locale);
},{"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],24:[function(require,module,exports){
/**
 * ApplicationDetails functionality.
 *
 */

// use function to avoid minification extracting out the values
var getName = function() { return '@@@__APPLICATION_NAME__'; }
var getVersion = function() { return '@@@__APPLICATION_VERSION__'; }
var getBuildTime = function() { return '@@@__BUILD_TIME__'; }

// Class definition
ApplicationDetails = function() {

  var self = this;

  this.get = function() {
    return {
      name: getName(),
      version: getVersion(),
      buildTime: getBuildTime()
    }
  };

  this.displayInConsole = function() {
    var details = self.get();
    var text = '%c ' + details.name + ' | ' + details.version + ' %c ' + details.buildTime + ' ';
    console.log(text, 'background: #c03; color: #fff', 'background: #000; color: #fff');
  };

};

// Make class public to outside world
module.exports = ApplicationDetails;
},{}],25:[function(require,module,exports){
/*!
 * typeahead.js 0.11.1
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
 */

(function(root, factory) {
    if (typeof define === "function" && define.amd) {
        define("bloodhound", [ "jquery" ], function(a0) {
            return root["Bloodhound"] = factory(a0);
        });
    } else if (typeof exports === "object") {
        module.exports = factory(require("jquery"));
    } else {
        root["Bloodhound"] = factory(jQuery);
    }
})(this, function($) {
    var _ = function() {
        "use strict";
        return {
            isMsie: function() {
                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
            },
            isBlankString: function(str) {
                return !str || /^\s*$/.test(str);
            },
            escapeRegExChars: function(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            },
            isString: function(obj) {
                return typeof obj === "string";
            },
            isNumber: function(obj) {
                return typeof obj === "number";
            },
            isArray: $.isArray,
            isFunction: $.isFunction,
            isObject: $.isPlainObject,
            isUndefined: function(obj) {
                return typeof obj === "undefined";
            },
            isElement: function(obj) {
                return !!(obj && obj.nodeType === 1);
            },
            isJQuery: function(obj) {
                return obj instanceof $;
            },
            toStr: function toStr(s) {
                return _.isUndefined(s) || s === null ? "" : s + "";
            },
            bind: $.proxy,
            each: function(collection, cb) {
                $.each(collection, reverseArgs);
                function reverseArgs(index, value) {
                    return cb(value, index);
                }
            },
            map: $.map,
            filter: $.grep,
            every: function(obj, test) {
                var result = true;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (!(result = test.call(null, val, key, obj))) {
                        return false;
                    }
                });
                return !!result;
            },
            some: function(obj, test) {
                var result = false;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (result = test.call(null, val, key, obj)) {
                        return false;
                    }
                });
                return !!result;
            },
            mixin: $.extend,
            identity: function(x) {
                return x;
            },
            clone: function(obj) {
                return $.extend(true, {}, obj);
            },
            getIdGenerator: function() {
                var counter = 0;
                return function() {
                    return counter++;
                };
            },
            templatify: function templatify(obj) {
                return $.isFunction(obj) ? obj : template;
                function template() {
                    return String(obj);
                }
            },
            defer: function(fn) {
                setTimeout(fn, 0);
            },
            debounce: function(func, wait, immediate) {
                var timeout, result;
                return function() {
                    var context = this, args = arguments, later, callNow;
                    later = function() {
                        timeout = null;
                        if (!immediate) {
                            result = func.apply(context, args);
                        }
                    };
                    callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) {
                        result = func.apply(context, args);
                    }
                    return result;
                };
            },
            throttle: function(func, wait) {
                var context, args, timeout, result, previous, later;
                previous = 0;
                later = function() {
                    previous = new Date();
                    timeout = null;
                    result = func.apply(context, args);
                };
                return function() {
                    var now = new Date(), remaining = wait - (now - previous);
                    context = this;
                    args = arguments;
                    if (remaining <= 0) {
                        clearTimeout(timeout);
                        timeout = null;
                        previous = now;
                        result = func.apply(context, args);
                    } else if (!timeout) {
                        timeout = setTimeout(later, remaining);
                    }
                    return result;
                };
            },
            stringify: function(val) {
                return _.isString(val) ? val : JSON.stringify(val);
            },
            noop: function() {}
        };
    }();
    var VERSION = "0.11.1";
    var tokenizers = function() {
        "use strict";
        return {
            nonword: nonword,
            whitespace: whitespace,
            obj: {
                nonword: getObjTokenizer(nonword),
                whitespace: getObjTokenizer(whitespace)
            }
        };
        function whitespace(str) {
            str = _.toStr(str);
            return str ? str.split(/\s+/) : [];
        }
        function nonword(str) {
            str = _.toStr(str);
            return str ? str.split(/\W+/) : [];
        }
        function getObjTokenizer(tokenizer) {
            return function setKey(keys) {
                keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
                return function tokenize(o) {
                    var tokens = [];
                    _.each(keys, function(k) {
                        tokens = tokens.concat(tokenizer(_.toStr(o[k])));
                    });
                    return tokens;
                };
            };
        }
    }();
    var LruCache = function() {
        "use strict";
        function LruCache(maxSize) {
            this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
            this.reset();
            if (this.maxSize <= 0) {
                this.set = this.get = $.noop;
            }
        }
        _.mixin(LruCache.prototype, {
            set: function set(key, val) {
                var tailItem = this.list.tail, node;
                if (this.size >= this.maxSize) {
                    this.list.remove(tailItem);
                    delete this.hash[tailItem.key];
                    this.size--;
                }
                if (node = this.hash[key]) {
                    node.val = val;
                    this.list.moveToFront(node);
                } else {
                    node = new Node(key, val);
                    this.list.add(node);
                    this.hash[key] = node;
                    this.size++;
                }
            },
            get: function get(key) {
                var node = this.hash[key];
                if (node) {
                    this.list.moveToFront(node);
                    return node.val;
                }
            },
            reset: function reset() {
                this.size = 0;
                this.hash = {};
                this.list = new List();
            }
        });
        function List() {
            this.head = this.tail = null;
        }
        _.mixin(List.prototype, {
            add: function add(node) {
                if (this.head) {
                    node.next = this.head;
                    this.head.prev = node;
                }
                this.head = node;
                this.tail = this.tail || node;
            },
            remove: function remove(node) {
                node.prev ? node.prev.next = node.next : this.head = node.next;
                node.next ? node.next.prev = node.prev : this.tail = node.prev;
            },
            moveToFront: function(node) {
                this.remove(node);
                this.add(node);
            }
        });
        function Node(key, val) {
            this.key = key;
            this.val = val;
            this.prev = this.next = null;
        }
        return LruCache;
    }();
    var PersistentStorage = function() {
        "use strict";
        var LOCAL_STORAGE;
        try {
            LOCAL_STORAGE = window.localStorage;
            LOCAL_STORAGE.setItem("~~~", "!");
            LOCAL_STORAGE.removeItem("~~~");
        } catch (err) {
            LOCAL_STORAGE = null;
        }
        function PersistentStorage(namespace, override) {
            this.prefix = [ "__", namespace, "__" ].join("");
            this.ttlKey = "__ttl__";
            this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
            this.ls = override || LOCAL_STORAGE;
            !this.ls && this._noop();
        }
        _.mixin(PersistentStorage.prototype, {
            _prefix: function(key) {
                return this.prefix + key;
            },
            _ttlKey: function(key) {
                return this._prefix(key) + this.ttlKey;
            },
            _noop: function() {
                this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
            },
            _safeSet: function(key, val) {
                try {
                    this.ls.setItem(key, val);
                } catch (err) {
                    if (err.name === "QuotaExceededError") {
                        this.clear();
                        this._noop();
                    }
                }
            },
            get: function(key) {
                if (this.isExpired(key)) {
                    this.remove(key);
                }
                return decode(this.ls.getItem(this._prefix(key)));
            },
            set: function(key, val, ttl) {
                if (_.isNumber(ttl)) {
                    this._safeSet(this._ttlKey(key), encode(now() + ttl));
                } else {
                    this.ls.removeItem(this._ttlKey(key));
                }
                return this._safeSet(this._prefix(key), encode(val));
            },
            remove: function(key) {
                this.ls.removeItem(this._ttlKey(key));
                this.ls.removeItem(this._prefix(key));
                return this;
            },
            clear: function() {
                var i, keys = gatherMatchingKeys(this.keyMatcher);
                for (i = keys.length; i--; ) {
                    this.remove(keys[i]);
                }
                return this;
            },
            isExpired: function(key) {
                var ttl = decode(this.ls.getItem(this._ttlKey(key)));
                return _.isNumber(ttl) && now() > ttl ? true : false;
            }
        });
        return PersistentStorage;
        function now() {
            return new Date().getTime();
        }
        function encode(val) {
            return JSON.stringify(_.isUndefined(val) ? null : val);
        }
        function decode(val) {
            return $.parseJSON(val);
        }
        function gatherMatchingKeys(keyMatcher) {
            var i, key, keys = [], len = LOCAL_STORAGE.length;
            for (i = 0; i < len; i++) {
                if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
                    keys.push(key.replace(keyMatcher, ""));
                }
            }
            return keys;
        }
    }();
    var Transport = function() {
        "use strict";
        var pendingRequestsCount = 0, pendingRequests = {}, maxPendingRequests = 6, sharedCache = new LruCache(10);
        function Transport(o) {
            o = o || {};
            this.cancelled = false;
            this.lastReq = null;
            this._send = o.transport;
            this._get = o.limiter ? o.limiter(this._get) : this._get;
            this._cache = o.cache === false ? new LruCache(0) : sharedCache;
        }
        Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
            maxPendingRequests = num;
        };
        Transport.resetCache = function resetCache() {
            sharedCache.reset();
        };
        _.mixin(Transport.prototype, {
            _fingerprint: function fingerprint(o) {
                o = o || {};
                return o.url + o.type + $.param(o.data || {});
            },
            _get: function(o, cb) {
                var that = this, fingerprint, jqXhr;
                fingerprint = this._fingerprint(o);
                if (this.cancelled || fingerprint !== this.lastReq) {
                    return;
                }
                if (jqXhr = pendingRequests[fingerprint]) {
                    jqXhr.done(done).fail(fail);
                } else if (pendingRequestsCount < maxPendingRequests) {
                    pendingRequestsCount++;
                    pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
                } else {
                    this.onDeckRequestArgs = [].slice.call(arguments, 0);
                }
                function done(resp) {
                    cb(null, resp);
                    that._cache.set(fingerprint, resp);
                }
                function fail() {
                    cb(true);
                }
                function always() {
                    pendingRequestsCount--;
                    delete pendingRequests[fingerprint];
                    if (that.onDeckRequestArgs) {
                        that._get.apply(that, that.onDeckRequestArgs);
                        that.onDeckRequestArgs = null;
                    }
                }
            },
            get: function(o, cb) {
                var resp, fingerprint;
                cb = cb || $.noop;
                o = _.isString(o) ? {
                    url: o
                } : o || {};
                fingerprint = this._fingerprint(o);
                this.cancelled = false;
                this.lastReq = fingerprint;
                if (resp = this._cache.get(fingerprint)) {
                    cb(null, resp);
                } else {
                    this._get(o, cb);
                }
            },
            cancel: function() {
                this.cancelled = true;
            }
        });
        return Transport;
    }();
    var SearchIndex = window.SearchIndex = function() {
        "use strict";
        var CHILDREN = "c", IDS = "i";
        function SearchIndex(o) {
            o = o || {};
            if (!o.datumTokenizer || !o.queryTokenizer) {
                $.error("datumTokenizer and queryTokenizer are both required");
            }
            this.identify = o.identify || _.stringify;
            this.datumTokenizer = o.datumTokenizer;
            this.queryTokenizer = o.queryTokenizer;
            this.reset();
        }
        _.mixin(SearchIndex.prototype, {
            bootstrap: function bootstrap(o) {
                this.datums = o.datums;
                this.trie = o.trie;
            },
            add: function(data) {
                var that = this;
                data = _.isArray(data) ? data : [ data ];
                _.each(data, function(datum) {
                    var id, tokens;
                    that.datums[id = that.identify(datum)] = datum;
                    tokens = normalizeTokens(that.datumTokenizer(datum));
                    _.each(tokens, function(token) {
                        var node, chars, ch;
                        node = that.trie;
                        chars = token.split("");
                        while (ch = chars.shift()) {
                            node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
                            node[IDS].push(id);
                        }
                    });
                });
            },
            get: function get(ids) {
                var that = this;
                return _.map(ids, function(id) {
                    return that.datums[id];
                });
            },
            search: function search(query) {
                var that = this, tokens, matches;
                tokens = normalizeTokens(this.queryTokenizer(query));
                _.each(tokens, function(token) {
                    var node, chars, ch, ids;
                    if (matches && matches.length === 0) {
                        return false;
                    }
                    node = that.trie;
                    chars = token.split("");
                    while (node && (ch = chars.shift())) {
                        node = node[CHILDREN][ch];
                    }
                    if (node && chars.length === 0) {
                        ids = node[IDS].slice(0);
                        matches = matches ? getIntersection(matches, ids) : ids;
                    } else {
                        matches = [];
                        return false;
                    }
                });
                return matches ? _.map(unique(matches), function(id) {
                    return that.datums[id];
                }) : [];
            },
            all: function all() {
                var values = [];
                for (var key in this.datums) {
                    values.push(this.datums[key]);
                }
                return values;
            },
            reset: function reset() {
                this.datums = {};
                this.trie = newNode();
            },
            serialize: function serialize() {
                return {
                    datums: this.datums,
                    trie: this.trie
                };
            }
        });
        return SearchIndex;
        function normalizeTokens(tokens) {
            tokens = _.filter(tokens, function(token) {
                return !!token;
            });
            tokens = _.map(tokens, function(token) {
                return token.toLowerCase();
            });
            return tokens;
        }
        function newNode() {
            var node = {};
            node[IDS] = [];
            node[CHILDREN] = {};
            return node;
        }
        function unique(array) {
            var seen = {}, uniques = [];
            for (var i = 0, len = array.length; i < len; i++) {
                if (!seen[array[i]]) {
                    seen[array[i]] = true;
                    uniques.push(array[i]);
                }
            }
            return uniques;
        }
        function getIntersection(arrayA, arrayB) {
            var ai = 0, bi = 0, intersection = [];
            arrayA = arrayA.sort();
            arrayB = arrayB.sort();
            var lenArrayA = arrayA.length, lenArrayB = arrayB.length;
            while (ai < lenArrayA && bi < lenArrayB) {
                if (arrayA[ai] < arrayB[bi]) {
                    ai++;
                } else if (arrayA[ai] > arrayB[bi]) {
                    bi++;
                } else {
                    intersection.push(arrayA[ai]);
                    ai++;
                    bi++;
                }
            }
            return intersection;
        }
    }();
    var Prefetch = function() {
        "use strict";
        var keys;
        keys = {
            data: "data",
            protocol: "protocol",
            thumbprint: "thumbprint"
        };
        function Prefetch(o) {
            this.url = o.url;
            this.ttl = o.ttl;
            this.cache = o.cache;
            this.prepare = o.prepare;
            this.transform = o.transform;
            this.transport = o.transport;
            this.thumbprint = o.thumbprint;
            this.storage = new PersistentStorage(o.cacheKey);
        }
        _.mixin(Prefetch.prototype, {
            _settings: function settings() {
                return {
                    url: this.url,
                    type: "GET",
                    dataType: "json"
                };
            },
            store: function store(data) {
                if (!this.cache) {
                    return;
                }
                this.storage.set(keys.data, data, this.ttl);
                this.storage.set(keys.protocol, location.protocol, this.ttl);
                this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
            },
            fromCache: function fromCache() {
                var stored = {}, isExpired;
                if (!this.cache) {
                    return null;
                }
                stored.data = this.storage.get(keys.data);
                stored.protocol = this.storage.get(keys.protocol);
                stored.thumbprint = this.storage.get(keys.thumbprint);
                isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
                return stored.data && !isExpired ? stored.data : null;
            },
            fromNetwork: function(cb) {
                var that = this, settings;
                if (!cb) {
                    return;
                }
                settings = this.prepare(this._settings());
                this.transport(settings).fail(onError).done(onResponse);
                function onError() {
                    cb(true);
                }
                function onResponse(resp) {
                    cb(null, that.transform(resp));
                }
            },
            clear: function clear() {
                this.storage.clear();
                return this;
            }
        });
        return Prefetch;
    }();
    var Remote = function() {
        "use strict";
        function Remote(o) {
            this.url = o.url;
            this.prepare = o.prepare;
            this.transform = o.transform;
            this.transport = new Transport({
                cache: o.cache,
                limiter: o.limiter,
                transport: o.transport
            });
        }
        _.mixin(Remote.prototype, {
            _settings: function settings() {
                return {
                    url: this.url,
                    type: "GET",
                    dataType: "json"
                };
            },
            get: function get(query, cb) {
                var that = this, settings;
                if (!cb) {
                    return;
                }
                query = query || "";
                settings = this.prepare(query, this._settings());
                return this.transport.get(settings, onResponse);
                function onResponse(err, resp) {
                    err ? cb([]) : cb(that.transform(resp));
                }
            },
            cancelLastRequest: function cancelLastRequest() {
                this.transport.cancel();
            }
        });
        return Remote;
    }();
    var oParser = function() {
        "use strict";
        return function parse(o) {
            var defaults, sorter;
            defaults = {
                initialize: true,
                identify: _.stringify,
                datumTokenizer: null,
                queryTokenizer: null,
                sufficient: 5,
                sorter: null,
                local: [],
                prefetch: null,
                remote: null
            };
            o = _.mixin(defaults, o || {});
            !o.datumTokenizer && $.error("datumTokenizer is required");
            !o.queryTokenizer && $.error("queryTokenizer is required");
            sorter = o.sorter;
            o.sorter = sorter ? function(x) {
                return x.sort(sorter);
            } : _.identity;
            o.local = _.isFunction(o.local) ? o.local() : o.local;
            o.prefetch = parsePrefetch(o.prefetch);
            o.remote = parseRemote(o.remote);
            return o;
        };
        function parsePrefetch(o) {
            var defaults;
            if (!o) {
                return null;
            }
            defaults = {
                url: null,
                ttl: 24 * 60 * 60 * 1e3,
                cache: true,
                cacheKey: null,
                thumbprint: "",
                prepare: _.identity,
                transform: _.identity,
                transport: null
            };
            o = _.isString(o) ? {
                url: o
            } : o;
            o = _.mixin(defaults, o);
            !o.url && $.error("prefetch requires url to be set");
            o.transform = o.filter || o.transform;
            o.cacheKey = o.cacheKey || o.url;
            o.thumbprint = VERSION + o.thumbprint;
            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
            return o;
        }
        function parseRemote(o) {
            var defaults;
            if (!o) {
                return;
            }
            defaults = {
                url: null,
                cache: true,
                prepare: null,
                replace: null,
                wildcard: null,
                limiter: null,
                rateLimitBy: "debounce",
                rateLimitWait: 300,
                transform: _.identity,
                transport: null
            };
            o = _.isString(o) ? {
                url: o
            } : o;
            o = _.mixin(defaults, o);
            !o.url && $.error("remote requires url to be set");
            o.transform = o.filter || o.transform;
            o.prepare = toRemotePrepare(o);
            o.limiter = toLimiter(o);
            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
            delete o.replace;
            delete o.wildcard;
            delete o.rateLimitBy;
            delete o.rateLimitWait;
            return o;
        }
        function toRemotePrepare(o) {
            var prepare, replace, wildcard;
            prepare = o.prepare;
            replace = o.replace;
            wildcard = o.wildcard;
            if (prepare) {
                return prepare;
            }
            if (replace) {
                prepare = prepareByReplace;
            } else if (o.wildcard) {
                prepare = prepareByWildcard;
            } else {
                prepare = idenityPrepare;
            }
            return prepare;
            function prepareByReplace(query, settings) {
                settings.url = replace(settings.url, query);
                return settings;
            }
            function prepareByWildcard(query, settings) {
                settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
                return settings;
            }
            function idenityPrepare(query, settings) {
                return settings;
            }
        }
        function toLimiter(o) {
            var limiter, method, wait;
            limiter = o.limiter;
            method = o.rateLimitBy;
            wait = o.rateLimitWait;
            if (!limiter) {
                limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
            }
            return limiter;
            function debounce(wait) {
                return function debounce(fn) {
                    return _.debounce(fn, wait);
                };
            }
            function throttle(wait) {
                return function throttle(fn) {
                    return _.throttle(fn, wait);
                };
            }
        }
        function callbackToDeferred(fn) {
            return function wrapper(o) {
                var deferred = $.Deferred();
                fn(o, onSuccess, onError);
                return deferred;
                function onSuccess(resp) {
                    _.defer(function() {
                        deferred.resolve(resp);
                    });
                }
                function onError(err) {
                    _.defer(function() {
                        deferred.reject(err);
                    });
                }
            };
        }
    }();
    var Bloodhound = function() {
        "use strict";
        var old;
        old = window && window.Bloodhound;
        function Bloodhound(o) {
            o = oParser(o);
            this.sorter = o.sorter;
            this.identify = o.identify;
            this.sufficient = o.sufficient;
            this.local = o.local;
            this.remote = o.remote ? new Remote(o.remote) : null;
            this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
            this.index = new SearchIndex({
                identify: this.identify,
                datumTokenizer: o.datumTokenizer,
                queryTokenizer: o.queryTokenizer
            });
            o.initialize !== false && this.initialize();
        }
        Bloodhound.noConflict = function noConflict() {
            window && (window.Bloodhound = old);
            return Bloodhound;
        };
        Bloodhound.tokenizers = tokenizers;
        _.mixin(Bloodhound.prototype, {
            __ttAdapter: function ttAdapter() {
                var that = this;
                return this.remote ? withAsync : withoutAsync;
                function withAsync(query, sync, async) {
                    return that.search(query, sync, async);
                }
                function withoutAsync(query, sync) {
                    return that.search(query, sync);
                }
            },
            _loadPrefetch: function loadPrefetch() {
                var that = this, deferred, serialized;
                deferred = $.Deferred();
                if (!this.prefetch) {
                    deferred.resolve();
                } else if (serialized = this.prefetch.fromCache()) {
                    this.index.bootstrap(serialized);
                    deferred.resolve();
                } else {
                    this.prefetch.fromNetwork(done);
                }
                return deferred.promise();
                function done(err, data) {
                    if (err) {
                        return deferred.reject();
                    }
                    that.add(data);
                    that.prefetch.store(that.index.serialize());
                    deferred.resolve();
                }
            },
            _initialize: function initialize() {
                var that = this, deferred;
                this.clear();
                (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
                return this.initPromise;
                function addLocalToIndex() {
                    that.add(that.local);
                }
            },
            initialize: function initialize(force) {
                return !this.initPromise || force ? this._initialize() : this.initPromise;
            },
            add: function add(data) {
                this.index.add(data);
                return this;
            },
            get: function get(ids) {
                ids = _.isArray(ids) ? ids : [].slice.call(arguments);
                return this.index.get(ids);
            },
            search: function search(query, sync, async) {
                var that = this, local;
                local = this.sorter(this.index.search(query));
                sync(this.remote ? local.slice() : local);
                if (this.remote && local.length < this.sufficient) {
                    this.remote.get(query, processRemote);
                } else if (this.remote) {
                    this.remote.cancelLastRequest();
                }
                return this;
                function processRemote(remote) {
                    var nonDuplicates = [];
                    _.each(remote, function(r) {
                        !_.some(local, function(l) {
                            return that.identify(r) === that.identify(l);
                        }) && nonDuplicates.push(r);
                    });
                    async && async(nonDuplicates);
                }
            },
            all: function all() {
                return this.index.all();
            },
            clear: function clear() {
                this.index.reset();
                return this;
            },
            clearPrefetchCache: function clearPrefetchCache() {
                this.prefetch && this.prefetch.clear();
                return this;
            },
            clearRemoteCache: function clearRemoteCache() {
                Transport.resetCache();
                return this;
            },
            ttAdapter: function ttAdapter() {
                return this.__ttAdapter();
            }
        });
        return Bloodhound;
    }();
    return Bloodhound;
});
},{"jquery":14}],26:[function(require,module,exports){
/*!
 * Datepicker for Bootstrap v1.7.0 (https://github.com/uxsolutions/bootstrap-datepicker)
 *
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */

!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):jQuery)}(function(a,b){function c(){return new Date(Date.UTC.apply(Date,arguments))}function d(){var a=new Date;return c(a.getFullYear(),a.getMonth(),a.getDate())}function e(a,b){return a.getUTCFullYear()===b.getUTCFullYear()&&a.getUTCMonth()===b.getUTCMonth()&&a.getUTCDate()===b.getUTCDate()}function f(c,d){return function(){return d!==b&&a.fn.datepicker.deprecated(d),this[c].apply(this,arguments)}}function g(a){return a&&!isNaN(a.getTime())}function h(b,c){function d(a,b){return b.toLowerCase()}var e,f=a(b).data(),g={},h=new RegExp("^"+c.toLowerCase()+"([A-Z])");c=new RegExp("^"+c.toLowerCase());for(var i in f)c.test(i)&&(e=i.replace(h,d),g[e]=f[i]);return g}function i(b){var c={};if(q[b]||(b=b.split("-")[0],q[b])){var d=q[b];return a.each(p,function(a,b){b in d&&(c[b]=d[b])}),c}}var j=function(){var b={get:function(a){return this.slice(a)[0]},contains:function(a){for(var b=a&&a.valueOf(),c=0,d=this.length;c<d;c++)if(0<=this[c].valueOf()-b&&this[c].valueOf()-b<864e5)return c;return-1},remove:function(a){this.splice(a,1)},replace:function(b){b&&(a.isArray(b)||(b=[b]),this.clear(),this.push.apply(this,b))},clear:function(){this.length=0},copy:function(){var a=new j;return a.replace(this),a}};return function(){var c=[];return c.push.apply(c,arguments),a.extend(c,b),c}}(),k=function(b,c){a.data(b,"datepicker",this),this._process_options(c),this.dates=new j,this.viewDate=this.o.defaultViewDate,this.focusDate=null,this.element=a(b),this.isInput=this.element.is("input"),this.inputField=this.isInput?this.element:this.element.find("input"),this.component=!!this.element.hasClass("date")&&this.element.find(".add-on, .input-group-addon, .btn"),this.component&&0===this.component.length&&(this.component=!1),this.isInline=!this.component&&this.element.is("div"),this.picker=a(r.template),this._check_template(this.o.templates.leftArrow)&&this.picker.find(".prev").html(this.o.templates.leftArrow),this._check_template(this.o.templates.rightArrow)&&this.picker.find(".next").html(this.o.templates.rightArrow),this._buildEvents(),this._attachEvents(),this.isInline?this.picker.addClass("datepicker-inline").appendTo(this.element):this.picker.addClass("datepicker-dropdown dropdown-menu"),this.o.rtl&&this.picker.addClass("datepicker-rtl"),this.o.calendarWeeks&&this.picker.find(".datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan",function(a,b){return Number(b)+1}),this._process_options({startDate:this._o.startDate,endDate:this._o.endDate,daysOfWeekDisabled:this.o.daysOfWeekDisabled,daysOfWeekHighlighted:this.o.daysOfWeekHighlighted,datesDisabled:this.o.datesDisabled}),this._allow_update=!1,this.setViewMode(this.o.startView),this._allow_update=!0,this.fillDow(),this.fillMonths(),this.update(),this.isInline&&this.show()};k.prototype={constructor:k,_resolveViewName:function(b){return a.each(r.viewModes,function(c,d){if(b===c||a.inArray(b,d.names)!==-1)return b=c,!1}),b},_resolveDaysOfWeek:function(b){return a.isArray(b)||(b=b.split(/[,\s]*/)),a.map(b,Number)},_check_template:function(c){try{if(c===b||""===c)return!1;if((c.match(/[<>]/g)||[]).length<=0)return!0;var d=a(c);return d.length>0}catch(a){return!1}},_process_options:function(b){this._o=a.extend({},this._o,b);var e=this.o=a.extend({},this._o),f=e.language;q[f]||(f=f.split("-")[0],q[f]||(f=o.language)),e.language=f,e.startView=this._resolveViewName(e.startView),e.minViewMode=this._resolveViewName(e.minViewMode),e.maxViewMode=this._resolveViewName(e.maxViewMode),e.startView=Math.max(this.o.minViewMode,Math.min(this.o.maxViewMode,e.startView)),e.multidate!==!0&&(e.multidate=Number(e.multidate)||!1,e.multidate!==!1&&(e.multidate=Math.max(0,e.multidate))),e.multidateSeparator=String(e.multidateSeparator),e.weekStart%=7,e.weekEnd=(e.weekStart+6)%7;var g=r.parseFormat(e.format);e.startDate!==-(1/0)&&(e.startDate?e.startDate instanceof Date?e.startDate=this._local_to_utc(this._zero_time(e.startDate)):e.startDate=r.parseDate(e.startDate,g,e.language,e.assumeNearbyYear):e.startDate=-(1/0)),e.endDate!==1/0&&(e.endDate?e.endDate instanceof Date?e.endDate=this._local_to_utc(this._zero_time(e.endDate)):e.endDate=r.parseDate(e.endDate,g,e.language,e.assumeNearbyYear):e.endDate=1/0),e.daysOfWeekDisabled=this._resolveDaysOfWeek(e.daysOfWeekDisabled||[]),e.daysOfWeekHighlighted=this._resolveDaysOfWeek(e.daysOfWeekHighlighted||[]),e.datesDisabled=e.datesDisabled||[],a.isArray(e.datesDisabled)||(e.datesDisabled=e.datesDisabled.split(",")),e.datesDisabled=a.map(e.datesDisabled,function(a){return r.parseDate(a,g,e.language,e.assumeNearbyYear)});var h=String(e.orientation).toLowerCase().split(/\s+/g),i=e.orientation.toLowerCase();if(h=a.grep(h,function(a){return/^auto|left|right|top|bottom$/.test(a)}),e.orientation={x:"auto",y:"auto"},i&&"auto"!==i)if(1===h.length)switch(h[0]){case"top":case"bottom":e.orientation.y=h[0];break;case"left":case"right":e.orientation.x=h[0]}else i=a.grep(h,function(a){return/^left|right$/.test(a)}),e.orientation.x=i[0]||"auto",i=a.grep(h,function(a){return/^top|bottom$/.test(a)}),e.orientation.y=i[0]||"auto";else;if(e.defaultViewDate instanceof Date||"string"==typeof e.defaultViewDate)e.defaultViewDate=r.parseDate(e.defaultViewDate,g,e.language,e.assumeNearbyYear);else if(e.defaultViewDate){var j=e.defaultViewDate.year||(new Date).getFullYear(),k=e.defaultViewDate.month||0,l=e.defaultViewDate.day||1;e.defaultViewDate=c(j,k,l)}else e.defaultViewDate=d()},_events:[],_secondaryEvents:[],_applyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(d=b,e=a[f][1]):3===a[f].length&&(d=a[f][1],e=a[f][2]),c.on(e,d)},_unapplyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(e=b,d=a[f][1]):3===a[f].length&&(e=a[f][1],d=a[f][2]),c.off(d,e)},_buildEvents:function(){var b={keyup:a.proxy(function(b){a.inArray(b.keyCode,[27,37,39,38,40,32,13,9])===-1&&this.update()},this),keydown:a.proxy(this.keydown,this),paste:a.proxy(this.paste,this)};this.o.showOnFocus===!0&&(b.focus=a.proxy(this.show,this)),this.isInput?this._events=[[this.element,b]]:this.component&&this.inputField.length?this._events=[[this.inputField,b],[this.component,{click:a.proxy(this.show,this)}]]:this._events=[[this.element,{click:a.proxy(this.show,this),keydown:a.proxy(this.keydown,this)}]],this._events.push([this.element,"*",{blur:a.proxy(function(a){this._focused_from=a.target},this)}],[this.element,{blur:a.proxy(function(a){this._focused_from=a.target},this)}]),this.o.immediateUpdates&&this._events.push([this.element,{"changeYear changeMonth":a.proxy(function(a){this.update(a.date)},this)}]),this._secondaryEvents=[[this.picker,{click:a.proxy(this.click,this)}],[this.picker,".prev, .next",{click:a.proxy(this.navArrowsClick,this)}],[this.picker,".day:not(.disabled)",{click:a.proxy(this.dayCellClick,this)}],[a(window),{resize:a.proxy(this.place,this)}],[a(document),{"mousedown touchstart":a.proxy(function(a){this.element.is(a.target)||this.element.find(a.target).length||this.picker.is(a.target)||this.picker.find(a.target).length||this.isInline||this.hide()},this)}]]},_attachEvents:function(){this._detachEvents(),this._applyEvents(this._events)},_detachEvents:function(){this._unapplyEvents(this._events)},_attachSecondaryEvents:function(){this._detachSecondaryEvents(),this._applyEvents(this._secondaryEvents)},_detachSecondaryEvents:function(){this._unapplyEvents(this._secondaryEvents)},_trigger:function(b,c){var d=c||this.dates.get(-1),e=this._utc_to_local(d);this.element.trigger({type:b,date:e,viewMode:this.viewMode,dates:a.map(this.dates,this._utc_to_local),format:a.proxy(function(a,b){0===arguments.length?(a=this.dates.length-1,b=this.o.format):"string"==typeof a&&(b=a,a=this.dates.length-1),b=b||this.o.format;var c=this.dates.get(a);return r.formatDate(c,b,this.o.language)},this)})},show:function(){if(!(this.inputField.prop("disabled")||this.inputField.prop("readonly")&&this.o.enableOnReadonly===!1))return this.isInline||this.picker.appendTo(this.o.container),this.place(),this.picker.show(),this._attachSecondaryEvents(),this._trigger("show"),(window.navigator.msMaxTouchPoints||"ontouchstart"in document)&&this.o.disableTouchKeyboard&&a(this.element).blur(),this},hide:function(){return this.isInline||!this.picker.is(":visible")?this:(this.focusDate=null,this.picker.hide().detach(),this._detachSecondaryEvents(),this.setViewMode(this.o.startView),this.o.forceParse&&this.inputField.val()&&this.setValue(),this._trigger("hide"),this)},destroy:function(){return this.hide(),this._detachEvents(),this._detachSecondaryEvents(),this.picker.remove(),delete this.element.data().datepicker,this.isInput||delete this.element.data().date,this},paste:function(b){var c;if(b.originalEvent.clipboardData&&b.originalEvent.clipboardData.types&&a.inArray("text/plain",b.originalEvent.clipboardData.types)!==-1)c=b.originalEvent.clipboardData.getData("text/plain");else{if(!window.clipboardData)return;c=window.clipboardData.getData("Text")}this.setDate(c),this.update(),b.preventDefault()},_utc_to_local:function(a){if(!a)return a;var b=new Date(a.getTime()+6e4*a.getTimezoneOffset());return b.getTimezoneOffset()!==a.getTimezoneOffset()&&(b=new Date(a.getTime()+6e4*b.getTimezoneOffset())),b},_local_to_utc:function(a){return a&&new Date(a.getTime()-6e4*a.getTimezoneOffset())},_zero_time:function(a){return a&&new Date(a.getFullYear(),a.getMonth(),a.getDate())},_zero_utc_time:function(a){return a&&c(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate())},getDates:function(){return a.map(this.dates,this._utc_to_local)},getUTCDates:function(){return a.map(this.dates,function(a){return new Date(a)})},getDate:function(){return this._utc_to_local(this.getUTCDate())},getUTCDate:function(){var a=this.dates.get(-1);return a!==b?new Date(a):null},clearDates:function(){this.inputField.val(""),this.update(),this._trigger("changeDate"),this.o.autoclose&&this.hide()},setDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.update.apply(this,b),this._trigger("changeDate"),this.setValue(),this},setUTCDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.setDates.apply(this,a.map(b,this._utc_to_local)),this},setDate:f("setDates"),setUTCDate:f("setUTCDates"),remove:f("destroy","Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead"),setValue:function(){var a=this.getFormattedDate();return this.inputField.val(a),this},getFormattedDate:function(c){c===b&&(c=this.o.format);var d=this.o.language;return a.map(this.dates,function(a){return r.formatDate(a,c,d)}).join(this.o.multidateSeparator)},getStartDate:function(){return this.o.startDate},setStartDate:function(a){return this._process_options({startDate:a}),this.update(),this.updateNavArrows(),this},getEndDate:function(){return this.o.endDate},setEndDate:function(a){return this._process_options({endDate:a}),this.update(),this.updateNavArrows(),this},setDaysOfWeekDisabled:function(a){return this._process_options({daysOfWeekDisabled:a}),this.update(),this},setDaysOfWeekHighlighted:function(a){return this._process_options({daysOfWeekHighlighted:a}),this.update(),this},setDatesDisabled:function(a){return this._process_options({datesDisabled:a}),this.update(),this},place:function(){if(this.isInline)return this;var b=this.picker.outerWidth(),c=this.picker.outerHeight(),d=10,e=a(this.o.container),f=e.width(),g="body"===this.o.container?a(document).scrollTop():e.scrollTop(),h=e.offset(),i=[0];this.element.parents().each(function(){var b=a(this).css("z-index");"auto"!==b&&0!==Number(b)&&i.push(Number(b))});var j=Math.max.apply(Math,i)+this.o.zIndexOffset,k=this.component?this.component.parent().offset():this.element.offset(),l=this.component?this.component.outerHeight(!0):this.element.outerHeight(!1),m=this.component?this.component.outerWidth(!0):this.element.outerWidth(!1),n=k.left-h.left,o=k.top-h.top;"body"!==this.o.container&&(o+=g),this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"),"auto"!==this.o.orientation.x?(this.picker.addClass("datepicker-orient-"+this.o.orientation.x),"right"===this.o.orientation.x&&(n-=b-m)):k.left<0?(this.picker.addClass("datepicker-orient-left"),n-=k.left-d):n+b>f?(this.picker.addClass("datepicker-orient-right"),n+=m-b):this.o.rtl?this.picker.addClass("datepicker-orient-right"):this.picker.addClass("datepicker-orient-left");var p,q=this.o.orientation.y;if("auto"===q&&(p=-g+o-c,q=p<0?"bottom":"top"),this.picker.addClass("datepicker-orient-"+q),"top"===q?o-=c+parseInt(this.picker.css("padding-top")):o+=l,this.o.rtl){var r=f-(n+m);this.picker.css({top:o,right:r,zIndex:j})}else this.picker.css({top:o,left:n,zIndex:j});return this},_allow_update:!0,update:function(){if(!this._allow_update)return this;var b=this.dates.copy(),c=[],d=!1;return arguments.length?(a.each(arguments,a.proxy(function(a,b){b instanceof Date&&(b=this._local_to_utc(b)),c.push(b)},this)),d=!0):(c=this.isInput?this.element.val():this.element.data("date")||this.inputField.val(),c=c&&this.o.multidate?c.split(this.o.multidateSeparator):[c],delete this.element.data().date),c=a.map(c,a.proxy(function(a){return r.parseDate(a,this.o.format,this.o.language,this.o.assumeNearbyYear)},this)),c=a.grep(c,a.proxy(function(a){return!this.dateWithinRange(a)||!a},this),!0),this.dates.replace(c),this.o.updateViewDate&&(this.dates.length?this.viewDate=new Date(this.dates.get(-1)):this.viewDate<this.o.startDate?this.viewDate=new Date(this.o.startDate):this.viewDate>this.o.endDate?this.viewDate=new Date(this.o.endDate):this.viewDate=this.o.defaultViewDate),d?(this.setValue(),this.element.change()):this.dates.length&&String(b)!==String(this.dates)&&d&&(this._trigger("changeDate"),this.element.change()),!this.dates.length&&b.length&&(this._trigger("clearDate"),this.element.change()),this.fill(),this},fillDow:function(){if(this.o.showWeekDays){var b=this.o.weekStart,c="<tr>";for(this.o.calendarWeeks&&(c+='<th class="cw">&#160;</th>');b<this.o.weekStart+7;)c+='<th class="dow',a.inArray(b,this.o.daysOfWeekDisabled)!==-1&&(c+=" disabled"),c+='">'+q[this.o.language].daysMin[b++%7]+"</th>";c+="</tr>",this.picker.find(".datepicker-days thead").append(c)}},fillMonths:function(){for(var a,b=this._utc_to_local(this.viewDate),c="",d=0;d<12;d++)a=b&&b.getMonth()===d?" focused":"",c+='<span class="month'+a+'">'+q[this.o.language].monthsShort[d]+"</span>";this.picker.find(".datepicker-months td").html(c)},setRange:function(b){b&&b.length?this.range=a.map(b,function(a){return a.valueOf()}):delete this.range,this.fill()},getClassNames:function(b){var c=[],f=this.viewDate.getUTCFullYear(),g=this.viewDate.getUTCMonth(),h=d();return b.getUTCFullYear()<f||b.getUTCFullYear()===f&&b.getUTCMonth()<g?c.push("old"):(b.getUTCFullYear()>f||b.getUTCFullYear()===f&&b.getUTCMonth()>g)&&c.push("new"),this.focusDate&&b.valueOf()===this.focusDate.valueOf()&&c.push("focused"),this.o.todayHighlight&&e(b,h)&&c.push("today"),this.dates.contains(b)!==-1&&c.push("active"),this.dateWithinRange(b)||c.push("disabled"),this.dateIsDisabled(b)&&c.push("disabled","disabled-date"),a.inArray(b.getUTCDay(),this.o.daysOfWeekHighlighted)!==-1&&c.push("highlighted"),this.range&&(b>this.range[0]&&b<this.range[this.range.length-1]&&c.push("range"),a.inArray(b.valueOf(),this.range)!==-1&&c.push("selected"),b.valueOf()===this.range[0]&&c.push("range-start"),b.valueOf()===this.range[this.range.length-1]&&c.push("range-end")),c},_fill_yearsView:function(c,d,e,f,g,h,i){for(var j,k,l,m="",n=e/10,o=this.picker.find(c),p=Math.floor(f/e)*e,q=p+9*n,r=Math.floor(this.viewDate.getFullYear()/n)*n,s=a.map(this.dates,function(a){return Math.floor(a.getUTCFullYear()/n)*n}),t=p-n;t<=q+n;t+=n)j=[d],k=null,t===p-n?j.push("old"):t===q+n&&j.push("new"),a.inArray(t,s)!==-1&&j.push("active"),(t<g||t>h)&&j.push("disabled"),t===r&&j.push("focused"),i!==a.noop&&(l=i(new Date(t,0,1)),l===b?l={}:"boolean"==typeof l?l={enabled:l}:"string"==typeof l&&(l={classes:l}),l.enabled===!1&&j.push("disabled"),l.classes&&(j=j.concat(l.classes.split(/\s+/))),l.tooltip&&(k=l.tooltip)),m+='<span class="'+j.join(" ")+'"'+(k?' title="'+k+'"':"")+">"+t+"</span>";o.find(".datepicker-switch").text(p+"-"+q),o.find("td").html(m)},fill:function(){var d,e,f=new Date(this.viewDate),g=f.getUTCFullYear(),h=f.getUTCMonth(),i=this.o.startDate!==-(1/0)?this.o.startDate.getUTCFullYear():-(1/0),j=this.o.startDate!==-(1/0)?this.o.startDate.getUTCMonth():-(1/0),k=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,l=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,m=q[this.o.language].today||q.en.today||"",n=q[this.o.language].clear||q.en.clear||"",o=q[this.o.language].titleFormat||q.en.titleFormat;if(!isNaN(g)&&!isNaN(h)){this.picker.find(".datepicker-days .datepicker-switch").text(r.formatDate(f,o,this.o.language)),this.picker.find("tfoot .today").text(m).css("display",this.o.todayBtn===!0||"linked"===this.o.todayBtn?"table-cell":"none"),this.picker.find("tfoot .clear").text(n).css("display",this.o.clearBtn===!0?"table-cell":"none"),this.picker.find("thead .datepicker-title").text(this.o.title).css("display","string"==typeof this.o.title&&""!==this.o.title?"table-cell":"none"),this.updateNavArrows(),this.fillMonths();var p=c(g,h,0),s=p.getUTCDate();p.setUTCDate(s-(p.getUTCDay()-this.o.weekStart+7)%7);var t=new Date(p);p.getUTCFullYear()<100&&t.setUTCFullYear(p.getUTCFullYear()),t.setUTCDate(t.getUTCDate()+42),t=t.valueOf();for(var u,v,w=[];p.valueOf()<t;){if(u=p.getUTCDay(),u===this.o.weekStart&&(w.push("<tr>"),this.o.calendarWeeks)){var x=new Date(+p+(this.o.weekStart-u-7)%7*864e5),y=new Date(Number(x)+(11-x.getUTCDay())%7*864e5),z=new Date(Number(z=c(y.getUTCFullYear(),0,1))+(11-z.getUTCDay())%7*864e5),A=(y-z)/864e5/7+1;w.push('<td class="cw">'+A+"</td>")}v=this.getClassNames(p),v.push("day");var B=p.getUTCDate();this.o.beforeShowDay!==a.noop&&(e=this.o.beforeShowDay(this._utc_to_local(p)),e===b?e={}:"boolean"==typeof e?e={enabled:e}:"string"==typeof e&&(e={classes:e}),e.enabled===!1&&v.push("disabled"),e.classes&&(v=v.concat(e.classes.split(/\s+/))),e.tooltip&&(d=e.tooltip),e.content&&(B=e.content)),v=a.isFunction(a.uniqueSort)?a.uniqueSort(v):a.unique(v),w.push('<td class="'+v.join(" ")+'"'+(d?' title="'+d+'"':"")+' data-date="'+p.getTime().toString()+'">'+B+"</td>"),d=null,u===this.o.weekEnd&&w.push("</tr>"),p.setUTCDate(p.getUTCDate()+1)}this.picker.find(".datepicker-days tbody").html(w.join(""));var C=q[this.o.language].monthsTitle||q.en.monthsTitle||"Months",D=this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode<2?C:g).end().find("tbody span").removeClass("active");if(a.each(this.dates,function(a,b){b.getUTCFullYear()===g&&D.eq(b.getUTCMonth()).addClass("active")}),(g<i||g>k)&&D.addClass("disabled"),g===i&&D.slice(0,j).addClass("disabled"),g===k&&D.slice(l+1).addClass("disabled"),this.o.beforeShowMonth!==a.noop){var E=this;a.each(D,function(c,d){var e=new Date(g,c,1),f=E.o.beforeShowMonth(e);f===b?f={}:"boolean"==typeof f?f={enabled:f}:"string"==typeof f&&(f={classes:f}),f.enabled!==!1||a(d).hasClass("disabled")||a(d).addClass("disabled"),f.classes&&a(d).addClass(f.classes),f.tooltip&&a(d).prop("title",f.tooltip)})}this._fill_yearsView(".datepicker-years","year",10,g,i,k,this.o.beforeShowYear),this._fill_yearsView(".datepicker-decades","decade",100,g,i,k,this.o.beforeShowDecade),this._fill_yearsView(".datepicker-centuries","century",1e3,g,i,k,this.o.beforeShowCentury)}},updateNavArrows:function(){if(this._allow_update){var a,b,c=new Date(this.viewDate),d=c.getUTCFullYear(),e=c.getUTCMonth(),f=this.o.startDate!==-(1/0)?this.o.startDate.getUTCFullYear():-(1/0),g=this.o.startDate!==-(1/0)?this.o.startDate.getUTCMonth():-(1/0),h=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,i=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,j=1;switch(this.viewMode){case 0:a=d<=f&&e<=g,b=d>=h&&e>=i;break;case 4:j*=10;case 3:j*=10;case 2:j*=10;case 1:a=Math.floor(d/j)*j<=f,b=Math.floor(d/j)*j+j>=h}this.picker.find(".prev").toggleClass("disabled",a),this.picker.find(".next").toggleClass("disabled",b)}},click:function(b){b.preventDefault(),b.stopPropagation();var e,f,g,h;e=a(b.target),e.hasClass("datepicker-switch")&&this.viewMode!==this.o.maxViewMode&&this.setViewMode(this.viewMode+1),e.hasClass("today")&&!e.hasClass("day")&&(this.setViewMode(0),this._setDate(d(),"linked"===this.o.todayBtn?null:"view")),e.hasClass("clear")&&this.clearDates(),e.hasClass("disabled")||(e.hasClass("month")||e.hasClass("year")||e.hasClass("decade")||e.hasClass("century"))&&(this.viewDate.setUTCDate(1),f=1,1===this.viewMode?(h=e.parent().find("span").index(e),g=this.viewDate.getUTCFullYear(),this.viewDate.setUTCMonth(h)):(h=0,g=Number(e.text()),this.viewDate.setUTCFullYear(g)),this._trigger(r.viewModes[this.viewMode-1].e,this.viewDate),this.viewMode===this.o.minViewMode?this._setDate(c(g,h,f)):(this.setViewMode(this.viewMode-1),this.fill())),this.picker.is(":visible")&&this._focused_from&&this._focused_from.focus(),delete this._focused_from},dayCellClick:function(b){var c=a(b.currentTarget),d=c.data("date"),e=new Date(d);this.o.updateViewDate&&(e.getUTCFullYear()!==this.viewDate.getUTCFullYear()&&this._trigger("changeYear",this.viewDate),e.getUTCMonth()!==this.viewDate.getUTCMonth()&&this._trigger("changeMonth",this.viewDate)),this._setDate(e)},navArrowsClick:function(b){var c=a(b.currentTarget),d=c.hasClass("prev")?-1:1;0!==this.viewMode&&(d*=12*r.viewModes[this.viewMode].navStep),this.viewDate=this.moveMonth(this.viewDate,d),this._trigger(r.viewModes[this.viewMode].e,this.viewDate),this.fill()},_toggle_multidate:function(a){var b=this.dates.contains(a);if(a||this.dates.clear(),b!==-1?(this.o.multidate===!0||this.o.multidate>1||this.o.toggleActive)&&this.dates.remove(b):this.o.multidate===!1?(this.dates.clear(),this.dates.push(a)):this.dates.push(a),"number"==typeof this.o.multidate)for(;this.dates.length>this.o.multidate;)this.dates.remove(0)},_setDate:function(a,b){b&&"date"!==b||this._toggle_multidate(a&&new Date(a)),(!b&&this.o.updateViewDate||"view"===b)&&(this.viewDate=a&&new Date(a)),this.fill(),this.setValue(),b&&"view"===b||this._trigger("changeDate"),this.inputField.trigger("change"),!this.o.autoclose||b&&"date"!==b||this.hide()},moveDay:function(a,b){var c=new Date(a);return c.setUTCDate(a.getUTCDate()+b),c},moveWeek:function(a,b){return this.moveDay(a,7*b)},moveMonth:function(a,b){if(!g(a))return this.o.defaultViewDate;if(!b)return a;var c,d,e=new Date(a.valueOf()),f=e.getUTCDate(),h=e.getUTCMonth(),i=Math.abs(b);if(b=b>0?1:-1,1===i)d=b===-1?function(){return e.getUTCMonth()===h}:function(){return e.getUTCMonth()!==c},c=h+b,e.setUTCMonth(c),c=(c+12)%12;else{for(var j=0;j<i;j++)e=this.moveMonth(e,b);c=e.getUTCMonth(),e.setUTCDate(f),d=function(){return c!==e.getUTCMonth()}}for(;d();)e.setUTCDate(--f),e.setUTCMonth(c);return e},moveYear:function(a,b){return this.moveMonth(a,12*b)},moveAvailableDate:function(a,b,c){do{if(a=this[c](a,b),!this.dateWithinRange(a))return!1;c="moveDay"}while(this.dateIsDisabled(a));return a},weekOfDateIsDisabled:function(b){return a.inArray(b.getUTCDay(),this.o.daysOfWeekDisabled)!==-1},dateIsDisabled:function(b){return this.weekOfDateIsDisabled(b)||a.grep(this.o.datesDisabled,function(a){return e(b,a)}).length>0},dateWithinRange:function(a){return a>=this.o.startDate&&a<=this.o.endDate},keydown:function(a){if(!this.picker.is(":visible"))return void(40!==a.keyCode&&27!==a.keyCode||(this.show(),a.stopPropagation()));var b,c,d=!1,e=this.focusDate||this.viewDate;switch(a.keyCode){case 27:this.focusDate?(this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill()):this.hide(),a.preventDefault(),a.stopPropagation();break;case 37:case 38:case 39:case 40:if(!this.o.keyboardNavigation||7===this.o.daysOfWeekDisabled.length)break;b=37===a.keyCode||38===a.keyCode?-1:1,0===this.viewMode?a.ctrlKey?(c=this.moveAvailableDate(e,b,"moveYear"),c&&this._trigger("changeYear",this.viewDate)):a.shiftKey?(c=this.moveAvailableDate(e,b,"moveMonth"),c&&this._trigger("changeMonth",this.viewDate)):37===a.keyCode||39===a.keyCode?c=this.moveAvailableDate(e,b,"moveDay"):this.weekOfDateIsDisabled(e)||(c=this.moveAvailableDate(e,b,"moveWeek")):1===this.viewMode?(38!==a.keyCode&&40!==a.keyCode||(b*=4),c=this.moveAvailableDate(e,b,"moveMonth")):2===this.viewMode&&(38!==a.keyCode&&40!==a.keyCode||(b*=4),c=this.moveAvailableDate(e,b,"moveYear")),c&&(this.focusDate=this.viewDate=c,this.setValue(),this.fill(),a.preventDefault());break;case 13:if(!this.o.forceParse)break;e=this.focusDate||this.dates.get(-1)||this.viewDate,this.o.keyboardNavigation&&(this._toggle_multidate(e),d=!0),this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.setValue(),this.fill(),this.picker.is(":visible")&&(a.preventDefault(),a.stopPropagation(),this.o.autoclose&&this.hide());break;case 9:this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill(),this.hide()}d&&(this.dates.length?this._trigger("changeDate"):this._trigger("clearDate"),this.inputField.trigger("change"))},setViewMode:function(a){this.viewMode=a,this.picker.children("div").hide().filter(".datepicker-"+r.viewModes[this.viewMode].clsName).show(),this.updateNavArrows(),this._trigger("changeViewMode",new Date(this.viewDate))}};var l=function(b,c){a.data(b,"datepicker",this),this.element=a(b),this.inputs=a.map(c.inputs,function(a){return a.jquery?a[0]:a}),delete c.inputs,this.keepEmptyValues=c.keepEmptyValues,delete c.keepEmptyValues,n.call(a(this.inputs),c).on("changeDate",a.proxy(this.dateUpdated,this)),this.pickers=a.map(this.inputs,function(b){return a.data(b,"datepicker")}),this.updateDates()};l.prototype={updateDates:function(){this.dates=a.map(this.pickers,function(a){return a.getUTCDate()}),this.updateRanges()},updateRanges:function(){var b=a.map(this.dates,function(a){return a.valueOf()});a.each(this.pickers,function(a,c){c.setRange(b)})},dateUpdated:function(c){if(!this.updating){this.updating=!0;var d=a.data(c.target,"datepicker");if(d!==b){var e=d.getUTCDate(),f=this.keepEmptyValues,g=a.inArray(c.target,this.inputs),h=g-1,i=g+1,j=this.inputs.length;if(g!==-1){if(a.each(this.pickers,function(a,b){b.getUTCDate()||b!==d&&f||b.setUTCDate(e)}),e<this.dates[h])for(;h>=0&&e<this.dates[h];)this.pickers[h--].setUTCDate(e);else if(e>this.dates[i])for(;i<j&&e>this.dates[i];)this.pickers[i++].setUTCDate(e);this.updateDates(),delete this.updating}}}},destroy:function(){a.map(this.pickers,function(a){a.destroy()}),a(this.inputs).off("changeDate",this.dateUpdated),delete this.element.data().datepicker},remove:f("destroy","Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead")};var m=a.fn.datepicker,n=function(c){var d=Array.apply(null,arguments);d.shift();var e;if(this.each(function(){var b=a(this),f=b.data("datepicker"),g="object"==typeof c&&c;if(!f){var j=h(this,"date"),m=a.extend({},o,j,g),n=i(m.language),p=a.extend({},o,n,j,g);b.hasClass("input-daterange")||p.inputs?(a.extend(p,{inputs:p.inputs||b.find("input").toArray()}),f=new l(this,p)):f=new k(this,p),b.data("datepicker",f)}"string"==typeof c&&"function"==typeof f[c]&&(e=f[c].apply(f,d))}),e===b||e instanceof k||e instanceof l)return this;if(this.length>1)throw new Error("Using only allowed for the collection of a single element ("+c+" function)");return e};a.fn.datepicker=n;var o=a.fn.datepicker.defaults={assumeNearbyYear:!1,autoclose:!1,beforeShowDay:a.noop,beforeShowMonth:a.noop,beforeShowYear:a.noop,beforeShowDecade:a.noop,beforeShowCentury:a.noop,calendarWeeks:!1,clearBtn:!1,toggleActive:!1,daysOfWeekDisabled:[],daysOfWeekHighlighted:[],datesDisabled:[],endDate:1/0,forceParse:!0,format:"mm/dd/yyyy",keepEmptyValues:!1,keyboardNavigation:!0,language:"en",minViewMode:0,maxViewMode:4,multidate:!1,multidateSeparator:",",orientation:"auto",rtl:!1,startDate:-(1/0),startView:0,todayBtn:!1,todayHighlight:!1,updateViewDate:!0,weekStart:0,disableTouchKeyboard:!1,enableOnReadonly:!0,showOnFocus:!0,zIndexOffset:10,container:"body",immediateUpdates:!1,title:"",templates:{leftArrow:"&#x00AB;",rightArrow:"&#x00BB;"},showWeekDays:!0},p=a.fn.datepicker.locale_opts=["format","rtl","weekStart"];a.fn.datepicker.Constructor=k;var q=a.fn.datepicker.dates={en:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",clear:"Clear",titleFormat:"MM yyyy"}},r={viewModes:[{names:["days","month"],clsName:"days",e:"changeMonth"},{names:["months","year"],clsName:"months",e:"changeYear",navStep:1},{names:["years","decade"],clsName:"years",e:"changeDecade",navStep:10},{names:["decades","century"],clsName:"decades",e:"changeCentury",navStep:100},{names:["centuries","millennium"],clsName:"centuries",e:"changeMillennium",navStep:1e3}],validParts:/dd?|DD?|mm?|MM?|yy(?:yy)?/g,nonpunctuation:/[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,parseFormat:function(a){if("function"==typeof a.toValue&&"function"==typeof a.toDisplay)return a;var b=a.replace(this.validParts,"\0").split("\0"),c=a.match(this.validParts);if(!b||!b.length||!c||0===c.length)throw new Error("Invalid date format.");return{separators:b,parts:c}},parseDate:function(c,e,f,g){function h(a,b){return b===!0&&(b=10),a<100&&(a+=2e3,a>(new Date).getFullYear()+b&&(a-=100)),a}function i(){var a=this.slice(0,j[n].length),b=j[n].slice(0,a.length);return a.toLowerCase()===b.toLowerCase()}if(!c)return b;if(c instanceof Date)return c;if("string"==typeof e&&(e=r.parseFormat(e)),e.toValue)return e.toValue(c,e,f);var j,l,m,n,o,p={d:"moveDay",m:"moveMonth",w:"moveWeek",y:"moveYear"},s={yesterday:"-1d",today:"+0d",tomorrow:"+1d"};if(c in s&&(c=s[c]),/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(c)){for(j=c.match(/([\-+]\d+)([dmwy])/gi),c=new Date,n=0;n<j.length;n++)l=j[n].match(/([\-+]\d+)([dmwy])/i),m=Number(l[1]),o=p[l[2].toLowerCase()],c=k.prototype[o](c,m);return k.prototype._zero_utc_time(c)}j=c&&c.match(this.nonpunctuation)||[];var t,u,v={},w=["yyyy","yy","M","MM","m","mm","d","dd"],x={yyyy:function(a,b){return a.setUTCFullYear(g?h(b,g):b)},m:function(a,b){if(isNaN(a))return a;for(b-=1;b<0;)b+=12;for(b%=12,a.setUTCMonth(b);a.getUTCMonth()!==b;)a.setUTCDate(a.getUTCDate()-1);return a},d:function(a,b){return a.setUTCDate(b)}};x.yy=x.yyyy,x.M=x.MM=x.mm=x.m,x.dd=x.d,c=d();var y=e.parts.slice();if(j.length!==y.length&&(y=a(y).filter(function(b,c){return a.inArray(c,w)!==-1}).toArray()),j.length===y.length){var z;for(n=0,z=y.length;n<z;n++){if(t=parseInt(j[n],10),l=y[n],isNaN(t))switch(l){case"MM":u=a(q[f].months).filter(i),t=a.inArray(u[0],q[f].months)+1;break;case"M":u=a(q[f].monthsShort).filter(i),t=a.inArray(u[0],q[f].monthsShort)+1}v[l]=t}var A,B;for(n=0;n<w.length;n++)B=w[n],B in v&&!isNaN(v[B])&&(A=new Date(c),x[B](A,v[B]),isNaN(A)||(c=A))}return c},formatDate:function(b,c,d){if(!b)return"";if("string"==typeof c&&(c=r.parseFormat(c)),c.toDisplay)return c.toDisplay(b,c,d);var e={d:b.getUTCDate(),D:q[d].daysShort[b.getUTCDay()],DD:q[d].days[b.getUTCDay()],m:b.getUTCMonth()+1,M:q[d].monthsShort[b.getUTCMonth()],MM:q[d].months[b.getUTCMonth()],yy:b.getUTCFullYear().toString().substring(2),yyyy:b.getUTCFullYear()};e.dd=(e.d<10?"0":"")+e.d,e.mm=(e.m<10?"0":"")+e.m,b=[];for(var f=a.extend([],c.separators),g=0,h=c.parts.length;g<=h;g++)f.length&&b.push(f.shift()),b.push(e[c.parts[g]]);return b.join("")},headTemplate:'<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">'+o.templates.leftArrow+'</th><th colspan="5" class="datepicker-switch"></th><th class="next">'+o.templates.rightArrow+"</th></tr></thead>",
contTemplate:'<tbody><tr><td colspan="7"></td></tr></tbody>',footTemplate:'<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'};r.template='<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">'+r.headTemplate+"<tbody></tbody>"+r.footTemplate+'</table></div><div class="datepicker-months"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-years"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-decades"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-centuries"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+"</table></div></div>",a.fn.datepicker.DPGlobal=r,a.fn.datepicker.noConflict=function(){return a.fn.datepicker=m,this},a.fn.datepicker.version="1.7.0",a.fn.datepicker.deprecated=function(a){var b=window.console;b&&b.warn&&b.warn("DEPRECATED: "+a)},a(document).on("focus.datepicker.data-api click.datepicker.data-api",'[data-provide="datepicker"]',function(b){var c=a(this);c.data("datepicker")||(b.preventDefault(),n.call(c,"show"))}),a(function(){n.call(a('[data-provide="datepicker-inline"]'))})});
},{"jquery":14}],27:[function(require,module,exports){
!function(a){"use strict";if("function"==typeof define&&define.amd)define(["jquery","moment"],a);else if("object"==typeof exports)module.exports=a(require("jquery"),require("moment"));else{if("undefined"==typeof jQuery)throw"bootstrap-datetimepicker requires jQuery to be loaded first";if("undefined"==typeof moment)throw"bootstrap-datetimepicker requires Moment.js to be loaded first";a(jQuery,moment)}}(function(a,b){"use strict";if(!b)throw new Error("bootstrap-datetimepicker requires Moment.js to be loaded first");var c=function(c,d){var e,f,g,h,i,j,k,l={},m=!0,n=!1,o=!1,p=0,q=[{clsName:"days",navFnc:"M",navStep:1},{clsName:"months",navFnc:"y",navStep:1},{clsName:"years",navFnc:"y",navStep:10},{clsName:"decades",navFnc:"y",navStep:100}],r=["days","months","years","decades"],s=["top","bottom","auto"],t=["left","right","auto"],u=["default","top","bottom"],v={up:38,38:"up",down:40,40:"down",left:37,37:"left",right:39,39:"right",tab:9,9:"tab",escape:27,27:"escape",enter:13,13:"enter",pageUp:33,33:"pageUp",pageDown:34,34:"pageDown",shift:16,16:"shift",control:17,17:"control",space:32,32:"space",t:84,84:"t",delete:46,46:"delete"},w={},x=function(){return void 0!==b.tz&&void 0!==d.timeZone&&null!==d.timeZone&&""!==d.timeZone},y=function(a){var c;return c=void 0===a||null===a?b():b.isDate(a)||b.isMoment(a)?b(a):x()?b.tz(a,j,d.useStrict,d.timeZone):b(a,j,d.useStrict),x()&&c.tz(d.timeZone),c},z=function(a){if("string"!=typeof a||a.length>1)throw new TypeError("isEnabled expects a single character string parameter");switch(a){case"y":return i.indexOf("Y")!==-1;case"M":return i.indexOf("M")!==-1;case"d":return i.toLowerCase().indexOf("d")!==-1;case"h":case"H":return i.toLowerCase().indexOf("h")!==-1;case"m":return i.indexOf("m")!==-1;case"s":return i.indexOf("s")!==-1;default:return!1}},A=function(){return z("h")||z("m")||z("s")},B=function(){return z("y")||z("M")||z("d")},C=function(){var b=a("<thead>").append(a("<tr>").append(a("<th>").addClass("prev").attr("data-action","previous").append(a("<span>").addClass(d.icons.previous))).append(a("<th>").addClass("picker-switch").attr("data-action","pickerSwitch").attr("colspan",d.calendarWeeks?"6":"5")).append(a("<th>").addClass("next").attr("data-action","next").append(a("<span>").addClass(d.icons.next)))),c=a("<tbody>").append(a("<tr>").append(a("<td>").attr("colspan",d.calendarWeeks?"8":"7")));return[a("<div>").addClass("datepicker-days").append(a("<table>").addClass("table-condensed").append(b).append(a("<tbody>"))),a("<div>").addClass("datepicker-months").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())),a("<div>").addClass("datepicker-years").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())),a("<div>").addClass("datepicker-decades").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone()))]},D=function(){var b=a("<tr>"),c=a("<tr>"),e=a("<tr>");return z("h")&&(b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementHour}).addClass("btn").attr("data-action","incrementHours").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-hour").attr({"data-time-component":"hours",title:d.tooltips.pickHour}).attr("data-action","showHours"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementHour}).addClass("btn").attr("data-action","decrementHours").append(a("<span>").addClass(d.icons.down))))),z("m")&&(z("h")&&(b.append(a("<td>").addClass("separator")),c.append(a("<td>").addClass("separator").html(":")),e.append(a("<td>").addClass("separator"))),b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementMinute}).addClass("btn").attr("data-action","incrementMinutes").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-minute").attr({"data-time-component":"minutes",title:d.tooltips.pickMinute}).attr("data-action","showMinutes"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementMinute}).addClass("btn").attr("data-action","decrementMinutes").append(a("<span>").addClass(d.icons.down))))),z("s")&&(z("m")&&(b.append(a("<td>").addClass("separator")),c.append(a("<td>").addClass("separator").html(":")),e.append(a("<td>").addClass("separator"))),b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementSecond}).addClass("btn").attr("data-action","incrementSeconds").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-second").attr({"data-time-component":"seconds",title:d.tooltips.pickSecond}).attr("data-action","showSeconds"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementSecond}).addClass("btn").attr("data-action","decrementSeconds").append(a("<span>").addClass(d.icons.down))))),h||(b.append(a("<td>").addClass("separator")),c.append(a("<td>").append(a("<button>").addClass("btn btn-primary").attr({"data-action":"togglePeriod",tabindex:"-1",title:d.tooltips.togglePeriod}))),e.append(a("<td>").addClass("separator"))),a("<div>").addClass("timepicker-picker").append(a("<table>").addClass("table-condensed").append([b,c,e]))},E=function(){var b=a("<div>").addClass("timepicker-hours").append(a("<table>").addClass("table-condensed")),c=a("<div>").addClass("timepicker-minutes").append(a("<table>").addClass("table-condensed")),d=a("<div>").addClass("timepicker-seconds").append(a("<table>").addClass("table-condensed")),e=[D()];return z("h")&&e.push(b),z("m")&&e.push(c),z("s")&&e.push(d),e},F=function(){var b=[];return d.showTodayButton&&b.push(a("<td>").append(a("<a>").attr({"data-action":"today",title:d.tooltips.today}).append(a("<span>").addClass(d.icons.today)))),!d.sideBySide&&B()&&A()&&b.push(a("<td>").append(a("<a>").attr({"data-action":"togglePicker",title:d.tooltips.selectTime}).append(a("<span>").addClass(d.icons.time)))),d.showClear&&b.push(a("<td>").append(a("<a>").attr({"data-action":"clear",title:d.tooltips.clear}).append(a("<span>").addClass(d.icons.clear)))),d.showClose&&b.push(a("<td>").append(a("<a>").attr({"data-action":"close",title:d.tooltips.close}).append(a("<span>").addClass(d.icons.close)))),a("<table>").addClass("table-condensed").append(a("<tbody>").append(a("<tr>").append(b)))},G=function(){var b=a("<div>").addClass("bootstrap-datetimepicker-widget dropdown-menu"),c=a("<div>").addClass("datepicker").append(C()),e=a("<div>").addClass("timepicker").append(E()),f=a("<ul>").addClass("list-unstyled"),g=a("<li>").addClass("picker-switch"+(d.collapse?" accordion-toggle":"")).append(F());return d.inline&&b.removeClass("dropdown-menu"),h&&b.addClass("usetwentyfour"),z("s")&&!h&&b.addClass("wider"),d.sideBySide&&B()&&A()?(b.addClass("timepicker-sbs"),"top"===d.toolbarPlacement&&b.append(g),b.append(a("<div>").addClass("row").append(c.addClass("col-md-6")).append(e.addClass("col-md-6"))),"bottom"===d.toolbarPlacement&&b.append(g),b):("top"===d.toolbarPlacement&&f.append(g),B()&&f.append(a("<li>").addClass(d.collapse&&A()?"collapse in":"").append(c)),"default"===d.toolbarPlacement&&f.append(g),A()&&f.append(a("<li>").addClass(d.collapse&&B()?"collapse":"").append(e)),"bottom"===d.toolbarPlacement&&f.append(g),b.append(f))},H=function(){var b,e={};return b=c.is("input")||d.inline?c.data():c.find("input").data(),b.dateOptions&&b.dateOptions instanceof Object&&(e=a.extend(!0,e,b.dateOptions)),a.each(d,function(a){var c="date"+a.charAt(0).toUpperCase()+a.slice(1);void 0!==b[c]&&(e[a]=b[c])}),e},I=function(){var b,e=(n||c).position(),f=(n||c).offset(),g=d.widgetPositioning.vertical,h=d.widgetPositioning.horizontal;if(d.widgetParent)b=d.widgetParent.append(o);else if(c.is("input"))b=c.after(o).parent();else{if(d.inline)return void(b=c.append(o));b=c,c.children().first().after(o)}if("auto"===g&&(g=f.top+1.5*o.height()>=a(window).height()+a(window).scrollTop()&&o.height()+c.outerHeight()<f.top?"top":"bottom"),"auto"===h&&(h=b.width()<f.left+o.outerWidth()/2&&f.left+o.outerWidth()>a(window).width()?"right":"left"),"top"===g?o.addClass("top").removeClass("bottom"):o.addClass("bottom").removeClass("top"),"right"===h?o.addClass("pull-right"):o.removeClass("pull-right"),"static"===b.css("position")&&(b=b.parents().filter(function(){return"static"!==a(this).css("position")}).first()),0===b.length)throw new Error("datetimepicker component should be placed within a non-static positioned container");o.css({top:"top"===g?"auto":e.top+c.outerHeight(),bottom:"top"===g?b.outerHeight()-(b===c?0:e.top):"auto",left:"left"===h?b===c?0:e.left:"auto",right:"left"===h?"auto":b.outerWidth()-c.outerWidth()-(b===c?0:e.left)})},J=function(a){"dp.change"===a.type&&(a.date&&a.date.isSame(a.oldDate)||!a.date&&!a.oldDate)||c.trigger(a)},K=function(a){"y"===a&&(a="YYYY"),J({type:"dp.update",change:a,viewDate:f.clone()})},L=function(a){o&&(a&&(k=Math.max(p,Math.min(3,k+a))),o.find(".datepicker > div").hide().filter(".datepicker-"+q[k].clsName).show())},M=function(){var b=a("<tr>"),c=f.clone().startOf("w").startOf("d");for(d.calendarWeeks===!0&&b.append(a("<th>").addClass("cw").text("#"));c.isBefore(f.clone().endOf("w"));)b.append(a("<th>").addClass("dow").text(c.format("dd"))),c.add(1,"d");o.find(".datepicker-days thead").append(b)},N=function(a){return d.disabledDates[a.format("YYYY-MM-DD")]===!0},O=function(a){return d.enabledDates[a.format("YYYY-MM-DD")]===!0},P=function(a){return d.disabledHours[a.format("H")]===!0},Q=function(a){return d.enabledHours[a.format("H")]===!0},R=function(b,c){if(!b.isValid())return!1;if(d.disabledDates&&"d"===c&&N(b))return!1;if(d.enabledDates&&"d"===c&&!O(b))return!1;if(d.minDate&&b.isBefore(d.minDate,c))return!1;if(d.maxDate&&b.isAfter(d.maxDate,c))return!1;if(d.daysOfWeekDisabled&&"d"===c&&d.daysOfWeekDisabled.indexOf(b.day())!==-1)return!1;if(d.disabledHours&&("h"===c||"m"===c||"s"===c)&&P(b))return!1;if(d.enabledHours&&("h"===c||"m"===c||"s"===c)&&!Q(b))return!1;if(d.disabledTimeIntervals&&("h"===c||"m"===c||"s"===c)){var e=!1;if(a.each(d.disabledTimeIntervals,function(){if(b.isBetween(this[0],this[1]))return e=!0,!1}),e)return!1}return!0},S=function(){for(var b=[],c=f.clone().startOf("y").startOf("d");c.isSame(f,"y");)b.push(a("<span>").attr("data-action","selectMonth").addClass("month").text(c.format("MMM"))),c.add(1,"M");o.find(".datepicker-months td").empty().append(b)},T=function(){var b=o.find(".datepicker-months"),c=b.find("th"),g=b.find("tbody").find("span");c.eq(0).find("span").attr("title",d.tooltips.prevYear),c.eq(1).attr("title",d.tooltips.selectYear),c.eq(2).find("span").attr("title",d.tooltips.nextYear),b.find(".disabled").removeClass("disabled"),R(f.clone().subtract(1,"y"),"y")||c.eq(0).addClass("disabled"),c.eq(1).text(f.year()),R(f.clone().add(1,"y"),"y")||c.eq(2).addClass("disabled"),g.removeClass("active"),e.isSame(f,"y")&&!m&&g.eq(e.month()).addClass("active"),g.each(function(b){R(f.clone().month(b),"M")||a(this).addClass("disabled")})},U=function(){var a=o.find(".datepicker-years"),b=a.find("th"),c=f.clone().subtract(5,"y"),g=f.clone().add(6,"y"),h="";for(b.eq(0).find("span").attr("title",d.tooltips.prevDecade),b.eq(1).attr("title",d.tooltips.selectDecade),b.eq(2).find("span").attr("title",d.tooltips.nextDecade),a.find(".disabled").removeClass("disabled"),d.minDate&&d.minDate.isAfter(c,"y")&&b.eq(0).addClass("disabled"),b.eq(1).text(c.year()+"-"+g.year()),d.maxDate&&d.maxDate.isBefore(g,"y")&&b.eq(2).addClass("disabled");!c.isAfter(g,"y");)h+='<span data-action="selectYear" class="year'+(c.isSame(e,"y")&&!m?" active":"")+(R(c,"y")?"":" disabled")+'">'+c.year()+"</span>",c.add(1,"y");a.find("td").html(h)},V=function(){var a,c=o.find(".datepicker-decades"),g=c.find("th"),h=b({y:f.year()-f.year()%100-1}),i=h.clone().add(100,"y"),j=h.clone(),k=!1,l=!1,m="";for(g.eq(0).find("span").attr("title",d.tooltips.prevCentury),g.eq(2).find("span").attr("title",d.tooltips.nextCentury),c.find(".disabled").removeClass("disabled"),(h.isSame(b({y:1900}))||d.minDate&&d.minDate.isAfter(h,"y"))&&g.eq(0).addClass("disabled"),g.eq(1).text(h.year()+"-"+i.year()),(h.isSame(b({y:2e3}))||d.maxDate&&d.maxDate.isBefore(i,"y"))&&g.eq(2).addClass("disabled");!h.isAfter(i,"y");)a=h.year()+12,k=d.minDate&&d.minDate.isAfter(h,"y")&&d.minDate.year()<=a,l=d.maxDate&&d.maxDate.isAfter(h,"y")&&d.maxDate.year()<=a,m+='<span data-action="selectDecade" class="decade'+(e.isAfter(h)&&e.year()<=a?" active":"")+(R(h,"y")||k||l?"":" disabled")+'" data-selection="'+(h.year()+6)+'">'+(h.year()+1)+" - "+(h.year()+12)+"</span>",h.add(12,"y");m+="<span></span><span></span><span></span>",c.find("td").html(m),g.eq(1).text(j.year()+1+"-"+h.year())},W=function(){var b,c,g,h=o.find(".datepicker-days"),i=h.find("th"),j=[],k=[];if(B()){for(i.eq(0).find("span").attr("title",d.tooltips.prevMonth),i.eq(1).attr("title",d.tooltips.selectMonth),i.eq(2).find("span").attr("title",d.tooltips.nextMonth),h.find(".disabled").removeClass("disabled"),i.eq(1).text(f.format(d.dayViewHeaderFormat)),R(f.clone().subtract(1,"M"),"M")||i.eq(0).addClass("disabled"),R(f.clone().add(1,"M"),"M")||i.eq(2).addClass("disabled"),b=f.clone().startOf("M").startOf("w").startOf("d"),g=0;g<42;g++)0===b.weekday()&&(c=a("<tr>"),d.calendarWeeks&&c.append('<td class="cw">'+b.week()+"</td>"),j.push(c)),k=["day"],b.isBefore(f,"M")&&k.push("old"),b.isAfter(f,"M")&&k.push("new"),b.isSame(e,"d")&&!m&&k.push("active"),R(b,"d")||k.push("disabled"),b.isSame(y(),"d")&&k.push("today"),0!==b.day()&&6!==b.day()||k.push("weekend"),J({type:"dp.classify",date:b,classNames:k}),c.append('<td data-action="selectDay" data-day="'+b.format("L")+'" class="'+k.join(" ")+'">'+b.date()+"</td>"),b.add(1,"d");h.find("tbody").empty().append(j),T(),U(),V()}},X=function(){var b=o.find(".timepicker-hours table"),c=f.clone().startOf("d"),d=[],e=a("<tr>");for(f.hour()>11&&!h&&c.hour(12);c.isSame(f,"d")&&(h||f.hour()<12&&c.hour()<12||f.hour()>11);)c.hour()%4===0&&(e=a("<tr>"),d.push(e)),e.append('<td data-action="selectHour" class="hour'+(R(c,"h")?"":" disabled")+'">'+c.format(h?"HH":"hh")+"</td>"),c.add(1,"h");b.empty().append(d)},Y=function(){for(var b=o.find(".timepicker-minutes table"),c=f.clone().startOf("h"),e=[],g=a("<tr>"),h=1===d.stepping?5:d.stepping;f.isSame(c,"h");)c.minute()%(4*h)===0&&(g=a("<tr>"),e.push(g)),g.append('<td data-action="selectMinute" class="minute'+(R(c,"m")?"":" disabled")+'">'+c.format("mm")+"</td>"),c.add(h,"m");b.empty().append(e)},Z=function(){for(var b=o.find(".timepicker-seconds table"),c=f.clone().startOf("m"),d=[],e=a("<tr>");f.isSame(c,"m");)c.second()%20===0&&(e=a("<tr>"),d.push(e)),e.append('<td data-action="selectSecond" class="second'+(R(c,"s")?"":" disabled")+'">'+c.format("ss")+"</td>"),c.add(5,"s");b.empty().append(d)},$=function(){var a,b,c=o.find(".timepicker span[data-time-component]");h||(a=o.find(".timepicker [data-action=togglePeriod]"),b=e.clone().add(e.hours()>=12?-12:12,"h"),a.text(e.format("A")),R(b,"h")?a.removeClass("disabled"):a.addClass("disabled")),c.filter("[data-time-component=hours]").text(e.format(h?"HH":"hh")),c.filter("[data-time-component=minutes]").text(e.format("mm")),c.filter("[data-time-component=seconds]").text(e.format("ss")),X(),Y(),Z()},_=function(){o&&(W(),$())},aa=function(a){var b=m?null:e;if(!a)return m=!0,g.val(""),c.data("date",""),J({type:"dp.change",date:!1,oldDate:b}),void _();if(a=a.clone().locale(d.locale),x()&&a.tz(d.timeZone),1!==d.stepping)for(a.minutes(Math.round(a.minutes()/d.stepping)*d.stepping).seconds(0);d.minDate&&a.isBefore(d.minDate);)a.add(d.stepping,"minutes");R(a)?(e=a,f=e.clone(),g.val(e.format(i)),c.data("date",e.format(i)),m=!1,_(),J({type:"dp.change",date:e.clone(),oldDate:b})):(d.keepInvalid?J({type:"dp.change",date:a,oldDate:b}):g.val(m?"":e.format(i)),J({type:"dp.error",date:a,oldDate:b}))},ba=function(){var b=!1;return o?(o.find(".collapse").each(function(){var c=a(this).data("collapse");return!c||!c.transitioning||(b=!0,!1)}),b?l:(n&&n.hasClass("btn")&&n.toggleClass("active"),o.hide(),a(window).off("resize",I),o.off("click","[data-action]"),o.off("mousedown",!1),o.remove(),o=!1,J({type:"dp.hide",date:e.clone()}),g.blur(),f=e.clone(),l)):l},ca=function(){aa(null)},da=function(a){return void 0===d.parseInputDate?(!b.isMoment(a)||a instanceof Date)&&(a=y(a)):a=d.parseInputDate(a),a},ea={next:function(){var a=q[k].navFnc;f.add(q[k].navStep,a),W(),K(a)},previous:function(){var a=q[k].navFnc;f.subtract(q[k].navStep,a),W(),K(a)},pickerSwitch:function(){L(1)},selectMonth:function(b){var c=a(b.target).closest("tbody").find("span").index(a(b.target));f.month(c),k===p?(aa(e.clone().year(f.year()).month(f.month())),d.inline||ba()):(L(-1),W()),K("M")},selectYear:function(b){var c=parseInt(a(b.target).text(),10)||0;f.year(c),k===p?(aa(e.clone().year(f.year())),d.inline||ba()):(L(-1),W()),K("YYYY")},selectDecade:function(b){var c=parseInt(a(b.target).data("selection"),10)||0;f.year(c),k===p?(aa(e.clone().year(f.year())),d.inline||ba()):(L(-1),W()),K("YYYY")},selectDay:function(b){var c=f.clone();a(b.target).is(".old")&&c.subtract(1,"M"),a(b.target).is(".new")&&c.add(1,"M"),aa(c.date(parseInt(a(b.target).text(),10))),A()||d.keepOpen||d.inline||ba()},incrementHours:function(){var a=e.clone().add(1,"h");R(a,"h")&&aa(a)},incrementMinutes:function(){var a=e.clone().add(d.stepping,"m");R(a,"m")&&aa(a)},incrementSeconds:function(){var a=e.clone().add(1,"s");R(a,"s")&&aa(a)},decrementHours:function(){var a=e.clone().subtract(1,"h");R(a,"h")&&aa(a)},decrementMinutes:function(){var a=e.clone().subtract(d.stepping,"m");R(a,"m")&&aa(a)},decrementSeconds:function(){var a=e.clone().subtract(1,"s");R(a,"s")&&aa(a)},togglePeriod:function(){aa(e.clone().add(e.hours()>=12?-12:12,"h"))},togglePicker:function(b){var c,e=a(b.target),f=e.closest("ul"),g=f.find(".in"),h=f.find(".collapse:not(.in)");if(g&&g.length){if(c=g.data("collapse"),c&&c.transitioning)return;g.collapse?(g.collapse("hide"),h.collapse("show")):(g.removeClass("in"),h.addClass("in")),e.is("span")?e.toggleClass(d.icons.time+" "+d.icons.date):e.find("span").toggleClass(d.icons.time+" "+d.icons.date)}},showPicker:function(){o.find(".timepicker > div:not(.timepicker-picker)").hide(),o.find(".timepicker .timepicker-picker").show()},showHours:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-hours").show()},showMinutes:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-minutes").show()},showSeconds:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-seconds").show()},selectHour:function(b){var c=parseInt(a(b.target).text(),10);h||(e.hours()>=12?12!==c&&(c+=12):12===c&&(c=0)),aa(e.clone().hours(c)),ea.showPicker.call(l)},selectMinute:function(b){aa(e.clone().minutes(parseInt(a(b.target).text(),10))),ea.showPicker.call(l)},selectSecond:function(b){aa(e.clone().seconds(parseInt(a(b.target).text(),10))),ea.showPicker.call(l)},clear:ca,today:function(){var a=y();R(a,"d")&&aa(a)},close:ba},fa=function(b){return!a(b.currentTarget).is(".disabled")&&(ea[a(b.currentTarget).data("action")].apply(l,arguments),!1)},ga=function(){var b,c={year:function(a){return a.month(0).date(1).hours(0).seconds(0).minutes(0)},month:function(a){return a.date(1).hours(0).seconds(0).minutes(0)},day:function(a){return a.hours(0).seconds(0).minutes(0)},hour:function(a){return a.seconds(0).minutes(0)},minute:function(a){return a.seconds(0)}};return g.prop("disabled")||!d.ignoreReadonly&&g.prop("readonly")||o?l:(void 0!==g.val()&&0!==g.val().trim().length?aa(da(g.val().trim())):m&&d.useCurrent&&(d.inline||g.is("input")&&0===g.val().trim().length)&&(b=y(),"string"==typeof d.useCurrent&&(b=c[d.useCurrent](b)),aa(b)),o=G(),M(),S(),o.find(".timepicker-hours").hide(),o.find(".timepicker-minutes").hide(),o.find(".timepicker-seconds").hide(),_(),L(),a(window).on("resize",I),o.on("click","[data-action]",fa),o.on("mousedown",!1),n&&n.hasClass("btn")&&n.toggleClass("active"),I(),o.show(),d.focusOnShow&&!g.is(":focus")&&g.focus(),J({type:"dp.show"}),l)},ha=function(){return o?ba():ga()},ia=function(a){var b,c,e,f,g=null,h=[],i={},j=a.which,k="p";w[j]=k;for(b in w)w.hasOwnProperty(b)&&w[b]===k&&(h.push(b),parseInt(b,10)!==j&&(i[b]=!0));for(b in d.keyBinds)if(d.keyBinds.hasOwnProperty(b)&&"function"==typeof d.keyBinds[b]&&(e=b.split(" "),e.length===h.length&&v[j]===e[e.length-1])){for(f=!0,c=e.length-2;c>=0;c--)if(!(v[e[c]]in i)){f=!1;break}if(f){g=d.keyBinds[b];break}}g&&(g.call(l,o),a.stopPropagation(),a.preventDefault())},ja=function(a){w[a.which]="r",a.stopPropagation(),a.preventDefault()},ka=function(b){var c=a(b.target).val().trim(),d=c?da(c):null;return aa(d),b.stopImmediatePropagation(),!1},la=function(){g.on({change:ka,blur:d.debug?"":ba,keydown:ia,keyup:ja,focus:d.allowInputToggle?ga:""}),c.is("input")?g.on({focus:ga}):n&&(n.on("click",ha),n.on("mousedown",!1))},ma=function(){g.off({change:ka,blur:blur,keydown:ia,keyup:ja,focus:d.allowInputToggle?ba:""}),c.is("input")?g.off({focus:ga}):n&&(n.off("click",ha),n.off("mousedown",!1))},na=function(b){var c={};return a.each(b,function(){var a=da(this);a.isValid()&&(c[a.format("YYYY-MM-DD")]=!0)}),!!Object.keys(c).length&&c},oa=function(b){var c={};return a.each(b,function(){c[this]=!0}),!!Object.keys(c).length&&c},pa=function(){var a=d.format||"L LT";i=a.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(a){var b=e.localeData().longDateFormat(a)||a;return b.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(a){return e.localeData().longDateFormat(a)||a})}),j=d.extraFormats?d.extraFormats.slice():[],j.indexOf(a)<0&&j.indexOf(i)<0&&j.push(i),h=i.toLowerCase().indexOf("a")<1&&i.replace(/\[.*?\]/g,"").indexOf("h")<1,z("y")&&(p=2),z("M")&&(p=1),z("d")&&(p=0),k=Math.max(p,k),m||aa(e)};if(l.destroy=function(){ba(),ma(),c.removeData("DateTimePicker"),c.removeData("date")},l.toggle=ha,l.show=ga,l.hide=ba,l.disable=function(){return ba(),n&&n.hasClass("btn")&&n.addClass("disabled"),g.prop("disabled",!0),l},l.enable=function(){return n&&n.hasClass("btn")&&n.removeClass("disabled"),g.prop("disabled",!1),l},l.ignoreReadonly=function(a){if(0===arguments.length)return d.ignoreReadonly;if("boolean"!=typeof a)throw new TypeError("ignoreReadonly () expects a boolean parameter");return d.ignoreReadonly=a,l},l.options=function(b){if(0===arguments.length)return a.extend(!0,{},d);if(!(b instanceof Object))throw new TypeError("options() options parameter should be an object");return a.extend(!0,d,b),a.each(d,function(a,b){if(void 0===l[a])throw new TypeError("option "+a+" is not recognized!");l[a](b)}),l},l.date=function(a){if(0===arguments.length)return m?null:e.clone();if(!(null===a||"string"==typeof a||b.isMoment(a)||a instanceof Date))throw new TypeError("date() parameter must be one of [null, string, moment or Date]");return aa(null===a?null:da(a)),l},l.format=function(a){if(0===arguments.length)return d.format;if("string"!=typeof a&&("boolean"!=typeof a||a!==!1))throw new TypeError("format() expects a string or boolean:false parameter "+a);return d.format=a,i&&pa(),l},l.timeZone=function(a){if(0===arguments.length)return d.timeZone;if("string"!=typeof a)throw new TypeError("newZone() expects a string parameter");return d.timeZone=a,l},l.dayViewHeaderFormat=function(a){if(0===arguments.length)return d.dayViewHeaderFormat;if("string"!=typeof a)throw new TypeError("dayViewHeaderFormat() expects a string parameter");return d.dayViewHeaderFormat=a,l},l.extraFormats=function(a){if(0===arguments.length)return d.extraFormats;if(a!==!1&&!(a instanceof Array))throw new TypeError("extraFormats() expects an array or false parameter");return d.extraFormats=a,j&&pa(),l},l.disabledDates=function(b){if(0===arguments.length)return d.disabledDates?a.extend({},d.disabledDates):d.disabledDates;if(!b)return d.disabledDates=!1,_(),l;if(!(b instanceof Array))throw new TypeError("disabledDates() expects an array parameter");return d.disabledDates=na(b),d.enabledDates=!1,_(),l},l.enabledDates=function(b){if(0===arguments.length)return d.enabledDates?a.extend({},d.enabledDates):d.enabledDates;if(!b)return d.enabledDates=!1,_(),l;if(!(b instanceof Array))throw new TypeError("enabledDates() expects an array parameter");return d.enabledDates=na(b),d.disabledDates=!1,_(),l},l.daysOfWeekDisabled=function(a){if(0===arguments.length)return d.daysOfWeekDisabled.splice(0);if("boolean"==typeof a&&!a)return d.daysOfWeekDisabled=!1,_(),l;if(!(a instanceof Array))throw new TypeError("daysOfWeekDisabled() expects an array parameter");if(d.daysOfWeekDisabled=a.reduce(function(a,b){return b=parseInt(b,10),b>6||b<0||isNaN(b)?a:(a.indexOf(b)===-1&&a.push(b),a)},[]).sort(),d.useCurrent&&!d.keepInvalid){for(var b=0;!R(e,"d");){if(e.add(1,"d"),31===b)throw"Tried 31 times to find a valid date";b++}aa(e)}return _(),l},l.maxDate=function(a){if(0===arguments.length)return d.maxDate?d.maxDate.clone():d.maxDate;if("boolean"==typeof a&&a===!1)return d.maxDate=!1,_(),l;"string"==typeof a&&("now"!==a&&"moment"!==a||(a=y()));var b=da(a);if(!b.isValid())throw new TypeError("maxDate() Could not parse date parameter: "+a);if(d.minDate&&b.isBefore(d.minDate))throw new TypeError("maxDate() date parameter is before options.minDate: "+b.format(i));return d.maxDate=b,d.useCurrent&&!d.keepInvalid&&e.isAfter(a)&&aa(d.maxDate),f.isAfter(b)&&(f=b.clone().subtract(d.stepping,"m")),_(),l},l.minDate=function(a){if(0===arguments.length)return d.minDate?d.minDate.clone():d.minDate;if("boolean"==typeof a&&a===!1)return d.minDate=!1,_(),l;"string"==typeof a&&("now"!==a&&"moment"!==a||(a=y()));var b=da(a);if(!b.isValid())throw new TypeError("minDate() Could not parse date parameter: "+a);if(d.maxDate&&b.isAfter(d.maxDate))throw new TypeError("minDate() date parameter is after options.maxDate: "+b.format(i));return d.minDate=b,d.useCurrent&&!d.keepInvalid&&e.isBefore(a)&&aa(d.minDate),f.isBefore(b)&&(f=b.clone().add(d.stepping,"m")),_(),l},l.defaultDate=function(a){if(0===arguments.length)return d.defaultDate?d.defaultDate.clone():d.defaultDate;if(!a)return d.defaultDate=!1,l;"string"==typeof a&&(a="now"===a||"moment"===a?y():y(a));var b=da(a);if(!b.isValid())throw new TypeError("defaultDate() Could not parse date parameter: "+a);if(!R(b))throw new TypeError("defaultDate() date passed is invalid according to component setup validations");return d.defaultDate=b,(d.defaultDate&&d.inline||""===g.val().trim())&&aa(d.defaultDate),l},l.locale=function(a){if(0===arguments.length)return d.locale;if(!b.localeData(a))throw new TypeError("locale() locale "+a+" is not loaded from moment locales!");return d.locale=a,e.locale(d.locale),f.locale(d.locale),i&&pa(),o&&(ba(),ga()),l},l.stepping=function(a){return 0===arguments.length?d.stepping:(a=parseInt(a,10),(isNaN(a)||a<1)&&(a=1),d.stepping=a,l)},l.useCurrent=function(a){var b=["year","month","day","hour","minute"];if(0===arguments.length)return d.useCurrent;if("boolean"!=typeof a&&"string"!=typeof a)throw new TypeError("useCurrent() expects a boolean or string parameter");if("string"==typeof a&&b.indexOf(a.toLowerCase())===-1)throw new TypeError("useCurrent() expects a string parameter of "+b.join(", "));return d.useCurrent=a,l},l.collapse=function(a){if(0===arguments.length)return d.collapse;if("boolean"!=typeof a)throw new TypeError("collapse() expects a boolean parameter");return d.collapse===a?l:(d.collapse=a,o&&(ba(),ga()),l)},l.icons=function(b){if(0===arguments.length)return a.extend({},d.icons);if(!(b instanceof Object))throw new TypeError("icons() expects parameter to be an Object");return a.extend(d.icons,b),o&&(ba(),ga()),l},l.tooltips=function(b){if(0===arguments.length)return a.extend({},d.tooltips);if(!(b instanceof Object))throw new TypeError("tooltips() expects parameter to be an Object");return a.extend(d.tooltips,b),o&&(ba(),ga()),l},l.useStrict=function(a){if(0===arguments.length)return d.useStrict;if("boolean"!=typeof a)throw new TypeError("useStrict() expects a boolean parameter");return d.useStrict=a,l},l.sideBySide=function(a){if(0===arguments.length)return d.sideBySide;if("boolean"!=typeof a)throw new TypeError("sideBySide() expects a boolean parameter");return d.sideBySide=a,o&&(ba(),ga()),l},l.viewMode=function(a){if(0===arguments.length)return d.viewMode;if("string"!=typeof a)throw new TypeError("viewMode() expects a string parameter");if(r.indexOf(a)===-1)throw new TypeError("viewMode() parameter must be one of ("+r.join(", ")+") value");return d.viewMode=a,k=Math.max(r.indexOf(a),p),L(),l},l.toolbarPlacement=function(a){if(0===arguments.length)return d.toolbarPlacement;if("string"!=typeof a)throw new TypeError("toolbarPlacement() expects a string parameter");if(u.indexOf(a)===-1)throw new TypeError("toolbarPlacement() parameter must be one of ("+u.join(", ")+") value");return d.toolbarPlacement=a,o&&(ba(),ga()),l},l.widgetPositioning=function(b){if(0===arguments.length)return a.extend({},d.widgetPositioning);if("[object Object]"!=={}.toString.call(b))throw new TypeError("widgetPositioning() expects an object variable");if(b.horizontal){if("string"!=typeof b.horizontal)throw new TypeError("widgetPositioning() horizontal variable must be a string");if(b.horizontal=b.horizontal.toLowerCase(),t.indexOf(b.horizontal)===-1)throw new TypeError("widgetPositioning() expects horizontal parameter to be one of ("+t.join(", ")+")");d.widgetPositioning.horizontal=b.horizontal}if(b.vertical){if("string"!=typeof b.vertical)throw new TypeError("widgetPositioning() vertical variable must be a string");if(b.vertical=b.vertical.toLowerCase(),s.indexOf(b.vertical)===-1)throw new TypeError("widgetPositioning() expects vertical parameter to be one of ("+s.join(", ")+")");d.widgetPositioning.vertical=b.vertical}return _(),l},l.calendarWeeks=function(a){if(0===arguments.length)return d.calendarWeeks;if("boolean"!=typeof a)throw new TypeError("calendarWeeks() expects parameter to be a boolean value");return d.calendarWeeks=a,_(),l},l.showTodayButton=function(a){if(0===arguments.length)return d.showTodayButton;if("boolean"!=typeof a)throw new TypeError("showTodayButton() expects a boolean parameter");return d.showTodayButton=a,o&&(ba(),ga()),l},l.showClear=function(a){if(0===arguments.length)return d.showClear;if("boolean"!=typeof a)throw new TypeError("showClear() expects a boolean parameter");return d.showClear=a,o&&(ba(),ga()),l},l.widgetParent=function(b){if(0===arguments.length)return d.widgetParent;if("string"==typeof b&&(b=a(b)),null!==b&&"string"!=typeof b&&!(b instanceof a))throw new TypeError("widgetParent() expects a string or a jQuery object parameter");return d.widgetParent=b,o&&(ba(),ga()),l},l.keepOpen=function(a){if(0===arguments.length)return d.keepOpen;if("boolean"!=typeof a)throw new TypeError("keepOpen() expects a boolean parameter");return d.keepOpen=a,l},l.focusOnShow=function(a){if(0===arguments.length)return d.focusOnShow;if("boolean"!=typeof a)throw new TypeError("focusOnShow() expects a boolean parameter");return d.focusOnShow=a,l},l.inline=function(a){if(0===arguments.length)return d.inline;if("boolean"!=typeof a)throw new TypeError("inline() expects a boolean parameter");return d.inline=a,l},l.clear=function(){return ca(),l},l.keyBinds=function(a){return 0===arguments.length?d.keyBinds:(d.keyBinds=a,l)},l.getMoment=function(a){return y(a)},l.debug=function(a){if("boolean"!=typeof a)throw new TypeError("debug() expects a boolean parameter");return d.debug=a,l},l.allowInputToggle=function(a){if(0===arguments.length)return d.allowInputToggle;if("boolean"!=typeof a)throw new TypeError("allowInputToggle() expects a boolean parameter");return d.allowInputToggle=a,l},l.showClose=function(a){if(0===arguments.length)return d.showClose;if("boolean"!=typeof a)throw new TypeError("showClose() expects a boolean parameter");return d.showClose=a,l},l.keepInvalid=function(a){if(0===arguments.length)return d.keepInvalid;if("boolean"!=typeof a)throw new TypeError("keepInvalid() expects a boolean parameter");
return d.keepInvalid=a,l},l.datepickerInput=function(a){if(0===arguments.length)return d.datepickerInput;if("string"!=typeof a)throw new TypeError("datepickerInput() expects a string parameter");return d.datepickerInput=a,l},l.parseInputDate=function(a){if(0===arguments.length)return d.parseInputDate;if("function"!=typeof a)throw new TypeError("parseInputDate() sholud be as function");return d.parseInputDate=a,l},l.disabledTimeIntervals=function(b){if(0===arguments.length)return d.disabledTimeIntervals?a.extend({},d.disabledTimeIntervals):d.disabledTimeIntervals;if(!b)return d.disabledTimeIntervals=!1,_(),l;if(!(b instanceof Array))throw new TypeError("disabledTimeIntervals() expects an array parameter");return d.disabledTimeIntervals=b,_(),l},l.disabledHours=function(b){if(0===arguments.length)return d.disabledHours?a.extend({},d.disabledHours):d.disabledHours;if(!b)return d.disabledHours=!1,_(),l;if(!(b instanceof Array))throw new TypeError("disabledHours() expects an array parameter");if(d.disabledHours=oa(b),d.enabledHours=!1,d.useCurrent&&!d.keepInvalid){for(var c=0;!R(e,"h");){if(e.add(1,"h"),24===c)throw"Tried 24 times to find a valid date";c++}aa(e)}return _(),l},l.enabledHours=function(b){if(0===arguments.length)return d.enabledHours?a.extend({},d.enabledHours):d.enabledHours;if(!b)return d.enabledHours=!1,_(),l;if(!(b instanceof Array))throw new TypeError("enabledHours() expects an array parameter");if(d.enabledHours=oa(b),d.disabledHours=!1,d.useCurrent&&!d.keepInvalid){for(var c=0;!R(e,"h");){if(e.add(1,"h"),24===c)throw"Tried 24 times to find a valid date";c++}aa(e)}return _(),l},l.viewDate=function(a){if(0===arguments.length)return f.clone();if(!a)return f=e.clone(),l;if(!("string"==typeof a||b.isMoment(a)||a instanceof Date))throw new TypeError("viewDate() parameter must be one of [string, moment or Date]");return f=da(a),K(),l},c.is("input"))g=c;else if(g=c.find(d.datepickerInput),0===g.length)g=c.find("input");else if(!g.is("input"))throw new Error('CSS class "'+d.datepickerInput+'" cannot be applied to non input element');if(c.hasClass("input-group")&&(n=0===c.find(".datepickerbutton").length?c.find(".input-group-addon"):c.find(".datepickerbutton")),!d.inline&&!g.is("input"))throw new Error("Could not initialize DateTimePicker without an input element");return e=y(),f=e.clone(),a.extend(!0,d,H()),l.options(d),pa(),la(),g.prop("disabled")&&l.disable(),g.is("input")&&0!==g.val().trim().length?aa(da(g.val().trim())):d.defaultDate&&void 0===g.attr("placeholder")&&aa(d.defaultDate),d.inline&&ga(),l};return a.fn.datetimepicker=function(b){b=b||{};var d,e=Array.prototype.slice.call(arguments,1),f=!0,g=["destroy","hide","show","toggle"];if("object"==typeof b)return this.each(function(){var d,e=a(this);e.data("DateTimePicker")||(d=a.extend(!0,{},a.fn.datetimepicker.defaults,b),e.data("DateTimePicker",c(e,d)))});if("string"==typeof b)return this.each(function(){var c=a(this),g=c.data("DateTimePicker");if(!g)throw new Error('bootstrap-datetimepicker("'+b+'") method was called on an element that is not using DateTimePicker');d=g[b].apply(g,e),f=d===g}),f||a.inArray(b,g)>-1?this:d;throw new TypeError("Invalid arguments for DateTimePicker: "+b)},a.fn.datetimepicker.defaults={timeZone:"",format:!1,dayViewHeaderFormat:"MMMM YYYY",extraFormats:!1,stepping:1,minDate:!1,maxDate:!1,useCurrent:!0,collapse:!0,locale:b.locale(),defaultDate:!1,disabledDates:!1,enabledDates:!1,icons:{time:"glyphicon glyphicon-time",date:"glyphicon glyphicon-calendar",up:"glyphicon glyphicon-chevron-up",down:"glyphicon glyphicon-chevron-down",previous:"glyphicon glyphicon-chevron-left",next:"glyphicon glyphicon-chevron-right",today:"glyphicon glyphicon-screenshot",clear:"glyphicon glyphicon-trash",close:"glyphicon glyphicon-remove"},tooltips:{today:"Go to today",clear:"Clear selection",close:"Close the picker",selectMonth:"Select Month",prevMonth:"Previous Month",nextMonth:"Next Month",selectYear:"Select Year",prevYear:"Previous Year",nextYear:"Next Year",selectDecade:"Select Decade",prevDecade:"Previous Decade",nextDecade:"Next Decade",prevCentury:"Previous Century",nextCentury:"Next Century",pickHour:"Pick Hour",incrementHour:"Increment Hour",decrementHour:"Decrement Hour",pickMinute:"Pick Minute",incrementMinute:"Increment Minute",decrementMinute:"Decrement Minute",pickSecond:"Pick Second",incrementSecond:"Increment Second",decrementSecond:"Decrement Second",togglePeriod:"Toggle Period",selectTime:"Select Time"},useStrict:!1,sideBySide:!1,daysOfWeekDisabled:!1,calendarWeeks:!1,viewMode:"days",toolbarPlacement:"default",showTodayButton:!1,showClear:!1,showClose:!1,widgetPositioning:{horizontal:"auto",vertical:"auto"},widgetParent:null,ignoreReadonly:!1,keepOpen:!1,focusOnShow:!0,inline:!1,keepInvalid:!1,datepickerInput:".datepickerinput",keyBinds:{up:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().subtract(7,"d")):this.date(b.clone().add(this.stepping(),"m"))}},down:function(a){if(!a)return void this.show();var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().add(7,"d")):this.date(b.clone().subtract(this.stepping(),"m"))},"control up":function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().subtract(1,"y")):this.date(b.clone().add(1,"h"))}},"control down":function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().add(1,"y")):this.date(b.clone().subtract(1,"h"))}},left:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().subtract(1,"d"))}},right:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().add(1,"d"))}},pageUp:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().subtract(1,"M"))}},pageDown:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().add(1,"M"))}},enter:function(){this.hide()},escape:function(){this.hide()},"control space":function(a){a&&a.find(".timepicker").is(":visible")&&a.find('.btn[data-action="togglePeriod"]').click()},t:function(){this.date(this.getMoment())},delete:function(){this.clear()}},debug:!1,allowInputToggle:!1,disabledTimeIntervals:!1,disabledHours:!1,enabledHours:!1,viewDate:!1},a.fn.datetimepicker});
},{"jquery":14,"moment":16}],28:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.cs={days:["Neděle","Pondělí","Úterý","Středa","Čtvrtek","Pátek","Sobota"],daysShort:["Ned","Pon","Úte","Stř","Čtv","Pát","Sob"],daysMin:["Ne","Po","Út","St","Čt","Pá","So"],months:["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"],monthsShort:["Led","Úno","Bře","Dub","Kvě","Čer","Čnc","Srp","Zář","Říj","Lis","Pro"],today:"Dnes",clear:"Vymazat",monthsTitle:"Měsíc",weekStart:1,format:"dd.m.yyyy"}}(jQuery);
},{}],29:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.de={days:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],daysShort:["So","Mo","Di","Mi","Do","Fr","Sa"],daysMin:["So","Mo","Di","Mi","Do","Fr","Sa"],months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthsShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],today:"Heute",monthsTitle:"Monate",clear:"Löschen",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
},{}],30:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.es={days:["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],daysShort:["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"],daysMin:["Do","Lu","Ma","Mi","Ju","Vi","Sa"],months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],monthsShort:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],today:"Hoy",monthsTitle:"Meses",clear:"Borrar",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
},{}],31:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.fr={days:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],daysShort:["dim","lun","mar","mer","jeu","ven","sam"],daysMin:["d","l","ma","me","j","v","s"],months:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthsShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],today:"Aujourd'hui",monthsTitle:"Mois",clear:"Effacer",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
},{}],32:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.hr={days:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],daysShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],daysMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],months:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],monthsShort:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],today:"Danas"}}(jQuery);
},{}],33:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.hu={days:["vasárnap","hétfő","kedd","szerda","csütörtök","péntek","szombat"],daysShort:["vas","hét","ked","sze","csü","pén","szo"],daysMin:["V","H","K","Sze","Cs","P","Szo"],months:["január","február","március","április","május","június","július","augusztus","szeptember","október","november","december"],monthsShort:["jan","feb","már","ápr","máj","jún","júl","aug","sze","okt","nov","dec"],today:"ma",weekStart:1,clear:"töröl",titleFormat:"yyyy. MM",format:"yyyy.mm.dd"}}(jQuery);
},{}],34:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.it={days:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],daysShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],daysMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthsShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],today:"Oggi",monthsTitle:"Mesi",clear:"Cancella",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
},{}],35:[function(require,module,exports){
!function(a){a.fn.datepicker.dates["nl-BE"]={days:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],daysShort:["zo","ma","di","wo","do","vr","za"],daysMin:["zo","ma","di","wo","do","vr","za"],months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthsShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],today:"Vandaag",monthsTitle:"Maanden",clear:"Leegmaken",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
},{}],36:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.nl={days:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],daysShort:["zo","ma","di","wo","do","vr","za"],daysMin:["zo","ma","di","wo","do","vr","za"],months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthsShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],today:"Vandaag",monthsTitle:"Maanden",clear:"Wissen",weekStart:1,format:"dd-mm-yyyy"}}(jQuery);
},{}],37:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.pl={days:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],daysShort:["Niedz.","Pon.","Wt.","Śr.","Czw.","Piąt.","Sob."],daysMin:["Ndz.","Pn.","Wt.","Śr.","Czw.","Pt.","Sob."],months:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],monthsShort:["Sty.","Lut.","Mar.","Kwi.","Maj","Cze.","Lip.","Sie.","Wrz.","Paź.","Lis.","Gru."],today:"Dzisiaj",weekStart:1,clear:"Wyczyść",format:"dd.mm.yyyy"}}(jQuery);
},{}],38:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.pt={days:["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"],daysShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],daysMin:["Do","Se","Te","Qu","Qu","Se","Sa"],months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthsShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],today:"Hoje",monthsTitle:"Meses",clear:"Limpar",format:"dd/mm/yyyy"}}(jQuery);
},{}],39:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.ro={days:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"],daysShort:["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"],daysMin:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],months:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],monthsShort:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"],today:"Astăzi",clear:"Șterge",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
},{}],40:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.ru={days:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"],daysShort:["Вск","Пнд","Втр","Срд","Чтв","Птн","Суб"],daysMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Сегодня",clear:"Очистить",format:"dd.mm.yyyy",weekStart:1,monthsTitle:"Месяцы"}}(jQuery);
},{}],41:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.sk={days:["Nedeľa","Pondelok","Utorok","Streda","Štvrtok","Piatok","Sobota"],daysShort:["Ned","Pon","Uto","Str","Štv","Pia","Sob"],daysMin:["Ne","Po","Ut","St","Št","Pia","So"],months:["Január","Február","Marec","Apríl","Máj","Jún","Júl","August","September","Október","November","December"],monthsShort:["Jan","Feb","Mar","Apr","Máj","Jún","Júl","Aug","Sep","Okt","Nov","Dec"],today:"Dnes",clear:"Vymazať",weekStart:1,format:"d.m.yyyy"}}(jQuery);
},{}],42:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.tr={days:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],daysShort:["Pz","Pzt","Sal","Çrş","Prş","Cu","Cts"],daysMin:["Pz","Pzt","Sa","Çr","Pr","Cu","Ct"],months:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],monthsShort:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],today:"Bugün",clear:"Temizle",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
},{}],43:[function(require,module,exports){
!function(a){a.fn.datepicker.dates.uk={days:["Неділя","Понеділок","Вівторок","Середа","Четвер","П'ятниця","Субота"],daysShort:["Нед","Пнд","Втр","Срд","Чтв","Птн","Суб"],daysMin:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Cічень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],monthsShort:["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],today:"Сьогодні",clear:"Очистити",format:"dd.mm.yyyy",weekStart:1}}(jQuery);
},{}],44:[function(require,module,exports){
/**
* @version: 3.0.5
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/
// Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Make globaly available as well
        define(['moment', 'jquery'], function (moment, jquery) {
            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
            if (typeof moment !== 'function' && moment.default) moment = moment.default
            return factory(moment, jquery);
        });
    } else if (typeof module === 'object' && module.exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = require('jquery/dist/jquery');
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment/min/moment-with-locales');
        module.exports = factory(moment, jQuery);
    } else {
        // Browser globals
        root.daterangepicker = factory(root.moment, root.jQuery);
    }
}(this, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {

        //default settings for options
        this.parentEl = 'body';
        this.element = $(element);
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.minDate = false;
        this.maxDate = false;
        this.maxSpan = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.minYear = moment().subtract(100, 'year').format('YYYY');
        this.maxYear = moment().add(100, 'year').format('YYYY');
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};

        this.opens = 'right';
        if (this.element.hasClass('pull-right'))
            this.opens = 'left';

        this.drops = 'down';
        if (this.element.hasClass('dropup'))
            this.drops = 'up';

        this.buttonClasses = 'btn btn-sm';
        this.applyButtonClasses = 'btn-primary';
        this.cancelButtonClasses = 'btn-default';

        this.locale = {
            direction: 'ltr',
            format: moment.localeData().longDateFormat('L'),
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };

        this.callback = function() { };

        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};

        //custom options from user
        if (typeof options !== 'object' || options === null)
            options = {};

        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);

        //html template for the picker UI
        if (typeof options.template !== 'string' && !(options.template instanceof $))
            options.template =
            '<div class="daterangepicker">' +
                '<div class="ranges"></div>' +
                '<div class="drp-calendar left">' +
                    '<div class="calendar-table"></div>' +
                    '<div class="calendar-time"></div>' +
                '</div>' +
                '<div class="drp-calendar right">' +
                    '<div class="calendar-table"></div>' +
                    '<div class="calendar-time"></div>' +
                '</div>' +
                '<div class="drp-buttons">' +
                    '<span class="drp-selected"></span>' +
                    '<button class="cancelBtn" type="button"></button>' +
                    '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
                '</div>' +
            '</div>';

        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);

        //
        // handle all the possible options overriding defaults
        //

        if (typeof options.locale === 'object') {

            if (typeof options.locale.direction === 'string')
                this.locale.direction = options.locale.direction;

            if (typeof options.locale.format === 'string')
                this.locale.format = options.locale.format;

            if (typeof options.locale.separator === 'string')
                this.locale.separator = options.locale.separator;

            if (typeof options.locale.daysOfWeek === 'object')
                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();

            if (typeof options.locale.monthNames === 'object')
              this.locale.monthNames = options.locale.monthNames.slice();

            if (typeof options.locale.firstDay === 'number')
              this.locale.firstDay = options.locale.firstDay;

            if (typeof options.locale.applyLabel === 'string')
              this.locale.applyLabel = options.locale.applyLabel;

            if (typeof options.locale.cancelLabel === 'string')
              this.locale.cancelLabel = options.locale.cancelLabel;

            if (typeof options.locale.weekLabel === 'string')
              this.locale.weekLabel = options.locale.weekLabel;

            if (typeof options.locale.customRangeLabel === 'string'){
                //Support unicode chars in the custom range name.
                var elem = document.createElement('textarea');
                elem.innerHTML = options.locale.customRangeLabel;
                var rangeHtml = elem.value;
                this.locale.customRangeLabel = rangeHtml;
            }
        }
        this.container.addClass(this.locale.direction);

        if (typeof options.startDate === 'string')
            this.startDate = moment(options.startDate, this.locale.format);

        if (typeof options.endDate === 'string')
            this.endDate = moment(options.endDate, this.locale.format);

        if (typeof options.minDate === 'string')
            this.minDate = moment(options.minDate, this.locale.format);

        if (typeof options.maxDate === 'string')
            this.maxDate = moment(options.maxDate, this.locale.format);

        if (typeof options.startDate === 'object')
            this.startDate = moment(options.startDate);

        if (typeof options.endDate === 'object')
            this.endDate = moment(options.endDate);

        if (typeof options.minDate === 'object')
            this.minDate = moment(options.minDate);

        if (typeof options.maxDate === 'object')
            this.maxDate = moment(options.maxDate);

        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate))
            this.startDate = this.minDate.clone();

        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate))
            this.endDate = this.maxDate.clone();

        if (typeof options.applyButtonClasses === 'string')
            this.applyButtonClasses = options.applyButtonClasses;

        if (typeof options.applyClass === 'string') //backwards compat
            this.applyButtonClasses = options.applyClass;

        if (typeof options.cancelButtonClasses === 'string')
            this.cancelButtonClasses = options.cancelButtonClasses;

        if (typeof options.cancelClass === 'string') //backwards compat
            this.cancelButtonClasses = options.cancelClass;

        if (typeof options.maxSpan === 'object')
            this.maxSpan = options.maxSpan;

        if (typeof options.dateLimit === 'object') //backwards compat
            this.maxSpan = options.dateLimit;

        if (typeof options.opens === 'string')
            this.opens = options.opens;

        if (typeof options.drops === 'string')
            this.drops = options.drops;

        if (typeof options.showWeekNumbers === 'boolean')
            this.showWeekNumbers = options.showWeekNumbers;

        if (typeof options.showISOWeekNumbers === 'boolean')
            this.showISOWeekNumbers = options.showISOWeekNumbers;

        if (typeof options.buttonClasses === 'string')
            this.buttonClasses = options.buttonClasses;

        if (typeof options.buttonClasses === 'object')
            this.buttonClasses = options.buttonClasses.join(' ');

        if (typeof options.showDropdowns === 'boolean')
            this.showDropdowns = options.showDropdowns;

        if (typeof options.minYear === 'number')
            this.minYear = options.minYear;

        if (typeof options.maxYear === 'number')
            this.maxYear = options.maxYear;

        if (typeof options.showCustomRangeLabel === 'boolean')
            this.showCustomRangeLabel = options.showCustomRangeLabel;

        if (typeof options.singleDatePicker === 'boolean') {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker)
                this.endDate = this.startDate.clone();
        }

        if (typeof options.timePicker === 'boolean')
            this.timePicker = options.timePicker;

        if (typeof options.timePickerSeconds === 'boolean')
            this.timePickerSeconds = options.timePickerSeconds;

        if (typeof options.timePickerIncrement === 'number')
            this.timePickerIncrement = options.timePickerIncrement;

        if (typeof options.timePicker24Hour === 'boolean')
            this.timePicker24Hour = options.timePicker24Hour;

        if (typeof options.autoApply === 'boolean')
            this.autoApply = options.autoApply;

        if (typeof options.autoUpdateInput === 'boolean')
            this.autoUpdateInput = options.autoUpdateInput;

        if (typeof options.linkedCalendars === 'boolean')
            this.linkedCalendars = options.linkedCalendars;

        if (typeof options.isInvalidDate === 'function')
            this.isInvalidDate = options.isInvalidDate;

        if (typeof options.isCustomDate === 'function')
            this.isCustomDate = options.isCustomDate;

        if (typeof options.alwaysShowCalendars === 'boolean')
            this.alwaysShowCalendars = options.alwaysShowCalendars;

        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while (iterator > 0) {
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }

        var start, end, range;

        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
            if ($(this.element).is(':text')) {
                var val = $(this.element).val(),
                    split = val.split(this.locale.separator);

                start = end = null;

                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }

        if (typeof options.ranges === 'object') {
            for (range in options.ranges) {

                if (typeof options.ranges[range][0] === 'string')
                    start = moment(options.ranges[range][0], this.locale.format);
                else
                    start = moment(options.ranges[range][0]);

                if (typeof options.ranges[range][1] === 'string')
                    end = moment(options.ranges[range][1], this.locale.format);
                else
                    end = moment(options.ranges[range][1]);

                // If the start or end date exceed those allowed by the minDate or maxSpan
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate))
                    start = this.minDate.clone();

                var maxDate = this.maxDate;
                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate))
                    maxDate = start.clone().add(this.maxSpan);
                if (maxDate && end.isAfter(maxDate))
                    end = maxDate.clone();

                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day'))
                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
                    continue;

                //Support unicode chars in the range names.
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;

                this.ranges[rangeHtml] = [start, end];
            }

            var list = '<ul>';
            for (range in this.ranges) {
                list += '<li data-range-key="' + range + '">' + range + '</li>';
            }
            if (this.showCustomRangeLabel) {
                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            }
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }

        if (typeof cb === 'function') {
            this.callback = cb;
        }

        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }

        //can't be used together for now
        if (this.timePicker && this.autoApply)
            this.autoApply = false;

        if (this.autoApply) {
            this.container.addClass('auto-apply');
        }

        if (typeof options.ranges === 'object')
            this.container.addClass('show-ranges');

        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.drp-calendar.left').addClass('single');
            this.container.find('.drp-calendar.left').show();
            this.container.find('.drp-calendar.right').hide();
            if (!this.timePicker) {
                this.container.addClass('auto-apply');
            }
        }

        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
            this.container.addClass('show-calendar');
        }

        this.container.addClass('opens' + this.opens);

        //apply CSS classes and labels to buttons
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyButtonClasses.length)
            this.container.find('.applyBtn').addClass(this.applyButtonClasses);
        if (this.cancelButtonClasses.length)
            this.container.find('.cancelBtn').addClass(this.cancelButtonClasses);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);

        //
        // event listeners
        //

        this.container.find('.drp-calendar')
            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))

        this.container.find('.ranges')
            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))

        this.container.find('.drp-buttons')
            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))

        if (this.element.is('input') || this.element.is('button')) {
            this.element.on({
                'click.daterangepicker': $.proxy(this.show, this),
                'focus.daterangepicker': $.proxy(this.show, this),
                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
                'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
            });
        } else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
        }

        //
        // if attached to a text input, set the initial value
        //

        this.updateElement();

    };

    DateRangePicker.prototype = {

        constructor: DateRangePicker,

        setStartDate: function(startDate) {
            if (typeof startDate === 'string')
                this.startDate = moment(startDate, this.locale.format);

            if (typeof startDate === 'object')
                this.startDate = moment(startDate);

            if (!this.timePicker)
                this.startDate = this.startDate.startOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        setEndDate: function(endDate) {
            if (typeof endDate === 'string')
                this.endDate = moment(endDate, this.locale.format);

            if (typeof endDate === 'object')
                this.endDate = moment(endDate);

            if (!this.timePicker)
                this.endDate = this.endDate.endOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.endDate.isBefore(this.startDate))
                this.endDate = this.startDate.clone();

            if (this.maxDate && this.endDate.isAfter(this.maxDate))
                this.endDate = this.maxDate.clone();

            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate))
                this.endDate = this.startDate.clone().add(this.maxSpan);

            this.previousRightTime = this.endDate.clone();

            this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        isInvalidDate: function() {
            return false;
        },

        isCustomDate: function() {
            return false;
        },

        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker('left');
                this.renderTimePicker('right');
                if (!this.endDate) {
                    this.container.find('.right .calendar-time select').prop('disabled', true).addClass('disabled');
                } else {
                    this.container.find('.right .calendar-time select').prop('disabled', false).removeClass('disabled');
                }
            }
            if (this.endDate)
                this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },

        updateMonthsInView: function() {
            if (this.endDate) {

                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    &&
                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    ) {
                    return;
                }

                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
                    this.rightCalendar.month = this.endDate.clone().date(2);
                } else {
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }

            } else {
                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                    this.leftCalendar.month = this.startDate.clone().date(2);
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
              this.rightCalendar.month = this.maxDate.clone().date(2);
              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
            }
        },

        updateCalendars: function() {

            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    }
                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    }
                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }

            this.renderCalendar('left');
            this.renderCalendar('right');

            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;

            this.calculateChosenLabel();
        },

        renderCalendar: function(side) {

            //
            // Build the matrix of dates that will populate the calendar
            //

            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([year, month]).daysInMonth();
            var firstDay = moment([year, month, 1]);
            var lastDay = moment([year, month, daysInMonth]);
            var lastMonth = moment(firstDay).subtract(1, 'month').month();
            var lastYear = moment(firstDay).subtract(1, 'month').year();
            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
            var dayOfWeek = firstDay.day();

            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;

            for (var i = 0; i < 6; i++) {
                calendar[i] = [];
            }

            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth)
                startDay -= 7;

            if (dayOfWeek == this.locale.firstDay)
                startDay = daysInLastMonth - 6;

            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

            var col, row;
            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);

                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
                    calendar[row][col] = this.minDate.clone();
                }

                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
                    calendar[row][col] = this.maxDate.clone();
                }

            }

            //make the calendar object available to hoverDate/clickDate
            if (side == 'left') {
                this.leftCalendar.calendar = calendar;
            } else {
                this.rightCalendar.calendar = calendar;
            }

            //
            // Display the calendar
            //

            var minDate = side == 'left' ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == 'left' ? this.startDate : this.endDate;
            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};

            var html = '<table class="table-condensed">';
            html += '<thead>';
            html += '<tr>';

            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th></th>';

            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
                html += '<th class="prev available"><span></span></th>';
            } else {
                html += '<th></th>';
            }

            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = (maxDate && maxDate.year()) || (this.maxYear);
                var minYear = (minDate && minDate.year()) || (this.minYear);
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;

                var monthHtml = '<select class="monthselect">';
                for (var m = 0; m < 12; m++) {
                    if ((!inMinYear || (minDate && m >= minDate.month())) && (!inMaxYear || (maxDate && m <= maxDate.month()))) {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            ">" + this.locale.monthNames[m] + "</option>";
                    } else {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                    }
                }
                monthHtml += "</select>";

                var yearHtml = '<select class="yearselect">';
                for (var y = minYear; y <= maxYear; y++) {
                    yearHtml += '<option value="' + y + '"' +
                        (y === currentYear ? ' selected="selected"' : '') +
                        '>' + y + '</option>';
                }
                yearHtml += '</select>';

                dateHtml = monthHtml + yearHtml;
            }

            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
                html += '<th class="next available"><span></span></th>';
            } else {
                html += '<th></th>';
            }

            html += '</tr>';
            html += '<tr>';

            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th class="week">' + this.locale.weekLabel + '</th>';

            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += '<th>' + dayOfWeek + '</th>';
            });

            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';

            //adjust maxDate to reflect the maxSpan setting in order to
            //grey out end dates beyond the maxSpan
            if (this.endDate == null && this.maxSpan) {
                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
                if (!maxDate || maxLimit.isBefore(maxDate)) {
                    maxDate = maxLimit;
                }
            }

            for (var row = 0; row < 6; row++) {
                html += '<tr>';

                // add week number
                if (this.showWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
                else if (this.showISOWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

                for (var col = 0; col < 7; col++) {

                    var classes = [];

                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day"))
                        classes.push('today');

                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5)
                        classes.push('weekend');

                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month())
                        classes.push('off', 'ends');

                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col]))
                        classes.push('off', 'disabled');

                    //highlight the currently selected start date
                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
                        classes.push('active', 'start-date');

                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
                        classes.push('active', 'end-date');

                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                        classes.push('in-range');

                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === 'string')
                            classes.push(isCustom);
                        else
                            Array.prototype.push.apply(classes, isCustom);
                    }

                    var cname = '', disabled = false;
                    for (var i = 0; i < classes.length; i++) {
                        cname += classes[i] + ' ';
                        if (classes[i] == 'disabled')
                            disabled = true;
                    }
                    if (!disabled)
                        cname += 'available';

                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';

                }
                html += '</tr>';
            }

            html += '</tbody>';
            html += '</table>';

            this.container.find('.drp-calendar.' + side + ' .calendar-table').html(html);

        },

        renderTimePicker: function(side) {

            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == 'right' && !this.endDate) return;

            var html, selected, minDate, maxDate = this.maxDate;

            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate)))
                maxDate = this.startDate.clone().add(this.maxSpan);

            if (side == 'left') {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == 'right') {
                selected = this.endDate.clone();
                minDate = this.startDate;

                //Preserve the time already selected
                var timeSelector = this.container.find('.drp-calendar.right .calendar-time');
                if (timeSelector.html() != '') {

                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find('.hourselect option:selected').val());
                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find('.minuteselect option:selected').val());
                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find('.secondselect option:selected').val());

                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find('.ampmselect option:selected').val();
                        if (ampm === 'PM' && selected.hour() < 12)
                            selected.hour(selected.hour() + 12);
                        if (ampm === 'AM' && selected.hour() === 12)
                            selected.hour(0);
                    }

                }

                if (selected.isBefore(this.startDate))
                    selected = this.startDate.clone();

                if (maxDate && selected.isAfter(maxDate))
                    selected = maxDate.clone();

            }

            //
            // hours
            //

            html = '<select class="hourselect">';

            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;

            for (var i = start; i <= end; i++) {
                var i_in_24 = i;
                if (!this.timePicker24Hour)
                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);

                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate))
                    disabled = true;

                if (i_in_24 == selected.hour() && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
                } else {
                    html += '<option value="' + i + '">' + i + '</option>';
                }
            }

            html += '</select> ';

            //
            // minutes
            //

            html += ': <select class="minuteselect">';

            for (var i = 0; i < 60; i += this.timePickerIncrement) {
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().minute(i);

                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate))
                    disabled = true;

                if (selected.minute() == i && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                } else {
                    html += '<option value="' + i + '">' + padded + '</option>';
                }
            }

            html += '</select> ';

            //
            // seconds
            //

            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';

                for (var i = 0; i < 60; i++) {
                    var padded = i < 10 ? '0' + i : i;
                    var time = selected.clone().second(i);

                    var disabled = false;
                    if (minDate && time.isBefore(minDate))
                        disabled = true;
                    if (maxDate && time.isAfter(maxDate))
                        disabled = true;

                    if (selected.second() == i && !disabled) {
                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                    } else if (disabled) {
                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                    } else {
                        html += '<option value="' + i + '">' + padded + '</option>';
                    }
                }

                html += '</select> ';
            }

            //
            // AM/PM
            //

            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';

                var am_html = '';
                var pm_html = '';

                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
                    am_html = ' disabled="disabled" class="disabled"';

                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
                    pm_html = ' disabled="disabled" class="disabled"';

                if (selected.hour() >= 12) {
                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
                } else {
                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
                }

                html += '</select>';
            }

            this.container.find('.drp-calendar.' + side + ' .calendar-time').html(html);

        },

        updateFormInputs: function() {

            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
                this.container.find('button.applyBtn').prop('disabled', false);
            } else {
                this.container.find('button.applyBtn').prop('disabled', true);
            }

        },

        move: function() {
            var parentOffset = { top: 0, left: 0 },
                containerTop;
            var parentRightEdge = $(window).width();
            if (!this.parentEl.is('body')) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }

            if (this.drops == 'up')
                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
            else
                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;

            // Force the container to it's actual width
            this.container.css({
              top: 0,
              left: 0,
              right: 'auto'
            });
            var containerWidth = this.container.outerWidth();

            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('drop-up');

            if (this.opens == 'left') {
                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
                if (containerWidth + containerRight > $(window).width()) {
                    this.container.css({
                        top: containerTop,
                        right: 'auto',
                        left: 9
                    });
                } else {
                    this.container.css({
                        top: containerTop,
                        right: containerRight,
                        left: 'auto'
                    });
                }
            } else if (this.opens == 'center') {
                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
                                        - containerWidth / 2;
                if (containerLeft < 0) {
                    this.container.css({
                        top: containerTop,
                        right: 'auto',
                        left: 9
                    });
                } else if (containerLeft + containerWidth > $(window).width()) {
                    this.container.css({
                        top: containerTop,
                        left: 'auto',
                        right: 0
                    });
                } else {
                    this.container.css({
                        top: containerTop,
                        left: containerLeft,
                        right: 'auto'
                    });
                }
            } else {
                var containerLeft = this.element.offset().left - parentOffset.left;
                if (containerLeft + containerWidth > $(window).width()) {
                    this.container.css({
                        top: containerTop,
                        left: 'auto',
                        right: 0
                    });
                } else {
                    this.container.css({
                        top: containerTop,
                        left: containerLeft,
                        right: 'auto'
                    });
                }
            }
        },

        show: function(e) {
            if (this.isShowing) return;

            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);

            // Bind global datepicker mousedown for hiding and
            $(document)
              .on('mousedown.daterangepicker', this._outsideClickProxy)
              // also support mobile devices
              .on('touchend.daterangepicker', this._outsideClickProxy)
              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
              // and also close when focus changes to outside the picker (eg. tabbing between controls)
              .on('focusin.daterangepicker', this._outsideClickProxy);

            // Reposition the picker if the window is resized while it's open
            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));

            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();

            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger('show.daterangepicker', this);
            this.isShowing = true;
        },

        hide: function(e) {
            if (!this.isShowing) return;

            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }

            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
                this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);

            //if picker is attached to a text input, update it
            this.updateElement();

            $(document).off('.daterangepicker');
            $(window).off('.daterangepicker');
            this.container.hide();
            this.element.trigger('hide.daterangepicker', this);
            this.isShowing = false;
        },

        toggle: function(e) {
            if (this.isShowing) {
                this.hide();
            } else {
                this.show();
            }
        },

        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (
                // ie modal dialog fix
                e.type == "focusin" ||
                target.closest(this.element).length ||
                target.closest(this.container).length ||
                target.closest('.calendar-table').length
                ) return;
            this.hide();
            this.element.trigger('outsideClick.daterangepicker', this);
        },

        showCalendars: function() {
            this.container.addClass('show-calendar');
            this.move();
            this.element.trigger('showCalendar.daterangepicker', this);
        },

        hideCalendars: function() {
            this.container.removeClass('show-calendar');
            this.element.trigger('hideCalendar.daterangepicker', this);
        },

        clickRange: function(e) {
            var label = e.target.getAttribute('data-range-key');
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) {
                this.showCalendars();
            } else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];

                if (!this.timePicker) {
                    this.startDate.startOf('day');
                    this.endDate.endOf('day');
                }

                if (!this.alwaysShowCalendars)
                    this.hideCalendars();
                this.clickApply();
            }
        },

        clickPrev: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.subtract(1, 'month');
                if (this.linkedCalendars)
                    this.rightCalendar.month.subtract(1, 'month');
            } else {
                this.rightCalendar.month.subtract(1, 'month');
            }
            this.updateCalendars();
        },

        clickNext: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.add(1, 'month');
            } else {
                this.rightCalendar.month.add(1, 'month');
                if (this.linkedCalendars)
                    this.leftCalendar.month.add(1, 'month');
            }
            this.updateCalendars();
        },

        hoverDate: function(e) {

            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) {
                this.container.find('.drp-calendar tbody td').each(function(index, el) {

                    //skip week numbers, only look at dates
                    if ($(el).hasClass('week')) return;

                    var title = $(el).attr('data-title');
                    var row = title.substr(1, 1);
                    var col = title.substr(3, 1);
                    var cal = $(el).parents('.drp-calendar');
                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];

                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                        $(el).addClass('in-range');
                    } else {
                        $(el).removeClass('in-range');
                    }

                });
            }

        },

        clickDate: function(e) {

            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //

            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    }
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) {
                //special case: clicking the same date for start/end,
                //but the time of the end date is before the start date
                this.setEndDate(this.startDate.clone());
            } else { // picking end
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    }
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                  this.calculateChosenLabel();
                  this.clickApply();
                }
            }

            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker)
                    this.clickApply();
            }

            this.updateView();

            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();

        },

        calculateChosenLabel: function () {
            var customRange = true;
            var i = 0;
            for (var range in this.ranges) {
              if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
                    //ignore times when comparing dates if time picker seconds is not enabled
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                        break;
                    }
                } else {
                    //ignore times when comparing dates if time picker is not enabled
                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                        break;
                    }
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) {
                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').attr('data-range-key');
                } else {
                    this.chosenLabel = null;
                }
                this.showCalendars();
            }
        },

        clickApply: function(e) {
            this.hide();
            this.element.trigger('apply.daterangepicker', this);
        },

        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger('cancel.daterangepicker', this);
        },

        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest('.drp-calendar').hasClass('left'),
                leftOrRight = isLeft ? 'left' : 'right',
                cal = this.container.find('.drp-calendar.'+leftOrRight);

            // Month must be Number for new moment versions
            var month = parseInt(cal.find('.monthselect').val(), 10);
            var year = cal.find('.yearselect').val();

            if (!isLeft) {
                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }

            if (this.minDate) {
                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }

            if (this.maxDate) {
                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }

            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
            this.updateCalendars();
        },

        timeChanged: function(e) {

            var cal = $(e.target).closest('.drp-calendar'),
                isLeft = cal.hasClass('left');

            var hour = parseInt(cal.find('.hourselect').val(), 10);
            var minute = parseInt(cal.find('.minuteselect').val(), 10);
            if (isNaN(minute)) {
                minute = parseInt(cal.find('.minuteselect option:last').val(), 10);
            }
            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

            if (!this.timePicker24Hour) {
                var ampm = cal.find('.ampmselect').val();
                if (ampm === 'PM' && hour < 12)
                    hour += 12;
                if (ampm === 'AM' && hour === 12)
                    hour = 0;
            }

            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) {
                    this.endDate = this.startDate.clone();
                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                    this.setEndDate(start.clone());
                }
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }

            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();

            //update the form inputs above the calendars with the new time
            this.updateFormInputs();

            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker('left');
            this.renderTimePicker('right');

        },

        elementChanged: function() {
            if (!this.element.is('input')) return;
            if (!this.element.val().length) return;

            var dateString = this.element.val().split(this.locale.separator),
                start = null,
                end = null;

            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }

            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }

            if (!start.isValid() || !end.isValid()) return;

            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },

        keydown: function(e) {
            //hide on tab or enter
            if ((e.keyCode === 9) || (e.keyCode === 13)) {
                this.hide();
            }

            //hide on esc and prevent propagation
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();

                this.hide();
            }
        },

        updateElement: function() {
            if (this.element.is('input') && this.autoUpdateInput) {
                var newValue = this.startDate.format(this.locale.format);
                if (!this.singleDatePicker) {
                    newValue += this.locale.separator + this.endDate.format(this.locale.format);
                }
                if (newValue !== this.element.val()) {
                    this.element.val(newValue).trigger('change');
                }
            }
        },

        remove: function() {
            this.container.remove();
            this.element.off('.daterangepicker');
            this.element.removeData();
        }

    };

    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker'))
                el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };

    return DateRangePicker;

}));

},{"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],45:[function(require,module,exports){
!function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=184)}([function(t,e,n){var r=n(2),i=n(13).f,o=n(16),a=n(14),c=n(84),s=n(114),u=n(54);t.exports=function(t,e){var n,l,f,h,d,p=t.target,g=t.global,v=t.stat;if(n=g?r:v?r[p]||c(p,{}):(r[p]||{}).prototype)for(l in e){if(h=e[l],f=t.noTargetGet?(d=i(n,l))&&d.value:n[l],!u(g?l:p+(v?".":"#")+l,t.forced)&&void 0!==f){if(typeof h==typeof f)continue;s(h,f)}(t.sham||f&&f.sham)&&o(h,"sham",!0),a(n,l,h,t)}}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){(function(e){var n=function(t){return t&&t.Math==Math&&t};t.exports=n("object"==typeof globalThis&&globalThis)||n("object"==typeof window&&window)||n("object"==typeof self&&self)||n("object"==typeof e&&e)||Function("return this")()}).call(this,n(185))},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var r=n(3);t.exports=function(t){if(!r(t))throw TypeError(String(t)+" is not an object");return t}},function(t,e,n){var r=n(1);t.exports=!r((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},function(t,e,n){var r=n(2),i=n(86),o=n(11),a=n(50),c=n(90),s=n(116),u=i("wks"),l=r.Symbol,f=s?l:l&&l.withoutSetter||a;t.exports=function(t){return o(u,t)||(c&&o(l,t)?u[t]=l[t]:u[t]=f("Symbol."+t)),u[t]}},function(t,e,n){var r=n(26),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,e,n){"use strict";var r,i=n(108),o=n(5),a=n(2),c=n(3),s=n(11),u=n(60),l=n(16),f=n(14),h=n(9).f,d=n(29),p=n(43),g=n(6),v=n(50),y=a.Int8Array,m=y&&y.prototype,b=a.Uint8ClampedArray,E=b&&b.prototype,w=y&&d(y),_=m&&d(m),S=Object.prototype,T=S.isPrototypeOf,I=g("toStringTag"),x=v("TYPED_ARRAY_TAG"),O=i&&!!p&&"Opera"!==u(a.opera),k=!1,M={Int8Array:1,Uint8Array:1,Uint8ClampedArray:1,Int16Array:2,Uint16Array:2,Int32Array:4,Uint32Array:4,Float32Array:4,Float64Array:8},N=function(t){return c(t)&&s(M,u(t))};for(r in M)a[r]||(O=!1);if((!O||"function"!=typeof w||w===Function.prototype)&&(w=function(){throw TypeError("Incorrect invocation")},O))for(r in M)a[r]&&p(a[r],w);if((!O||!_||_===S)&&(_=w.prototype,O))for(r in M)a[r]&&p(a[r].prototype,_);if(O&&d(E)!==_&&p(E,_),o&&!s(_,I))for(r in k=!0,h(_,I,{get:function(){return c(this)?this[x]:void 0}}),M)a[r]&&l(a[r],x,r);t.exports={NATIVE_ARRAY_BUFFER_VIEWS:O,TYPED_ARRAY_TAG:k&&x,aTypedArray:function(t){if(N(t))return t;throw TypeError("Target is not a typed array")},aTypedArrayConstructor:function(t){if(p){if(T.call(w,t))return t}else for(var e in M)if(s(M,r)){var n=a[e];if(n&&(t===n||T.call(n,t)))return t}throw TypeError("Target is not a typed array constructor")},exportTypedArrayMethod:function(t,e,n){if(o){if(n)for(var r in M){var i=a[r];i&&s(i.prototype,t)&&delete i.prototype[t]}_[t]&&!n||f(_,t,n?e:O&&m[t]||e)}},exportTypedArrayStaticMethod:function(t,e,n){var r,i;if(o){if(p){if(n)for(r in M)(i=a[r])&&s(i,t)&&delete i[t];if(w[t]&&!n)return;try{return f(w,t,n?e:O&&y[t]||e)}catch(t){}}for(r in M)!(i=a[r])||i[t]&&!n||f(i,t,e)}},isView:function(t){var e=u(t);return"DataView"===e||s(M,e)},isTypedArray:N,TypedArray:w,TypedArrayPrototype:_}},function(t,e,n){var r=n(5),i=n(111),o=n(4),a=n(27),c=Object.defineProperty;e.f=r?c:function(t,e,n){if(o(t),e=a(e,!0),o(n),i)try{return c(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(15);t.exports=function(t){return Object(r(t))}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(37),i=n(49),o=n(10),a=n(7),c=n(56),s=[].push,u=function(t){var e=1==t,n=2==t,u=3==t,l=4==t,f=6==t,h=5==t||f;return function(d,p,g,v){for(var y,m,b=o(d),E=i(b),w=r(p,g,3),_=a(E.length),S=0,T=v||c,I=e?T(d,_):n?T(d,0):void 0;_>S;S++)if((h||S in E)&&(m=w(y=E[S],S,b),t))if(e)I[S]=m;else if(m)switch(t){case 3:return!0;case 5:return y;case 6:return S;case 2:s.call(I,y)}else if(l)return!1;return f?-1:u||l?l:I}};t.exports={forEach:u(0),map:u(1),filter:u(2),some:u(3),every:u(4),find:u(5),findIndex:u(6)}},function(t,e,n){var r=n(5),i=n(64),o=n(35),a=n(21),c=n(27),s=n(11),u=n(111),l=Object.getOwnPropertyDescriptor;e.f=r?l:function(t,e){if(t=a(t),e=c(e,!0),u)try{return l(t,e)}catch(t){}if(s(t,e))return o(!i.f.call(t,e),t[e])}},function(t,e,n){var r=n(2),i=n(16),o=n(11),a=n(84),c=n(85),s=n(17),u=s.get,l=s.enforce,f=String(String).split("String");(t.exports=function(t,e,n,c){var s=!!c&&!!c.unsafe,u=!!c&&!!c.enumerable,h=!!c&&!!c.noTargetGet;"function"==typeof n&&("string"!=typeof e||o(n,"name")||i(n,"name",e),l(n).source=f.join("string"==typeof e?e:"")),t!==r?(s?!h&&t[e]&&(u=!0):delete t[e],u?t[e]=n:i(t,e,n)):u?t[e]=n:a(e,n)})(Function.prototype,"toString",(function(){return"function"==typeof this&&u(this).source||c(this)}))},function(t,e){t.exports=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t}},function(t,e,n){var r=n(5),i=n(9),o=n(35);t.exports=r?function(t,e,n){return i.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r,i,o,a=n(113),c=n(2),s=n(3),u=n(16),l=n(11),f=n(65),h=n(51),d=c.WeakMap;if(a){var p=new d,g=p.get,v=p.has,y=p.set;r=function(t,e){return y.call(p,t,e),e},i=function(t){return g.call(p,t)||{}},o=function(t){return v.call(p,t)}}else{var m=f("state");h[m]=!0,r=function(t,e){return u(t,m,e),e},i=function(t){return l(t,m)?t[m]:{}},o=function(t){return l(t,m)}}t.exports={set:r,get:i,has:o,enforce:function(t){return o(t)?i(t):r(t,{})},getterFor:function(t){return function(e){var n;if(!s(e)||(n=i(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return n}}}},function(t,e,n){var r=n(52),i=n(11),o=n(119),a=n(9).f;t.exports=function(t){var e=r.Symbol||(r.Symbol={});i(e,t)||a(e,t,{value:o.f(t)})}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t}},function(t,e,n){var r=n(5),i=n(1),o=n(11),a=Object.defineProperty,c={},s=function(t){throw t};t.exports=function(t,e){if(o(c,t))return c[t];e||(e={});var n=[][t],u=!!o(e,"ACCESSORS")&&e.ACCESSORS,l=o(e,0)?e[0]:s,f=o(e,1)?e[1]:void 0;return c[t]=!!n&&!i((function(){if(u&&!r)return!0;var t={length:-1};u?a(t,1,{enumerable:!0,get:s}):t[1]=1,n.call(t,l,f)}))}},function(t,e,n){var r=n(49),i=n(15);t.exports=function(t){return r(i(t))}},function(t,e,n){var r=n(15),i=/"/g;t.exports=function(t,e,n,o){var a=String(r(t)),c="<"+e;return""!==n&&(c+=" "+n+'="'+String(o).replace(i,"&quot;")+'"'),c+">"+a+"</"+e+">"}},function(t,e,n){var r=n(1);t.exports=function(t){return r((function(){var e=""[t]('"');return e!==e.toLowerCase()||e.split('"').length>3}))}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){var r=n(52),i=n(2),o=function(t){return"function"==typeof t?t:void 0};t.exports=function(t,e){return arguments.length<2?o(r[t])||o(i[t]):r[t]&&r[t][e]||i[t]&&i[t][e]}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(3);t.exports=function(t,e){if(!r(t))return t;var n,i;if(e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;if("function"==typeof(n=t.valueOf)&&!r(i=n.call(t)))return i;if(!e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},function(t,e){t.exports=!1},function(t,e,n){var r=n(11),i=n(10),o=n(65),a=n(97),c=o("IE_PROTO"),s=Object.prototype;t.exports=a?Object.getPrototypeOf:function(t){return t=i(t),r(t,c)?t[c]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e,n){var r=n(9).f,i=n(11),o=n(6)("toStringTag");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,o)&&r(t,o,{configurable:!0,value:e})}},function(t,e,n){var r,i=n(4),o=n(91),a=n(88),c=n(51),s=n(117),u=n(83),l=n(65),f=l("IE_PROTO"),h=function(){},d=function(t){return"<script>"+t+"<\/script>"},p=function(){try{r=document.domain&&new ActiveXObject("htmlfile")}catch(t){}var t,e;p=r?function(t){t.write(d("")),t.close();var e=t.parentWindow.Object;return t=null,e}(r):((e=u("iframe")).style.display="none",s.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(d("document.F=Object")),t.close(),t.F);for(var n=a.length;n--;)delete p.prototype[a[n]];return p()};c[f]=!0,t.exports=Object.create||function(t,e){var n;return null!==t?(h.prototype=i(t),n=new h,h.prototype=null,n[f]=t):n=p(),void 0===e?n:o(n,e)}},function(t,e,n){"use strict";var r=n(1);t.exports=function(t,e){var n=[][t];return!!n&&r((function(){n.call(null,e||function(){throw 1},1)}))}},function(t,e,n){var r=n(4),i=n(19),o=n(6)("species");t.exports=function(t,e){var n,a=r(t).constructor;return void 0===a||null==(n=r(a)[o])?e:i(n)}},function(t,e,n){"use strict";var r=n(0),i=n(2),o=n(5),a=n(109),c=n(8),s=n(82),u=n(39),l=n(35),f=n(16),h=n(7),d=n(179),p=n(180),g=n(27),v=n(11),y=n(60),m=n(3),b=n(31),E=n(43),w=n(40).f,_=n(181),S=n(12).forEach,T=n(47),I=n(9),x=n(13),O=n(17),k=n(69),M=O.get,N=O.set,R=I.f,A=x.f,D=Math.round,$=i.RangeError,L=s.ArrayBuffer,j=s.DataView,P=c.NATIVE_ARRAY_BUFFER_VIEWS,C=c.TYPED_ARRAY_TAG,F=c.TypedArray,U=c.TypedArrayPrototype,V=c.aTypedArrayConstructor,z=c.isTypedArray,Y=function(t,e){for(var n=0,r=e.length,i=new(V(t))(r);r>n;)i[n]=e[n++];return i},W=function(t,e){R(t,e,{get:function(){return M(this)[e]}})},H=function(t){var e;return t instanceof L||"ArrayBuffer"==(e=y(t))||"SharedArrayBuffer"==e},G=function(t,e){return z(t)&&"symbol"!=typeof e&&e in t&&String(+e)==String(e)},B=function(t,e){return G(t,e=g(e,!0))?l(2,t[e]):A(t,e)},q=function(t,e,n){return!(G(t,e=g(e,!0))&&m(n)&&v(n,"value"))||v(n,"get")||v(n,"set")||n.configurable||v(n,"writable")&&!n.writable||v(n,"enumerable")&&!n.enumerable?R(t,e,n):(t[e]=n.value,t)};o?(P||(x.f=B,I.f=q,W(U,"buffer"),W(U,"byteOffset"),W(U,"byteLength"),W(U,"length")),r({target:"Object",stat:!0,forced:!P},{getOwnPropertyDescriptor:B,defineProperty:q}),t.exports=function(t,e,n){var o=t.match(/\d+$/)[0]/8,c=t+(n?"Clamped":"")+"Array",s="get"+t,l="set"+t,g=i[c],v=g,y=v&&v.prototype,I={},x=function(t,e){R(t,e,{get:function(){return function(t,e){var n=M(t);return n.view[s](e*o+n.byteOffset,!0)}(this,e)},set:function(t){return function(t,e,r){var i=M(t);n&&(r=(r=D(r))<0?0:r>255?255:255&r),i.view[l](e*o+i.byteOffset,r,!0)}(this,e,t)},enumerable:!0})};P?a&&(v=e((function(t,e,n,r){return u(t,v,c),k(m(e)?H(e)?void 0!==r?new g(e,p(n,o),r):void 0!==n?new g(e,p(n,o)):new g(e):z(e)?Y(v,e):_.call(v,e):new g(d(e)),t,v)})),E&&E(v,F),S(w(g),(function(t){t in v||f(v,t,g[t])})),v.prototype=y):(v=e((function(t,e,n,r){u(t,v,c);var i,a,s,l=0,f=0;if(m(e)){if(!H(e))return z(e)?Y(v,e):_.call(v,e);i=e,f=p(n,o);var g=e.byteLength;if(void 0===r){if(g%o)throw $("Wrong length");if((a=g-f)<0)throw $("Wrong length")}else if((a=h(r)*o)+f>g)throw $("Wrong length");s=a/o}else s=d(e),i=new L(a=s*o);for(N(t,{buffer:i,byteOffset:f,byteLength:a,length:s,view:new j(i)});l<s;)x(t,l++)})),E&&E(v,F),y=v.prototype=b(U)),y.constructor!==v&&f(y,"constructor",v),C&&f(y,C,c),I[c]=v,r({global:!0,forced:v!=g,sham:!P},I),"BYTES_PER_ELEMENT"in v||f(v,"BYTES_PER_ELEMENT",o),"BYTES_PER_ELEMENT"in y||f(y,"BYTES_PER_ELEMENT",o),T(c)}):t.exports=function(){}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var r=n(26),i=Math.max,o=Math.min;t.exports=function(t,e){var n=r(t);return n<0?i(n+e,0):o(n,e)}},function(t,e,n){var r=n(19);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 0:return function(){return t.call(e)};case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,i){return t.call(e,n,r,i)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(6),i=n(31),o=n(9),a=r("unscopables"),c=Array.prototype;null==c[a]&&o.f(c,a,{configurable:!0,value:i(null)}),t.exports=function(t){c[a][t]=!0}},function(t,e){t.exports=function(t,e,n){if(!(t instanceof e))throw TypeError("Incorrect "+(n?n+" ":"")+"invocation");return t}},function(t,e,n){var r=n(115),i=n(88).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,i)}},function(t,e,n){var r=n(24);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){"use strict";var r=n(27),i=n(9),o=n(35);t.exports=function(t,e,n){var a=r(e);a in t?i.f(t,a,o(0,n)):t[a]=n}},function(t,e,n){var r=n(4),i=n(134);t.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,n={};try{(t=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(n,[]),e=n instanceof Array}catch(t){}return function(n,o){return r(n),i(o),e?t.call(n,o):n.__proto__=o,n}}():void 0)},function(t,e,n){var r=n(51),i=n(3),o=n(11),a=n(9).f,c=n(50),s=n(63),u=c("meta"),l=0,f=Object.isExtensible||function(){return!0},h=function(t){a(t,u,{value:{objectID:"O"+ ++l,weakData:{}}})},d=t.exports={REQUIRED:!1,fastKey:function(t,e){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!o(t,u)){if(!f(t))return"F";if(!e)return"E";h(t)}return t[u].objectID},getWeakData:function(t,e){if(!o(t,u)){if(!f(t))return!0;if(!e)return!1;h(t)}return t[u].weakData},onFreeze:function(t){return s&&d.REQUIRED&&f(t)&&!o(t,u)&&h(t),t}};r[u]=!0},function(t,e,n){var r=n(15),i="["+n(70)+"]",o=RegExp("^"+i+i+"*"),a=RegExp(i+i+"*$"),c=function(t){return function(e){var n=String(r(e));return 1&t&&(n=n.replace(o,"")),2&t&&(n=n.replace(a,"")),n}};t.exports={start:c(1),end:c(2),trim:c(3)}},function(t,e,n){var r=n(14);t.exports=function(t,e,n){for(var i in e)r(t,i,e[i],n);return t}},function(t,e,n){"use strict";var r=n(25),i=n(9),o=n(6),a=n(5),c=o("species");t.exports=function(t){var e=r(t),n=i.f;a&&e&&!e[c]&&n(e,c,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(4),i=n(93),o=n(7),a=n(37),c=n(59),s=n(130),u=function(t,e){this.stopped=t,this.result=e};(t.exports=function(t,e,n,l,f){var h,d,p,g,v,y,m,b=a(e,n,l?2:1);if(f)h=t;else{if("function"!=typeof(d=c(t)))throw TypeError("Target is not iterable");if(i(d)){for(p=0,g=o(t.length);g>p;p++)if((v=l?b(r(m=t[p])[0],m[1]):b(t[p]))&&v instanceof u)return v;return new u(!1)}h=d.call(t)}for(y=h.next;!(m=y.call(h)).done;)if("object"==typeof(v=s(h,b,m.value,l))&&v&&v instanceof u)return v;return new u(!1)}).stop=function(t){return new u(!0,t)}},function(t,e,n){var r=n(1),i=n(24),o="".split;t.exports=r((function(){return!Object("z").propertyIsEnumerable(0)}))?function(t){return"String"==i(t)?o.call(t,""):Object(t)}:Object},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++n+r).toString(36)}},function(t,e){t.exports={}},function(t,e,n){var r=n(2);t.exports=r},function(t,e,n){var r=n(21),i=n(7),o=n(36),a=function(t){return function(e,n,a){var c,s=r(e),u=i(s.length),l=o(a,u);if(t&&n!=n){for(;u>l;)if((c=s[l++])!=c)return!0}else for(;u>l;l++)if((t||l in s)&&s[l]===n)return t||l||0;return!t&&-1}};t.exports={includes:a(!0),indexOf:a(!1)}},function(t,e,n){var r=n(1),i=/#|\.prototype\./,o=function(t,e){var n=c[a(t)];return n==u||n!=s&&("function"==typeof e?r(e):!!e)},a=o.normalize=function(t){return String(t).replace(i,".").toLowerCase()},c=o.data={},s=o.NATIVE="N",u=o.POLYFILL="P";t.exports=o},function(t,e,n){var r=n(115),i=n(88);t.exports=Object.keys||function(t){return r(t,i)}},function(t,e,n){var r=n(3),i=n(41),o=n(6)("species");t.exports=function(t,e){var n;return i(t)&&("function"!=typeof(n=t.constructor)||n!==Array&&!i(n.prototype)?r(n)&&null===(n=n[o])&&(n=void 0):n=void 0),new(void 0===n?Array:n)(0===e?0:e)}},function(t,e,n){var r=n(1),i=n(6),o=n(92),a=i("species");t.exports=function(t){return o>=51||!r((function(){var e=[];return(e.constructor={})[a]=function(){return{foo:1}},1!==e[t](Boolean).foo}))}},function(t,e){t.exports={}},function(t,e,n){var r=n(60),i=n(58),o=n(6)("iterator");t.exports=function(t){if(null!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e,n){var r=n(94),i=n(24),o=n(6)("toStringTag"),a="Arguments"==i(function(){return arguments}());t.exports=r?i:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?n:a?i(e):"Object"==(r=i(e))&&"function"==typeof e.callee?"Arguments":r}},function(t,e,n){"use strict";var r=n(21),i=n(38),o=n(58),a=n(17),c=n(95),s=a.set,u=a.getterFor("Array Iterator");t.exports=c(Array,"Array",(function(t,e){s(this,{type:"Array Iterator",target:r(t),index:0,kind:e})}),(function(){var t=u(this),e=t.target,n=t.kind,r=t.index++;return!e||r>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:e[r],done:!1}:{value:[r,e[r]],done:!1}}),"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var r=n(4);t.exports=function(){var t=r(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var r=n(1);t.exports=!r((function(){return Object.isExtensible(Object.preventExtensions({}))}))},function(t,e,n){"use strict";var r={}.propertyIsEnumerable,i=Object.getOwnPropertyDescriptor,o=i&&!r.call({1:2},1);e.f=o?function(t){var e=i(this,t);return!!e&&e.enumerable}:r},function(t,e,n){var r=n(86),i=n(50),o=r("keys");t.exports=function(t){return o[t]||(o[t]=i(t))}},function(t,e,n){var r=n(25);t.exports=r("navigator","userAgent")||""},function(t,e,n){var r=n(6)("iterator"),i=!1;try{var o=0,a={next:function(){return{done:!!o++}},return:function(){i=!0}};a[r]=function(){return this},Array.from(a,(function(){throw 2}))}catch(t){}t.exports=function(t,e){if(!e&&!i)return!1;var n=!1;try{var o={};o[r]=function(){return{next:function(){return{done:n=!0}}}},t(o)}catch(t){}return n}},function(t,e,n){var r=n(19),i=n(10),o=n(49),a=n(7),c=function(t){return function(e,n,c,s){r(n);var u=i(e),l=o(u),f=a(u.length),h=t?f-1:0,d=t?-1:1;if(c<2)for(;;){if(h in l){s=l[h],h+=d;break}if(h+=d,t?h<0:f<=h)throw TypeError("Reduce of empty array with no initial value")}for(;t?h>=0:f>h;h+=d)h in l&&(s=n(s,l[h],h,u));return s}};t.exports={left:c(!1),right:c(!0)}},function(t,e,n){var r=n(3),i=n(43);t.exports=function(t,e,n){var o,a;return i&&"function"==typeof(o=e.constructor)&&o!==n&&r(a=o.prototype)&&a!==n.prototype&&i(t,a),t}},function(t,e){t.exports="\t\n\v\f\r                　\u2028\u2029\ufeff"},function(t,e,n){var r=n(3),i=n(24),o=n(6)("match");t.exports=function(t){var e;return r(t)&&(void 0!==(e=t[o])?!!e:"RegExp"==i(t))}},function(t,e,n){"use strict";var r=n(1);function i(t,e){return RegExp(t,e)}e.UNSUPPORTED_Y=r((function(){var t=i("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),e.BROKEN_CARET=r((function(){var t=i("^r","gy");return t.lastIndex=2,null!=t.exec("str")}))},function(t,e,n){"use strict";var r=n(0),i=n(74);r({target:"RegExp",proto:!0,forced:/./.exec!==i},{exec:i})},function(t,e,n){"use strict";var r,i,o=n(62),a=n(72),c=RegExp.prototype.exec,s=String.prototype.replace,u=c,l=(r=/a/,i=/b*/g,c.call(r,"a"),c.call(i,"a"),0!==r.lastIndex||0!==i.lastIndex),f=a.UNSUPPORTED_Y||a.BROKEN_CARET,h=void 0!==/()??/.exec("")[1];(l||h||f)&&(u=function(t){var e,n,r,i,a=this,u=f&&a.sticky,d=o.call(a),p=a.source,g=0,v=t;return u&&(-1===(d=d.replace("y","")).indexOf("g")&&(d+="g"),v=String(t).slice(a.lastIndex),a.lastIndex>0&&(!a.multiline||a.multiline&&"\n"!==t[a.lastIndex-1])&&(p="(?: "+p+")",v=" "+v,g++),n=new RegExp("^(?:"+p+")",d)),h&&(n=new RegExp("^"+p+"$(?!\\s)",d)),l&&(e=a.lastIndex),r=c.call(u?n:a,v),u?r?(r.input=r.input.slice(g),r[0]=r[0].slice(g),r.index=a.lastIndex,a.lastIndex+=r[0].length):a.lastIndex=0:l&&r&&(a.lastIndex=a.global?r.index+r[0].length:e),h&&r&&r.length>1&&s.call(r[0],n,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(r[i]=void 0)})),r}),t.exports=u},function(t,e,n){var r=n(26),i=n(15),o=function(t){return function(e,n){var o,a,c=String(i(e)),s=r(n),u=c.length;return s<0||s>=u?t?"":void 0:(o=c.charCodeAt(s))<55296||o>56319||s+1===u||(a=c.charCodeAt(s+1))<56320||a>57343?t?c.charAt(s):o:t?c.slice(s,s+2):a-56320+(o-55296<<10)+65536}};t.exports={codeAt:o(!1),charAt:o(!0)}},function(t,e,n){"use strict";n(73);var r=n(14),i=n(1),o=n(6),a=n(74),c=n(16),s=o("species"),u=!i((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")})),l="$0"==="a".replace(/./,"$0"),f=o("replace"),h=!!/./[f]&&""===/./[f]("a","$0"),d=!i((function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2!==n.length||"a"!==n[0]||"b"!==n[1]}));t.exports=function(t,e,n,f){var p=o(t),g=!i((function(){var e={};return e[p]=function(){return 7},7!=""[t](e)})),v=g&&!i((function(){var e=!1,n=/a/;return"split"===t&&((n={}).constructor={},n.constructor[s]=function(){return n},n.flags="",n[p]=/./[p]),n.exec=function(){return e=!0,null},n[p](""),!e}));if(!g||!v||"replace"===t&&(!u||!l||h)||"split"===t&&!d){var y=/./[p],m=n(p,""[t],(function(t,e,n,r,i){return e.exec===a?g&&!i?{done:!0,value:y.call(e,n,r)}:{done:!0,value:t.call(n,e,r)}:{done:!1}}),{REPLACE_KEEPS_$0:l,REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE:h}),b=m[0],E=m[1];r(String.prototype,t,b),r(RegExp.prototype,p,2==e?function(t,e){return E.call(t,this,e)}:function(t){return E.call(t,this)})}f&&c(RegExp.prototype[p],"sham",!0)}},function(t,e,n){"use strict";var r=n(75).charAt;t.exports=function(t,e,n){return e+(n?r(t,e).length:1)}},function(t,e,n){var r=n(24),i=n(74);t.exports=function(t,e){var n=t.exec;if("function"==typeof n){var o=n.call(t,e);if("object"!=typeof o)throw TypeError("RegExp exec method returned something other than an Object or null");return o}if("RegExp"!==r(t))throw TypeError("RegExp#exec called on incompatible receiver");return i.call(t,e)}},function(t,e,n){"use strict";var r=n(28),i=n(2),o=n(1);t.exports=r||!o((function(){var t=Math.random();__defineSetter__.call(null,t,(function(){})),delete i[t]}))},function(t,e){var n=Math.expm1,r=Math.exp;t.exports=!n||n(10)>22025.465794806718||n(10)<22025.465794806718||-2e-17!=n(-2e-17)?function(t){return 0==(t=+t)?t:t>-1e-6&&t<1e-6?t+t*t/2:r(t)-1}:n},function(t,e,n){"use strict";var r=n(0),i=n(2),o=n(54),a=n(14),c=n(44),s=n(48),u=n(39),l=n(3),f=n(1),h=n(67),d=n(30),p=n(69);t.exports=function(t,e,n){var g=-1!==t.indexOf("Map"),v=-1!==t.indexOf("Weak"),y=g?"set":"add",m=i[t],b=m&&m.prototype,E=m,w={},_=function(t){var e=b[t];a(b,t,"add"==t?function(t){return e.call(this,0===t?0:t),this}:"delete"==t?function(t){return!(v&&!l(t))&&e.call(this,0===t?0:t)}:"get"==t?function(t){return v&&!l(t)?void 0:e.call(this,0===t?0:t)}:"has"==t?function(t){return!(v&&!l(t))&&e.call(this,0===t?0:t)}:function(t,n){return e.call(this,0===t?0:t,n),this})};if(o(t,"function"!=typeof m||!(v||b.forEach&&!f((function(){(new m).entries().next()})))))E=n.getConstructor(e,t,g,y),c.REQUIRED=!0;else if(o(t,!0)){var S=new E,T=S[y](v?{}:-0,1)!=S,I=f((function(){S.has(1)})),x=h((function(t){new m(t)})),O=!v&&f((function(){for(var t=new m,e=5;e--;)t[y](e,e);return!t.has(-0)}));x||((E=e((function(e,n){u(e,E,t);var r=p(new m,e,E);return null!=n&&s(n,r[y],r,g),r}))).prototype=b,b.constructor=E),(I||O)&&(_("delete"),_("has"),g&&_("get")),(O||T)&&_(y),v&&b.clear&&delete b.clear}return w[t]=E,r({global:!0,forced:E!=m},w),d(E,t),v||n.setStrong(E,t,g),E}},function(t,e,n){"use strict";var r=n(2),i=n(5),o=n(108),a=n(16),c=n(46),s=n(1),u=n(39),l=n(26),f=n(7),h=n(179),d=n(318),p=n(29),g=n(43),v=n(40).f,y=n(9).f,m=n(103),b=n(30),E=n(17),w=E.get,_=E.set,S=r.ArrayBuffer,T=S,I=r.DataView,x=I&&I.prototype,O=Object.prototype,k=r.RangeError,M=d.pack,N=d.unpack,R=function(t){return[255&t]},A=function(t){return[255&t,t>>8&255]},D=function(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]},$=function(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]},L=function(t){return M(t,23,4)},j=function(t){return M(t,52,8)},P=function(t,e){y(t.prototype,e,{get:function(){return w(this)[e]}})},C=function(t,e,n,r){var i=h(n),o=w(t);if(i+e>o.byteLength)throw k("Wrong index");var a=w(o.buffer).bytes,c=i+o.byteOffset,s=a.slice(c,c+e);return r?s:s.reverse()},F=function(t,e,n,r,i,o){var a=h(n),c=w(t);if(a+e>c.byteLength)throw k("Wrong index");for(var s=w(c.buffer).bytes,u=a+c.byteOffset,l=r(+i),f=0;f<e;f++)s[u+f]=l[o?f:e-f-1]};if(o){if(!s((function(){S(1)}))||!s((function(){new S(-1)}))||s((function(){return new S,new S(1.5),new S(NaN),"ArrayBuffer"!=S.name}))){for(var U,V=(T=function(t){return u(this,T),new S(h(t))}).prototype=S.prototype,z=v(S),Y=0;z.length>Y;)(U=z[Y++])in T||a(T,U,S[U]);V.constructor=T}g&&p(x)!==O&&g(x,O);var W=new I(new T(2)),H=x.setInt8;W.setInt8(0,2147483648),W.setInt8(1,2147483649),!W.getInt8(0)&&W.getInt8(1)||c(x,{setInt8:function(t,e){H.call(this,t,e<<24>>24)},setUint8:function(t,e){H.call(this,t,e<<24>>24)}},{unsafe:!0})}else T=function(t){u(this,T,"ArrayBuffer");var e=h(t);_(this,{bytes:m.call(new Array(e),0),byteLength:e}),i||(this.byteLength=e)},I=function(t,e,n){u(this,I,"DataView"),u(t,T,"DataView");var r=w(t).byteLength,o=l(e);if(o<0||o>r)throw k("Wrong offset");if(o+(n=void 0===n?r-o:f(n))>r)throw k("Wrong length");_(this,{buffer:t,byteLength:n,byteOffset:o}),i||(this.buffer=t,this.byteLength=n,this.byteOffset=o)},i&&(P(T,"byteLength"),P(I,"buffer"),P(I,"byteLength"),P(I,"byteOffset")),c(I.prototype,{getInt8:function(t){return C(this,1,t)[0]<<24>>24},getUint8:function(t){return C(this,1,t)[0]},getInt16:function(t){var e=C(this,2,t,arguments.length>1?arguments[1]:void 0);return(e[1]<<8|e[0])<<16>>16},getUint16:function(t){var e=C(this,2,t,arguments.length>1?arguments[1]:void 0);return e[1]<<8|e[0]},getInt32:function(t){return $(C(this,4,t,arguments.length>1?arguments[1]:void 0))},getUint32:function(t){return $(C(this,4,t,arguments.length>1?arguments[1]:void 0))>>>0},getFloat32:function(t){return N(C(this,4,t,arguments.length>1?arguments[1]:void 0),23)},getFloat64:function(t){return N(C(this,8,t,arguments.length>1?arguments[1]:void 0),52)},setInt8:function(t,e){F(this,1,t,R,e)},setUint8:function(t,e){F(this,1,t,R,e)},setInt16:function(t,e){F(this,2,t,A,e,arguments.length>2?arguments[2]:void 0)},setUint16:function(t,e){F(this,2,t,A,e,arguments.length>2?arguments[2]:void 0)},setInt32:function(t,e){F(this,4,t,D,e,arguments.length>2?arguments[2]:void 0)},setUint32:function(t,e){F(this,4,t,D,e,arguments.length>2?arguments[2]:void 0)},setFloat32:function(t,e){F(this,4,t,L,e,arguments.length>2?arguments[2]:void 0)},setFloat64:function(t,e){F(this,8,t,j,e,arguments.length>2?arguments[2]:void 0)}});b(T,"ArrayBuffer"),b(I,"DataView"),t.exports={ArrayBuffer:T,DataView:I}},function(t,e,n){var r=n(2),i=n(3),o=r.document,a=i(o)&&i(o.createElement);t.exports=function(t){return a?o.createElement(t):{}}},function(t,e,n){var r=n(2),i=n(16);t.exports=function(t,e){try{i(r,t,e)}catch(n){r[t]=e}return e}},function(t,e,n){var r=n(112),i=Function.toString;"function"!=typeof r.inspectSource&&(r.inspectSource=function(t){return i.call(t)}),t.exports=r.inspectSource},function(t,e,n){var r=n(28),i=n(112);(t.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.6.5",mode:r?"pure":"global",copyright:"© 2020 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var r=n(25),i=n(40),o=n(89),a=n(4);t.exports=r("Reflect","ownKeys")||function(t){var e=i.f(a(t)),n=o.f;return n?e.concat(n(t)):e}},function(t,e){t.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(1);t.exports=!!Object.getOwnPropertySymbols&&!r((function(){return!String(Symbol())}))},function(t,e,n){var r=n(5),i=n(9),o=n(4),a=n(55);t.exports=r?Object.defineProperties:function(t,e){o(t);for(var n,r=a(e),c=r.length,s=0;c>s;)i.f(t,n=r[s++],e[n]);return t}},function(t,e,n){var r,i,o=n(2),a=n(66),c=o.process,s=c&&c.versions,u=s&&s.v8;u?i=(r=u.split("."))[0]+r[1]:a&&(!(r=a.match(/Edge\/(\d+)/))||r[1]>=74)&&(r=a.match(/Chrome\/(\d+)/))&&(i=r[1]),t.exports=i&&+i},function(t,e,n){var r=n(6),i=n(58),o=r("iterator"),a=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||a[o]===t)}},function(t,e,n){var r={};r[n(6)("toStringTag")]="z",t.exports="[object z]"===String(r)},function(t,e,n){"use strict";var r=n(0),i=n(96),o=n(29),a=n(43),c=n(30),s=n(16),u=n(14),l=n(6),f=n(28),h=n(58),d=n(133),p=d.IteratorPrototype,g=d.BUGGY_SAFARI_ITERATORS,v=l("iterator"),y=function(){return this};t.exports=function(t,e,n,l,d,m,b){i(n,e,l);var E,w,_,S=function(t){if(t===d&&k)return k;if(!g&&t in x)return x[t];switch(t){case"keys":case"values":case"entries":return function(){return new n(this,t)}}return function(){return new n(this)}},T=e+" Iterator",I=!1,x=t.prototype,O=x[v]||x["@@iterator"]||d&&x[d],k=!g&&O||S(d),M="Array"==e&&x.entries||O;if(M&&(E=o(M.call(new t)),p!==Object.prototype&&E.next&&(f||o(E)===p||(a?a(E,p):"function"!=typeof E[v]&&s(E,v,y)),c(E,T,!0,!0),f&&(h[T]=y))),"values"==d&&O&&"values"!==O.name&&(I=!0,k=function(){return O.call(this)}),f&&!b||x[v]===k||s(x,v,k),h[e]=k,d)if(w={values:S("values"),keys:m?k:S("keys"),entries:S("entries")},b)for(_ in w)(g||I||!(_ in x))&&u(x,_,w[_]);else r({target:e,proto:!0,forced:g||I},w);return w}},function(t,e,n){"use strict";var r=n(133).IteratorPrototype,i=n(31),o=n(35),a=n(30),c=n(58),s=function(){return this};t.exports=function(t,e,n){var u=e+" Iterator";return t.prototype=i(r,{next:o(1,n)}),a(t,u,!1,!0),c[u]=s,t}},function(t,e,n){var r=n(1);t.exports=!r((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype}))},function(t,e,n){var r,i,o,a=n(2),c=n(1),s=n(24),u=n(37),l=n(117),f=n(83),h=n(152),d=a.location,p=a.setImmediate,g=a.clearImmediate,v=a.process,y=a.MessageChannel,m=a.Dispatch,b=0,E={},w=function(t){if(E.hasOwnProperty(t)){var e=E[t];delete E[t],e()}},_=function(t){return function(){w(t)}},S=function(t){w(t.data)},T=function(t){a.postMessage(t+"",d.protocol+"//"+d.host)};p&&g||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return E[++b]=function(){("function"==typeof t?t:Function(t)).apply(void 0,e)},r(b),b},g=function(t){delete E[t]},"process"==s(v)?r=function(t){v.nextTick(_(t))}:m&&m.now?r=function(t){m.now(_(t))}:y&&!h?(o=(i=new y).port2,i.port1.onmessage=S,r=u(o.postMessage,o,1)):!a.addEventListener||"function"!=typeof postMessage||a.importScripts||c(T)||"file:"===d.protocol?r="onreadystatechange"in f("script")?function(t){l.appendChild(f("script")).onreadystatechange=function(){l.removeChild(this),w(t)}}:function(t){setTimeout(_(t),0)}:(r=T,a.addEventListener("message",S,!1))),t.exports={set:p,clear:g}},function(t,e,n){"use strict";var r=n(19),i=function(t){var e,n;this.promise=new t((function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r})),this.resolve=r(e),this.reject=r(n)};t.exports.f=function(t){return new i(t)}},function(t,e,n){var r=n(71);t.exports=function(t){if(r(t))throw TypeError("The method doesn't accept regular expressions");return t}},function(t,e,n){var r=n(6)("match");t.exports=function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[r]=!1,"/./"[t](e)}catch(t){}}return!1}},function(t,e,n){"use strict";var r=n(75).charAt,i=n(17),o=n(95),a=i.set,c=i.getterFor("String Iterator");o(String,"String",(function(t){a(this,{type:"String Iterator",string:String(t),index:0})}),(function(){var t,e=c(this),n=e.string,i=e.index;return i>=n.length?{value:void 0,done:!0}:(t=r(n,i),e.index+=t.length,{value:t,done:!1})}))},function(t,e,n){"use strict";var r=n(10),i=n(36),o=n(7);t.exports=function(t){for(var e=r(this),n=o(e.length),a=arguments.length,c=i(a>1?arguments[1]:void 0,n),s=a>2?arguments[2]:void 0,u=void 0===s?n:i(s,n);u>c;)e[c++]=t;return e}},function(t,e,n){var r=n(7),i=n(105),o=n(15),a=Math.ceil,c=function(t){return function(e,n,c){var s,u,l=String(o(e)),f=l.length,h=void 0===c?" ":String(c),d=r(n);return d<=f||""==h?l:(s=d-f,(u=i.call(h,a(s/h.length))).length>s&&(u=u.slice(0,s)),t?l+u:u+l)}};t.exports={start:c(!1),end:c(!0)}},function(t,e,n){"use strict";var r=n(26),i=n(15);t.exports="".repeat||function(t){var e=String(i(this)),n="",o=r(t);if(o<0||o==1/0)throw RangeError("Wrong number of repetitions");for(;o>0;(o>>>=1)&&(e+=e))1&o&&(n+=e);return n}},function(t,e,n){var r=n(1),i=n(70);t.exports=function(t){return r((function(){return!!i[t]()||"​᠎"!="​᠎"[t]()||i[t].name!==t}))}},function(t,e){t.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:t<0?-1:1}},function(t,e){t.exports="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof DataView},function(t,e,n){var r=n(2),i=n(1),o=n(67),a=n(8).NATIVE_ARRAY_BUFFER_VIEWS,c=r.ArrayBuffer,s=r.Int8Array;t.exports=!a||!i((function(){s(1)}))||!i((function(){new s(-1)}))||!o((function(t){new s,new s(null),new s(1.5),new s(t)}),!0)||i((function(){return 1!==new s(new c(2),1,void 0).length}))},function(t,e,n){"use strict";var r=n(0),i=n(2),o=n(25),a=n(28),c=n(5),s=n(90),u=n(116),l=n(1),f=n(11),h=n(41),d=n(3),p=n(4),g=n(10),v=n(21),y=n(27),m=n(35),b=n(31),E=n(55),w=n(40),_=n(118),S=n(89),T=n(13),I=n(9),x=n(64),O=n(16),k=n(14),M=n(86),N=n(65),R=n(51),A=n(50),D=n(6),$=n(119),L=n(18),j=n(30),P=n(17),C=n(12).forEach,F=N("hidden"),U=D("toPrimitive"),V=P.set,z=P.getterFor("Symbol"),Y=Object.prototype,W=i.Symbol,H=o("JSON","stringify"),G=T.f,B=I.f,q=_.f,X=x.f,Z=M("symbols"),K=M("op-symbols"),J=M("string-to-symbol-registry"),Q=M("symbol-to-string-registry"),tt=M("wks"),et=i.QObject,nt=!et||!et.prototype||!et.prototype.findChild,rt=c&&l((function(){return 7!=b(B({},"a",{get:function(){return B(this,"a",{value:7}).a}})).a}))?function(t,e,n){var r=G(Y,e);r&&delete Y[e],B(t,e,n),r&&t!==Y&&B(Y,e,r)}:B,it=function(t,e){var n=Z[t]=b(W.prototype);return V(n,{type:"Symbol",tag:t,description:e}),c||(n.description=e),n},ot=u?function(t){return"symbol"==typeof t}:function(t){return Object(t)instanceof W},at=function(t,e,n){t===Y&&at(K,e,n),p(t);var r=y(e,!0);return p(n),f(Z,r)?(n.enumerable?(f(t,F)&&t[F][r]&&(t[F][r]=!1),n=b(n,{enumerable:m(0,!1)})):(f(t,F)||B(t,F,m(1,{})),t[F][r]=!0),rt(t,r,n)):B(t,r,n)},ct=function(t,e){p(t);var n=v(e),r=E(n).concat(ft(n));return C(r,(function(e){c&&!st.call(n,e)||at(t,e,n[e])})),t},st=function(t){var e=y(t,!0),n=X.call(this,e);return!(this===Y&&f(Z,e)&&!f(K,e))&&(!(n||!f(this,e)||!f(Z,e)||f(this,F)&&this[F][e])||n)},ut=function(t,e){var n=v(t),r=y(e,!0);if(n!==Y||!f(Z,r)||f(K,r)){var i=G(n,r);return!i||!f(Z,r)||f(n,F)&&n[F][r]||(i.enumerable=!0),i}},lt=function(t){var e=q(v(t)),n=[];return C(e,(function(t){f(Z,t)||f(R,t)||n.push(t)})),n},ft=function(t){var e=t===Y,n=q(e?K:v(t)),r=[];return C(n,(function(t){!f(Z,t)||e&&!f(Y,t)||r.push(Z[t])})),r};(s||(k((W=function(){if(this instanceof W)throw TypeError("Symbol is not a constructor");var t=arguments.length&&void 0!==arguments[0]?String(arguments[0]):void 0,e=A(t),n=function(t){this===Y&&n.call(K,t),f(this,F)&&f(this[F],e)&&(this[F][e]=!1),rt(this,e,m(1,t))};return c&&nt&&rt(Y,e,{configurable:!0,set:n}),it(e,t)}).prototype,"toString",(function(){return z(this).tag})),k(W,"withoutSetter",(function(t){return it(A(t),t)})),x.f=st,I.f=at,T.f=ut,w.f=_.f=lt,S.f=ft,$.f=function(t){return it(D(t),t)},c&&(B(W.prototype,"description",{configurable:!0,get:function(){return z(this).description}}),a||k(Y,"propertyIsEnumerable",st,{unsafe:!0}))),r({global:!0,wrap:!0,forced:!s,sham:!s},{Symbol:W}),C(E(tt),(function(t){L(t)})),r({target:"Symbol",stat:!0,forced:!s},{for:function(t){var e=String(t);if(f(J,e))return J[e];var n=W(e);return J[e]=n,Q[n]=e,n},keyFor:function(t){if(!ot(t))throw TypeError(t+" is not a symbol");if(f(Q,t))return Q[t]},useSetter:function(){nt=!0},useSimple:function(){nt=!1}}),r({target:"Object",stat:!0,forced:!s,sham:!c},{create:function(t,e){return void 0===e?b(t):ct(b(t),e)},defineProperty:at,defineProperties:ct,getOwnPropertyDescriptor:ut}),r({target:"Object",stat:!0,forced:!s},{getOwnPropertyNames:lt,getOwnPropertySymbols:ft}),r({target:"Object",stat:!0,forced:l((function(){S.f(1)}))},{getOwnPropertySymbols:function(t){return S.f(g(t))}}),H)&&r({target:"JSON",stat:!0,forced:!s||l((function(){var t=W();return"[null]"!=H([t])||"{}"!=H({a:t})||"{}"!=H(Object(t))}))},{stringify:function(t,e,n){for(var r,i=[t],o=1;arguments.length>o;)i.push(arguments[o++]);if(r=e,(d(e)||void 0!==t)&&!ot(t))return h(e)||(e=function(t,e){if("function"==typeof r&&(e=r.call(this,t,e)),!ot(e))return e}),i[1]=e,H.apply(null,i)}});W.prototype[U]||O(W.prototype,U,W.prototype.valueOf),j(W,"Symbol"),R[F]=!0},function(t,e,n){var r=n(5),i=n(1),o=n(83);t.exports=!r&&!i((function(){return 7!=Object.defineProperty(o("div"),"a",{get:function(){return 7}}).a}))},function(t,e,n){var r=n(2),i=n(84),o=r["__core-js_shared__"]||i("__core-js_shared__",{});t.exports=o},function(t,e,n){var r=n(2),i=n(85),o=r.WeakMap;t.exports="function"==typeof o&&/native code/.test(i(o))},function(t,e,n){var r=n(11),i=n(87),o=n(13),a=n(9);t.exports=function(t,e){for(var n=i(e),c=a.f,s=o.f,u=0;u<n.length;u++){var l=n[u];r(t,l)||c(t,l,s(e,l))}}},function(t,e,n){var r=n(11),i=n(21),o=n(53).indexOf,a=n(51);t.exports=function(t,e){var n,c=i(t),s=0,u=[];for(n in c)!r(a,n)&&r(c,n)&&u.push(n);for(;e.length>s;)r(c,n=e[s++])&&(~o(u,n)||u.push(n));return u}},function(t,e,n){var r=n(90);t.exports=r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},function(t,e,n){var r=n(25);t.exports=r("document","documentElement")},function(t,e,n){var r=n(21),i=n(40).f,o={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return a&&"[object Window]"==o.call(t)?function(t){try{return i(t)}catch(t){return a.slice()}}(t):i(r(t))}},function(t,e,n){var r=n(6);e.f=r},function(t,e,n){"use strict";var r=n(0),i=n(5),o=n(2),a=n(11),c=n(3),s=n(9).f,u=n(114),l=o.Symbol;if(i&&"function"==typeof l&&(!("description"in l.prototype)||void 0!==l().description)){var f={},h=function(){var t=arguments.length<1||void 0===arguments[0]?void 0:String(arguments[0]),e=this instanceof h?new l(t):void 0===t?l():l(t);return""===t&&(f[e]=!0),e};u(h,l);var d=h.prototype=l.prototype;d.constructor=h;var p=d.toString,g="Symbol(test)"==String(l("test")),v=/^Symbol\((.*)\)[^)]+$/;s(d,"description",{configurable:!0,get:function(){var t=c(this)?this.valueOf():this,e=p.call(t);if(a(f,t))return"";var n=g?e.slice(7,-1):e.replace(v,"$1");return""===n?void 0:n}}),r({global:!0,forced:!0},{Symbol:h})}},function(t,e,n){n(18)("iterator")},function(t,e,n){"use strict";var r=n(0),i=n(1),o=n(41),a=n(3),c=n(10),s=n(7),u=n(42),l=n(56),f=n(57),h=n(6),d=n(92),p=h("isConcatSpreadable"),g=d>=51||!i((function(){var t=[];return t[p]=!1,t.concat()[0]!==t})),v=f("concat"),y=function(t){if(!a(t))return!1;var e=t[p];return void 0!==e?!!e:o(t)};r({target:"Array",proto:!0,forced:!g||!v},{concat:function(t){var e,n,r,i,o,a=c(this),f=l(a,0),h=0;for(e=-1,r=arguments.length;e<r;e++)if(y(o=-1===e?a:arguments[e])){if(h+(i=s(o.length))>9007199254740991)throw TypeError("Maximum allowed index exceeded");for(n=0;n<i;n++,h++)n in o&&u(f,h,o[n])}else{if(h>=9007199254740991)throw TypeError("Maximum allowed index exceeded");u(f,h++,o)}return f.length=h,f}})},function(t,e,n){"use strict";var r=n(0),i=n(12).filter,o=n(57),a=n(20),c=o("filter"),s=a("filter");r({target:"Array",proto:!0,forced:!c||!s},{filter:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r=n(0),i=n(12).find,o=n(38),a=n(20),c=!0,s=a("find");"find"in[]&&Array(1).find((function(){c=!1})),r({target:"Array",proto:!0,forced:c||!s},{find:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),o("find")},function(t,e,n){"use strict";var r=n(0),i=n(12).findIndex,o=n(38),a=n(20),c=!0,s=a("findIndex");"findIndex"in[]&&Array(1).findIndex((function(){c=!1})),r({target:"Array",proto:!0,forced:c||!s},{findIndex:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),o("findIndex")},function(t,e,n){"use strict";var r=n(0),i=n(127);r({target:"Array",proto:!0,forced:[].forEach!=i},{forEach:i})},function(t,e,n){"use strict";var r=n(12).forEach,i=n(32),o=n(20),a=i("forEach"),c=o("forEach");t.exports=a&&c?[].forEach:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}},function(t,e,n){var r=n(0),i=n(129);r({target:"Array",stat:!0,forced:!n(67)((function(t){Array.from(t)}))},{from:i})},function(t,e,n){"use strict";var r=n(37),i=n(10),o=n(130),a=n(93),c=n(7),s=n(42),u=n(59);t.exports=function(t){var e,n,l,f,h,d,p=i(t),g="function"==typeof this?this:Array,v=arguments.length,y=v>1?arguments[1]:void 0,m=void 0!==y,b=u(p),E=0;if(m&&(y=r(y,v>2?arguments[2]:void 0,2)),null==b||g==Array&&a(b))for(n=new g(e=c(p.length));e>E;E++)d=m?y(p[E],E):p[E],s(n,E,d);else for(h=(f=b.call(p)).next,n=new g;!(l=h.call(f)).done;E++)d=m?o(f,y,[l.value,E],!0):l.value,s(n,E,d);return n.length=E,n}},function(t,e,n){var r=n(4);t.exports=function(t,e,n,i){try{return i?e(r(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&r(o.call(t)),e}}},function(t,e,n){"use strict";var r=n(0),i=n(53).includes,o=n(38);r({target:"Array",proto:!0,forced:!n(20)("indexOf",{ACCESSORS:!0,1:0})},{includes:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),o("includes")},function(t,e,n){"use strict";var r=n(0),i=n(53).indexOf,o=n(32),a=n(20),c=[].indexOf,s=!!c&&1/[1].indexOf(1,-0)<0,u=o("indexOf"),l=a("indexOf",{ACCESSORS:!0,1:0});r({target:"Array",proto:!0,forced:s||!u||!l},{indexOf:function(t){return s?c.apply(this,arguments)||0:i(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r,i,o,a=n(29),c=n(16),s=n(11),u=n(6),l=n(28),f=u("iterator"),h=!1;[].keys&&("next"in(o=[].keys())?(i=a(a(o)))!==Object.prototype&&(r=i):h=!0),null==r&&(r={}),l||s(r,f)||c(r,f,(function(){return this})),t.exports={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:h}},function(t,e,n){var r=n(3);t.exports=function(t){if(!r(t)&&null!==t)throw TypeError("Can't set "+String(t)+" as a prototype");return t}},function(t,e,n){"use strict";var r=n(0),i=n(49),o=n(21),a=n(32),c=[].join,s=i!=Object,u=a("join",",");r({target:"Array",proto:!0,forced:s||!u},{join:function(t){return c.call(o(this),void 0===t?",":t)}})},function(t,e,n){"use strict";var r=n(0),i=n(68).left,o=n(32),a=n(20),c=o("reduce"),s=a("reduce",{1:0});r({target:"Array",proto:!0,forced:!c||!s},{reduce:function(t){return i(this,t,arguments.length,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r=n(0),i=n(3),o=n(41),a=n(36),c=n(7),s=n(21),u=n(42),l=n(6),f=n(57),h=n(20),d=f("slice"),p=h("slice",{ACCESSORS:!0,0:0,1:2}),g=l("species"),v=[].slice,y=Math.max;r({target:"Array",proto:!0,forced:!d||!p},{slice:function(t,e){var n,r,l,f=s(this),h=c(f.length),d=a(t,h),p=a(void 0===e?h:e,h);if(o(f)&&("function"!=typeof(n=f.constructor)||n!==Array&&!o(n.prototype)?i(n)&&null===(n=n[g])&&(n=void 0):n=void 0,n===Array||void 0===n))return v.call(f,d,p);for(r=new(void 0===n?Array:n)(y(p-d,0)),l=0;d<p;d++,l++)d in f&&u(r,l,f[d]);return r.length=l,r}})},function(t,e,n){"use strict";var r=n(0),i=n(12).some,o=n(32),a=n(20),c=o("some"),s=a("some");r({target:"Array",proto:!0,forced:!c||!s},{some:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r=n(0),i=n(19),o=n(10),a=n(1),c=n(32),s=[],u=s.sort,l=a((function(){s.sort(void 0)})),f=a((function(){s.sort(null)})),h=c("sort");r({target:"Array",proto:!0,forced:l||!f||!h},{sort:function(t){return void 0===t?u.call(o(this)):u.call(o(this),i(t))}})},function(t,e,n){var r=n(5),i=n(9).f,o=Function.prototype,a=o.toString,c=/^\s*function ([^ (]*)/;r&&!("name"in o)&&i(o,"name",{configurable:!0,get:function(){try{return a.call(this).match(c)[1]}catch(t){return""}}})},function(t,e,n){"use strict";var r=n(5),i=n(2),o=n(54),a=n(14),c=n(11),s=n(24),u=n(69),l=n(27),f=n(1),h=n(31),d=n(40).f,p=n(13).f,g=n(9).f,v=n(45).trim,y=i.Number,m=y.prototype,b="Number"==s(h(m)),E=function(t){var e,n,r,i,o,a,c,s,u=l(t,!1);if("string"==typeof u&&u.length>2)if(43===(e=(u=v(u)).charCodeAt(0))||45===e){if(88===(n=u.charCodeAt(2))||120===n)return NaN}else if(48===e){switch(u.charCodeAt(1)){case 66:case 98:r=2,i=49;break;case 79:case 111:r=8,i=55;break;default:return+u}for(a=(o=u.slice(2)).length,c=0;c<a;c++)if((s=o.charCodeAt(c))<48||s>i)return NaN;return parseInt(o,r)}return+u};if(o("Number",!y(" 0o1")||!y("0b1")||y("+0x1"))){for(var w,_=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof _&&(b?f((function(){m.valueOf.call(n)})):"Number"!=s(n))?u(new y(E(e)),n,_):E(e)},S=r?d(y):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),T=0;S.length>T;T++)c(y,w=S[T])&&!c(_,w)&&g(_,w,p(y,w));_.prototype=m,m.constructor=_,a(i,"Number",_)}},function(t,e,n){var r=n(0),i=n(143);r({target:"Object",stat:!0,forced:Object.assign!==i},{assign:i})},function(t,e,n){"use strict";var r=n(5),i=n(1),o=n(55),a=n(89),c=n(64),s=n(10),u=n(49),l=Object.assign,f=Object.defineProperty;t.exports=!l||i((function(){if(r&&1!==l({b:1},l(f({},"a",{enumerable:!0,get:function(){f(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var t={},e={},n=Symbol();return t[n]=7,"abcdefghijklmnopqrst".split("").forEach((function(t){e[t]=t})),7!=l({},t)[n]||"abcdefghijklmnopqrst"!=o(l({},e)).join("")}))?function(t,e){for(var n=s(t),i=arguments.length,l=1,f=a.f,h=c.f;i>l;)for(var d,p=u(arguments[l++]),g=f?o(p).concat(f(p)):o(p),v=g.length,y=0;v>y;)d=g[y++],r&&!h.call(p,d)||(n[d]=p[d]);return n}:l},function(t,e,n){var r=n(0),i=n(1),o=n(21),a=n(13).f,c=n(5),s=i((function(){a(1)}));r({target:"Object",stat:!0,forced:!c||s,sham:!c},{getOwnPropertyDescriptor:function(t,e){return a(o(t),e)}})},function(t,e,n){var r=n(0),i=n(5),o=n(87),a=n(21),c=n(13),s=n(42);r({target:"Object",stat:!0,sham:!i},{getOwnPropertyDescriptors:function(t){for(var e,n,r=a(t),i=c.f,u=o(r),l={},f=0;u.length>f;)void 0!==(n=i(r,e=u[f++]))&&s(l,e,n);return l}})},function(t,e,n){var r=n(0),i=n(10),o=n(55);r({target:"Object",stat:!0,forced:n(1)((function(){o(1)}))},{keys:function(t){return o(i(t))}})},function(t,e,n){var r=n(94),i=n(14),o=n(186);r||i(Object.prototype,"toString",o,{unsafe:!0})},function(t,e,n){var r=n(0),i=n(149).values;r({target:"Object",stat:!0},{values:function(t){return i(t)}})},function(t,e,n){var r=n(5),i=n(55),o=n(21),a=n(64).f,c=function(t){return function(e){for(var n,c=o(e),s=i(c),u=s.length,l=0,f=[];u>l;)n=s[l++],r&&!a.call(c,n)||f.push(t?[n,c[n]]:c[n]);return f}};t.exports={entries:c(!0),values:c(!1)}},function(t,e,n){"use strict";var r,i,o,a,c=n(0),s=n(28),u=n(2),l=n(25),f=n(151),h=n(14),d=n(46),p=n(30),g=n(47),v=n(3),y=n(19),m=n(39),b=n(24),E=n(85),w=n(48),_=n(67),S=n(33),T=n(98).set,I=n(153),x=n(154),O=n(187),k=n(99),M=n(155),N=n(17),R=n(54),A=n(6),D=n(92),$=A("species"),L="Promise",j=N.get,P=N.set,C=N.getterFor(L),F=f,U=u.TypeError,V=u.document,z=u.process,Y=l("fetch"),W=k.f,H=W,G="process"==b(z),B=!!(V&&V.createEvent&&u.dispatchEvent),q=R(L,(function(){if(!(E(F)!==String(F))){if(66===D)return!0;if(!G&&"function"!=typeof PromiseRejectionEvent)return!0}if(s&&!F.prototype.finally)return!0;if(D>=51&&/native code/.test(F))return!1;var t=F.resolve(1),e=function(t){t((function(){}),(function(){}))};return(t.constructor={})[$]=e,!(t.then((function(){}))instanceof e)})),X=q||!_((function(t){F.all(t).catch((function(){}))})),Z=function(t){var e;return!(!v(t)||"function"!=typeof(e=t.then))&&e},K=function(t,e,n){if(!e.notified){e.notified=!0;var r=e.reactions;I((function(){for(var i=e.value,o=1==e.state,a=0;r.length>a;){var c,s,u,l=r[a++],f=o?l.ok:l.fail,h=l.resolve,d=l.reject,p=l.domain;try{f?(o||(2===e.rejection&&et(t,e),e.rejection=1),!0===f?c=i:(p&&p.enter(),c=f(i),p&&(p.exit(),u=!0)),c===l.promise?d(U("Promise-chain cycle")):(s=Z(c))?s.call(c,h,d):h(c)):d(i)}catch(t){p&&!u&&p.exit(),d(t)}}e.reactions=[],e.notified=!1,n&&!e.rejection&&Q(t,e)}))}},J=function(t,e,n){var r,i;B?((r=V.createEvent("Event")).promise=e,r.reason=n,r.initEvent(t,!1,!0),u.dispatchEvent(r)):r={promise:e,reason:n},(i=u["on"+t])?i(r):"unhandledrejection"===t&&O("Unhandled promise rejection",n)},Q=function(t,e){T.call(u,(function(){var n,r=e.value;if(tt(e)&&(n=M((function(){G?z.emit("unhandledRejection",r,t):J("unhandledrejection",t,r)})),e.rejection=G||tt(e)?2:1,n.error))throw n.value}))},tt=function(t){return 1!==t.rejection&&!t.parent},et=function(t,e){T.call(u,(function(){G?z.emit("rejectionHandled",t):J("rejectionhandled",t,e.value)}))},nt=function(t,e,n,r){return function(i){t(e,n,i,r)}},rt=function(t,e,n,r){e.done||(e.done=!0,r&&(e=r),e.value=n,e.state=2,K(t,e,!0))},it=function(t,e,n,r){if(!e.done){e.done=!0,r&&(e=r);try{if(t===n)throw U("Promise can't be resolved itself");var i=Z(n);i?I((function(){var r={done:!1};try{i.call(n,nt(it,t,r,e),nt(rt,t,r,e))}catch(n){rt(t,r,n,e)}})):(e.value=n,e.state=1,K(t,e,!1))}catch(n){rt(t,{done:!1},n,e)}}};q&&(F=function(t){m(this,F,L),y(t),r.call(this);var e=j(this);try{t(nt(it,this,e),nt(rt,this,e))}catch(t){rt(this,e,t)}},(r=function(t){P(this,{type:L,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0})}).prototype=d(F.prototype,{then:function(t,e){var n=C(this),r=W(S(this,F));return r.ok="function"!=typeof t||t,r.fail="function"==typeof e&&e,r.domain=G?z.domain:void 0,n.parent=!0,n.reactions.push(r),0!=n.state&&K(this,n,!1),r.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new r,e=j(t);this.promise=t,this.resolve=nt(it,t,e),this.reject=nt(rt,t,e)},k.f=W=function(t){return t===F||t===o?new i(t):H(t)},s||"function"!=typeof f||(a=f.prototype.then,h(f.prototype,"then",(function(t,e){var n=this;return new F((function(t,e){a.call(n,t,e)})).then(t,e)}),{unsafe:!0}),"function"==typeof Y&&c({global:!0,enumerable:!0,forced:!0},{fetch:function(t){return x(F,Y.apply(u,arguments))}}))),c({global:!0,wrap:!0,forced:q},{Promise:F}),p(F,L,!1,!0),g(L),o=l(L),c({target:L,stat:!0,forced:q},{reject:function(t){var e=W(this);return e.reject.call(void 0,t),e.promise}}),c({target:L,stat:!0,forced:s||q},{resolve:function(t){return x(s&&this===o?F:this,t)}}),c({target:L,stat:!0,forced:X},{all:function(t){var e=this,n=W(e),r=n.resolve,i=n.reject,o=M((function(){var n=y(e.resolve),o=[],a=0,c=1;w(t,(function(t){var s=a++,u=!1;o.push(void 0),c++,n.call(e,t).then((function(t){u||(u=!0,o[s]=t,--c||r(o))}),i)})),--c||r(o)}));return o.error&&i(o.value),n.promise},race:function(t){var e=this,n=W(e),r=n.reject,i=M((function(){var i=y(e.resolve);w(t,(function(t){i.call(e,t).then(n.resolve,r)}))}));return i.error&&r(i.value),n.promise}})},function(t,e,n){var r=n(2);t.exports=r.Promise},function(t,e,n){var r=n(66);t.exports=/(iphone|ipod|ipad).*applewebkit/i.test(r)},function(t,e,n){var r,i,o,a,c,s,u,l,f=n(2),h=n(13).f,d=n(24),p=n(98).set,g=n(152),v=f.MutationObserver||f.WebKitMutationObserver,y=f.process,m=f.Promise,b="process"==d(y),E=h(f,"queueMicrotask"),w=E&&E.value;w||(r=function(){var t,e;for(b&&(t=y.domain)&&t.exit();i;){e=i.fn,i=i.next;try{e()}catch(t){throw i?a():o=void 0,t}}o=void 0,t&&t.enter()},b?a=function(){y.nextTick(r)}:v&&!g?(c=!0,s=document.createTextNode(""),new v(r).observe(s,{characterData:!0}),a=function(){s.data=c=!c}):m&&m.resolve?(u=m.resolve(void 0),l=u.then,a=function(){l.call(u,r)}):a=function(){p.call(f,r)}),t.exports=w||function(t){var e={fn:t,next:void 0};o&&(o.next=e),i||(i=e,a()),o=e}},function(t,e,n){var r=n(4),i=n(3),o=n(99);t.exports=function(t,e){if(r(t),i(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e){t.exports=function(t){try{return{error:!1,value:t()}}catch(t){return{error:!0,value:t}}}},function(t,e,n){var r=n(0),i=n(25),o=n(19),a=n(4),c=n(3),s=n(31),u=n(157),l=n(1),f=i("Reflect","construct"),h=l((function(){function t(){}return!(f((function(){}),[],t)instanceof t)})),d=!l((function(){f((function(){}))})),p=h||d;r({target:"Reflect",stat:!0,forced:p,sham:p},{construct:function(t,e){o(t),a(e);var n=arguments.length<3?t:o(arguments[2]);if(d&&!h)return f(t,e,n);if(t==n){switch(e.length){case 0:return new t;case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3])}var r=[null];return r.push.apply(r,e),new(u.apply(t,r))}var i=n.prototype,l=s(c(i)?i:Object.prototype),p=Function.apply.call(t,l,e);return c(p)?p:l}})},function(t,e,n){"use strict";var r=n(19),i=n(3),o=[].slice,a={},c=function(t,e,n){if(!(e in a)){for(var r=[],i=0;i<e;i++)r[i]="a["+i+"]";a[e]=Function("C,a","return new C("+r.join(",")+")")}return a[e](t,n)};t.exports=Function.bind||function(t){var e=r(this),n=o.call(arguments,1),a=function(){var r=n.concat(o.call(arguments));return this instanceof a?c(e,r.length,r):e.apply(t,r)};return i(e.prototype)&&(a.prototype=e.prototype),a}},function(t,e,n){var r=n(5),i=n(2),o=n(54),a=n(69),c=n(9).f,s=n(40).f,u=n(71),l=n(62),f=n(72),h=n(14),d=n(1),p=n(17).set,g=n(47),v=n(6)("match"),y=i.RegExp,m=y.prototype,b=/a/g,E=/a/g,w=new y(b)!==b,_=f.UNSUPPORTED_Y;if(r&&o("RegExp",!w||_||d((function(){return E[v]=!1,y(b)!=b||y(E)==E||"/a/i"!=y(b,"i")})))){for(var S=function(t,e){var n,r=this instanceof S,i=u(t),o=void 0===e;if(!r&&i&&t.constructor===S&&o)return t;w?i&&!o&&(t=t.source):t instanceof S&&(o&&(e=l.call(t)),t=t.source),_&&(n=!!e&&e.indexOf("y")>-1)&&(e=e.replace(/y/g,""));var c=a(w?new y(t,e):y(t,e),r?this:m,S);return _&&n&&p(c,{sticky:n}),c},T=function(t){t in S||c(S,t,{configurable:!0,get:function(){return y[t]},set:function(e){y[t]=e}})},I=s(y),x=0;I.length>x;)T(I[x++]);m.constructor=S,S.prototype=m,h(i,"RegExp",S)}g("RegExp")},function(t,e,n){"use strict";var r=n(14),i=n(4),o=n(1),a=n(62),c=RegExp.prototype,s=c.toString,u=o((function(){return"/a/b"!=s.call({source:"a",flags:"b"})})),l="toString"!=s.name;(u||l)&&r(RegExp.prototype,"toString",(function(){var t=i(this),e=String(t.source),n=t.flags;return"/"+e+"/"+String(void 0===n&&t instanceof RegExp&&!("flags"in c)?a.call(t):n)}),{unsafe:!0})},function(t,e,n){"use strict";var r=n(0),i=n(100),o=n(15);r({target:"String",proto:!0,forced:!n(101)("includes")},{includes:function(t){return!!~String(o(this)).indexOf(i(t),arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r=n(76),i=n(4),o=n(10),a=n(7),c=n(26),s=n(15),u=n(77),l=n(78),f=Math.max,h=Math.min,d=Math.floor,p=/\$([$&'`]|\d\d?|<[^>]*>)/g,g=/\$([$&'`]|\d\d?)/g;r("replace",2,(function(t,e,n,r){var v=r.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,y=r.REPLACE_KEEPS_$0,m=v?"$":"$0";return[function(n,r){var i=s(this),o=null==n?void 0:n[t];return void 0!==o?o.call(n,i,r):e.call(String(i),n,r)},function(t,r){if(!v&&y||"string"==typeof r&&-1===r.indexOf(m)){var o=n(e,t,this,r);if(o.done)return o.value}var s=i(t),d=String(this),p="function"==typeof r;p||(r=String(r));var g=s.global;if(g){var E=s.unicode;s.lastIndex=0}for(var w=[];;){var _=l(s,d);if(null===_)break;if(w.push(_),!g)break;""===String(_[0])&&(s.lastIndex=u(d,a(s.lastIndex),E))}for(var S,T="",I=0,x=0;x<w.length;x++){_=w[x];for(var O=String(_[0]),k=f(h(c(_.index),d.length),0),M=[],N=1;N<_.length;N++)M.push(void 0===(S=_[N])?S:String(S));var R=_.groups;if(p){var A=[O].concat(M,k,d);void 0!==R&&A.push(R);var D=String(r.apply(void 0,A))}else D=b(O,d,k,M,R,r);k>=I&&(T+=d.slice(I,k)+D,I=k+O.length)}return T+d.slice(I)}];function b(t,n,r,i,a,c){var s=r+t.length,u=i.length,l=g;return void 0!==a&&(a=o(a),l=p),e.call(c,l,(function(e,o){var c;switch(o.charAt(0)){case"$":return"$";case"&":return t;case"`":return n.slice(0,r);case"'":return n.slice(s);case"<":c=a[o.slice(1,-1)];break;default:var l=+o;if(0===l)return e;if(l>u){var f=d(l/10);return 0===f?e:f<=u?void 0===i[f-1]?o.charAt(1):i[f-1]+o.charAt(1):e}c=i[l-1]}return void 0===c?"":c}))}}))},function(t,e,n){"use strict";var r=n(76),i=n(71),o=n(4),a=n(15),c=n(33),s=n(77),u=n(7),l=n(78),f=n(74),h=n(1),d=[].push,p=Math.min,g=!h((function(){return!RegExp(4294967295,"y")}));r("split",2,(function(t,e,n){var r;return r="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,n){var r=String(a(this)),o=void 0===n?4294967295:n>>>0;if(0===o)return[];if(void 0===t)return[r];if(!i(t))return e.call(r,t,o);for(var c,s,u,l=[],h=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),p=0,g=new RegExp(t.source,h+"g");(c=f.call(g,r))&&!((s=g.lastIndex)>p&&(l.push(r.slice(p,c.index)),c.length>1&&c.index<r.length&&d.apply(l,c.slice(1)),u=c[0].length,p=s,l.length>=o));)g.lastIndex===c.index&&g.lastIndex++;return p===r.length?!u&&g.test("")||l.push(""):l.push(r.slice(p)),l.length>o?l.slice(0,o):l}:"0".split(void 0,0).length?function(t,n){return void 0===t&&0===n?[]:e.call(this,t,n)}:e,[function(e,n){var i=a(this),o=null==e?void 0:e[t];return void 0!==o?o.call(e,i,n):r.call(String(i),e,n)},function(t,i){var a=n(r,t,this,i,r!==e);if(a.done)return a.value;var f=o(t),h=String(this),d=c(f,RegExp),v=f.unicode,y=(f.ignoreCase?"i":"")+(f.multiline?"m":"")+(f.unicode?"u":"")+(g?"y":"g"),m=new d(g?f:"^(?:"+f.source+")",y),b=void 0===i?4294967295:i>>>0;if(0===b)return[];if(0===h.length)return null===l(m,h)?[h]:[];for(var E=0,w=0,_=[];w<h.length;){m.lastIndex=g?w:0;var S,T=l(m,g?h:h.slice(w));if(null===T||(S=p(u(m.lastIndex+(g?0:w)),h.length))===E)w=s(h,w,v);else{if(_.push(h.slice(E,w)),_.length===b)return _;for(var I=1;I<=T.length-1;I++)if(_.push(T[I]),_.length===b)return _;w=E=S}}return _.push(h.slice(E)),_}]}),!g)},function(t,e,n){var r=n(2),i=n(164),o=n(127),a=n(16);for(var c in i){var s=r[c],u=s&&s.prototype;if(u&&u.forEach!==o)try{a(u,"forEach",o)}catch(t){u.forEach=o}}},function(t,e){t.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},function(t,e,n){var r=n(2),i=n(164),o=n(61),a=n(16),c=n(6),s=c("iterator"),u=c("toStringTag"),l=o.values;for(var f in i){var h=r[f],d=h&&h.prototype;if(d){if(d[s]!==l)try{a(d,s,l)}catch(t){d[s]=l}if(d[u]||a(d,u,f),i[f])for(var p in o)if(d[p]!==o[p])try{a(d,p,o[p])}catch(t){d[p]=o[p]}}}},function(t,e,n){var r=function(t){"use strict";var e=Object.prototype,n=e.hasOwnProperty,r="function"==typeof Symbol?Symbol:{},i=r.iterator||"@@iterator",o=r.asyncIterator||"@@asyncIterator",a=r.toStringTag||"@@toStringTag";function c(t,e,n){return Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,n){return t[e]=n}}function s(t,e,n,r){var i=e&&e.prototype instanceof f?e:f,o=Object.create(i.prototype),a=new S(r||[]);return o._invoke=function(t,e,n){var r="suspendedStart";return function(i,o){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===i)throw o;return I()}for(n.method=i,n.arg=o;;){var a=n.delegate;if(a){var c=E(a,n);if(c){if(c===l)continue;return c}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var s=u(t,e,n);if("normal"===s.type){if(r=n.done?"completed":"suspendedYield",s.arg===l)continue;return{value:s.arg,done:n.done}}"throw"===s.type&&(r="completed",n.method="throw",n.arg=s.arg)}}}(t,n,a),o}function u(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}t.wrap=s;var l={};function f(){}function h(){}function d(){}var p={};p[i]=function(){return this};var g=Object.getPrototypeOf,v=g&&g(g(T([])));v&&v!==e&&n.call(v,i)&&(p=v);var y=d.prototype=f.prototype=Object.create(p);function m(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function b(t,e){var r;this._invoke=function(i,o){function a(){return new e((function(r,a){!function r(i,o,a,c){var s=u(t[i],t,o);if("throw"!==s.type){var l=s.arg,f=l.value;return f&&"object"==typeof f&&n.call(f,"__await")?e.resolve(f.__await).then((function(t){r("next",t,a,c)}),(function(t){r("throw",t,a,c)})):e.resolve(f).then((function(t){l.value=t,a(l)}),(function(t){return r("throw",t,a,c)}))}c(s.arg)}(i,o,r,a)}))}return r=r?r.then(a,a):a()}}function E(t,e){var n=t.iterator[e.method];if(void 0===n){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=void 0,E(t,e),"throw"===e.method))return l;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return l}var r=u(n,t.iterator,e.arg);if("throw"===r.type)return e.method="throw",e.arg=r.arg,e.delegate=null,l;var i=r.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,l):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,l)}function w(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function _(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function S(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(w,this),this.reset(!0)}function T(t){if(t){var e=t[i];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,o=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return o.next=o}}return{next:I}}function I(){return{value:void 0,done:!0}}return h.prototype=y.constructor=d,d.constructor=h,h.displayName=c(d,a,"GeneratorFunction"),t.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,d):(t.__proto__=d,c(t,a,"GeneratorFunction")),t.prototype=Object.create(y),t},t.awrap=function(t){return{__await:t}},m(b.prototype),b.prototype[o]=function(){return this},t.AsyncIterator=b,t.async=function(e,n,r,i,o){void 0===o&&(o=Promise);var a=new b(s(e,n,r,i),o);return t.isGeneratorFunction(n)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},m(y),c(y,a,"Generator"),y[i]=function(){return this},y.toString=function(){return"[object Generator]"},t.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},t.values=T,S.prototype={constructor:S,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(_),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(n,r){return a.type="throw",a.arg=t,e.next=n,r&&(e.method="next",e.arg=void 0),!!r}for(var i=this.tryEntries.length-1;i>=0;--i){var o=this.tryEntries[i],a=o.completion;if("root"===o.tryLoc)return r("end");if(o.tryLoc<=this.prev){var c=n.call(o,"catchLoc"),s=n.call(o,"finallyLoc");if(c&&s){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(c){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var o=i;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=t,a.arg=e,o?(this.method="next",this.next=o.finallyLoc,l):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),l},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),_(n),l}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var i=r.arg;_(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:T(t),resultName:e,nextLoc:n},"next"===this.method&&(this.arg=void 0),l}},t}(t.exports);try{regeneratorRuntime=r}catch(t){Function("r","regeneratorRuntime = r")(r)}},function(t,e){t.exports=Object.is||function(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}},function(t,e,n){"use strict";var r=n(10),i=n(36),o=n(7),a=Math.min;t.exports=[].copyWithin||function(t,e){var n=r(this),c=o(n.length),s=i(t,c),u=i(e,c),l=arguments.length>2?arguments[2]:void 0,f=a((void 0===l?c:i(l,c))-u,c-s),h=1;for(u<s&&s<u+f&&(h=-1,u+=f-1,s+=f-1);f-- >0;)u in n?n[s]=n[u]:delete n[s],s+=h,u+=h;return n}},function(t,e,n){"use strict";var r=n(41),i=n(7),o=n(37),a=function(t,e,n,c,s,u,l,f){for(var h,d=s,p=0,g=!!l&&o(l,f,3);p<c;){if(p in n){if(h=g?g(n[p],p,e):n[p],u>0&&r(h))d=a(t,e,h,i(h.length),d,u-1)-1;else{if(d>=9007199254740991)throw TypeError("Exceed the acceptable array length");t[d]=h}d++}p++}return d};t.exports=a},function(t,e,n){"use strict";var r=n(21),i=n(26),o=n(7),a=n(32),c=n(20),s=Math.min,u=[].lastIndexOf,l=!!u&&1/[1].lastIndexOf(1,-0)<0,f=a("lastIndexOf"),h=c("indexOf",{ACCESSORS:!0,1:0}),d=l||!f||!h;t.exports=d?function(t){if(l)return u.apply(this,arguments)||0;var e=r(this),n=o(e.length),a=n-1;for(arguments.length>1&&(a=s(a,i(arguments[1]))),a<0&&(a=n+a);a>=0;a--)if(a in e&&e[a]===t)return a||0;return-1}:u},function(t,e,n){var r=n(66);t.exports=/Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(r)},function(t,e,n){var r=n(2),i=n(45).trim,o=n(70),a=r.parseInt,c=/^[+-]?0[Xx]/,s=8!==a(o+"08")||22!==a(o+"0x16");t.exports=s?function(t,e){var n=i(String(t));return a(n,e>>>0||(c.test(n)?16:10))}:a},function(t,e,n){var r=n(2),i=n(45).trim,o=n(70),a=r.parseFloat,c=1/a(o+"-0")!=-1/0;t.exports=c?function(t){var e=i(String(t)),n=a(e);return 0===n&&"-"==e.charAt(0)?-0:n}:a},function(t,e,n){var r=n(3),i=Math.floor;t.exports=function(t){return!r(t)&&isFinite(t)&&i(t)===t}},function(t,e,n){var r=n(24);t.exports=function(t){if("number"!=typeof t&&"Number"!=r(t))throw TypeError("Incorrect invocation");return+t}},function(t,e){var n=Math.log;t.exports=Math.log1p||function(t){return(t=+t)>-1e-8&&t<1e-8?t-t*t/2:n(1+t)}},function(t,e,n){"use strict";var r=n(9).f,i=n(31),o=n(46),a=n(37),c=n(39),s=n(48),u=n(95),l=n(47),f=n(5),h=n(44).fastKey,d=n(17),p=d.set,g=d.getterFor;t.exports={getConstructor:function(t,e,n,u){var l=t((function(t,r){c(t,l,e),p(t,{type:e,index:i(null),first:void 0,last:void 0,size:0}),f||(t.size=0),null!=r&&s(r,t[u],t,n)})),d=g(e),v=function(t,e,n){var r,i,o=d(t),a=y(t,e);return a?a.value=n:(o.last=a={index:i=h(e,!0),key:e,value:n,previous:r=o.last,next:void 0,removed:!1},o.first||(o.first=a),r&&(r.next=a),f?o.size++:t.size++,"F"!==i&&(o.index[i]=a)),t},y=function(t,e){var n,r=d(t),i=h(e);if("F"!==i)return r.index[i];for(n=r.first;n;n=n.next)if(n.key==e)return n};return o(l.prototype,{clear:function(){for(var t=d(this),e=t.index,n=t.first;n;)n.removed=!0,n.previous&&(n.previous=n.previous.next=void 0),delete e[n.index],n=n.next;t.first=t.last=void 0,f?t.size=0:this.size=0},delete:function(t){var e=d(this),n=y(this,t);if(n){var r=n.next,i=n.previous;delete e.index[n.index],n.removed=!0,i&&(i.next=r),r&&(r.previous=i),e.first==n&&(e.first=r),e.last==n&&(e.last=i),f?e.size--:this.size--}return!!n},forEach:function(t){for(var e,n=d(this),r=a(t,arguments.length>1?arguments[1]:void 0,3);e=e?e.next:n.first;)for(r(e.value,e.key,this);e&&e.removed;)e=e.previous},has:function(t){return!!y(this,t)}}),o(l.prototype,n?{get:function(t){var e=y(this,t);return e&&e.value},set:function(t,e){return v(this,0===t?0:t,e)}}:{add:function(t){return v(this,t=0===t?0:t,t)}}),f&&r(l.prototype,"size",{get:function(){return d(this).size}}),l},setStrong:function(t,e,n){var r=e+" Iterator",i=g(e),o=g(r);u(t,e,(function(t,e){p(this,{type:r,target:t,state:i(t),kind:e,last:void 0})}),(function(){for(var t=o(this),e=t.kind,n=t.last;n&&n.removed;)n=n.previous;return t.target&&(t.last=n=n?n.next:t.state.first)?"keys"==e?{value:n.key,done:!1}:"values"==e?{value:n.value,done:!1}:{value:[n.key,n.value],done:!1}:(t.target=void 0,{value:void 0,done:!0})}),n?"entries":"values",!n,!0),l(e)}}},function(t,e,n){"use strict";var r=n(46),i=n(44).getWeakData,o=n(4),a=n(3),c=n(39),s=n(48),u=n(12),l=n(11),f=n(17),h=f.set,d=f.getterFor,p=u.find,g=u.findIndex,v=0,y=function(t){return t.frozen||(t.frozen=new m)},m=function(){this.entries=[]},b=function(t,e){return p(t.entries,(function(t){return t[0]===e}))};m.prototype={get:function(t){var e=b(this,t);if(e)return e[1]},has:function(t){return!!b(this,t)},set:function(t,e){var n=b(this,t);n?n[1]=e:this.entries.push([t,e])},delete:function(t){var e=g(this.entries,(function(e){return e[0]===t}));return~e&&this.entries.splice(e,1),!!~e}},t.exports={getConstructor:function(t,e,n,u){var f=t((function(t,r){c(t,f,e),h(t,{type:e,id:v++,frozen:void 0}),null!=r&&s(r,t[u],t,n)})),p=d(e),g=function(t,e,n){var r=p(t),a=i(o(e),!0);return!0===a?y(r).set(e,n):a[r.id]=n,t};return r(f.prototype,{delete:function(t){var e=p(this);if(!a(t))return!1;var n=i(t);return!0===n?y(e).delete(t):n&&l(n,e.id)&&delete n[e.id]},has:function(t){var e=p(this);if(!a(t))return!1;var n=i(t);return!0===n?y(e).has(t):n&&l(n,e.id)}}),r(f.prototype,n?{get:function(t){var e=p(this);if(a(t)){var n=i(t);return!0===n?y(e).get(t):n?n[e.id]:void 0}},set:function(t,e){return g(this,t,e)}}:{add:function(t){return g(this,t,!0)}}),f}}},function(t,e,n){var r=n(26),i=n(7);t.exports=function(t){if(void 0===t)return 0;var e=r(t),n=i(e);if(e!==n)throw RangeError("Wrong length or index");return n}},function(t,e,n){var r=n(323);t.exports=function(t,e){var n=r(t);if(n%e)throw RangeError("Wrong offset");return n}},function(t,e,n){var r=n(10),i=n(7),o=n(59),a=n(93),c=n(37),s=n(8).aTypedArrayConstructor;t.exports=function(t){var e,n,u,l,f,h,d=r(t),p=arguments.length,g=p>1?arguments[1]:void 0,v=void 0!==g,y=o(d);if(null!=y&&!a(y))for(h=(f=y.call(d)).next,d=[];!(l=h.call(f)).done;)d.push(l.value);for(v&&p>2&&(g=c(g,arguments[2],2)),n=i(d.length),u=new(s(this))(n),e=0;n>e;e++)u[e]=v?g(d[e],e):d[e];return u}},function(t,e,n){var r=n(1),i=n(6),o=n(28),a=i("iterator");t.exports=!r((function(){var t=new URL("b?a=1&b=2&c=3","http://a"),e=t.searchParams,n="";return t.pathname="c%20d",e.forEach((function(t,r){e.delete("b"),n+=r+t})),o&&!t.toJSON||!e.sort||"http://a/c%20d?a=1&c=3"!==t.href||"3"!==e.get("c")||"a=1"!==String(new URLSearchParams("?a=1"))||!e[a]||"a"!==new URL("https://a@b").username||"b"!==new URLSearchParams(new URLSearchParams("a=b")).get("a")||"xn--e1aybc"!==new URL("http://тест").host||"#%D0%B1"!==new URL("http://a#б").hash||"a1c3"!==n||"x"!==new URL("http://x",void 0).host}))},function(t,e,n){"use strict";n(61);var r=n(0),i=n(25),o=n(182),a=n(14),c=n(46),s=n(30),u=n(96),l=n(17),f=n(39),h=n(11),d=n(37),p=n(60),g=n(4),v=n(3),y=n(31),m=n(35),b=n(375),E=n(59),w=n(6),_=i("fetch"),S=i("Headers"),T=w("iterator"),I=l.set,x=l.getterFor("URLSearchParams"),O=l.getterFor("URLSearchParamsIterator"),k=/\+/g,M=Array(4),N=function(t){return M[t-1]||(M[t-1]=RegExp("((?:%[\\da-f]{2}){"+t+"})","gi"))},R=function(t){try{return decodeURIComponent(t)}catch(e){return t}},A=function(t){var e=t.replace(k," "),n=4;try{return decodeURIComponent(e)}catch(t){for(;n;)e=e.replace(N(n--),R);return e}},D=/[!'()~]|%20/g,$={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+"},L=function(t){return $[t]},j=function(t){return encodeURIComponent(t).replace(D,L)},P=function(t,e){if(e)for(var n,r,i=e.split("&"),o=0;o<i.length;)(n=i[o++]).length&&(r=n.split("="),t.push({key:A(r.shift()),value:A(r.join("="))}))},C=function(t){this.entries.length=0,P(this.entries,t)},F=function(t,e){if(t<e)throw TypeError("Not enough arguments")},U=u((function(t,e){I(this,{type:"URLSearchParamsIterator",iterator:b(x(t).entries),kind:e})}),"Iterator",(function(){var t=O(this),e=t.kind,n=t.iterator.next(),r=n.value;return n.done||(n.value="keys"===e?r.key:"values"===e?r.value:[r.key,r.value]),n})),V=function(){f(this,V,"URLSearchParams");var t,e,n,r,i,o,a,c,s,u=arguments.length>0?arguments[0]:void 0,l=this,d=[];if(I(l,{type:"URLSearchParams",entries:d,updateURL:function(){},updateSearchParams:C}),void 0!==u)if(v(u))if("function"==typeof(t=E(u)))for(n=(e=t.call(u)).next;!(r=n.call(e)).done;){if((a=(o=(i=b(g(r.value))).next).call(i)).done||(c=o.call(i)).done||!o.call(i).done)throw TypeError("Expected sequence with length 2");d.push({key:a.value+"",value:c.value+""})}else for(s in u)h(u,s)&&d.push({key:s,value:u[s]+""});else P(d,"string"==typeof u?"?"===u.charAt(0)?u.slice(1):u:u+"")},z=V.prototype;c(z,{append:function(t,e){F(arguments.length,2);var n=x(this);n.entries.push({key:t+"",value:e+""}),n.updateURL()},delete:function(t){F(arguments.length,1);for(var e=x(this),n=e.entries,r=t+"",i=0;i<n.length;)n[i].key===r?n.splice(i,1):i++;e.updateURL()},get:function(t){F(arguments.length,1);for(var e=x(this).entries,n=t+"",r=0;r<e.length;r++)if(e[r].key===n)return e[r].value;return null},getAll:function(t){F(arguments.length,1);for(var e=x(this).entries,n=t+"",r=[],i=0;i<e.length;i++)e[i].key===n&&r.push(e[i].value);return r},has:function(t){F(arguments.length,1);for(var e=x(this).entries,n=t+"",r=0;r<e.length;)if(e[r++].key===n)return!0;return!1},set:function(t,e){F(arguments.length,1);for(var n,r=x(this),i=r.entries,o=!1,a=t+"",c=e+"",s=0;s<i.length;s++)(n=i[s]).key===a&&(o?i.splice(s--,1):(o=!0,n.value=c));o||i.push({key:a,value:c}),r.updateURL()},sort:function(){var t,e,n,r=x(this),i=r.entries,o=i.slice();for(i.length=0,n=0;n<o.length;n++){for(t=o[n],e=0;e<n;e++)if(i[e].key>t.key){i.splice(e,0,t);break}e===n&&i.push(t)}r.updateURL()},forEach:function(t){for(var e,n=x(this).entries,r=d(t,arguments.length>1?arguments[1]:void 0,3),i=0;i<n.length;)r((e=n[i++]).value,e.key,this)},keys:function(){return new U(this,"keys")},values:function(){return new U(this,"values")},entries:function(){return new U(this,"entries")}},{enumerable:!0}),a(z,T,z.entries),a(z,"toString",(function(){for(var t,e=x(this).entries,n=[],r=0;r<e.length;)t=e[r++],n.push(j(t.key)+"="+j(t.value));return n.join("&")}),{enumerable:!0}),s(V,"URLSearchParams"),r({global:!0,forced:!o},{URLSearchParams:V}),o||"function"!=typeof _||"function"!=typeof S||r({global:!0,enumerable:!0,forced:!0},{fetch:function(t){var e,n,r,i=[t];return arguments.length>1&&(v(e=arguments[1])&&(n=e.body,"URLSearchParams"===p(n)&&((r=e.headers?new S(e.headers):new S).has("content-type")||r.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"),e=y(e,{body:m(0,String(n)),headers:m(0,r)}))),i.push(e)),_.apply(this,i)}}),t.exports={URLSearchParams:V,getState:x}},function(t,e,n){"use strict";n.r(e);n(110),n(120),n(121),n(122),n(123),n(124),n(125),n(126),n(128),n(131),n(132),n(61),n(135),n(136),n(137),n(138),n(139),n(140),n(141),n(142),n(144),n(145),n(146),n(147),n(148),n(150),n(156),n(158),n(73),n(159),n(160),n(102),n(161),n(162),n(163),n(165),n(166),n(188);function r(t,e,n){return(r=i()?Reflect.construct:function(t,e,n){var r=[null];r.push.apply(r,e);var i=new(Function.bind.apply(t,r));return n&&o(i,n.prototype),i}).apply(null,arguments)}function i(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}function o(t,e){return(o=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function a(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,i=!1,o=void 0;try{for(var a,c=t[Symbol.iterator]();!(r=(a=c.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){i=!0,o=t}finally{try{r||null==c.return||c.return()}finally{if(i)throw o}}return n}(t,e)||h(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function c(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function s(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?c(Object(n),!0).forEach((function(e){u(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function u(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function l(t){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function f(t){return function(t){if(Array.isArray(t))return d(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||h(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function h(t,e){if(t){if("string"==typeof t)return d(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?d(t,e):void 0}}function d(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function p(t,e,n,r,i,o,a){try{var c=t[o](a),s=c.value}catch(t){return void n(t)}c.done?e(s):Promise.resolve(s).then(r,i)}function g(t){return function(){var e=this,n=arguments;return new Promise((function(r,i){var o=t.apply(e,n);function a(t){p(o,r,i,a,c,"next",t)}function c(t){p(o,r,i,a,c,"throw",t)}a(void 0)}))}}function v(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}
/*!
 * jQuery Timeline
 * ------------------------
 * Version: 2.0.0 (revised from beta 6)
 * Last Modified: November 19, 2019 (UTC)
 * Author: Ka2 (https://ka2.org/)
 * Repository: https://github.com/ka215/jquery.timeline
 * Lisenced: MIT
 */
var $ = jQuery.noConflict();

var y,m,b="Timeline",E="jq.timeline",w=".".concat(E),_="jqtl-",S="ontouchstart"in window,T=$.fn[b],I={type:"bar",scale:"day",startDatetime:"currently",endDatetime:"auto",range:3,rows:"auto",rowHeight:48,width:"auto",height:"auto",minGridSize:30,marginHeight:2,headline:{display:!0,title:"",range:!0,locale:"en-US",format:{hour12:!1}},sidebar:{sticky:!1,overlay:!1,list:[]},ruler:{truncateLowers:!1,top:{lines:[],height:30,fontSize:14,color:"#777777",background:"#FFFFFF",locale:"en-US",format:{hour12:!1}}},footer:{display:!0,content:"",range:!1,locale:"en-US",format:{hour12:!1}},eventMeta:{display:!1,scale:"day",locale:"en-US",format:{hour12:!1},content:""},eventData:[],effects:{presentTime:!0,hoverEvent:!0,stripedGridRow:!0,horizontalGridStyle:"dotted",verticalGridStyle:"solid"},colorScheme:{event:{text:"#000",border:"#000",background:"#000"},hookEventColors:function(){return null}},rangeAlign:"latest",loader:"default",loadingMessage:"",hideScrollbar:!1,storage:"session",reloadCacheKeep:!0,zoom:!1,wrapScale:!0,firstDayOfWeek:0,engine:"canvas",debug:!1},x={millennium:100,century:500,decade:500,lustrum:500,year:500,month:540,week:530,day:366,hour:720,quarterHour:720,halfHour:720,minute:720,second:900},O={uid:"",eventId:"",x:0,y:I.marginHeight,width:I.minGridSize,height:I.rowHeight-2*I.marginHeight,start:"",end:"",row:1,bgColor:I.colorScheme.event.background,color:I.colorScheme.event.text,bdColor:I.colorScheme.event.border,label:"",content:"",category:"",image:"",margin:I.marginHeight,rangeMeta:"",size:"normal",type:"",extend:{},remote:!1,relation:{},callback:function(){}},k={INITIALIZED:"initialized".concat(w),HIDE:"hide".concat(w),SHOW:"show".concat(w),CLICK_EVENT:"click.open".concat(w),FOCUSIN_EVENT:"focusin.event".concat(w),FOCUSOUT_EVENT:"focusout.event".concat(w),TOUCHSTART_TIMELINE:"mousedown.timeline".concat(w),TOUCHMOVE_TIMELINE:"mousemove.timeline".concat(w),TOUCHEND_TIMELINE:"mouseup.timeline".concat(w),MOUSEENTER_POINTER:"mouseenter.pointer".concat(w),MOUSELEAVE_POINTER:"mouseleave.pointer".concat(w),ZOOMIN_SCALE:"dblclick.zoom".concat(w)},M={TIMELINE_CONTAINER:"".concat(_,"container"),TIMELINE_MAIN:"".concat(_,"main"),TIMELINE_HEADLINE:"".concat(_,"headline"),TIMELINE_HEADLINE_WRAPPER:"".concat(_,"headline-wrapper"),HEADLINE_TITLE:"".concat(_,"timeline-title"),RANGE_META:"".concat(_,"range-meta"),RANGE_SPAN:"".concat(_,"range-span"),TIMELINE_EVENT_CONTAINER:"".concat(_,"event-container"),TIMELINE_BACKGROUND_GRID:"".concat(_,"bg-grid"),TIMELINE_RELATION_LINES:"".concat(_,"relation-lines"),TIMELINE_EVENTS:"".concat(_,"events"),TIMELINE_EVENT_NODE:"".concat(_,"event-node"),TIMELINE_EVENT_LABEL:"".concat(_,"event-label"),TIMELINE_EVENT_THUMBNAIL:"".concat(_,"event-thumbnail"),TIMELINE_RULER_LINES:"".concat(_,"ruler-line-rows"),TIMELINE_RULER_ITEM:"".concat(_,"ruler-line-item"),TIMELINE_SIDEBAR:"".concat(_,"side-index"),TIMELINE_SIDEBAR_MARGIN:"".concat(_,"side-index-margin"),TIMELINE_SIDEBAR_ITEM:"".concat(_,"side-index-item"),TIMELINE_FOOTER:"".concat(_,"footer"),TIMELINE_FOOTER_CONTENT:"".concat(_,"footer-content"),VIEWER_EVENT_TITLE:"".concat(_,"event-title"),VIEWER_EVENT_CONTENT:"".concat(_,"event-content"),VIEWER_EVENT_META:"".concat(_,"event-meta"),VIEWER_EVENT_IMAGE_WRAPPER:"".concat(_,"event-image-wrapper"),VIEWER_EVENT_IMAGE:"".concat(_,"event-image"),VIEWER_EVENT_TYPE_POINTER:"".concat(_,"event-type-pointer"),HIDE_SCROLLBAR:"".concat(_,"hide-scrollbar"),HIDE:"".concat(_,"hide"),RULER_ITEM_ALIGN_LEFT:"".concat(_,"rli-left"),STICKY_LEFT:"".concat(_,"sticky-left"),OVERLAY:"".concat(_,"overlay"),ALIGN_SELF_RIGHT:"".concat(_,"align-self-right"),PRESENT_TIME_MARKER:"".concat(_,"present-time"),LOADER_CONTAINER:"".concat(_,"loader"),LOADER_ITEM:"".concat(_,"loading")},N={EVENT_NODE:".".concat(_,"event-node"),EVENT_VIEW:".timeline-event-view, .".concat(_,"event-view"),RULER_TOP:".".concat(_,"ruler-top"),RULER_BOTTOM:".".concat(_,"ruler-bottom"),TIMELINE_CONTAINER:".".concat(M.TIMELINE_CONTAINER),TIMELINE_MAIN:".".concat(M.TIMELINE_MAIN),TIMELINE_RULER_TOP:".".concat(_,"ruler-top"),TIMELINE_EVENT_CONTAINER:".".concat(M.TIMELINE_EVENT_CONTAINER),TIMELINE_RULER_BOTTOM:".".concat(_,"ruler-bottom"),TIMELINE_RULER_ITEM:".".concat(M.TIMELINE_RULER_ITEM),TIMELINE_RELATION_LINES:".".concat(M.TIMELINE_RELATION_LINES),TIMELINE_EVENTS:".".concat(M.TIMELINE_EVENTS),TIMELINE_SIDEBAR:".".concat(M.TIMELINE_SIDEBAR),TIMELINE_SIDEBAR_ITEM:".".concat(M.TIMELINE_SIDEBAR_ITEM),TIMELINE_EVENT_NODE:".".concat(M.TIMELINE_EVENT_NODE),VIEWER_EVENT_TYPE_POINTER:".".concat(M.VIEWER_EVENT_TYPE_POINTER),LOADER:".".concat(M.LOADER_CONTAINER),DEFAULT_EVENTS:".timeline-events"},R=(y={},m=1,{set:function(t,e,n){void 0===t.key&&(t.key={key:e,id:m},m++),y[t.key.id]=n},get:function(t,e){if(!t||void 0===t.key)return null;var n=t.key;return n.key===e?y[n.id]:null},delete:function(t,e){if(void 0!==t.key){var n=t.key;n.key===e&&(delete y[n.id],delete t.key)}}}),A=function(t,e,n){R.set(t,e,n)},D=function(t,e){return R.get(t,e)},L=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._config=this._getConfig(n),this._element=e,this._selector=null,this._isInitialized=!1,this._isCached=!1,this._isCompleted=!1,this._isShown=!1,this._isTouched=!1,this._instanceProps={},this._observer=null,this._beforeOpenEvent=null,A(e,E,this)}var e,n,i,o,c,h,d,p;return e=t,n=[{key:"_getConfig",value:function(t){return t.startDatetime instanceof Date&&(t.startDatetime=t.startDatetime.toString()),t.endDatetime instanceof Date&&(t.endDatetime=t.endDatetime.toString()),this.mergeDeep(I,t)}},{key:"_filterScaleKeyName",value:function(t){var e=null;switch(!0){case/^millenniums?|millennia$/i.test(t):e="millennium";break;case/^century$/i.test(t):e="century";break;case/^dec(ade|ennium)$/i.test(t):e="decade";break;case/^lustrum$/i.test(t):e="lustrum";break;case/^years?$/i.test(t):e="year";break;case/^months?$/i.test(t):e="month";break;case/^weeks?$/i.test(t):e="week";break;case/^weekdays?$/i.test(t):e="weekday";break;case/^da(y|te)s?$/i.test(t):e="day";break;case/^hours?$/i.test(t):e="hour";break;case/^quarter-?(|hour)$/i.test(t):e="quarterHour";break;case/^half-?(|hour)$/i.test(t):e="halfHour";break;case/^minutes?$/i.test(t):e="minute";break;case/^seconds?$/i.test(t):e="second";break;default:e="millisecond"}return e}},{key:"_init",value:(p=g(regeneratorRuntime.mark((function t(){var e,n,r,i=this;return regeneratorRuntime.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._debug("_init"),e=this._element,n="".concat(e.tagName).concat(e.id?"#".concat(e.id):"").concat(e.className?".".concat(e.className.replace(/\s/g,".")):""),this._selector=n.toLowerCase(),!this._isInitialized&&!this._isCompleted){t.next=5;break}return t.abrupt("return",this);case 5:if(this._calcVars(),this.showLoader(),this._verifyMaxRenderableRange()){t.next=9;break}throw new RangeError("Timeline display period exceeds maximum renderable range.");case 9:if(this._renderView(),this._isCached||this._loadEvent(),!this._isCached){t.next=14;break}return t.next=14,this._placeEvent();case 14:return $(document).on(k.CLICK_EVENT,"".concat(this._selector," ").concat(N.EVENT_NODE),(function(t){return i.openEvent(t)})),$(e).on(k.FOCUSIN_EVENT,N.TIMELINE_EVENT_NODE,(function(t){return i._activeEvent(t)})),$(e).on(k.FOCUSOUT_EVENT,N.TIMELINE_EVENT_NODE,(function(t){return i._activeEvent(t)})),$(e).on(k.TOUCHSTART_TIMELINE,N.TIMELINE_MAIN,(function(t){return i._swipeStart(t)})),$(e).on(k.TOUCHMOVE_TIMELINE,N.TIMELINE_MAIN,(function(t){return i._swipeMove(t)})),$(e).on(k.TOUCHEND_TIMELINE,N.TIMELINE_MAIN,(function(t){return i._swipeEnd(t)})),/^point(|er)$/i.test(this._config.type)&&($(e).on(k.MOUSEENTER_POINTER,N.VIEWER_EVENT_TYPE_POINTER,(function(t){return i._hoverPointer(t)})),$(e).on(k.MOUSELEAVE_POINTER,N.VIEWER_EVENT_TYPE_POINTER,(function(t){return i._hoverPointer(t)}))),this._config.zoom&&$(e).on(k.ZOOMIN_SCALE,N.TIMELINE_RULER_ITEM,(function(t){return i.zoomScale(t)})),$(e).find(N.TIMELINE_CONTAINER).on("scroll",(function(t){return i._scrollTimeline(t)})),this._isCompleted=!0,t.next=26,this.hideLoader();case 26:this.alignment(),this._isInitialized||(r=$.Event(k.INITIALIZED,e),$(e).trigger(r),$(e).off(k.INITIALIZED)),$.fn.popover&&$('[data-toggle="popover"]').popover();case 29:case"end":return t.stop()}}),t,this)}))),function(){return p.apply(this,arguments)})},{key:"_calcVars",value:function(){var t=this,e=this._config,n={},r=function(e,n){return t.verifyScale(n)&&(n=t._filterScaleKeyName(n),-1===e.indexOf(n)&&e.push(n)),e};n.begin=this.supplement(null,this._getPluggableDatetime(e.startDatetime,"first")),n.end=this.supplement(null,this._getPluggableDatetime(e.endDatetime,"last")),n.scaleSize=this.supplement(null,e.minGridSize,this.validateNumeric),n.rows=this._getPluggableRows(),n.rowSize=this.supplement(null,e.rowHeight,this.validateNumeric),n.width=this.supplement(null,e.width,this.validateNumeric),n.height=this.supplement(null,e.height,this.validateNumeric),n.isVLS=!0,n.absX=0,n.moveX=0;var i=e.ruler.top.lines.reduce(r,[]);if(Object.hasOwnProperty.call(e.ruler,"bottom")&&Object.hasOwnProperty.call(e.ruler.bottom,"lines")&&(i=[].concat(f(i),f(e.ruler.bottom.lines)).reduce(r,[])),this.is_empty(i)&&(e.ruler.top.lines.push(e.scale),i.push(e.scale)),n.rulers=i,this._instanceProps=n,n.isVLS){var o=this.verifyScale(e.scale,n.begin,n.end,n.isVLS),a=Object.values(o),c=(this.numRound(a.reduce((function(t,e){return t+e}),0)/a.length,4),Math.min.apply(Math,f(a))),s=0,u=c;switch(!0){case/^millenniums?|millennia$/i.test(e.scale):case/^century$/i.test(e.scale):n.scale=315576e5*u;break;case/^dec(ade|ennium)$/i.test(e.scale):case/^lustrum$/i.test(e.scale):case/^years?$/i.test(e.scale):case/^months?$/i.test(e.scale):n.scale=864e5*u;break;case/^weeks?$/i.test(e.scale):case/^(|week)days?$/i.test(e.scale):n.scale=36e5*u;break;case/^hours?$/i.test(e.scale):n.scale=6e4*u;break;case/^minutes?$/i.test(e.scale):n.scale=1e3*u;break;case/^seconds?$/i.test(e.scale):default:n.scale=1*u}a.forEach((function(e){s+=t.numRound(e*n.scaleSize/u,2)})),n.grids=a.length,n.variableScale=o,n.fullwidth=s}for(var l in n.fullheight=n.rows*n.rowSize,n.visibleWidth=n.width>0?"".concat(n.width<=n.fullwidth?n.width:n.fullwidth,"px"):"100%",n.visibleHeight=n.height>0?"".concat(n.height<=n.fullheight?n.height:n.fullheight,"px"):"auto",n)if(!/^(width|height|variableScale|absX|moveX)$/.test(l)&&this.is_empty(n[l]))throw new TypeError('Property "'.concat(l,'" cannot set because undefined or invalid variable.'));if(n.fullwidth<2||n.fullheight<2)throw new TypeError("The range of the timeline to be rendered is incorrect.");this._instanceProps=n}},{key:"_getPluggableDatetime",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=this._config,r=null,i=function(t,e){var n,r=t.getFullYear(),i=r>=0&&Math.abs(r)<100;switch(!0){case/^millenniums?|millennia$/i.test(e):case/^century$/i.test(e):case/^dec(ade|ennium)$/i.test(e):case/^lustrum$/i.test(e):case/^years?$/i.test(e):n=new Date(r,0,1);break;case/^months?$/i.test(e):n=new Date(r,t.getMonth(),1);break;case/^(week|day)s?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate());break;case/^(|half|quarter)-?hours?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate(),t.getHours());break;case/^minutes?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate(),t.getHours(),t.getMinutes());break;case/^seconds?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds());break;default:n=new Date(r,t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds(),t.getMilliseconds())}return i&&n.setFullYear(r),n},o=function(t,e){var n,r=t.getFullYear(),i=r>=0&&Math.abs(r)<100,o=r>=0?-1:1;switch(!0){case/^millenniums?|millennia$/i.test(e):case/^century$/i.test(e):case/^dec(ade|ennium)$/i.test(e):case/^lustrum$/i.test(e):case/^years?$/i.test(e):n=new Date(r+1,0,1),i=r+1>=0&&Math.abs(r+1)<100,o=r+1>=0?-1:1;break;case/^months?$/i.test(e):n=new Date(r,t.getMonth()+1,1);break;case/^(week|day)s?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate()+1);break;case/^(|half|quarter)-?hours?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate(),t.getHours()+1);break;case/^minutes?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate(),t.getHours(),t.getMinutes()+1);break;case/^seconds?$/i.test(e):n=new Date(r,t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds()+1);break;default:n=new Date(r,t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds(),t.getMilliseconds()+1)}return i&&n.setFullYear(r),new Date(n.getTime()+o)};switch(!0){case/^current(|ly)$/i.test(t):r=new Date;break;case/^auto$/i.test(t):var a=n.range&&n.range>0?parseInt(n.range,10):3,c=/^(|week)days?$/i.test(n.scale)?"month":this.getHigherScale(n.scale);r=/^current(|ly)$/i.test(n.startDatetime)?i(new Date,n.scale):this.getCorrectDatetime(n.startDatetime),r=this.modifyDate(r,a,c);break;default:r=this.getCorrectDatetime(t)}return this.is_empty(e)||("first"===e?r=i(r,n.scale):"last"===e&&(r=o(r,n.scale))),r.getTime()}},{key:"_getPluggableParams",value:function(t){var e={};if("string"==typeof t&&t)try{e=JSON.parse(JSON.stringify(new Function("return ".concat(t))())),Object.hasOwnProperty.call(e,"extend")&&"string"==typeof e.extend&&(e.extend=JSON.parse(JSON.stringify(new Function("return ".concat(e.extend))())))}catch(t){console.warn("Can not parse to object therefor invalid param.")}return e}},{key:"_getPluggableRows",value:function(){var t=this._config,e=this.supplement("auto",t.rows,this.validateNumeric);return"auto"===e&&(e=t.sidebar.list.length),e>0?e:1}},{key:"_verifyMaxRenderableRange",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this._config.scale;return this._debug("Verify max renderable range::".concat(t,": ").concat(this._instanceProps.grids," / ").concat(x[this._filterScaleKeyName(t)])),this._instanceProps.grids<=x[this._filterScaleKeyName(t)]}},{key:"_renderView",value:function(){this._debug("_renderView");var t=this._element,e=this._config,n=this._instanceProps,r=$("<div></div>",{class:M.TIMELINE_CONTAINER,style:"width: ".concat(n.visibleWidth,"; height: ").concat(n.visibleHeight,";")}),i=$("<div></div>",{class:M.TIMELINE_MAIN});if(0==$(t).length)throw new TypeError("Does not exist the element to render a timeline container.");this._debug("Timeline:{ fullWidth: ".concat(n.fullwidth,"px, fullHeight: ").concat(n.fullheight,"px, viewWidth: ").concat(n.visibleWidth,", viewHeight: ").concat(n.visibleHeight," }")),$(t).css("position","relative"),e.hideScrollbar&&r.addClass(M.HIDE_SCROLLBAR),$(t).prepend(this._createHeadline()),i.append(this._createEventContainer()),Object.hasOwnProperty.call(e.ruler,"top")&&Object.hasOwnProperty.call(e.ruler.top,"lines")&&!this.is_empty(e.ruler.top.lines)&&i.prepend(this._createRuler("top")),Object.hasOwnProperty.call(e.ruler,"bottom")&&Object.hasOwnProperty.call(e.ruler.bottom,"lines")&&!this.is_empty(e.ruler.bottom.lines)&&i.append(this._createRuler("bottom"));var o={top:parseInt(i.find(N.RULER_TOP).height(),10)-1,bottom:parseInt(i.find(N.RULER_BOTTOM).height(),10)-1};e.sidebar.list.length>0&&r.prepend(this._createSideIndex(o)),r.append(i),$(t).append(r),$(t).append(this._createFooter()),this._isShown=!0}},{key:"_createHeadline",value:function(){var t=this._config,e=this._instanceProps,n=this.supplement(I.headline.display,t.headline.display,this.validateBoolean),r=this.supplement(null,t.headline.title),i=this.supplement(I.headline.range,t.headline.range,this.validateBoolean),o=this.supplement(I.headline.locale,t.headline.locale),a=this.supplement(I.headline.format,t.headline.format),c=this.supplement(null,e.begin),s=this.supplement(null,e.end),u=t.scale,l=$("<div></div>",{class:M.TIMELINE_HEADLINE}),f=$("<div></div>",{class:M.TIMELINE_HEADLINE_WRAPPER});if(r&&f.append('<h3 class="'.concat(M.HEADLINE_TITLE,'">').concat(t.headline.title,"</h3>")),i&&c&&s){Object.hasOwnProperty.call(a,"custom")&&(u="custom");var h="".concat(this.getLocaleString(c,u,o,a),'<span class="').concat(M.RANGE_SPAN,'"></span>').concat(this.getLocaleString(s,u,o,a));f.append('<div class="'.concat(M.RANGE_META,'">').concat(h,"</div>"))}return n||l.addClass(M.HIDE),l.append(f)}},{key:"_createEventContainer",value:function(){var t,e,n=this,r=this._config,i=this._instanceProps,o=i.fullheight+Math.ceil(i.rows/2),a=$("<div></div>",{class:M.TIMELINE_EVENT_CONTAINER,style:"height:".concat(o,"px;")}),c=$('<canvas width="'.concat(i.fullwidth-1,'" height="').concat(o,'" class="').concat(M.TIMELINE_BACKGROUND_GRID,'"></canvas>')),s=$('<canvas width="'.concat(i.fullwidth-1,'" height="').concat(o,'" class="').concat(M.TIMELINE_RELATION_LINES,'"></canvas>')),u=$("<div></div>",{class:M.TIMELINE_EVENTS}),l=0,f=c[0].getContext("2d"),h={horizontal:"dotted",vertical:"solid"},d=function(t,e){switch(!0){case/^solid$/i.test(e):e="solid";break;case/^dotted$/i.test(e):e="dotted";break;case/^none$/i.test(e):default:return}f.strokeStyle=null!=r.effects.horizontalGridColor?r.effects.horizontalGridColor:"rgba( 221, 221, 221, 0.8 )",f.lineWidth=1,f.filter="url(#crisp)",f.beginPath(),"dotted"===e?f.setLineDash([1,2]):f.setLineDash([]),f.moveTo(0,t+.5),f.lineTo(i.fullwidth,t+.5),f.closePath(),f.stroke()},p=function(t,e){switch(!0){case/^solid$/i.test(e):e="solid";break;case/^dotted$/i.test(e):e="dotted";break;case/^none$/i.test(e):default:return}f.strokeStyle=null!=r.effects.verticalGridColor?r.effects.verticalGridColor:"rgba( 0, 128, 0, 0 )",f.lineWidth=1,f.filter="url(#crisp)",f.beginPath(),"dotted"===e?f.setLineDash([1,2]):f.setLineDash([]),f.moveTo(t+-.5,0),f.lineTo(t+-.5,i.fullheight),f.closePath(),f.stroke()};Object.hasOwnProperty.call(r.effects,"horizontalGridStyle")&&(h.horizontal=r.effects.horizontalGridStyle),Object.hasOwnProperty.call(r.effects,"verticalGridStyle")&&(h.vertical=r.effects.verticalGridStyle),l=0;for(var g=0;g<i.rows;g++){l+=g%2==0?1:0;var v=g*i.rowSize+l,y=null!=r.colorScheme.event.background?r.colorScheme.event.background:"#000";t=v,e=y,e=n.supplement("#FFFFFF",e),f.fillStyle=e,f.fillRect(0,t+.5,i.fullwidth,i.rowSize+1.5),f.stroke()}l=0;for(var m=1;m<i.rows;m++)l+=m%2==0?1:0,d(m*i.rowSize+l,h.horizontal);if(i.isVLS){var b,E=0;switch(!0){case/^millenniums?|millennia$/i.test(r.scale):case/^century$/i.test(r.scale):b=i.scale/315576e5;break;case/^dec(ade|ennium)$/i.test(r.scale):case/^lustrum$/i.test(r.scale):case/^years?$/i.test(r.scale):case/^months?$/i.test(r.scale):b=i.scale/864e5;break;case/^weeks?$/i.test(r.scale):case/^(|week)days?$/i.test(r.scale):b=i.scale/36e5;break;case/^hours?$/i.test(r.scale):b=i.scale/6e4;break;case/^minutes?$/i.test(r.scale):b=i.scale/1e3;break;case/^seconds?$/i.test(r.scale):default:b=i.scale/1}for(var w=0,_=Object.keys(i.variableScale);w<_.length;w++){var S=_[w];p(E+=this.numRound(i.variableScale[S]*i.scaleSize/b,2),h.vertical)}}else for(var T=1;T<i.grids;T++)p(T*i.scaleSize,!1);return a.append(c).append(s).append(u)}},{key:"_createRuler",value:function(t){var e=this,n=this._config,r=this._instanceProps,i=this.supplement([n.scale],n.ruler[t].lines,(function(t,r){if(Array.isArray(r)&&r.length>0){if(Object.hasOwnProperty.call(n.ruler,"truncateLowers")&&n.ruler.truncateLowers){var i=e.findScale(n.scale,"lower all"),o=r.filter((function(t){return!i.includes(e._filterScaleKeyName(t))}));r=o}return r}return t})),o=this.supplement(I.ruler.top.height,n.ruler[t].height),a=this.supplement(I.ruler.top.fontSize,n.ruler[t].fontSize),c=this.supplement(I.ruler.top.color,n.ruler[t].color),s=this.supplement(I.ruler.top.background,n.ruler[t].background),u=this.supplement(I.ruler.top.locale,n.ruler[t].locale),l=this.supplement(I.ruler.top.format,n.ruler[t].format),f={lines:i,height:o,fontSize:a,color:c,background:s,locale:u,format:l},h=r.fullwidth-1,d=i.length*o,p=$("<div></div>",{class:"".concat(_,"ruler-").concat(t),style:"height:".concat(d,"px;")}),g=$('<canvas class="'.concat(_,"ruler-bg-").concat(t,'" width="').concat(h,'" height="').concat(d,'"></canvas>')),v=$("<div></div>",{class:"".concat(_,"ruler-content-").concat(t)}),y=0,m=g[0].getContext("2d");return m.fillStyle=s,m.fillRect(0,0,m.canvas.width,m.canvas.height),m.strokeStyle="rgba( 51, 51, 51, 0.1 )",m.lineWidth=1,m.filter="url(#crisp)",i.some((function(n,r){if(/^(quarter|half)-?(|hour)$/i.test(n))return!0;m.beginPath();var i="top"===t?o*(r+1)-.5:o*r+.5;m.moveTo(0,i),m.lineTo(m.canvas.width,i);var a,c=0;a=e._filterVariableScale(n);for(var s=0,u=Object.keys(a);s<u.length;s++){var l=u[s];c+=e.numRound(a[l],2),m.moveTo(c+-.5,"top"===t?i-o:i),m.lineTo(c+-.5,"top"===t?i:i+o)}m.closePath(),m.stroke(),v.append(e._createRulerContent(a,n,f)),y++})),i.length!=y&&p.css("height","".concat(y*o,"px")),p.append(g).append(v)}},{key:"_filterVariableScale",value:function(t){var e,n=this._config,r=this._instanceProps,i=r.variableScale,o={};switch(!0){case/^millenniums?|millennia$/i.test(n.scale):case/^century$/i.test(n.scale):e=r.scale/315576e5;break;case/^dec(ade|ennium)$/i.test(n.scale):case/^lustrum$/i.test(n.scale):case/^years?$/i.test(n.scale):case/^months?$/i.test(n.scale):e=r.scale/864e5;break;case/^weeks?$/i.test(n.scale):case/^(|week)days?$/i.test(n.scale):e=r.scale/36e5;break;case/^hours?$/i.test(n.scale):e=r.scale/6e4;break;case/^minutes?$/i.test(n.scale):e=r.scale/1e3;break;case/^seconds?$/i.test(n.scale):default:e=r.scale/1}for(var a=0,c=Object.keys(i);a<c.length;a++){var s=c[a],u=this.numRound(i[s]*r.scaleSize/e,2),l=null,f=s.split(","),h=/^weeks?$/i.test(n.scale)?this.getFirstDayOfWeek(parseInt(f[1],10),parseInt(f[0],10)):this.getCorrectDatetime(f[0]),d=void 0;switch(!0){case/^millenniums?|millennia$/i.test(t):l=Math.ceil(h.getFullYear()/1e3);break;case/^century$/i.test(t):l=Math.ceil(h.getFullYear()/100);break;case/^dec(ade|ennium)$/i.test(t):l=Math.ceil(h.getFullYear()/10);break;case/^lustrum$/i.test(t):l=Math.ceil(h.getFullYear()/5);break;case/^years?$/i.test(t):l="".concat(h.getFullYear());break;case/^months?$/i.test(t):l="".concat(h.getFullYear(),"/").concat(h.getMonth()+1);break;case/^weeks?$/i.test(t):/^weeks?$/i.test(n.scale)?l=f.join():(d=this.getWeek(h),l="".concat(h.getFullYear(),",").concat(d));break;case/^weekdays?$/i.test(t):/^weeks?$/i.test(n.scale)&&this.is_empty(o)&&(h=new Date(r.begin)),d=h.getDay(),l="".concat(h.getFullYear(),"/").concat(h.getMonth()+1,"/").concat(h.getDate(),",").concat(d);break;case/^days?$/i.test(t):/^weeks?$/i.test(n.scale)&&this.is_empty(o)&&(h=new Date(r.begin)),l="".concat(h.getFullYear(),"/").concat(h.getMonth()+1,"/").concat(h.getDate());break;case/^hours?$/i.test(t):l="".concat(h.getFullYear(),"/").concat(h.getMonth()+1,"/").concat(h.getDate()," ").concat(h.getHours());break;case/^minutes?$/i.test(t):l="".concat(h.getFullYear(),"/").concat(h.getMonth()+1,"/").concat(h.getDate()," ").concat(h.getHours(),":").concat(h.getMinutes());break;case/^seconds?$/i.test(t):l="".concat(h.getFullYear(),"/").concat(h.getMonth()+1,"/").concat(h.getDate()," ").concat(h.getHours(),":").concat(h.getMinutes(),":").concat(h.getSeconds());break;default:l="".concat(h.getFullYear(),"/").concat(h.getMonth()+1,"/").concat(h.getDate()," ").concat(h.getHours(),":").concat(h.getMinutes(),":").concat(h.getSeconds(),".").concat(h.getMilliseconds())}Object.hasOwnProperty.call(o,l)?o[l]+=u:o[l]=u}return o}},{key:"_createRulerContent",value:function(t,e,n){for(var r=this.supplement(I.ruler.top.height,n.height),i=this.supplement(I.ruler.top.fontSize,n.fontSize),o=this.supplement(I.ruler.top.color,n.color),a=this.supplement(I.ruler.top.locale,n.locale,this.validateString),c=this.supplement(I.ruler.top.format,n.format,this.validateObject),s=$("<div></div>",{class:M.TIMELINE_RULER_LINES,style:"width:100%;height:".concat(r,"px;")}),u=0,l=Object.keys(t);u<l.length;u++){var f=l[u],h=t[f],d=$("<div></div>",{class:M.TIMELINE_RULER_ITEM,style:"width:".concat(h,"px;height:").concat(r,"px;line-height:").concat(r,"px;font-size:").concat(i,"px;color:").concat(o,";")}),p=this.getLocaleString(f,this._filterScaleKeyName(e),a,c),g="";g="".concat(e,"-").concat(""===g?String(f):g),d.attr("data-ruler-item",g).html("<span>".concat(p,"</span>")),this.strWidth(p),s.append(d).attr("data-ruler-scope",e)}return s}},{key:"_createSideIndex",value:function(t){var e=this._config,n=this._instanceProps,r=this.supplement(I.sidebar.sticky,e.sidebar.sticky),i=this.supplement(I.sidebar.overlay,e.sidebar.overlay),o=this.supplement(I.sidebar.list,e.sidebar.list),a=$("<div></div>",{class:M.TIMELINE_SIDEBAR}),c=$("<div></div>",{class:M.TIMELINE_SIDEBAR_MARGIN}),s=$("<div></div>",{class:M.TIMELINE_SIDEBAR_ITEM}),u=this.numRound((n.fullheight+Math.ceil(n.rows/2))/n.rows,2);r&&a.addClass(M.STICKY_LEFT),i&&s.addClass(M.OVERLAY),t.top>0&&a.prepend(c.clone().css("height","".concat(t.top,"px")));for(var l=0;l<n.rows;l++){var f=s.clone().html("".concat(o[l]));l+1==n.rows?f.css("height","".concat(u+-.5,"px")).css("line-height","".concat(u+-.5,"px")):f.css("height","".concat(u-1,"px")).css("line-height","".concat(u-1,"px")),a.append(f)}return t.bottom>0&&a.append(c.clone().css("height","".concat(t.bottom+-.5,"px"))),a}},{key:"_createFooter",value:function(){var t=this._config,e=this._instanceProps,n=this.supplement(I.footer.display,t.footer.display),r=this.supplement(null,t.footer.content),i=this.supplement(I.footer.range,t.footer.range),o=this.supplement(I.footer.locale,t.footer.locale),a=this.supplement(I.footer.format,t.footer.format),c=this.supplement(null,e.begin),s=this.supplement(null,e.end),u=t.scale,l=$("<div></div>",{class:M.TIMELINE_FOOTER});if(i&&c&&s){Object.hasOwnProperty.call(a,"custom")&&(u="custom");var f="".concat(this.getLocaleString(c,u,o,a),'<span class="').concat(M.RANGE_SPAN,'"></span>').concat(this.getLocaleString(s,u,o,a));l.append('<div class="'.concat(M.RANGE_META," ").concat(M.ALIGN_SELF_RIGHT,'">').concat(f,"</div>"))}return r&&l.append('<div class="'.concat(M.TIMELINE_FOOTER_CONTENT,'">').concat(r,"</div>")),n||l.addClass(M.HIDE),l}},{key:"_loadEvent",value:function(){var t=this;this._debug("_loadEvent");var e=this,n=this._element,r=this._config,i=r.eventData,o=$(n).find(N.DEFAULT_EVENTS),a=i.length,c=[],s=0;o.children().each((function(){var t=$(this).attr("data-timeline-node");void 0!==t&&!1!==t&&a++})),0==a&&console.warn("Enable event does not exist."),i.length>0&&i.forEach((function(e){var n={};t.is_empty(e)||(n=t._registerEventData("<div></div>",e),c.push(n),s=Math.max(s,parseInt(n.eventId,10)))})),o.children().each((function(){var t=e._getPluggableParams($(this).attr("data-timeline-node")),n={};e.is_empty(t)||(n=e._registerEventData(this,t),c.push(n),s=Math.max(s,parseInt(n.eventId,10)))}));var u=[];c.forEach((function(t,e,n){var r=parseInt(n[e].eventId,10);0==r||u.includes(r)?(s++,n[e].eventId=s):n[e].eventId=r,u.push(n[e].eventId)})),c.forEach((function(t,e,n){if(Object.hasOwnProperty.call(r.colorScheme,"event")&&"object"===l(r.colorScheme.event)&&(Object.hasOwnProperty.call(r.colorScheme.event,"text")&&t.color===I.colorScheme.event.text&&I.colorScheme.event.text!==r.colorScheme.event.text&&(n[e].color=r.colorScheme.event.text),Object.hasOwnProperty.call(r.colorScheme.event,"background")&&t.bgColor===I.colorScheme.event.background&&I.colorScheme.event.background!==r.colorScheme.event.background&&(n[e].bgColor=r.colorScheme.event.background),Object.hasOwnProperty.call(r.colorScheme.event,"border")&&t.bdColor===I.colorScheme.event.border&&I.colorScheme.event.border!==r.colorScheme.event.border&&(n[e].bdColor=r.colorScheme.event.border)),Object.hasOwnProperty.call(r.colorScheme,"hookEventColors")&&"function"==typeof r.colorScheme.hookEventColors){var i=r.colorScheme.hookEventColors(t,{text:n[e].color,border:n[e].bdColor,background:n[e].bgColor})||void 0;"object"===l(i)&&(Object.hasOwnProperty.call(i,"text")&&t.color!==i.text&&(n[e].color=i.text),Object.hasOwnProperty.call(i,"background")&&t.bgColor!==i.background&&(n[e].bgColor=i.background),Object.hasOwnProperty.call(i,"border")&&t.bdColor!==i.border&&(n[e].bdColor=i.border))}})),this._isCached=this._saveToCache(c)}},{key:"_registerEventData",value:function(t,e){var n,r,i,o,a=this,c=this._config,u=this._instanceProps,l=s(s({},O),{uid:this.generateUniqueID(),label:$(t).html()}),f={};return Object.hasOwnProperty.call(e,"start")&&!this.is_empty(e.start)&&(n=this._getCoordinateX(e.start),l.x=this.numRound(n,2),Object.hasOwnProperty.call(e,"end")&&!this.is_empty(e.end)?(r=(n=this._getCoordinateX(e.end))-l.x,l.width=this.numRound(r,2),c.eventMeta.display&&(this.is_empty(c.eventMeta.content)&&!Object.hasOwnProperty.call(e,"rangeMeta")?(l.rangeMeta+=this.getLocaleString(e.start,c.eventMeta.scale,c.eventMeta.locale,c.eventMeta.format),l.rangeMeta+=" - ".concat(this.getLocaleString(e.end,c.eventMeta.scale,c.eventMeta.locale,c.eventMeta.format))):l.rangeMeta=c.eventMeta.content)):l.width=0,i=Object.hasOwnProperty.call(e,"row")?parseInt(e.row,10):1,o=Math.floor(i/2),l.y=(i-1)*c.rowHeight+l.margin+o,l.height=c.rowHeight-2*c.marginHeight,Object.keys(l).forEach((function(n){switch(!0){case/^eventId$/i.test(n):Object.hasOwnProperty.call(e,"id")?l.eventId=parseInt(e.id,10):l.eventId=parseInt(e[n],10)||0;break;case/^(label|content)$/i.test(n):Object.hasOwnProperty.call(e,n)&&!a.is_empty(e[n])&&(l[n]=e[n]),$(t).children(".event-".concat(n)).length>0&&(l[n]=$(t).children(".event-".concat(n)).html());break;case/^relation$/i.test(n):(/^mix(|ed)$/i.test(c.type)||/^point(|er)$/i.test(c.type))&&(f.x=a.numRound(l.x,2),f.y=a.numRound(u.rowSize*((e.row||1)-1)+u.rowSize/2,2)+.5*((e.row||1)-1),l[n]=s(s({},e[n]),f));break;default:Object.hasOwnProperty.call(e,n)&&!a.is_empty(e[n])&&(l[n]=e[n])}}))),l}},{key:"_getCoordinateX",value:function(t){var e=this._instanceProps,n=this.supplement(null,this._getPluggableDatetime(t)),r=0;return n?r=n-e.begin>=0&&e.end-n>=0?Math.abs(n-e.begin)/e.scale*e.scaleSize:(n-e.begin)/e.scale*e.scaleSize:console.warn("Cannot parse date because invalid format or undefined."),r}},{key:"_saveToCache",value:function(t){var e=/^local(|Storage)$/i.test(this._config.storage)?"localStorage":"sessionStorage";if(e in window&&null!==("localStorage"===e?window.localStorage:window.sessionStorage))return"localStorage"===e?localStorage.setItem(this._selector,JSON.stringify(t)):sessionStorage.setItem(this._selector,JSON.stringify(t)),!0;throw new TypeError('The storage named "'.concat(e,'" can not be available.'))}},{key:"_loadToCache",value:function(){var t=/^local(|Storage)$/i.test(this._config.storage)?"localStorage":"sessionStorage";if(!(t in window)||null===("localStorage"===t?window.localStorage:window.sessionStorage))throw new TypeError('The storage named "'.concat(t,'" can not be available.'));return"localStorage"===t?JSON.parse(localStorage.getItem(this._selector)):JSON.parse(sessionStorage.getItem(this._selector))}},{key:"_removeCache",value:function(){var t=/^local(|Storage)$/i.test(this._config.storage)?"localStorage":"sessionStorage";if(!(t in window)||null===("localStorage"===t?window.localStorage:window.sessionStorage))throw new TypeError('The storage named "'.concat(t,'" can not be available.'));"localStorage"===t?localStorage.removeItem(this._selector):sessionStorage.removeItem(this._selector)}},{key:"_placeEvent",value:function(){var t=this;return new Promise((function(e,n){t._debug("_placeEvent"),t._isCached||n("No Cached Event");var r=t._element,i=t._config,o=$(r).find(N.TIMELINE_EVENTS),a=$(r).find(N.TIMELINE_RELATION_LINES),c=t._loadToCache(),s=[];t._observer=new MutationObserver((function(t){t.forEach((function(t){var n=t.target;switch(t.type){case"childList":t.addedNodes.length==s.length&&(a.attr("data-state","show"),o.attr("data-state","show"));break;case"attributes":"data-state"===t.attributeName&&("shown"===$(n).attr("data-state")?e("Completed Placing"):"show"===$(n).attr("data-state")&&setTimeout((function(){o.attr("data-state","shown")}),300))}}))})),t._observer.observe(o.get(0),{childList:!0,attributes:!0,subtree:!0,attributeOldValue:!0}),c.length>0?(o.empty(),c.forEach((function(e){var n=t._createEventNode(e);n&&s.push(n)})),s.length>0&&o.append.apply(o,s)):(a.attr("data-state","show"),o.attr("data-state","show")),(/^mix(|ed)$/i.test(i.type)||/^point(|er)$/i.test(i.type))&&t._drawRelationLine(c),Object.hasOwnProperty.call(i.effects,"presentTime")&&i.effects.presentTime&&t._viewPresentTime(),e(!0)}))}},{key:"_createEventNode",value:function(t){var e=this._config,n=this._instanceProps,r=$("<div></div>",{class:M.TIMELINE_EVENT_NODE,id:"evt-".concat(t.eventId),css:{left:"".concat(t.x,"px"),top:"".concat(t.y,"px"),width:"".concat(t.width,"px"),height:"".concat(t.height,"px"),color:this.hexToRgbA(t.color),backgroundColor:this.hexToRgbA(t.bgColor)},html:'<div class="'.concat(M.TIMELINE_EVENT_LABEL,'">').concat(t.label,"</div>")}),i=!0;if(/^point(|er)$/i.test(e.type)?i=!1:/^mix(|ed)$/i.test(e.type)&&(/^point(|er)$/i.test(t.type)?i=!1:t.width<1&&(i=!!/^bar$/i.test(t.type))),t.x>=0?t.x<=n.fullwidth?t.x+t.width<=n.fullwidth||(t.width=n.fullwidth-t.x):t.width=-1:i?t.x+t.width<=0?t.width=-1:t.x+t.width<=n.fullwidth?(t.width=Math.abs(t.x+t.width),t.x=0):(t.width=n.fullwidth,t.x=0):t.width=-1,i){if(t.width<1)return null;r.css("left","".concat(t.x,"px")).css("width","".concat(t.width,"px"))}else{if(t.width<0)return null;var o=this._getPointerSize(t.size,t.margin),a=this.numRound(t.x-o/2,2)-t.margin,c=this.numRound(t.y+(t.height-o)/2,2)-t.margin;r.addClass(M.VIEWER_EVENT_TYPE_POINTER).css("border-color",t.bdColor).css("left","".concat(a,"px")).css("top","".concat(c,"px")).css("width","".concat(o,"px")).css("height","".concat(o,"px")).attr("data-base-size",o).attr("data-base-left",a).attr("data-base-top",c)}if(r.attr("data-uid",t.uid),!this.is_empty(t.image))if(i){var s=t.height-2*t.margin;r.prepend('<img src="'.concat(t.image,'" class="').concat(M.TIMELINE_EVENT_THUMBNAIL,'" width="').concat(s,'" height="').concat(s,'" />'))}else r.css("background-image","url(".concat(t.image,")"));if(i&&e.eventMeta.display&&(t.extend.meta=t.rangeMeta),!this.is_empty(t.extend))for(var u=0,l=Object.keys(t.extend);u<l.length;u++){var f=l[u];r.attr("data-".concat(f),t.extend[f]),"toggle"===f&&["popover","tooltip"].includes(t.extend[f])&&(r.attr("title",t.label),Object.hasOwnProperty.call(t.extend,"content")||r.attr("data-content",t.content))}return this.is_empty(t.callback)||r.attr("data-callback",t.callback),r}},{key:"_getPointerSize",value:function(t,e){var n=this._instanceProps,r=Math.min(n.scaleSize-2*e,n.rowSize-2*e),i=null;switch(!0){case/^([1-9]\d*|0)$/i.test(t):i=Math.max(parseInt(t,10),12);break;case/^small$/i.test(t):i=Math.max(this.numRound(r/4,2),12);break;case/^large$/i.test(t):i=Math.max(this.numRound(.75*r,2),12);break;case/^normal$/i.test(t):default:i=Math.max(this.numRound(r/2,2),12)}return i}},{key:"_drawRelationLine",value:function(t){var e=this,n=this._instanceProps,r=$(this._element).find(N.TIMELINE_RELATION_LINES),i=r[0].getContext("2d"),o=function(t,r,o,a,c,s){var u={},l=e.numRound(Math.min(n.scaleSize,n.rowSize)/2,2);i.strokeStyle=O.bdColor,i.lineWidth=2.5,i.filter="url(#crisp)";for(var f=0,h=Object.keys(c.relation);f<h.length;f++){var d=h[f];switch(!0){case/^(|line)color$/i.test(d):i.strokeStyle=c.relation[d];break;case/^(|line)size$/i.test(d):i.lineWidth=parseInt(c.relation[d],10)||2.5;break;case/^curve$/i.test(d):if(/^(r|l)(t|b),?(r|l)?(t|b)?$/i.test(c.relation[d])){var p=c.relation[d].split(",");2==p.length?(u.before=p[0],u.after=p[1]):u[s]=p[0]}else("boolean"==typeof c.relation[d]&&c.relation[d]||"number"==typeof c.relation[d]&&Boolean(c.relation[d]))&&("before"===s?u[s]=r>a?t>o?"lb":t<o?"lb+lt":null:r<a?t>o?"lt":t<o?"lt+lb":null:null:"after"===s&&(u[s]=r<a?t<o?"rt":t>o?"rt+rb":null:r>a?t<o?"rb":t>o?"rb+rt":null:null))}}if(Math.abs(a-r)>n.rowSize&&(a+=Math.floor(Math.abs(a-r)/n.rowSize)),i.beginPath(),e.is_empty(u))i.moveTo(t,r),i.lineTo(o,a);else switch(!0){case/^lt$/i.test(u[s]):i.moveTo(t,r),Math.abs(t-o)>l&&i.lineTo(o-l,r),Math.abs(a-r)>l?(i.quadraticCurveTo(o,r,o,r+l),i.lineTo(o,a)):i.quadraticCurveTo(o,r,o,a);break;case/^lb$/i.test(u[s]):i.moveTo(t,r),Math.abs(t-o)>l&&i.lineTo(o+l,r),Math.abs(r-a)>l?(i.quadraticCurveTo(o,r,o,r-l),i.lineTo(o,a)):i.quadraticCurveTo(o,r,o,a);break;case/^rt$/i.test(u[s]):i.moveTo(t,r),Math.abs(o-t)>l&&i.lineTo(o-l,r),Math.abs(a-r)>l?(i.quadraticCurveTo(o,r,o,r+l),i.lineTo(o,a)):i.quadraticCurveTo(o,r,o,a);break;case/^rb$/i.test(u[s]):i.moveTo(t,r),Math.abs(o-t)>l&&i.lineTo(o-l,r),Math.abs(r-a)>l?(i.quadraticCurveTo(o,r,o,r-l),i.lineTo(o,a)):i.quadraticCurveTo(o,r,o,a);break;case/^lt\+lb$/i.test(u[s]):case/^lb\+lt$/i.test(u[s]):i.moveTo(t,r),i.lineTo(t-l,r),i.bezierCurveTo(t-2*l,r,t-2*l,a,t-l,a),i.lineTo(o,a);break;case/^rt\+rb$/i.test(u[s]):case/^rb\+rt$/i.test(u[s]):i.moveTo(t,r),i.lineTo(t+l,r),i.bezierCurveTo(t+2*l,r,t+2*l,a,t+l,a),i.lineTo(o,a)}i.stroke()};i.clearRect(0,0,r[0].width,r[0].height),t.forEach((function(r){var i,a,c,s,u,l,f=r.relation;Object.hasOwnProperty.call(f,"before")&&(i=f.x+e.numRound(r.margin/2,2),a=f.y+e.numRound(r.margin/2,2),(u=parseInt(f.before,10))<0?(c=0,s=a+e.numRound(r.margin/2,2)):(l=t.find((function(t){return parseInt(t.eventId,10)==u})),!e.is_empty(l)&&l.relation&&(c=l.relation.x<0?0:l.relation.x+e.numRound(r.margin/2,2),s=l.relation.y+e.numRound(r.margin/2,2))),i>=0&&a>=0&&c>=0&&s>=0&&o(i,a,c,s,r,"before")),Object.hasOwnProperty.call(f,"after")&&(i=f.x+e.numRound(r.margin/2,2),a=f.y+e.numRound(r.margin/2,2),(u=parseInt(f.after,10))<0?(c=n.fullwidth,s=a+e.numRound(r.margin/2,2)):(l=t.find((function(t){return parseInt(t.eventId,10)==u})),!e.is_empty(l)&&l.relation&&(c=l.relation.x>n.fullwidth?n.fullwidth:l.relation.x+e.numRound(r.margin/2,2),s=l.relation.y+e.numRound(r.margin/2,2))),i>=0&&a>=0&&c>=0&&s>=0&&o(i,a,c,s,r,"after"))}))}},{key:"_viewPresentTime",value:function(){var t=this._element,e=this._instanceProps,n=new Date;if(!(this.diffDate(e.begin,n)<0||this.diffDate(n,e.end)<0)){var r=$("<div></div>",{class:M.PRESENT_TIME_MARKER,style:"left:".concat(this.numRound(this._getCoordinateX(n),2),"px;top:").concat($(t).find(N.TIMELINE_RULER_TOP).height(),"px;height:").concat($(t).find(N.TIMELINE_EVENT_CONTAINER).height(),"px;")});$(t).find(N.TIMELINE_MAIN).append(r)}}},{key:"_mapPlacedEvents",value:function(){var t=this,e=$(this._element).find(N.TIMELINE_EVENTS).children(),n=this._loadToCache(),r=[];return!this._isCached||this.is_empty(n)||e.each((function(){var e=$(this).data("uid"),i=null;i=n?n.find((function(t){return t.uid===e}))||null:$(this).data(),t.is_empty(i)||r.push(i)})),r}},{key:"_activeEvent",value:function(t){this._debug("_activeEvent@Event");var e=t.target;"focusin"===t.type?($(N.TIMELINE_EVENT_NODE).removeClass("active"),$(e).addClass("active")):"focusout"===t.type&&$(e).removeClass("active")}},{key:"_scrollTimeline",value:function(t){this._debug("_scrollTimeline@Event");var e=t.target;this._debug(e.scrollLeft)}},{key:"_swipeStart",value:function(t){this._debug("_swipeStart@Event"),t.preventDefault();var e=this._instanceProps;e.absX=S?t.changedTouches[0].pageX:t.pageX,e.moveX=-1*$(t.currentTarget).parent(N.TIMELINE_CONTAINER).scrollLeft(),this._isTouched=!0}},{key:"_swipeMove",value:function(t){if(this._isTouched){this._debug("_swipeMove@Event"),t.preventDefault();var e=this._instanceProps;e.moveX-=e.absX-(S?t.changedTouches[0].pageX:t.pageX),$(t.currentTarget).parent(N.TIMELINE_CONTAINER).scrollLeft(-1*e.moveX),e.absX=S?t.changedTouches[0].pageX:t.pageX}}},{key:"_swipeEnd",value:function(){this._isTouched&&(this._debug("_swipeEnd@Event"),this._isTouched=!1)}},{key:"_hoverPointer",value:function(t){if(this._config.effects.hoverEvent){this._debug("_hoverPointer@Event");var e=this._instanceProps,n=t.target,r={left:$(n).data("baseLeft"),top:$(n).data("baseTop"),width:$(n).data("baseSize")},i=r.left,o=r.top,a=r.width,c=5;"mouseenter"===t.type?(a=Math.min(this.numRound(1.25*a,"ceil"),Math.min(e.rowSize,e.scaleSize)),i=this.numRound(i-(a-r.width)/2,2),o=this.numRound(o-(a-r.width)/2,2),c=9,$(n).trigger(k.FOCUSIN_EVENT)):$(n).trigger(k.FOCUSOUT_EVENT),$(n).css("left","".concat(i,"px")).css("top","".concat(o,"px")).css("width","".concat(a,"px")).css("height","".concat(a,"px")).css("z-index",c)}}},{key:"_debug",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"Notice";if(this._config.debug&&(t=this.supplement(null,t))){var n=void 0!==$(this._element).data(E)[t]?'Called method "'.concat(t,'".'):t,r=/^Called method "/.test(n)?"font-weight:600;color:blue;":"",i="";if(window.console&&window.console.log){if("Notice"!==e)throw new Error("".concat(n));window.console.log("%c%s%c",r,n,i)}}}},{key:"initialized",value:function(){var t=this._isInitialized?'Skipped because method "initialized" already has been called once':"initialized";if(this._debug(t),!this._isInitialized){var e=this._element,n=this._config,r=arguments.length<=0?void 0:arguments[0],i=r.length>0&&"function"==typeof r[0]?r[0]:null,o=r.length>1?r.slice(1):null;return i&&!this._isInitialized&&(this._debug("Fired your callback function after initializing this plugin."),i(e,n,o)),this._isInitialized=!0,this}}},{key:"destroy",value:function(){this._debug("destroy"),$.removeData(this._element,E),$(window,document,this._element).off(w),$(this._element).remove(),this._removeCache();for(var t=0,e=Object.keys(this);t<e.length;t++){var n=e[t];this[n]=null,delete this[n]}}},{key:"render",value:function(){throw new ReferenceError('This method named "render" has been deprecated since version 2.0.0')}},{key:"show",value:function(){this._debug("show");var t=this._element;this._isShown||($(t).removeClass(M.HIDE),this._isShown=!0)}},{key:"hide",value:function(){this._debug("hide");var t=this._element;this._isShown&&($(t).addClass(M.HIDE),this._isShown=!1)}},{key:"dateback",value:function(){this._debug("dateback");var t,e,n,r=arguments.length<=0?void 0:arguments[0],i=this._config,o=this.supplement(null,r[0],this.validateObject),a=r.length>1&&"function"==typeof r[1]?r[1]:null,c=r.length>2?r.slice(2):null,s={};switch(this.is_empty(o)?o={scale:i.scale,range:i.range,shift:!0}:(Object.hasOwnProperty.call(o,"shift")&&!1===o.shift||(o.shift=!0),Object.hasOwnProperty.call(o,"scale")&&this.verifyScale(o.scale)||(o.scale=i.scale),(!Object.hasOwnProperty.call(o,"range")||parseInt(o.range,10)>x[o.scale])&&(o.range=i.range)),n=new Date(i.startDatetime),!0){case/^years?$/i.test(o.scale):t=new Date(n.setFullYear(n.getFullYear()-parseInt(o.range,10)));break;case/^months?$/i.test(o.scale):t=new Date(n.setMonth(n.getMonth()-parseInt(o.range,10)));break;default:t=new Date(n.getTime()-this.verifyScale(o.scale,n.getTime(),n.getTime(),!1)*parseInt(o.range,10))}if(s.startDatetime=t.toString(),o.shift){switch(n=new Date(i.endDatetime),!0){case/^years?$/i.test(o.scale):e=new Date(n.setFullYear(n.getFullYear()-parseInt(o.range,10)));break;case/^months?$/i.test(o.scale):e=new Date(n.setMonth(n.getMonth()-parseInt(o.range,10)));break;default:e=new Date(n.getTime()-this.verifyScale(o.scale,n.getTime(),n.getTime(),!1)*parseInt(o.range,10))}s.endDatetime=e.toString()}o.scale!==i.scale&&(s.moveScale=o.scale),this.reload([s]),a&&(this._debug("Fired your callback function after datebacking."),a(this._element,i,c))}},{key:"dateforth",value:function(){this._debug("dateforth");var t,e,n,r=arguments.length<=0?void 0:arguments[0],i=this._config,o=this.supplement(null,r[0],this.validateObject),a=r.length>1&&"function"==typeof r[1]?r[1]:null,c=r.length>2?r.slice(2):null,s={};switch(this.is_empty(o)?o={scale:i.scale,range:i.range,shift:!0}:(Object.hasOwnProperty.call(o,"shift")&&!1===o.shift||(o.shift=!0),Object.hasOwnProperty.call(o,"scale")&&this.verifyScale(o.scale)||(o.scale=i.scale),(!Object.hasOwnProperty.call(o,"range")||parseInt(o.range,10)>x[o.scale])&&(o.range=i.range)),n=new Date(i.endDatetime),!0){case/^years?$/i.test(o.scale):e=new Date(n.setFullYear(n.getFullYear()+parseInt(o.range,10)));break;case/^months?$/i.test(o.scale):e=new Date(n.setMonth(n.getMonth()+parseInt(o.range,10)));break;default:e=new Date(n.getTime()+this.verifyScale(o.scale,n.getTime(),n.getTime(),!1)*parseInt(o.range,10))}if(s.endDatetime=e.toString(),o.shift){switch(n=new Date(i.startDatetime),!0){case/^years?$/i.test(o.scale):t=new Date(n.setFullYear(n.getFullYear()+parseInt(o.range,10)));break;case/^months?$/i.test(o.scale):t=new Date(n.setMonth(n.getMonth()+parseInt(o.range,10)));break;default:t=new Date(n.getTime()+this.verifyScale(o.scale,n.getTime(),n.getTime(),!1)*parseInt(o.range,10))}s.startDatetime=t.toString()}o.scale!==i.scale&&(s.moveScale=o.scale),this.reload([s]),a&&(this._debug("Fired your callback function after dateforthing."),a(this._element,this._config,c))}},{key:"alignment",value:function(){this._debug("alignment");for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];var r=this._config,i=this._instanceProps,o=this._element,a=$(o).find(N.TIMELINE_CONTAINER),c=0,s=this.is_empty(e)?[]:e[0],u=s.length>0&&"string"==typeof s[0]?s[0]:r.rangeAlign,l=s.length>1&&/^(\d{1,}|fast|normal|slow)$/i.test(s[1])?s[1]:0;if(!(i.fullwidth<=o.scrollWidth)){switch(!0){case/^(left|begin)$/i.test(u):c=0;break;case/^center$/i.test(u):c=(a[0].scrollWidth-o.scrollWidth)/2+1;break;case/^(right|end)$/i.test(u):c=a[0].scrollWidth-o.scrollWidth+1;break;case/^latest$/i.test(u):var f=this._mapPlacedEvents().sort(this.compareValues("x")),h=f[f.length-1];c=this.is_empty(h)?0:h.x,o.scrollWidth/2<c?c-=Math.ceil(o.scrollWidth/2):c=0,this.is_empty(h)||$("".concat(N.TIMELINE_EVENT_NODE,'[data-uid="').concat(h.uid,'"]')).trigger(k.FOCUSIN_EVENT);break;case/^\d{1,}$/.test(u):var d=this._mapPlacedEvents(),p={};d.length>0&&(p=d.find((function(t){return t.eventId==parseInt(u,10)}))),c=this.is_empty(p)?0:p.x,Math.ceil(o.scrollWidth/2)<c?c-=Math.ceil(o.scrollWidth/2):c=0,this.is_empty(p)||$("".concat(N.TIMELINE_EVENT_NODE,'[data-uid="').concat(p.uid,'"]')).trigger(k.FOCUSIN_EVENT);break;case/^current(|ly)|now$/i.test(u):default:var g=(new Date).toString(),v=this.numRound(this._getCoordinateX(g),2);c=v>=0?a[0].scrollWidth-o.scrollWidth+1<v?a[0].scrollWidth-o.scrollWidth+1:v:0}"0"===l?a.scrollLeft(c):a.animate({scrollLeft:c},l)}}},{key:"getOptions",value:function(){throw new ReferenceError('This method named "getOptions" has been deprecated since version 2.0.0')}},{key:"addEvent",value:(d=g(regeneratorRuntime.mark((function t(){var e,n,r,i,o,a,c,s=this,u=arguments;return regeneratorRuntime.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._debug("addEvent"),e=u.length<=0?void 0:u[0],n=this.supplement(null,e[0],this.validateArray),r=e.length>1&&"function"==typeof e[1]?e[1]:null,i=e.length>2?e.slice(2):null,o=this._loadToCache(),a=0,c=!1,!this.is_empty(n)&&this._isCompleted){t.next=4;break}return t.abrupt("return");case 4:if(this.is_empty(o)||(o.sort(this.compareValues("eventId")),a=parseInt(o[o.length-1].eventId,10)),n.forEach((function(t){var e=s._registerEventData("<div></div>",t);s.is_empty(e)||(e.eventId=Math.max(a+1,parseInt(e.eventId,10)),o.push(e),a=parseInt(e.eventId,10),c=!0)})),c){t.next=8;break}return t.abrupt("return");case 8:return this._saveToCache(o),t.next=11,this._placeEvent();case 11:r&&(this._debug("Fired your callback function after replacing events."),r(this._element,this._config,i));case 12:case"end":return t.stop()}}),t,this)}))),function(){return d.apply(this,arguments)})},{key:"removeEvent",value:(h=g(regeneratorRuntime.mark((function t(){var e,n,r,i,o,a,c,s=this,u=arguments;return regeneratorRuntime.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._debug("removeEvent"),e=u.length<=0?void 0:u[0],n=this.supplement(null,e[0],this.validateArray),r=e.length>1&&"function"==typeof e[1]?e[1]:null,i=e.length>2?e.slice(2):null,o=this._loadToCache(),a={},c=[],!this.is_empty(n)&&this._isCompleted&&!this.is_empty(o)){t.next=4;break}return t.abrupt("return");case 4:if(n.forEach((function(t){switch(!0){case/^\d{1,}$/.test(t):a.type="eventId",a.value=parseInt(t,10);break;case/^(|\d{1,}(-|\/)\d{1,2}(-|\/)\d{1,2}(|\s\d{1,2}:\d{1,2}(|:\d{1,2})))(|,\d{1,}(-|\/)\d{1,2}(-|\/)\d{1,2}(|\s\d{1,2}:\d{1,2}(|:\d{1,2})))$/.test(t):var e=t.split(",");a.type="daterange",a.value={},a.value.from=s.is_empty(e[0])?null:new Date(e[0]),a.value.to=s.is_empty(e[1])?null:new Date(e[1]);break;default:a.type="regex",a.value=new RegExp(t)}o.forEach((function(t){var e=!1;switch(a.type){case"eventId":parseInt(t.eventId,10)==a.value&&(e=!0);break;case"daterange":var n=a.value.from?Math.ceil(s._getCoordinateX(a.value.from.toString())):0,r=a.value.to?Math.floor(s._getCoordinateX(a.value.to.toString())):n;n<=t.x&&t.x<=r&&(e=!0);break;case"regex":a.value.test(JSON.stringify(t))&&(e=!0)}e||c.push(t)}))})),c.length!==o.length){t.next=8;break}return t.abrupt("return");case 8:return this._saveToCache(c),t.next=11,this._placeEvent();case 11:r&&(this._debug("Fired your callback function after placing additional events."),r(this._element,this._config,i));case 12:case"end":return t.stop()}}),t,this)}))),function(){return h.apply(this,arguments)})},{key:"updateEvent",value:(c=g(regeneratorRuntime.mark((function t(){var e,n,r,i,o,a,c=this,s=arguments;return regeneratorRuntime.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._debug("updateEvent"),e=s.length<=0?void 0:s[0],n=this.supplement(null,e[0],this.validateArray),r=e.length>1&&"function"==typeof e[1]?e[1]:null,i=e.length>2?e.slice(2):null,o=this._loadToCache(),a=!1,!this.is_empty(n)&&this._isCompleted&&!this.is_empty(o)){t.next=4;break}return t.abrupt("return");case 4:if(n.forEach((function(t){var e=c._registerEventData("<div></div>",t),n=null,r=o.find((function(t,r){return n=r,t.eventId==e.eventId})),i={};c.is_empty(r)||c.is_empty(e)||(Object.hasOwnProperty.call(e,"uid")&&delete e.uid,i=Object.assign(i,r,e),o[n]=i,a=!0)})),a){t.next=7;break}return t.abrupt("return");case 7:return this._saveToCache(o),t.next=10,this._placeEvent();case 10:r&&(this._debug("Fired your callback function after updating events."),r(this._element,this._config,i));case 11:case"end":return t.stop()}}),t,this)}))),function(){return c.apply(this,arguments)})},{key:"reload",value:(o=g(regeneratorRuntime.mark((function t(){var e,n,r,i,o,a,c,s,u,l,f,h=this,d=arguments;return regeneratorRuntime.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._debug("reload"),e=d.length<=0?void 0:d[0],n=this.supplement(null,e[0],this.validateObject),r=e.length>1&&"function"==typeof e[1]?e[1]:null,i=e.length>2?e.slice(2):null,o=this._element,a=$(o).find(N.DEFAULT_EVENTS),c=this._config,s={},this.is_empty(n)||(s=this.mergeDeep(c,n),this._config=s),this._isInitialized=!1,this._isCached=!1,this._isCompleted=!1,this._instanceProps={},this._countEventinCell={},$(o).empty().append(a),this._calcVars(),this.showLoader(),Object.hasOwnProperty.call(this._config,"moveScale")?(u=this._config.moveScale,delete this._config.moveScale):u=this._config.scale,this._verifyMaxRenderableRange(u)){t.next=14;break}throw new RangeError("Timeline display period exceeds maximum renderable range.");case 14:return this._isInitialized||(this._renderView(),this._isInitialized=!0),this._config.reloadCacheKeep?(l=this._loadToCache(),f=[],this.is_empty(l)||l.forEach((function(t){delete t.uid,delete t.x,delete t.Y,delete t.width,delete t.height,delete t.relation.x,delete t.relation.y,f.push(h._registerEventData("<div></div>",t))})),this._isCached=this._saveToCache(f)):this._loadEvent(),t.next=18,this._placeEvent();case 18:return this._isCompleted=!0,t.next=21,this.hideLoader();case 21:r&&(this._debug("Fired your callback function after reloading timeline."),r(this._element,this._config,i)),$.fn.popover&&$('[data-toggle="popover"]').popover();case 23:case"end":return t.stop()}}),t,this)}))),function(){return o.apply(this,arguments)})},{key:"openEvent",value:function(t){this._debug("openEvent"),this.is_empty(t)||Object.hasOwnProperty.call(t,"type")||Object.hasOwnProperty.call(t,"target")||"function"==typeof t[0]&&(this._beforeOpenEvent=t[0]);var e=t.target,n=$(document).find(N.EVENT_VIEW),r=$(e).data("uid"),i=this.supplement(null,$(e).data("callback")),o=this._loadToCache().find((function(t){return t.uid===r})),a=!0;if(!this.is_empty(e)){var c=$("<div></div>",{class:M.VIEWER_EVENT_TITLE}),s=$("<div></div>",{class:M.VIEWER_EVENT_CONTENT}),u=$("<div></div>",{class:M.VIEWER_EVENT_META}),l=$("<div></div>",{class:M.VIEWER_EVENT_IMAGE_WRAPPER}),f={},h=["label","image","content","meta"];if(this.is_empty(o.image)||(l.append('<img src="'.concat(o.image,'" class="').concat(M.VIEWER_EVENT_IMAGE,'" />')),f.image=l.get(0)),this.is_empty(o.label)||(c.html(o.label),f.label=c.get(0)),this.is_empty(o.content)||(s.html(o.content),f.content=s.get(0)),this.is_empty(o.rangeMeta)||(u.html(o.rangeMeta),f.meta=u.get(0)),this._beforeOpenEvent&&(a=this._beforeOpenEvent(o,f)||!0),a&&(n.length>0&&n.each((function(){var t=this;$(this).empty(),h.forEach((function(e){Object.prototype.hasOwnProperty.call(f,e)&&$(t).append(f[e].outerHTML)}))})),i)){this._debug('The callback "'.concat(i,'" was called by the "openEvent" method.'));try{Function.call(null,"return ".concat(i))()}catch(t){throw new TypeError(t)}}}}},{key:"zoomScale",value:function(t){var e=this;this._debug("zoomScale");var n=t.currentTarget,r=$(n).data("ruler-item"),i={millennium:{years:1e3,lower:"century",minGrids:10},century:{years:100,lower:"decade",minGrids:10},decade:{years:10,lower:"lustrum",minGrids:2},lustrum:{years:5,lower:"year",minGrids:5},year:{years:1,lower:"month",minGrids:12},month:{lower:"day",minGrids:28},week:{lower:"day",minGrids:7},day:{lower:"hour",minGrids:24},weekday:{lower:"hour",minGrids:24},hour:{lower:"minute",minGrids:60},minute:{lower:"second",minGrids:60},second:{lower:null,minGrids:60},millisecond:{lower:null,minGrids:1e3}},o=function(t){var n,r,o,c,s=a(t.split("-"),2),u=s[0],l=s[1],f=e._filterScaleKeyName(u),h=i[f].minGrids;switch(!0){case/^millennium$/i.test(f):case/^century$/i.test(f):case/^decade$/i.test(f):case/^lustrum$/i.test(f):n="".concat((l-1)*i[f].years+1,"/1/1 0:00:00"),r=new Date(e.modifyDate(n,i[f].years,"year").getTime()-1).toString();break;case/^year$/i.test(f):n="".concat(l,"/1/1 0:00:00"),r=new Date(e.modifyDate(n,i[f].years,"year").getTime()-1).toString();break;case/^month$/i.test(f):n=e.getCorrectDatetime(l).toString(),r=new Date(e.modifyDate(n,1,"month").getTime()-1).toString();break;case/^week$/i.test(f):var d=a(l.split(","),2);o=d[0],c=d[1],n=e.getFirstDayOfWeek(c,o).toString(),r=new Date(e.modifyDate(n,7,"day").getTime()-1).toString();break;case/^day$/i.test(f):case/^weekday$/i.test(f):l="weekday"===f?l.substring(0,l.indexOf(",")):l,n=e.getCorrectDatetime(l).toString(),r=new Date(e.modifyDate(n,1,"day").getTime()-1).toString();break;case/^hour$/i.test(f):case/^minute$/i.test(f):case/^second$/i.test(f):case/^millisecond$/i.test(f):default:n=e.getCorrectDatetime(l).toString(),r=new Date(e.modifyDate(n,1,f).getTime()-1).toString()}return[f=Object.hasOwnProperty.call(i,f)?i[f].lower:f,n,r,h]}(r),c=a(o,4),s=c[0],u=c[1],l=c[2],f=c[3],h={startDatetime:u,endDatetime:l,scale:s};if(!this.is_empty(h.scale)){if(this._config.wrapScale){var d,p=Math.ceil(($(this._element).find(N.TIMELINE_CONTAINER).width()-$(this._element).find(N.TIMELINE_SIDEBAR).width())/f);Object.hasOwnProperty.call(this._config,"originMinGridSize")||(this._config.originMinGridSize=this._config.minGridSize),d=this._config.originMinGridSize,h.minGridSize=Math.max(p,d)}this.reload([h])}}},{key:"showLoader",value:function(){this._debug("showLoader");var t=$(this._element),e=this._config,n=this._instanceProps,r=t.find(N.TIMELINE_CONTAINER),i=n.scaleSize*n.grids,o=n.rowSize*n.rows,a=$("<div></div>",{class:"jqtl-loader",style:"max-width:".concat(i,"px;min-height:").concat(o,"px;")}),c=null,s="";!1!==e.loader&&(0==r.length&&(r=r.prevObject),0==t.find(N.LOADER).length?(0==$(e.loader).length?(s=this.is_empty(e.loadingMessage)?"<span></span><span></span><span></span><span></span><span></span>":e.loadingMessage,c=$("<div></div>",{class:M.LOADER_ITEM}).html(s)):c=$(e.loader).clone().prop("hidden",!1).css("display","block"),a.append(c),r.append(a)):t.find(N.LOADER).css({width:"100%",height:"100%"}),t.find(N.LOADER).attr("data-state","show"))}},{key:"hideLoader",value:function(){var t=this;return new Promise((function(e){t._debug("hideLoader"),$(t._element).find(N.LOADER).attr("data-state","hide"),setTimeout((function(){e()}),300)}))}},{key:"is_empty",value:function(t){if(null==t)return!0;switch(l(t)){case"object":return Array.isArray(t)?0===t.length:!(Object.keys(t).length>0||Object.getOwnPropertySymbols(t).length>0)&&(void 0!==t.valueOf().length?0===t.valueOf().length:"object"===l(t.valueOf())||this.is_empty(t.valueOf()));case"string":return""===t;case"number":return 0==t;case"boolean":return!t;case"undefined":case"null":return!0;case"symbol":case"function":default:return!1}}},{key:"is_Object",value:function(t){return t&&"object"===l(t)&&!Array.isArray(t)}},{key:"mergeDeep",value:function(t,e){var n=Object.assign({},t);if(this.is_Object(t)&&this.is_Object(e))for(var r=0,i=Object.keys(e);r<i.length;r++){var o=i[r];this.is_Object(e[o])&&o in t?n[o]=this.mergeDeep(t[o],e[o]):Object.assign(n,u({},o,e[o]))}return n}},{key:"is_iterable",value:function(t){return t&&"function"==typeof t[Symbol.iterator]}},{key:"toIterableObject",value:function(t){return this.is_iterable(t)||(t[Symbol.iterator]=function(){var e=0;return{next:function(){return t.length<=e?{done:!0}:{value:t[e++]}}}}),t}},{key:"supplement",value:function(t,e,n){return void 0===e?t:void 0===n?e:n(t,e)}},{key:"generateUniqueID",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1e3;return(new Date).getTime().toString(16)+Math.floor(t*Math.random()).toString(16)}},{key:"numRound",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"round";e=this.supplement(0,e,this.validateNumeric);var r=Math.pow(10,e);switch(!0){case/^ceil$/i.test(n):return Math.ceil(t*r)/r;case/^floor$/i.test(n):return Math.floor(t*r)/r;case/^round$/i.test(n):default:return Math.round(t*r)/r}}},{key:"hexToRgbA",value:function(t){var e,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return/^#([A-Fa-f0-9]{3}){1,2}$/.test(t)?(3==(e=t.substring(1).split("")).length&&(e=[e[0],e[0],e[1],e[1],e[2],e[2]]),e="0x".concat(e.join("")),"rgba(".concat([e>>16&255,e>>8&255,255&e].join(","),",").concat(n,")")):t}},{key:"getCorrectDatetime",value:function(t){var e,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=function(t){var e,n=/^-/.test(t),r=n?"-":"";switch(n&&(t=t.replace(/^-/,"")),e=t.replace(/-/g,"/"),!0){case/^\d{1,4}\/\d{1,2}$/.test(e):return"".concat(r).concat(e,"/1");case/^.+(\.\d{1,3})$/.test(e):return isNaN(Date.parse(e))&&(e=e.replace(RegExp.$1,"")),"".concat(r).concat(e);default:return"".concat(r).concat(e)}},o=function(t){var e,n,o,c,s=i(t),u=0;switch(!0){case/^-?\d{1,}\/\d{1,2}(|\/\d{1,2})(| \d{1,2}(|:\d{1,2}(|:\d{1,2})))$/i.test(s):var l=a(s.split(" "),2);e=l[0],n=l[1],(o=e.split("/"))[1]&&(u=Math.floor(o[1]/13),o[1]=parseInt(o[1],10)-1);var h,d,p=[0,0,0];n?(h=o).push.apply(h,f(Object.assign(p,n.split(":")))):(d=o).push.apply(d,p),c=new Date(r(Date,f(o)).setFullYear(parseInt(o[0],10)+u));break;case/^-?\d+$/.test(s):c=new Date(s,0,1,0,0,0,0).setFullYear(parseInt(s,10));break;default:c=new Date(s.toString())}return c};switch(l(t)){case"number":e=new Date(t);break;case"string":e=o(t);break;case"object":t instanceof Date&&(e=t)}if(isNaN(e)||!e)return console.warn('"'.concat(t,'" Cannot parse date because invalid format.')),null;if(e instanceof Date==0&&(e=new Date(e)),n){var c=new Date(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate(),e.getUTCHours(),e.getUTCMinutes(),e.getUTCSeconds(),e.getUTCMilliseconds()),s=this.diffDate(e,c);0!=s&&(e=this.modifyDate(s>0?c:e,-1*s,"millisecond"))}return e}},{key:"getWeek",value:function(t){if(this.is_empty(t))return!1;for(var e=this._config.firstDayOfWeek||0,n=this.getCorrectDatetime(t),r=this.getCorrectDatetime("".concat(n.getFullYear(),"/1/1")),i=n.toDateString(),o=1,a=r,c=0;c<367&&(c>0&&(a=this.modifyDate(r,c,"day")),a.getDay()==e&&o++,a.toDateString()!==i);c++);return o}},{key:"getFirstDayOfWeek",value:function(t,e){if(this.is_empty(t))return!1;e=this.is_empty(e)?(new Date).getFullYear():parseInt(e,10);var n,r=this._config.firstDayOfWeek,i=this.getCorrectDatetime("".concat(e,"/1/1")),o=i.getDay(),a=i,c=o>r?o-r:0,s=c<=0?0:1;if(s==t&&o==r)n=i;else{for(var u=c;u<c+7;u++)if(u>c&&(a=this.modifyDate(i,u,"day")),a.getDay()==r){s++;break}n=s==t?a:this.modifyDate(a,7*(t-s),"day")}return n}},{key:"modifyDate",value:function(t,e,n){if(this.is_empty(t)||this.is_empty(e)||this.is_empty(n)||!this.verifyScale(n))return!1;var i,o=this.getCorrectDatetime(t),a=this.validateNumeric(0,e),c=[o.getFullYear(),o.getMonth(),o.getDate(),o.getHours(),o.getMinutes(),o.getSeconds(),o.getMilliseconds()],s=new Date(r(Date,c).setFullYear(c[0]));switch(!0){case/^millenniums?|millennia$/i.test(n):i=new Date(s.setFullYear(s.getFullYear()+1e3*a));break;case/^century$/i.test(n):i=new Date(s.setFullYear(s.getFullYear()+100*a));break;case/^dec(ade|ennium)$/i.test(n):i=new Date(s.setFullYear(s.getFullYear()+10*a));break;case/^lustrum$/i.test(n):i=new Date(s.setFullYear(s.getFullYear()+5*a));break;case/^years?$/i.test(n):i=new Date(s.setFullYear(s.getFullYear()+a));break;case/^months?$/i.test(n):i=new Date(s.setMonth(s.getMonth()+a));break;case/^weeks?$/i.test(n):(i=new Date(s.setDate(s.getDate()+7*a))).setHours(c[3]),i.setMinutes(c[4]),i.setSeconds(c[5]),i.setMilliseconds(c[6]);break;case/^(|week)days?$/i.test(n):(i=new Date(s.setDate(s.getDate()+a))).setHours(c[3]),i.setMinutes(c[4]),i.setSeconds(c[5]),i.setMilliseconds(c[6]);break;case/^hours?$/i.test(n):(i=new Date(s.setTime(s.getTime()+60*a*60*1e3))).setMinutes(c[4]),i.setSeconds(c[5]),i.setMilliseconds(c[6]);break;case/^minutes?$/i.test(n):(i=new Date(s.setTime(s.getTime()+60*a*1e3))).setSeconds(c[5]),i.setMilliseconds(c[6]);break;case/^seconds?$/i.test(n):(i=new Date(s.setTime(s.getTime()+1e3*a))).setMilliseconds(c[6]);break;default:i=new Date(s.setTime(s.getTime()+a))}return i}},{key:"diffDate",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"millisecond",r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=void 0===t?null:t,o=void 0===e?null:e,a=0,c=!1,s=function(t){var e=new Date(t.getFullYear(),t.getMonth()+1,1);return e.setTime(e.getTime()-1),e.getDate()},u=function(t){for(var e=new Date(t.getFullYear(),0,1),n=0,r=0;r<12;r++)e.setMonth(r),n+=s(e);return 365!=n};if(!i||!o)return console.warn("Cannot parse date to get difference because undefined."),!1;if(a=o-i,isNaN(a))return console.warn("Cannot parse date to get difference because invalid format."),!1;r&&(a=Math.abs(a));var l=i instanceof Date?i:new Date(i),f=o instanceof Date?o:new Date(o),h=f.getFullYear()-l.getFullYear(),d={};switch(!0){case/^millenniums?|millennia$/i.test(n):var p=l.getFullYear(),g=f.getFullYear(),v=Math.ceil((0==p?1:p)/1e3),y=Math.ceil((0==g?1:g)/1e3),m=v;for(d[v]=y-v>0?1e3*v-p:g-p,m++;m<=y;)d[m]=y-m>0?1e3:g-1e3*(m-1),m++;c=d;break;case/^century$/i.test(n):var b=l.getFullYear(),E=f.getFullYear(),w=Math.ceil((0==b?1:b)/100),_=Math.ceil((0==E?1:E)/100),S=w;for(d[w]=_-w>0?100*w-b:E-b,S++;S<=_;)d[S]=_-S>0?100:E-100*(S-1),S++;c=d;break;case/^dec(ade|ennium)$/i.test(n):for(var T,I,x=l.getFullYear(),O=f.getFullYear(),k=0==x?1:x;k<=O;)I=u(new Date(k,0,1))?366:365,T=Math.ceil(k/10),Object.hasOwnProperty.call(d,T)?d[T]+=I:d[T]=I,k++;c=d;break;case/^lustrum$/i.test(n):for(var M,N,R=l.getFullYear(),A=f.getFullYear(),D=0==R?1:R;D<=A;)N=u(new Date(D,0,1))?366:365,M=Math.ceil(D/5),Object.hasOwnProperty.call(d,M)?d[M]+=N:d[M]=N,D++;c=d;break;case/^years?$/i.test(n):if(h>0)for(var $=0;$<=h;$++){var L=new Date(l.getFullYear()+$,0,1);d["".concat(l.getFullYear()+$)]=u(L)?366:365}else d["".concat(l.getFullYear())]=u(l)?366:365;c=d;break;case/^months?$/i.test(n):if(h>0){for(var j=l.getMonth();j<12;j++){var P=new Date(l.getFullYear(),j,1);d["".concat(l.getFullYear(),"/").concat(j+1)]=s(P)}if(h>1)for(var C=1;C<h;C++)for(var F=0;F<12;F++){var U=new Date(l.getFullYear()+C,F,1);d["".concat(l.getFullYear()+C,"/").concat(F+1)]=s(U)}for(var V=0;V<=f.getMonth();V++){var z=new Date(f.getFullYear(),V,1);d["".concat(f.getFullYear(),"/").concat(V+1)]=s(z)}}else for(var Y=l.getMonth();Y<=f.getMonth();Y++){var W=new Date(l.getFullYear(),Y,1);d["".concat(l.getFullYear(),"/").concat(Y+1)]=s(W)}c=d;break;case/^weeks?$/i.test(n):var H=new Date(l.getFullYear(),l.getMonth(),l.getDate()),G=this.getWeek(H),B=new Date(H),q=new Date(H),X="".concat(H.getFullYear(),",").concat(G);for(B.setDate(B.getDate()+1),q.setDate(q.getDate()-1),d[X]=(H-q)/36e5;B.getTime()<=f.getTime();){B.setDate(B.getDate()+1),H.setDate(H.getDate()+1),G=this.getWeek(H);var Z="".concat(H.getFullYear(),",").concat(G);Object.hasOwnProperty.call(d,Z)?d[Z]+=(B-H)/36e5:d[Z]=(B-H)/36e5}c=d;break;case/^(|week)days?$/i.test(n):var K=new Date(l.getFullYear(),l.getMonth(),l.getDate()),J=new Date(K),Q=new Date(K);for(J.setDate(J.getDate()+1),Q.setDate(Q.getDate()-1),d["".concat(K.getFullYear(),"/").concat(K.getMonth()+1,"/").concat(K.getDate())]=(K-Q)/36e5;J.getTime()<=f.getTime();)J.setDate(J.getDate()+1),K.setDate(K.getDate()+1),d["".concat(K.getFullYear(),"/").concat(K.getMonth()+1,"/").concat(K.getDate())]=(J-K)/36e5;c=d;break;case/^hours?$/i.test(n):var tt=new Date(l.getFullYear(),l.getMonth(),l.getDate(),l.getHours()),et=new Date(tt),nt=new Date(tt);for(et.setHours(et.getHours()+1),nt.setHours(nt.getHours()-1),d["".concat(tt.getFullYear(),"/").concat(tt.getMonth()+1,"/").concat(tt.getDate()," ").concat(tt.getHours())]=(tt-nt)/6e4;et.getTime()<=f.getTime();)et.setHours(et.getHours()+1),tt.setHours(tt.getHours()+1),d["".concat(tt.getFullYear(),"/").concat(tt.getMonth()+1,"/").concat(tt.getDate()," ").concat(tt.getHours())]=(et-tt)/6e4;c=d;break;case/^minutes?$/i.test(n):var rt=new Date(l.getFullYear(),l.getMonth(),l.getDate(),l.getHours(),l.getMinutes()),it=new Date(rt),ot=new Date(rt);for(it.setMinutes(it.getMinutes()+1),ot.setMinutes(ot.getMinutes()-1),d["".concat(rt.getFullYear(),"/").concat(rt.getMonth()+1,"/").concat(rt.getDate()," ").concat(rt.getHours(),":").concat(rt.getMinutes())]=(rt-ot)/1e3;it.getTime()<=f.getTime();)it.setMinutes(it.getMinutes()+1),rt.setMinutes(rt.getMinutes()+1),d["".concat(rt.getFullYear(),"/").concat(rt.getMonth()+1,"/").concat(rt.getDate()," ").concat(rt.getHours(),":").concat(rt.getMinutes())]=(it-rt)/1e3;c=d;break;case/^seconds?$/i.test(n):var at=new Date(l.getFullYear(),l.getMonth(),l.getDate(),l.getHours(),l.getMinutes(),l.getSeconds()),ct=new Date(at),st=new Date(at);for(ct.setSeconds(ct.getSeconds()+1),st.setSeconds(st.getSeconds()-1),d["".concat(at.getFullYear(),"/").concat(at.getMonth()+1,"/").concat(at.getDate()," ").concat(at.getHours(),":").concat(at.getMinutes(),":").concat(at.getSeconds())]=at-st;ct.getTime()<=f.getTime();)ct.setSeconds(ct.getSeconds()+1),at.setSeconds(at.getSeconds()+1),d["".concat(at.getFullYear(),"/").concat(at.getMonth()+1,"/").concat(at.getDate()," ").concat(at.getHours(),":").concat(at.getMinutes(),":").concat(at.getSeconds())]=ct-at;c=d;break;default:c=a}return c}},{key:"verifyScale",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=-1,o=this.is_empty(e)||this.is_empty(n),a=!!r&&this.diffDate(e,n,t);if(void 0===t||"string"!=typeof t)return!1;switch(!0){case/^millisec(|ond)s?$/i.test(t):i=1;break;case/^seconds?$/i.test(t):i=1e3;break;case/^minutes?$/i.test(t):i=6e4;break;case/^quarter-?(|hour)$/i.test(t):i=9e5;break;case/^half-?(|hour)$/i.test(t):i=18e5;break;case/^hours?$/i.test(t):i=36e5;break;case/^(|week)days?$/i.test(t):i=864e5;break;case/^weeks?$/i.test(t):i=6048e5;break;case/^months?$/i.test(t):i=2630016000.0000005;break;case/^years?$/i.test(t):i=315576e5;break;case/^lustrum$/i.test(t):i=157788e6;break;case/^dec(ade|ennium)$/i.test(t):i=315576e6;break;case/^century$/i.test(t):i=315576e7;break;case/^millenniums?|millennia$/i.test(t):i=315576e8;break;default:console.warn('Specified an invalid "'.concat(t,'" scale.')),i=-1}return o?i>0:r?a:i}},{key:"getHigherScale",value:function(t){return this.findScale(t,"higher")}},{key:"getLowerScale",value:function(t){return this.findScale(t,"lower")}},{key:"findScale",value:function(t,e){var n,r=[["millisecond","^millisec(|ond)s?$"],["second","^seconds?$"],["minute","^minutes?$"],["hour","^(|half|quarter)-?(|hour)s?$"],["day","^(|week)days?$"],["week","^weeks?$"],["month","^months?$"],["year","^years?$"],["lustrum","^lustrum$"],["decade","^dec(ade|ennium)$"],["century","^century$"],["millennium","^millenniums?|millennia$"]],i=r.findIndex((function(e){return new RegExp("".concat(e[1]),"i").test(t)}));switch(!0){case/^higher$/i.test(e):return r[i=r[i+1]?i+1:i][0];case/^higher\s?all$/i.test(e):return(n=(n=r.slice(i+1)).reduce((function(t,e){return t.concat(e[0])}),[])).includes("day")&&n.push("weekday"),n;case/^lower$/i.test(e):return r[i=r[i-1]?i-1:i][0];case/^lower\s?all$/i.test(e):return(n=(n=r.slice(0,i)).reduce((function(t,e){return t.concat(e[0])}),[])).includes("day")&&n.push("weekday"),n;default:return r[i][0]}}},{key:"getLocaleString",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"en-US",r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};function i(){try{(new Date).toLocaleString("i")}catch(t){return"RangeError"===t.name}return!1}var o,c,s,u,l,f,h,d=i(),p="",g={},v=!1,y=function(t){var e=["th","st","nd","rd"],n=t%100;return t+(e[(n-20)%10]||e[n]||e[0])},m=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:4,n=function(t,e){return Array(t+1).join(e)},r=n(e-String(t).length,"0");return String(t).length==e?String(t):(r+t).substr(-1*t)};if(this.is_empty(t))return!1;for(o in n=this.supplement("en-US",n,this.validateString),r=this.supplement({},r,this.validateObject))/^(localeMatcher|timeZone|hour12|formatMatcher|era|timeZoneName)$/.test(o)&&(g[o]=r[o]);switch(Object.keys(g).length>0&&(v=!0),!0){case/^millenniums?|millennia$/i.test(e):case/^century$/i.test(e):case/^dec(ade|ennium)$/i.test(e):case/^lustrum$/i.test(e):l=this.getCorrectDatetime(t).getFullYear(),c=/^millenniums?|millennia$/i.test(e)?1e3:/^century$/i.test(e)?100:/^dec(ade|ennium)$/i.test(e)?10:5,u=this.numRound(l/c,0,"ceil"),p=Object.hasOwnProperty.call(r,e)&&"ordinal"===r[e]?y(u):u;break;case/^years?$/i.test(e):l=(c=this.getCorrectDatetime(t)).getFullYear(),d&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)?/^(numeric|2-digit)$/i.test(r[e])?(g.year=r[e],p=c.toLocaleDateString(n,g)):/^zerofill$/i.test(r[e])?(p=l.toString().length>3?l:m(l,4),v&&(p=c.toLocaleDateString(n,g).replace(l,p))):p=l:v&&(p=c.toLocaleDateString(n,g))),p=this.is_empty(p)?l:p;break;case/^months?$/i.test(e):f=(c=this.getCorrectDatetime(t,!0)).getMonth()+1,d&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)?/^(numeric|2-digit|narrow|short|long)$/i.test(r[e])?(g.month=r[e],p=c.toLocaleString(n,g)):p=f:v&&(p=c.toLocaleDateString(n,g))),p=this.is_empty(p)?f:p;break;case/^weeks?$/i.test(e):if("string"==typeof t&&/^(.*)+,\d{1,2}$/.test(t)){var b=t.split(","),E=a(b,2);s=E[0],u=E[1],h=parseInt(u,10)}else h=this.getWeek(this.getCorrectDatetime(t));p=Object.hasOwnProperty.call(r,e)&&"ordinal"===r[e]?y(h):h;break;case/^weekdays?$/i.test(e):if("string"==typeof t&&/^(.*)+,\d{1}$/.test(t)){var w=t.split(","),_=a(w,2);s=_[0],u=_[1],c=this.getCorrectDatetime(s,!0),u=parseInt(u,10)}else c=this.getCorrectDatetime(t,!0);d&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)?/^(narrow|short|long)$/i.test(r[e])&&(g.weekday=r[e],p=c.toLocaleString(n,g)):v&&(p=c.toLocaleDateString(n,g))),this.is_empty(p)&&(s=c.toLocaleDateString(n,{weekday:"long"}),p=/^short$/i.test(r[e])?s.substring(0,3):/^long$/i.test(r[e])?s:s.substring(0,1));break;case/^days?$/i.test(e):c=this.getCorrectDatetime(t,!0),d&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)?/^(numeric|2-digit)$/i.test(r[e])?(g.day=r[e],p=c.toLocaleString(n,g)):/^ordinal$/i.test(r[e])&&(p=y(parseInt(c.getDate(),10))):v&&(p=c.toLocaleDateString(n,g))),p=this.is_empty(p)?c.getDate():p;break;case/^hours?$/i.test(e):case/^(half|quarter)-?hours?$/i.test(e):c=this.getCorrectDatetime(t),d&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)?(/^(numeric|2-digit)$/i.test(r[e])?g.hour=r[e]:/^fulltime$/i.test(r[e])&&(g.hour="numeric",g.minute="numeric"),p=c.toLocaleString(n,g)):v&&(p=c.toLocaleString(n,g))),p=this.is_empty(p)?c.getHours():p;break;case/^minutes?$/i.test(e):c=this.getCorrectDatetime(t),d&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)?(/^(numeric|2-digit)$/i.test(r[e])?g.minute=r[e]:/^fulltime$/i.test(r[e])&&(g.hour="numeric",g.minute="numeric"),p=c.toLocaleString(n,g)):v&&(p=c.toLocaleString(n,g))),p=this.is_empty(p)?c.getMinutes():p;break;case/^seconds?$/i.test(e):c=this.getCorrectDatetime(t),d&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)?(/^(numeric|2-digit)$/i.test(r[e])?g.second=r[e]:/^fulltime$/i.test(r[e])&&(g.hour="numeric",g.minute="numeric",g.second="numeric"),p=c.toLocaleString(n,g)):v&&(p=c.toLocaleString(n,g))),p=this.is_empty(p)?c.getSeconds():p;break;case/^millisec(|ond)s?$/i.test(e):c=this.getCorrectDatetime(t),Object.hasOwnProperty.call(r,e)&&(Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),p=/^numeric$/i.test(r[e])?parseInt(c.getMilliseconds(),10):m(parseInt(c.getMilliseconds(),10),3)),p=this.is_empty(p)?c.getMilliseconds():p;break;case/^custom$/i.test(e):c=this.getCorrectDatetime(t),Object.hasOwnProperty.call(r,"timeZone")&&/^utc$/i.test(r.timeZone)&&(c=this.modifyDate(c,-1*c.getTimezoneOffset(),"minute")),Object.hasOwnProperty.call(r,e)&&(p=this.datetimeFormat(c,r[e],n)),p=this.is_empty(p)?c.toString():p;break;default:c=this.getCorrectDatetime(t),p=v?c.toLocaleString(n,g):c.toString()}return p.toString()}},{key:"datetimeFormat",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"en-US",i=t instanceof Date?t:this.getCorrectDatetime(t),o=n.toString().split(""),a="YyZmBbdwWAaIHMSj".split(""),c="",s=function(t){var e=new Date(t.getFullYear(),t.getMonth()+1,1);return e.setTime(e.getTime()-1),e.getDate()};return this.is_empty(o)?i.toString():(o.forEach((function(t,n,o){var u=!1,l="";if(a.includes(t)&&!e.is_empty(o[n-1])&&"%"===o[n-1]&&(u=e.is_empty(o[n-2])||"\\"!==o[n-2]),u){switch(t){case"Y":case"y":case"Z":var f=i.getFullYear();l="Z"===t?f<10?"000".concat(f):f<100?"00".concat(f):f<1e3?"0".concat(f):f:"Y"===t?f:f.toString().slice(-2);break;case"m":case"B":case"b":if("m"===t){var h=i.getMonth()+1;l=h<10?"0".concat(h):h}else{var d={month:"B"===t?"long":"short"};l=i.toLocaleDateString(r,d)}break;case"d":var p=i.getDate();l=p<10?"0".concat(p):p;break;case"w":case"A":case"a":if("w"===t)l=i.getDay();else{var g={weekday:"A"===t?"long":"short"};l=i.toLocaleDateString(r,g)}break;case"W":l=e.getWeek(i);break;case"I":case"H":var v={hour12:"I"===t,hour:"numeric"};l=i.toLocaleTimeString(r,v);break;case"M":l=i.toLocaleTimeString(r,{minute:"numeric"});break;case"S":l=i.toLocaleTimeString(r,{second:"numeric"});break;case"j":var y,m=new Date(i.getFullYear(),0,1),b=i.getMonth(),E=0;for(y=0;y<b;y++)m.setMonth(y),E+=s(m);l=(l=E+i.getDate())<10?"00".concat(l):l<100?"0".concat(l):l}c=c.substring(0,c.length-1)+l.toString()}else c+=t}),c),c=c.toString().replace(/\\/g,""))}},{key:"strWidth",value:function(t){var e,n=$('<span id="jqtl-str-ruler"></span>');return 0==$("#jqtl-str-ruler").length&&$("body").append(n),e=$("#jqtl-str-ruler").text(t).get(0).offsetWidth,$("#jqtl-str-ruler").empty(),e}},{key:"compareValues",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"asc";return function(n,r){if(!Object.hasOwnProperty.call(n,t)||!Object.hasOwnProperty.call(r,t))return 0;var i="string"==typeof n[t]?n[t].toUpperCase():n[t],o="string"==typeof r[t]?r[t].toUpperCase():r[t],a=0;return i>o?a=1:i<o&&(a=-1),"desc"===e?-1*a:a}}},{key:"validateString",value:function(t,e){return"string"==typeof e&&""!==e?e:t}},{key:"validateNumeric",value:function(t,e){return"number"==typeof e?Number(e):t}},{key:"validateBoolean",value:function(t,e){return"boolean"==typeof e||"object"===l(e)&&null!==e&&"boolean"==typeof e.valueOf()?e:t}},{key:"validateObject",value:function(t,e){return"object"===l(e)?e:t}},{key:"validateArray",value:function(t,e){return"[object Array]"===Object.prototype.toString.call(e)?e:t}}],i=[{key:"_jQueryInterface",value:function(e){for(var n=arguments.length,r=new Array(n>1?n-1:0),i=1;i<n;i++)r[i-1]=arguments[i];return this.each((function(){var n=$(this).data(E),i=s(s(s({},I),$(this).data()),"object"===l(e)&&e?e:{});if(n||(n=new t(this,i),$(this).data(E,n)),"string"==typeof e&&"_"!=e.charAt(0)){if(void 0===n[e])throw new ReferenceError('No method named "'.concat(e,'"'));n[e](r)}else n._isInitialized&&n._isCompleted||n._init()}))}},{key:"_getInstance",value:function(t){return D(t,E)}},{key:"VERSION",get:function(){return"2.0.0"}},{key:"Default",get:function(){return I}}],n&&v(e.prototype,n),i&&v(e,i),t}();$.fn[b]=L._jQueryInterface,$.fn[b].Constructor=L,$.fn[b].noConflict=function(){return $.fn[b]=T,L._jQueryInterface}},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";var r=n(94),i=n(60);t.exports=r?{}.toString:function(){return"[object "+i(this)+"]"}},function(t,e,n){var r=n(2);t.exports=function(t,e){var n=r.console;n&&n.error&&(1===arguments.length?n.error(t):n.error(t,e))}},function(t,e,n){n(189),n(369);var r=n(52);t.exports=r},function(t,e,n){n(110),n(190),n(120),n(191),n(192),n(121),n(193),n(194),n(195),n(196),n(197),n(198),n(199),n(200),n(201),n(142),n(202),n(203),n(204),n(205),n(206),n(207),n(144),n(145),n(208),n(209),n(210),n(211),n(212),n(213),n(146),n(214),n(215),n(216),n(148),n(147),n(217),n(218),n(219),n(220),n(221),n(140),n(222),n(223),n(128),n(224),n(225),n(122),n(226),n(227),n(228),n(123),n(124),n(125),n(229),n(230),n(126),n(131),n(132),n(135),n(231),n(232),n(136),n(233),n(234),n(137),n(138),n(139),n(235),n(236),n(237),n(238),n(61),n(239),n(240),n(241),n(242),n(160),n(243),n(244),n(245),n(246),n(247),n(161),n(248),n(162),n(249),n(250),n(251),n(252),n(102),n(253),n(254),n(255),n(256),n(257),n(258),n(259),n(260),n(261),n(262),n(263),n(264),n(265),n(158),n(73),n(266),n(267),n(268),n(159),n(269),n(270),n(141),n(271),n(272),n(274),n(275),n(276),n(277),n(278),n(279),n(280),n(281),n(282),n(283),n(284),n(285),n(286),n(287),n(288),n(289),n(290),n(292),n(293),n(294),n(295),n(296),n(297),n(298),n(299),n(300),n(301),n(302),n(303),n(304),n(306),n(307),n(309),n(310),n(150),n(311),n(312),n(313),n(314),n(315),n(316),n(317),n(319),n(320),n(321),n(322),n(324),n(325),n(326),n(327),n(328),n(329),n(330),n(331),n(332),n(333),n(334),n(335),n(336),n(337),n(338),n(339),n(340),n(341),n(342),n(343),n(344),n(345),n(346),n(347),n(348),n(349),n(350),n(351),n(352),n(353),n(354),n(355),n(356),n(357),n(156),n(358),n(359),n(360),n(361),n(362),n(363),n(364),n(365),n(366),n(367),n(368);var r=n(52);t.exports=r},function(t,e,n){n(18)("asyncIterator")},function(t,e,n){n(18)("hasInstance")},function(t,e,n){n(18)("isConcatSpreadable")},function(t,e,n){n(18)("match")},function(t,e,n){n(18)("matchAll")},function(t,e,n){n(18)("replace")},function(t,e,n){n(18)("search")},function(t,e,n){n(18)("species")},function(t,e,n){n(18)("split")},function(t,e,n){n(18)("toPrimitive")},function(t,e,n){n(18)("toStringTag")},function(t,e,n){n(18)("unscopables")},function(t,e,n){n(0)({target:"Object",stat:!0,sham:!n(5)},{create:n(31)})},function(t,e,n){var r=n(0),i=n(5);r({target:"Object",stat:!0,forced:!i,sham:!i},{defineProperty:n(9).f})},function(t,e,n){var r=n(0),i=n(5);r({target:"Object",stat:!0,forced:!i,sham:!i},{defineProperties:n(91)})},function(t,e,n){var r=n(0),i=n(149).entries;r({target:"Object",stat:!0},{entries:function(t){return i(t)}})},function(t,e,n){var r=n(0),i=n(63),o=n(1),a=n(3),c=n(44).onFreeze,s=Object.freeze;r({target:"Object",stat:!0,forced:o((function(){s(1)})),sham:!i},{freeze:function(t){return s&&a(t)?s(c(t)):t}})},function(t,e,n){var r=n(0),i=n(48),o=n(42);r({target:"Object",stat:!0},{fromEntries:function(t){var e={};return i(t,(function(t,n){o(e,t,n)}),void 0,!0),e}})},function(t,e,n){var r=n(0),i=n(1),o=n(118).f;r({target:"Object",stat:!0,forced:i((function(){return!Object.getOwnPropertyNames(1)}))},{getOwnPropertyNames:o})},function(t,e,n){var r=n(0),i=n(1),o=n(10),a=n(29),c=n(97);r({target:"Object",stat:!0,forced:i((function(){a(1)})),sham:!c},{getPrototypeOf:function(t){return a(o(t))}})},function(t,e,n){n(0)({target:"Object",stat:!0},{is:n(167)})},function(t,e,n){var r=n(0),i=n(1),o=n(3),a=Object.isExtensible;r({target:"Object",stat:!0,forced:i((function(){a(1)}))},{isExtensible:function(t){return!!o(t)&&(!a||a(t))}})},function(t,e,n){var r=n(0),i=n(1),o=n(3),a=Object.isFrozen;r({target:"Object",stat:!0,forced:i((function(){a(1)}))},{isFrozen:function(t){return!o(t)||!!a&&a(t)}})},function(t,e,n){var r=n(0),i=n(1),o=n(3),a=Object.isSealed;r({target:"Object",stat:!0,forced:i((function(){a(1)}))},{isSealed:function(t){return!o(t)||!!a&&a(t)}})},function(t,e,n){var r=n(0),i=n(3),o=n(44).onFreeze,a=n(63),c=n(1),s=Object.preventExtensions;r({target:"Object",stat:!0,forced:c((function(){s(1)})),sham:!a},{preventExtensions:function(t){return s&&i(t)?s(o(t)):t}})},function(t,e,n){var r=n(0),i=n(3),o=n(44).onFreeze,a=n(63),c=n(1),s=Object.seal;r({target:"Object",stat:!0,forced:c((function(){s(1)})),sham:!a},{seal:function(t){return s&&i(t)?s(o(t)):t}})},function(t,e,n){n(0)({target:"Object",stat:!0},{setPrototypeOf:n(43)})},function(t,e,n){"use strict";var r=n(0),i=n(5),o=n(79),a=n(10),c=n(19),s=n(9);i&&r({target:"Object",proto:!0,forced:o},{__defineGetter__:function(t,e){s.f(a(this),t,{get:c(e),enumerable:!0,configurable:!0})}})},function(t,e,n){"use strict";var r=n(0),i=n(5),o=n(79),a=n(10),c=n(19),s=n(9);i&&r({target:"Object",proto:!0,forced:o},{__defineSetter__:function(t,e){s.f(a(this),t,{set:c(e),enumerable:!0,configurable:!0})}})},function(t,e,n){"use strict";var r=n(0),i=n(5),o=n(79),a=n(10),c=n(27),s=n(29),u=n(13).f;i&&r({target:"Object",proto:!0,forced:o},{__lookupGetter__:function(t){var e,n=a(this),r=c(t,!0);do{if(e=u(n,r))return e.get}while(n=s(n))}})},function(t,e,n){"use strict";var r=n(0),i=n(5),o=n(79),a=n(10),c=n(27),s=n(29),u=n(13).f;i&&r({target:"Object",proto:!0,forced:o},{__lookupSetter__:function(t){var e,n=a(this),r=c(t,!0);do{if(e=u(n,r))return e.set}while(n=s(n))}})},function(t,e,n){n(0)({target:"Function",proto:!0},{bind:n(157)})},function(t,e,n){"use strict";var r=n(3),i=n(9),o=n(29),a=n(6)("hasInstance"),c=Function.prototype;a in c||i.f(c,a,{value:function(t){if("function"!=typeof this||!r(t))return!1;if(!r(this.prototype))return t instanceof this;for(;t=o(t);)if(this.prototype===t)return!0;return!1}})},function(t,e,n){n(0)({global:!0},{globalThis:n(2)})},function(t,e,n){n(0)({target:"Array",stat:!0},{isArray:n(41)})},function(t,e,n){"use strict";var r=n(0),i=n(1),o=n(42);r({target:"Array",stat:!0,forced:i((function(){function t(){}return!(Array.of.call(t)instanceof t)}))},{of:function(){for(var t=0,e=arguments.length,n=new("function"==typeof this?this:Array)(e);e>t;)o(n,t,arguments[t++]);return n.length=e,n}})},function(t,e,n){var r=n(0),i=n(168),o=n(38);r({target:"Array",proto:!0},{copyWithin:i}),o("copyWithin")},function(t,e,n){"use strict";var r=n(0),i=n(12).every,o=n(32),a=n(20),c=o("every"),s=a("every");r({target:"Array",proto:!0,forced:!c||!s},{every:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){var r=n(0),i=n(103),o=n(38);r({target:"Array",proto:!0},{fill:i}),o("fill")},function(t,e,n){"use strict";var r=n(0),i=n(169),o=n(10),a=n(7),c=n(26),s=n(56);r({target:"Array",proto:!0},{flat:function(){var t=arguments.length?arguments[0]:void 0,e=o(this),n=a(e.length),r=s(e,0);return r.length=i(r,e,e,n,0,void 0===t?1:c(t)),r}})},function(t,e,n){"use strict";var r=n(0),i=n(169),o=n(10),a=n(7),c=n(19),s=n(56);r({target:"Array",proto:!0},{flatMap:function(t){var e,n=o(this),r=a(n.length);return c(t),(e=s(n,0)).length=i(e,n,n,r,0,1,t,arguments.length>1?arguments[1]:void 0),e}})},function(t,e,n){var r=n(0),i=n(170);r({target:"Array",proto:!0,forced:i!==[].lastIndexOf},{lastIndexOf:i})},function(t,e,n){"use strict";var r=n(0),i=n(12).map,o=n(57),a=n(20),c=o("map"),s=a("map");r({target:"Array",proto:!0,forced:!c||!s},{map:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r=n(0),i=n(68).right,o=n(32),a=n(20),c=o("reduceRight"),s=a("reduce",{1:0});r({target:"Array",proto:!0,forced:!c||!s},{reduceRight:function(t){return i(this,t,arguments.length,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r=n(0),i=n(41),o=[].reverse,a=[1,2];r({target:"Array",proto:!0,forced:String(a)===String(a.reverse())},{reverse:function(){return i(this)&&(this.length=this.length),o.call(this)}})},function(t,e,n){"use strict";var r=n(0),i=n(36),o=n(26),a=n(7),c=n(10),s=n(56),u=n(42),l=n(57),f=n(20),h=l("splice"),d=f("splice",{ACCESSORS:!0,0:0,1:2}),p=Math.max,g=Math.min;r({target:"Array",proto:!0,forced:!h||!d},{splice:function(t,e){var n,r,l,f,h,d,v=c(this),y=a(v.length),m=i(t,y),b=arguments.length;if(0===b?n=r=0:1===b?(n=0,r=y-m):(n=b-2,r=g(p(o(e),0),y-m)),y+n-r>9007199254740991)throw TypeError("Maximum allowed length exceeded");for(l=s(v,r),f=0;f<r;f++)(h=m+f)in v&&u(l,f,v[h]);if(l.length=r,n<r){for(f=m;f<y-r;f++)d=f+n,(h=f+r)in v?v[d]=v[h]:delete v[d];for(f=y;f>y-r+n;f--)delete v[f-1]}else if(n>r)for(f=y-r;f>m;f--)d=f+n-1,(h=f+r-1)in v?v[d]=v[h]:delete v[d];for(f=0;f<n;f++)v[f+m]=arguments[f+2];return v.length=y-r+n,l}})},function(t,e,n){n(47)("Array")},function(t,e,n){n(38)("flat")},function(t,e,n){n(38)("flatMap")},function(t,e,n){var r=n(0),i=n(36),o=String.fromCharCode,a=String.fromCodePoint;r({target:"String",stat:!0,forced:!!a&&1!=a.length},{fromCodePoint:function(t){for(var e,n=[],r=arguments.length,a=0;r>a;){if(e=+arguments[a++],i(e,1114111)!==e)throw RangeError(e+" is not a valid code point");n.push(e<65536?o(e):o(55296+((e-=65536)>>10),e%1024+56320))}return n.join("")}})},function(t,e,n){var r=n(0),i=n(21),o=n(7);r({target:"String",stat:!0},{raw:function(t){for(var e=i(t.raw),n=o(e.length),r=arguments.length,a=[],c=0;n>c;)a.push(String(e[c++])),c<r&&a.push(String(arguments[c]));return a.join("")}})},function(t,e,n){"use strict";var r=n(0),i=n(75).codeAt;r({target:"String",proto:!0},{codePointAt:function(t){return i(this,t)}})},function(t,e,n){"use strict";var r,i=n(0),o=n(13).f,a=n(7),c=n(100),s=n(15),u=n(101),l=n(28),f="".endsWith,h=Math.min,d=u("endsWith");i({target:"String",proto:!0,forced:!!(l||d||(r=o(String.prototype,"endsWith"),!r||r.writable))&&!d},{endsWith:function(t){var e=String(s(this));c(t);var n=arguments.length>1?arguments[1]:void 0,r=a(e.length),i=void 0===n?r:h(a(n),r),o=String(t);return f?f.call(e,o,i):e.slice(i-o.length,i)===o}})},function(t,e,n){"use strict";var r=n(76),i=n(4),o=n(7),a=n(15),c=n(77),s=n(78);r("match",1,(function(t,e,n){return[function(e){var n=a(this),r=null==e?void 0:e[t];return void 0!==r?r.call(e,n):new RegExp(e)[t](String(n))},function(t){var r=n(e,t,this);if(r.done)return r.value;var a=i(t),u=String(this);if(!a.global)return s(a,u);var l=a.unicode;a.lastIndex=0;for(var f,h=[],d=0;null!==(f=s(a,u));){var p=String(f[0]);h[d]=p,""===p&&(a.lastIndex=c(u,o(a.lastIndex),l)),d++}return 0===d?null:h}]}))},function(t,e,n){"use strict";var r=n(0),i=n(96),o=n(15),a=n(7),c=n(19),s=n(4),u=n(24),l=n(71),f=n(62),h=n(16),d=n(1),p=n(6),g=n(33),v=n(77),y=n(17),m=n(28),b=p("matchAll"),E=y.set,w=y.getterFor("RegExp String Iterator"),_=RegExp.prototype,S=_.exec,T="".matchAll,I=!!T&&!d((function(){"a".matchAll(/./)})),x=i((function(t,e,n,r){E(this,{type:"RegExp String Iterator",regexp:t,string:e,global:n,unicode:r,done:!1})}),"RegExp String",(function(){var t=w(this);if(t.done)return{value:void 0,done:!0};var e=t.regexp,n=t.string,r=function(t,e){var n,r=t.exec;if("function"==typeof r){if("object"!=typeof(n=r.call(t,e)))throw TypeError("Incorrect exec result");return n}return S.call(t,e)}(e,n);return null===r?{value:void 0,done:t.done=!0}:t.global?(""==String(r[0])&&(e.lastIndex=v(n,a(e.lastIndex),t.unicode)),{value:r,done:!1}):(t.done=!0,{value:r,done:!1})})),O=function(t){var e,n,r,i,o,c,u=s(this),l=String(t);return e=g(u,RegExp),void 0===(n=u.flags)&&u instanceof RegExp&&!("flags"in _)&&(n=f.call(u)),r=void 0===n?"":String(n),i=new e(e===RegExp?u.source:u,r),o=!!~r.indexOf("g"),c=!!~r.indexOf("u"),i.lastIndex=a(u.lastIndex),new x(i,l,o,c)};r({target:"String",proto:!0,forced:I},{matchAll:function(t){var e,n,r,i=o(this);if(null!=t){if(l(t)&&!~String(o("flags"in _?t.flags:f.call(t))).indexOf("g"))throw TypeError("`.matchAll` does not allow non-global regexes");if(I)return T.apply(i,arguments);if(void 0===(n=t[b])&&m&&"RegExp"==u(t)&&(n=O),null!=n)return c(n).call(t,i)}else if(I)return T.apply(i,arguments);return e=String(i),r=new RegExp(t,"g"),m?O.call(r,e):r[b](e)}}),m||b in _||h(_,b,O)},function(t,e,n){"use strict";var r=n(0),i=n(104).end;r({target:"String",proto:!0,forced:n(171)},{padEnd:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var r=n(0),i=n(104).start;r({target:"String",proto:!0,forced:n(171)},{padStart:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){n(0)({target:"String",proto:!0},{repeat:n(105)})},function(t,e,n){"use strict";var r=n(76),i=n(4),o=n(15),a=n(167),c=n(78);r("search",1,(function(t,e,n){return[function(e){var n=o(this),r=null==e?void 0:e[t];return void 0!==r?r.call(e,n):new RegExp(e)[t](String(n))},function(t){var r=n(e,t,this);if(r.done)return r.value;var o=i(t),s=String(this),u=o.lastIndex;a(u,0)||(o.lastIndex=0);var l=c(o,s);return a(o.lastIndex,u)||(o.lastIndex=u),null===l?-1:l.index}]}))},function(t,e,n){"use strict";var r,i=n(0),o=n(13).f,a=n(7),c=n(100),s=n(15),u=n(101),l=n(28),f="".startsWith,h=Math.min,d=u("startsWith");i({target:"String",proto:!0,forced:!!(l||d||(r=o(String.prototype,"startsWith"),!r||r.writable))&&!d},{startsWith:function(t){var e=String(s(this));c(t);var n=a(h(arguments.length>1?arguments[1]:void 0,e.length)),r=String(t);return f?f.call(e,r,n):e.slice(n,n+r.length)===r}})},function(t,e,n){"use strict";var r=n(0),i=n(45).trim;r({target:"String",proto:!0,forced:n(106)("trim")},{trim:function(){return i(this)}})},function(t,e,n){"use strict";var r=n(0),i=n(45).start,o=n(106)("trimStart"),a=o?function(){return i(this)}:"".trimStart;r({target:"String",proto:!0,forced:o},{trimStart:a,trimLeft:a})},function(t,e,n){"use strict";var r=n(0),i=n(45).end,o=n(106)("trimEnd"),a=o?function(){return i(this)}:"".trimEnd;r({target:"String",proto:!0,forced:o},{trimEnd:a,trimRight:a})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("anchor")},{anchor:function(t){return i(this,"a","name",t)}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("big")},{big:function(){return i(this,"big","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("blink")},{blink:function(){return i(this,"blink","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("bold")},{bold:function(){return i(this,"b","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("fixed")},{fixed:function(){return i(this,"tt","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("fontcolor")},{fontcolor:function(t){return i(this,"font","color",t)}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("fontsize")},{fontsize:function(t){return i(this,"font","size",t)}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("italics")},{italics:function(){return i(this,"i","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("link")},{link:function(t){return i(this,"a","href",t)}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("small")},{small:function(){return i(this,"small","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("strike")},{strike:function(){return i(this,"strike","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("sub")},{sub:function(){return i(this,"sub","","")}})},function(t,e,n){"use strict";var r=n(0),i=n(22);r({target:"String",proto:!0,forced:n(23)("sup")},{sup:function(){return i(this,"sup","","")}})},function(t,e,n){var r=n(5),i=n(9),o=n(62),a=n(72).UNSUPPORTED_Y;r&&("g"!=/./g.flags||a)&&i.f(RegExp.prototype,"flags",{configurable:!0,get:o})},function(t,e,n){var r=n(5),i=n(72).UNSUPPORTED_Y,o=n(9).f,a=n(17).get,c=RegExp.prototype;r&&i&&o(RegExp.prototype,"sticky",{configurable:!0,get:function(){if(this!==c){if(this instanceof RegExp)return!!a(this).sticky;throw TypeError("Incompatible receiver, RegExp required")}}})},function(t,e,n){"use strict";n(73);var r,i,o=n(0),a=n(3),c=(r=!1,(i=/[ac]/).exec=function(){return r=!0,/./.exec.apply(this,arguments)},!0===i.test("abc")&&r),s=/./.test;o({target:"RegExp",proto:!0,forced:!c},{test:function(t){if("function"!=typeof this.exec)return s.call(this,t);var e=this.exec(t);if(null!==e&&!a(e))throw new Error("RegExp exec method returned something other than an Object or null");return!!e}})},function(t,e,n){var r=n(0),i=n(172);r({global:!0,forced:parseInt!=i},{parseInt:i})},function(t,e,n){var r=n(0),i=n(173);r({global:!0,forced:parseFloat!=i},{parseFloat:i})},function(t,e,n){n(0)({target:"Number",stat:!0},{EPSILON:Math.pow(2,-52)})},function(t,e,n){n(0)({target:"Number",stat:!0},{isFinite:n(273)})},function(t,e,n){var r=n(2).isFinite;t.exports=Number.isFinite||function(t){return"number"==typeof t&&r(t)}},function(t,e,n){n(0)({target:"Number",stat:!0},{isInteger:n(174)})},function(t,e,n){n(0)({target:"Number",stat:!0},{isNaN:function(t){return t!=t}})},function(t,e,n){var r=n(0),i=n(174),o=Math.abs;r({target:"Number",stat:!0},{isSafeInteger:function(t){return i(t)&&o(t)<=9007199254740991}})},function(t,e,n){n(0)({target:"Number",stat:!0},{MAX_SAFE_INTEGER:9007199254740991})},function(t,e,n){n(0)({target:"Number",stat:!0},{MIN_SAFE_INTEGER:-9007199254740991})},function(t,e,n){var r=n(0),i=n(173);r({target:"Number",stat:!0,forced:Number.parseFloat!=i},{parseFloat:i})},function(t,e,n){var r=n(0),i=n(172);r({target:"Number",stat:!0,forced:Number.parseInt!=i},{parseInt:i})},function(t,e,n){"use strict";var r=n(0),i=n(26),o=n(175),a=n(105),c=n(1),s=1..toFixed,u=Math.floor,l=function(t,e,n){return 0===e?n:e%2==1?l(t,e-1,n*t):l(t*t,e/2,n)};r({target:"Number",proto:!0,forced:s&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==(0xde0b6b3a7640080).toFixed(0))||!c((function(){s.call({})}))},{toFixed:function(t){var e,n,r,c,s=o(this),f=i(t),h=[0,0,0,0,0,0],d="",p="0",g=function(t,e){for(var n=-1,r=e;++n<6;)r+=t*h[n],h[n]=r%1e7,r=u(r/1e7)},v=function(t){for(var e=6,n=0;--e>=0;)n+=h[e],h[e]=u(n/t),n=n%t*1e7},y=function(){for(var t=6,e="";--t>=0;)if(""!==e||0===t||0!==h[t]){var n=String(h[t]);e=""===e?n:e+a.call("0",7-n.length)+n}return e};if(f<0||f>20)throw RangeError("Incorrect fraction digits");if(s!=s)return"NaN";if(s<=-1e21||s>=1e21)return String(s);if(s<0&&(d="-",s=-s),s>1e-21)if(n=(e=function(t){for(var e=0,n=t;n>=4096;)e+=12,n/=4096;for(;n>=2;)e+=1,n/=2;return e}(s*l(2,69,1))-69)<0?s*l(2,-e,1):s/l(2,e,1),n*=4503599627370496,(e=52-e)>0){for(g(0,n),r=f;r>=7;)g(1e7,0),r-=7;for(g(l(10,r,1),0),r=e-1;r>=23;)v(1<<23),r-=23;v(1<<r),g(1,1),v(2),p=y()}else g(0,n),g(1<<-e,0),p=y()+a.call("0",f);return p=f>0?d+((c=p.length)<=f?"0."+a.call("0",f-c)+p:p.slice(0,c-f)+"."+p.slice(c-f)):d+p}})},function(t,e,n){"use strict";var r=n(0),i=n(1),o=n(175),a=1..toPrecision;r({target:"Number",proto:!0,forced:i((function(){return"1"!==a.call(1,void 0)}))||!i((function(){a.call({})}))},{toPrecision:function(t){return void 0===t?a.call(o(this)):a.call(o(this),t)}})},function(t,e,n){var r=n(0),i=n(176),o=Math.acosh,a=Math.log,c=Math.sqrt,s=Math.LN2;r({target:"Math",stat:!0,forced:!o||710!=Math.floor(o(Number.MAX_VALUE))||o(1/0)!=1/0},{acosh:function(t){return(t=+t)<1?NaN:t>94906265.62425156?a(t)+s:i(t-1+c(t-1)*c(t+1))}})},function(t,e,n){var r=n(0),i=Math.asinh,o=Math.log,a=Math.sqrt;r({target:"Math",stat:!0,forced:!(i&&1/i(0)>0)},{asinh:function t(e){return isFinite(e=+e)&&0!=e?e<0?-t(-e):o(e+a(e*e+1)):e}})},function(t,e,n){var r=n(0),i=Math.atanh,o=Math.log;r({target:"Math",stat:!0,forced:!(i&&1/i(-0)<0)},{atanh:function(t){return 0==(t=+t)?t:o((1+t)/(1-t))/2}})},function(t,e,n){var r=n(0),i=n(107),o=Math.abs,a=Math.pow;r({target:"Math",stat:!0},{cbrt:function(t){return i(t=+t)*a(o(t),1/3)}})},function(t,e,n){var r=n(0),i=Math.floor,o=Math.log,a=Math.LOG2E;r({target:"Math",stat:!0},{clz32:function(t){return(t>>>=0)?31-i(o(t+.5)*a):32}})},function(t,e,n){var r=n(0),i=n(80),o=Math.cosh,a=Math.abs,c=Math.E;r({target:"Math",stat:!0,forced:!o||o(710)===1/0},{cosh:function(t){var e=i(a(t)-1)+1;return(e+1/(e*c*c))*(c/2)}})},function(t,e,n){var r=n(0),i=n(80);r({target:"Math",stat:!0,forced:i!=Math.expm1},{expm1:i})},function(t,e,n){n(0)({target:"Math",stat:!0},{fround:n(291)})},function(t,e,n){var r=n(107),i=Math.abs,o=Math.pow,a=o(2,-52),c=o(2,-23),s=o(2,127)*(2-c),u=o(2,-126);t.exports=Math.fround||function(t){var e,n,o=i(t),l=r(t);return o<u?l*(o/u/c+1/a-1/a)*u*c:(n=(e=(1+c/a)*o)-(e-o))>s||n!=n?l*(1/0):l*n}},function(t,e,n){var r=n(0),i=Math.hypot,o=Math.abs,a=Math.sqrt;r({target:"Math",stat:!0,forced:!!i&&i(1/0,NaN)!==1/0},{hypot:function(t,e){for(var n,r,i=0,c=0,s=arguments.length,u=0;c<s;)u<(n=o(arguments[c++]))?(i=i*(r=u/n)*r+1,u=n):i+=n>0?(r=n/u)*r:n;return u===1/0?1/0:u*a(i)}})},function(t,e,n){var r=n(0),i=n(1),o=Math.imul;r({target:"Math",stat:!0,forced:i((function(){return-5!=o(4294967295,5)||2!=o.length}))},{imul:function(t,e){var n=+t,r=+e,i=65535&n,o=65535&r;return 0|i*o+((65535&n>>>16)*o+i*(65535&r>>>16)<<16>>>0)}})},function(t,e,n){var r=n(0),i=Math.log,o=Math.LOG10E;r({target:"Math",stat:!0},{log10:function(t){return i(t)*o}})},function(t,e,n){n(0)({target:"Math",stat:!0},{log1p:n(176)})},function(t,e,n){var r=n(0),i=Math.log,o=Math.LN2;r({target:"Math",stat:!0},{log2:function(t){return i(t)/o}})},function(t,e,n){n(0)({target:"Math",stat:!0},{sign:n(107)})},function(t,e,n){var r=n(0),i=n(1),o=n(80),a=Math.abs,c=Math.exp,s=Math.E;r({target:"Math",stat:!0,forced:i((function(){return-2e-17!=Math.sinh(-2e-17)}))},{sinh:function(t){return a(t=+t)<1?(o(t)-o(-t))/2:(c(t-1)-c(-t-1))*(s/2)}})},function(t,e,n){var r=n(0),i=n(80),o=Math.exp;r({target:"Math",stat:!0},{tanh:function(t){var e=i(t=+t),n=i(-t);return e==1/0?1:n==1/0?-1:(e-n)/(o(t)+o(-t))}})},function(t,e,n){n(30)(Math,"Math",!0)},function(t,e,n){var r=n(0),i=Math.ceil,o=Math.floor;r({target:"Math",stat:!0},{trunc:function(t){return(t>0?o:i)(t)}})},function(t,e,n){n(0)({target:"Date",stat:!0},{now:function(){return(new Date).getTime()}})},function(t,e,n){"use strict";var r=n(0),i=n(1),o=n(10),a=n(27);r({target:"Date",proto:!0,forced:i((function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function(){return 1}})}))},{toJSON:function(t){var e=o(this),n=a(e);return"number"!=typeof n||isFinite(n)?e.toISOString():null}})},function(t,e,n){var r=n(0),i=n(305);r({target:"Date",proto:!0,forced:Date.prototype.toISOString!==i},{toISOString:i})},function(t,e,n){"use strict";var r=n(1),i=n(104).start,o=Math.abs,a=Date.prototype,c=a.getTime,s=a.toISOString;t.exports=r((function(){return"0385-07-25T07:06:39.999Z"!=s.call(new Date(-50000000000001))}))||!r((function(){s.call(new Date(NaN))}))?function(){if(!isFinite(c.call(this)))throw RangeError("Invalid time value");var t=this.getUTCFullYear(),e=this.getUTCMilliseconds(),n=t<0?"-":t>9999?"+":"";return n+i(o(t),n?6:4,0)+"-"+i(this.getUTCMonth()+1,2,0)+"-"+i(this.getUTCDate(),2,0)+"T"+i(this.getUTCHours(),2,0)+":"+i(this.getUTCMinutes(),2,0)+":"+i(this.getUTCSeconds(),2,0)+"."+i(e,3,0)+"Z"}:s},function(t,e,n){var r=n(14),i=Date.prototype,o=i.toString,a=i.getTime;new Date(NaN)+""!="Invalid Date"&&r(i,"toString",(function(){var t=a.call(this);return t==t?o.call(this):"Invalid Date"}))},function(t,e,n){var r=n(16),i=n(308),o=n(6)("toPrimitive"),a=Date.prototype;o in a||r(a,o,i)},function(t,e,n){"use strict";var r=n(4),i=n(27);t.exports=function(t){if("string"!==t&&"number"!==t&&"default"!==t)throw TypeError("Incorrect hint");return i(r(this),"number"!==t)}},function(t,e,n){var r=n(0),i=n(25),o=n(1),a=i("JSON","stringify"),c=/[\uD800-\uDFFF]/g,s=/^[\uD800-\uDBFF]$/,u=/^[\uDC00-\uDFFF]$/,l=function(t,e,n){var r=n.charAt(e-1),i=n.charAt(e+1);return s.test(t)&&!u.test(i)||u.test(t)&&!s.test(r)?"\\u"+t.charCodeAt(0).toString(16):t},f=o((function(){return'"\\udf06\\ud834"'!==a("\udf06\ud834")||'"\\udead"'!==a("\udead")}));a&&r({target:"JSON",stat:!0,forced:f},{stringify:function(t,e,n){var r=a.apply(null,arguments);return"string"==typeof r?r.replace(c,l):r}})},function(t,e,n){var r=n(2);n(30)(r.JSON,"JSON",!0)},function(t,e,n){"use strict";var r=n(0),i=n(19),o=n(99),a=n(155),c=n(48);r({target:"Promise",stat:!0},{allSettled:function(t){var e=this,n=o.f(e),r=n.resolve,s=n.reject,u=a((function(){var n=i(e.resolve),o=[],a=0,s=1;c(t,(function(t){var i=a++,c=!1;o.push(void 0),s++,n.call(e,t).then((function(t){c||(c=!0,o[i]={status:"fulfilled",value:t},--s||r(o))}),(function(t){c||(c=!0,o[i]={status:"rejected",reason:t},--s||r(o))}))})),--s||r(o)}));return u.error&&s(u.value),n.promise}})},function(t,e,n){"use strict";var r=n(0),i=n(28),o=n(151),a=n(1),c=n(25),s=n(33),u=n(154),l=n(14);r({target:"Promise",proto:!0,real:!0,forced:!!o&&a((function(){o.prototype.finally.call({then:function(){}},(function(){}))}))},{finally:function(t){var e=s(this,c("Promise")),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then((function(){return n}))}:t,n?function(n){return u(e,t()).then((function(){throw n}))}:t)}}),i||"function"!=typeof o||o.prototype.finally||l(o.prototype,"finally",c("Promise").prototype.finally)},function(t,e,n){"use strict";var r=n(81),i=n(177);t.exports=r("Map",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),i)},function(t,e,n){"use strict";var r=n(81),i=n(177);t.exports=r("Set",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),i)},function(t,e,n){"use strict";var r,i=n(2),o=n(46),a=n(44),c=n(81),s=n(178),u=n(3),l=n(17).enforce,f=n(113),h=!i.ActiveXObject&&"ActiveXObject"in i,d=Object.isExtensible,p=function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}},g=t.exports=c("WeakMap",p,s);if(f&&h){r=s.getConstructor(p,"WeakMap",!0),a.REQUIRED=!0;var v=g.prototype,y=v.delete,m=v.has,b=v.get,E=v.set;o(v,{delete:function(t){if(u(t)&&!d(t)){var e=l(this);return e.frozen||(e.frozen=new r),y.call(this,t)||e.frozen.delete(t)}return y.call(this,t)},has:function(t){if(u(t)&&!d(t)){var e=l(this);return e.frozen||(e.frozen=new r),m.call(this,t)||e.frozen.has(t)}return m.call(this,t)},get:function(t){if(u(t)&&!d(t)){var e=l(this);return e.frozen||(e.frozen=new r),m.call(this,t)?b.call(this,t):e.frozen.get(t)}return b.call(this,t)},set:function(t,e){if(u(t)&&!d(t)){var n=l(this);n.frozen||(n.frozen=new r),m.call(this,t)?E.call(this,t,e):n.frozen.set(t,e)}else E.call(this,t,e);return this}})}},function(t,e,n){"use strict";n(81)("WeakSet",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),n(178))},function(t,e,n){"use strict";var r=n(0),i=n(2),o=n(82),a=n(47),c=o.ArrayBuffer;r({global:!0,forced:i.ArrayBuffer!==c},{ArrayBuffer:c}),a("ArrayBuffer")},function(t,e){var n=Math.abs,r=Math.pow,i=Math.floor,o=Math.log,a=Math.LN2;t.exports={pack:function(t,e,c){var s,u,l,f=new Array(c),h=8*c-e-1,d=(1<<h)-1,p=d>>1,g=23===e?r(2,-24)-r(2,-77):0,v=t<0||0===t&&1/t<0?1:0,y=0;for((t=n(t))!=t||t===1/0?(u=t!=t?1:0,s=d):(s=i(o(t)/a),t*(l=r(2,-s))<1&&(s--,l*=2),(t+=s+p>=1?g/l:g*r(2,1-p))*l>=2&&(s++,l/=2),s+p>=d?(u=0,s=d):s+p>=1?(u=(t*l-1)*r(2,e),s+=p):(u=t*r(2,p-1)*r(2,e),s=0));e>=8;f[y++]=255&u,u/=256,e-=8);for(s=s<<e|u,h+=e;h>0;f[y++]=255&s,s/=256,h-=8);return f[--y]|=128*v,f},unpack:function(t,e){var n,i=t.length,o=8*i-e-1,a=(1<<o)-1,c=a>>1,s=o-7,u=i-1,l=t[u--],f=127&l;for(l>>=7;s>0;f=256*f+t[u],u--,s-=8);for(n=f&(1<<-s)-1,f>>=-s,s+=e;s>0;n=256*n+t[u],u--,s-=8);if(0===f)f=1-c;else{if(f===a)return n?NaN:l?-1/0:1/0;n+=r(2,e),f-=c}return(l?-1:1)*n*r(2,f-e)}}},function(t,e,n){var r=n(0),i=n(8);r({target:"ArrayBuffer",stat:!0,forced:!i.NATIVE_ARRAY_BUFFER_VIEWS},{isView:i.isView})},function(t,e,n){"use strict";var r=n(0),i=n(1),o=n(82),a=n(4),c=n(36),s=n(7),u=n(33),l=o.ArrayBuffer,f=o.DataView,h=l.prototype.slice;r({target:"ArrayBuffer",proto:!0,unsafe:!0,forced:i((function(){return!new l(2).slice(1,void 0).byteLength}))},{slice:function(t,e){if(void 0!==h&&void 0===e)return h.call(a(this),t);for(var n=a(this).byteLength,r=c(t,n),i=c(void 0===e?n:e,n),o=new(u(this,l))(s(i-r)),d=new f(this),p=new f(o),g=0;r<i;)p.setUint8(g++,d.getUint8(r++));return o}})},function(t,e,n){var r=n(0),i=n(82);r({global:!0,forced:!n(108)},{DataView:i.DataView})},function(t,e,n){n(34)("Int8",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){var r=n(26);t.exports=function(t){var e=r(t);if(e<0)throw RangeError("The argument can't be less than 0");return e}},function(t,e,n){n(34)("Uint8",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){n(34)("Uint8",(function(t){return function(e,n,r){return t(this,e,n,r)}}),!0)},function(t,e,n){n(34)("Int16",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){n(34)("Uint16",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){n(34)("Int32",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){n(34)("Uint32",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){n(34)("Float32",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){n(34)("Float64",(function(t){return function(e,n,r){return t(this,e,n,r)}}))},function(t,e,n){"use strict";var r=n(109);(0,n(8).exportTypedArrayStaticMethod)("from",n(181),r)},function(t,e,n){"use strict";var r=n(8),i=n(109),o=r.aTypedArrayConstructor;(0,r.exportTypedArrayStaticMethod)("of",(function(){for(var t=0,e=arguments.length,n=new(o(this))(e);e>t;)n[t]=arguments[t++];return n}),i)},function(t,e,n){"use strict";var r=n(8),i=n(168),o=r.aTypedArray;(0,r.exportTypedArrayMethod)("copyWithin",(function(t,e){return i.call(o(this),t,e,arguments.length>2?arguments[2]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=n(12).every,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("every",(function(t){return i(o(this),t,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=n(103),o=r.aTypedArray;(0,r.exportTypedArrayMethod)("fill",(function(t){return i.apply(o(this),arguments)}))},function(t,e,n){"use strict";var r=n(8),i=n(12).filter,o=n(33),a=r.aTypedArray,c=r.aTypedArrayConstructor;(0,r.exportTypedArrayMethod)("filter",(function(t){for(var e=i(a(this),t,arguments.length>1?arguments[1]:void 0),n=o(this,this.constructor),r=0,s=e.length,u=new(c(n))(s);s>r;)u[r]=e[r++];return u}))},function(t,e,n){"use strict";var r=n(8),i=n(12).find,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("find",(function(t){return i(o(this),t,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=n(12).findIndex,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("findIndex",(function(t){return i(o(this),t,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=n(12).forEach,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("forEach",(function(t){i(o(this),t,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=n(53).includes,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("includes",(function(t){return i(o(this),t,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=n(53).indexOf,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("indexOf",(function(t){return i(o(this),t,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(2),i=n(8),o=n(61),a=n(6)("iterator"),c=r.Uint8Array,s=o.values,u=o.keys,l=o.entries,f=i.aTypedArray,h=i.exportTypedArrayMethod,d=c&&c.prototype[a],p=!!d&&("values"==d.name||null==d.name),g=function(){return s.call(f(this))};h("entries",(function(){return l.call(f(this))})),h("keys",(function(){return u.call(f(this))})),h("values",g,!p),h(a,g,!p)},function(t,e,n){"use strict";var r=n(8),i=r.aTypedArray,o=r.exportTypedArrayMethod,a=[].join;o("join",(function(t){return a.apply(i(this),arguments)}))},function(t,e,n){"use strict";var r=n(8),i=n(170),o=r.aTypedArray;(0,r.exportTypedArrayMethod)("lastIndexOf",(function(t){return i.apply(o(this),arguments)}))},function(t,e,n){"use strict";var r=n(8),i=n(12).map,o=n(33),a=r.aTypedArray,c=r.aTypedArrayConstructor;(0,r.exportTypedArrayMethod)("map",(function(t){return i(a(this),t,arguments.length>1?arguments[1]:void 0,(function(t,e){return new(c(o(t,t.constructor)))(e)}))}))},function(t,e,n){"use strict";var r=n(8),i=n(68).left,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("reduce",(function(t){return i(o(this),t,arguments.length,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=n(68).right,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("reduceRight",(function(t){return i(o(this),t,arguments.length,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=r.aTypedArray,o=r.exportTypedArrayMethod,a=Math.floor;o("reverse",(function(){for(var t,e=i(this).length,n=a(e/2),r=0;r<n;)t=this[r],this[r++]=this[--e],this[e]=t;return this}))},function(t,e,n){"use strict";var r=n(8),i=n(7),o=n(180),a=n(10),c=n(1),s=r.aTypedArray;(0,r.exportTypedArrayMethod)("set",(function(t){s(this);var e=o(arguments.length>1?arguments[1]:void 0,1),n=this.length,r=a(t),c=i(r.length),u=0;if(c+e>n)throw RangeError("Wrong length");for(;u<c;)this[e+u]=r[u++]}),c((function(){new Int8Array(1).set({})})))},function(t,e,n){"use strict";var r=n(8),i=n(33),o=n(1),a=r.aTypedArray,c=r.aTypedArrayConstructor,s=r.exportTypedArrayMethod,u=[].slice;s("slice",(function(t,e){for(var n=u.call(a(this),t,e),r=i(this,this.constructor),o=0,s=n.length,l=new(c(r))(s);s>o;)l[o]=n[o++];return l}),o((function(){new Int8Array(1).slice()})))},function(t,e,n){"use strict";var r=n(8),i=n(12).some,o=r.aTypedArray;(0,r.exportTypedArrayMethod)("some",(function(t){return i(o(this),t,arguments.length>1?arguments[1]:void 0)}))},function(t,e,n){"use strict";var r=n(8),i=r.aTypedArray,o=r.exportTypedArrayMethod,a=[].sort;o("sort",(function(t){return a.call(i(this),t)}))},function(t,e,n){"use strict";var r=n(8),i=n(7),o=n(36),a=n(33),c=r.aTypedArray;(0,r.exportTypedArrayMethod)("subarray",(function(t,e){var n=c(this),r=n.length,s=o(t,r);return new(a(n,n.constructor))(n.buffer,n.byteOffset+s*n.BYTES_PER_ELEMENT,i((void 0===e?r:o(e,r))-s))}))},function(t,e,n){"use strict";var r=n(2),i=n(8),o=n(1),a=r.Int8Array,c=i.aTypedArray,s=i.exportTypedArrayMethod,u=[].toLocaleString,l=[].slice,f=!!a&&o((function(){u.call(new a(1))}));s("toLocaleString",(function(){return u.apply(f?l.call(c(this)):c(this),arguments)}),o((function(){return[1,2].toLocaleString()!=new a([1,2]).toLocaleString()}))||!o((function(){a.prototype.toLocaleString.call([1,2])})))},function(t,e,n){"use strict";var r=n(8).exportTypedArrayMethod,i=n(1),o=n(2).Uint8Array,a=o&&o.prototype||{},c=[].toString,s=[].join;i((function(){c.call({})}))&&(c=function(){return s.call(this)});var u=a.toString!=c;r("toString",c,u)},function(t,e,n){var r=n(0),i=n(25),o=n(19),a=n(4),c=n(1),s=i("Reflect","apply"),u=Function.apply;r({target:"Reflect",stat:!0,forced:!c((function(){s((function(){}))}))},{apply:function(t,e,n){return o(t),a(n),s?s(t,e,n):u.call(t,e,n)}})},function(t,e,n){var r=n(0),i=n(5),o=n(4),a=n(27),c=n(9);r({target:"Reflect",stat:!0,forced:n(1)((function(){Reflect.defineProperty(c.f({},1,{value:1}),1,{value:2})})),sham:!i},{defineProperty:function(t,e,n){o(t);var r=a(e,!0);o(n);try{return c.f(t,r,n),!0}catch(t){return!1}}})},function(t,e,n){var r=n(0),i=n(4),o=n(13).f;r({target:"Reflect",stat:!0},{deleteProperty:function(t,e){var n=o(i(t),e);return!(n&&!n.configurable)&&delete t[e]}})},function(t,e,n){var r=n(0),i=n(3),o=n(4),a=n(11),c=n(13),s=n(29);r({target:"Reflect",stat:!0},{get:function t(e,n){var r,u,l=arguments.length<3?e:arguments[2];return o(e)===l?e[n]:(r=c.f(e,n))?a(r,"value")?r.value:void 0===r.get?void 0:r.get.call(l):i(u=s(e))?t(u,n,l):void 0}})},function(t,e,n){var r=n(0),i=n(5),o=n(4),a=n(13);r({target:"Reflect",stat:!0,sham:!i},{getOwnPropertyDescriptor:function(t,e){return a.f(o(t),e)}})},function(t,e,n){var r=n(0),i=n(4),o=n(29);r({target:"Reflect",stat:!0,sham:!n(97)},{getPrototypeOf:function(t){return o(i(t))}})},function(t,e,n){n(0)({target:"Reflect",stat:!0},{has:function(t,e){return e in t}})},function(t,e,n){var r=n(0),i=n(4),o=Object.isExtensible;r({target:"Reflect",stat:!0},{isExtensible:function(t){return i(t),!o||o(t)}})},function(t,e,n){n(0)({target:"Reflect",stat:!0},{ownKeys:n(87)})},function(t,e,n){var r=n(0),i=n(25),o=n(4);r({target:"Reflect",stat:!0,sham:!n(63)},{preventExtensions:function(t){o(t);try{var e=i("Object","preventExtensions");return e&&e(t),!0}catch(t){return!1}}})},function(t,e,n){var r=n(0),i=n(4),o=n(3),a=n(11),c=n(1),s=n(9),u=n(13),l=n(29),f=n(35);r({target:"Reflect",stat:!0,forced:c((function(){var t=s.f({},"a",{configurable:!0});return!1!==Reflect.set(l(t),"a",1,t)}))},{set:function t(e,n,r){var c,h,d=arguments.length<4?e:arguments[3],p=u.f(i(e),n);if(!p){if(o(h=l(e)))return t(h,n,r,d);p=f(0)}if(a(p,"value")){if(!1===p.writable||!o(d))return!1;if(c=u.f(d,n)){if(c.get||c.set||!1===c.writable)return!1;c.value=r,s.f(d,n,c)}else s.f(d,n,f(0,r));return!0}return void 0!==p.set&&(p.set.call(d,r),!0)}})},function(t,e,n){var r=n(0),i=n(4),o=n(134),a=n(43);a&&r({target:"Reflect",stat:!0},{setPrototypeOf:function(t,e){i(t),o(e);try{return a(t,e),!0}catch(t){return!1}}})},function(t,e,n){n(163),n(165),n(370),n(371),n(372),n(373),n(376),n(183);var r=n(52);t.exports=r},function(t,e,n){var r=n(0),i=n(2),o=n(98);r({global:!0,bind:!0,enumerable:!0,forced:!i.setImmediate||!i.clearImmediate},{setImmediate:o.set,clearImmediate:o.clear})},function(t,e,n){var r=n(0),i=n(2),o=n(153),a=n(24),c=i.process,s="process"==a(c);r({global:!0,enumerable:!0,noTargetGet:!0},{queueMicrotask:function(t){var e=s&&c.domain;o(e?e.bind(t):t)}})},function(t,e,n){var r=n(0),i=n(2),o=n(66),a=[].slice,c=function(t){return function(e,n){var r=arguments.length>2,i=r?a.call(arguments,2):void 0;return t(r?function(){("function"==typeof e?e:Function(e)).apply(this,i)}:e,n)}};r({global:!0,bind:!0,forced:/MSIE .\./.test(o)},{setTimeout:c(i.setTimeout),setInterval:c(i.setInterval)})},function(t,e,n){"use strict";n(102);var r,i=n(0),o=n(5),a=n(182),c=n(2),s=n(91),u=n(14),l=n(39),f=n(11),h=n(143),d=n(129),p=n(75).codeAt,g=n(374),v=n(30),y=n(183),m=n(17),b=c.URL,E=y.URLSearchParams,w=y.getState,_=m.set,S=m.getterFor("URL"),T=Math.floor,I=Math.pow,x=/[A-Za-z]/,O=/[\d+-.A-Za-z]/,k=/\d/,M=/^(0x|0X)/,N=/^[0-7]+$/,R=/^\d+$/,A=/^[\dA-Fa-f]+$/,D=/[\u0000\u0009\u000A\u000D #%/:?@[\\]]/,$=/[\u0000\u0009\u000A\u000D #/:?@[\\]]/,L=/^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,j=/[\u0009\u000A\u000D]/g,P=function(t,e){var n,r,i;if("["==e.charAt(0)){if("]"!=e.charAt(e.length-1))return"Invalid host";if(!(n=F(e.slice(1,-1))))return"Invalid host";t.host=n}else if(B(t)){if(e=g(e),D.test(e))return"Invalid host";if(null===(n=C(e)))return"Invalid host";t.host=n}else{if($.test(e))return"Invalid host";for(n="",r=d(e),i=0;i<r.length;i++)n+=H(r[i],V);t.host=n}},C=function(t){var e,n,r,i,o,a,c,s=t.split(".");if(s.length&&""==s[s.length-1]&&s.pop(),(e=s.length)>4)return t;for(n=[],r=0;r<e;r++){if(""==(i=s[r]))return t;if(o=10,i.length>1&&"0"==i.charAt(0)&&(o=M.test(i)?16:8,i=i.slice(8==o?1:2)),""===i)a=0;else{if(!(10==o?R:8==o?N:A).test(i))return t;a=parseInt(i,o)}n.push(a)}for(r=0;r<e;r++)if(a=n[r],r==e-1){if(a>=I(256,5-e))return null}else if(a>255)return null;for(c=n.pop(),r=0;r<n.length;r++)c+=n[r]*I(256,3-r);return c},F=function(t){var e,n,r,i,o,a,c,s=[0,0,0,0,0,0,0,0],u=0,l=null,f=0,h=function(){return t.charAt(f)};if(":"==h()){if(":"!=t.charAt(1))return;f+=2,l=++u}for(;h();){if(8==u)return;if(":"!=h()){for(e=n=0;n<4&&A.test(h());)e=16*e+parseInt(h(),16),f++,n++;if("."==h()){if(0==n)return;if(f-=n,u>6)return;for(r=0;h();){if(i=null,r>0){if(!("."==h()&&r<4))return;f++}if(!k.test(h()))return;for(;k.test(h());){if(o=parseInt(h(),10),null===i)i=o;else{if(0==i)return;i=10*i+o}if(i>255)return;f++}s[u]=256*s[u]+i,2!=++r&&4!=r||u++}if(4!=r)return;break}if(":"==h()){if(f++,!h())return}else if(h())return;s[u++]=e}else{if(null!==l)return;f++,l=++u}}if(null!==l)for(a=u-l,u=7;0!=u&&a>0;)c=s[u],s[u--]=s[l+a-1],s[l+--a]=c;else if(8!=u)return;return s},U=function(t){var e,n,r,i;if("number"==typeof t){for(e=[],n=0;n<4;n++)e.unshift(t%256),t=T(t/256);return e.join(".")}if("object"==typeof t){for(e="",r=function(t){for(var e=null,n=1,r=null,i=0,o=0;o<8;o++)0!==t[o]?(i>n&&(e=r,n=i),r=null,i=0):(null===r&&(r=o),++i);return i>n&&(e=r,n=i),e}(t),n=0;n<8;n++)i&&0===t[n]||(i&&(i=!1),r===n?(e+=n?":":"::",i=!0):(e+=t[n].toString(16),n<7&&(e+=":")));return"["+e+"]"}return t},V={},z=h({},V,{" ":1,'"':1,"<":1,">":1,"`":1}),Y=h({},z,{"#":1,"?":1,"{":1,"}":1}),W=h({},Y,{"/":1,":":1,";":1,"=":1,"@":1,"[":1,"\\":1,"]":1,"^":1,"|":1}),H=function(t,e){var n=p(t,0);return n>32&&n<127&&!f(e,t)?t:encodeURIComponent(t)},G={ftp:21,file:null,http:80,https:443,ws:80,wss:443},B=function(t){return f(G,t.scheme)},q=function(t){return""!=t.username||""!=t.password},X=function(t){return!t.host||t.cannotBeABaseURL||"file"==t.scheme},Z=function(t,e){var n;return 2==t.length&&x.test(t.charAt(0))&&(":"==(n=t.charAt(1))||!e&&"|"==n)},K=function(t){var e;return t.length>1&&Z(t.slice(0,2))&&(2==t.length||"/"===(e=t.charAt(2))||"\\"===e||"?"===e||"#"===e)},J=function(t){var e=t.path,n=e.length;!n||"file"==t.scheme&&1==n&&Z(e[0],!0)||e.pop()},Q=function(t){return"."===t||"%2e"===t.toLowerCase()},tt={},et={},nt={},rt={},it={},ot={},at={},ct={},st={},ut={},lt={},ft={},ht={},dt={},pt={},gt={},vt={},yt={},mt={},bt={},Et={},wt=function(t,e,n,i){var o,a,c,s,u,l=n||tt,h=0,p="",g=!1,v=!1,y=!1;for(n||(t.scheme="",t.username="",t.password="",t.host=null,t.port=null,t.path=[],t.query=null,t.fragment=null,t.cannotBeABaseURL=!1,e=e.replace(L,"")),e=e.replace(j,""),o=d(e);h<=o.length;){switch(a=o[h],l){case tt:if(!a||!x.test(a)){if(n)return"Invalid scheme";l=nt;continue}p+=a.toLowerCase(),l=et;break;case et:if(a&&(O.test(a)||"+"==a||"-"==a||"."==a))p+=a.toLowerCase();else{if(":"!=a){if(n)return"Invalid scheme";p="",l=nt,h=0;continue}if(n&&(B(t)!=f(G,p)||"file"==p&&(q(t)||null!==t.port)||"file"==t.scheme&&!t.host))return;if(t.scheme=p,n)return void(B(t)&&G[t.scheme]==t.port&&(t.port=null));p="","file"==t.scheme?l=dt:B(t)&&i&&i.scheme==t.scheme?l=rt:B(t)?l=ct:"/"==o[h+1]?(l=it,h++):(t.cannotBeABaseURL=!0,t.path.push(""),l=mt)}break;case nt:if(!i||i.cannotBeABaseURL&&"#"!=a)return"Invalid scheme";if(i.cannotBeABaseURL&&"#"==a){t.scheme=i.scheme,t.path=i.path.slice(),t.query=i.query,t.fragment="",t.cannotBeABaseURL=!0,l=Et;break}l="file"==i.scheme?dt:ot;continue;case rt:if("/"!=a||"/"!=o[h+1]){l=ot;continue}l=st,h++;break;case it:if("/"==a){l=ut;break}l=yt;continue;case ot:if(t.scheme=i.scheme,a==r)t.username=i.username,t.password=i.password,t.host=i.host,t.port=i.port,t.path=i.path.slice(),t.query=i.query;else if("/"==a||"\\"==a&&B(t))l=at;else if("?"==a)t.username=i.username,t.password=i.password,t.host=i.host,t.port=i.port,t.path=i.path.slice(),t.query="",l=bt;else{if("#"!=a){t.username=i.username,t.password=i.password,t.host=i.host,t.port=i.port,t.path=i.path.slice(),t.path.pop(),l=yt;continue}t.username=i.username,t.password=i.password,t.host=i.host,t.port=i.port,t.path=i.path.slice(),t.query=i.query,t.fragment="",l=Et}break;case at:if(!B(t)||"/"!=a&&"\\"!=a){if("/"!=a){t.username=i.username,t.password=i.password,t.host=i.host,t.port=i.port,l=yt;continue}l=ut}else l=st;break;case ct:if(l=st,"/"!=a||"/"!=p.charAt(h+1))continue;h++;break;case st:if("/"!=a&&"\\"!=a){l=ut;continue}break;case ut:if("@"==a){g&&(p="%40"+p),g=!0,c=d(p);for(var m=0;m<c.length;m++){var b=c[m];if(":"!=b||y){var E=H(b,W);y?t.password+=E:t.username+=E}else y=!0}p=""}else if(a==r||"/"==a||"?"==a||"#"==a||"\\"==a&&B(t)){if(g&&""==p)return"Invalid authority";h-=d(p).length+1,p="",l=lt}else p+=a;break;case lt:case ft:if(n&&"file"==t.scheme){l=gt;continue}if(":"!=a||v){if(a==r||"/"==a||"?"==a||"#"==a||"\\"==a&&B(t)){if(B(t)&&""==p)return"Invalid host";if(n&&""==p&&(q(t)||null!==t.port))return;if(s=P(t,p))return s;if(p="",l=vt,n)return;continue}"["==a?v=!0:"]"==a&&(v=!1),p+=a}else{if(""==p)return"Invalid host";if(s=P(t,p))return s;if(p="",l=ht,n==ft)return}break;case ht:if(!k.test(a)){if(a==r||"/"==a||"?"==a||"#"==a||"\\"==a&&B(t)||n){if(""!=p){var w=parseInt(p,10);if(w>65535)return"Invalid port";t.port=B(t)&&w===G[t.scheme]?null:w,p=""}if(n)return;l=vt;continue}return"Invalid port"}p+=a;break;case dt:if(t.scheme="file","/"==a||"\\"==a)l=pt;else{if(!i||"file"!=i.scheme){l=yt;continue}if(a==r)t.host=i.host,t.path=i.path.slice(),t.query=i.query;else if("?"==a)t.host=i.host,t.path=i.path.slice(),t.query="",l=bt;else{if("#"!=a){K(o.slice(h).join(""))||(t.host=i.host,t.path=i.path.slice(),J(t)),l=yt;continue}t.host=i.host,t.path=i.path.slice(),t.query=i.query,t.fragment="",l=Et}}break;case pt:if("/"==a||"\\"==a){l=gt;break}i&&"file"==i.scheme&&!K(o.slice(h).join(""))&&(Z(i.path[0],!0)?t.path.push(i.path[0]):t.host=i.host),l=yt;continue;case gt:if(a==r||"/"==a||"\\"==a||"?"==a||"#"==a){if(!n&&Z(p))l=yt;else if(""==p){if(t.host="",n)return;l=vt}else{if(s=P(t,p))return s;if("localhost"==t.host&&(t.host=""),n)return;p="",l=vt}continue}p+=a;break;case vt:if(B(t)){if(l=yt,"/"!=a&&"\\"!=a)continue}else if(n||"?"!=a)if(n||"#"!=a){if(a!=r&&(l=yt,"/"!=a))continue}else t.fragment="",l=Et;else t.query="",l=bt;break;case yt:if(a==r||"/"==a||"\\"==a&&B(t)||!n&&("?"==a||"#"==a)){if(".."===(u=(u=p).toLowerCase())||"%2e."===u||".%2e"===u||"%2e%2e"===u?(J(t),"/"==a||"\\"==a&&B(t)||t.path.push("")):Q(p)?"/"==a||"\\"==a&&B(t)||t.path.push(""):("file"==t.scheme&&!t.path.length&&Z(p)&&(t.host&&(t.host=""),p=p.charAt(0)+":"),t.path.push(p)),p="","file"==t.scheme&&(a==r||"?"==a||"#"==a))for(;t.path.length>1&&""===t.path[0];)t.path.shift();"?"==a?(t.query="",l=bt):"#"==a&&(t.fragment="",l=Et)}else p+=H(a,Y);break;case mt:"?"==a?(t.query="",l=bt):"#"==a?(t.fragment="",l=Et):a!=r&&(t.path[0]+=H(a,V));break;case bt:n||"#"!=a?a!=r&&("'"==a&&B(t)?t.query+="%27":t.query+="#"==a?"%23":H(a,V)):(t.fragment="",l=Et);break;case Et:a!=r&&(t.fragment+=H(a,z))}h++}},_t=function(t){var e,n,r=l(this,_t,"URL"),i=arguments.length>1?arguments[1]:void 0,a=String(t),c=_(r,{type:"URL"});if(void 0!==i)if(i instanceof _t)e=S(i);else if(n=wt(e={},String(i)))throw TypeError(n);if(n=wt(c,a,null,e))throw TypeError(n);var s=c.searchParams=new E,u=w(s);u.updateSearchParams(c.query),u.updateURL=function(){c.query=String(s)||null},o||(r.href=Tt.call(r),r.origin=It.call(r),r.protocol=xt.call(r),r.username=Ot.call(r),r.password=kt.call(r),r.host=Mt.call(r),r.hostname=Nt.call(r),r.port=Rt.call(r),r.pathname=At.call(r),r.search=Dt.call(r),r.searchParams=$t.call(r),r.hash=Lt.call(r))},St=_t.prototype,Tt=function(){var t=S(this),e=t.scheme,n=t.username,r=t.password,i=t.host,o=t.port,a=t.path,c=t.query,s=t.fragment,u=e+":";return null!==i?(u+="//",q(t)&&(u+=n+(r?":"+r:"")+"@"),u+=U(i),null!==o&&(u+=":"+o)):"file"==e&&(u+="//"),u+=t.cannotBeABaseURL?a[0]:a.length?"/"+a.join("/"):"",null!==c&&(u+="?"+c),null!==s&&(u+="#"+s),u},It=function(){var t=S(this),e=t.scheme,n=t.port;if("blob"==e)try{return new URL(e.path[0]).origin}catch(t){return"null"}return"file"!=e&&B(t)?e+"://"+U(t.host)+(null!==n?":"+n:""):"null"},xt=function(){return S(this).scheme+":"},Ot=function(){return S(this).username},kt=function(){return S(this).password},Mt=function(){var t=S(this),e=t.host,n=t.port;return null===e?"":null===n?U(e):U(e)+":"+n},Nt=function(){var t=S(this).host;return null===t?"":U(t)},Rt=function(){var t=S(this).port;return null===t?"":String(t)},At=function(){var t=S(this),e=t.path;return t.cannotBeABaseURL?e[0]:e.length?"/"+e.join("/"):""},Dt=function(){var t=S(this).query;return t?"?"+t:""},$t=function(){return S(this).searchParams},Lt=function(){var t=S(this).fragment;return t?"#"+t:""},jt=function(t,e){return{get:t,set:e,configurable:!0,enumerable:!0}};if(o&&s(St,{href:jt(Tt,(function(t){var e=S(this),n=String(t),r=wt(e,n);if(r)throw TypeError(r);w(e.searchParams).updateSearchParams(e.query)})),origin:jt(It),protocol:jt(xt,(function(t){var e=S(this);wt(e,String(t)+":",tt)})),username:jt(Ot,(function(t){var e=S(this),n=d(String(t));if(!X(e)){e.username="";for(var r=0;r<n.length;r++)e.username+=H(n[r],W)}})),password:jt(kt,(function(t){var e=S(this),n=d(String(t));if(!X(e)){e.password="";for(var r=0;r<n.length;r++)e.password+=H(n[r],W)}})),host:jt(Mt,(function(t){var e=S(this);e.cannotBeABaseURL||wt(e,String(t),lt)})),hostname:jt(Nt,(function(t){var e=S(this);e.cannotBeABaseURL||wt(e,String(t),ft)})),port:jt(Rt,(function(t){var e=S(this);X(e)||(""==(t=String(t))?e.port=null:wt(e,t,ht))})),pathname:jt(At,(function(t){var e=S(this);e.cannotBeABaseURL||(e.path=[],wt(e,t+"",vt))})),search:jt(Dt,(function(t){var e=S(this);""==(t=String(t))?e.query=null:("?"==t.charAt(0)&&(t=t.slice(1)),e.query="",wt(e,t,bt)),w(e.searchParams).updateSearchParams(e.query)})),searchParams:jt($t),hash:jt(Lt,(function(t){var e=S(this);""!=(t=String(t))?("#"==t.charAt(0)&&(t=t.slice(1)),e.fragment="",wt(e,t,Et)):e.fragment=null}))}),u(St,"toJSON",(function(){return Tt.call(this)}),{enumerable:!0}),u(St,"toString",(function(){return Tt.call(this)}),{enumerable:!0}),b){var Pt=b.createObjectURL,Ct=b.revokeObjectURL;Pt&&u(_t,"createObjectURL",(function(t){return Pt.apply(b,arguments)})),Ct&&u(_t,"revokeObjectURL",(function(t){return Ct.apply(b,arguments)}))}v(_t,"URL"),i({global:!0,forced:!a,sham:!o},{URL:_t})},function(t,e,n){"use strict";var r=/[^\0-\u007E]/,i=/[.\u3002\uFF0E\uFF61]/g,o="Overflow: input needs wider integers to process",a=Math.floor,c=String.fromCharCode,s=function(t){return t+22+75*(t<26)},u=function(t,e,n){var r=0;for(t=n?a(t/700):t>>1,t+=a(t/e);t>455;r+=36)t=a(t/35);return a(r+36*t/(t+38))},l=function(t){var e,n,r=[],i=(t=function(t){for(var e=[],n=0,r=t.length;n<r;){var i=t.charCodeAt(n++);if(i>=55296&&i<=56319&&n<r){var o=t.charCodeAt(n++);56320==(64512&o)?e.push(((1023&i)<<10)+(1023&o)+65536):(e.push(i),n--)}else e.push(i)}return e}(t)).length,l=128,f=0,h=72;for(e=0;e<t.length;e++)(n=t[e])<128&&r.push(c(n));var d=r.length,p=d;for(d&&r.push("-");p<i;){var g=2147483647;for(e=0;e<t.length;e++)(n=t[e])>=l&&n<g&&(g=n);var v=p+1;if(g-l>a((2147483647-f)/v))throw RangeError(o);for(f+=(g-l)*v,l=g,e=0;e<t.length;e++){if((n=t[e])<l&&++f>2147483647)throw RangeError(o);if(n==l){for(var y=f,m=36;;m+=36){var b=m<=h?1:m>=h+26?26:m-h;if(y<b)break;var E=y-b,w=36-b;r.push(c(s(b+E%w))),y=a(E/w)}r.push(c(s(y))),h=u(f,v,p==d),f=0,++p}}++f,++l}return r.join("")};t.exports=function(t){var e,n,o=[],a=t.toLowerCase().replace(i,".").split(".");for(e=0;e<a.length;e++)n=a[e],o.push(r.test(n)?"xn--"+l(n):n);return o.join(".")}},function(t,e,n){var r=n(4),i=n(59);t.exports=function(t){var e=i(t);if("function"!=typeof e)throw TypeError(String(t)+" is not iterable");return r(e.call(t))}},function(t,e,n){"use strict";n(0)({target:"URL",proto:!0,enumerable:!0},{toJSON:function(){return URL.prototype.toString.call(this)}})}]);
},{}],46:[function(require,module,exports){
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this file,
 * You can obtain one at http://mozilla.org/MPL/2.0/. */

/*
 * flot-tickrotor: flot plugin to display angled X-axis tick labels.
 *
 * Requires flot 0.7 or higher and a browser supporting <canvas>.
 *
 * To activate, just set xaxis.rotateTicks to an angle in degrees.  Labels
 * are rotated clockwise, so if you want the labels to angle up and to the
 * right (/) you need to provide an angle > 90.  The text will be flipped so
 * that it is still right-side-up.
 * Angles greater than or equal to 180 are ignored.
 */
(function ($) {
    var options = { };

    function init(plot) {
        // Taken from flot-axislabels.
        // This is kind of a hack. There are no hooks in Flot between
        // the creation and measuring of the ticks (setTicks, measureTickLabels
        // in setupGrid() ) and the drawing of the ticks and plot box
        // (insertAxisLabels in setupGrid() ).
        //
        // Therefore, we use a trick where we run the draw routine twice:
        // the first time to get the tick measurements, so that we can change
        // them, and then have it draw it again.

        var ticks = [];  // preserve between draw() calls.
        var font;
        var secondPass = false;
        var rotateTicks, rotateTicksRads, radsAboveHoriz;

        plot.hooks.draw.push(function (plot, ctx) {
            var xaxis;  // for convenience
            if (!secondPass) {
                var opts = plot.getAxes().xaxis.options;
                if (opts.rotateTicks === undefined) {
                    return;
                }

                rotateTicks = parseInt(opts.rotateTicks, 10);
                if (rotateTicks.toString() != opts.rotateTicks || rotateTicks == 0 || rotateTicks >= 180) {
                    return;
                }

                rotateTicksRads = rotateTicks * Math.PI/180;
                if (rotateTicks > 90) {
                    radsAboveHoriz = Math.PI - rotateTicksRads;
                } else {
                    radsAboveHoriz = Math.PI/2 - rotateTicksRads;
                }

                font = opts.rotateTicksFont;
                if (!font) {
                    font = $('.tickLabel').css('font');
                }
                if (!font) {
                    font = 'smaller sans-serif';
                }

                var elem, maxLabelWidth = 0, maxLabelHeight = 0, minX = 0, maxX = 0;

                // We have to clear the ticks option so that flot core
                // doesn't draw ticks superimposed with ours, but we preserve
                // the tick data as xaxis.rotatedTicks so that external code
                // can still get to it.

                // FIXME: It would obviously be better to just interrupt
                // the drawing of the ticks and preserve the 'ticks'
                // property.  That probably requires another hook.

                xaxis = plot.getAxes().xaxis;
                ticks = plot.getAxes().xaxis.ticks;
                xaxis.rotatedTicks = ticks;
                opts.ticks = [];  // we'll make our own

                var x;
                for (var i = 0; i < ticks.length; i++) {
                  elem = $('<span style="font:' + font + '">' + ticks[i].label + '</span>');
                  plot.getPlaceholder().append(elem);
                  ticks[i].height = elem.outerHeight(true);
                  ticks[i].width = elem.outerWidth(true);
                  elem.remove();
                  if (ticks[i].height > maxLabelHeight) {
                      maxLabelHeight = ticks[i].height;
                  }
                  if (ticks[i].width > maxLabelWidth) {
                      maxLabelWidth = ticks[i].width;
                  }
                  var tick = ticks[i];
                  // See second-draw code below for explanation of offsets.
                  if (rotateTicks > 90) {
                      // See if any labels are too long and require increased left
                      // padding.
                      x = Math.round(plot.getPlotOffset().left + xaxis.p2c(tick.v))
                          - Math.ceil(Math.cos(radsAboveHoriz) * tick.height)
                          - Math.ceil(Math.cos(radsAboveHoriz) * tick.width);
                      if (x < minX) {
                          minX = x;
                      }
                  } else {
                      // See if any labels are too long and require increased right
                      // padding.
                      x = Math.round(plot.getPlotOffset().left + xaxis.p2c(tick.v))
                          + Math.ceil(Math.cos(radsAboveHoriz) * tick.height)
                          + Math.ceil(Math.cos(radsAboveHoriz) * tick.width);
                      if (x > maxX) {
                          maxX = x;
                      }
                  }
                }

                // Calculate maximum label height after rotating.
                if (rotateTicks > 90) {
                    var acuteRads = rotateTicksRads - Math.PI/2;
                    opts.labelHeight = Math.ceil(Math.sin(acuteRads) * maxLabelWidth)
                                       + Math.ceil(Math.sin(acuteRads) * maxLabelHeight);
                } else {
                    var acuteRads = Math.PI/2 - rotateTicksRads;
                    // Center such that the top of the label is at the center of the tick.
                    opts.labelHeight = Math.ceil(Math.sin(rotateTicksRads) * maxLabelWidth)
                                       + Math.ceil(Math.sin(acuteRads) * maxLabelHeight);
                }

                if (minX < 0) {
                  plot.getAxes().yaxis.options.labelWidth = -1 * minX;
                }

                // Doesn't seem to work if there are no values using the
                // second y axis.
                //if (maxX > xaxis.box.left + xaxis.box.width) {
                //  plot.getAxes().y2axis.options.labelWidth = maxX - xaxis.box.left - xaxis.box.width;
                //}

                // re-draw with new label widths and heights
                secondPass = true;
                plot.setupGrid();
                plot.draw();
            } else {
                if (ticks.length == 0) {
                    return;
                }
                xaxis = plot.getAxes().xaxis;
                var box = xaxis.box;
                var tick, label, xoffset, yoffset;
                for (var i = 0; i < ticks.length; i++) {
                    tick = ticks[i];
                    if (!tick.label) {
                        continue;
                    }
                    ctx.save();
                    ctx.font = font;
                    if (rotateTicks <= 90) {
                        // Center such that the top of the label is at the center of the tick.
                        xoffset = Math.ceil(Math.cos(radsAboveHoriz) * tick.height/2);
                        ctx.translate(plot.getPlotOffset().left + xaxis.p2c(tick.v) + xoffset,
                                      box.top + box.padding);
                        ctx.rotate(rotateTicksRads);
                    } else {
                        // We want the text to facing up, so we have to
                        // rotate counterclockwise, which means the label
                        // has to *end* at the center of the tick.
                        xoffset = -Math.ceil(Math.sin(radsAboveHoriz) * tick.height/2);
                        ctx.translate(plot.getPlotOffset().left + xaxis.p2c(tick.v) + xoffset,
                                      box.top + box.padding);
                        ctx.rotate(-radsAboveHoriz);
                        ctx.translate(-tick.width, 0);
                    }

                    ctx.textBaseline = 'middle';

                    ctx.fillText(tick.label, 0, tick.height / 2);
                    ctx.restore();
                }
            }
        });
    }

    $.plot.plugins.push({
        init: init,
        options: options,
        name: 'tickRotor',
        version: '1.0'
    });
})(jQuery);

},{}],47:[function(require,module,exports){
jQuery.fn.limitLength = function(maxChar) {
    return this.each(function() {
        jQuery(this).on('input', null, function (e) {
            const ele = e.target;
            const charLen = ele.value.length;
            let newlineCount = 0;

            for (let i = 0; i < charLen; i++) {
                // check if the \n character is present
                if (ele.value[i] === "\n") {
                    newlineCount += 1;
                }
            }

            const totalLength = charLen + newlineCount;
            if (totalLength <= maxChar) {
                return;
            }
            // truncate to fit
            ele.value = ele.value.substring(0, maxChar - newlineCount);
        });
    })
};

},{}],48:[function(require,module,exports){
/*!
 * jQuery Mousewheel 3.1.13
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 */

(function (factory) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS style for Browserify
        module.exports = factory;
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
        slice  = Array.prototype.slice,
        nullLowestDeltaTimeout, lowestDelta;

    if ( $.event.fixHooks ) {
        for ( var i = toFix.length; i; ) {
            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
        }
    }

    var special = $.event.special.mousewheel = {
        version: '3.1.12',

        setup: function() {
            if ( this.addEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.addEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = handler;
            }
            // Store the line height and page height for this particular element
            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
        },

        teardown: function() {
            if ( this.removeEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.removeEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = null;
            }
            // Clean up the data we added to the element
            $.removeData(this, 'mousewheel-line-height');
            $.removeData(this, 'mousewheel-page-height');
        },

        getLineHeight: function(elem) {
            var $elem = $(elem),
                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
            if (!$parent.length) {
                $parent = $('body');
            }
            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
        },

        getPageHeight: function(elem) {
            return $(elem).height();
        },

        settings: {
            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
            normalizeOffset: true  // calls getBoundingClientRect for each event
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
        },

        unmousewheel: function(fn) {
            return this.unbind('mousewheel', fn);
        }
    });


    function handler(event) {
        var orgEvent   = event || window.event,
            args       = slice.call(arguments, 1),
            delta      = 0,
            deltaX     = 0,
            deltaY     = 0,
            absDelta   = 0,
            offsetX    = 0,
            offsetY    = 0;
        event = $.event.fix(orgEvent);
        event.type = 'mousewheel';

        // Old school scrollwheel delta
        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }

        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
            deltaX = deltaY * -1;
            deltaY = 0;
        }

        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
        delta = deltaY === 0 ? deltaX : deltaY;

        // New school wheel delta (wheel event)
        if ( 'deltaY' in orgEvent ) {
            deltaY = orgEvent.deltaY * -1;
            delta  = deltaY;
        }
        if ( 'deltaX' in orgEvent ) {
            deltaX = orgEvent.deltaX;
            if ( deltaY === 0 ) { delta  = deltaX * -1; }
        }

        // No change actually happened, no reason to go any further
        if ( deltaY === 0 && deltaX === 0 ) { return; }

        // Need to convert lines and pages to pixels if we aren't already in pixels
        // There are three delta modes:
        //   * deltaMode 0 is by pixels, nothing to do
        //   * deltaMode 1 is by lines
        //   * deltaMode 2 is by pages
        if ( orgEvent.deltaMode === 1 ) {
            var lineHeight = $.data(this, 'mousewheel-line-height');
            delta  *= lineHeight;
            deltaY *= lineHeight;
            deltaX *= lineHeight;
        } else if ( orgEvent.deltaMode === 2 ) {
            var pageHeight = $.data(this, 'mousewheel-page-height');
            delta  *= pageHeight;
            deltaY *= pageHeight;
            deltaX *= pageHeight;
        }

        // Store lowest absolute delta to normalize the delta values
        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );

        if ( !lowestDelta || absDelta < lowestDelta ) {
            lowestDelta = absDelta;

            // Adjust older deltas if necessary
            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
                lowestDelta /= 40;
            }
        }

        // Adjust older deltas if necessary
        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
            // Divide all the things by 40!
            delta  /= 40;
            deltaX /= 40;
            deltaY /= 40;
        }

        // Get a whole, normalized value for the deltas
        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);

        // Normalise offsetX and offsetY properties
        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
            var boundingRect = this.getBoundingClientRect();
            offsetX = event.clientX - boundingRect.left;
            offsetY = event.clientY - boundingRect.top;
        }

        // Add information to the event object
        event.deltaX = deltaX;
        event.deltaY = deltaY;
        event.deltaFactor = lowestDelta;
        event.offsetX = offsetX;
        event.offsetY = offsetY;
        // Go ahead and set deltaMode to 0 since we converted to pixels
        // Although this is a little odd since we overwrite the deltaX/Y
        // properties with normalized deltas.
        event.deltaMode = 0;

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        // Clearout lowestDelta after sometime to better
        // handle multiple device types that give different
        // a different lowestDelta
        // Ex: trackpad = 3 and mouse wheel = 120
        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

    function nullLowestDelta() {
        lowestDelta = null;
    }

    function shouldAdjustOldDeltas(orgEvent, absDelta) {
        // If this is an older event and the delta is divisable by 120,
        // then we are assuming that the browser is treating this as an
        // older mouse wheel event and that we should divide the deltas
        // by 40 to try and get a more usable deltaFactor.
        // Side note, this actually impacts the reported scroll distance
        // in older browsers and can cause scrolling to be slower than native.
        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
    }

}));

},{}],49:[function(require,module,exports){
(function (global){(function (){
; var __browserify_shim_require__=require;(function browserifyShim(module, define, require) {
/*!
 * JavaScript Cookie v2.1.2
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	if (typeof define === 'function' && define.amd) {
		define(factory);
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
					attributes.path    && '; path=' + attributes.path,
					attributes.domain  && '; domain=' + attributes.domain,
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api(key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

}).call(global, module, undefined, undefined);

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],50:[function(require,module,exports){
/*!
 * Select2 4.0.0
 * https://select2.github.io
 *
 * Released under the MIT license
 * https://github.com/select2/select2/blob/master/LICENSE.md
 */
jQuery      = require('jquery');
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function (jQuery) {
  // This is needed so we can catch the AMD loader configuration and use it
  // The inner file should be wrapped (by `banner.start.js`) in a function that
  // returns the AMD loader references.
  var S2 =
(function () {
  // Restore the Select2 AMD loader so it can be used
  // Needed mostly in the language files, where the loader is not inserted
  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
    var S2 = jQuery.fn.select2.amd;
  }
var S2;(function () { if (!S2 || !S2.requirejs) {
if (!S2) { S2 = {}; } else { require = S2; }
/**
 * @license almond 0.2.9 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*jslint sloppy: true */
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name && name.charAt(0) === ".") {
            //If have a base name, try to normalize against it,
            //otherwise, assume it is a top-level require that will
            //be relative to baseUrl in the end.
            if (baseName) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that "directory" and not name of the baseName's
                //module. For instance, baseName of "one/two/three", maps to
                //"one/two/three.js", but we want the directory, "one/two" for
                //this normalization.
                baseParts = baseParts.slice(0, baseParts.length - 1);
                name = name.split('/');
                lastIndex = name.length - 1;

                // Node .js allowance:
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                name = baseParts.concat(name);

                //start trimDots
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                            //End of the line. Keep at least one non-dot
                            //path segment at the front so it can be mapped
                            //correctly to disk. Otherwise, there is likely
                            //no path mapping for a path starting with '..'.
                            //This can still fail, but catches the most reasonable
                            //uses of ..
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                //end trimDots

                name = name.join("/");
            } else if (name.indexOf('./') === 0) {
                // No baseName, so this is ID is resolved relative
                // to baseUrl, pull off the leading dot.
                name = name.substring(2);
            }
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            return req.apply(undef, aps.call(arguments, 0).concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

S2.requirejs = requirejs;S2.require = require;S2.define = define;
}
}());
S2.define("almond", function(){});

/* global jQuery:false, $:false */
S2.define('jquery',[],function () {
  var _$ = jQuery || $;

  if (_$ == null && console && console.error) {
    console.error(
      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
      'found. Make sure that you are including jQuery before Select2 on your ' +
      'web page.'
    );
  }

  return _$;
});

S2.define('select2/utils',[
  'jquery'
], function ($) {
  var Utils = {};

  Utils.Extend = function (ChildClass, SuperClass) {
    var __hasProp = {}.hasOwnProperty;

    function BaseConstructor () {
      this.constructor = ChildClass;
    }

    for (var key in SuperClass) {
      if (__hasProp.call(SuperClass, key)) {
        ChildClass[key] = SuperClass[key];
      }
    }

    BaseConstructor.prototype = SuperClass.prototype;
    ChildClass.prototype = new BaseConstructor();
    ChildClass.__super__ = SuperClass.prototype;

    return ChildClass;
  };

  function getMethods (theClass) {
    var proto = theClass.prototype;

    var methods = [];

    for (var methodName in proto) {
      var m = proto[methodName];

      if (typeof m !== 'function') {
        continue;
      }

      if (methodName === 'constructor') {
        continue;
      }

      methods.push(methodName);
    }

    return methods;
  }

  Utils.Decorate = function (SuperClass, DecoratorClass) {
    var decoratedMethods = getMethods(DecoratorClass);
    var superMethods = getMethods(SuperClass);

    function DecoratedClass () {
      var unshift = Array.prototype.unshift;

      var argCount = DecoratorClass.prototype.constructor.length;

      var calledConstructor = SuperClass.prototype.constructor;

      if (argCount > 0) {
        unshift.call(arguments, SuperClass.prototype.constructor);

        calledConstructor = DecoratorClass.prototype.constructor;
      }

      calledConstructor.apply(this, arguments);
    }

    DecoratorClass.displayName = SuperClass.displayName;

    function ctr () {
      this.constructor = DecoratedClass;
    }

    DecoratedClass.prototype = new ctr();

    for (var m = 0; m < superMethods.length; m++) {
        var superMethod = superMethods[m];

        DecoratedClass.prototype[superMethod] =
          SuperClass.prototype[superMethod];
    }

    var calledMethod = function (methodName) {
      // Stub out the original method if it's not decorating an actual method
      var originalMethod = function () {};

      if (methodName in DecoratedClass.prototype) {
        originalMethod = DecoratedClass.prototype[methodName];
      }

      var decoratedMethod = DecoratorClass.prototype[methodName];

      return function () {
        var unshift = Array.prototype.unshift;

        unshift.call(arguments, originalMethod);

        return decoratedMethod.apply(this, arguments);
      };
    };

    for (var d = 0; d < decoratedMethods.length; d++) {
      var decoratedMethod = decoratedMethods[d];

      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
    }

    return DecoratedClass;
  };

  var Observable = function () {
    this.listeners = {};
  };

  Observable.prototype.on = function (event, callback) {
    this.listeners = this.listeners || {};

    if (event in this.listeners) {
      this.listeners[event].push(callback);
    } else {
      this.listeners[event] = [callback];
    }
  };

  Observable.prototype.trigger = function (event) {
    var slice = Array.prototype.slice;

    this.listeners = this.listeners || {};

    if (event in this.listeners) {
      this.invoke(this.listeners[event], slice.call(arguments, 1));
    }

    if ('*' in this.listeners) {
      this.invoke(this.listeners['*'], arguments);
    }
  };

  Observable.prototype.invoke = function (listeners, params) {
    for (var i = 0, len = listeners.length; i < len; i++) {
      listeners[i].apply(this, params);
    }
  };

  Utils.Observable = Observable;

  Utils.generateChars = function (length) {
    var chars = '';

    for (var i = 0; i < length; i++) {
      var randomChar = Math.floor(Math.random() * 36);
      chars += randomChar.toString(36);
    }

    return chars;
  };

  Utils.bind = function (func, context) {
    return function () {
      func.apply(context, arguments);
    };
  };

  Utils._convertData = function (data) {
    for (var originalKey in data) {
      var keys = originalKey.split('-');

      var dataLevel = data;

      if (keys.length === 1) {
        continue;
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k];

        // Lowercase the first letter
        // By default, dash-separated becomes camelCase
        key = key.substring(0, 1).toLowerCase() + key.substring(1);

        if (!(key in dataLevel)) {
          dataLevel[key] = {};
        }

        if (k == keys.length - 1) {
          dataLevel[key] = data[originalKey];
        }

        dataLevel = dataLevel[key];
      }

      delete data[originalKey];
    }

    return data;
  };

  Utils.hasScroll = function (index, el) {
    // Adapted from the function created by @ShadowScripter
    // and adapted by @BillBarry on the Stack Exchange Code Review website.
    // The original code can be found at
    // http://codereview.stackexchange.com/q/13338
    // and was designed to be used with the Sizzle selector engine.

    var $el = $(el);
    var overflowX = el.style.overflowX;
    var overflowY = el.style.overflowY;

    //Check both x and y declarations
    if (overflowX === overflowY &&
        (overflowY === 'hidden' || overflowY === 'visible')) {
      return false;
    }

    if (overflowX === 'scroll' || overflowY === 'scroll') {
      return true;
    }

    return ($el.innerHeight() < el.scrollHeight ||
      $el.innerWidth() < el.scrollWidth);
  };

  Utils.escapeMarkup = function (markup) {
    var replaceMap = {
      '\\': '&#92;',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      '/': '&#47;'
    };

    // Do not try to escape the markup if it's not a string
    if (typeof markup !== 'string') {
      return markup;
    }

    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
      return replaceMap[match];
    });
  };

  // Append an array of jQuery nodes to a given element.
  Utils.appendMany = function ($element, $nodes) {
    // jQuery 1.7.x does not support $.fn.append() with an array
    // Fall back to a jQuery object collection using $.fn.add()
    if ($.fn.jquery.substr(0, 3) === '1.7') {
      var $jqNodes = $();

      $.map($nodes, function (node) {
        $jqNodes = $jqNodes.add(node);
      });

      $nodes = $jqNodes;
    }

    $element.append($nodes);
  };

  return Utils;
});

S2.define('select2/results',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Results ($element, options, dataAdapter) {
    this.$element = $element;
    this.data = dataAdapter;
    this.options = options;

    Results.__super__.constructor.call(this);
  }

  Utils.Extend(Results, Utils.Observable);

  Results.prototype.render = function () {
    var $results = $(
      '<ul class="select2-results__options" role="tree"></ul>'
    );

    if (this.options.get('multiple')) {
      $results.attr('aria-multiselectable', 'true');
    }

    this.$results = $results;

    return $results;
  };

  Results.prototype.clear = function () {
    this.$results.empty();
  };

  Results.prototype.displayMessage = function (params) {
    var escapeMarkup = this.options.get('escapeMarkup');

    this.clear();
    this.hideLoading();

    var $message = $(
      '<li role="treeitem" class="select2-results__option"></li>'
    );

    var message = this.options.get('translations').get(params.message);

    $message.append(
      escapeMarkup(
        message(params.args)
      )
    );

    this.$results.append($message);
  };

  Results.prototype.append = function (data) {
    this.hideLoading();

    var $options = [];

    if (data.results == null || data.results.length === 0) {
      if (this.$results.children().length === 0) {
        this.trigger('results:message', {
          message: 'noResults'
        });
      }

      return;
    }

    data.results = this.sort(data.results);

    for (var d = 0; d < data.results.length; d++) {
      var item = data.results[d];

      var $option = this.option(item);

      $options.push($option);
    }

    this.$results.append($options);
  };

  Results.prototype.position = function ($results, $dropdown) {
    var $resultsContainer = $dropdown.find('.select2-results');
    $resultsContainer.append($results);
  };

  Results.prototype.sort = function (data) {
    var sorter = this.options.get('sorter');

    return sorter(data);
  };

  Results.prototype.setClasses = function () {
    var self = this;

    this.data.current(function (selected) {
      var selectedIds = $.map(selected, function (s) {
        return s.id.toString();
      });

      var $options = self.$results
        .find('.select2-results__option[aria-selected]');

      $options.each(function () {
        var $option = $(this);

        var item = $.data(this, 'data');

        // id needs to be converted to a string when comparing
        var id = '' + item.id;

        if ((item.element != null && item.element.selected) ||
            (item.element == null && $.inArray(id, selectedIds) > -1)) {
          $option.attr('aria-selected', 'true');
        } else {
          $option.attr('aria-selected', 'false');
        }
      });

      var $selected = $options.filter('[aria-selected=true]');

      // Check if there are any selected options
      if ($selected.length > 0) {
        // If there are selected options, highlight the first
        $selected.first().trigger('mouseenter');
      } else {
        // If there are no selected options, highlight the first option
        // in the dropdown
        $options.first().trigger('mouseenter');
      }
    });
  };

  Results.prototype.showLoading = function (params) {
    this.hideLoading();

    var loadingMore = this.options.get('translations').get('searching');

    var loading = {
      disabled: true,
      loading: true,
      text: loadingMore(params)
    };
    var $loading = this.option(loading);
    $loading.className += ' loading-results';

    this.$results.prepend($loading);
  };

  Results.prototype.hideLoading = function () {
    this.$results.find('.loading-results').remove();
  };

  Results.prototype.option = function (data) {
    var option = document.createElement('li');
    option.className = 'select2-results__option';

    var attrs = {
      'role': 'treeitem',
      'aria-selected': 'false'
    };

    if (data.disabled) {
      delete attrs['aria-selected'];
      attrs['aria-disabled'] = 'true';
    }

    if (data.id == null) {
      delete attrs['aria-selected'];
    }

    if (data._resultId != null) {
      option.id = data._resultId;
    }

    if (data.title) {
      option.title = data.title;
    }

    if (data.children) {
      attrs.role = 'group';
      attrs['aria-label'] = data.text;
      delete attrs['aria-selected'];
    }

    for (var attr in attrs) {
      var val = attrs[attr];

      option.setAttribute(attr, val);
    }

    if (data.children) {
      var $option = $(option);

      var label = document.createElement('strong');
      label.className = 'select2-results__group';

      var $label = $(label);
      this.template(data, label);

      var $children = [];

      for (var c = 0; c < data.children.length; c++) {
        var child = data.children[c];

        var $child = this.option(child);

        $children.push($child);
      }

      var $childrenContainer = $('<ul></ul>', {
        'class': 'select2-results__options select2-results__options--nested'
      });

      $childrenContainer.append($children);

      $option.append(label);
      $option.append($childrenContainer);
    } else {
      this.template(data, option);
    }

    $.data(option, 'data', data);

    return option;
  };

  Results.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-results';

    this.$results.attr('id', id);

    container.on('results:all', function (params) {
      self.clear();
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
      }
    });

    container.on('results:append', function (params) {
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
      }
    });

    container.on('query', function (params) {
      self.showLoading(params);
    });

    container.on('select', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
    });

    container.on('unselect', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expended="true"
      self.$results.attr('aria-expanded', 'true');
      self.$results.attr('aria-hidden', 'false');

      self.setClasses();
      self.ensureHighlightVisible();
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expended="false"
      self.$results.attr('aria-expanded', 'false');
      self.$results.attr('aria-hidden', 'true');
      self.$results.removeAttr('aria-activedescendant');
    });

    container.on('results:toggle', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      $highlighted.trigger('mouseup');
    });

    container.on('results:select', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      var data = $highlighted.data('data');

      if ($highlighted.attr('aria-selected') == 'true') {
        self.trigger('close');
      } else {
        self.trigger('select', {
          data: data
        });
      }
    });

    container.on('results:previous', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      // If we are already at te top, don't move further
      if (currentIndex === 0) {
        return;
      }

      var nextIndex = currentIndex - 1;

      // If none are highlighted, highlight the first
      if ($highlighted.length === 0) {
        nextIndex = 0;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top;
      var nextTop = $next.offset().top;
      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextTop - currentOffset < 0) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:next', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      var nextIndex = currentIndex + 1;

      // If we are at the last option, stay there
      if (nextIndex >= $options.length) {
        return;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var nextBottom = $next.offset().top + $next.outerHeight(false);
      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextBottom > currentOffset) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:focus', function (params) {
      params.element.addClass('select2-results__option--highlighted');
    });

    container.on('results:message', function (params) {
      self.displayMessage(params);
    });

    if ($.fn.mousewheel) {
      this.$results.on('mousewheel', function (e) {
        var top = self.$results.scrollTop();

        var bottom = (
          self.$results.get(0).scrollHeight -
          self.$results.scrollTop() +
          e.deltaY
        );

        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

        if (isAtTop) {
          self.$results.scrollTop(0);

          e.preventDefault();
          e.stopPropagation();
        } else if (isAtBottom) {
          self.$results.scrollTop(
            self.$results.get(0).scrollHeight - self.$results.height()
          );

          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
      function (evt) {
      var $this = $(this);

      var data = $this.data('data');

      if ($this.attr('aria-selected') === 'true') {
        if (self.options.get('multiple')) {
          self.trigger('unselect', {
            originalEvent: evt,
            data: data
          });
        } else {
          self.trigger('close');
        }

        return;
      }

      self.trigger('select', {
        originalEvent: evt,
        data: data
      });
    });

    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
      function (evt) {
      var data = $(this).data('data');

      self.getHighlightedResults()
          .removeClass('select2-results__option--highlighted');

      self.trigger('results:focus', {
        data: data,
        element: $(this)
      });
    });
  };

  Results.prototype.getHighlightedResults = function () {
    var $highlighted = this.$results
    .find('.select2-results__option--highlighted');

    return $highlighted;
  };

  Results.prototype.destroy = function () {
    this.$results.remove();
  };

  Results.prototype.ensureHighlightVisible = function () {
    var $highlighted = this.getHighlightedResults();

    if ($highlighted.length === 0) {
      return;
    }

    var $options = this.$results.find('[aria-selected]');

    var currentIndex = $options.index($highlighted);

    var currentOffset = this.$results.offset().top;
    var nextTop = $highlighted.offset().top;
    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);

    var offsetDelta = nextTop - currentOffset;
    nextOffset -= $highlighted.outerHeight(false) * 2;

    if (currentIndex <= 2) {
      this.$results.scrollTop(0);
    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
      this.$results.scrollTop(nextOffset);
    }
  };

  Results.prototype.template = function (result, container) {
    var template = this.options.get('templateResult');
    var escapeMarkup = this.options.get('escapeMarkup');

    var content = template(result);

    if (content == null) {
      container.style.display = 'none';
    } else if (typeof content === 'string') {
      container.innerHTML = escapeMarkup(content);
    } else {
      $(container).append(content);
    }
  };

  return Results;
});

S2.define('select2/keys',[

], function () {
  var KEYS = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46
  };

  return KEYS;
});

S2.define('select2/selection/base',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function BaseSelection ($element, options) {
    this.$element = $element;
    this.options = options;

    BaseSelection.__super__.constructor.call(this);
  }

  Utils.Extend(BaseSelection, Utils.Observable);

  BaseSelection.prototype.render = function () {
    var $selection = $(
      '<span class="select2-selection" role="combobox" ' +
      'aria-autocomplete="list" aria-haspopup="true" aria-expanded="false">' +
      '</span>'
    );

    this._tabindex = 0;

    if (this.$element.data('old-tabindex') != null) {
      this._tabindex = this.$element.data('old-tabindex');
    } else if (this.$element.attr('tabindex') != null) {
      this._tabindex = this.$element.attr('tabindex');
    }

    $selection.attr('title', this.$element.attr('title'));
    $selection.attr('tabindex', this._tabindex);

    this.$selection = $selection;

    return $selection;
  };

  BaseSelection.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-container';
    var resultsId = container.id + '-results';

    this.container = container;

    this.$selection.on('focus', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('blur', function (evt) {
      self.trigger('blur', evt);
    });

    this.$selection.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      if (evt.which === KEYS.SPACE) {
        evt.preventDefault();
      }
    });

    container.on('results:focus', function (params) {
      self.$selection.attr('aria-activedescendant', params.data._resultId);
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expanded="true"
      self.$selection.attr('aria-expanded', 'true');
      self.$selection.attr('aria-owns', resultsId);

      self._attachCloseHandler(container);
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expanded="false"
      self.$selection.attr('aria-expanded', 'false');
      self.$selection.removeAttr('aria-activedescendant');
      self.$selection.removeAttr('aria-owns');

      self.$selection.focus();

      self._detachCloseHandler(container);
    });

    container.on('enable', function () {
      self.$selection.attr('tabindex', self._tabindex);
    });

    container.on('disable', function () {
      self.$selection.attr('tabindex', '-1');
    });
  };

  BaseSelection.prototype._attachCloseHandler = function (container) {
    var self = this;

    $(document.body).on('mousedown.select2.' + container.id, function (e) {
      var $target = $(e.target);

      var $select = $target.closest('.select2');

      var $all = $('.select2.select2-container--open');

      $all.each(function () {
        var $this = $(this);

        if (this == $select[0]) {
          return;
        }

        var $element = $this.data('element');

        $element.select2('close');
      });
    });
  };

  BaseSelection.prototype._detachCloseHandler = function (container) {
    $(document.body).off('mousedown.select2.' + container.id);
  };

  BaseSelection.prototype.position = function ($selection, $container) {
    var $selectionContainer = $container.find('.selection');
    $selectionContainer.append($selection);
  };

  BaseSelection.prototype.destroy = function () {
    this._detachCloseHandler(this.container);
  };

  BaseSelection.prototype.update = function (data) {
    throw new Error('The `update` method must be defined in child classes.');
  };

  return BaseSelection;
});

S2.define('select2/selection/single',[
  'jquery',
  './base',
  '../utils',
  '../keys'
], function ($, BaseSelection, Utils, KEYS) {
  function SingleSelection () {
    SingleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(SingleSelection, BaseSelection);

  SingleSelection.prototype.render = function () {
    var $selection = SingleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--single');

    $selection.html(
      '<span class="select2-selection__rendered"></span>' +
      '<span class="select2-selection__arrow" role="presentation">' +
        '<b role="presentation"></b>' +
      '</span>'
    );

    return $selection;
  };

  SingleSelection.prototype.bind = function (container, $container) {
    var self = this;

    SingleSelection.__super__.bind.apply(this, arguments);

    var id = container.id + '-container';

    this.$selection.find('.select2-selection__rendered').attr('id', id);
    this.$selection.attr('aria-labelledby', id);

    this.$selection.on('mousedown', function (evt) {
      // Only respond to left clicks
      if (evt.which !== 1) {
        return;
      }

      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on('focus', function (evt) {
      // User focuses on the container
    });

    this.$selection.on('blur', function (evt) {
      // User exits the container
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });
  };

  SingleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  SingleSelection.prototype.display = function (data) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data));
  };

  SingleSelection.prototype.selectionContainer = function () {
    return $('<span></span>');
  };

  SingleSelection.prototype.update = function (data) {
    if (data.length === 0) {
      this.clear();
      return;
    }

    var selection = data[0];

    var formatted = this.display(selection);

    var $rendered = this.$selection.find('.select2-selection__rendered');
    $rendered.empty().append(formatted);
    $rendered.prop('title', selection.title || selection.text);
  };

  return SingleSelection;
});

S2.define('select2/selection/multiple',[
  'jquery',
  './base',
  '../utils'
], function ($, BaseSelection, Utils) {
  function MultipleSelection ($element, options) {
    MultipleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(MultipleSelection, BaseSelection);

  MultipleSelection.prototype.render = function () {
    var $selection = MultipleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--multiple');

    $selection.html(
      '<ul class="select2-selection__rendered"></ul>'
    );

    return $selection;
  };

  MultipleSelection.prototype.bind = function (container, $container) {
    var self = this;

    MultipleSelection.__super__.bind.apply(this, arguments);

    this.$selection.on('click', function (evt) {
      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on('click', '.select2-selection__choice__remove',
      function (evt) {
      var $remove = $(this);
      var $selection = $remove.parent();

      var data = $selection.data('data');

      self.trigger('unselect', {
        originalEvent: evt,
        data: data
      });
    });
  };

  MultipleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  MultipleSelection.prototype.display = function (data) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data));
  };

  MultipleSelection.prototype.selectionContainer = function () {
    var $container = $(
      '<li class="select2-selection__choice">' +
        '<span class="select2-selection__choice__remove" role="presentation">' +
          '&times;' +
        '</span>' +
      '</li>'
    );

    return $container;
  };

  MultipleSelection.prototype.update = function (data) {
    this.clear();

    if (data.length === 0) {
      return;
    }

    var $selections = [];

    for (var d = 0; d < data.length; d++) {
      var selection = data[d];

      var formatted = this.display(selection);
      var $selection = this.selectionContainer();

      $selection.append(formatted);
      $selection.prop('title', selection.title || selection.text);

      $selection.data('data', selection);

      $selections.push($selection);
    }

    var $rendered = this.$selection.find('.select2-selection__rendered');

    Utils.appendMany($rendered, $selections);
  };

  return MultipleSelection;
});

S2.define('select2/selection/placeholder',[
  '../utils'
], function (Utils) {
  function Placeholder (decorated, $element, options) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options);
  }

  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
    var $placeholder = this.selectionContainer();

    $placeholder.html(this.display(placeholder));
    $placeholder.addClass('select2-selection__placeholder')
                .removeClass('select2-selection__choice');

    return $placeholder;
  };

  Placeholder.prototype.update = function (decorated, data) {
    var singlePlaceholder = (
      data.length == 1 && data[0].id != this.placeholder.id
    );
    var multipleSelections = data.length > 1;

    if (multipleSelections || singlePlaceholder) {
      return decorated.call(this, data);
    }

    this.clear();

    var $placeholder = this.createPlaceholder(this.placeholder);

    this.$selection.find('.select2-selection__rendered').append($placeholder);
  };

  return Placeholder;
});

S2.define('select2/selection/allowClear',[
  'jquery',
  '../keys'
], function ($, KEYS) {
  function AllowClear () { }

  AllowClear.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    if (this.placeholder == null) {
      if (this.options.get('debug') && window.console && console.error) {
        console.error(
          'Select2: The `allowClear` option should be used in combination ' +
          'with the `placeholder` option.'
        );
      }
    }

    this.$selection.on('mousedown', '.select2-selection__clear',
      function (evt) {
        self._handleClear(evt);
    });

    container.on('keypress', function (evt) {
      self._handleKeyboardClear(evt, container);
    });
  };

  AllowClear.prototype._handleClear = function (_, evt) {
    // Ignore the event if it is disabled
    if (this.options.get('disabled')) {
      return;
    }

    var $clear = this.$selection.find('.select2-selection__clear');

    // Ignore the event if nothing has been selected
    if ($clear.length === 0) {
      return;
    }

    evt.stopPropagation();

    var data = $clear.data('data');

    for (var d = 0; d < data.length; d++) {
      var unselectData = {
        data: data[d]
      };

      // Trigger the `unselect` event, so people can prevent it from being
      // cleared.
      this.trigger('unselect', unselectData);

      // If the event was prevented, don't clear it out.
      if (unselectData.prevented) {
        return;
      }
    }

    if(this.placeholder){
      this.$element.val(this.placeholder.id).trigger('change');
    }

    this.trigger('toggle');
  };

  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
    if (container.isOpen()) {
      return;
    }

    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
      this._handleClear(evt);
    }
  };

  AllowClear.prototype.update = function (decorated, data) {
    decorated.call(this, data);

    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
        data.length === 0) {
      return;
    }

    var $remove = $(
      '<span class="select2-selection__clear">' +
        '&times;' +
      '</span>'
    );
    $remove.data('data', data);

    this.$selection.find('.select2-selection__rendered').prepend($remove);
  };

  return AllowClear;
});

S2.define('select2/selection/search',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function Search (decorated, $element, options) {
    decorated.call(this, $element, options);
  }

  Search.prototype.render = function (decorated) {
    var $search = $(
      '<li class="select2-search select2-search--inline">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
        ' spellcheck="false" role="textbox" />' +
      '</li>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    var $rendered = decorated.call(this);

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self.$search.attr('tabindex', 0);

      self.$search.focus();
    });

    container.on('close', function () {
      self.$search.attr('tabindex', -1);

      self.$search.val('');
      self.$search.focus();
    });

    container.on('enable', function () {
      self.$search.prop('disabled', false);
    });

    container.on('disable', function () {
      self.$search.prop('disabled', true);
    });

    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
      self.trigger('blur', evt);
    });

    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
      evt.stopPropagation();

      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();

      var key = evt.which;

      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
        var $previousChoice = self.$searchContainer
          .prev('.select2-selection__choice');

        if ($previousChoice.length > 0) {
          var item = $previousChoice.data('data');

          self.searchRemoveChoice(item);

          evt.preventDefault();
        }
      }
    });

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$selection.on('input', '.select2-search--inline', function (evt) {
      // Unbind the duplicated `keyup` event
      self.$selection.off('keyup.search');
    });

    this.$selection.on('keyup.search input', '.select2-search--inline',
        function (evt) {
      self.handleSearch(evt);
    });
  };

  Search.prototype.createPlaceholder = function (decorated, placeholder) {
    this.$search.attr('placeholder', placeholder.text);
  };

  Search.prototype.update = function (decorated, data) {
    this.$search.attr('placeholder', '');

    decorated.call(this, data);

    this.$selection.find('.select2-selection__rendered')
                   .append(this.$searchContainer);

    this.resizeSearch();
  };

  Search.prototype.handleSearch = function () {
    this.resizeSearch();

    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.searchRemoveChoice = function (decorated, item) {
    this.trigger('unselect', {
      data: item
    });

    this.trigger('open');

    this.$search.val(item.text + ' ');
  };

  Search.prototype.resizeSearch = function () {
    this.$search.css('width', '25px');

    var width = '';

    if (this.$search.attr('placeholder') !== '') {
      width = this.$selection.find('.select2-selection__rendered').innerWidth();
    } else {
      var minimumWidth = this.$search.val().length + 1;

      width = (minimumWidth * 0.75) + 'em';
    }

    this.$search.css('width', width);
  };

  return Search;
});

S2.define('select2/selection/eventRelay',[
  'jquery'
], function ($) {
  function EventRelay () { }

  EventRelay.prototype.bind = function (decorated, container, $container) {
    var self = this;
    var relayEvents = [
      'open', 'opening',
      'close', 'closing',
      'select', 'selecting',
      'unselect', 'unselecting'
    ];

    var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting'];

    decorated.call(this, container, $container);

    container.on('*', function (name, params) {
      // Ignore events that should not be relayed
      if ($.inArray(name, relayEvents) === -1) {
        return;
      }

      // The parameters should always be an object
      params = params || {};

      // Generate the jQuery event for the Select2 event
      var evt = $.Event('select2:' + name, {
        params: params
      });

      self.$element.trigger(evt);

      // Only handle preventable events if it was one
      if ($.inArray(name, preventableEvents) === -1) {
        return;
      }

      params.prevented = evt.isDefaultPrevented();
    });
  };

  return EventRelay;
});

S2.define('select2/translation',[
  'jquery',
  'require'
], function ($, require) {
  function Translation (dict) {
    this.dict = dict || {};
  }

  Translation.prototype.all = function () {
    return this.dict;
  };

  Translation.prototype.get = function (key) {
    return this.dict[key];
  };

  Translation.prototype.extend = function (translation) {
    this.dict = $.extend({}, translation.all(), this.dict);
  };

  // Static functions

  Translation._cache = {};

  Translation.loadPath = function (path) {
    if (!(path in Translation._cache)) {
      var translations = require(path);

      Translation._cache[path] = translations;
    }

    return new Translation(Translation._cache[path]);
  };

  return Translation;
});

S2.define('select2/diacritics',[

], function () {
  var diacritics = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03C9': '\u03C9',
    '\u03C2': '\u03C3'
  };

  return diacritics;
});

S2.define('select2/data/base',[
  '../utils'
], function (Utils) {
  function BaseAdapter ($element, options) {
    BaseAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(BaseAdapter, Utils.Observable);

  BaseAdapter.prototype.current = function (callback) {
    throw new Error('The `current` method must be defined in child classes.');
  };

  BaseAdapter.prototype.query = function (params, callback) {
    throw new Error('The `query` method must be defined in child classes.');
  };

  BaseAdapter.prototype.bind = function (container, $container) {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.destroy = function () {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.generateResultId = function (container, data) {
    var id = container.id + '-result-';

    id += Utils.generateChars(4);

    if (data.id != null) {
      id += '-' + data.id.toString();
    } else {
      id += '-' + Utils.generateChars(4);
    }
    return id;
  };

  return BaseAdapter;
});

S2.define('select2/data/select',[
  './base',
  '../utils',
  'jquery'
], function (BaseAdapter, Utils, $) {
  function SelectAdapter ($element, options) {
    this.$element = $element;
    this.options = options;

    SelectAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(SelectAdapter, BaseAdapter);

  SelectAdapter.prototype.current = function (callback) {
    var data = [];
    var self = this;

    this.$element.find(':selected').each(function () {
      var $option = $(this);

      var option = self.item($option);

      data.push(option);
    });

    callback(data);
  };

  SelectAdapter.prototype.select = function (data) {
    var self = this;

    data.selected = true;

    // If data.element is a DOM node, use it instead
    if ($(data.element).is('option')) {
      data.element.selected = true;

      this.$element.trigger('change');

      return;
    }

    if (this.$element.prop('multiple')) {
      this.current(function (currentData) {
        var val = [];

        data = [data];
        data.push.apply(data, currentData);

        for (var d = 0; d < data.length; d++) {
          var id = data[d].id;

          if ($.inArray(id, val) === -1) {
            val.push(id);
          }
        }

        self.$element.val(val);
        self.$element.trigger('change');
      });
    } else {
      var val = data.id;

      this.$element.val(val);
      this.$element.trigger('change');
    }
  };

  SelectAdapter.prototype.unselect = function (data) {
    var self = this;

    if (!this.$element.prop('multiple')) {
      return;
    }

    data.selected = false;

    if ($(data.element).is('option')) {
      data.element.selected = false;

      this.$element.trigger('change');

      return;
    }

    this.current(function (currentData) {
      var val = [];

      for (var d = 0; d < currentData.length; d++) {
        var id = currentData[d].id;

        if (id !== data.id && $.inArray(id, val) === -1) {
          val.push(id);
        }
      }

      self.$element.val(val);

      self.$element.trigger('change');
    });
  };

  SelectAdapter.prototype.bind = function (container, $container) {
    var self = this;

    this.container = container;

    container.on('select', function (params) {
      self.select(params.data);
    });

    container.on('unselect', function (params) {
      self.unselect(params.data);
    });
  };

  SelectAdapter.prototype.destroy = function () {
    // Remove anything added to child elements
    this.$element.find('*').each(function () {
      // Remove any custom data set by Select2
      $.removeData(this, 'data');
    });
  };

  SelectAdapter.prototype.query = function (params, callback) {
    var data = [];
    var self = this;

    var $options = this.$element.children();

    $options.each(function () {
      var $option = $(this);

      if (!$option.is('option') && !$option.is('optgroup')) {
        return;
      }

      var option = self.item($option);

      var matches = self.matches(params, option);

      if (matches !== null) {
        data.push(matches);
      }
    });

    callback({
      results: data
    });
  };

  SelectAdapter.prototype.addOptions = function ($options) {
    Utils.appendMany(this.$element, $options);
  };

  SelectAdapter.prototype.option = function (data) {
    var option;

    if (data.children) {
      option = document.createElement('optgroup');
      option.label = data.text;
    } else {
      option = document.createElement('option');

      if (option.textContent !== undefined) {
        option.textContent = data.text;
      } else {
        option.innerText = data.text;
      }
    }

    if (data.id) {
      option.value = data.id;
    }

    if (data.disabled) {
      option.disabled = true;
    }

    if (data.selected) {
      option.selected = true;
    }

    if (data.title) {
      option.title = data.title;
    }

    var $option = $(option);

    var normalizedData = this._normalizeItem(data);
    normalizedData.element = option;

    // Override the option's data with the combined data
    $.data(option, 'data', normalizedData);

    return $option;
  };

  SelectAdapter.prototype.item = function ($option) {
    var data = {};

    data = $.data($option[0], 'data');

    if (data != null) {
      return data;
    }

    if ($option.is('option')) {
      data = {
        id: $option.val(),
        text: $option.text(),
        disabled: $option.prop('disabled'),
        selected: $option.prop('selected'),
        title: $option.prop('title')
      };
    } else if ($option.is('optgroup')) {
      data = {
        text: $option.prop('label'),
        children: [],
        title: $option.prop('title')
      };

      var $children = $option.children('option');
      var children = [];

      for (var c = 0; c < $children.length; c++) {
        var $child = $($children[c]);

        var child = this.item($child);

        children.push(child);
      }

      data.children = children;
    }

    data = this._normalizeItem(data);
    data.element = $option[0];

    $.data($option[0], 'data', data);

    return data;
  };

  SelectAdapter.prototype._normalizeItem = function (item) {
    if (!$.isPlainObject(item)) {
      item = {
        id: item,
        text: item
      };
    }

    item = $.extend({}, {
      text: ''
    }, item);

    var defaults = {
      selected: false,
      disabled: false
    };

    if (item.id != null) {
      item.id = item.id.toString();
    }

    if (item.text != null) {
      item.text = item.text.toString();
    }

    if (item._resultId == null && item.id && this.container != null) {
      item._resultId = this.generateResultId(this.container, item);
    }

    return $.extend({}, defaults, item);
  };

  SelectAdapter.prototype.matches = function (params, data) {
    var matcher = this.options.get('matcher');

    return matcher(params, data);
  };

  return SelectAdapter;
});

S2.define('select2/data/array',[
  './select',
  '../utils',
  'jquery'
], function (SelectAdapter, Utils, $) {
  function ArrayAdapter ($element, options) {
    var data = options.get('data') || [];

    ArrayAdapter.__super__.constructor.call(this, $element, options);

    this.addOptions(this.convertToOptions(data));
  }

  Utils.Extend(ArrayAdapter, SelectAdapter);

  ArrayAdapter.prototype.select = function (data) {
    var $option = this.$element.find('option').filter(function (i, elm) {
      return elm.value == data.id.toString();
    });

    if ($option.length === 0) {
      $option = this.option(data);

      this.addOptions($option);
    }

    ArrayAdapter.__super__.select.call(this, data);
  };

  ArrayAdapter.prototype.convertToOptions = function (data) {
    var self = this;

    var $existing = this.$element.find('option');
    var existingIds = $existing.map(function () {
      return self.item($(this)).id;
    }).get();

    var $options = [];

    // Filter out all items except for the one passed in the argument
    function onlyItem (item) {
      return function () {
        return $(this).val() == item.id;
      };
    }

    for (var d = 0; d < data.length; d++) {
      var item = this._normalizeItem(data[d]);

      // Skip items which were pre-loaded, only merge the data
      if ($.inArray(item.id, existingIds) >= 0) {
        var $existingOption = $existing.filter(onlyItem(item));

        var existingData = this.item($existingOption);
        var newData = $.extend(true, {}, existingData, item);

        var $newOption = this.option(existingData);

        $existingOption.replaceWith($newOption);

        continue;
      }

      var $option = this.option(item);

      if (item.children) {
        var $children = this.convertToOptions(item.children);

        Utils.appendMany($option, $children);
      }

      $options.push($option);
    }

    return $options;
  };

  return ArrayAdapter;
});

S2.define('select2/data/ajax',[
  './array',
  '../utils',
  'jquery'
], function (ArrayAdapter, Utils, $) {
  function AjaxAdapter ($element, options) {
    this.ajaxOptions = this._applyDefaults(options.get('ajax'));

    if (this.ajaxOptions.processResults != null) {
      this.processResults = this.ajaxOptions.processResults;
    }

    ArrayAdapter.__super__.constructor.call(this, $element, options);
  }

  Utils.Extend(AjaxAdapter, ArrayAdapter);

  AjaxAdapter.prototype._applyDefaults = function (options) {
    var defaults = {
      data: function (params) {
        return {
          q: params.term
        };
      },
      transport: function (params, success, failure) {
        var $request = $.ajax(params);

        $request.then(success);
        $request.fail(failure);

        return $request;
      }
    };

    return $.extend({}, defaults, options, true);
  };

  AjaxAdapter.prototype.processResults = function (results) {
    return results;
  };

  AjaxAdapter.prototype.query = function (params, callback) {
    var matches = [];
    var self = this;

    if (this._request != null) {
      // JSONP requests cannot always be aborted
      if ($.isFunction(this._request.abort)) {
        this._request.abort();
      }

      this._request = null;
    }

    var options = $.extend({
      type: 'GET'
    }, this.ajaxOptions);

    if (typeof options.url === 'function') {
      options.url = options.url(params);
    }

    if (typeof options.data === 'function') {
      options.data = options.data(params);
    }

    function request () {
      var $request = options.transport(options, function (data) {
        var results = self.processResults(data, params);

        if (self.options.get('debug') && window.console && console.error) {
          // Check to make sure that the response included a `results` key.
          if (!results || !results.results || !$.isArray(results.results)) {
            console.error(
              'Select2: The AJAX results did not return an array in the ' +
              '`results` key of the response.'
            );
          }
        }

        callback(results);
      }, function () {
        // TODO: Handle AJAX errors
      });

      self._request = $request;
    }

    if (this.ajaxOptions.delay && params.term !== '') {
      if (this._queryTimeout) {
        window.clearTimeout(this._queryTimeout);
      }

      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
    } else {
      request();
    }
  };

  return AjaxAdapter;
});

S2.define('select2/data/tags',[
  'jquery'
], function ($) {
  function Tags (decorated, $element, options) {
    var tags = options.get('tags');

    var createTag = options.get('createTag');

    if (createTag !== undefined) {
      this.createTag = createTag;
    }

    decorated.call(this, $element, options);

    if ($.isArray(tags)) {
      for (var t = 0; t < tags.length; t++) {
        var tag = tags[t];
        var item = this._normalizeItem(tag);

        var $option = this.option(item);

        this.$element.append($option);
      }
    }
  }

  Tags.prototype.query = function (decorated, params, callback) {
    var self = this;

    this._removeOldTags();

    if (params.term == null || params.page != null) {
      decorated.call(this, params, callback);
      return;
    }

    function wrapper (obj, child) {
      var data = obj.results;

      for (var i = 0; i < data.length; i++) {
        var option = data[i];

        var checkChildren = (
          option.children != null &&
          !wrapper({
            results: option.children
          }, true)
        );

        var checkText = option.text === params.term;

        if (checkText || checkChildren) {
          if (child) {
            return false;
          }

          obj.data = data;
          callback(obj);

          return;
        }
      }

      if (child) {
        return true;
      }

      var tag = self.createTag(params);

      if (tag != null) {
        var $option = self.option(tag);
        $option.attr('data-select2-tag', true);

        self.addOptions([$option]);

        self.insertTag(data, tag);
      }

      obj.results = data;

      callback(obj);
    }

    decorated.call(this, params, wrapper);
  };

  Tags.prototype.createTag = function (decorated, params) {
    var term = $.trim(params.term);

    if (term === '') {
      return null;
    }

    return {
      id: term,
      text: term
    };
  };

  Tags.prototype.insertTag = function (_, data, tag) {
    data.unshift(tag);
  };

  Tags.prototype._removeOldTags = function (_) {
    var tag = this._lastTag;

    var $options = this.$element.find('option[data-select2-tag]');

    $options.each(function () {
      if (this.selected) {
        return;
      }

      $(this).remove();
    });
  };

  return Tags;
});

S2.define('select2/data/tokenizer',[
  'jquery'
], function ($) {
  function Tokenizer (decorated, $element, options) {
    var tokenizer = options.get('tokenizer');

    if (tokenizer !== undefined) {
      this.tokenizer = tokenizer;
    }

    decorated.call(this, $element, options);
  }

  Tokenizer.prototype.bind = function (decorated, container, $container) {
    decorated.call(this, container, $container);

    this.$search =  container.dropdown.$search || container.selection.$search ||
      $container.find('.select2-search__field');
  };

  Tokenizer.prototype.query = function (decorated, params, callback) {
    var self = this;

    function select (data) {
      self.select(data);
    }

    params.term = params.term || '';

    var tokenData = this.tokenizer(params, this.options, select);

    if (tokenData.term !== params.term) {
      // Replace the search term if we have the search box
      if (this.$search.length) {
        this.$search.val(tokenData.term);
        this.$search.focus();
      }

      params.term = tokenData.term;
    }

    decorated.call(this, params, callback);
  };

  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
    var separators = options.get('tokenSeparators') || [];
    var term = params.term;
    var i = 0;

    var createTag = this.createTag || function (params) {
      return {
        id: params.term,
        text: params.term
      };
    };

    while (i < term.length) {
      var termChar = term[i];

      if ($.inArray(termChar, separators) === -1) {
        i++;

        continue;
      }

      var part = term.substr(0, i);
      var partParams = $.extend({}, params, {
        term: part
      });

      var data = createTag(partParams);

      callback(data);

      // Reset the term to not include the tokenized portion
      term = term.substr(i + 1) || '';
      i = 0;
    }

    return {
      term: term
    };
  };

  return Tokenizer;
});

S2.define('select2/data/minimumInputLength',[

], function () {
  function MinimumInputLength (decorated, $e, options) {
    this.minimumInputLength = options.get('minimumInputLength');

    decorated.call(this, $e, options);
  }

  MinimumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (params.term.length < this.minimumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooShort',
        args: {
          minimum: this.minimumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MinimumInputLength;
});

S2.define('select2/data/maximumInputLength',[

], function () {
  function MaximumInputLength (decorated, $e, options) {
    this.maximumInputLength = options.get('maximumInputLength');

    decorated.call(this, $e, options);
  }

  MaximumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (this.maximumInputLength > 0 &&
        params.term.length > this.maximumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooLong',
        args: {
          maximum: this.maximumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MaximumInputLength;
});

S2.define('select2/data/maximumSelectionLength',[

], function (){
  function MaximumSelectionLength (decorated, $e, options) {
    this.maximumSelectionLength = options.get('maximumSelectionLength');

    decorated.call(this, $e, options);
  }

  MaximumSelectionLength.prototype.query =
    function (decorated, params, callback) {
      var self = this;

      this.current(function (currentData) {
        var count = currentData != null ? currentData.length : 0;
        if (self.maximumSelectionLength > 0 &&
          count >= self.maximumSelectionLength) {
          self.trigger('results:message', {
            message: 'maximumSelected',
            args: {
              maximum: self.maximumSelectionLength
            }
          });
          return;
        }
        decorated.call(self, params, callback);
      });
  };

  return MaximumSelectionLength;
});

S2.define('select2/dropdown',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Dropdown ($element, options) {
    this.$element = $element;
    this.options = options;

    Dropdown.__super__.constructor.call(this);
  }

  Utils.Extend(Dropdown, Utils.Observable);

  Dropdown.prototype.render = function () {
    var $dropdown = $(
      '<span class="select2-dropdown">' +
        '<span class="select2-results"></span>' +
      '</span>'
    );

    $dropdown.attr('dir', this.options.get('dir'));

    this.$dropdown = $dropdown;

    return $dropdown;
  };

  Dropdown.prototype.position = function ($dropdown, $container) {
    // Should be implmented in subclasses
  };

  Dropdown.prototype.destroy = function () {
    // Remove the dropdown from the DOM
    this.$dropdown.remove();
  };

  return Dropdown;
});

S2.define('select2/dropdown/search',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function Search () { }

  Search.prototype.render = function (decorated) {
    var $rendered = decorated.call(this);

    var $search = $(
      '<span class="select2-search select2-search--dropdown">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
        ' spellcheck="false" role="textbox" />' +
      '</span>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    $rendered.prepend($search);

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    this.$search.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();
    });

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$search.on('input', function (evt) {
      // Unbind the duplicated `keyup` event
      $(this).off('keyup');
    });

    this.$search.on('keyup input', function (evt) {
      self.handleSearch(evt);
    });

    container.on('open', function () {
      self.$search.attr('tabindex', 0);

      self.$search.focus();

      window.setTimeout(function () {
        self.$search.focus();
      }, 0);
    });

    container.on('close', function () {
      self.$search.attr('tabindex', -1);

      self.$search.val('');
    });

    container.on('results:all', function (params) {
      if (params.query.term == null || params.query.term === '') {
        var showSearch = self.showSearch(params);

        if (showSearch) {
          self.$searchContainer.removeClass('select2-search--hide');
        } else {
          self.$searchContainer.addClass('select2-search--hide');
        }
      }
    });
  };

  Search.prototype.handleSearch = function (evt) {
    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.showSearch = function (_, params) {
    return true;
  };

  return Search;
});

S2.define('select2/dropdown/hidePlaceholder',[

], function () {
  function HidePlaceholder (decorated, $element, options, dataAdapter) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options, dataAdapter);
  }

  HidePlaceholder.prototype.append = function (decorated, data) {
    data.results = this.removePlaceholder(data.results);

    decorated.call(this, data);
  };

  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
    var modifiedData = data.slice(0);

    for (var d = data.length - 1; d >= 0; d--) {
      var item = data[d];

      if (this.placeholder.id === item.id) {
        modifiedData.splice(d, 1);
      }
    }

    return modifiedData;
  };

  return HidePlaceholder;
});

S2.define('select2/dropdown/infiniteScroll',[
  'jquery'
], function ($) {
  function InfiniteScroll (decorated, $element, options, dataAdapter) {
    this.lastParams = {};

    decorated.call(this, $element, options, dataAdapter);

    this.$loadingMore = this.createLoadingMore();
    this.loading = false;
  }

  InfiniteScroll.prototype.append = function (decorated, data) {
    this.$loadingMore.remove();
    this.loading = false;

    decorated.call(this, data);

    if (this.showLoadingMore(data)) {
      this.$results.append(this.$loadingMore);
    }
  };

  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('query', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    container.on('query:append', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    this.$results.on('scroll', function () {
      var isLoadMoreVisible = $.contains(
        document.documentElement,
        self.$loadingMore[0]
      );

      if (self.loading || !isLoadMoreVisible) {
        return;
      }

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var loadingMoreOffset = self.$loadingMore.offset().top +
        self.$loadingMore.outerHeight(false);

      if (currentOffset + 50 >= loadingMoreOffset) {
        self.loadMore();
      }
    });
  };

  InfiniteScroll.prototype.loadMore = function () {
    this.loading = true;

    var params = $.extend({}, {page: 1}, this.lastParams);

    params.page++;

    this.trigger('query:append', params);
  };

  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
    return data.pagination && data.pagination.more;
  };

  InfiniteScroll.prototype.createLoadingMore = function () {
    var $option = $(
      '<li class="option load-more" role="treeitem"></li>'
    );

    var message = this.options.get('translations').get('loadingMore');

    $option.html(message(this.lastParams));

    return $option;
  };

  return InfiniteScroll;
});

S2.define('select2/dropdown/attachBody',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function AttachBody (decorated, $element, options) {
    this.$dropdownParent = options.get('dropdownParent') || document.body;

    decorated.call(this, $element, options);
  }

  AttachBody.prototype.bind = function (decorated, container, $container) {
    var self = this;

    var setupResultsEvents = false;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self._showDropdown();
      self._attachPositioningHandler(container);

      if (!setupResultsEvents) {
        setupResultsEvents = true;

        container.on('results:all', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });

        container.on('results:append', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });
      }
    });

    container.on('close', function () {
      self._hideDropdown();
      self._detachPositioningHandler(container);
    });

    this.$dropdownContainer.on('mousedown', function (evt) {
      evt.stopPropagation();
    });
  };

  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
    // Clone all of the container classes
    $dropdown.attr('class', $container.attr('class'));

    $dropdown.removeClass('select2');
    $dropdown.addClass('select2-container--open');

    $dropdown.css({
      position: 'absolute',
      top: -999999
    });

    this.$container = $container;
  };

  AttachBody.prototype.render = function (decorated) {
    var $container = $('<span></span>');

    var $dropdown = decorated.call(this);
    $container.append($dropdown);

    this.$dropdownContainer = $container;

    return $container;
  };

  AttachBody.prototype._hideDropdown = function (decorated) {
    this.$dropdownContainer.detach();
  };

  AttachBody.prototype._attachPositioningHandler = function (container) {
    var self = this;

    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.each(function () {
      $(this).data('select2-scroll-position', {
        x: $(this).scrollLeft(),
        y: $(this).scrollTop()
      });
    });

    $watchers.on(scrollEvent, function (ev) {
      var position = $(this).data('select2-scroll-position');
      $(this).scrollTop(position.y);
    });

    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
      function (e) {
      self._positionDropdown();
      self._resizeDropdown();
    });
  };

  AttachBody.prototype._detachPositioningHandler = function (container) {
    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.off(scrollEvent);

    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
  };

  AttachBody.prototype._positionDropdown = function () {
    var $window = $(window);

    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

    var newDirection = null;

    var position = this.$container.position();
    var offset = this.$container.offset();

    offset.bottom = offset.top + this.$container.outerHeight(false);

    var container = {
      height: this.$container.outerHeight(false)
    };

    container.top = offset.top;
    container.bottom = offset.top + container.height;

    var dropdown = {
      height: this.$dropdown.outerHeight(false)
    };

    var viewport = {
      top: $window.scrollTop(),
      bottom: $window.scrollTop() + $window.height()
    };

    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

    var css = {
      left: offset.left,
      top: container.bottom
    };

    if (!isCurrentlyAbove && !isCurrentlyBelow) {
      newDirection = 'below';
    }

    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
      newDirection = 'above';
    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
      newDirection = 'below';
    }

    if (newDirection == 'above' ||
      (isCurrentlyAbove && newDirection !== 'below')) {
      css.top = container.top - dropdown.height;
    }

    if (newDirection != null) {
      this.$dropdown
        .removeClass('select2-dropdown--below select2-dropdown--above')
        .addClass('select2-dropdown--' + newDirection);
      this.$container
        .removeClass('select2-container--below select2-container--above')
        .addClass('select2-container--' + newDirection);
    }

    this.$dropdownContainer.css(css);
  };

  AttachBody.prototype._resizeDropdown = function () {
    this.$dropdownContainer.width();

    var css = {
      width: this.$container.outerWidth(false) + 'px'
    };

    if (this.options.get('dropdownAutoWidth')) {
      css.minWidth = css.width;
      css.width = 'auto';
    }

    this.$dropdown.css(css);
  };

  AttachBody.prototype._showDropdown = function (decorated) {
    this.$dropdownContainer.appendTo(this.$dropdownParent);

    this._positionDropdown();
    this._resizeDropdown();
  };

  return AttachBody;
});

S2.define('select2/dropdown/minimumResultsForSearch',[

], function () {
  function countResults (data) {
    var count = 0;

    for (var d = 0; d < data.length; d++) {
      var item = data[d];

      if (item.children) {
        count += countResults(item.children);
      } else {
        count++;
      }
    }

    return count;
  }

  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
    this.minimumResultsForSearch = options.get('minimumResultsForSearch');

    if (this.minimumResultsForSearch < 0) {
      this.minimumResultsForSearch = Infinity;
    }

    decorated.call(this, $element, options, dataAdapter);
  }

  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
    if (countResults(params.data.results) < this.minimumResultsForSearch) {
      return false;
    }

    return decorated.call(this, params);
  };

  return MinimumResultsForSearch;
});

S2.define('select2/dropdown/selectOnClose',[

], function () {
  function SelectOnClose () { }

  SelectOnClose.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('close', function () {
      self._handleSelectOnClose();
    });
  };

  SelectOnClose.prototype._handleSelectOnClose = function () {
    var $highlightedResults = this.getHighlightedResults();

    if ($highlightedResults.length < 1) {
      return;
    }

    this.trigger('select', {
        data: $highlightedResults.data('data')
    });
  };

  return SelectOnClose;
});

S2.define('select2/dropdown/closeOnSelect',[

], function () {
  function CloseOnSelect () { }

  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('select', function (evt) {
      self._selectTriggered(evt);
    });

    container.on('unselect', function (evt) {
      self._selectTriggered(evt);
    });
  };

  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
    var originalEvent = evt.originalEvent;

    // Don't close if the control key is being held
    if (originalEvent && originalEvent.ctrlKey) {
      return;
    }

    this.trigger('close');
  };

  return CloseOnSelect;
});

S2.define('select2/i18n/en',[],function () {
  // English
  return {
    errorLoading: function () {
      return 'The results could not be loaded.';
    },
    inputTooLong: function (args) {
      var overChars = args.input.length - args.maximum;

      var message = 'Please delete ' + overChars + ' character';

      if (overChars != 1) {
        message += 's';
      }

      return message;
    },
    inputTooShort: function (args) {
      var remainingChars = args.minimum - args.input.length;

      var message = 'Please enter ' + remainingChars + ' or more characters';

      return message;
    },
    loadingMore: function () {
      return 'Loading more results…';
    },
    maximumSelected: function (args) {
      var message = 'You can only select ' + args.maximum + ' item';

      if (args.maximum != 1) {
        message += 's';
      }

      return message;
    },
    noResults: function () {
      return 'No results found';
    },
    searching: function () {
      return 'Searching…';
    }
  };
});

S2.define('select2/defaults',[
  'jquery',
  'require',

  './results',

  './selection/single',
  './selection/multiple',
  './selection/placeholder',
  './selection/allowClear',
  './selection/search',
  './selection/eventRelay',

  './utils',
  './translation',
  './diacritics',

  './data/select',
  './data/array',
  './data/ajax',
  './data/tags',
  './data/tokenizer',
  './data/minimumInputLength',
  './data/maximumInputLength',
  './data/maximumSelectionLength',

  './dropdown',
  './dropdown/search',
  './dropdown/hidePlaceholder',
  './dropdown/infiniteScroll',
  './dropdown/attachBody',
  './dropdown/minimumResultsForSearch',
  './dropdown/selectOnClose',
  './dropdown/closeOnSelect',

  './i18n/en'
], function ($, require,

             ResultsList,

             SingleSelection, MultipleSelection, Placeholder, AllowClear,
             SelectionSearch, EventRelay,

             Utils, Translation, DIACRITICS,

             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,

             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,

             EnglishTranslation) {
  function Defaults () {
    this.reset();
  }

  Defaults.prototype.apply = function (options) {
    options = $.extend({}, this.defaults, options);

    if (options.dataAdapter == null) {
      if (options.ajax != null) {
        options.dataAdapter = AjaxData;
      } else if (options.data != null) {
        options.dataAdapter = ArrayData;
      } else {
        options.dataAdapter = SelectData;
      }

      if (options.minimumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MinimumInputLength
        );
      }

      if (options.maximumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumInputLength
        );
      }

      if (options.maximumSelectionLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumSelectionLength
        );
      }

      if (options.tags) {
        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
      }

      if (options.tokenSeparators != null || options.tokenizer != null) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Tokenizer
        );
      }

      if (options.query != null) {
        var Query = require(options.amdBase + 'compat/query');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Query
        );
      }

      if (options.initSelection != null) {
        var InitSelection = require(options.amdBase + 'compat/initSelection');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          InitSelection
        );
      }
    }

    if (options.resultsAdapter == null) {
      options.resultsAdapter = ResultsList;

      if (options.ajax != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          InfiniteScroll
        );
      }

      if (options.placeholder != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          HidePlaceholder
        );
      }

      if (options.selectOnClose) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          SelectOnClose
        );
      }
    }

    if (options.dropdownAdapter == null) {
      if (options.multiple) {
        options.dropdownAdapter = Dropdown;
      } else {
        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);

        options.dropdownAdapter = SearchableDropdown;
      }

      if (options.minimumResultsForSearch !== 0) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          MinimumResultsForSearch
        );
      }

      if (options.closeOnSelect) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          CloseOnSelect
        );
      }

      if (
        options.dropdownCssClass != null ||
        options.dropdownCss != null ||
        options.adaptDropdownCssClass != null
      ) {
        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');

        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          DropdownCSS
        );
      }

      options.dropdownAdapter = Utils.Decorate(
        options.dropdownAdapter,
        AttachBody
      );
    }

    if (options.selectionAdapter == null) {
      if (options.multiple) {
        options.selectionAdapter = MultipleSelection;
      } else {
        options.selectionAdapter = SingleSelection;
      }

      // Add the placeholder mixin if a placeholder was specified
      if (options.placeholder != null) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          Placeholder
        );
      }

      if (options.allowClear) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          AllowClear
        );
      }

      if (options.multiple) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          SelectionSearch
        );
      }

      if (
        options.containerCssClass != null ||
        options.containerCss != null ||
        options.adaptContainerCssClass != null
      ) {
        var ContainerCSS = require(options.amdBase + 'compat/containerCss');

        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          ContainerCSS
        );
      }

      options.selectionAdapter = Utils.Decorate(
        options.selectionAdapter,
        EventRelay
      );
    }

    if (typeof options.language === 'string') {
      // Check if the language is specified with a region
      if (options.language.indexOf('-') > 0) {
        // Extract the region information if it is included
        var languageParts = options.language.split('-');
        var baseLanguage = languageParts[0];

        options.language = [options.language, baseLanguage];
      } else {
        options.language = [options.language];
      }
    }

    if ($.isArray(options.language)) {
      var languages = new Translation();
      options.language.push('en');

      var languageNames = options.language;

      for (var l = 0; l < languageNames.length; l++) {
        var name = languageNames[l];
        var language = {};

        try {
          // Try to load it with the original name
          language = Translation.loadPath(name);
        } catch (e) {
          try {
            // If we couldn't load it, check if it wasn't the full path
            name = this.defaults.amdLanguageBase + name;
            language = Translation.loadPath(name);
          } catch (ex) {
            // The translation could not be loaded at all. Sometimes this is
            // because of a configuration problem, other times this can be
            // because of how Select2 helps load all possible translation files.
            if (options.debug && window.console && console.warn) {
              console.warn(
                'Select2: The language file for "' + name + '" could not be ' +
                'automatically loaded. A fallback will be used instead.'
              );
            }

            continue;
          }
        }

        languages.extend(language);
      }

      options.translations = languages;
    } else {
      var baseTranslation = Translation.loadPath(
        this.defaults.amdLanguageBase + 'en'
      );
      var customTranslation = new Translation(options.language);

      customTranslation.extend(baseTranslation);

      options.translations = customTranslation;
    }

    return options;
  };

  Defaults.prototype.reset = function () {
    function stripDiacritics (text) {
      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
      function match(a) {
        return DIACRITICS[a] || a;
      }

      return text.replace(/[^\u0000-\u007E]/g, match);
    }

    function matcher (params, data) {
      // Always return the object if there is nothing to compare
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do a recursive check for options with children
      if (data.children && data.children.length > 0) {
        // Clone the data object if there are children
        // This is required as we modify the object to remove any non-matches
        var match = $.extend(true, {}, data);

        // Check each child of the option
        for (var c = data.children.length - 1; c >= 0; c--) {
          var child = data.children[c];

          var matches = matcher(params, child);

          // If there wasn't a match, remove the object in the array
          if (matches == null) {
            match.children.splice(c, 1);
          }
        }

        // If any children matched, return the new object
        if (match.children.length > 0) {
          return match;
        }

        // If there were no matching children, check just the plain object
        return matcher(params, match);
      }

      var original = stripDiacritics(data.text).toUpperCase();
      var term = stripDiacritics(params.term).toUpperCase();

      // Check if the text contains the term
      if (original.indexOf(term) > -1) {
        return data;
      }

      // If it doesn't contain the term, don't return anything
      return null;
    }

    this.defaults = {
      amdBase: './',
      amdLanguageBase: './i18n/',
      closeOnSelect: true,
      debug: false,
      dropdownAutoWidth: false,
      escapeMarkup: Utils.escapeMarkup,
      language: EnglishTranslation,
      matcher: matcher,
      minimumInputLength: 0,
      maximumInputLength: 0,
      maximumSelectionLength: 0,
      minimumResultsForSearch: 0,
      selectOnClose: false,
      sorter: function (data) {
        return data;
      },
      templateResult: function (result) {
        return result.text;
      },
      templateSelection: function (selection) {
        return selection.text;
      },
      theme: 'default',
      width: 'resolve'
    };
  };

  Defaults.prototype.set = function (key, value) {
    var camelKey = $.camelCase(key);

    var data = {};
    data[camelKey] = value;

    var convertedData = Utils._convertData(data);

    $.extend(this.defaults, convertedData);
  };

  var defaults = new Defaults();

  return defaults;
});

S2.define('select2/options',[
  'require',
  'jquery',
  './defaults',
  './utils'
], function (require, $, Defaults, Utils) {
  function Options (options, $element) {
    this.options = options;

    if ($element != null) {
      this.fromElement($element);
    }

    this.options = Defaults.apply(this.options);

    if ($element && $element.is('input')) {
      var InputCompat = require(this.get('amdBase') + 'compat/inputData');

      this.options.dataAdapter = Utils.Decorate(
        this.options.dataAdapter,
        InputCompat
      );
    }
  }

  Options.prototype.fromElement = function ($e) {
    var excludedData = ['select2'];

    if (this.options.multiple == null) {
      this.options.multiple = $e.prop('multiple');
    }

    if (this.options.disabled == null) {
      this.options.disabled = $e.prop('disabled');
    }

    if (this.options.language == null) {
      if ($e.prop('lang')) {
        this.options.language = $e.prop('lang').toLowerCase();
      } else if ($e.closest('[lang]').prop('lang')) {
        this.options.language = $e.closest('[lang]').prop('lang');
      }
    }

    if (this.options.dir == null) {
      if ($e.prop('dir')) {
        this.options.dir = $e.prop('dir');
      } else if ($e.closest('[dir]').prop('dir')) {
        this.options.dir = $e.closest('[dir]').prop('dir');
      } else {
        this.options.dir = 'ltr';
      }
    }

    $e.prop('disabled', this.options.disabled);
    $e.prop('multiple', this.options.multiple);

    if ($e.data('select2Tags')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-select2-tags` attribute has been changed to ' +
          'use the `data-data` and `data-tags="true"` attributes and will be ' +
          'removed in future versions of Select2.'
        );
      }

      $e.data('data', $e.data('select2Tags'));
      $e.data('tags', true);
    }

    if ($e.data('ajaxUrl')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-ajax-url` attribute has been changed to ' +
          '`data-ajax--url` and support for the old attribute will be removed' +
          ' in future versions of Select2.'
        );
      }

      $e.attr('ajax--url', $e.data('ajaxUrl'));
      $e.data('ajax--url', $e.data('ajaxUrl'));
    }

    var dataset = {};

    // Prefer the element's `dataset` attribute if it exists
    // jQuery 1.x does not correctly handle data attributes with multiple dashes
    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
      dataset = $.extend(true, {}, $e[0].dataset, $e.data());
    } else {
      dataset = $e.data();
    }

    var data = $.extend(true, {}, dataset);

    data = Utils._convertData(data);

    for (var key in data) {
      if ($.inArray(key, excludedData) > -1) {
        continue;
      }

      if ($.isPlainObject(this.options[key])) {
        $.extend(this.options[key], data[key]);
      } else {
        this.options[key] = data[key];
      }
    }

    return this;
  };

  Options.prototype.get = function (key) {
    return this.options[key];
  };

  Options.prototype.set = function (key, val) {
    this.options[key] = val;
  };

  return Options;
});

S2.define('select2/core',[
  'jquery',
  './options',
  './utils',
  './keys'
], function ($, Options, Utils, KEYS) {
  var Select2 = function ($element, options) {
    if ($element.data('select2') != null) {
      $element.data('select2').destroy();
    }

    this.$element = $element;

    this.id = this._generateId($element);

    options = options || {};

    this.options = new Options(options, $element);

    Select2.__super__.constructor.call(this);

    // Set up the tabindex

    var tabindex = $element.attr('tabindex') || 0;
    $element.data('old-tabindex', tabindex);
    $element.attr('tabindex', '-1');

    // Set up containers and adapters

    var DataAdapter = this.options.get('dataAdapter');
    this.dataAdapter = new DataAdapter($element, this.options);

    var $container = this.render();

    this._placeContainer($container);

    var SelectionAdapter = this.options.get('selectionAdapter');
    this.selection = new SelectionAdapter($element, this.options);
    this.$selection = this.selection.render();

    this.selection.position(this.$selection, $container);

    var DropdownAdapter = this.options.get('dropdownAdapter');
    this.dropdown = new DropdownAdapter($element, this.options);
    this.$dropdown = this.dropdown.render();

    this.dropdown.position(this.$dropdown, $container);

    var ResultsAdapter = this.options.get('resultsAdapter');
    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
    this.$results = this.results.render();

    this.results.position(this.$results, this.$dropdown);

    // Bind events

    var self = this;

    // Bind the container to all of the adapters
    this._bindAdapters();

    // Register any DOM event handlers
    this._registerDomEvents();

    // Register any internal event handlers
    this._registerDataEvents();
    this._registerSelectionEvents();
    this._registerDropdownEvents();
    this._registerResultsEvents();
    this._registerEvents();

    // Set the initial state
    this.dataAdapter.current(function (initialData) {
      self.trigger('selection:update', {
        data: initialData
      });
    });

    // Hide the original select
    $element.addClass('select2-hidden-accessible');
	$element.attr('aria-hidden', 'true');
	
    // Synchronize any monitored attributes
    this._syncAttributes();

    $element.data('select2', this);
  };

  Utils.Extend(Select2, Utils.Observable);

  Select2.prototype._generateId = function ($element) {
    var id = '';

    if ($element.attr('id') != null) {
      id = $element.attr('id');
    } else if ($element.attr('name') != null) {
      id = $element.attr('name') + '-' + Utils.generateChars(2);
    } else {
      id = Utils.generateChars(4);
    }

    id = 'select2-' + id;

    return id;
  };

  Select2.prototype._placeContainer = function ($container) {
    $container.insertAfter(this.$element);

    var width = this._resolveWidth(this.$element, this.options.get('width'));

    if (width != null) {
      $container.css('width', width);
    }
  };

  Select2.prototype._resolveWidth = function ($element, method) {
    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;

    if (method == 'resolve') {
      var styleWidth = this._resolveWidth($element, 'style');

      if (styleWidth != null) {
        return styleWidth;
      }

      return this._resolveWidth($element, 'element');
    }

    if (method == 'element') {
      var elementWidth = $element.outerWidth(false);

      if (elementWidth <= 0) {
        return 'auto';
      }

      return elementWidth + 'px';
    }

    if (method == 'style') {
      var style = $element.attr('style');

      if (typeof(style) !== 'string') {
        return null;
      }

      var attrs = style.split(';');

      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
        var attr = attrs[i].replace(/\s/g, '');
        var matches = attr.match(WIDTH);

        if (matches !== null && matches.length >= 1) {
          return matches[1];
        }
      }

      return null;
    }

    return method;
  };

  Select2.prototype._bindAdapters = function () {
    this.dataAdapter.bind(this, this.$container);
    this.selection.bind(this, this.$container);

    this.dropdown.bind(this, this.$container);
    this.results.bind(this, this.$container);
  };

  Select2.prototype._registerDomEvents = function () {
    var self = this;

    this.$element.on('change.select2', function () {
      self.dataAdapter.current(function (data) {
        self.trigger('selection:update', {
          data: data
        });
      });
    });

    this._sync = Utils.bind(this._syncAttributes, this);

    if (this.$element[0].attachEvent) {
      this.$element[0].attachEvent('onpropertychange', this._sync);
    }

    var observer = window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver
    ;

    if (observer != null) {
      this._observer = new observer(function (mutations) {
        $.each(mutations, self._sync);
      });
      this._observer.observe(this.$element[0], {
        attributes: true,
        subtree: false
      });
    } else if (this.$element[0].addEventListener) {
      this.$element[0].addEventListener('DOMAttrModified', self._sync, false);
    }
  };

  Select2.prototype._registerDataEvents = function () {
    var self = this;

    this.dataAdapter.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerSelectionEvents = function () {
    var self = this;
    var nonRelayEvents = ['toggle'];

    this.selection.on('toggle', function () {
      self.toggleDropdown();
    });

    this.selection.on('*', function (name, params) {
      if ($.inArray(name, nonRelayEvents) !== -1) {
        return;
      }

      self.trigger(name, params);
    });
  };

  Select2.prototype._registerDropdownEvents = function () {
    var self = this;

    this.dropdown.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerResultsEvents = function () {
    var self = this;

    this.results.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerEvents = function () {
    var self = this;

    this.on('open', function () {
      self.$container.addClass('select2-container--open');
    });

    this.on('close', function () {
      self.$container.removeClass('select2-container--open');
    });

    this.on('enable', function () {
      self.$container.removeClass('select2-container--disabled');
    });

    this.on('disable', function () {
      self.$container.addClass('select2-container--disabled');
    });

    this.on('focus', function () {
      self.$container.addClass('select2-container--focus');
    });

    this.on('blur', function () {
      self.$container.removeClass('select2-container--focus');
    });

    this.on('query', function (params) {
      if (!self.isOpen()) {
        self.trigger('open');
      }

      this.dataAdapter.query(params, function (data) {
        self.trigger('results:all', {
          data: data,
          query: params
        });
      });
    });

    this.on('query:append', function (params) {
      this.dataAdapter.query(params, function (data) {
        self.trigger('results:append', {
          data: data,
          query: params
        });
      });
    });

    this.on('keypress', function (evt) {
      var key = evt.which;

      if (self.isOpen()) {
        if (key === KEYS.ENTER) {
          self.trigger('results:select');

          evt.preventDefault();
        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
          self.trigger('results:toggle');

          evt.preventDefault();
        } else if (key === KEYS.UP) {
          self.trigger('results:previous');

          evt.preventDefault();
        } else if (key === KEYS.DOWN) {
          self.trigger('results:next');

          evt.preventDefault();
        } else if (key === KEYS.ESC || key === KEYS.TAB) {
          self.close();

          evt.preventDefault();
        }
      } else {
        if (key === KEYS.ENTER || key === KEYS.SPACE ||
            ((key === KEYS.DOWN || key === KEYS.UP) && evt.altKey)) {
          self.open();

          evt.preventDefault();
        }
      }
    });
  };

  Select2.prototype._syncAttributes = function () {
    this.options.set('disabled', this.$element.prop('disabled'));

    if (this.options.get('disabled')) {
      if (this.isOpen()) {
        this.close();
      }

      this.trigger('disable');
    } else {
      this.trigger('enable');
    }
  };

  /**
   * Override the trigger method to automatically trigger pre-events when
   * there are events that can be prevented.
   */
  Select2.prototype.trigger = function (name, args) {
    var actualTrigger = Select2.__super__.trigger;
    var preTriggerMap = {
      'open': 'opening',
      'close': 'closing',
      'select': 'selecting',
      'unselect': 'unselecting'
    };

    if (name in preTriggerMap) {
      var preTriggerName = preTriggerMap[name];
      var preTriggerArgs = {
        prevented: false,
        name: name,
        args: args
      };

      actualTrigger.call(this, preTriggerName, preTriggerArgs);

      if (preTriggerArgs.prevented) {
        args.prevented = true;

        return;
      }
    }

    actualTrigger.call(this, name, args);
  };

  Select2.prototype.toggleDropdown = function () {
    if (this.options.get('disabled')) {
      return;
    }

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  };

  Select2.prototype.open = function () {
    if (this.isOpen()) {
      return;
    }

    this.trigger('query', {});

    this.trigger('open');
  };

  Select2.prototype.close = function () {
    if (!this.isOpen()) {
      return;
    }

    this.trigger('close');
  };

  Select2.prototype.isOpen = function () {
    return this.$container.hasClass('select2-container--open');
  };

  Select2.prototype.enable = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("enable")` method has been deprecated and will' +
        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
        ' instead.'
      );
    }

    if (args == null || args.length === 0) {
      args = [true];
    }

    var disabled = !args[0];

    this.$element.prop('disabled', disabled);
  };

  Select2.prototype.data = function () {
    if (this.options.get('debug') &&
        arguments.length > 0 && window.console && console.warn) {
      console.warn(
        'Select2: Data can no longer be set using `select2("data")`. You ' +
        'should consider setting the value instead using `$element.val()`.'
      );
    }

    var data = [];

    this.dataAdapter.current(function (currentData) {
      data = currentData;
    });

    return data;
  };

  Select2.prototype.val = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("val")` method has been deprecated and will be' +
        ' removed in later Select2 versions. Use $element.val() instead.'
      );
    }

    if (args == null || args.length === 0) {
      return this.$element.val();
    }

    var newVal = args[0];

    if ($.isArray(newVal)) {
      newVal = $.map(newVal, function (obj) {
        return obj.toString();
      });
    }

    this.$element.val(newVal).trigger('change');
  };

  Select2.prototype.destroy = function () {
    this.$container.remove();

    if (this.$element[0].detachEvent) {
      this.$element[0].detachEvent('onpropertychange', this._sync);
    }

    if (this._observer != null) {
      this._observer.disconnect();
      this._observer = null;
    } else if (this.$element[0].removeEventListener) {
      this.$element[0]
        .removeEventListener('DOMAttrModified', this._sync, false);
    }

    this._sync = null;

    this.$element.off('.select2');
    this.$element.attr('tabindex', this.$element.data('old-tabindex'));

    this.$element.removeClass('select2-hidden-accessible');
	this.$element.attr('aria-hidden', 'false');
    this.$element.removeData('select2');

    this.dataAdapter.destroy();
    this.selection.destroy();
    this.dropdown.destroy();
    this.results.destroy();

    this.dataAdapter = null;
    this.selection = null;
    this.dropdown = null;
    this.results = null;
  };

  Select2.prototype.render = function () {
    var $container = $(
      '<span class="select2 select2-container">' +
        '<span class="selection"></span>' +
        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
      '</span>'
    );

    $container.attr('dir', this.options.get('dir'));

    this.$container = $container;

    this.$container.addClass('select2-container--' + this.options.get('theme'));

    $container.data('element', this.$element);

    return $container;
  };

  return Select2;
});

S2.define('jquery.select2',[
  'jquery',
  'require',

  './select2/core',
  './select2/defaults'
], function ($, require, Select2, Defaults) {
  // Force jQuery.mousewheel to be loaded if it hasn't already
  require('jquery.mousewheel');

  if ($.fn.select2 == null) {
    // All methods that should return the element
    var thisMethods = ['open', 'close', 'destroy'];

    $.fn.select2 = function (options) {
      options = options || {};

      if (typeof options === 'object') {
        this.each(function () {
          var instanceOptions = $.extend({}, options, true);

          var instance = new Select2($(this), instanceOptions);
        });

        return this;
      } else if (typeof options === 'string') {
        var instance = this.data('select2');

        if (instance == null && window.console && console.error) {
          console.error(
            'The select2(\'' + options + '\') method was called on an ' +
            'element that is not using Select2.'
          );
        }

        var args = Array.prototype.slice.call(arguments, 1);

        var ret = instance[options](args);

        // Check if we should be returning `this`
        if ($.inArray(options, thisMethods) > -1) {
          return this;
        }

        return ret;
      } else {
        throw new Error('Invalid arguments for Select2: ' + options);
      }
    };
  }

  if ($.fn.select2.defaults == null) {
    $.fn.select2.defaults = Defaults;
  }

  return Select2;
});

S2.define('jquery.mousewheel',[
  'jquery'
], function ($) {
  // Used to shim jQuery.mousewheel for non-full builds.
  return $;
});

  // Return the AMD loader configuration so it can be used outside of this file
  return {
    define: S2.define,
    require: S2.require
  };
}());

  // Autoload the jQuery bindings
  // We know that all of the modules exist above this, so we're safe
  var select2 = S2.require('jquery.select2');

  // Hold the AMD module references on the jQuery function that was just loaded
  // This allows Select2 to use the internal loader outside of this file, such
  // as in the language files.
  jQuery.fn.select2.amd = S2;

  // Return the Select2 instance for anyone who is importing it.
  return select2;
}));

},{"jquery":14,"jquery.mousewheel":48}],51:[function(require,module,exports){
(function (setImmediate){(function (){
/*!
 * typeahead.js 0.11.1
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
 */

(function(root, factory) {
    if (typeof define === "function" && define.amd) {
        define("typeahead.js", [ "jquery" ], function(a0) {
            return factory(a0);
        });
    } else if (typeof exports === "object") {
        module.exports = factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(this, function($) {
    var _ = function() {
        "use strict";
        return {
            isMsie: function() {
                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
            },
            isBlankString: function(str) {
                return !str || /^\s*$/.test(str);
            },
            escapeRegExChars: function(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            },
            isString: function(obj) {
                return typeof obj === "string";
            },
            isNumber: function(obj) {
                return typeof obj === "number";
            },
            isArray: $.isArray,
            isFunction: $.isFunction,
            isObject: $.isPlainObject,
            isUndefined: function(obj) {
                return typeof obj === "undefined";
            },
            isElement: function(obj) {
                return !!(obj && obj.nodeType === 1);
            },
            isJQuery: function(obj) {
                return obj instanceof $;
            },
            toStr: function toStr(s) {
                return _.isUndefined(s) || s === null ? "" : s + "";
            },
            bind: $.proxy,
            each: function(collection, cb) {
                $.each(collection, reverseArgs);
                function reverseArgs(index, value) {
                    return cb(value, index);
                }
            },
            map: $.map,
            filter: $.grep,
            every: function(obj, test) {
                var result = true;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (!(result = test.call(null, val, key, obj))) {
                        return false;
                    }
                });
                return !!result;
            },
            some: function(obj, test) {
                var result = false;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (result = test.call(null, val, key, obj)) {
                        return false;
                    }
                });
                return !!result;
            },
            mixin: $.extend,
            identity: function(x) {
                return x;
            },
            clone: function(obj) {
                return $.extend(true, {}, obj);
            },
            getIdGenerator: function() {
                var counter = 0;
                return function() {
                    return counter++;
                };
            },
            templatify: function templatify(obj) {
                return $.isFunction(obj) ? obj : template;
                function template() {
                    return String(obj);
                }
            },
            defer: function(fn) {
                setTimeout(fn, 0);
            },
            debounce: function(func, wait, immediate) {
                var timeout, result;
                return function() {
                    var context = this, args = arguments, later, callNow;
                    later = function() {
                        timeout = null;
                        if (!immediate) {
                            result = func.apply(context, args);
                        }
                    };
                    callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) {
                        result = func.apply(context, args);
                    }
                    return result;
                };
            },
            throttle: function(func, wait) {
                var context, args, timeout, result, previous, later;
                previous = 0;
                later = function() {
                    previous = new Date();
                    timeout = null;
                    result = func.apply(context, args);
                };
                return function() {
                    var now = new Date(), remaining = wait - (now - previous);
                    context = this;
                    args = arguments;
                    if (remaining <= 0) {
                        clearTimeout(timeout);
                        timeout = null;
                        previous = now;
                        result = func.apply(context, args);
                    } else if (!timeout) {
                        timeout = setTimeout(later, remaining);
                    }
                    return result;
                };
            },
            stringify: function(val) {
                return _.isString(val) ? val : JSON.stringify(val);
            },
            noop: function() {}
        };
    }();
    var WWW = function() {
        "use strict";
        var defaultClassNames = {
            wrapper: "twitter-typeahead",
            input: "tt-input",
            hint: "tt-hint",
            menu: "tt-menu",
            dataset: "tt-dataset",
            suggestion: "tt-suggestion",
            selectable: "tt-selectable",
            empty: "tt-empty",
            open: "tt-open",
            cursor: "tt-cursor",
            highlight: "tt-highlight"
        };
        return build;
        function build(o) {
            var www, classes;
            classes = _.mixin({}, defaultClassNames, o);
            www = {
                css: buildCss(),
                classes: classes,
                html: buildHtml(classes),
                selectors: buildSelectors(classes)
            };
            return {
                css: www.css,
                html: www.html,
                classes: www.classes,
                selectors: www.selectors,
                mixin: function(o) {
                    _.mixin(o, www);
                }
            };
        }
        function buildHtml(c) {
            return {
                wrapper: '<span class="' + c.wrapper + '"></span>',
                menu: '<div class="' + c.menu + '"></div>'
            };
        }
        function buildSelectors(classes) {
            var selectors = {};
            _.each(classes, function(v, k) {
                selectors[k] = "." + v;
            });
            return selectors;
        }
        function buildCss() {
            var css = {
                wrapper: {
                    position: "relative",
                    display: "inline-block"
                },
                hint: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    borderColor: "transparent",
                    boxShadow: "none",
                    opacity: "1"
                },
                input: {
                    position: "relative",
                    verticalAlign: "top",
                    backgroundColor: "transparent"
                },
                inputWithNoHint: {
                    position: "relative",
                    verticalAlign: "top"
                },
                menu: {
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    zIndex: "100",
                    display: "none"
                },
                ltr: {
                    left: "0",
                    right: "auto"
                },
                rtl: {
                    left: "auto",
                    right: " 0"
                }
            };
            if (_.isMsie()) {
                _.mixin(css.input, {
                    backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
                });
            }
            return css;
        }
    }();
    var EventBus = function() {
        "use strict";
        var namespace, deprecationMap;
        namespace = "typeahead:";
        deprecationMap = {
            render: "rendered",
            cursorchange: "cursorchanged",
            select: "selected",
            autocomplete: "autocompleted"
        };
        function EventBus(o) {
            if (!o || !o.el) {
                $.error("EventBus initialized without el");
            }
            this.$el = $(o.el);
        }
        _.mixin(EventBus.prototype, {
            _trigger: function(type, args) {
                var $e;
                $e = $.Event(namespace + type);
                (args = args || []).unshift($e);
                this.$el.trigger.apply(this.$el, args);
                return $e;
            },
            before: function(type) {
                var args, $e;
                args = [].slice.call(arguments, 1);
                $e = this._trigger("before" + type, args);
                return $e.isDefaultPrevented();
            },
            trigger: function(type) {
                var deprecatedType;
                this._trigger(type, [].slice.call(arguments, 1));
                if (deprecatedType = deprecationMap[type]) {
                    this._trigger(deprecatedType, [].slice.call(arguments, 1));
                }
            }
        });
        return EventBus;
    }();
    var EventEmitter = function() {
        "use strict";
        var splitter = /\s+/, nextTick = getNextTick();
        return {
            onSync: onSync,
            onAsync: onAsync,
            off: off,
            trigger: trigger
        };
        function on(method, types, cb, context) {
            var type;
            if (!cb) {
                return this;
            }
            types = types.split(splitter);
            cb = context ? bindContext(cb, context) : cb;
            this._callbacks = this._callbacks || {};
            while (type = types.shift()) {
                this._callbacks[type] = this._callbacks[type] || {
                    sync: [],
                    async: []
                };
                this._callbacks[type][method].push(cb);
            }
            return this;
        }
        function onAsync(types, cb, context) {
            return on.call(this, "async", types, cb, context);
        }
        function onSync(types, cb, context) {
            return on.call(this, "sync", types, cb, context);
        }
        function off(types) {
            var type;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            while (type = types.shift()) {
                delete this._callbacks[type];
            }
            return this;
        }
        function trigger(types) {
            var type, callbacks, args, syncFlush, asyncFlush;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            args = [].slice.call(arguments, 1);
            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
                syncFlush() && nextTick(asyncFlush);
            }
            return this;
        }
        function getFlush(callbacks, context, args) {
            return flush;
            function flush() {
                var cancelled;
                for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
                    cancelled = callbacks[i].apply(context, args) === false;
                }
                return !cancelled;
            }
        }
        function getNextTick() {
            var nextTickFn;
            if (window.setImmediate) {
                nextTickFn = function nextTickSetImmediate(fn) {
                    setImmediate(function() {
                        fn();
                    });
                };
            } else {
                nextTickFn = function nextTickSetTimeout(fn) {
                    setTimeout(function() {
                        fn();
                    }, 0);
                };
            }
            return nextTickFn;
        }
        function bindContext(fn, context) {
            return fn.bind ? fn.bind(context) : function() {
                fn.apply(context, [].slice.call(arguments, 0));
            };
        }
    }();
    var highlight = function(doc) {
        "use strict";
        var defaults = {
            node: null,
            pattern: null,
            tagName: "strong",
            className: null,
            wordsOnly: false,
            caseSensitive: false
        };
        return function hightlight(o) {
            var regex;
            o = _.mixin({}, defaults, o);
            if (!o.node || !o.pattern) {
                return;
            }
            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
            traverse(o.node, hightlightTextNode);
            function hightlightTextNode(textNode) {
                var match, patternNode, wrapperNode;
                if (match = regex.exec(textNode.data)) {
                    wrapperNode = doc.createElement(o.tagName);
                    o.className && (wrapperNode.className = o.className);
                    patternNode = textNode.splitText(match.index);
                    patternNode.splitText(match[0].length);
                    wrapperNode.appendChild(patternNode.cloneNode(true));
                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
                }
                return !!match;
            }
            function traverse(el, hightlightTextNode) {
                var childNode, TEXT_NODE_TYPE = 3;
                for (var i = 0; i < el.childNodes.length; i++) {
                    childNode = el.childNodes[i];
                    if (childNode.nodeType === TEXT_NODE_TYPE) {
                        i += hightlightTextNode(childNode) ? 1 : 0;
                    } else {
                        traverse(childNode, hightlightTextNode);
                    }
                }
            }
        };
        function getRegex(patterns, caseSensitive, wordsOnly) {
            var escapedPatterns = [], regexStr;
            for (var i = 0, len = patterns.length; i < len; i++) {
                escapedPatterns.push(_.escapeRegExChars(patterns[i]));
            }
            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
        }
    }(window.document);
    var Input = function() {
        "use strict";
        var specialKeyCodeMap;
        specialKeyCodeMap = {
            9: "tab",
            27: "esc",
            37: "left",
            39: "right",
            13: "enter",
            38: "up",
            40: "down"
        };
        function Input(o, www) {
            o = o || {};
            if (!o.input) {
                $.error("input is missing");
            }
            www.mixin(this);
            this.$hint = $(o.hint);
            this.$input = $(o.input);
            this.query = this.$input.val();
            this.queryWhenFocused = this.hasFocus() ? this.query : null;
            this.$overflowHelper = buildOverflowHelper(this.$input);
            this._checkLanguageDirection();
            if (this.$hint.length === 0) {
                this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
            }
        }
        Input.normalizeQuery = function(str) {
            return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
        };
        _.mixin(Input.prototype, EventEmitter, {
            _onBlur: function onBlur() {
                this.resetInputValue();
                this.trigger("blurred");
            },
            _onFocus: function onFocus() {
                this.queryWhenFocused = this.query;
                this.trigger("focused");
            },
            _onKeydown: function onKeydown($e) {
                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
                this._managePreventDefault(keyName, $e);
                if (keyName && this._shouldTrigger(keyName, $e)) {
                    this.trigger(keyName + "Keyed", $e);
                }
            },
            _onInput: function onInput() {
                this._setQuery(this.getInputValue());
                this.clearHintIfInvalid();
                this._checkLanguageDirection();
            },
            _managePreventDefault: function managePreventDefault(keyName, $e) {
                var preventDefault;
                switch (keyName) {
                  case "up":
                  case "down":
                    preventDefault = !withModifier($e);
                    break;

                  default:
                    preventDefault = false;
                }
                preventDefault && $e.preventDefault();
            },
            _shouldTrigger: function shouldTrigger(keyName, $e) {
                var trigger;
                switch (keyName) {
                  case "tab":
                    trigger = !withModifier($e);
                    break;

                  default:
                    trigger = true;
                }
                return trigger;
            },
            _checkLanguageDirection: function checkLanguageDirection() {
                var dir = (this.$input.css("direction") || "ltr").toLowerCase();
                if (this.dir !== dir) {
                    this.dir = dir;
                    this.$hint.attr("dir", dir);
                    this.trigger("langDirChanged", dir);
                }
            },
            _setQuery: function setQuery(val, silent) {
                var areEquivalent, hasDifferentWhitespace;
                areEquivalent = areQueriesEquivalent(val, this.query);
                hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
                this.query = val;
                if (!silent && !areEquivalent) {
                    this.trigger("queryChanged", this.query);
                } else if (!silent && hasDifferentWhitespace) {
                    this.trigger("whitespaceChanged", this.query);
                }
            },
            bind: function() {
                var that = this, onBlur, onFocus, onKeydown, onInput;
                onBlur = _.bind(this._onBlur, this);
                onFocus = _.bind(this._onFocus, this);
                onKeydown = _.bind(this._onKeydown, this);
                onInput = _.bind(this._onInput, this);
                this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
                if (!_.isMsie() || _.isMsie() > 9) {
                    this.$input.on("input.tt", onInput);
                } else {
                    this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
                        if (specialKeyCodeMap[$e.which || $e.keyCode]) {
                            return;
                        }
                        _.defer(_.bind(that._onInput, that, $e));
                    });
                }
                return this;
            },
            focus: function focus() {
                this.$input.focus();
            },
            blur: function blur() {
                this.$input.blur();
            },
            getLangDir: function getLangDir() {
                return this.dir;
            },
            getQuery: function getQuery() {
                return this.query || "";
            },
            setQuery: function setQuery(val, silent) {
                this.setInputValue(val);
                this._setQuery(val, silent);
            },
            hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
                return this.query !== this.queryWhenFocused;
            },
            getInputValue: function getInputValue() {
                return this.$input.val();
            },
            setInputValue: function setInputValue(value) {
                this.$input.val(value);
                this.clearHintIfInvalid();
                this._checkLanguageDirection();
            },
            resetInputValue: function resetInputValue() {
                this.setInputValue(this.query);
            },
            getHint: function getHint() {
                return this.$hint.val();
            },
            setHint: function setHint(value) {
                this.$hint.val(value);
            },
            clearHint: function clearHint() {
                this.setHint("");
            },
            clearHintIfInvalid: function clearHintIfInvalid() {
                var val, hint, valIsPrefixOfHint, isValid;
                val = this.getInputValue();
                hint = this.getHint();
                valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
                isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
                !isValid && this.clearHint();
            },
            hasFocus: function hasFocus() {
                return this.$input.is(":focus");
            },
            hasOverflow: function hasOverflow() {
                var constraint = this.$input.width() - 2;
                this.$overflowHelper.text(this.getInputValue());
                return this.$overflowHelper.width() >= constraint;
            },
            isCursorAtEnd: function() {
                var valueLength, selectionStart, range;
                valueLength = this.$input.val().length;
                selectionStart = this.$input[0].selectionStart;
                if (_.isNumber(selectionStart)) {
                    return selectionStart === valueLength;
                } else if (document.selection) {
                    range = document.selection.createRange();
                    range.moveStart("character", -valueLength);
                    return valueLength === range.text.length;
                }
                return true;
            },
            destroy: function destroy() {
                this.$hint.off(".tt");
                this.$input.off(".tt");
                this.$overflowHelper.remove();
                this.$hint = this.$input = this.$overflowHelper = $("<div>");
            }
        });
        return Input;
        function buildOverflowHelper($input) {
            return $('<pre aria-hidden="true"></pre>').css({
                position: "absolute",
                visibility: "hidden",
                whiteSpace: "pre",
                fontFamily: $input.css("font-family"),
                fontSize: $input.css("font-size"),
                fontStyle: $input.css("font-style"),
                fontVariant: $input.css("font-variant"),
                fontWeight: $input.css("font-weight"),
                wordSpacing: $input.css("word-spacing"),
                letterSpacing: $input.css("letter-spacing"),
                textIndent: $input.css("text-indent"),
                textRendering: $input.css("text-rendering"),
                textTransform: $input.css("text-transform")
            }).insertAfter($input);
        }
        function areQueriesEquivalent(a, b) {
            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
        }
        function withModifier($e) {
            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
        }
    }();
    var Dataset = function() {
        "use strict";
        var keys, nameGenerator;
        keys = {
            val: "tt-selectable-display",
            obj: "tt-selectable-object"
        };
        nameGenerator = _.getIdGenerator();
        function Dataset(o, www) {
            o = o || {};
            o.templates = o.templates || {};
            o.templates.notFound = o.templates.notFound || o.templates.empty;
            if (!o.source) {
                $.error("missing source");
            }
            if (!o.node) {
                $.error("missing node");
            }
            if (o.name && !isValidName(o.name)) {
                $.error("invalid dataset name: " + o.name);
            }
            www.mixin(this);
            this.highlight = !!o.highlight;
            this.name = o.name || nameGenerator();
            this.limit = o.limit || 5;
            this.displayFn = getDisplayFn(o.display || o.displayKey);
            this.templates = getTemplates(o.templates, this.displayFn);
            this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
            this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
            this._resetLastSuggestion();
            this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
        }
        Dataset.extractData = function extractData(el) {
            var $el = $(el);
            if ($el.data(keys.obj)) {
                return {
                    val: $el.data(keys.val) || "",
                    obj: $el.data(keys.obj) || null
                };
            }
            return null;
        };
        _.mixin(Dataset.prototype, EventEmitter, {
            _overwrite: function overwrite(query, suggestions) {
                suggestions = suggestions || [];
                if (suggestions.length) {
                    this._renderSuggestions(query, suggestions);
                } else if (this.async && this.templates.pending) {
                    this._renderPending(query);
                } else if (!this.async && this.templates.notFound) {
                    this._renderNotFound(query);
                } else {
                    this._empty();
                }
                this.trigger("rendered", this.name, suggestions, false);
            },
            _append: function append(query, suggestions) {
                suggestions = suggestions || [];
                if (suggestions.length && this.$lastSuggestion.length) {
                    this._appendSuggestions(query, suggestions);
                } else if (suggestions.length) {
                    this._renderSuggestions(query, suggestions);
                } else if (!this.$lastSuggestion.length && this.templates.notFound) {
                    this._renderNotFound(query);
                }
                this.trigger("rendered", this.name, suggestions, true);
            },
            _renderSuggestions: function renderSuggestions(query, suggestions) {
                var $fragment;
                $fragment = this._getSuggestionsFragment(query, suggestions);
                this.$lastSuggestion = $fragment.children().last();
                this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
            },
            _appendSuggestions: function appendSuggestions(query, suggestions) {
                var $fragment, $lastSuggestion;
                $fragment = this._getSuggestionsFragment(query, suggestions);
                $lastSuggestion = $fragment.children().last();
                this.$lastSuggestion.after($fragment);
                this.$lastSuggestion = $lastSuggestion;
            },
            _renderPending: function renderPending(query) {
                var template = this.templates.pending;
                this._resetLastSuggestion();
                template && this.$el.html(template({
                    query: query,
                    dataset: this.name
                }));
            },
            _renderNotFound: function renderNotFound(query) {
                var template = this.templates.notFound;
                this._resetLastSuggestion();
                template && this.$el.html(template({
                    query: query,
                    dataset: this.name
                }));
            },
            _empty: function empty() {
                this.$el.empty();
                this._resetLastSuggestion();
            },
            _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
                var that = this, fragment;
                fragment = document.createDocumentFragment();
                _.each(suggestions, function getSuggestionNode(suggestion) {
                    var $el, context;
                    context = that._injectQuery(query, suggestion);
                    $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
                    fragment.appendChild($el[0]);
                });
                this.highlight && highlight({
                    className: this.classes.highlight,
                    node: fragment,
                    pattern: query
                });
                return $(fragment);
            },
            _getFooter: function getFooter(query, suggestions) {
                return this.templates.footer ? this.templates.footer({
                    query: query,
                    suggestions: suggestions,
                    dataset: this.name
                }) : null;
            },
            _getHeader: function getHeader(query, suggestions) {
                return this.templates.header ? this.templates.header({
                    query: query,
                    suggestions: suggestions,
                    dataset: this.name
                }) : null;
            },
            _resetLastSuggestion: function resetLastSuggestion() {
                this.$lastSuggestion = $();
            },
            _injectQuery: function injectQuery(query, obj) {
                return _.isObject(obj) ? _.mixin({
                    _query: query
                }, obj) : obj;
            },
            update: function update(query) {
                var that = this, canceled = false, syncCalled = false, rendered = 0;
                this.cancel();
                this.cancel = function cancel() {
                    canceled = true;
                    that.cancel = $.noop;
                    that.async && that.trigger("asyncCanceled", query);
                };
                this.source(query, sync, async);
                !syncCalled && sync([]);
                function sync(suggestions) {
                    if (syncCalled) {
                        return;
                    }
                    syncCalled = true;
                    suggestions = (suggestions || []).slice(0, that.limit);
                    rendered = suggestions.length;
                    that._overwrite(query, suggestions);
                    if (rendered < that.limit && that.async) {
                        that.trigger("asyncRequested", query);
                    }
                }
                function async(suggestions) {
                    suggestions = suggestions || [];
                    if (!canceled && rendered < that.limit) {
                        that.cancel = $.noop;
                        rendered += suggestions.length;
                        that._append(query, suggestions.slice(0, that.limit - rendered));
                        that.async && that.trigger("asyncReceived", query);
                    }
                }
            },
            cancel: $.noop,
            clear: function clear() {
                this._empty();
                this.cancel();
                this.trigger("cleared");
            },
            isEmpty: function isEmpty() {
                return this.$el.is(":empty");
            },
            destroy: function destroy() {
                this.$el = $("<div>");
            }
        });
        return Dataset;
        function getDisplayFn(display) {
            display = display || _.stringify;
            return _.isFunction(display) ? display : displayFn;
            function displayFn(obj) {
                return obj[display];
            }
        }
        function getTemplates(templates, displayFn) {
            return {
                notFound: templates.notFound && _.templatify(templates.notFound),
                pending: templates.pending && _.templatify(templates.pending),
                header: templates.header && _.templatify(templates.header),
                footer: templates.footer && _.templatify(templates.footer),
                suggestion: templates.suggestion || suggestionTemplate
            };
            function suggestionTemplate(context) {
                return $("<div>").text(displayFn(context));
            }
        }
        function isValidName(str) {
            return /^[_a-zA-Z0-9-]+$/.test(str);
        }
    }();
    var Menu = function() {
        "use strict";
        function Menu(o, www) {
            var that = this;
            o = o || {};
            if (!o.node) {
                $.error("node is required");
            }
            www.mixin(this);
            this.$node = $(o.node);
            this.query = null;
            this.datasets = _.map(o.datasets, initializeDataset);
            function initializeDataset(oDataset) {
                var node = that.$node.find(oDataset.node).first();
                oDataset.node = node.length ? node : $("<div>").appendTo(that.$node);
                return new Dataset(oDataset, www);
            }
        }
        _.mixin(Menu.prototype, EventEmitter, {
            _onSelectableClick: function onSelectableClick($e) {
                this.trigger("selectableClicked", $($e.currentTarget));
            },
            _onRendered: function onRendered(type, dataset, suggestions, async) {
                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
                this.trigger("datasetRendered", dataset, suggestions, async);
            },
            _onCleared: function onCleared() {
                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
                this.trigger("datasetCleared");
            },
            _propagate: function propagate() {
                this.trigger.apply(this, arguments);
            },
            _allDatasetsEmpty: function allDatasetsEmpty() {
                return _.every(this.datasets, isDatasetEmpty);
                function isDatasetEmpty(dataset) {
                    return dataset.isEmpty();
                }
            },
            _getSelectables: function getSelectables() {
                return this.$node.find(this.selectors.selectable);
            },
            _removeCursor: function _removeCursor() {
                var $selectable = this.getActiveSelectable();
                $selectable && $selectable.removeClass(this.classes.cursor);
            },
            _ensureVisible: function ensureVisible($el) {
                var elTop, elBottom, nodeScrollTop, nodeHeight;
                elTop = $el.position().top;
                elBottom = elTop + $el.outerHeight(true);
                nodeScrollTop = this.$node.scrollTop();
                nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
                if (elTop < 0) {
                    this.$node.scrollTop(nodeScrollTop + elTop);
                } else if (nodeHeight < elBottom) {
                    this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
                }
            },
            bind: function() {
                var that = this, onSelectableClick;
                onSelectableClick = _.bind(this._onSelectableClick, this);
                this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
                _.each(this.datasets, function(dataset) {
                    dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
                });
                return this;
            },
            isOpen: function isOpen() {
                return this.$node.hasClass(this.classes.open);
            },
            open: function open() {
                this.$node.addClass(this.classes.open);
            },
            close: function close() {
                this.$node.removeClass(this.classes.open);
                this._removeCursor();
            },
            setLanguageDirection: function setLanguageDirection(dir) {
                this.$node.attr("dir", dir);
            },
            selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
                var $selectables, $oldCursor, oldIndex, newIndex;
                $oldCursor = this.getActiveSelectable();
                $selectables = this._getSelectables();
                oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
                newIndex = oldIndex + delta;
                newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
                newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
                return newIndex === -1 ? null : $selectables.eq(newIndex);
            },
            setCursor: function setCursor($selectable) {
                this._removeCursor();
                if ($selectable = $selectable && $selectable.first()) {
                    $selectable.addClass(this.classes.cursor);
                    this._ensureVisible($selectable);
                }
            },
            getSelectableData: function getSelectableData($el) {
                return $el && $el.length ? Dataset.extractData($el) : null;
            },
            getActiveSelectable: function getActiveSelectable() {
                var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
                return $selectable.length ? $selectable : null;
            },
            getTopSelectable: function getTopSelectable() {
                var $selectable = this._getSelectables().first();
                return $selectable.length ? $selectable : null;
            },
            update: function update(query) {
                var isValidUpdate = query !== this.query;
                if (isValidUpdate) {
                    this.query = query;
                    _.each(this.datasets, updateDataset);
                }
                return isValidUpdate;
                function updateDataset(dataset) {
                    dataset.update(query);
                }
            },
            empty: function empty() {
                _.each(this.datasets, clearDataset);
                this.query = null;
                this.$node.addClass(this.classes.empty);
                function clearDataset(dataset) {
                    dataset.clear();
                }
            },
            destroy: function destroy() {
                this.$node.off(".tt");
                this.$node = $("<div>");
                _.each(this.datasets, destroyDataset);
                function destroyDataset(dataset) {
                    dataset.destroy();
                }
            }
        });
        return Menu;
    }();
    var DefaultMenu = function() {
        "use strict";
        var s = Menu.prototype;
        function DefaultMenu() {
            Menu.apply(this, [].slice.call(arguments, 0));
        }
        _.mixin(DefaultMenu.prototype, Menu.prototype, {
            open: function open() {
                !this._allDatasetsEmpty() && this._show();
                return s.open.apply(this, [].slice.call(arguments, 0));
            },
            close: function close() {
                this._hide();
                return s.close.apply(this, [].slice.call(arguments, 0));
            },
            _onRendered: function onRendered() {
                if (this._allDatasetsEmpty()) {
                    this._hide();
                } else {
                    this.isOpen() && this._show();
                }
                return s._onRendered.apply(this, [].slice.call(arguments, 0));
            },
            _onCleared: function onCleared() {
                if (this._allDatasetsEmpty()) {
                    this._hide();
                } else {
                    this.isOpen() && this._show();
                }
                return s._onCleared.apply(this, [].slice.call(arguments, 0));
            },
            setLanguageDirection: function setLanguageDirection(dir) {
                this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
                return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
            },
            _hide: function hide() {
                this.$node.hide();
            },
            _show: function show() {
                this.$node.css("display", "block");
            }
        });
        return DefaultMenu;
    }();
    var Typeahead = function() {
        "use strict";
        function Typeahead(o, www) {
            var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
            o = o || {};
            if (!o.input) {
                $.error("missing input");
            }
            if (!o.menu) {
                $.error("missing menu");
            }
            if (!o.eventBus) {
                $.error("missing event bus");
            }
            www.mixin(this);
            this.eventBus = o.eventBus;
            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
            this.input = o.input;
            this.menu = o.menu;
            this.enabled = true;
            this.active = false;
            this.input.hasFocus() && this.activate();
            this.dir = this.input.getLangDir();
            this._hacks();
            this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
            onFocused = c(this, "activate", "open", "_onFocused");
            onBlurred = c(this, "deactivate", "_onBlurred");
            onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
            onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
            onEscKeyed = c(this, "isActive", "_onEscKeyed");
            onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
            onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
            onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
            onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
            onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
            onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
            this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
        }
        _.mixin(Typeahead.prototype, {
            _hacks: function hacks() {
                var $input, $menu;
                $input = this.input.$input || $("<div>");
                $menu = this.menu.$node || $("<div>");
                $input.on("blur.tt", function($e) {
                    var active, isActive, hasActive;
                    active = document.activeElement;
                    isActive = $menu.is(active);
                    hasActive = $menu.has(active).length > 0;
                    if (_.isMsie() && (isActive || hasActive)) {
                        $e.preventDefault();
                        $e.stopImmediatePropagation();
                        _.defer(function() {
                            $input.focus();
                        });
                    }
                });
                $menu.on("mousedown.tt", function($e) {
                    $e.preventDefault();
                });
            },
            _onSelectableClicked: function onSelectableClicked(type, $el) {
                this.select($el);
            },
            _onDatasetCleared: function onDatasetCleared() {
                this._updateHint();
            },
            _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
                this._updateHint();
                this.eventBus.trigger("render", suggestions, async, dataset);
            },
            _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
                this.eventBus.trigger("asyncrequest", query, dataset);
            },
            _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
                this.eventBus.trigger("asynccancel", query, dataset);
            },
            _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
                this.eventBus.trigger("asyncreceive", query, dataset);
            },
            _onFocused: function onFocused() {
                this._minLengthMet() && this.menu.update(this.input.getQuery());
            },
            _onBlurred: function onBlurred() {
                if (this.input.hasQueryChangedSinceLastFocus()) {
                    this.eventBus.trigger("change", this.input.getQuery());
                }
            },
            _onEnterKeyed: function onEnterKeyed(type, $e) {
                var $selectable;
                if ($selectable = this.menu.getActiveSelectable()) {
                    this.select($selectable) && $e.preventDefault();
                }
            },
            _onTabKeyed: function onTabKeyed(type, $e) {
                var $selectable;
                if ($selectable = this.menu.getActiveSelectable()) {
                    this.select($selectable) && $e.preventDefault();
                } else if ($selectable = this.menu.getTopSelectable()) {
                    this.autocomplete($selectable) && $e.preventDefault();
                }
            },
            _onEscKeyed: function onEscKeyed() {
                this.close();
            },
            _onUpKeyed: function onUpKeyed() {
                this.moveCursor(-1);
            },
            _onDownKeyed: function onDownKeyed() {
                this.moveCursor(+1);
            },
            _onLeftKeyed: function onLeftKeyed() {
                if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
                    this.autocomplete(this.menu.getTopSelectable());
                }
            },
            _onRightKeyed: function onRightKeyed() {
                if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
                    this.autocomplete(this.menu.getTopSelectable());
                }
            },
            _onQueryChanged: function onQueryChanged(e, query) {
                this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
            },
            _onWhitespaceChanged: function onWhitespaceChanged() {
                this._updateHint();
            },
            _onLangDirChanged: function onLangDirChanged(e, dir) {
                if (this.dir !== dir) {
                    this.dir = dir;
                    this.menu.setLanguageDirection(dir);
                }
            },
            _openIfActive: function openIfActive() {
                this.isActive() && this.open();
            },
            _minLengthMet: function minLengthMet(query) {
                query = _.isString(query) ? query : this.input.getQuery() || "";
                return query.length >= this.minLength;
            },
            _updateHint: function updateHint() {
                var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
                $selectable = this.menu.getTopSelectable();
                data = this.menu.getSelectableData($selectable);
                val = this.input.getInputValue();
                if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
                    query = Input.normalizeQuery(val);
                    escapedQuery = _.escapeRegExChars(query);
                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
                    match = frontMatchRegEx.exec(data.val);
                    match && this.input.setHint(val + match[1]);
                } else {
                    this.input.clearHint();
                }
            },
            isEnabled: function isEnabled() {
                return this.enabled;
            },
            enable: function enable() {
                this.enabled = true;
            },
            disable: function disable() {
                this.enabled = false;
            },
            isActive: function isActive() {
                return this.active;
            },
            activate: function activate() {
                if (this.isActive()) {
                    return true;
                } else if (!this.isEnabled() || this.eventBus.before("active")) {
                    return false;
                } else {
                    this.active = true;
                    this.eventBus.trigger("active");
                    return true;
                }
            },
            deactivate: function deactivate() {
                if (!this.isActive()) {
                    return true;
                } else if (this.eventBus.before("idle")) {
                    return false;
                } else {
                    this.active = false;
                    this.close();
                    this.eventBus.trigger("idle");
                    return true;
                }
            },
            isOpen: function isOpen() {
                return this.menu.isOpen();
            },
            open: function open() {
                if (!this.isOpen() && !this.eventBus.before("open")) {
                    this.menu.open();
                    this._updateHint();
                    this.eventBus.trigger("open");
                }
                return this.isOpen();
            },
            close: function close() {
                if (this.isOpen() && !this.eventBus.before("close")) {
                    this.menu.close();
                    this.input.clearHint();
                    this.input.resetInputValue();
                    this.eventBus.trigger("close");
                }
                return !this.isOpen();
            },
            setVal: function setVal(val) {
                this.input.setQuery(_.toStr(val));
            },
            getVal: function getVal() {
                return this.input.getQuery();
            },
            select: function select($selectable) {
                var data = this.menu.getSelectableData($selectable);
                if (data && !this.eventBus.before("select", data.obj)) {
                    this.input.setQuery(data.val, true);
                    this.eventBus.trigger("select", data.obj);
                    this.close();
                    return true;
                }
                return false;
            },
            autocomplete: function autocomplete($selectable) {
                var query, data, isValid;
                query = this.input.getQuery();
                data = this.menu.getSelectableData($selectable);
                isValid = data && query !== data.val;
                if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
                    this.input.setQuery(data.val);
                    this.eventBus.trigger("autocomplete", data.obj);
                    return true;
                }
                return false;
            },
            moveCursor: function moveCursor(delta) {
                var query, $candidate, data, payload, cancelMove;
                query = this.input.getQuery();
                $candidate = this.menu.selectableRelativeToCursor(delta);
                data = this.menu.getSelectableData($candidate);
                payload = data ? data.obj : null;
                cancelMove = this._minLengthMet() && this.menu.update(query);
                if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
                    this.menu.setCursor($candidate);
                    if (data) {
                        this.input.setInputValue(data.val);
                    } else {
                        this.input.resetInputValue();
                        this._updateHint();
                    }
                    this.eventBus.trigger("cursorchange", payload);
                    return true;
                }
                return false;
            },
            destroy: function destroy() {
                this.input.destroy();
                this.menu.destroy();
            }
        });
        return Typeahead;
        function c(ctx) {
            var methods = [].slice.call(arguments, 1);
            return function() {
                var args = [].slice.call(arguments);
                _.each(methods, function(method) {
                    return ctx[method].apply(ctx, args);
                });
            };
        }
    }();
    (function() {
        "use strict";
        var old, keys, methods;
        old = $.fn.typeahead;
        keys = {
            www: "tt-www",
            attrs: "tt-attrs",
            typeahead: "tt-typeahead"
        };
        methods = {
            initialize: function initialize(o, datasets) {
                var www;
                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
                o = o || {};
                www = WWW(o.classNames);
                return this.each(attach);
                function attach() {
                    var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
                    _.each(datasets, function(d) {
                        d.highlight = !!o.highlight;
                    });
                    $input = $(this);
                    $wrapper = $(www.html.wrapper);
                    $hint = $elOrNull(o.hint);
                    $menu = $elOrNull(o.menu);
                    defaultHint = o.hint !== false && !$hint;
                    defaultMenu = o.menu !== false && !$menu;
                    defaultHint && ($hint = buildHintFromInput($input, www));
                    defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
                    $hint && $hint.val("");
                    $input = prepInput($input, www);
                    if (defaultHint || defaultMenu) {
                        $wrapper.css(www.css.wrapper);
                        $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
                        $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
                    }
                    MenuConstructor = defaultMenu ? DefaultMenu : Menu;
                    eventBus = new EventBus({
                        el: $input
                    });
                    input = new Input({
                        hint: $hint,
                        input: $input
                    }, www);
                    menu = new MenuConstructor({
                        node: $menu,
                        datasets: datasets
                    }, www);
                    typeahead = new Typeahead({
                        input: input,
                        menu: menu,
                        eventBus: eventBus,
                        minLength: o.minLength
                    }, www);
                    $input.data(keys.www, www);
                    $input.data(keys.typeahead, typeahead);
                }
            },
            isEnabled: function isEnabled() {
                var enabled;
                ttEach(this.first(), function(t) {
                    enabled = t.isEnabled();
                });
                return enabled;
            },
            enable: function enable() {
                ttEach(this, function(t) {
                    t.enable();
                });
                return this;
            },
            disable: function disable() {
                ttEach(this, function(t) {
                    t.disable();
                });
                return this;
            },
            isActive: function isActive() {
                var active;
                ttEach(this.first(), function(t) {
                    active = t.isActive();
                });
                return active;
            },
            activate: function activate() {
                ttEach(this, function(t) {
                    t.activate();
                });
                return this;
            },
            deactivate: function deactivate() {
                ttEach(this, function(t) {
                    t.deactivate();
                });
                return this;
            },
            isOpen: function isOpen() {
                var open;
                ttEach(this.first(), function(t) {
                    open = t.isOpen();
                });
                return open;
            },
            open: function open() {
                ttEach(this, function(t) {
                    t.open();
                });
                return this;
            },
            close: function close() {
                ttEach(this, function(t) {
                    t.close();
                });
                return this;
            },
            select: function select(el) {
                var success = false, $el = $(el);
                ttEach(this.first(), function(t) {
                    success = t.select($el);
                });
                return success;
            },
            autocomplete: function autocomplete(el) {
                var success = false, $el = $(el);
                ttEach(this.first(), function(t) {
                    success = t.autocomplete($el);
                });
                return success;
            },
            moveCursor: function moveCursoe(delta) {
                var success = false;
                ttEach(this.first(), function(t) {
                    success = t.moveCursor(delta);
                });
                return success;
            },
            val: function val(newVal) {
                var query;
                if (!arguments.length) {
                    ttEach(this.first(), function(t) {
                        query = t.getVal();
                    });
                    return query;
                } else {
                    ttEach(this, function(t) {
                        t.setVal(newVal);
                    });
                    return this;
                }
            },
            destroy: function destroy() {
                ttEach(this, function(typeahead, $input) {
                    revert($input);
                    typeahead.destroy();
                });
                return this;
            }
        };
        $.fn.typeahead = function(method) {
            if (methods[method]) {
                return methods[method].apply(this, [].slice.call(arguments, 1));
            } else {
                return methods.initialize.apply(this, arguments);
            }
        };
        $.fn.typeahead.noConflict = function noConflict() {
            $.fn.typeahead = old;
            return this;
        };
        function ttEach($els, fn) {
            $els.each(function() {
                var $input = $(this), typeahead;
                (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
            });
        }
        function buildHintFromInput($input, www) {
            return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
                autocomplete: "off",
                spellcheck: "false",
                tabindex: -1
            });
        }
        function prepInput($input, www) {
            $input.data(keys.attrs, {
                dir: $input.attr("dir"),
                autocomplete: $input.attr("autocomplete"),
                spellcheck: $input.attr("spellcheck"),
                style: $input.attr("style")
            });
            $input.addClass(www.classes.input).attr({
                autocomplete: "off",
                spellcheck: false
            });
            try {
                !$input.attr("dir") && $input.attr("dir", "auto");
            } catch (e) {}
            return $input;
        }
        function getBackgroundStyles($el) {
            return {
                backgroundAttachment: $el.css("background-attachment"),
                backgroundClip: $el.css("background-clip"),
                backgroundColor: $el.css("background-color"),
                backgroundImage: $el.css("background-image"),
                backgroundOrigin: $el.css("background-origin"),
                backgroundPosition: $el.css("background-position"),
                backgroundRepeat: $el.css("background-repeat"),
                backgroundSize: $el.css("background-size")
            };
        }
        function revert($input) {
            var www, $wrapper;
            www = $input.data(keys.www);
            $wrapper = $input.parent().filter(www.selectors.wrapper);
            _.each($input.data(keys.attrs), function(val, key) {
                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
            });
            $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
            if ($wrapper.length) {
                $input.detach().insertAfter($wrapper);
                $wrapper.remove();
            }
        }
        function $elOrNull(obj) {
            var isValid, $el;
            isValid = _.isJQuery(obj) || _.isElement(obj);
            $el = isValid ? $(obj).first() : [];
            return $el.length ? $el : null;
        }
    })();
});
}).call(this)}).call(this,require("timers").setImmediate)
},{"jquery":14,"timers":19}],52:[function(require,module,exports){
/**
 * AdminEstablishmentList functionality.
 *
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
AdminEstablishmentList = function() {

    // self references
    var self;

    // selector constants
    var SEL_MODULE                  = '.mod-stats-establishments-list-item';
    var BTN_SYNCHRONIZE             = '.synchronize';
    var SEL_ESTABLISHMENT_CODE      = 'i[data-synchronizeEstablishment]';

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

        // Retrieve and cache dom nodes
        var moduleNodes           = initNode.find(SEL_MODULE);

        // Init all matching nodes
        moduleNodes.each(function() {
            var moduleNode =   jQuery(this);
            moduleNode.on('click', BTN_SYNCHRONIZE, function(event) {
                var inputNode 		= moduleNode.find(SEL_ESTABLISHMENT_CODE);
                var establishmentCode = inputNode.attr("data-synchronizeEstablishment");
                var iconId = document.getElementById("icon-spin-" + establishmentCode);
                var className = iconId.getAttribute("class");
                if (className === "fas fa-sync-alt") {
                    iconId.className = "fas fa-spinner fa-pulse";
                }
                return true;
            });
        });
    };
};

// Make class public to outside world
module.exports = AdminEstablishmentList;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],53:[function(require,module,exports){
/**
 * AdminStats functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
var Datepicker  	= require('bootstrap.datepicker');
DateUtils		= require('../utils/DateUtils');



// Class definition
AdminStats = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						= '.mod-stats-establishments-list';
	var SEL_CREATED_DATE_INPUT			= 'input.startDate';
	var SEL_COUNTRY						= '.country';
	var SEL_SELECT_COUNTRY				= '#countryCodes';
	var SEL_CLEAR_FILTERS_BTN			= '.clearFilters';

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {
			var node = jQuery(this);

			// Cache nodes
			var displayDate 		= node.find(SEL_CREATED_DATE_INPUT);
			var receivedCountries 	= window.config.adminStats.selectedCountries || '';
			var clearFiltersBtn 	= node.find(SEL_CLEAR_FILTERS_BTN);


			// Init calendar display
			displayDate.datepicker({
			    format: window.config.adminStats.dateFormat,
			    language: window.config.adminStats.calendarLanguageCode,
			    weekStart: 1,
			    autoclose: true,
			    todayHighlight: false
			});
			if(receivedCountries != ''){
				node.find(SEL_COUNTRY).each(function(){
						if( receivedCountries.includes(jQuery(this).val()))
						{
							this.setAttribute('selected', true);
						}
				});
			}
			clearFiltersBtn.on('click', function(e){
				e.preventDefault();
				e.stopImmediatePropagation();
				node.find(SEL_CREATED_DATE_INPUT).each(function(){
					jQuery(this).val('');
				});
				node.find(SEL_SELECT_COUNTRY).each(function(){
					jQuery(this).selectpicker('deselectAll');
				});
			});

		});
	};
};

// Make class public to outside world
module.exports = AdminStats;
},{"../mediator/mediator":103,"../utils/DateUtils":185,"bootstrap.datepicker":26,"jquery/dist/jquery":14}],54:[function(require,module,exports){
/**
 * GradientTable functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

jQuery = require('jquery/dist/jquery');
GradientTableUtils = require('../utils/GradientTableUtils')



// Class definition
AdminStatsGradientTable = function() {

  // self references
    var self;
    
    var gradientTableUtils = new GradientTableUtils();

    // selector constants
    var SEL_MODULE                    = '.mod-stats-gradient-table';
    
    var SEL_TABLE_DIV                 = '.reservationTable';
    var SEL_GRADIENT_SHOWCASE         = '.wrapGradientTable';


    var localConfig = window.config.statsGradientTable  || {};
    var jan = localConfig.jan;
    var feb = localConfig.feb;
    var mar = localConfig.mar;
    var apr = localConfig.apr;
    var may = localConfig.may;
    var jun = localConfig.jun;
    var jul = localConfig.jul;
    var aug = localConfig.aug;
    var sep = localConfig.sep;
    var oct = localConfig.oct;
    var nov = localConfig.nov;
    var dec = localConfig.dec;

    var monthsArray = [jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec];
    
    var minNumTotal     = localConfig.minNumTotal;
    var maxNumTotal     = localConfig.maxNumTotal;
    var minNumWidget    = localConfig.minNumWidget;
    var maxNumWidget    = localConfig.maxNumWidget;
    var minNumGoogle    = localConfig.minNumGoogle;
    var maxNumGoogle    = localConfig.maxNumGoogle;
    var minNumFacebook  = localConfig.minNumFacebook;
    var maxNumFacebook  = localConfig.maxNumFacebook;
    var minNumInstagram  = localConfig.minNumInstagram;
    var maxNumInstagram  = localConfig.maxNumInstagram;

    var totalMap = localConfig.totalMap;

    var widgetMap = localConfig.widgetMap;

    var googleMap = localConfig.googleMap;
    
   	var facebookMap = localConfig.facebookMap;

    var instagramMap = localConfig.instagramMap;


    var minYear                        = localConfig.minYear;
    var maxYear                        = localConfig.maxYear;
    
    var numberOfCols                   = 12;
    var numberofRows                   = (maxYear - minYear) + 1;
    
    
    var gradientArray = ['#f4f4f4', '#e1e1e1', '#cccccc', '#83838A', '#323334'];

    BuildGradientTotal = function(button){
        jQuery(button).toggleClass("btn-secondary",true);
        jQuery(button).toggleClass("btn-default",false);
        jQuery("#btnWidgetStats").toggleClass("btn-secondary", false);
        jQuery("#btnWidgetStats").toggleClass("btn-default", true);
        jQuery("#btnGoogleStats").toggleClass("btn-secondary", false);
        jQuery("#btnGoogleStats").toggleClass("btn-default", true);
        jQuery("#btnFacebookStats").toggleClass("btn-secondary", false);
        jQuery("#btnFacebookStats").toggleClass("btn-default", true);
        jQuery("#btnInstagramStats").toggleClass("btn-secondary", false);
        jQuery("#btnInstagramStats").toggleClass("btn-default", true);
        gradientTableUtils.BuildGradient(minYear, maxYear, minNumTotal, maxNumTotal, totalMap, gradientArray);
    }

    BuildGradientWidget = function(button){
        jQuery(button).toggleClass("btn-secondary",true);
        jQuery(button).toggleClass("btn-default",false);
        jQuery("#btnTotalStats").toggleClass("btn-secondary", false);
        jQuery("#btnTotalStats").toggleClass("btn-default", true);
        jQuery("#btnGoogleStats").toggleClass("btn-secondary", false);
        jQuery("#btnGoogleStats").toggleClass("btn-default", true);
        jQuery("#btnFacebookStats").toggleClass("btn-secondary", false);
        jQuery("#btnFacebookStats").toggleClass("btn-default", true);
        jQuery("#btnInstagramStats").toggleClass("btn-secondary", false);
        jQuery("#btnInstagramStats").toggleClass("btn-default", true);
        gradientTableUtils.BuildGradient(minYear, maxYear, minNumWidget, maxNumWidget, widgetMap, gradientArray);
    }
    
    BuildGradientGoogle = function(button){
        jQuery(button).toggleClass("btn-secondary",true);
        jQuery(button).toggleClass("btn-default",false);
        jQuery("#btnTotalStats").toggleClass("btn-secondary", false);
        jQuery("#btnTotalStats").toggleClass("btn-default", true);
        jQuery("#btnWidgetStats").toggleClass("btn-secondary", false);
        jQuery("#btnWidgetStats").toggleClass("btn-default", true);
        jQuery("#btnFacebookStats").toggleClass("btn-secondary", false);
        jQuery("#btnFacebookStats").toggleClass("btn-default", true);
        jQuery("#btnInstagramStats").toggleClass("btn-secondary", false);
        jQuery("#btnInstagramStats").toggleClass("btn-default", true);
        gradientTableUtils.BuildGradient(minYear, maxYear, minNumGoogle, maxNumGoogle, googleMap, gradientArray);
    }

    BuildGradientFacebook = function(button){
        jQuery(button).toggleClass("btn-secondary",true);
        jQuery(button).toggleClass("btn-default",false);
        jQuery("#btnTotalStats").toggleClass("btn-secondary", false);
        jQuery("#btnTotalStats").toggleClass("btn-default", true);
        jQuery("#btnWidgetStats").toggleClass("btn-secondary", false);
        jQuery("#btnWidgetStats").toggleClass("btn-default", true);
        jQuery("#btnGoogleStats").toggleClass("btn-secondary", false);
        jQuery("#btnGoogleStats").toggleClass("btn-default", true);
        jQuery("#btnInstagramStats").toggleClass("btn-secondary", false);
        jQuery("#btnInstagramStats").toggleClass("btn-default", true);
        gradientTableUtils.BuildGradient(minYear, maxYear, minNumFacebook, maxNumFacebook, facebookMap, gradientArray);
    }

    BuildGradientInstagram = function(button){
        jQuery(button).toggleClass("btn-secondary",true);
        jQuery(button).toggleClass("btn-default",false);
        jQuery("#btnTotalStats").toggleClass("btn-secondary", false);
        jQuery("#btnTotalStats").toggleClass("btn-default", true);
        jQuery("#btnWidgetStats").toggleClass("btn-secondary", false);
        jQuery("#btnWidgetStats").toggleClass("btn-default", true);
        jQuery("#btnGoogleStats").toggleClass("btn-secondary", false);
        jQuery("#btnGoogleStats").toggleClass("btn-default", true);
        jQuery("#btnFacebookStats").toggleClass("btn-secondary", false);
        jQuery("#btnFacebookStats").toggleClass("btn-default", true);
        gradientTableUtils.BuildGradient(minYear, maxYear, minNumInstagram, maxNumInstagram, instagramMap, gradientArray);
    }

    
    jQuery("#btnTotalStats").click(function(){
        BuildGradientTotal(this);
    });
    
    jQuery("#btnWidgetStats").click(function(){
        BuildGradientWidget(this);
    });

    jQuery("#btnGoogleStats").click(function(){
        BuildGradientGoogle(this);
    });

    jQuery("#btnFacebookStats").click(function(){
        BuildGradientFacebook(this);
    });

    jQuery("#btnInstagramStats").click(function(){
        BuildGradientInstagram(this);
    });


    this.init = function(initNode) {
      
        self = this;
        // Retrieve and cache dom nodes
        var moduleNodes       = initNode.find(SEL_MODULE);
        
        // Init all matching nodes
        moduleNodes.each(function() {
            
        var moduleNode = jQuery(this);
        var reservationTable = moduleNode.find(SEL_TABLE_DIV);
        var gradientShowcase = moduleNode.find(SEL_GRADIENT_SHOWCASE);

        gradientTableUtils.showGradientTable(gradientShowcase, gradientArray);
        if(totalMap == null || widgetMap == null || googleMap == null|| facebookMap == null){
            moduleNode.addClass('no-reservations');
            return;
        }

        gradientTableUtils.BuildTable(reservationTable, numberofRows, numberOfCols, minYear, monthsArray);
        gradientTableUtils.BuildGradient(minYear, maxYear, minNumTotal, maxNumTotal, totalMap, gradientArray);

      });
    };

};

// Make class public to outside world
module.exports = AdminStatsGradientTable;

},{"../mediator/mediator":103,"../utils/GradientTableUtils":186,"jquery/dist/jquery":14}],55:[function(require,module,exports){
/**
 * AdminStats functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
var Datepicker  	= require('bootstrap.datepicker');
DateUtils		= require('../utils/DateUtils');



// Class definition
AdminStatsTotals = function() {

    // self references
    var self;

	// selector constants
	var SEL_MODULE						= '.mod-stats-totals';
	var SEL_MODULE_ACCORDION			= '.mod-stats-accordionInformation';
	var SEL_COUNTRY						= '.country';
	var SEL_SELECTED_COUNTRIES			= '.countriesWrapper';
	var SEL_ALL_COUNTRIES_NODE			= '.allCountries';
	var SEL_SELECT_NODE					= '.selectpicker';
	var SEL_COUNTRY_CODES_DROPDOWN		= '#countryCodes';
	var SEL_HEADER						= '.header';
	
	/*
	* Transform string into array of country codes.
	* The parameter which is a string in format "[DE, EN, FR]" will 
	* be transformed into array that holds only the country codes.
	*/	

	var getCountryCodes = function(receivedCountries){
		receivedCountries = receivedCountries.replace('[','');
		receivedCountries = receivedCountries.replace(']','');
		receivedCountries = receivedCountries.replace(/\s+/g,'');
		var arrayReceivedCountries = receivedCountries.split(",");

		return arrayReceivedCountries;
	};

	var initCountryDropdown = function(countryOptions, countryCodesArray, node){
		var countriesContainer  = node.find(SEL_SELECTED_COUNTRIES);
		var allCountriesNode 	= node.find(SEL_ALL_COUNTRIES_NODE);

		var countryArray 		= [];

		if(countryCodesArray !="" && countryCodesArray.length < countryOptions.length){
			jQuery(allCountriesNode).removeAttr('selected');
			var valueArray = [];

			node.find(SEL_COUNTRY).each(function(){
				var itemValue = jQuery(this).val();
				if( countryCodesArray.includes(itemValue))
				{
					valueArray.push(itemValue);
					countryArray.push(jQuery(this).text());
				}
			});

			jQuery(SEL_SELECT_NODE).selectpicker('val',valueArray);

		}else if(countryOptions != ''){
				jQuery(SEL_SELECT_NODE).selectpicker('selectAll');
				countryArray = countryOptions;
		}

		var countrySelected = buildCountryString(countryArray);
		countriesContainer.text(countrySelected);
	};

	//logic that builds the string with countries that are selected
	var buildCountryString = function (countryArray){
		var countryString = '';
		var andWord = window.config.adminStatsTotals.andWord || 'and';
		for(var index=0; index < countryArray.length; index++){
			if(index != 0 && index + 1 == countryArray.length){
				countryString = countryString.slice(0, -2);
				countryString +=  ' ' + andWord + ' ' + countryArray[index];
			}else{
				countryString += countryArray[index] + ', ';
			}
			if(index == 0 && index + 1 == countryArray.length)
			{
				countryString = countryString.slice(0, -2);
			}

		}
		return countryString;
	};
	
	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

        self = this;
		// Retrieve and cache dom nodes 
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {
			var node = jQuery(this);
			
			// Cache nodes
			var accordionNode 		= node.find(SEL_MODULE_ACCORDION);
			var selectNode	 		= node.find(SEL_SELECT_NODE);
			var localconfig 		= window.config.adminStatsTotals || {};
			var receivedCountries 	= localconfig.selectedCountries || '';
			var countryOptions		= localconfig.countryOptions || '';
			var countryCodesArray 	= getCountryCodes(receivedCountries);
			var countryDropdownNode = node.find(SEL_COUNTRY_CODES_DROPDOWN);

			countryDropdownNode.on('change', function(){
				var dropdown 				= jQuery(this);
				var optionAll 				= dropdown.find('option[value="all"]');
				var isAllSelected 			= optionAll.prop('selected');
				var lastAllSelected 		= jQuery(this).data('all');
				var selectedOptions 		= (dropdown.val())?dropdown.val():[];
				var allOptionsLength 		= dropdown.find('option[value!="all"]').length;
				var selectedOptionsLength 	= selectedOptions.length;
				
				if(isAllSelected == lastAllSelected){
				
					if(jQuery.inArray("all", selectedOptions) >= 0){
						selectedOptionsLength -= 1;      
					}

					if(allOptionsLength <= selectedOptionsLength){
						optionAll.prop('selected', true).parent().selectpicker('refresh');
						isAllSelected = true;
					}else{       
						optionAll.prop('selected', false).parent().selectpicker('refresh');
						isAllSelected = false;
					}
				}else{   		
					dropdown.find('option').prop('selected', isAllSelected).parent().selectpicker('refresh');
				}
			
				jQuery(this).data('all', isAllSelected);
			}).trigger('change');

			accordionNode.on('click','.header',function(){
				var icon = jQuery(this).find('.arrowIcon');
				if(icon.hasClass('fas fa-chevron-down')){
					icon.removeClass('fas fa-chevron-down');
					icon.addClass('fas fa-chevron-up')
				}else if(!icon.hasClass('fas fa-chevron-down')){
					icon.removeClass('fas fa-chevron-up');
					icon.addClass('fas fa-chevron-down')
				}
			});

			initCountryDropdown(countryOptions, countryCodesArray, node);

		});
	};
};

// Make class public to outside world
module.exports = AdminStatsTotals;
},{"../mediator/mediator":103,"../utils/DateUtils":185,"bootstrap.datepicker":26,"jquery/dist/jquery":14}],56:[function(require,module,exports){
/**
 * AdminUserList functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
AdminUserList = function() {

    // self references
    var self;

    // selector constants
    var SEL_MODULE                = '.mod-stats-users-list';
    var SEL_DELETE_FORM           = '.delete-form';
    var SEL_DELETE_MODAL          = '.delete-user-modal';
    var BTN_DELETE                = '.delete'
    var BTN_CONFIRM               = '.btn-confirm'
    var BTN_SYNCHRONIZE           = '.sync-button';

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

    // Retrieve and cache dom nodes
    var moduleNodes           = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);
      var deleteModal = moduleNode.find(SEL_DELETE_MODAL);
      var currentDeleteForm = '';

      moduleNode.on('click', BTN_DELETE, function(event) {
        event.preventDefault();
        var btn = jQuery(this);
        currentDeleteForm = btn.closest(SEL_DELETE_FORM);
        deleteModal.modal('show');
        return false;
      });

      deleteModal.on('click', BTN_CONFIRM, function() {
        currentDeleteForm.find('[name="password"]').val(deleteModal.find('#password').val());
        currentDeleteForm.trigger('submit');
      });

      moduleNode.on('click', BTN_SYNCHRONIZE, function() {

          var inputNode = jQuery(this);
          var iTag      = inputNode.find('i');
          var userId    = iTag.attr("data-synchronizeUser");
          var iconId = document.getElementById("icon-spin-" + userId);
          var className     = iconId.getAttribute("class");
          if (className === "fas fa-sync-alt") {
              iconId.className = "fas fa-spinner fa-pulse";
          }
          return true;
        });
    });
  };
};

// Make class public to outside world
module.exports = AdminUserList;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],57:[function(require,module,exports){
/**
 * Admin functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
AdminStats = require('./AdminStats');
AdminStatsTotals = require('./AdminStatsTotals');
AdminStatsGradientTable = require('./AdminStatsGradientTable');
AdminUserList = require('./AdminUserList');
AdminEstablishmentList = require('./AdminEstablishmentList')

// Handle application start
mediator.subscribe("app:started", function(initNode) {
	// Instanciate implementing class
	var adminStats = new AdminStats();
	var adminStatsTotals = new AdminStatsTotals();
	var adminStatsGradientTable = new AdminStatsGradientTable();
	var adminUserList = new AdminUserList();
	var adminEstablishmentList = new AdminEstablishmentList();

	// Trigger onload activities
	adminStats.init(initNode);
	adminStatsTotals.init(initNode);
	adminStatsGradientTable.init(initNode);
	adminUserList.init(initNode);
	adminEstablishmentList.init(initNode);
});
},{"../mediator/mediator":103,"./AdminEstablishmentList":52,"./AdminStats":53,"./AdminStatsGradientTable":54,"./AdminStatsTotals":55,"./AdminUserList":56}],58:[function(require,module,exports){
/**
 * AJAX page load functionality.
*
*/

//Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

//External libs
jQuery = require('jquery/dist/jquery');

//Class definition
AjaxPageLoad = function() {

    // self references
    var self;

    /**
     * Default configuration.
     */
    var defaultConfig = {
        containers      : [],
        callback        : function(){},
        updateHistory   : false,
        tracking        : false
    };



    /**
     * Load URL and replace current pages' fragment with fragment from result page.
     */
    this.loadUrl = function(config, url) {

        // Fallback for missing url
        if (url === undefined || url == '') {
            url = document.location.href;
        }

        loadFragments(config, url, 'GET');
    };



    /**
     * Submit form and replace current pages' fragment with fragment from result page.
     */
    this.submitForm = function(config, node) {

        var method = node.attr('method');
        var action = node.attr('action');

        // Fallback for missing action
        if (action === undefined || action == '') {
            action = document.location.href;
        }

        // For GET: Remove current URL parameters
        if (method.toUpperCase() == "GET") {
            var link = document.createElement('a');
            link.setAttribute('href', action);
            action = '//' + link.host + link.pathname;
        }

        loadFragments(config, action, method, node.serialize());
    };



    /**
     * Perform GET/POST and replace current pages' fragment with fragment from result page.
     */
    var loadFragments = function(config, url, method, data) {

        // Merge default and given config
        config = jQuery.extend({}, defaultConfig, config);

        // Make container nodes no longer editable
        jQuery.each(config.containers, function(key, value) {

            // Loading cursor
            jQuery(value + " *").css('cursor', 'wait');

            // Fade out content
            jQuery(value).css('opacity', '0.5');

            // Disable user actions that could break the logic
            jQuery(value).find('input,a').attr('disabled', 'disabled');
            jQuery(value).find('form').on('submit', function() {return false;});
            jQuery(value).find('a').on('click', function() {return false;});

        });

        // Empty data if not defined
        if (data === undefined) {
            data = '';
        }

        // Perform action
        jQuery.ajax({
            url         : url,
            method      : method,
            data        : data,
            dataType    : 'html'
         })
         .done(function(htmlData) {

            // Update all requested fragments
            jQuery.each(config.containers, function(key, value) {
                 var newFragment = jQuery(htmlData).find(value).html();
                 var node = jQuery(value);
                 node.html(newFragment).css('opacity', '1');

            });

            // Modify browser history
            if (config.updateHistory) {
                window.history.replaceState({}, "", url + (data != '' ? '?' + data : ''));
            }

            // Trigger tracking
            if (config.tracking) {
                // Using regex since it doesn't work with jquery
                var trackingJs = /<script class="js-tracking-data">[\s\S]*?<\/script>/.exec(htmlData);
                var trackingNode = jQuery(".js-tracking-data");
                trackingNode.last().after(trackingJs);
            }

            // Call provided callback method
            if (config.callback !== undefined) {
                config.callback();
            }

         })
         .fail(function() {
             location.reload();
         });

    };



    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

    };

};

//Make class public to outside world
module.exports = AjaxPageLoad;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],59:[function(require,module,exports){


/**
 * AJAX page load functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
AjaxPageLoad = require('./AjaxPageLoad');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var ajaxPageLoad = new AjaxPageLoad();
	
	// Trigger onload activities
	ajaxPageLoad.init(initNode);

});
},{"../mediator/mediator":103,"./AjaxPageLoad":58}],60:[function(require,module,exports){

jQuery = require('jquery/dist/jquery');

BannerManager = function() {

    var SEL_BANNER = '.mod-common-banner';
    var SEL_DISMISS_BTN = '.dismiss-btn';

    this.init = function (initNode) {
        self = this;

        var bannerNodes = initNode.find(SEL_BANNER);
        bannerNodes.each(function () {
            var bannerNode = jQuery(this);
            var bannerDismissButton = bannerNode.find(SEL_DISMISS_BTN);
            if (localStorage.getItem(bannerNode.attr('id')) == null) {
                bannerNode.removeClass('hidden');
            }
            bannerDismissButton.on('click', function(){
                bannerNode.addClass('hidden');
                localStorage.setItem(bannerNode.attr('id'), 'dismiss');
            });
        });

    }
}

module.exports = BannerManager;

},{"jquery/dist/jquery":14}],61:[function(require,module,exports){
/**
 * Page (Pause/UnPause Subscription) functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
const BannerManager = require('../banner/bannerManager');
const PromoManager = require('./promoManager');
const UpgradeManager = require('./upgradeManager');

// Handle application start
mediator.subscribe("app:started", function(initNode) {
    // Instanciate implementing class
    const bannerManager = new BannerManager();
    const promoManager = new PromoManager();
    const upgradeManager = new UpgradeManager()

    // Trigger onload activities
    bannerManager.init(initNode);
    promoManager.init(initNode);
    upgradeManager.init(initNode);
});

},{"../banner/bannerManager":60,"../mediator/mediator":103,"./promoManager":62,"./upgradeManager":63}],62:[function(require,module,exports){

jQuery = require('jquery/dist/jquery');

const PromoManager = function() {

    const SEL_PROMO = '.mod-promo-modal';
    const SEL_DISMISS_BTN = '.dismiss-btn';
    const SEL_LEARN_MORE_BTN = '#btn-learn-more';
    const SEL_GET_ADD_ON_BTN = '#btn-get-add-on';
    const ATTR_CAMPAIGN = 'data-campaign';
    const ATTR_SESSION_ID = 'data-session-id';
    const PREFIX_CAMPAIGN = 'popup_';

    this.init = function (initNode) {
        self = this;

        const promoNodes = initNode.find(SEL_PROMO);

        let adobeDataLayer;
        let campaigns = [];

        promoNodes.each(function () {
            const promoNode = jQuery(this);
            const promoDismissButton = promoNode.find(SEL_DISMISS_BTN);
            const promoLearnMoreButton = promoNode.find(SEL_LEARN_MORE_BTN);
            const promoGetAddOnButton = promoNode.find(SEL_GET_ADD_ON_BTN);
            const campaign = PREFIX_CAMPAIGN + promoNode.attr(ATTR_CAMPAIGN);
            promoNode.on('shown.bs.modal', function() {
                campaigns.push(campaign);
            })
            if (localStorage.getItem(promoNode.attr('id')) == null && localStorage.getItem("promo-session") !== promoNode.attr(ATTR_SESSION_ID)) {
                promoNode.modal({
                    backdrop: 'static',
                    keyboard: false
                }, 'show');
                localStorage.setItem("promo-session", promoNode.attr(ATTR_SESSION_ID));
            }
            promoDismissButton.on('click', function(){
                localStorage.setItem(promoNode.attr('id'), 'dismiss');
                promoNode.modal('hide');
                pushToAdobe('banner_close', campaign);
            });
            promoLearnMoreButton.on('click', function(){
                pushToAdobe('learnmore_click', campaign);
            });
            promoGetAddOnButton.on('click', function(){
                pushToAdobe('banner_click', campaign);
            });
        });

        window.onload = (event) => {
            adobeDataLayer = window.adobeDataLayer || [];
            for (const campaign of campaigns) {
                pushToAdobe('banner_impression', campaign);
            }
        };

        function pushToAdobe(event, value) {
            adobeDataLayer = adobeDataLayer || [];
            adobeDataLayer.push({event: event, eventValue: value});
        }

    }
}

module.exports = PromoManager;

},{"jquery/dist/jquery":14}],63:[function(require,module,exports){

jQuery = require('jquery/dist/jquery');

const UpgradeManager = function() {

    const SEL_PROMO = '.mod-upgrade-modal';
    const SEL_DISMISS_BTN = '.dismiss-btn';
    const SEL_GET_UPGRADE_BTN = '#btn-get-upgrade';
    const ATTR_CAMPAIGN = 'data-campaign';

    this.init = function (initNode) {
        self = this;

        const upgradeNodes = initNode.find(SEL_PROMO);

        let adobeDataLayer;
        let campaigns = [];

        upgradeNodes.each(function () {
            const upgradeNode = jQuery(this);
            const upgradeDismissButton = upgradeNode.find(SEL_DISMISS_BTN);
            const upgradeGetUpgradeButton = upgradeNode.find(SEL_GET_UPGRADE_BTN);
            const campaign = upgradeNode.attr(ATTR_CAMPAIGN);
            upgradeNode.on('shown.bs.modal', function() {
                campaigns.push(campaign);
            })

            if (localStorage.getItem(upgradeNode.attr('id')) == null ) {
                upgradeNode.modal({
                    backdrop: 'static',
                    keyboard: false
                }, 'show');
            }
            upgradeDismissButton.on('click', function(){
                localStorage.setItem(upgradeNode.attr('id'), 'dismiss');
                pushToAdobe('banner_close', campaign);
            });
            upgradeGetUpgradeButton.on('click', function(){
                pushToAdobe('banner_click', campaign);
            });
        });

        window.onload = (event) => {
            adobeDataLayer = window.adobeDataLayer || [];
            for (const campaign of campaigns) {
                pushToAdobe('banner_impression', campaign);
            }
        };

        function pushToAdobe(event, value) {
            adobeDataLayer = adobeDataLayer || [];
            adobeDataLayer.push({event: event, eventValue: value});
        }
    }
}

module.exports = UpgradeManager;

},{"jquery/dist/jquery":14}],64:[function(require,module,exports){
/**
 * PercentageBarChart
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');

var CSS_CHART                       = 'percentage-bar-chart';
var CSS_CHART_AREA                  = 'chart-area';
var CSS_CHART_ITEM                  = 'bar';
var CSS_CHART_NO_ITEMS              = 'chart-empty';

var ATTR_DATA_LABEL                 = 'data-label';

var DEFAULT_COLOR                   = 'transparent';

var addNewItem = function(chartArea, label, percentage, color) {
  if (percentage == 0 ){
    return;
  }
  var styles = {
    width: percentage + '%'
  };

  if (color && color !== '') {
    styles['background-color'] = color;
  }

  return jQuery('<div />')
          .addClass(CSS_CHART_ITEM)
          .attr(ATTR_DATA_LABEL, label)
          .css(styles)
          .appendTo(chartArea);
};

var calculateTotal = function(data) {
  var total = 0;
  data.forEach(function(dataItem) {
    total += dataItem.value;
  });
  return total;
};

var isMaxDecimals = function(percentage, data, totalValue){
  var decimalsHolder = 0; 

  for(var index = 0; index < data.length; index++){
    var percentageFromValue = data[index].value / totalValue * 100;
    var percentageDecimals = parseFloat((percentageFromValue % 1).toFixed(4));
    if(percentageDecimals > decimalsHolder){
      decimalsHolder = percentageDecimals;
    }
  }
  var decimalsFromPercentage = parseFloat((percentage % 1).toFixed(4));
  if(decimalsFromPercentage == decimalsHolder){
    return true;
  }

  return false;
};

var addItemsToChart = function(chartArea, data, totalValue){
  var totalPercentage = 0;
  var min = data[0].value;
  var middleIndex = data.length % 2;
  var minVar = 0;
  data.forEach(function(dataItem){
    var percentage = Math.round((dataItem.value / totalValue % 100) * 100);
    totalPercentage += percentage;
  });
 
  //move the dataItems with the lowest precenteage into the middle to avoid overlapping when displaying
  for(var index=0;index<data.length;index++){
    if(data[index].value < min)
    {
      min = data[index].value;
      minVar = index;
    }
    if(index + 1 == data.length ){
      if(data.length > 2){
        var holder = data[minVar];
        data[minVar] = data[middleIndex];
        data[middleIndex] = holder;
      }else if( data.length > 1 && minVar == 0){
        var holder = data[minVar];
        data[minVar] = data[1];
        data[1] = holder;
      }
    }
  }

  //check if the percentages are adding up to 100
  if(totalPercentage == 100){
    data.forEach(function(dataItem){
      var percentageDisplay = Math.round((dataItem.value / totalValue % 100) * 100);
      var label = dataItem.title + ' (' + percentageDisplay + '%)';
      
      addNewItem(chartArea, label, percentageDisplay);
    });
  }else{
    var addedOne = 0;
    data.forEach(function(dataItem){
      var percentageDisplay = (dataItem.value / totalValue % 100) * 100;
      var label = dataItem.title + ' (' + Math.round(percentageDisplay) + '%)';
      var hasMaxDecimals = isMaxDecimals(percentageDisplay, data, totalValue);
      if(hasMaxDecimals && addedOne == 0){
        var percentageToBeDisplayed = Math.ceil(percentageDisplay);
        var label = dataItem.title + ' (' + percentageToBeDisplayed + '%)';
        addedOne = 1;
        addNewItem(chartArea,label, percentageToBeDisplayed);
      }else{
        addNewItem(chartArea, label, Math.round(percentageDisplay));
      }
    });
  }

};

var cleanAndGetValidDataItems = function(data) {
  var filtered = [];
  (data || []).forEach(function(dataItem) {
    if (dataItem && dataItem.title) {
      dataItem.value = parseInt(dataItem.value); // convert to int
      if (!isNaN(dataItem.value)) {
        filtered.push(dataItem);
      }
    }
  });
  return filtered;
};


// Class definition
PercentageBarChart = function() {

    // self references
    var self;


    /** Show the confirm modal
     * @param element The element to generate the chart in
     * @param {array} data List of data items
     *                      e.g. `[ { title: "item A", value: 5 }, { title: "item B", value: 3 } ]`
     *                      `color` property for each item is optional and can be used to override the color
     */
    this.init = function(element, data) {

      data = cleanAndGetValidDataItems(data);
      var chart = jQuery(element).empty().addClass(CSS_CHART);
      var totalValue = calculateTotal(data);

      if (totalValue > 0) {
        chart.removeClass(CSS_CHART_NO_ITEMS);
        var chartArea = jQuery('<div />').addClass(CSS_CHART_AREA).appendTo(chart);
        addItemsToChart(chartArea, data, totalValue);
      } else {
        chart.addClass(CSS_CHART_NO_ITEMS);
      }

    };

};

// Make class public to outside world
module.exports = PercentageBarChart;

},{"jquery/dist/jquery":14}],65:[function(require,module,exports){
/**
 * Confirm Modal
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');

UserInterfaceUtils = require('../utils/UserInterfaceUtils');

// selector constants
var SEL_MODULE                      = '.mod-collapsible-section';
var SEL_GROUP                       = '.collapsible-section-group';
var SEL_TITLE                       = '.collapsible-section-group-title';

var DATA_ATTR_DISABLE_COLLAPSE      = 'disableCollapse';

var CSS_CLASS_COLLAPSED             = 'collapsed';



// Class definition
CollapsibleSection = function() {

    // self references
    var self;

    this.init = function(initNode) {

      self = this;

      // Retrieve and cache dom nodes
      var moduleNodes 					= initNode.find(SEL_MODULE);

      // Init all matching nodes
      moduleNodes.each(function() {

        var moduleNode 			= jQuery(this);

        var groups = moduleNode.find(SEL_GROUP);

        groups.each(function() {
          var group = jQuery(this);

          var disableCollapse = group.data(DATA_ATTR_DISABLE_COLLAPSE) || false;

          if (!disableCollapse) {
            group.find(SEL_TITLE).on('click', function() {
              var otherGroupsToDisable = groups.not(group).filter(function() {
                // only ones that have no collapsing disabled
                return !jQuery(this).data(DATA_ATTR_DISABLE_COLLAPSE);
              });

              otherGroupsToDisable.addClass(CSS_CLASS_COLLAPSED);
              group.toggleClass(CSS_CLASS_COLLAPSED);

              if (!group.hasClass(CSS_CLASS_COLLAPSED)) {
                UserInterfaceUtils.scrollToElementXsConsiderNavbar(group);
              }
            });
          }

        });

      });

    };

};

// Make class public to outside world
module.exports = CollapsibleSection;

},{"../utils/UserInterfaceUtils":189,"jquery/dist/jquery":14}],66:[function(require,module,exports){


/**
 * CollapsibleSection functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
CollapsibleSection 			= require('./CollapsibleSection');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var collapsibleSection 		= new CollapsibleSection();

	// Trigger onload activities
	collapsibleSection.init(initNode);

});

},{"../mediator/mediator":103,"./CollapsibleSection":65}],67:[function(require,module,exports){
/**
 * Page (Pause/UnPause Subscription) functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
Page = require('./page');

// Handle application start
mediator.subscribe("app:started", function(initNode) {
	// Instanciate implementing class
	var page = new Page();

	// Trigger onload activities
	page.init(initNode);
});
},{"../mediator/mediator":103,"./page":68}],68:[function(require,module,exports){
/**
 * Confirm Modal
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
Page = function() {

    var SEL_MODULE = '.content';
    var SEL_MAIN_NAVIATION = '.mod-navigation-main';
    var SEL_MAIN_HEADER = '.mod-navigation-header';
    var SEL_HEADER_NAVIGATION = '.navbar-fixed-top';
    var SEL_MODAL_PAUSE_SUBSCRIPTION = '#pauseSubscriptionModal';
    var SEL_LOGOUT_BUTTON  = '.user-link-logout';
    var SEL_MODAL_RWG_PROMO = '#rwgPromoModal';
    var SEL_RWG_PROMO_BANNER = '.mod-rwg-promo-banner';
    var SEL_RWG_PROMO_BANNER_CLOSE_BUTTON = '.close';
    var SEL_RWG_FREE_TRIAL_BUTTON = '.btn-free-trial';
    
    var CSS_HIDDEN = 'hidden';
    var CSS_BODY = 'body';
    var CSS_HOME_PAGE = 'page-home';
    var CSS_BLUR_BACKGROUND = 'blur-background';
    var CSS_HIDE_SCROLL = 'hide-vertical-scroll';
    
    var ATTR_CLASS = 'class';
    var ATTR_ADMIN_PANEL = 'adminpanel';

    var topOffset = '82px';

    var getPauseSubscriptionModal = function(moduleNode, subscriptionModal){
        moduleNode.addClass(CSS_BLUR_BACKGROUND);
        moduleNode.siblings(SEL_MAIN_NAVIATION).addClass(CSS_BLUR_BACKGROUND);
        moduleNode.siblings(SEL_MAIN_HEADER).addClass(CSS_BLUR_BACKGROUND);
        moduleNode.closest('html').addClass(CSS_HIDE_SCROLL);
        
        return subscriptionModal.clone().removeClass(CSS_HIDDEN);
    }

    var updateTopSpacing = function(moduleNode, headerNavigationNode, sideNavigationNode, topOffset){
        moduleNode.css('margin-top', topOffset);
        headerNavigationNode.css('top', topOffset);
        sideNavigationNode.css('top', topOffset);
    }

    /**
     * Initialize.
     */
     this.init = function (initNode) {

        self = this;

        // Retrieve and cache dom nodes
        var moduleNodes = initNode.find(SEL_MODULE);
        
        // Init all matching nodes
        moduleNodes.each(function () {
            
            var moduleNode = jQuery(this);
            
            var bodyClass = moduleNode.closest(CSS_BODY).attr(ATTR_CLASS).includes(CSS_HOME_PAGE);
            var isAdminPanel = window.location.href.includes(ATTR_ADMIN_PANEL);
            var subscriptionModal = moduleNode.find(SEL_MODAL_PAUSE_SUBSCRIPTION);
            var logoutBtnNode = moduleNode.siblings(SEL_MAIN_HEADER).find(SEL_LOGOUT_BUTTON);

            var headerLocalConfig = window.config.headerNavigation || [];
            var rwgPromoModal = moduleNode.find(SEL_MODAL_RWG_PROMO);
            var headerNavigationNode = moduleNode.siblings(SEL_MAIN_HEADER).find(SEL_HEADER_NAVIGATION);
            var sideNavigationNode = moduleNode.siblings(SEL_MAIN_NAVIATION);
            var rwgPromoBannerNode = moduleNode.siblings(SEL_RWG_PROMO_BANNER);
            var rwgBannerCloseButton = rwgPromoBannerNode.find(SEL_RWG_PROMO_BANNER_CLOSE_BUTTON);
            
            isPausedSubscription = subscriptionModal.hasClass('paused-subscription');

            // don't display subscription popup for both homepage and admin panel
            if(!bodyClass && !isAdminPanel && isPausedSubscription){
                var pauseSubscriptionModal = getPauseSubscriptionModal(moduleNode, subscriptionModal);
    
                // show pause subscription modal on page load
                pauseSubscriptionModal.modal({
                    backdrop: 'static',
                    keyboard: false
                }, 'show');
            }

            // prevent multiple clicks on both admin and dashboard logout button
            logoutBtnNode.one('click', function(){
                localStorage.removeItem('showRwgPromoPopup');
                localStorage.removeItem('showRwgPromoBanner');
                window.location.href = isAdminPanel ? headerLocalConfig.adminLogoutUrl : headerLocalConfig.logoutUrl;
            });

            
            // show rwg promo popup on page load
            var rwgPromoPopup = rwgPromoModal.clone().removeClass(CSS_HIDDEN);
            var rwgFreeTrialBtn = rwgPromoPopup.find(SEL_RWG_FREE_TRIAL_BUTTON);

            var showRwgPromoPopup = localStorage.getItem('showRwgPromoPopup');
            if(showRwgPromoPopup == 'false'){
                rwgPromoModal.modal('hide');
            }else{
                rwgPromoPopup.modal({
                    backdrop: 'static',
                    keyboard: false
                }, 'show');
            }
            
            rwgPromoPopup.on("hidden.bs.modal", function () {
                localStorage.setItem('showRwgPromoPopup', false);
            });

            rwgFreeTrialBtn.on('click', function(){
                localStorage.setItem('showRwgPromoPopup', false);
                window.location.href = "/settings/reservation";
            });

            // to display RWG Banner (adjust top header, side navigation and content area)
            var showRwgPromoBanner = localStorage.getItem('showRwgPromoBanner');
            
            if(showRwgPromoBanner == 'false'){
                rwgPromoBannerNode.addClass(CSS_HIDDEN);
            }

            if(rwgPromoBannerNode.hasClass(CSS_HIDDEN)){
                topOffset = '0px';
            }else{
                topOffset = (window.innerWidth > 991) ? '82px' : (window.innerWidth > 700) ? '170px' : (window.innerWidth > 425) ? '187px' : (window.innerWidth > 348) ? '207px' : '225px';
            }

            updateTopSpacing(moduleNode, headerNavigationNode, sideNavigationNode, topOffset);

            rwgBannerCloseButton.on('click', function(){
                rwgPromoBannerNode.hide();
                topOffset = '0px';
                localStorage.setItem('showRwgPromoBanner', false);
                updateTopSpacing(moduleNode, headerNavigationNode, sideNavigationNode, topOffset);
            });
        });
    }
};

// Make class public to outside world
module.exports = Page;

},{"jquery/dist/jquery":14}],69:[function(require,module,exports){
/**
 * CustomerList functionality.
*
*/

// Mediator module (handles event delegation)
const mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
Notification = require('../notification/Notification');

// Class definition
CustomerInformation = function () {

    // self references
    let self;

	// selector constants
    const SEL_MODULE              = '.mod-customer-information-card';
    const SEL_FORM_GROUP          = '.form-group';
    const SEL_FORM                = 'form';
    const SEL_GUEST_NAME_LABEL = '#guest-name-label'
    const SEL_FIRSTNAME_FIELD     = '#customer-firstName';
    const SEL_LASTNAME_FIELD      = '#customer-lastName';
    const SEL_CONTACT_DETAILS_LABEL = '#contact-details-label'
    const SEL_PHONENUMBER_FIELD   = '#customer-phoneNumber';
    const SEL_EMAIL_FIELD         = '#customer-email';
    const SEL_NOTE = '#customer-note';

    const CSS_HAS_ERROR = 'has-error';
    const CONST_EMAIL_REG = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    const SEL_REMOVE_GUEST_DATA_BUTTON = '.remove-guest-data-btn';
    const SEL_REMOVE_GUEST_DATA_MODAL = "#guestDataModal"
    const SEL_MODAL_REMOVE_GUEST_DATA_CANCEL_BUTTON = "#btn-modal-remove-guest-data-cancel"
    const SEL_MODAL_REMOVE_GUEST_DATA_BUTTON = "#btn-modal-remove-guest-data"
    const SEL_MODAL_ERROR_MSG = ".guest-data-modal-error"
    const SEL_CSRF = 'input[name="_csrf"]';
    const SEL_CUSTOMER_ID = 'input[name="customerId"]';

    var notification = new Notification();
    var localConfig 	= window.config.customerDetails || [];
    var localMsgConfig 	= (window.config.msg && window.config.msg.customerDetails) || [];

    let showRemoveGuestDataModal = function (guestDataModal) {
        guestDataModal.modal({
            backdrop: 'static',
            keyboard: false
        }, 'show');
    }

    var handleFormSubmit = function(passedForm, moduleNode) {
        const form			= jQuery(passedForm);
        const guestNameLabel = moduleNode.find(SEL_GUEST_NAME_LABEL);
        const contactDetailsLabel = moduleNode.find(SEL_CONTACT_DETAILS_LABEL);
        const firstName		= form.find(SEL_FIRSTNAME_FIELD);
        const lastName		= form.find(SEL_LASTNAME_FIELD);
        const email			= form.find(SEL_EMAIL_FIELD);

        var errors = 0;

        guestNameLabel.removeClass(CSS_HAS_ERROR);
        const firstNameFormGroup = firstName.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
        const lastNameFormGroup = lastName.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
        if(firstName.val() === '' && lastName.val() === '') {
            guestNameLabel.addClass(CSS_HAS_ERROR)
            firstNameFormGroup.addClass(CSS_HAS_ERROR);
            lastNameFormGroup.addClass(CSS_HAS_ERROR);
            notification.showGlobalErrorNotification(localMsgConfig.errorNoNameProvided);
            errors++;
        }
        
        contactDetailsLabel.removeClass(CSS_HAS_ERROR);
        const emailFormGroup = email.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
        var isEmailValid = true;
        if(email.val() !== '') {
            isEmailValid = CONST_EMAIL_REG.test(email.val());
        }
        if (!isEmailValid) {
            contactDetailsLabel.addClass(CSS_HAS_ERROR);
            emailFormGroup.addClass(CSS_HAS_ERROR);
            notification.showGlobalErrorNotification(localMsgConfig.errorInvalidEmailFormat);
            errors++;
        }

        return (errors == 0);
    }

    var preventDoubleSubmit = function(form) {
        form.submit(function() {
            if (form.data('beenSubmitted')) {
                return false;
            }
            if (form.find(".has-error").length === 0) {
                form.data('beenSubmitted', true);
            }
        });
    };


    /**
     * Initialize.
     */
    this.init = function (initNode) {
        self = this;
        // Retrieve and cache dom nodes
        const moduleNodes = initNode.find(SEL_MODULE);
        // Init all matching nodes
        moduleNodes.each(function () {
            const moduleNode = jQuery(this);
            const guestDataModal = moduleNode.find(SEL_REMOVE_GUEST_DATA_MODAL);
            const removeGuestDataCancelButton = moduleNode.find(SEL_MODAL_REMOVE_GUEST_DATA_CANCEL_BUTTON);
            const removeGuestDataButton = moduleNode.find(SEL_MODAL_REMOVE_GUEST_DATA_BUTTON);
            const csrf = moduleNode.find(SEL_CSRF).val();
            const modalErrorMsg = moduleNode.find(SEL_MODAL_ERROR_MSG);
            const customerId = moduleNode.find(SEL_CUSTOMER_ID).val();
            const form = moduleNode.find(SEL_FORM);
            const contactDetailsLabel = form.find(SEL_CONTACT_DETAILS_LABEL);
            const phoneNumber = form.find(SEL_PHONENUMBER_FIELD);

            const phoneFormGroup = phoneNumber.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
            var isPhoneNumberValid = true;
            if(phoneNumber.val() != '') {
                isPhoneNumberValid = !localConfig.phoneNumberError;
            }
            if(!isPhoneNumberValid) {
                contactDetailsLabel.addClass(CSS_HAS_ERROR);
                phoneFormGroup.addClass(CSS_HAS_ERROR);
            }

            removeGuestDataCancelButton.on('click', function () {
                guestDataModal.modal('hide');
            });

            removeGuestDataButton.on('click', function () {
                modalErrorMsg.hide();
                const userListUrl = "/customers";
                const userAnonymizeUrl = "/guest/" + customerId;
                jQuery.ajax({
                    url: userAnonymizeUrl,
                    type: 'DELETE',
                    data: {_csrf: csrf},
                    dataType: 'text',
                    success: function (response, textStatus, xhr) {
                        if (xhr.status === 200) {
                            window.location.href = userListUrl;
                        } else {
                            modalErrorMsg.show();
                        }
                    },
                    error: function () {
                        modalErrorMsg.show();
                    }
                });
            });

            moduleNode.on('click', SEL_REMOVE_GUEST_DATA_BUTTON, function () {
                showRemoveGuestDataModal(guestDataModal);
            });

            // limit the characters with 500 characters
            moduleNode.find(SEL_NOTE).limitLength(500);

            // Form submit validation
            form.on('submit', function (e) {
                var noErrors = handleFormSubmit(this, moduleNode);
                if(noErrors == false){
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    return false;
                }
            });

            preventDoubleSubmit(form);

        });
    };
};

// Make class public to outside world
module.exports = CustomerInformation;
},{"../mediator/mediator":103,"../notification/Notification":125,"jquery/dist/jquery":14}],70:[function(require,module,exports){
/**
 * CustomerList functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

/**
 * Get URL parameter 
 */
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

// Class definition
CustomerList = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						    = '.mod-customer-list';
    var SEL_CUSTOMER_SEARCH_NODE            = '.guests-list';
    var SEL_CUSTOMER_ANCHOR_NODE            = '.table .actions.clickable a';
    var SEL_CUSTOMER_ITEM_CLICK_ZONE	    = '.table tbody tr td.clickable';
    var SEL_UNSUBSCRIBE_BUTTON              = '.unsubscribe-link';

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {

            var moduleNode = jQuery(this);

            var searchParameter = getUrlParameter('q');

            var path = searchParameter ? ("customers?q=" + searchParameter) : "customers";

            moduleNode.find("input[name='path']").attr("value", path);

			var customerItemClickZoneNodes = jQuery(this).find(SEL_CUSTOMER_ITEM_CLICK_ZONE);

            // get the search param and update the view button url accordingly
            if(searchParameter != undefined && searchParameter != ''){
                var viewButtonNode = moduleNode.siblings(SEL_CUSTOMER_SEARCH_NODE).find(SEL_CUSTOMER_ANCHOR_NODE);
                var prevUrl = viewButtonNode.attr('href');
                viewButtonNode.attr('href', prevUrl+'?q='+searchParameter);
            }
			
			customerItemClickZoneNodes.bind('click', function() {
				document.location.href = jQuery(this).parents('tbody').attr('data-editurl');
            });
            
            var unsubscribeBtn = moduleNode.find(SEL_UNSUBSCRIBE_BUTTON);
            unsubscribeBtn.on('click', function (e) {
                e.stopPropagation();
            });			
		});
    };
};

// Make class public to outside world
module.exports = CustomerList;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],71:[function(require,module,exports){


/**
 * Customer functionality.
 */

// Mediator module (handles event delegation)
const mediator = require('../mediator/mediator');

// Modules
CustomerList 				= require('./CustomerList');
CustomerInformation 		= require('./CustomerInformation');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instantiate implementing class
	let customerList 			    = new CustomerList();
	let customerInformation 	= new CustomerInformation();
	
	// Trigger onload activities
	customerList.init(initNode);
	customerInformation.init(initNode);

});
},{"../mediator/mediator":103,"./CustomerInformation":69,"./CustomerList":70}],72:[function(require,module,exports){
/**
 * No-Shows Settings page functionality.
 */

// External libs
const jQuery = require('jquery/dist/jquery');
const FormTimepicker= require('../form/FormTimepicker');
const ArrayUtils = require('../utils/ArrayUtils');
const Alert = require('../modals/Alert');
const Confirm = require('../modals/Confirm');

// Class definition
let DaysHours = function () {

    const SEL_MAIN_FORM                   = 'form';
    const SEL_DATA_CONTAINER              = '.data-container';

    const SEL_MODAL_ERROR_ALERT           = '.reservationHours-alertModal';
    const SEL_MODAL_DELETE_CONFIRM        = '.reservationHours-deleteConfirmModal';

    const SEL_HOURS_CONTAINER             = '.reservation-hours-container';
    const SEL_HOURS_ITEM                  = '.reservation-hours-item';

    const SEL_PARENT_FOR_INPUT            = '.input-parent';
    const SEL_INPUT_WEEKDAYS              = 'select.weekdays-input';
    const SEL_INPUT_START_TIME            = '.startingTime';
    const SEL_INPUT_END_TIME              = '.endingTime';

    const SEL_TIME_INTERVALS_GROUP        = '.time-intervals-group';
    const SEL_TIME_INTERVALS_ITEM         = '.timeIntervalSet';

    const SEL_BUTTON_ADD_ITEM             = '.addTimeSetting';
    const SEL_BUTTON_REMOVE_ITEM          = '.removeTimeSetting';

    const SEL_ACTION_ADD_TIME_INTERVAL    = '.addTimeInterval';
    const SEL_ACTION_REMOVE_TIME_INTERVAL = '.deleteTimeInterval';

    const SEL_TEMPLATE_ITEM               = '.reservationHoursTimeRowTemplate';
    const SEL_TEMPLATE_TIME_INTERVAL      = '.reservationHoursTimeIntervalTemplate';

    const DATA_ATTR_PATH                  = 'path';
    const DATA_ATTR_VALIDATION_ERROR      = 'validationError';
    const DATA_ATTR_DELETE_CONFIRM        = 'deleteConfirm';
    const DATA_CONFIG_PATH                = 'configPath'

    const EVENT_ON_CHANGE_LIST            = 'reservationHours:wizard:listRefreshed';
    const CSS_HAS_ERROR                   = 'has-error';
    const DATA_JOINED_INDEXES             = 'data-joined-indexes';

    const STARTING_TIME_MINUTES           = '.startingTime .timepicker-inner input[type=text]:last-child';
    const ENDING_TIME_MINUTES             = '.endingTime .timepicker-inner input[type=text]:last-child';

    const formTimepicker = new FormTimepicker();
    const alertModal = new Alert();
    const confirmModal = new Confirm();

    let isRecycleMode;

    let addInput = function(container, name, value) {
        return jQuery('<input />')
            .attr('type', 'hidden')
            .attr('name', name)
            .attr('value', value || '')
            .appendTo(container);
    };

    let buildPath = function(path, index, name) {
        return path + '[' + index + '].' + name;
    };

    let buildIntervalPath = function(path, index, subIndex, name) {
        return path + '[' + index + '].timeIntervals[' + subIndex + '].' + name;
    };

    let createItemForSubmit = function(container, path, data, index) {

        if (isRecycleMode === true) {
            console.log("recycle mode is enabled")
            addInput(container, buildPath(path, index, 'id'), data.id || '0');
            addInput(container, buildPath(path, index, 'inRequest'), 'true');
        }
        addInput(container, buildPath(path, index, 'weekday'), data.weekday);

        let timeIntervals = data.timeIntervals || [];
        timeIntervals.forEach(function(timeInterval, i) {
            if (isRecycleMode === true) {
                addInput(container, buildIntervalPath(path, index, i, 'id'), data.id || '0');
                addInput(container, buildIntervalPath(path, index, i, 'inRequest'), 'true');
            }
            addInput(container, buildIntervalPath(path, index, i, 'startHour'), timeInterval.startHour);
            addInput(container, buildIntervalPath(path, index, i, 'startMinute'), timeInterval.startMinute);
            addInput(container, buildIntervalPath(path, index, i, 'endHour'), timeInterval.endHour);
            addInput(container, buildIntervalPath(path, index, i, 'endMinute'), timeInterval.endMinute);
        });

    };

    let updateDataForSubmit = function(moduleNode, data) {

        let container = moduleNode.find(SEL_DATA_CONTAINER);
        let path = container.data(DATA_ATTR_PATH);

        // remove any previous errors
        container.empty();

        // convert data to inputs
        (data || []).forEach(function (timeSetting, index) {
            createItemForSubmit(container, path, timeSetting, index);
        });

    };

    let findWeekday = function(list, weekday) {
        let results = jQuery.grep(list, function(item) { return item.weekday == weekday; });
        if (results.length) {
            return results[0];
        }
        return null;
    };

    let getWeekdayRow = function(newData, previousData, weekday) {
        // check new data
        let result = findWeekday(newData, weekday);
        if (result) {
            // use the same instance
            return result;
        }
        // check previous data
        result = findWeekday(previousData, weekday);
        let newRow;
        if (result) {
            // get new instance
            newRow = {
                id: result.id || 0,
                weekday: weekday,
                timeIntervals: (result.timeIntervals || []).slice() // clone the time intervals
            };
        } else {
            // completely new weekday, then create one
            newRow = {
                id: 0,
                weekday: weekday,
                timeIntervals: []
            };
        }
        // add to new data
        newData.push(newRow);
        return newRow;
    };

    let isTimeIntervalEqual = function(item1, item2) {
        return item1.startHour === item2.startHour &&
            item1.startMinute === item2.startMinute &&
            item1.endHour === item2.endHour &&
            item1.endMinute === item2.endMinute;
    };

    let addTimeIntervalToList = function(newList, previousList, data) {
        // check new data
        let results = jQuery.grep(newList, function(item) {
            return isTimeIntervalEqual(item, data);
        });
        if (results.length) {
            // item exists, so no need to create duplicates
            return;
        }
        // use an old item (and remove it from the previous list)
        let row = previousList.pop();
        // no item in old list? then let's create a new one
        if (!row) {
            row = {
                id: 0
            };
        }

        // replace values
        row.startHour = data.startHour;
        row.startMinute = data.startMinute;
        row.endHour = data.endHour;
        row.endMinute = data.endMinute;

        // add to new data
        newList.push(row);
    };

    let getTimeIntervalsFromGroup = function(group) {
        let timeIntervals = [];
        group.find(SEL_TIME_INTERVALS_ITEM).each(function() {
            let item = jQuery(this);
            let startTime = formTimepicker.getValue(item.find(SEL_INPUT_START_TIME));
            let endTime = formTimepicker.getValue(item.find(SEL_INPUT_END_TIME));
            timeIntervals.push({
                startHour: startTime.hours,
                startMinute: startTime.mins,
                endHour: endTime.hours,
                endMinute: endTime.mins
            });
        });
        return timeIntervals;
    };

    let calculateDataToSubmitFromInputSimple = function(moduleNode) {
        let data = [];

        let items = moduleNode.find(SEL_HOURS_CONTAINER).find(SEL_HOURS_ITEM);
        items.each(function() {
            let item = jQuery(this);
            let weekdays = item.find(SEL_INPUT_WEEKDAYS).selectpicker('val');
            let timeIntervals = getTimeIntervalsFromGroup(item.find(SEL_TIME_INTERVALS_GROUP));

            (weekdays || []).forEach(function(weekday) {
                let newRow = {
                    weekday: weekday,
                    timeIntervals: []
                };
                (timeIntervals || []).forEach(function(timeInterval) {
                    newRow.timeIntervals.push({
                        startHour: timeInterval.startHour,
                        startMinute: timeInterval.startMinute,
                        endHour: timeInterval.endHour,
                        endMinute: timeInterval.endMinute,
                    });
                });
                data.push(newRow);
            });
        });
        return data;
    }

    let calculateDataToSubmitFromInputRecycle = function(moduleNode, initialData) {

        let data = [];

        let items = moduleNode.find(SEL_HOURS_CONTAINER).find(SEL_HOURS_ITEM);
        items.each(function() {
            let item = jQuery(this);
            let weekdays = item.find(SEL_INPUT_WEEKDAYS).selectpicker('val');
            let timeIntervals = getTimeIntervalsFromGroup(item.find(SEL_TIME_INTERVALS_GROUP));

            (weekdays || []).forEach(function(weekday) {
                let weekdayRow = getWeekdayRow(data, initialData, weekday);

                // lets add all the new ones to a new property,
                // which we will use for syncing old database ids
                weekdayRow.newTimeIntervals = weekdayRow.newTimeIntervals || [];
                timeIntervals.forEach(function(timeInterval) {
                    // add a clone of the time intervals
                    weekdayRow.newTimeIntervals.push({
                        startHour: timeInterval.startHour,
                        startMinute: timeInterval.startMinute,
                        endHour: timeInterval.endHour,
                        endMinute: timeInterval.endMinute,
                    });
                });
            });
        });

        // clean up the time intervals for each weekday now
        data.forEach(function(weekdayRow) {
            let timeIntervals = [];
            let oldTimeIntervals = weekdayRow.timeIntervals;
            weekdayRow.newTimeIntervals.forEach(function(timeIntervalData) {
                addTimeIntervalToList(timeIntervals, oldTimeIntervals, timeIntervalData);
            });
            // replace time intervals
            weekdayRow.timeIntervals = timeIntervals;
            // remove old unsynced time intervals
            delete weekdayRow.newTimeIntervals;
        });

        // we need to clear any existing weekdays, that are no longer covered.
        // we will add these days to the data, but clear the time intervals
        initialData.forEach(function(weekdayRow) {
            if (!findWeekday(data, weekdayRow.weekday)) {
                data.push({
                    id: weekdayRow.id || 0,
                    weekday: weekdayRow.weekday,
                    timeIntervals: [] //clear the time intervals
                });
            }
        });

        return data;
    };

    let calculateDataToSubmitFromInput = function(moduleNode, initialData) {
        if (isRecycleMode === true) {
            return calculateDataToSubmitFromInputRecycle(moduleNode, initialData);
        }
        return calculateDataToSubmitFromInputSimple(moduleNode);
    };

    let buildItemsFromInitialData = function(moduleNode, configPath, initialData, itemTemplate, timeIntervalTemplate) {
        let container = moduleNode.find(SEL_HOURS_CONTAINER).empty();

        if (window.config[configPath].showInitialSetting) {
            //display hours section by default (if no hours present)
            let noPreviousHours = initialData.every(function (opt) {
                return (opt.timeIntervals == null || opt.timeIntervals.length == 0)
            });

            // if previous hours doesn't exist, show the default section to create reservation opening hours
            if (noPreviousHours) {
                addNewItem(moduleNode, itemTemplate, timeIntervalTemplate);
            }
        }

        let itemData = getItemDataFromInitialData(initialData);
        // Removing days which is having 0 intervals
        itemData.forEach(function (item, index, object) {
            if((item.timeIntervals || []).length === 0){
                object.splice(index,1);
            }
        });

        let newitemData = itemData;
        newitemData.forEach(function (item) {
            createItemFromData(container, item, itemTemplate, timeIntervalTemplate);
        });
    };

    let buildVirtualId = function(timeInterval) {
        return [
            timeInterval.startHour,
            timeInterval.startMinute,
            timeInterval.endHour,
            timeInterval.endMinute
        ].join(':');
    };

    let getItemDataFromInitialData = function(initialData) {

        let timeIntervalsToWeekdays = {};
        let virtualIdsToTimeIntervals = {};
        let weekdaysToTimeIntervals = {};

        // group weekdays by time intervals
        initialData.forEach(function(weekdayRow) {
            (weekdayRow.timeIntervals || []).forEach(function(timeInterval, indexTimeinterval) {
                timeInterval.virtualId = buildVirtualId(timeInterval);
                virtualIdsToTimeIntervals[timeInterval.virtualId] = timeInterval;
                if (!(timeInterval.virtualId in timeIntervalsToWeekdays)) {
                    timeIntervalsToWeekdays[timeInterval.virtualId] = {
                        days: [],
                        joinedIndexes: []
                    };
                }
                timeIntervalsToWeekdays[timeInterval.virtualId].days.push(weekdayRow.weekday);

                timeIntervalsToWeekdays[timeInterval.virtualId].joinedIndexes.push((weekdayRow.weekday - 1) + '|' + indexTimeinterval);
            });
        });

        // now check for time interval groups
        for (let virtualId in timeIntervalsToWeekdays) {
            let weekdays = timeIntervalsToWeekdays[virtualId].days;
            let weekdaysId = weekdays.sort().join(':');
            if (!(weekdaysId in weekdaysToTimeIntervals)) {
                weekdaysToTimeIntervals[weekdaysId] = {
                    id: weekdaysId,
                    weekdays: weekdays,
                    timeIntervals: {
                        ids: [],
                        joinedIndexes: {}
                    }
                };
            }
            weekdaysToTimeIntervals[weekdaysId].timeIntervals.ids.push(virtualId);

            weekdaysToTimeIntervals[weekdaysId].timeIntervals.joinedIndexes[virtualId] = timeIntervalsToWeekdays[virtualId].joinedIndexes;
        }

        let items = [];
        for (let weekdaysId in weekdaysToTimeIntervals) {
            let weekdayGroup = weekdaysToTimeIntervals[weekdaysId];
            let timeIntervals = ArrayUtils.unique(weekdayGroup.timeIntervals.ids)
                .map(function(virtualId) {
                    virtualIdsToTimeIntervals[virtualId].joinedIndexes = weekdayGroup.timeIntervals.joinedIndexes[virtualId];
                    return virtualIdsToTimeIntervals[virtualId];
                });
            items.push({
                weekdays: weekdayGroup.weekdays,
                timeIntervals: timeIntervals
            });
        }

        return items;
    };

    let handleTimeIntervalError = function (form, configPath) {
        let errorsOpeningTimes = window.config[configPath].errorsOpeningTimes;
        let timeIntervals = form.find('[' + DATA_JOINED_INDEXES + ']');
        let errorDisplayed = false;
        errorsOpeningTimes.forEach(function (error) {
            timeIntervals.map(function () {
                let timeInterval = jQuery(this);
                let joinedIndexes = timeInterval.attr(DATA_JOINED_INDEXES).split(',');
                if (jQuery.inArray(error.index, joinedIndexes) != -1) {
                    timeInterval.parent().addClass(CSS_HAS_ERROR);
                    if(errorDisplayed != true){
                        timeInterval.parent().append(error.label);
                        errorDisplayed = true;
                    }
                }
            });
        });
    }

    let createItemFromData = function(container, data, itemTemplate, timeIntervalTemplate) {
        let item = itemTemplate.find(SEL_HOURS_ITEM).clone();

        item.find(SEL_INPUT_WEEKDAYS).selectpicker('val', data.weekdays);

        (data.timeIntervals || []).forEach(function(timeInterval) {
            let interval = addNewTimeInterval(item, timeIntervalTemplate);
            formTimepicker.setValue(interval.find(SEL_INPUT_START_TIME), timeInterval.startHour, timeInterval.startMinute);
            formTimepicker.setValue(interval.find(SEL_INPUT_END_TIME), timeInterval.endHour, timeInterval.endMinute);
            interval.attr(DATA_JOINED_INDEXES, timeInterval.joinedIndexes);
        });

        item.appendTo(container);

        initialiseItem(item);
    };

    let initialiseItem = function(item) {
        item.find(SEL_INPUT_WEEKDAYS)
            .selectpicker()
            .on('change', function() {
                clearError(jQuery(this));
            });
        item.find(SEL_INPUT_START_TIME).each(function() {
            formTimepicker.init(jQuery(this));
        });
        item.find(SEL_INPUT_END_TIME).each(function() {
            formTimepicker.init(jQuery(this));
        });

        // to check if the existed time has 00 minutes or not
        let timeIntervalSet = item.find('.timeIntervalSet');
        timeIntervalSet.each(function(){
            let interval = jQuery(this);
            let startTimeMinutes = interval.find(STARTING_TIME_MINUTES).val();
            let endTimeMinutes = interval.find(ENDING_TIME_MINUTES).val();
            initialiseMinutes(interval, startTimeMinutes, STARTING_TIME_MINUTES);
            initialiseMinutes(interval, endTimeMinutes, ENDING_TIME_MINUTES);
        })
    };

    let initialiseMinutes = function(item, minutes, type){
        if(minutes == '00' || minutes == ''){
            item.find(type).val('00');
        }
    };

    let highlightError = function(input) {
        input.parents(SEL_PARENT_FOR_INPUT).addClass(CSS_HAS_ERROR);
    };

    let clearError = function(input) {
        input.parents(SEL_PARENT_FOR_INPUT).removeClass(CSS_HAS_ERROR);
    };

    let isFormValid = function(moduleNode) {
        let errors = [];

        let items = moduleNode.find(SEL_HOURS_CONTAINER).find(SEL_HOURS_ITEM);

        // weekdays
        items.find(SEL_INPUT_WEEKDAYS).each(function() {
            let input = jQuery(this);
            let value = input.selectpicker('val') || [];
            if (!value.length) {
                errors.push(input);
                highlightError(input);
            } else {
                clearError(input);
            }
        });

        // time intervals - starting times
        items.find(SEL_INPUT_START_TIME).each(function() {
            let startingTime = jQuery(this);
            let invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(startingTime);
            if (invalidTimepicker.length) {
                invalidTimepicker.forEach(function(timepicker) {
                    errors.push(timepicker);
                });
            }
        });

        // time intervals - ending times
        items.find(SEL_INPUT_END_TIME).each(function() {
            let endingTime = jQuery(this);
            let invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(endingTime);
            if (invalidTimepicker.length) {
                invalidTimepicker.forEach(function(timepicker) {
                    errors.push(timepicker);
                });
            }
        });

        return !errors.length;
    };

    let addNewItem = function(moduleNode, itemTemplate, timeIntervalTemplate) {
        let container = moduleNode.find(SEL_HOURS_CONTAINER);
        let item = itemTemplate.find(SEL_HOURS_ITEM).clone();
        addNewTimeInterval(item, timeIntervalTemplate);
        item.appendTo(container);
        initialiseItem(item);
        return item;
    };

    let removeItem = function(item) {
        item.remove();
    };

    let addNewTimeInterval = function(item, timeIntervalTemplate, initialiseTimepickers) {
        let timeIntervalsContainer = item.find(SEL_TIME_INTERVALS_GROUP);
        let interval = timeIntervalTemplate.find(SEL_TIME_INTERVALS_ITEM).clone();
        interval.appendTo(timeIntervalsContainer);

        // initialise time picker
        if (initialiseTimepickers) {
            interval.find(SEL_INPUT_START_TIME).each(function() {
                formTimepicker.init(jQuery(this));
            });
            interval.find(SEL_INPUT_END_TIME).each(function() {
                formTimepicker.init(jQuery(this));
            });
        }

        refreshTimeIntervals(item);
        return interval;
    };

    let removeTimeInterval = function(timeInterval) {
        let item = timeInterval.parents(SEL_HOURS_ITEM);
        timeInterval.remove();
        refreshTimeIntervals(item);
    };

    let refreshTimeIntervals = function(item) {
        // disable the remove action button in the time interval, if there's only one
        let timeIntervals = item.find(SEL_TIME_INTERVALS_ITEM);
        timeIntervals.find(SEL_ACTION_REMOVE_TIME_INTERVAL).prop('disabled', timeIntervals.length < 2);
    };

    let showErrorModal = function(modal, error) {
        alertModal.show(modal, error);
    };

    let addAndSetMinutes = function(inputs){
        inputs.each(function(){
            let item = jQuery(this);
            if(item.val() == '00' || item.val() == ''){
                item.val('00');
            }
        });
    };

    /**
     * Initialize.
     */
    this.init = function (initNode, recycleMode) {

        isRecycleMode = recycleMode === true;
        initNode.each(function () {

            let moduleNode = jQuery(this);

            let mainForm = moduleNode.parents(SEL_MAIN_FORM);

            let errorAlertModal = moduleNode.find(SEL_MODAL_ERROR_ALERT);
            let validationErrorMessage = moduleNode.data(DATA_ATTR_VALIDATION_ERROR);

            let deleteConfirmModal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM);
            let deleteConfirmMessage = moduleNode.data(DATA_ATTR_DELETE_CONFIRM);

            let itemTemplate = moduleNode.find(SEL_TEMPLATE_ITEM).remove();
            let timeIntervalTemplate = moduleNode.find(SEL_TEMPLATE_TIME_INTERVAL).remove();
            let configPath = moduleNode.data(DATA_CONFIG_PATH);
            let initialData = window.config[configPath].form || [];

            // we need to create the data just before submitting the form
            mainForm.on('submit', function(event) {
                if (!isFormValid(moduleNode)) {
                    showErrorModal(errorAlertModal, validationErrorMessage);
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    return false;
                }
                let data = calculateDataToSubmitFromInput(moduleNode, initialData);
                updateDataForSubmit(moduleNode, data);
            });
            // handle adding and removing items
            moduleNode.on('click', SEL_BUTTON_ADD_ITEM, function() {
                addNewItem(moduleNode, itemTemplate, timeIntervalTemplate);
                jQuery(moduleNode).trigger(EVENT_ON_CHANGE_LIST);
            });
            moduleNode.on('click', SEL_BUTTON_REMOVE_ITEM, function() {
                let button = jQuery(this);
                confirmModal.show(deleteConfirmModal, deleteConfirmMessage)
                    .done(function() {
                        let item = button.parents(SEL_HOURS_ITEM);
                        removeItem(item);
                        jQuery(moduleNode).trigger(EVENT_ON_CHANGE_LIST);
                    });
            });

            // handle adding and removing time intervals
            moduleNode.on('click', SEL_ACTION_ADD_TIME_INTERVAL, function() {
                let button = jQuery(this);
                let item = button.parents(SEL_HOURS_ITEM);
                addNewTimeInterval(item, timeIntervalTemplate, true);

                // set 00  to new created time slot and check if the existed time has 00 minutes or not
                let startTimeInputs = item.find(STARTING_TIME_MINUTES);
                let endTimeInputs = item.find(ENDING_TIME_MINUTES);

                if(startTimeInputs.length > 0){
                    addAndSetMinutes(startTimeInputs);
                }

                if(endTimeInputs.length > 0){
                    addAndSetMinutes(endTimeInputs);
                }
            });

            moduleNode.on('click', SEL_ACTION_REMOVE_TIME_INTERVAL, function() {
                let button = jQuery(this);
                let timeInterval = button.parents(SEL_TIME_INTERVALS_ITEM);
                removeTimeInterval(timeInterval);
            });

            buildItemsFromInitialData(moduleNode, configPath, initialData, itemTemplate, timeIntervalTemplate);
            handleTimeIntervalError(mainForm, configPath)
        });
    };

};

// Make class public to the outside world
module.exports = DaysHours;

},{"../form/FormTimepicker":90,"../modals/Alert":110,"../modals/Confirm":111,"../utils/ArrayUtils":183,"jquery/dist/jquery":14}],73:[function(require,module,exports){
/**
 * FormData functionality.
**/

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
var DataObject = function(weekdays, discount, discountType, startHour, startMin, endHour, endMin, customText, startDate, endDate, id) {
	this.weekdays = weekdays;
	this.discount = discount;
	this.discountType = discountType;
	this.startHour = startHour;
	this.startMin = startMin;
	this.endHour = endHour;
  	this.endMin = endMin;
  	this.customText = customText;
	this.startDate = startDate;
	this.endDate = endDate;
	this.id = id;
};

// Make class public to outside world
module.exports = DataObject;
},{"jquery/dist/jquery":14}],74:[function(require,module,exports){
/**
 * DiscountHours functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');
Tracking       = require('../utils/Tracking');

// External libs
jQuery = require('jquery/dist/jquery');

var UserInterfaceUtils = require('../utils/UserInterfaceUtils');

var moment 			= require('moment/min/moment-with-locales');
var HiddenData 		= require('./HiddenData');
var ItemsList 		= require('./ItemsList');
var Form 			= require('./Form');
var ExistentForm 	= require('./ExistentForm');
var FormTimepicker  = require('../form/FormTimepicker');
var Confirm         = require('../modals/Confirm');
var DataObject      = require('./DataObject');

// Class definition
var DiscountHours = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE									= '.mod-discount-hours';
	var SEL_HEADLINE_MODULE							= '.mod-headline';
	var SEL_DISCOUNT_HOURS_CONTAINER				= '.discountHours-container';
	var SEL_INITIAL_OFFERS							= '.discountHours-initialOffers';
	var SEL_INITIAL_OFFERS_CONTAINER				= '.discountHours-initialOffers-container';
	var SEL_MAIN_FORM_MODULE						= '.mod-settings-discount-hours';
	var SEL_WIZARD_MAIN_FORM						= '#wizardFlowStepForm';

	var SEL_NO_ITEMS_CARD							= '.no-card-added';
	var SEL_TEMPLATE_LIST_ROW						= '.discountHoursListRowTemplate';
	var SEL_TEMPLATE_DATA_ROW						= '.discountHoursRowDataTemplate';
	var SEL_TEMPLATE_ONETIME_DATA_ROW 				= '.discountHoursOneTimeRowDataTemplate';
	var SEL_DISCOUNT_HOURS_TEMPLATE					= '.discountHoursItemTemplate';
	var SEL_DISCOUTN_HOURS_EXISTENT_ITEM_TEMPLATE 	= '.discountHoursExistentItemTemplate';
	var SEL_DISCOUNT_HOURS_ITEM		 				= '.discountHoursItem';
	var SEL_DISCOUNT_HOURS_EXISTENT_ITEM			= '.discountHoursExistentItem';
	var SEL_HIDDEN_FORM_DATA						= '.discountHours-hiddenFormData';
	var SEL_FORM									= '.discountHours-addEditForm';
	var SEL_LIST									= '.discountHours-itemsList';
  	var SEL_MODAL_DELETE_CONFIRM        			= '.reservationHours-deleteConfirmModal';
	var SEL_ANOTHER_CARD 							= '.add-time-settings-card';
	var SEL_FORM_INPUT_TIMES_GROUP          		= '.form-group-field-times';
	var SEL_INPUT_START_TIME            			= '.startingTime';
 	var SEL_INPUT_END_TIME             				= '.endingTime';
	var SEL_TIME_INTERVAL_FORM_GROUP 				= '.form-group.mod-form-timepicker';
	var SEL_DELETE_CARD 							= '.removeTimeSetting';
	var SEL_NAVBAR									= '.navbar';
	var SEL_EDIT_ICON 								= '.editForm';
	
	var SEL_ACTIVITY_SELECTOR_WRAPPER				= '.btn-group.activitySelector';
	var SEL_ACTIVITY_SELECTOR_INPUT     			= '.activitySelector :input';
	var SEL_ACTIVE_SELECTOR_ACTIVITY_INPUT 			= '.activitySelector label.active input';
	var SEL_DISCOUNT_ONE_TIME_SECTION				= '.discountHours-oneTimeSection';
	var SEL_DISCOUNT_RECURRING_SECTION				= '.discountHours-recurringOption';
	var SEL_DISCOUNT_FORM_INPUTS_WRAPPER 			= '.discountHours-formInputs';
	var SEL_DISCOUNT_FORM_INPUTS 					= '.discountHours-formInputs input';
	var SEL_DISCOUNT_HOURS_TIMEINTERVALS			= '.timeIntervals';
	var SEL_WEEKDAY_INPUT 							= '#input-discountHoursDays';
	var SEL_STARTING_TIME_INPUT_GROUP 				= '.startingTime .input-group';
	var SEL_ENDING_TIME_INPUT_GROUP 				= '.endingTime .input-group';
	var SEL_TIME_INTERVALS_HELP_BLOCK 				= '.timeIntervals-help-block';
	var SEL_STARTING_TIME_FORM_GROUP 			 	= '.form-group-field-times .startingTime';
	var SEL_ENDING_TIME_FORM_GROUP 			 		= '.form-group-field-times .endingTime';

	var SEL_HIDDEN_INPUT_START_HOUR     			= '.hidden-input-startHour';
	var SEL_HIDDEN_INPUT_START_MIN      			= '.hidden-input-startMinute';
	var SEL_HIDDEN_INPUT_END_HOUR       			= '.hidden-input-endHour';
	var SEL_HIDDEN_INPUT_END_MIN        			= '.hidden-input-endMinute';
	var SEL_HIDDEN_INPUT_START_DATE 				= '.hidden-input-startDate';
	var SEL_HIDDEN_INPUT_END_DATE 					= '.hidden-input-endDate';
	var SEL_HIDDEN_INPUT_ONTIME_ROW_ID 				= '.hidden-input-rowId';

	var SEL_HIDDEN_FORM_DATA	  					= '.discountHours-hiddenFormData';
	var SEL_HIDDEN_FORM_DATA_WEEK_DAY     			= '.discountHours-hiddenFormData-weekday';
	var SEL_HIDDEN_FORM_DATA_ROW          			= 'span.discountHours-rowData';
	var SEL_DISCOUNT_ONETIME_HIDDEN_ROWS  			= '.discountHours-hiddenFormData-oneTime span.discountHours-rowData';
	
	var SEL_START_TIME_MINUTE_INPUT					= ".startingTime .timepicker-inner input[type=text]:last-child";
	var SEL_END_TIME_MINUTE_INPUT					= ".endingTime .timepicker-inner input[type=text]:last-child";
	var SEL_ONE_TIME_HIDDEN_DATA_ROWS  				= '.discountHours-hiddenFormData .discountHours-hiddenFormData-oneTime span.discountHours-rowData';
	
	var SEL_INPUT_DATE_TYPE             			= 'select.dateType';
	var SEL_INPUT_DATE_START           				= 'input.startDate';
  	var SEL_INPUT_DATE_END              			= 'input.endDate';
	var SEL_START_DATE_FORM_GROUP 					= '.form-group.start-date-group';
	var SEL_END_DATE_FORM_GROUP 					= '.form-group.end-date-group';
	var SEL_DATE_GROUP_END_DATE         			= '.date-group.date-group-endDate';
	var SEL_INPUT_DATE_END_INTERNAL     			= 'input.endDateInternal';
	var SEL_DATE_HELP_BLOCK 						= '.help-block';
	var SEL_DATE_WITH_SPAN_HELP_BLOCK				= '.help-block span';
	var SEL_FORM_NOT_ACTIVE_LABEL 					= 'label:not(.active)';
	var SEL_FORM_GROUP_HAS_ERROR 					= '.form-group.has-error';
	var SEL_FORM_ONETIME_TIMEINTERVALS_WRAPPER      = '.discountHours-dateTimeSettings';
	var SEL_FORM_ONETIME_TIMEPICKER_INPUT_GROUP 	= '.timepicker-inner .input-group';
		
	var DATA_JOINED_INDEXES 						= 'joinedIndex';
	var CSS_ERROR 									= 'has-error';
	var CSS_TOGGLE_ON								= 'toggle-active';
	var MERIDIEM_AM									= 'am';
	var MERIDIEM_PM									= 'pm';
	var DATA_ATTRIBUTE_MERIDIEM						= 'meridiem';
	var DATA_ATTR_DELETE_CONFIRM       				= 'deleteConfirm';
	var CSS_HIDDEN                      			= 'hidden';
	var RECURRING_OPTION_TEXT						= 'recurring';
	var FORM_ERROR_TYPE								= "form-error";
	var FORM_EVENT_TYPE								= "error-form";
	var FORM_EVENT_NAME								= "error";
	var FORM_EVENT_ACTION_NAME						= "Add Offer";
	var FORM_ERROR_MESSAGE							= "All fields are mandatory.";

	var FORM_CLICK_EVENT_NAME						= "save";
	var FORM_CLICK_EVENT_TYPE						= "click";
	
	var formNumber = 0;
	var formArray = [];
	var formTimepicker = new FormTimepicker();
	var confirmModal = new Confirm();
	var errorFound = false;

	var formFieldInfo = [];
	var errorToFocus = [];

	//initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.selection = window._adl.selection || [];
	window._adl.error = window._adl.error || {};

	var submitData = function(moduleNode, itemsList, hiddenData, event){
		errorToFocus = [];
		formArray.forEach(function(form, index){
			handleFormButtonAddClick(itemsList, form, hiddenData, index, event);
		});

		//make focus to the error field if any error present during for submission
		if(errorToFocus.length == 1){
			var error = errorToFocus[0].find('select');
			error = error.length > 0 ? error : errorToFocus[0].find('input').first();
			error.focus();
		}
	};

	var updateDatalayerWithDiscountInfo = function(formArray){
		
		var formData = [];

		//get all required form data in formData array
		formArray.forEach(function (form) {
			var dataObject = form.getDataObjectFromValues(form.getActivitySelection());
			var startTime = formatAMPM(dataObject.startHour, dataObject.startMin);
			var endTime = formatAMPM(dataObject.endHour, dataObject.endMin);

			var selectedOption1 = startTime + '-' + endTime;
			var selectedOption2 = dataObject.discount + '% on ' + dataObject.discountType;

			formData.push({
				selectedOption1: selectedOption1,
				selectedOption2: selectedOption2
			});
		});

		if (window._satellite && window._adl) {
			//push eventInfo in _adl
			_adl.eventInfo = {
				eventName: FORM_CLICK_EVENT_NAME,
				eventType: FORM_CLICK_EVENT_TYPE,
				eventAction: FORM_EVENT_ACTION_NAME
			}

			//push all the selections in adobe data layer
			_adl.selection = formData;

			//fire direct call
			window._satellite.track('trackButtonClick');
		}
	}

	var scrollToElement = function(element) {
		if (UserInterfaceUtils.isScreenSize('xs')) {
			var offsetTop = jQuery(SEL_NAVBAR).outerHeight();
			UserInterfaceUtils.scrollToElement(element, offsetTop);
		}
	};

	var updateContainerWithExistingData = function(moduleNode, itemsList, isWizard, hiddenData){
		var rows = itemsList.getAllRows();
		var selectedOption = '';
		var count = 0;

		for(var index = 0; index<rows.length; index++){
			var row = rows[index];
			var dataFromRow = itemsList.getDataObjectFromRow(jQuery(row));

			//if start doesn't exist, set selectedOption as "recurring" otherwise "oneTime"
			if(dataFromRow.startDate == undefined || dataFromRow.startDate == null){
				selectedOption = 'recurring';
			}else{
				selectedOption = 'oneTime';
			}

			//get the data for all existing rows input hidden fields.
			var hiddenRowsObject = [];
			if(selectedOption === 'oneTime'){
				var oneTimeDataRows = moduleNode.find(SEL_ONE_TIME_HIDDEN_DATA_ROWS);
				oneTimeDataRows.each(function(){
					var selectedRowObject = hiddenData.getDataObjectFromRow(jQuery(this));
					hiddenRowsObject.push(selectedRowObject);
				});
			}

			//get the id - if hidden input id = dataFromRow and send it to form.setvalues() function to add the value of if for existing row
			var hiddenObjId = '';
			if(hiddenRowsObject && hiddenRowsObject.length > 0){

				//check if there are more than one rows exist with exact data
				var duplicateHiddenRows = checkDuplicateHiddenRows(hiddenRowsObject, dataFromRow);

				if(duplicateHiddenRows.length > 1){
					hiddenObjId = getRowIdFromDuplicateRows(duplicateHiddenRows, dataFromRow, count);
					count++;
				}else{
					hiddenObjId = getUniqueRowHiddenId(hiddenRowsObject, dataFromRow);
				}
			}

			var container = moduleNode.find(SEL_DISCOUNT_HOURS_CONTAINER);
			var templateItem = moduleNode.find(SEL_DISCOUNT_HOURS_TEMPLATE);
			var item = templateItem.find(SEL_DISCOUNT_HOURS_ITEM).clone();
			var addNewForm = new Form(item, formNumber, selectedOption);

			if(!isWizard){
				resetTimeInterval(item);
			}

			formArray.push(addNewForm);
			addNewForm.init();
			addNewForm.setValues(dataFromRow, container, selectedOption, hiddenObjId, hiddenData);
			jQuery(item).addClass("itemCard" + formNumber);
			item.appendTo(container);
			formNumber++;
		}
		for(var index = 0; index<rows.length; index++){
			var row = rows[index];
			itemsList.deleteRow(jQuery(row));
		}

		// applicable only for wizard flow
		// when comes back from 5th step to 4th step (offers step), clear the span rows for previous data to prevent for creating duplicate entries
		if(window.config.discountHours && window.config.discountHours.isWizard){
			//remove older one time entries
			hiddenData.removeOneTimeInputs();
			//remove older weekday/recurring entries
			hiddenData.removeWeekdayInputs();
		}
	};

	/**
	 * @description check if there are more than one rows exist with exact data
	 * @param {*} hiddenRowsObject 
	 * @param {*} dataFromRow 
	 * @returns 
	 */
	var checkDuplicateHiddenRows = function(hiddenRowsObject, dataFromRow){
		return hiddenRowsObject.filter(function(hiddenObj){
			return (hiddenObj.startDate === dataFromRow.startDate && hiddenObj.endDate === dataFromRow.endDate
					&& hiddenObj.startHour === dataFromRow.startHour && hiddenObj.startMin === dataFromRow.startMin
					&& hiddenObj.endHour === dataFromRow.endHour && hiddenObj.endMin === dataFromRow.endMin);
		});
	}

	/**
	 * @description check if there are more than one rows exist with exact data, and get the hiddenObjId for specific row
	 * @param {*} hiddenRow 
	 * @param {*} row 
	 * @param {*} i 
	 * @returns 
	 */
	var getRowIdFromDuplicateRows = function(hiddenRow, row, i){
		var hiddenObjId = '';

		if(hiddenRow[i].startDate === row.startDate && hiddenRow[i].endDate === row.endDate
			&& hiddenRow[i].startHour === row.startHour && hiddenRow[i].startMin === row.startMin
			&& hiddenRow[i].endHour === row.endHour && hiddenRow[i].endMin === row.endMin){
				hiddenObjId = hiddenRow[i].id;
		}

		return hiddenObjId;
	}

	/**
	 * @description get the hidden id for each row
	 * @param {*} rowObj 
	 * @param {*} row 
	 * @returns 
	 */
	var getUniqueRowHiddenId = function(rowObj, row){
		var hiddenObjId = '';

		rowObj.forEach(function(obj){
			if(obj.startDate === row.startDate && obj.endDate === row.endDate
			&& obj.startHour === row.startHour && obj.startMin === row.startMin
			&& obj.endHour === row.endHour && obj.endMin === row.endMin){
				hiddenObjId = obj.id;
			}
		});

		return hiddenObjId;
	}

	/**
	 * @description update the adobe data layer
	 * @param {*} formArray 
	 */
	var updateAdobeDataLayer = function(formArray){
		var discountData = [];
		formArray.each(function(){
			var item = jQuery(this);
			var selectedTime = item.find('.times-text').text();
			var selectedDiscount = item.find('.discount-text').text();
			discountData.push({'selectedOption1': selectedTime, 'selectedOption2': selectedDiscount})
		});

		if (window._adl) {
			//push eventInfo in _adl
			_adl.eventInfo = {
				eventName: FORM_CLICK_EVENT_NAME,
				eventType: FORM_CLICK_EVENT_TYPE,
				eventAction: FORM_EVENT_ACTION_NAME
			}

			//push all the selections in adobe data layer
			_adl.selection = discountData;
		}
	}

	/**
	 * @description display all the offers if exists, initially
	 * @param {*} moduleNode 
	 * @param {*} itemsList 
	 * @param {*} hiddenData 
	 */
	var showInitialOffers = function(moduleNode, itemsList, hiddenData){
		var rows = itemsList.getAllRows();

		var ADVTrack = localStorage.getItem('ADVTrack');
		if(rows.length !== 0 && ADVTrack){
			//set eventInfo and selection details on data layer “_adl”
			updateAdobeDataLayer(rows);
			localStorage.removeItem('ADVTrack');
		}
		
		for(var index = 0; index<rows.length; index++){
			var row = rows[index];
			//get the data from itemlist row and put it inside dataObject
			var dataFromRow = itemsList.getDataObjectFromRow(jQuery(row));
			var container = moduleNode.find(SEL_INITIAL_OFFERS_CONTAINER);
			var templateItem = moduleNode.find(SEL_DISCOUTN_HOURS_EXISTENT_ITEM_TEMPLATE);
			var item = templateItem.find(SEL_DISCOUNT_HOURS_EXISTENT_ITEM).clone();
			item.appendTo(container);
			var addNewExistentForm = new ExistentForm(item, formNumber);
			addNewExistentForm.init();
			addNewExistentForm.setValues(row, dataFromRow, hiddenData, itemsList);
			jQuery(item).addClass("itemCard" + formNumber);
		}
	};

	/**
	 * @description specific row will be deleted after click on 'X' button
	 * @param {*} moduleNode 
	 * @param {*} itemsList 
	 * @param {*} removedItem 
	 */
	var removeCard = function(moduleNode, itemsList, removedItem, hiddenData){
		var container = moduleNode.find(SEL_DISCOUNT_HOURS_CONTAINER);
		var items = container.find(SEL_DISCOUNT_HOURS_ITEM);
		for(var index = 0; index < items.length; index++){
			if(jQuery(items[index]).hasClass(jQuery(removedItem).attr('class'))){
				items[index].remove();
				formArray.splice(index,1);
				var rows = itemsList.getAllRows();
				itemsList.deleteRow(jQuery(rows[index]));

			}
		}

		//remove weekday span hidden div after removing specific entry (only for Wizard)
		if(window.config.discountHours && window.config.discountHours.isWizard){
			hiddenData.removeWeekdayInputs();
		}
	};
	
	/**
	 * @description create a new row after click on 'add' button
	 * @param {*} moduleNode 
	 */
	var createNewCard = function(moduleNode){
		var container = moduleNode.find(SEL_DISCOUNT_HOURS_CONTAINER);
		var templateCard = moduleNode.find(SEL_DISCOUNT_HOURS_TEMPLATE);
		var itemTemplate = templateCard.find(SEL_DISCOUNT_HOURS_ITEM).clone();
		var addNewForm = new Form(itemTemplate, formNumber, RECURRING_OPTION_TEXT);
		formArray.push(addNewForm);
		addNewForm.clear();
		addNewForm.init();
		resetTimeInterval(itemTemplate);
		jQuery(itemTemplate).addClass("itemCard" + formNumber);

		// initialize minutes with 00 for new item creation --> FOR RECURRING OPTION
		var timesGroup = itemTemplate.find(SEL_DISCOUNT_RECURRING_SECTION).find(SEL_FORM_INPUT_TIMES_GROUP);
		timesGroup.find(SEL_START_TIME_MINUTE_INPUT).val('00');
        timesGroup.find(SEL_END_TIME_MINUTE_INPUT).val('00');

		// initialize minutes with 00 for new item creation --> FOR ONETIME OPTION
		var timesGroupOneTime = itemTemplate.find(SEL_DISCOUNT_ONE_TIME_SECTION).find(SEL_FORM_INPUT_TIMES_GROUP);
		timesGroupOneTime.find(SEL_START_TIME_MINUTE_INPUT).val('00');
        timesGroupOneTime.find(SEL_END_TIME_MINUTE_INPUT).val('00');

		itemTemplate.appendTo(container);
		//to retain the radio button which is getting disappear after create 3rd row
		var containerRow = container.find(SEL_DISCOUNT_HOURS_ITEM);

		if(containerRow.length >= 3){
			var secondRow = containerRow.eq(1);
			for(var i=0; i<2; i++){
				secondRow.find(SEL_DISCOUNT_FORM_INPUTS_WRAPPER).find(SEL_ACTIVITY_SELECTOR_WRAPPER).find(SEL_FORM_NOT_ACTIVE_LABEL).trigger('click');
			}
		}

		//make focus to the newly creatd row after click on 'add' button
		itemTemplate.find(SEL_DISCOUNT_FORM_INPUTS).focus();
		formNumber++;
	};

	var resetTimeInterval = function(item) {
		item.find(SEL_INPUT_START_TIME).each(function() {
			formTimepicker.init(jQuery(this));
		});  
		
		item.find(SEL_INPUT_END_TIME).each(function() {
			formTimepicker.init(jQuery(this));
		});
	};

	var formatAMPM = function(hours,minutes) {
		var ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0'+minutes : minutes;
		var time = hours + ':' + minutes +  ampm;
		return time;
	}

	var handleFormButtonAddClick = function(itemsList, form, hiddenData, index, event) {
		var onSuccess = function() {
			var dataObject = form.getDataObjectFromValues(form.getActivitySelection());
			itemsList.addRow(dataObject, hiddenData, form.getActivitySelection(), index);
			
			if(form.getActivitySelection() === 'recurring'){
				hiddenData.resetDataIndexes();
			}

			itemsList.refresh();
			scrollToElement(itemsList.getNode());
			errorFound = false;
			formFieldInfo.push(form);
		};

		var onFail = function(errorMessage) {
			//make focus to the first error field if any error present during for submission
			if(errorToFocus.length == 0){
				var errorNode = form.getNode();
				errorToFocus.push(errorNode.find(SEL_FORM_GROUP_HAS_ERROR).first());
			}

			if(errorFound == false){
				var dataObject = form.getDataObjectFromValues(form.getActivitySelection());
				var errorField;
				var weekdaysCondition = (dataObject.weekdays.length === 0);
				var discountTypeCondition = (dataObject.discountType === "" || dataObject.discountType === null);
				var timeCondition = (dataObject.startHour === "" || dataObject.startMin === "" || dataObject.endHour === "" || dataObject.endMin === "");
				
				switch(!errorFound){
					case (weekdaysCondition && timeCondition && discountTypeCondition):
						errorField = 'Days | Time | Selected Items';
						break;
					case (weekdaysCondition && timeCondition):
						errorField = 'Days | Time';
						break;
					case (weekdaysCondition && discountTypeCondition):
						errorField = 'Days | Selected Items';
						break;
					case (timeCondition && discountTypeCondition):
						errorField = 'Time | Selected Items';
						break;
					case (weekdaysCondition):
						errorField = 'Days';
						break;
					case (timeCondition):
						errorField = 'Time';
						break;
					case (discountTypeCondition):
						errorField = 'Selected Items';
						break;					
				}

				updateDatalayerErrorTracking(errorField);
				alert(errorMessage);

				// stop reloading the page for settings offers
				event.preventDefault();
			}
			errorFound = true;
		};
		form.validateAndProcess(onSuccess, onFail, form.getActivitySelection());
	};

	//to update error tracking in adobe datalayer with event info
	var updateDatalayerErrorTracking = function(errorField){
		if (window._satellite && window._adl) {
		  //push eventInfo in _adl
		  _adl.eventInfo = {
			eventName: FORM_EVENT_NAME,
			eventType: FORM_EVENT_TYPE
		  }
	
		  //push all the errors in adobe data layer
		  _adl.error = {
			errorType: FORM_ERROR_TYPE,
			errorMessage: FORM_ERROR_MESSAGE,
			errorFields: errorField
		  }

		  _adl.selection = [];
	
		  //fire direct call
		  window._satellite.track('errorCall');
		}
	}

	/**
   * Handles the switch of fixed date to timeframe as date type.
   */
	 var updateActivitySelection = function(radioOption) {
		var row = radioOption.parents(SEL_ACTIVITY_SELECTOR_WRAPPER);
		var recurringOption = row.siblings(SEL_DISCOUNT_RECURRING_SECTION);
		var oneTimeOption = row.siblings(SEL_DISCOUNT_ONE_TIME_SECTION);
		var timeIntervals = oneTimeOption.find(SEL_DISCOUNT_HOURS_TIMEINTERVALS);

		if(radioOption.val() === 'recurring'){
			recurringOption.removeClass(CSS_HIDDEN);
			oneTimeOption.addClass(CSS_HIDDEN);
		}else{
			recurringOption.addClass(CSS_HIDDEN);
			oneTimeOption.removeClass(CSS_HIDDEN);
		}

		if(!oneTimeOption.hasClass(CSS_HIDDEN)){
			var dateGroupType = oneTimeOption.find(SEL_INPUT_DATE_TYPE)[0].value;
			dateGroupType === 'date' ? timeIntervals.addClass(CSS_HIDDEN) : timeIntervals.removeClass(CSS_HIDDEN);
		}
	};

	/**
   * Handles the switch of fixed date to timeframe as date type.
   */
	var updateDataType = function(dateTypeInput) {
		var row                         = dateTypeInput.parents(SEL_DISCOUNT_ONE_TIME_SECTION);
		var timeIntervals				= row.find(SEL_DISCOUNT_HOURS_TIMEINTERVALS);
		var groupEndDate                = row.find(SEL_DATE_GROUP_END_DATE);
		var dateStartInputNode          = row.find(SEL_INPUT_DATE_START);
		var dateEndInputNode            = row.find(SEL_INPUT_DATE_END);
		var dateEndInternalInputNode    = row.find(SEL_INPUT_DATE_END_INTERNAL);
	
		initCalendarLanguage(dateStartInputNode);
		initCalendarLanguage(dateEndInputNode);

		if (dateTypeInput.val() == 'timeframe') {
			// Show according fields
			timeIntervals.removeClass(CSS_HIDDEN);
			groupEndDate.removeClass(CSS_HIDDEN);

			// Show same as start date in case none was selected before
			if (dateEndInternalInputNode.val() == '') {
				dateEndInputNode.datepicker('setDate', dateStartInputNode.datepicker('getDate'));
			}
		} else {
			// Hide according fields
			timeIntervals.addClass(CSS_HIDDEN);
			groupEndDate.addClass(CSS_HIDDEN);

			//update hidden fields for both hours and minutes for start and end time with 0
			formTimepicker.clear(timeIntervals.find(SEL_INPUT_START_TIME));
			formTimepicker.clear(timeIntervals.find(SEL_INPUT_END_TIME));
			timeIntervals.find(SEL_START_TIME_MINUTE_INPUT).val('00');
			timeIntervals.find(SEL_END_TIME_MINUTE_INPUT).val('00');
		
			// Reset date fields
			dateEndInputNode.val('');
			dateEndInternalInputNode.val('');
		}
	};

	/**
	 * @description localize calendar for selected language
	 * @param {*} node 
	 */
	var initCalendarLanguage = function(node){
		node.datepicker({
			format: (window.config.discountHours && window.config.discountHours.dateFormat),
			language: (window.config.discountHours && window.config.discountHours.calendarLanguageCode),
		});
	}

	/**
   * Init datepicker
   */
	var initDatepicker = function(moduleNode) {
		var dateFields = moduleNode.find(SEL_DISCOUNT_HOURS_TEMPLATE).find(SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END);

		// Init datepicker
		dateFields.datepicker({
			format: (window.config.discountHours && window.config.discountHours.dateFormat),
			language: (window.config.discountHours && window.config.discountHours.calendarLanguageCode),
			weekStart: 1,
			autoclose: true,
			todayHighlight: false
		});

		// On focus - display datepicker or calendar
		moduleNode.on('focus', SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END, function() {
			var node = jQuery(this);
			updateDatePicker(node);
		});
	
		// Track datepicker changes
		moduleNode.on('change', SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END, function() {
			var node = jQuery(this);
			updateDatePicker(node);
		});
	};

	var updateDatePicker = function(node){

		initCalendarLanguage(node);
		
		var internalNode  = node.prev();
		var date = node.datepicker('getUTCDate');

		if (date != undefined) {
			var dateUtils = new DateUtils();
			var dateObj = dateUtils.toDate(date);
			internalNode.val(dateObj);
		}
	}

	//if any conflicting error occurs, this function will execute
	var handleTimeIntervalError = function (form, container) {
		var errorsOneTimes = window.config.settingsTimeSettings && window.config.settingsTimeSettings.errorsOneTimes;
		var errorsOpeningTimes = window.config.settingsTimeSettings && window.config.settingsTimeSettings.errorsOpeningTimes;
		var errorLabel = (errorsOpeningTimes && errorsOpeningTimes.length > 0) ? errorsOpeningTimes[0].label : '';
		var errorDateLabel = (errorsOneTimes && errorsOneTimes.length > 0) ? errorsOneTimes[0].label : '';

		var errorFieldIndexes = [];
		var joinedIndexesTime = [];

		//validation for recurring overlapping time interval fields
		if(errorsOpeningTimes && errorsOpeningTimes.length > 0){
			errorsOpeningTimes.forEach(function(item){
				errorFieldIndexes.push(item.index.split('|')[0]);
			});
	
			var unique = errorFieldIndexes.filter(function(itm, i, a) {
				return i == a.indexOf(itm);
			});
			
            // will only applicable for discount settings page
            if(window.config.discountHours && window.config.discountHours.isWizard !== 'true'){
                form.find(SEL_EDIT_ICON).trigger('click');
                //prefill minutes with 00 for both recurring and oneTime option
                prefillMinutesWithZero(container);
            }

			var optionType = container.find(SEL_DISCOUNT_HOURS_ITEM).find(SEL_ACTIVE_SELECTOR_ACTIVITY_INPUT).val();

			if(optionType === 'recurring'){
				//getting the data from hidden span rows with joined index
				var joinedIndexesTime = getRecurringHiddenInputData(container, errorsOpeningTimes);
				overlappingTimeIntervalErrors(container, unique, joinedIndexesTime, errorLabel);
			}
		}
		
		//validation for onetime date fields
		if(errorsOneTimes && errorsOneTimes.length > 0){

			// will only applicable for discount settings page
            if(window.config.discountHours && window.config.discountHours.isWizard !== 'true'){
				form.find(SEL_EDIT_ICON).trigger('click');
				//prefill minutes with 00 for both recurring and oneTime option
				prefillMinutesWithZero(container);
			}

			var affectedRows = [];
			var oneTimeHiddenRows = container.siblings(SEL_HIDDEN_FORM_DATA).find(SEL_DISCOUNT_ONETIME_HIDDEN_ROWS);

			if(oneTimeHiddenRows.length > 0){
				//get hidden input fields data in an array
				oneTimeHiddenData = getOneTimeHiddenRowData(oneTimeHiddenRows);
			}

			if(oneTimeHiddenData.length > 0){
				//get the rows data, which matches (errorRowIndex == hiddenRowIndex) condition
				affectedRows = getAffectedRowsData(errorsOneTimes, oneTimeHiddenData);
				showDateOverlappingValidation(affectedRows, container, errorDateLabel);
			}
		}
	}

	/**
	 * @description display error message for dateField
	 * @param {*} affectedRows 
	 * @param {*} container 
	 * @param {*} errorDateLabel 
	 */
	 var showDateOverlappingValidation = function(affectedRows, container, errorDateLabel){
		affectedRows.forEach(function(innerRow){
			container.find(SEL_DISCOUNT_HOURS_ITEM).each(function(){
				var row = jQuery(this);
				var oneTimeRow = row.find(SEL_DISCOUNT_ONE_TIME_SECTION);
				var optionType = row.find(SEL_ACTIVE_SELECTOR_ACTIVITY_INPUT).val();

				if(optionType === 'oneTime'){
					var startDateInput = oneTimeRow.find(SEL_INPUT_DATE_START);
					var endDateInput = oneTimeRow.find(SEL_INPUT_DATE_END);

					var timeInput = endDateInput.closest(SEL_FORM_ONETIME_TIMEINTERVALS_WRAPPER).find(SEL_DISCOUNT_HOURS_TIMEINTERVALS);
					var startTimeInput = timeInput.find(SEL_INPUT_START_TIME);
					var endTimeInput = timeInput.find(SEL_INPUT_END_TIME);

					//splitting date from comma, because some language weekday translate does not matches
					var innerRowStartDateVal = innerRow.startDate !== '' ? innerRow.startDate.split(', ')[1] : innerRow.startDate;
					var innerRowEndDateVal = innerRow.endDate !== '' ? innerRow.endDate.split(', ')[1] : innerRow.endDate;

					if(window.config.discountHours.calendarLanguageCode == 'cs'){
						var startDateVal = startDateInput.val() !== '' ? startDateInput.val().split(' ')[1] : startDateInput.val();
						var endDateVal = endDateInput.val() !== '' ? endDateInput.val().split(' ')[1] : endDateInput.val();
					}else{
						//splitting date from comma, because some language weekday translate does not matches
						//Ex: Stř, 28.07.2021 -> for comparison purpose, have to split it
						var startDateVal = startDateInput.val() !== '' ? startDateInput.val().split(', ')[1] : startDateInput.val();
						var endDateVal = endDateInput.val() !== '' ? endDateInput.val().split(', ')[1] : endDateInput.val();
					}

					//check if startDate and endDate value matches (for 'from' option)
					if((startDateVal === innerRowStartDateVal) && (endDateInput.val() !== "") && (endDateVal === innerRowEndDateVal)){
						if(innerRow.type === 'date'){
							startDateInput.parent(SEL_START_DATE_FORM_GROUP).addClass(CSS_ERROR);
							endDateInput.parent(SEL_END_DATE_FORM_GROUP).addClass(CSS_ERROR);
							endDateInput.siblings(SEL_DATE_HELP_BLOCK).empty().append(errorDateLabel);
							endDateInput.siblings(SEL_DATE_WITH_SPAN_HELP_BLOCK).addClass(CSS_ERROR);
						}else{
							startTimeInput.find(SEL_FORM_ONETIME_TIMEPICKER_INPUT_GROUP).addClass(CSS_ERROR);
							endTimeInput.find(SEL_FORM_ONETIME_TIMEPICKER_INPUT_GROUP).addClass(CSS_ERROR);
							timeInput.find('p.has-error').empty().append(innerRow.errorMsg);
						}
					}

					//check if startDate value matches and endDate is empty (for 'on' option)
					if((startDateVal === innerRowStartDateVal) && (endDateInput.val() === "") && (innerRow.type === 'date')){
						startDateInput.parent(SEL_START_DATE_FORM_GROUP).addClass(CSS_ERROR);
						startDateInput.siblings(SEL_DATE_HELP_BLOCK).empty().append(innerRow.errorMsg);
						startDateInput.siblings(SEL_DATE_WITH_SPAN_HELP_BLOCK).addClass(CSS_ERROR);
					}
				}
			});
		});
	}

	/**
	 * @description get the error rows with start and endDate
	 * @param {*} errorData 
	 * @param {*} hiddenData 
	 * @returns affectedRows - rows which has errors
	 */
	 var getAffectedRowsData = function(errorData, hiddenData){
		var affectedRows = [];

		//match the hidden row index with error rowIndex and get the data in an array
		errorData.forEach(function(error){
			hiddenData.forEach(function(hiddenRow){
				if(error.rowIndex == hiddenRow.rowId){
					affectedRows.push({
						'startDate': hiddenRow.startDate,
						'endDate': hiddenRow.endDate,
						'type': error.type,
						'errorMsg': error.label
					});
				}
			});
		});

		return affectedRows;
	}

	/**
	 * @description get the data of onetime hidden inputs and insert in an array
	 * @param {*} hiddenRow 
	 * @returns hidden input data
	 */
	 var getOneTimeHiddenRowData = function(hiddenRow){
		var oneTimeHiddenData = [];
		hiddenRow.each(function(){
			var span = jQuery(this);
			//get the start and end hours, minutes values
			var startDate = span.find(SEL_HIDDEN_INPUT_START_DATE).val();
			var endDate = span.find(SEL_HIDDEN_INPUT_END_DATE).val();
			var rowId = span.find(SEL_HIDDEN_INPUT_ONTIME_ROW_ID).val();

			//get data of oneTime hidden inputs and insert it in an array
			oneTimeHiddenData.push({
				'rowId': rowId,
				'startDate': startDate,
				'endDate': endDate
			});
		});

		return oneTimeHiddenData;
	}

	/**
	 * @description prefill minutes with 00 for both recurring and oneTime options (if no data available)
	 * @param {*} container 
	 */
	var prefillMinutesWithZero = function(container){
		container.find(SEL_DISCOUNT_HOURS_ITEM).each(function(){
			var row = jQuery(this);
			var recurringRow = row.find(SEL_DISCOUNT_RECURRING_SECTION);
			var oneTimeRow = row.find(SEL_DISCOUNT_ONE_TIME_SECTION);
			var optionType = row.find(SEL_ACTIVE_SELECTOR_ACTIVITY_INPUT).val();

			if(optionType === 'recurring'){
				addZeroMinutes(oneTimeRow);
			}else{
				addZeroMinutes(recurringRow);
			}
		});
	}

	/**
	 * @description add '00' in minutes input
	 * @param {*} row 
	 */
	var addZeroMinutes = function(row){
		var startingTime = row.find(SEL_STARTING_TIME_FORM_GROUP);
		var endingTime = row.find(SEL_ENDING_TIME_FORM_GROUP)
		formTimepicker.setValue(startingTime, '', '00');
		formTimepicker.setValue(endingTime, '', '00');
	}

	/**
	 * @description get the hidden input data for recurring
	 * @param {*} container 
	 * @param {*} errorTimes 
	 * @returns 
	 */
	var getRecurringHiddenInputData = function(container, errorTimes){
		var joinedIndexesTime = [];

		container.siblings(SEL_HIDDEN_FORM_DATA).find(SEL_HIDDEN_FORM_DATA_WEEK_DAY).each(function(){
			var item = jQuery(this);
			var hasSpan = item.find(SEL_HIDDEN_FORM_DATA_ROW);
			if(hasSpan.length !== 0){
				hasSpan.each(function(){
					var span = jQuery(this);
					//get the joined index value
					var joinedIndex = span.find(SEL_HIDDEN_INPUT_START_HOUR).data(DATA_JOINED_INDEXES);
					//get the start and end hours, minutes values
					var startHour = span.find(SEL_HIDDEN_INPUT_START_HOUR).val();
					var startMinute = span.find(SEL_HIDDEN_INPUT_START_MIN).val();
					var endHour = span.find(SEL_HIDDEN_INPUT_END_HOUR).val();
					var endMinute = span.find(SEL_HIDDEN_INPUT_END_MIN).val();
					errorTimes.forEach(function(error){
						//if errorOpeningTimes array have same index as hidden span row joinedIndex, push the time values
						if(error.index === joinedIndex){
							joinedIndexesTime.push({
								'startHour': startHour,
								'startMinute': startMinute,
								'endHour': endHour,
								'endMinute': endMinute,
								'joinedIndex': joinedIndex
							});
						}
					});
				});
			}
		});

		return joinedIndexesTime;
	}

	/**
	 * @description display errors for recurring overlapping timeintervals
	 * @param {*} container 
	 * @param {*} unique 
	 * @param {*} joinedIndexesTime 
	 */
	var overlappingTimeIntervalErrors = function(container, unique, joinedIndexesTime, errorLabel){
		var isFounded;

		container.find(SEL_DISCOUNT_HOURS_ITEM).each(function(){
			var row = jQuery(this);
			var recurringRow = row.find(SEL_DISCOUNT_RECURRING_SECTION);
			var weekdayArr = recurringRow.find(SEL_WEEKDAY_INPUT).val();

			//check if the weekday index mateches with errorOpeningTimes weekday index
			isFounded = unique.some(function(arr){
				return weekdayArr.includes(arr);
			});

			//getting start and end time values for recurring row
			var startTimeInput = recurringRow.find(SEL_INPUT_START_TIME);
			var endTimeInput = recurringRow.find(SEL_INPUT_END_TIME);
			var startTime = formTimepicker.getValue(startTimeInput);
			var endTime = formTimepicker.getValue(endTimeInput);

			//if the weekday index of recurring row matches with errorOpeningTimes weekday index
			if(isFounded){
				//iterate the joinedIndexesTime array and compare the start and end time
				joinedIndexesTime.forEach(function(item){
					if(item.startHour == startTime.hours && item.startMinute == startTime.mins && item.endHour == endTime.hours && item.endMinute == endTime.mins){
						recurringRow.find(SEL_STARTING_TIME_INPUT_GROUP).addClass(CSS_ERROR);
						recurringRow.find(SEL_ENDING_TIME_INPUT_GROUP).addClass(CSS_ERROR);
						recurringRow.find(SEL_TIME_INTERVALS_HELP_BLOCK).empty().append(errorLabel);
						recurringRow.find(SEL_TIME_INTERVALS_HELP_BLOCK).find('span').addClass(CSS_ERROR);
					}
				});
			}
		});
	}

	/**
	 * @description clickable meridiem during time for overlapping errors for both recurring and oneTime discounts
	 * @param {*} meridiemToggle 
	 */
	var updateMeridiem = function(meridiemToggle){
		var timePicker = meridiemToggle.closest(SEL_TIME_INTERVAL_FORM_GROUP);
		var meridiem = timePicker.data(DATA_ATTRIBUTE_MERIDIEM);
		var toggleMeridiem = meridiem === MERIDIEM_AM ? MERIDIEM_PM : MERIDIEM_AM;
		if (toggleMeridiem) {
			timePicker.data(DATA_ATTRIBUTE_MERIDIEM, toggleMeridiem);
			if (toggleMeridiem === MERIDIEM_AM) {
				meridiemToggle.removeClass(CSS_TOGGLE_ON);
			} else {
				meridiemToggle.addClass(CSS_TOGGLE_ON);
			}
		}
	}

	/**
	 * @description to make meridiem toggle work if any error occurs for both recurring and oneTime discounts
	 * @param {*} row 
	 */
	var meridiemToggleReactivate = function(row){
		row.each(function(){
			var item = jQuery(this);
			var meridiemToggle = item.find('.meridiem-toggle');
			//to make meridiem work after getting error
			meridiemToggle.each(function(){
				var toggle = jQuery(this);
				toggle.on('click', function() {
					//update meridiem value
					updateMeridiem(toggle);
				});
			});
		});
	}

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes  = initNode.find(SEL_MODULE);
		var headlineNode = initNode.find(SEL_HEADLINE_MODULE);
		var mainFormNode = initNode.find(SEL_MAIN_FORM_MODULE);
		var mainWizardFormNode = initNode.find(SEL_WIZARD_MAIN_FORM);
		
		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode = jQuery(this);

			var listRowTemplate = moduleNode.find(SEL_TEMPLATE_LIST_ROW).remove();
			var dataRowTemplate = moduleNode.find(SEL_TEMPLATE_DATA_ROW).remove();
			var oneTimeDataRowTemplate = moduleNode.find(SEL_TEMPLATE_ONETIME_DATA_ROW).remove();

			var formNode = moduleNode.find(SEL_FORM);
			var itemsListNode = moduleNode.find(SEL_LIST);
			var hiddenDataNode = moduleNode.find(SEL_HIDDEN_FORM_DATA);
			var anotherCardNode = moduleNode.find(SEL_ANOTHER_CARD);
			var noItemsCardNode = moduleNode.find(SEL_NO_ITEMS_CARD);
			var addAnotherCardNode = moduleNode.find(SEL_ANOTHER_CARD);
			var initialOffers = moduleNode.find(SEL_INITIAL_OFFERS);
			var submitButtonNode = mainFormNode.find('.submit');
			var discountHoursContainer = mainFormNode.find(SEL_DISCOUNT_HOURS_CONTAINER);
			var discountHoursWizard = mainWizardFormNode.find(SEL_DISCOUNT_HOURS_CONTAINER);
			var wizardButtonsWrap = mainWizardFormNode.find('.wizardButtonsWrap');
			var wizardBtnContinue = wizardButtonsWrap.find('.btn-continue');
			var deleteConfirmModal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM);
	  		var deleteConfirmMessage = moduleNode.data(DATA_ATTR_DELETE_CONFIRM);
			
			var addEditForm = new Form(formNode);
			var itemsList = new ItemsList(itemsListNode, listRowTemplate);
			var hiddenData = new HiddenData(hiddenDataNode, dataRowTemplate, oneTimeDataRowTemplate);

			itemsList.init(hiddenData);
			
			var rows = itemsList.getAllRows();

			//if there are no offers and it is not the wizard
			if(rows.length < 1 && discountHoursWizard.length < 1){
				jQuery(noItemsCardNode).show();
				jQuery(initialOffers).hide();
				jQuery(addAnotherCardNode).hide();
				jQuery(submitButtonNode).hide();
			//if there are no offers and is not the wizard
			}else if(rows.length < 1 && discountHoursWizard.length > 0){
				jQuery(noItemsCardNode).hide();
				jQuery(initialOffers).hide();
				jQuery(discountHoursWizard).show();
				jQuery(addAnotherCardNode).show();
				jQuery(submitButtonNode).show();
			}else if(rows.length >= 1 && discountHoursWizard.length > 0){
			//if there are offers and it is the wizard
				var isWizard = true;
				updateContainerWithExistingData(moduleNode, itemsList, isWizard, hiddenData);
				jQuery(discountHoursWizard).show();
				jQuery(addAnotherCardNode).show();
			}else{
			//if there are offers and it is not the wizard
				jQuery(noItemsCardNode).hide();
				jQuery(initialOffers).show();
				showInitialOffers(moduleNode,itemsList,hiddenData);
			}
			
			
			noItemsCardNode.on('click','.btn-primary',function(){
				createNewCard(moduleNode);
				jQuery(noItemsCardNode).hide();
				jQuery(discountHoursContainer).show();
				jQuery(addAnotherCardNode).show();
				jQuery(submitButtonNode).show();
			});
			
			moduleNode.on('click','.editForm',function(){
				updateContainerWithExistingData(moduleNode, itemsList, false, hiddenData);
				jQuery(initialOffers).hide();
				jQuery(discountHoursContainer).show();
				jQuery(discountHoursWizard).show();
				jQuery(addAnotherCardNode).show();
				jQuery(submitButtonNode).show();
			});
			
			// handle activity selector change
			moduleNode.on('change', SEL_ACTIVITY_SELECTOR_INPUT, function() {
				updateActivitySelection(jQuery(this));
			});

			// Handle datetype change (between fixed date and timeframe)
			moduleNode.on('change', SEL_INPUT_DATE_TYPE, function() {
				updateDataType(jQuery(this));
			});

			mainFormNode.on('click','.submit',function(event){
				//remove recurring (weekday) hidden inputs after click on save button
				hiddenData.removeWeekdayInputs();
				
				//remove oneTime hidden inputs after click on save button
				hiddenData.removeOneTimeInputs();

				submitData(moduleNode,itemsList, hiddenData, event);
				localStorage.setItem('ADVTrack', true);
				
				if(errorFound == true){
					event.preventDefault();
					errorFound = false;
				}else{
					updateDatalayerWithDiscountInfo(formFieldInfo);
				}
			});

			wizardButtonsWrap.on('click',wizardBtnContinue,function(event){
				//remove recurring (weekday) hidden inputs after click on save button
				hiddenData.removeWeekdayInputs();
				
				//remove oneTime hidden inputs after click on save button
				hiddenData.removeOneTimeInputs();
				submitData(moduleNode,itemsList, hiddenData, event);
				if(errorFound == true){
					event.preventDefault();
					errorFound = false;
				}
			});
			
			anotherCardNode.on('click', '.buttonCreate', function() {
				createNewCard(moduleNode);
				jQuery(discountHoursContainer).show();
			});

			moduleNode.on('click', SEL_DELETE_CARD, function() {
				var button = jQuery(this);
				confirmModal.show(deleteConfirmModal, deleteConfirmMessage)
					.done(function() {
						var item = button.parents(SEL_DISCOUNT_HOURS_ITEM);
						removeCard(moduleNode, itemsList, item, hiddenData);
					});
			});

			// initialize the datPicker for oneTime discounts
			initDatepicker(moduleNode);

			//handle all overlapping errors for both recurring and oneTime discounts
            if(window.config.discountHours && window.config.discountHours.isWizard){
                var weekdaySettings = window.config.discountHours.weekdaySettings;

                weekdaySettings.forEach(function(week){
                    (week.timeIntervals || []).map(function(interval, intervalIndex){
						// for recurring rows
                        if(week.startDate == null && week.endDate == null && week.recurringDiscounts){
                            if(interval.inRequest){
                                var weekdays = [];
    
                                // start weekday id from 0 (ex: for Mon: 0, Tue: 1 ...)
                                weekdays.push(parseInt(week.weekday) - 1);
    
                                // create dataobjects on the basis of all values
                                var dataObject = new DataObject(weekdays, interval.discountPercentage, interval.discountType,
                                    interval.startHour, interval.startMinute, interval.endHour, interval.endMinute,
                                    interval.customText);
    
                                // add span hidden inputs with all data object values for each weekday (if dataobject exists for specific weekday)
                                hiddenData.updateWithRowData(dataObject, intervalIndex);
                            }
                        }else{
							// for oneTime rows
                            if(interval.inRequest){
								// create dataobjects on the basis of all values
                                var dataObject = new DataObject(null, interval.discountPercentage, interval.discountType,
                                    interval.startHour, interval.startMinute, interval.endHour, interval.endMinute,
                                    interval.customText, week.startDate, week.endDate, week.rowId);

								// add span hidden inputs with all data object values for oneTime
                                hiddenData.updateWithOneTimeRowData(dataObject, week.id);
                            }
                        }
                    });
                });

                // handle all recurring and onetime errors for wizard flow
                handleTimeIntervalError(mainWizardFormNode, discountHoursWizard);
            }else{
                handleTimeIntervalError(mainFormNode, discountHoursContainer);
            }

			//get the overlapping errors for recurring discounts
			var errorsDiscountTimes = window.config.settingsTimeSettings && window.config.settingsTimeSettings.errorsOpeningTimes;
			//get the overlapping errors for oneTime discounts
			var errorsOneTimes = window.config.settingsTimeSettings && window.config.settingsTimeSettings.errorsOneTimes;

			//for recurring rows if time overlapping error exists
			if(errorsDiscountTimes && errorsDiscountTimes.length > 0){
				var row = discountHoursContainer.find(SEL_DISCOUNT_RECURRING_SECTION);
				meridiemToggleReactivate(row);
			}

			//for oneTime rows if date overlapping error exists
			if(errorsOneTimes && errorsOneTimes.length > 0){
				var row = discountHoursContainer.find(SEL_DISCOUNT_ONE_TIME_SECTION);
				meridiemToggleReactivate(row);
			}
		});
	};
};

// Make class public to outside world
module.exports = DiscountHours;
},{"../form/FormTimepicker":90,"../mediator/mediator":103,"../modals/Confirm":111,"../utils/Tracking":188,"../utils/UserInterfaceUtils":189,"./DataObject":73,"./ExistentForm":75,"./Form":76,"./HiddenData":77,"./ItemsList":78,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],75:[function(require,module,exports){
/**
 * ExistentForm functionality.
*
*/

// External libs
jQuery              = require('jquery/dist/jquery');
var Datepicker      = require('bootstrap.datepicker');
var ArrayUtils      = require('../utils/ArrayUtils');
var StringUtils     = require('../utils/StringUtils');
var FormTimepicker  = require('../form/FormTimepicker');
var FormInputFilter  = require('../form/FormInputFilter');

var DataObject  = require('./DataObject');

// selector constants

var SEL_FORM_WEEKDAY                    = '.weekdays-text';
var SEL_FORM_TIMES                      = '.times-text';
var SEL_FORM_DISCOUNT_TYPE              = '.discount-text';
var SEL_FORM_OFFER_DATE                 = '.offer-date-text';

var PERCENTAGE_SYMBOL                   = '%';

var DATA_ATTR_DISCOUNT_FORMAT           = 'format';

var TIME_GROUP_SPLITTER                 = ' - ';

// Class definition
var ExistentForm = function(formNode, formNumber) {
    
  var localConfig = window.config.discountHours || {};

  this.init = function() {

  };

  this.setValues = function(row, newData, hiddenData, itemsList) {
    if(newData != undefined){
      var dataObject = newData;
    }else{
      var dataObject = itemsList.getDataObjectFromRow(row);
    }

    var weekdayLabels = hiddenData.getWeekdayLabelsForIds(dataObject.weekdays);
    weekdayLabels = ArrayUtils.unique(weekdayLabels);

    //change short day names into long names
    for(var index = 0; index < weekdayLabels.length ; index++){
      switch(weekdayLabels[index]){
        case localConfig.monshort:
          weekdayLabels[index] = localConfig.monlong;
          continue;
        case localConfig.tueshort:
          weekdayLabels[index] = localConfig.tuelong;
          continue;
        case localConfig.wedshort:
          weekdayLabels[index] = localConfig.wedlong;
          continue;
        case localConfig.thushort:
          weekdayLabels[index] = localConfig.thulong;
          continue;
        case localConfig.frishort:
          weekdayLabels[index] = localConfig.frilong;
          continue;
        case localConfig.satshort:
          weekdayLabels[index] = localConfig.satlong;
          continue;
        case localConfig.sunshort:
          weekdayLabels[index] = localConfig.sunlong;
          continue;
      }
    };

    var weekdaysFormatted = weekdayLabels.join(', ');
    formNode.find(SEL_FORM_WEEKDAY).text(weekdaysFormatted);

    //check if weekdays length is 0 or not - if it is 0 its onetime otherwise its recurring
    if(dataObject.weekdays.length == 0){
      //if start and endDate are equal, will display only startDate otherwise will display both dates separated with -
      var dateFormatted = (dataObject.startDate === dataObject.endDate) ? dataObject.startDate : (dataObject.startDate + ' - ' + dataObject.endDate);
      formNode.find(SEL_FORM_OFFER_DATE).text(dateFormatted);
    }

    var timesElement = formNode.find(SEL_FORM_TIMES);
    var timesFormatted = [];
    var timeGroupFormatted = itemsList._formatTime(dataObject.startHour, dataObject.startMin);
    if (timeGroupFormatted !== '') {
      timesFormatted.push(timeGroupFormatted);
    }
    timeGroupFormatted = itemsList._formatTime(dataObject.endHour, dataObject.endMin);
    if (timeGroupFormatted !== '') {
      timesFormatted.push(timeGroupFormatted);
    }
    timesFormatted = timesFormatted.join(TIME_GROUP_SPLITTER);

    var discountElement = formNode.find(SEL_FORM_DISCOUNT_TYPE);
    var discountFormat = discountElement.data(DATA_ATTR_DISCOUNT_FORMAT);
    var discountFormatted = StringUtils.findAndReplaceAll(discountFormat, {
      '%%DISCOUNT%%': dataObject.discount + PERCENTAGE_SYMBOL,
      '%%DISCOUNT_TYPE%%': itemsList._getDiscountTypeName(dataObject.discountType)
    });
    if (itemsList._isCustomType(dataObject.discountType)) {
      discountFormatted = dataObject.customText || '';
    } else if (itemsList._isHappyHour(dataObject.discountType)) {
      discountFormatted = itemsList._getHappyHourText();
    }

    //time should display only for recurring and onetime 'from' option (not for 'on' option)
    if((dataObject.startDate === dataObject.endDate) && (dataObject.startDate != null && dataObject.endDate != null)){
      if(!(dataObject.startHour == '0' && dataObject.startMin == '0' && dataObject.endHour == '0' && dataObject.endMin == '0')){
        timesElement.text(timesFormatted);
        //display discount with '-' for 'from' selection in onetime and recurring option
        discountElement.text(' - ' + discountFormatted);
      }else{
        //display discount without '-' for 'on' selection in onetime option
        discountElement.text(discountFormatted);  
      }
    }else{
      timesElement.text(timesFormatted);
      discountElement.text(' - ' + discountFormatted);
    }
  };
};

// Make class public to outside world
module.exports = ExistentForm;
},{"../form/FormInputFilter":86,"../form/FormTimepicker":90,"../utils/ArrayUtils":183,"../utils/StringUtils":187,"./DataObject":73,"bootstrap.datepicker":26,"jquery/dist/jquery":14}],76:[function(require,module,exports){
/**
 * Form functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var Datepicker      = require('bootstrap.datepicker');
var FormTimepicker  = require('../form/FormTimepicker');
var FormInputFilter = require('../form/FormInputFilter');
var moment          = require('moment/min/moment-with-locales');

var DataObject  = require('./DataObject');

// selector constants

var SEL_FORM_SELECT                     = 'select';
var SEL_FORM_GROUP                      = '.form-group';
var SEL_FORM_CONTROL                    = '.form-control';
var SEL_FORM_INPUT_DAYS                 = '.form-group-field-days select';
var SEL_FORM_INPUT_TIMES_GROUP          = '.form-group-field-times';
var SEL_FORM_INPUT_TIMES_WRAPPER        = '.timeIntervals';
var SEL_FORM_INPUT_TIMES_START_GROUP    = '.startingTime';
var SEL_FORM_INPUT_TIMES_END_GROUP      = '.endingTime';
var SEL_FORM_INPUT_DISCOUNT             = '.form-group-field-discount input[type="text"]';
var SEL_FORM_INPUT_DISCOUNT_TYPE        = '.form-group-field-discountType select';
var SEL_FORM_INPUT_CUSTOM_TEXT          = '#input-discountHours-CustomText';
var SEL_FORM_RADIO_BASIC                = '.form-group-discount-type-radio #input-discountHours-Basic';
var SEL_FORM_RADIO_HAPPY_HOUR           = '.form-group-discount-type-radio #input-discountHours-HappyHour';
var SEL_FORM_RADIO_CUSTOM               = '.form-group-discount-type-radio #input-discountHours-Custom';

var SEL_FORM_RADIO_ONETIME_BASIC        = '.form-group-discount-type-radio #input-discountHours-oneTime-Basic';
var SEL_FORM_RADIO_ONETIME_HAPPY_HOUR   = '.form-group-discount-type-radio #input-discountHours-oneTime-HappyHour';
var SEL_FORM_RADIO_ONETIME_CUSTOM       = '.form-group-discount-type-radio #input-discountHours-oneTime-Custom';
var SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME = '.form-group-field-discountType-oneTime select';
var SEL_FORM_INPUT_DISCOUNT_ONETIME     = '.form-group-field-discount-oneTime input[type="text"]';
var SEL_FORM_INPUT_START_MINUTE					= ".startingTime .timepicker-inner input[type=text]:last-child";
var SEL_FORM_INPUT_END_MINUTE					  = ".endingTime .timepicker-inner input[type=text]:last-child";
var SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME  = '#input-discountHours-CustomText-oneTime';
var SEL_ACTIVITY_SELECTOR_WRAPPER       = '.activitySelector';
var SEL_ACTIVITY_SELECTOR_INPUT         = ".activitySelector :input";
var SEL_ACTIVE_INPUT_LABEL              = 'label.active :input';
var SEL_NON_ACTIVE_INPUT_INPUT          = 'label :input';
var SEL_FORM_RECURRING_WRAPPER          = '.discountHours-recurringOption';
var SEL_FORM_ONETIME_WRAPPER            = '.discountHours-oneTimeSection';
var SEL_TIME_ERROR_DIV                  = 'p.has-error';
var SEL_FORM_ONETIME_ID_INPUT           = '.hidden-oneTime-id';

var SEL_FORM_HIDDEN_ROW_ID_INPUT        = '.hidden-input-rowId';
var SEL_FORM_HIDDEN_INPUTS_WRAPPER      = '.discountHours-hiddenFormData';
var SEL_FORM_HIDDEN_ONETIME_ROWS        = '.discountHours-hiddenFormData-oneTime span.discountHours-rowData';

var SEL_FORM_DATE_GROUP                 = '.section-time-range';
//var SEL_FORM_START_DATE_INPUT           = '.startDateInternal';
//var SEL_FORM_END_DATE_INPUT             = '.endDateInternal';
var SEL_FROM_DROPDOWN_WRAPPER           = '.dropdown.bootstrap-select.dateType';
var SEL_FROM_SELECT_DROPDOWN            = 'select.dateType';
var SEL_FORM_START_DATE_WRAPPER         = '.date-group.date-group-startDate';
var SEL_FORM_END_DATE_WRAPPER           = '.date-group.date-group-endDate';
var SEL_FORM_START_DATE_INPUT           = 'input.startDate';
var SEL_FORM_END_DATE_INPUT             = 'input.endDate';
var SEL_FORM_HELP_BLOCK                 = '.help-block';

var SEL_FORM_BTN_CANCEL                 = '.buttonCancel';
var SEL_FORM_BTN_SAVE                   = '.buttonSave';
var SEL_FORM_BTN_CREATE                 = '.buttonCreate';
var SEL_LABEL                           = 'label';

var DATA_ATTR_CURRENT_ROW               = 'currentRow';
var DATA_ATTR_CURRENT_DATA              = 'currentData';
var DATA_ATTR_FORM_VALIDATION_ERROR     = 'errorMessageValidation';
var DATA_ATTR_FORM_TIME_VALIDATION_ERROR = 'errorMessageTimeValidation';
var DATA_ATTR_HAPPY_HOUR_TYPE           = 'happyHourType';
var DATA_ATTR_CUSTOM_TYPE               = 'customType';

var CSS_IS_EDITING                      = 'is-editing';
var CSS_HAS_ERROR                       = 'has-error';
var CSS_ACTIVE_CLASS                    = 'active';
var CSS_HIDDEN                          = 'hidden';

var FILTER_FOUR_CHARACTERS  = function(value) {
  return value === '' || /^[0-9]{1,2}$/.test(value);
};

// Class definition
var Form = function(formNode, formNumber, activeOption) {

  var self = this;

  var inputFilter = new FormInputFilter();
  var formTimepicker = new FormTimepicker();

  var commonSelectedVal;
  var selectedRecurringValue;
  var selectedOneTimeValue;
  var hasRecurrringPrevVal = '';
  var hasOneTimePrevVal = '';

  // private methods

  this._rememberCurrentRowAndData = function(row, data) {
    formNode.data(DATA_ATTR_CURRENT_ROW, row);
    formNode.data(DATA_ATTR_CURRENT_DATA, data);
  };

  this._forgetCurrentRow = function() {
    formNode.data(DATA_ATTR_CURRENT_ROW, null);
    formNode.data(DATA_ATTR_CURRENT_DATA, null);
  };

  this._getCurrentData = function() {
    return formNode.data(DATA_ATTR_CURRENT_DATA);
  };

  this._getValidationErrorMessage = function() {
    return formNode.data(DATA_ATTR_FORM_VALIDATION_ERROR);
  };

  this._getCustomType = function() {
    return formNode.data(DATA_ATTR_CUSTOM_TYPE);
  };

  this._isCustomType = function(type) {
    return type === self._getCustomType();
  };

  this._getHappyHourType = function() {
    return formNode.data(DATA_ATTR_HAPPY_HOUR_TYPE);
  };

  this._isHappyHour = function(type) {
    return type === self._getHappyHourType();
  };

  // if oneTime option selected, below function will call
  this._selectHappyHourForOneTime = function() {
    var discountInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
    var discountTypeInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME);
    var customTextInputOneTime = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME);
    var oneTimeRadioBasic = formNode.find(SEL_FORM_RADIO_ONETIME_BASIC);
    var oneTimeRadioHappyHour = formNode.find(SEL_FORM_RADIO_ONETIME_HAPPY_HOUR);
    var oneTimeRadioCustom = formNode.find(SEL_FORM_RADIO_ONETIME_CUSTOM);

    oneTimeRadioBasic.prop('checked', false);
    oneTimeRadioHappyHour.prop('checked', true);
    oneTimeRadioCustom.prop('checked', false);

    discountTypeInputOneTime.selectpicker('val', '');
    discountTypeInputOneTime.prop('disabled', true).selectpicker('refresh');
    discountInputOneTime.val('').prop('disabled', true);
    customTextInputOneTime.val('').prop('disabled', true);
  };

  // if recurring option selected, below function will call
  this._selectHappyHour = function() {
    var discountInput = formNode.find(SEL_FORM_INPUT_DISCOUNT);
    var discountTypeInput = formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE);
    var customTextInput = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT);
    var radioBasic = formNode.find(SEL_FORM_RADIO_BASIC);
    var radioHappyHour = formNode.find(SEL_FORM_RADIO_HAPPY_HOUR);
    var radioCustom = formNode.find(SEL_FORM_RADIO_CUSTOM);

    radioBasic.prop('checked', false);
    radioHappyHour.prop('checked', true);
    radioCustom.prop('checked', false);

    discountTypeInput.selectpicker('val', '');
    discountTypeInput.prop('disabled', true).selectpicker('refresh');
    discountInput.val('').prop('disabled', true);
    customTextInput.val('').prop('disabled', true);
  };

  // if oneTime option selected, below function will call
  this._selectCustomForOneTime = function(customText) {
    var discountInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
    var discountTypeInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME);
    var customTextInputOneTime = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME);
    var oneTimeRadioBasic = formNode.find(SEL_FORM_RADIO_ONETIME_BASIC);
    var oneTimeRadioHappyHour = formNode.find(SEL_FORM_RADIO_ONETIME_HAPPY_HOUR);
    var oneTimeRadioCustom = formNode.find(SEL_FORM_RADIO_ONETIME_CUSTOM);

    oneTimeRadioBasic.prop('checked', false);
    oneTimeRadioHappyHour.prop('checked', false);
    oneTimeRadioCustom.prop('checked', true);

    discountTypeInputOneTime.selectpicker('val', '');
    discountTypeInputOneTime.prop('disabled', true).selectpicker('refresh');
    discountInputOneTime.val('').prop('disabled', true);
    customTextInputOneTime.val(customText || '').prop('disabled', false);
  };

  // if recurring option selected, below function will call
  this._selectCustom = function(customText) {
    var discountInput = formNode.find(SEL_FORM_INPUT_DISCOUNT);
    var discountTypeInput = formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE);
    var customTextInput = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT);
    var radioBasic = formNode.find(SEL_FORM_RADIO_BASIC);
    var radioHappyHour = formNode.find(SEL_FORM_RADIO_HAPPY_HOUR);
    var radioCustom = formNode.find(SEL_FORM_RADIO_CUSTOM);

    radioBasic.prop('checked', false);
    radioHappyHour.prop('checked', false);
    radioCustom.prop('checked', true);

    discountTypeInput.selectpicker('val', '');
    discountTypeInput.prop('disabled', true).selectpicker('refresh');
    discountInput.val('').prop('disabled', true);
    customTextInput.val(customText || '').prop('disabled', false);
  };

  // if oneTime option selected, below function will call
  this._selectBasicForOneTime = function(discount, discountType) {
    var discountInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
    var discountTypeInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME);
    var customTextInputOneTime = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME);
    var oneTimeRadioBasic = formNode.find(SEL_FORM_RADIO_ONETIME_BASIC);
    var oneTimeRadioHappyHour = formNode.find(SEL_FORM_RADIO_ONETIME_HAPPY_HOUR);
    var oneTimeRadioCustom = formNode.find(SEL_FORM_RADIO_ONETIME_CUSTOM);
    
    oneTimeRadioBasic.prop('checked', true);
    oneTimeRadioHappyHour.prop('checked', false);
    oneTimeRadioCustom.prop('checked', false);

    discountTypeInputOneTime.prop('disabled', false).selectpicker('refresh');
    discountTypeInputOneTime.selectpicker('val', discountType || '');
    discountInputOneTime.val(discount || 0).prop('disabled', false);
    customTextInputOneTime.val('').prop('disabled', true);
  };

  // if recurring option selected, below function will call
  this._selectBasic = function(discount, discountType) {
    var discountInput = formNode.find(SEL_FORM_INPUT_DISCOUNT);
    var discountTypeInput = formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE);
    var customTextInput = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT);
    var radioBasic = formNode.find(SEL_FORM_RADIO_BASIC);
    var radioHappyHour = formNode.find(SEL_FORM_RADIO_HAPPY_HOUR);
    var radioCustom = formNode.find(SEL_FORM_RADIO_CUSTOM);

    radioBasic.prop('checked', true);
    radioHappyHour.prop('checked', false);
    radioCustom.prop('checked', false);

    discountTypeInput.prop('disabled', false).selectpicker('refresh');
    discountTypeInput.selectpicker('val', discountType || '');
    discountInput.val(discount || 0).prop('disabled', false);
    customTextInput.val('').prop('disabled', true);
  };

  this.fillRecurringRadioButtonValues = function(selectedValue){
    var radioBasic = formNode.find(SEL_FORM_RADIO_BASIC);
    var radioHappyHour = formNode.find(SEL_FORM_RADIO_HAPPY_HOUR);
    var radioCustom = formNode.find(SEL_FORM_RADIO_CUSTOM);

    var discountInput = formNode.find(SEL_FORM_INPUT_DISCOUNT);
    var discountTypeInput = formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE);
    var customTextInput = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT);

    radioBasic.prop('checked', selectedValue.basic);
    radioHappyHour.prop('checked', selectedValue.happyHour);
    radioCustom.prop('checked', selectedValue.custom);

    return { 
      'discountInput': discountInput, 
      'discountTypeInput': discountTypeInput, 
      'customTextInput': customTextInput 
    };
  }
  
  // if recurring option selected, below function will call
  this._preSelectedBasic = function(selectedValue) {
    var getRadioInputNodes = this.fillRecurringRadioButtonValues(selectedValue);
    
    getRadioInputNodes.discountTypeInput.prop('disabled', !selectedValue.basic).selectpicker('refresh');
    getRadioInputNodes.discountTypeInput.selectpicker('val', selectedValue.discountType || '');
    getRadioInputNodes.discountInput.val(selectedValue.discount || 0).prop('disabled', !selectedValue.basic);
    getRadioInputNodes.customTextInput.val('').prop('disabled', !selectedValue.custom);
  };

  // if recurring option selected, below function will call
  this._preSelectedHappyHour = function(selectedValue) {
    var getRadioInputNodes = this.fillRecurringRadioButtonValues(selectedValue);

    getRadioInputNodes.discountTypeInput.selectpicker('val', '');
    getRadioInputNodes.discountTypeInput.prop('disabled', !selectedValue.basic).selectpicker('refresh');
    getRadioInputNodes.discountInput.val('').prop('disabled', !selectedValue.basic);
    getRadioInputNodes.customTextInput.val('').prop('disabled', !selectedValue.custom);
  };

  // if recurring option selected, below function will call
  this._preSelectedCustom = function(selectedValue) {
    var getRadioInputNodes = this.fillRecurringRadioButtonValues(selectedValue);

    getRadioInputNodes.discountTypeInput.selectpicker('val', '');
    getRadioInputNodes.discountTypeInput.prop('disabled', !selectedValue.basic).selectpicker('refresh');
    getRadioInputNodes.discountInput.val('').prop('disabled', !selectedValue.basic);
    getRadioInputNodes.customTextInput.val(selectedValue.customText || '').prop('disabled', !selectedValue.custom);
  };



  this.fillOneTimeRadioButtonValues = function(selectedValue){
    var discountInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
    var discountTypeInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME);
    var customTextInputOneTime = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME);
    var oneTimeRadioBasic = formNode.find(SEL_FORM_RADIO_ONETIME_BASIC);
    var oneTimeRadioHappyHour = formNode.find(SEL_FORM_RADIO_ONETIME_HAPPY_HOUR);
    var oneTimeRadioCustom = formNode.find(SEL_FORM_RADIO_ONETIME_CUSTOM);

    oneTimeRadioBasic.prop('checked', selectedValue.basic);
    oneTimeRadioHappyHour.prop('checked', selectedValue.happyHour);
    oneTimeRadioCustom.prop('checked', selectedValue.custom);

    return { 
      'discountInput': discountInputOneTime, 
      'discountTypeInput': discountTypeInputOneTime, 
      'customTextInput': customTextInputOneTime 
    };
  }

  // if oneTime option selected, below function will call
  this._preSelectedBasicOneTime = function(selectedValue) {
    var getRadioInputNodes = this.fillOneTimeRadioButtonValues(selectedValue);

    getRadioInputNodes.discountTypeInput.prop('disabled', !selectedValue.basic).selectpicker('refresh');
    getRadioInputNodes.discountTypeInput.selectpicker('val', selectedValue.discountType || '');
    getRadioInputNodes.discountInput.val(selectedValue.discount || 0).prop('disabled', !selectedValue.basic);
    getRadioInputNodes.customTextInput.val('').prop('disabled', !selectedValue.custom);
  };

  // if oneTime option selected, below function will call
  this._preSelectedHappyHourOneTime = function(selectedValue) {
    var getRadioInputNodes = this.fillOneTimeRadioButtonValues(selectedValue);

    getRadioInputNodes.discountTypeInput.selectpicker('val', '');
    getRadioInputNodes.discountTypeInput.prop('disabled', !selectedValue.basic).selectpicker('refresh');
    getRadioInputNodes.discountInput.val('').prop('disabled', !selectedValue.basic);
    getRadioInputNodes.customTextInput.val('').prop('disabled', !selectedValue.custom);
  };

  // if oneTime option selected, below function will call
  this._preSelectedCustomOneTime = function(selectedValue) {
    var getRadioInputNodes = this.fillOneTimeRadioButtonValues(selectedValue);

    getRadioInputNodes.discountTypeInput.selectpicker('val', '');
    getRadioInputNodes.discountTypeInput.prop('disabled', !selectedValue.basic).selectpicker('refresh');
    getRadioInputNodes.discountInput.val('').prop('disabled', !selectedValue.basic);
    getRadioInputNodes.customTextInput.val(selectedValue.customText || '').prop('disabled', !selectedValue.custom);
  };

  this._createPreSelectedDataObject = function(happyHour, custom, optionType){

    commonSelectedVal = {
      'basic': (happyHour || custom) ? false : true,
      'happyHour': happyHour,
      'custom': custom,
      'optionType': optionType,
    }

    optionType === 'recurring' ? selectedRecurringValue = JSON.parse(JSON.stringify(commonSelectedVal)) :  selectedOneTimeValue = JSON.parse(JSON.stringify(commonSelectedVal));
  }

  this._prePopulateRadioSelections = function(selectedRecurringValue, selectedOneTimeValue, data){

    var activitySelectorVal = this.getActivitySelection();

    if(activitySelectorVal === (selectedRecurringValue && selectedRecurringValue.optionType)){
      if(selectedRecurringValue.happyHour){
        self._preSelectedHappyHour(selectedRecurringValue);
      }else if(selectedRecurringValue.custom){
        self._preSelectedCustom(selectedRecurringValue);
      }else{
        self._preSelectedBasic(selectedRecurringValue);
      }
    } else{
      if(selectedOneTimeValue.happyHour){
        self._preSelectedHappyHourOneTime(selectedOneTimeValue);
      }else if(selectedOneTimeValue.custom){
        self._preSelectedCustomOneTime(selectedOneTimeValue);
      }else{
        self._preSelectedBasicOneTime(selectedOneTimeValue);
      }
    }
  }

  this._radioSelectionChange = function(happyHour, custom, data, optionType) {
    if (!data) {
      data = {};
    }

    var checkRecurringCondition = selectedRecurringValue && selectedRecurringValue.happyHour == happyHour && selectedRecurringValue.custom == custom;
    var checkOnetimeCondition =selectedOneTimeValue && selectedOneTimeValue.happyHour == happyHour && selectedOneTimeValue.custom == custom;
    
    if(optionType === 'recurring'){
      if(!checkRecurringCondition){
        self._createPreSelectedDataObject(happyHour, custom, optionType);
      }
    }else{
      if(!checkOnetimeCondition){
        self._createPreSelectedDataObject(happyHour, custom, optionType);
      }
    }

    if(selectedRecurringValue !== undefined || selectedOneTimeValue !== undefined){
      self._prePopulateRadioSelections(selectedRecurringValue, selectedOneTimeValue, data);
    }else{
      if (happyHour) {
        optionType === 'recurring' ? this._selectHappyHour() : this._selectHappyHourForOneTime();
      } else if (custom) {
        optionType === 'recurring' ? this._selectCustom(data.customText) : this._selectCustomForOneTime(data.customText);
      } else {
        var discountType = data.discountType;
        // ignore HAPPY_HOUR and CUSTOM
        if (self._isCustomType(discountType) || self._isHappyHour(discountType)) {
          discountType = '';
        }
        optionType === 'recurring' ? this._selectBasic(data.discount, discountType) : this._selectBasicForOneTime(data.discount, discountType);
      }
    }
  };


  this.setRadioButtonSelection = function(basicRadio, happyHourRadio, customRadio, optionType){
    [basicRadio, happyHourRadio, customRadio].forEach(function(radio) {
      jQuery(radio).on('change', function() {
        var happyHour = happyHourRadio.is(':checked');
        var custom = customRadio.is(':checked');
        var data = self._getCurrentData();
        if(hasRecurrringPrevVal != '' || hasOneTimePrevVal != ''){
          optionType === 'recurring' ? self._radioSelectionChange(selectedRecurringValue.happyHour, selectedRecurringValue.custom, data, optionType) : self._radioSelectionChange(selectedOneTimeValue.happyHour, selectedOneTimeValue.custom, data, optionType);
          hasRecurrringPrevVal = '';
          hasOneTimePrevVal = '';
        }else{
          self._radioSelectionChange(happyHour, custom, data, optionType);
        }
      });
      jQuery(radio).attr('name', '_ignoreThisField' + formNumber);
    });
    // default to basic
    basicRadio.prop('checked', true).change();
  }

  // exposed methods

  this.init = function() {

    // initialize selectpicker
    formNode.find(SEL_FORM_SELECT).selectpicker();

    // initialize input filters
    var discountInput = formNode.find(SEL_FORM_INPUT_DISCOUNT);
    var discountInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
    
    inputFilter.init(discountInput, FILTER_FOUR_CHARACTERS);
    inputFilter.init(discountInputOneTime, FILTER_FOUR_CHARACTERS);

    var basicRadio = formNode.find(SEL_FORM_RADIO_BASIC);
    var happyHourRadio = formNode.find(SEL_FORM_RADIO_HAPPY_HOUR);
    var customRadio = formNode.find(SEL_FORM_RADIO_CUSTOM);

    // radio button nodes for onetime option
    var oneTimeBasicRadio = formNode.find(SEL_FORM_RADIO_ONETIME_BASIC);
    var oneTimeHappyHourRadio = formNode.find(SEL_FORM_RADIO_ONETIME_HAPPY_HOUR);
    var oneTimeCustomRadio = formNode.find(SEL_FORM_RADIO_ONETIME_CUSTOM);

    activeOption === 'recurring' ? self.setRadioButtonSelection(basicRadio, happyHourRadio, customRadio, "recurring") : self.setRadioButtonSelection(oneTimeBasicRadio, oneTimeHappyHourRadio, oneTimeCustomRadio, "oneTime");

    // Activity Selector inputs nodes
    var activitySelectorInputs = formNode.find(SEL_ACTIVITY_SELECTOR_INPUT);
    
    // loop will call for all activity selector inout
    activitySelectorInputs.each(function() {
      var activity = jQuery(this);
      // after switching between both tabs, change event will call
      jQuery(activity).on("change", function() {
        var isLabelActive = jQuery(this).parents('label').hasClass(CSS_ACTIVE_CLASS);
        var selectedOption;
    
        if(isLabelActive){
          selectedOption = jQuery(this).val();
        }

        self._updateRadioButtonValues();

        if(selectedOption === 'recurring'){
          hasRecurrringPrevVal = (selectedRecurringValue && selectedRecurringValue.optionType != '') ? 'exist' : '';
        }else{
          hasOneTimePrevVal = (selectedOneTimeValue && selectedOneTimeValue.optionType != '') ? 'exist' : '';
        }

        selectedOption === 'recurring' ? self.setRadioButtonSelection(basicRadio, happyHourRadio, customRadio, selectedOption) : self.setRadioButtonSelection(oneTimeBasicRadio, oneTimeHappyHourRadio, oneTimeCustomRadio, selectedOption);
      });
    });
  };

  this._updateRadioButtonValues = function(){

    var discountNode = formNode.find(SEL_FORM_RECURRING_WRAPPER);
    var discountInput = discountNode.find(SEL_FORM_INPUT_DISCOUNT);
    var discountType = discountNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE);
    var customTextInput = discountNode.find(SEL_FORM_INPUT_CUSTOM_TEXT);
    
    var discountNodeOneTime = formNode.find(SEL_FORM_ONETIME_WRAPPER);
    var discountInputOneTime = discountNodeOneTime.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
    var discountTypeOneTime = discountNodeOneTime.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME);
    var customTextInputOneTime = discountNodeOneTime.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME);
    
    if(selectedRecurringValue && selectedRecurringValue.optionType === 'recurring'){
      selectedRecurringValue.discount = selectedRecurringValue.basic ? discountInput.val() : '';
      selectedRecurringValue.discountType = selectedRecurringValue.basic ? discountType.val() : '';
      selectedRecurringValue.customText = selectedRecurringValue.custom ? customTextInput.val() : '';
    }
    
    if(selectedOneTimeValue && selectedOneTimeValue.optionType === 'oneTime'){
      selectedOneTimeValue.discount = selectedOneTimeValue.basic ? discountInputOneTime.val() : '';
      selectedOneTimeValue.discountType = selectedOneTimeValue.basic ? discountTypeOneTime.val() : '';
      selectedOneTimeValue.customText = selectedOneTimeValue.custom ? customTextInputOneTime.val() : '';
    }
  }

  this.getNode = function() {
    return formNode;
  };

  this.markAsEditing = function() {
    formNode.addClass(CSS_IS_EDITING);
  };

  this.markAsNotEditing = function() {
    formNode.removeClass(CSS_IS_EDITING);
  };

  this.getCurrentEditingRow = function() {
    return formNode.data(DATA_ATTR_CURRENT_ROW) || null;
  };

  //fill the data for recurring and oneTime option (on basis of selected tab option)
  this.setValues = function(newData, container, optionType, hiddenObjId, hiddenData, row, itemsList) {
    if(newData != undefined){
      var data = newData;
    }else{
      var data = itemsList.getDataObjectFromRow(row);
    }
    
    var isHappyHour = self._isHappyHour(data.discountType);
    var isCustom = self._isCustomType(data.discountType);
    self._radioSelectionChange(isHappyHour, isCustom, data, optionType);

    // clear previous values
    inputFilter.clearPreviousValues(formNode.find(SEL_FORM_INPUT_DISCOUNT));

    //check which option is selectable
    var activityWrapper = formNode.find(SEL_ACTIVITY_SELECTOR_WRAPPER);
    var activeInput = activityWrapper.find(SEL_ACTIVE_INPUT_LABEL);
    var notActiveInput = activityWrapper.find(SEL_NON_ACTIVE_INPUT_INPUT);
    var recurringWrapper = formNode.find(SEL_FORM_RECURRING_WRAPPER);
    var oneTimeWrapper = formNode.find(SEL_FORM_ONETIME_WRAPPER);
    var oneTimeInterval = oneTimeWrapper.find(SEL_FORM_INPUT_TIMES_WRAPPER);
    var dateTimeSelectOption = oneTimeWrapper.find(SEL_FORM_DATE_GROUP).find(SEL_FROM_SELECT_DROPDOWN);

    var recurringTimesGroup = formNode.find(SEL_FORM_RECURRING_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);
    var oneTimesGroup = formNode.find(SEL_FORM_ONETIME_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);

    //check if optionType is equal to active activitySelector byDefault
    if(activeInput.val() !== optionType){
      //if not -> remove class from recurring
      recurringWrapper.addClass(CSS_HIDDEN);

      // initialize minutes with 00 --> FOR RECURRING OPTION
      recurringTimesGroup.find(SEL_FORM_INPUT_START_MINUTE).val('00');
      recurringTimesGroup.find(SEL_FORM_INPUT_END_MINUTE).val('00');

      //add class in oneTime wrapper
      oneTimeWrapper.removeClass(CSS_HIDDEN);

      var startNode = oneTimeWrapper.find(SEL_FORM_START_DATE_WRAPPER).find(SEL_FORM_START_DATE_INPUT);
      var endNode = oneTimeWrapper.find(SEL_FORM_END_DATE_WRAPPER).find(SEL_FORM_END_DATE_INPUT);

      //if start and end time is 0 -> hide the timeinterval section
      if(data.startHour == '0' && data.startMin == "0" && data.endHour == '0' && data.endMin == "0" && (data.endDate == '' || data.startDate == data.endDate)){
        oneTimeInterval.addClass(CSS_HIDDEN);
      }else{
        //if start and end time not 0 -> change the select value from "date" to "timeframe"
        dateTimeSelectOption.val('timeframe').trigger('change');
        oneTimeWrapper.find(SEL_FORM_END_DATE_WRAPPER).removeClass(CSS_HIDDEN);
      }

      //get datefields which contains both start and end date
      var dateFields = oneTimeWrapper.find(SEL_FORM_START_DATE_INPUT + ',' + SEL_FORM_END_DATE_INPUT);

      // Initialize datepicker to adapt the language and date format to change calendar for specific language
      dateFields.datepicker({
        format: (window.config.discountHours && window.config.discountHours.dateFormat),
        language: (window.config.discountHours && window.config.discountHours.calendarLanguageCode),
        weekStart: 1,
        autoclose: true,
        todayHighlight: false
      });

      //add rowId inside data object to make it unique (if we have multiple entries with '0' id)
      container.siblings(SEL_FORM_HIDDEN_INPUTS_WRAPPER).find(SEL_FORM_HIDDEN_ONETIME_ROWS).each(function(){
        var row = jQuery(this);
        var dataObject = hiddenData.getDataObjectFromRow(row);

        //compare both dateobject and data values and if matches, insert the rowId inside data
        if(dataObject.id == data.id && dataObject.startHour == data.startHour && dataObject.startMin == data.startMin && dataObject.endHour == data.endHour && dataObject.endMin == data.endMin && dataObject.startDate == data.startDate && dataObject.endDate == data.endDate){
          data.rowId = row.find(SEL_FORM_HIDDEN_ROW_ID_INPUT).val();
        }
      });

      //get the array of start and enddate and storing in a single variable
      var discountHoursDateObject = window.config.settingsTimeSettings && window.config.settingsTimeSettings.discountHoursTimeSettings;
      
      //iterate dateArray and compare if hiddenId == datArray id
      (discountHoursDateObject || []).forEach(function(dateObj){
        //first check both dateObj and data have same values or not
        if(dateObj.id == hiddenObjId && dateObj.rowId == data.rowId && dateObj.startHour == data.startHour && dateObj.startMinute == data.startMin && dateObj.endHour == data.endHour && dateObj.endMinute == data.endMin){
          //if start and end time is 0, set date only for start date input
          if(dateObj.startHour == 0 && dateObj.startMinute == 0 && dateObj.endHour == 0 && dateObj.endMinute == 0 && (data.endDate == '' || data.startDate == data.endDate)){
            startNode.datepicker('setDate', dateObj.startDate);
          }else{
            //if start and end time is not 0, set date for both start and end date input
            startNode.datepicker('setDate', dateObj.startDate);
            endNode.datepicker('setDate', dateObj.endDate);
          }
        }
      });

      //get both inputs of activity selector
      notActiveInput.parents(SEL_LABEL).each(function(){
        var input = jQuery(this);
        //if input has active class then remove
        if(input.hasClass(CSS_ACTIVE_CLASS)){
          input.removeClass(CSS_ACTIVE_CLASS);
        }else{
          //if input doesn't have active class then add
          input.addClass(CSS_ACTIVE_CLASS);
        }
      });
    }else{
      // initialize minutes with 00 --> FOR ONETIME OPTION
      oneTimesGroup.find(SEL_FORM_INPUT_START_MINUTE).val('00');
      oneTimesGroup.find(SEL_FORM_INPUT_END_MINUTE).val('00');
    }
    
    if(optionType === 'recurring'){
      // weekdays
      formNode.find(SEL_FORM_INPUT_DAYS).selectpicker('val', data.weekdays || []);

      //add discount percentage and discount type in respective inputs
      var discountInput = formNode.find(SEL_FORM_INPUT_DISCOUNT);
      var discountTypeInput = formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE);
      var customTextInput = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT);

      discountTypeInput.selectpicker('val', data.discountType || '');
      discountInput.val(data.discount || 0);
      customTextInput.val(data.customText || '');

      // update start and end time
      var startingTime = recurringTimesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
      var endingTime = recurringTimesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);
      formTimepicker.setValue(startingTime, data.startHour, data.startMin);
      formTimepicker.setValue(endingTime, data.endHour, data.endMin);
    }else{
      //add discount percentage and discount type in respective inputs
      var discountInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
      var discountTypeInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME);
      var customTextInputOneTime = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME);

      //add id value inside input hidden field if it is an existing row
      oneTimeWrapper.find(SEL_FORM_ONETIME_ID_INPUT).val(hiddenObjId);

      discountTypeInputOneTime.selectpicker('val', data.discountType || '');
      discountInputOneTime.val(data.discount || 0);
      customTextInputOneTime.val(data.customText || '');

      // update start and end time
      var oneTimeStartingTime = oneTimesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
      var oneTimeEndingTime = oneTimesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);

      if((data.startDate === data.endDate) && (data.startHour == '0' && data.startMin == "0" && data.endHour == '0' && data.endMin == "0")){
        //if start and endDate are equal, prefill minutes of 'from' time with 00 
        oneTimesGroup.find(SEL_FORM_INPUT_START_MINUTE).val('00');
        oneTimesGroup.find(SEL_FORM_INPUT_END_MINUTE).val('00');
      }else{
        //if start and endDate are not equal, fill start and end time with the existing value
        formTimepicker.setValue(oneTimeStartingTime, data.startHour, data.startMin);
        formTimepicker.setValue(oneTimeEndingTime, data.endHour, data.endMin);
      }
    }

    self.clearValidationErrors(formNode);
    self._rememberCurrentRowAndData(row, data);
  };

  //needs to update later for oneTime option (on basis of selected tab option)
  this.getDataObjectFromValues = function(activitySelection) {

    if(activitySelection == 'recurring'){

      var selectedWeekdays = formNode.find(SEL_FORM_INPUT_DAYS).selectpicker('val');

      var discount    =  formNode.find(SEL_FORM_INPUT_DISCOUNT).val();
      var discountType  =  formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE).selectpicker('val');
      var isHappyHour = formNode.find(SEL_FORM_RADIO_HAPPY_HOUR).is(':checked');
      var isCustomType = formNode.find(SEL_FORM_RADIO_CUSTOM).is(':checked');

      var customText = '';

      if (isHappyHour) {
        discount = 0;
        discountType = self._getHappyHourType();
      } else if (isCustomType) {
        discount = 0;
        discountType = self._getCustomType();
        customText = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT).val() || '';
      }

      var timesGroup = formNode.find(SEL_FORM_RECURRING_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);
      var startTimeGroup  =  timesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
      var endTimeGroup  =  timesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);
      var startTime    =  formTimepicker.getValue(startTimeGroup);
      var endTime      =  formTimepicker.getValue(endTimeGroup);

      startTime.hours = startTime.hours == "" ? 0 : parseInt(startTime.hours);
      startTime.mins = startTime.mins == "" ? 0 : parseInt(startTime.mins);

      endTime.hours = endTime.hours == "" ? 0 : parseInt(endTime.hours);
      endTime.mins = endTime.mins == "" ? 0 : parseInt(endTime.mins);

      return new DataObject(selectedWeekdays, discount, discountType,
      startTime.hours, startTime.mins, endTime.hours, endTime.mins,
      customText);
    }
    // will update it later with updated data (for onetime option)
    else{
      var discountOneTime    =  formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME).val();
      var discountTypeOneTime  =  formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME).selectpicker('val');
      var isHappyHourOneTime = formNode.find(SEL_FORM_RADIO_ONETIME_HAPPY_HOUR).is(':checked');
      var isCustomTypeOneTime = formNode.find(SEL_FORM_RADIO_ONETIME_CUSTOM).is(':checked');

      var customTextOneTime = '';

      if (isHappyHourOneTime) {
        discountOneTime = 0;
        discountTypeOneTime = self._getHappyHourType();
      } else if (isCustomTypeOneTime) {
        discountOneTime = 0;
        discountTypeOneTime = self._getCustomType();
        customTextOneTime = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME).val() || '';
      }

      var timesGroup = formNode.find(SEL_FORM_ONETIME_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);
      var oneTimeStartTimeGroup = timesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
      var oneTimeEndTimeGroup = timesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);
      var oneTimeStartTime    =  formTimepicker.getValue(oneTimeStartTimeGroup);
      var oneTimeEndTime      =  formTimepicker.getValue(oneTimeEndTimeGroup);

      oneTimeStartTime.hours = oneTimeStartTime.hours == "" ? 0 : parseInt(oneTimeStartTime.hours);
      oneTimeStartTime.mins = oneTimeStartTime.mins == "" ? 0 : parseInt(oneTimeStartTime.mins);

      oneTimeEndTime.hours = oneTimeEndTime.hours == "" ? 0 : parseInt(oneTimeEndTime.hours);
      oneTimeEndTime.mins = oneTimeEndTime.mins == "" ? 0 : parseInt(oneTimeEndTime.mins);

      var dateGroup = formNode.find(SEL_FORM_DATE_GROUP);

      var startDate = dateGroup.find(SEL_FORM_START_DATE_INPUT);
      if(startDate.val() != ''){
        var newStartDate = startDate.datepicker('getUTCDate');
        var startDateToIso = newStartDate.toISOString();
        startDateToIso = [startDateToIso.split('T')[0], startDateToIso.split('T')[1].replace(/[0-9]/g, "0")].join('T');
      }else{
        startDateToIso = '';
      }

      var endDate = dateGroup.find(SEL_FORM_END_DATE_INPUT);
      if(endDate.val() != ''){
        var newEndDate = endDate.datepicker('getUTCDate');
        var endDateToIso = newEndDate.toISOString();
        endDateToIso = [endDateToIso.split('T')[0], endDateToIso.split('T')[1].replace(/[0-9]/g, "0")].join('T');
      }else{
        endDateToIso = '';
      }

      //get the value of id for onetime to update the same row
      var oneTimeInputId = formNode.find(SEL_FORM_ONETIME_WRAPPER).find(SEL_FORM_ONETIME_ID_INPUT).val();

      return new DataObject(([] || ''), discountOneTime, discountTypeOneTime,
        oneTimeStartTime.hours, oneTimeStartTime.mins, oneTimeEndTime.hours, oneTimeEndTime.mins,
        customTextOneTime, startDateToIso, endDateToIso, oneTimeInputId);
    }
  };

  // get the value of active selected tab (between recurring or oneTime)
  this.getActivitySelection = function(){
    return formNode.find(SEL_ACTIVITY_SELECTOR_WRAPPER).find(SEL_ACTIVE_INPUT_LABEL).val();
  };

  //needs to update later for oneTime option (on basis of selected tab option)
  this.clear = function() {

    // weekdays
    formNode.find(SEL_FORM_INPUT_DAYS).selectpicker('val', []);

    // discount
    var discountInput = formNode.find(SEL_FORM_INPUT_DISCOUNT).val('');
    inputFilter.clearPreviousValues(discountInput);

    // discount type
    formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE).selectpicker('val', '');

    // custom text
    formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT).val('');

    // clear radio buttons
    this._selectBasic('', '');
    this._selectBasicForOneTime('', '');

    // times
    var timesGroup = formNode.find(SEL_FORM_RECURRING_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);
    var startingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
    var endingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);
    formTimepicker.clear(startingTime);
    formTimepicker.clear(endingTime);

    // will update it later (for onetime option)
    // discount
    var discountInputOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME).val('');
    inputFilter.clearPreviousValues(discountInputOneTime);

    // discount type
    formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME).selectpicker('val', '');

    // custom text
    formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME).val('');

    var timesGroupOneTime = formNode.find(SEL_FORM_RECURRING_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);
    var oneTimeStartingTime = timesGroupOneTime.find(SEL_FORM_INPUT_TIMES_START_GROUP);
    var oneTimeEndingTime = timesGroupOneTime.find(SEL_FORM_INPUT_TIMES_END_GROUP);
    formTimepicker.clear(oneTimeStartingTime);
    formTimepicker.clear(oneTimeEndingTime);

    self.markAsNotEditing();
    self.clearValidationErrors(formNode);
    self._forgetCurrentRow();
  };

  //clear all form-groups and form-controls errors 
  this.clearValidationErrors = function() {
    formNode.find(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
    formNode.find(SEL_FORM_CONTROL).removeClass(CSS_HAS_ERROR);
  };

  //needs to update later for oneTime option (on basis of selected tab option)
  this.validate = function(activitySelected) {
    var errors = [];
    var timeErrors = [];
    var dateErrors = false;

    if(activitySelected == 'recurring'){
      var weekdays = formNode.find(SEL_FORM_INPUT_DAYS);
      var discount = formNode.find(SEL_FORM_INPUT_DISCOUNT);
      var discountType = formNode.find(SEL_FORM_INPUT_DISCOUNT_TYPE);
      
      var timesGroup = formNode.find(SEL_FORM_RECURRING_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);
      var startingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
      var endingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);

      var happyHourRadio = formNode.find(SEL_FORM_RADIO_HAPPY_HOUR);
      var customRadio = formNode.find(SEL_FORM_RADIO_CUSTOM);
      var isCustom = customRadio.is(':checked');
      var isHappyHour = happyHourRadio.is(':checked');

      var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(startingTime);
      if (invalidTimepicker.length) {
        invalidTimepicker.forEach(function(timepicker) {
          errors.push(timepicker);
        });
      }

      invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(endingTime);
      if (invalidTimepicker.length) {
        invalidTimepicker.forEach(function(timepicker) {
          errors.push(timepicker);
        });
      }

      var selectPickerValue = weekdays.selectpicker('val') || [];
      if (selectPickerValue.length === 0) {
        errors.push(weekdays);
      }

      if (!isHappyHour && !isCustom) {
        if (discount.val().trim() === '') {
          errors.push(discount);
        }
        selectPickerValue = discountType.selectpicker('val') || '';
        if (selectPickerValue.trim() === '') {
          errors.push(discountType);
        }
      }

      if (isCustom) {
        var customText = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT);
        if (customText.val().trim() === '') {
          errors.push(customText);
        }
      }

      //display red border accross the input which has errors
      errors.forEach(function(input) {
        input.parents(SEL_FORM_GROUP).addClass(CSS_HAS_ERROR);
      });
    }

    else{
      // will update it later (for onetime option)
      var discountOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNT_ONETIME);
      var discountTypeOneTime = formNode.find(SEL_FORM_INPUT_DISCOUNTTYPE_ONETIME);

      var timesGroup = formNode.find(SEL_FORM_ONETIME_WRAPPER).find(SEL_FORM_INPUT_TIMES_GROUP);
      var oneTimeStartingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
      var oneTimeEndingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);

      var happyHourRadioOneTime = formNode.find(SEL_FORM_RADIO_ONETIME_HAPPY_HOUR);
      var customRadioOneTime = formNode.find(SEL_FORM_RADIO_ONETIME_CUSTOM);
      var isCustomOneTime = customRadioOneTime.is(':checked');
      var isHappyHourOneTime = happyHourRadioOneTime.is(':checked');

      var dateGroup = formNode.find(SEL_FORM_DATE_GROUP);
      var startDate = dateGroup.find(SEL_FORM_START_DATE_INPUT);
      var endDate = dateGroup.find(SEL_FORM_END_DATE_INPUT);

      var selectedDateInput = dateGroup.find(SEL_FROM_DROPDOWN_WRAPPER).find(SEL_FROM_SELECT_DROPDOWN).val();

      //date validation if date option selected
      if(selectedDateInput === 'date' && startDate.val() == ''){
        errors.push(startDate);
      }

      //date validation if timeframe selected
      if(selectedDateInput === 'timeframe'){
        //if both start and endDate inputs are empty
        if(startDate.val() == '' && endDate.val() == ''){
          errors.push(startDate);
          errors.push(endDate);
        }
        
        //if startDate input is empty
        if(startDate.val() == ''){
          errors.push(startDate);
        }
        
        //if endDate input is empty
        if(endDate.val() == ''){
          errors.push(endDate);
        }

        //validation - if startDate > endDate (startDate should not be greater than endDate)
        var convertedStartDate = startDate.datepicker('getDate', '+1d');
        var convertedEndDate = endDate.datepicker('getDate', '+1d');

        //startDate.val() !== endDate.val() -> condition is to check is start and end dates are equal or not
        //because if we don't add this condition, we may get error because timezone value is different for both dates even we added same date
        //to avoid this case, added startDate.val() !== endDate.val() condition
        if(+convertedEndDate < +convertedStartDate && startDate.val() !== endDate.val()){
          errors.push(endDate);
          dateErrors = true;
        }
      }

      if(!(selectedDateInput === 'date' && startDate.val() !== '') || (selectedDateInput === 'timeframe' && startDate.val() !== '' && endDate.val() !== '')){
        var invalidTimepickerOneTime = formTimepicker.validateAndGetEmptyTimepickers(oneTimeStartingTime);
        if (invalidTimepickerOneTime.length) {
          invalidTimepickerOneTime.forEach(function(timepicker) {
            errors.push(timepicker);
          });
        }
  
        invalidTimepickerOneTime = formTimepicker.validateAndGetEmptyTimepickers(oneTimeEndingTime);
        if (invalidTimepickerOneTime.length) {
          invalidTimepickerOneTime.forEach(function(timepicker) {
            errors.push(timepicker);
          });
        }

        var oneTimeStartTime = formTimepicker.getValue(oneTimeStartingTime);
        var oneTimeEndTime = formTimepicker.getValue(oneTimeEndingTime);

        //calculate start and end time
        var startTime = Number(oneTimeStartTime.hours)*60 + Number(oneTimeStartTime.mins);
        var endTime = Number(oneTimeEndTime.hours)*60 + Number(oneTimeEndTime.mins);

        //validation - startTime should not be greater than or equal to endTime
        if((startDate.val() === endDate.val()) && (startTime >= endTime)){
          //validation check - error should not display if time is 12AM - 12AM (for other cases it should display error like 1AM-1AM / 11AM-11AM)
          if(!(startTime == 0 && endTime == 0)){
            errors.push(oneTimeStartingTime);
            errors.push(oneTimeEndingTime);
            timeErrors.push(true);
          }
        }
      }

      var selectPickerValueOneTime = [];
      if (!isHappyHourOneTime && !isCustomOneTime) {
        if (discountOneTime.val().trim() === '') {
          errors.push(discountOneTime);
        }
        selectPickerValueOneTime = discountTypeOneTime.selectpicker('val') || '';
        if (selectPickerValueOneTime.trim() === '') {
          errors.push(discountTypeOneTime);
        }
      }

      if (isCustomOneTime) {
        var customTextOneTime = formNode.find(SEL_FORM_INPUT_CUSTOM_TEXT_ONETIME);
        if (customTextOneTime.val().trim() === '') {
          errors.push(customTextOneTime);
        }
      }

      //display red border accross the input which has errors
      errors.forEach(function(input) {
        input.parents(SEL_FORM_GROUP).addClass(CSS_HAS_ERROR);
      });

      //to display the error message if starttime >= endtime
      var count = 0;
      var timeErrorInput = formNode.find(SEL_FORM_INPUT_TIMES_WRAPPER).find(SEL_TIME_ERROR_DIV);
      timeErrorInput.empty();
      if(timeErrors.length > 0 && count == 0){ // count=0 for render below condition only once
        timeErrorInput.empty().append(formNode.data(DATA_ATTR_FORM_TIME_VALIDATION_ERROR));
        count++;
      }

      //to display the error message if endDate < startDate
      var helpBlockNode = endDate.siblings(SEL_FORM_HELP_BLOCK).empty();
      var dateErrorMessage = window.config.discountHours && window.config.discountHours.dateError;
      if(dateErrors){
        helpBlockNode.append('<span class="has-error">'+dateErrorMessage+'</span>');
      }
    }

    return !errors.length;
  };

  this.validateAndProcess = function(onSucess, onFail, activitySelected) {
    self.clearValidationErrors();
    if (self.validate(activitySelected)) {
      if (onSucess) {
        onSucess();
      }
    } else {
      if (onFail) {
        var errorMessage = self._getValidationErrorMessage();
        onFail(errorMessage);
      }
    }
  };

  this.focusOnFirstInput = function() {
    var firstInput = formNode.find(SEL_FORM_INPUT_DAYS);
    firstInput.focus();
  };

  this.onAddButtonClick = function(callback) {
    if (callback) {
      formNode.on('click', SEL_FORM_BTN_CREATE, function() {
        callback();
      });
    }
  };

  this.onCancelButtonClick = function(callback) {
    if (callback) {
      formNode.on('click', SEL_FORM_BTN_CANCEL, function() {
        callback();
      });
    }
  };

  this.onSaveButtonClick = function(callback) {
    if (callback) {
      formNode.on('click', SEL_FORM_BTN_SAVE, function() {
        callback();
      });
    }
  };

};

// Make class public to outside world
module.exports = Form;
},{"../form/FormInputFilter":86,"../form/FormTimepicker":90,"./DataObject":73,"bootstrap.datepicker":26,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],77:[function(require,module,exports){
/**
 * HiddenData functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var StringUtils	= require('../utils/StringUtils');
var ArrayUtils	= require('../utils/ArrayUtils');

var DataObject = require('./DataObject');
var moment 	   = require('moment/min/moment-with-locales');

// selector constants
var SEL_HIDDEN_FORM_DATA_WEEK_DAY     = '.discountHours-hiddenFormData-weekday';
var SEL_HIDDEN_FORM_DATA_ONETIME	  = '.discountHours-hiddenFormData-oneTime';
var SEL_HIDDEN_FORM_DATA_ROW          = '.discountHours-rowData';
var SEL_HIDDEN_FORM_INPUTS_WITH_PATH  = '[data-path]';

var SEL_FORMDATA_INPUT_DISCOUNT       = '.hidden-input-discountPercentage';
var SEL_FORMDATA_INPUT_DISCOUNT_TYPE  = '.hidden-input-discountType';
var SEL_FORMDATA_INPUT_CUSTOM_TEXT    = '.hidden-input-customText';
var SEL_FORMDATA_INPUT_START_HOUR     = '.hidden-input-startHour';
var SEL_FORMDATA_INPUT_START_MIN      = '.hidden-input-startMinute';
var SEL_FORMDATA_INPUT_END_HOUR       = '.hidden-input-endHour';
var SEL_FORMDATA_INPUT_END_MIN        = '.hidden-input-endMinute';
var SEL_FORMDATA_INPUT_IN_REQUEST 	  = '.hidden-input-inRequest';
var SEL_FORMDATA_INPUT_START_DATE 	  = '.hidden-input-startDate';
var SEL_FORMDATA_INPUT_END_DATE 	  = '.hidden-input-endDate';
var SEL_FORMDATA_INPUT_ID	  		  = '.hidden-input-id';
var SEL_FORMDATA_INPUT_ROWID 		  = '.hidden-input-rowId';

var ONETIME_WRAPPER_CLASS 			  = 'discountHours-hiddenFormData-oneTime';

var ATTR_DATA_PATH                    = 'data-path';
var ATTR_PATH                         = 'name';

var DATA_ATTR_WEEKDAY_ID              = 'weekday';
var DATA_ATTR_WEEKDAY_LABEL           = 'weekdayLabel';

// Class definition
var HiddenData = function(hiddenDataNode, dataRowTemplate, oneTimeDataRowTemplate) {

	var self = this;

	// private methods

	this._createNewRowDataRow = function() {
		var clone = jQuery(dataRowTemplate.html());
		return clone;
	};

	this._createNewOneTimeDataRow = function(){
		var clone = jQuery(oneTimeDataRowTemplate.html());
		return clone;
	}

	this._buildVirtualGroupIdFromDataRow = function(dataRow) {
		var weekdays = [];
		var discount = dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT).val();
		var discountType = dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT_TYPE).val();
		var startHour = dataRow.find(SEL_FORMDATA_INPUT_START_HOUR).val();
		var startMin = dataRow.find(SEL_FORMDATA_INPUT_START_MIN).val();
		var endHour = dataRow.find(SEL_FORMDATA_INPUT_END_HOUR).val();
		var endMin = dataRow.find(SEL_FORMDATA_INPUT_END_MIN).val();
		var customText = dataRow.find(SEL_FORMDATA_INPUT_CUSTOM_TEXT).val();
		//adding id to distinguish oneTime and recurring offers virtualId
		var id = dataRow.find(SEL_FORMDATA_INPUT_ROWID).val();
		var startDate = '';
		var endDate = '';

		var dataObject = new DataObject(
			weekdays,
			discount, discountType,
			startHour, startMin, endHour, endMin,
			customText,
			startDate, endDate,
			id
		);

		return self._buildVirtualGroupId(dataObject);
	};

	this._buildVirtualGroupId = function(dataObject) {
		// build a virtual id, using concatinating all values in the dataRow using ':';
		// e.g. "<firstValue>:<secondValue>: ... :<lastValue>"
		return [
			dataObject.discount,
			dataObject.discountType,
			dataObject.startHour,
			dataObject.startMin,
			dataObject.endHour,
			dataObject.endMin,
			dataObject.customText,
			dataObject.id
		].join(':');
	};

	/**
	 * @return Map with 'virtual id' as key and a list of rows as value.
	 */
	this._groupDataRowsByDiscountSetup = function(dataRows) {
		var groupsByKey = {};

		dataRows.each(function() {
			var row = jQuery(this);
			var id = self._buildVirtualGroupIdFromDataRow(row);
			if (!(id in groupsByKey)) {
				groupsByKey[id] = [];
			}
			groupsByKey[id].push(row);
		});

		return groupsByKey;
	};

	/**
	 * @returns Sorted list (sorted by weekday) of weekday Ids
	 */
	this._getWeekdaysFromDataRows = function(dataRows) {
		var weekdays = dataRows.map(function(row) {
			return jQuery(row).parents(SEL_HIDDEN_FORM_DATA_WEEK_DAY).data(DATA_ATTR_WEEKDAY_ID);
		});
		weekdays.sort();
		return weekdays;
	};

	this._resetInputPath = function(inputNode, rowIndex, dataIndex) {
		var path = inputNode.attr(ATTR_DATA_PATH) || '';
		path = StringUtils.findAndReplaceAll(path, {
			'%%ROW_INDEX%%': rowIndex,
			'%%DATA_INDEX%%': dataIndex
		});
		inputNode.attr(ATTR_PATH, path);
	};

	this._updateDataRowWithDataObject = function(dataRow, dataObject, rowIndex, colIndex) {
		//update inRequest value to true for selected weekday
		dataRow.siblings(SEL_FORMDATA_INPUT_IN_REQUEST).val(true);

		//update other input values for selected weekday
		dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT).val(dataObject.discount);
		dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT_TYPE).val(dataObject.discountType);
		dataRow.find(SEL_FORMDATA_INPUT_START_HOUR).val(dataObject.startHour);
		dataRow.find(SEL_FORMDATA_INPUT_START_MIN).val(dataObject.startMin);
		dataRow.find(SEL_FORMDATA_INPUT_END_HOUR).val(dataObject.endHour);
		dataRow.find(SEL_FORMDATA_INPUT_END_MIN).val(dataObject.endMin);
		dataRow.find(SEL_FORMDATA_INPUT_CUSTOM_TEXT).val(dataObject.customText);

		// add joined data index attribute for start hour hidden element (for comparison pupose during time of overlapping)
		if(window.config.discountHours && window.config.discountHours.isWizard){
			dataRow.find(SEL_FORMDATA_INPUT_START_HOUR).attr('data-joined-index', rowIndex+"|"+colIndex);
		}
	};

	this._addNewDataRowToWeekdayRow = function(weekdayRow, dataObject, weekdayIndex, timeIntervalIndex) {
		var newRow = self._createNewRowDataRow();
		weekdayRow.append(newRow);
		self._updateDataRowWithDataObject(newRow, dataObject, weekdayIndex, timeIntervalIndex);
	};

	/**
	 * @description select oneTime wrapper and create span rows inside it
	 * @param {*} dataObject 
	 * @param {*} id 
	 */
	this.updateWithOneTimeRowData = function(dataObject, id) {
		var oneTimeRow = hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ONETIME);
		self._addNewDataRowToOneTimeRow(oneTimeRow, dataObject, id);
	};

	/**
	 * @description create oneTime span elements with blank data
	 * @param {*} oneTimeRow 
	 * @param {*} dataObject 
	 * @param {*} id 
	 */
	this._addNewDataRowToOneTimeRow = function(oneTimeRow, dataObject, id){
		var newRow = self._createNewOneTimeDataRow();
		oneTimeRow.append(newRow);
		self._updateOneTimeRowWithDataObject(newRow, dataObject, id);	
	}

	/**
	 * @description update the specific span element with dataObject value 
	 */
	this._updateOneTimeRowWithDataObject = function(dataRow, dataObject, id){
		//update inRequest value to true for onetime row
		dataRow.siblings(SEL_FORMDATA_INPUT_IN_REQUEST).val(true);
		
		// change the epoch timestamp into desired date format to display
		dataObject.startDate = (dataObject.startDate != null) ? moment(dataObject.startDate).format(window.config.discountHours.calendarDateFormatMomentJs) : "";
		dataObject.endDate = (dataObject.endDate != null) ? moment(dataObject.endDate).format(window.config.discountHours.calendarDateFormatMomentJs) : "";
		
		//update other input values for ontime row
		dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT).val(dataObject.discount);
		dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT_TYPE).val(dataObject.discountType);
		dataRow.find(SEL_FORMDATA_INPUT_START_HOUR).val(dataObject.startHour);
		dataRow.find(SEL_FORMDATA_INPUT_START_MIN).val(dataObject.startMin);
		dataRow.find(SEL_FORMDATA_INPUT_END_HOUR).val(dataObject.endHour);
		dataRow.find(SEL_FORMDATA_INPUT_END_MIN).val(dataObject.endMin);
		dataRow.find(SEL_FORMDATA_INPUT_CUSTOM_TEXT).val(dataObject.customText);
		dataRow.find(SEL_FORMDATA_INPUT_START_DATE).val(dataObject.startDate);
		dataRow.find(SEL_FORMDATA_INPUT_END_DATE).val(dataObject.endDate);
		dataRow.find(SEL_FORMDATA_INPUT_ROWID).val(dataObject.id);
		dataRow.find(SEL_FORMDATA_INPUT_ID).val(id);
	}

	// exposed methods

	//append input hidden fields inside container for each row of onetime option
	this.updateDataToSubmitFormOneTime = function(dataObject, index){
		var container = hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ONETIME);
		var path = container.attr(ATTR_DATA_PATH);		
		createItemForSubmit(container, path, dataObject, index);
	}

	//build path for outer array object like weekdayTimeSettings[7].startDate
 	var buildPath = function (path, index, name) {
		return path + '[' + index + '].' + name;
	};

	//build path for nested array object like weekdayTimeSettings[7].timeIntervals[0].discountPercentage
	var buildIntervalPath = function(path, index, subIndex, name) {
		return path + '[' + index + '].timeIntervals[' + subIndex + '].' + name;
	};

	//create input hidden fields for onetime option
	var addInput = function(container, name, value) {
		return jQuery('<input />')
			.attr('type', 'hidden')
			.attr('name', name)
			.attr('value', value)
			.appendTo(container);
	};

	//create inputs for each row of onetime option with specific path
	var createItemForSubmit = function(container, path, data, index) {
		//index start with 7 because 0-6 index has been taken by recurring
		index = index + 7;
		
		//date inputs
		addInput(container, buildPath(path, index, "id"), data.id || 0);
		addInput(container, buildPath(path, index, "rowId"), index);
		addInput(container, buildPath(path, index, "weekday"), 0);
		addInput(container, buildPath(path, index, "inRequest"), true);
		addInput(container, buildPath(path, index, "recurringDiscounts"), false);
		addInput(container, buildPath(path, index, "startDate"), data.startDate);
		addInput(container, buildPath(path, index, "endDate"), data.endDate);
		
		//timeIntervals inputs
		addInput(container, buildIntervalPath(path, index, 0, 'inRequest'), 'true');
		addInput(container, buildIntervalPath(path, index, 0, "discountPercentage"), data.discount || 0);
		addInput(container, buildIntervalPath(path, index, 0, "discountType"), data.discountType || '');
		addInput(container, buildIntervalPath(path, index, 0, "customText"), data.customText || '');
		addInput(container, buildIntervalPath(path, index, 0, "startHour"), data.startHour || 0);
		addInput(container, buildIntervalPath(path, index, 0, "startMinute"), data.startMin || 0);
		addInput(container, buildIntervalPath(path, index, 0, "endHour"), data.endHour || 0);
		addInput(container, buildIntervalPath(path, index, 0, "endMinute"), data.endMin || 0);
	};

	this.updateWithRowData = function(dataObject, timeIntervalIndex) {
		var virtualId = self._buildVirtualGroupId(dataObject);
		var selectedWeekdays = dataObject.weekdays || [];
		var noStrictComparison = true;

		hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_WEEK_DAY).each(function(weekdayIndex, weekdayRowNode) {
			var weekdayRow = jQuery(weekdayRowNode);
			var weekday = weekdayRow.data(DATA_ATTR_WEEKDAY_ID);
			var isSelectedWeekday = ArrayUtils.inArray(selectedWeekdays, weekday, noStrictComparison);
			var dataRows = weekdayRow.find(SEL_HIDDEN_FORM_DATA_ROW);

			// we may have an overlap due to values changing, so let's step through and
			// remove any matching data rows
			dataRows.each(function(dataRowIndex, dataRowNode) {
				var dataRow = jQuery(dataRowNode);
				var rowVirtualId = self._buildVirtualGroupIdFromDataRow(dataRow);
				var sameWeekday = dataObject.weekdays.includes(dataRow.parent().attr('data-weekday'));
				if (rowVirtualId == virtualId && sameWeekday) {
					dataRow.remove();
				}
			});

			if (isSelectedWeekday) {
				self._addNewDataRowToWeekdayRow(weekdayRow, dataObject, weekdayIndex, timeIntervalIndex, dataRowTemplate);
			}
		});
	};

	this.getWeekdayLabelsForIds = function(weekdayIds) {
		var weekdaysToLabels = {};
		hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_WEEK_DAY).each(function(index, weekdayRowNode) {
			var weekdayRow = jQuery(weekdayRowNode);
			var weekdayId = weekdayRow.data(DATA_ATTR_WEEKDAY_ID);
			var weekdayLabel = weekdayRow.data(DATA_ATTR_WEEKDAY_LABEL);
			weekdaysToLabels[weekdayId] = weekdayLabel;
		});
		return jQuery.map(weekdayIds, function(weekdayId) {
			return weekdaysToLabels[weekdayId];
		});
	};

	this.resetDataIndexes = function() {
		var weekdayRows = hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_WEEK_DAY);
		weekdayRows.each(function(weekdayIndex, weekdayRowNode) {
			var dataRows = jQuery(weekdayRowNode).find(SEL_HIDDEN_FORM_DATA_ROW);
			dataRows.each(function(dataRowIndex, rawNode) {
				var dataRow = jQuery(rawNode);
				dataRow.find(SEL_HIDDEN_FORM_INPUTS_WITH_PATH).each(function(index, inputNode) {
					self._resetInputPath(jQuery(inputNode), weekdayIndex, dataRowIndex);
				});
			});
		});
	};

	this.getDataObjectFromRow = function(dataRow) {
		var weekdays		  =	[];
		var discount		  =	dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT).val();
		var discountType 	  =	dataRow.find(SEL_FORMDATA_INPUT_DISCOUNT_TYPE).val();
		var startHour		  =	dataRow.find(SEL_FORMDATA_INPUT_START_HOUR).val();
		var startMin		  =	dataRow.find(SEL_FORMDATA_INPUT_START_MIN).val();
		var endHour			  =	dataRow.find(SEL_FORMDATA_INPUT_END_HOUR).val();
		var endMin			  =	dataRow.find(SEL_FORMDATA_INPUT_END_MIN).val();
		var customText	      =	dataRow.find(SEL_FORMDATA_INPUT_CUSTOM_TEXT).val();
		var startDate	      =	dataRow.find(SEL_FORMDATA_INPUT_START_DATE).val();
		var endDate	      	  =	dataRow.find(SEL_FORMDATA_INPUT_END_DATE).val();
		var id	      	  	  =	dataRow.find(SEL_FORMDATA_INPUT_ID).val();

		return new DataObject(
			weekdays,
			discount, discountType,
			startHour, startMin, endHour, endMin,
			customText,
			startDate,
			endDate,
			id
		);
	};

	this.getAllDataRowsForDataObject = function(dataObject) {
		var virtualId = self._buildVirtualGroupId(dataObject);
		return hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ROW).filter(function(index, row) {
			return virtualId === self._buildVirtualGroupIdFromDataRow(jQuery(row));
		});
	};

	this.getAllDataForOneTimeDataObject = function() {
		return hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ONETIME);
	};

	this.buildItemsListFromInitialData = function(itemsList) {
		//get the data row for recurring
		var discounts = self._groupDataRowsByDiscountSetup(hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ROW));
		for (var id in discounts) {
			var items = discounts[id];
			var weekdays = self._getWeekdaysFromDataRows(items);
			
			if(items[0].parent().attr('class') === ONETIME_WRAPPER_CLASS){
				//for onetime - multiple rows with unique id can be possible (because date can be different)
				for(var i=0; i<items.length; i++){
					itemsList.addRowFromDataRowAndWeekdays(items[i], weekdays, this);
				}
			}else{
				//for recurring 
				var firstItem = items[0]; // there should be at least one item for this discount to exist
				itemsList.addRowFromDataRowAndWeekdays(firstItem, weekdays, this);
			}
		}
		itemsList.refresh();
	};

	//to remove weekday nodes after click on edit icon on offers page
	this.removeWeekdayInputs = function(){
		hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_WEEK_DAY).each(function(index, item){
			jQuery(item).find(SEL_HIDDEN_FORM_DATA_ROW).remove();
		});
	}

	//to remove oneTime hidden inputs after click on edit icon on offers page
	this.removeOneTimeInputs = function(){
		var spanRows = hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ONETIME).find(SEL_HIDDEN_FORM_DATA_ROW);

		if(spanRows.length > 0){
			hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ONETIME).each(function(index, item){
				jQuery(item).find(SEL_HIDDEN_FORM_DATA_ROW).remove();
			});
		}else{
			hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ONETIME).empty();	
		}
	}
};

// Make class public to outside world
module.exports = HiddenData;
},{"../utils/ArrayUtils":183,"../utils/StringUtils":187,"./DataObject":73,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],78:[function(require,module,exports){
/**
 * FormData functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var StringUtils     = require('../utils/StringUtils');
var ArrayUtils      = require('../utils/ArrayUtils');

var DataObject  = require('./DataObject');

// selector constants

var SEL_LIST_CONTAINER              = 'tbody';
var SEL_LIST_ROW                    = '.discountHours-itemsList-row';
var SEL_LIST_WEEKDAYS               = '.weekdays-text';
var SEL_LIST_TIMES                  = '.times-text';
var SEL_LIST_DISCOUNT               = '.discount-text';
var SEL_LIST_DATE                   = '.offer-date-text';

var SEL_LIST_BTN_EDIT               = '.buttonEdit';
var SEL_LIST_BTN_DELETE             = '.buttonDelete';

var SEL_DISCOUNT_TYPE_OPTIONS       = '.discountTypeOptions .discountType';

var DATA_ATTR_DISCOUNT_FORMAT       = 'format';
var DATA_ATTR_LIST_CONFIRM_DELETE   = 'confirmMessageDelete';
var DATA_ATTR_FORMDATA_ROWS         = 'formDataRows';
var DATA_ATTR_ROW_VALUES            = 'rowValues';
var DATA_ATTR_VALUE                 = 'value';
var DATA_ATTR_NAME                  = 'name';
var DATA_ATTR_24HOURS               = 'display-24h';
var DATA_ATTR_CUSTOM_TYPE           = 'customType';
var DATA_ATTR_HAPPY_HOUR_TYPE       = 'happyHourType';
var DATA_ATTR_HAPPY_HOUR_TEXT       = 'happyHourText';

var CSS_EMPTY_LIST                  = 'empty-list';
var CSS_IS_EDITING                  = 'is-editing';

var PERCENTAGE_SYMBOL               = '%';

var TIME_24HOUR_CUTOFF              = 12;
var TIME_CHARACTERS_TOTAL           = 2;
var TIME_HOURS_MINS_SPLITTER        = ':';
var TIME_GROUP_SPLITTER             = ' - ';
var MERIDIEM_AM                     = ' AM';
var MERIDIEM_PM                     = ' PM';

var HIDDEN_ONETIME_ROW              = 'discountHours-hiddenFormData-oneTime';

var EVENT_ON_FORCE_REFRESH          = 'itemEditor:itemsList:forceRefresh';
var EVENT_ON_LIST_REFRESHED         = 'itemEditor:itemsList:listRefreshed';


// TODO refactor to use the AbstractList used by other itemEditors (table setup, etc)
// Class definition
var ItemsList = function(itemsListNode, listRowTemplate) {

  var self = this;

  var discountTypes = {};

  // private methods

  this._createNewRow = function() {
    var clone = jQuery(listRowTemplate.html()).find(SEL_LIST_ROW);
    return clone;
  };

  this._saveDataRowReferences = function(row, dataRows) {
    row.data(DATA_ATTR_FORMDATA_ROWS, dataRows);
  };

  this._deleteDataRowReferences = function(row) {
    var oldRowItems = row.data(DATA_ATTR_FORMDATA_ROWS);

    if(oldRowItems != undefined){
      //for oneTime hidden rows
      if(jQuery(oldRowItems[0]).attr('class') === 'discountHours-rowData'){
        jQuery.each(oldRowItems, function(index, item) {
          jQuery(item).remove();
        });
      }
      
      //for recurring hidden rows
      if(jQuery(oldRowItems[0]).attr('class') === HIDDEN_ONETIME_ROW){
        jQuery.each(oldRowItems, function(index, item) {
          jQuery(item).empty();
        });
      }
    }    
  };

  this._getRowFromActionButton = function(button) {
    return button.parents(SEL_LIST_ROW);
  };

  this._populateDiscountTypes = function() {
    self.getNode().find(SEL_DISCOUNT_TYPE_OPTIONS).each(function() {
      var option = jQuery(this);
      var optionValue = option.data(DATA_ATTR_VALUE);
      var optionName = option.data(DATA_ATTR_NAME);
      discountTypes[optionValue] = optionName;
    });
  };

  this._getDiscountTypeName = function(value) {
    return discountTypes[value] || '';
  };

  this._shouldUse24Hours = function() {
    return self.getNode().data(DATA_ATTR_24HOURS) || false;
  };

  this._formatTime = function(hours, mins) {
    if (hours === '' || mins === '') {
      return '';
    }

    var use24Hours = self._shouldUse24Hours();
    var merediem = '';
    var hoursInt = parseInt(hours);
    if (!use24Hours) {
      merediem += ' ';
      if (hoursInt === 0) {
        hours = TIME_24HOUR_CUTOFF;
        merediem = MERIDIEM_AM;
      } else if (hoursInt > TIME_24HOUR_CUTOFF) {
        hours -= TIME_24HOUR_CUTOFF;
        merediem = MERIDIEM_PM;
      } else if (hoursInt === TIME_24HOUR_CUTOFF) {
        merediem = MERIDIEM_PM;
      } else {
        merediem = MERIDIEM_AM;
      }
    }

    hours = use24Hours ? StringUtils.numLeftPad(hours, TIME_CHARACTERS_TOTAL) : hours;
    mins = StringUtils.numLeftPad(mins, TIME_CHARACTERS_TOTAL);

    return hours + TIME_HOURS_MINS_SPLITTER + mins + merediem;

  };

  this._getCustomType = function() {
    return self.getNode().data(DATA_ATTR_CUSTOM_TYPE);
  };

  this._isCustomType = function(type) {
    return type === self._getCustomType();
  };

  this._getHappyHourType = function() {
    return self.getNode().data(DATA_ATTR_HAPPY_HOUR_TYPE);
  };

  this._getHappyHourText = function() {
    return self.getNode().data(DATA_ATTR_HAPPY_HOUR_TEXT);
  };

  this._isHappyHour = function(type) {
    return type === self._getHappyHourType();
  };

  // exposed methods

  this.init = function(hiddenData) {
    self._populateDiscountTypes();
    hiddenData.buildItemsListFromInitialData(self);
    itemsListNode.on(EVENT_ON_FORCE_REFRESH, function() {
      self.refresh();
    });
  };

  this.getNode = function() {
    return itemsListNode;
  };

  this.deleteRow = function(row) {
    self._deleteDataRowReferences(row);
    row.remove();
  };

  this.getDeleteConfirmMessage = function() {
    return self.getNode().data(DATA_ATTR_LIST_CONFIRM_DELETE);
  };

  this.refresh = function(eventData) {
    self.markAllRowsAsNotEditing();
    var itemsListNode = self.getNode();
    // has items?
    if (itemsListNode.find(SEL_LIST_ROW).length > 0) {
      itemsListNode.removeClass(CSS_EMPTY_LIST);
    } else {
      itemsListNode.addClass(CSS_EMPTY_LIST);
    }
    itemsListNode.trigger(EVENT_ON_LIST_REFRESHED, [this, eventData]);
  };

  this.markRowAsEditing = function(row) {
    row.addClass(CSS_IS_EDITING);
  };

  this.markAllRowsAsNotEditing = function() {
    self.getNode().find(SEL_LIST_ROW).removeClass(CSS_IS_EDITING);
  };

  this.editRow = function(row, form) {
    self.markRowAsEditing(row);
    form.setValues(row, self);
    form.focusOnFirstInput();
  };

  this.getDataObjectFromRow = function(row) {
    return row.data(DATA_ATTR_ROW_VALUES) || {};
  };

  this._convertDisplayDateFormat = function(dateVal){
    var getMonthYear =  dateVal.split("-");
    var getDate = dateVal.split('-')[2].split('T')[0];
    return getDate+'/'+getMonthYear[1]+'/'+getMonthYear[0];
  }

  this.updateRow = function(row, dataObject, hiddenData, shouldNotUpdateHiddenData, selectedActivity, index) {

    if(dataObject.weekdays.length !== 0){
      var weekdayLabels = hiddenData.getWeekdayLabelsForIds(dataObject.weekdays);
      weekdayLabels = ArrayUtils.unique(weekdayLabels);
  
      var weekdaysFormatted = weekdayLabels.join(', ');
      row.find(SEL_LIST_WEEKDAYS).text(weekdaysFormatted);
    }else{
      var startDate = (dataObject.startDate != undefined || dataObject.startDate != null) ? dataObject.startDate : '';
      var endDate = (dataObject.endDate != undefined || dataObject.endDate != null) ? (' - ' + dataObject.endDate) : '';
      var dateFormatted = startDate + endDate;
      row.find(SEL_LIST_DATE).text(dateFormatted);
    }

    var timesElement = row.find(SEL_LIST_TIMES);
    var timesFormatted = [];
    var timeGroupFormatted = self._formatTime(dataObject.startHour, dataObject.startMin);
    if (timeGroupFormatted !== '') {
      timesFormatted.push(timeGroupFormatted);
    }
    timeGroupFormatted = self._formatTime(dataObject.endHour, dataObject.endMin);
    if (timeGroupFormatted !== '') {
      timesFormatted.push(timeGroupFormatted);
    }
    timesFormatted = timesFormatted.join(TIME_GROUP_SPLITTER);
    timesElement.text(timesFormatted);

    var discountElement = row.find(SEL_LIST_DISCOUNT);
    var discountFormat = discountElement.data(DATA_ATTR_DISCOUNT_FORMAT);
    var discountFormatted = StringUtils.findAndReplaceAll(discountFormat, {
      '%%DISCOUNT%%': dataObject.discount + PERCENTAGE_SYMBOL,
      '%%DISCOUNT_TYPE%%': self._getDiscountTypeName(dataObject.discountType)
    });
    if (self._isCustomType(dataObject.discountType)) {
      discountFormatted = dataObject.customText || '';
    } else if (self._isHappyHour(dataObject.discountType)) {
      discountFormatted = self._getHappyHourText();
    }
    discountElement.text(discountFormatted);

    row.data(DATA_ATTR_ROW_VALUES, dataObject);

    // do we need to update the form data?
    if (!shouldNotUpdateHiddenData) {
      // remove old data row items
      self._deleteDataRowReferences(row);
      // add new data row items

      if(selectedActivity === 'recurring'){
        hiddenData.updateWithRowData(dataObject);
        // keep a reference to the new data row items
        var rowItems = hiddenData.getAllDataRowsForDataObject(dataObject);
        self._saveDataRowReferences(row, rowItems);
      }else{
        hiddenData.updateDataToSubmitFormOneTime(dataObject, index);
        // keep a reference to the new data row items
        //hiddenData.removeWeekdayInputs();
        var rowItems = hiddenData.getAllDataForOneTimeDataObject();
        self._saveDataRowReferences(row, rowItems);
      }
    }
  };

  this.addRow = function(dataObject, hiddenData, selectedActivity, index) {
    var newRow = self._createNewRow();
    self.updateRow(newRow, dataObject, hiddenData, undefined, selectedActivity, index);
    newRow.appendTo(self.getNode().find(SEL_LIST_CONTAINER));
  };

  this.addRowFromDataRowAndWeekdays = function(dataRow, weekdays, hiddenData) {
    var dataObject = hiddenData.getDataObjectFromRow(dataRow);
    if(weekdays[0] != undefined){
      dataObject.weekdays = weekdays; // override the weekdays
    }

    dataObject.startDate = dataObject.startDate == undefined ? null : dataObject.startDate;
    dataObject.endDate = dataObject.endDate == undefined ? null : dataObject.endDate;

    var shouldNotUpdateHiddenData = true;

    var newRow = self._createNewRow();
    self.updateRow(newRow, dataObject, hiddenData, shouldNotUpdateHiddenData);
    newRow.appendTo(self.getNode().find(SEL_LIST_CONTAINER));
    return newRow;
  };

  this.onRowEditButtonClick = function(callback) {
    self.getNode().on('click', SEL_LIST_BTN_EDIT, function() {
      if (callback) {
        var row = self._getRowFromActionButton(jQuery(this));
        callback(row);
      }
    });
  };

  this.onRowDeleteButtonClick = function(callback) {
    self.getNode().on('click', SEL_LIST_BTN_DELETE, function() {
      if (callback) {
        var row = self._getRowFromActionButton(jQuery(this));
        callback(row);
      }
    });
  };

  this.getAllRows = function() {
    return itemsListNode.find(SEL_LIST_ROW);
  };

};

// Make class public to outside world
module.exports = ItemsList;
},{"../utils/ArrayUtils":183,"../utils/StringUtils":187,"./DataObject":73,"jquery/dist/jquery":14}],79:[function(require,module,exports){


/**
 * DiscountHours functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
var DiscountHours 			= require('./DiscountHours');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var discountHours 		= new DiscountHours();

	// Trigger onload activities
	discountHours.init(initNode);

});

},{"../mediator/mediator":103,"./DiscountHours":74}],80:[function(require,module,exports){
/**
 * EditableSummary functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');




// Class definition
EditableSummary = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                      = '.editable-summary';
  var SEL_EDIT_BUTTON                 = '.edit-summary-action';

  var CSS_CLASS_EDIT_MODE             = 'edit-mode';


  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes 			= initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      moduleNode.find(SEL_EDIT_BUTTON).on('click', function() {
        moduleNode.toggleClass(CSS_CLASS_EDIT_MODE);
      });

    });

  };

};

// Make class public to outside world
module.exports = EditableSummary;

},{"../mediator/mediator":103,"jquery/dist/jquery":14}],81:[function(require,module,exports){
/**
 * FeedbackList functionality.
*
*/

// Mediator module (handles event delegation)
var mediator 	= require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
Notification	= require('../notification/Notification');

// Class definition
FeedbackList = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						= '.mod-feedback-list';
    var SEL_FEEDBACK_ITEM_CLICK_ZONE	= '.table tbody tr td.clickable';
	var SEL_FEEDBACK_LIST_MODULE		= ".mod-feedback-list-item";
	var SEL_FEEDBACK_REPLY_BTN			= ".reply-button";
	var SEL_MODAL_SUBMIT 				= '.submit-button';
	var SEL_MODAL_CLOSE					= '.close';
	var SEL_MODAL_MESSAGE_TEXT 			= '.customer-message';
	var SEL_MODAL_STATUS_CONFIRM 		= '#reservationStatusConfirmModal';
	var SEL_REPLIED_BLOCK				= '.replied-block';
	var SEL_RESERVATION_DETAIL_ICON		= '.reservationDetailIcon';

	var CSS_HIDDEN 						= 'hidden';
	var CSS_VISIBLE_REPLIED_BLOCK		= 'visible-replied-block';
    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes = initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {
			
			var moduleNode = jQuery(this);

			var feedbackItemClickZoneNodes = jQuery(this).find(SEL_FEEDBACK_ITEM_CLICK_ZONE);
			var reservationDetailPageNodes = jQuery(this).find(SEL_RESERVATION_DETAIL_ICON);
			
			feedbackItemClickZoneNodes.bind('click', function() {
				var editUrl = jQuery(this).parents('tbody').attr('data-editurl');
				if (editUrl != undefined) {
					document.location.href = editUrl;
				}
			});

			reservationDetailPageNodes.bind('click', function(){
				var editUrl = jQuery(this).parents('tbody').attr('data-editurl');
				if (editUrl != undefined) {
					document.location.href = editUrl;
				}
			})

			feedbackItemModule(moduleNode);
		});
    };

	var feedbackItemModule = function(moduleNode){

		var notification = new Notification();
		var innerModuleNode	= moduleNode.find(SEL_FEEDBACK_LIST_MODULE);

		innerModuleNode.each(function(){
			var feedbackItem = jQuery(this);
			var replyBtn = feedbackItem.find(SEL_FEEDBACK_REPLY_BTN);

			replyBtn.click(function(){
				showCancelPopup(moduleNode, feedbackItem).done(function (message) {
					submitFeedbackForm(message, feedbackItem, notification);
                });
			});
		})
	}

	var showCancelPopup = function (moduleNode, feedbackItem) {
        var dfd = jQuery.Deferred();
        var modal = getStatusConfirmModal(moduleNode);
        var modalSubmitted = false;

		var textContent = modal.find(SEL_MODAL_MESSAGE_TEXT);
		var submitBtn = modal.find(SEL_MODAL_SUBMIT);
		submitBtn.attr('disabled', 'disabled');

		textContent.bind('input', function() {
			toggleSubmitBtn(jQuery(this).val(), submitBtn);
		});

		modal.find(SEL_MODAL_CLOSE).on('click', function (e) {
			modal.find(SEL_MODAL_MESSAGE_TEXT).val('');
		});

        // resolve promise if the submit button was clicked
        modal.find(SEL_MODAL_SUBMIT).on('click', function (e) {
            e.preventDefault();
            modalSubmitted = true;
            var message = modal.find(SEL_MODAL_MESSAGE_TEXT).val() || '';
			//submitFeedbackForm(message, feedbackItem);
            modal.modal('hide');
			modal.find(SEL_MODAL_MESSAGE_TEXT).val('');
            dfd.resolve(message === '' ? null : message);
        });

        // reject the promise if modal was closed without submitting
        modal.on('hide.bs.modal', function () {
            // if modal was simply closed
            if (!modalSubmitted) {
                dfd.reject();
            }
        });

        // show modal
        modal.modal('show');

        return dfd.promise();
    };

	var toggleSubmitBtn = function(value, submitBtn){
		var isValueEmpty = !value;
		if (isValueEmpty) {
			submitBtn.attr('disabled','disabled');
		} else {
			submitBtn.removeAttr('disabled');
		}
	}

	var getStatusConfirmModal = function (moduleNode) {
        return moduleNode.find(SEL_MODAL_STATUS_CONFIRM)
				.clone()
				.removeClass(CSS_HIDDEN);
    };

	var submitFeedbackForm = function(message, feedbackItem, notification){

		var repliedBlock = feedbackItem.find(SEL_REPLIED_BLOCK);

		var feedbackId = feedbackItem.find(SEL_FEEDBACK_REPLY_BTN).attr("data-feedback-id");
		var csrf_token = feedbackItem.find(SEL_FEEDBACK_REPLY_BTN).attr("data-csrf");

		var replyBtn = feedbackItem.find(SEL_FEEDBACK_REPLY_BTN);

		var feedbackUrl = "feedback/"+feedbackId+"/response";
		
		var requestData = {
			text: message,
			_csrf: csrf_token
		}

		jQuery.ajax({
            url: feedbackUrl,
            type: 'POST',
            data: requestData,
            dataType: 'json',
			success: function(result) {
				if(result.status == 'OK'){
					replyBtn.css('display', 'none');
					repliedBlock.addClass(CSS_VISIBLE_REPLIED_BLOCK);
					notification.showConfirmNotification(result.msg);
				}
			},
			error: function(result) {
				notification.showErrorNotification(result.msg);
			}
		});
	}
};

// Make class public to outside world
module.exports = FeedbackList;
},{"../mediator/mediator":103,"../notification/Notification":125,"jquery/dist/jquery":14}],82:[function(require,module,exports){
/**
 * FeedbackListItem functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
FeedbackListItem = function() {


    // self references
    var self;

	// selector constants
    var SEL_MODULE					= '.mod-feedback-list-item';
    var SEL_FEEDBACK_ITEM_FORM		= 'form';
    var SEL_FEEDBACK_ITEM_SELECT	= 'select';
    var SEL_FEEDBACK_ITEM_OPTION	= 'option';
    var SEL_FEEDBACK_ITEM_CSRF		= 'input[name="_csrf"]';



    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode = jQuery(this);
			var feedbackForm = moduleNode.find(SEL_FEEDBACK_ITEM_FORM);
      var feedbackRow = moduleNode.closest('tbody');

			var feedbackPublishSelect = moduleNode.find(SEL_FEEDBACK_ITEM_SELECT);
			var csrf = moduleNode.find(SEL_FEEDBACK_ITEM_CSRF).val();
			var previousValue = feedbackPublishSelect.val();
			var feedbackParent = feedbackPublishSelect.closest('tbody');

			feedbackPublishSelect.on('change', function() {
				var currentValue = jQuery(this).val();
				var urlTextEnd = currentValue != "UNPUBLISH" ? "publish/" + currentValue : "unpublish/ALL";
				var url = feedbackForm.data("url") + urlTextEnd;
				updatePublishStatus(url, currentValue);
			});

			function updatePublishStatus(url, currentValue) {
				jQuery.ajax({
					url: url,
					type: 'POST',
					data: {
						_csrf: csrf
					},
					dataType: 'json',
					success: function(result, status) {
						if(result.status == '200') {
							if(currentValue !== 'UNPUBLISH') {
								feedbackParent.addClass('published');
							} else {
								feedbackParent.removeClass('published');
							}
							previousValue = currentValue;
						}
					},
					error: function(result, status) {
						feedbackPublishSelect.val(previousValue);
					}
				});
      }

      // internal
      feedbackForm.on('form-ajax:success', function(event, data) {
        if(data.status == 'OK') {
          feedbackRow.toggleClass('published');
          feedbackRow.toggleClass('unpublished');
        }
      });

		});
	};

};

// Make class public to outside world
module.exports = FeedbackListItem;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],83:[function(require,module,exports){


/**
 * Feedback functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
FeedbackList = require('./FeedbackList');
FeedbackListItem = require('./FeedbackListItem');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var feedbackList = new FeedbackList();
	var feedbackListItem = new FeedbackListItem();
	
	// Trigger onload activities
	feedbackList.init(initNode);
	feedbackListItem.init(initNode);

});
},{"../mediator/mediator":103,"./FeedbackList":81,"./FeedbackListItem":82}],84:[function(require,module,exports){
/**
 * FormAjaxSubmit functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');


var getFormData = function(formNode, submitData) {
  var data = formNode.serialize();
  if (submitData) {
    for (var key in submitData) {
      data += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(submitData[key]);
    }
  }
  return data;
};


// Class definition
FormAjaxSubmit = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						= '.mod-form-ajax-submit';

    var AJAX_SUCCESS					= 'form-ajax:success';
    var AJAX_FAIL						  = 'form-ajax:fail';
    var AJAX_ALWAYS						= 'form-ajax:always';

    /**
     * Initialize.
     */
    this.init = function(initNode) {

      self = this;

      // Retrieve and cache dom nodes
      var moduleNodes 					= initNode.find(SEL_MODULE);

      // Init all matching nodes
      moduleNodes.each(function() {

        var formNode = jQuery(this);

        var action = formNode.attr('action') || '';
        var method = formNode.attr('method') || 'GET';
        var dataType = formNode.attr('data-type') || 'json';

        var submitData = {};

        formNode.on('click', '[type="submit"]', function(event) {
          var button = jQuery(this);
          var name = button.attr('name') || '';
          if (name !== '') {
            submitData[name] = button.attr('value') || '';
          }
        });

        formNode.on('submit', function(event) {

          event.preventDefault();

          var data = getFormData(formNode, submitData);

          // clear submit data
          submitData = {};

          jQuery.ajax({
            url: action,
            method: method,
            data: data,
            dataType: dataType,
            xhrFields: {
              withCredentials: true
            }
          })
          .done(function(data, textStatus, jqXHR) {
            formNode.trigger(AJAX_SUCCESS, [data, textStatus, jqXHR]);
          })
          .fail(function(jqXHR, textStatus, errorThrown) {
            formNode.trigger(AJAX_FAIL, [jqXHR, textStatus, errorThrown]);
          })
          .always(function(data, textStatus, jqXHR) {
            formNode.trigger(AJAX_ALWAYS, [data, textStatus, jqXHR]);
          });

          return false;

        });

      });

    };

};

// Make class public to outside world
module.exports = FormAjaxSubmit;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],85:[function(require,module,exports){
/**
 * Customer feedback form functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
FormFeedback = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.page-customer-feedback';
    var SEL_MOD_RATING                  = '.mod-form-rating';
    var SEL_MOD_FORM                    = '#feedbackForm';

    var SEL_BTN                         = '.btn';
    var SEL_BTN_SUCCESS                 = '.btn-success';
    var SEL_BTN_DANGER                  = '.btn-danger';
    var SEL_SUBMIT_BUTTON               = '.submit';

    var SEL_FOOD_BEVERAGE_INPUT         = '#feedback-ratingFoodBeverage';
    var SEL_RATING_SERVICE_INPUT        = '#feedback-ratingService';
    var SEL_FOOD_BEVERAGE_ERROR         = '.ratingFoodBeverage-error';
    var SEL_RATING_SERVICE_ERROR        = '.ratingService-error';
    
    var SEL_VALUE_FOR_MONEY             = '.valueForMoney';
    var SEL_WOULD_RECOMMEND             = '.wouldRecommend';
    var SEL_VALUE_FOR_MONEY_INPUT       = '#valueForMoney';
    var SEL_WOULD_RECOMMEND_INPUT       = '#wouldRecommend';
    var SEL_VALUE_FOR_MONEY_ERROR       = '.valueForMoney-error';
    var SEL_WOULD_RECOMMEND_ERROR       = '.wouldRecommend-error';
    
    var CLASS_ACTIVE                    = 'active';
    var CLASS_FOCUS                     = 'focus';
    var CLASS_HOVER                     = 'hover';
    var CLASS_BTN_SUCCESS               = 'btn-success';
    var CLASS_BTN_DANGER                = 'btn-danger';
    var CSS_ERROR_CLASS                 = 'has-error';

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

        var activateOrDeactivateButton = function(btn, activate){
            btn.toggleClass(CLASS_ACTIVE, activate);
            btn.toggleClass(CLASS_FOCUS, activate);
            btn.toggleClass(CLASS_HOVER, activate);
        };
        
        var addButtonData = function(node, inputNode){
            var inputErrors = true;
            node.find(SEL_BTN).each(function(){
                var item = jQuery(this);
                if(item.hasClass(CLASS_ACTIVE)){
                    if(item.hasClass(CLASS_BTN_SUCCESS)){
                        inputNode.val(true);
                    }else{
                        inputNode.val(false);
                    }
                    inputErrors = false;
                }
            });
            return inputErrors;
        }

        var validateForm = function(moduleNode){
            var hasErrors = true;

            var valueForMoneyNode   = moduleNode.find(SEL_VALUE_FOR_MONEY);
            var wouldRecommendNode  = moduleNode.find(SEL_WOULD_RECOMMEND);
            var valueForMoneyInput  = moduleNode.find(SEL_VALUE_FOR_MONEY_INPUT);
            var wouldRecommendInput = moduleNode.find(SEL_WOULD_RECOMMEND_INPUT);

            var foodBeverageInput = moduleNode.find(SEL_FOOD_BEVERAGE_INPUT);
            var ratingServiceInput = moduleNode.find(SEL_RATING_SERVICE_INPUT);
            var valueForMoneyValue = addButtonData(valueForMoneyNode, valueForMoneyInput);
            var wouldRecommendValue = addButtonData(wouldRecommendNode, wouldRecommendInput);

            var ratingFoodBeverageError = handleInputErrors(moduleNode, foodBeverageInput.val() == 0, window.config.msg.ratingFoodBeverageError, SEL_FOOD_BEVERAGE_ERROR);
            var ratingServiceError = handleInputErrors(moduleNode, ratingServiceInput.val() == 0, window.config.msg.ratingServiceError, SEL_RATING_SERVICE_ERROR);
            var valueForMoneyError = handleInputErrors(moduleNode, valueForMoneyValue, window.config.msg.valueForMoneyError, SEL_VALUE_FOR_MONEY_ERROR);
            var wouldRecommendError = handleInputErrors(moduleNode, wouldRecommendValue, window.config.msg.wouldRecommendError, SEL_WOULD_RECOMMEND_ERROR);
            
            moduleNode.find(SEL_FOOD_BEVERAGE_ERROR).empty().append(ratingFoodBeverageError);
            moduleNode.find(SEL_RATING_SERVICE_ERROR).empty().append(ratingServiceError);
            moduleNode.find(SEL_VALUE_FOR_MONEY_ERROR).empty().append(valueForMoneyError);
            moduleNode.find(SEL_WOULD_RECOMMEND_ERROR).empty().append(wouldRecommendError);

            hasErrors = (ratingFoodBeverageError == "" && ratingServiceError == "" && valueForMoneyError == "" && wouldRecommendError == "") ? false : true;

            return hasErrors;
        };

        var handleInputErrors = function(moduleNode, input, errMsg, SEL){
            var hasInputError;
            var formSelector = moduleNode.find(SEL).closest(SEL_MOD_RATING);
            if(input){
                hasInputError = errMsg;
                formSelector.addClass(CSS_ERROR_CLASS);
            }else{
                hasInputError = "";
                formSelector.removeClass(CSS_ERROR_CLASS);
            }
            return hasInputError;
        }

        var changeButtons = function(btn, btnGroupNode){
            if(btn.hasClass(CLASS_BTN_SUCCESS)){
                activateOrDeactivateButton(btn, true);
                activateOrDeactivateButton(btnGroupNode.find(SEL_BTN_DANGER), false);
            }else if(btn.hasClass(CLASS_BTN_DANGER)){
                activateOrDeactivateButton(btn, true);
                activateOrDeactivateButton(btnGroupNode.find(SEL_BTN_SUCCESS), false);
            }
        };
		// Init all matching nodes
		moduleNodes.each(function() {
			var moduleNode 			= jQuery(this);
            var valueForMoneyNode   = moduleNode.find(SEL_VALUE_FOR_MONEY);
            var wouldRecommendNode  = moduleNode.find(SEL_WOULD_RECOMMEND);
            var formNode            = moduleNode.find(SEL_MOD_FORM);
            var submitBtnNode       = moduleNode.find(SEL_SUBMIT_BUTTON);

            valueForMoneyNode.on('click', SEL_BTN, function(){
                var btn = jQuery(this);
                changeButtons(btn, valueForMoneyNode);
            });

            wouldRecommendNode.on('click', SEL_BTN, function(){
                var btn = jQuery(this);
                changeButtons(btn, wouldRecommendNode);
            });

            formNode.on('submit', function(e){
                submitBtnNode.attr('disabled', true);
                var hasErrors = validateForm(moduleNode);

                if(hasErrors == true){
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    submitBtnNode.attr('disabled', false);
                    return false;
                }
            });
		});

	};

};

// Make class public to outside world
module.exports = FormFeedback;

},{"../mediator/mediator":103,"jquery/dist/jquery":14}],86:[function(require,module,exports){
/**
 * FormatInputFilter functionality.
 *
 * Usage
 * =====
 *
 * var input = jQuery('.my-input');
 * var filter = function(value) { return /^-?\d*$/.test(value); };
 * var inputFilter = new FormInputFilter();
 * inputFilter.init(input, filter);
 *
 * Common filters examples
 * =======================
 *
 * var positiveAndNegativeInteger = function(value) {
 *		return /^-?\d*$/.test(value);
 * };
 *
 * var positiveInteger = function(value) {
 *		return /^\d*$/.test(value);
 * };
 *
 * var positiveIntegerLessThan500 = function(value) {
 *		return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 500);
 * };
 *
 * var floatingPoint = function(value) {
 *		return /^-?\d*[.,]?\d*$/.test(value);
 * };
 *
 * var twoDecimalPlaces = function(value) {
 *		return /^-?\d*[.,]?\d{0,2}$/.test(value);
 * };
 *
 * var hexadecimal = function(value) {
 *		return /^[0-9a-f]*$/i.test(value);
 * };
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');

FormatInputFilter = function() {

	// self references
	let self;

	/**
	 * Initialize.
	 */
	this.init = function(inputNodes, filter) {

		let eventFunction = function () {
			if (filter(this.value)) {
				this.oldValue = this.value;
				this.oldSelectionStart = this.selectionStart;
				this.oldSelectionEnd = this.selectionEnd;
			} else if (this.hasOwnProperty('oldValue')) {
				this.value = this.oldValue;
				this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
			}
		};

		this.setEvent(inputNodes, eventFunction);
	};

	this.setEvent = function(inputNodes, eventFunction) {
		self = this;

		inputNodes.each(function() {
			jQuery(this).on('input keydown keyup mousedown mouseup select contextmenu drop', eventFunction);
		});
	}

	/**
	 * Clear previously remembered values.
	 */
	this.clearPreviousValues = function(inputNodes) {

		inputNodes.each(function() {
			this.oldValue = '';
			this.oldSelectionStart = null;
			this.oldSelectionEnd = null;
		});
	};
};

// Make class public to outside world
module.exports = FormatInputFilter;
},{"jquery/dist/jquery":14}],87:[function(require,module,exports){
// External libs
jQuery = require('jquery/dist/jquery');
FormInputFilter = require('../form/FormInputFilter');


FormatInputNumericFilter = function(inputFilter) {

    /**
     * Initialize.
     */
    this.init = function(inputNodes, numericFilter) {

        let eventFunction = function() {
            if (numericFilter(this.value)) {
                this.oldValue = this.value;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
            }
        }
        inputFilter.setEvent(inputNodes, eventFunction);
    };
};

// Make class public to outside world
module.exports = FormatInputNumericFilter;
},{"../form/FormInputFilter":86,"jquery/dist/jquery":14}],88:[function(require,module,exports){
/**
 * FormRating functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
FormRating = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						= '.mod-form-rating';
    var SEL_RATING_BOX					= '.mod-feedback-rating';
    var SEL_RATING_ITEM					= '.star';
    var SEL_RATING_INPUT				= 'input';
    var CLASS_ACTIVE					= 'active';
    var ATTRIBUTE_NO					= 'data-no';
	
	
	
	/**
	 * Sets a display value.
	 * 
	 */
	var setDisplayValue = function(value, ratingItemNodes) {
		ratingItemNodes.removeClass(CLASS_ACTIVE);
		for (var i = 1; i <= value; i++) {
			ratingItemNodes.filter("[" + ATTRIBUTE_NO + "='" + i + "']").addClass(CLASS_ACTIVE);
		}
	}
	
	
	
	/**
	 * Sets a value to both display AND hidden input.
	 * 
	 */
	var setValue = function(value, inputNode, ratingItemNodes) {
		setDisplayValue(value, ratingItemNodes);
		inputNode.val(value);
	}
	
	
	
	/**
	 * Sync value from hidden input to display.
	 * 
	 */
	var syncValue = function(inputNode, ratingItemNodes) {
		setDisplayValue(inputNode.val(), ratingItemNodes);
	}

	
	
    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode 			= jQuery(this);
			var ratingBoxNode 		= moduleNode.find(SEL_RATING_BOX);
			var ratingItemNodes 	= moduleNode.find(SEL_RATING_ITEM);
			var inputNode 			= moduleNode.find(SEL_RATING_INPUT);
			
			// Create data attributes on all rating items
			var ratingNo = 1;
			ratingItemNodes.each(function() {
				jQuery(this).attr(ATTRIBUTE_NO, ratingNo);
				ratingNo++;
			});
			
			// Init display
			syncValue(inputNode, ratingItemNodes);
			
			// Handle clicks
			ratingItemNodes.bind('click', function() {
				var currentValue = jQuery(this).attr(ATTRIBUTE_NO);
				setValue(currentValue, inputNode, ratingItemNodes);
			});
			
			// Handle mouseovers
			ratingItemNodes.bind('mouseover', function() {
				var currentValue = jQuery(this).attr(ATTRIBUTE_NO);
				setDisplayValue(currentValue, ratingItemNodes);
			});
			
			// Handle mouseouts
			ratingItemNodes.bind('mouseout', function() {
				syncValue(inputNode, ratingItemNodes);
			});
			
		});

    };

};

// Make class public to outside world
module.exports = FormRating;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],89:[function(require,module,exports){
/**
 * FormSwitch functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

FormInputFilter = require('../form/FormInputFilter');


// Class definition
FormSwitch = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-form-switch';
	var SEL_LABEL						= 'label';
	var SEL_INPUT						= '.switch-input';
	var SEL_LEVER						= '.lever';

	var CSS_CLASS_TABBED				= 'tabbed';

	var cleanupOtherElements = function(label, input, lever) {
		var inputElement = input.get(0);
		var leverElement = lever.get(0);

		var otherItems = label.children().filter(function() {
			return this !== inputElement && this !== leverElement;
		});

		// remove and readd at the end of the label
		otherItems.remove().appendTo(label);
	};

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode			= jQuery(this);

			var label			= moduleNode.find(SEL_LABEL);
			var input			= moduleNode.find(SEL_INPUT);
			var lever			= moduleNode.find(SEL_LEVER);

			cleanupOtherElements(label, input, lever);

			input.on('focus', function() {
				input.addClass(CSS_CLASS_TABBED);
			}).on('blur', function() {
				input.removeClass(CSS_CLASS_TABBED);
			}).on('change', function() {
				if (!input.is(':focus')) {
					input.removeClass(CSS_CLASS_TABBED);
				}
			});

		});

	};

};

// Make class public to outside world
module.exports = FormSwitch;

},{"../form/FormInputFilter":86,"../mediator/mediator":103,"jquery/dist/jquery":14}],90:[function(require,module,exports){
/**
 * FormTimepicker functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

FormInputFilter = require('../form/FormInputFilter');


// Class definition
FormTimepicker = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-form-timepicker:not(.do-not-initialize)';
	var SEL_INPUT_HOURS					= 'input[type="text"][data-field="hours"]';
	var SEL_INPUT_MINUTES				= 'input[type="text"][data-field="mins"]';
	var SEL_INPUT_HIDDEN_HOURS			= '.hidden-value-hours';
	var SEL_INPUT_HIDDEN_MINUTES		= '.hidden-value-minutes';
	var SEL_MERIDIEM_TOGGLE				= '.meridiem-toggle';

	// attribute / data attirbute contstants
	var DATA_ATTRIBUTE_24HOURS			= '24hours';
	var DATA_ATTRIBUTE_MERIDIEM			= 'meridiem';
	var ATTR_NAME						= 'name';

	// time helper constants
	var MAX_CHAR_LENGTH					= 2;
	var HOUR_CUTOFF_12HOURS				= 12;
	var MERIDIEM_AM						= 'am';
	var MERIDIEM_PM						= 'pm';

	// regular expressions
	var RGX_FORMAT_24HRS 				= /^(\d|[0-1]\d|2[0-4])$/;
	var RGX_FORMAT_12HRS 				= /^(\d|0\d|1[0-2])$/;
	var RGX_FORMAT_MINS 				= /^(\d|[0-5]\d)$/;

	var CSS_HAS_ERROR					= 'has-error';
	var CSS_TOGGLE_ON					= 'toggle-active';

	// key code constants
	var KEY_A = 'A'.charCodeAt(0);
	var KEY_P = 'P'.charCodeAt(0);
	var KEY_0 = '0'.charCodeAt(0);
	var KEY_9 = '9'.charCodeAt(0);

	/**
	 * Converts the input time (hours/mins) to values (values are always 24 hours, expected by Backend).
	 * @param {String} 	hours		The input hours
	 * @param {String} 	mins		The input minutes
	 * @param {Boolean} is24Hours	Is the timepicker using 24-hour mode or 12-hour mode?
	 * @param {String} 	meridiem	If using 12-hour mode, then the meridiem (am/pm)
	 * @returns {Object} A literal object with "hours" and "mins" properties
	 */
	var convertInputToValues = function(hours, mins, is24Hours, meridiem) {

		// cleanup
		hours = hours.trim();
		mins = mins.trim();

		// do we need to convert the 12-hour time to 24-hour time?
		if (!is24Hours && hours !== '') {

			var morning = meridiem === MERIDIEM_AM;
			hours = parseInt(hours);

			// is midnight?
			if (hours == HOUR_CUTOFF_12HOURS && morning) {
				hours = 0;
			}
			// is in the afternoon and not midday?
			else if (hours != HOUR_CUTOFF_12HOURS && !morning) {
				hours = hours + HOUR_CUTOFF_12HOURS;
			}

		}

		return {
			hours: hours,
			mins: mins
		};

	};

	/**
	 * Converts the initial time (hours/mins) to input (initial time is always 24 hours, provided by Backend).
	 * @param {String} 	hours		The initial hours provided by backend
	 * @param {String} 	mins		The initial minutes provided by backend
	 * @param {Boolean}	is24Hours	Is the timepicker using 24-hour mode or 12-hour mode?
	 * @returns {Object} A literal object with "hours", "mins" and "meridiem" properties. If the timepicker is using 24-hour mode, the "meridiem" property will be "null"
	 */
	var convertValuesToInput = function(hours, mins, is24Hours) {

		// cleanup
		hours = hours.trim();
		mins = mins.trim();

		var meridiem = null;

		// do we need to convert the 24-hour time to 12-hour time?
		if (!is24Hours && hours !== '') {

			var morning = hours < HOUR_CUTOFF_12HOURS;
			meridiem = morning ? MERIDIEM_AM : MERIDIEM_PM;
			hours = parseInt(hours);

			// is midnight?
			if (morning && hours == 0) {
				hours = HOUR_CUTOFF_12HOURS;
			}
			// is afternoon and not midday?
			else if (hours != HOUR_CUTOFF_12HOURS && !morning) {
				hours = hours - HOUR_CUTOFF_12HOURS;
			}

		}

		return {
			hours: formatPadZero(hours),
			mins: formatPadZero(mins),
			meridiem: meridiem
		};

	};

	/**
	 * Toggles the meridiem between "am" and "pm"
	 * @param {String} meridiem
	 */
	var toggleMeridiem = function(meridiem) {
		return meridiem === MERIDIEM_AM ? MERIDIEM_PM : MERIDIEM_AM;
	};

	/**
	 * If the number is an integer less than 10, a zero will be padded.
	 * @param {*} num And integer value
	 * @returns {String} Empty string, if input is not and integer. If input is a number, a string of numeric value will be returned.
	 */
	var formatPadZero = function(num) {
		if (num !== '') {
			num = parseInt(num);
			return (num < 10) ? '0' + num : '' + num;
		}
		return '';
	}

	/**
	 * Checks if the given keyCode is a numeric key between 0 and 9.
	 * @param {*} keyCode
	 */
	var isNumericKey = function(keyCode) {
		return keyCode >= KEY_0 && keyCode <= KEY_9;
	};

	/**
	 * Gets the current meridiem from a given timepicker
	 * @param {*} timepicker
	 */
	var getCurrentMeridiem = function(timepicker) {
		return timepicker.data(DATA_ATTRIBUTE_MERIDIEM);
	};

	/**
	 * Checks if the timepicker is using 24 hour mode
	 * @param {*} timepicker
	 */
	var isUsing24hours = function(timepicker) {
		return !!timepicker.data(DATA_ATTRIBUTE_24HOURS);
	};

	var updateTimepickerMeridiem = function(timepicker, meridiemToggle, meridiem) {
		if (meridiem) {
			timepicker.data(DATA_ATTRIBUTE_MERIDIEM, meridiem);
			if (meridiem === MERIDIEM_AM) {
				meridiemToggle.removeClass(CSS_TOGGLE_ON);
			} else {
				meridiemToggle.addClass(CSS_TOGGLE_ON);
			}
		}
	};

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var timepicker			= jQuery(this);

			var hoursValue			= timepicker.find(SEL_INPUT_HIDDEN_HOURS);
			var minutesValue		= timepicker.find(SEL_INPUT_HIDDEN_MINUTES);

			var hoursInput			= timepicker.find(SEL_INPUT_HOURS);
			var minutesInput		= timepicker.find(SEL_INPUT_MINUTES);

			var meridiemToggle		= timepicker.find(SEL_MERIDIEM_TOGGLE);

			var is24Hours = isUsing24hours(timepicker);
			var rgxHours = is24Hours ? RGX_FORMAT_24HRS : RGX_FORMAT_12HRS;

			// helper functions
			var updateMerediem = function(meridiem) {
				updateTimepickerMeridiem(timepicker, meridiemToggle, meridiem);
			};
			var updateValues = function() {
				var meridiem = getCurrentMeridiem(timepicker);
				var values = convertInputToValues(hoursInput.val(), minutesInput.val(), is24Hours, meridiem);
				hoursValue.val(values.hours);
				minutesValue.val(values.mins);
				clearError();
			};
			var focusOnMinsInput = function() {
				if (hoursInput.val().length === MAX_CHAR_LENGTH) {
					minutesInput.select();
					minutesInput.focus();
				}
			};
			var focusOnMeridiemToggle = function() {
				if (!is24Hours && minutesInput.val().length === MAX_CHAR_LENGTH) {
					meridiemToggle.focus();
				}
			};

			var clearError = function() {
				timepicker.removeClass(CSS_HAS_ERROR);
			};

			// set initial value
			var intialValues = convertValuesToInput(hoursValue.val(), minutesValue.val(), is24Hours);
			hoursInput.val(intialValues.hours);
			minutesInput.val(intialValues.mins);
			updateMerediem(intialValues.meridiem || getCurrentMeridiem(timepicker) || MERIDIEM_AM);

			// add filters for input fields
			var inputFilter = new FormInputFilter();
			inputFilter.init(hoursInput, function(v) {
				return v === '' || rgxHours.test(v);
			});
			inputFilter.init(minutesInput, function(v) {
				return v === '' || RGX_FORMAT_MINS.test(v);
			});

			// meridiem button event handlers
			meridiemToggle.on('click', function() {

				var meridiem = getCurrentMeridiem(timepicker);
				updateMerediem(toggleMeridiem(meridiem));
				updateValues();

			}).on('keyup', function(e) {

				if (e.which === KEY_A) {
					e.preventDefault();
					updateMerediem(MERIDIEM_AM);
					updateValues();
				} else if (e.which === KEY_P) {
					e.preventDefault();
					updateMerediem(MERIDIEM_PM);
					updateValues();
				}

			});

			// input/value updates
			jQuery.each([hoursInput, minutesInput], function() {
				jQuery(this).on('change keyup', function() {
					updateValues();
				});
			});

			// automatically go to next input
			hoursInput.on('change', function() {
				focusOnMinsInput();
			});
			hoursInput.on('keyup', function(e) {
				if (isNumericKey(e.which)) {
					focusOnMinsInput();
				}
			});
			minutesInput.on('change', function() {
				focusOnMeridiemToggle();
			});
			minutesInput.on('keyup', function(e) {
				if (isNumericKey(e.which)) {
					focusOnMeridiemToggle();
				}
			});

		});

	};

	this.clear = function(initNode) {

		var moduleNodes				= initNode.find(SEL_MODULE);

		moduleNodes.each(function() {

			var timepicker			= jQuery(this);

			var hoursValue			= timepicker.find(SEL_INPUT_HIDDEN_HOURS);
			var minutesValue		= timepicker.find(SEL_INPUT_HIDDEN_MINUTES);

			var hoursInput			= timepicker.find(SEL_INPUT_HOURS);
			var minutesInput		= timepicker.find(SEL_INPUT_MINUTES);

			var meridiemToggle		= timepicker.find(SEL_MERIDIEM_TOGGLE);

			timepicker.removeClass(CSS_HAS_ERROR);

			hoursValue.val('');
			minutesValue.val('');
			hoursInput.val('');
			minutesInput.val('');

			updateTimepickerMeridiem(timepicker, meridiemToggle, MERIDIEM_AM);

		});

	};

	this.setPaths = function(initNode, hours, mins) {

		var moduleNodes 			= initNode.find(SEL_MODULE);

		moduleNodes.each(function() {

			var timepicker			= jQuery(this);

			var hoursValue			= timepicker.find(SEL_INPUT_HIDDEN_HOURS);
			var minutesValue		= timepicker.find(SEL_INPUT_HIDDEN_MINUTES);

			hoursValue.attr(ATTR_NAME, hours);
			minutesValue.attr(ATTR_NAME, mins);

		});

	};

	this.setValue = function(initNode, hoursIn24h, mins) {

		// convert to strings
		hoursIn24h = '' + hoursIn24h;
		mins = '' + mins;

		var moduleNodes 			= initNode.find(SEL_MODULE);

		moduleNodes.each(function() {

			var timepicker			= jQuery(this);

			var hoursValue			= timepicker.find(SEL_INPUT_HIDDEN_HOURS);
			var minutesValue		= timepicker.find(SEL_INPUT_HIDDEN_MINUTES);

			var hoursInput			= timepicker.find(SEL_INPUT_HOURS);
			var minutesInput		= timepicker.find(SEL_INPUT_MINUTES);

			var meridiemToggle		= timepicker.find(SEL_MERIDIEM_TOGGLE);

			var is24Hours = isUsing24hours(timepicker);

			hoursValue.val(hoursIn24h);
			minutesValue.val(mins);

			var intialValues = convertValuesToInput(hoursIn24h, mins, is24Hours);
			hoursInput.val(intialValues.hours);
			minutesInput.val(intialValues.mins);
			updateTimepickerMeridiem(timepicker, meridiemToggle, intialValues.meridiem);

		});

	};

	/**
	 * Returns the selected time as an { hours, mins } object.
	 * If there are multiple timepicker modules in the initNode, the values for only the first is returned.
	 */
	this.getValue = function(initNode) {

		var moduleNodes 			= initNode.find(SEL_MODULE);

		// since we have to return a value, only return the first
		var first = moduleNodes.first();

		// default value
		var result = {
			hours: '',
			mins: '',
		};

		// using 'each' takes care of null checking
		first.each(function() {

			var timepicker			= jQuery(this);

			var hoursValue			= timepicker.find(SEL_INPUT_HIDDEN_HOURS);
			var minutesValue		= timepicker.find(SEL_INPUT_HIDDEN_MINUTES);

			var hours = hoursValue.val() ? parseInt(hoursValue.val()) : '';
			var minutes = minutesValue.val() ? parseInt(minutesValue.val()) : '';

			result = {
				hours: String(hours),
				mins: String(minutes)
			};

		});

		return result;

	};

	this.validateAndGetEmptyTimepickers = function(initNode, filter) {

		var moduleNodes 			= initNode.find(SEL_MODULE);

		if (filter) {
			moduleNodes = moduleNodes.filter(filter);
		}

		var results = [];

		moduleNodes.each(function() {
			var timepicker			= jQuery(this);
			var hoursValue			= timepicker.find(SEL_INPUT_HIDDEN_HOURS).val() || '';
			var minutesValue		= timepicker.find(SEL_INPUT_HIDDEN_MINUTES).val() || '';
			if (hoursValue.trim() === '' || minutesValue.trim() === '') {
				timepicker.addClass(CSS_HAS_ERROR);
				results.push(timepicker);
			}
		});

		return results;

	};

};

// Make class public to outside world
module.exports = FormTimepicker;

},{"../form/FormInputFilter":86,"../mediator/mediator":103,"jquery/dist/jquery":14}],91:[function(require,module,exports){
/**
 * FormUrl functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
FormUrl = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-form-url';
	var SEL_INPUT						= '.form-control';
	var SEL_INPUT_HIDDEN				= 'input[type="hidden"]';
	
	var RGX_SCHEME_SEPARATOR			= /:\/\//;
	var URL_SCHEME_SEPARATOR			= '://';
	var DEFAULT_URL_SCHEME				= 'http';
	

	
	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode 			= jQuery(this);
			var formInput 			= moduleNode.find(SEL_INPUT);
			var hiddenInput			= moduleNode.find(SEL_INPUT_HIDDEN);

			// initial value
			formInput.val(hiddenInput.val());

			formInput.on('change', function() {
				var rawInput = formInput.val();
				hiddenInput.val(self.addSchemeIfNotExists(rawInput));
			});

		});

	};

	this.addSchemeIfNotExists = function(input) {
		
		input = (input || '').trim();

		var parts = input.split(RGX_SCHEME_SEPARATOR);

		// no scheme set?
		if (parts.length == 1) {
			// add the default scheme
			parts.unshift(DEFAULT_URL_SCHEME);
		}
		
		return parts.join(URL_SCHEME_SEPARATOR);

	};

};

// Make class public to outside world
module.exports = FormUrl;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],92:[function(require,module,exports){
/**
 * SwitchableInputs functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
SwitchableInputs = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE              = '.switchable-inputs-group';
  var SEL_INPUT_SELECTOR      = '.switchable-inputs-selector';
  var SEL_INPUT_TARGET        = '.switchable-inputs-target';
  var SEL_HELP_BLOCK          = '.help-block';
  var SEL_FORM_GROUP          = '.form-group';
  var SEL_GLOBAL_MESSAGES     = '.mod-global-messages';

  var DATA_ATTR_TARGET        = 'switchableTarget';

  var CSS_CLASS_HIDDEN        = 'hidden';
  var CSS_HAS_ERROR					  = 'has-error';


  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes           = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode        = jQuery(this);

      var selector          = moduleNode.find(SEL_INPUT_SELECTOR);

      selector.on('change', function(e, initial) {
        
        // Restore all errors and hide notifications
        if(initial != "initial"){
          jQuery(SEL_GLOBAL_MESSAGES).hide();
          moduleNode.find(SEL_HELP_BLOCK).text("").hide();
          moduleNode.find(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
        }
        
        var currentValue = jQuery(this).val();
        var targets = moduleNode.find(SEL_INPUT_TARGET);

        // hide all
        targets.hide();

        //adding delay so below filter is not skipped
          setTimeout(function(){
            // unhide the matching target
            targets.filter(function() {
              return jQuery(this).data(DATA_ATTR_TARGET) === currentValue;
            }).show()  
          }, 200);

        e.preventDefault();
      });

      // trigger the first time
      selector.trigger("change", ["initial"]);

    });

  };

};

// Make class public to outside world
module.exports = SwitchableInputs;

},{"../mediator/mediator":103,"jquery/dist/jquery":14}],93:[function(require,module,exports){
/**
 * Form functionalities.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
FormRating = require('./FormRating');
FormUrl = require('./FormUrl');
FormTimepicker = require('./FormTimepicker');
FormSwitch = require('./FormSwitch');
FormAjaxSubmit = require('./FormAjaxSubmit');
FormFeedback = require('./FormFeedback');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var formRating = new FormRating();
	var formUrl = new FormUrl();
	var formTimepicker = new FormTimepicker();
	var formSwitch = new FormSwitch();
	var formAjaxSubmit = new FormAjaxSubmit();
	var formFeedback = new FormFeedback();

	// Trigger onload activities
	formRating.init(initNode);
	formUrl.init(initNode);
	formTimepicker.init(initNode);
	formSwitch.init(initNode);
	formAjaxSubmit.init(initNode);
	formFeedback.init(initNode);

});
},{"../mediator/mediator":103,"./FormAjaxSubmit":84,"./FormFeedback":85,"./FormRating":88,"./FormSwitch":89,"./FormTimepicker":90,"./FormUrl":91}],94:[function(require,module,exports){
/**
 * GuideListItem functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
GuideListItem = function() {
    // self references
    var self;

	// selector constants
	var SEL_MODULE							= '.mod-guide-list-item';
	var SEL_MODULE_PARENT					= '.mod-guide-list';
    var SEL_GUIDE_ITEM_CHECKBOX				= 'input[type="checkbox"]';
    var SEL_GUIDE_ITEM_CSRF					= 'input[name="_csrf"]';


    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {
			var nodeThis=jQuery(this);	
			var guideCheckbox = nodeThis.find(SEL_GUIDE_ITEM_CHECKBOX);
			var csrf = nodeThis.find(SEL_GUIDE_ITEM_CSRF).val();
			var guideListParent = nodeThis.closest(SEL_MODULE_PARENT);
			
		
			guideCheckbox.on('change', function() {
				
				var checkBox=jQuery(this);				
				var isChecked = checkBox.is(':checked');
				var settingType = checkBox.data("setting-type");
			    var url = "/guidedFlow/action/" + settingType + "/" + isChecked.toString();
			    bannerBox = checkBox.closest(SEL_MODULE);
			    
			    jQuery.ajax({
					  url: url,
					  type: "POST",
					  data: {
							_csrf: csrf
						  },
					  dataType: "json",
					  success: function(data, status){					        
							updateBannerColor(bannerBox, data.currentStatus);
							if (data.totalGuideCount == 0) {
								guideListParent.animate({
									height: "toggle",
									opacity: "toggle"
								  }, "slow");
							}
					    },
					  error: function() {
						  //console.log("ajax error");
					  }
				});
			    
			    function updateBannerColor(banner, state){
				      
				    if(state=="CONFIRMED"){
				    	banner.removeClass("alert-info");
				    	banner.addClass("alert-success");			    	
				    } else {
				    	banner.removeClass("alert-success");
				    	banner.addClass("alert-info");
				    }				    
			    }
			    
			});//guideCheckbox
			
		});
	};
};

// Make class public to outside world
module.exports = GuideListItem;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],95:[function(require,module,exports){


/**
 * Guide functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
GuideListItem = require('./GuideListItem');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var guideListItem = new GuideListItem();
	
	// Trigger onload activities
	guideListItem.init(initNode);

});
},{"../mediator/mediator":103,"./GuideListItem":94}],96:[function(require,module,exports){
/**
 * AbstractForm functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

var ClassUtils = require('../utils/ClassUtils');

// selector constants

var SEL_FORM_GROUP                      = '.form-group';

var SEL_FORM_BTN_CANCEL                 = '.itemEditor-editForm-action-cancel';
var SEL_FORM_BTN_SAVE                   = '.itemEditor-editForm-action-save';
var SEL_FORM_BTN_CREATE                 = '.itemEditor-editForm-action-create';

var DATA_ATTR_CURRENT_ROW               = 'currentRow';
var DATA_ATTR_FORM_VALIDATION_ERROR     = 'errorMessageValidation';

var CSS_IS_EDITING                      = 'is-editing';
var CSS_HAS_ERROR                       = 'has-error';

var EVENT_ON_CREATE_CLICKED             = 'itemEditor:editForm:create';
var EVENT_ON_CANCEL_CLICKED             = 'itemEditor:editForm:cancel';
var EVENT_ON_SAVE_CLICKED               = 'itemEditor:editForm:save';

// Class definition
var AbstractForm = function(formNode) {

  var self = this;

  /**
   * @abstract
   * Creates an object (key/value pairs) from the form values
   *
   * @returns {object} form values
   */
  this.getDataObjectFromValues = function() {
    ClassUtils.throwUnimplementedError('getDataObjectFromValues');
  };

  /**
   * @abstract
   * Populate the form using a row
   * @param {element} row Row element from the list of items
   * @param {Function} dataObjectExtractor A function that takes a row element and returns the data object
   *                    e.g. function(row) {
   *                            return {
   *                              "id": row.find("#input-id").val(),
   *                              "name": row.find("#input-name").val()
   *                            };
   *                          }
   */
  this.setValues = function(row, dataObjectExtractor) {
    ClassUtils.throwUnimplementedError('setValues');
  };

  /**
   * @abstract
   * Clears the form
   */
  this.clear = function() {
    ClassUtils.throwUnimplementedError('clear');
  };

  /**
   * @abstract
   * Validates the form and returns true/false on the form validity
   *
   * @returns true if there are no validation errors, otherwise false
   */
  this.validate = function() {
    ClassUtils.throwUnimplementedError('validate');
  };

  /**
   * @abstract
   * Focus on the first input field in the form
   */
  this.focusOnFirstInput = function() {
    ClassUtils.throwUnimplementedError('focusOnFirstInput');
  };

  /**
   * Iniitialise form
   */
  this.init = function() {

    formNode.on('click', SEL_FORM_BTN_CREATE, function() {
      formNode.trigger(EVENT_ON_CREATE_CLICKED);
    });

    formNode.on('click', SEL_FORM_BTN_CANCEL, function() {
      formNode.trigger(EVENT_ON_CANCEL_CLICKED);
    });

    formNode.on('click', SEL_FORM_BTN_SAVE, function() {
      formNode.trigger(EVENT_ON_SAVE_CLICKED);
    });

  };

  this.rememberCurrentRow = function(row) {
    formNode.data(DATA_ATTR_CURRENT_ROW, row);
  }

  this.forgetCurrentRow = function() {
    this.rememberCurrentRow(null);
  }

  this.getValidationErrorMessage = function() {
    return formNode.data(DATA_ATTR_FORM_VALIDATION_ERROR);
  };

  this.getNode = function() {
    return formNode;
  };

  this.markAsEditing = function() {
    formNode.addClass(CSS_IS_EDITING);
  };

  this.markAsNotEditing = function() {
    formNode.removeClass(CSS_IS_EDITING);
  };

  this.getCurrentEditingRow = function() {
    return formNode.data(DATA_ATTR_CURRENT_ROW) || null;
  };

  this.markFieldsWithErrors = function(errors) {
    (errors || []).forEach(function(input) {
      input.parents(SEL_FORM_GROUP).first().addClass(CSS_HAS_ERROR);
    });
  };

  this.clearValidationErrors = function() {
    formNode.find(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
  };

  this.validateAndProcess = function(onSucess, onFail) {
    this.clearValidationErrors();
    if (this.validate()) {
      if (onSucess) {
        onSucess();
      }
    } else {
      if (onFail) {
        var errorMessage = this.getValidationErrorMessage();
        onFail(errorMessage);
      }
    }
  };


};

// Make class public to outside world
module.exports = AbstractForm;

},{"../utils/ClassUtils":184,"jquery/dist/jquery":14}],97:[function(require,module,exports){
/**
 * AbstractHiddenData functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

var ClassUtils = require('../utils/ClassUtils');

// selector constants

var SEL_HIDDEN_FORM_DATA_PARENT_ROW   = '.itemEditor-hiddenFormData-parentRow';
var SEL_HIDDEN_FORM_DATA_ROW          = '.itemEditor-hiddenFormData-rowData';
var SEL_HIDDEN_FORM_INPUTS_WITH_PATH  = '[data-path]';

var DATA_ATTR_PARENT_ID               = 'itemEditorParentId';
var DATA_ATTR_PARENT_LABEL            = 'itemEditorParentLabel';

// Class definition
var AbstractHiddenData = function(hiddenDataNode, dataRowTemplate) {

  var self = this;

  /**
   * @abstract
   * Reset the path/name attribute of the input element
   *
   * @param {element} inputNode The input element
   * @param {integer} rowIndex The index of the parent row
   * @param {integer} dataIndex The index of the data row
   */
  this.resetInputPath = function(inputNode, rowIndex, dataIndex) {
    ClassUtils.throwUnimplementedError('resetInputPath');
  };

  /**
   * @abstract
   * Update a particular data row with the given data object
   *
   * @param {element} dataRow The data row element
   * @param {object} the data object for the data row
   */
  this.updateDataRowWithDataObject = function(dataRow, dataObject) {
    ClassUtils.throwUnimplementedError('updateDataRowWithDataObject');
  };


  /**
   * @abstract
   * Update the hidden data with a given data object,
   * this could update multiple data rows if necessary
   */
  this.updateWithRowData = function(dataObject) {
    ClassUtils.throwUnimplementedError('updateWithRowData');
  };

  /**
   * @abstract
   * Create new DataObject from a given data row
   *
   * @param {element} dataRow The data row element
   * @return {object} a new data object
   */
  this.buildDataObjectFromDataRow = function(dataRow) {
    ClassUtils.throwUnimplementedError('buildDataObjectFromDataRow');
  };

  /**
   * Iniitialise
   */
  this.init = function() {
    // nothing needs to be initialised at abstract level
  };

  this.createNewRowDataRow = function() {
    return jQuery(dataRowTemplate.html());
  };

  this.buildVirtualGroupIdFromDataRow = function(dataRow) {
    var dataObject = self.buildDataObjectFromDataRow(dataRow);
    return self.buildVirtualGroupId(dataObject);
  };

  this.buildVirtualGroupId = function(dataObject) {
    var values = [];
    for (var key in dataObject) {
      var prop = dataObject[key];
      if (jQuery.isArray(prop)) {
        var flattened = prop.map(function(item) {
          return self.buildVirtualGroupId(item);
        }).join('|');
        values.push('[' + flattened + ']');
      } else if (jQuery.isPlainObject(prop)) {
        values.push('[' + self.buildVirtualGroupId(prop) + ']');
      } else {
        values.push(prop);
      }
    }
    return values.join(':');
  };

  /**
   * @return Map with 'virtual id' as key and a list of rows as value.
   */
  this.groupDataRowsByParentSetup = function(dataRows) {
    var groupsByKey = {};
    dataRows.each(function() {
      var row = jQuery(this);
      var id = self.buildVirtualGroupIdFromDataRow(row);
      if (!(id in groupsByKey)) {
        groupsByKey[id] = [];
      }
      groupsByKey[id].push(row);
    });
    return groupsByKey;
  };

  /**
   * @returns Sorted list (sorted by weekday) of weekday Ids
   */
  this.getIdsFromParentRows = function(dataRows) {
    var parentIds = dataRows.map(function(row) {
      return jQuery(row).parents(SEL_HIDDEN_FORM_DATA_PARENT_ROW).data(DATA_ATTR_PARENT_ID);
    });
    parentIds.sort();
    return parentIds;
  };

  this.getNode = function() {
    return hiddenDataNode;
  };

  this.addNewDataRowToParentRow = function(parentRow, dataObject) {
    var newRow = self.createNewRowDataRow();
    parentRow.append(newRow);
    self.updateDataRowWithDataObject(newRow, dataObject);
  };

  this.getParentLabelsForIds = function(weekdayIds) {
    var parentsToLabels = {};
    hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_PARENT_ROW).each(function(index, parentRowNode) {
      var parentRow = jQuery(parentRowNode);
      var parentId = parentRow.data(DATA_ATTR_PARENT_ID);
      var ParentLabel = parentRow.data(DATA_ATTR_PARENT_LABEL);
      parentsToLabels[parentId] = ParentLabel;
    });
    return jQuery.map(weekdayIds, function(parentId) {
      return parentsToLabels[parentId];
    });
  };

  this.resetDataIndexes = function() {
    var parentRows = hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_PARENT_ROW);
    parentRows.each(function(parentIndex, parentRowNode) {
      var dataRows = jQuery(parentRowNode).find(SEL_HIDDEN_FORM_DATA_ROW);
      dataRows.each(function(dataRowIndex, rawNode) {
        var dataRow = jQuery(rawNode);
        dataRow.find(SEL_HIDDEN_FORM_INPUTS_WITH_PATH).each(function(index, inputNode) {
          self.resetInputPath(jQuery(inputNode), parentIndex, dataRowIndex);
        });
      });
    });
  };

  this.getAllDataRowsForDataObject = function(dataObject) {
    var virtualId = self.buildVirtualGroupId(dataObject);
    return hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ROW).filter(function(index, row) {
      return virtualId === self.buildVirtualGroupIdFromDataRow(jQuery(row));
    });
  };

  this.buildItemsListFromInitialData = function(itemsList) {
    var parents = self.groupDataRowsByParentSetup(hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_ROW));
    for (var id in parents) {
      var items = parents[id];
      var parentIds = self.getIdsFromParentRows(items);
      var firstItem = items[0]; // there should be at least one item for this item to exist
      itemsList.addRowFromDataRowAndParentIds(firstItem, parentIds, this);
    }
    itemsList.refresh();
  };

};

// Make class public to outside world
module.exports = AbstractHiddenData;

},{"../utils/ClassUtils":184,"jquery/dist/jquery":14}],98:[function(require,module,exports){
/**
 * AbstractList functionality.
*
*/


// External libs

// selector constants

var SEL_LIST_CONTAINER              = '.itemEditor-itemList-container';
var SEL_LIST_ROW                    = '.itemEditor-itemList-row';

var SEL_LIST_BTN_EDIT               = '.itemEditor-itemList-rowAction-edit';
var SEL_LIST_BTN_DELETE             = '.itemEditor-itemList-rowAction-delete';
var SEL_LIST_BTN_COPY               = '.itemEditor-itemList-rowAction-copy';

var DATA_ATTR_LIST_CONFIRM_DELETE   = 'confirmMessageDelete';
var DATA_ATTR_FORMDATA_ROWS         = 'formDataRows';

var ATTR_NAME                       = 'name';

var CSS_EMPTY_LIST                  = 'empty-list';
var CSS_IS_EDITING                  = 'is-editing';

var EVENT_ON_FORCE_REFRESH          = 'itemEditor:itemsList:forceRefresh';
var EVENT_ON_EDIT_CLICKED           = 'itemEditor:itemsList:rowEdit';
var EVENT_ON_DELETE_CLICKED         = 'itemEditor:itemsList:rowDelete';
var EVENT_ON_COPY_CLICKED           = 'itemEditor:itemsList:rowCopy';
var EVENT_ON_LIST_REFRESHED         = 'itemEditor:itemsList:listRefreshed';

// Class definition
var AbstractList = function(itemsListNode, listRowTemplate) {

  var self = this;

  /**
   * @abstract
   * Iniitialise list
   * @param {element} row The row element
   * @param {object} dataObject The data object
   */
  this.updateRow = function(row, dataObject, hiddenData, shouldNotUpdateHiddenData) {
    ClassUtils.throwUnimplementedError('updateRow');
  };

  /**
   * @abstract
   * Creates a new data object from the given row
   * @param {element} row The row element
   * @returns {object} dataObject The data object
   */
  this.buildDataObjectFromRow = function(row) {
    ClassUtils.throwUnimplementedError('buildDataObjectFromRow');
  };

  /**
   * @abstract
   * Creates the input name with proper indexes
   * @param {element} inputNode The input element
   * @returns {int} index Row index
   */
  this.generateInputName = function(inputNode, index) {
    ClassUtils.throwUnimplementedError('generateInputName');
  };

  /**
   * @abstract
   * Get a list of hidden (or not) input fields that will be POSTed to the server when saving.
   * The list should only contain the fields for a given row.
   * @param {element} row The row to find the input fields for
   * @returns {Array} index Row index
   */
  this.getRowValueItems = function(row) {
    ClassUtils.throwUnimplementedError('getRowValueItems');
  };

  /**
   * @abstract
   * Add new row from (hidden) data row
   * @param {element} dataRow The hidden data row
   * @param {object} parentIds The parent ids
   * @param {HiddenData} hiddenData The hidden data object
   */
  this.addRowFromDataRowAndParentIds = function(dataRow, parentIds, hiddenData) {
    ClassUtils.throwUnimplementedError('addRowFromDataRowAndParentIds');
  };

  /**
   * Iniitialise list
   * @param {object} hiddenData (optional)
   */
  this.init = function(hiddenData) {

    if (hiddenData) {
      hiddenData.buildItemsListFromInitialData(this);
    }

    itemsListNode.on(EVENT_ON_FORCE_REFRESH, function() {
      self.refresh();
    });

    itemsListNode.on('click', SEL_LIST_BTN_EDIT, function() {
      var row = self.getRowFromActionButton(jQuery(this));
      itemsListNode.trigger(EVENT_ON_EDIT_CLICKED, [row]);
    });

    itemsListNode.on('click', SEL_LIST_BTN_DELETE, function() {
      var row = self.getRowFromActionButton(jQuery(this));
      itemsListNode.trigger(EVENT_ON_DELETE_CLICKED, [row]);
    });

    itemsListNode.on('click', SEL_LIST_BTN_COPY, function() {
      var row = self.getRowFromActionButton(jQuery(this));
      itemsListNode.trigger(EVENT_ON_COPY_CLICKED, [row]);
    });

    this.refresh();

  };

  this.createNewRow = function() {
    var clone = jQuery(listRowTemplate.html()).find(SEL_LIST_ROW);
    return clone;
  };

  this.getRowFromActionButton = function(button) {
    return button.parents(SEL_LIST_ROW);
  };

  this.getNode = function() {
    return itemsListNode;
  };

  this.deleteRow = function(row) {
    this.deleteDataRowReferences(row);
    row.remove();
  };

  this.getDeleteConfirmMessage = function() {
    return itemsListNode.data(DATA_ATTR_LIST_CONFIRM_DELETE);
  };

  this.getAllRows = function() {
    return itemsListNode.find(SEL_LIST_ROW);
  };

  this.refresh = function(eventData) {
    this.markAllRowsAsNotEditing();
    this.resetItemIndexes();
    // has items?
    if (this.getAllRows().length > 0) {
      itemsListNode.removeClass(CSS_EMPTY_LIST);
    } else {
      itemsListNode.addClass(CSS_EMPTY_LIST);
    }
    itemsListNode.trigger(EVENT_ON_LIST_REFRESHED, [this, eventData]);
  };

  this.markRowAsEditing = function(row) {
    row.addClass(CSS_IS_EDITING);
  };

  this.markAllRowsAsNotEditing = function() {
    itemsListNode.find(SEL_LIST_ROW).removeClass(CSS_IS_EDITING);
  };

  this.editRow = function(row, form) {
    this.markRowAsEditing(row);
    var dataExtractor = this.buildDataObjectFromRow; // should be a function
    form.setValues(row, dataExtractor);
    form.focusOnFirstInput();
  };

  this.addRow = function(dataObject, hiddenData) {
    var newRow = this.createNewRow();
    this.updateRow(newRow, dataObject, hiddenData);
    var container = itemsListNode.filter(SEL_LIST_CONTAINER);
    if (!container || !container.length) {
      container = itemsListNode.find(SEL_LIST_CONTAINER);
    }
    newRow.appendTo(container);
    return newRow;
  };

  this.resetItemIndexes = function() {
    var rows = itemsListNode.find(SEL_LIST_ROW);
    rows.each(function(index, rowNode) {
      var valueItems = self.getRowValueItems(jQuery(rowNode));
      jQuery.each(valueItems, function(i, valueItemNode) {
        var inputNode = jQuery(valueItemNode);
        var name = self.generateInputName(inputNode, index);
        inputNode.attr(ATTR_NAME, name);
      });
    });
  };

  this.saveDataRowReferences = function(row, dataRows) {
    row.data(DATA_ATTR_FORMDATA_ROWS, dataRows);
  };

  this.deleteDataRowReferences = function(row) {
    var oldRowItems = row.data(DATA_ATTR_FORMDATA_ROWS);
    jQuery.each(oldRowItems || [], function(index, item) {
      jQuery(item).remove();
    });
  };

};


// Make class public to outside world
module.exports = AbstractList;

},{}],99:[function(require,module,exports){
/**
 * ScrollHelper functionality.
*
*/

jQuery = require('jquery/dist/jquery');

var UserInterfaceUtils = require('../utils/UserInterfaceUtils');


var SEL_NAVBAR                      = '.navbar';

// Class definition
var ScrollHelper = function() {

  var self = this;

  /**
   * Scrolls to given element, but only when the screen size is 'xs'.
   * It also takes into consideration, the height of the main navbar.
   */
  this.scrollToElement = function(element) {
    if (UserInterfaceUtils.isScreenSize('xs')) {
      var offsetTop = jQuery(SEL_NAVBAR).outerHeight();
      UserInterfaceUtils.scrollToElement(element, offsetTop);
    }
  };

}

// singleton pattern
var singleton = new ScrollHelper();

// Make class public to outside world
module.exports = singleton;

},{"../utils/UserInterfaceUtils":189,"jquery/dist/jquery":14}],100:[function(require,module,exports){
/**
 * FormData functionality.
**/

// External libs
var jQuery			= require('jquery');

// Class definition
var FormObject = function(weekday, startHour, startMin, endHour, endMin, startDate, endDate, capacity, reservableGroups) {
	this.weekday = weekday;
	this.startHour = startHour;
	this.startMin = startMin;
	this.endHour = endHour;
  	this.endMin = endMin;
	this.startDate = startDate;
	this.endDate = endDate;
	this.capacity = capacity;
	this.reservableGroups = reservableGroups;
};

// Make class public to outside world
module.exports = FormObject;
},{"jquery":14}],101:[function(require,module,exports){
/**
 * ReservationLimit functionality.
*
*/

// External libs
var jQuery 			= require('jquery');
var moment 			= require('moment');
var FormTimepicker 	= require('../form/FormTimepicker');
var FormObject  	= require('./FormObject');
var Confirm			= require('../modals/Confirm');
Notification = require('../notification/Notification');

// Class definition
ReservationLimit = function () {

    // selector constants
    var SEL_MODULE                          	= '.mod-reservation-limit';
	var SEL_FORM								= 'form';
    var SEL_DATE_RANGE_CONTAINER				= '.date-range-holder';
    var SEL_DATE_RANGE_INPUT					= '.daterange-input';
	var SEL_DATEPICKER_INPUT_GROUP_ADDON 		= '.input-group-addon';
	var SEL_MAIN_CONTENT 						= '#main-content';
	var SEL_DATERANGEPICKER 					= '.daterangepicker';

	var SEL_RESERVATION_LIMIT_CARD 				= ".mod-reservation-select-limit-card";
	var SEL_RESERVATION_ADD_LIMIT_CARD			= ".mod-reservation-add-limit-card";
	var SEL_ADD_NEW_LIMIT_BTN 					= ".btn-add-new-limit";
	var SEL_CANCEL_LIMIT_BTN 					= ".btn-limit-cancel";
	var SEL_NEXT_LIMIT_BTN 						= ".btn-limit-next";
	var SEL_PREVIOUS_LIMIT_BTN 					= ".btn-limit-previous";
	var SEL_CREATE_LIMIT_BTN 					= '.btn-limit-add';

	var SEL_LIMIT_TYPE_ACTIVITY_SELECTOR 		= ".limit-reservation-opitons :input";
	var SEL_AREAS_ACTIVITY_SELECTOR 			= ".select-areas-block :input";
	var SEL_AREAS_BLOCK 						= ".display-areas";

	var SEL_CAPACITY_CUSTOM_TIME_INPUTS			= '.capacity-custom-time input[type=text]';
	var SEL_DATE_TIME_ACTIVITY_SELECTOR 		= ".limit-date-time :input";
	var SEL_HOW_TO_APPLY_LIMIT_BLOCK 			= ".how-to-apply-limit-step";
	var SEL_WHEN_TO_APPLY_LIMIT_BLOCK			= ".when-to-apply-limit-step";
	var SEL_LIMIT_CUSTOM_TIME_SECTION 			= ".limit-custom-time";
	var SEL_DO_NOT_ACCEPT_RESERVATION_SECTION 	= ".do-not-accept-reservation-section";
	var SEL_CHANGE_RESERVATION_CAPACITY_SECTION = ".change-capacity-reservation-section";
	var SEL_SPECIFIC_RECURRING_DAY_SELECTOR 	= ".select-limit-day-time :input";
	var SEL_WEEKDAY_BLOCK 						= ".weekdays-holder";
	var SEL_FORM_GROUP_WRAPPER 					= ".form-group-field-times";
	var SEL_STARTING_TIME_FORM_GROUP 			= '.form-group-field-times .startingTime';
	var SEL_ENDING_TIME_FORM_GROUP 			 	= '.form-group-field-times .endingTime';
	var SEL_FORM_INPUT_START_TIME    			= '.startingTime';
	var SEL_FORM_INPUT_END_TIME      			= '.endingTime';

	var SEL_FORM_START_HOUR_INPUT 				= '.input-group input[type=text]:first-child';
	var SEL_FORM_START_MINUTE_INPUT 			= '.input-group input[type=text]:last-child';

	
	var SEL_NOT_ACCEPT_RESERVATION_OPTION_ID 	= '#notAcceptReservation';
	var SEL_LIMIT_CHANGE_CAPACITY_INPUT 		= "#requestedCapacity";
	var SEL_ALL_AREAS_OPTION_ID 				= '#allAreas';
	var SEL_SPECIFIC_AREAS_OPTION_ID 			= '#specificAreas';
	var SEL_ENTIRE_DAY_AREAS_OPTION_ID			= '#areaEntireDay';
	var SEL_ENTIRE_DAY_CAPACITY_OPTION_ID 		= '#capacityEntireDay';
	var SEL_WEEKDAY_OPTION 						= '.weekday-option-holder .weekday-option';
	var SEL_WEEKDAY_OPTION_CHECKBOX_CHECKED 	= '.weekday-option-holder .weekday-option input[type=checkbox]:checked';
	var SEL_DISPLAY_AREAS_CHECKBOX_INPUT 		= '.display-areas input[type=checkbox]';
	var SEL_DISPLAY_AREA_CHECKBOX_CHECKED 		= '.display-areas input[type=checkbox]:checked';

	var SEL_CHECKBOX_INPUT						= 'input[type=checkbox]';
	var SEL_LIMIT_DATA_CONTAINER 				= '.limit-data-container';
	var SEL_SPECIFIC_DATE_RADIO_INPUT			= '#specificDay';
	var SEL_RECURRING_WEKDAY_RADIO_INPUT 		= '#recurringDay';
	var SEL_DATERANGEPICKER_APPLY				= 'apply.daterangepicker';
	
	var SEL_AREA_CUSTOM_TIME 					= '#areaCustomTime';
	var SEL_CAPACITY_CUSTOM_TIME 				= '#capacityCustomTime';
	var SEL_CAPACITY_RADIO_BUTTON 				= '#changeReservationCapacity';
	var SEL_AREA_RADIO_BUTTON 					= '#notAcceptReservation';
	var SEL_CAPACITY_WARNING_SPAN 				= '#capacity-warning';
	var SEL_MISSING_SELECTION_MESSAGE 			= '.missing-selection';
	var SEL_MISSING_DATE_SELECTION_MESSAGE 		= '.date-missing-selection';
	var SEL_MERIDIEM_TOGGLE_BTN 				= '.meridiem-toggle .toggle-group .btn';

	var SEL_MODULE_ACCORDION 					= ".mod-todays-limits";
	var SEL_SHOW_MORE_LESS_BLOCK 				= ".show-more-less";
	var SEL_SHOW_MORE_LINK 						= ".show-more";
	var SEL_SHOW_LESS_LINK 						= ".show-less";
	var SEL_DEFAULT_LIMIT_TITLE 				= '.default-active-limit-heading';
	var SEL_LIMIT_TITLE 						= '.active-limit-heading';
	var SEL_TODAY_LIMIT_ACCORDION_HEADER 		= '.todayLimit';
	var SEL_ACCORDION_ARROW_DOWN				= 'fas fa-chevron-down';
	var SEL_ACCORDION_ARROW_UP 					= 'fas fa-chevron-up';
	var SEL_ACCORDION_ARROW_ICON				= '.arrowIcon';
	var SEL_DELETE_ICON 						= '.fa-trash-alt';
	var SEL_MODAL_DELETE_CONFIRM				= '.deleteConfirmModal';
	var SEL_MODAL_DELETE_CONFIRM_MESSAGE		= '.confirm-message';
	var SEL_CUSTOM_TIME_ERROR 					= '.time-error';
	var SEL_EMPTY_TIME_FIELD_ERROR 				= '.empty-field-error';
	var SEL_MIDNIGHT_24HOURS_ERROR 				= '.midnight-24hours-error';

	var ATTR_NOT_ACCEPT_RESERVATION				= "notAcceptReservation";
	var ATTR_SPECIFIC_AREAS						= "specificAreas";
	var ATTR_CUSTOM_TIME 						= "customTime";
	var ATTR_SPECIFIC_DAY 						= "specificDay";
	var ATTR_CHECKED 							= ':checked';

	var DATA_ATTR_START_DATE					= 'startDate';
	var DATA_ATTR_END_DATE						= 'endDate';
	var DATA_ATTR_PATH                  		= 'path';
	var SPAN_ELEMENT							= 'span';
	var DEFAULT_MINUTES 						= '00';
	var SYSTEM_DATE_FORMAT						= 'YYYY-MM-DD';
	var DEFAULT_DATE_FORMAT						= 'DD/MM/YYYY';

	var CSS_HIDDEN 								= 'hidden';
	var CSS_HIDE 								= 'hide';
	var CSS_HAS_ERROR							= 'has-error';
	var CSS_CURSOR_NONE 						= 'cursor-none';
	var IS_CHECKED 								= ":checked";

	var START_HOUR								= 'startHour';
	var START_MINUTE							= 'startMinute';
	var END_HOUR								= 'endHour';
	var END_MINUTE								= 'endMinute';

	var formTimepicker 	= new FormTimepicker();
	var confirmModal 	= new Confirm();
	var notification 	= new Notification();
	var isCalendarOpened = 0;

	var parseInitialDate = function(date) {
		return moment(date, SYSTEM_DATE_FORMAT);
	};

	/**
	 *@param {Moment} date A momentJS object
	 */
	 var formatDateForUrl = function(date) {
		if (!date) {
			return '';
		}
		return date.format(SYSTEM_DATE_FORMAT);
	};

	/**
	 * @description add start and end date to a new date object
	 * @param {*} datePicker 
	 * @returns 
	 */
	var updateSelectedDateRanges = function(datePicker){
		var startDate = formatDateForUrl(datePicker.startDate);
		var endDate = formatDateForUrl(datePicker.endDate);
		return datePicker.element.attr({'data-start-date': startDate, 'data-end-date': endDate});
	}

	/**
	 * @description initialize the daterangepicker with current day as a default selection
	 * @param {*} moduleNode 
	 * @param {*} localConfig 
	 */
    var initDateRangePicker = function(moduleNode, localConfig) {
		var container 				= moduleNode.find(SEL_DATE_RANGE_CONTAINER);
		var dateRangeInput 			= container.find(SEL_DATE_RANGE_INPUT);
		var isOpened = 0;

		var startDate = parseInitialDate(dateRangeInput.data(DATA_ATTR_START_DATE));
		if (!startDate) {
			startDate = moment().startOf('day');
		}
		var endDate = parseInitialDate(dateRangeInput.data(DATA_ATTR_END_DATE));

		if (!endDate) {
			endDate = moment(endDate);
		}

		var isDeviceMobile = UserInterfaceUtils.isDeviceMobile();
		var displayFormat = localConfig.dateFormatWithoutYear;

		var locale = jQuery.extend({}, localConfig.locale, {
			format: displayFormat || DEFAULT_DATE_FORMAT,
			firstDay: 1, // start on monday
		});

		dateRangeInput.daterangepicker({
			autoApply: true,
			autoclose: true,
			linkedCalendars: !isDeviceMobile,
			opens: 'center',
			locale: locale,
			startDate: startDate,
			endDate: endDate,
			minDate: new Date(),
			showCustomRangeLabel: true,
			alwaysShowCalendars: true
		});

		dateRangeInput.on(SEL_DATERANGEPICKER_APPLY, function(e, picker){
			updateSelectedDateRanges(picker);
		});

		dateRangeInput.on('hide.daterangepicker', function(e, picker){
			isOpened = 0;
		});

		dateRangeInput.on('click', function(){
			isOpened++;
			var datePickerNode = jQuery(this).closest(SEL_MAIN_CONTENT).siblings(SEL_DATERANGEPICKER);

			//close daterangepicker if click on input field
			if(isOpened > 1){
				datePickerNode.hide();
				isOpened = 0;
				isCalendarOpened = 0;
			}else{
				//show daterangepicker on first click
				datePickerNode.show();
				isOpened = 1;
				isCalendarOpened = 1;
			}
		});	
	};

	// handle selection for (Do not accept any online reservations/Change online reservation capacity)
	var updateLimitTypeSelection = function(radioOption, moduleNode) {
		var areaLimitSection = moduleNode.find(SEL_DO_NOT_ACCEPT_RESERVATION_SECTION);
		var capacityLimitSection = moduleNode.find(SEL_CHANGE_RESERVATION_CAPACITY_SECTION);

		if(radioOption.val() === ATTR_NOT_ACCEPT_RESERVATION){
			areaLimitSection.removeClass(CSS_HIDDEN);
			capacityLimitSection.addClass(CSS_HIDDEN);
		}else{
			areaLimitSection.addClass(CSS_HIDDEN);
			capacityLimitSection.removeClass(CSS_HIDDEN);
		}
	};

	// handle all areas or specific areas selection 
	var updateLimitAreasSelection = function(radioOption, moduleNode){
		var displayAreas = moduleNode.find(SEL_AREAS_BLOCK);

		if(radioOption.val() === ATTR_SPECIFIC_AREAS){
			displayAreas.removeClass(CSS_HIDDEN);
		}else{
			displayAreas.addClass(CSS_HIDDEN);
		}
	}

	// handle day or custom time selection
	var updateCustomTimeSelection = function(radioOption){
		var areaLimitSection = radioOption.closest(SEL_DO_NOT_ACCEPT_RESERVATION_SECTION);
		var capacityLimitSection = radioOption.closest(SEL_CHANGE_RESERVATION_CAPACITY_SECTION);
		var areaLimitCustomTime = areaLimitSection.find(SEL_LIMIT_CUSTOM_TIME_SECTION);
		var capacityLimitCustomTime = capacityLimitSection.find(SEL_LIMIT_CUSTOM_TIME_SECTION);

		if(radioOption.val() === ATTR_CUSTOM_TIME && areaLimitSection.length === 1){
			areaLimitCustomTime.removeClass(CSS_HIDDEN);
			capacityLimitCustomTime.addClass(CSS_HIDDEN);
		}else if(radioOption.val() === ATTR_CUSTOM_TIME && capacityLimitSection.length === 1){
			capacityLimitCustomTime.removeClass(CSS_HIDDEN);
			areaLimitCustomTime.addClass(CSS_HIDDEN);
		}else{
			capacityLimitCustomTime.addClass(CSS_HIDDEN);
			areaLimitCustomTime.addClass(CSS_HIDDEN);
		}
	}

	// handle recurring/specific day selection 
	var updateSpecificDaySelection = function(radioOption, moduleNode){
		var specificDayBlock = moduleNode.find(SEL_WEEKDAY_BLOCK);
		var recurringDayBlock = moduleNode.find(SEL_DATE_RANGE_CONTAINER);

		if(radioOption.val() === ATTR_SPECIFIC_DAY){
			specificDayBlock.addClass(CSS_HIDDEN);
			recurringDayBlock.removeClass(CSS_HIDDEN);
		}else{
			specificDayBlock.removeClass(CSS_HIDDEN);
			recurringDayBlock.addClass(CSS_HIDDEN);
		}
	}

	// reset form after click on cancel button
	var resetForm = function(moduleNode, previousStep, nextStep){
		var form = moduleNode.find(SEL_FORM);
		form[0].reset();

		previousStep.removeClass(CSS_HIDDEN);
		nextStep.addClass(CSS_HIDDEN);

		previousStep.find(SEL_AREAS_BLOCK).addClass(CSS_HIDDEN);
		previousStep.find(SEL_LIMIT_CUSTOM_TIME_SECTION).addClass(CSS_HIDDEN);
		previousStep.find(SEL_DO_NOT_ACCEPT_RESERVATION_SECTION).addClass(CSS_HIDDEN);
		previousStep.find(SEL_CHANGE_RESERVATION_CAPACITY_SECTION).addClass(CSS_HIDDEN);

		nextStep.find(SEL_WEEKDAY_BLOCK).addClass(CSS_HIDDEN);
		nextStep.find(SEL_DATE_RANGE_CONTAINER).addClass(CSS_HIDDEN);
	}

	/**
	 * @description prefill minutes with 00 for custom time inputs
	 * @param {*} container 
	 */
	var prefillMinutes = function(container){
		var customTimeNodes = container.find(SEL_LIMIT_CUSTOM_TIME_SECTION);
		customTimeNodes.each(function(){
			addZeroMinutes(jQuery(this));
		})
	}

	/**
	 * @description prefill minutes with '00'
	 * @param {*} row 
	 */
	 var addZeroMinutes = function(customTime){
		var startingTime = customTime.find(SEL_STARTING_TIME_FORM_GROUP);
		var endingTime = customTime.find(SEL_ENDING_TIME_FORM_GROUP)
		formTimepicker.setValue(startingTime, '', DEFAULT_MINUTES);
		formTimepicker.setValue(endingTime, '', DEFAULT_MINUTES);
	}

	/**
	 * @description prepare the formObject data to submit the form
	 * @param {*} howToLimitStep 
	 * @param {*} whenToLimitStep 
	 * @returns 
	 */
	var prepareDataToSubmitFromInput = function(howToLimitStep, whenToLimitStep){
		var isAllAreasSelected = howToLimitStep.find(SEL_ALL_AREAS_OPTION_ID).is(ATTR_CHECKED);
		var reservableGroups = prepareReservableGroupsData(howToLimitStep);
		var capacity = howToLimitStep.find(SEL_LIMIT_CHANGE_CAPACITY_INPUT).val();

		var dateRangeInput = whenToLimitStep.find(SEL_DATE_RANGE_INPUT);
		var startDate = convertDateToISOString(dateRangeInput.attr('data-start-date'));
		var endDate = convertDateToISOString(dateRangeInput.attr('data-end-date'));

		var weekday = prepareWeekdayData(whenToLimitStep);

		var limitTime = prepareLimitTimeData(howToLimitStep);

		return new FormObject(
			weekday,
			limitTime.startHour, 
			limitTime.startMinute, 
			limitTime.endHour,
			limitTime.endMinute,
			startDate, 
			endDate, 
			((capacity == '' || capacity == undefined) ? null : capacity), 
			isAllAreasSelected ? [] : reservableGroups
		);
	}

	/**
	 * @description prepare the time data on basis of entireDay/customTime selection
	 * @param {*} limitNode 
	 * @returns 
	 */
	var prepareLimitTimeData = function(limitNode){
		var isAreaOptionEnabled = limitNode.find(SEL_AREA_RADIO_BUTTON).is(IS_CHECKED);
		var isCapacityOptionEnabled = limitNode.find(SEL_CAPACITY_RADIO_BUTTON).is(IS_CHECKED);
		var isEntireDayEnabled = false;

		if(isAreaOptionEnabled){
			isEntireDayEnabled = limitNode.find(SEL_ENTIRE_DAY_AREAS_OPTION_ID).is(ATTR_CHECKED);
		}

		if(isCapacityOptionEnabled){
			isEntireDayEnabled = limitNode.find(SEL_ENTIRE_DAY_CAPACITY_OPTION_ID).is(ATTR_CHECKED);
		}

		var limitTime = {};

		if(isEntireDayEnabled){
			limitTime = prepareEntireDayTime();
		}else{
			limitTime = prepareCustomTime(limitNode);
		}

		return limitTime;
	}

	/**
	 * @description prepare the custom time data on basis of area/capacity based selection
	 * @param {*} limitTimeNode 
	 * @returns 
	 */
	var prepareCustomTime = function(limitTimeNode){
		var areaBasedLimitOption = limitTimeNode.find(SEL_NOT_ACCEPT_RESERVATION_OPTION_ID).is(ATTR_CHECKED);
		var areaLimitSection = limitTimeNode.find(SEL_DO_NOT_ACCEPT_RESERVATION_SECTION);
		var capacityLimitSection = limitTimeNode.find(SEL_CHANGE_RESERVATION_CAPACITY_SECTION);
		var limitCustomTime = {};

		if(areaBasedLimitOption){
			limitCustomTime = prepareStartAndEndTimeData(areaLimitSection);
		}else{
			limitCustomTime = prepareStartAndEndTimeData(capacityLimitSection);
		}

		return limitCustomTime;
	}

	/**
	 * @description prepare the time data when entire day selected.
	 * @returns 
	 */
	var prepareEntireDayTime = function(){
		return {
			'startHour': null,
			'startMinute': null,
			'endHour': null,
			'endMinute': null
		};
	}

	/**
	 * @description prepare state and end time data on basis of area/capacity custom time selection
	 * @param {*} limitTimeNode 
	 * @returns 
	 */
	var prepareStartAndEndTimeData = function(limitTimeNode){
		var startTimeGroup 	 = limitTimeNode.find(SEL_FORM_INPUT_START_TIME);
		var endTimeGroup 	 = limitTimeNode.find(SEL_FORM_INPUT_END_TIME);
		var startTime    	 = formTimepicker.getValue(startTimeGroup);
		var endTime      	 = formTimepicker.getValue(endTimeGroup);

		startTime.hours = startTime.hours == "" ? '0' : startTime.hours;
		startTime.mins = startTime.mins == "" ? '0' : startTime.mins;

		endTime.hours = endTime.hours == "" ? '0' : endTime.hours;
		endTime.mins = endTime.mins == "" ? '0' : endTime.mins;

		return {
			'startHour': startTime.hours,
			'startMinute': startTime.mins,
			'endHour': endTime.hours,
			'endMinute': endTime.mins
		};
	}

	/**
	 * @description convert string date to ISO string format
	 * @param {*} limitDateNode 
	 * @returns 
	 */
	var convertDateToISOString = function(limitDateNode){
		var dateObject = new Date(limitDateNode);
		return dateObject.toISOString();
	}

	/**
	 * @description prepare weekday data
	 * @param {*} limitWeekdayNode 
	 * @returns 
	 */
	var prepareWeekdayData = function(limitWeekdayNode){
		var weekdayData = [];

		limitWeekdayNode.find(SEL_WEEKDAY_OPTION).each(function(){
			var day = jQuery(this);
			if(day.find(SEL_CHECKBOX_INPUT).is(ATTR_CHECKED)){
				weekdayData.push(1);
			}else{
				weekdayData.push('0');
			}
		});

		return weekdayData;
	}

	/**
	 * @description prepare reservable groups data
	 * @param {*} limitSectionNode 
	 * @returns 
	 */
	var prepareReservableGroupsData = function(limitSectionNode){
		var reservableGroups = [];

		limitSectionNode.find(SEL_DISPLAY_AREAS_CHECKBOX_INPUT).each(function(){
			var reservable = jQuery(this);
			if(reservable.is(ATTR_CHECKED)){
				reservableGroups.push({
					id: parseInt(reservable.val()),
					name: reservable.next(SPAN_ELEMENT).text()
				})
			}
		});

		return reservableGroups;
	}

	/**
	 * @description update hidden input fields, if any value/selection changes before form submission
	 * @param {*} moduleNode 
	 * @param {*} data 
	 */
	var updateHiddenInputDataForSubmit = function(moduleNode, data){
		var container = moduleNode.find(SEL_LIMIT_DATA_CONTAINER);
		var path = container.data(DATA_ATTR_PATH);

		// remove any previous errors
		container.empty();

		// convert data to inputs
		createLimitItemForSubmit(moduleNode, container, path, data);
	}

	var createLimitInputForReservableGroups = function(container, path, data, isNotAcceptReservationEnabled){
		if(isNotAcceptReservationEnabled){
			var reservableGroups = data.reservableGroups || [];

			if(reservableGroups.length == 0){
				addLimitInput(container, buildLimitPath(path, 'reservableGroups'), []);
			}

			reservableGroups.forEach(function(reservable, index) {
				addLimitInput(container, buildReservablePath(path, index, 'id'), reservable.id);
				addLimitInput(container, buildReservablePath(path, index, 'name'), reservable.name);
			});
		}else{
			addLimitInput(container, buildLimitPath(path, 'capacity'), data.capacity);
		}
	}

	/**
	 * @description add form data in input hidden fields
	 * @param {*} moduleNode 
	 * @param {*} container 
	 * @param {*} path 
	 * @param {*} data 
	 */
	var createLimitItemForSubmit = function(moduleNode, container, path, data) {

		var isNotAcceptReservationEnabled = moduleNode.find(SEL_NOT_ACCEPT_RESERVATION_OPTION_ID).is(ATTR_CHECKED);
		var isSpecificDayEnabled = moduleNode.find(SEL_SPECIFIC_DATE_RADIO_INPUT).is(ATTR_CHECKED);
		var hasReservableGroup = window.config.reservationLimit && window.config.reservationLimit.reservableGroups;

		if(hasReservableGroup !== ''){
			createLimitInputForReservableGroups(container, path, data, isNotAcceptReservationEnabled);
		}
		
		if(hasReservableGroup == '' && !isNotAcceptReservationEnabled){
			addLimitInput(container, buildLimitPath(path, 'capacity'), data.capacity);
		}

		if(isSpecificDayEnabled){
			addLimitInput(container, buildLimitPath(path, 'startDate'), data.startDate);
			addLimitInput(container, buildLimitPath(path, 'endDate'), data.endDate);
		}else{
			data.weekday.forEach(function(day, index){
				addLimitInput(container, buildWeekdayPath(path, index, 'weekday'), day);
			});
		}

		addLimitInput(container, buildLimitPath(path, START_HOUR), data.startHour || 0);
		addLimitInput(container, buildLimitPath(path, START_MINUTE), data.startMin || 0);
		addLimitInput(container, buildLimitPath(path, END_HOUR), data.endHour || 0);
		addLimitInput(container, buildLimitPath(path, END_MINUTE), data.endMin || 0);
	};

	/**
	 * @description create input hidden fields
	 * @param {*} container 
	 * @param {*} name 
	 * @param {*} value 
	 * @returns 
	 */
	var addLimitInput = function(container, name, value) {
		return jQuery('<input />')
			.attr('type', 'hidden')
			.attr('name', name)
			.attr('value', value || '')
			.appendTo(container);
	};

	var buildLimitPath = function(path, name) {
		return path + '.' + name;
	};

	var buildReservablePath = function(path, index, name) {
		return path + '.reservableGroups[' + index + '].' + name;
	};

	var buildWeekdayPath = function(path, index, name) {
		return path + '.' + name + '[' + index + ']';
	};

	var expandTodayActiveLimitSection = function(accordionNode){
		var todayLimitAccordion = accordionNode.find(SEL_TODAY_LIMIT_ACCORDION_HEADER);
		todayLimitAccordion.trigger('click');
		todayLimitAccordion.find(SEL_DEFAULT_LIMIT_TITLE).addClass(CSS_HIDE);
		todayLimitAccordion.find(SEL_LIMIT_TITLE).removeClass(CSS_HIDE);
		todayLimitAccordion.find(SEL_SHOW_MORE_LINK).addClass(CSS_HIDE);
		todayLimitAccordion.find(SEL_SHOW_LESS_LINK).removeClass(CSS_HIDE);
		todayLimitAccordion.find(SEL_ACCORDION_ARROW_ICON).removeClass(SEL_ACCORDION_ARROW_DOWN);
		todayLimitAccordion.find(SEL_ACCORDION_ARROW_ICON).addClass(SEL_ACCORDION_ARROW_UP);
	}

	var showDeletePopup = function(moduleNode, message) {
		var modal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM)
					.clone()
					.removeClass(CSS_HIDDEN);
		modal.find(SEL_MODAL_DELETE_CONFIRM_MESSAGE).text(message);
		return confirmModal.show(modal);
	};

	var deleteSpecificLimit = function(url){
		jQuery.ajax({
			url: url,
			type: 'DELETE',
			data: {'_csrf' : window.config.reservationLimit.csrfToken},
			success: function(result, status){
				if(status == 'success'){
					localStorage.setItem('deleteSucceeded', true);
					location.reload();
				}
			},
			error: function(result, status){
				localStorage.setItem('deleteError', true);
			  	console.log(status + ": " + result.status);
			}
		});
	}

	// remove all errors related to invalid custom time
	var removeHighlightedErrors = function(nextBtnNode, limitNode){
		nextBtnNode.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
		limitNode.find(SEL_FORM_GROUP_WRAPPER).removeClass(CSS_HAS_ERROR);
		limitNode.find(SEL_CUSTOM_TIME_ERROR).addClass(CSS_HIDE);
		limitNode.find(SEL_EMPTY_TIME_FIELD_ERROR).addClass(CSS_HIDE);
		limitNode.find(SEL_MIDNIGHT_24HOURS_ERROR).addClass(CSS_HIDE);
	}

	// hide all previous highlighted errors, just after click on next button
	// and only show the errors which may happen due to the new entered data
	var hideAllErrorsInitially = function(limitBlock, sectionNode){
		limitBlock.find(SEL_CAPACITY_WARNING_SPAN).addClass(CSS_HIDE);
		sectionNode.find(SEL_CUSTOM_TIME_ERROR).addClass(CSS_HIDE);
		sectionNode.find(SEL_EMPTY_TIME_FIELD_ERROR).addClass(CSS_HIDE);
		sectionNode.find(SEL_MIDNIGHT_24HOURS_ERROR).addClass(CSS_HIDE);
		sectionNode.find(SEL_FORM_GROUP_WRAPPER).removeClass(CSS_HAS_ERROR);
	}

	// calculate both start and end time
	var calculateStartAndEndTime = function(sectionNode){
		var startTimeNode = sectionNode.find(SEL_STARTING_TIME_FORM_GROUP);
		var endTimeNode = sectionNode.find(SEL_ENDING_TIME_FORM_GROUP);
		var startTime = formTimepicker.getValue(startTimeNode);
		var endTime = formTimepicker.getValue(endTimeNode);
		// calculate start and end time
		var startTimeVal = Number(startTime.hours)*60 + Number(startTime.mins);
		var endTimeVal = Number(endTime.hours)*60 + Number(endTime.mins);

		return [startTimeVal, endTimeVal];
	}

	var toggleTimeAndCapacityClasses = function(limitNode, limitBlock, nextBtn, classes){
		classes[0] === 'remove' ? limitNode.find(SEL_EMPTY_TIME_FIELD_ERROR).removeClass(CSS_HIDE) : limitNode.find(SEL_EMPTY_TIME_FIELD_ERROR).addClass(CSS_HIDE);
		classes[1] === 'remove' ? limitNode.find(SEL_FORM_GROUP_WRAPPER).removeClass(CSS_HAS_ERROR) : limitNode.find(SEL_FORM_GROUP_WRAPPER).addClass(CSS_HAS_ERROR);
		classes[2] === 'remove' ? limitNode.find(SEL_CUSTOM_TIME_ERROR).removeClass(CSS_HIDE) : limitNode.find(SEL_CUSTOM_TIME_ERROR).addClass(CSS_HIDE);
		classes[3] === 'remove' ? limitBlock.find(SEL_CAPACITY_WARNING_SPAN).removeClass(CSS_HIDE) : limitBlock.find(SEL_CAPACITY_WARNING_SPAN).addClass(CSS_HIDE);
		classes[4] === 'remove' ? limitBlock.find(SEL_MIDNIGHT_24HOURS_ERROR).removeClass(CSS_HIDE) : limitBlock.find(SEL_MIDNIGHT_24HOURS_ERROR).addClass(CSS_HIDE);
		nextBtn.addClass(CSS_CURSOR_NONE).attr('disabled', true);
	}

	// validate both custom time and entered capacity
	var applyTimeAndCapacityValidation = function(sectionNode, customTime, nextBtnNode, howToApplyBlock, whenToApplyBlock){

		var is24Hours = window.config.reservationLimit.display24Hours;

		var customTimeSelected = sectionNode.find(SEL_CAPACITY_CUSTOM_TIME).is(IS_CHECKED);
		var entireDaySelected = sectionNode.find(SEL_ENTIRE_DAY_CAPACITY_OPTION_ID).is(IS_CHECKED);
		var requestedCapacity = howToApplyBlock.find(SEL_LIMIT_CHANGE_CAPACITY_INPUT).val();

		var endHour = sectionNode.find(SEL_ENDING_TIME_FORM_GROUP).find(SEL_FORM_START_HOUR_INPUT).val();
		endHour = endHour !== '' ? parseInt(endHour) : '';

		var endMin = sectionNode.find(SEL_ENDING_TIME_FORM_GROUP).find(SEL_FORM_START_MINUTE_INPUT).val();
		endMin = endMin !== '' ? parseInt(endMin) : '';

		var startHour = sectionNode.find(SEL_STARTING_TIME_FORM_GROUP).find(SEL_FORM_START_HOUR_INPUT).val();
		startHour = startHour !== '' ? parseInt(startHour) : '';

		var startMin = sectionNode.find(SEL_STARTING_TIME_FORM_GROUP).find(SEL_FORM_START_MINUTE_INPUT).val();
		startMin = startMin !== '' ? parseInt(startMin) : '';

		var midnightCaseFor24Hours = endHour === 24 && endMin >= 0 && is24Hours;
		
		var startGreaterThanEndCase = customTime[0] >= customTime[1];
		var equalStartEndTimeCase = customTime[0] === customTime[1];
		var startEndTimeZeroCase = (customTime[0] === 0 && startHour === '') || (customTime[1] === 0 && endHour === '');
		var customTimeNotZeroCase = (customTime[0] !== 0 && customTime[1] !== 0) || (startMin !== '' || endMin !== '');
		var startEndHourEmptyCase = (endMin === '' || startMin === '');
		var emptyCapacityCustomTimeCase = (customTimeSelected && requestedCapacity === '');
		var emptyCapacityEntireDayCase = (entireDaySelected && requestedCapacity === '');
		var capacityGreaterThanTotalCapacityCase = requestedCapacity !== '' && requestedCapacity >= parseInt(window.config.reservationLimit.totalCapacity);

		let classArr = [];

		if((startEndTimeZeroCase || startEndHourEmptyCase) || ((startEndTimeZeroCase || startEndHourEmptyCase) && emptyCapacityCustomTimeCase)){
			
			classArr = ['remove', 'add', 'add', 'add', 'add'];
			toggleTimeAndCapacityClasses(sectionNode, howToApplyBlock, nextBtnNode, classArr);

		}else if(startGreaterThanEndCase || (startGreaterThanEndCase && emptyCapacityCustomTimeCase) || equalStartEndTimeCase){

			classArr = ['add', 'add', 'remove', 'add', 'add'];
			toggleTimeAndCapacityClasses(sectionNode, howToApplyBlock, nextBtnNode, classArr);

		}else if(midnightCaseFor24Hours || (midnightCaseFor24Hours && emptyCapacityCustomTimeCase)){
			// midnight cases only for the countries which follows 24 hours timezone 
			classArr = ['add', 'add', 'add', 'add', 'remove'];
			toggleTimeAndCapacityClasses(sectionNode, howToApplyBlock, nextBtnNode, classArr);

		}else if(customTimeNotZeroCase && emptyCapacityCustomTimeCase){

			classArr = ['add', 'remove', 'add', 'add', 'add'];
			howToApplyBlock.find(SEL_MISSING_SELECTION_MESSAGE).removeClass(CSS_HIDE);
			toggleTimeAndCapacityClasses(sectionNode, howToApplyBlock, nextBtnNode, classArr);
		}else if((customTimeSelected || entireDaySelected) && capacityGreaterThanTotalCapacityCase){

			classArr = ['add', 'remove', 'add', 'remove', 'add'];
			toggleTimeAndCapacityClasses(sectionNode, howToApplyBlock, nextBtnNode, classArr);

		}else if(emptyCapacityCustomTimeCase || emptyCapacityEntireDayCase){

			classArr = ['add', 'remove', 'add', 'add', 'add'];
			toggleTimeAndCapacityClasses(sectionNode, howToApplyBlock, nextBtnNode, classArr);

		}else{
			nextBtnNode.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
			howToApplyBlock.addClass(CSS_HIDDEN);
			whenToApplyBlock.removeClass(CSS_HIDDEN);
		}
	}


	// reset the custom time with blank values (if invalid data entered) after switching between area/capacity based options
	var clearCustomTimeInvalidValues = function(sectionNode){
		var startTimeNode = sectionNode.find(SEL_STARTING_TIME_FORM_GROUP);
		var endTimeNode = sectionNode.find(SEL_ENDING_TIME_FORM_GROUP);

		formTimepicker.setValue(startTimeNode, '', 00);
		formTimepicker.setValue(endTimeNode, '', 00);
	}

	// clear all the invalid error messages related to custom time after switching between area/capacity based options
	var resetInvalidCustomTimeData = function(howLimitBlock, sectionNode){

		var is24Hours = window.config.reservationLimit.display24Hours;

		var midnightEndHour = sectionNode.find(SEL_ENDING_TIME_FORM_GROUP).find(SEL_FORM_START_HOUR_INPUT).val();
		midnightEndHour = midnightEndHour !== '' ? parseInt(midnightEndHour) : '';

		var midnightEndMin = sectionNode.find(SEL_ENDING_TIME_FORM_GROUP).find(SEL_FORM_START_MINUTE_INPUT).val();
		midnightEndMin = midnightEndMin !== '' ? parseInt(midnightEndMin) : 0;

		hideAllErrorsInitially(howLimitBlock, sectionNode);

		var limitCustomTime = calculateStartAndEndTime(sectionNode);

		if(((limitCustomTime[0] >= limitCustomTime[1]) && !(!is24Hours && midnightEndHour === 12 && midnightEndMin === 0) && !(is24Hours && midnightEndHour === 0 && midnightEndMin === 0)) || (limitCustomTime[0] === limitCustomTime[1])){
			clearCustomTimeInvalidValues(sectionNode);
		}
	}

	// reset entered capacity with blank value if invalid value entered
	var resetAndValidateCapacityData = function(limitBlock){
		var capacityNode = limitBlock.find(SEL_LIMIT_CHANGE_CAPACITY_INPUT);
		var reqCapacity = capacityNode.val() !== '' ? parseInt(capacityNode.val()) : 0;

		if(reqCapacity >= parseInt(window.config.reservationLimit.totalCapacity)){
			capacityNode.val('');
		}
	}

	var missingSelectionErrorMessage = function(moduleNode, nextLimitBtn){
		moduleNode.find(SEL_MISSING_SELECTION_MESSAGE).removeClass(CSS_HIDE);
		nextLimitBtn.addClass(CSS_CURSOR_NONE).attr('disabled', true);
	}

	var missingDateSelectionMessage = function(moduleNode, createLimitBtn){
		moduleNode.find(SEL_MISSING_DATE_SELECTION_MESSAGE).removeClass(CSS_HIDE);
		createLimitBtn.addClass(CSS_CURSOR_NONE).attr('disabled', true);
	}

	var hideCurrentAndShowNextSection = function(nextLimitBtn, howToApplyLimitBlock, whenToApplyLimitBlock){
		nextLimitBtn.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
		howToApplyLimitBlock.addClass(CSS_HIDDEN);
		whenToApplyLimitBlock.removeClass(CSS_HIDDEN);
	}

	var missingSelectionsValidation = function(moduleNode, nextLimitBtn, howToApplyLimitBlock, whenToApplyLimitBlock){
		var totalCapacity = parseInt(window.config.reservationLimit.totalCapacity);
		var isCapacityBasedLimit = moduleNode.find(SEL_CAPACITY_RADIO_BUTTON).is(IS_CHECKED);
		var isAreaBasedLimit = moduleNode.find(SEL_AREA_RADIO_BUTTON).is(IS_CHECKED);

		var isAllAreas = howToApplyLimitBlock.find(SEL_ALL_AREAS_OPTION_ID).is(IS_CHECKED);
		var isSpecificArea = howToApplyLimitBlock.find(SEL_SPECIFIC_AREAS_OPTION_ID).is(IS_CHECKED);

		var isAreaCustomTime = howToApplyLimitBlock.find(SEL_AREA_CUSTOM_TIME).is(IS_CHECKED);
		var isAreaEntireDay = howToApplyLimitBlock.find(SEL_ENTIRE_DAY_AREAS_OPTION_ID).is(IS_CHECKED);

		var isCapacityCustomTime = howToApplyLimitBlock.find(SEL_CAPACITY_CUSTOM_TIME).is(IS_CHECKED);
		var isCapacityEntireDay = howToApplyLimitBlock.find(SEL_ENTIRE_DAY_CAPACITY_OPTION_ID).is(IS_CHECKED);
		
		var isReservablesExists = window.config.reservationLimit.reservableGroups !== "" ? true : false;

		var areaBasedNode = moduleNode.find(SEL_DO_NOT_ACCEPT_RESERVATION_SECTION);
		var capacityBasedNode = moduleNode.find(SEL_CHANGE_RESERVATION_CAPACITY_SECTION);

		var areaBasedCustomTime = calculateStartAndEndTime(areaBasedNode);
		var capacityBasedCustomTime = calculateStartAndEndTime(capacityBasedNode);

		var isSpecificAreaChecked = moduleNode.find(SEL_DISPLAY_AREA_CHECKBOX_CHECKED).length;

		var capacityInput = howToApplyLimitBlock.find(SEL_LIMIT_CHANGE_CAPACITY_INPUT).val();
		capacityInput = capacityInput === '' ? '' : parseInt(capacityInput);

		moduleNode.find(SEL_MISSING_SELECTION_MESSAGE).addClass(CSS_HIDE);

		if(!isCapacityBasedLimit && !isAreaBasedLimit){
			missingSelectionErrorMessage(moduleNode, nextLimitBtn);
		}else if(isAreaBasedLimit && !isCapacityBasedLimit){
			// add validations for area based limit
			if((isReservablesExists && !isAllAreas && !isSpecificArea) || (!isAreaCustomTime && !isAreaEntireDay) || (isReservablesExists && isSpecificArea && !isAllAreas && isSpecificAreaChecked === 0)){
				missingSelectionErrorMessage(moduleNode, nextLimitBtn);
			}else if(isAreaCustomTime && !isAreaEntireDay){
				applyTimeAndCapacityValidation(areaBasedNode, areaBasedCustomTime, nextLimitBtn, howToApplyLimitBlock, whenToApplyLimitBlock);
			}else{
				hideCurrentAndShowNextSection(nextLimitBtn, howToApplyLimitBlock, whenToApplyLimitBlock);
			}
		}else if(!isAreaBasedLimit && isCapacityBasedLimit){
			// add validations for capacity based limit
			if((!isCapacityCustomTime && !isCapacityEntireDay && capacityInput === '') || (!isCapacityCustomTime && !isCapacityEntireDay && capacityInput !== '') || (!isCapacityCustomTime && isCapacityEntireDay && capacityInput === '')){
				missingSelectionErrorMessage(moduleNode, nextLimitBtn);
			}else if(isCapacityCustomTime && !isCapacityEntireDay){
				applyTimeAndCapacityValidation(capacityBasedNode, capacityBasedCustomTime, nextLimitBtn, howToApplyLimitBlock, whenToApplyLimitBlock);
			}else if(!isCapacityCustomTime && isCapacityEntireDay && (capacityInput !== '' && capacityInput >= totalCapacity)){
				howToApplyLimitBlock.find(SEL_CAPACITY_WARNING_SPAN).removeClass(CSS_HIDE);
				nextLimitBtn.addClass(CSS_CURSOR_NONE).attr('disabled', true);
			}else{
				hideCurrentAndShowNextSection(nextLimitBtn, howToApplyLimitBlock, whenToApplyLimitBlock);
			}
		}
	}

	var whenToCreateLimitValidation = function(moduleNode, createLimitBtn){
		var hasError = false;
		var isSpecificDayEnabled = moduleNode.find(SEL_SPECIFIC_DATE_RADIO_INPUT).is(IS_CHECKED);
		var isRecurringDayEnabled = moduleNode.find(SEL_RECURRING_WEKDAY_RADIO_INPUT).is(IS_CHECKED);

		var weekdayCheckboxChecked = moduleNode.find(SEL_WEEKDAY_OPTION_CHECKBOX_CHECKED).length;

		if((!isSpecificDayEnabled && !isRecurringDayEnabled) || (weekdayCheckboxChecked === 0 && (!isSpecificDayEnabled && isRecurringDayEnabled))){
			missingDateSelectionMessage(moduleNode, createLimitBtn);
			hasError = true;
		}

		return hasError;
	}

	var removeDateMissingErrorMessage = function(moduleNode, createLimitBtn){
		moduleNode.find(SEL_MISSING_DATE_SELECTION_MESSAGE).addClass(CSS_HIDE);
		createLimitBtn.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
	}

	var addNewLimit = function(selectLimitCard, addLimitCard){
		selectLimitCard.slideDown();
		addLimitCard.hide();
	}

    /**
     * Initialize.
     */
    this.init = function (initNode) {

        // Retrieve and cache dom nodes
        var moduleNodes = initNode.find(SEL_MODULE);
		var localConfig = window.config.reservationLimit || {};

        // Init all matching nodes
        moduleNodes.each(function () {

            var moduleNode = jQuery(this);
			var addNewLimitBtn 	= moduleNode.find(SEL_ADD_NEW_LIMIT_BTN);
			var cancelLimitBtn 	= moduleNode.find(SEL_CANCEL_LIMIT_BTN);
			var nextLimitBtn	= moduleNode.find(SEL_NEXT_LIMIT_BTN);
			var previousLimitBtn = moduleNode.find(SEL_PREVIOUS_LIMIT_BTN);
			var createLimitBtn 	= moduleNode.find(SEL_CREATE_LIMIT_BTN);
			var formNode = moduleNode.find(SEL_FORM);
			var selectLimitCard	= moduleNode.find(SEL_RESERVATION_LIMIT_CARD);
			var addLimitCard 	= moduleNode.find(SEL_RESERVATION_ADD_LIMIT_CARD);
			var howToApplyLimitBlock = moduleNode.find(SEL_HOW_TO_APPLY_LIMIT_BLOCK);
			var whenToApplyLimitBlock = moduleNode.find(SEL_WHEN_TO_APPLY_LIMIT_BLOCK);

			var accordionNode = moduleNode.find(SEL_MODULE_ACCORDION);
			var todayActiveLimits = window.config.reservationLimit && window.config.reservationLimit.todaysActiveLimits;

			var areaBasedNode = moduleNode.find(SEL_DO_NOT_ACCEPT_RESERVATION_SECTION);
			var capacityBasedNode = moduleNode.find(SEL_CHANGE_RESERVATION_CAPACITY_SECTION);

			var totalCapacity = window.config.reservationLimit.totalCapacity;

			// to open/close the calendar on click of calendar icon
			var datepickerContainer = moduleNode.find(SEL_DATE_RANGE_CONTAINER);
			var dateRangeInput = datepickerContainer.find(SEL_DATE_RANGE_INPUT);
			var calendarIcon = datepickerContainer.find(SEL_DATEPICKER_INPUT_GROUP_ADDON);	

			if(localStorage.getItem('reservationOverviewReferrer')){
				addNewLimit(selectLimitCard, addLimitCard);
				localStorage.removeItem('reservationOverviewReferrer');
			}

			if(localStorage.getItem('deleteSucceeded')){
				notification.showGlobalConfirmNotification(window.config.reservationLimit.deleteSuccessMessage);
				localStorage.removeItem('deleteSucceeded');
			}

			if(localStorage.getItem('deleteError')){
				notification.showGlobalErrorNotification(window.config.reservationLimit.deleteSuccessMessage);
				localStorage.removeItem('deleteError');
			}

			if(todayActiveLimits !== ''){
				expandTodayActiveLimitSection(accordionNode);
			}

			initDateRangePicker(moduleNode, localConfig);

			prefillMinutes(howToApplyLimitBlock);
			
			// handle event on add new limit button
			addNewLimitBtn.on('click', function(){
				addNewLimit(selectLimitCard, addLimitCard);
			});

			// handle event on cancel button click
			cancelLimitBtn.on('click', function(){
				selectLimitCard.hide(200);
				addLimitCard.slideDown();
				resetForm(moduleNode, howToApplyLimitBlock, whenToApplyLimitBlock);
				initDateRangePicker(moduleNode, localConfig);
				prefillMinutes(howToApplyLimitBlock);
			});

			//on change of capacity input field - validate the input and disable next button
			moduleNode.find(SEL_LIMIT_CHANGE_CAPACITY_INPUT).on('input', function(event){
				var isCapacityBasedLimit = moduleNode.find(SEL_CAPACITY_RADIO_BUTTON).is(IS_CHECKED);
				var requestedCapacity = event.target.value !== '' ? parseInt(event.target.value) : '';
				howToApplyLimitBlock.find(SEL_CAPACITY_WARNING_SPAN).addClass(CSS_HIDE);
				moduleNode.find(SEL_MISSING_SELECTION_MESSAGE).addClass(CSS_HIDE);

				// Capacity input field will only accept integers
				jQuery(this).val(jQuery(this).val().replace(/[^0-9]/g, ''));

				if(isCapacityBasedLimit && requestedCapacity >= parseInt(totalCapacity)){
					howToApplyLimitBlock.find(SEL_CAPACITY_WARNING_SPAN).removeClass(CSS_HIDE);
					nextLimitBtn.addClass(CSS_CURSOR_NONE).attr('disabled', true);
				}else{
					nextLimitBtn.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
				}
			})

			// on click on next button - validate the capacity input and disable next button
			nextLimitBtn.on('click', function(){
				hideAllErrorsInitially(howToApplyLimitBlock, areaBasedNode);
				hideAllErrorsInitially(howToApplyLimitBlock, capacityBasedNode);
				missingSelectionsValidation(moduleNode, nextLimitBtn, howToApplyLimitBlock, whenToApplyLimitBlock);
			});

			// on change of custom time fields, remove the highlighted errors - for capacity based mode
			capacityBasedNode.find(SEL_CAPACITY_CUSTOM_TIME_INPUTS).on('keyup', function(){
				removeHighlightedErrors(nextLimitBtn, capacityBasedNode);
			});

			// on change of custom time fields, remove the highlighted errors - for area/table based mode
			areaBasedNode.find('input[type=text]').on('keyup', function(){
				removeHighlightedErrors(nextLimitBtn, areaBasedNode);
			});

			// on click of meridiem, remove the highlighted errors - for area/table based mode
			areaBasedNode.find(SEL_MERIDIEM_TOGGLE_BTN).on('click', function(){
				removeHighlightedErrors(nextLimitBtn, areaBasedNode);
			});

			// on click of meridiem, remove the highlighted errors - for capacity based mode
			capacityBasedNode.find(SEL_MERIDIEM_TOGGLE_BTN).on('click', function(){
				removeHighlightedErrors(nextLimitBtn, capacityBasedNode);
			});

			previousLimitBtn.on('click', function(){
				howToApplyLimitBlock.removeClass(CSS_HIDDEN);
				whenToApplyLimitBlock.addClass(CSS_HIDDEN);
			});

			// handle radio button limit type selector change
			moduleNode.on('change', SEL_LIMIT_TYPE_ACTIVITY_SELECTOR, function() {

				moduleNode.find(SEL_MISSING_SELECTION_MESSAGE).addClass(CSS_HIDE);
				nextLimitBtn.removeClass(CSS_CURSOR_NONE).attr('disabled', false);

				resetInvalidCustomTimeData(howToApplyLimitBlock, areaBasedNode);
				resetInvalidCustomTimeData(howToApplyLimitBlock, capacityBasedNode);

				resetAndValidateCapacityData(howToApplyLimitBlock);				
				updateLimitTypeSelection(jQuery(this), moduleNode);
			});

			// handle radio button area selector change
			moduleNode.on('change', SEL_AREAS_ACTIVITY_SELECTOR, function() {
				moduleNode.find(SEL_MISSING_SELECTION_MESSAGE).addClass(CSS_HIDE);
				nextLimitBtn.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
				updateLimitAreasSelection(jQuery(this), moduleNode);
			});

			// handle radio button custom time selector change
			moduleNode.on('change', SEL_DATE_TIME_ACTIVITY_SELECTOR, function() {
				moduleNode.find(SEL_MISSING_SELECTION_MESSAGE).addClass(CSS_HIDE);
				nextLimitBtn.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
				updateCustomTimeSelection(jQuery(this));
			});

			// handle radio button recurring/specific day selection change
			moduleNode.on('change', SEL_SPECIFIC_RECURRING_DAY_SELECTOR, function() {
				removeDateMissingErrorMessage(moduleNode, createLimitBtn);
				updateSpecificDaySelection(jQuery(this), moduleNode);
			});

			moduleNode.on('change', SEL_AREAS_BLOCK, function(){
				moduleNode.find(SEL_MISSING_SELECTION_MESSAGE).addClass(CSS_HIDE);
				nextLimitBtn.removeClass(CSS_CURSOR_NONE).attr('disabled', false);
			})

			moduleNode.on('change', SEL_WEEKDAY_OPTION, function(){
				removeDateMissingErrorMessage(moduleNode, createLimitBtn);
			})

			formNode.on('submit', function(event) {
				var isError = whenToCreateLimitValidation(moduleNode, createLimitBtn);
				if(!isError){
					var data = prepareDataToSubmitFromInput(howToApplyLimitBlock, whenToApplyLimitBlock);
					updateHiddenInputDataForSubmit(moduleNode, data);
				}else{
					event.preventDefault();
					isError = false;
				}
			});

			accordionNode.on('click','.header',function(){
				var icon = jQuery(this).find(SEL_ACCORDION_ARROW_ICON);
				var showMoreLess = icon.closest(SEL_SHOW_MORE_LESS_BLOCK);
				var showMore = showMoreLess.find(SEL_SHOW_MORE_LINK);
				var showLess = showMoreLess.find(SEL_SHOW_LESS_LINK);
				var defaultTitle = showMoreLess.prev().find(SEL_DEFAULT_LIMIT_TITLE);
				var newTitle = showMoreLess.prev().find(SEL_LIMIT_TITLE);

				if(icon.hasClass(SEL_ACCORDION_ARROW_DOWN)){
					icon.removeClass(SEL_ACCORDION_ARROW_DOWN);
					icon.addClass(SEL_ACCORDION_ARROW_UP);
					showMore.addClass(CSS_HIDE);
					showLess.removeClass(CSS_HIDE);
					defaultTitle.addClass(CSS_HIDE);
					newTitle.removeClass(CSS_HIDE);
				}else if(!icon.hasClass(SEL_ACCORDION_ARROW_DOWN)){
					icon.removeClass(SEL_ACCORDION_ARROW_UP);
					icon.addClass(SEL_ACCORDION_ARROW_DOWN);
					showLess.addClass(CSS_HIDE);
					showMore.removeClass(CSS_HIDE);
					newTitle.addClass(CSS_HIDE);
					defaultTitle.removeClass(CSS_HIDE);
				}
			});

			accordionNode.on('click', SEL_DELETE_ICON, function(){
				var deleteLimitId = jQuery(this).data('id');
				var deleteUrl = window.config.reservationLimit.deleteLimitUrl + deleteLimitId;
				var deleteConfirmMsg = window.config.reservationLimit.deleteMessage;

				showDeletePopup(moduleNode, deleteConfirmMsg).done(function() {
					deleteSpecificLimit(deleteUrl);
				});
			});

			// to open/close the calendar on click of calendar icon
			calendarIcon.on('click', function(){
				var datePickerNode = moduleNode.closest(SEL_MAIN_CONTENT).siblings(SEL_DATERANGEPICKER);
				
				if(isCalendarOpened > 0){
					datePickerNode.hide();
					isCalendarOpened = 0;
				}else{
					dateRangeInput.trigger('click');
					isCalendarOpened = 1;
				}
			})
        });
    };
};

// Make class public to outside world
module.exports = ReservationLimit;
},{"../form/FormTimepicker":90,"../modals/Confirm":111,"../notification/Notification":125,"./FormObject":100,"jquery":14,"moment":16}],102:[function(require,module,exports){


/**
 * Reservation Limits functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
var ReservationLimit = require('./ReservationLimit');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

  // Instanciate implementing class
  var reservationLimit    = new ReservationLimit();
  
  // Trigger onload activities
  reservationLimit.init(initNode);
});
},{"../mediator/mediator":103,"./ReservationLimit":101}],103:[function(require,module,exports){
var Mediator = function () {
  var observers = [];

  this.subscribe = function (events, listener) {
    var event, i;
    events = events.split(' ');
    for (i in events) {
      if (events.hasOwnProperty(i)) {
        event = events[i];
        (observers[event] || (observers[event] = [])).push(listener);
      }
    }
  };

  this.unsubscribe = function (event, listener) {
    var value, key;
    for (
      value = observers[event] || [];
      (key = value.indexOf(listener)) > -1;
    ) {
      value.splice(key, 1);
    }
    observers[event] = listener ? value : [];
  };

  this.publish = function (event) {
    var args = Array.prototype.slice.call(arguments, 1);
    for (
      var value = observers[event] || [], key = 0;
      key < value.length;
    ) {
      value[key++].apply(this, args);
    }
  };

  this.reset = function () {
    observers = [];
  };
};

// export instance (kind of a singleton pattern)
module.exports = new Mediator();

},{}],104:[function(require,module,exports){
/**
 * Digital Menu Summary Page functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var Tooltipster = require('tooltipster/dist/js/tooltipster.bundle');

// Class definition
var DigitalMenu = function() {

    var SEL_MODULE = '.mod-digitalMenu';

    
    var SEL_DELETE_MENU_CARD		= '.deleteMenuButton';
    var SEL_TOGGLE_MENU             = '.toggleMenu';
    var SEL_MENU_CARD               = '.digitalMenuCard';
    var SEL_ROW                     = '.row';
    var SEL_TEXT_ACTIVE             = '.activeInfo';
    var SEL_TOOLTIP                 = '.tooltip';
    var SEL_TOGGLE                  = '.switch-input';
    var SEL_ACTIVE_INFO_TEXT        = '.infoTextActive';
    var SEL_MENU_TYPE_HEADER        = '.menuTypeHeader';

    var CSS_ACTIVE_INFO             = 'activeInfo';
    var CSS_INACTIVE_INFO           = 'inactiveInfo';
    var CSS_HIDDEN                  = 'hidden';
    var CSS_ALREADY_ACTIVE          = 'alreadyActive';
    var CSS_ACTIVE_MENU_CARD        = 'active-true';
    var CSS_INACTIVE_MENU_CARD      = 'active-false';


    var checkIfMenuTypeHasMenus = function(moduleNode){
        moduleNode.find(SEL_MENU_TYPE_HEADER).each(function(){
            var item = jQuery(this);
            var collapseId = item.attr('href');
            item.parent().find(collapseId).each(function(){
                if(jQuery(this).children().length == 0 ){
                    item.addClass(CSS_HIDDEN);
                }
            });
        });
    };

    var activateMenuAjax = function(item, menuId, moduleNode){
        var toggleMenuUrl = 'menus/toggle/' + menuId;
        var selectMenuCard = 'menuCard-' + menuId;
        var localConfigDigitalMenu = window.config.digitalMenu || [];
        var activeInfoText = localConfigDigitalMenu.activeMenu;
        var inactiveInfoText = localConfigDigitalMenu.inactiveMenu;
        var csrf = localConfigDigitalMenu.csrf;

        //the async is false because there are multiple ajax calls made in a short time which might cause some issues
        jQuery.ajax({
            url: toggleMenuUrl,
            type: 'POST',
            data:{
                menuId: menuId,
                _csrf: csrf,
            },
            async: false,
            dataType: 'json',
            success: function(result, status){
                moduleNode.find(SEL_MENU_CARD).each(function(){
                    var menuCard = jQuery(this);
                    if(menuCard.attr('id') == selectMenuCard){
                        var infoText = menuCard.find(SEL_ACTIVE_INFO_TEXT);
                        if(item.prop('checked')){
                            if(infoText.hasClass(CSS_INACTIVE_INFO)){
                                infoText.removeClass(CSS_INACTIVE_INFO);
                                infoText.addClass(CSS_ACTIVE_INFO);
                                infoText.text(activeInfoText);
                            }else if(infoText.hasClass(CSS_ACTIVE_INFO)){
                                infoText.removeClass(CSS_ACTIVE_INFO);
                                infoText.addClass(CSS_INACTIVE_INFO);
                                infoText.text(inactiveInfoText);
                                item.prop('checked',false);
                            }
                        }else{
                            if(infoText.hasClass(CSS_ACTIVE_INFO)){
                                infoText.removeClass(CSS_ACTIVE_INFO);
                                infoText.addClass(CSS_INACTIVE_INFO);
                                infoText.text(inactiveInfoText);
                            }
                        }
                        if(item.prop('checked')){
                            if(menuCard.hasClass(CSS_INACTIVE_MENU_CARD)){
                                menuCard.removeClass(CSS_INACTIVE_MENU_CARD);
                                menuCard.addClass(CSS_ACTIVE_MENU_CARD);
                            }
                        }else{
                            if(menuCard.hasClass(CSS_ACTIVE_MENU_CARD)){
                                menuCard.removeClass(CSS_ACTIVE_MENU_CARD);
                                menuCard.addClass(CSS_INACTIVE_MENU_CARD);
                            }
                        }
                        menuCard.removeClass(CSS_ALREADY_ACTIVE);
                    }
                });
            }
        });
    };

    this.init = function(initNode){
        
        var moduleNodes = initNode.find(SEL_MODULE);

        moduleNodes.each(function(){
            
            var moduleNode = jQuery(this);
            
            var deleteMenuCardButton = moduleNode.find(SEL_DELETE_MENU_CARD);
            var localConfigDigitalMenu = window.config.digitalMenu || [];
            var csrf = localConfigDigitalMenu.csrf;
            var toggleMenu = moduleNode.find(SEL_TOGGLE_MENU);
            var toggle = moduleNode.find(SEL_TOGGLE);
            
            checkIfMenuTypeHasMenus(moduleNode);

            toggle.on('click',function(){
                var item = jQuery(this);
                var menuId = item.attr('id').split('_')[1];
                var menuType = item.attr('id').split('_')[2];
                //if the toggle is true it means we have to activate a menu, before we have to check if other menus are active and if there are deactivate them
                if(item.prop('checked') && menuType == 'FIXED'){
                    moduleNode.find(SEL_MENU_CARD).each(function(){
                        var menuCard = jQuery(this);
                        if(menuCard.hasClass('FIXED') && menuCard.hasClass(CSS_ACTIVE_MENU_CARD)){
                            var itemToDeactivate = menuCard.find(toggle);
                            var menuToDeactivateId = itemToDeactivate.attr('id').split('_')[1];
                            activateMenuAjax(itemToDeactivate, menuToDeactivateId, moduleNode);
                        }
                    });
                }
                activateMenuAjax(item, menuId, moduleNode);
            });

			deleteMenuCardButton.on('click', function(){
                var id = jQuery(this).parent().attr('id');
                var deleteMenuUrl = 'menus/edit/' + id;
				jQuery.ajax({
					url: deleteMenuUrl,
                    type: 'DELETE',
                    data:{
                        menuId: id,
                        _csrf: csrf,
                    },  
                    dataType: 'json',
                    success: function(result, status){
                        moduleNode.find(SEL_MENU_CARD).each(function(){
                            var item = jQuery(this);
                            var menuCardId = 'menuCard-' + id; 
                            if(item.attr('id') == menuCardId){
                                item.remove();
                                checkIfMenuTypeHasMenus(moduleNode);
                            }
                        });
                    }
				});
            });
            moduleNode.find(SEL_TOOLTIP).tooltipster({
                maxWidth: 250,
                delay: 100,
                trigger: 'custom',
                triggerOpen: {
                    mouseenter: true,
                    tap: true
                },
                triggerClose: {
                    mouseleave: true,
                    tap: true
                }
            });

        });
    }
};

// Make class public to outside world
module.exports = DigitalMenu;

},{"jquery/dist/jquery":14,"tooltipster/dist/js/tooltipster.bundle":20}],105:[function(require,module,exports){
/**
 * Functionality of editing or adding a menu.
 *
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
var moment = require('moment/min/moment-with-locales');
Sortable = require('sortablejs/Sortable');
var StringUtils     		= require('../utils/StringUtils');
var UserInterfaceUtils 		= require('../utils/UserInterfaceUtils');

var MenuData  = require('./MenuData');
var MenuInterval = require('./MenuInterval');
var MenuItem 	  = require('./MenuItem');

// Class definition
EditMenu = function() {

    // self references
    var self;

	// selector constants
	var SEL_MODULE					= '.mod-editMenu';

	var SEL_CARD_CHOOSE_MENU		= '.chooseMenu';
	var SEL_CHECKBOX_MENU			= '.checkboxMenu';
	var SEL_MENU_CARD				= '.menuCard';
	var SEL_TIME_MENU				= '.timeMenu';
	var SEL_TIME_RANGE_TIME_MENU	= '.timeRangeTimeMenu';
	var SEL_CUSTOM_CHECKBOX			= '.customCheckbox';
	var SEL_ERROR_INFO_MESSAGE		= '.errorMessage';
	var SEL_NO_CATEGORY_CHECK		= '#noCategory';
	var SEL_DATE_RANGE_INPUT		= '.date-range-input';
	var SEL_CATEGORIES_SECTION		= '.categoriesSection';
	var SEL_TITLE_SECTION			= '.titleSection';
	var SEL_TITLE_INPUT				= '#titleInfo';
	var SEL_MIDDLE_SECTION			= '.middleSection';
	var SEL_INPUT_MENU_DAYS			= '#input-menuDays';
	var SEL_INPUT_TIME_TYPE			= '#input-timeType';
	var SEL_INPUT_SPECIAL_TYPE		= '#input-specialMenu';
	var SEL_ACTIVE_MENU				= '.activeMenu';
	var SEL_CATEGORY_INPUT 			= '.inputItem';
	var SEL_CATEGORY_INPUT_NAME		= '.input-name';
	var SEL_CATEGORY_CONTAINER		= '.itemContainer';
	var SEL_CATEGORY_TEMPLATE_ITEM	= '.templateItem';
	var SEL_DIHES_SECTION 			= '.dishesSection';
	
	var SEL_CATEGORIES_CONTAINER	= '.categoriesContainer';
	var SEL_CATEGORIES_SECTION_ITEM	= '.categorySectionItem';
	var SEL_CATEGORY_SECTION_TEMPLATE = '.categoryTemplate';
	var SEL_CATEGORY_NAME			= '.categoryName';
	var SEL_CATEGORY_HEADER			= '.categoryHeader';
	var SEL_DISHES_CONTAINER 		= '.dishesContainer';
	var SEL_DISH_ITEM_TEMPLATE		= '.templateDishItem';
	var SEL_DISH_ITEM 				= '.dishItem';
	var SEL_DISH_ITEM_NAME			= '.itemName';
	var SEL_DISH_ITEM_DESCRIPTION	= ".itemDescription";
	var SEL_DISH_ITEM_DIET_TYPE		= '#input-dietTypes';
	var SEL_DISH_ITEM_QUANTITY		= '.itemQuantity';
	var SEL_DISH_ITEM_PRICE			= '.itemPrice';

	var SEL_COLLAPSE				= '.collapse'
	
	var SEL_ID_SORTABLE_CATEGORIES			= 'sortableCategories';
	var SEL_ID_SORTABLE_DISHES				= 'dishSortable';

	var SEL_SUBMIT_FORM_BTN 				= '.submitFormBtn';
	var SEL_BTN_ADD_CATEGORY_ITEM			= '.btnAddCategoryItem'
	var SEL_BTN_DELETE_CATEGORY_ITEM		= '.deleteCategoryItem';

	var SEL_BTN_ADD_DISH_ITEM 				= '.btnAddDishItem';
	var SEL_BTN_DELETE_DISH_ITEM			= '.deleteDishItem';
	var SEL_MOVE_DISH_UP					= '.moveItemUpButton';
	var SEL_MOVE_DISH_DOWN					= '.moveItemDownButton';

	var SEL_DATA_SUBMISSION_CONTAINER		= '.containerDataSubmission';

	var CSS_CLASS_ACTIVE_MENU				= 'activeMenu';
	var CSS_CLASS_HIDDEN					= 'hidden';
	var CSS_CLASS_TIME_MENU					= 'timeMenu';
	var CSS_CLASS_TEMPLATE_ITEM				= 'templateItem';
	var CSS_CLASS_CATEGORY_TEMPLATE			= 'categoryTemplate';
	var CSS_CLASS_INPUT_ITEM				= 'inputItem';
	var CSS_CLASS_DISH_ITEM_TEMPLATE		= 'templateDishItem';
	var CSS_CLASS_INPUT_ERROR				= 'inputError';
	var CSS_CLASS_DISH_ITEM					= 'dishItem';

	var DATA_ATTR_START_DATE				= 'startDate';
	var DATA_ATTR_START_DATE_INPUT			= 'data-start-date';
	var DATA_ATTR_END_DATE					= 'endDate';
	var DATA_ATTR_END_DATE_INPUT			= 'data-end-date';
	var DATA_ATTR_URL_PATTERN				= 'urlPattern';

	var SYSTEM_DATE_FORMAT					= 'YYYY-MM-DD';

	var FORM_ERROR_TYPE						= "form-error";
	var FORM_EVENT_TYPE						= "error-form";
	var FORM_EVENT_NAME						= "error";
	var FORM_EVENT_ACTION_NAME				= "titleInfo";
	var FORM_ERROR_MESSAGE					= "Please check the error inputs.";

	//initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.error = window._adl.error || {};

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;
		//startdate and enddate for specialMenu
		var startSpecialMenuDate;
		var endSpecialMenuDate;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		var categoryId = 0;
		var categorySectionId = 0;
		var menuId;
		var dishId = 0;

		var getCategorySectionId = function(){
			return categorySectionId++;
		};
		
		var getDishId = function(){
			return dishId++;
		};

		var updateSpecialMenuTimes = function(startDate, endDate){
			startSpecialMenuDate = startDate.format(SYSTEM_DATE_FORMAT);
			endSpecialMenuDate = endDate.format(SYSTEM_DATE_FORMAT);
		};

		var getSpecialMenuStartTime = function(){
			return startSpecialMenuDate;
		}
		
		var getSpecialMenuEndTime = function(){
			return endSpecialMenuDate;
		};

		var getCategoryId = function(){
			return categoryId++;
		}
		var checkOtherMenuCards = function(menuCards){
			menuCards.each(function(){
				var menu = jQuery(this);
				var checkbox = menu.find(SEL_CHECKBOX_MENU);
				if(checkbox.prop('checked') == true){
					checkbox.prop('checked',false);
					checkbox.parentsUntil(SEL_MIDDLE_SECTION).removeClass(CSS_CLASS_ACTIVE_MENU);
				}
			});
		};

		var submitDataForm = function(moduleNode, menuData, dataContainerSubmission){

			var inputId = dataContainerSubmission.find('#inputId');
			inputId.attr('value', menuId);

			var inputName = dataContainerSubmission.find('#inputName');
			inputName.attr('value', menuData.name);

			var inputMenuType = dataContainerSubmission.find('#inputMenuType');
			inputMenuType.attr('value', menuData.menuType);

			var inputTimeType = dataContainerSubmission.find('#inputTimeType');
			inputTimeType.attr('value', menuData.timeType);

			var inputStartDate = dataContainerSubmission.find('#inputStartDate');
			if(menuData.startDate != null){
				var startDate = moment(menuData.startDate, SYSTEM_DATE_FORMAT);	
				inputStartDate.attr('value', startDate.format());
			}else{
				inputStartDate.attr('value', null);
			}

			var inputEndDate = dataContainerSubmission.find('#inputEndDate');
			if(menuData.endDate != null){
				var endDate = moment(menuData.endDate, SYSTEM_DATE_FORMAT);
				inputEndDate.attr('value', endDate.format());
			}else{

				inputEndDate.attr('value', null);
			}

			var inputWeekdays = dataContainerSubmission.find('#inputWeekdays');
			inputWeekdays.val(menuData.weekdays);
			
			//the menuCategories and menuIntervals are build dynamically because the FE has to provide a list
			var attrName = 'name';
			for(var index = 0; index < menuData.categoryNames.length; index++){

				var inputIdTag = document.createElement("input");
				var path = 'menuCategories['+index+'].id';
				var categoryId;
				moduleNode.find(SEL_CATEGORY_INPUT).each(function(){
					var inputItem = jQuery(this);
					inputItem.find(SEL_CATEGORY_INPUT_NAME).each(function(){
						if(jQuery(this).val() == menuData.categoryNames[index]){
							categoryId = inputItem.attr('id');
						}
					});
				});
				
				jQuery(inputIdTag).attr(attrName, path);
				jQuery(inputIdTag).val(categoryId);

				var inputNameTag = document.createElement("input");
				var path = 'menuCategories['+index+'].name';
				var categoryName = menuData.categoryNames[index];
				jQuery(inputNameTag).attr(attrName,path);
				jQuery(inputNameTag).val(categoryName);
				
				var menuList = menuData.menuCategories.get(categoryName);
				dataContainerSubmission.append(inputIdTag);
				dataContainerSubmission.append(inputNameTag);

				for(var j=0; j<menuList.length;j++){

					var inputMenuItemTag = document.createElement("input");

					var path = 'menuCategories['+ index + '].menuItems[' + j + ']';

					var pathId = path + '.id';
					var inputMenuItemId = document.createElement("input");
					jQuery(inputMenuItemId).attr(attrName,pathId);
					jQuery(inputMenuItemId).val(menuList[j].id);

					var pathName = path + '.name';
					var inputMenuItemName = document.createElement("input");
					jQuery(inputMenuItemName).attr(attrName,pathName);
					jQuery(inputMenuItemName).val(menuList[j].name);

					var pathDescription = path + '.description';
					var inputMenuItemDescription = document.createElement("input");
					jQuery(inputMenuItemDescription).attr(attrName,pathDescription);
					jQuery(inputMenuItemDescription).val(menuList[j].description);

					var pathSize = path + '.size';
					var inputMenuItemSize = document.createElement("input");
					jQuery(inputMenuItemSize).attr(attrName,pathSize);
					jQuery(inputMenuItemSize).val(menuList[j].size);

					var pathPrice = path + '.price';
					var inputMenuItemPrice = document.createElement("input");
					jQuery(inputMenuItemPrice).attr(attrName,pathPrice);
					jQuery(inputMenuItemPrice).val(menuList[j].price);

					dataContainerSubmission.append(inputMenuItemId);
					dataContainerSubmission.append(inputMenuItemName);
					dataContainerSubmission.append(inputMenuItemDescription);

					var dietTypeList = menuList[j].dietType;
					for(var i=0; i<dietTypeList.length; i++){
						var pathDietType = path + '.dietTypes['+i+']';
						var inputMenuItemDietType = document.createElement("input");
						jQuery(inputMenuItemDietType).attr(attrName,pathDietType);
						jQuery(inputMenuItemDietType).val(dietTypeList[i]);
						dataContainerSubmission.append(inputMenuItemDietType);
					}
					
					
					dataContainerSubmission.append(inputMenuItemSize);
					dataContainerSubmission.append(inputMenuItemPrice);
				}
				
			}

			var menuIntervals = menuData.timeMenuInterval;
			
			var path = 'menuInterval';
			var pathName = path + '.startHour';
			var inputMenuIntervalStartHour = document.createElement("input");
			jQuery(inputMenuIntervalStartHour).attr(attrName,pathName);
			if(menuIntervals == undefined){
				jQuery(inputMenuIntervalStartHour).val('');
			}else{

				jQuery(inputMenuIntervalStartHour).val(menuIntervals.startHour);
			}

			var pathName = path + '.startMinute';
			var inputMenuIntervalStartMinute = document.createElement("input");
			jQuery(inputMenuIntervalStartMinute).attr(attrName,pathName);
			if(menuIntervals == undefined){
				jQuery(inputMenuIntervalStartMinute).val('');
			}else{	
				jQuery(inputMenuIntervalStartMinute).val(menuIntervals.startMinute);
			}

			var pathName = path + '.endHour';
			var inputMenuIntervalEndHour = document.createElement("input");
			jQuery(inputMenuIntervalEndHour).attr(attrName,pathName);
			if(menuIntervals == undefined){
				jQuery(inputMenuIntervalEndHour).val('');
			}else{	
				jQuery(inputMenuIntervalEndHour).val(menuIntervals.endHour);
			}
			
			var pathName = path + '.endMinute';
			var inputMenuIntervalEndMinute = document.createElement("input");
			jQuery(inputMenuIntervalEndMinute).attr(attrName,pathName);
			if(menuIntervals == undefined){
				jQuery(inputMenuIntervalEndMinute).val('');
			}else{	
				jQuery(inputMenuIntervalEndMinute).val(menuIntervals.endMinute);
			}

			dataContainerSubmission.append(inputMenuIntervalStartHour);
			dataContainerSubmission.append(inputMenuIntervalStartMinute);
			dataContainerSubmission.append(inputMenuIntervalEndHour);
			dataContainerSubmission.append(inputMenuIntervalEndMinute);
		};

		var gatherDataForm = function(moduleNode){
			
			var chooseMenuSection = moduleNode.find(SEL_CARD_CHOOSE_MENU);
			var titleSection 	  = moduleNode.find(SEL_TITLE_INPUT);
			var categoriesSection = moduleNode.find(SEL_CATEGORIES_SECTION);
			var dishesSection 	  = moduleNode.find(SEL_DIHES_SECTION);
			var dataContainerSubmission = moduleNode.find(SEL_DATA_SUBMISSION_CONTAINER);
			

			//Gather data from choose menu section
			var menuCard = chooseMenuSection.find(SEL_MIDDLE_SECTION).find(SEL_ACTIVE_MENU);
			var menuType = menuCard.attr('id');
			var menuTitle = titleSection.val();
			if(menuTitle == ''){
				titleSection.parent().addClass(CSS_CLASS_INPUT_ERROR);
				return false;
			}
			var weekdays = [];
			var timeType = null;
			var startDate = null;
			var endDate = null;
			var timeInterval = [];

			//Gather menu data for different type of menus
			switch(menuType){
				case "FIXED":
					break;
				case "DAILY":
					var daysSelect = menuCard.find(SEL_INPUT_MENU_DAYS);
					
					daysSelect.find('option').each(function(){
						var optionItem = jQuery(this);
						if(optionItem.prop('selected')){
							weekdays.push(optionItem.val());
						}
					});
					if(weekdays.length < 1){
						daysSelect.parent().addClass(CSS_CLASS_INPUT_ERROR);
						return false;
					}
					break;
				case "TIME":
					var timeTypeSelected = menuCard.find(SEL_INPUT_TIME_TYPE);
					timeType = timeTypeSelected.val();
					if(timeType == ''){
						timeTypeSelected.parent().addClass(CSS_CLASS_INPUT_ERROR);
						return false;
					}
					var timeRange = chooseMenuSection.find(SEL_TIME_RANGE_TIME_MENU);
					timeRange.find('.form-control').each(function(){
						var item = jQuery(this);
						if(!item.parent().parent().find('.meridiem-toggle').hasClass('toggle-active')){
							timeInterval.push(item.val());
						}else{
							if(item.attr('data-field') == 'hours'){
								var time12hrFormat = parseInt(item.val()) + 12;
								timeInterval.push(time12hrFormat);
							}else{
								timeInterval.push(item.val());
							}
						}
						
					});
					var menuTimeInterval = new MenuInterval(timeInterval[0],timeInterval[1],timeInterval[2],timeInterval[3]);
					break;
				case "SPECIAL":
					startDate = getSpecialMenuStartTime();
					endDate = getSpecialMenuEndTime();
					if(startDate == undefined || endDate == undefined){
						var inputSpecialMenu = menuCard.find(SEL_DATE_RANGE_INPUT);
						startDate = inputSpecialMenu.attr(DATA_ATTR_START_DATE_INPUT);
						endDate = inputSpecialMenu.attr(DATA_ATTR_END_DATE_INPUT);
					}
					break;
			}
			
			//Gather categories and menu items
			var categoryItems = new Map();
			var categoryNames = [];
			var errorFound = false;
			dishesSection.find(SEL_CATEGORIES_SECTION_ITEM).each(function(){
				var isTemplateItem = jQuery(this).hasClass('categoryTemplate');
				if(!isTemplateItem){
					var item = jQuery(this);
					var menuItemsList = [];
					var categoryName = item.find(SEL_CATEGORY_NAME).text();
					categoryNames.push(categoryName);
					var dishesContainer = item.find(SEL_DISHES_CONTAINER);
					dishesContainer.find(SEL_DISH_ITEM).each(function(){
						var menuItem = jQuery(this);
						if(!menuItem.hasClass(SEL_CATEGORY_TEMPLATE_ITEM)){
							var id = menuItem.attr('id');
							var itemName = menuItem.find(SEL_DISH_ITEM_NAME).val();
							if(itemName == ''){
								menuItem.find(SEL_DISH_ITEM_NAME).addClass(CSS_CLASS_INPUT_ERROR);
								errorFound = true;
							}
							var itemDescription = menuItem.find(SEL_DISH_ITEM_DESCRIPTION).val();
							var itemDietType = [];
							menuItem.find('option').each(function(){
								var optionItem = jQuery(this);
								if(optionItem.prop('selected')){
									itemDietType.push(optionItem.val());
								}
							});
							var itemQuantity = menuItem.find(SEL_DISH_ITEM_QUANTITY).val();
							var itemPrice = menuItem.find(SEL_DISH_ITEM_PRICE).val();
							if(itemPrice == ''){
								menuItem.find(SEL_DISH_ITEM_PRICE).addClass(CSS_CLASS_INPUT_ERROR);
								errorFound = true;
							}
							var menuItem = new MenuItem(id, itemName, itemDescription, itemQuantity, itemPrice, itemDietType);
							menuItemsList.push(menuItem);
						}
					});
					if(errorFound == false){
						categoryItems.set(categoryName, menuItemsList);
					}
				}
			});
			if(errorFound == true){
				return false;
			}
			var menuData = new MenuData(menuTitle, menuType, timeType, startDate, endDate, weekdays, categoryItems,categoryNames, menuTimeInterval);

			submitDataForm(moduleNode, menuData, dataContainerSubmission);
			
			return true;
		};

		var prepareFormForSubmission = function(moduleNode){
			var data = gatherDataForm(moduleNode);

			return data;
		};

		var buildDatePickerRanges = function(config) {
			var ranges = {};
	
			ranges[config.TODAY] = [
				moment(),
				moment()
			];
			ranges[config.THIS_WEEK] = [
				moment().startOf('week').add(1, 'day'), // picker week starts on Sun, but we need Monday (so +1 day)
				moment().startOf('week').add(1, 'week')
			];
			ranges[config.NEXT_WEEK] = [
				moment().startOf('week').add(1, 'week').add(1, 'day'), // picker week starts on Sun, but we need Monday (so +1 day)
				moment().startOf('week').add(2, 'week')
			];
			ranges[config.THIS_MONTH] = [
				moment().startOf('month'),
				moment().startOf('month').add(1, 'month').subtract(1, 'day') // we need to step back one day to select the last day of month
			];
			ranges[config.NEXT_MONTH] = [
				moment().startOf('month').add(1, 'month'),
				moment().startOf('month').add(2, 'month').subtract(1, 'day') // we need to step back one day to select the last day of month
			];
	
			return ranges;
		};

		var parseInitialDate = function(str) {
			if (!str || str === '') {
				return null;
			}
			return moment(str, SYSTEM_DATE_FORMAT);
		};

		var initDateRangeSelector = function(moduleNode, localConfig) {
			var dateRangeInput 			= moduleNode.find(SEL_DATE_RANGE_INPUT);
	
			var startDate = parseInitialDate(dateRangeInput.data(DATA_ATTR_START_DATE));
			if (!startDate) {
				startDate = moment().startOf('day');
			}
			var endDate = parseInitialDate(dateRangeInput.data(DATA_ATTR_END_DATE));
			if (!endDate) {
				endDate = moment(endDate);
			}

			var isDeviceMobile = UserInterfaceUtils.isDeviceMobile();
			var displayFormat = isDeviceMobile ? localConfig.dateFormatShort : localConfig.dateFormat;

			var locale = jQuery.extend({}, localConfig.locale, {
				format: displayFormat || 'DD/MM/YYYY',
				firstDay: 1, // start on monday
			});

			dateRangeInput.daterangepicker({
				opens: isDeviceMobile ? 'center' : 'right',
				timePicker: false,
				startDate: startDate,
				endDate: endDate,
				linkedCalendars: !isDeviceMobile,
				// showDropdowns: true,
				locale: locale,
				alwaysShowCalendars: true
			}, function(start, end, label) {
				updateSpecialMenuTimes(start, end);
			});
			
		};

		var addCategoryItem = function(moduleNode){
			var categoryContainer = moduleNode.find(SEL_CATEGORY_CONTAINER);
			var templateItem 	  = moduleNode.find(SEL_CATEGORY_TEMPLATE_ITEM);
			var newCategoryItem   = templateItem.clone();
			var newItem = jQuery(newCategoryItem);
			newItem.addClass(CSS_CLASS_INPUT_ITEM);
			newItem.removeClass(CSS_CLASS_TEMPLATE_ITEM);
			newItem.find('.form-control').val('');
			var categoryItemId = getCategoryId();
			newItem.addClass('categoryItem' + categoryItemId);
			jQuery(categoryContainer).append(newCategoryItem);

		};

		var deleteCategoryItem = function(moduleNode, itemToDelete){
			var categoryContainer = moduleNode.find(SEL_CATEGORY_CONTAINER);
			categoryContainer.find(itemToDelete).remove();
		};

		var isCategoryAdded = function(categoryName, moduleNode){
			var isExistent = false;
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);
			containerCategories.find(SEL_CATEGORY_NAME).each(function(){
				if(jQuery(this).text() == categoryName){
					isExistent = true;
				}
			});
			return isExistent;
		};

		var makeCategoriesSortable = function(){
			var sortableNode = document.getElementById(SEL_ID_SORTABLE_CATEGORIES);
			if (sortableNode.childElementCount > 1) {
				Sortable.create(sortableNode, {
					animation: 150,
					ghostClass:'blue-background-class'
				});
			};
		};

		var makeDishesSortable = function(dishSortableID){
			//every category has to have a container with a unique id so the items inside can be sortable
			var sortableNode = document.getElementById(dishSortableID);
			Sortable.create(sortableNode,{
				animation: 150,
				ghostClass:'blue-background-class'
			});
		};
		var setInputFilter = function(itemPriceInput, inputFilter) {
			["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
				itemPriceInput.addEventListener(event, function() {
				if (inputFilter(this.value)) {
				  this.oldValue = this.value;
				  this.oldSelectionStart = this.selectionStart;
				  this.oldSelectionEnd = this.selectionEnd;
				} else if (this.hasOwnProperty("oldValue")) {
				  this.value = this.oldValue;
				  this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
				} else {
				  this.value = "";
				}
			  });
			});
		}

		var addDishWithDataToCategory = function(categoryInWhichToAdd, menuItem){
			
			var dishesContainer = categoryInWhichToAdd.find(SEL_DISHES_CONTAINER);
			var dishItemTemplate = categoryInWhichToAdd.find(SEL_DISH_ITEM_TEMPLATE);
			var newDishItem = dishItemTemplate.clone(true);
			newDishItem.removeClass(CSS_CLASS_HIDDEN);
			newDishItem.removeClass(CSS_CLASS_DISH_ITEM_TEMPLATE);
			newDishItem.find('.bootstrap-select').replaceWith(function() { return jQuery('select', this); });
			newDishItem.find('select').selectpicker();
			newDishItem.addClass(CSS_CLASS_DISH_ITEM);
			newDishItem.find('.itemName').val(menuItem.name);
			newDishItem.find('.itemDescription').val(menuItem.description);
			newDishItem.find('.itemQuantity').val(menuItem.size);
			var itemPriceInput = newDishItem.find('.itemPrice');
			itemPriceInput.val(menuItem.price);
			setInputFilter(itemPriceInput[0], function(value) {
				return /^-?\d*[.,]?\d{0,2}$/.test(value); });
			newDishItem.attr('id', menuItem.id);
			if(menuItem.dietType != '[]' && menuItem.dietType != undefined){
				newDishItem.find('#input-dietTypes').each(function(){
					var input = jQuery(this);
					jQuery(this).find('option').each(function(){
						var item = jQuery(this);
						if(item.val() != ''){
							if(menuItem.dietType.includes(item.val())){
								item.prop('selected',true);
								input.selectpicker('refresh');
							}
						}
					});
				});	
			}
			dishesContainer.append(newDishItem);
		};
		var disableDeleteCategoryButton = function(moduleNode, categoryName){
			var middleSection = moduleNode.find(SEL_MIDDLE_SECTION);

			middleSection.find(SEL_CATEGORY_INPUT_NAME).each(function(){
				if(jQuery(this).val()==categoryName){
					jQuery(this).parent().find(SEL_BTN_DELETE_CATEGORY_ITEM).prop('disabled',true);
				}
			});
		};

		var enableDeleteCategoryButton = function(moduleNode, categoryItem){
			var middleSection = moduleNode.find(SEL_MIDDLE_SECTION);
			var categoryName;
			categoryItem.each(function(){
				categoryName = jQuery(this).find(SEL_CATEGORY_NAME).text();
			});
			var dishesContainer = categoryItem.find(SEL_DISHES_CONTAINER);
			var nbOfDishes = dishesContainer.find(SEL_DISH_ITEM);
			if(nbOfDishes.length == 0){	
				middleSection.find(SEL_CATEGORY_INPUT_NAME).each(function(){
					if(jQuery(this).val() == categoryName){
						jQuery(this).parent().find(SEL_BTN_DELETE_CATEGORY_ITEM).prop('disabled',false);
					}
				});
			}
		};
		

		var addDishToCategory = function(categoryInWhichToAdd, moduleNode, index){
			var dishesContainer = categoryInWhichToAdd.find(SEL_DISHES_CONTAINER);
			var dishItemTemplate = categoryInWhichToAdd.find(SEL_DISH_ITEM_TEMPLATE);
			var newDishItem = dishItemTemplate.clone(true);
			newDishItem.removeClass(CSS_CLASS_HIDDEN);
			newDishItem.removeClass(CSS_CLASS_DISH_ITEM_TEMPLATE);
			var menuItemId = getDishId();
			dishesContainer.append(newDishItem);
			newDishItem.attr('id',menuItemId);
			newDishItem.find('.bs-title-option').remove();
			var copySelect = newDishItem.find('select').clone();
			newDishItem.find('.bootstrap-select').remove();
			newDishItem.find('.form-group-dietTypes').append(copySelect);
			newDishItem.find('select').attr('id',menuItemId);
			newDishItem.find('.selectpicker').selectpicker();
			var itemPriceInput = newDishItem.find('.itemPrice');
			setInputFilter(itemPriceInput[0], function(value) {
				return /^-?\d*[.,]?\d{0,2}$/.test(value); });
			newDishItem.addClass(CSS_CLASS_DISH_ITEM);
			var addedDish = categoryInWhichToAdd.find(SEL_DISH_ITEM);
			if (addedDish.length > 1) {
				Sortable.create(dishesContainer[0], {
					animation: 150,
					ghostClass: 'blue-background-class'
				});
			};

			
		};

		var deleteDishFromCategory = function(moduleNode, buttonPressed){
			var dishItem = buttonPressed.parentsUntil(SEL_DISHES_CONTAINER);
			var categoryItem = buttonPressed.parentsUntil(SEL_CATEGORIES_SECTION_ITEM);
			dishItem.remove();
			enableDeleteCategoryButton(moduleNode, categoryItem);
		};

		//if the nb of categories in step2 > nb of categories in step3, we rename the one that is not in step2
		var checkRename = function(categoriesItems, moduleNode, newName){
			var isRename=false;
			var isExistent = false;
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);
			containerCategories.find(SEL_CATEGORY_NAME).each(function(){
				isExistent = false;
				for(var index=0; index < categoriesItems.length; index++){
					if(jQuery(this).text() == categoriesItems[index]){
						isExistent = true;
					}
				}
				if(isExistent == false){
					jQuery(this).text(newName);
					isRename=true;
				}
			});
			
			return isRename;
		};
		var statusEnableCategoryInputs= function(moduleNode, disable){
			var middleSectionNode = moduleNode.find(SEL_MIDDLE_SECTION);
			middleSectionNode.find('input').each(function(){
				var input = jQuery(this);
				input.prop('disabled',disable);
			});
		};
		var deleteCategories = function(moduleNode){		
			var middleSectionNode = moduleNode.find(SEL_MIDDLE_SECTION); 
			middleSectionNode.find(SEL_CATEGORY_INPUT).each(function(){
				jQuery(this).remove();
			});
			addCategoryItem(moduleNode);
		};

		var moveDishesToEmptyCategory = function(categoryInWhichToAdd, moduleNode){
			var dishesSection = moduleNode.find(SEL_DIHES_SECTION);

			var menuItemsList = [];
			dishesSection.find(SEL_CATEGORIES_SECTION_ITEM).each(function(){
				var item = jQuery(this);
				var dishesContainer = item.find(SEL_DISHES_CONTAINER);
				dishesContainer.find(SEL_DISH_ITEM).each(function(){
					var menuItem = jQuery(this);
					if(!menuItem.hasClass(SEL_CATEGORY_TEMPLATE_ITEM)){
						var id = menuItem.attr('id');
						var itemName = menuItem.find(SEL_DISH_ITEM_NAME).val();
						var itemDescription = menuItem.find(SEL_DISH_ITEM_DESCRIPTION).val();
						var itemDietType;
						menuItem.find('option').each(function(){
							var optionItem = jQuery(this);
							if(optionItem.prop('selected')){
								itemDietType = optionItem.val();
							}
						});
						var itemQuantity = menuItem.find(SEL_DISH_ITEM_QUANTITY).val();
						var itemPrice = menuItem.find(SEL_DISH_ITEM_PRICE).val();
						var menuItem = new MenuItem(id, itemName, itemDescription, itemQuantity, itemPrice, itemDietType);
						menuItemsList.push(menuItem);
					}
				});
				if(!item.hasClass('categoryTemplate')){
					item.remove();
				}
			});

			for(var index=0; index< menuItemsList.length; index++){
				addDishWithDataToCategory(categoryInWhichToAdd, menuItemsList[index]);
			}
		};

		var addEmptyCategory = function(moduleNode){
			var index = -1;
			var noCategoryName = window.config.editMenu.noCategoryName || [];
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);
			var categoriesSectionTemplate = moduleNode.find(SEL_CATEGORY_SECTION_TEMPLATE);
			var newCategorySection = categoriesSectionTemplate.clone();
			var isAlreadyNoCategory = isCategoryAdded(noCategoryName, moduleNode);
			if( isAlreadyNoCategory == false){
				newCategorySection.removeClass(CSS_CLASS_HIDDEN);
				newCategorySection.removeClass(CSS_CLASS_CATEGORY_TEMPLATE);
				newCategorySection.find(SEL_CATEGORY_HEADER).attr('data-target', '#dishesSection' + index);
				newCategorySection.find(SEL_COLLAPSE).prop('id','dishesSection' + index);
				var dishId = getDishId();
				var dishSortableID = 'dishSortable' + dishId;
				newCategorySection.find(SEL_DISHES_CONTAINER).prop('id',dishSortableID);
				var categorySectionId = getCategorySectionId();
				newCategorySection.addClass('categorySection' + categorySectionId);
				newCategorySection.find(SEL_CATEGORY_NAME).text(noCategoryName);
				moveDishesToEmptyCategory(newCategorySection, moduleNode);
				containerCategories.append(newCategorySection);
				makeDishesSortable(dishSortableID);
			}

		};
		var isNoCategorySelected = function(categoriesItems, moduleNode){
			var noCategoryName = window.config.editMenu.noCategoryName || [];
			var isNoCategory = isCategoryAdded(noCategoryName, moduleNode);
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);

			if(isNoCategory){
				containerCategories.find(SEL_CATEGORY_NAME).each(function(){
					if(jQuery(this).text() == noCategoryName){
						jQuery(this).text(categoriesItems[0]);
					}
				});
			}
		};

		var addCategorySection = function(categoriesItems, moduleNode){
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);
			var categoriesSectionTemplate = moduleNode.find(SEL_CATEGORY_SECTION_TEMPLATE);
			var newName;
			for(var index = 0 ; index < categoriesItems.length; index++){
				var isAlreadyACategory = isCategoryAdded(categoriesItems[index], moduleNode);
				if( isAlreadyACategory == false){
					newName = categoriesItems[index];
					var isRename = checkRename(categoriesItems, moduleNode, newName);
					if(!isRename){
						var newCategorySection = categoriesSectionTemplate.clone();
						newCategorySection.removeClass(CSS_CLASS_HIDDEN);
						newCategorySection.removeClass(CSS_CLASS_CATEGORY_TEMPLATE);
						newCategorySection.find(SEL_CATEGORY_HEADER).attr('data-target', '#dishesSection'+index);
						newCategorySection.find(SEL_COLLAPSE).prop('id','dishesSection'+index);
						var dishId = getDishId();
						var dishSortableID = 'dishSortable' + dishId; 
						newCategorySection.find(SEL_DISHES_CONTAINER).prop('id',dishSortableID);
						var categorySectionId = getCategorySectionId();
						newCategorySection.addClass('categorySection' + categorySectionId);
						newCategorySection.find(SEL_CATEGORY_NAME).text(categoriesItems[index]);
						addDishToCategory(newCategorySection, moduleNode, index);
						disableDeleteCategoryButton(moduleNode, categoriesItems[index]);
						containerCategories.append(newCategorySection);
						makeDishesSortable(dishSortableID);
					} 
				}
			}
		};

		var deleteCategorySection = function(moduleNode, itemToDelete){
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);
			var nameToDelete = itemToDelete.find(SEL_CATEGORY_INPUT_NAME).val();
			containerCategories.find(SEL_CATEGORY_NAME).each(function(){
				var item = jQuery(this);
				if(item.text() == nameToDelete){
					item.parentsUntil(SEL_CATEGORIES_CONTAINER).remove();
				}
			});
		};

		var initDishesSection = function(categoriesItems, moduleNode){
			//insert category section into the container
			isNoCategorySelected(categoriesItems, moduleNode);
			addCategorySection(categoriesItems, moduleNode);
			makeCategoriesSortable();

		};

		var inputExistentDataToMenuSelection = function(menuTitle, weekdays, menuType, timeType, startDate, endDate ,menuIntervalForm, moduleNode){

			var chooseMenuSection = moduleNode.find(SEL_CARD_CHOOSE_MENU);
			var timeRange = moduleNode.find(SEL_TIME_RANGE_TIME_MENU);
			var titleSection 	  = moduleNode.find(SEL_TITLE_INPUT);
			titleSection.val(menuTitle);
			
			chooseMenuSection.find(SEL_MIDDLE_SECTION).find(SEL_MENU_CARD).each(function(){
				var menuCard = jQuery(this);
				if(menuCard.attr('id') == menuType){
					menuCard.addClass(CSS_CLASS_ACTIVE_MENU);
					menuCard.find(SEL_CHECKBOX_MENU).each(function(){
						jQuery(this).prop('checked',true);
					});
				}
			});
			var menuCard = chooseMenuSection.find(SEL_MIDDLE_SECTION).find(SEL_ACTIVE_MENU);

			switch(menuType){
				case "FIXED":
					break;
				case "DAILY":
					var daysSelect = menuCard.find(SEL_INPUT_MENU_DAYS);
					//TODO when weekdays are implemented
					daysSelect.find('option').each(function(){
						var optionItem = jQuery(this);
						if(weekdays.includes(optionItem.val())){
							optionItem.prop('selected',true);
						}
					});
					break;
				case "TIME":
					var timeTypeSelect = menuCard.find(SEL_INPUT_TIME_TYPE);
					timeTypeSelect.find('option').each(function(){
						var optionItem = jQuery(this);
						if(optionItem.val() == timeType){
							optionItem.parent().selectpicker('val',timeType);
						}
					});
					
					timeRange.removeClass(CSS_CLASS_HIDDEN);
					timeRange.find('.startingTime').each(function(){
						var item = jQuery(this);
						item.find('.hidden-value-hours').val(menuIntervalForm.startHour);
						item.find('.hidden-value-minutes').val(menuIntervalForm.startMinute);
					});
					timeRange.find('.endingTime').each(function(){
						var item = jQuery(this);
						item.find('.hidden-value-hours').val(menuIntervalForm.endHour);
						item.find('.hidden-value-minutes').val(menuIntervalForm.endMinute);
					});

					break;
				case "SPECIAL":
					var inputSpecialMenu = menuCard.find(SEL_DATE_RANGE_INPUT);
					inputSpecialMenu.attr(DATA_ATTR_START_DATE_INPUT, moment(startDate).format(SYSTEM_DATE_FORMAT));
					inputSpecialMenu.attr(DATA_ATTR_END_DATE_INPUT, moment(endDate).format(SYSTEM_DATE_FORMAT));
					break;
			}

		};

		var addCategorySectionWithDishes = function(categoriesItems, menuCategoriesList, moduleNode){
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);
			var categoriesSectionTemplate = moduleNode.find(SEL_CATEGORY_SECTION_TEMPLATE);
			for(var index = 0 ; index < menuCategoriesList.length; index++){
				var newCategorySection = categoriesSectionTemplate.clone();
				newCategorySection.removeClass(CSS_CLASS_HIDDEN);
				newCategorySection.removeClass(CSS_CLASS_CATEGORY_TEMPLATE);
				newCategorySection.find(SEL_CATEGORY_HEADER).attr('data-target', '#dishesSection'+index);
				newCategorySection.find(SEL_COLLAPSE).prop('id','dishesSection'+index);
				var dishId = getDishId();
				var dishSortableID = 'dishSortable' + dishId;
				newCategorySection.find(SEL_DISHES_CONTAINER).prop('id',dishSortableID);
				var categorySectionId = getCategorySectionId();
				newCategorySection.addClass('categorySection' + categorySectionId);
				newCategorySection.attr('id',menuCategoriesList[index].id);
				newCategorySection.find(SEL_CATEGORY_NAME).text(menuCategoriesList[index].name);
				for(var j=0; j<menuCategoriesList[index].menuItems.length; j++){
					addDishWithDataToCategory(newCategorySection, menuCategoriesList[index].menuItems[j]);
					disableDeleteCategoryButton(moduleNode, menuCategoriesList[index].name);
				}
				containerCategories.append(newCategorySection);
				makeDishesSortable(dishSortableID);
			}

		};

		var inputExistentDataToCategories = function(menuCategoriesList, moduleNode){
			var categoryContainer = moduleNode.find(SEL_CATEGORY_CONTAINER);
			var templateItem 	  = moduleNode.find(SEL_CATEGORY_TEMPLATE_ITEM);
			var dishesSection 	  = moduleNode.find(SEL_DIHES_SECTION);
			var categoriesItems = [];
			for(var index = 0 ;index<menuCategoriesList.length; index++){
				var newCategoryItem   = templateItem.clone();
				var newItem = jQuery(newCategoryItem);
				newItem.addClass(CSS_CLASS_INPUT_ITEM);
				newItem.removeClass(CSS_CLASS_TEMPLATE_ITEM);
				newItem.find('.form-control').val(menuCategoriesList[index].name);
				categoriesItems.push(menuCategoriesList[index].name);
				var categoryItemId = getCategoryId();
				newItem.addClass('categoryItem' + categoryItemId);
				newItem.attr('id',menuCategoriesList[index].id);
				categoryContainer.append(newCategoryItem);
				makeCategoriesSortable();
			}
			addCategorySectionWithDishes(categoriesItems, menuCategoriesList, moduleNode);
		};

		var initEditMenuMode = function(localConfigEditMenu, moduleNode){
			var menuTitle = localConfigEditMenu.name;
			var menuType = localConfigEditMenu.menuType;
			var weekdays = localConfigEditMenu.weekdays;
			var timeType = localConfigEditMenu.timeType;
			var startDate = localConfigEditMenu.startDate;
			var endDate = localConfigEditMenu.endDate;
			var menuIntervalForm = localConfigEditMenu.menuIntervalForm;
			var menuCategoriesList = localConfigEditMenu.menuCategories.list;

			inputExistentDataToMenuSelection(menuTitle, weekdays, menuType, timeType, startDate, endDate , menuIntervalForm, moduleNode);
			inputExistentDataToCategories(menuCategoriesList, moduleNode);
		};

		var moveDishItem = function (node, direction) {	
			if (direction == "up") {
				node.prev().insertAfter(node);
			} else {
				node.next().insertBefore(node);
			}
		}

		//to update error tracking in adobe datalayer with event info
		var updateDatalayerErrorTracking = function(){
			if (window._satellite && window._adl) {
				//push eventInfo in _adl
				_adl.eventInfo = {
					eventName: FORM_EVENT_NAME,
					eventType: FORM_EVENT_TYPE
				}
	
				//push all the errors in adobe data layer
				_adl.error = {
					errorType: FORM_ERROR_TYPE,
					errorMessage: FORM_ERROR_MESSAGE,
					errorFields: FORM_EVENT_ACTION_NAME
				}

				//fire direct call
				window._satellite.track('errorCall');
			}
		}

		// Init all matching nodes
		moduleNodes.each(function() {
			
			var moduleNode = jQuery(this);
			var localConfigMenuSection = window.config.menuSection || [];
			var localConfigEditMenu = window.config.editMenu.menuForm || [];

			var chooseMenuCard = moduleNode.find(SEL_CARD_CHOOSE_MENU);
			var titleSection = moduleNode.find(SEL_TITLE_SECTION);
			var middleSectionNode = moduleNode.find(SEL_MIDDLE_SECTION);
			var categoryDeleteItemButton = moduleNode.find(SEL_BTN_DELETE_CATEGORY_ITEM);
			var btnAddCategoryItem = moduleNode.find(SEL_BTN_ADD_CATEGORY_ITEM);
			var btnDelteCategoryItem = moduleNode.find(SEL_BTN_DELETE_CATEGORY_ITEM);
			var categoriesSection = moduleNode.find(SEL_CATEGORIES_SECTION);
			var noCategoryCheckbox = moduleNode.find(SEL_NO_CATEGORY_CHECK);
			var containerCategories = moduleNode.find(SEL_CATEGORIES_CONTAINER);
			var dishesSection = moduleNode.find(SEL_DIHES_SECTION);
			var timeRange = moduleNode.find(SEL_TIME_RANGE_TIME_MENU);
			var submitFormBtn = moduleNode.find(SEL_SUBMIT_FORM_BTN);
			var moveDishUpArrow = dishesSection.find(SEL_MOVE_DISH_UP);
			var moveDishDownArrow = dishesSection.find(SEL_MOVE_DISH_DOWN);
			var index = 0;
			var menuCards = chooseMenuCard.find(SEL_MENU_CARD);

			if(localConfigEditMenu.id != undefined){
				menuId = localConfigEditMenu.id;
				categoriesSection.removeClass(CSS_CLASS_HIDDEN);
				dishesSection.removeClass(CSS_CLASS_HIDDEN);
				submitFormBtn.removeClass(CSS_CLASS_HIDDEN);
				initEditMenuMode(localConfigEditMenu, moduleNode);
			}else{
				addCategoryItem(moduleNode);
			}
			initDateRangeSelector(moduleNode, localConfigMenuSection);
			menuCards.each(function(){
				jQuery(this).addClass('id-menu-'+index);
				index++;
			});

			dishesSection.on('click',SEL_MOVE_DISH_DOWN,function(){
				var currentNode = jQuery(this).parent().parent();
				moveDishItem(currentNode, 'down');
			});
			dishesSection.on('click',SEL_MOVE_DISH_UP,function(){
				var currentNode = jQuery(this).parent().parent();
				moveDishItem(currentNode, 'up');
			});
			
			menuCards.on('click',SEL_CHECKBOX_MENU, function(){
				var item = jQuery(this);
				checkOtherMenuCards(menuCards);
				item.prop('checked',true);
				if(item.parents().hasClass(CSS_CLASS_TIME_MENU)){
					timeRange.removeClass(CSS_CLASS_HIDDEN);
				}else{
					timeRange.addClass(CSS_CLASS_HIDDEN);
				}
				item.parentsUntil(SEL_MIDDLE_SECTION).addClass(CSS_CLASS_ACTIVE_MENU);
				categoriesSection.removeClass(CSS_CLASS_HIDDEN);

			});

			btnAddCategoryItem.on('click',function(){
				addCategoryItem(moduleNode);
			});

			noCategoryCheckbox.on('change',function(){
				var item = jQuery(this);
				var isChecked = item.prop('checked');
				if(isChecked){
					deleteCategories(moduleNode);
					addEmptyCategory(moduleNode);
					statusEnableCategoryInputs(moduleNode, true);
					dishesSection.removeClass(CSS_CLASS_HIDDEN);
					submitFormBtn.removeClass(CSS_CLASS_HIDDEN);
				}else{
					//check if there are items inside the category and change the name.
					statusEnableCategoryInputs(moduleNode, false);
				}
			});

			//When a category is deleted we delete it from step3 as well
			moduleNode.on('click', SEL_BTN_DELETE_CATEGORY_ITEM, function(){
				var itemToDelete = jQuery(this).parent();
				deleteCategorySection(moduleNode, itemToDelete);
				deleteCategoryItem(moduleNode, itemToDelete);
			});

			//When a category is inputed we create a new category in step3
			middleSectionNode.on('change', SEL_CATEGORY_INPUT, function(){
				var categoriesItems = [];
				middleSectionNode.find(SEL_CATEGORY_INPUT_NAME).each(function(){
					var inputItem = jQuery(this);
					if(inputItem.val() != ''){
						categoriesItems.push(inputItem.val());
					}
				});
				initDishesSection(categoriesItems, moduleNode);
				dishesSection.removeClass(CSS_CLASS_HIDDEN);
				submitFormBtn.removeClass(CSS_CLASS_HIDDEN);
			});
			
			//add dish item on category
			containerCategories.on('click',SEL_BTN_ADD_DISH_ITEM,function(){
				var categoryInWhichToAdd = jQuery(this).parentsUntil(containerCategories);
				var categoryName = categoryInWhichToAdd.find(SEL_CATEGORY_NAME).val();
				addDishToCategory(categoryInWhichToAdd, moduleNode);
				disableDeleteCategoryButton(moduleNode,categoryName);
			});

			//delete dish item from a category
			containerCategories.on('click', SEL_BTN_DELETE_DISH_ITEM,function(){
				deleteDishFromCategory(moduleNode, jQuery(this));
			});
			submitFormBtn.on('click',function(e){
				if(!prepareFormForSubmission(moduleNode)){
					moduleNode.find(SEL_CARD_CHOOSE_MENU).find(SEL_ERROR_INFO_MESSAGE).removeClass(CSS_CLASS_HIDDEN);
					updateDatalayerErrorTracking(); //update adobe datalayer with the error event info
					e.preventDefault();
					e.stopImmediatePropagation();
					return false;
				}
			});
		});

	}

};

// Make class public to outside world
module.exports = EditMenu;
},{"../mediator/mediator":103,"../utils/StringUtils":187,"../utils/UserInterfaceUtils":189,"./MenuData":106,"./MenuInterval":107,"./MenuItem":108,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15,"sortablejs/Sortable":18}],106:[function(require,module,exports){
/**
 * MenuData functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
var MenuData = function(name, menuType, timeType, startDate, endDate, weekdays, menuCategories,categoryNames, timeMenuInterval) {

    this.name = name;
    this.menuType = menuType;
    this.timeType = timeType;
    this.startDate = startDate;
    this.endDate = endDate;
    this.weekdays = weekdays;
    this.menuCategories = menuCategories;
    this.categoryNames = categoryNames;
    this.timeMenuInterval = timeMenuInterval;
};

// Make class public to outside world
module.exports = MenuData;

},{"jquery/dist/jquery":14}],107:[function(require,module,exports){
/**
 * MenuInterval functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
var MenuInterval = function(startHour, startMinute, endHour, endMinute) {

    this.startHour = startHour;
    this.startMinute = startMinute;
    this.endHour = endHour;
    this.endMinute = endMinute;
};

// Make class public to outside world
module.exports = MenuInterval;

},{"jquery/dist/jquery":14}],108:[function(require,module,exports){
/**
 * MenuItem functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
var MenuItem = function(id, name, description, size, price, dietType) {

    this.id = id;
    this.name = name;
    this.description = description;
    this.size = size;
    this.price = price;
    this.dietType = dietType;
};

// Make class public to outside world
module.exports = MenuItem;

},{"jquery/dist/jquery":14}],109:[function(require,module,exports){
/**
 * Menu functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
DigitalMenu = require('./DigitalMenu');
EditMenu = require('./EditMenu');
// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var editMenu = new EditMenu();
	var digitalMenu = new DigitalMenu();

	// Trigger onload activities
	editMenu.init(initNode);
	digitalMenu.init(initNode);
});
},{"../mediator/mediator":103,"./DigitalMenu":104,"./EditMenu":105}],110:[function(require,module,exports){
/**
 * Alert Modal
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');


// selector constants
var SEL_MODULE                      = '.mod-modal-alert';
var SEL_CONTENT                     = '.modal-body';


// Class definition
Alert = function() {

    // self references
    var self;


    /** Show the confirm modal
     * @param modalNode The modal element
     * @param {string} body Body content (optional)
     * @param {bool} bodyHtml Should use HTML instead of escaping content. Defaults to false
     * @returns {promise} A promise, which can be chained using `done` and `fail`
     */
    this.show = function(modalNode, body, bodyHtml) {

      var modal = jQuery(modalNode).filter(SEL_MODULE);

      // remove all existing event handlers
      modal.off('hidden.bs.modal');

      var deferred = jQuery.Deferred();

      // add event handlers for when the modal closes
      modal.on('hidden.bs.modal', function() {
        deferred.resolve();
      });

      // update content
      if (body) {
        var content = modal.find(SEL_CONTENT);
        if (bodyHtml) {
          content.html(body);
        } else {
          content.text(body);
        }
      }

      // show modal
      modal.modal('show');

      // return the promise
      return deferred.promise();

    };

    /** Close a modal
     * @param modalNode The modal element
     */
    this.close = function(modalNode) {

      var modal = jQuery(modalNode).filter(SEL_MODULE);

      // hide modal
      modal.modal('hide');

    };

};

// Make class public to outside world
module.exports = Alert;

},{"jquery/dist/jquery":14}],111:[function(require,module,exports){
/**
 * Confirm Modal
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');


// selector constants
var SEL_MODULE                      = '.mod-modal-confirm';
var SEL_CONTENT                     = '.modal-body';
var SEL_CONFIRM_BUTTON              = '.modal-footer .action-button-confirm';
var SEL_CANCEL_BUTTON               = '.modal-footer .action-button-cancel';


// Class definition
Confirm = function() {

    // self references
    var self;


    /** Show the confirm modal
     * @param modalNode The modal element
     * @param {string} body Body content (optional)
     * @param {bool} bodyHtml Should use HTML instead of escaping content. Defaults to false
     * @returns {promise} A promise, which can be chained using `done` and `fail`
     */
    this.show = function(modalNode, body, bodyHtml) {

      var modal = jQuery(modalNode).filter(SEL_MODULE);

      var confirmButton = modal.find(SEL_CONFIRM_BUTTON);
      var cancelButton = modal.find(SEL_CANCEL_BUTTON);

      // remove all existing event handlers
      confirmButton.off();
      cancelButton.off();

      var deferred = jQuery.Deferred();

      // add event handlers for the button clicks
      confirmButton.on('click', function() {
        deferred.resolve();
      });
      cancelButton.on('click', function() {
        deferred.reject();
      });

      // update content
      if (body) {
        var content = modal.find(SEL_CONTENT);
        if (bodyHtml) {
          content.html(body);
        } else {
          content.text(body);
        }
      }

      // show modal
      modal.modal('show');

      // return the promise
      return deferred.promise();

    };

    /** Close a modal
     * @param modalNode The modal element
     */
    this.close = function(modalNode) {

      var modal = jQuery(modalNode).filter(SEL_MODULE);

      // hide modal
      modal.modal('hide');

    };

};

// Make class public to outside world
module.exports = Confirm;

},{"jquery/dist/jquery":14}],112:[function(require,module,exports){
/**
 * Loading progress bar
 *
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
NavigationLoadingProgress = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE				= '.mod-navigation-loading-progress';

	var CSS_LOADING				= 'loading';


	var showProgressBar = function(moduleNode) {
		moduleNode.addClass(CSS_LOADING);
	};

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode = jQuery(this);

			jQuery(window).on('beforeunload', function() {
				showProgressBar(moduleNode);
			});

		});

	}

};

// Make class public to outside world
module.exports = NavigationLoadingProgress;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],113:[function(require,module,exports){
/**
 * Displays or hides cookie consent message.
 *
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
MainNavigation = function () {

	// self references
	var self;

	// selector constants
	var SEL_MODULE = '.mod-navigation-header';
	var SEL_BUTTON = '.navbar-toggle';
	var SEL_MAIN_NAVIGATION = ".mod-navigation-main";
	var CLASS_MENU_TOGGLE = 'offcanvas-active';
	var CLASS_ESTABLISHMENT = 'establishment';
	var CLASS_NAVBAR = 'navbar';
	var SETTINGS_MENU_TEXT = 'settings';

	/**
	 * Initialize.
	 */
	this.init = function (initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes = initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function () {

			// Retrieve and cache dom nodes
			var buttonNode = jQuery(this).find(SEL_BUTTON);
			var navigationNode = jQuery('body');

			// Handle button click
			buttonNode.on("click", function () {
				navigationNode.toggleClass(CLASS_MENU_TOGGLE);
			});

			//hide sidebar navigation after click on outside menu area 
			jQuery(document).on("click", function (e) {
				var currentNode = jQuery(e.target);
				var mainNavigation = currentNode.closest(SEL_MODULE).siblings(SEL_MAIN_NAVIGATION);
				if ((mainNavigation.length == 0 || currentNode.hasClass(CLASS_ESTABLISHMENT)) && navigationNode.hasClass(CLASS_MENU_TOGGLE) && currentNode.closest(SEL_BUTTON).length == 0 && !currentNode.hasClass(CLASS_NAVBAR) && currentNode.text().trim().toLowerCase() !== SETTINGS_MENU_TEXT) {
					navigationNode.toggleClass(CLASS_MENU_TOGGLE);
				}
			});
		});
	}
};

// Make class public to outside world
module.exports = MainNavigation;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],114:[function(require,module,exports){
/**
 * Pause reservations functionality
 *
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
Notification = require('../notification/Notification');
var Tracking    = require('../utils/Tracking');
var FormTimepicker      = require('../form/FormTimepicker');

// Class definition
PauseReservations = function() {

    // self references
    var self; 

	// selector constants
    var SEL_MODULE								= '.mod-pause-reservations';
	var SEL_BUTTON_PLAY_PAUSE 					= '.reservation-pause-btn';
	var SEL_RESERVATIONS_PAUSE_MODAL 			= '.reservation-pause-modal';
	var SEL_FORM 								= 'form';
	var SEL_CSRF 								= 'input[name="_csrf"]';

	var SEL_INPUT_START_TIME            		= '.startingTime';
	var SEL_INPUT_END_TIME              		= '.endingTime';
	var SEL_TIME_HOURS							= '.timepicker-inner input[type=text]:first-child';
	var SEL_TIME_MINUTES						= '.timepicker-inner input[type=text]:last-child';
	var SEL_PAUSED_START_TIME					= '.paused-start-time';
	var SEL_PAUSED_UNTIL_TIME					= '.paused-until-time';

	var SEL_MERIDIEM_TOGGLE_BTN					= '.meridiem-toggle';
	var SEL_SUBMIT_BTN							= '.submit-button';
	var SEL_FORM_TIME_PICKER					= '.form-group.mod-form-timepicker';
	
	var CLASS_TOGGLE_ACTIVE						= 'toggle-active';
	var CLASS_PAUSED_MODE 						= 'paused-mode';
	var CONST_RESUME_URL 						= '/settings/unpausereservation';
	var CONST_PAUSE_URL 						= '/settings/pausereservation';
	var CSS_HAS_ERROR                   		= 'has-error';
	var DATA_ATTRIBUTE_MERIDIEM					= 'meridiem';

	var FORM_EVENT_TYPE 		= 'error-pageload';
	var FORM_ERROR_FIELD_NAME 	= "no-field";
	var FORM_EVENT_NAME	 		= "error";
	var FORM_ERROR_TYPE	 		= "404";
	var FORM_CLICK_EVENT_NAME	= "pause";
	var FORM_CLICK_EVENT_TYPE	= "click";

	//check the selected page is tableplan page or not
	var isTablePlan = window.location.href.indexOf('tablePlan') > -1 ? true : false;

	//initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.error = window._adl.error || {};

	var sendRequestPauseReservation = function(moduleNode, modal, startInput, endInput, csrf, notification){

		var playPauseReservations = moduleNode.find(SEL_BUTTON_PLAY_PAUSE);

		var startHour = parseInt(startInput.find(SEL_TIME_HOURS).val());
		var startMinutes = parseInt(startInput.find(SEL_TIME_MINUTES).val());
		var meridiem = !window.config.pauseHoursLightbox.is24Hours ? (startInput.find(SEL_MERIDIEM_TOGGLE_BTN).hasClass(CLASS_TOGGLE_ACTIVE) ? 'PM' : 'AM') : '';

		var reservationStartPauseTime = (startHour < 10 ? '0'+startHour : startHour) + ":"+ (startMinutes < 10 ? '0'+startMinutes : startMinutes) + " " + meridiem;
		startMinutes = startMinutes == "00" ? 0 : parseInt(startMinutes);

		var endHour = parseInt(endInput.find(SEL_TIME_HOURS).val());
		var endMinutes = parseInt(endInput.find(SEL_TIME_MINUTES).val());
		endMinutes = endMinutes == "00" ? 0 : parseInt(endMinutes);

		var startToggleClass = startInput.find(SEL_MERIDIEM_TOGGLE_BTN);
		var endToggleClass = endInput.find(SEL_MERIDIEM_TOGGLE_BTN);

		//if starthour < 12 and meridiem is 'PM' ==> it will convert [2PM ===> 14:00] or [11PM ===> 23:00]
		if(startToggleClass.hasClass(CLASS_TOGGLE_ACTIVE) && startHour < 12){
			startHour = startHour + 12;
		}

		//if endhour < 12 and meridiem is 'PM' ==> it will convert [2PM ===> 14:00] or [11PM ===> 23:00]
		if(endToggleClass.hasClass(CLASS_TOGGLE_ACTIVE) && endHour < 12){
			endHour = endHour + 12;
		}

		//this condition will work only for 12 hours format (not 24 hours format)
		//For 12 hours -> [12AM ==> 0:00] and [12PM ===> 12:00] and [2PM ===> 14:00]
		//For 24 hours -> [12 ==> 12] and [13 ==> 13] and [21 ==> 21] (because no concept of AM, PM)
		if(!endToggleClass.hasClass(CLASS_TOGGLE_ACTIVE) && endHour == 12 && !window.config.pauseHoursLightbox.is24Hours){
			endHour = 0;
		}

		jQuery.ajax({
			url: window.config.pauseReservations.msg.apiUrlPauseReservations,
			type: 'POST',
			data: {
				_csrf: csrf,
				pauseStartHour: startHour,
				pauseStartMinutes: startMinutes,
				pauseEndHour: endHour,
				pauseEndMinutes: endMinutes
			},
			dataType: 'json',
			success: function(result) {
				if(result.status == 'OK') {
					moduleNode.addClass(CLASS_PAUSED_MODE);
					moduleNode.find(SEL_PAUSED_START_TIME).empty().append(reservationStartPauseTime);
					moduleNode.find(SEL_PAUSED_UNTIL_TIME).empty().append(result.reservationPauseTime);
				
					modal.modal('hide');
					notification.showGlobalConfirmNotification(window.config.pauseReservations.msg.pausedSuccess + " " + reservationStartPauseTime + ' ' + window.config.pauseReservations.msg.pausedMiddleText + ' ' + result.reservationPauseTime);
					
					//prepare the paused button text on hover for tableplan page
					var reservationPausedText = window.config.pauseReservations.msg.pausedSuccess + ' ' + reservationStartPauseTime + ' ' + window.config.pauseReservations.msg.pausedMiddleText + ' ' + result.reservationPauseTime;
					//add paused button (title attribute) info if the current page is table plan page
					if(isTablePlan){
						playPauseReservations.attr('title', reservationPausedText);
					}

				}else if(result.status == 'ko'){
					startInput.addClass(CSS_HAS_ERROR);
					endInput.addClass(CSS_HAS_ERROR);
					notification.showGlobalErrorNotification(result.errorMsg);
				}
			},
			error: function(result, status) {
				notification.showGlobalErrorNotification(window.config.pauseReservations.msg.pausedError);
			}
		});
	}

	//to update error tracking in adobe datalayer with event info
	var updateDatalayerErrorTracking = function(){
		if (window._satellite && window._adl) {
			//push eventInfo in _adl
			_adl.eventInfo = {
				eventName: FORM_EVENT_NAME,
				eventType: FORM_EVENT_TYPE
			}
		
			//push all the errors in adobe data layer
			_adl.error = {
				errorType: FORM_ERROR_TYPE,
				errorMessage: "Sorry, there was an error during checkout. Please try again from the tools page.",
				errorFields: FORM_ERROR_FIELD_NAME
			}
		}
	}
	
	/**
	 * Send POST request for resume reservations
	 * and switch node to ready for pause mode.
	 * @csrf value for csrf input
	 * @moduleNode node 
	 * @notification notification instance
	 */
	this.resumeReservations = function(csrf, moduleNode, notification, endInput) {

		var playPauseReservations = moduleNode.find(SEL_BUTTON_PLAY_PAUSE);

		jQuery.ajax({
			url: CONST_RESUME_URL,
			type: 'POST',
			data: {
				_csrf: csrf
			},
			dataType: 'json',
			success: function(result) {
				if(result.status == 'OK') {
					notification.showGlobalConfirmNotification(window.config.pauseReservations.msg.resumeSuccess);
					moduleNode.removeClass(CLASS_PAUSED_MODE);
					endInput.find(SEL_TIME_HOURS).val('');
					endInput.find(SEL_TIME_MINUTES).val('00');

					//add play button (title attribute) info if the current page is table plan page
					if(isTablePlan){
						playPauseReservations.attr('title', window.config.pauseReservations.msg.workingText);
					}
				}
			},
			error: function(result, status) {
				notification.showGlobalErrorNotification(window.config.pauseReservations.msg.resumeError);
			}
		});
    }

	var updateAdobeDataLayer = function(){
		if (window._satellite && window._adl) {
			//push eventInfo in _adl
			_adl.eventInfo = {
				eventName: FORM_CLICK_EVENT_NAME,
				eventType: FORM_CLICK_EVENT_TYPE
			}

			//fire direct call
			window._satellite.track('trackButtonClick');
		}
	}

	/**
	 * @description remove all error classes for for start or endtime if present initially
	 * @param startTime - starttime input value
	 * @param endTime - endtime input value
	 */
	var removeInitialErrors = function(startTime, endTime){
		if(startTime.hasClass(CSS_HAS_ERROR)){
			startTime.removeClass(CSS_HAS_ERROR);
		}
		
		if(endTime.hasClass(CSS_HAS_ERROR)){
			endTime.removeClass(CSS_HAS_ERROR);
		}
	}

	/**
	 * @description Validation to check if there is any empty input field (Either Starttime or Endtime input)
	 * @param startInput - starttime outer container
	 * @param endInput - endtime outer container
	 * @returns returns the validation error array
	 */
	var invalidStartEndTime = function(startInput, endInput){
		var invalidFieldErrors = [];
		var startHour = startInput.find(SEL_TIME_HOURS).val();
		var startMinutes = startInput.find(SEL_TIME_MINUTES).val();
		var endHour = endInput.find(SEL_TIME_HOURS).val();
		var endMinutes = endInput.find(SEL_TIME_MINUTES).val();
		var is24Hours = window.config.pauseHoursLightbox.is24Hours;

		if(startHour == "" || startMinutes == "" || (parseInt(startHour) == 0 && !is24Hours)){
			startInput.addClass(CSS_HAS_ERROR);
			invalidFieldErrors.push('invalidField');
		}
		
		if(endHour == "" || endMinutes == "" || (parseInt(endHour) == 0 && !is24Hours)){
			endInput.addClass(CSS_HAS_ERROR);
			invalidFieldErrors.push('invalidField');
		}

		var distinctError = invalidFieldErrors.filter(function(obj, index){
			return invalidFieldErrors.indexOf(obj) === index;
		})

		return distinctError;
	}
	
	/**
	 * @description Validation to check if Starttime = Endtime
	 * @param startInput - starttime outer container
	 * @param endInput - endtime outer container
	 * @returns returns the validation error array
	 */
	var startCurrentEndTimeErrors = function(startInput, endInput){
		var startCurrentEndTimeError = [];

		var startHourValue = startInput.find(SEL_TIME_HOURS).val();
		var startMinValue = startInput.find(SEL_TIME_MINUTES).val();
		var endHourValue = endInput.find(SEL_TIME_HOURS).val();
		var endMinValue = endInput.find(SEL_TIME_MINUTES).val();

		var startHour = startHourValue != '' ? parseInt(startHourValue) : 0;
		var startMinutes = startMinValue != '' ? parseInt(startMinValue) : 0;
		var endHour = endHourValue != '' ? parseInt(endHourValue) : 0;
		var endMinutes = endMinValue != '' ? parseInt(endMinValue) : 0;

		var is24Hours = window.config.pauseHoursLightbox.is24Hours;

		var startToggleClass = startInput.find(SEL_MERIDIEM_TOGGLE_BTN);
		if(startToggleClass.hasClass(CLASS_TOGGLE_ACTIVE)){
			startHour = startHour + 12;
		}

		var endToggleClass = endInput.find(SEL_MERIDIEM_TOGGLE_BTN);
		if(endToggleClass.hasClass(CLASS_TOGGLE_ACTIVE)){
			endHour = endHour + 12;
		}
		
		var startTime = startHour*60 + startMinutes;
		var endTime = endHour*60 + endMinutes;

		if(!((startHour == 0 && !is24Hours) || (endHour == 0 && !is24Hours))){ //if start hour or end hour not zero, will check further condition
			if(startTime == endTime){
				startCurrentEndTimeError.push('startEndTimeEqual');
				startInput.addClass(CSS_HAS_ERROR);
				endInput.addClass(CSS_HAS_ERROR);
			}
		}

		return startCurrentEndTimeError;
	}

	/**
	 * @description if endtime has no minutes initially then fill the minutes with 00
	 * @param endInput - endtime outer container
	 */
	this.prefillEndHoursMinutes = function(modal, endInput, timeObj){
		var endMinutes = timeObj.endMinutes == 0 ? '00' : (timeObj.endMinutes < 10 ? '0'+timeObj.endMinutes : timeObj.endMinutes);
		var toggleClass = modal.find(SEL_INPUT_END_TIME).find(SEL_MERIDIEM_TOGGLE_BTN);
		var timepicker = endInput.find(SEL_FORM_TIME_PICKER);
		var endHour;
		var meridiem = '';

		if(timeObj.endHour > 12 && !window.config.pauseHoursLightbox.is24Hours){
			endHour = timeObj.endHour - 12;
			meridiem = 'pm';
			timepicker.data(DATA_ATTRIBUTE_MERIDIEM, meridiem);
			toggleClass.addClass(CLASS_TOGGLE_ACTIVE);
		}else{
			endHour = timeObj.endHour;
			toggleClass.removeClass(CLASS_TOGGLE_ACTIVE);
		}

		if(timeObj.endHour == 0 && !window.config.pauseHoursLightbox.is24Hours){
			endHour = 12;
		}

		endHour = endHour < 10 ? ('0'+endHour) : endHour;
		endInput.find(SEL_TIME_HOURS).val(endHour);
		endInput.find(SEL_TIME_MINUTES).val(endMinutes);
	}

	/**
	 * @description prefill hours and minutes of current time
	 */
	this.prefillCurrentHoursMinutes = function(modal, startInput, timeObj){
		var prepareMinutes = timeObj.currentMinutes < 10 ? '0'+timeObj.currentMinutes : timeObj.currentMinutes;
		var currentMinutes = timeObj.currentMinutes == 0 ? '00' : prepareMinutes;
		var toggleClass = modal.find(SEL_INPUT_START_TIME).find(SEL_MERIDIEM_TOGGLE_BTN);
		var timepicker = startInput.find(SEL_FORM_TIME_PICKER);
		var currentHour;
		var meridiem = '';

		if(timeObj.currentHour > 12 && !window.config.pauseHoursLightbox.is24Hours){
			//if currentHour > 12, will display as currentHour-12 (ex: if currentHour is 18, 18-12 = 6)
			currentHour = timeObj.currentHour - 12;
			meridiem = 'pm';
			timepicker.data(DATA_ATTRIBUTE_MERIDIEM, meridiem);
			toggleClass.addClass(CLASS_TOGGLE_ACTIVE);
		}else if(timeObj.currentHour == 12 && !window.config.pauseHoursLightbox.is24Hours){
			//if currentHour is 12, will display as 12PM
			currentHour = timeObj.currentHour;
			meridiem = 'pm';
			timepicker.data(DATA_ATTRIBUTE_MERIDIEM, meridiem);
			toggleClass.addClass(CLASS_TOGGLE_ACTIVE);
		}else{
			currentHour = timeObj.currentHour;
			toggleClass.removeClass(CLASS_TOGGLE_ACTIVE);
		}

		if(timeObj.currentHour == 0 && !window.config.pauseHoursLightbox.is24Hours){
			currentHour = 12;
		}

		currentHour = currentHour < 10 ? ('0'+currentHour) : currentHour;
		startInput.find(SEL_TIME_HOURS).val(currentHour);
		startInput.find(SEL_TIME_MINUTES).val(currentMinutes);
	}

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {
			
			// Retrieve and cache dom nodes
			var moduleNode = jQuery(this);
			var playPauseReservations = moduleNode.find(SEL_BUTTON_PLAY_PAUSE);
			var modal = jQuery(SEL_RESERVATIONS_PAUSE_MODAL);
			var modalForm = modal.find(SEL_FORM);
			var notification = new Notification();
			//check if the pause reservation icon has paused class or not
			var isPaused = moduleNode.hasClass(CLASS_PAUSED_MODE);

			var submitBtn = modal.find(SEL_SUBMIT_BTN);
			var startTimeInput = modal.find(SEL_INPUT_START_TIME);
			var endTimeInput = modal.find(SEL_INPUT_END_TIME);

			removeInitialErrors(startTimeInput, endTimeInput);

			//prepare the paused button text on hover for tableplan page (when page loads)
			var reservationPausedText = window.config.pauseReservations.msg.pausedSuccess + ' ' + window.config.pauseReservations.info.startTime + ' ' + window.config.pauseReservations.msg.pausedMiddleText + ' ' + window.config.pauseReservations.info.endTime;

			//add play/paused button (title attribute) info if the current page is table plan page
			if(isTablePlan){
				isPaused ? playPauseReservations.attr('title', reservationPausedText) : playPauseReservations.attr('title', window.config.pauseReservations.msg.workingText);
			}

			// handle play/pause button click
			playPauseReservations.on('click', function () {

				//updating the value again because the 'paused-mode' class could toggle on basis of pause reservation button click
				isPaused = moduleNode.hasClass(CLASS_PAUSED_MODE);
				
				removeInitialErrors(startTimeInput, endTimeInput);

				if(!isPaused) {
					jQuery.get(CONST_PAUSE_URL, function(data) {
						if(data.status == "ok"){
							modal.modal('show');
							self.prefillEndHoursMinutes(modal, endTimeInput, data);
							self.prefillCurrentHoursMinutes(modal, startTimeInput, data);
							updateAdobeDataLayer();
						}else if(data.status == 'ko'){
							notification.showGlobalErrorNotification(data.errorMsg);
						}else{
							updateDatalayerErrorTracking();
						}
					});
				} else {
					var csrf = modalForm.find(SEL_CSRF).val();
					self.resumeReservations(csrf, moduleNode,notification, endTimeInput);
				}
				return false;
			});

			//form validation and submission after click on PAUSE button inside popup
			submitBtn.on('click', function(){

				//if error class present in any of the input, just remove them
				removeInitialErrors(startTimeInput, endTimeInput);
				//invalid error if start or end hour is zero or blank
				var timeIntervalError = invalidStartEndTime(startTimeInput, endTimeInput);
				//check if start and end time are equal or not
				var startCurrentEndTimeError = startCurrentEndTimeErrors(startTimeInput, endTimeInput);

				//condition to check which error exists
				if(timeIntervalError.length !== 0 || startCurrentEndTimeError.length !== 0){
					var errorMessage = "";

					if(timeIntervalError.length !== 0){
						errorMessage = window.config.pauseHoursLightbox.invalidFieldError;
					}else if(startCurrentEndTimeError.length !== 0){
						if(startCurrentEndTimeError.indexOf('startEndTimeEqual') != -1){
							errorMessage = window.config.pauseHoursLightbox.timeEqualError;
						}
					}

					notification.showGlobalErrorNotification(errorMessage);
				}else{
					var csrf = modalForm.find(SEL_CSRF).val()
					//form submission code
					sendRequestPauseReservation(moduleNode, modal, startTimeInput, endTimeInput, csrf, notification);
				}
			});
		});
	}
};

// Make class public to outside world
module.exports = PauseReservations;
},{"../form/FormTimepicker":90,"../mediator/mediator":103,"../notification/Notification":125,"../utils/Tracking":188,"jquery/dist/jquery":14}],115:[function(require,module,exports){
/**
 * Main Navigation functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
NavigationMain = require('./NavigationMain');
NavigationLoadingProgress = require('./NavigationLoadingProgress');
PauseReservations = require('./PauseReservations');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var navigationMain = new NavigationMain();
	var navigationLoadingProgress = new NavigationLoadingProgress();
	var pauseReservations = new PauseReservations();

	// Trigger onload activities
	navigationMain.init(initNode);
	navigationLoadingProgress.init(initNode);
	pauseReservations.init(initNode);

});
},{"../mediator/mediator":103,"./NavigationLoadingProgress":112,"./NavigationMain":113,"./PauseReservations":114}],116:[function(require,module,exports){
/**
 * No-Shows Settings page functionality.
 */

// External libs
const jQuery = require('jquery/dist/jquery');
const DaysHours = require('../daysHours/DaysHours');

// Class definition
let CardGuaranteeTimes = function () {

    let self;
    const SEL_MODULE= '.mod-bank-card-guarantee-times';
    /**
     * Initialize.
     */
    this.init = function (initNode) {
        self = this;
        const moduleNodes = initNode.find(SEL_MODULE);
        moduleNodes.each(function() {
            let daysHours = new DaysHours();
            daysHours.init(jQuery(this));
        })
    }
}

// Make class public to the outside world
module.exports = CardGuaranteeTimes;
},{"../daysHours/DaysHours":72,"jquery/dist/jquery":14}],117:[function(require,module,exports){
/**
 * Handles the confirmation pop-up for the No-Show Charge Fee button.
 */

// External libs
var jQuery = require('jquery/dist/jquery');
var Confirm = require('../modals/Confirm');

// Class definition
var NoShowCharge = function () {

    var SEL_RESERVATION_ITEM = '.mod-reservation-list-item';
    var SEL_CHARGE_BUTTON_ACTION = '.action-on-charge';
    var SEL_MODAL_CHARGE_CONFIRM = '.noShowList-chargeConfirmModal';
    var SEL_MODAL_CONTENT_CONTAINER = '.charge-modal-container';
    var confirmModal = new Confirm();

    /**
     * Initialize.
     */
    this.init = function (initNode) {

        initNode.on('click', SEL_CHARGE_BUTTON_ACTION, function (e) {
            e.preventDefault();
            e.stopPropagation();

            const button = jQuery(this);
            const reservationItem = button.closest(SEL_RESERVATION_ITEM);
            const modal = reservationItem.find(SEL_MODAL_CHARGE_CONFIRM);
            const form = button.closest('form');
            const modalContent = reservationItem.find(SEL_MODAL_CONTENT_CONTAINER).html();
            confirmModal
                .show(modal, modalContent, true)
                .done(() => form.submit());
        });

    };
};

// Make class public to the outside world
module.exports = NoShowCharge;

},{"../modals/Confirm":111,"jquery/dist/jquery":14}],118:[function(require,module,exports){
/**
 * Handles the filter selection for the No-Show Overview list
 */

// External libs
var jQuery = require('jquery/dist/jquery');

// Class definition
var NoShowFilter = function () {

    var SEL_FILTER_CONTAINER = '.mod-no-show-overview-filter-card';
    var SEL_RADIOS   = 'input[name="noShowStatusFilter"]';

    function bindFilterChange(moduleNode) {
        var selectedRadio = moduleNode.find(SEL_RADIOS);
        selectedRadio.on('change', function () {
            const val = this.value;
            const targetUrl = val
                ? BASE_PATH + '?noShowStatusFilter=' + encodeURIComponent(val)
                : BASE_PATH;

            window.location.href = targetUrl;
        });
    }

    /**
     * Initialize.
     */
    this.init = function (initNode) {

        const selectFilter = jQuery(initNode).find(SEL_FILTER_CONTAINER);
        selectFilter.each(function () {
            bindFilterChange(jQuery(this));
        });

    };
};

// Make class public to the outside world
module.exports = NoShowFilter;
},{"jquery/dist/jquery":14}],119:[function(require,module,exports){

jQuery = require('jquery/dist/jquery');

const NoShowPromo = function() {

    const SEL_PROMO = '.promo';
    const SEL_LEARN_MORE_BTN = '#btn-learn-more';
    const SEL_GET_ADD_ON_BTN = '#btn-get-add-on';
    const ADOBE_EVENT_LEARN_MORE = 'learnmore_click';
    const ADOBE_EVENT_GET_ADD_ON = 'banner_click';
    const ADOBE_EVENT_VALUE = 'section_upselling_no_show_fee';

    this.init = function (initNode) {
        self = this;

        const promoNodes = initNode.find(SEL_PROMO);

        promoNodes.each(function () {
            const promoNode = jQuery(this);
            const promoLearnMoreButton = promoNode.find(SEL_LEARN_MORE_BTN);
            const promoGetAddOnButton = promoNode.find(SEL_GET_ADD_ON_BTN);

            promoLearnMoreButton.on('click', function(){
                pushToAdobe(ADOBE_EVENT_LEARN_MORE);
            });
            promoGetAddOnButton.on('click', function(){
                pushToAdobe(ADOBE_EVENT_GET_ADD_ON);
            });

        });

        function pushToAdobe(event) {
            let adobeDataLayer = window.adobeDataLayer || [];
            adobeDataLayer.push({event: event, eventValue: ADOBE_EVENT_VALUE});
        }
    }
}

module.exports = NoShowPromo;
},{"jquery/dist/jquery":14}],120:[function(require,module,exports){
/**
 * Handles the confirmation pop-up for the No-Show Refund Fee button.
 */

// External libs
var jQuery = require('jquery/dist/jquery');
var Confirm = require('../modals/Confirm');

// Class definition
var NoShowRefund = function () {

    var SEL_RESERVATION_ITEM = '.mod-reservation-list-item';
    var SEL_REFUND_BUTTON_ACTION = '.action-on-refund';
    var SEL_MODAL_REFUND_CONFIRM = '.noShowList-refundConfirmModal';
    var SEL_MODAL_CONTENT_CONTAINER = '.refund-modal-container';
    var confirmModal = new Confirm();

    /**
     * Initialize.
     */
    this.init = function (initNode) {

        initNode.on('click', SEL_REFUND_BUTTON_ACTION, function (e) {
            e.preventDefault();
            e.stopPropagation();

            const button = jQuery(this);
            const reservationItem = button.closest(SEL_RESERVATION_ITEM);
            const modal = reservationItem.find(SEL_MODAL_REFUND_CONFIRM);
            const form = button.closest('form');
            const modalContent = reservationItem.find(SEL_MODAL_CONTENT_CONTAINER).html();
            confirmModal
                .show(modal, modalContent, true)
                .done(() => form.submit());
        });

    };
};

// Make class public to the outside world
module.exports = NoShowRefund;

},{"../modals/Confirm":111,"jquery/dist/jquery":14}],121:[function(require,module,exports){
/**
    Allows to open reservation details from no-show list
 */

// External libs
const jQuery = require('jquery/dist/jquery');

let NoShowReservationDetails = function() {

    const SEL_RESERVATION_ITEM = '.mod-reservation-list-item';
    const SEL_RESERVATION_ITEM_IGNORE_CLICK = '.no-edit-click';
    const ATTR_EDIT_URL = 'data-edit-url';

    /**
     *  Initialize
     */
    this.init = function(initNode) {

        // allow clicking on child elements
        // without being redirected to edit page
        // NOTE: this should be done before setting up the click handler below
        initNode.on('click', SEL_RESERVATION_ITEM_IGNORE_CLICK, function (event) {
            event.stopPropagation();
        });

        // handle clicking the card (except on the child elements defined above)
        initNode.on('click', SEL_RESERVATION_ITEM, function () {
            let item = jQuery(this);
            let editUrl = item.attr(ATTR_EDIT_URL) || '';
            goToUrl(editUrl);
        });


    }

    let goToUrl = function (url) {
        document.location.href = url;
    };

}

// Make class public to the outside world
module.exports = NoShowReservationDetails;
},{"jquery/dist/jquery":14}],122:[function(require,module,exports){
/**
 * No-Shows Settings page functionality.
 */

// External libs
const jQuery = require('jquery/dist/jquery');
FormInputNumericFilter  		= require('../form/FormInputNumericFilter');
FormInputFilter = require('../form/FormInputFilter')


// Class definition
let NoShowSettings = function () {

    let self;
    const SEL_MODULE= '.mod-reservation-setting-no-shows';
    const SEL_MAIN_FORM= 'form';
    const SEL_MIN_PARTY_SIZE = '#minimumPartySize'
    const SEL_FEE_PER_PERSON = '#feePerPerson'
    const CSS_HAS_ERROR= 'has-error';

    const inputFormFilter = new FormInputFilter();

    /**
     * Initialize.
     */
    this.init = function (initNode) {
        self = this;
        const moduleNodes = initNode.find(SEL_MODULE);

        moduleNodes.each(function() {

            let moduleNode = jQuery(this);
            let mainForm = moduleNode.find(SEL_MAIN_FORM);

            mainForm.on('submit', function(event) {
                if (!isFormValid(moduleNode)) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    return false;
                }
            });
        });

        let feePerPerson = initNode.find(SEL_FEE_PER_PERSON);
        initFeePerPerson(feePerPerson);

    }

    let isFormValid = function(moduleNode) {
        let minPartySize = moduleNode.find(SEL_MIN_PARTY_SIZE);
        let feePerPerson = moduleNode.find(SEL_FEE_PER_PERSON);
        minPartySize.parent().removeClass(CSS_HAS_ERROR);
        feePerPerson.parent().removeClass(CSS_HAS_ERROR);
        let min = minPartySize.val();
        let fee = feePerPerson.val();
        if (!min) {
            minPartySize.parent().addClass(CSS_HAS_ERROR);
        }
        if (!fee) {
            feePerPerson.parent().addClass(CSS_HAS_ERROR);
        }
        return min && fee;
    }

    let initFeePerPerson = function(feePerPerson) {
        let numericInputFilter = new FormInputNumericFilter(inputFormFilter);
        let min = feePerPerson.attr("min");
        let max = feePerPerson.attr("max");

        let FILTER_NUMBER_POSITIVE_UNDER_1000  = function(value) {
            return value === "" || ( /^\d*$/.test(value) && parseInt(value) >= min && parseInt(value) <= max);
        };

        numericInputFilter.init(feePerPerson, FILTER_NUMBER_POSITIVE_UNDER_1000);
    }

}

// Make class public to the outside world
module.exports = NoShowSettings;
},{"../form/FormInputFilter":86,"../form/FormInputNumericFilter":87,"jquery/dist/jquery":14}],123:[function(require,module,exports){

jQuery = require('jquery/dist/jquery');

const NoShowUpsellPromo = function() {

    const SEL_UPSELL_PROMO_BANNER = '.noshow-upsell-banner-container.show';
    const SEL_LEARN_MORE_BUTTON = '.btn-upsell-learn-more';
    const ADOBE_EVENT_LEARN_MORE = 'learnmore_click';
    const ADOBE_EVENT_BANNER_IMPRESSION = 'banner_impression';
    const ADOBE_EVENT_VALUE = 'inline_note_upselling_no_show_fee';

    this.init = function (initNode) {
        self = this;

        const upsellPromoNodes = initNode.find(SEL_UPSELL_PROMO_BANNER);
        upsellPromoNodes.each(function () {
            const promoNode = jQuery(this);
            const promoLearnMoreButton = promoNode.find(SEL_LEARN_MORE_BUTTON);
            promoLearnMoreButton.on('click', function(){
                pushToAdobe(ADOBE_EVENT_LEARN_MORE, ADOBE_EVENT_VALUE);
            });
        });

        window.addEventListener("load", () => {
            const bannerCount = document.querySelectorAll(SEL_UPSELL_PROMO_BANNER).length;
            if (bannerCount > 0) {
                const eventValue = ADOBE_EVENT_VALUE + "_" + bannerCount;
                pushToAdobe(ADOBE_EVENT_BANNER_IMPRESSION, eventValue);
            }
        });

        function pushToAdobe(event, value) {
            let adobeDataLayer = window.adobeDataLayer || [];
            adobeDataLayer.push({event: event, eventValue: value});
        }
    }
}

module.exports = NoShowUpsellPromo;
},{"jquery/dist/jquery":14}],124:[function(require,module,exports){


/**
 * No-Show Charge functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
var NoShowCharge              = require('./NoShowCharge');
var CardGuaranteeTimes        = require('./CardGuaranteeTimes');
var NoShowSettings            = require('./NoShowSettings');
var NoShowFilter              = require('./NoShowFilter');
var NoShowReservationDetails  = require('./NoShowReservationDetails');
var NoShowRefund              = require('./NoShowRefund');
let NoShowPromo = require('./NoShowPromo');
let NoShowUpsellPromo = require('./NoShowUpsellPromo');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

    // Instantiate implementing class
    var noShowCharge          = new NoShowCharge();
    var cardGuaranteeTimes= new CardGuaranteeTimes();
    var noShowSettings       = new NoShowSettings();
    var noShowFilter           = new NoShowFilter();
    var noShowReservationDetails = new NoShowReservationDetails();
    var noShowRefund = new NoShowRefund();
    let noShowPromo = new NoShowPromo();
    let noShowUpsellPromo = new NoShowUpsellPromo();

    // Trigger onload activities
    noShowCharge.init(initNode);
    cardGuaranteeTimes.init(initNode);
    noShowSettings.init(initNode);
    noShowFilter.init(initNode);
    noShowReservationDetails.init(initNode);
    noShowRefund.init(initNode);
    noShowPromo.init(initNode);
    noShowUpsellPromo.init(initNode);
});
},{"../mediator/mediator":103,"./CardGuaranteeTimes":116,"./NoShowCharge":117,"./NoShowFilter":118,"./NoShowPromo":119,"./NoShowRefund":120,"./NoShowReservationDetails":121,"./NoShowSettings":122,"./NoShowUpsellPromo":123}],125:[function(require,module,exports){
/**
 * Notification functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
Notify		= require('bootstrap-notify/bootstrap-notify');



// Class definition
Notification = function() {

    // self references
    var self;

	// selector constants
	var SEL_MODULE						= '.mod-global-messages';
	var CLASS_NO_MESSAGES				= 'no-messages';



	/**
	 * Displays a notification of the given type.
	 *
	 */
	this.showNotification = function(title, text, type) {
		window.config = window.config || {};
		window.config.messages = window.config.messages || [];
		window.config.messages.push({title : title, text: text, type: type});
		showNotifications();
	}



	/**
	 * Displays a confirmation notification.
	 *
	 */
	this.showConfirmNotification = function(text) {
		this.showNotification('', text, 'success');
	}

	this.showGlobalConfirmNotification = function(text) {
		this.showGlobalNotification(text, 'success');
	}



	/**
	 * Displays a warning notifcation.
	 *
	 */
	this.showWarningNotification = function(text) {
		this.showNotification('', text, 'warning');
	}

	this.showGlobalWarningNotification = function(text) {
		this.showGlobalNotification(text, 'warning');
	}



	/**
	 * Displays an error notification.
	 *
	 */
	this.showErrorNotification = function(text) {
		this.showNotification('', text, 'danger');
	}

	this.showGlobalErrorNotification = function(text) {
		this.showGlobalNotification(text, 'danger');
	}



	/**
	 * Displays an info notification.
	 *
	 */
	this.showInfoNotification = function(text) {
		this.showNotification('', text, 'info');
	}

	this.showGlobalInfoNotification = function(text) {
		this.showGlobalNotification(text, 'info');
	}


	/**
	 * Checks the global window notification array for new notifications and displays them.
	 * Based on http://bootstrap-notify.remabledesigns.com/.
	 *
	 * @returns
	 */
	var showNotifications = function() {
		if (window.config && window.config.messages) {
			for (i = 0; i < window.config.messages.length; i++) {
				var message = window.config.messages[i];

				var icon = 'fas fa-info-circle';
				if (message.type == 'info') {
					icon = 'fas fa-info-circle';
				} else if (message.type == 'warning') {
					icon = 'fas fa-exclamation-triangle';
				} else if (message.type == 'danger') {
					icon = 'far fa-times-circle';
				} else if (message.type == 'success') {
					icon = 'far fa-check-circle';
				}

			    // http://bootstrap-notify.remabledesigns.com/
			    jQuery.notify({
			    	// options
			    	title: message.title,
			    	message: message.text
			    },{
			    	// settings
			    	type: message.type,
			    	offset: {
			    		x : 10,
			    		y : 70
			    	},
			    	animate: {
			    		enter: 'animated fadeInDown',
			    		exit: 'animated fadeOut'
			    	},
			    	delay : 2000,
			    	template: '<div data-notify="container" class="col-xs-12 col-sm-2 alert alert-{0}" role="alert">'
			    	+ '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>'
			    	+ '<span data-notify="icon"></span>'
			    	+ '<i class="' + icon + '"></i>&nbsp;'
			    	+ (message.title != '' ? '<span data-notify="title"><b>{1}</b></span><br />' : '')
			    	+ '<span data-notify="message">{2}</span>'
			    	+ '<div class="progress" data-notify="progressbar">'
			    	+ '	<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>'
			    	+ '</div>'
			    	+ '<a href="{3}" target="{4}" data-notify="url"></a>'
			    	+ '</div>'
			    });

			}
			window.config.messages = [];
		}
	};

	this.showGlobalNotification = function(text, type) {
		var newNotification = '<div class="alert alert-' + type +' alert-dismissible" role="alert">' +
		'<a class="close" data-dismiss="alert" aria-label="close"><i class="fas fa-times"></i></a>' + 
		text +
		'</div>';
		jQuery(SEL_MODULE).removeClass(CLASS_NO_MESSAGES).empty().append(newNotification)
	}



    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			showNotifications();

		});

    };

};

// Make class public to outside world
module.exports = Notification;

},{"../mediator/mediator":103,"bootstrap-notify/bootstrap-notify":2,"jquery/dist/jquery":14}],126:[function(require,module,exports){


/**
 * Notification functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
Notification = require('./Notification');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var notification = new Notification();
	
	// Trigger onload activities
	notification.init(initNode);

});
},{"../mediator/mediator":103,"./Notification":125}],127:[function(require,module,exports){
/**
 * NotificationTargetEdit functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');
Tracking       = require('../utils/Tracking');

// External libs
jQuery = require('jquery/dist/jquery');
var Alert               = require('../modals/Alert');
var SwitchableInputs    = require('../form/SwitchableInputs');

// Class definition
NotificationTargetEdit = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                            = '.mod-notification-target-edit';
  var SEL_RECIPIENT_FORM                    = '.recipient-form';
  var SEL_RECIPIENT_INPUT                   = '.recipient-input';
  var SEL_RECIPIENT_INPUT_CONTAINER         = '.switchable-inputs-target:visible';
  var SEL_FORM_VALIDATION_ERROR_MODAL       = '.noRecipient-alertModal';
  var SEL_FRONTEND_VALIDATION_HELP_BLOCK	  = ".fe-validation-block";
  var SEL_GLOBAL_MESSAGES                   = '.mod-global-messages';
  var SEL_HELP_BLOCK                        = '.help-block';
  var SEL_FORM_GROUP                        = '.form-group';

  var CSS_HAS_ERROR					                = 'has-error';

  var FORM_ERROR_TYPE								        = "form-error";
	var FORM_EVENT_TYPE								        = "error-form";
	var FORM_EVENT_NAME								        = "error";
  var FORM_EVENT_ACTION_NAME                = "Recipient";
  var FORM_ERROR_MESSAGE	                  = "Please enter recipients! | Recipients has not been created, please correct the highlighted errors.";

  var alertModal 							              = new Alert();

  //initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.error = window._adl.error || {};

  var showErrorModal = function(modal, error) {
		alertModal.show(modal, error);
	};

  //to update error tracking in adobe datalayer with event info
	var updateDatalayerErrorTracking = function(){
		if (window._satellite && window._adl) {

		  //push eventInfo in _adl
		  _adl.eventInfo = {
        eventName: FORM_EVENT_NAME,
        eventType: FORM_EVENT_TYPE
		  }
	
		  //push all the errors in adobe data layer
		  _adl.error = {
        errorType: FORM_ERROR_TYPE,
        errorMessage: FORM_ERROR_MESSAGE,
        errorFields: FORM_EVENT_ACTION_NAME
		  }
	
		  //fire direct call
		  window._satellite.track('errorCall');
		}
	}

  /**
   * Initialize.
   */
  this.init = function(initNode) {

        self = this;

    // Retrieve and cache dom nodes
    var moduleNodes           = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var switchableInputs = new SwitchableInputs();

      switchableInputs.init(moduleNode);

      var recipientForm = moduleNode.find(SEL_RECIPIENT_FORM);
      
      var formValidationErrorModal = moduleNode.find(SEL_FORM_VALIDATION_ERROR_MODAL);
      var formValidationErrorMessage = window.config.notificationTargetEdit.noRecipient || "";
      var noRecipientError = window.config.notificationTargetEdit.noRecipientError || "";
      
      // FE Validation and logic
			recipientForm.on('submit', function(event) {

        var recipientInputParent = moduleNode.find(SEL_RECIPIENT_INPUT_CONTAINER);
        var recipientInput = recipientInputParent.find(SEL_RECIPIENT_INPUT);

        // Restore all errors and hide notifications
        jQuery(SEL_GLOBAL_MESSAGES).hide();
        moduleNode.find(SEL_HELP_BLOCK).text("").hide();
        moduleNode.find(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);

        // Apply frontend validation rule(s) and logic
        var validationCondition = recipientInput.val() == "";

				if (validationCondition) {
          showErrorModal(formValidationErrorModal, formValidationErrorMessage);
          
          updateDatalayerErrorTracking();

          var recipientFormGroup = recipientInput.closest(SEL_FORM_GROUP);
          recipientFormGroup.toggleClass(CSS_HAS_ERROR, validationCondition);
          var feHelpBlock = recipientFormGroup.find(SEL_FRONTEND_VALIDATION_HELP_BLOCK);
          feHelpBlock.show().text(noRecipientError);
					event.stopImmediatePropagation();
					event.preventDefault();
					return false;
        }
        
			});

    });

  };

};

// Make class public to outside world
module.exports = NotificationTargetEdit;

},{"../form/SwitchableInputs":92,"../mediator/mediator":103,"../modals/Alert":110,"../utils/Tracking":188,"jquery/dist/jquery":14}],128:[function(require,module,exports){
/**
 * NotificationTargetList functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
NotificationTargetList = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE								= '.mod-notification-target-list';
    var SEL_NOTIFICATION_TARGET_ITEM_CLICK_ZONE	= '.table tbody tr td.clickable';
    var SEL_NOTIFICATIONS_OPTIONS               = '.mod-notification-options';
    var SEL_INTERNAL_MESSAGE                    = '#reservation-internalComment';

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {
			
            var notificationOptionsNode = moduleNodes.siblings(SEL_NOTIFICATIONS_OPTIONS);

            // var internalMessage = notificationOptionsNode.find(SEL_INTERNAL_MESSAGE);

			var notificationTargetItemClickZoneNodes = jQuery(this).find(SEL_NOTIFICATION_TARGET_ITEM_CLICK_ZONE);
			
			notificationTargetItemClickZoneNodes.bind('click', function() {
				document.location.href = jQuery(this).parents('tbody').attr('data-editurl');
			});

            notificationOptionsNode.on('change', SEL_INTERNAL_MESSAGE, function(){
                var ele = notificationOptionsNode.find(SEL_INTERNAL_MESSAGE).val();
				var maxChar = 500;
				var charLen = ele.length;
				var newlineCount = 0;

				for (let i = 0; i < ele.length; i++) {
					// check if the \n character is present
					if (ele[i] == "\n") {
						newlineCount += 1;
					}
				}

				charLen += newlineCount;
				maxChar -= newlineCount;

				if (charLen > maxChar) {
					notificationOptionsNode.find(SEL_INTERNAL_MESSAGE).val(ele.substring(0, maxChar));
				}
            })
			
		});

    };

};

// Make class public to outside world
module.exports = NotificationTargetList;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],129:[function(require,module,exports){
/**
 * WebsiteTracking functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
WebsiteTracking = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                  = '.mod-event-tracked-website';

  var SEL_CLICK_TRACKER           = '.click-tracker';

  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes = initNode.find(SEL_MODULE);
    

    /**
 * Set _adl.pageName regarding page offset
 */
    setADLPageName = function (sectionId) {
      if (typeof (sectionId) !== 'undefined') {

        if (!window._adl.pageName) return false;
        var sectionName = sectionId ? sectionId.slice(1) : 'homepage';
        var pageName = window._adl.pageName
        window._adl.pageName = pageName.substr(0, pageName.lastIndexOf(":")) + ":" + sectionName;
      }
    };

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode     = jQuery(this);

      moduleNode.find(SEL_CLICK_TRACKER).on('click', function () {
         setADLPageName(jQuery(this).attr('data-pointer'));
      });

    });

  };

};

// Make class public to outside world
module.exports = WebsiteTracking;

},{"../mediator/mediator":103,"jquery/dist/jquery":14}],130:[function(require,module,exports){


/**
 * Reservable functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
NotificationTargetList = require('./NotificationTargetList');
NotificationTargetEdit = require('./NotificationTargetEdit');
WebsiteTracking 	   = require('./WebsiteTracking');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var notificationTargetList = new NotificationTargetList();
	var notificationTargetEdit = new NotificationTargetEdit();
	var websiteTracking 	   = new WebsiteTracking();

	// Trigger onload activities
	notificationTargetList.init(initNode);
	notificationTargetEdit.init(initNode);
	websiteTracking.init(initNode);
});

},{"../mediator/mediator":103,"./NotificationTargetEdit":127,"./NotificationTargetList":128,"./WebsiteTracking":129}],131:[function(require,module,exports){
/**
 * Pagination functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
Pagination = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						= '.mod-pagination';
    var SEL_LINK_PREV					= 'a.prev';
    var SEL_LINK_NEXT					= 'a.next';
    var SEL_LINK_QUICKFILTER			= 'a.quickFilter';
    
    var ATTR_QUICKFILTER_ID				= 'data-quickfilter-id';
    var ATTR_QUICKFILTER_VALUE			= 'data-quickfilter-value';



    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
    	var moduleNodes 			= initNode.find(SEL_MODULE);
		var quickFilterButtonNode	= moduleNodes.find(SEL_LINK_QUICKFILTER);

		var quickFilterId 			= quickFilterButtonNode.attr(ATTR_QUICKFILTER_ID);
		var quickFilterValue 		= quickFilterButtonNode.attr(ATTR_QUICKFILTER_VALUE);
		var quickFilterNode			= jQuery('#' + quickFilterId);
		

		
		
		// Init all matching nodes
		moduleNodes.each(function() {

			var linkPrevNode = jQuery(this).find(SEL_LINK_PREV);
			var linkNextNode = jQuery(this).find(SEL_LINK_NEXT);
			
			// Make pages navigable via keyboard
			jQuery('body').bind('keydown', function(e) {
				var inputFields = jQuery('body').find('input, textarea, select, option, button');
				var activeInputFields = inputFields.filter(':focus').length;
				if ((inputFields.length == 0 || activeInputFields == 0) && e.which == 37) {
					var url = linkPrevNode.attr("href");
					if (url != undefined) {
						document.location.href = url;
					}
				} else if ((inputFields.length == 0 || activeInputFields == 0) && e.which == 39) {
					var url = linkNextNode.attr("href");
					if (url != undefined) {
						document.location.href = url;
					}
				}
			});			
			
			
		});
		
		// Add toggle to quickfilter
		quickFilterButtonNode.on('click', function() {

			if (quickFilterNode.is(':visible')) {
				quickFilterNode.slideUp();
			} else {
				quickFilterNode.slideDown();
			}

		});
		
		// Show quickfiler only in case it has a selection value
		if (quickFilterValue == '') {
			quickFilterNode.hide();
		}

    };

};

// Make class public to outside world
module.exports = Pagination;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],132:[function(require,module,exports){


/**
 * Pagination functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
Pagination 			= require('./Pagination');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var pagination 			= new Pagination();
	
	// Trigger onload activities
	pagination.init(initNode);

});
},{"../mediator/mediator":103,"./Pagination":131}],133:[function(require,module,exports){
/**
 * ReservableCapacityMode functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
ReservableCapacityMode = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE								= '.mod-reservable-capacity-mode';
    var SEL_CAPACITY_MODE_DROPDOWN				= '#reservableCapacityMode-capacityMode';
    var SEL_CAPACITY_MODE_WARNING_TO_SIMPLE		= '#reservableCapacityMode-capacityMode-msg-RESERVABLE2SIMPLE';
    var SEL_CAPACITY_MODE_WARNING_TO_RESERVABLE	= '#reservableCapacityMode-capacityMode-msg-SIMPLE2RESERVABLE';
    var SEL_CAPACITY_DROPDOWN					= '#reservableCapacityMode-capacity';
    var SEL_CAPACITY_ROW						= ".capacityRow";



    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {

			var capacityModeDropdownNode = jQuery(this).find(SEL_CAPACITY_MODE_DROPDOWN);
			var warningToSimpleNode = jQuery(this).find(SEL_CAPACITY_MODE_WARNING_TO_SIMPLE);
			var warningToReservableNode = jQuery(this).find(SEL_CAPACITY_MODE_WARNING_TO_RESERVABLE);

			var capacityDropdownNode = jQuery(this).find(SEL_CAPACITY_DROPDOWN);
			var capacityRowNode = jQuery(this).find(SEL_CAPACITY_ROW);
					
			capacityModeDropdownNode.bind('change', function() {
				warningToSimpleNode.hide();
				warningToReservableNode.hide();
				if (jQuery(this).val() == 'SIMPLE') {
					warningToSimpleNode.show();
					capacityDropdownNode.removeAttr("disabled");
					capacityRowNode.css("opacity", "1");
				} else {
					warningToReservableNode.show();
					capacityDropdownNode.attr("disabled", "disabled");
					capacityRowNode.css("opacity", "0.5");
				}
			}).trigger('change');
			
			// Initially hide messages
			warningToSimpleNode.hide();
			warningToReservableNode.hide();	
			
		});

    };

};

// Make class public to outside world
module.exports = ReservableCapacityMode;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],134:[function(require,module,exports){


/**
 * Reservable functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
ReservableCapacityMode	= require('./ReservableCapacityMode');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var reservableCapacityMode	= new ReservableCapacityMode();

	// Trigger onload activities
	reservableCapacityMode.init(initNode);

});
},{"../mediator/mediator":103,"./ReservableCapacityMode":133}],135:[function(require,module,exports){
/**
 * ReservationEdit functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery 					= require('jquery/dist/jquery');
var Datepicker  		= require('bootstrap.datepicker');
Typeahead  				= require('typeahead');
moment 					= require("moment");
Bloodhound				= require('bloodhound');
xssEscape       		= require('xss-escape/xss-escape');
DateUtils				= require('../utils/DateUtils');
UserInterfaceUtils 		= require('../utils/UserInterfaceUtils');
Notification			= require('../notification/Notification');
FormInputFilter  		= require('../form/FormInputFilter');

// Confirm class
var Confirm             = require('../modals/Confirm');
var resultSlots         = [];

// Fix for the tooltip issue where it is shown not only on hover but also on focus and click.
jQuery('[data-toggle="tooltip"]').on('mouseenter', function () {
	jQuery(this).tooltip('show');
}).on('mouseleave', function () {
	jQuery(this).tooltip('hide');
}).on('focus click', function () {
	jQuery(this).tooltip('hide');
});



// Class definition
ReservationEdit = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE							= '.mod-reservation-edit';

	var SEL_FORM							= 'form';
	var SEL_LABEL 							= 'label';
	var SEL_FORM_GROUP						= '.form-group';
	var SEL_HELP_BLOCK						= '.help-block';

	var SEL_START_DATE_DISPLAY 				= '#reservation-date';
	var SEL_SELECTED_DATES 					= '#reservation-selectedDates';
	var SEL_CAPACITY 						= '#reservation-capacity';
	var SEL_ADDITIONAL_CAPACITY				= '#reservation-additionalCapacity';
	var SEL_TIME_SLOTS 						= '#reservation-slot';
	var SEL_TABLES 							= '#reservation-reservableIds';
	var SEL_EMAIL_FIELD						= '#reservation-fieldEm';
	var SEL_FIRST_NAME_INPUT				= "input#reservation-fieldFn";
	var SEL_LAST_NAME_INPUT					= "input#reservation-fieldLn";
	var SEL_PHONE_NUMBER_INPUT 				= 'input#reservation-fieldPn';
	var SEL_INTERNAL_COMMENTS 				= '#reservation-internalComment';
	var SEL_CUSTOMER_NOTES 					= '#reservation-customerNote';
	var SEL_NEWSLETTER_INPUT 				= '#reservation-notifyCustomer';	
	var SEL_EXTENDED_RESERVATIONS_DROPDOWN	= '#reservation-extendedTimes';
	var SEL_REQUEST_CCG           			= '#reservation-requestCCG';
	var SEL_MOVE_ON_DESKTOP					= '.move-on-desktop';
	var SEL_RESERVATION_OCCASSION 			= '#reservation-purpose';
	var SEL_RESERVATION_CREATED_BY_INPUT 	= 'input#reservation-fieldCb';
	var SEL_MAIN_GUEST_VACCINATION_DROPDOWN = '.main-guest-information #reservation-vaccinationStatus';
	var SEL_MAIN_GUEST_ADDRESS_INPUT 		= '.main-guest-information #reservation-customerAdd';
	var SEL_EDITABLE_OTHER_GUEST_INFO 		= '.editable-other-guest-information';
	var SEL_OTHER_GUEST_VACCINATION_DROPDOWN = '.editable-other-guest-information #reservation-vaccinationStatus';
	var SEL_OTHER_GUEST_INFO_INPUT_WRAPPER 	= '.card-body .itemContainer .inputWrapper';
	var SEL_CARD_BODY 						= '.card-body';

	var SEL_OTHER_GUEST_INFORMATION			= '.otherGuestInformation';
	var SEL_OTHER_GUEST_ITEM_TEMPLATE		= '.templateItem';
	var SEL_OTHER_GUEST_ITEM				= '.inputWrapper';
	var SEL_OTHER_GUEST_HEADLINE 			= '.headline';
	var SEL_HELP_BLOCK_PHONE 				= '.phoneNrOtherInfo'; 
	var SEL_OTHER_GUEST_ITEM_CONTAINER		= '.itemContainer';
	var SEL_OTHER_GUEST_NAME				= '.otherGuestName';
	var SEL_OTHER_GUEST_ADDRESS				= '.otherGuestAddress';
	var SEL_OTHER_GUEST_PHONEN_INPUT_WRAP	= '.otherGuestInfoPhoneInputWrapper';
	var SEL_OTHER_GUEST_PHONENUMBER			= '.otherGuestPhoneNumber';
	var SEL_OTHER_GUEST_VACCINESTATUS		= '.guestVaccineStatus';
	var SEL_OPTIONS							= 'option';
	var SEL_ENABLED_OPTIONS					= 'option:not([disabled])';
	var SEL_SUGGESTED_OPTIONS				= 'option[data-suggested="true"]';
	var SEL_WARNING_CAPACITY				= '.warningCapacityText';

	var SEL_ALLERGIES_LIST 					= '.allergies-list';
	var SEL_DIET_LIST 						= '.diet-list';
	var SEL_CHECKBOX 						= 'input[type="checkbox"]';
	var SEL_FORM_GROUP_INPUT_WRAP 			= '.form-group-input-wrap';
	var SEL_FORM_GROUP 						= '.form-group';
	var SEL_FORM_GROUP_WITH_INFO_TEXT 		= '.form-group.info-text';
	var SEL_COL_SM_9						= '.col-sm-9';
	var SEL_ROW 							= '.row';

	var SEL_FEEDBACK_ITEM_CSRF				= 'input[name="_csrf"]';

	var SEL_CAPACITY_OVERRIDE_CONFIRM_MODAL = ".capacity-override-confirm-modal";
	var SEL_SUBMIT_BUTTON					= "button[type='submit']";
	var SEL_RESEND_CCG_BUTTON				= '.resend-card-guarantee-request';
	var SEL_CAPACITY_OVERRIDE_INPUT			= "input[name='checkGuestCapacityLimits']";
	
	var SEL_MAIN_HEADLINE_WRAPPER			= '.mod-reservation-intro-section';
	var SEL_INTRO_BACK_BUTTON				= '.btn.btn-default';
	var SEL_MOBILE_HEADLINE					= '.mod-mobile-headline';
	var SEL_MOBILE_BACK_BUTTON				= '.headline-button.btn.btn-default';

	var SEL_RESERVABLE_DROPDOWN 			= '.btn.dropdown-toggle.bs-placeholder.btn-default';
	var SEL_RESERVABLE_PLACEHOLDER_OPTION 	= '.filter-option-inner-inner';

	var DATA_ATTR_TARGET					= 'target';

	var ATTR_CAPACITY						= 'data-capacity';
	var ATTR_SUGGESTED						= 'data-suggested';
	var ATTR_INTERNAL_TIME					= 'data-internal-time';

	var CSS_HAS_ERROR						= 'has-error';
	var CSS_HIDDEN							= 'hidden';
	var CSS_MOVE_ON_DESKTOP					= 'move-on-desktop';
	var CSS_TEMPLATE_ITEM					= 'templateItem';
	var CSS_REMOVE_BOTTOM_SPACING 			= 'remove-bottom-padding';
	var CSS_DISABLED_ALLERGIES 				= 'disabled-allergies';
	var CSS_DISABLED_DIETS 					= 'disabled-diets';

	var CAPACITYT_MODE_RESERVABLE			= 'RESERVABLE';

	var REGEX_ISO_EXTRACT_TIME				= /[0-9]{4}-[0-9]{2}-[0-9]{2}T([0-9]{2}):([0-9]{2}):[0-9]{2}.*/;

	var CONST_EMAIL_REG 		            = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

	var SEL_MODAL_STATUS_CONFIRM 			= '#reservationStatusConfirmModal';
	var SEL_MODAL_MESSAGE_TEXT 				= '.customer-message';
	var SEL_MODAL_CLOSE						= '.close';
	var SEL_MODAL_SUBMIT 					= '.submit-button';
	var SEL_FEEDBACK_REPLY_BTN				= ".reply-button";
	var SEL_FEEDBACK_REPLIED_BTN			= ".replied-button";

	var CSS_VISIBLE_REPLIED_BLOCK			= "visible-replied-button";

	var SEL_GLOBAL_MESSAGE					= '.mod-global-messages';
	var SEL_ALERT_DANGER					= '.alert-danger';

	var DISCOUNT_TYPE = {
		NONE: 'NONE',
		ALL: 'ALL',
		CUSTOM: 'CUSTOM',
		HAPPY_HOURS: 'HAPPY_HOURS'
	};

	var dateUtils = new DateUtils();
	var isCapacityOrDateChange = false;
	var isOnlyDateChange = false;
	var pathIndex = -1;
	var isDurationReset = false;

	var confirmModal = new Confirm();
	var notification = new Notification();
	var localConfig = window.config.reservationEdit || [];
	var localMsgConfig 	= (window.config.msg && window.config.msg.reservationEdit) || [];

	//Meal Hours should display if the timeslot is under any meal periods
	//set count variable on the basis of page url (either it is Edit or Add)
	var pageUrl = window.location.href;
	var count;
	if(pageUrl.indexOf("add?") == -1){
		count = 0; //in case of edit
	}else{
		count = 1; //in case of add
	}

	//store the last selected value of duration input
	var preserveTimeslot = "";
	//store the last selected value of duration input
	var preserveReservables = [];

	var preventDoubleSubmit = function(form) {
		form.submit(function() {
			if (form.data('beenSubmitted')) {
				return false;
			}
			if (form.find(".has-error").length === 0) {
				form.data('beenSubmitted', true);
			}
		});
	};

	/**
	 * Check is establishment in table mode.
	 * Find select what is responsible for selecting tables and if it exist - return true.
	 * @param {*} form 
	 * @return Boolean
	 */
	var isTableMode = function(form) {
		return form.find(SEL_TABLES).length > 0;
	}

	/**
	 * Handle validation on form submission.
	 */
	var handleFormSubmit = function(passedForm, isWalkInCase, moduleNode) {

		var form			= jQuery(passedForm);
		var originalDates 	= form.find(SEL_SELECTED_DATES);
		var displayDate 	= form.find(SEL_START_DATE_DISPLAY);
		var timeSlot 		= form.find(SEL_TIME_SLOTS);
		var capacity		= form.find(SEL_CAPACITY);
		var email			= form.find(SEL_EMAIL_FIELD);
		var requestCCG      = form.find(SEL_REQUEST_CCG);
		var additionalCapacity = form.find(SEL_ADDITIONAL_CAPACITY);
		var firstName		= form.find('#reservation-fieldFn');
		var lastName		= form.find('#reservation-fieldLn');
		var purpose			= form.find(SEL_RESERVATION_OCCASSION);
		var source			= form.find('#reservation-origin');
		var notifyCustomer 	= form.find('#reservation-notifyCustomer');
		var firstNameInput		= form.find(SEL_FIRST_NAME_INPUT);
		var lastNameInput		= form.find(SEL_LAST_NAME_INPUT);
		var createdByInput		= form.find(SEL_RESERVATION_CREATED_BY_INPUT);

		var additionalCapacityTotal = 0;
		var selectedCapacity = getSelectedCapacity(form);
		var insertedCapacity = parseInt(capacity.val());
		
		additionalCapacityTotal = selectedCapacity - insertedCapacity;
		if(isTableMode(form) && additionalCapacityTotal <= 0) {
			additionalCapacityTotal = Math.abs(additionalCapacityTotal);
			additionalCapacity.val(additionalCapacityTotal);
		
		} else {
			additionalCapacity.val(0);
		}

		// Make sure that after first submission the validation is done with every change
		form.unbind('change', handleFormSubmit);
		form.bind('change', handleFormSubmit);

		var errors = 0;
		var errorFields = [];

		//
		// Note: Not using some plugin here, since this is very specific validation.
		//       For any further frontend validation we should decide for a good plugin.
		//

		// Validate start date
		var displayDateFormGroup = displayDate.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		var timeSlotFormGroup = timeSlot.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		if (!isWalkInCase && !originalDates.val()) {
			displayDateFormGroup.addClass(CSS_HAS_ERROR);
			timeSlotFormGroup.addClass(CSS_HAS_ERROR);
			//push the time slot field to array if this has errors
			errorFields.push(timeSlotFormGroup);
			errors++;
		}

		if (!isWalkInCase && !timeSlot.val()) {
			timeSlotFormGroup.addClass(CSS_HAS_ERROR);
			//push the time slot field to array if this has errors
			errorFields.push(timeSlotFormGroup);
			errors++;
		}

		// Validate capacity
		var capacityFormGroup = capacity.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		if (!capacity.val()) {
			capacityFormGroup.addClass(CSS_HAS_ERROR);
			errors++;
		}

		// Email validation
		var emailFormGroup = email.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		var isEmailValid = true;
		if(email.val() != '') {
			isEmailValid = CONST_EMAIL_REG.test(email.val());
		}
		if (!isEmailValid && !isWalkInCase) {
			emailFormGroup.addClass(CSS_HAS_ERROR);
			errors++;
		}

		if(!isWalkInCase){
			// Validate firstName and lastName, purpose and source
			var firstNameFormGroup 	= firstName.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
			var firstNameHelpBlock 	= firstNameFormGroup.find(SEL_HELP_BLOCK).empty();
			var lastNameFormGroup 	= lastName.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
			var lastNameHelpBlock 	= lastNameFormGroup.find(SEL_HELP_BLOCK).empty();
			var purposeFormGroup 	= purpose.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
			var purposeHelpBlock 	= purposeFormGroup.find(SEL_HELP_BLOCK).empty();
			var sourceFormGroup 	= source.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
			var sourceHelpBlock 	= sourceFormGroup.find(SEL_HELP_BLOCK).empty();
		}

		// Validation if both First and Last Name inouts are empty
		var firstNameFormGroup = firstNameInput.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		var lastNameFormGroup = lastNameInput.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		if(firstNameInput.val() == "" && lastNameInput.val() == ""){
			firstNameFormGroup.addClass(CSS_HAS_ERROR);
			lastNameFormGroup.addClass(CSS_HAS_ERROR);
			notification.showGlobalErrorNotification(localMsgConfig.errorNoNameProvided);
			errors++;
		}else{
			if(moduleNode){
				var formErrorElement = moduleNode.siblings(SEL_GLOBAL_MESSAGE).find(SEL_ALERT_DANGER);
				if(formErrorElement.length === 1){
					formErrorElement.addClass('hide');
				}
			}
		}
		// Email validation
		if (email.val() == '' && requestCCG.prop('checked') ) {
			emailFormGroup.addClass(CSS_HAS_ERROR);
			notification.showGlobalErrorNotification(localMsgConfig.errorNoEmailOnCCGRequest);
			errors++;
		}
		if (email.val() != '' && requestCCG.prop('checked') && !isEmailValid ) {
			emailFormGroup.addClass(CSS_HAS_ERROR);
			notification.showGlobalErrorNotification(localMsgConfig.invalidEmailFormat);
			errors++;
		}
		if (source.val() != '' && requestCCG.prop('checked') && source.val() === 'WALKIN' ) {
			sourceFormGroup.addClass(CSS_HAS_ERROR);
			notification.showGlobalErrorNotification(localMsgConfig.invalidSourceSelection);
			errors++;
		}

		let notifyCustomerGroup = notifyCustomer.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		if (localConfig.isEditReservation === 'true' && !notifyCustomer.is(':checked') && requestCCG.is(':checked')) {
			notifyCustomerGroup.addClass(CSS_HAS_ERROR);
			notification.showGlobalErrorNotification(localMsgConfig.notifyCustomerNotChecked);
			errors++;
		}

		// Validate Card Guarantee for series reservation
		const requestCCGFormGroup = requestCCG.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		const selectedDates = String(originalDates.val());
		const selectedDatesSplit = selectedDates.split(",");
		if (requestCCG.prop('checked') && selectedDatesSplit.length > 1) {
			requestCCGFormGroup.addClass(CSS_HAS_ERROR);
			notification.showGlobalErrorNotification(localMsgConfig.errorSeriesReservationWithCardGuarantee);
			errors++;
		}

		// Validate other guest information
		// Validate phone number 
		var otherGuestPhoneNumberWrapper = form.find(SEL_OTHER_GUEST_PHONEN_INPUT_WRAP);
		var otherGuestPhoneNumber = form.find(SEL_OTHER_GUEST_PHONENUMBER);
		var validationErrorMassage = form.find(SEL_HELP_BLOCK_PHONE);
		var otherGuestPhoneNumberLabel = otherGuestPhoneNumberWrapper.siblings(SEL_LABEL);
		var numbers = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
		
		for (x = 1; x < otherGuestPhoneNumberWrapper.length; x++) {
			if (otherGuestPhoneNumber[x].value.match(numbers) || otherGuestPhoneNumber[x].value == '') {
				otherGuestPhoneNumberWrapper[x].classList.remove(CSS_HAS_ERROR);
				otherGuestPhoneNumberLabel[x].classList.remove(CSS_HAS_ERROR);
				validationErrorMassage[x].innerHTML = '';
				validationErrorMassage[x].classList.remove(CSS_HAS_ERROR);
			} else {
				otherGuestPhoneNumberWrapper[x].classList.add(CSS_HAS_ERROR);
				otherGuestPhoneNumberLabel[x].classList.add(CSS_HAS_ERROR);
				validationErrorMassage[x].innerHTML = (localMsgConfig.errorOtherGuestPhNr);
				validationErrorMassage[x].classList.add(CSS_HAS_ERROR);
				errors++
			}
		}

		// validate created by
		var createdByFormGroup = createdByInput.parents(SEL_FORM_GROUP).removeClass(CSS_HAS_ERROR);
		if (createdByInput.val() == '') {
			createdByFormGroup.addClass(CSS_HAS_ERROR);
			notification.showGlobalErrorNotification(localMsgConfig.errorNoCreatedByProvided);
			errors++;
		}

		//if time slot field has an error, will scroll to input for mobile devices
		if(jQuery(window).width() <= 1024){
			if(errorFields.length > 0){
				jQuery('html, body').animate({
					scrollTop: (errorFields[0].offset().top - 150)
				   }, 2000);
			}
		}

		return (errors == 0);
	};


	var getSelectedCapacity = function(form){
		var optionSelector	= form.find(SEL_TABLES);
		var options			= optionSelector.find('option');
		var selectedCapacity = 0;

		for(var index = 0; index < options.length; index ++){
			if(jQuery(options[index]).prop('selected')){
				selectedCapacity = selectedCapacity + parseInt(jQuery(options[index]).attr('data-capacity'));
			}
		};
		return parseInt(selectedCapacity);
	};
	/**
	 * Init autosuggest for last name input
	 */
	var initAutosuggest = function(module) {

		let firstName 		= module.find(SEL_FIRST_NAME_INPUT);
		var lastName 		= module.find(SEL_LAST_NAME_INPUT);
		let phoneNumber 	= module.find(SEL_PHONE_NUMBER_INPUT);
		var email	 		= module.find(SEL_EMAIL_FIELD);
		var dietList 		= module.find(SEL_DIET_LIST);
		var allergiestList 	= module.find(SEL_ALLERGIES_LIST);
		var guestNote       = module.find('#reservation-customerNote');

		let fieldNameLastName = 'lastName';
		let fieldNameFirstName = 'firstName';
		let fieldNamePhoneNumber = 'phoneNumber';
		let createEngine = function(fieldUrl) {
			return new Bloodhound({
				queryTokenizer: Bloodhound.tokenizers.whitespace,
				datumTokenizer: Bloodhound.tokenizers.obj.whitespace(fieldNameFirstName, fieldNameLastName, fieldNamePhoneNumber),
				remote: {
					url: config.apiUrlCustomerAutoSuggest + fieldUrl + '/%QUERY',
					wildcard: '%QUERY',
					transform : function(data) {
						return data.results;
					}
				}
			});
		}

		let bindTypeahead = function(element, engine, displayKey) {
			element.typeahead(
				{
					minLength: 3
				},
				{
					source: engine,
					displayKey: displayKey,
					limit: Infinity,
					templates : {
						suggestion: function(item) {
							let escapedItem = xssEscape(item);
							let lastname = escapedItem[fieldNameLastName] || '';
							let firstname = escapedItem[fieldNameFirstName] || '';
							let phonenumber = escapedItem[fieldNamePhoneNumber] || '';
							let email = escapedItem.email || '';
							return `<div><span class="fullname"><span>${lastname}</span><span>${firstname}</span></span><span>${phonenumber}</span><span>${email}</span></div>`;
						}
					}
				}
			);
		}

		// Define autosuggest lookup
		let engineLastName = createEngine(fieldNameLastName);
		let engineFirstName = createEngine(fieldNameFirstName)
		let enginePhoneNumber = createEngine(fieldNamePhoneNumber);
		// Bind typeahead functionality to field
		bindTypeahead(lastName, engineLastName,fieldNameLastName);
		bindTypeahead(firstName, engineFirstName, fieldNameFirstName);
		bindTypeahead(phoneNumber, enginePhoneNumber, fieldNamePhoneNumber);

		// Handle selection of autosuggest suggestions
		[firstName, lastName, phoneNumber].forEach((element) => {
			element.bind('typeahead:select', (ev, suggestion) => {
				// Update according fields
				fillCustomerFormFieldsFromSuggestion(suggestion);
			});
		})

		let fillCustomerFormFieldsFromSuggestion = function(suggestion){
			lastName.val(suggestion[fieldNameLastName]);
			firstName.val(suggestion[fieldNameFirstName]);
			phoneNumber.val(suggestion[fieldNamePhoneNumber]);
			email.val(suggestion.email);

			// Indicate change by visual effect
			lastName.hide().fadeIn();
			firstName.hide().fadeIn();
			phoneNumber.hide().fadeIn();
			email.hide().fadeIn();

			sendRequestForGuestData(module, suggestion.customerId, (response) => {
				guestNote.val(response.note);
				guestNote.hide().fadeIn();
				preselectFoodPreferences(dietList, response.diets);
				preselectFoodPreferences(allergiestList, response.allergies);
			});
		}
	};

	/**
	 * Init autosuggest for createdBy field
	 * @param module
	 */
	const initCreatedByAutosuggest = function (module) {
		let createdBy = module.find(SEL_RESERVATION_CREATED_BY_INPUT);

		// Define autosuggest lookup
		let engine = new Bloodhound({
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
			sorter: (a, b) => -1,
			prefetch: {
				url: config.apiUrlCreatedByAutoSuggest,
				cache: false,
				transform: function (listOfNames) {
					return engine.sorter(listOfNames);
				}
			}
		});

		// Bind typeahead functionality to field
		createdBy.typeahead(
			{
				minLength: 0,
				classNames: {
					menu: 'tt-menu tt-menu-createdby'
				}
			},
			{
				source: createdByDefaults,
				displayKey: 'name',
				limit: 15,
				templates: {
					suggestion: function (item) {
						let escapedItem = xssEscape(item);
						return '<div><b>' + escapedItem.name + '</b></div>';
					}
				}
			}
		);

		function createdByDefaults(q, sync, async) {
			if (q === '') {
				sync(engine.all());
			} else {
				engine.search(q, sync);
			}
		}

		createdBy.bind('focus', function () {
			engine.initialize().done(
				function() {
					engine.search('');
				}
			);
		});
		return engine;
	};

	var sendRequestForGuestData = function(moduleNode, userId, callback) {
		var csrf = moduleNode.find(SEL_FEEDBACK_ITEM_CSRF).val();
		jQuery.ajax({
			url: `/guest/${userId}`,
			type: 'GET',
			data: {
				_csrf: csrf
			},
			dataType: 'json',
			success: (result, status) => callback(result),
			error: () => console.log(`guest data request failed for guest ${userId}`)
		});
	}

	/**
	 * Preselect checkboxes by data recived from BE
	 * @param {*} list 
	 * @param {*} selectedItems 
	 */
	var preselectFoodPreferences = function(list, selectedItems) {

		list.find(SEL_CHECKBOX).prop('checked', false);

		selectedItems.forEach(function(item) {
			list.find(`[value="${item.toLowerCase()}"]`).prop('checked', true);
		});
	}

	var initCalendarDisplay = function(displayDate, isWalkInCase) {

		let calenderSelectedDates = [];
		let infoTimeout;
		//On init the multiSelect checkbox will be checked only when the series reservation failed
		let isMultiSelect = localConfig.seriesReservationFailed && localConfig.selectedDates.length > 1;
		let selectedDates = localConfig.selectedDates;
		const currentDate = new Date();

		if(localConfig.calendarLanguageCode === 'hu'){
			var closedDates = localConfig.closedDates.map(function(str) {
				const [date, month, year] = str.split("/");				
				return `${year}-${month}-${date}`;      
			});
		}

		const datepickerConfig = {
			format: localConfig.calendarDateFormat,
			startDate: "+0d",
			datesDisabled: localConfig.calendarLanguageCode === 'hu' ? closedDates : localConfig.closedDates,
			daysOfWeekDisabled: [],
			language: localConfig.calendarLanguageCode,
			weekStart: 1,
			minViewMode: 'days',
			maxViewMode: 'days',
			todayHighlight: false,
			multidateSeparator: '; '
		};

		displayDate.datepicker({
			...datepickerConfig,
			autoclose: !isMultiSelect,
			multidate: isMultiSelect
		}).on('show', function(e) {
			if (!localConfig.isPayingCustomer || !localConfig.seriesReservationEnabled || localConfig.isEditReservation === 'true') return;
			let multiSelectCheckBox = '.datepicker-days .custom-footer .multiSelectCheckbox';
			if(jQuery(multiSelectCheckBox).length === 0){
				const checkboxHTML = `<div class="col-sm-10 custom-checkbox-container"><input type="checkbox" class="multiSelectCheckbox" ${isMultiSelect ? 'checked' : ''}>
												<label title="${localMsgConfig.reservationDatesSelectMessage}">${localMsgConfig.reservationDatesSelectMessage}</label></div>`;
				const okButtonHTML = isMultiSelect ?
							`<div class="col-sm-2 custom-button-container"><button id="okButton" class="btn btn-primary">${localMsgConfig.dateSelectOkMessage}</button></div>` :
							`<div class="col-sm-2 custom-button-container"></div>`;
				const customFooter = jQuery(`<div class="custom-footer"><div class="msgHolder"></div><div>${checkboxHTML}${okButtonHTML}</div></div>`);
				jQuery('.datepicker-days').append(customFooter);
			}
			jQuery(multiSelectCheckBox).on('click', function(e) {
				isMultiSelect = jQuery('.multiSelectCheckbox').is(':checked');
				displayDate.datepicker('setDates', isMultiSelect ? calenderSelectedDates : calenderSelectedDates[0]);
				displayDate.datepicker('destroy').datepicker({
					...datepickerConfig,
					autoclose: !isMultiSelect,
					multidate: isMultiSelect
				}).datepicker('show');
				e.stopPropagation();
			});
			jQuery('#okButton').on('click', function() {
				displayDate.datepicker('hide');
			});
		}).on('changeDate', function(e) {
			if (!localConfig.isPayingCustomer || !localConfig.seriesReservationEnabled || localConfig.isEditReservation === 'true') return;
			let dates = e.dates;
			if (dates.length === 0) {
				// If no dates selected, set to today's date
				displayDate.datepicker('setDates', currentDate);
			} else if ( dates.length > localConfig.seriesReservationLimit) {
				displayDate.datepicker('setDates', calenderSelectedDates);
				if (jQuery('.custom-footer .msgHolder .fade-info').length === 0) {
					let infoMessage = jQuery('<div class="fade-info"><label>'+localMsgConfig.reservationDatesLimitMessage+'</label></div>');
					jQuery('.msgHolder').append(infoMessage);
					clearTimeout(infoTimeout);
					infoTimeout = setTimeout(function() {
						infoMessage.fadeOut(500, function() {
							infoMessage.remove();
						});
					}, 1000);
				}
			} else {
				calenderSelectedDates = dates;
			}
		});

		if(isWalkInCase) {
			//pre-fill the datepicker with currentDate
			displayDate.datepicker('setDates', currentDate);
		} else {
			const isAnySelectedDateInPast = selectedDates.filter(d => d < new Date()).length > 0;
			displayDate.datepicker('setDates', (selectedDates.length === 0 || isAnySelectedDateInPast) ? currentDate : selectedDates);
		}
	};

	var validateCapacity = function(capacity) {
		var inputFilter = new FormInputFilter();
		var max = capacity.attr('max');
		var min = capacity.attr('min');
		var FILTER_NUMBER_UNDER_100  = function(value) {
			return value === "" || ( /^\d*$/.test(value) && parseInt(value) >= min && parseInt(value) <= max );
		};
		inputFilter.init(capacity, FILTER_NUMBER_UNDER_100);
	};

	function addSelectOption(dropdown, value, text, isDisabled) {
		var option = jQuery('<option />')
						.text(text)
						.attr('value', value)
						.appendTo(dropdown);
		if (isDisabled) {
			option.attr('disabled', 'disabled');
		}
		return option;
	};

	function addErrorMsgToDuration(dropdown) {
		addSelectOption(dropdown, '', localMsgConfig.errorNoSlotsAvailable, true);
	};

	function addPlaceholderToDuration(dropdown) {
		addSelectOption(dropdown, '', localMsgConfig.extendedTimePlaceholder, true);
	};

	function addErrorMsgToSlots(dropdown) {
		addSelectOption(dropdown, '', localMsgConfig.errorNoSlotsAvailable, true);
	};

	function addPlaceholderToSlots(dropdown) {
		addSelectOption(dropdown, '', localMsgConfig.selectSlot, true);
	};

	function addNotAvailableErrorMsgToTables(dropdown) {
		addSelectOption(dropdown, '', localMsgConfig.errorNoReservablesAvailable, true);
	};

	function addNotLoadedErrorMsgToTables(dropdown) {
		addSelectOption(dropdown, '', localMsgConfig.errorReservablesNotLoaded, true);
	};

	function addPlaceholderToTables(dropdown) {
		addSelectOption(dropdown, '', localMsgConfig.selectSlotFirst, true);
	};

	/**
	 * update the default placeholder of reservable dropdown
	 * @param {*} dropdown reservable dropdown
	 */
	function updateReservableDefaultPlaceholder(dropdown){
		dropdown.siblings(SEL_RESERVABLE_DROPDOWN).find(SEL_RESERVABLE_PLACEHOLDER_OPTION).text(localMsgConfig.selectSlotFirst);
	}

	var calculateSelectedCapacity = function(reservableDropdown, currentSelection) {
		var totalCapacity = 0;
		reservableDropdown.find(SEL_OPTIONS).each(function() {
			var option = jQuery(this);
			var value = option.attr('value') || '';
			if (currentSelection.indexOf(value) >= 0) {
				var optionCapacity = parseInt(option.attr(ATTR_CAPACITY));
				totalCapacity += isNaN(optionCapacity) ? 0 : optionCapacity;
			}
		});
		return totalCapacity;
	};

	var calculateAvailableCapacity = function(reservableDropdown) {
		var totalCapacity = 0;
		reservableDropdown.find(SEL_ENABLED_OPTIONS).each(function() {
			var option = jQuery(this);
			var optionCapacity = parseInt(option.attr(ATTR_CAPACITY));
			totalCapacity += isNaN(optionCapacity) ? 0 : optionCapacity;
		});
		return totalCapacity;
	};

	var getSuggestedValues = function(reservableDropdown) {
		var values = [];
		reservableDropdown.find(SEL_SUGGESTED_OPTIONS).each(function() {
			var value = jQuery(this).attr('value') || '';
			if (value !== '') {
				values.push(value);
			}
		});
		return values;
	};

	/**
	 * search the previous reservable inside the dropdown list and get it selected, to make it highlighted
	 * @param {*} reservableDropdown 
	 * @param {*} prevSelection 
	 */
	var makePreviousReservableSelected = function(reservableDropdown, prevSelection){
		var isPrevReservableExist = false;
		reservableDropdown.find('option').each(function(){
			var item = jQuery(this);
			(prevSelection || []).filter(function(elem){
				if(parseInt(elem.id) == parseInt(item.attr('value'))){
					item.attr("selected", "selected");
					isPrevReservableExist = true;
				}
			});
		});

		if(!isPrevReservableExist){
			makeSuggestedReservableSelected(reservableDropdown);
		}
	}

	var makeSuggestedReservableSelected = function(reservableDropdown){
		//prefill with suggested values
		var suggestedValues = getSuggestedValues(reservableDropdown);
		reservableDropdown.selectpicker('val', suggestedValues);
	}

	/**
	 * calculate the previous reservables total capacity
	 * @param {*} prevSelection 
	 * @returns 
	 */
	var getPrevReservablesTotalCapacity = function(prevSelection){
		var result = (prevSelection || []).reduce(function(previousValue, currentValue) {
            return previousValue + currentValue.capacity;
        }, 0);

		return result;
	}

	/**
	 * validate the selected reservable's capacity
	 * @param {*} reservableDropdown 
	 * @param {*} availableCapacity 
	 * @param {*} requiredCapacity 
	 * @param {*} selectedCapacity 
	 * @param {*} prevSelectedCapacity 
	 * @param {*} isCapacityExceed 
	 * @param {*} prevReservableSelection 
	 * @param {*} prevReservableTotalCapacity 
	 */
	var validateSelectedReservableCapacity = function(reservableDropdown, availableCapacity, requiredCapacity, selectedCapacity, prevSelectedCapacity, isCapacityExceed, prevReservableSelection, prevReservableTotalCapacity, suggestedReservablesTotal) {

		if (requiredCapacity > availableCapacity) {
			// Show error if not enough capacity available
			notification.showErrorNotification(localMsgConfig.errorNoReservablesAvailable);
		} else if (selectedCapacity > requiredCapacity) {
			// Show warning if bad capacity planning
			notification.showWarningNotification(localMsgConfig.warningReservableSelectionSuboptimal);
		} else if (selectedCapacity < requiredCapacity) {
			// Adapt selection if selected reservable capacity not sufficient
			var prevSelectedReservables = localConfig.reservableIds;
			if(!isCapacityExceed){
				//if previous reservable's capacity is lesser than required one
				if((prevReservableTotalCapacity < requiredCapacity) || (prevReservableTotalCapacity > suggestedReservablesTotal)){
					makeSuggestedReservableSelected(reservableDropdown);
				}else{
					//otherwise prefill with previous selected reservables choice
					makePreviousReservableSelected(reservableDropdown, prevReservableSelection);
				}
			}else{
				reservableDropdown.selectpicker('val', prevSelectedReservables);
			}
			// Show info (only in case of edit)
			if (prevSelectedCapacity > 0) {
				notification.showInfoNotification(localMsgConfig.infoReservablesAdapted);
			}
		} else if(selectedCapacity == 0 && requiredCapacity == 0){ //if there is no entered capacity
			//prefill with previous selected reservables choice
			makePreviousReservableSelected(reservableDropdown, prevReservableSelection);
		}
	};

	var hasAllOptions = function(dropdown, items) {
		// get all non-disabled values
		var availableOptions = [];
		dropdown.find(SEL_ENABLED_OPTIONS).each(function() {
			var value = jQuery(this).attr('value') || '';
			availableOptions.push(value);
		});
		// check each item, and see if it's available
		for (var i=0; i<items.length; i++) {
			// if not available, then we know all options are not available
			if (availableOptions.indexOf(items[i]) < 0) {
				return false;
			}
		}
		return true;
	};

	/**
	 * Try to preselect a dropdown with a preselect value,
	 * the first to match that exists as an option will be selected.
	 * e.g. tryToPreselect(dropdown, 'user selected value', 'user configured default value', 'system default');
	 * @param {node} dropdown The select node
	 * @param {list of arguments} 'value 1', 'value 2', 'value 3', .... 'value n'
	 */
	function tryToPreselect(dropdown) {
		// start arguments at 1, since 0 = dropdown
		for (var i=1; i < arguments.length; i++) {
			var value = arguments[i] || '';
			if (jQuery.isArray(value) && hasAllOptions(dropdown, value)) {
				dropdown.selectpicker('val', value);
				break;
			} else {
				dropdown.selectpicker('val', value);
				if (dropdown.selectpicker('val') === value) {
					break;
				}
			}
		}
	};

	function pad(str, length, pad) {
		var s = String(str);
		while (s.length < length) {s = pad + s;}
		return s;
	};

	/**
	 * Time formatted in establishment local timezone
	 * @param {*} dateString
	 */
	var getFormattedTime = function(dateString) {
		var splitResult = REGEX_ISO_EXTRACT_TIME.exec(dateString);
		if (splitResult.length > 2) {
			var hours = splitResult[1];
			var minutes = splitResult[2];
			return dateUtils.formatTime(hours, minutes, localConfig.timeFormat);
		}
		return '';
	};

	var getFormattedDateOnly = function(date) {
		return date.getFullYear() + "-" + pad(date.getMonth() + 1, 2, "0") + "-" + pad(date.getDate(), 2, "0");
	};

	var moveOnDesktop = function(moduleNode) {
		moduleNode.find(SEL_MOVE_ON_DESKTOP).each(function() {
			var element = jQuery(this);
			element.removeClass(CSS_MOVE_ON_DESKTOP);

			var target = element.data(DATA_ATTR_TARGET) || '';
			if (target !== '') {
				var targetElem = moduleNode.find(target);
				if (target.length) {
					// move all children
					element.children().each(function() {
						jQuery(this).detach().appendTo(targetElem);
					});
					// now remove element itself
					element.remove();
				}
			}
		});
	};

	var fillDurations = function(moduleNode, isWalkInCase) {

		var form			= moduleNode.find(SEL_FORM);
		var capacity		= form.find(SEL_CAPACITY);
		var slot 			= form.find(SEL_TIME_SLOTS);
		var durationSelect 	= form.find(SEL_EXTENDED_RESERVATIONS_DROPDOWN);

		var selectedDate = slot.selectpicker('val') || '';
		var requiredCapacity = capacity.val() || '';

		// skip if date and capacity is invalid
		if ((selectedDate === '' && !isWalkInCase) || requiredCapacity === '') {
			durationSelect.selectpicker('refresh');
			return;
		}
		
		var getCurrentSelection = function(selectedDate, isWalkInCase, reservationDuration, count) {
			var value = '';

			//if any form error occurs during Add reservation, get the variable value from localStorage and add in condition with count variable
			var mealHoursCount; 
			if(localStorage.getItem('previousMealHoursCount')){
				mealHoursCount = localStorage.getItem('previousMealHoursCount');
			}
			
			//if any form error occurs during add resrevation, this variable will set to 0 to retain the previous selected value of duration hours
			//or during edit reservation using count = 0, display previous selected value
			if (count == 0 || mealHoursCount == 0) {
				value = config.reservationEdit.reservationDuration;
			} else {
				if(resultSlots.length > 0){
					var preSelectItem = resultSlots.find(function(item){
						return item.startDate == selectedDate;
					});
					var dateEnd = dateUtils.toDate(preSelectItem.endDate);
					var dateStart = dateUtils.toDate(preSelectItem.startDate);
					var duration = ((dateEnd.getTime() - dateStart.getTime()) / 1000) / 60;
					value = duration.toString();
				} else {
					value = config.reservationEdit.defaultDuration;
					if(isWalkInCase){
						value = reservationDuration.toString();
					}
				}
			}

			// isDurationSelect variable holds the value on the basis of resetting with default duration
			var prevDurationValue = durationSelect.selectpicker('val');
			
			if(prevDurationValue !== config.reservationEdit.defaultDuration && prevDurationValue !== null && prevDurationValue !== value){
				isDurationReset = true;
			}else{
				isDurationReset = false;
			}

			return value;
		};

		var reservationId = localConfig.reservationId || null;

		var data = {
			capacity: requiredCapacity,
			reservationId: reservationId,
		}

		if(!isWalkInCase){
			var date = dateUtils.toDate(selectedDate); // turn value into date to make it easier to manipulate
			data["date"] = getFormattedDateOnly(date);
			data["startDate"] = selectedDate;
		}
		
		jQuery.ajax({
			url: window.config.apiUrlGetExtendedTimes,
			type: 'GET',
			data: data,
			dataType: 'json',
			success: function(result, status) {
				// remember previous selection
				//whenever change the capacity, this would be a default selection
				var prevSelection = getCurrentSelection(selectedDate, isWalkInCase, result.reservationDuration, count);
				count++;

				if(isDurationReset){
					notification.showWarningNotification(localMsgConfig.warningDurationModified);
				}

				// clear current options
				durationSelect.empty();

				var durations = Object.keys(result.durations);
				if (result.status == 'OK' && durations.length > 0) {
					// add placholder
					addPlaceholderToDuration(durationSelect);
					// add all options
					durations.forEach(function(key) {
						addSelectOption(durationSelect, key, result.durations[key]);
					});

					// try to preselect the previously selected value, or the default value
					tryToPreselect(durationSelect, prevSelection, config.reservationEdit.reservationDuration, '');
				} else {
					addErrorMsgToDuration(durationSelect);
				}
				durationSelect.selectpicker('refresh');
			},
			error: function() {
				durationSelect.empty();
				addErrorMsgToDuration(durationSelect);
				durationSelect.selectpicker('refresh');
			}
		});

	};

	var fillAvailableTimeSlots = function(moduleNode, initialStartDate) {

		var form			= moduleNode.find(SEL_FORM);
		var displayDate 	= form.find(SEL_START_DATE_DISPLAY);
		var capacity		= form.find(SEL_CAPACITY);
		var slot 			= form.find(SEL_TIME_SLOTS);

		var requiredCapacity = capacity.val() || 0;
		var reservationId = localConfig.reservationId;

		var isAddMode = localConfig.isAddReservation === 'false' ? false : true;
		var isEditMode = localConfig.isEditReservation === 'true' ? true : false;
		var isViewMode = localConfig.isViewReservation === 'false' ? false : true;

		var isFutureDate = ((localConfig.selectedDates[0] - localConfig.currentDate) > 0 || localConfig.currentDateString === localConfig.selectedDates[0]) ? true : false;

		var selectedDates = initialStartDate || displayDate.datepicker('getDates')[0];

		var setPreviouslySelectedValue = function(prevSelection, alertNode) {
			var selectedOption = slot.find('option').filter(function() {
				return jQuery(this).attr(ATTR_INTERNAL_TIME) === prevSelection;
			}).first();
			if (selectedOption && selectedOption.length) {
				var value = selectedOption.attr('value');
				slot.selectpicker('val', value);
				return true;
			}
			
			if(!isAddMode && isEditMode && !isViewMode && selectedOption.length === 0 && isFutureDate && alertNode.length === 0){
				notification.showGlobalWarningNotification(localMsgConfig.lastSlotNotAvailableWarning);
			}

			return false;
		};

		var getInternalTimeFromDate = function(date) {
			return '' + pad(date.getHours(), 2, "0") + pad(date.getMinutes(), 2, "0");
		};

		var getInternalTimeFromDateString = function(dateString) {
			var splitResult = REGEX_ISO_EXTRACT_TIME.exec(dateString);
			if (splitResult.length > 2) {
				var hours = splitResult[1];
				var minutes = splitResult[2];
				return '' + hours + minutes;
			}
			return '';
		};

		var getCurrentSelection = function() {
			var selectedValue = slot.selectpicker('val') || '';
			if (selectedValue !== '') {
				var selectedOption = slot.find('option').filter(function() {
					return jQuery(this).attr('value') === selectedValue;
				}).first();
				if (selectedOption && selectedOption.length) {
					return selectedOption.attr(ATTR_INTERNAL_TIME);
				}
			}
			return '';
		};

		var getDiscountMessage = function(slotItem) {
			var discountPercentage = (slotItem && slotItem.discountPercentage) || '';
			var discountType = (slotItem && slotItem.discountType) || '';
			var customText = (slotItem && slotItem.customText) || '';
			var discountMsg = '';

			if (discountType != '' && discountType != DISCOUNT_TYPE.NONE) {
				if (discountType == DISCOUNT_TYPE.HAPPY_HOURS) {
					discountMsg = ' - ' + localMsgConfig.discountType[discountType];
				} else if (discountType == DISCOUNT_TYPE.CUSTOM) {
					discountMsg = (customText !== '') ? ' - ' + customText : '';
				} else if (discountPercentage > 0) {
					if (discountType == DISCOUNT_TYPE.ALL) {
						discountMsg = ' - ' + discountPercentage + '% ' + localMsgConfig.discount;
					} else {
						discountMsg = ' - ' + discountPercentage + '% ' + localMsgConfig.discountOn + ' ' + localMsgConfig.discountType[discountType];
					}
				}
			}

			return discountMsg;
		};

		var getCapacityMsg = function(slotItem) {
			var capacitySuffix = (slotItem && slotItem.guestLimitCapacity) > 1 ? localMsgConfig.capacitySeats : localMsgConfig.capacitySeat;
			return ' (' + (slotItem && slotItem.guestLimitCapacity) + ' ' + capacitySuffix + ') ';
		};

		var triggerChange = function() {
			var isInitializing = !!initialStartDate;
			slot.trigger('change', [isInitializing]);
		};

		var showError = function() {
			slot.empty();
			addErrorMsgToSlots(slot);
			slot.selectpicker('refresh');
			triggerChange();
		};

		jQuery.ajax({
			url: window.config.apiUrlGetSlots,
			type: 'GET',
			data: {
				capacity		: requiredCapacity,
				date			: getFormattedDateOnly(selectedDates),
				reservationId	: reservationId,
				adminArea     	: true
			},
			dataType: 'json',
			success: function(result, status) {
				// remember current selection
				var prevSelection = initialStartDate ? getInternalTimeFromDate(initialStartDate) : getCurrentSelection();
				// fill options
				if (result.status == 'OK' && result.slots.length > 0) {
					resultSlots = result.slots;
					// clear current options
					slot.empty();
					// add placeholder
					addPlaceholderToSlots(slot);

					// add all options
					result.slots.forEach(function(slotItem) {
						var discountMsg = getDiscountMessage(slotItem);
						var capacityMsg = (slotItem && slotItem.guestLimitCapacity != undefined) ? getCapacityMsg(slotItem) : '';
						var formattedTime = getFormattedTime(slotItem.startDate);
						var label = formattedTime + ' ' + capacityMsg + discountMsg;
						var option = addSelectOption(slot, slotItem.startDate, label);
						// remember a internal time format for distingushing each option
						var internalTimeFormat = getInternalTimeFromDateString(slotItem.startDate);
						option.attr(ATTR_INTERNAL_TIME, internalTimeFormat);

						//if there is already a previous value for timeslot, which fits with new inputs, keep it as selected
						if(preserveTimeslot != "" && slotItem.startDate == preserveTimeslot){
							option.attr("selected","selected");
						}
					});

					//refresh
					slot.selectpicker('refresh');

					var alertNode = slot.closest('.mod-reservation-edit').siblings('.mod-global-messages').find('.alert.alert-dismissible');

					// try to preselect the previously selected value, or the default value
					if(!setPreviouslySelectedValue(prevSelection, alertNode)){
						triggerChange();
					}else{
						slot.selectpicker('refresh');
						triggerChange();
					}
					// trigger change event
				} else {
					showError();
				}
			},
			error: function() {
				showError();
			}
		});
	};

	var refreshAndTriggerSlot = function(slot){
		var selectedSlot = slot.find('option:selected');

		if((localConfig.isEditReservation === 'true' && selectedSlot.val() === '') || isOnlyDateChange){
			selectedSlot.remove();
		}

		isOnlyDateChange = false;
		slot.selectpicker('refresh');
		slot.trigger('change');
	}

	var fillReservables = function(moduleNode, isWalkInCase) {

		var form				= moduleNode.find(SEL_FORM);
		var capacity			= form.find(SEL_CAPACITY);
		var slot 				= form.find(SEL_TIME_SLOTS);
		var reservable			= form.find(SEL_TABLES);
		var durationSelect 		= form.find(SEL_EXTENDED_RESERVATIONS_DROPDOWN);
		var isViewReservation	= localConfig.isViewReservation;

		var refreshDropdown = function() {
			reservable.selectpicker('refresh');
			reservable.trigger('change');
		};

		if(isViewReservation == "true") {
			return;
		}
		
		var selectedDate = slot.selectpicker('val') || '';
		if (selectedDate === '' && !isWalkInCase) {
			// Skip if no valid date/time slot selected
			reservable.empty();
			addPlaceholderToTables(reservable);
			refreshDropdown();
			updateReservableDefaultPlaceholder(reservable);
			return;
		}

		var getCurrentSelection = function() {
			var values = reservable.selectpicker('val') || [];
			if (values.length === 0) {
				values = localConfig.reservableIds || [];
			}
			return values;
		};

		var getDisplayLabel = function(reservableItem) {
			var capacity = reservableItem.capacity + ' ' + localMsgConfig.capacity;
			var areaName = reservableItem.areaName;
			return reservableItem.name + ' (' + capacity + ') - ' + areaName;
		};

		var reservationId = localConfig.reservationId;
		var duration = durationSelect.selectpicker('val') || '';
		var shouldCheckCapacity = localConfig.capacityMode === CAPACITYT_MODE_RESERVABLE;
		var prevSelectedCapacity = calculateSelectedCapacity(reservable, getCurrentSelection());
		var requiredCapacity = parseInt(capacity.val());
		requiredCapacity = isNaN(requiredCapacity) ? 0 : requiredCapacity;

		var data={
			capacity		: requiredCapacity,
			reservationId	: reservationId,
			duration		: duration
		};
		
		if(isCapacityOrDateChange)
			data.allocateReservables=true;
			if(!isWalkInCase){
				data["startDate"] = selectedDate; // Tested with: "2020-10-02T11:00:00.000+02:00",
			}
		jQuery.ajax({
			url: window.config.apiUrlGetReservables,
			type: 'GET',
			data: data,
			dataType: 'json',
			success: function(result, status) {
				var isCapacityExceed = localConfig.capacityExceeded;

				if (result.status == 'OK') {
					if (result.reservables.length > 0) {

						// clear current options
						reservable.empty();
						var suggestedReservables = [];
						
						// add all options
						result.reservables.forEach(function(reservableItem) {
							var label = getDisplayLabel(reservableItem);
							var option = addSelectOption(reservable, reservableItem.id, label);
							var capacity = form.find(SEL_CAPACITY);
							var insertedCapacity = parseInt(capacity.val());
							option.attr(ATTR_CAPACITY, reservableItem.capacity);
							option.attr(ATTR_SUGGESTED, reservableItem.suggested);
							option.attr('title', reservableItem.name);
							var colorRed = 'color: #ff6a42';
							if(reservableItem.capacity < insertedCapacity){
								option.attr('style', colorRed);
							}
							if (!reservableItem.available) {
								option.remove();
							}

							//store the suggested combination of reservables inside an empty array
							if(reservableItem.suggested){
								suggestedReservables.push({ id: reservableItem.id, capacity: reservableItem.capacity });
							}
						});

						//get the total capacity of previous selected reservables
						var prevReservableTotalCapacity = getPrevReservablesTotalCapacity(preserveReservables);
						var suggestedReservablesTotal = getPrevReservablesTotalCapacity(suggestedReservables);
						//if previous reservables total capacity is lesser than required one
						if(prevReservableTotalCapacity < requiredCapacity){
							//assign the value of suggested reservables array to selectedReservablesOptions variable
							preserveReservables = suggestedReservables;
						}

						// refresh
						reservable.selectpicker('refresh');

						// in order to try to preselect the previously selected value, or the default value call here tryToPreselect(reservable, prevSelection, []);
						
						// do we need to validate capacity?
						if (shouldCheckCapacity) {
							var selectedCapacity = calculateSelectedCapacity(reservable, getCurrentSelection());
							var availableCapacity = calculateAvailableCapacity(reservable);
							validateSelectedReservableCapacity(reservable,
								availableCapacity, requiredCapacity,
								selectedCapacity, prevSelectedCapacity,
								isCapacityExceed, preserveReservables, prevReservableTotalCapacity, suggestedReservablesTotal
							);
						}

					} else {
						addNotAvailableErrorMsgToTables(reservable);
						reservable.selectpicker('refresh');
					}
				} else {
					addNotLoadedErrorMsgToTables(reservable);
					reservable.selectpicker('refresh');
				}
				// trigger change
				reservable.trigger('change');

				// update durations
				fillDurations(moduleNode, isWalkInCase);

			},
			error: function() {
				reservable.empty();
				addNotLoadedErrorMsgToTables(reservable);
				refreshDropdown();
			}
		});
	};

	var getPathIndex = function(){
		return ++pathIndex;
	}

	var decreasePathIndex = function(){
		pathIndex--;
	}

	var showOtherGuestInformation = function(capacity, moduleNode){
		var otherGuestInformation = moduleNode.find(SEL_OTHER_GUEST_INFORMATION);
		var container    = otherGuestInformation.find(SEL_OTHER_GUEST_ITEM_CONTAINER);
		var nbOfGuests = capacity.val() - 1;
		var nbOfInputs = container.find(SEL_OTHER_GUEST_ITEM).length;

		if(nbOfGuests > 0){
			otherGuestInformation.removeClass(CSS_HIDDEN);
			
			if(nbOfGuests > nbOfInputs){
				var loopLength = nbOfGuests - nbOfInputs;
				for(var index = 0; index < loopLength; index++){
					var templateItem = otherGuestInformation.find(SEL_OTHER_GUEST_ITEM_TEMPLATE);
					var newItem = templateItem.clone();
					var pathIndex = getPathIndex() + nbOfInputs;
					var path = 'guestInformationDtoList['+pathIndex+'].';
					newItem.removeClass(CSS_HIDDEN);
					newItem.removeClass(CSS_TEMPLATE_ITEM);
					newItem.find(SEL_OTHER_GUEST_NAME).attr('name',path + 'name');
					newItem.find(SEL_OTHER_GUEST_ADDRESS).attr('name',path + 'address');
					newItem.find(SEL_OTHER_GUEST_PHONENUMBER).attr('name',path + 'phoneNumber');
					newItem.find(SEL_OTHER_GUEST_VACCINESTATUS).attr('name',path+'covidVaccinationStatus');
					newItem.appendTo(container);
				}
			}else{
				var loopLength = nbOfInputs - nbOfGuests;
				var items = container.find(SEL_OTHER_GUEST_ITEM);
				for(var index = loopLength + 1; index > 1; index--){
					if(items[index] != undefined){
						items[index].remove();
						decreasePathIndex();
					}
				}
				var newItems = container.find(SEL_OTHER_GUEST_ITEM);
				if(newItems.length == 2 && nbOfGuests == 1){
					newItems[1].remove();
					decreasePathIndex();
				}
			}
		}else{
			otherGuestInformation.addClass(CSS_HIDDEN);
			container.find(SEL_OTHER_GUEST_ITEM).each(function(){
				jQuery(this).remove();
			});
			
		}
	};

	var showCancelPopup = function (moduleNode) {
        var dfd = jQuery.Deferred();
        var modal = getStatusConfirmModal(moduleNode);
        var modalSubmitted = false;

		var textContent = modal.find(SEL_MODAL_MESSAGE_TEXT);
		var submitBtn = modal.find(SEL_MODAL_SUBMIT);
		submitBtn.attr('disabled', 'disabled');

		textContent.bind('input', function() {
			toggleSubmitBtn(jQuery(this).val(), submitBtn);
		});

		modal.find(SEL_MODAL_CLOSE).on('click', function (e) {
			modal.find(SEL_MODAL_MESSAGE_TEXT).val('');
		});

        // resolve promise if the submit button was clicked
        modal.find(SEL_MODAL_SUBMIT).on('click', function (e) {
            e.preventDefault();
            modalSubmitted = true;
            var message = modal.find(SEL_MODAL_MESSAGE_TEXT).val() || '';
            modal.modal('hide');
			modal.find(SEL_MODAL_MESSAGE_TEXT).val('');
            dfd.resolve(message === '' ? null : message);
        });

        // reject the promise if modal was closed without submitting
        modal.on('hide.bs.modal', function () {
            // if modal was simply closed
            if (!modalSubmitted) {
                dfd.reject();
            }
        });

        // show modal
        modal.modal('show');

        return dfd.promise();
    };

	var getStatusConfirmModal = function (moduleNode) {
        return moduleNode.find(SEL_MODAL_STATUS_CONFIRM)
				.clone()
				.removeClass(CSS_HIDDEN);
    };

	var toggleSubmitBtn = function(value, submitBtn){
		var isValueEmpty = !value;
		if (isValueEmpty) {
			submitBtn.attr('disabled','disabled');
		} else {
			submitBtn.removeAttr('disabled');
		}
	}

	var submitFeedbackForm = function(message, replyBtn, feedbackId, csrf_token, repliedBtn){
		
		var feedbackUrl = "/feedback/"+feedbackId+"/response";
		
		var requestData = {
			text: message,
			_csrf: csrf_token
		}

		jQuery.ajax({
            url: feedbackUrl,
            type: 'POST',
            data: requestData,
            dataType: 'json',
			success: function(result) {
				if(result.status == 'OK'){
					replyBtn.css('display', 'none');
					repliedBtn.addClass(CSS_VISIBLE_REPLIED_BLOCK);
					notification.showConfirmNotification(result.msg);
					window.location.reload();
				}
			},
			error: function(result) {
				notification.showErrorNotification(result.msg);
			}
		});
	}

	/**
	 * @description update the back button url for both desktop and mobile devices to feedback
	 * @param backButton - back button node
	 */
	var updateBackButtonUrlToFeedback = function(backButton){
		var getBackBtnUrl = backButton.attr('href');
		if(getBackBtnUrl.indexOf("/reservation/") != -1){ //if back btn url changes to reservation detail page then
			backButton.attr('href', '/feedback'); //will set the url to feedback page
		}
	}

	/**
	 * @description convert all type of past reservations (both with past dates and current day past times) 
	 * to view only mode or non-editable
	 * @param {*} moduleNode 
	 */
	var convertPastReservationToViewMode = function(moduleNode, isWalkInCase){

		var pastTimeDiff = localConfig.currentDate - localConfig.selectedDates[0];
		var futureTimeDiff = localConfig.currentDate - localConfig.endDate;

		var endTimeHours = parseInt(localConfig.endDate.getHours());
		var endTimeMinutes = parseInt(localConfig.endDate.getMinutes());

		var currentTimeHours = parseInt(localConfig.currentDate.getHours());
		var currentTimeMinutes = parseInt(localConfig.currentDate.getMinutes());
		
		//if endHours represent the next day midnight time 12:00AM (which generally considers as 00:00AM)
		if(endTimeHours === 0 && futureTimeDiff < 0){
			var timeCondition = false;
		}else{
			//if the end time is of same or past day
			var timeCondition = (currentTimeHours*60 + currentTimeMinutes) > (endTimeHours*60 + endTimeMinutes);
		}

		var pastReservationCondition = localConfig.reservationStartDate != localConfig.currentDateString && pastTimeDiff > 0;
		var currentReservationCondition = localConfig.reservationStartDate === localConfig.currentDateString && timeCondition;
		var isNextDay = localConfig.reservationStartDate > localConfig.currentDateString;
		var isAddMode = localConfig.isAddReservation === 'false' ? false : true;
		var isEditMode = localConfig.isEditReservation === 'true' ? true : false;
		var isViewMode = localConfig.isViewReservation === 'false' ? false : true;
		 
		if((pastReservationCondition || currentReservationCondition) && !isAddMode && isEditMode && !isViewMode && !isWalkInCase && !isNextDay){
			moduleNode.find(SEL_CAPACITY).closest(SEL_CARD_BODY).addClass('pastReservationsViewMode');
			moduleNode.find(SEL_CAPACITY).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.guestCapacity+'</span>');
			moduleNode.find(SEL_START_DATE_DISPLAY).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.reservationStartDate + ' ' + localConfig.reservationStartTime +' - ' + localConfig.reservationEndTime +'</span>');
			moduleNode.find(SEL_TIME_SLOTS).closest(SEL_FORM_GROUP).hide();
			moduleNode.find(SEL_EXTENDED_RESERVATIONS_DROPDOWN).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+durationConversionToHours()+'</span>');
			moduleNode.find(SEL_TABLES).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.reservableName+'</span>');
			moduleNode.find(SEL_RESERVATION_OCCASSION).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.reservationPurposeName+'</span>');
			moduleNode.find(SEL_LAST_NAME_INPUT).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.lastName.replace(/[|]/g, "\'")+'</span>');
			moduleNode.find(SEL_FIRST_NAME_INPUT).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.firstName.replace(/[|]/g, "\'")+'</span>');
			moduleNode.find(SEL_PHONE_NUMBER_INPUT).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.phoneNumber+'</span>');
			moduleNode.find(SEL_EMAIL_FIELD).closest(SEL_FORM_GROUP_INPUT_WRAP).html('<span>'+localConfig.emailAddress+'</span>');
			moduleNode.find(SEL_INTERNAL_COMMENTS).closest(SEL_COL_SM_9).html('<span>'+localConfig.internalNotes+'</span>');
			moduleNode.find(SEL_CUSTOMER_NOTES).closest(SEL_COL_SM_9).html('<span>'+localConfig.customerNotes+'</span>')
			moduleNode.find(SEL_MAIN_GUEST_VACCINATION_DROPDOWN).attr('disabled', true);
			moduleNode.find(SEL_MAIN_GUEST_ADDRESS_INPUT).attr('disabled', true);
			moduleNode.find(SEL_ALLERGIES_LIST).addClass(CSS_DISABLED_ALLERGIES);
			moduleNode.find(SEL_DIET_LIST).addClass(CSS_DISABLED_DIETS);
			moduleNode.find(SEL_NEWSLETTER_INPUT).closest(SEL_FORM_GROUP_WITH_INFO_TEXT).remove();
			moduleNode.find(SEL_SUBMIT_BUTTON).closest(SEL_ROW).hide();
			disabledOtherGuestInformation(moduleNode);
		}
	}

	var disabledOtherGuestInformation = function(mainNode){
		var guestInfoInputNodes = mainNode.find(SEL_EDITABLE_OTHER_GUEST_INFO).find(SEL_OTHER_GUEST_INFO_INPUT_WRAPPER);

		guestInfoInputNodes.each(function(){
			var input = jQuery(this);
			input.find(SEL_OTHER_GUEST_NAME).attr('disabled', true);
			input.find(SEL_OTHER_GUEST_PHONENUMBER).attr('disabled', true);
			input.find(SEL_OTHER_GUEST_ADDRESS).attr('disabled', true);
			input.find(SEL_OTHER_GUEST_VACCINATION_DROPDOWN).attr('disabled', true);

		});
	}

	var durationConversionToHours = function(){
		var durationMinutes = parseInt(localConfig.reservationDuration);
		const hours = Math.floor(durationMinutes / 60).toString().padStart(2, '0');
		const minutes = (durationMinutes % 60).toString().padStart(2, '0');
		return `${hours}:${minutes}`;
	}

	/**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode 		= jQuery(this);
			var form			= moduleNode.find(SEL_FORM);
			var warningText 	= moduleNode.find(SEL_WARNING_CAPACITY);
			var selectedDates	= form.find(SEL_SELECTED_DATES);
			var displayDate 	= form.find(SEL_START_DATE_DISPLAY);
			var capacity		= form.find(SEL_CAPACITY);
			var tableSelection  = form.find(SEL_TABLES);
			var slot 			= form.find(SEL_TIME_SLOTS);
			var newsletterInput = form.find(SEL_NEWSLETTER_INPUT);
			var hasOtherGuestData = localConfig.hasOtherGuestData;
			var isReservationEdit = localConfig.isEditReservation;
			var timer;
			var delay=600;

			var walkInCase 		= localConfig.walkInCase || "";
			var isWalkInCase 	= walkInCase == "true";

			// if we have unmanaged reservation, then after edit reservation, will checked the newsletter checkbox to notify customer
			var isNewsletter = window.location.href.indexOf('sendUpdate') > -1 ? true : false;
			if(isNewsletter){
				newsletterInput.prop('checked', true);
			}

			/**
			 * Guest and RO Feedback Block Code
			 */
			var replyBtn = moduleNode.find(SEL_FEEDBACK_REPLY_BTN);
			var feedbackId = moduleNode.find(SEL_FEEDBACK_REPLY_BTN).attr("data-feedback-id");
			var csrf_token = moduleNode.find(SEL_FEEDBACK_REPLY_BTN).attr("data-csrf");
			var repliedBtn = moduleNode.find(SEL_FEEDBACK_REPLIED_BTN);
			
			//to retain backUrl after feedback submission on reservation detail page
			var backBtn = moduleNode.siblings(SEL_MAIN_HEADLINE_WRAPPER).find(SEL_INTRO_BACK_BUTTON);
			var mobileBackBtn = moduleNode.siblings(SEL_MOBILE_HEADLINE).find(SEL_MOBILE_BACK_BUTTON);
			updateBackButtonUrlToFeedback(backBtn); //update back button url for desktop
			updateBackButtonUrlToFeedback(mobileBackBtn); //update back button url for mobile devices

			replyBtn.click(function(){
				showCancelPopup(moduleNode).done(function (message) {
					submitFeedbackForm(message, replyBtn, feedbackId, csrf_token, repliedBtn);
                });
			});
			//get the alert div if exists (only exists if any error comes) -> added during add reservation error detection
			var formErrorElement = moduleNode.siblings(SEL_GLOBAL_MESSAGE).find(SEL_ALERT_DANGER);

			var capacityOverrideConfirmModal = moduleNode.find(SEL_CAPACITY_OVERRIDE_CONFIRM_MODAL);
			var capacityOverrideConfirmModalMessage = localMsgConfig.capacityConfirmMessage;
			var capacityExceeded = localConfig.capacityExceeded == "true";
			
			if(capacityExceeded){
				count = 0;
				setTimeout(function(){
					confirmModal.show(capacityOverrideConfirmModal, capacityOverrideConfirmModalMessage).done(function(){
						form.find(SEL_CAPACITY_OVERRIDE_INPUT).attr("value", "false");
						form.find(SEL_SUBMIT_BUTTON).click();
					});
				}, 3000);
			}

			// convert past reservations to view only (non-editable) mode
			convertPastReservationToViewMode(moduleNode, isWalkInCase);

			/**
			 * If alert div presents, added a variable in localstorage and 
			 * if everything is fine, will remove that variable from localstorage
			 */
			if(formErrorElement.length === 1){
				//basically added to retain the selected value during add reservation time if any error occurs after submission
				localStorage.setItem('previousMealHoursCount', 0);
			}else{
				if(localStorage.getItem('previousMealHoursCount')){
					localStorage.removeItem('previousMealHoursCount');
				}
			}

			moveOnDesktop(moduleNode);

			// Auto-suggest for last name input
			initAutosuggest(moduleNode);

			// Auto-suggest for createdBy
			let reservationCreatorRequired = localConfig.reservationCreatorRequired === 'true';
			if (reservationCreatorRequired) {
				initCreatedByAutosuggest(moduleNode);
			}

			// validate guest number
			validateCapacity(capacity);

			// Init calendar display
			initCalendarDisplay(displayDate, isWalkInCase);

			//Hide other guest info section if no data available
			var otherGuestInfo = localConfig.otherGuestInformation;
			var isViewMode = localConfig.isViewReservation;
			var otherGuestInfoNode = moduleNode.find(SEL_OTHER_GUEST_INFORMATION);

			var isDefaultData = (otherGuestInfo || []).every(function(item){
				return ((item.name == "" || item.name == null) && (item.address == null || item.address == "") && (item.phoneNumber == null || item.phoneNumber == "") && (item.covidVaccinationStatus == null))
			});

			//hide the other guest block only if no other guest data available and viewReservation is true
			if(isDefaultData && isViewMode == 'true'){
				otherGuestInfoNode.hide();
			}else{
				otherGuestInfoNode.find(SEL_OTHER_GUEST_ITEM).each(function(){
					var item = jQuery(this);
					item.find(SEL_OTHER_GUEST_HEADLINE).length == 0 ? item.addClass(CSS_REMOVE_BOTTOM_SPACING) : item.removeClass(CSS_REMOVE_BOTTOM_SPACING);
				})
			}

			//check capacity changes so the error message can be shown
			tableSelection.on('change',function(){
				var item = jQuery(capacity);
				
				var selectedCapacity = getSelectedCapacity(form);
				if(hasOtherGuestData == 'false'){
					showOtherGuestInformation(capacity, moduleNode);
				}
				hasOtherGuestData = 'false';

				preserveReservables = [];
				var optionsSelected = jQuery(this).find('option');
				optionsSelected.each(function(){
					var option = jQuery(this);
					if(option.prop('selected')){
						option.attr('style','color: black;');
						//add the value of selected reservables inside an array
						preserveReservables.push({ id: parseInt(option.attr('value')), capacity: option.data('capacity') });
					}else{
						if(parseInt(option.attr('data-capacity')) < parseInt(item.val())){
							option.attr('style','color: #ff6a42;');
						}
					}
				});

				if (selectedCapacity > 0 && selectedCapacity < parseInt(item.val())){
					warningText.addClass('visible');
				}else{
					warningText.removeClass('visible');
				}

				tableSelection.selectpicker('refresh');
			});

			// limit input to 500 characters
			moduleNode.find(SEL_CUSTOMER_NOTES).limitLength(500);

			// Form submit validation
			form.on('submit', function (e) {
				var noErrors = handleFormSubmit(this, isWalkInCase, moduleNode);
				if(noErrors == false){
					e.stopImmediatePropagation();
					e.preventDefault();
					return false;
				}
			});

			preventDoubleSubmit(form);

			// input handler
			capacity.bind('input', function(event) {
				window.clearTimeout(timer);
				showOtherGuestInformation(capacity, moduleNode);
				//if not empty input
				if(!!this.value){
					//should not apply logic immediatly e.g input is 13, the user inputs 1 first
					timer = window.setTimeout(function(){
						isCapacityOrDateChange=true;
						if(!isWalkInCase){
							fillAvailableTimeSlots(moduleNode);
						} else {
							fillReservables(moduleNode, isWalkInCase);
						}
					}, delay);
				} else {
					fillDurations(moduleNode, isWalkInCase);
					fillReservables(moduleNode, isWalkInCase);
				}	
			});
			
			// change handlers
			displayDate.bind('change', function() {
				isCapacityOrDateChange=true;
				isOnlyDateChange=true;
				if(!isWalkInCase){
					fillAvailableTimeSlots(moduleNode);
				}
			});

			if(!isWalkInCase){
				slot.bind('change', function(event, isInitializing) {
					//store the last selected value in duration dropdown
					//if timeslot value is null, keep the current one as is (for unusual timeslots creating via VTP)
					var timeslot = form.find(SEL_TIME_SLOTS);
					preserveTimeslot = timeslot.val() == null ? preserveTimeslot : timeslot.val();
					
					//this code is called in two cases: trying preselect or triggering change
					let datepickerDates = displayDate.datepicker('getDates');
					let selectedTime = slot.selectpicker('val');
					selectedDates.val(datepickerDates.map(function (date) {
						let formattedDate = moment(date).format('YYYY-MM-DD');
						let formattedTime = moment(selectedTime).format('THH:mm:ss.SSSZ');
						return `${formattedDate}${formattedTime}`;
					}));
					fillReservables(moduleNode, isWalkInCase);
				});
			}
			
			// initializing default values
			fillDurations(moduleNode, isWalkInCase);
			fillReservables(moduleNode, isWalkInCase);

			// Only initialize if we really have a select dropdown with slots
			if (slot.length > 0) {
				if(!isWalkInCase){
					slot.empty();
					addSelectOption(slot, '', localMsgConfig.selectGuestNumberToSeeTime, true);
					slot.selectpicker('refresh');
				}
				if(isReservationEdit == 'true' || !!capacity.val()){
					fillAvailableTimeSlots(moduleNode, localConfig.selectedDates[0]);
				}
			}

			// Make previous page accessible via keyboard
			jQuery('body').bind('keydown', function(e) {
				var inputFields = jQuery('body').find('input, textarea, select, option, button');
				var activeInputFields = inputFields.filter(':focus').length;
				if (e.which == 37 && activeInputFields == 0 && localConfig.returnUrl != '') {
					document.location.href = config.reservationEdit.returnUrl;
				}
			});

            const resendCcgButton = moduleNode.find(SEL_RESEND_CCG_BUTTON);
			resendCcgButton.on('click', function(e) {
				e.preventDefault();

                const reservationId = localConfig.reservationId;
				if (!reservationId) {
					notification.showErrorNotification('Reservation ID not found.');
					return;
				}

                const csrfToken = form.find('input[name="_csrf"]').val();

				jQuery.ajax({
					url: '/reservation/' + reservationId + '/resend-card-guarantee',
					type: 'POST',
					data: { _csrf: csrfToken },
					dataType: 'json',
					success: function(result) {
                        if (result && result.success === true) {
                            notification.showConfirmNotification(result.message);
                        }
					},
                    error: function (result) {
                        notification.showErrorNotification(result.message);
                    }
				});
			});
		});

    };

};

// Make class public to outside world
module.exports = ReservationEdit;
},{"../form/FormInputFilter":86,"../mediator/mediator":103,"../modals/Confirm":111,"../notification/Notification":125,"../utils/DateUtils":185,"../utils/UserInterfaceUtils":189,"bloodhound":25,"bootstrap.datepicker":26,"jquery/dist/jquery":14,"moment":16,"typeahead":51,"xss-escape/xss-escape":21}],136:[function(require,module,exports){
/**
 * ReservationList functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
var moment = require('moment/min/moment-with-locales');
var StringUtils = require('../utils/StringUtils');
var Confirm = require('../modals/Confirm');
const Alert = require('../modals/Alert');
var UserInterfaceUtils = require('../utils/UserInterfaceUtils');

// Class definition
ReservationList = function () {

    // self references
    var self;

    // selector constants
    var SEL_MODULE = '.mod-reservation-list';

    var SEL_RESERVATION_LIST_REFRESH = ".reservation-list-refresh";
    var SEL_RESERVATION_GROUP = '.mod-reservation-list-grouped .list-group';
    var SEL_RESERVATION_ITEM = '.mod-reservation-list-item';
    var SEL_RESERVATION_ITEM_IGNORE_CLICK = '.no-edit-click';
    var SEL_RESERVATION_ADD_CARD = '.mod-reservation-overview-add-card';
    var SEL_RESERVATION_STATISTICS = '.reservationStatistics';
    var SEL_MANAGE_RESERVATION_CARD = '.mod-reservation-requests-alert';

    var SEL_RESERVATION_PAGINATION = '.mod-reservation-pagination';
    var SEL_LIMIT_LIST_BANNER = '.limits-list';
    var SEL_NO_LIMITS_BANNER = '.mod-no-limits-banner';
    var SEL_INVALID_REQUESTED_RESERVATION_ALERT = '.mod-reservation-invalid-reservations-alert';

    var SEL_ALERT = '.item-alert';

    var SEL_ALERT_INVALID = '.item-invalid-alert';
    var SEL_INVALID_ALERT_ACTION_CANCEL = '.item-invalid-alert .action-cancel-reservation';
    var SEL_REMIND_ALERT_ACTION_REMIND = '.item-remind-alert .action-send-reminder';
    var SEL_REQUESTED_ALERT_ACTION = '.item-requested-alert .alert-actions .btn';
    var SEL_REMIND_ALERT_ACTIONS = '.alert-actions.no-edit-click';
    var SEL_REMIND_ALERT_MESSAGE_BOX = '.alert-message';

    var SEL_FOOD_DIETS              = '.food-preferences.diet';
    var SEL_FOOD_ALLERGIES          = '.food-preferences.allergies';
    var SEL_FOOD_DIETS_VALUES        = '.food-list .food-diet';
    var SEL_FOOD_ALLERGIES_VALUES   = '.food-list .food-allergies';

    var SEL_STATUS_DROPDOWN = '.status-dropdown';
    var SEL_STATUS_DROPDOWN_TOGGLE = '.status-dropdown-toggle';
    const SEL_STATUS_DROPDOWN_TOGGLE_TEXT = '.status-dropdown-toggle .text';
    var SEL_STATUS_DROPDOWN_OPTIONS = '.status-options';
	var SEL_BTN_PRINT	= '.print-button';
    var SEL_ARROW_DOWN  = '.arrow-down';
    var SEL_ARROW_UP    = '.arrow-up';

    var SEL_TEXT = '.text';

    var SEL_MODAL_STATUS_CONFIRM = '#reservationStatusConfirmModal';
    var SEL_MODAL_BODY = '.modal-body';
    var SEL_MODAL_LANGUAGE_HINT = '.customer-language-hint';
    var SEL_MODAL_LANGUAGE_HINT_PLACEHOLDER = '.lang';
    var SEL_MODAL_MESSAGE_TEXT = '.customer-message';
    var SEL_MODAL_SUBMIT = '.submit-button';
    var SEL_MODAL_CANCEL_CHECKBOX = '.cancellationCheckbox';

    var ATTR_RESERVATION_ID = 'data-reservation-id';
    var ATTR_RESERVATION_STATUS = 'data-reservation-status';
    var ATTR_RESERVATION_SHOW_ARRIVED_DROPDOWN = 'data-reservation-showArrivedDropdown';
    var ATTR_RESERVATION_SHOW_UNDO_CONFIRMED = "data-reservation-showUndoConfirm";
    var ATTR_RESERVATION_START_DATE = 'data-reservation-start-date';
    var ATTR_RESERVATION_EMAIL = 'data-reservation-email';
    const ATTR_RESERVATION_PHONE = 'data-reservation-phone';
    const ATTR_RESERVATION_TIME = 'data-reservation-time';
    const ATTR_RESERVATION_GUEST = 'data-reservation-guest';
    const ATTR_RESERVATION_SOURCE = 'data-reservation-source';
    const ATTR_RESERVATION_CAN_SEND_CANCELLATION_SMS = 'data-reservation-can-send-cancellation-sms';
    var ATTR_RESERVATION_ORIGIN = 'data-reservation-origin';
    var ATTR_RESERVATION_LANGUAGE_CODE = 'data-reservation-languageCode';
    var ATTR_ESTABLISHMENT_LANGUAGE_CODE = 'data-establishment-languageCode';
    var ATTR_RESERVATION_LANG_NAME = 'data-reservation-lang-name';
    var ATTR_RESERVATION_LANG_ICON = 'data-reservation-lang-icon';
    var ATTR_EDIT_URL = 'data-edit-url';
    var ATTR_STATUS = 'data-status';
    const ATTR_RESERVATION_SERIES = 'data-reservation-series'; // holds reservation series ID if there is one.
    
    var CSS_OPEN = 'open';
    var CSS_PROCESSING = 'processing';
    var CSS_NO_OPTIONS = 'no-options';
    var CSS_NO_ITEM_ALERTS = 'no-item-alerts';
    var CSS_HIDDEN = 'hidden';
    var CSS_HIDDEN_PRINT = 'hidden-print';

    var CSS_HIDE = 'hide';
    var CSS_SHOW = 'show';
    var SEL_ARRIVED_BUTTON_ACTION = '.item-status-alert .action-on-arrived';
    var SEL_NOSHOW_BUTTON_ACTION = '.item-status-alert .action-on-noshow';

    var SEL_REMIND_BUTTON = '.remind-button-container';
    var SEL_NOSHOW_ARRIVED_BUTTON = '.arrived-noshow-button-container';
    var SEL_NOSHOW_UPSELL_BANNER = '.noshow-upsell-banner-container';
    var SEL_END_RESERVATION_BUTTON_CONTAINER = '.end-reservation-btn-container';
    var SEL_END_RESERVATION_BUTTON = '.end-reservation-button';
    var SEL_MODAL_DELETE_CONFIRM = '.reservationList-deleteConfirmModal';
    const SEL_MODAL_PHONE_ONLY_REMINDER = '.reservationList-phoneOnlyReminderModal';

    var STATUS = {
        CONFIRMED: 'CONFIRMED',
        CANCELLED: 'CANCELLED',
        ARRIVED: 'ARRIVED',
        DONE: 'DONE',
        NO_SHOW: 'NO_SHOW',
        REJECTED: 'REJECTED',
        REQUESTED: 'REQUESTED',
        SERIES_CANCELLED: 'SERIES_CANCELLED',
        PENDING_CCG: 'PENDING_CCG'
    };

    var confirmModal = new Confirm();
    const alertModal = new Alert();

    var showArrived = false;
    var showNoShow = false;
    var showRemind = false;
    var showNoShowUpsellBanner = false;

    var buildUrlWithParams = function (url, params) {
        var replacements = {};
        for (var name in params) {
            replacements['%%' + name + '%%'] = params[name];
        };
        return StringUtils.findAndReplaceAll(url || '', replacements);
    };

    var goToUrl = function (url) {
        document.location.href = url;
    };

    var getReservationStartDate = function (item) {
        var reservationStartDate = item.attr(ATTR_RESERVATION_START_DATE) || '';
        if (reservationStartDate === '') {
            return null;
        }
        return moment(reservationStartDate);
    };

    var getReservationEmail = function (item) {
        var reservationEmail = item.attr(ATTR_RESERVATION_EMAIL) || '';

        return reservationEmail;
    };

    const hasReservationPhone = function (item) {
        return (item.attr(ATTR_RESERVATION_PHONE) || '') !== '';
    };

    const canSendCancellationSms = function (item) {
        return item.attr(ATTR_RESERVATION_CAN_SEND_CANCELLATION_SMS) === 'true';
    };

    const shouldShowPhoneOnlyCancelPopup = function (item) {
        return getReservationEmail(item) === '' && hasReservationPhone(item) && !canSendCancellationSms(item);
    };

    const getPhoneOnlyReminderDetails = function (item) {
        return {
            time: item.attr(ATTR_RESERVATION_TIME) || '',
            guest: item.attr(ATTR_RESERVATION_GUEST) || '',
            phone: item.attr(ATTR_RESERVATION_PHONE) || '',
            source: item.attr(ATTR_RESERVATION_SOURCE) || ''
        };
    };

    const appendReminderDetailRow = function (detailsNode, label, value, phoneValue) {
        const row = jQuery('<div />').addClass('reservation-reminder-detail-row').appendTo(detailsNode);
        jQuery('<strong />').text(label).appendTo(row);

        if (phoneValue) {
            jQuery('<a />')
                .attr('href', 'tel:' + phoneValue.replace(/[^\d+]/g, ''))
                .text(value)
                .appendTo(row);
            jQuery('<button />')
                .attr('type', 'button')
                .attr('title', value)
                .attr('data-phone-number', phoneValue)
                .addClass('action-copy-phone')
                .append(jQuery('<i />').addClass('far fa-copy'))
                .appendTo(row);
        } else {
            jQuery('<span />').text(value).appendTo(row);
        }
    };

    const buildPhoneOnlyReminderMessage = function (localConfig, item) {
        const details = getPhoneOnlyReminderDetails(item);
        const container = jQuery('<div />').addClass('reservation-reminder-phone-only');
        jQuery('<p />').html(localConfig.phoneOnlyReminderMessage || '').appendTo(container);

        const detailsNode = jQuery('<div />').addClass('reservation-reminder-details').appendTo(container);
        jQuery('<div />')
            .addClass('reservation-reminder-details-title')
            .text(localConfig.phoneOnlyReminderDetails || '')
            .appendTo(detailsNode);

        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyReminderTime || '', details.time);
        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyReminderGuest || '', details.guest);
        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyReminderPhone || '', details.phone, details.phone);
        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyReminderSource || '', details.source);

        return container.prop('outerHTML');
    };

    const buildPhoneOnlyCancelMessage = function (localConfig, item) {
        const details = getPhoneOnlyReminderDetails(item);
        const container = jQuery('<div />').addClass('reservation-cancel-phone-only');
        jQuery('<p />').html(localConfig.phoneOnlyCancellationMessage || '').appendTo(container);

        const detailsNode = jQuery('<div />').addClass('reservation-cancel-details').appendTo(container);
        jQuery('<div />')
            .addClass('reservation-cancel-details-title')
            .text(localConfig.phoneOnlyCancellationDetails || '')
            .appendTo(detailsNode);

        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyCancellationTime || '', details.time);
        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyCancellationGuest || '', details.guest);
        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyCancellationPhone || '', details.phone, details.phone);
        appendReminderDetailRow(detailsNode, localConfig.phoneOnlyCancellationSource || '', details.source);

        return container.prop('outerHTML');
    };

    var getReservationOrigin = function (item) {
        var reservationOrigin = item.attr(ATTR_RESERVATION_ORIGIN) || '';

        if (reservationOrigin === '') {
            return null;
        }
        return reservationOrigin;
    };

    var getReservationLanguageCode = function (item) {
        var reservationLanguage = item.attr(ATTR_RESERVATION_LANGUAGE_CODE) || '';

        if (reservationLanguage === '') {
            return null;
        }
        return reservationLanguage;
    };

    var getEstablishmentLanguageCode = function (item) {
        var establishmentLanguage = item.attr(ATTR_ESTABLISHMENT_LANGUAGE_CODE) || '';

        if (establishmentLanguage === '') {
            return null;
        }
        return establishmentLanguage;
    };

    var getStatusConfirmModal = function (moduleNode) {
        return moduleNode.find(SEL_MODAL_STATUS_CONFIRM)
            .clone()
            .removeClass(CSS_HIDDEN);
    };

    var showErrorMsg = function (error) {
        jQuery.notify({
            icon: 'far fa-times-circle',
            message: error
        }, {
            type: 'danger'
        });
    };

    var showSuccessMsg = function (msg) {
        jQuery.notify({
            icon: 'far fa-check-circle',
            message: msg
        }, {
            type: 'success'
        });
    };

    var showCancelPopup = function (moduleNode, item, buttonLabel, newStatus, isSeriesCancel) {
        var dfd = jQuery.Deferred();

        var modal = getStatusConfirmModal(moduleNode);

        // hide custom message if the reservation has already started
        var reservationOrigin = getReservationOrigin(item);
        var reservationLanguage = getReservationLanguageCode(item);
        var establishmentLanguage = getEstablishmentLanguageCode(item);
        const showPhoneOnlyCancelMessage = newStatus === STATUS.CANCELLED && shouldShowPhoneOnlyCancelPopup(item);

        if (reservationOrigin != 'WIDGET' || establishmentLanguage === reservationLanguage) {
            modal.find(SEL_MODAL_LANGUAGE_HINT).remove();
        }

        renderMessageLanguage(item, modal)

        // update button label
        modal.find(SEL_MODAL_SUBMIT).text(buttonLabel);
        var cancelCheckbox = modal.find(SEL_MODAL_CANCEL_CHECKBOX);
        if (newStatus === STATUS.CONFIRMED) {
            modal.find(SEL_MODAL_SUBMIT).addClass('btn-success');
            modal.find(SEL_MODAL_SUBMIT).removeClass('btn-danger');
        }else if(newStatus === STATUS.CANCELLED){
            cancelCheckbox.show();
        }

        if (showPhoneOnlyCancelMessage) {
            const localConfig = window.config.reservationList || {};
            const keepButton = jQuery('<button />')
                .attr('type', 'button')
                .addClass('btn btn-default')
                .attr('data-dismiss', 'modal')
                .text(localConfig.phoneOnlyCancellationKeepButton || '');
            modal.addClass('phone-only-cancel-modal');
            modal.find('.modal-title').text(localConfig.phoneOnlyCancellationTitle || '');
            modal.find(SEL_MODAL_BODY).html(buildPhoneOnlyCancelMessage(localConfig, item));
            modal.find(SEL_MODAL_LANGUAGE_HINT).addClass(CSS_HIDDEN);
            modal.find(SEL_MODAL_SUBMIT).before(keepButton);
            modal.off('click.phoneOnlyCancel').on('click.phoneOnlyCancel', '.action-copy-phone', function (event) {
                event.preventDefault();
                const phoneNumber = jQuery(this).attr('data-phone-number') || '';
                if (navigator.clipboard && phoneNumber !== '') {
                    navigator.clipboard.writeText(phoneNumber);
                }
            });
        }

        handlePromise(modal, dfd, cancelCheckbox, showPhoneOnlyCancelMessage);

        // show modal
        modal.modal('show');

        if (hideModalBody(isSeriesCancel, item)) {
            modal.find('input[name="sendCancelEmail"]').removeAttr('checked');
            modal.find(SEL_MODAL_LANGUAGE_HINT).addClass(CSS_HIDDEN);
            modal.find(SEL_MODAL_BODY).addClass(CSS_HIDDEN);
        }

        return dfd.promise();
    };

    let handlePromise = function (modal, dfd, cancelCheckbox, showPhoneOnlyCancelMessage) {
        let modalSubmitted = false;

        // resolve promise if the submit button was clicked
        modal.find(SEL_MODAL_SUBMIT).on('click', function (e) {
            e.preventDefault();
            modalSubmitted = true;
            let message = modal.find(SEL_MODAL_MESSAGE_TEXT).val() || '';
            let sendCancelEmail = cancelCheckbox.find('input[type=checkbox]').is(":checked");
            if (showPhoneOnlyCancelMessage) {
                sendCancelEmail = false;
            }
            modal.modal('hide');
            dfd.resolve(message === '' ? null : message, sendCancelEmail);
        });

        // reject the promise if modal was closed without submitting
        modal.on('hide.bs.modal', function () {
            // if modal was simply closed
            if (!modalSubmitted) {
                dfd.reject();
            }
        });
    }

    let renderMessageLanguage = function (item, modal) {
        let customerLanguage = item.attr(ATTR_RESERVATION_LANG_NAME) || '';
        if (customerLanguage !== '') {
            let langPlaceholder = modal.find(SEL_MODAL_LANGUAGE_HINT).find(SEL_MODAL_LANGUAGE_HINT_PLACEHOLDER);

            // append flag icon
            let customerLanguageIcon = item.attr(ATTR_RESERVATION_LANG_ICON) || '';
            if (customerLanguageIcon !== '') {
                let localConfig = window.config.reservationList || {};
                let langFlagPath = localConfig.langFlagPath || '';
                jQuery('<img />')
                    .attr('src', langFlagPath + customerLanguageIcon)
                    .appendTo(langPlaceholder);
            }

            // append language name
            jQuery('<span />')
                .text(customerLanguage)
                .appendTo(langPlaceholder);
        } else {
            modal.find(SEL_MODAL_LANGUAGE_HINT).remove();
        }
    }

    let hideModalBody = function (isSeriesCancel, item) {
        let reservationEmail = getReservationEmail(item);

        return isSeriesCancel || (reservationEmail === '' && (!hasReservationPhone(item) || canSendCancellationSms(item)));
    }

    var sendReminder = function (reservationId) {
        var dfd = jQuery.Deferred();

        var localConfig = window.config.reservationList || {};
        var apiUrl = localConfig.apiUrlSendReminder || '';
        var csrf = localConfig._csrf || '';

        var url = buildUrlWithParams(apiUrl, {
            reservationId: reservationId
        });
        jQuery.ajax({
            url: url,
            method: 'POST',
            data: {
                _csrf: csrf
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response) {
            if (response.sent) {
                dfd.resolve();
            } else {
                dfd.reject(response.error || localConfig.defaultSendError);
            }
        }).fail(function (error) {
            dfd.reject(error);
        });

        return dfd.promise();
    };

    var sendStatusUpdateRequest = function (reservationId, newStatus, message, sendCancelEmail, currentReservationCard) {
        var dfd = jQuery.Deferred();

        var localConfig = window.config.reservationList || {};
        var apiUrl = localConfig.apiUrlUpdateStatus || '';
        var csrf = localConfig._csrf || '';

        var url = buildUrlWithParams(apiUrl, {
            reservationId: reservationId,
            newStatus: newStatus
        });
        jQuery.ajax({
            url: url,
            method: 'POST',
            data: {
                message: message,
                sendCancelEmail: sendCancelEmail,
                _csrf: csrf
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response) {
            if (response.status) {
                showArrived = response.showArrived;
                showNoShow = response.showNoShow;
                showRemind = response.showRemind;
                showNoShowUpsellBanner = response.showNoShowUpsellBanner === true;
                currentReservationCard.find(SEL_ARRIVED_BUTTON_ACTION).hide();
                currentReservationCard.find(SEL_NOSHOW_BUTTON_ACTION).hide();
                currentReservationCard.find(SEL_REMIND_ALERT_ACTION_REMIND).hide();
                dfd.resolve(response.status);
            } else {
                dfd.reject(response.error || localConfig.defaultError);
            }
        }).fail(function (error) {
            dfd.reject(error);
        });
        return dfd.promise();
    };

    var updateReservationEndTime = function (reservationId, endResBtn) {

        var apiUrl = window.config.reservationList.endReservationUrl || '';
        
        var successMessage = window.config.reservationList.successMessage || ''; 

        var url = apiUrl + reservationId;
       
        var localConfig = window.config.reservationList || {};

        var csrf = localConfig._csrf || '';

        jQuery.ajax({
            url: url,
            method: 'POST',
            data: {
                _csrf: csrf
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response) {
            if(response.status == "OK") { 
                showSuccessMsg(successMessage); 
                endResBtn.closest(SEL_END_RESERVATION_BUTTON_CONTAINER).removeClass(CSS_SHOW);

                var statusDropdown = endResBtn.closest(SEL_RESERVATION_ITEM);
                var statusDropdownToggle = statusDropdown.find(SEL_STATUS_DROPDOWN_TOGGLE);

                if (window.config && window.config.reservationList && window.config.reservationList.status) {
                    statusDropdownToggle.find(SEL_TEXT).text(window.config.reservationList.status);
                    statusDropdownToggle.find(SEL_ARROW_DOWN).addClass(CSS_HIDE);
                    statusDropdownToggle.find(SEL_ARROW_UP).addClass(CSS_HIDE);
                }
            }
            if(response.status == "KO") { 
                showErrorMsg(response.error);
            }
        }).fail(function (error) {
            console.log('Error: ', error);
        });
    };

    var initializeElements = function(moduleNode){
                
        var items = moduleNode.find(SEL_RESERVATION_ITEM);
        items.each(function () {
            var item = jQuery(this);
            initStatusDropdown(moduleNode, item);
        });

        var arriveButton = moduleNode.find(SEL_ARRIVED_BUTTON_ACTION);
        arriveButton.on('click', function () {
            updateStatusOnClickButton(moduleNode, jQuery(this));
        });

        var noShowButton = moduleNode.find(SEL_NOSHOW_BUTTON_ACTION);
        var deleteConfirmModal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM);
        var deleteConfirmMessage = window.config && window.config.reservationList &&  window.config.reservationList.confirmNoShow ? window.config.reservationList.confirmNoShow : "";
        noShowButton.on('click', function () {
            var button = jQuery(this);
            confirmModal.show(deleteConfirmModal, deleteConfirmMessage)
            .done(function(){
                updateStatusOnClickButton(moduleNode, button);
            });
        });

        var endReservationBtn = moduleNode.find(SEL_END_RESERVATION_BUTTON);
        endReservationBtn.on('click', function (e) {
            e.stopPropagation();
            var clickedButton = jQuery(this);
            var reservationId = clickedButton.closest(SEL_RESERVATION_ITEM).attr(ATTR_RESERVATION_ID);
            updateReservationEndTime(reservationId, clickedButton);
        });

        const textElements = moduleNode.find(SEL_STATUS_DROPDOWN_TOGGLE_TEXT);
        textElements.each(function () {
            const textElement = this;
            const text = jQuery(this);
            text.removeAttr('title');
            if (textElement.offsetWidth < textElement.scrollWidth) {
                text.attr('title', text.text())
                    .tooltip();
            }
        });
    }

    var sendReminderFromAlert = function (alert, reservationId) {
        alert.addClass(CSS_PROCESSING);
        return sendReminder(reservationId)
            .fail(function (error) {
                showErrorMsg(error);
            })
            .always(function () {
                alert.removeClass(CSS_PROCESSING);
            });
    };

    const showPhoneOnlyReminderPopup = function (moduleNode, item) {
        const localConfig = window.config.reservationList || {};
        const modal = moduleNode.find(SEL_MODAL_PHONE_ONLY_REMINDER);
        const message = buildPhoneOnlyReminderMessage(localConfig, item);

        modal.off('click.phoneOnlyReminder').on('click.phoneOnlyReminder', '.action-copy-phone', function (event) {
            event.preventDefault();
            const phoneNumber = jQuery(this).attr('data-phone-number') || '';
            if (navigator.clipboard && phoneNumber !== '') {
                navigator.clipboard.writeText(phoneNumber);
            }
        });

        return alertModal.show(modal, message, true);
    };

    var updateStatusFromAlert = function (moduleNode, alert, reservationId, newStatus, message, sendCancelEmail, currentReservationCard) {
        alert.addClass(CSS_PROCESSING);
        currentReservationCard = alert.closest('.mod-reservation-list-item'); 
        return sendStatusUpdateRequest(reservationId, newStatus, message, sendCancelEmail, currentReservationCard)
            .done(function (newStatus) {
                var item = alert.parents(SEL_RESERVATION_ITEM);
                updateReservationItemStatus(moduleNode, item, newStatus);
                var localConfig = window.config.reservationList || {};
                var successMsg = localConfig.defaultStatusUpdateSuccess || '';
                showSuccessMsg(successMsg);
            })
            .fail(function (error) {
                showErrorMsg(error);
            })
            .always(function () {
                alert.removeClass(CSS_PROCESSING);
            });
    };

    var updateReservationItemStatus = function (moduleNode, item, newStatus) {
        var localConfig = window.config.reservationList || {};
        var statuses = localConfig.statuses || {};
        var statusLabel = statuses[newStatus] || '';
        var statusDropdown = item.find(SEL_STATUS_DROPDOWN);
        statusDropdown.find(SEL_STATUS_DROPDOWN_TOGGLE).find(SEL_TEXT).text(statusLabel);
        var reservationId = item.attr(ATTR_RESERVATION_ID) || '';
        let noShowUpsellBannerTag = moduleNode.find("[" + ATTR_RESERVATION_ID + "='" + reservationId + "']").find(SEL_NOSHOW_UPSELL_BANNER);
        if (newStatus === STATUS.ARRIVED) {
            newStatus = STATUS.DONE;
        }
        
        // when the dropdown status changed to undo, show the buttons
        if(newStatus == STATUS.CONFIRMED){
            getUpdatedFlagValue(item);
        }

        // when status is changed to no-show, display upsell banner (is criteria are met)
        if(newStatus == STATUS.NO_SHOW){
            if (showNoShowUpsellBanner) {
                noShowUpsellBannerTag.removeClass(CSS_HIDE);
                noShowUpsellBannerTag.addClass(CSS_SHOW);
            }
        }
        
        item.attr(ATTR_RESERVATION_STATUS, newStatus);

        // check if we have any visible alerts
        var alerts = item.find(SEL_ALERT).filter(':visible');
        if (alerts.length) {
            item.removeClass(CSS_NO_ITEM_ALERTS);
        } else {

            item.addClass(CSS_NO_ITEM_ALERTS);
        }

        refreshStatusDropdown(moduleNode, item);
    };

    var changeStatus = function (moduleNode, statusDropdown, reservationId, newStatus, message, sendCancelEmail) {
        statusDropdown.addClass(CSS_PROCESSING);
        var currentReservationCard = statusDropdown.closest('.mod-reservation-list-item');

        sendStatusUpdateRequest(reservationId, newStatus, message, sendCancelEmail, currentReservationCard)
            .done(function (newStatus) {
                var item = statusDropdown.parents(SEL_RESERVATION_ITEM);
                if (newStatus === STATUS.DONE && showArrived == true) {
                    newStatus = STATUS.ARRIVED;
                }
                updateReservationItemStatus(moduleNode, item, newStatus);
                var localConfig = window.config.reservationList || {};
                var successMsg = localConfig.defaultStatusUpdateSuccess || '';
                showSuccessMsg(successMsg);

            })
            .fail(function (error) {
                showErrorMsg(error);
            })
            .always(function () {
                statusDropdown.removeClass(CSS_PROCESSING);
            });
    };



    var buildStatusOption = function (text, onClick) {
        var anchor = jQuery('<a/>').attr('href', '#').text(text);
        anchor.on('click', function (e) {
            e.preventDefault();
            if (onClick) {
                onClick();
            }
        });
        return jQuery('<li/>').append(anchor);
    };

    let sendCancelSeriesData = function (seriesId, message, sendCancelEmail ) {

        let localConfig = window.config.reservationList || {};
        let csrf = localConfig._csrf || '';
        let form = document.forms["cancel-series-form"];
        if (form) {
            document.forms["cancel-series-form"].action = localConfig.apiUrlCancelSeries;
            document.forms['cancel-series-form'].children['_csrf'].value = csrf;
            document.forms['cancel-series-form'].children['seriesId'].value = seriesId;
            document.forms['cancel-series-form'].children['message'].value = message;
            document.forms['cancel-series-form'].children['sendCancelEmail'].value = sendCancelEmail;
            document.forms["cancel-series-form"].submit();
        }
    }

    var addStatusOptionToDropdown = function (moduleNode, item, dropdown, label, reservationId, newStatus) {
        var option = buildStatusOption(label, function () {
            switch (newStatus) {
                case STATUS.CANCELLED:
                    showCancelPopup(moduleNode, item, label, newStatus, false)
                        .done(function (message, sendCancelEmail) {
                            changeStatus(moduleNode, dropdown, reservationId, newStatus, message, sendCancelEmail);
                        });
                    break;
                case STATUS.SERIES_CANCELLED:
                    showCancelPopup(moduleNode, item, label, STATUS.CANCELLED, true)
                        .done(function (message, sendCancelEmail) {
                            // send form data
                            sendCancelSeriesData(item.attr(ATTR_RESERVATION_SERIES), message, sendCancelEmail);
                        });
                    break;
                default:
                    changeStatus(moduleNode, dropdown, reservationId, newStatus);
            }
            dropdown.toggleClass(CSS_OPEN);
        });
        dropdown.find(SEL_STATUS_DROPDOWN_OPTIONS).append(option);
    };

    let refreshStatusDropdown = function (moduleNode, item) {
        let dropdown = item.find(SEL_STATUS_DROPDOWN);
        let optionsContainer = dropdown.find(SEL_STATUS_DROPDOWN_OPTIONS).empty();

        let hasInvalidAlerts = item.find(SEL_ALERT_INVALID).length > 0;

        let currentTime = moment();
        let reservationId = item.attr(ATTR_RESERVATION_ID) || '';
        let reservationStatus = item.attr(ATTR_RESERVATION_STATUS) || '';
        let reservationStartDate = getReservationStartDate(item);

        let showArrivedDropdown = item.attr(ATTR_RESERVATION_SHOW_ARRIVED_DROPDOWN) || '';
        let showUndoConfirmOption = item.attr(ATTR_RESERVATION_SHOW_UNDO_CONFIRMED) || '';
        let showNoShowDropdown = (reservationStartDate && reservationStartDate.isBefore(currentTime));
        if (hasInvalidAlerts) {
            showArrivedDropdown = 'false';
            showUndoConfirmOption = 'false';
            showNoShowDropdown = false;
        }

        let localConfig = window.config.reservationList || {};
        let configStatusOptions = localConfig.statusOptions || {};
        let reservationSeries = item.attr(ATTR_RESERVATION_SERIES) || '';
        if (reservationSeries !== '') {
            configStatusOptions = localConfig.seriesStatusOptions || {};
        }
        let minDateBeforeDone = localConfig.minDateBeforeDone ? moment(localConfig.minDateBeforeDone) : null;
        let statusOptions = configStatusOptions[reservationStatus] || {};
        for (let newStatus in statusOptions) {
            let optionLabel = statusOptions[newStatus] || '';

            // add show arrived button 3hours before
            if (newStatus === STATUS.DONE) {
                if (showArrivedDropdown == "false") {
                    continue;
                }
            }

            // invalid new status? then skip
            if (optionLabel === '') {
                continue;
            }

            if (reservationStatus === STATUS.CONFIRMED) {
                if (newStatus === STATUS.NO_SHOW) {
                    if (!showNoShowDropdown) {
                        continue;
                    }
                }
            }

            // if the status is DONE and the reservation has ended the creation of "Undo Confirm" option is skiped
            if (reservationStatus === STATUS.DONE) {
                if (newStatus === STATUS.CONFIRMED) {
                    if (showUndoConfirmOption == "false") {
                        continue;
                    }
                }
            }

            // add to list
            addStatusOptionToDropdown(
                moduleNode,
                item,
                dropdown,
                optionLabel,
                reservationId,
                newStatus
            );
        }


        if (optionsContainer.children().length) {
            dropdown.removeClass(CSS_NO_OPTIONS);
        } else {
            dropdown.addClass(CSS_NO_OPTIONS);
        }

    };

    var initStatusDropdown = function (moduleNode, item) {

        var dropdown = item.find(SEL_STATUS_DROPDOWN);
        var toggle = dropdown.find(SEL_STATUS_DROPDOWN_TOGGLE);

        toggle.on('click', function () {
            // close any other open dropdowns
            item.find(SEL_STATUS_DROPDOWN_TOGGLE_TEXT).removeAttr('data-original-title title');
            moduleNode.find(SEL_RESERVATION_ITEM)
                .not(item)
                .find(SEL_STATUS_DROPDOWN)
                .removeClass(CSS_OPEN);
            // show/hide dropdown list
            if (!dropdown.hasClass(CSS_PROCESSING) && !dropdown.hasClass(CSS_NO_OPTIONS)) {
                dropdown.toggleClass(CSS_OPEN);
            }


        });

        refreshStatusDropdown(moduleNode, item);

    };

    var initItemCardClickHandling = function (moduleNode) {
        // allow clicking on child elements
        // without being redirected to edit page
        // NOTE: this should be done before setting up the click handler below
        moduleNode.on('click', SEL_RESERVATION_ITEM_IGNORE_CLICK, function (event) {
            event.stopPropagation();
        });

        // handle clicking the card (except on the child elements defined above)
        moduleNode.on('click', SEL_RESERVATION_ITEM, function () {
            var item = jQuery(this);
            var editUrl = item.attr(ATTR_EDIT_URL) || '';
            goToUrl(editUrl);
        });
    };

    var initInvalidAlerts = function (moduleNode) {

        moduleNode.on('click', SEL_INVALID_ALERT_ACTION_CANCEL, function (event) {
            event.preventDefault();
            var button = jQuery(this);
            var alert = button.parents(SEL_ALERT);
            var item = button.parents(SEL_RESERVATION_ITEM);
            var reservationId = item.attr(ATTR_RESERVATION_ID) || '';
            var buttonLabel = button.text();

            showCancelPopup(moduleNode, item, buttonLabel, STATUS.CANCELLED, false)
                .done(function (message, sendCancelEmail) {
                    updateStatusFromAlert(moduleNode, alert, reservationId, STATUS.CANCELLED, message, sendCancelEmail);
                });
        });

    };

    var initRequstedAlerts = function (moduleNode) {

        moduleNode.on('click', SEL_REQUESTED_ALERT_ACTION, function (event) {
            event.preventDefault();
            var button = jQuery(this);
            var alert = button.parents(SEL_ALERT);
            var item = alert.parents(SEL_RESERVATION_ITEM);
            var reservationId = item.attr(ATTR_RESERVATION_ID) || '';
            var newStatus = button.attr(ATTR_STATUS) || '';
            if (newStatus === STATUS.REJECTED || newStatus === STATUS.CANCELLED || newStatus === STATUS.CONFIRMED) {
                var buttonLabel = button.text();
                showCancelPopup(moduleNode, item, buttonLabel, newStatus, false)
                    .done(function (message) {
                        updateStatusFromAlert(moduleNode, alert, reservationId, newStatus, message);
                        if(newStatus == STATUS.CONFIRMED){
                            setTimeout(function() {
                                refreshReservationList(moduleNode);
                              }, 2000);
                        }
                    });
            } else {
                updateStatusFromAlert(moduleNode, alert, reservationId, newStatus);
            }
        });

    };

    var initRemindAlerts = function (moduleNode) {
        moduleNode.on('click', SEL_REMIND_ALERT_ACTION_REMIND, function (event) {
            event.preventDefault();
            var button = jQuery(this);
            var alert = button.parents(SEL_ALERT);
            var item = alert.parents(SEL_RESERVATION_ITEM);
            var reservationId = item.attr(ATTR_RESERVATION_ID) || '';
            var remindMessage = button.parent(SEL_REMIND_ALERT_ACTIONS).siblings(SEL_REMIND_ALERT_MESSAGE_BOX);
            const reservationEmail = getReservationEmail(item);
            if (reservationEmail === '' && hasReservationPhone(item)) {
                showPhoneOnlyReminderPopup(moduleNode, item);
                return;
            }
            sendReminderFromAlert(alert, reservationId)
                .done(function () {
                    // mark the alert as sent
                    var localConfig = window.config.reservationList || {};
                    var reminderSent = localConfig.reminderSent || '';
                    var reminderSentSuccess = localConfig.reminderSentSuccess || '';

                    // reset tooltip
                    alert.attr('data-original-title', reminderSent);

                    button.prop('disabled', true);
                    remindMessage.hide();

                    // show success message
                    showSuccessMsg(reminderSentSuccess);
                });
        });

    };

    var initGroupsForPrinting = function (moduleNode) {
        var groups = moduleNode.find(SEL_RESERVATION_GROUP);
        groups.each(function () {
            var group = jQuery(this);
            var futureReservations = group.find(SEL_RESERVATION_ITEM).filter(function () {
                var item = jQuery(this);
                var reservationStatus = item.attr(ATTR_RESERVATION_STATUS) || '';

                // hide is reservation is
                switch (reservationStatus) {
                    case STATUS.CANCELLED:
                    case STATUS.DONE:
                    case STATUS.REJECTED:
                    case STATUS.NO_SHOW:
                        return false;
                }

                return true;
            });
            if (futureReservations.length) {
                group.removeClass(CSS_HIDDEN_PRINT);
            } else {
                group.addClass(CSS_HIDDEN_PRINT);
            }
        });
    };




    var updateStatusOnClickButton = function (moduleNode, selectedButton) {
        event.preventDefault();
       
        var currentReservationCard = selectedButton.closest('.mod-reservation-list-item');
        var newStatus = selectedButton.val();
        var alert = selectedButton.parents(SEL_ALERT);
        var item = alert.parents(SEL_RESERVATION_ITEM);
        var reservationId = item.attr(ATTR_RESERVATION_ID) || '';
        var remindButtonTag = moduleNode.find("[" + ATTR_RESERVATION_ID + "='" + reservationId + "']").find(SEL_REMIND_BUTTON);
        var arrivedAndNoshowButtonTag = moduleNode.find("[" + ATTR_RESERVATION_ID + "='" + reservationId + "']").find(SEL_NOSHOW_ARRIVED_BUTTON);
        let noShowUpsellBannerTag = moduleNode.find("[" + ATTR_RESERVATION_ID + "='" + reservationId + "']").find(SEL_NOSHOW_UPSELL_BANNER);
        updateStatusFromAlert(moduleNode, alert, reservationId, newStatus, undefined, undefined, currentReservationCard)
            .done(function () {
                arrivedAndNoshowButtonTag.removeClass(CSS_SHOW);
                arrivedAndNoshowButtonTag.addClass(CSS_HIDE);

                if (showNoShowUpsellBanner) {
                    noShowUpsellBannerTag.removeClass(CSS_HIDE);
                    noShowUpsellBannerTag.addClass(CSS_SHOW);
                }

                var isRemindFlag = window.config.reservationList ? window.config.reservationList.isShowRemindButton : '';
                if (isRemindFlag) {
                    if (remindButtonTag.hasClass(CSS_SHOW)) {
                        remindButtonTag.removeClass(CSS_SHOW);
                        remindButtonTag.addClass(CSS_HIDE);
                    }
                }
                
            });
    };

    var getUpdatedFlagValue = function (item) { 
        var arrivedAndNoshowButtonTag = item.find(SEL_NOSHOW_ARRIVED_BUTTON);
        var remindButtonTag = item.find(SEL_REMIND_BUTTON);

        if (showRemind) {
            if (remindButtonTag.is(':hidden')) {
                remindButtonTag.removeClass(CSS_HIDE);
                remindButtonTag.addClass(CSS_SHOW);
            }
        }else {
            remindButtonTag.removeClass(CSS_SHOW);
            remindButtonTag.addClass(CSS_HIDE);
        }

        if (showNoShow) {
            if (arrivedAndNoshowButtonTag.is(':hidden')) {
                arrivedAndNoshowButtonTag.removeClass(CSS_HIDE);
                arrivedAndNoshowButtonTag.addClass(CSS_SHOW);
            }
        } else {
            arrivedAndNoshowButtonTag.removeClass(CSS_SHOW);
            arrivedAndNoshowButtonTag.addClass(CSS_HIDE);
        }
    };

	var initPrintButton = function(moduleNode) {
		var btnPrint = moduleNode.find(SEL_BTN_PRINT);
		btnPrint.on('click', function() {
            var userAgent = navigator.userAgent.toLowerCase();
            var AndroidCheck = userAgent.indexOf("android") > -1;
            if(AndroidCheck){
                Android.print();
                window.print();
            }
            else{
                window.print();
            }
			return false;
		});
	};

    var iterations = 0;
    var refreshReservationList = function (moduleNode, iterationNum, interval, refreshFrequency, refreshMaxDuration) {

        var incrementedNumber = iterationNum + 1;
        iterations = incrementedNumber;
        if (iterations >= (refreshMaxDuration / refreshFrequency)) {clearInterval(interval)}
        
        var url = window.location.href;
        
        var localConfig = window.config.reservationList || {};

        var csrf = localConfig._csrf || '';

        jQuery.ajax({
            url: url,
            method: 'GET',
            data: {
                _csrf: csrf
            },
            dataType: 'html',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response) {

                var newFragment = jQuery(response).find(SEL_RESERVATION_LIST_REFRESH).html();
                var newAddCardFragment = jQuery(response).find(SEL_RESERVATION_ADD_CARD).html();
                var newReservationStatisticsCard = jQuery(response).find(SEL_RESERVATION_STATISTICS).html();
                
                var newManageReservationCard = jQuery(response).find(SEL_MANAGE_RESERVATION_CARD).html();

                //refresh the add reservation card to show the walkin button when the establishment is open
                var addCardNode = jQuery(SEL_RESERVATION_ADD_CARD);
                addCardNode.html(newAddCardFragment);

                //refresh the statistics of reservations (guest number, nb of reservations)
                var reservationStatisticsCard = jQuery(SEL_RESERVATION_STATISTICS);
                reservationStatisticsCard.html(newReservationStatisticsCard);
                
                var node = jQuery(SEL_RESERVATION_LIST_REFRESH);
                node.html(newFragment);

                var manageReservationCard = jQuery(SEL_MANAGE_RESERVATION_CARD);
                if(newManageReservationCard != undefined){
                    manageReservationCard.html(newManageReservationCard);
                }else{
                    manageReservationCard.remove();
                }
                // Event listeners are gone after refresh, therefore we need to add then again. Also we init / refresh dropdown
                initializeElements(moduleNode);

            // }
        }).fail(function (error) {
            console.log('Error: ', error);
        });
    };

    /**
     * @description id diets/allergies don't have any values, will hide respective label so that it will not display in print screen
     * @param {*} moduleNode 
     */
    var hideDietAllergyOnPrintSecreen = function(moduleNode){
        moduleNode.find(SEL_RESERVATION_ITEM).each(function(){
            var item = jQuery(this);
            var foodDiet = item.find(SEL_FOOD_DIETS);
            var foodAllergies = item.find(SEL_FOOD_ALLERGIES);

            var dietData = foodDiet.find(SEL_FOOD_DIETS_VALUES);
            var allergyData = foodAllergies.find(SEL_FOOD_ALLERGIES_VALUES);

            if(dietData.length == 0){ foodDiet.remove(); }
            if(allergyData.length == 0){ foodAllergies.remove(); }
        });
    }

    /**
     * Initialize.
     */
    this.init = function (initNode) {

        self = this;

        // Retrieve and cache dom nodes
        var moduleNodes = initNode.find(SEL_MODULE);

        // Init all matching nodes
        moduleNodes.each(function () {

            var moduleNode = jQuery(this);

            var refreshFrequency = +window.config.reservationList.refreshFrequency;
            var refreshMaxDuration = +window.config.reservationList.refreshMaxDuration;

            // hide both limits and manage reservations banner on invalid and requested reservations page
            if(window.location.href.match(/(INVALIDANDREQUESTED|INVALIDONLY|REQUESTEDONLY)/)){
                var paginationNode = moduleNode.prev(SEL_RESERVATION_PAGINATION);
                paginationNode.find(SEL_NO_LIMITS_BANNER).hide();
                paginationNode.find(SEL_LIMIT_LIST_BANNER).hide();
                paginationNode.find(SEL_INVALID_REQUESTED_RESERVATION_ALERT).hide();
            }

            hideDietAllergyOnPrintSecreen(moduleNode);

            initGroupsForPrinting(moduleNode);

            initItemCardClickHandling(moduleNode);

            initInvalidAlerts(moduleNode);

            initRequstedAlerts(moduleNode);

            initRemindAlerts(moduleNode);

			initPrintButton(moduleNode);

            if (refreshFrequency && refreshMaxDuration){
                var interval = setInterval(function(){
                refreshReservationList(moduleNode, iterations, interval, refreshFrequency, refreshMaxDuration)
                }, refreshFrequency * 1000);
            }
            
            initializeElements(moduleNode);

        });

    };

};

// Make class public to outside world
module.exports = ReservationList;
},{"../mediator/mediator":103,"../modals/Alert":110,"../modals/Confirm":111,"../utils/StringUtils":187,"../utils/UserInterfaceUtils":189,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],137:[function(require,module,exports){
/**
 * ReservationPagination functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery 						= require('jquery/dist/jquery');
var moment 					= require('moment/min/moment-with-locales');
var UserInterfaceUtils 		= require('../utils/UserInterfaceUtils');
var Confirm					= require('../modals/Confirm');
Notification 				= require('../notification/Notification');

// Class definition
ReservationPagination = function() {

    // self references
    var self;

	// selector constants
	var SEL_MODULE							= '.mod-reservation-pagination';

	var SEL_MODULE_ACCORDION 				= ".mod-todays-limits";
	var SEL_ADD_NEW_LIMIT_BUTTON 			= '.mod-no-limits-banner .btn-limit-add';
    var SEL_DELETE_ICON 					= '.fa-trash-alt';
    var SEL_MODAL_DELETE_CONFIRM 			= '.deleteConfirmModal';
	var SEL_MODAL_DELETE_CONFIRM_MESSAGE	= '.confirm-message';

	var SEL_ACCORDION_ARROW_DOWN			= 'fas fa-chevron-down';
	var SEL_ACCORDION_ARROW_UP 				= 'fas fa-chevron-up';
	var SEL_ACCORDION_ARROW_ICON			= '.arrowIcon';
	var SEL_DEFAULT_LIMIT_TITLE 			= '.default-active-limit-heading';
	var SEL_LIMIT_TITLE 					= '.active-limit-heading';
	var SEL_SHOW_MORE_LESS_BLOCK 			= ".show-more-less";
	var SEL_SHOW_MORE_LINK 					= ".show-more";
	var SEL_SHOW_LESS_LINK 					= ".show-less";

	var SEL_DATE_RANGE_CONTAINER			= '.mod-reservation-overview-date-range-card';
	var SEL_FILTER_CONTAINER				= '.mod-reservation-overview-filter-card';
	var SEL_DATEPICKER_INPUT_GROUP_ADDON 	= '.input-group-addon';
	var SEL_MEAL_TYPES_CONTAINER			= '.mealTimesWrapper';
	var SEL_DATE_RANGE_INPUT				= '.date-range-input';
	var SEL_DATE_RANGE_ARROW				= '.move-arrow';
	const SEL_TODAY_BUTTON					= '.btn-today';

	var SEL_MAIN_CONTENT 					= '#main-content';
	var SEL_DATERANGEPICKER 				= '.daterangepicker';
	var SEL_DATEPICKER_RANGE 				= '.ranges';

	var SEL_RADIO							= 'input[type="radio"]';

	var SEL_DATERANGEPICKER_RANGE 			= '.daterangepicker.show-ranges .ranges li';

	var CSS_DISABLED						= 'disabled';
	var CSS_ACTIVE 							= 'active';
	var CSS_HIDDEN 							= 'hidden';
	var CSS_HIDE 							= 'hide';

	var DATA_ATTR_START_DATE				= 'startDate';
	var DATA_ATTR_END_DATE					= 'endDate';
	var DATA_ATTR_START_TIME				= 'startTime';
	var DATA_ATTR_END_TIME					= 'endTime';

	var SYSTEM_DATE_FORMAT					= 'YYYY-MM-DD';
	var SYSTEM_TIME_FORMAT					= 'HH:mm';

	var confirmModal = new Confirm();
	var notification = new Notification();
	var isCalendarOpened = 0;

	/**
	 *@param {Moment} date A momentJS object
	 */
	var formatDateForUrl = function(date) {
		if (!date) {
			return '';
		}
		return date.format(SYSTEM_DATE_FORMAT);
	};

	/**
	 *@param {Moment} time A momentJS object
	 */
	var formatTimeForUrl = function(time) {
		if (!time) {
			return '';
		}
		return time.format(SYSTEM_TIME_FORMAT);
	};

	var parseInitialDate = function(date, time) {
		var timeArray = ['00', '00']
		if (!date || date === '') {
			return null;
		}
		if (time) {
			timeArray = time.split(':');
		}
		return moment(date, SYSTEM_DATE_FORMAT).set({hours: timeArray[0], minute: timeArray[1]});
	};

	var loadPageWithDateRange = function(startDate, endDate) {
		var queryParamsObj = getQueryParamsObj();

		queryParamsObj['date']=formatDateForUrl(startDate);
		queryParamsObj['endDate']=formatDateForUrl(endDate);
		queryParamsObj['startTime']=formatTimeForUrl(startDate);
		queryParamsObj['endTime']=formatTimeForUrl(endDate);

		document.location.href = '/reservations?' + jQuery.param(queryParamsObj);
	};

	var buildDatePickerRanges = function(config, calendarLanguageCode) {
		var ranges = {};

		ranges[config.THIS_WEEK] = [
			calendarLanguageCode === 'en' ? moment().startOf('week').add(1, 'day') : // picker week starts on Sun for en, but we need Monday (so +1 day)
			 moment().startOf('week'), // picker week starts on mon for rest of langs
			calendarLanguageCode === 'en' ? moment().startOf('week').add(1, 'week').hour(23).minute(59) : 
			moment().startOf('week').add(1, 'week').subtract(1,'minute') //adding a week gives mon again, so subtracting a min gives 23:59 on sun
		];
		ranges[config.NEXT_WEEK] = [
			calendarLanguageCode === 'en' ? moment().startOf('week').add(1, 'week').add(1, 'day') : // picker week starts on Sun for en, but we need Monday (so +1 day)
			moment().startOf('week').add(1, 'week'), // picker week starts on mon for rest of langs
			calendarLanguageCode === 'en' ? moment().startOf('week').add(2, 'week').hour(23).minute(59) : 
			moment().startOf('week').add(2, 'week').subtract(1,'minute') //adding 2 week gives mon again, so subtracting a min gives 23:59 on sun 
		];
		ranges[config.THIS_MONTH] = [
			moment().startOf('month'),
			moment().startOf('month').add(1, 'month').subtract(1, 'day').hour(23).minute(59) // we need to step back one day to select the last day of month
		];
		ranges[config.NEXT_MONTH] = [
			moment().startOf('month').add(1, 'month'),
			moment().startOf('month').add(2, 'month').subtract(1, 'day').hour(23).minute(59) // we need to step back one day to select the last day of month
		];

		return ranges;
	};

	var initDateRangeSelector = function(moduleNode, localConfig) {
		var container 				= moduleNode.find(SEL_DATE_RANGE_CONTAINER);
		var dateRangeInput 			= container.find(SEL_DATE_RANGE_INPUT);
		var arrows 					= container.find(SEL_DATE_RANGE_ARROW);
		const todayButton			= container.find(SEL_TODAY_BUTTON);
		var isOpened = 0;

		// disable arrows if the input is disabled
		if (dateRangeInput.prop('disabled')) {
			arrows.attr('href', '#').addClass(CSS_DISABLED);
			todayButton.addClass(CSS_DISABLED);
		} else {
			var startDate = parseInitialDate(dateRangeInput.data(DATA_ATTR_START_DATE), dateRangeInput.data(DATA_ATTR_START_TIME));
			if (!startDate) {
				startDate = moment().startOf('day');
			}
			var endDate = parseInitialDate(dateRangeInput.data(DATA_ATTR_END_DATE), dateRangeInput.data(DATA_ATTR_END_TIME));

			if(dateRangeInput.data(DATA_ATTR_END_TIME) == "") {
				endDate = endDate.hour(23).minute(59);
			}

			if (!endDate) {
				endDate = moment(endDate);
			}

			if (dateRangeInput.data(DATA_ATTR_START_DATE) == moment().format(SYSTEM_DATE_FORMAT) && dateRangeInput.data(DATA_ATTR_END_DATE) == moment().format(SYSTEM_DATE_FORMAT)) {
				todayButton.addClass(CSS_DISABLED);
			}

			var isDeviceMobile = UserInterfaceUtils.isDeviceMobile();
			var displayFormat = localConfig.dateFormatWithoutYear;

			var locale = jQuery.extend({}, localConfig.locale, {
				format: displayFormat || 'DD/MM/YYYY',
				firstDay: 1, // start on monday
			});

			dateRangeInput.daterangepicker({
				autoApply: true,
				autoclose: true,
				linkedCalendars: !isDeviceMobile,
				opens: 'center',
				locale: locale,
				startDate: startDate,
				endDate: endDate,
				showCustomRangeLabel: true,
				alwaysShowCalendars: true,
				ranges: buildDatePickerRanges(localConfig.ranges, localConfig.calendarLanguageCode),
			}, function(start, end, label) {
				loadPageWithDateRange(start, end);
			});

			dateRangeInput.on('hide.daterangepicker', function(e, picker){
				isOpened = 0;
			});

			dateRangeInput.on('click', function(){
				isOpened++;
				var datePickerNode = jQuery(this).closest(SEL_MAIN_CONTENT).siblings(SEL_DATERANGEPICKER);
				if(datePickerNode.length == 1 && datePickerNode.css('display') == 'block' && jQuery(window).width() < 768){
					datePickerNode.css({'display': 'flex', 'flex-direction': 'column', 'align-items': 'center'});
					datePickerNode.find(SEL_DATEPICKER_RANGE).css({'border-bottom': '1px solid #e1e1e1', 'text-align': 'center', 'width': '100%'});
				}

				//close daterangepicker if click on input field
				if(isOpened > 1){
					datePickerNode.hide();
					isOpened = 0;
					isCalendarOpened = 0;
				}else{
					//show daterangepicker on first click
					datePickerNode.show();
					isOpened = 1;
					isCalendarOpened = 1;
				}
			});			
		}

		// highlight the "date range" option in daterangepicker when click on it
		jQuery(SEL_DATERANGEPICKER_RANGE).on('click', function(){
			var customRangeText = (window.config.reservationPagination && window.config.reservationPagination.locale.customRangeLabel);
			var customRangeOption = jQuery(this)[0];
			var rangeOption = jQuery(this);
			if(customRangeOption.innerHTML == customRangeText){
				rangeOption.siblings().hasClass(CSS_ACTIVE) ? rangeOption.siblings().removeClass(CSS_ACTIVE) : '';
				rangeOption.addClass(CSS_ACTIVE);
			}
		})
	};

	var initFilterResevations = function(moduleNode) {
		var filterInput = moduleNode.find(SEL_FILTER_CONTAINER).find(SEL_RADIO);
		filterInput.on('change', function() {

			var queryParamsObj = getQueryParamsObj();

			queryParamsObj['statusFilter'] = jQuery(this).val();
			document.location.href = '/reservations?' + jQuery.param(queryParamsObj);
		});
	};

	var initMealTypesDropdown = function(moduleNode){
		var mealTypesDropdown = moduleNode.find(SEL_MEAL_TYPES_CONTAINER);
		mealTypesDropdown.on('change', function(){

			var queryParamsObj = getQueryParamsObj();

			queryParamsObj['mealType'] = jQuery(this).val();
			document.location.href = '/reservations?' + jQuery.param(queryParamsObj);
		});
	};

	var getQueryParamsObj = function() {
		var search = window.location.search.substring(1);
		var queryParamsObj = {};
		if (search !== '') {
			search.split('&').forEach(function(param) {
				if (param === '') {
					return;
				}
				let parts = param.split('=');
				let key = parts[0];
				if (!key) {
					return;
				}
				queryParamsObj[decodeURIComponent(key)] = parts.length > 1 ? decodeURIComponent(parts[1]) : '';
			});
		}

		return queryParamsObj;
	}

	// show delete limit popup on click of a specific limit 
	var showDeletePopup = function(moduleNode, message) {
		var modal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM)
					.clone()
					.removeClass(CSS_HIDDEN);
		modal.find(SEL_MODAL_DELETE_CONFIRM_MESSAGE).text(message);
		return confirmModal.show(modal);
	};

	// call delete limit api to delete a specific limit
    var deleteSpecificLimit = function(url){
		jQuery.ajax({
			url: url,
			type: 'DELETE',
			data: {'_csrf' : window.config.reservationPagination.csrfToken},
			success: function(result, status){
				if(status == 'success'){
					localStorage.setItem('deleteSucceeded', true);
					location.reload();
				}
			},
			error: function(result, status){
				localStorage.setItem('deleteError', true);
			  	console.log(status + ": " + result.status);
			}
		});
	}


	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 	= initNode.find(SEL_MODULE);

		var localConfig 	= window.config.reservationPagination || {};

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode 		= jQuery(this);
			var accordionNode = moduleNode.find(SEL_MODULE_ACCORDION);

			initDateRangeSelector(moduleNode, localConfig);

			initFilterResevations(moduleNode);

			initMealTypesDropdown(moduleNode);

			if(localStorage.getItem('deleteSucceeded')){
				notification.showGlobalConfirmNotification(window.config.reservationPagination.limit.deleteSuccessMessage);
				localStorage.removeItem('deleteSucceeded');
			}

			if(localStorage.getItem('deleteError')){
				notification.showGlobalErrorNotification(window.config.reservationPagination.limit.deleteSuccessMessage);
				localStorage.removeItem('deleteError');
			}

			// to open/close the calendar on click of calendar icon
			var datepickerContainer = moduleNode.find(SEL_DATE_RANGE_CONTAINER);
			var dateRangeInput = datepickerContainer.find(SEL_DATE_RANGE_INPUT);
			var calendarIcon = datepickerContainer.find(SEL_DATEPICKER_INPUT_GROUP_ADDON);	
			

			calendarIcon.on('click', function(){
				var datePickerNode = moduleNode.closest(SEL_MAIN_CONTENT).siblings(SEL_DATERANGEPICKER);
				
				if(isCalendarOpened > 0){
					datePickerNode.hide();
					isCalendarOpened = 0;
				}else{
					dateRangeInput.trigger('click');
					isCalendarOpened = 1;
				}
			})

			moduleNode.on('click', SEL_ADD_NEW_LIMIT_BUTTON, function(){
				localStorage.setItem('reservationOverviewReferrer', true);
			});

			accordionNode.on('click','.header',function(){
				var icon = jQuery(this).find(SEL_ACCORDION_ARROW_ICON);
				var showMoreLess = icon.closest(SEL_SHOW_MORE_LESS_BLOCK);
				var showMore = showMoreLess.find(SEL_SHOW_MORE_LINK);
				var showLess = showMoreLess.find(SEL_SHOW_LESS_LINK);
				var defaultTitle = showMoreLess.prev().find(SEL_DEFAULT_LIMIT_TITLE);
				var newTitle = showMoreLess.prev().find(SEL_LIMIT_TITLE);

				if(icon.hasClass(SEL_ACCORDION_ARROW_DOWN)){
					icon.removeClass(SEL_ACCORDION_ARROW_DOWN);
					icon.addClass(SEL_ACCORDION_ARROW_UP);
					showMore.addClass(CSS_HIDE);
					showLess.removeClass(CSS_HIDE);
					defaultTitle.addClass(CSS_HIDE);
					newTitle.removeClass(CSS_HIDE);
				}else if(!icon.hasClass(SEL_ACCORDION_ARROW_DOWN)){
					icon.removeClass(SEL_ACCORDION_ARROW_UP);
					icon.addClass(SEL_ACCORDION_ARROW_DOWN);
					showLess.addClass(CSS_HIDE);
					showMore.removeClass(CSS_HIDE);
					newTitle.addClass(CSS_HIDE);
					defaultTitle.removeClass(CSS_HIDE);
				}
			});

			// this will execute on click of delete icon for a specific limit
			accordionNode.on('click', SEL_DELETE_ICON, function(){
				var deleteLimitId = jQuery(this).data('id');
				var deleteUrl = window.config.reservationPagination.limit.deleteLimitUrl + deleteLimitId;
				var deleteConfirmMsg = window.config.reservationPagination.limit.deleteMessage;

				showDeletePopup(moduleNode, deleteConfirmMsg).done(function() {
					deleteSpecificLimit(deleteUrl);
				});
			});

		});

	};

};

// Make class public to outside world
module.exports = ReservationPagination;

},{"../mediator/mediator":103,"../modals/Confirm":111,"../notification/Notification":125,"../utils/UserInterfaceUtils":189,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],138:[function(require,module,exports){
/**
 * ReservationStatusButton functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
ReservationStatusButton = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						= '.mod-reservation-status-button';
    var SEL_STATUS_CONFIRMED			= '.status-CONFIRMED';
    var SEL_STATUS_REJECTED				= '.status-REJECTED';
    var SEL_STATUS_CANCELLED			= '.status-CANCELLED';
    var SEL_STATUS_NO_SHOW				= '.status-NO_SHOW';
    var SEL_IN_PAST						= '.is-in-past';
    var SEL_MESSAGE						= '.message';
    var SEL_STAUTS_CHANGE_MODAL			= '#reservationStatusChangeModal';
    var SEL_LANGUAGE_HINT				= '.customerLanguageHint';
    var SEL_DATA_LANGUAGE_HINT			= 'data-customer-language-hint';
    
    // class constants
	var CLASS_NO_SUBMIT_MSG				= 'noSubmitMsg';
	
	/**
	 * Prevent double submit
	 */
	var preventDoubleSubmit = function(form) {
		form.submit(function() {
			if (this.beenSubmitted) {
				return false;
			} else {
				this.beenSubmitted = true;
			}
		});
	};


	/**
	 * Handle button form submit
	 */
	var handleFormSubmit = function() {	
		var formNode = jQuery(this);
		var buttonNode = formNode.find('.btn');
		
		var moduleNode = jQuery(this).parents(SEL_MODULE);
		
		if (moduleNode.is(SEL_STATUS_CONFIRMED) || moduleNode.is(SEL_STATUS_REJECTED) || moduleNode.is(SEL_STATUS_CANCELLED) || moduleNode.is(SEL_STATUS_NO_SHOW)) {
			
			var modalNode = jQuery(SEL_STAUTS_CHANGE_MODAL);
			var modalBtnCancelNode = modalNode.find('button[type="reset"]');
			var modalBtnSubmitNode = modalNode.find('button[type="submit"]');
			var modalMessageNode = modalNode.find(SEL_MESSAGE);
			var languageHintNode = modalNode.find(SEL_LANGUAGE_HINT);
			
			// Clear message
			modalMessageNode.val('');
			
			// Hide msg for NO-SHOW or reservations starting in the PAST
			if (moduleNode.is(SEL_STATUS_NO_SHOW) || moduleNode.is(SEL_IN_PAST)) {
				modalNode.addClass(CLASS_NO_SUBMIT_MSG);
			} else {
				modalNode.removeClass(CLASS_NO_SUBMIT_MSG);
			}
			
			// Display language hint
			languageHintNode.html(buttonNode.attr(SEL_DATA_LANGUAGE_HINT));
			
			// Unbind all previous actions - we are reusing this modal!!!
			modalBtnCancelNode.unbind('click');
			modalBtnSubmitNode.unbind('click');
			
			// Re-style button to current status
			modalBtnSubmitNode.attr('class', buttonNode.attr('class'));
			modalBtnSubmitNode.html(buttonNode.html());
			
			// Bind form submission action
			modalBtnSubmitNode.bind('click', function() {
				
				// Unbind handleFormSubmit() method first - otherwise we can never really submit the form
				formNode.unbind(self.handleFormSubmit);
				
				// Put user-entered message into form's msg field
				formNode.find("input[name='message']").val(modalMessageNode.val());

				preventDoubleSubmit(formNode);

				// Finally really submit the form
				formNode.trigger('submit');
			});
			
			// Bind form cancel action
			modalBtnCancelNode.bind('click', function() {
				modalNode.modal('hide');
				buttonNode.focus();
			});
			
			// Show modal
			modalNode.modal('show');
			
			// Set focus on submit node
			modalBtnSubmitNode.focus();
			
			return false;			
		}

	}

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {
			
			// Handle requested form submit
			jQuery(this).find('form').bind('submit', handleFormSubmit);
			
		});

    };

};

// Make class public to outside world
module.exports = ReservationStatusButton;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],139:[function(require,module,exports){
/**
 * ReservationStatusButtonGroup functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
ReservationStatusButtonGroup = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                = '.mod-reservation-status-buttons-group';
  var SEL_STATUS_BUTTON         = '.update-status-button';
  var SEL_STATUS_CONTENT        = '.update-status-content';

  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes           = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var statusButton = moduleNode.find(SEL_STATUS_BUTTON);
      var statusContent = moduleNode.find(SEL_STATUS_CONTENT);

      statusButton.popover({
        trigger: 'focus',
        placement: 'bottom',
        container: 'body',
        content: ' '
      });

      // remove content and attach to popover when it's about to be displayed
      statusButton.on('inserted.bs.popover', function() {
        var popover = jQuery(this).data('bs.popover').tip();
        popover.find('.popover-content').append(statusContent.detach().removeClass('hidden'));
      });

      // when hidden, add the content back to where it was
      statusButton.on('hidden.bs.popover', function() {
        statusContent.detach().addClass('hidden').insertAfter(statusButton);
      });

    });

  };

};

// Make class public to outside world
module.exports = ReservationStatusButtonGroup;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],140:[function(require,module,exports){


/**
 * Reservation functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
var ReservationEdit                 = require('./ReservationEdit');
var ReservationList                 = require('./ReservationList');
var ReservationPagination           = require('./ReservationPagination');
var ReservationStatusButton         = require('./ReservationStatusButton');
var ReservationStatusButtonGroup    = require('./ReservationStatusButtonGroup');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

  // Instanciate implementing class
  var reservationEdit     = new ReservationEdit();
  var reservationList     = new ReservationList();
  var reservationPagination   = new ReservationPagination();
  var reservationStatusButton = new ReservationStatusButton();
  var reservationStatusButtonGroup = new ReservationStatusButtonGroup();
  
  // Trigger onload activities
  reservationEdit.init(initNode);
  reservationList.init(initNode);
  reservationPagination.init(initNode);
  reservationStatusButton.init(initNode);
  reservationStatusButtonGroup.init(initNode);
});
},{"../mediator/mediator":103,"./ReservationEdit":135,"./ReservationList":136,"./ReservationPagination":137,"./ReservationStatusButton":138,"./ReservationStatusButtonGroup":139}],141:[function(require,module,exports){
/**
 * DataObject functionality.
 *
 */

// Class definition
var DataObject = function(weekdays, times) {

  this.weekdays = weekdays;
  this.times = times;

};

// Class definition
var DataTimeObject = function(startHour, startMin, endHour, endMin) {

  this.startHour = startHour;
  this.startMin = startMin;
  this.endHour = endHour;
  this.endMin = endMin;

};

// Make class public to outside world
module.exports = {
  DataObject: DataObject,
  DataTimeObject: DataTimeObject
};

},{}],142:[function(require,module,exports){
/**
 * Form functionality.
*
*/


// External libs
jQuery                      = require('jquery/dist/jquery');
var ClassUtils              = require('../utils/ClassUtils');
var AbstractForm            = require('../itemEditor/AbstractForm');
var DataObject              = require('./DataObject');
var FormTimepicker          = require('../form/FormTimepicker');


var SEL_FORM_SELECT                     = 'select';
var SEL_FORM_TIME_BLOCK_HOLDER          = '.time-block-holder';
var SEL_FORM_TIME_BLOCK                 = '.time-block';
var SEL_FORM_INPUT_DAYS                 = '.form-group-field-days select';
var SEL_FORM_INPUT_TIMES_GROUP          = '.form-group-field-times';
var SEL_FORM_INPUT_TIMES_START_GROUP    = '.startingTime';
var SEL_FORM_INPUT_TIMES_END_GROUP      = '.endingTime';

var SEL_TIME_BLOCK_BUTTON_ADD           = '.time-block .buttonAdd';
var SEL_TIME_BLOCK_BUTTON_DELETE        = '.time-block .buttonDelete';

var CSS_CLASS_SINGLE_TIME_BLOCK         = 'single-time-block';

// Class definition
var Form = ClassUtils.extendClass(AbstractForm, function() {

  var self = this;

  var formTimepicker = new FormTimepicker();

  var timeBlockTemplate = null;

  /**
   * @override
   */
  this.init = function() {

    this._parent.init(); // call super class init

    var formNode = this.getNode();

    formNode.find(SEL_FORM_SELECT).selectpicker();

    // extract the template
    var timeBlockClone = formNode.find(SEL_FORM_TIME_BLOCK).clone().remove();
    // we need to wrap in div to get the outer HTML string
    timeBlockTemplate = jQuery('<div />').append(timeBlockClone).html();

    // add event listeners for add / delete buttons
    var timeBlockHolder = formNode.find(SEL_FORM_TIME_BLOCK_HOLDER);
    timeBlockHolder.on('click', SEL_TIME_BLOCK_BUTTON_ADD, function() {
      timeBlockHolder.append(self.createNewBlankTimeblock());
      self.refreshTimeBlocks();
    });
    timeBlockHolder.on('click', SEL_TIME_BLOCK_BUTTON_DELETE, function() {
      jQuery(this).parents(SEL_FORM_TIME_BLOCK).remove();
      self.refreshTimeBlocks();
    });

    this.clear();

  };

  /**
   * @override
   */
  this.getDataObjectFromValues = function() {
    var formNode = this.getNode();

    var weekdays = formNode.find(SEL_FORM_INPUT_DAYS).selectpicker('val');

    var times = [];
    formNode.find(SEL_FORM_TIME_BLOCK).each(function() {
      var timeBlock = jQuery(this);
      var startTimeGroup  =  timeBlock.find(SEL_FORM_INPUT_TIMES_START_GROUP);
      var endTimeGroup    =  timeBlock.find(SEL_FORM_INPUT_TIMES_END_GROUP);
      var startTime       =  formTimepicker.getValue(startTimeGroup);
      var endTime         =  formTimepicker.getValue(endTimeGroup);
      times.push(new DataObject.DataTimeObject(
        startTime.hours, startTime.mins,
        endTime.hours, endTime.mins
      ));
    });

    return new DataObject.DataObject(weekdays, times);
  };

  /**
   * @override
   */
  this.setValues = function(row, dataObjectExtractor) {
    var formNode = this.getNode();
    var data = dataObjectExtractor(row);

    // weekdays
    formNode.find(SEL_FORM_INPUT_DAYS).selectpicker('val', data.weekdays || []);

    // times
    var timeBlockHolder = formNode.find(SEL_FORM_TIME_BLOCK_HOLDER).empty();
    var times = data.times || [];
    times.forEach(function(timesItem) {
      var timeBlock = self.createNewTimeblock(timesItem);
      timeBlockHolder.append(timeBlock);
    });

    this.refreshTimeBlocks();

    this.markAsEditing();
    this.clearValidationErrors();
    this.rememberCurrentRow(row);
  }

  /**
   * @override
   */
  this.clear = function() {
    var formNode = this.getNode();

    // weekdays
    formNode.find(SEL_FORM_INPUT_DAYS).selectpicker('val', []);

    // times
    formNode.find(SEL_FORM_TIME_BLOCK_HOLDER)
      .empty()
      .append(this.createNewBlankTimeblock());

    this.refreshTimeBlocks();

    this.markAsNotEditing();
    this.clearValidationErrors();
    this.forgetCurrentRow();
  };

  /**
   * @override
   */
  this.validate = function() {
    var errors = [];
    var errorsToHighlight = [];
    var formNode = this.getNode();

    var weekdays = formNode.find(SEL_FORM_INPUT_DAYS);

    var timesGroup = formNode.find(SEL_FORM_INPUT_TIMES_GROUP);
    var startingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_START_GROUP);
    var endingTime = timesGroup.find(SEL_FORM_INPUT_TIMES_END_GROUP);

    var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(startingTime);
    if (invalidTimepicker.length) {
      invalidTimepicker.forEach(function(timepicker) {
        errors.push(timepicker);
      });
    }
    invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(endingTime);
    if (invalidTimepicker.length) {
      invalidTimepicker.forEach(function(timepicker) {
        errors.push(timepicker);
      });
    }

    var selectPickerValue = weekdays.selectpicker('val') || [];
    if (selectPickerValue.length === 0) {
      errorsToHighlight.push(weekdays);
      errors.push(weekdays);
    }

    this.markFieldsWithErrors(errorsToHighlight);

    return !errors.length;
  };

  /**
   * @override
   */
  this.focusOnFirstInput = function() {
    // do nothing as it's a select dropdown
    // and we don't want it to open automatically
  };

  this.createNewBlankTimeblock = function() {
    var clone = jQuery(timeBlockTemplate);
    formTimepicker.init(clone);
    return clone;
  };

  this.createNewTimeblock = function(timeData) {
    var clone = this.createNewBlankTimeblock();
    var startingTime = clone.find(SEL_FORM_INPUT_TIMES_START_GROUP);
    var endingTime = clone.find(SEL_FORM_INPUT_TIMES_END_GROUP);
    formTimepicker.setValue(startingTime, timeData.startHour, timeData.startMin);
    formTimepicker.setValue(endingTime, timeData.endHour, timeData.endMin);
    return clone;
  };

  this.refreshTimeBlocks = function() {
    var timeBlockHolder = this.getNode().find(SEL_FORM_TIME_BLOCK_HOLDER);
    if (timeBlockHolder.find(SEL_FORM_TIME_BLOCK).length > 1) {
      timeBlockHolder.removeClass(CSS_CLASS_SINGLE_TIME_BLOCK);
    } else {
      timeBlockHolder.addClass(CSS_CLASS_SINGLE_TIME_BLOCK);
    }
  };

});

// Make class public to outside world
module.exports = Form;

},{"../form/FormTimepicker":90,"../itemEditor/AbstractForm":96,"../utils/ClassUtils":184,"./DataObject":141,"jquery/dist/jquery":14}],143:[function(require,module,exports){
/**
 * HiddenData functionality.
*
*/

// External libs
jQuery                  = require('jquery/dist/jquery');
var FormTimepicker      = require('../form/FormTimepicker');
var StringUtils         = require('../utils/StringUtils');
var ArrayUtils          = require('../utils/ArrayUtils');
var ClassUtils          = require('../utils/ClassUtils');

var AbstractHiddenData  = require('../itemEditor/AbstractHiddenData');
var DataObject          = require('./DataObject');

// selector constants
var SEL_HIDDEN_FORM_DATA_PARENT_ROW   = '.itemEditor-hiddenFormData-parentRow';
var SEL_HIDDEN_FORM_DATA_ROW          = '.itemEditor-hiddenFormData-rowData';

var SEL_FORMDATA_INPUT_START_HOUR     = '.hidden-input-startHour';
var SEL_FORMDATA_INPUT_START_MIN      = '.hidden-input-startMinute';
var SEL_FORMDATA_INPUT_END_HOUR       = '.hidden-input-endHour';
var SEL_FORMDATA_INPUT_END_MIN        = '.hidden-input-endMinute';

var ATTR_DATA_PATH                    = 'data-path';
var ATTR_PATH                         = 'name';

var DATA_ATTR_PARENT_ID               = 'itemEditorParentId';
var DATA_ATTR_PARENT_LABEL            = 'itemEditorParentLabel';

// Class definition
var HiddenData = ClassUtils.extendClass(AbstractHiddenData, function(hiddenDataNode, dataRowTemplate) {

  var self = this;

  /**
   * @override
   */
  this.resetInputPath = function(inputNode, rowIndex, dataIndex) {
    var path = inputNode.attr(ATTR_DATA_PATH) || '';
    path = StringUtils.findAndReplaceAll(path, {
      '%%ROW_INDEX%%': rowIndex,
      '%%DATA_INDEX%%': dataIndex
    });
    inputNode.attr(ATTR_PATH, path);
  };

  /**
   * @override
   */
  this.updateDataRowWithDataObject = function(dataRow, dataTimeObject) {
    dataRow.find(SEL_FORMDATA_INPUT_START_HOUR).val(dataTimeObject.startHour);
    dataRow.find(SEL_FORMDATA_INPUT_START_MIN).val(dataTimeObject.startMin);
    dataRow.find(SEL_FORMDATA_INPUT_END_HOUR).val(dataTimeObject.endHour);
    dataRow.find(SEL_FORMDATA_INPUT_END_MIN).val(dataTimeObject.endMin);
  };

  /**
   * @param {object} dataObject The data object to merge into the rest of hidden data
   * @param {func} onExistingDataRow A function that should be called if an existing row is found
   *                                  The `dataRow` will be passed as a the first argument
   * @param {func} onWeekdaySelected A function that should be called when the current weekday is selected,
   *                                  called per dataRow. The `weekdayRow` will be passed as a the first argument
   */
  this.lookForExistingMatchingData = function(dataObject, onExistingDataRow, onWeekdaySelected) {
    var hiddenDataNode = this.getNode();
    // since we have multiple times, we need to get a list of virtual ids
    var selectedWeekdays = dataObject.weekdays || [];
    var times = dataObject.times || [];
    var virtualIds = times.map(function(timeData) {
      var dataWeekdays = [];
      var dataTimes = [ timeData ];
      return self.buildVirtualGroupId(new DataObject.DataObject(dataWeekdays, dataTimes));
    });
    var noStrictComparison = true;

    var weekdayRows = hiddenDataNode.find(SEL_HIDDEN_FORM_DATA_PARENT_ROW);
    weekdayRows.each(function(weekdayIndex, weekdayRowNode) {
      var weekdayRow = jQuery(weekdayRowNode);
      var weekday = weekdayRow.data(DATA_ATTR_PARENT_ID);
      var isSelectedWeekday = ArrayUtils.inArray(selectedWeekdays, weekday, noStrictComparison);
      var dataRows = weekdayRow.find(SEL_HIDDEN_FORM_DATA_ROW);

      // we may have an overlap due to values changing, so let's step through and
      // remove any matching data rows
      dataRows.each(function(dataRowIndex, dataRowNode) {
        var dataRow = jQuery(dataRowNode);
        var rowVirtualId = self.buildVirtualGroupIdFromDataRow(dataRow);
        var isExistingDataRow = ArrayUtils.inArray(virtualIds, rowVirtualId, noStrictComparison);
        if (isExistingDataRow && onExistingDataRow) {
          onExistingDataRow.call(self, dataRow);
        }
      });

      if (isSelectedWeekday && onWeekdaySelected) {
        onWeekdaySelected.call(self, weekdayRow);
      }
    });
  };

  /**
   * @override
   */
  this.updateWithRowData = function(dataObject) {
    var times = dataObject.times || [];

    var onExistingDataRow = null;

    var onWeekdaySelected = function(weekdayRow) {
      times.forEach(function(timeData) {
        self.addNewDataRowToParentRow(weekdayRow, timeData, dataRowTemplate);
      });
    };

    this.lookForExistingMatchingData(dataObject, onExistingDataRow, onWeekdaySelected);
  };

  /**
   * @override
   * In here, we are expecting a list of dataRows
   * as opposed to the parent class
   */
  this.buildDataObjectFromDataRow = function(dataRows) {
    var weekdays = []; // weekdays are not taken into consideration

    var times = [];
    jQuery(dataRows).each(function() {
      var dataRow = jQuery(this);
      var startHour = dataRow.find(SEL_FORMDATA_INPUT_START_HOUR).val();
      var startMin = dataRow.find(SEL_FORMDATA_INPUT_START_MIN).val();
      var endHour = dataRow.find(SEL_FORMDATA_INPUT_END_HOUR).val();
      var endMin = dataRow.find(SEL_FORMDATA_INPUT_END_MIN).val();
      times.push(new DataObject.DataTimeObject(
        startHour, startMin,
        endHour, endMin
      ));
    });
    return new DataObject.DataObject(weekdays, times);
  };

  /**
   * @override
   */
  this.buildItemsListFromInitialData = function(itemsList) {
    var parents = this.mergeDataRowsWithSameParents();
    for (var id in parents) {
      var parent = parents[id];
      itemsList.addRowFromDataRowAndParentIds(parent.items, parent.ids, this);
    }
    itemsList.refresh();
  };

  /**
   * @override
   */
  this.getAllDataRowsForDataObject = function(dataObject) {

    var rowsForDataObject = [];

    var onExistingDataRow = function(dataRow) {
      rowsForDataObject.push(dataRow);
    };

    this.lookForExistingMatchingData(dataObject, onExistingDataRow);

    return jQuery(rowsForDataObject);

  };

  this.mergeDataRowsWithSameParents = function() {

    var allDataRows = this.getNode().find(SEL_HIDDEN_FORM_DATA_ROW);
    var dataRowsByParents = self.groupDataRowsByParentSetup(allDataRows);

    var virtualIdBuilder = function(parentIds) {
      return parentIds.join('|');
    };

    var parents = {};
    for (var id in dataRowsByParents) {
      var items = dataRowsByParents[id];
      var parentIds = self.getIdsFromParentRows(items).sort();
      var parentsVirtualId = virtualIdBuilder(parentIds);
      var singleItem = items[0]; // first item should always exist if this parent is to exist;
      if (!(parentsVirtualId in parents)) {
        parents[parentsVirtualId] = {
          ids: parentIds,
          items: []
        };
      }
      parents[parentsVirtualId].items = jQuery.merge(parents[parentsVirtualId].items, [ singleItem ]);
    }

    return parents;

  }

  this.getWeekdayLabelsForIds = function(weekdayIds) {
    var weekdaysToLabels = {};
    this.getNode().find(SEL_HIDDEN_FORM_DATA_PARENT_ROW)
      .each(function(index, weekdayRowNode) {
        var weekdayRow = jQuery(weekdayRowNode);
        var weekdayId = weekdayRow.data(DATA_ATTR_PARENT_ID);
        var weekdayLabel = weekdayRow.data(DATA_ATTR_PARENT_LABEL);
        weekdaysToLabels[weekdayId] = weekdayLabel;
      });
    return jQuery.map(weekdayIds, function(weekdayId) {
      return weekdaysToLabels[weekdayId];
    });
  };

});

// Make class public to outside world
module.exports = HiddenData;

},{"../form/FormTimepicker":90,"../itemEditor/AbstractHiddenData":97,"../utils/ArrayUtils":183,"../utils/ClassUtils":184,"../utils/StringUtils":187,"./DataObject":141,"jquery/dist/jquery":14}],144:[function(require,module,exports){
/**
 * AreasList functionality.
*
*/

// External libs
jQuery                      = require('jquery/dist/jquery');
var ClassUtils              = require('../utils/ClassUtils');
var ArrayUtils              = require('../utils/ArrayUtils');
var StringUtils             = require('../utils/StringUtils');
var AbstractList            = require('../itemEditor/AbstractList');
var DataObject              = require('./DataObject');

var SEL_LIST_WEEKDAYS               = '.weekdays-text';
var SEL_LIST_TIMES_HOLDER           = '.times-holder';
var SEL_LIST_TIMES                  = '.times-text';

var DATA_ROW_DATA                   = 'rowDataObject';
var DATA_ATTR_24HOURS               = 'display-24h';

var TIME_24HOUR_CUTOFF              = 12;
var TIME_CHARACTERS_TOTAL           = 2;
var TIME_HOURS_MINS_SPLITTER        = ':';
var TIME_GROUP_SPLITTER             = ' - ';
var MERIDIEM_AM                     = 'am';
var MERIDIEM_PM                     = 'pm';

// Class definition
var List = ClassUtils.extendClass(AbstractList, function(itemsListNode, listRowTemplate) {

  var self = this;

  var timeBlockTempalte = null;

  /**
   * @override
   */
  this.init = function(hiddenData) {

    // let's create the template before we initialise everything else
    var timeBlockClone = listRowTemplate.find(SEL_LIST_TIMES).clone().remove();
    // we need to wrap in div to get the outer HTML string
    timeBlockTempalte = jQuery('<div />').append(timeBlockClone).html();

    // call super class init
    this._parent.init(hiddenData);

  };

  /**
   * @override
   */
  this.updateRow = function(row, dataObject, hiddenData, shouldNotUpdateHiddenData) {

    var weekdayLabels = hiddenData.getWeekdayLabelsForIds(dataObject.weekdays);
    weekdayLabels = ArrayUtils.unique(weekdayLabels);

    var weekdaysFormatted = weekdayLabels.join(', ');
    row.find(SEL_LIST_WEEKDAYS).text(weekdaysFormatted);

    // time blocks
    var timesHolder = row.find(SEL_LIST_TIMES_HOLDER).empty();
    var times = dataObject.times || [];
    times.forEach(function(timeData) {
      var timesElement = self.createNewBlankTimeblock();
      var timesFormatted = [];
      var timeGroupFormatted = self.formatTime(timeData.startHour, timeData.startMin);
      if (timeGroupFormatted !== '') {
        timesFormatted.push(timeGroupFormatted);
      }
      timeGroupFormatted = self.formatTime(timeData.endHour, timeData.endMin);
      if (timeGroupFormatted !== '') {
        timesFormatted.push(timeGroupFormatted);
      }
      timesFormatted = timesFormatted.join(TIME_GROUP_SPLITTER);
      timesElement.text(timesFormatted);
      timesElement.appendTo(timesHolder);
    });

    row.data(DATA_ROW_DATA, dataObject);

    // do we need to update the form data?
    if (!shouldNotUpdateHiddenData) {
      // remove old data row items
      self.deleteDataRowReferences(row);
      // add new data row items
      hiddenData.updateWithRowData(dataObject);
    }

    // keep a reference to the new data row items
    var rowItems = hiddenData.getAllDataRowsForDataObject(dataObject);
    self.saveDataRowReferences(row, rowItems);

  };

  /**
   * @override
   */
  this.buildDataObjectFromRow = function(row) {
    var dataObject = row.data(DATA_ROW_DATA) || {};
    var times = (dataObject.times || []).map(function(item) {
      return new DataObject.DataTimeObject(
        item.startHour, item.startMin,
        item.endHour, item.endMin
      );
    });
    return new DataObject.DataObject(
      dataObject.weekdays,
      times
    );
  };

  /**
   * @override
   */
  this.generateInputName = function(inputNode, index) {
    // we don't have any input names in the list
    return '';
  };

  /**
   * @override
   */
  this.getRowValueItems = function(row) {
    // we don't need to store any values in the list row
    return [];
  };

  /**
   * @override
   */
  this.addRowFromDataRowAndParentIds = function(dataItems, parentIds, hiddenData) {
    var dataObject = hiddenData.buildDataObjectFromDataRow(dataItems);
    dataObject.weekdays = parentIds; // override the weekdays
    var shouldNotUpdateHiddenData = true;

    var itemsListNode = this.getNode();
    var newRow = self.createNewRow();
    self.updateRow(newRow, dataObject, hiddenData, shouldNotUpdateHiddenData);
    newRow.appendTo(itemsListNode);
    return newRow;
  };

  this.formatTime = function(hours, mins) {

    hours = (hours || '').trim();
    mins = (mins || '').trim();
    if (hours === '' || mins === '') {
      return '';
    }

    var use24Hours = self.shouldUse24Hours();
    var merediem = '';
    var hoursInt = parseInt(hours);
    if (!use24Hours) {
      merediem += ' ';
      if (hoursInt === 0) {
        hours = TIME_24HOUR_CUTOFF;
        merediem = MERIDIEM_AM;
      } else if (hoursInt > TIME_24HOUR_CUTOFF) {
        hours -= TIME_24HOUR_CUTOFF;
        merediem = MERIDIEM_PM;
      } else if (hoursInt === TIME_24HOUR_CUTOFF) {
        merediem = MERIDIEM_PM;
      } else {
        merediem = MERIDIEM_AM;
      }
    }

    hours = use24Hours ? StringUtils.numLeftPad(hours, TIME_CHARACTERS_TOTAL) : hours;
    mins = StringUtils.numLeftPad(mins, TIME_CHARACTERS_TOTAL);

    return hours + TIME_HOURS_MINS_SPLITTER + mins + merediem;

  };

  this.shouldUse24Hours = function() {
    var itemsListNode = this.getNode();
    return itemsListNode.data(DATA_ATTR_24HOURS) || false;
  };

  this.createNewBlankTimeblock = function() {
    return jQuery(timeBlockTempalte);
  };

});

// Make class public to outside world
module.exports = List;

},{"../itemEditor/AbstractList":98,"../utils/ArrayUtils":183,"../utils/ClassUtils":184,"../utils/StringUtils":187,"./DataObject":141,"jquery/dist/jquery":14}],145:[function(require,module,exports){
/**
 * MealServiceHours functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

var FormTimepicker      = require('../form/FormTimepicker');
var ArrayUtils          = require('../utils/ArrayUtils');
var Alert               = require('../modals/Alert');
var Confirm             = require('../modals/Confirm');

// Class definition
var MealServiceHours = function() {

  // selector constants
  var SEL_MODULE                      = '.mod-meal-service-hours';

  var SEL_MAIN_FORM                   = 'form';
  var SEL_DATA_CONTAINER              = '.data-container';

  var SEL_MODAL_ERROR_ALERT           = '.reservationHours-alertModal';
  var SEL_MODAL_DELETE_CONFIRM        = '.reservationHours-deleteConfirmModal';

  var SEL_HOURS_CONTAINER             = '.reservation-hours-container';
  var SEL_HOURS_ITEM                  = '.reservation-hours-item';

  var SEL_PARENT_FOR_INPUT            = '.input-parent';
  var SEL_INPUT_WEEKDAYS              = 'select.weekdays-input';
  var SEL_INPUT_MEAL_SERVICE          = 'select.meal-service';
  
  var SEL_INPUT_START_TIME            = '.startingTime';
  var SEL_INPUT_END_TIME              = '.endingTime';

  var SEL_TIME_INTERVALS_GROUP        = '.time-intervals-group';
  var SEL_TIME_INTERVALS_ITEM         = '.timeIntervalSet';

  var SEL_BUTTON_ADD_ITEM             = '.addTimeSetting';
  var SEL_BUTTON_REMOVE_ITEM          = '.removeTimeSetting';

  var SEL_ACTION_ADD_TIME_INTERVAL    = '.addTimeInterval';
  var SEL_ACTION_REMOVE_TIME_INTERVAL = '.deleteTimeInterval';

  var SEL_TEMPLATE_ITEM               = '.reservationHoursTimeRowTemplate';
  var SEL_TEMPLATE_TIME_INTERVAL      = '.reservationHoursTimeIntervalTemplate';

  var DATA_ATTR_PATH                  = 'path';
  var DATA_ATTR_VALIDATION_ERROR      = 'validationError';
  var DATA_ATTR_DELETE_CONFIRM        = 'deleteConfirm';

  var EVENT_ON_CHANGE_LIST            = 'reservationHours:wizard:listRefreshed';
  var CSS_HAS_ERROR                   = 'has-error';
  var DATA_JOINED_INDEXES             = 'data-joined-indexes';

  var STARTING_TIME_MINUTES           = ".startingTime .timepicker-inner input[type=text]:last-child";
  var ENDING_TIME_MINUTES             = ".endingTime .timepicker-inner input[type=text]:last-child";

  var MEAL_SERVICES = [];
  
  var SELECTED_MEAL_SERVICES = [];
  var AVAILABLE_MEAL_SERVICES = [];

  var SORT_MEAL_SERVICES = {
    "": 0, 
    BREAKFAST: 1, 
    BRUNCH: 2, 
    LUNCH: 3, 
    DINNER: 4
  }

  var selectedMealServices = function(item){
    SELECTED_MEAL_SERVICES = [];  
    var timeIntervals = item.find(SEL_TIME_INTERVALS_ITEM);
    timeIntervals.each(function(){
        var timeInterval = jQuery(this);
        var mealServicesDropdown = timeInterval.find(SEL_INPUT_MEAL_SERVICE);
        var selectedValue = mealServicesDropdown.selectpicker('val');
        if(selectedValue != ''){
            SELECTED_MEAL_SERVICES.push(selectedValue);
        }
    });
    return SELECTED_MEAL_SERVICES;
  }

  var availableMealServices = function(selectedServices){
    AVAILABLE_MEAL_SERVICES = MEAL_SERVICES.map(function(item){
      return item.code;
    }).filter(function(mealService) {
        return selectedServices.indexOf(mealService) === -1;
    });
    return AVAILABLE_MEAL_SERVICES;
  }

  var updateMealServiceOptions = function(item){
    var selectedServices = selectedMealServices(item);
    var availableServices = availableMealServices(selectedServices);
    item.find(SEL_INPUT_MEAL_SERVICE).each(function(){
      var selectItem = jQuery(this);
      var selectItemValue = selectItem.selectpicker('val');
      var selectItemOptions = selectItem.find('option');
      selectItemOptions.each(function(){
        var option = jQuery(this);
        if(option.attr('value') != '' && option.attr('value') != selectItemValue && !availableServices.some(function(item){return option.attr('value') == item})){
          option.remove();
        }
      })

      availableServices.forEach(function(availableService){
        var availableServiceOption = selectItem.find('option[value="' + availableService + '"]');
        if(availableServiceOption.length !== 1){
          var availableServiceName = MEAL_SERVICES.find(function(item){
            return item.code == availableService;
          }).name;
          selectItem.append('<option value=' + availableService + '>' + availableServiceName + '</option>');
        }
      })
      
      var items = [];
      selectItem.find('option').each(function() {
          var item = jQuery(this);
          items.push(item);
      });
      items = items.sort(function(a, b) {
          var positionA = SORT_MEAL_SERVICES[a.attr('value')];
          var positionB = SORT_MEAL_SERVICES[b.attr('value')];
          return (positionA > positionB) ? 1 : (positionA < positionB) ? -1 : 0;
      });
      for (var i = 0; i < items.length; i++) {
          selectItem.append(items[i]);
      }
      selectItem.selectpicker('refresh');
    })
  }

  var formTimepicker = new FormTimepicker();
  var alertModal = new Alert();
  var confirmModal = new Confirm();

  var addInput = function(container, name, value) {
    return jQuery('<input />')
            .attr('type', 'hidden')
            .attr('name', name)
            .attr('value', value || '')
            .appendTo(container);
  };

  var buildPath = function(path, index, name) {
    return path + '[' + index + '].' + name;
  };

  var buildIntervalPath = function(path, index, subIndex, name) {
    return path + '[' + index + '].timeIntervals[' + subIndex + '].' + name;
  };

  var createItemForSubmit = function(container, path, data, index) {
    addInput(container, buildPath(path, index, 'id'), data.id || '0');
    addInput(container, buildPath(path, index, 'inRequest'), 'true');
    addInput(container, buildPath(path, index, 'weekday'), data.weekday);

    var timeIntervals = data.timeIntervals || [];
    timeIntervals.forEach(function(timeInterval, i) {
      addInput(container, buildIntervalPath(path, index, i, 'id'), data.id || '0');
      addInput(container, buildIntervalPath(path, index, i, 'inRequest'), 'true');
      addInput(container, buildIntervalPath(path, index, i, 'startHour'), timeInterval.startHour);
      addInput(container, buildIntervalPath(path, index, i, 'startMinute'), timeInterval.startMinute);
      addInput(container, buildIntervalPath(path, index, i, 'endHour'), timeInterval.endHour);
      addInput(container, buildIntervalPath(path, index, i, 'endMinute'), timeInterval.endMinute);
      addInput(container, buildIntervalPath(path, index, i, 'mealType'), timeInterval.mealType);
    });

  };

  var updateDataForSubmit = function(moduleNode, data) {

    var container = moduleNode.find(SEL_DATA_CONTAINER);
    var path = container.data(DATA_ATTR_PATH);

    // remove any previous errors
    container.empty();

    // convert data to inputs
    (data || []).forEach(function (timeSetting, index) {
      createItemForSubmit(container, path, timeSetting, index);
    });
  };

  var findWeekday = function(list, weekday) {
    var results = jQuery.grep(list, function(item) { return item.weekday == weekday; });
    if (results.length) {
      return results[0];
    }
    return null;
  };

  var getWeekdayRow = function(newData, previousData, weekday) {
    // check new data
    var result = findWeekday(newData, weekday);
    if (result) {
      // use the same instance
      return result;
    }
    // check previous data
    result = findWeekday(previousData, weekday);
    var newRow;
    if (result) {
      // get new instance
      newRow = {
        id: result.id || 0,
        weekday: weekday,
        timeIntervals: (result.timeIntervals || []).slice() // clone the time intervals
      };
    } else {
      // completely new weekday, then create one
      newRow = {
        id: 0,
        weekday: weekday,
        timeIntervals: []
      };
    }
    // add to new data
    newData.push(newRow);
    return newRow;
  };

  var isTimeIntervalEqual = function(item1, item2) {
    return item1.startHour == item2.startHour &&
            item1.startMinute == item2.startMinute &&
            item1.endHour == item2.endHour &&
            item1.endMinute == item2.endMinute &&
            item1.mealType == item2.mealType;
  };

  var addTimeIntervalToList = function(newList, previousList, data) {
    // check new data
    var results = jQuery.grep(newList, function(item) {
      return isTimeIntervalEqual(item, data);
    });
    if (results.length) {
      // item exists, so no need to create duplicates
      return;
    }
    // use an old item (and remove it from the previous list)
    var row = previousList.pop();
    // no item in old list? then let's create a new one
    if (!row) {
      row = {
        id: 0
      };
    }

    // replace values
    row.startHour = data.startHour;
    row.startMinute = data.startMinute;
    row.endHour = data.endHour;
    row.endMinute = data.endMinute;
    row.mealType = data.mealType;

    // add to new data
    newList.push(row);
  };

  var getTimeIntervalsFromGroup = function(group) {
    var timeIntervals = [];
    group.find(SEL_TIME_INTERVALS_ITEM).each(function() {
      var item = jQuery(this);
      var startTime = formTimepicker.getValue(item.find(SEL_INPUT_START_TIME));
      var endTime = formTimepicker.getValue(item.find(SEL_INPUT_END_TIME));
      var mealType = item.find(SEL_INPUT_MEAL_SERVICE).selectpicker('val');
      timeIntervals.push({
        startHour: startTime.hours,
        startMinute: startTime.mins,
        endHour: endTime.hours,
        endMinute: endTime.mins,
        mealType: mealType
      });
    });
    return timeIntervals;
  };

  // try to reuse existing data rows,
  // because they are already in database and we only want to do updates to
  // a minimal of them (not to delete/create)
  var calculateDataToSubmitFromInput = function(moduleNode, initialData) {
    var data = [];
    var items = moduleNode.find(SEL_HOURS_CONTAINER).find(SEL_HOURS_ITEM);

    items.each(function() {
      var item = jQuery(this);
      var weekdays = item.find(SEL_INPUT_WEEKDAYS).selectpicker('val');
      var timeIntervals = getTimeIntervalsFromGroup(item.find(SEL_TIME_INTERVALS_GROUP));

      (weekdays || []).forEach(function(weekday) {
        var weekdayRow = getWeekdayRow(data, initialData, weekday);

        // lets add all the new ones to a new property,
        // which we will use for syncing old database ids
        weekdayRow.newTimeIntervals = weekdayRow.newTimeIntervals || [];
        timeIntervals.forEach(function(timeInterval) {
          // add a clone of the time intervals
          weekdayRow.newTimeIntervals.push({
            startHour: timeInterval.startHour,
            startMinute: timeInterval.startMinute,
            endHour: timeInterval.endHour,
            endMinute: timeInterval.endMinute,
            mealType: timeInterval.mealType
          });
        });

      });

    });

    // clean up the time intervals for each weekday now
    data.forEach(function(weekdayRow) {
      var timeIntervals = [];
      var oldTimeIntervals = weekdayRow.timeIntervals;
      weekdayRow.newTimeIntervals.forEach(function(timeIntervalData) {
        addTimeIntervalToList(timeIntervals, oldTimeIntervals, timeIntervalData);
      });
      // replace time intervals
      weekdayRow.timeIntervals = timeIntervals;
      // remove old unsynced time intervals
      delete weekdayRow.newTimeIntervals;
    });

    // we need to clear any existing weekdays, that are no longer covered.
    // we will add these days to the data, but clear the time intervals
    initialData.forEach(function(weekdayRow) {
      if (!findWeekday(data, weekdayRow.weekday)) {
        data.push({
          id: weekdayRow.id || 0,
          weekday: weekdayRow.weekday,
          timeIntervals: [] //clear the time intervals
        });
      }
    });

    return data;
  };

  var buildItemsFromInitialData = function (moduleNode, initialData, itemTemplate, timeIntervalTemplate) {
    var container = moduleNode.find(SEL_HOURS_CONTAINER).empty();
    var itemData = getItemDataFromInitialData(initialData);

    // Removing timeintervals which have no intervals
    itemData.forEach(function (item, index, object) {
      if((item.timeIntervals || []).length === 0){
        object.splice(index,1);
      }
    });

    var newitemData = itemData;
    newitemData.forEach(function (item) {
      createItemFromData(container, item, itemTemplate, timeIntervalTemplate);
    });
  };

  var buildVirtualId = function(timeInterval) {
    return [
      timeInterval.startHour,
      timeInterval.startMinute,
      timeInterval.endHour,
      timeInterval.endMinute,
      timeInterval.mealType
    ].join(':');
  };

  var getItemDataFromInitialData = function(initialData) {

    var timeIntervalsToWeekdays = {};
    var virtualIdsToTimeIntervals = {};
    var weekdaysToTimeIntervals = {};

    // group weekdays by time intervals
    initialData.forEach(function(weekdayRow) {
      (weekdayRow.timeIntervals || []).forEach(function(timeInterval, indexTimeinterval) {
        timeInterval.virtualId = buildVirtualId(timeInterval);
        virtualIdsToTimeIntervals[timeInterval.virtualId] = timeInterval;
        if (!(timeInterval.virtualId in timeIntervalsToWeekdays)) {
          timeIntervalsToWeekdays[timeInterval.virtualId] = {
            days: [],
            joinedIndexes: []
          };;
        }
        timeIntervalsToWeekdays[timeInterval.virtualId].days.push(weekdayRow.weekday);

        timeIntervalsToWeekdays[timeInterval.virtualId].joinedIndexes.push((weekdayRow.weekday - 1) + '|' + indexTimeinterval);
      });
    });

    // now check for time interval groups
    for (var virtualId in timeIntervalsToWeekdays) {
      var weekdays = timeIntervalsToWeekdays[virtualId].days;
      var weekdaysId = weekdays.sort().join(':');
      if (!(weekdaysId in weekdaysToTimeIntervals)) {
        weekdaysToTimeIntervals[weekdaysId] = {
          id: weekdaysId,
          weekdays: weekdays,
          timeIntervals: {
            ids: [],
            joinedIndexes: {}
          }
        };
      }
      weekdaysToTimeIntervals[weekdaysId].timeIntervals.ids.push(virtualId);

      weekdaysToTimeIntervals[weekdaysId].timeIntervals.joinedIndexes[virtualId] = timeIntervalsToWeekdays[virtualId].joinedIndexes;
    }

    var items = [];
    for (var weekdaysId in weekdaysToTimeIntervals) {
      var weekdayGroup = weekdaysToTimeIntervals[weekdaysId];
      var timeIntervals = ArrayUtils.unique(weekdayGroup.timeIntervals.ids)
                            .map(function(virtualId) {
                              virtualIdsToTimeIntervals[virtualId].joinedIndexes = weekdayGroup.timeIntervals.joinedIndexes[virtualId];
                              return virtualIdsToTimeIntervals[virtualId];
                            });
      items.push({
        weekdays: weekdayGroup.weekdays,
        timeIntervals: timeIntervals
      });
    }

    return items;

  };

  var handleTimeIntervalError = function (form) {
    var errorsOpeningTimes = window.config.mealPeriodTimeSettings.errorsOpeningTimes;
    var timeIntervals = form.find('[' + DATA_JOINED_INDEXES + ']');
    errorsOpeningTimes.forEach(function (error) {
      timeIntervals.map(function () {
        var timeInterval = jQuery(this);
        var joinedIndexes = timeInterval.attr(DATA_JOINED_INDEXES).split(',');
        if (jQuery.inArray(error.index, joinedIndexes) != -1) {
          timeInterval.addClass(CSS_HAS_ERROR);
          var errorDisplayed = timeInterval.parent().find('span').hasClass(CSS_HAS_ERROR);
          if(!errorDisplayed){
            timeInterval.parent().append(error.label);
            timeInterval.parent().children().last().addClass(CSS_HAS_ERROR);
          }
        }
      });
    });

  }

  var createItemFromData = function(container, data, itemTemplate, timeIntervalTemplate) {
    var item = itemTemplate.find(SEL_HOURS_ITEM).clone();
    item.find(SEL_INPUT_WEEKDAYS).selectpicker('val', data.weekdays);
    (data.timeIntervals || []).forEach(function(timeInterval) {
      var interval = addNewTimeInterval(item, timeIntervalTemplate, false);
      formTimepicker.setValue(interval.find(SEL_INPUT_START_TIME), timeInterval.startHour, timeInterval.startMinute);
      formTimepicker.setValue(interval.find(SEL_INPUT_END_TIME), timeInterval.endHour, timeInterval.endMinute);
      interval.find(SEL_INPUT_MEAL_SERVICE).selectpicker('val', timeInterval.mealType);
      interval.attr(DATA_JOINED_INDEXES, timeInterval.joinedIndexes);
    });
    updateMealServiceOptions(item);
    item.appendTo(container);
    initialiseItem(item);
  };

  var initialiseItem = function(item) {
    item.find(SEL_INPUT_WEEKDAYS)
      .selectpicker()
      .on('change', function() {
        clearError(jQuery(this));
      });
    item.find(SEL_INPUT_MEAL_SERVICE)
      .selectpicker()
      .on('change', function() {
        clearError(jQuery(this));
      });
    item.find(SEL_INPUT_START_TIME).each(function() {
      formTimepicker.init(jQuery(this));
    });
    item.find(SEL_INPUT_END_TIME).each(function() {
      formTimepicker.init(jQuery(this));
    });

    // to check if the existed time has 00 minutes or not
    var timeIntervalSet = item.find(".timeIntervalSet");
    timeIntervalSet.each(function(){
      var interval = jQuery(this);
      var startTimeMinutes = interval.find(STARTING_TIME_MINUTES).val();
      var endTimeMinutes = interval.find(ENDING_TIME_MINUTES).val();
      initialiseMinutes(interval, startTimeMinutes, STARTING_TIME_MINUTES);
      initialiseMinutes(interval, endTimeMinutes, ENDING_TIME_MINUTES);
    })

  };

  var initialiseMinutes = function(item, minutes, type){
    if(minutes == '00' || minutes == ''){
      item.find(type).val('00');
    }
  }

  var highlightError = function(input) {
    input.parents(SEL_PARENT_FOR_INPUT).addClass(CSS_HAS_ERROR);
  };

  var clearError = function(input) {
    input.parents(SEL_PARENT_FOR_INPUT).removeClass(CSS_HAS_ERROR);
  };

  var isFormValid = function(moduleNode) {
    var errors = [];

    var items = moduleNode.find(SEL_HOURS_CONTAINER).find(SEL_HOURS_ITEM);

    // weekdays
    items.find(SEL_INPUT_WEEKDAYS).each(function() {
      var input = jQuery(this);
      var value = input.selectpicker('val') || [];
      if (!value.length) {
        errors.push(input);
        highlightError(input);
      } else {
        clearError(input);
      }
    });

    // time intervals - starting times
    items.find(SEL_INPUT_START_TIME).each(function() {
      var startingTime = jQuery(this);
      var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(startingTime);
      if (invalidTimepicker.length) {
        invalidTimepicker.forEach(function(timepicker) {
          errors.push(timepicker);
        });
      }
    });

    // time intervals - ending times
    items.find(SEL_INPUT_END_TIME).each(function() {
      var endingTime = jQuery(this);
      var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(endingTime);
      if (invalidTimepicker.length) {
        invalidTimepicker.forEach(function(timepicker) {
          errors.push(timepicker);
        });
      }
    });

    // Meal services
    items.find(SEL_INPUT_MEAL_SERVICE).each(function() {
      var input = jQuery(this);
      var value = input.selectpicker('val') || [];
      if (!value.length) {
        errors.push(input);
        highlightError(input);
      } else {
        clearError(input);
      }
    });

    return !errors.length;
  };

  var addNewItem = function(moduleNode, itemTemplate, timeIntervalTemplate) {
    var container = moduleNode.find(SEL_HOURS_CONTAINER);
    var item = itemTemplate.find(SEL_HOURS_ITEM).clone();
    addNewTimeInterval(item, timeIntervalTemplate, true);
    item.appendTo(container);
    initialiseItem(item);
    return item;
  };

  var removeItem = function(item) {
    item.remove();
  };

  var addNewTimeInterval = function(item, timeIntervalTemplate, validateOptions, initialiseTimepickers) {
    var timeIntervalsContainer = item.find(SEL_TIME_INTERVALS_GROUP);
    var interval = timeIntervalTemplate.find(SEL_TIME_INTERVALS_ITEM).clone();
    interval.appendTo(timeIntervalsContainer);
    
    // initialise time picker
    if (initialiseTimepickers) {
      interval.find(SEL_INPUT_START_TIME).each(function() {
        formTimepicker.init(jQuery(this));
      });
      interval.find(SEL_INPUT_END_TIME).each(function() {
        formTimepicker.init(jQuery(this));
      });
    }
    // Initialize selectpicker
    var mealServiceDropdown = interval.find(SEL_INPUT_MEAL_SERVICE);
    mealServiceDropdown
    .selectpicker()
    .on('change', function() {
        clearError(jQuery(this));
    })
    var selectedServices = selectedMealServices(item);
    if(!validateOptions){
      selectedServices = [];
    }
    
    var availableServices = availableMealServices(selectedServices);
    availableServices.forEach(function(availableService){
      var availableServiceName = MEAL_SERVICES.find(function(item){
        return item.code == availableService;
      }).name;
      mealServiceDropdown.append('<option value=' + availableService + '>' + availableServiceName + '</option>');
    });

    mealServiceDropdown.selectpicker('refresh');
    refreshTimeIntervals(item);
    return interval;
  };

  var removeTimeInterval = function(timeInterval) {
    var item = timeInterval.parents(SEL_HOURS_ITEM);
    timeInterval.remove();
    updateMealServiceOptions(item);
    refreshTimeIntervals(item);
  };

  var refreshTimeIntervals = function(item) {
    var timeIntervals = item.find(SEL_TIME_INTERVALS_ITEM);
    // disable the remove action button in the time interval, if there's only one
    timeIntervals.find(SEL_ACTION_REMOVE_TIME_INTERVAL).prop('disabled', timeIntervals.length < 2);
    // disable the add action button in the time interval, if there are already four
    timeIntervals.find(SEL_ACTION_ADD_TIME_INTERVAL).prop('disabled', timeIntervals.length >= 4);
  };

  var showErrorModal = function(modal, error) {
    alertModal.show(modal, error);
  };

  var addAndSetMinutes = function(inputs){
    inputs.each(function(){
      var item = jQuery(this);
      if(item.val() == '00' || item.val() == ''){
        item.val('00');
      }
    })
  }

  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      MEAL_SERVICES = window.config.mealPeriodTimeSettings.mealTypeOptions ||  [];

      var mainForm = moduleNode.parents(SEL_MAIN_FORM);

      var errorAlertModal = moduleNode.find(SEL_MODAL_ERROR_ALERT);
      var validationErrorMessage = moduleNode.data(DATA_ATTR_VALIDATION_ERROR);

      var deleteConfirmModal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM);
      var deleteConfirmMessage = moduleNode.data(DATA_ATTR_DELETE_CONFIRM);

      var itemTemplate = moduleNode.find(SEL_TEMPLATE_ITEM).remove();
      var timeIntervalTemplate = moduleNode.find(SEL_TEMPLATE_TIME_INTERVAL).remove();

      var initialData = window.config.mealPeriodTimeSettings.form || [];
      
      // we need to create the data just before submitting the form
      mainForm.on('submit', function(event) {
        if (!isFormValid(moduleNode)) {
          showErrorModal(errorAlertModal, validationErrorMessage);
          event.stopImmediatePropagation();
          event.preventDefault();
          return false;
        }
        var data = calculateDataToSubmitFromInput(moduleNode, initialData);
        updateDataForSubmit(moduleNode, data);
      });

      // handle adding and removing items
      moduleNode.on('click', SEL_BUTTON_ADD_ITEM, function() {
        addNewItem(moduleNode, itemTemplate, timeIntervalTemplate);
        jQuery(moduleNode).trigger(EVENT_ON_CHANGE_LIST);
      });

      moduleNode.on('click', SEL_BUTTON_REMOVE_ITEM, function() {
        var button = jQuery(this);
        confirmModal.show(deleteConfirmModal, deleteConfirmMessage)
          .done(function() {
            var item = button.parents(SEL_HOURS_ITEM);
            removeItem(item);
            jQuery(moduleNode).trigger(EVENT_ON_CHANGE_LIST);
          });
      });

      // handle adding and removing time intervals
      moduleNode.on('click', SEL_ACTION_ADD_TIME_INTERVAL, function() {
        var button = jQuery(this);
        var item = button.parents(SEL_HOURS_ITEM);
        var timeIntervals = item.find(SEL_TIME_INTERVALS_ITEM);
        if(timeIntervals.length >= 4){
            return;
        }

        addNewTimeInterval(item, timeIntervalTemplate, true, true);

        // set 00  to new created time slot and check if the existed time has 00 minutes or not
        var startTimeInputs = item.find(STARTING_TIME_MINUTES);
        var endTimeInputs = item.find(ENDING_TIME_MINUTES);

        if(startTimeInputs.length > 0){
          addAndSetMinutes(startTimeInputs);
        }

        if(endTimeInputs.length > 0){
          addAndSetMinutes(endTimeInputs);
        }

      });

      moduleNode.on('click', SEL_ACTION_REMOVE_TIME_INTERVAL, function() {
        var button = jQuery(this);
        var timeInterval = button.parents(SEL_TIME_INTERVALS_ITEM);
        removeTimeInterval(timeInterval);
      });

      moduleNode.on('change', SEL_INPUT_MEAL_SERVICE, function(){
        var mealServiceDropdown = jQuery(this);
        var item = mealServiceDropdown.parents(SEL_HOURS_ITEM);
        updateMealServiceOptions(item);
      })

      // display the inital items
      buildItemsFromInitialData(moduleNode, initialData, itemTemplate, timeIntervalTemplate);
      handleTimeIntervalError(mainForm);
    });
  };
};

// Make class public to outside world
module.exports = MealServiceHours;
},{"../form/FormTimepicker":90,"../modals/Alert":110,"../modals/Confirm":111,"../utils/ArrayUtils":183,"jquery/dist/jquery":14}],146:[function(require,module,exports){
/**
 * ReservationExceptionalHours functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery                  = require('jquery/dist/jquery');
var FormTimepicker      = require('../form/FormTimepicker');
var Alert               = require('../modals/Alert');
var Confirm             = require('../modals/Confirm');
Tracking                = require('../utils/Tracking');


// Class definition
var ReservationExceptionalHours = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                      = '.mod-reservation-exceptional-hours';

  var SEL_MAIN_FORM                   = 'form';

  var SEL_MODAL_ERROR_ALERT           = '.reservationHours-alertModal';
  var SEL_MODAL_DELETE_CONFIRM        = '.reservationHours-deleteConfirmModal';

  var SEL_PARENT_FOR_INPUT            = '.input-parent';
  var SEL_INPUT_DATE_TYPE             = 'select.dateType';
  var SEL_INPUT_DATE_START            = 'input.startDate';
  var SEL_INPUT_DATE_END              = 'input.endDate';
  var SEL_INPUT_DATE_END_INTERNAL     = 'input.endDateInternal';
  var SEL_INPUT_WEEKDAY               = 'select.weekday-field';

  var SEL_BTN_TIME_SETTING_REMOVE     = '.removeTimeSetting';
  var SEL_BTN_TIME_SETTING_ADD        = '.addTimeSetting';

  var SEL_TEMPLATE_TIME_SETTING       = '.reservationExceptionalHoursTimeRowTemplate';
  var SEL_EXCEPTIONAL_HOURS_ITEM      = '.exceptional-item';
  var SEL_EXCEPTIONAL_HOURS_CONTAINER = '.exceptional-hours-container';

  var SEL_DATE_GROUP_END_DATE         = '.date-group.date-group-endDate';
  var SEL_DATE_GROUP_OCCURENCES       = '.date-group.date-group-occurrence';

  var DATA_TIME_SETTING_INDEX         = 'data-row-index';

  var SEL_TEMPLATE_TIME_INTERVAL      = '.reservationHoursTimeIntervalTemplate';
  var SEL_DAY_ROW_CHECKBOX            = '.dayRowCheckbox';

  var SEL_TIME_INTERVAL_SET           = '.timeIntervalSet';
  var SEL_TIME_INTERVAL_ADD_BUTTON    = '.addTimeInterval';
  var SEL_TIME_INTERVAL_DEL_BUTTON    = '.deleteTimeInterval';

  var SEL_ACTIVITY_SELECTOR_INPUT     = '.activitySelector :input';
  var SEL_ACTIVITY_SELECTOR_ACTIVE    = '.activitySelector label.active :input';
  var SEL_TIME_INTERVALS_HOLDER       = '.intervals-holder';

  var SEL_START_TIMEPICKER_WRAP       = '.startingTime';
  var SEL_END_TIMEPICKER_WRAP         = '.endingTime';
  var SEL_HIDDEN_IN_REQUEST           = '.hidden-in-request';

  var DATA_ATTR_START_HOURS           = 'nameStartHours';
  var DATA_ATTR_START_MINS            = 'nameStartMins';
  var DATA_ATTR_END_HOURS             = 'nameEndHours';
  var DATA_ATTR_END_MINS              = 'nameEndMins';
  var DATA_ATTR_IN_REQUEST            = 'nameInRequest';
  var DATA_ATTR_DEFAULT_HOURS         = 'defaultHours';
  var DATA_ATTR_DEFAULT_MINS          = 'defaultMins';

  var DATA_ATTR_VALIDATION_ERROR      = 'validationError';
  var DATA_ATTR_DELETE_CONFIRM        = 'deleteConfirm';

  var ATTR_ROW_INDEX                  = 'data-row-index';
  var ATTR_DATA_INDEX                 = 'data-index';

  
  var RGX_DATA_INDEX_REPLACEMENT      = /%%DATA_INDEX%%/;
  var RGX_ROW_INDEX_REPLACEMENT       = /%%ROW_INDEX%%/;

  var CSS_NO_RESERVATION_HOURS        = 'no-reservation-hours';
  var CSS_BLANK_TIME_INTERVAL         = 'blank-time-interval';
  var CSS_DO_NOT_INIT                 = 'do-not-initialize';
  var CSS_HIDDEN                      = 'hidden';
  var CSS_HAS_ERROR                   = 'has-error';

  var FORM_ERROR_TYPE								  = "form-error";
	var FORM_EVENT_TYPE								  = "error-form";
	var FORM_EVENT_NAME								  = "error";
  var FORM_ERROR_MESSAGE	            = "Your inputs could not be saved,please correct the highlighted errors";

  var formTimepicker = new FormTimepicker();
  var alertModal = new Alert();
  var confirmModal = new Confirm();

  //initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.error = window._adl.error || {};

  var createNewTimeSet = function(template) {
    // get the first timeslot and clone it
    var clone = jQuery(template.html());

    // clear all exsiting values
    var formTimepicker = new FormTimepicker();
    formTimepicker.init(clone);

    // set default values
    var defaultHours = clone.data(DATA_ATTR_DEFAULT_HOURS) || '0';
    var defaultMins = clone.data(DATA_ATTR_DEFAULT_MINS) || '0';
    formTimepicker.setValue(clone.find(SEL_START_TIMEPICKER_WRAP), defaultHours, defaultMins);
    formTimepicker.setValue(clone.find(SEL_END_TIMEPICKER_WRAP), defaultHours, defaultMins);

    return clone;
  };

  var replaceIndexes = function(source, rowIndex, dataIndex) {
    source = source.replace(RGX_ROW_INDEX_REPLACEMENT, rowIndex);
    source = source.replace(RGX_DATA_INDEX_REPLACEMENT, dataIndex);
    return source;
  };

  var cleanUpTimeIntervalSetPaths = function(dayRow) {

    var formTimepicker = new FormTimepicker();

    var timeIntervalSets = dayRow.find(SEL_TIME_INTERVAL_SET).filter(function() {
      return !jQuery(this).hasClass(CSS_BLANK_TIME_INTERVAL);
    });

    var rowIndex = dayRow.attr(ATTR_ROW_INDEX);

    timeIntervalSets.each(function(index) {

      var timeIntervalSet = jQuery(this);

      // clean up paths (form names) for timepickers
      var startHoursPath  = replaceIndexes(timeIntervalSet.data(DATA_ATTR_START_HOURS), rowIndex, index);
      var startMinsPath   = replaceIndexes(timeIntervalSet.data(DATA_ATTR_START_MINS), rowIndex, index);
      var endHoursPath    = replaceIndexes(timeIntervalSet.data(DATA_ATTR_END_HOURS), rowIndex, index);
      var endMinsPath     = replaceIndexes(timeIntervalSet.data(DATA_ATTR_END_MINS), rowIndex, index);
      var inRequestPath   = replaceIndexes(timeIntervalSet.data(DATA_ATTR_IN_REQUEST), rowIndex, index);

      formTimepicker.setPaths(timeIntervalSet.find(SEL_START_TIMEPICKER_WRAP), startHoursPath, startMinsPath);
      formTimepicker.setPaths(timeIntervalSet.find(SEL_END_TIMEPICKER_WRAP), endHoursPath, endMinsPath);

      timeIntervalSet.find(SEL_HIDDEN_IN_REQUEST).attr('name', inRequestPath);
      // reset data-attribute-index
      timeIntervalSet.attr(ATTR_DATA_INDEX, index);

    });

  };

  var cleanUpDayRow = function(dayRow) {

    var timeIntervalSets = dayRow.find(SEL_TIME_INTERVAL_SET).filter(function() {
      return !jQuery(this).hasClass(CSS_BLANK_TIME_INTERVAL);
    });

    timeIntervalSets.removeClass('first').first().addClass('first');

    if (timeIntervalSets.length === 0) {
      dayRow.addClass(CSS_NO_RESERVATION_HOURS);
      dayRow.find(SEL_DAY_ROW_CHECKBOX).prop('checked', false);
    } else {
      dayRow.removeClass(CSS_NO_RESERVATION_HOURS);
      dayRow.find(SEL_DAY_ROW_CHECKBOX).prop('checked', true);
    }

  };

  var initSelectpicker = function(dayRow) {
    dayRow.find(SEL_INPUT_DATE_TYPE).selectpicker();
    dayRow.find(SEL_INPUT_WEEKDAY).selectpicker();
  };

  var deleteTimeInterval = function(deleteButton) {
    var timeIntervalSet = deleteButton.parents(SEL_TIME_INTERVAL_SET);
    var row = timeIntervalSet.parents(SEL_EXCEPTIONAL_HOURS_ITEM);
    timeIntervalSet.remove();
    cleanUpTimeIntervalSetPaths(row);
    cleanUpDayRow(row);
  };

  var addNewTimeInterval = function(row, timeIntervalTemplate) {
    var newSlot = createNewTimeSet(timeIntervalTemplate);
    newSlot.appendTo(row.find(SEL_TIME_INTERVALS_HOLDER));
    cleanUpTimeIntervalSetPaths(row);
    cleanUpDayRow(row);
  };

  /**
   * Handles the switch of fixed date to timeframe as date type.
   */
  var updateActivitySelection = function(radioOption, timeIntervalTemplate) {
    var row            = radioOption.parents(SEL_EXCEPTIONAL_HOURS_ITEM);
    var selectedValue  = row.find(SEL_ACTIVITY_SELECTOR_ACTIVE).val();

    if (selectedValue === 'closed') {
      // remove the time intervals
      row.find(SEL_TIME_INTERVALS_HOLDER).empty().addClass(CSS_HIDDEN);
    } else {
      row.find(SEL_TIME_INTERVALS_HOLDER).removeClass(CSS_HIDDEN);
      addNewTimeInterval(row, timeIntervalTemplate);
    }
  };

  /**
   * Handles the switch of fixed date to timeframe as date type.
   */
  var updateDataType = function(dateTypeInput) {

    var row                         = dateTypeInput.parents(SEL_EXCEPTIONAL_HOURS_ITEM);

    var groupEndDate                = row.find(SEL_DATE_GROUP_END_DATE);
    var groupOccurence              = row.find(SEL_DATE_GROUP_OCCURENCES);

    var dateStartInputNode          = row.find(SEL_INPUT_DATE_START);
    var dateEndInputNode            = row.find(SEL_INPUT_DATE_END);
    var dateEndInternalInputNode    = row.find(SEL_INPUT_DATE_END_INTERNAL);
    var weekdaySelectNode           = row.find(SEL_INPUT_WEEKDAY);

    if (dateTypeInput.val() == 'timeframe') {

      // Show according fields
      groupEndDate.removeClass(CSS_HIDDEN);
      groupOccurence.removeClass(CSS_HIDDEN);

      // Show same as start date in case none was selected before
      if (dateEndInternalInputNode.val() == '') {
        dateEndInputNode.datepicker('setDate', dateStartInputNode.datepicker('getDate'));
      }
    } else {

      // Hide according fields
      groupEndDate.addClass(CSS_HIDDEN);
      groupOccurence.addClass(CSS_HIDDEN);

      // Reset date and weekday fields
      dateEndInputNode.val('');
      dateEndInternalInputNode.val('');
      weekdaySelectNode.selectpicker('val', 0);
    }

  };

  /**
   * Init datepicker
   */
  var initDatepicker = function(moduleNode) {

    var dateFields = moduleNode.find(SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END);

    // Init datepicker
    dateFields.datepicker({
        format: window.config.settingsTimeSettings.dateFormat,
        language: window.config.settingsTimeSettings.calendarLanguageCode,
        weekStart: 1,
        autoclose: true,
        todayHighlight: false
    });

    // Set original datepicker dates for exceptional dates
    dateFields.each(function() {

      var node           = jQuery(this);
      var exceptionDateRowNode  = node.parents('[' + DATA_TIME_SETTING_INDEX + ']');

      var exceptionalDateIndex   = exceptionDateRowNode.attr(DATA_TIME_SETTING_INDEX);
      if (isNaN(exceptionalDateIndex)) {
        return;
      }

      // Get data from data attribute instead of form - since form value is in UTC,
      // but we need to have it converted to establishments' timezone
      var date;
      if (node.is(SEL_INPUT_DATE_START)) {
        date = config.settingsTimeSettings.exceptionalTimeSettings[exceptionalDateIndex].startDate;
      } else {
        date = config.settingsTimeSettings.exceptionalTimeSettings[exceptionalDateIndex].endDate;
      }

      if (date != '') {
        node.datepicker('setDate', date);
      }
    });

    // Track datepicker changes
    moduleNode.on('change', SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END, function() {
      var node       = jQuery(this);
      var internalNode  = node.prev();

      var date = node.datepicker('getUTCDate');
      if (date != undefined) {
        var dateUtils = new DateUtils();
        var dateObj = dateUtils.toDate(date);
        internalNode.val(dateObj.toISOString());
      }
    });
  };

  /**
   * Handles request to remove a time setting.
   */
  var removeTimeSetting = function(moduleNode, removeButton) {
    var timeSettingNode = removeButton.parents(SEL_EXCEPTIONAL_HOURS_ITEM);
    timeSettingNode.remove();
  };

  /**
   * Handles request to add a new time setting.
   */
  var addNewTimeSetting = function(moduleNode) {
    var exceptionalHoursContainer = moduleNode.find(SEL_EXCEPTIONAL_HOURS_CONTAINER);
    var exceptionalTimeSettingNodes  = exceptionalHoursContainer.find(SEL_EXCEPTIONAL_HOURS_ITEM);

    // Collect required index information
    var newTimeSettingIndex     = 0;
    exceptionalTimeSettingNodes.each(function() {
      var nodeIndex = parseInt(jQuery(this).attr(DATA_TIME_SETTING_INDEX));
      if (nodeIndex >= newTimeSettingIndex) {
        newTimeSettingIndex = nodeIndex + 1;
      }
    });

    // Create HTML
    var newTimeSettingHtml = jQuery(SEL_TEMPLATE_TIME_SETTING).html();
    newTimeSettingHtml = newTimeSettingHtml.replace(/{TIME_SETTING_INDEX}/g, newTimeSettingIndex);

    // Create node
    var newTimeSettingNode = jQuery(newTimeSettingHtml);

    // Add node
    exceptionalHoursContainer.append(newTimeSettingNode);

    // Init calendar and dateType selection
    newTimeSettingNode.find(SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END).datepicker({
        format: window.config.settingsTimeSettings.dateFormat,
        language: window.config.settingsTimeSettings.calendarLanguageCode,
        weekStart: 1,
        autoclose: true,
        todayHighlight: false
    });
    newTimeSettingNode.find(SEL_INPUT_DATE_TYPE).trigger('change');

    initSelectpicker(newTimeSettingNode);

  };

  var addNewItemIfEmpty = function(moduleNode) {
    var items = moduleNode.find(SEL_EXCEPTIONAL_HOURS_CONTAINER).find(SEL_EXCEPTIONAL_HOURS_ITEM);
    if (items.length === 0) {
      addNewTimeSetting(moduleNode);
    }
  };

  var showErrorModal = function(modal, error) {
    alertModal.show(modal, error);
  };

  var highlightError = function(input) {
    input.parents(SEL_PARENT_FOR_INPUT).addClass(CSS_HAS_ERROR);
  };

  var clearError = function(input) {
    input.parents(SEL_PARENT_FOR_INPUT).removeClass(CSS_HAS_ERROR);
  };

  var isFormValid = function(moduleNode) {
    var errors = [];

    var items = moduleNode.find(SEL_EXCEPTIONAL_HOURS_CONTAINER).find(SEL_EXCEPTIONAL_HOURS_ITEM);

    //restrain adding different times for a closed day
    var selectedValue = [];
    items.find(SEL_ACTIVITY_SELECTOR_ACTIVE).each(function() {
      var input = jQuery(this);
      var value = input.val() || '';
      selectedValue.push(value);
    });

    items.find(SEL_INPUT_DATE_START).each(function() {
      var activitySelection = [];
      var exitLoop = true;
      var startDate = jQuery(this).val();
      items.find(SEL_INPUT_DATE_START).each(function(index) {
       var input = jQuery(this);
       var value = input.val() || '';
        startDate === value ? activitySelection.push(selectedValue[index]) : '';
        if(activitySelection.length > 1 && activitySelection.includes('closed')){
          errors.push(input);
          highlightError(input);
          exitLoop = false;
          return false;
        }
      });
      return exitLoop;
    });

    // start date
    items.find(SEL_INPUT_DATE_START).each(function() {
      var input = jQuery(this);
      var value = input.val() || '';
      if (value.trim() === '') {
        errors.push(input);
        highlightError(input);
      } else {
        // clearError(input);
      }
    });

    // end date
    items.find(SEL_INPUT_DATE_END).each(function() {
      var input = jQuery(this);
      if (input.is(':visible')) {
        var value = input.val() || '';
        if (value.trim() === '') {
          errors.push(input);
          highlightError(input);
        } else {
          // clearError(input);
        }
      }
    });

    var timeIntervals = items.find(SEL_TIME_INTERVAL_SET);

    // time intervals - starting times
    timeIntervals.find(SEL_START_TIMEPICKER_WRAP).each(function() {
      var startingTime = jQuery(this);
      var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(startingTime);
      if (invalidTimepicker.length) {
        invalidTimepicker.forEach(function(timepicker) {
          errors.push(timepicker);
        });
      }
    });

    // time intervals - ending times
    timeIntervals.find(SEL_END_TIMEPICKER_WRAP).each(function() {
      var endingTime = jQuery(this);
      var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(endingTime);
      if (invalidTimepicker.length) {
        invalidTimepicker.forEach(function(timepicker) {
          errors.push(timepicker);
        });
      }
    });

    return !errors.length;
  };

  var handleTimeIntervalError = function (form) {
    var errorsOpeningTimes = window.config.settingsTimeSettings.errorsOpeningTimes;
    var timeIntervals = form.find(".timeIntervals");
    timeIntervals.each(function(index){
        var item = jQuery(this);
        var time = item.find(".timeIntervalSet");
        var errorMsg = "";
        time.each(function(subIndex){
          var subItem = jQuery(this);
          errorsOpeningTimes.forEach(function(e1){
            var e2 = index+"|"+subIndex;
            if(e1.index == e2){
              subItem.find(".startingTime .input-group.input-group-sm").addClass(CSS_HAS_ERROR);
              subItem.find(".endingTime .input-group.input-group-sm").addClass(CSS_HAS_ERROR);
              errorMsg = e1.label;
            }
          })
        });

        if(errorMsg != ''){
          item.find(".intervals-holder").append(errorMsg).addClass(CSS_HAS_ERROR);
        }
    })
  }

  //to update error tracking in adobe datalayer with event info
  var updateDatalayerErrorTracking = function(errorFields){
    if (window._satellite && window._adl) {
      //push eventInfo in _adl
      _adl.eventInfo = {
        eventName: FORM_EVENT_NAME,
        eventType: FORM_EVENT_TYPE
      }

      //push all the errors in adobe data layer
      _adl.error = {
        errorType: FORM_ERROR_TYPE,
        errorMessage: FORM_ERROR_MESSAGE,
        errorFields: errorFields
      }

      //fire direct call
      window._satellite.track('errorCall');
    }
  }

  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var mainForm = moduleNode.parents(SEL_MAIN_FORM);

      var errorAlertModal = moduleNode.find(SEL_MODAL_ERROR_ALERT);
      var validationErrorMessage = moduleNode.data(DATA_ATTR_VALIDATION_ERROR);

      var deleteConfirmModal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM);
      var deleteConfirmMessage = moduleNode.data(DATA_ATTR_DELETE_CONFIRM);

      var timeIntervalTemplate = moduleNode.find(SEL_TEMPLATE_TIME_INTERVAL).remove();

      // Init datepicker
      initDatepicker(moduleNode);

      // validation
      mainForm.on('submit', function(event) {
        
        if (!isFormValid(moduleNode)) {
          showErrorModal(errorAlertModal, validationErrorMessage);
          
          var errorFields;
          var errorFieldNum = moduleNode.find(".has-error").length;

          if(errorFieldNum === 2){
            errorFields = "startDate | endDate";
          }else if(errorFieldNum === 1){
            var errorFieldName = moduleNode.find('.has-error').find('input[type=text]').attr('class').trim().split(" ")[1];
            errorFields = errorFieldName;
          }

          if(validationErrorMessage !== ""){
            updateDatalayerErrorTracking(errorFields);
          }

          event.stopImmediatePropagation();
          event.preventDefault();
          return false;
        }
      });

      // Init selectpicker
      moduleNode.find(SEL_EXCEPTIONAL_HOURS_ITEM).each(function() {
        initSelectpicker(jQuery(this));
      });

      // Handle datetype change (between fixed date and timeframe)
      moduleNode.on('change', SEL_INPUT_DATE_TYPE, function() {
        updateDataType(jQuery(this));
      });
      moduleNode.find(SEL_INPUT_DATE_TYPE).each(function() {
        updateDataType(jQuery(this));
      });

      // clear errors for date fields
      moduleNode.on('change', SEL_INPUT_DATE_START, function() {
        clearError(jQuery(this));
      });
      moduleNode.on('change', SEL_INPUT_DATE_END, function() {
        clearError(jQuery(this));
      });

      // handle activity selector change
      moduleNode.on('change', SEL_ACTIVITY_SELECTOR_INPUT, function() {
        updateActivitySelection(jQuery(this), timeIntervalTemplate);
      });

      moduleNode.on('click', SEL_BTN_TIME_SETTING_REMOVE, function() {
        var button = jQuery(this);
        confirmModal.show(deleteConfirmModal, deleteConfirmMessage)
          .done(function() {
            removeTimeSetting(moduleNode, button);
          });
      });
      moduleNode.on('click', SEL_BTN_TIME_SETTING_ADD, function() {
        addNewTimeSetting(moduleNode);
      });

      // delete and add time intervals events
      moduleNode.on('click', SEL_TIME_INTERVAL_ADD_BUTTON, function() {
        var row = jQuery(this).parents(SEL_EXCEPTIONAL_HOURS_ITEM);
        addNewTimeInterval(row, timeIntervalTemplate);
      });
      moduleNode.on('click', SEL_TIME_INTERVAL_DEL_BUTTON, function() {
        deleteTimeInterval(jQuery(this));
      });

      handleTimeIntervalError(mainForm);
      addNewItemIfEmpty(moduleNode);

    });

  };

};

// Make class public to outside world
module.exports = ReservationExceptionalHours;

},{"../form/FormTimepicker":90,"../mediator/mediator":103,"../modals/Alert":110,"../modals/Confirm":111,"../utils/Tracking":188,"jquery/dist/jquery":14}],147:[function(require,module,exports){
/**
 * TableSetup functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

var ScrollHelper = require('../itemEditor/ScrollHelper');
var Form = require('./Form');
var List = require('./List');
var HiddenData = require('./HiddenData');

// Class definition
var ReservationHours = function() {

  // selector constants
  var SEL_MODULE                      = '.mod-reservation-hours';

  var SEL_TEMPLATE_ROW                = '.reservationHoursListRowTemplate';
  var SEL_TEMPLATE_DATA_ROW           = '.reservationHoursDataRowTemplate';

  var SEL_FORM                        = '.reservationHours-addEditForm';
  var SEL_LIST                        = '.reservationHours-itemsList';
  var SEL_HIDDEN_DATA                 = '.reservationHours-hiddenData';

  var SEL_DELETE_CONFIRM_MODAL        = '.reservationHours-deleteConfirmModal';
  var SEL_ERROR_ALERT_MODAL           = '.reservationHours-alertModal';

  var CSS_CLASS_INITIALISED           = 'itemEditor-initialised';

  var confirmModal = new Confirm();
  var alertModal = new Alert();

  var handleFormButtonAddClick = function(itemsList, addEditForm, hiddenData, modal) {
    var onSuccess = function() {
      var dataObject = addEditForm.getDataObjectFromValues();
      itemsList.addRow(dataObject, hiddenData);
      hiddenData.resetDataIndexes();
      itemsList.refresh();
      addEditForm.clear();
      ScrollHelper.scrollToElement(itemsList.getNode());
    };
    var onFail = function(errorMessage) {
      alertModal.show(modal, errorMessage);
    };
    addEditForm.validateAndProcess(onSuccess, onFail);
  };

  var handleFormButtonCancelClick = function(itemsList, addEditForm) {
    itemsList.markAllRowsAsNotEditing();
    addEditForm.clear();
  };

  var handleFormButtonSaveClick = function(itemsList, addEditForm, hiddenData, modal) {
    var onSuccess = function() {
      var currentRow = addEditForm.getCurrentEditingRow();
      if (currentRow) {
        var dataObject = addEditForm.getDataObjectFromValues();
        itemsList.updateRow(currentRow, dataObject, hiddenData);
        ScrollHelper.scrollToElement(currentRow);
      }
      hiddenData.resetDataIndexes();
      itemsList.refresh();
      addEditForm.clear();
    };
    var onFail = function(errorMessage) {
      alertModal.show(modal, errorMessage);
    };
    addEditForm.validateAndProcess(onSuccess, onFail);
  };

  var handleListButtonEditClick = function(row, itemsList, addEditForm) {
    itemsList.markAllRowsAsNotEditing();
    itemsList.editRow(row, addEditForm);
    ScrollHelper.scrollToElement(addEditForm.getNode());
  };

  var handleListButtonDeleteClick = function(row, itemsList, addEditForm, hiddenData, modal) {
    var confirmMessage = itemsList.getDeleteConfirmMessage();
    confirmModal.show(modal, confirmMessage).done(function() {
      itemsList.deleteRow(row);
      addEditForm.clear();
      hiddenData.resetDataIndexes();
      itemsList.refresh();
    });
  };

  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var listRowTemplate = moduleNode.find(SEL_TEMPLATE_ROW).remove();
      var dataRowTemplate = moduleNode.find(SEL_TEMPLATE_DATA_ROW).remove();

      var formNode = moduleNode.find(SEL_FORM);
      var listNode = moduleNode.find(SEL_LIST);
      var hiddenDataNode = moduleNode.find(SEL_HIDDEN_DATA);

      var addEditForm = new Form(formNode);
      var hiddenData = new HiddenData(hiddenDataNode, dataRowTemplate);
      var itemsList = new List(listNode, listRowTemplate, hiddenData);

      var deleteConfirmModal = moduleNode.find(SEL_DELETE_CONFIRM_MODAL);
      var errorAlertModal = moduleNode.find(SEL_ERROR_ALERT_MODAL);

      // form events
      formNode.on('itemEditor:editForm:create', function(event) {
        handleFormButtonAddClick(itemsList, addEditForm, hiddenData, errorAlertModal);
      });
      formNode.on('itemEditor:editForm:cancel', function(event) {
        handleFormButtonCancelClick(itemsList, addEditForm);
      });
      formNode.on('itemEditor:editForm:save', function(event) {
        handleFormButtonSaveClick(itemsList, addEditForm, hiddenData, errorAlertModal);
      });

      // list events
      listNode.on('itemEditor:itemsList:rowEdit', function(event, row) {
        handleListButtonEditClick(row, itemsList, addEditForm);
      });
      listNode.on('itemEditor:itemsList:rowDelete', function(event, row) {
        handleListButtonDeleteClick(row, itemsList, addEditForm, hiddenData, deleteConfirmModal);
      });

      // init
      addEditForm.init();
      itemsList.init(hiddenData);

      moduleNode.addClass(CSS_CLASS_INITIALISED);

    });

  };

  // get the module nodes
  this.getModules = function(initNode) {
    return initNode.find(SEL_MODULE);
  };

  // refresh the module
  this.refresh = function(initNode) {

    var moduleNodes = initNode.find(SEL_MODULE);

    moduleNodes.each(function() {
      var listNode = jQuery(this).find(SEL_LIST);
      listNode.trigger('itemEditor:itemsList:forceRefresh');
    });

  };

};

// Make class public to outside world
module.exports = ReservationHours;

},{"../itemEditor/ScrollHelper":99,"./Form":142,"./HiddenData":143,"./List":144,"jquery/dist/jquery":14}],148:[function(require,module,exports){
/**
 * Reservation hours settings page,
 * and Wizard reservation hours settings step functionality.
 */

// External libs
const jQuery = require('jquery/dist/jquery');
const DaysHours = require('../daysHours/DaysHours');

// Class definition
let ReservationHoursAlternative = function () {

  let self;
  const SEL_MODULE= '.mod-reservation-hours-alternative';
  /**
   * Initialize.
   */
  this.init = function (initNode) {
    self = this;
    const moduleNodes = initNode.find(SEL_MODULE);
    moduleNodes.each(function() {
      let daysHours = new DaysHours();
      daysHours.init(jQuery(this), true);
    })
  }
}

// Make class public to the outside world
module.exports = ReservationHoursAlternative;
},{"../daysHours/DaysHours":72,"jquery/dist/jquery":14}],149:[function(require,module,exports){


/**
 * ReservationHours functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
var ReservationHours 			= require('./ReservationHours');
var ReservationHoursAlternative = require('./ReservationHoursAlternative');
var ReservationExceptionalHours = require('./ReservationExceptionalHours');
var MealServiceHours 			= require('./MealServiceHours');
var EditableSummary 			= require('../editableSummary/EditableSummary');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var reservationHours 					= new ReservationHours();
	var reservationHoursAlternative 		= new ReservationHoursAlternative();
	var reservationExceptionalHours 		= new ReservationExceptionalHours();
	var mealServiceHours 					= new MealServiceHours();
	var editableSummary 					= new EditableSummary();

	// Trigger onload activities
	reservationHours.init(initNode);
	reservationHoursAlternative.init(initNode);
	reservationExceptionalHours.init(initNode);
	mealServiceHours.init(initNode);
	editableSummary.init(initNode);

});

},{"../editableSummary/EditableSummary":80,"../mediator/mediator":103,"./MealServiceHours":145,"./ReservationExceptionalHours":146,"./ReservationHours":147,"./ReservationHoursAlternative":148}],150:[function(require,module,exports){
/**
 * TimeSettings functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');


// Class definition
SettingsAccount = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE					= '.mod-settings-account';
	var SEL_USER_DATA_FORM			= '.user-data-form';
	var SEL_CONFIRMATION_MODAL		= '#change-email-modal';
	var SEL_BUTTON_SAVE				= '.btn-save-user-profile';
	var SEL_EMAIL					= '#account-username';

	var CLASS_ACCOUNT_UPDATE_ERROR 	= 'account-update-error';
	var DATA_ATTR_TARGET			= 'data-target';

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;
		// Retrieve and cache dom nodes
		var moduleNodes = initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {
			var node = jQuery(this);
			var form = node.find(SEL_USER_DATA_FORM);
			var btnSave = node.find(SEL_BUTTON_SAVE);
			var emailText = node.find(SEL_EMAIL).val();
			var loginEmail = node.find(SEL_EMAIL);


			//check if the account update error exists or not
			if(window.config.accountUpdateErr){
				loginEmail.addClass(CLASS_ACCOUNT_UPDATE_ERROR)
			} else{
				loginEmail.hasClass(CLASS_ACCOUNT_UPDATE_ERROR) ? loginEmail.removeClass(CLASS_ACCOUNT_UPDATE_ERROR) : '';
			}

			form.on('submit', function () {
				emailText = node.find(SEL_EMAIL).val();
			});

			btnSave.on('click', function(e) {
				// if account update error message exists, display the password popup in next attempt
				var isAccountUpdateErr = loginEmail.hasClass(CLASS_ACCOUNT_UPDATE_ERROR) ? true : false;
				if (emailText != form.find(SEL_EMAIL).val() || isAccountUpdateErr) {
					jQuery(this).attr(DATA_ATTR_TARGET, SEL_CONFIRMATION_MODAL);
				} else {
					jQuery(this).removeAttr(DATA_ATTR_TARGET);
					form.submit();
				}
			});
		});
	};
};

// Make class public to outside world
module.exports = SettingsAccount;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],151:[function(require,module,exports){
/**
 * SettingsReservations functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');
Tracking       = require('../utils/Tracking');

// External libs
jQuery = require('jquery/dist/jquery');
var FormTimepicker      = require('../form/FormTimepicker');
UserInterfaceUtils 		= require('../utils/UserInterfaceUtils');
var Alert               = require('../modals/Alert');
var ArrayUtils 			= require('../utils/ArrayUtils');
Notification 			= require('../notification/Notification');

// Class definition
SettingsReservations = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE							= '.mod-settings-reservation';

	var SEL_MAIN_FORM                   	= "#reservationConfigForm";
	var SEL_DATA_CONTAINER              	= '.data-container';
	var DATA_ATTR_PATH                  	= 'path';

	var SEL_MODAL_ERROR_ALERT           	= '.reservationHours-alertModal';

	var SEL_BOOKING_LIMIT					= ".booking-limit-container";

	var SEL_HOURS_CONTAINER             	= '.reservation-hours-container';
	var SEL_HOURS_ITEM                  	= '.reservation-hours-item';
	var SEL_PARENT_FOR_INPUT          	    = '.input-parent';
	var SEL_INPUT_WEEKDAYS            	    = 'select.weekdays-input';

	var SEL_INPUT_START_TIME            	= '.startingTime';
	var SEL_INPUT_END_TIME              	= '.endingTime';
	var SEL_GUEST_LIMIT_INPUT_CONTAINER		= ".guest-limit-container";
	var SEL_GUEST_LIMIT_INPUT				= '.guests';

	var SEL_TIME_INTERVALS_GROUP        	= '.time-intervals-group';
	var SEL_TIME_INTERVALS_ITEM         	= '.timeIntervalSet';

	var SEL_ACTION_BOOK_LIMIT    			= '.addBookingLimit';
	var SEL_ACTION_REMOVE_TIME_INTERVAL 	= '.deleteTimeInterval';

	var SEL_TEMPLATE_ITEM               	= '.reservationHoursTimeRowTemplate';
	var SEL_TEMPLATE_TIME_INTERVAL      	= '.reservationHoursTimeIntervalTemplate';

	var SEL_ADDITIONAL_INFO_GUEST 			= '#reservation-additionalInformationForGuests';
	
	var DATA_ATTR_VALIDATION_ERROR      	= 'validationError';

	var SEL_CHANNEL_PANEL					= '.channel-panel';
	var SEL_CHANNEL_SWITCH					= '.channel-toggle .switch-input';

	var SEL_HYDRA_WIDGET_CARD				= '.hydra-widget-card';
	var SEL_HYDRA_WIDGET_INPUT				= '.hydra-widget-input';
	var SEL_HYDRA_WIDGET_ACTION_BUTTON		= '.hydra-widget-action-button';
	var SEL_HYDRA_ACTIVATION_CARDS			= '.hydra-add-card, .hydra-remove-card';
	var CLASS_WIDGET_ADD_CARD				= 'hydra-add-card';
	var SEL_HANDLE_WIDGET_ACTIVE			= '#reservation-widgetActive';
	var SEL_RES_MAX_CAPACITY				= "#reservation-reservationMaxCapacity";
	var SEL_RES_MIN_CAPACITY				= "#reservation-reservationMinCapacity";
	var SEL_FORM_GROUP						= ".form-group";
	var SEL_HELP_BLOCK						= ".help-block";

	var SEL_FACEBOOK_MODAL 					= "#facebookModal";
	var SEL_FACEBOOK_ACTIVATE_BTN 			= ".activate-now-btn";
	var SEL_FACEBOOK_POPUP_ACTIVATE_BTN 	= ".btn-activate-now";
	let SEL_ATTR_PANEL_ID			        = 'facebook-instagram-toggle';
	var SEL_INSTAGRAM_SETUP_MODAL			= "#instagramModal";
	var SEL_INSTAGRAM_ACTIVATE_BTN 			= ".instagram-activate-btn";

	var SEL_GUEST_DURATION_SELECTPICKER 	= "#reservation-guestDurationSettingsEnabled";
	var SEL_MIN_MAX_GUEST_DURATION_BLOCK 	= ".minMaxGuestDuration";
	var SEL_MIN_GUEST_DURATION_DROPDOWN     = "#reservation-reservationMinGuestDuration";
	var SEL_MAX_GUEST_DURATION_DROPDOWN     = "#reservation-reservationMaxGuestDuration";
	var SEL_RESREVATION_DURATION			= "#reservation-reservationDuration";

	var CSS_CHANNEL_DISABLED				= 'channel-disabled';
	var CSS_HAS_PENDING_CHANGES				= 'has-pending-changes';
	var CSS_HAS_ERROR                   	= 'has-error';
	var CSS_HAS_DROPDOWN_ERROR 				= "border-error";
	var DATA_JOINED_INDEXES             	= 'data-joined-indexes';
	var SCROLL_TO_ELEMENT_OFFSET			= 15; // 15 pixels => default spacing
	
	var ATTR_DATA_NAME						= 'data-name';

	var SEL_ONLINE_WIDGET_TOGGLE			= "input#reservation-widgetActive";
	var SEL_GOOGLE_WIDGET_TOGGLE			= "input#reservation-googleActive";

	var formTimepicker 						= new FormTimepicker();
	var alertModal 							= new Alert();
	var confirmModal 						= new Confirm();
	
	var EVENT_ON_CHANGE_LIST 				= 'reservationHours:wizard:listRefreshed';
	var SEL_BUTTON_REMOVE_ITEM 				= '.removeTimeSetting';
	var SEL_MODAL_DELETE_CONFIRM 			= '.reservationHours-deleteConfirmModal';
	var DATA_ATTR_DELETE_CONFIRM 			= 'deleteConfirm';
	var SEL_ACTION_ADD_TIME_INTERVAL 		= '.addTimeInterval';

	var STARTING_TIME_MINUTES           = ".startingTime .timepicker-inner input[type=text]:last-child";
	var ENDING_TIME_MINUTES             = ".endingTime .timepicker-inner input[type=text]:last-child";

	var SEL_INPUT_MEAL_SERVICE			= ".meal-service-select";
	var SEL_MEAL_CONTAINER 				= ".meal-data-container";

	var FORM_ERROR_TYPE					= "form-error";
	var FORM_EVENT_TYPE					= "error-form";
	var FORM_EVENT_NAME					= "error";
	var FORM_ERROR_FIELD_NAME			= "Booking Limit";
	var FORM_EVENT_ACTION_NAME 			= "Add reservation preferences";
	var FORM_CLICK_EVENT_NAME			= "save";
	var FORM_CLICK_EVENT_TYPE			= "click";
	var FORM_ERROR_MESSAGE	 			= "Your inputs could not be saved,please correct the highlighted errors";

	//initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.selection = window._adl.selection || [];
	window._adl.error = window._adl.error || {};

	var initChannelPanels = function(moduleNode) {

		moduleNode.find(SEL_CHANNEL_PANEL).each(function() {

			var panel = jQuery(this);
			var toggleSwitch = panel.find(SEL_CHANNEL_SWITCH);

			var updateChannelSelected = function() {
				if (toggleSwitch.is(':checked')) {
					panel.removeClass(CSS_CHANNEL_DISABLED);
				} else {
					let panelId = panel.attr('id');
					if (panelId === SEL_ATTR_PANEL_ID) {
						panel.removeClass(CSS_CHANNEL_DISABLED);
					}
					else {
						panel.addClass(CSS_CHANNEL_DISABLED);
					}
				}
			};

			toggleSwitch.on('change', updateChannelSelected);
			updateChannelSelected();
		});
	};

	var actualizeHydraWidgetCards = function(moduleNode, isInit) {

		moduleNode.find(SEL_HYDRA_WIDGET_CARD).each(function() {

			var card = jQuery(this);

			var updateInputName = function() {
				var input = card.find(SEL_HYDRA_WIDGET_INPUT);
				var name = input.attr(ATTR_DATA_NAME) || '';
				input.attr('name', name);
			};

			card.find(SEL_HYDRA_WIDGET_ACTION_BUTTON).on('click', function() {
				updateInputName();
				card.addClass(CSS_HAS_PENDING_CHANGES);
			});

			if (!isInit) {
				var input = card.find(SEL_HYDRA_WIDGET_INPUT);
				input.removeAttr('name');
				card.removeClass(CSS_HAS_PENDING_CHANGES);
			}

		});

	};

	var addInput = function(container, name, value) {
		return jQuery('<input />')
			.attr('type', 'hidden')
			.attr('name', name)
			.attr('value', value || '')
			.appendTo(container);
	};

	var buildPath = function (path, index, name) {
		return path + '[' + index + '].' + name;
	};
	
	var buildIntervalPath = function(path, index, subIndex, name) {
		return path + '[' + index + '].bookingLimitsData[' + subIndex + '].' + name;
	};

	var createItemForSubmit = function (container, path, data, index) {
		addInput(container, buildPath(path, index, 'inRequest'), 'true');
		addInput(container, buildPath(path, index, 'weekday'), data.weekday);

		var bookingLimitData = data.bookingLimitsData || [];
		bookingLimitData.forEach(function (bookingLimit, i) {
			addInput(container, buildIntervalPath(path, index, i, 'id'), data.id || '0');
			addInput(container, buildIntervalPath(path, index, i, 'inRequest'), 'true');
			addInput(container, buildIntervalPath(path, index, i, 'startHour'), bookingLimit.startHour);
			addInput(container, buildIntervalPath(path, index, i, 'startMinute'), bookingLimit.startMinute);
			addInput(container, buildIntervalPath(path, index, i, 'endHour'), bookingLimit.endHour);
			addInput(container, buildIntervalPath(path, index, i, 'endMinute'), bookingLimit.endMinute);
			addInput(container, buildIntervalPath(path, index, i, 'guests'), bookingLimit.guests);
		});
	};

	/**
	 * @description create hidden input fields for all meal types
	 */
	var createMealServiceForSubmit = function(container, path, data, index){
		addInput(container, buildPath(path, index, 'id'), data.id || '0');
		addInput(container, buildPath(path, index, 'mealType'), data.mealType);
		addInput(container, buildPath(path, index, 'mealTypeDuration'), data.mealTypeDuration);
	}

	var findWeekday = function(list, weekday) {
		var results = jQuery.grep(list, function(item) { return item.weekday == weekday; });
		if (results.length) {
		  return results[0];
		}
		return null;
	};
	
	var getWeekdayRow = function(newData, previousData, weekday) {
		// check new data
		var result = findWeekday(newData, weekday);
		if (result) {
		  // use the same instance
		  return result;
		}
		// check previous data
		result = findWeekday(previousData, weekday);
		var newRow;
		if (result) {
		  // get new instance
		  newRow = {
			weekday: weekday,
			  bookingLimitsData: (result.bookingLimitsData || []).slice() // clone the time intervals
		  };
		} else {
		  // completely new weekday, then create one
		  newRow = {
			weekday: weekday,
			  bookingLimitsData: []
		  };
		}
		// add to new data
		newData.push(newRow);
		return newRow;
	};
	
	var getTimeIntervalsFromGroup = function(group) {
		var bookingLimitsData = [];
		group.find(SEL_TIME_INTERVALS_ITEM).each(function() {
		  var item = jQuery(this);
		  var startTime = formTimepicker.getValue(item.find(SEL_INPUT_START_TIME));
		  var endTime = formTimepicker.getValue(item.find(SEL_INPUT_END_TIME));
		  var guests = item.find(SEL_GUEST_LIMIT_INPUT).val();
			bookingLimitsData.push({
			startHour: startTime.hours,
			startMinute: startTime.mins,
			endHour: endTime.hours,
			endMinute: endTime.mins,
			guests: guests
		  });
		});
		return bookingLimitsData;
	};

	var initialiseItem = function (item) {
		item.find(SEL_INPUT_WEEKDAYS)
     	 	.selectpicker()
     	 	.on('change', function() {
        	clearError(jQuery(this));
      	});

		item.find(SEL_INPUT_START_TIME).each(function() {
			formTimepicker.init(jQuery(this));
		});
		item.find(SEL_INPUT_END_TIME).each(function() {
			formTimepicker.init(jQuery(this));
		});
	};

	var highlightError = function(input) {
		input.parents(SEL_PARENT_FOR_INPUT).addClass(CSS_HAS_ERROR);
		input.closest(SEL_GUEST_LIMIT_INPUT_CONTAINER).addClass(CSS_HAS_ERROR);
	};
	
	var clearError = function(input) {
		input.parents(SEL_PARENT_FOR_INPUT).removeClass(CSS_HAS_ERROR);
		input.closest(SEL_GUEST_LIMIT_INPUT_CONTAINER).removeClass(CSS_HAS_ERROR);
	};

	var isFormValid = function (moduleNode) {
		var errors = [];
		var items = moduleNode.find(SEL_HOURS_CONTAINER).find(SEL_HOURS_ITEM);

		// weekdays
		items.find(SEL_INPUT_WEEKDAYS).each(function () {
			var input = jQuery(this);
			var value = input.selectpicker('val') || [];
			if (!value.length) {
				errors.push(input);
				highlightError(input);
			} else {
				clearError(input);
			}
		});

		// time intervals - starting times
		items.find(SEL_INPUT_START_TIME).each(function() {
			var startingTime = jQuery(this);
			var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(startingTime);
			if (invalidTimepicker.length) {
				invalidTimepicker.forEach(function(timepicker) {
				errors.push(timepicker);
				});
			}
		});
	
		// time intervals - ending times
		items.find(SEL_INPUT_END_TIME).each(function() {
			var endingTime = jQuery(this);
			var invalidTimepicker = formTimepicker.validateAndGetEmptyTimepickers(endingTime);
			if (invalidTimepicker.length) {
				invalidTimepicker.forEach(function(timepicker) {
				errors.push(timepicker);
				});
			}
		});

		// time intervals - guests
		items.find(SEL_GUEST_LIMIT_INPUT).each(function() {
			var input = jQuery(this);
			if (input.val() == "") {
			  errors.push(input);
			  highlightError(input);
			} else {
			  clearError(input);
			}
		});

		// Minimum group size < maximum group size
		var maximumSelect = moduleNode.find(SEL_RES_MAX_CAPACITY);
		var minimumSelect = moduleNode.find(SEL_RES_MIN_CAPACITY);
		var maximumSelectValue = parseInt(maximumSelect.selectpicker("val"));
		var minimumSelectValue = parseInt(minimumSelect.selectpicker("val"));
		var isMinValueInvalid = minimumSelectValue > maximumSelectValue;
		var selectParent = minimumSelect.closest(SEL_FORM_GROUP);
		selectParent.toggleClass(CSS_HAS_ERROR, isMinValueInvalid);
		selectParent.find(SEL_HELP_BLOCK).text('');
		var validationErrorMessage = window.config && window.config.min && window.config.min.validationMessage ? window.config.min.validationMessage : "";
		if(isMinValueInvalid){
			selectParent.find(SEL_HELP_BLOCK).text(validationErrorMessage);
			errors.push(minimumSelect);
		}
	
		return !errors.length;
	};
	
	var addNewItem = function(moduleNode, itemTemplate, timeIntervalTemplate) {
		var container = moduleNode.find(SEL_HOURS_CONTAINER);
		var item = itemTemplate.find(SEL_HOURS_ITEM).clone();
		addNewTimeInterval(item, timeIntervalTemplate, true);
		item.appendTo(container);
		item.find(SEL_INPUT_WEEKDAYS)
     	 	.selectpicker()
     	 	.on('change', function() {
        	clearError(jQuery(this));
      	});
		
		return item;
	};

	var removeItem = function(item) {
		item.remove();
	};
	
	var addNewTimeInterval = function (item, timeIntervalTemplate, initialiseTimepickers) {
		var timeIntervalsContainer = item.find(SEL_TIME_INTERVALS_GROUP);
		var interval = timeIntervalTemplate.find(SEL_TIME_INTERVALS_ITEM).clone();
		// Guests input field will only accept integers
		interval.find(SEL_GUEST_LIMIT_INPUT).on('input', function(e) { 
			jQuery(this).val(jQuery(this).val().replace(/[^0-9]/g, ''));			
		}); 

		interval.appendTo(timeIntervalsContainer);
		// initialise time picker
		if (initialiseTimepickers) {
			interval.find(SEL_INPUT_START_TIME).each(function() {
				formTimepicker.init(jQuery(this));
			});
			interval.find(SEL_INPUT_END_TIME).each(function() {
				formTimepicker.init(jQuery(this));
			});
		}

		// to check if the existed time has 00 minutes or not
		var timeIntervalSet = item.find(".timeIntervalSet");
		timeIntervalSet.each(function(){
		  var interval = jQuery(this);
		  var startTimeMinutes = interval.find(STARTING_TIME_MINUTES).val();
		  var endTimeMinutes = interval.find(ENDING_TIME_MINUTES).val();
		  initialiseMinutes(interval, startTimeMinutes, STARTING_TIME_MINUTES);
		  initialiseMinutes(interval, endTimeMinutes, ENDING_TIME_MINUTES);
		});

		refreshTimeIntervals(item);
		return interval;
	};

	var initialiseMinutes = function(item, minutes, type){
		if(minutes == '00' || minutes == ''){
		  item.find(type).val('00');
		}
	}
	
	var removeTimeInterval = function(timeInterval) {
		var item = timeInterval.parents(SEL_HOURS_ITEM);
		timeInterval.remove();
		refreshTimeIntervals(item);
	};

	var refreshTimeIntervals = function (item) {
		var timeIntervals = item.find(SEL_TIME_INTERVALS_ITEM);
		// disable the remove action button in the time interval, if there's only one
		timeIntervals.find(SEL_ACTION_REMOVE_TIME_INTERVAL).prop('disabled', timeIntervals.length < 2);
		// disable the add action button in the time interval, if there are already four
		timeIntervals.find(SEL_ACTION_ADD_TIME_INTERVAL).prop('disabled', timeIntervals.length >= 4);
	};
	
	var showErrorModal = function (modal, error) {
		alertModal.show(modal, error);
	};

	var removeItem = function (item) {
		item.remove();
	};

	// try to reuse existing data rows,
	// because they are already in database and we only want to do updates to
	// a minimal of them (not to delete/create)
	var calculateDataToSubmitFromInput = function (moduleNode, initialData) {
		var data = [];
		var items = moduleNode.find(SEL_HOURS_CONTAINER).find(SEL_HOURS_ITEM);
		
		items.each(function () {
			var item = jQuery(this);
			var weekdays = item.find(SEL_INPUT_WEEKDAYS).selectpicker('val');
			var timeIntervals = getTimeIntervalsFromGroup(item.find(SEL_TIME_INTERVALS_GROUP));

			(weekdays || []).forEach(function (weekday) {
				var weekdayRow = getWeekdayRow(data, initialData, weekday);

				// lets add all the new ones to a new property,
				// which we will use for syncing old database ids
				weekdayRow.newbookingLimitsData = weekdayRow.newbookingLimitsData || [];
				timeIntervals.forEach(function (timeInterval) {
					// add a clone of the time intervals
					weekdayRow.newbookingLimitsData.push({
						startHour: timeInterval.startHour,
						startMinute: timeInterval.startMinute,
						endHour: timeInterval.endHour,
						endMinute: timeInterval.endMinute,
						guests: timeInterval.guests
					});
				});
			});
		});

		// clean up the time intervals for each weekday now
		data.forEach(function (weekdayRow) {
			var bookingLimitsData = [];
			var oldbookingLimitsData = weekdayRow.bookingLimitsData;
			weekdayRow.newbookingLimitsData.forEach(function (timeIntervalData) {
				addTimeIntervalToList(bookingLimitsData, oldbookingLimitsData, timeIntervalData);
			});
			// replace time intervals
			weekdayRow.bookingLimitsData = bookingLimitsData;
			// remove old unsynced time intervals
			delete weekdayRow.newbookingLimitsData;
		});

		// we need to clear any existing weekdays, that are no longer covered.
		// we will add these days to the data, but clear the time intervals
		initialData.forEach(function (weekdayRow) {
			if (!findWeekday(data, weekdayRow.weekday)) {
				data.push({
					weekday: weekdayRow.weekday,
					bookingLimitsData: [] //clear the time intervals
				});
			}
		});
		return data;
	};

	var isTimeIntervalEqual = function(item1, item2) {
		return item1.startHour == item2.startHour &&
			item1.startMinute == item2.startMinute &&
			item1.endHour == item2.endHour &&
			item1.endMinute == item2.endMinute;
	};

	var addTimeIntervalToList = function (newList, previousList, data) {
		// check new data
		var results = jQuery.grep(newList, function (item) {
			return isTimeIntervalEqual(item, data);
		});
		if (results.length) {
			// item exists, so no need to create duplicates
			return;
		}
		// use an old item (and remove it from the previous list)
		var row = previousList.pop();
		// no item in old list? then let's create a new one
		if (!row) {
			row = {
				id: 0
			};
		}

		// replace values
		row.startHour = data.startHour;
		row.startMinute = data.startMinute;
		row.endHour = data.endHour;
		row.endMinute = data.endMinute;
		row.guests = data.guests;

		// add to new data
		newList.push(row);
	};

	
	var updateDataForSubmit = function (moduleNode, data) {
		var container = moduleNode.find(SEL_DATA_CONTAINER);
		var path = container.data(DATA_ATTR_PATH);

		// remove any previous errors
		container.empty();

		// convert data to inputs
		(data || []).forEach(function (timeSetting, index) {
			createItemForSubmit(container, path, timeSetting, index);
		});
	};

	/**
	 * @description get the latest selected data during form submission
	 */
	var buildMealServiceData = function(moduleNode){
		var mealServiceSelect = moduleNode.find(SEL_INPUT_MEAL_SERVICE);
		var mealServiceData = [];
		mealServiceSelect.each(function(){
			var mealServiceDropdown = jQuery(this);
            var mealServiceType = mealServiceDropdown.attr("id");
            if(mealServiceType){
				mealServiceData.push({
					mealType: mealServiceType,
					mealTypeDuration: mealServiceDropdown.find("option:selected").val()
				});
            }
		});

		return mealServiceData;
	}

	/**
	 * @description get the latest selected meal services and render it for each meal type
	 */
	var updateMealServiceData = function(moduleNode, initialData){
		var data = buildMealServiceData(moduleNode);
		var container = moduleNode.find(SEL_MEAL_CONTAINER);
		var path = container.data(DATA_ATTR_PATH);

		// remove any previous errors
		container.empty();
		
		// convert data to inputs
		(data || []).forEach(function (mealService, index) {
			createMealServiceForSubmit(container, path, mealService, index);
		});
	}

	var buildItemsFromInitialData = function (moduleNode, initialData, itemTemplate, timeIntervalTemplate) {
		var container = moduleNode.find(SEL_HOURS_CONTAINER).empty();
		var itemData = getItemDataFromInitialData(initialData);

		// Removing days which is having 0 intervals
		itemData.forEach(function (item, index, object) {
			(item.bookingLimitsData || []).forEach(function (timeInterval) {
				if (timeInterval.startHour === 0 && timeInterval.endHour === 0) {
					object.splice(index, 1);
				}
			});
		});

		var newitemData = itemData;
		newitemData.forEach(function (item) {
			createItemFromData(container, item, itemTemplate, timeIntervalTemplate);
		});
	};

	var buildVirtualId = function(timeInterval) {
		return [
		  timeInterval.startHour,
		  timeInterval.startMinute,
		  timeInterval.endHour,
		  timeInterval.endMinute,
		  timeInterval.guests
		].join(':');
	};
	

	var getItemDataFromInitialData = function (initialData) {
		var timeIntervalsToWeekdays = {};
		var virtualIdsToTimeIntervals = {};
		var weekdaysToTimeIntervals = {};
		// group weekdays by time intervals
		initialData.forEach(function (weekdayRow) {
			(weekdayRow.bookingLimitsData || []).forEach(function (timeInterval, indexTimeinterval) {
				timeInterval.virtualId = buildVirtualId(timeInterval);
				virtualIdsToTimeIntervals[timeInterval.virtualId] = timeInterval;
				if (!(timeInterval.virtualId in timeIntervalsToWeekdays)) {
					timeIntervalsToWeekdays[timeInterval.virtualId] = {
						days: [],
						joinedIndexes: []
					};;
				}
				timeIntervalsToWeekdays[timeInterval.virtualId].days.push(weekdayRow.weekday);

				timeIntervalsToWeekdays[timeInterval.virtualId].joinedIndexes.push((weekdayRow.weekday - 1) + '|' + indexTimeinterval);
			});
		});

		// now check for time interval groups
		for (var virtualId in timeIntervalsToWeekdays) {
			var weekdays = timeIntervalsToWeekdays[virtualId].days;
			var weekdaysId = weekdays.sort().join(':');
			if (!(weekdaysId in weekdaysToTimeIntervals)) {
				weekdaysToTimeIntervals[weekdaysId] = {
					weekdays: weekdays,
					bookingLimitsData: {
						ids: [],
						joinedIndexes: {}
					}
				};
			}

			weekdaysToTimeIntervals[weekdaysId].bookingLimitsData.ids.push(virtualId);
			weekdaysToTimeIntervals[weekdaysId].bookingLimitsData.joinedIndexes[virtualId] = timeIntervalsToWeekdays[virtualId].joinedIndexes;
		}

		var items = [];
		for (var weekdaysId in weekdaysToTimeIntervals) {
			var weekdayGroup = weekdaysToTimeIntervals[weekdaysId];
			var timeIntervals = ArrayUtils.unique(weekdayGroup.bookingLimitsData.ids)
				.map(function (virtualId) {
					virtualIdsToTimeIntervals[virtualId].joinedIndexes = weekdayGroup.bookingLimitsData.joinedIndexes[virtualId];
					return virtualIdsToTimeIntervals[virtualId];
				});
			items.push({
				weekdays: weekdayGroup.weekdays,
				bookingLimitsData: timeIntervals
			});
		}

		return items;
	};

	var handleTimeIntervalError = function (form) {
		var errorsOpeningTimes = window.config.bookingLimitSection.errorsOpeningTimes;
		var timeIntervals = form.find('[' + DATA_JOINED_INDEXES + ']');
		errorsOpeningTimes.forEach(function (error) {
			timeIntervals.map(function () {
				var timeInterval = jQuery(this);
				var joinedIndexes = timeInterval.attr(DATA_JOINED_INDEXES).split(',');
				if (jQuery.inArray(error.index, joinedIndexes) != -1) {
					timeInterval.addClass(CSS_HAS_ERROR);
					var errorDisplayed = timeInterval.parent().find('span').hasClass(CSS_HAS_ERROR);
					if(!errorDisplayed){
						var errLabel = "<span>"+error.label.split(">")[1].split("reservationConfigForm")[0]+"</span>";
						timeInterval.parent().append(errLabel);
						timeInterval.parent().children().last().addClass(CSS_HAS_ERROR);
					}
				}
			});
		});
	}


	var createItemFromData = function (container, data, itemTemplate, timeIntervalTemplate) {
		var item = itemTemplate.find(SEL_HOURS_ITEM).clone();
		item.find(SEL_INPUT_WEEKDAYS).selectpicker('val', data.weekdays);
		(data.bookingLimitsData || []).forEach(function (timeInterval) {
			var interval = addNewTimeInterval(item, timeIntervalTemplate, false);
			formTimepicker.setValue(interval.find(SEL_INPUT_START_TIME), timeInterval.startHour, timeInterval.startMinute);
			formTimepicker.setValue(interval.find(SEL_INPUT_END_TIME), timeInterval.endHour, timeInterval.endMinute);
			interval.find(SEL_GUEST_LIMIT_INPUT).val(timeInterval.guests);
			interval.attr(DATA_JOINED_INDEXES, timeInterval.joinedIndexes);
		});

		item.appendTo(container);
		initialiseItem(item);
	};

	/**
	 * @description display and render the meal services and display the latest selected value
	 */
	var displayMealServices = function(moduleNode, mealServices){
		var mealServiceSelect = moduleNode.find(SEL_INPUT_MEAL_SERVICE);
		mealServiceSelect.each(function(){
			var mealServiceDropdown = jQuery(this);
			mealServices.forEach(function(meal){
				if(meal.mealType == mealServiceDropdown.attr("id")){
					var mealDuration = mealServiceDropdown.find("option");
					mealDuration.each(function(){
						var duration = jQuery(this);
						if(duration.val() == meal.mealTypeDuration){
							duration.attr("selected", true);
						}
					})
				}
			})
		});

		mealServiceSelect.selectpicker('refresh');
	}

	var getSelectedOnlineReservationValue = function(moduleNode){
		var isWidgetActive = moduleNode.find(SEL_ONLINE_WIDGET_TOGGLE).prop("checked");
		var isGoogleActive = moduleNode.find(SEL_GOOGLE_WIDGET_TOGGLE).prop("checked");
		var selectedOption;

		if(isWidgetActive && isGoogleActive){
			selectedOption = "Online Widget | Reserve with Google";
		}else if(isWidgetActive){
			selectedOption = "Online Widget";
		}else if(isGoogleActive){
			selectedOption = "Reserve with Google";
		}else{
			selectedOption = "";
		}

		return selectedOption;
	}

	var updateDatalayerWithSelectedInfo = function(moduleNode){
		
		var selectedOption = getSelectedOnlineReservationValue(moduleNode);

		if (window._satellite && window._adl) {
			//push eventInfo in _adl
			_adl.eventInfo = {
				eventName: FORM_CLICK_EVENT_NAME,
				eventType: FORM_CLICK_EVENT_TYPE,
				eventAction: FORM_EVENT_ACTION_NAME
			}
			
			if(selectedOption !== ""){
				_adl.selection = [];
				//push all the selections in adobe data layer
				_adl.selection.push({'selectedOption1': selectedOption});
			}
	
			//fire direct call
			window._satellite.track('trackButtonClick');
		}
	}

	var getLocalStorageData = function(moduleNode){
		var ADVTrack = localStorage.getItem('ADVTrack');
		if(ADVTrack){
			//set eventInfo and selection details on data layer “_adl”
			updateAdobeDataLayer(moduleNode);
			localStorage.removeItem('ADVTrack');
		}
	}

	var updateAdobeDataLayer = function(moduleNode){
		var selectedOption = getSelectedOnlineReservationValue(moduleNode);

		if (window._adl) {
			//push eventInfo in _adl
			_adl.eventInfo = {
				eventName: FORM_CLICK_EVENT_NAME,
				eventType: FORM_CLICK_EVENT_TYPE,
				eventAction: FORM_EVENT_ACTION_NAME
			}
			
			if(selectedOption !== ""){
				_adl.selection = [];
				//push all the selections in adobe data layer
				_adl.selection.push({'selectedOption1': selectedOption});
			}
		}
	}

	//to update error tracking in adobe datalayer with event info
	var updateDatalayerErrorTracking = function(){
		if (window._satellite && window._adl) {
		  //push eventInfo in _adl
		  _adl.eventInfo = {
			eventName: FORM_EVENT_NAME,
			eventType: FORM_EVENT_TYPE
		  }
	
		  //push all the errors in adobe data layer
		  _adl.error = {
			errorType: FORM_ERROR_TYPE,
			errorMessage: FORM_ERROR_MESSAGE,
			errorFields: FORM_ERROR_FIELD_NAME
		  }

		  _adl.selection = [];
	
		  //fire direct call
		  window._satellite.track('errorCall');
		}
	}

	//on the basis of selectedOption of guest duration dropdown, hide or show the min/max duration block
	var hideShowMinMaxGuestDuration = function(option, minMaxGuestDurationBlock){
		var selectedOption = selectedOptionInGuestDuration(option);
		selectedOption == "true" ? minMaxGuestDurationBlock.show() : minMaxGuestDurationBlock.hide();
	}

	//check the selected option from the guest duration dropdown and return the same
	var selectedOptionInGuestDuration = function(optionsList){
		var selectedOption = "";
		optionsList.each(function(){
			var option = jQuery(this);
			if(option.prop("selected")){
				selectedOption = option.val();
			}
		});
		return selectedOption;
	}

	//remove duration dropdown error class if exists
	var removeDropdownErrorClass = function(durationDropdown){
		if(durationDropdown.next().hasClass(CSS_HAS_DROPDOWN_ERROR)){
			durationDropdown.next().removeClass(CSS_HAS_DROPDOWN_ERROR);
		}
	}

	var setDurationErrorMessages = function(isEqualDurationError, isEmptyDurationError, isMultipleDurationError){
		var equalDurationErrorMessage = window.config.guestDuration && window.config.guestDuration.equalDurationErrorMessage;
		var emptyDurationErrorMessage = window.config.guestDuration && window.config.guestDuration.emptyDurationErrorMessage;
		var combinedErrorMessage = window.config.guestDuration && window.config.guestDuration.combinedErrorMessage;

		if(isMultipleDurationError){
			return combinedErrorMessage;
		}else if(isEmptyDurationError){
			return emptyDurationErrorMessage;
		}else if(isEqualDurationError){
			return equalDurationErrorMessage;
		}
	}

	var highlightDuartionErrorDropdown = function(isEqualDurationError, isMultipleDurationError, minGuestDuration, maxGuestDuration){
		//highlight the dropdown, which is having error
		if(isEqualDurationError || isMultipleDurationError){
			minGuestDuration.next().addClass(CSS_HAS_DROPDOWN_ERROR);
			maxGuestDuration.next().addClass(CSS_HAS_DROPDOWN_ERROR);
		}else if(minGuestDuration.val() == ""){
			minGuestDuration.next().addClass(CSS_HAS_DROPDOWN_ERROR);
		}else if(maxGuestDuration.val() == ""){
			maxGuestDuration.next().addClass(CSS_HAS_DROPDOWN_ERROR);
		}
	}

	var addSelectOption = function(dropdown, value, text, selected) {
		return jQuery('<option />')
						.text(text)
						.attr('value', value)
						.attr('selected', selected)
						.appendTo(dropdown);
	};

	//fetch new min and max durations after selecting new general settings value
	var fetchNewGuestDuration = function(durationNode, guestDurationDropdown, minGuestDuration, maxGuestDuration){
		var reservationDurationUrl = "/settings/getGuestDurationsOptions";

		var requestData = {
			generalSettingDuration: parseInt(durationNode.val()),
			_csrf: window.config.csrfToken
		}

		jQuery.ajax({
			url: reservationDurationUrl,
			type: 'GET',
			data: requestData,
			dataType: 'json',
			success: function(result) {
				//display the error popup to select both min/max duration only when guest duration option is enabled
				if(guestDurationDropdown.val() !== 'false'){
					var hasMinDurationError = updateNewGuestDurations(minGuestDuration, result.minGuestDurationOptions);
					var hasMaxDurationError = updateNewGuestDurations(maxGuestDuration, result.maxGuestDurationOptions);
	
					var errorAlertModal = minGuestDuration.closest(SEL_MODULE).find(SEL_MODAL_ERROR_ALERT);
					var durationErrorMessage = window.config.guestDuration && window.config.guestDuration.combinedErrorMessage;
	
					if(hasMinDurationError == undefined || hasMaxDurationError == undefined){
						showErrorPopup(errorAlertModal, durationErrorMessage, minGuestDuration);
					}
				}else{
					addNewDurationOptions(minGuestDuration, result.minGuestDurationOptions);
					addNewDurationOptions(maxGuestDuration, result.maxGuestDurationOptions);
				}
			},
			error: function(result) {
				console.log("Error...");
			}
		});
	}

	// update the guest duration (min/max) options when the feature exists but not enabled
	var addNewDurationOptions = function(durationNode, durationOptions){
		removeDropdownErrorClass(durationNode);
		durationNode.empty();

		//add default "please select" placeholder to the dropdown
		addSelectOption(durationNode, "", window.config.guestDuration.defaultDurationPlaceholder, true);

		//add fetched options in the respective dropdown
		(durationOptions || []).forEach(function(duration){
			addSelectOption(durationNode, duration.code, duration.name);
		});

		//refresh the selectpicker to update the new options
		durationNode.selectpicker('refresh');
	}

	//update both min and max duration dropdown with new values only when the guest duration feature exist and enabled
	var updateNewGuestDurations = function(durationNode, guestDuration){

		removeDropdownErrorClass(durationNode);

		//search the previous selected min/max duration in the new list
		var matchedDuration = guestDuration.find(function(item){
			return item.code === durationNode.val();
		});

		durationNode.empty();
		//add default "please select" placeholder to the dropdown
		addSelectOption(durationNode, "", window.config.guestDuration.defaultDurationPlaceholder, matchedDuration == undefined ? true : false);

		//add fetched options in the respective dropdown
		(guestDuration || []).forEach(function(duration){
			var selectedOption = (matchedDuration && matchedDuration != undefined && matchedDuration.code == duration.code) ? true : false;
			addSelectOption(durationNode, duration.code, duration.name, selectedOption);
		});

		//refresh the selectpicker to update the new options
		durationNode.selectpicker('refresh');

		if(matchedDuration == undefined){
			durationNode.next().addClass(CSS_HAS_DROPDOWN_ERROR);
		}

		return matchedDuration;
	}

	//if error class is there in the dropdown, on change of respective dropdown, remove that class
	var removeErrorOnChangeOfDropdown = function(durationDropdown){
		if(durationDropdown.val() != ""){
			removeDropdownErrorClass(durationDropdown);
		}
	}

	//display error popup for validation errors
	var showErrorPopup = function(errorAlertModal, durationErrorMessage, durationDropdown){
		alertModal.show(errorAlertModal, durationErrorMessage, true).done(function(){
			// scroll to the error item for minimum and maximum guest duration
			UserInterfaceUtils.scrollToElementConsiderNavbar(
				durationDropdown,
				SCROLL_TO_ELEMENT_OFFSET
			);
		});
	}
	
	var showFacebookSetupPopup = function(facebookSetupPopup){
		facebookSetupPopup.modal({
			backdrop: 'static',
			keyboard: false
		}, 'show');
	}

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes = initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function(){

			var moduleNode = jQuery(this);
			var bookingLimitData = window.config && window.config.bookingLimitSection && window.config.bookingLimitSection.bookingLimitData ? window.config.bookingLimitSection.bookingLimitData : [];
			var deleteConfirmModal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM);
			var deleteConfirmMessage = moduleNode.find(SEL_BOOKING_LIMIT).data(DATA_ATTR_DELETE_CONFIRM);
			var errorAlertModal = moduleNode.find(SEL_MODAL_ERROR_ALERT);
			var validationErrorMessage = moduleNode.data(DATA_ATTR_VALIDATION_ERROR);
			var minMaxGuestDurationBlock = moduleNode.find(SEL_MIN_MAX_GUEST_DURATION_BLOCK);
			var minGuestDuration = moduleNode.find(SEL_MIN_GUEST_DURATION_DROPDOWN);
			var maxGuestDuration = moduleNode.find(SEL_MAX_GUEST_DURATION_DROPDOWN);
			var guestDurationDropdown = moduleNode.find(SEL_GUEST_DURATION_SELECTPICKER);

			var mainForm = moduleNode.find(SEL_MAIN_FORM);
			var validationErrorMessage = moduleNode.find(SEL_BOOKING_LIMIT).data(DATA_ATTR_VALIDATION_ERROR);
			var itemTemplate = moduleNode.find(SEL_TEMPLATE_ITEM).remove();
			var timeIntervalTemplate = moduleNode.find(SEL_TEMPLATE_TIME_INTERVAL).remove();
			var bookingLimitData = window.config.bookingLimitSection.bookingLimitData || [];

			var facebookSetupPopup = moduleNode.find(SEL_FACEBOOK_MODAL);
			var facebookActivateBtn = facebookSetupPopup.find(SEL_FACEBOOK_POPUP_ACTIVATE_BTN);
			
			var instagramSetupPopup = moduleNode.find(SEL_INSTAGRAM_SETUP_MODAL);

			// initial meal service data
			var mealServiceSelect = window.config.mealServiceSection.mealServiceDurationData || [];

			//hide or show minimum and maximum duration on page load if "yes" option selected
			(window.config.guestDuration && window.config.guestDuration.isGuestDurationEnabled) == "true" ? minMaxGuestDurationBlock.show() : minMaxGuestDurationBlock.hide();

			initChannelPanels(moduleNode);
			actualizeHydraWidgetCards(moduleNode, true);
			var widgetActivationCards = moduleNode.find(SEL_HYDRA_ACTIVATION_CARDS);

			// limit the characters with 1000 characters
			moduleNode.find(SEL_ADDITIONAL_INFO_GUEST).limitLength(1000);

			moduleNode.on('change', SEL_HANDLE_WIDGET_ACTIVE, function() {
				var isWidgetActive = jQuery(this).prop('checked');
				if (isWidgetActive) {
					widgetActivationCards.removeClass('hidden');
					if (widgetActivationCards.hasClass(CLASS_WIDGET_ADD_CARD)) {
						UserInterfaceUtils.scrollToElementXsConsiderNavbar(widgetActivationCards);
					}
				} else {
					widgetActivationCards.addClass('hidden');
					actualizeHydraWidgetCards(moduleNode);
				}
			});

			//on change of guest duration select option
			//show minimum and maximum dropdown if selects "yes" otherwise hide those
			moduleNode.on('change', SEL_GUEST_DURATION_SELECTPICKER, function(){
				//display a warning popup that guest duration will be applied if mealtime durations exist 
				if((mealServiceSelect.length != 0 || mealServiceSelect == []) && jQuery(this).val() == "true"){
					showErrorModal(errorAlertModal, window.config.guestDuration.mealtimeDurationNotApplied);
				}
				hideShowMinMaxGuestDuration(jQuery(this).find("option"), minMaxGuestDurationBlock);
			});

			//on change of general settings dropdown value
			moduleNode.on('change', SEL_RESREVATION_DURATION, function(){
				if(window.config.guestDuration && window.config.guestDuration.hasFeature !== ""){
					fetchNewGuestDuration(jQuery(this), guestDurationDropdown, minGuestDuration, maxGuestDuration);
				}
			});

			getLocalStorageData(moduleNode);

			//remove the error class on change of min guest duration
			minGuestDuration.on('change', function(){
				removeErrorOnChangeOfDropdown(jQuery(this));
			});

			//remove the error class on change of max guest duration
			maxGuestDuration.on('change', function(){
				removeErrorOnChangeOfDropdown(jQuery(this));
			});

			// Validation and preparation of data to submit
			mainForm.on('submit', function (event) {
				updateDatalayerWithSelectedInfo(moduleNode);
				localStorage.setItem('ADVTrack', true);
				var isDurationError = false;
				var isEqualDurationError = false;
				var isEmptyDurationError = false;
				var durationErrorMessage = "";
				var isMultipleDurationError = false;

				//remove the error class from both min and max duration dropdowns
				if(guestDurationDropdown.val() == "true"){
					removeDropdownErrorClass(minGuestDuration);
					removeDropdownErrorClass(maxGuestDuration);

					isEqualDurationError = minGuestDuration.val() == maxGuestDuration.val();
					isEmptyDurationError = (minGuestDuration.val() == "") || (maxGuestDuration.val() == "");
					isMultipleDurationError = isEqualDurationError && isEmptyDurationError;

					durationErrorMessage = setDurationErrorMessages(isEqualDurationError, isEmptyDurationError, isMultipleDurationError);

					//check for validation if both min and max duration are equal or not
					isDurationError = isEqualDurationError || isEmptyDurationError;

				}else{
					//don't send both min/max fields during form submission if the selected option for duration is "No"
					minGuestDuration.remove();
					maxGuestDuration.remove();
				}

				//check for form other errors or duration validation errors
				if (!isFormValid(moduleNode) || isDurationError){
					//why checking this error first, because this will display without page reload but the next one would display on page load only
					if(isDurationError){
						showErrorPopup(errorAlertModal, durationErrorMessage, minGuestDuration);

						//highlight the dropdown, which is having error
						highlightDuartionErrorDropdown(isEqualDurationError, isMultipleDurationError, minGuestDuration, maxGuestDuration);

					}else if (!isFormValid(moduleNode)) {
						showErrorModal(errorAlertModal, validationErrorMessage);
						if(validationErrorMessage !== ""){
							updateDatalayerErrorTracking();
						}
					}

					event.stopImmediatePropagation();
					event.preventDefault();
					return false;
				}

				var data = calculateDataToSubmitFromInput(moduleNode, bookingLimitData);
				// update meal services on the basis of the initial data
				updateMealServiceData(moduleNode, mealServiceSelect);
				updateDataForSubmit(moduleNode, data);
			});
			
			// handle adding and removing time intervals
			moduleNode.on('click', SEL_ACTION_ADD_TIME_INTERVAL, function () {
				var button = jQuery(this);
				var item = button.parents(SEL_HOURS_ITEM);
				var timeIntervals = item.find(SEL_TIME_INTERVALS_ITEM);
				if (timeIntervals.length >= 4) {
					return;
				}
				addNewTimeInterval(item, timeIntervalTemplate, true);
			});

			// handle adding and removing items
			moduleNode.on('click', SEL_ACTION_BOOK_LIMIT, function () {
				addNewItem(moduleNode, itemTemplate, timeIntervalTemplate);
				jQuery(moduleNode).trigger(EVENT_ON_CHANGE_LIST);
			});

			moduleNode.on('click', SEL_BUTTON_REMOVE_ITEM, function () {
				var button = jQuery(this);
				confirmModal.show(deleteConfirmModal, deleteConfirmMessage).done(function () {
					var item = button.parents(SEL_HOURS_ITEM);
					removeItem(item);
					jQuery(moduleNode).trigger(EVENT_ON_CHANGE_LIST);
				});
			});
			
			moduleNode.on('click', SEL_ACTION_REMOVE_TIME_INTERVAL, function () {
				var button = jQuery(this);
				var timeInterval = button.parents(SEL_TIME_INTERVALS_ITEM);
				removeTimeInterval(timeInterval);
			});

			moduleNode.on('click', SEL_FACEBOOK_ACTIVATE_BTN, function(){
				showFacebookSetupPopup(facebookSetupPopup);
			});

			facebookActivateBtn.on('click', function(){

				var parentBodyClass = moduleNode.closest('.page-settings-reservation');
				var htmlBody = parentBodyClass.closest('.domReady');

				// hide the previous popup
				facebookSetupPopup.modal('hide');

				htmlBody.css('overflow-y', 'scroll');
				window.location.href = "/settings/integration";
			});

			moduleNode.on('click', SEL_INSTAGRAM_ACTIVATE_BTN, function(){
				// open instagram setup modal
				instagramSetupPopup.modal({
					backdrop: 'static',
					keyboard: false
				}, 'show');
			});

			// display the inital items
			buildItemsFromInitialData(moduleNode, bookingLimitData, itemTemplate, timeIntervalTemplate);
			displayMealServices(moduleNode, mealServiceSelect);
			handleTimeIntervalError(mainForm);

		});

	};
};

// Make class public to outside world
module.exports = SettingsReservations;
},{"../form/FormTimepicker":90,"../mediator/mediator":103,"../modals/Alert":110,"../notification/Notification":125,"../utils/ArrayUtils":183,"../utils/Tracking":188,"../utils/UserInterfaceUtils":189,"jquery/dist/jquery":14}],152:[function(require,module,exports){
/**
 * TimeSettings functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
var Datepicker  	= require('bootstrap.datepicker');
DateUtils		= require('../utils/DateUtils');



// Class definition
TimeSettings = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE						= '.mod-settings-time-settings';

    var SEL_TEMPLATE_TIME_SETTING		= '.timeSettingTemplate table tbody';
    var SEL_TEMPLATE_TIME_INTERVAL		= '.timeIntervalTemplate';

    var SEL_TIME_INTERVAL				= '.timeInterval';
    var SEL_TIME_INTERVALS_HOLDER		= '.timeIntervals';
    var SEL_TIME_INTERVALS_CELL			= 'td.timeIntervals';
    var SEL_NO_TIME_INTERVALS			= '.noTimeIntervals';

    var SEL_INPUT_DATE_TYPE				= 'select.dateType';
    var SEL_INPUT_DATE_START			= 'input.startDate';
    var SEL_INPUT_DATE_END				= 'input.endDate';
    var SEL_INPUT_DATE_END_INTERNAL		= 'input.endDateInternal';
    var SEL_INPUT_WEEKDAY				= 'select.weekday';
    var SEL_TEXT_TO						= 'span.textTo';

    var SEL_TIME_SETTING_EXCEPTIONAL= 'tr.exceptional';

    var SEL_BTN_TIME_SETTING_ADD		= '.btn.addTimeSetting';
    var SEL_BTN_TIME_SETTING_REMOVE		= '.btn.removeTimeSetting';
    var SEL_BTN_TIME_INTERVAL_ADD		= '.btn.addTimeInterval';
    var SEL_BTN_TIME_INTERVAL_REMOVE	= '.btn.removeTimeInterval';

    var DATA_TIME_SETTING_INDEX			= 'data-time-setting-index';
    var DATA_TIME_INTERVAL_INDEX		= 'data-time-interval-index';



	/**
	 * Handles request to add a new time setting.
	 */
	var handleAddNewTimeSetting = function() {

		var buttonRowNode 				= jQuery(this).parents('tr');
		var exceptionalTimeSettingNodes	= jQuery(this).parents('table').find(SEL_TIME_SETTING_EXCEPTIONAL);

		// Collect required index information
		var newTimeSettingIndex 		= 0;
		exceptionalTimeSettingNodes.each(function() {
			var nodeIndex = parseInt(jQuery(this).attr(DATA_TIME_SETTING_INDEX));
			if (nodeIndex >= newTimeSettingIndex) {
				newTimeSettingIndex = nodeIndex + 1;
			}
		});

		// Create HTML
		var newTimeSettingHtml = jQuery(this).parents(SEL_MODULE).find(SEL_TEMPLATE_TIME_SETTING).html();
		newTimeSettingHtml = newTimeSettingHtml.replace(/{TIME_SETTING_INDEX}/g, newTimeSettingIndex);

		// Create node
		var newTimeSettingNode = jQuery(newTimeSettingHtml);

		// Add node
		newTimeSettingNode.insertBefore(buttonRowNode);

		// Init calendar and dateType selection
		newTimeSettingNode.find(SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END).datepicker({
		    format: window.config.settingsTimeSettings.dateFormat,
		    language: window.config.settingsTimeSettings.calendarLanguageCode,
		    weekStart: 1,
		    autoclose: true,
		    todayHighlight: false
		});
		newTimeSettingNode.find(SEL_INPUT_DATE_TYPE).trigger('change');

	};



	/**
	 * Handles request to remove a time setting.
	 */
	var handleRemoveTimeSetting = function() {

		var timeSettingNode = jQuery(this).parents('tr');

		timeSettingNode.remove();

	};



	/**
	 * Handles request to add a new time interval.
	 */
	var handleAddTimeInterval = function() {

		var timeSettingNode 	= jQuery(this).parents('tr');
		var timeIntervalsNode 		= timeSettingNode.find(SEL_TIME_INTERVALS_HOLDER);
		var timeIntervalNodes 		= timeSettingNode.find(SEL_TIME_INTERVAL)

		// Collect required index information
		var timeSettingIndex 	= timeSettingNode.attr(DATA_TIME_SETTING_INDEX);
		var timeIntervalIndex 		= 0;
		timeIntervalNodes.each(function() {
			var nodeIndex = parseInt(jQuery(this).attr(DATA_TIME_INTERVAL_INDEX));
			if (nodeIndex >= timeIntervalIndex) {
				timeIntervalIndex = nodeIndex + 1;
			}
		});

		// Create HTML
		var newTimeIntervalHtml = jQuery(this).parents(SEL_MODULE).find(SEL_TEMPLATE_TIME_INTERVAL).html();
		newTimeIntervalHtml = newTimeIntervalHtml.replace(/{TIME_SETTING_INDEX}/g, timeSettingIndex);
		newTimeIntervalHtml = newTimeIntervalHtml.replace(/{TIME_INTERVAL_INDEX}/g, timeIntervalIndex);
		newTimeIntervalHtml = newTimeIntervalHtml.replace(/{PATH}/g, timeSettingNode.is(SEL_TIME_SETTING_EXCEPTIONAL) ? 'exceptionalTimeSettings' : 'weekdayTimeSettings');

		// Add node
		timeIntervalsNode.append(newTimeIntervalHtml);

		// Init node display
		timeIntervalsNode.trigger('change');

	};



	/**
	 * Handles request to remove a time interval.
	 */
	var handleRemoveTimeInterval = function() {

		var intervalsNode 	= jQuery(this).parents(SEL_TIME_INTERVALS_HOLDER);
		var intervalNode 	= jQuery(this).parents(SEL_TIME_INTERVAL);

		intervalNode.remove();
		intervalsNode.trigger('change');

	};



	/**
	 * Toggles 'no time interval' message on or off
	 */
	var toggleNoTimeIntervalMsg = function() {

		var noIntervalsNode 	= jQuery(this).find(SEL_NO_TIME_INTERVALS);
		var timeIntervalNodes	= jQuery(this).find(SEL_TIME_INTERVAL);

		if (timeIntervalNodes.length == 0) {
			noIntervalsNode.show();
		} else {
			noIntervalsNode.hide();
		}

	};



	/**
	 * Handles the switch of fixed date to timeframe as date type.
	 */
	var handleDateTypeChange = function() {

		var rowNode 					= jQuery(this).parents('tr');
		var toTextNode 					= rowNode.find(SEL_TEXT_TO);
		var dateStartInputNode 			= rowNode.find(SEL_INPUT_DATE_START);
		var dateEndInputNode 			= rowNode.find(SEL_INPUT_DATE_END);
		var dateEndInternalInputNode 	= rowNode.find(SEL_INPUT_DATE_END_INTERNAL);
		var weekdaySelectNode 			= rowNode.find(SEL_INPUT_WEEKDAY);

		if (jQuery(this).val() == 'timeframe') {

			// Show according fields
			toTextNode.show();
			dateEndInputNode.show();
			weekdaySelectNode.show();

			// Show same as start date in case none was selected before
			if (dateEndInternalInputNode.val() == '') {
				dateEndInputNode.datepicker('setDate', dateStartInputNode.datepicker('getDate'));
			}
		} else {

			// Hide according fields
			toTextNode.hide();
			dateEndInputNode.hide();
			weekdaySelectNode.hide();

			// Reset date and weekday fields
			dateEndInputNode.val('');
			dateEndInternalInputNode.val('');
			weekdaySelectNode.val(0);
		}

	};



	/**
	 * Init datepicker
	 */
	var initDatepicker = function(moduleNode) {

		// Init datepicker
		moduleNode.find(SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END).datepicker({
		    format: window.config.settingsTimeSettings.dateFormat,
		    language: window.config.settingsTimeSettings.calendarLanguageCode,
		    weekStart: 1,
		    autoclose: true,
		    todayHighlight: false
		});

		// Set original datepicker dates for exceptional dates
		moduleNode.find(SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END).each(function() {

			var node 					= jQuery(this);
			var internalNode 			= node.prev();
			var exceptionDateRowNode	= node.parents('[' + DATA_TIME_SETTING_INDEX + ']');

			var exceptionalDateIndex 	= exceptionDateRowNode.attr(DATA_TIME_SETTING_INDEX);
			if (isNaN(exceptionalDateIndex)) {
				return;
			}

			// Get data from data attribute instead of form - since form value is in UTC,
			// but we need to have it converted to establishments' timezone
			var date;
			if (node.is(SEL_INPUT_DATE_START)) {
				date = config.settingsTimeSettings.exceptionalTimeSettings[exceptionalDateIndex].startDate;
			} else {
				date = config.settingsTimeSettings.exceptionalTimeSettings[exceptionalDateIndex].endDate;
			}

			if (date != '') {
				var dateUtils = new DateUtils();
				node.datepicker('setDate', date);
			}

		});

		// Track datepicker changes
		moduleNode.on('change', SEL_INPUT_DATE_START + ',' + SEL_INPUT_DATE_END, function() {

			var node 			= jQuery(this);
			var internalNode	= node.prev();

			var date = node.datepicker('getUTCDate');
			if (date != undefined) {
				var dateUtils = new DateUtils();
				var dateObj = dateUtils.toDate(date);
				internalNode.val(dateObj.toISOString());
			}

		});

	};



    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes = initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			// Init datepicker
			initDatepicker(jQuery(this));

			// Handle add / remove time settings
			jQuery(this).find(SEL_BTN_TIME_SETTING_ADD).bind('click', handleAddNewTimeSetting);
			jQuery(this).on('click', SEL_BTN_TIME_SETTING_REMOVE, handleRemoveTimeSetting);

			// Handle add / remove time intervals
			jQuery(this).on('click', SEL_BTN_TIME_INTERVAL_ADD, handleAddTimeInterval);
			jQuery(this).on('click', SEL_BTN_TIME_INTERVAL_REMOVE, handleRemoveTimeInterval);

			// Toggle 'no time intervals' msg on or off
			jQuery(this).on('change', SEL_TIME_INTERVALS_CELL, toggleNoTimeIntervalMsg);
			jQuery(SEL_TIME_INTERVALS_CELL).trigger('change');

			// Handle datetype change (between fixed date and timeframe)
			jQuery(this).on('change', SEL_INPUT_DATE_TYPE, handleDateTypeChange);
			jQuery(SEL_INPUT_DATE_TYPE).trigger('change');

		});

    };

};

// Make class public to outside world
module.exports = TimeSettings;
},{"../mediator/mediator":103,"../utils/DateUtils":185,"bootstrap.datepicker":26,"jquery/dist/jquery":14}],153:[function(require,module,exports){
/**
 * WebsiteIntegration functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
Tracking    	= require('../utils/Tracking');


// Class definition
WebsiteIntegration = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE							= '.mod-settings-integration-page';

	var SEL_RESERVATION_NODE								= '.reservationWidgetCard';
	var SEL_FEEDBACK_NODE									= '.feedbackWidgetCard';
	var SEL_MENU_NODE										= '.menuWidgetCard';
	var SEL_COPY_CARD										= '.copyCodeWrapper';
	var SEL_COPY_BUTTON										= '.copy-button';
	var SEL_CODE_COPY 										= 'pre';
	var SEL_COPY_SELECT_RESERVATION_WIDGET					= '#dropDownCodeReservationWidget';
	var SEL_COPY_SELECT_FEEDBACK_WIDGET						= '#dropDownCodeFeedbackWidget';
	var SEL_COPY_SELECT_MENU_WIDGET							= '#dropDownCodeMenuWidget';
	var SEL_SELECTED_OPTION									= '.optionToBeSelected';

	var CSS_BTN_PRIMARY 									= 'btn-primary';

	var FORM_ERROR_TYPE										= "form-error";
	var FORM_EVENT_TYPE										= "error-form";
	var FORM_EVENT_NAME										= "error";
	var FORM_ERROR_FIELD_NAME 								= "sendToDeveloper-email";
	var FORM_ERROR_MESSAGE									= "Email has not been sent, please correct the highlighted errors.";

	var FROM_SELECTION_EVENT_NAME							= "integrationMethod";
	var FORM_SELECTION_EVENT_TYPE							= "selection";

	//initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.selection = window._adl.selection || [];
	window._adl.error = window._adl.error || {};

	var changeOption = function(selectInput, moduleNode){	
		var optionSelected = jQuery(selectInput).find(":selected").val();
		moduleNode.find(SEL_SELECTED_OPTION).each(function(){
			var item = jQuery(this);
			if( item.hasClass(optionSelected)){
				item.removeClass('hiddenCopyCode');
			}else if(!item.hasClass('hiddenCopyCode')){
				item.addClass('hiddenCopyCode');
			}
		});
	}

	var initCopyCards = function(moduleNode) {
		var copyCardNodes = moduleNode.find(SEL_COPY_CARD);
		var copiedText = window.config.copycode.copied || {};
		var copyText = window.config.copycode.copy || {};

		copyCardNodes.each(function() {
			var copyCardNode = jQuery(this);
			var copyBtnNode = copyCardNode.find(SEL_COPY_BUTTON);
			var codeToCopy=copyCardNode.find(SEL_CODE_COPY);

			copyBtnNode.on('click', function(elem){
				var temp = jQuery("<input>");
				jQuery("body").append(temp);
				temp.val(jQuery(codeToCopy).text()).select();
				document.execCommand("copy");
				temp.remove();
				changeText();
			});

			var changeText = function(){
				if(jQuery(copyBtnNode).text().trim() === copyText){
					jQuery(copyBtnNode).text(copiedText);
					jQuery(copyBtnNode).addClass(CSS_BTN_PRIMARY);
					setTimeout(function(){
						jQuery(copyBtnNode).text(copyText);
						jQuery(copyBtnNode).removeClass(CSS_BTN_PRIMARY);
					},5000);
				}
				
			};
		});

	};

	var updateAdobeDataLayer = function(moduleNode){
		var selectedDropdownOption = moduleNode.find(SEL_COPY_SELECT_RESERVATION_WIDGET).val();

		if (window._satellite && window._adl) {
			//push eventInfo in _adl
			_adl.eventInfo = {
				eventName: FROM_SELECTION_EVENT_NAME,
				eventType: FORM_SELECTION_EVENT_TYPE
			}
			
			if(selectedDropdownOption !== ""){
				_adl.selection = [];
				//push all the selections in adobe data layer
				_adl.selection.push({'selectedOption1': selectedDropdownOption});
			}

			_adl.error = {};
	
			//fire direct call
			window._satellite.track('trackButtonClick');
		}
	}

	//to update error tracking in adobe datalayer with event info
	var updateDatalayerErrorTracking = function(){
		if (window._satellite && window._adl) {
		  //push eventInfo in _adl
		  _adl.eventInfo = {
			eventName: FORM_EVENT_NAME,
			eventType: FORM_EVENT_TYPE
		  }
	
		  //push all the errors in adobe data layer
		  _adl.error = {
			errorType: FORM_ERROR_TYPE,
			errorMessage: FORM_ERROR_MESSAGE,
			errorFields: FORM_ERROR_FIELD_NAME
		  }

		  _adl.selection = [];
	
		  //fire direct call
		  window._satellite.track('errorCall');
		}
	}

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes = initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode = jQuery(this);
			var reservationCardNode = moduleNode.find(SEL_RESERVATION_NODE);
			var feedbackCardNode = moduleNode.find(SEL_FEEDBACK_NODE);
			var menuCardNode = moduleNode.find(SEL_MENU_NODE);
			var selectedInputReservationWidget = moduleNode.find(SEL_COPY_SELECT_RESERVATION_WIDGET);
			var selectedInputFeedbackWidget = moduleNode.find(SEL_COPY_SELECT_FEEDBACK_WIDGET);
			var selectedInputMenuWidget = moduleNode.find(SEL_COPY_SELECT_MENU_WIDGET);

			initCopyCards(moduleNode);
		
			selectedInputReservationWidget.on('change',function(){	
				updateAdobeDataLayer(moduleNode);
				changeOption(selectedInputReservationWidget, reservationCardNode);
			});

			selectedInputFeedbackWidget.on('change',function(){
				changeOption(selectedInputFeedbackWidget, feedbackCardNode);
			});

			selectedInputMenuWidget.on('change',function(){
				changeOption(selectedInputMenuWidget, menuCardNode);
			});

			// adobe error tracking in case wrong email address entered
			if(window.config.msg.errorCall === window.config.msg.errorMsg){
				updateDatalayerErrorTracking();
			}

		});
	};
};

// Make class public to outside world
module.exports = WebsiteIntegration;

},{"../mediator/mediator":103,"../utils/Tracking":188,"jquery/dist/jquery":14}],154:[function(require,module,exports){


/**
 * Settings functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
TimeSettings = require('./TimeSettings');
SettingsAccount = require('./SettingsAccount');
SettingsReservations = require('./SettingsReservations');
WebsiteIntegration = require('./WebsiteIntegration');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var timeSettings = new TimeSettings();
	var settingsAccount = new SettingsAccount();
	var settingsReservations = new SettingsReservations();
	var websiteIntegration=new WebsiteIntegration();

	// Trigger onload activities
	timeSettings.init(initNode);
	settingsAccount.init(initNode);
	settingsReservations.init(initNode);
	websiteIntegration.init(initNode);
});
},{"../mediator/mediator":103,"./SettingsAccount":150,"./SettingsReservations":151,"./TimeSettings":152,"./WebsiteIntegration":153}],155:[function(require,module,exports){
/**
 * Overview functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');
jQuery = require('jquery/dist/jquery');

// Class definition
BannerTracking = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                        = '.mod-banner-tracking';

  // Detect and return the environment
	var getCurrentEnvironment = function () {
		var env = '';

        if (document.location.hostname.indexOf('dev.dish.co') >= 0) {
            env = 'dev.';
        } else if (document.location.hostname.indexOf('acc.dish.co') >= 0) {
            env = 'acc.';
        } else if (document.location.hostname.indexOf('stg.dish.co') >= 0) {
            env = 'stg.';
        } else {
            // Production
            env = '';
        }

		return env;
  }

  /**
     * Get URL parameter 
     */
	var getUrlParameter = function getUrlParameter(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;
	
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
	
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
		}
	};


    this.init = function(initNode) {
      
      self = this;

      // Retrieve and cache dom nodes
      var moduleNodes       = initNode.find(SEL_MODULE);
      
      // Init all matching nodes
      moduleNodes.each(function() {
        
        var moduleNode = jQuery(this);

        var redirectUrl= getUrlParameter('redirect_link');
        window.location.href=redirectUrl;


      });
    };

};

// Make class public to outside world
module.exports = BannerTracking;

},{"../mediator/mediator":103,"jquery/dist/jquery":14}],156:[function(require,module,exports){

var yellow1 = '#fbad25';
var yellow2 = '#fcc360';
var yellow3 = '#fddea8';
var grey1 = '#65655f';
var grey2 = '#2f2f2f';

var colors = [
  yellow1,
  yellow2,
  yellow3,
  grey1,
  grey2,
];

var darkColors = [
  grey1,
  grey2
];

var lightColors = [
  yellow1,
  yellow2,
  yellow3
];

var ChartColors = function() {

  var self = this;

  // even numbers will return a primary color
  // odd numbers will return a secondary color
  this.get = function(index) {
    return colors[index] || colors[0];
  };

  this.isDark = function(color) {
    return darkColors.indexOf(color) >= 0;
  };

  this.isLight = function(color) {
    return lightColors.indexOf(color) >= 0;
  };

};

// create singleton
var chartColors = new ChartColors();

// Make class public to outside world
module.exports = chartColors;

},{}],157:[function(require,module,exports){
/**
 * GradientTable functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

jQuery = require('jquery/dist/jquery');
GradientTableUtils = require('../utils/GradientTableUtils')



// Class definition
GradientTable = function() {

  // self references
    var self;
    
    var gradientTableUtils = new GradientTableUtils();

    // selector constants
    var SEL_MODULE                    = '.mod-stats-overview';
    
    var SEL_ORIGIN_CARD               = '.mod-stats-overview-origin-card';
    var SEL_TABLE_DIV                 = '.reservationTable';
    var SEL_GRADIENT_SHOWCASE         = '.wrapGradientTable';


    var localConfig = window.config.settingsStatistics  || {};
    var jan = localConfig.jan;
    var feb = localConfig.feb;
    var mar = localConfig.mar;
    var apr = localConfig.apr;
    var may = localConfig.may;
    var jun = localConfig.jun;
    var jul = localConfig.jul;
    var aug = localConfig.aug;
    var sep = localConfig.sep;
    var oct = localConfig.oct;
    var nov = localConfig.nov;
    var dec = localConfig.dec;

    var monthsArray = [jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec];
    
    var minNumReservations             = localConfig.minNumReservations;
    var maxNumReservations             = localConfig.maxNumReservations;
    var minNumGuests                   = localConfig.minNumGuests;
    var maxNumGuests                   = localConfig.maxNumGuests;
    var reservationsMap                = localConfig.reservationsMap;
    var guestsMap                      = localConfig.guestsMap;
    var minYear                        = localConfig.minYear;
    var maxYear                        = localConfig.maxYear;
    
    var numberOfCols                   = 12
    var numberofRows                   = (maxYear - minYear) + 1;
    
    
    var gradientArray = ['#f4f4f4', '#e1e1e1', '#cccccc', '#83838A', '#323334'];


    BuildGradientGuests = function(button){
      jQuery(button).toggleClass("btn-secondary",true);
      jQuery(button).toggleClass("btn-default",false);
      jQuery("#btnReservationsStats").toggleClass("btn-secondary", false);
      jQuery("#btnReservationsStats").toggleClass("btn-default", true);
      gradientTableUtils.BuildGradient(minYear, maxYear, minNumGuests, maxNumGuests, guestsMap, gradientArray);
    }
    
    BuildGradientReservations = function(button){
      jQuery(button).toggleClass("btn-secondary",true);
      jQuery(button).toggleClass("btn-default",false);
      jQuery("#btnGuestsStats").toggleClass("btn-secondary", false);
      jQuery("#btnGuestsStats").toggleClass("btn-default", true);
      gradientTableUtils.BuildGradient(minYear, maxYear, minNumReservations, maxNumReservations, reservationsMap, gradientArray);
    }
    
    jQuery("#btnGuestsStats").click(function(){
        BuildGradientGuests(this);
    });
    
    jQuery("#btnReservationsStats").click(function(){
      BuildGradientReservations(this);
    });

    this.init = function(initNode) {
      
        self = this;
        // Retrieve and cache dom nodes
        var moduleNodes       = initNode.find(SEL_MODULE);
        
        // Init all matching nodes
        moduleNodes.each(function() {
            
        var moduleNode = jQuery(this);
        var reservationTable = moduleNode.find(SEL_TABLE_DIV);
        var gradientShowcase = moduleNode.find(SEL_GRADIENT_SHOWCASE);

        gradientTableUtils.showGradientTable(gradientShowcase, gradientArray);
        if(reservationsMap == null || guestsMap == null){
            var gradientTableNode = moduleNode.find(SEL_ORIGIN_CARD);
            gradientTableNode.addClass('no-reservations');
            return;
        }

        gradientTableUtils.BuildTable(reservationTable, numberofRows, numberOfCols, minYear, monthsArray);
        gradientTableUtils.BuildGradient(minYear, maxYear, minNumReservations, maxNumReservations, reservationsMap, gradientArray);

      });
    };

};

// Make class public to outside world
module.exports = GradientTable;

},{"../mediator/mediator":103,"../utils/GradientTableUtils":186,"jquery/dist/jquery":14}],158:[function(require,module,exports){
/**
 * Utilization functionality.
*
*/


jQuery = require('jquery/dist/jquery');

var PercentageBarChart      = require('../charts/PercentageBarChart');


// Class definition
var Insights = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                        = '.mod-stats-insights';

  var SEL_ORIGIN_CARD                   = '.mod-stats-insights-origin-card';
  
  var SEL_PURPOSE_CARD                  = '.mod-stats-insights-purpose-card';
  
  var SEL_GUESTS_CARD                   = '.mod-stats-insights-guests-card';

  var SEL_CHART                         = '.chart';


  var percentageBarChart = new PercentageBarChart();


  var initOriginCard = function(moduleNode, localConfig) {

    var card = moduleNode.find(SEL_ORIGIN_CARD);
    var chart = card.find(SEL_CHART);

    var originData = localConfig.originData || {};
    var data = [];
    for (var title in originData) {
      var value = originData[title] || 0;
      data.push({
        title: title,
        value: value
      });
    }

    percentageBarChart.init(chart, data);

  };
  
  var initPurposeCard = function(moduleNode, localConfig) {

	    var card = moduleNode.find(SEL_PURPOSE_CARD);
	    var chart = card.find(SEL_CHART);

	    var purposeData = localConfig.purposeData || {};
	    var data = [];
	    for (var title in purposeData) {
	      var value = purposeData[title] || 0;
	      data.push({
	        title: title,
	        value: value
	      });
	    }

	    percentageBarChart.init(chart, data);

	  };

  var initGuestsCard = function(moduleNode, localConfig) {

	    var card = moduleNode.find(SEL_GUESTS_CARD);
	    var chart = card.find(SEL_CHART);

	    var data = [];
	    var guestsLocalCount = localConfig.guestsLocalCount || {};
      var guestsInternationalCount = localConfig.guestsInternationalCount || {};
      var localGuestsLabel = localConfig.localLabel || {};
      var internationalGuestsLabel = localConfig.internationalLabel || {};
	    
	    data.push({
	        title: localGuestsLabel,
	        value: localConfig.guestsLocalCount
	    });
	    data.push({
	        title: internationalGuestsLabel,
	        value: guestsInternationalCount
	    });

	    percentageBarChart.init(chart, data);

	  };
		  
  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes       = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var localConfig = window.config.settingsStatistics || {};

      initOriginCard(moduleNode, localConfig);
      initPurposeCard(moduleNode, localConfig);
      initGuestsCard(moduleNode, localConfig);

    });

  };

};

// Make class public to outside world
module.exports = Insights;

},{"../charts/PercentageBarChart":64,"jquery/dist/jquery":14}],159:[function(require,module,exports){
/**
 * Overview functionality.
*
*/

// Mediator module (handles event delegation)
var mediator  = require('../mediator/mediator');
jQuery = require('jquery/dist/jquery');

// Class definition
Overview = function () {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                    = '.mod-stats-overview';

  var SEL_ORIGIN_CARD               = '.mod-stats-overview-averageRating-card';
  var SEL_NOSHOWRATE_CARD           = '.mod-stats-overview-noShowRateCard-card';
  
  var SEL_FOOD_RATING_VALUE         = '.foodRating';
  var SEL_SERVICE_RATING_VALUE      = '.servicesRating';
  var SEL_FOOD_AND_DRINK_RATING     = '.foodAndDrinksRating';
  var SEL_SERVICE_RATING            = '.serviceRating';
  
  var SEL_VALUE_FOR_MONEY_RATE_VAL  = '.valueForMoney';
  var SEL_WOULD_RECOMMEND_RATE_VAL  = '.wouldRecommend';
  var SEL_VALUE_FOR_MONEY_RATING    = '.valueForMoneyRating';
  var SEL_WOULD_RECOMMEND_RATING    = '.wouldRecommendRating';
  
  var SEL_UNAVAILABLE_DATA          = '.unavailableData';
  var SEL_SHOWRATING_NODE           = '.ratingCurrentMonth';
  var SEL_CURRENT_MONTH_RATING_SPAN = '.ratingCurrentMonthSpan';
  var SEL_LAST_MONTH_RATING_PERCENT = '.ratingPrecentLastMonth';
  var SEL_LAST_MONTH_RATING_SPAN    = '.ratingLastMonthSpan';

  var SEL_STAR_ICON                 = '.fa-star';
  var SEL_VALUE_FOR_MONEY_ICON      = '.fa-credit-card';
  var SEL_WOULD_RECOMMEND_ICON      = '.fa-thumbs-up';
  var SEL_ARROW_UP_ICON             = '.fa-caret-up';
  var SEL_ARROW_DOWN_ICON           = '.fa-caret-down';

  var CSS_RATING_NUMBER             = 'ratingNumber';



  var initNoShowRateCard = function (moduleNode, localConfig) {
    var rateNoShow = localConfig.rateNoShow;
    var rateNoShowPrevious = localConfig.rateNoShowPrevious;

    var ratingCurrentMonthNode = moduleNode.find(SEL_NOSHOWRATE_CARD);
    var noShowRatingNode = ratingCurrentMonthNode.find(SEL_SHOWRATING_NODE);

    if (rateNoShow == null && rateNoShowPrevious == null) {
      noShowRatingNode.find(SEL_UNAVAILABLE_DATA).css({ "display": "block" });
      noShowRatingNode.find(SEL_LAST_MONTH_RATING_PERCENT).css({ "display": "none" });
      noShowRatingNode.find(SEL_ARROW_DOWN_ICON).css({ "display": "none" });
      noShowRatingNode.find(SEL_ARROW_UP_ICON).css({ "display": "none" });
      return;
    }

    if (rateNoShow < rateNoShowPrevious) {
      noShowRatingNode.find(SEL_ARROW_DOWN_ICON).css({ "visibility": "visible" });
      noShowRatingNode.find(SEL_ARROW_UP_ICON).css({ "display": "none" });

    } else {
      noShowRatingNode.find(SEL_ARROW_UP_ICON).css({ "visibility": "visible" });
      noShowRatingNode.find(SEL_ARROW_DOWN_ICON).css({ "display": "none" });
    }

    if (rateNoShow == null) {
      noShowRatingNode.find(SEL_CURRENT_MONTH_RATING_SPAN).text("0%");
      noShowRatingNode.find(SEL_LAST_MONTH_RATING_PERCENT).children(SEL_LAST_MONTH_RATING_SPAN).text(rateNoShowPrevious + "%");
      noShowRatingNode.find(SEL_LAST_MONTH_RATING_PERCENT).css({ "display": "block" });
      return;

    } else if (rateNoShowPrevious == null) {
      noShowRatingNode.find(SEL_CURRENT_MONTH_RATING_SPAN).text(rateNoShow + "%");
      noShowRatingNode.find(SEL_LAST_MONTH_RATING_PERCENT).children(SEL_LAST_MONTH_RATING_SPAN).text("0%");
      noShowRatingNode.find(SEL_LAST_MONTH_RATING_PERCENT).css({ "display": "block" });
      return;
    }

    noShowRatingNode.find(SEL_CURRENT_MONTH_RATING_SPAN).text(rateNoShow + "%");
    noShowRatingNode.find(SEL_LAST_MONTH_RATING_PERCENT).children(SEL_LAST_MONTH_RATING_SPAN).text(rateNoShowPrevious + "%");
    noShowRatingNode.find(SEL_LAST_MONTH_RATING_PERCENT).css({ "display": "block" });
  };

  var initAverageCard = function (moduleNode, localConfig) {

    var feedbackFoodRatings = localConfig.feedbackFoodRatings;
    var feedbackServiceRatings = localConfig.feedbackServiceRatings;
    var card = moduleNode.find(SEL_ORIGIN_CARD);
    var originData = localConfig.originData || {};

    var foodAndDrinksRatingNode = moduleNode.find(SEL_FOOD_AND_DRINK_RATING);
    var serviceRatingsNode = moduleNode.find(SEL_SERVICE_RATING);

    if (feedbackFoodRatings == null) {
      foodAndDrinksRatingNode.find(SEL_FOOD_RATING_VALUE).text(window.config.msg.reservationStatus.noRating);
    } else {
      foodAndDrinksRatingNode.find(SEL_FOOD_RATING_VALUE).text(feedbackFoodRatings);
      foodAndDrinksRatingNode.find(SEL_FOOD_RATING_VALUE).addClass(CSS_RATING_NUMBER);
      foodAndDrinksRatingNode.find(SEL_STAR_ICON).css({ "visibility": "visible" });
    }

    if (feedbackServiceRatings == null) {
      serviceRatingsNode.find(SEL_SERVICE_RATING_VALUE).text(window.config.msg.reservationStatus.noRating);
    } else {
      serviceRatingsNode.find(SEL_SERVICE_RATING_VALUE).text(feedbackServiceRatings);
      serviceRatingsNode.find(SEL_SERVICE_RATING_VALUE).addClass(CSS_RATING_NUMBER);
      serviceRatingsNode.find(SEL_STAR_ICON).css({ "visibility": "visible" });
    }
  };

  var initGuestOpinionCard = function (moduleNode, localConfig) {

    var valueForMoneyRating = localConfig.valueForMoney;
    var wouldRecommendRating = localConfig.wouldRecommend;

    var valueForMoneyRatingNode = moduleNode.find(SEL_VALUE_FOR_MONEY_RATING);
    var wouldRecommendRatingNode = moduleNode.find(SEL_WOULD_RECOMMEND_RATING);

    if (valueForMoneyRating == null || valueForMoneyRating == '') {
      valueForMoneyRatingNode.find(SEL_VALUE_FOR_MONEY_RATE_VAL).text(window.config.msg.reservationStatus.noRating);
    } else {
      valueForMoneyRatingNode.find(SEL_VALUE_FOR_MONEY_RATE_VAL).text(valueForMoneyRating + '%');
      valueForMoneyRatingNode.find(SEL_VALUE_FOR_MONEY_RATE_VAL).addClass(CSS_RATING_NUMBER);
      valueForMoneyRatingNode.find(SEL_VALUE_FOR_MONEY_ICON).css({ "visibility": "visible" });
    }

    if (wouldRecommendRating == null || wouldRecommendRating == '') {
      wouldRecommendRatingNode.find(SEL_WOULD_RECOMMEND_RATE_VAL).text(window.config.msg.reservationStatus.noRating);
    } else {
      wouldRecommendRatingNode.find(SEL_WOULD_RECOMMEND_RATE_VAL).text(wouldRecommendRating + '%');
      wouldRecommendRatingNode.find(SEL_WOULD_RECOMMEND_RATE_VAL).addClass(CSS_RATING_NUMBER);
      wouldRecommendRatingNode.find(SEL_WOULD_RECOMMEND_ICON).css({ "visibility": "visible" });

    }
  };

  this.init = function (initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function () {

      var moduleNode = jQuery(this);

      var localConfig = window.config.settingsStatistics || {};
      var localConfigMsg = window.config.msg || {};

      initAverageCard(moduleNode, localConfig);
      initNoShowRateCard(moduleNode, localConfig);
      initGuestOpinionCard(moduleNode, localConfig);
    });
  };
};

// Make class public to outside world
module.exports = Overview;
},{"../mediator/mediator":103,"jquery/dist/jquery":14}],160:[function(require,module,exports){
/**
 * ReservationStatus functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// they don't need references, only need to be imported
require('jquery.flot/jquery.flot');
require('jquery.flot/jquery.flot.pie');
require('jquery.flot/jquery.flot.time');
require('flot-axislabels/jquery.flot.axislabels');
require('jquery.flot.tickrotor');
require('jquery.flot.tooltip/js/jquery.flot.tooltip');

jQuery = require('jquery/dist/jquery');
ChartColors   	= require('./ChartColors');

// Class definition
ReservationStatus = function() {

    // self references
    var self;

    // selector constants
    var SEL_MODULE                    = '.mod-stats-reservation-status';
    var SEL_CHART_STATUSES            = '.chartStatuses';
    var SEL_CHART_ORIGINS             = '.chartOrigins';
    var SEL_CHART_PURPOSES            = '.chartPurposes';
    var SEL_CHART_RES_TRENDS          = '.chartReservationTrends';
 
    var DATA_ATTR_STATUSES_DATA       = 'chartStatusesData';
    var DATA_ATTR_ORIGINS_DATA        = 'chartOriginsData';
    var DATA_ATTR_PURPOSES_DATA       = 'chartPurposesData';
    var DATA_ATTR_RES_TRENDS_DATA     = 'chartReservationTrendsData';

    var DATA_ATTR_AXES_LABEL_Y        = 'axisLabelY';

    var CSS_CLASS_NO_DATA             = 'no-data';
    var CSS_CLASS_HAS_DATA            = 'has-data';


    var htmlHelperElem = jQuery('<div />');

    var getHtml = function(elem) {
      return htmlHelperElem.empty().append(elem).html();
    };

    var hasDataToShow = function(statusesData, originData, purposeData) {
      return !jQuery.isEmptyObject(statusesData) || !jQuery.isEmptyObject(originData) || !jQuery.isEmptyObject(purposeData);
    };

    var formatPadZero = function(num) {
      if (num !== '') {
        num = parseInt(num);
        return (num < 10) ? '0' + num : '' + num;
      }
      return '';
    };

    var convertDataToGraphFlotFormat = function(rawData) {
      var data = [];
      var labels = [];

      // they have to be swapped to when the actual
      // value is compared, the actual value is selected
      var maxY = Number.MIN_VALUE;
      var minY = Number.MAX_VALUE;

      var i = 0;
      for (var k in rawData) {
        var y = rawData[k];
        data.push([i, y]);
        labels.push([i, formatPadZero(parseInt(k))]);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
        i++;
      }
      // since we used a MAP to get the data, they are not sorted
      // so let's sort by the "date"
      data.sort(function(a, b) {
        return (a[0] < b[0]) ? -1 : (a[0] > b[0]) ? 1 : 0;
      });

      return {
        data: data,
        labels: labels,
        minY: minY,
        maxY: maxY * 1.1 // let's give is a small padding at the top in the graph
      };
    };

    var initGraphData = function(container, reservationTrendsData) {
      // save the data in the container
      container.data(DATA_ATTR_RES_TRENDS_DATA, reservationTrendsData);
    };

    var renderGraphs = function(container) {

      var chart = container.find(SEL_CHART_RES_TRENDS);

      // skip if hidden
      if (!chart.is(':visible')) {
        return;
      }

      var reservationTrendsData = container.data(DATA_ATTR_RES_TRENDS_DATA);

      var chartOptions = {
        legend: {
          show: false
        },
        tooltip: {
          show: true,
          content: function(seriesLabel, x, y) {
            var h = formatPadZero(x);
            var hours = h + ':00 - ' + h + ':59';
            return hours + " | %y";
          }
        },
        grid: {
          hoverable: true,
          clickable: true,
          margin: {
            top: 50,
            left: 30
          }
        },
        xaxis: {
          ticks: reservationTrendsData.labels,
          show: true,
          min: 0,
          max: 23,
          tickSize: 1,
          axisLabel: chart.data(DATA_ATTR_AXES_LABEL_Y)
        },
        yaxis: {
          min: reservationTrendsData.minY,
          max: reservationTrendsData.maxY
        }
      };

      var data = [
        {
          data: reservationTrendsData.data,
          label: reservationTrendsData.labels,
          color: ChartColors.get(0),
          lines: {
            show: true,
            fill: true
          }
        }
      ];

      chart.plot(data, chartOptions);

    };

    var convertDataToPieCharFlotFormat = function(rawData) {
      var data = [];
      var i = 0;
      for (var k in rawData) {
        var value = rawData[k];
        data.push({
          label: k,
          data: value,
          color: ChartColors.get(i)
        });
        i++;
      }
      return data;
    };

    var initPieChartData = function(container, statusesData, originData, purposeData) {

      // save the data in the container
      container.data(DATA_ATTR_STATUSES_DATA, statusesData);
      container.data(DATA_ATTR_ORIGINS_DATA, originData);
      container.data(DATA_ATTR_PURPOSES_DATA, purposeData);

    };

    var renderPieCharts = function(container) {

      var statusesData = container.data(DATA_ATTR_STATUSES_DATA);
      var originData = container.data(DATA_ATTR_ORIGINS_DATA);
      var purposeData = container.data(DATA_ATTR_PURPOSES_DATA);

      var chartOptions = {
        series: {
          pie: {
            show: true,
            radius: 1,
            label: {
              show: true,
              radius: 0.6,
              threshold: 0,
              formatter: function(label, series) {
                var amount = series.data[0] || [];
                amount = amount[1] || '';

                var elem = jQuery('<div />').addClass('sliceLabel');
                if (ChartColors.isDark(series.color)) {
                  elem.addClass('sliceLabel-light');
                }
                elem.append(jQuery('<span />').text(label));
                elem.append('<br />');
                elem.append(jQuery('<span />').text(amount + ' (' + Math.round(series.percent) + '%)'));

                return getHtml(elem);
              }
            }
          }
        },
        legend: {
          show: false
        },
        grid: {
          hoverable: true
        }
      };

      container.find(SEL_CHART_STATUSES).plot(statusesData, chartOptions);
      container.find(SEL_CHART_ORIGINS).plot(originData, chartOptions);
      container.find(SEL_CHART_PURPOSES).plot(purposeData, chartOptions);

    };

    this.init = function(initNode) {

      self = this;

      // Retrieve and cache dom nodes
      var moduleNodes       = initNode.find(SEL_MODULE);

      // Init all matching nodes
      moduleNodes.each(function() {

        var moduleNode = jQuery(this);

        var statusesData            = convertDataToPieCharFlotFormat(window.config.settingsStatistics.statusesData || {});
        var originData              = convertDataToPieCharFlotFormat(window.config.settingsStatistics.originData || {});
        var purposeData             = convertDataToPieCharFlotFormat(window.config.settingsStatistics.purposeData || {});
        var feedbackFoodRatings     = window.config.settingsStatistics.feedbackFoodRatings;
        var feedbackServiceRatings  = window.config.settingsStatistics.feedbackServiceRatings;

        if (!hasDataToShow(statusesData, originData, purposeData)) {
          moduleNode.addClass(CSS_CLASS_NO_DATA);
        } else {
          moduleNode.addClass(CSS_CLASS_HAS_DATA);
          initPieChartData(moduleNode, statusesData, originData, purposeData);
          renderPieCharts(moduleNode);

          var reservationTrendsData   = convertDataToGraphFlotFormat(window.config.settingsStatistics.reservationTrendData || {});
          initGraphData(moduleNode, reservationTrendsData);
          renderGraphs(moduleNode);

          jQuery(window).resize(function() {
            renderPieCharts(moduleNode);
            renderGraphs(moduleNode);
          });
        }

      });
    };

};

// Make class public to outside world
module.exports = ReservationStatus;
},{"../mediator/mediator":103,"./ChartColors":156,"flot-axislabels/jquery.flot.axislabels":8,"jquery.flot.tickrotor":46,"jquery.flot.tooltip/js/jquery.flot.tooltip":10,"jquery.flot/jquery.flot":11,"jquery.flot/jquery.flot.pie":12,"jquery.flot/jquery.flot.time":13,"jquery/dist/jquery":14}],161:[function(require,module,exports){
/**
 * TimePeriodSelection functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var Datepicker    = require('bootstrap.datepicker');
DateUtils     = require('../utils/DateUtils');



// Class definition
TimePeriodSelection = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                    = '.mod-stats-timeperiod-section';
  var SEL_TIMEPERIOD_DATE_FIELDS    = '[data-timeperiod-date-field]';

  var DATA_ATTR_TIMEPERIOD_FIELD    = 'timeperiodDateField';
  var DATA_ATTR_DATE_FORMAT         = 'dateFormat';
  var DATA_ATTR_CALENDAR_LANG_CODE  = 'calendarLanguageCode';

  /**
   * Fills up a string with given substrings.
   */
  var pad = function(str, length, pad) {
    var s = String(str);
    while (s.length < length) {s = pad + s;}
    return s;
  }

  /**
   * Returns date string from given calendar node.
   */
  var getSelectedDate = function(node) {
    var date = node.datepicker('getDate');
    return date.getFullYear() + '-' + pad(date.getMonth() + 1, 2, 0) + '-' + pad(date.getDate(), 2, 0);
  };

  var initTimeperiodDatepickers = function(node, dateFormat, language) {
    var dateUtils = new DateUtils();

    node.each(function() {
      var input = jQuery(this);
      var group = input.parents('.date');

      // remember the inital value, and clear the value
      var value = input.val();
      input.val('');

      group.datepicker({
        format: dateFormat,
        language: language,
        weekStart: 1,
        autoclose: true,
        todayHighlight: false
      });

      if (value !== '') {
        try {
          var date = dateUtils.parseDate(value);
          group.datepicker('setDate', new Date(date));
        } catch (ignored) { }
      }

    });
  };


  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes           = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var timePeriodDateFields    = moduleNode.find(SEL_TIMEPERIOD_DATE_FIELDS);

      var dateFormat              = moduleNode.data(DATA_ATTR_DATE_FORMAT);
      var language                = moduleNode.data(DATA_ATTR_CALENDAR_LANG_CODE);

      // time period section
      initTimeperiodDatepickers(timePeriodDateFields, dateFormat, language);

      timePeriodDateFields.on('change', function() {
        var input = jQuery(this);
        var datepicker = input.parents('.date');
        var field = jQuery(input.data(DATA_ATTR_TIMEPERIOD_FIELD));
        field.val(getSelectedDate(datepicker));
      });

    });

  };

};

// Make class public to outside world
module.exports = TimePeriodSelection;

},{"../utils/DateUtils":185,"bootstrap.datepicker":26,"jquery/dist/jquery":14}],162:[function(require,module,exports){
/**
 * Utilization functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs

// they don't need references, only need to be imported
require('jquery.flot/jquery.flot');
require('jquery.flot/jquery.flot.time');
require('flot-axislabels/jquery.flot.axislabels');
require('jquery.flot.tickrotor');
require('jquery.flot.tooltip/js/jquery.flot.tooltip');

jQuery = require('jquery/dist/jquery');

DateUtils   	= require('../utils/DateUtils');
ChartColors   	= require('./ChartColors');


// Class definition
Utilization = function() {

  // self references
  var self;

  // selector constants
  var SEL_MODULE                        = '.mod-stats-utilization';
  var SEL_CHART                         = '.chartUtilizations';
  var SEL_CHART_TOOLS                   = '.chartUtilizationsTools';
  var SEL_CHART_SERIES_CHECKBOX         = 'input[type="checkbox"]';

  var SEL_DATA_ATTR_LABELS_RESERVATIONS = 'labelsReservations';
  var SEL_DATA_ATTR_LABELS_GUESTS       = 'labelsGuests';
  var SEL_DATA_ATTR_PLOT_DATA           = 'plotData';
  var SEL_DATA_ATTR_DATE_FORMAT         = 'dateFormat';
  var SEL_DATA_ATTR_NAME                = 'name';

  var CHART_SELECTIONS_RESERVATIONS     = 'reservations';
  var CHART_SELECTIONS_GUESTS           = 'guests';

  var RGX_RAW_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

  var formatDate = function (strDate, outputFormat) {
    var groups = RGX_RAW_DATE.exec(strDate);
    if (!groups) {
      return strDate;
    }
    // use the format, but replace the date
    outputFormat = outputFormat.replace(/d+/i, groups[3]);
    outputFormat = outputFormat.replace(/m+/i, groups[2]);
    outputFormat = outputFormat.replace(/y+/i, groups[1]);
    return outputFormat;
  };

  var isChecked = function(checkboxes, name) {
    return checkboxes.filter(function() {
      return jQuery(this).data(SEL_DATA_ATTR_NAME) == name;
    }).is(':checked');
  };

  var convertDataToFlotFormat = function(rawData, dateFormat) {
    var data = [];
    var labels = [];

    var i = 0;
    for (var k in rawData) {
      var y = rawData[k];
      data.push([i, y]);
      labels.push([i, formatDate(k, dateFormat)]);
      i++;
    }
    // since we used a MAP to get the data, they are not sorted
    // so let's sort by the "date"
    data.sort(function(a, b) {
      return (a[0] < b[0]) ? -1 : (a[0] > b[0]) ? 1 : 0;
    });

    return {
      data: data,
      labels: labels
    };
  };

  var getDataFromSelections = function(container, reservationData, guestData, selections) {

    var data = [];

    // reservations should come first, since this number will always be smaller
    if (selections[CHART_SELECTIONS_RESERVATIONS]) {
      data.push({
        data: reservationData,
        label: container.data(SEL_DATA_ATTR_LABELS_RESERVATIONS),
        color: ChartColors.get(0),
        lines: {
          show: true,
          fill: true
        }
      });
    }

    // then guests at the back
    if (selections[CHART_SELECTIONS_GUESTS]) {
      data.push({
        data: guestData,
        label: container.data(SEL_DATA_ATTR_LABELS_GUESTS),
        color: ChartColors.get(2),
        lines: {
          show: true,
          fill: true
        }
      });
    }

    return data;

  };

  var initChartData = function(container, chartNode, chartToolsNode, reservationData, guestData, xAxisLabels) {

    var checkboxes = chartToolsNode.find(SEL_CHART_SERIES_CHECKBOX);

    var selections = {};
    selections[CHART_SELECTIONS_RESERVATIONS] = isChecked(checkboxes, CHART_SELECTIONS_RESERVATIONS);
    selections[CHART_SELECTIONS_GUESTS] = isChecked(checkboxes, CHART_SELECTIONS_GUESTS);;

    var data = getDataFromSelections(container, reservationData, guestData, selections);
    container.data(SEL_DATA_ATTR_PLOT_DATA, data);

    checkboxes.on('change', function(event) {

      var checkbox = jQuery(this);

      // atleast one has to be checked
      if (!checkboxes.filter(':checked').length) {
        checkbox.prop('checked', true);
      }

      var name = checkbox.data(SEL_DATA_ATTR_NAME);
      selections[name] = checkbox.is(':checked');

      // update the data
      var data = getDataFromSelections(container, reservationData, guestData, selections);
      container.data(SEL_DATA_ATTR_PLOT_DATA, data);

      renderChart(container, chartNode, xAxisLabels);
    });

  };

  var renderChart = function(container, chartNode, xAxisLabels) {

    // skip if hidden
    if (!chartNode.is(':visible')) {
      return;
    }

    var data = container.data(SEL_DATA_ATTR_PLOT_DATA);

    var dateMap = {};
    xAxisLabels.forEach(function(item) {
      var key = '' + item[0];
      dateMap[key] = item[1];
    });

    chartNode.plot(data, {
      legend: {
        position: "ne",
        show: true,
        margin: [0, -50]
      },
      tooltip: {
        show: true,
        content: function(seriesLabel, x, y) {
          var date = dateMap['' + x]; // the key needs to be a string
          return date + " | %y";
        }
      },
      grid: {
        hoverable: true,
        clickable: true,
        margin: {
          top: 50,
          left: 30
        }
      },
      xaxis: {
        ticks: xAxisLabels,
        show: true,
        tickSize: 1,
        axisLabelUseCanvas: true,
        axisLabelFontSizePixels: 12,
        axisLabelFontFamily: 'arial,sans-serif',
        axisLabelPadding: 100,
        rotateTicks: 135
      },
      yaxis: {
        min: 0,
        minTickSize: 1
      }
    });

  };


  /**
   * Initialize.
   */
  this.init = function(initNode) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes       = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);
      var chartNode = moduleNode.find(SEL_CHART);
      var chartToolsNode = moduleNode.find(SEL_CHART_TOOLS);

      var dateFormat = moduleNode.data(SEL_DATA_ATTR_DATE_FORMAT);

      var reservationData = convertDataToFlotFormat(window.config.settingsStatistics.reservationData || {}, dateFormat);
      var guestData = convertDataToFlotFormat(window.config.settingsStatistics.guestData || {}, dateFormat);

      var xAxisLabels = reservationData.labels;

      initChartData(moduleNode, chartNode, chartToolsNode, reservationData.data, guestData.data, xAxisLabels);
      renderChart(moduleNode, chartNode, xAxisLabels);

      jQuery(window).resize(function() {
        renderChart(moduleNode, chartNode, xAxisLabels);
      });

    });

  };

};

// Make class public to outside world
module.exports = Utilization;

},{"../mediator/mediator":103,"../utils/DateUtils":185,"./ChartColors":156,"flot-axislabels/jquery.flot.axislabels":8,"jquery.flot.tickrotor":46,"jquery.flot.tooltip/js/jquery.flot.tooltip":10,"jquery.flot/jquery.flot":11,"jquery.flot/jquery.flot.time":13,"jquery/dist/jquery":14}],163:[function(require,module,exports){


/**
 * Stats functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
var ReservationStatus = require('./ReservationStatus');
var Utilization = require('./Utilization');
var TimePeriodSelection = require('./TimePeriodSelection');
var Insights = require('./Insights');
var Overview = require('./Overview');
var GradientTable = require('./GradientTable');
var BannerTracking = require('./BannerTracking')


// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var timePeriodSelection = new TimePeriodSelection();
	var utilization = new Utilization();
	var reservationStatus = new ReservationStatus();
	var insights = new Insights();
	var overview = new Overview();
	var gradientTable = new GradientTable();
	var bannerTracking = new BannerTracking();

	// Trigger onload activities
	reservationStatus.init(initNode);
	utilization.init(initNode);
	timePeriodSelection.init(initNode);
	insights.init(initNode);
	overview.init(initNode);
	gradientTable.init(initNode);
	bannerTracking.init(initNode);

});

},{"../mediator/mediator":103,"./BannerTracking":155,"./GradientTable":157,"./Insights":158,"./Overview":159,"./ReservationStatus":160,"./TimePeriodSelection":161,"./Utilization":162}],164:[function(require,module,exports){
/**
* RectTable functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
require('fabric/dist/fabric');
var TablePlannerUtils     = require('./TablePlannerUtils');

// Class definition
var RectTable = function() {

  var self = this;

  this.CONST_CHAIR_WIDTH = 30;

  this.CONST_TABLE_HEIGHT = 60;
  this.CONST_TABLEVIEW_HEIGHT = 121;
  this.CONST_TABLE_SHADOW = "rgba(0, 0, 0, 0.7) 0 0 25px";

  this.CONST_ACTIVE_TABLE_COLOR = "red";

  //to change the color for all tables to light gray (in edit mode)
  var mode = window.location.href.indexOf('editMode') > -1 ? 'editMode' : 'viewMode';

  this.CONST_MAP_TABLES_STATUSES_COLORS = {
    "ARRIVED": "#c3425f",
    "CONFIRMED": "#fbac24",
    "UNCONFIRMED": "#143c34",
    "AVAILABLE": mode == 'viewMode' ? "#42c3a6" : "#939393",
    "INACTIVE": "#393938"
  };


  /**
   * Create rect table with data from BE
   * @param  { id: number, tableName: string, guestsNumber: number, left: number, top: number, status: string, } data
   * @param {fabric.Canvas} canvas
   *  @return {fabric.Group}
   */
  this.createRectTableWithData = function(data, canvas) {
    // Get array of table ojects [activeLayer, chairs, tableCover, tableText]
    var preparedTableObjects = self.prepareTableObjects(data);

    // Get array of table text ojects [activeLayer, chairs, tableCover, tableText]
    var preparedTableObjectsText = self.prepareTableObjectsText(data);

    // Group activeLayer, chairs, tableCover as one object
    var groupedTable = new fabric.Group(preparedTableObjects, {
      left: data.xPosition,
      top: data.yPosition,
      centeredRotation: true,
      snapAngle: 15,
      selectable: true,
      tableId: data.id,
      lockScalingX: true,
      lockScalingY: true,
      type: "table",
      reservationIds: data.reservationIds || [],
      hasBorders: false,
      hasRotatingPoint: true,
      angle: data.angle,
      shape: data.shape
    });

    var tableWidth = self.getTableWidth(data.capacity) + 60;
    var tableTextPosition = self.setTableNamePosition(data.angle, tableWidth, self.CONST_TABLEVIEW_HEIGHT, data.xPosition, data.yPosition, data.capacity);
    var tableTextLeft = tableTextPosition[0];
    var tableTextTop = tableTextPosition[1];

    // Group activeLayer, chairs, tableCover and tableTextId as one object
    var groupedTableText = new fabric.Group(preparedTableObjectsText, {
      left: tableTextLeft,
      top: tableTextTop,
      tableTextId: data.id,
      lockScalingX: true,
      lockScalingY: true,
      type: "tableText",
      lockRotation: true,
      lockMovementX:true,
      lockMovementY:true,
      selectable: false
    });

    var extendedGroupTable = self.extendGroupTable(data, groupedTable);
    
    canvas.add(extendedGroupTable);
    canvas.add(groupedTableText);
    return extendedGroupTable;
  };

  /**
   * @description Set the table name at the time of moving and during save (in view mode)
   * @param {*} tableAngle 
   * @param {*} tableWidth 
   * @param {*} tableHeight 
   * @param {*} tableLeft 
   * @param {*} tableTop 
   * @param {*} tableCapacity 
   */
  this.setTableNamePosition = function(tableAngle, tableWidth, tableHeight, tableLeft, tableTop, tableCapacity){
    var tableTextLeft = tableLeft;
    var tableTextTop = tableTop + 115;

    if(tableAngle == 0){
      tableTextLeft = tableLeft + 5;
      tableTextTop = tableTop + tableHeight;
    }else if(tableAngle == 15){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 20;
            tableTextTop = tableTop + tableWidth + 10;
        }else if(tableCapacity >= 5 && tableCapacity <= 10){
            tableTextLeft = tableLeft - 20;
            tableTextTop = tableTop + tableHeight + 30;
        }else{
            tableTextLeft = tableLeft - 40;
            tableTextTop = tableTop + tableHeight + 55;
        }
    }else if(tableAngle == 30){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 50;
            tableTextTop = tableTop + tableWidth + 20;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - 65;
            tableTextTop = tableTop + tableHeight + 45;
        }else if(tableCapacity >= 7 && tableCapacity <= 10){
            tableTextLeft = tableLeft - 75;
            tableTextTop = tableTop + tableHeight + 50;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - 80;
            tableTextTop = tableTop + tableHeight + 85;
        }else{
            tableTextLeft = tableLeft - 100;
            tableTextTop = tableTop + tableHeight + 95;
        }
    }else if(tableAngle == 45){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 60;
            tableTextTop = tableTop + tableWidth + 15;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - 55;
            tableTextTop = tableTop + tableHeight + 50;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - 50;
            tableTextTop = tableTop + tableHeight + 80;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - 40;
            tableTextTop = tableTop + tableHeight + 110;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - 20;
            tableTextTop = tableTop + (1.5*tableHeight) + 80;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft;
            tableTextTop = tableTop + (2*tableHeight) + 55;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft;
            tableTextTop = tableTop + (2.5*tableHeight) + 30;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft + 20;
            tableTextTop = tableTop + (3*tableHeight);
        }else{
            tableTextLeft = tableLeft + 30;
            tableTextTop = tableTop + (3.5*tableHeight) - 20;
        }
    }else if(tableAngle == 60){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 80;
            tableTextTop = tableTop + tableWidth + 15;
        }else if(tableCapacity >= 5 && tableCapacity <= 10){
            tableTextLeft = tableLeft - 90;
            tableTextTop = tableTop + tableWidth;
        }else{
            tableTextLeft = tableLeft - 70;
            tableTextTop = tableTop + tableWidth - 15;
        }
    }else if(tableAngle == 75){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 100;
            tableTextTop = tableTop + tableWidth + 5;
        }else if(tableCapacity >= 5 && tableCapacity <= 8){
            tableTextLeft = tableLeft - 120;
            tableTextTop = tableTop + tableWidth;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - 130;
            tableTextTop = tableTop + tableWidth;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - 140;
            tableTextTop = tableTop + tableWidth;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - 150;
            tableTextTop = tableTop + tableWidth;
        }else if(tableCapacity >= 15 && tableCapacity <= 18){
            tableTextLeft = tableLeft - 160;
            tableTextTop = tableTop + tableWidth - 5;
        }else{
            tableTextLeft = tableLeft - 180;
            tableTextTop = tableTop + tableWidth - 5;
        }
    }else if(tableAngle == 90){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 120;
            tableTextTop = tableTop + tableWidth - 5;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - tableHeight - 20;
            tableTextTop = tableTop + tableWidth;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - tableHeight - 40;
            tableTextTop = tableTop + tableWidth;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - tableHeight - 70;
            tableTextTop = tableTop + tableWidth;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - (2*tableHeight) + 30;
            tableTextTop = tableTop + tableWidth - 5;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - (2*tableHeight) + 10;
            tableTextTop = tableTop + tableWidth - 5;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - (2*tableHeight) - 10;
            tableTextTop = tableTop + tableWidth - 5;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - (2*tableHeight) - 35;
            tableTextTop = tableTop + tableWidth - 5;
        }else{
            tableTextLeft = tableLeft - (2*tableHeight) - 55;
            tableTextTop = tableTop + tableWidth - 5;
        }
    }else if(tableAngle == 105){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 135;
            tableTextTop = tableTop + tableWidth - 15;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - (1.5*tableHeight) + 10;
            tableTextTop = tableTop + tableWidth - 20;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - (1.5*tableHeight) - 30;
            tableTextTop = tableTop + tableWidth - 20;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - (1.5*tableHeight) - 60;
            tableTextTop = tableTop + tableWidth - 20;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - (2.5*tableHeight) + 25;
            tableTextTop = tableTop + tableWidth - 30;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - (2.5*tableHeight) - 10;
            tableTextTop = tableTop + tableWidth - 30;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - (2.5*tableHeight) - 40;
            tableTextTop = tableTop + tableWidth - 30;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - (3*tableHeight) - 20;
            tableTextTop = tableTop + tableWidth - 25;
        }else{
            tableTextLeft = tableLeft - (3*tableHeight) - 55;
            tableTextTop = tableTop + tableWidth - 25;
        }
    }else if(tableAngle == 120){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 140;
            tableTextTop = tableTop + tableWidth - 40;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - tableHeight - 80;
            tableTextTop = tableTop + tableWidth - 30;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - (2*tableHeight);
            tableTextTop = tableTop + tableWidth - 50;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = 0;
            tableTextTop = tableTop + tableWidth - 50;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - (3*tableHeight) + 20;
            tableTextTop = tableTop + tableWidth - 75;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - (3*tableHeight) - (2.5*tableCapacity);
            tableTextTop = tableTop + tableWidth - 75;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - (3*tableHeight) - (3*tableCapacity) - 20;
            tableTextTop = tableTop + tableWidth - 75;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - (4*tableHeight) + 15;
            tableTextTop = tableTop + tableWidth - 80;
        }else{
            tableTextLeft = tableLeft - (4*tableHeight) - 40;
            tableTextTop = tableTop + tableWidth - 80;
        }
    }else if(tableAngle == 135){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 140;
            tableTextTop = tableTop + tableWidth - 60;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - (1.5*tableHeight) - (5*tableCapacity);
            tableTextTop = tableTop + tableWidth - 90;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - (2*tableHeight) - 20;
            tableTextTop = tableTop + tableWidth - 90;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - (2.5*tableHeight) - 30;
            tableTextTop = tableTop + tableWidth - 100;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - (3*tableHeight) - (2.5*tableCapacity);
            tableTextTop = tableTop + tableWidth - 120;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - (3.5*tableHeight) - (1.5*tableCapacity);
            tableTextTop = tableTop + tableWidth - 120;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - (4*tableHeight) - (1.5*tableCapacity);
            tableTextTop = tableTop + tableWidth - 140;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - (4*tableHeight) - 50;
            tableTextTop = tableTop + tableWidth - 170;
        }else{
            tableTextLeft = tableLeft - (4.5*tableHeight) - 50;
            tableTextTop = tableTop + tableWidth - 170;
        }
    }else if(tableAngle == 150){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 140;
            tableTextTop = tableTop + tableWidth - 80;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - (1.5*tableHeight) - (2*tableCapacity);
            tableTextTop = tableTop + tableWidth - 105;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - (1.5*tableHeight) - (4.5*tableCapacity);
            tableTextTop = tableTop + tableWidth - 130;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - (2*tableHeight) - (3*tableCapacity);
            tableTextTop = tableTop + tableWidth - 160;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - (3*tableHeight);
            tableTextTop = tableTop + tableWidth - 170;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - (3.5*tableHeight);
            tableTextTop = tableTop + tableWidth - 195;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - (4*tableHeight);
            tableTextTop = tableTop + tableWidth - 225;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - (4*tableHeight) - 30;
            tableTextTop = tableTop + tableWidth - 245;
        }else{
            tableTextLeft = tableLeft - (5*tableHeight) - 30;
            tableTextTop = tableTop + tableWidth - 270;
        }                 
    }else if(tableAngle == 165){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 120;
            tableTextTop = tableTop + tableWidth - 110;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - (1.5*tableHeight);
            tableTextTop = tableTop + tableWidth - 135;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - (1.5*tableHeight) - (4.5*tableCapacity);
            tableTextTop = tableTop + tableWidth - 170;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - (2*tableHeight) - (4*tableCapacity);
            tableTextTop = tableTop + tableWidth - 205;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - (2.5*tableHeight);
            tableTextTop = tableTop + tableWidth - 240;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - (3*tableHeight);
            tableTextTop = tableTop + tableWidth - 280;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - (3*tableHeight) - (2*tableCapacity);
            tableTextTop = tableTop + tableWidth - 320;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - (4*tableHeight);
            tableTextTop = tableTop + tableWidth - 350;
        }else{
            tableTextLeft = tableLeft - (4*tableHeight);
            tableTextTop = tableTop + tableWidth - 400;
        }                 
    }else if(tableAngle == 180){
        tableTextLeft = tableLeft - tableWidth;
        tableTextTop = tableTop;
    }else if(tableAngle == 345){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft + 20;
            tableTextTop = tableTop + tableWidth - 15;
        }else if(tableCapacity >= 5 && tableCapacity <= 10){
            tableTextLeft = tableLeft + 20;
            tableTextTop = tableTop + tableHeight - 30;
        }else{
            tableTextLeft = tableLeft + 40;
            tableTextTop = tableTop + tableHeight - 50;
        }
    }else if(tableAngle == 330){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft + 25;
            tableTextTop = tableTop + tableWidth - 50;
        }else if(tableCapacity >= 5 && tableCapacity <= 10){
            tableTextLeft = tableLeft + 40;
            tableTextTop = tableTop + tableHeight - 50;
        }else if(tableCapacity > 10 && tableCapacity <= 16){
            tableTextLeft = tableLeft + 50;
            tableTextTop = tableTop + tableHeight - 80;
        }else{
            tableTextLeft = tableLeft + 40;
            tableTextTop = tableTop + tableHeight - 100;
        }
    }else if(tableAngle == 315){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft + 30;
            tableTextTop = tableTop + tableWidth - 70;
        }else if(tableCapacity >= 5 && tableCapacity <= 10){
            tableTextLeft = tableLeft;
            tableTextTop = tableTop + tableHeight - 70;
        }else if(tableCapacity > 10 && tableCapacity <= 16){
            tableTextLeft = tableLeft - 60;
            tableTextTop = tableTop + tableHeight - 75;
        }else{
            tableTextLeft = tableLeft + 20;
            tableTextTop = tableTop + tableHeight - 140;
        }
    }else if(tableAngle == 300){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft + 20;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - 10;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - 40;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - 60;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - 85;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - 100;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - 130;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - 145;
        }else {
            tableTextLeft = tableLeft - 170;
        }
        tableTextTop = tableTop + tableHeight - 90;
    }else if(tableAngle == 285){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft + 10;
            tableTextTop = tableTop + tableHeight - 105;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - 25;
            tableTextTop = tableTop + tableHeight - 105;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - 40;
            tableTextTop = tableTop + tableHeight - 105;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - 65;
            tableTextTop = tableTop + tableHeight - 105;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - 90;
            tableTextTop = tableTop + tableHeight - 105;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - 110;
            tableTextTop = tableTop + tableHeight - 105;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - 130;
            tableTextTop = tableTop + tableHeight - 105;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - 150;
            tableTextTop = tableTop + tableHeight - 105;
        }else{
            tableTextLeft = tableLeft - 175;
            tableTextTop = tableTop + tableHeight - 105;
        }
    }else if(tableAngle == 270){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft;
            tableTextTop = tableTop + tableWidth - 120;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - 20;
            tableTextTop = tableTop + tableHeight - 120;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - 40;
            tableTextTop = tableTop + tableHeight - 120;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - 65;
            tableTextTop = tableTop + tableHeight - 120;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - 85;
            tableTextTop = tableTop + tableHeight - 120;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - 115;
            tableTextTop = tableTop + tableHeight - 120;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - 135;
            tableTextTop = tableTop + tableHeight - 120;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - 155;
            tableTextTop = tableTop + tableHeight - 120;
        }else {
            tableTextLeft = tableLeft - 180;
            tableTextTop = tableTop + tableHeight - 120;
        }
    }else if(tableAngle == 255){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 10;
            tableTextTop = tableTop + tableWidth - 135;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - 35;
            tableTextTop = tableTop + tableHeight - 135;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - 60;
            tableTextTop = tableTop + tableHeight - 135;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - 80;
            tableTextTop = tableTop + tableHeight - 135;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - 100;
            tableTextTop = tableTop + tableHeight - 135;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - 120;
            tableTextTop = tableTop + tableHeight - 135;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - 145;
            tableTextTop = tableTop + tableHeight - 135;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - 165;
            tableTextTop = tableTop + tableHeight - 135;
        }else{
            tableTextLeft = tableLeft - 190;
            tableTextTop = tableTop + tableHeight - 135;
        }
    }else if(tableAngle == 240){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 40;
            tableTextTop = tableTop + tableWidth - 150;
        }else if(tableCapacity >= 5 && tableCapacity <= 8){
            tableTextLeft = tableLeft - 70;
            tableTextTop = tableTop + tableHeight - 150;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - 100;
            tableTextTop = tableTop + tableHeight - 150;
        }else if(tableCapacity > 10 && tableCapacity <= 14){
            tableTextLeft = tableLeft - 125;
            tableTextTop = tableTop + tableHeight - 150;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - 125;
            tableTextTop = tableTop + tableHeight - 160;
        }else{
            tableTextLeft = tableLeft - 190;
            tableTextTop = tableTop + tableHeight - 150;
        }
    }else if(tableAngle == 225){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 60;
            tableTextTop = tableTop + tableWidth - 155;
        }else if(tableCapacity >= 5 && tableCapacity <= 10){
            tableTextLeft = tableLeft - 100;
            tableTextTop = tableTop + tableHeight - 155;
        }else if(tableCapacity > 10 && tableCapacity <= 14){
            tableTextLeft = tableLeft - 150;
            tableTextTop = tableTop + tableHeight - 155;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - 190;
            tableTextTop = tableTop + tableHeight - 155;
        }else{
            tableTextLeft = tableLeft - 215;
            tableTextTop = tableTop + tableHeight - 155;
        }
    }else if(tableAngle == 210){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 90;
            tableTextTop = tableTop + tableWidth - 150;
        }else if(tableCapacity == 5 || tableCapacity == 6){
            tableTextLeft = tableLeft - tableHeight - 20;
            tableTextTop = tableTop + tableHeight - 150;
        }else if(tableCapacity == 7 || tableCapacity == 8){
            tableTextLeft = tableLeft - (1.5*tableHeight);
            tableTextTop = tableTop + tableHeight - 160;
        }else if(tableCapacity == 9 || tableCapacity == 10){
            tableTextLeft = tableLeft - (1.5*tableHeight) - 20;
            tableTextTop = tableTop + tableHeight - 150;
        }else if(tableCapacity == 11 || tableCapacity == 12){
            tableTextLeft = tableLeft - (2*tableHeight) - 40;
            tableTextTop = tableTop + tableHeight - 180;
        }else if(tableCapacity == 13 || tableCapacity == 14){
            tableTextLeft = tableLeft - (2.5*tableHeight) - 40;
            tableTextTop = tableTop + tableHeight - 200;
        }else if(tableCapacity == 15 || tableCapacity == 16){
            tableTextLeft = tableLeft - (3*tableHeight);
            tableTextTop = tableTop + tableHeight - 200;
        }else if(tableCapacity == 17 || tableCapacity == 18){
            tableTextLeft = tableLeft - (3.5*tableHeight);
            tableTextTop = tableTop + tableHeight - 220;
        }else{
            tableTextLeft = tableLeft - (4*tableHeight);
            tableTextTop = tableTop + tableHeight - 260;
        }
    }else if(tableAngle == 195){
        if(tableCapacity < 5){
            tableTextLeft = tableLeft - 110;
            tableTextTop = tableTop + tableWidth - 145;
        }else if(tableCapacity >= 5 && tableCapacity <= 10){
            tableTextLeft = tableLeft - tableWidth;
            tableTextTop = tableTop + tableHeight - 145;
        }else if(tableCapacity > 10 && tableCapacity <= 16){
            tableTextLeft = tableLeft - tableWidth;
            tableTextTop = tableTop + tableHeight - 155;
        }else{
            tableTextLeft = tableLeft - tableWidth;
            tableTextTop = tableTop + tableHeight - 165;
        }
    }else{
        tableTextLeft = 0;
        tableTextTop = 0;
    }

    return [tableTextLeft, tableTextTop];
  }

     /**
      * Get canvas center
      * @param {fabric.Canvas} canvas
      * @return {Object} 
      */
     this.getCanvasCenter = function (canvas) {
      var areaObject = TablePlannerUtils.getAreaObject(canvas);

       return {
         top: areaObject.height / 2,
         left: areaObject.width / 2
       };
     };

  /**
   * Create default rect table without chairs
   * @param {number} id
   * @param {fabric.Canvas} canvas
   *  @return {fabric.Group}
   */
  this.createDefaultRectTable = function(id, canvas) {
    // Get array of table ojects [activeLayer, tableCover, tableText]
    var preparedTableObjects = self.prepareTableObjects("");

    // TODO: Double check if we will add new tables in the canvas center 
    var canvasCenter = self.getCanvasCenter(canvas);

    // Group activeLayer, chair, tableCover and tableText as one object
    var groupedTable = new fabric.Group(preparedTableObjects, {
      left: canvasCenter.left - 60,
      top: canvasCenter.top - 60,
      centeredRotation: true,
      snapAngle: 15,
      selectable: true,
      tableId: id,
      lockScalingX: true,
      lockScalingY: true,
      type: "table",
      isNewTable: true,
      hasBorders: false,
      hasRotatingPoint: true
    });

    // Add object to canvas
    canvas.add(groupedTable);
    return groupedTable;
  };

  /**
   * Update rect table with data recived from BE or edited by user,
   * What exactly we do:
   * 1) Create a new objects with new width, color, chairs and table text
   * 2) take coordinates and id from old table, delete old table and
   * create a new table (with old coordinates and id) by grouping updated(new) objects
   * @param {guestsNumber?: number, status?: string, tableName?: string} data
   * @param {fabric.Group} table
   * @param {fabric.Canvas} canvas
   * @return {fabric.Group}
   */
  this.updateRectTable = function(data, table, tableText, canvas) {
    // Get array of table ojects [activeLayer, chairs, tableCover, tableText]
    var preparedTableObjects = self.prepareTableObjects(data);

    // Get array of table text ojects [activeLayer, chairs, tableCover, tableText]
    var preparedTableObjectsText = self.prepareTableObjectsText(data);

    // Get data from old table group and remove it from canvas
    var tableGroupData = {
      left: table.left,
      top: table.top,
      tableId: table.tableId,
      isNewTable: !!table.isNewTable
    };
    
    canvas.remove(table);
    canvas.remove(tableText);

    // Group activeLayer, chairs, tableCover and tableText as one object
    var groupedTable = new fabric.Group(preparedTableObjects, {
      left: tableGroupData.left,
      top: tableGroupData.top,
      centeredRotation: true,
      snapAngle: 15,
      selectable: true,
      tableId: tableGroupData.tableId,
      lockScalingX: true,
      lockScalingY: true,
      type: "table",
      isNewTable: tableGroupData.isNewTable,
      hasBorders: false,
      hasRotatingPoint: true
    });

    var tableWidth = self.getTableWidth(table.tableCapacity) + 60;
    table.xPosition = table.xPosition === undefined ? table.left : table.xPosition;
    table.yPosition = table.yPosition === undefined ? table.top : table.yPosition;
    var tableTextPosition = self.setTableNamePosition(table.angle, tableWidth, self.CONST_TABLEVIEW_HEIGHT, table.xPosition, table.yPosition, table.tableCapacity);
    var tableTextLeft = tableTextPosition[0];
    var tableTextTop = tableTextPosition[1];

    // Group activeLayer, chairs, tableCover and tableTextId as one object
    var groupedTableText = new fabric.Group(preparedTableObjectsText, {
        left: tableTextLeft,
        top: tableTextTop,
        tableTextId: table.tableId,
        lockScalingX: true,
        lockScalingY: true,
        type: "tableText",
        lockRotation: true,
        lockMovementX:true,
        lockMovementY:true,
        selectable: false
    });

    var extendedGroupTable = self.extendGroupTable(data, groupedTable);

    canvas.add(extendedGroupTable);
    canvas.add(groupedTableText);
    return extendedGroupTable;
  };

  /**
   * Extend table object with additional data,
   * @param {object} data
   * @param {fabric.Group} table
   * @return {fabric.Group}
   */
  this.extendGroupTable = function(data, table) {
    // Adding some custom attributes
    table.tableCapacity = +data.capacity;
    table.isLocked = data.isLocked;
    table.tableName = data.name;
    table.xPosition = data.xPosition;
    table.yPosition = data.yPosition;
    table.tableStatus = data.status;
    table.priority = data.priority;
    table.angle = data.angle;
    table.shape = data.shape;
    table.isBlocked = data.isBlocked;
    return table;
  }

  /**
   * Prepare table objects:
   * 1) create activeLayer with correct width
   * 2) if available guest - create chairs with correct coordinates
   * 3) create tableCover with correct width
   * 4) create tableText with correct width
   * @param {guestsNumber?: number, status?: string, tableName?: string} data
   * @return {array[fabric.Object]}
   */
  this.prepareTableObjects  = function(data) {

    var guestsNumber = (data && data.capacity) || 0;
    var tableStatus = (data && data.status) || "inactive";

    var tableObjectsArray = [];

    var tableWidth =
      guestsNumber > 0
        ? self.getTableWidth(guestsNumber)
        : self.CONST_TABLE_HEIGHT;

    // Create active layer
    var activeLayer = self.createActiveLayer(tableWidth);
    tableObjectsArray.push(activeLayer);

    // Create chairs
    if (guestsNumber > 0) {
      var chairs = self.addChairs(guestsNumber, tableWidth, tableStatus, data.shape);
      tableObjectsArray.push(chairs);
    }

    // Create tableCover object
    var tableCover = self.createTableCover(tableWidth, tableStatus, data.shape);
    tableObjectsArray.push(tableCover);

    return tableObjectsArray;
  }

  /**
   * Prepare table objects:
   * 1) create activeLayer with correct width
   * 2) if available guest - create chairs with correct coordinates
   * 3) create tableCover with correct width
   * 4) create tableText with correct width
   * @param {guestsNumber?: number, status?: string, tableName?: string} data
   * @return {array[fabric.Object]}
   */
   this.prepareTableObjectsText  = function(data) {

    var guestsNumber = (data && data.capacity) || 0;
    var tableName = (data && data.name) || "";

    var tableObjectsTextArray = [];

    var tableWidth =
      guestsNumber > 0
        ? self.getTableWidth(guestsNumber)
        : self.CONST_TABLE_HEIGHT;

    // Create tableText
    var tableText = self.createTableText(tableWidth, tableName);
    tableObjectsTextArray.push(tableText);

    return tableObjectsTextArray;
  }

  /**
   * Calcualte width of the table
   * @param {number} guestsNumber
   * @return {number} tableWidth
   */
  this.getTableWidth  = function (guestsNumber) {
    var chairWidth = self.CONST_CHAIR_WIDTH;
    var distanceBeetweenChairs = chairWidth / 2;
    var chairsOnOneSide = 1;

    // Calculate number of chairs on one side
    if (guestsNumber % 2 && guestsNumber > 4) {
      // Round this number to bigger.
      // If we have 5 chairs, then on one side will be 2 chairs like:
      // Math.round((5 - 2(two chairs at the begginig and at the end of the table)) / 2(two sides - top and bottom)) = 2
      chairsOnOneSide = Math.round((guestsNumber - 2) / 2);
    } else {
      // Round this number to less.
      // If we have 6 chairs, then on one side will be 2 chairs like:
      // (6 - 2(two chairs at the begginig and at the end of the table)) / 2(two sides - top and bottom) = 2
      chairsOnOneSide = Math.floor((guestsNumber - 2) / 2);
    }

    // If chairsOnOneSide < 1 like for case where we have less then 4 chair
    // decided to have one chair on the side
    if (chairsOnOneSide < 1) chairsOnOneSide = 1;

    // Calculate table width
    // Ex. chairWidth = 50, chairsOnOneSide = 5, distanceBeetweenChairs = 25
    // tableWidth = (50 + 25) * 5 + 25 = 400
    // (50 + 25) * 5 - this is the width of 5 chairs with a distance between each other 25
    // + 25 add distance after last chair
    var tableWidth =
      (chairWidth + distanceBeetweenChairs) * chairsOnOneSide +
      distanceBeetweenChairs;

    return tableWidth;
  };

  /**
   * Add chairs to table group
   * @param {number} chairsQty
   * @param {number} tableWidth
   *  @return {fabric.Group}
   */
  this.addChairs = function(chairsQty, tableWidth, tableStatus, tableShape) {
    var chairs = [];
    var chairWidth = self.CONST_CHAIR_WIDTH;
    var distanceBeetweenChairs = chairWidth / 2;

    for (var i = 0; i < chairsQty; i++) {
      // Create new chair
      var newChair = new fabric.Rect({
        width: chairWidth,
        height: chairWidth,
        fill: self.CONST_MAP_TABLES_STATUSES_COLORS[tableStatus],
        rx: tableShape == "round" ? 50 : 10,
        ry: tableShape == "round" ? 50 : 10,
      });

      // Make chair order number for odd elemens as even, for correct offset calculation
      // thats means what chair has the same index but on another side of the table.
      // And set different offset top for chairs on top and bottom sides of the table
      var chairOrderNumber = i;
      if (chairOrderNumber % 2 == 0) {
        // This chair will be on the top side
        newChair.top = distanceBeetweenChairs;
      } else {
        // This chair will be on the bottom side
        chairOrderNumber = i - 1;
        newChair.top = chairWidth * 2 + distanceBeetweenChairs;
      }

      // Calculate chair offset left
      newChair.left =
        chairWidth +
        distanceBeetweenChairs +
        ((chairWidth + distanceBeetweenChairs) * chairOrderNumber) / 2;

      // The latest chair should be set on the side at the beginning of the table.
      // Do it only if we have more than 2 chairs
      if (chairsQty > 2 && i == chairsQty - 1) {
        newChair.top = chairWidth + distanceBeetweenChairs;
        newChair.left = distanceBeetweenChairs;
      }

      // Penultimate chair should be set on the side at the end of the table.
      // Do it only if we have more than 2 chairs and number of chairs is even.
      // If number of chair is odd - end of the table will be empty.
      if (chairsQty > 2 && !(chairsQty % 2) && i == chairsQty - 2) {
        newChair.top = chairWidth + distanceBeetweenChairs;
        newChair.left = tableWidth + distanceBeetweenChairs;
      }

      chairs.push(newChair);
    }

    return new fabric.Group(chairs);
  };

  /**
   * Create active layer
   * @param {number} tableWidth
   * @return {fabric.Object}
   */
  this.createActiveLayer = function(tableWidth) {
    return new fabric.Rect({
      width: tableWidth + self.CONST_CHAIR_WIDTH * 2,
      height:
        self.CONST_TABLE_HEIGHT +
        self.CONST_CHAIR_WIDTH * 2,
      rx: 50,
      ry: 50,
      fill: 'transparent',
      type: "activeLayer",
    });
  }

  /**
   * Create table cover
   * @param {number} tableWidth
   * @param {status} string
   * @return {fabric.Object}
   */
  this.createTableCover = function(tableWidth, status, shape) {
    return new fabric.Rect({
      width: tableWidth,
      height: self.CONST_TABLE_HEIGHT,
      fill: self.CONST_MAP_TABLES_STATUSES_COLORS[status],
      shadow: self.CONST_TABLE_SHADOW,
      rx: shape == "round" ? 50 : 10,
      ry: shape == "round" ? 50 : 10,
      top: self.CONST_CHAIR_WIDTH,
      left: self.CONST_CHAIR_WIDTH,
      tableStatus: status,
      type: "tableCover",
    });
  }

  /**
   * Create table text
   * @param {number} tableWidth
   * @param {tableText} string
   * @return {fabric.Object}
   */
  this.createTableText = function(tableWidth, tableText) {
    return new fabric.Textbox(tableText, {
      fontFamily: "Montserrat, sans-serif",
      fontSize: 16,
      fill: "#fff",
      textAlign: "center",
      top: self.CONST_TABLE_HEIGHT * 2,
      width: tableWidth + self.CONST_CHAIR_WIDTH * 2,
      type: "tableText",
    });
  }

};



// singleton pattern
var singleton = new RectTable();

// Make class public to outside world
module.exports = singleton;

},{"./TablePlannerUtils":166,"fabric/dist/fabric":7,"jquery/dist/jquery":14}],165:[function(require,module,exports){
/**
 * TableEditPlan functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
require('fabric/dist/fabric');
var RectTable             = require('./RectTable');
var TablePlannerUtils     = require('./TablePlannerUtils');
var UserInterfaceUtils 	  = require('../utils/UserInterfaceUtils');
Cookies = require('cookies');

// Class definition
TableEditPlan = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE								= '.mod-table-plan-edit-mode';
    var BTN_SAVE_AREA = '.btn-save-area';
    var SEL_CSRF = 'input[name="_csrf"]';

    var SEL_PAGE_BODY_CLASS = 'body.page-table-plan-edit';
    var SEL_AREA_TITLE = '.area-title-block';
    var SEL_AREA_NAME = 'input.area-name';
    var SEL_AREA_STATUS = 'input.area-status';
    var SEL_TABLES_LIST = '.tables-list';
    var SEL_TABLE_LIST_ITEM = '.table-list-item';
    var SEL_TABLE_NAME = '.table-name input';
    var SEL_TABLE_CAPACITY = '.table-capacity input';
    var SEL_TABLE_PRIORITY = '.table-priority select';
    var SEL_TABLE_SHAPE = '.table-shape select';
    var SEL_TABLE_STATUS = '.table-status';
    var SEL_TABLE_ONLINE_RESERVATION = '.table-online-reservation';
    var SEL_DELETE_LINK = '.delete-link';
    var SEL_TABLE_PATTERN = '.pattern-item';
    var SEL_ADD_TABLE_LINK = 'a.add-tables-link';
    var SEL_DELETE_AREA_LINK = ".delete-area-link";
    var SEL_HIDDEN_AREA_SELECTABLE_INPUT = '.area-selectable';

    var CLASS_EDIT_MODE_HTML = 'html-table-plan-edit-mode';
    var CLASS_ACTIVE_TABLE = 'active-table';
    var CLASS_ERROR = 'error';
    var CLASS_PATTERN_ITEM = 'pattern-item';
    var CLASS_LINK_DISABLED = 'disabled-link';

    var DATA_TABLE_ID = 'data-table-id'
    var DATA_TABLE_NAME = 'data-table-name';
    var DATA_TABLE_CAPACITY = 'data-table-capacity';
    var DATA_TABLE_PRIORITY = 'data-table-priority';
    var DATA_TABLE_SHAPE = 'data-table-shape';
    var DATA_TABLE_LOCKED = 'data-table-locked';
    var DATA_AREA_ID = 'data-area-id';
    var DATA_SINGLE_AREA = "data-single-area";
    var DATA_AREA_ID = "data-area-id";
    var DATA_TABLE_BLOCKED = "data-table-blocked";

    var MAX_CAPACITY = 20;
    var ZERO_CAPACITY = 0;

    var CONST_DELAY = 500;
    var CONST_CURRENT_MODE = 'editMode';
    var CONST_PLACEHOLDER_TABLE_ID = '%%%tableId%%%';
    var CONST_GRID = 30;
    var CONST_DEFAULT_CANVAS_SIZE = 500;
    var CONST_GET_AREAS_URL = "/tablePlan/areas";
    var saveButtonClickCount = 0;

    var isBlockedTableFeatureToggle = (window.config.tableEditPlan && window.config.tableEditPlan.isBlockedOnlineEnabled) ?  window.config.tableEditPlan.isBlockedOnlineEnabled == 'true' : false;

    this.snapToGrid = function(target) {
        target.set({
            left: (Math.round(target.left / (CONST_GRID / 2)) * CONST_GRID) / 2,
            top: (Math.round(target.top / (CONST_GRID / 2)) * CONST_GRID) / 2,
        });
    }

    /**
     * Scrolling tables list to active table
     * @param {jQuery.DOMElement} tablesList
     * @param {jQuery.DOMElement} activeTableInList
     */
    this.scrollTableListToActiveTable = function(tablesList, activeTableInList) {
        tablesList.stop().animate({ 
            scrollTop: activeTableInList[0].offsetTop - tablesList.height() / 2 + activeTableInList.height() / 2
        }, 300);
    }

    /**
     * Setting active table in list by clicking on table in canvas and scroll list to active table
     * @param {number[]} selectedTablesIds
     * @param {jQuery.DOMElement} tablesList
     */
    this.setActiveTableInList = function(selectedTablesIds, tablesList) {
        tablesList.find(SEL_TABLE_LIST_ITEM).removeClass(CLASS_ACTIVE_TABLE);

        if(selectedTablesIds) {
            selectedTablesIds.forEach(function(tableId){
                var activeTableInList = tablesList.find('[' + DATA_TABLE_ID + '="'+ tableId +'"]');
                activeTableInList.addClass(CLASS_ACTIVE_TABLE);
                self.scrollTableListToActiveTable(tablesList, activeTableInList);
            });
        }
    }

    /**
     * Update table on canvas
     * @param {jQuery.DOMElement} tableItem
     * @param {canvas} tablePlanner
     */
    this.updateTableOnCanvas = function(tableItem, tablePlanner, isAreaStatusChanged) {

        var tableId = +tableItem.attr(DATA_TABLE_ID);

        var selectedTable = TablePlannerUtils.getTableById(tableId, tablePlanner);
        var selectedTableText = TablePlannerUtils.getTableTextById(tableId, tablePlanner);

        var tableData = {
            name: tableItem.attr(DATA_TABLE_NAME),
            capacity: +tableItem.attr(DATA_TABLE_CAPACITY),
            priority: tableItem.attr(DATA_TABLE_PRIORITY),
            shape: tableItem.attr(DATA_TABLE_SHAPE),
            status: tableItem.attr(DATA_TABLE_LOCKED) === 'false' ? 'AVAILABLE' : 'INACTIVE',
            isLocked: tableItem.attr(DATA_TABLE_LOCKED) === 'false' ? false : true,
            angle: selectedTable.angle,
        };
        
        if(isBlockedTableFeatureToggle){
            tableData.isBlocked = tableItem.attr(DATA_TABLE_BLOCKED) === 'false' ? false : true;
        }
        
        var updatedRectTable = RectTable.updateRectTable(
            tableData,
            selectedTable,
            selectedTableText,
            tablePlanner
        );

        if (!isAreaStatusChanged) {
            tablePlanner.setActiveObject(updatedRectTable);
        }

    }

    /* 
    *
    * Handle delete area link
    * 
    */
    this.deactivateLink = function(deleteAreaLink, deactivateCondition) {
        deleteAreaLink.toggleClass(CLASS_LINK_DISABLED, deactivateCondition);
        var tooltipContent = deactivateCondition ? window.config.tableEditPlan.deleteAreaLinkTooltip : "";
        deleteAreaLink.attr("title", tooltipContent);
    }

    /* 
    *
    * Delete area link activation / deactivation logic
    * 
    */
    this.deleteAreaLinkHandler = function(data) {
        var deleteAreaLink = jQuery(SEL_DELETE_AREA_LINK);
        deleteAreaLink.attr(DATA_SINGLE_AREA, data.isLastArea);
        deleteAreaLink.attr(DATA_AREA_ID, data.areaId);
        var deactivateLinkCondition = deleteAreaLink.attr(DATA_SINGLE_AREA) == "true" ||  (!!data.tables && data.tables.length != 0);
        self.deactivateLink(deleteAreaLink, deactivateLinkCondition);
    }

    /**
   * Creating tables list and drawing tables on canvas
   * @param {object} data
   * @param {jQuery.DOMElement} areaTitle
   * @param {jQuery.DOMElement} tablesList
   * @param {fabric.Canvas} tablePlanner
   */
  this.createArea = function(data, areaTitle, tablesList, tablePlanner) {
    if(data && data.tableCapacityLimit){
        MAX_CAPACITY = data.tableCapacityLimit;
        ZERO_CAPACITY = data.tableCapacityLimit;
    }
    areaTitle.removeClass('hidden');
    areaTitle.attr(DATA_AREA_ID, data.areaId);

    areaTitle.find(SEL_AREA_NAME).val(data.areaName);
    areaTitle.find(SEL_AREA_STATUS).prop('checked', !data.areaIsLocked);
    //set the value of area selectable in hidden input to retain it for settings page even area is disabled
    areaTitle.find(SEL_HIDDEN_AREA_SELECTABLE_INPUT).val(data.areaIsSelected);

    self.deleteAreaLinkHandler(data);

    // Prepare layer for area background
    var areaObject = new fabric.Rect({
        width: (data.areaWidth || CONST_DEFAULT_CANVAS_SIZE),
        height: (data.areaHeight || CONST_DEFAULT_CANVAS_SIZE),
        fill: "",
        selectable: false,
        type: 'bgCanvas'
    });
    areaObject.fill = new fabric.Pattern(
        {
            source: window.config.tableEditPlan.gridImg,
        },
        function () {
            areaObject.dirty = true;
            tablePlanner.requestRenderAll();
        }
    );
    tablePlanner.add(areaObject);

    var tablePattern = tablesList.find(SEL_TABLE_PATTERN);

    var posX = 40;
    var posY = 40;
    var areaNewWidth = 0;
    var areaNewHeight = 0;
    //TODO: just for demo
    var avarageWidth = 20;
    var avarageHeight = 50;
    var beetwenTables = 150;
    var groupedTable;
    var maxWidthTable = 0;
    var maxHeightTable = 0;

    (data.tables || []).forEach(function(tableItem, index) {

        var newTable = tablePattern.clone(true).html();
        newTable = jQuery(newTable.replace(new RegExp(CONST_PLACEHOLDER_TABLE_ID, 'g'), tableItem.id));

        // Set name
        newTable.find(SEL_TABLE_NAME).val(tableItem.name);
        newTable.attr(DATA_TABLE_NAME, tableItem.name);

        // Set capacity
        newTable.find(SEL_TABLE_CAPACITY).val(tableItem.capacity);
        newTable.attr(DATA_TABLE_CAPACITY, tableItem.capacity);

        // Set priority
        newTable.find(SEL_TABLE_PRIORITY).val(tableItem.priority);
        newTable.attr(DATA_TABLE_PRIORITY, tableItem.priority);

        // Set Shape
        newTable.find(SEL_TABLE_SHAPE).val(tableItem.shape);
        newTable.attr(DATA_TABLE_SHAPE, tableItem.shape);

        //Set activity
        newTable.find(SEL_TABLE_STATUS).prop('checked', !tableItem.isLocked);

        if(isBlockedTableFeatureToggle){
            newTable.find(SEL_TABLE_ONLINE_RESERVATION).prop('checked', !tableItem.isBlocked);
            newTable.attr(DATA_TABLE_BLOCKED, tableItem.isBlocked);
        }

        if(data.areaIsLocked) {
            newTable.find(SEL_TABLE_STATUS).prop('disabled', data.areaIsLocked)
        }

        newTable.find(SEL_TABLE_STATUS);
        tableItem.status = tableItem.status ? tableItem.status : (tableItem.isLocked ? 'INACTIVE' : 'AVAILABLE');
        newTable.attr(DATA_TABLE_LOCKED, tableItem.isLocked);

        //Set tooltip and disable link conditionally
        if(!tableItem.canBeRemoved){
            var deleteButton = newTable.find(SEL_DELETE_LINK);
            deleteButton.addClass(CLASS_LINK_DISABLED);
            deleteButton.attr("title", window.config.tableEditPlan.canNotBeDeletedText);
        }
        
        tablesList.append(newTable.removeClass(CLASS_PATTERN_ITEM));

        // Create grid of tables if table has no coordinats
        if(!tableItem.xPosition) {
            tableItem['xPosition'] = posX;
            tableItem['yPosition'] = posY;
            posX += beetwenTables;

            //create area width based on 5 first elements
            if(index < 5) {
                areaNewWidth += beetwenTables + avarageWidth
            }

            //create area height 
            if((index+1)%5 == 0) {
                posX = 40;
                posY += beetwenTables;
                areaNewHeight += beetwenTables + avarageHeight
            }
        }
        
        // Draw tabels on canvas
        groupedTable = RectTable.createRectTableWithData(tableItem, tablePlanner);
        maxWidthTable = tableItem.xPosition + groupedTable.width;
        areaNewWidth = areaNewWidth > maxWidthTable ? areaNewWidth : maxWidthTable;
        areaNewWidth > tablePlanner.getWidth() ? tablePlanner.setZoom(tablePlanner.getWidth()/areaNewWidth) : tablePlanner.setZoom(1);

        //to display all tables inside the grid (if change all tables room from one to another -> edit mode)
        maxHeightTable = tableItem.yPosition + groupedTable.height;
        areaNewHeight = areaNewHeight > maxHeightTable ? areaNewHeight : maxHeightTable;
    });
 
    if (areaObject.width < areaNewWidth) {
        areaObject.width = areaNewWidth;
    }
    if (areaObject.height < areaNewHeight) {
        areaObject.height = areaNewHeight;
    };

    tablePlanner.renderAll();
  }
    /**
     * Creating empty area and drawing one table
     * @param {jQuery.DOMElement} tablesList
     * @param {fabric.Canvas} tablePlanner
     */
    this.createEmptyArea = function(areaTitle, tempAreaId, tableId, tablesList, tablePlanner, addTableLink){
        //create empty area with empty data, id is temporary
        areaTitle.find(SEL_AREA_STATUS).prop('checked', true);
        areaTitle.removeClass('hidden');

        tablePlanner.setDimensions({width: CONST_DEFAULT_CANVAS_SIZE, height: CONST_DEFAULT_CANVAS_SIZE });

        // Prepare layer for area background
        // Prepare layer for area background
        var bgCanvas = new fabric.Rect({
            width: CONST_DEFAULT_CANVAS_SIZE,
            height: CONST_DEFAULT_CANVAS_SIZE,
            fill: "",
            selectable: false,
            type: 'bgCanvas'
        });
        bgCanvas.fill = new fabric.Pattern(
            {
                source: window.config.tableEditPlan.gridImg,
            },
            function () {
                bgCanvas.dirty = true;
                tablePlanner.requestRenderAll();
            }
        );
        tablePlanner.add(bgCanvas);

    }
    /**
     * Prepare data for submit
     * @param {jQuery.DOMElement} areaTitle
     * @param {canvas} tablePlanner
     * @return {object}
     */
    this.prepareData = function (areaTitle, tablePlanner, tablesList) {
        var tableData = TablePlannerUtils.getAllTablesData(tablePlanner);
        var tableNames = {};
        var validError;
        var tablesWithError = tableData.filter(function (table) {
            var tableItemId = table.tempId || table.id;
            var tableWithError = tablesList.find('[' + DATA_TABLE_ID + '="' + tableItemId + '"]');
            var tableNameTrim = table.name.trim();
            var tableName = tableNameTrim.toLowerCase();
            tableWithError.find(SEL_TABLE_NAME).toggleClass(CLASS_ERROR, false);
            validError = !tableName || !table.capacity || (table.capacity && table.capacity > MAX_CAPACITY) || !table.priority;
            validError = validError || tableNames[tableName];
            tableNames[tableName] = tableNames[tableName] ? 2 : 1;
           return validError;
        });

        var flatTableData = tableData.reduce(function (acc, table, index) {
            acc['tables[' + index + '].id'] = table.id;
            acc['tables[' + index + '].capacity'] = table.capacity;
            acc['tables[' + index + '].priority'] = table.priority;
            acc['tables[' + index + '].shape'] = table.shape;
            acc['tables[' + index + '].name'] = table.name;
            acc['tables[' + index + '].paused'] = table.isLocked;
            acc['tables[' + index + '].xPosition'] = table.xPosition;
            acc['tables[' + index + '].yPosition'] = table.yPosition;
            acc['tables[' + index + '].angle'] = table.angle;

            if(isBlockedTableFeatureToggle){
                acc['tables[' + index + '].blocked'] = table.isBlocked;
            }

            return acc;
        }, {});

        // Scroll tabels list to first table with error.
        if (tablesWithError.length) {
           var errorMessage = "";
           errorMessage = errorMessage + ' ' + window.config.tableEditPlan.tableError;
            tablesWithError.map(function (tableItem) {
                var tableItemId = tableItem.tempId || tableItem.id;
                var tableWithError = tablesList.find('[' + DATA_TABLE_ID + '="' + tableItemId + '"]');
                var tableNameTrim = tableItem.name.trim();
                var tableName = tableNameTrim.toLowerCase();
                if (!tableItem.name) {
                    errorMessage = errorMessage.includes(window.config.tableEditPlan.tableEmptyError) ? errorMessage : errorMessage + '<ul class="text-left"><li>' + window.config.tableEditPlan.tableEmptyError + '</li></ul>';
                    tableWithError.find(SEL_TABLE_NAME).toggleClass(CLASS_ERROR, true);
                }

                if (tableName && (tableNames[tableName] > 1)) {
                    errorMessage = errorMessage.includes(window.config.tableEditPlan.tableUniqueError) ? errorMessage : errorMessage + '<ul class="text-left"><li>' + window.config.tableEditPlan.tableUniqueError + '</li></ul>';
                    tableWithError.find(SEL_TABLE_NAME).toggleClass(CLASS_ERROR, true);
                }
                if (!tableItem.capacity) {
                    var capacity =  tableWithError.find(SEL_TABLE_CAPACITY).val();
                    
                    if (capacity === ""){
                        errorMessage = errorMessage.includes(window.config.tableEditPlan.tableSizeError) ? errorMessage : errorMessage + '<ul class="text-left"><li>' + window.config.tableEditPlan.tableSizeError + '</li></ul>';
                        tableWithError.find(SEL_TABLE_CAPACITY).toggleClass(CLASS_ERROR, true);
                    }
                    else if (capacity == 0){
                        errorMessage = errorMessage.includes(window.config.tableEditPlan.tableZEROCapacityError) ? errorMessage : errorMessage + '<ul class="text-left"><li>' + window.config.tableEditPlan.tableZEROCapacityError + '</li></ul>';
                        tableWithError.find(SEL_TABLE_CAPACITY).toggleClass(CLASS_ERROR, true);  
                    }
                }else if(tableItem.capacity > MAX_CAPACITY){
                    errorMessage = errorMessage.includes(window.config.tableEditPlan.tableCapacityError) ? errorMessage : errorMessage + '<ul class="text-left"><li>' + window.config.tableEditPlan.tableCapacityError + '</li></ul>';
                    tableWithError.find(SEL_TABLE_CAPACITY).toggleClass(CLASS_ERROR, true);
                }
            });
           
            TablePlannerUtils.showAlert(errorMessage);
            // If this is a new table it has no id from BE, so we have to use tempId
            var tableWithErrorId = tablesWithError[0].tempId || tablesWithError[0].id;
            self.setActiveTableInList([tableWithErrorId], tablesList);
            return false;
        }

        var areaObject = TablePlannerUtils.getAreaObject(tablePlanner);
        var areaName = areaTitle.find(SEL_AREA_NAME).val();
        // Area name should be filled
        if (!areaName.length) {
            TablePlannerUtils.showAlert(window.config.tableEditPlan.areaNameError);
            return false;
        }

        var areaData = {
            'area.id': areaTitle.attr(DATA_AREA_ID),
            'area.paused': !areaTitle.find(SEL_AREA_STATUS).prop('checked'),
            'area.name': areaName,
            'area.areaWidth': areaObject.width,
            'area.areaHeight': areaObject.height,
            'area.selectable': Boolean(areaTitle.find(SEL_HIDDEN_AREA_SELECTABLE_INPUT).val())
        };

        var data = jQuery.extend({}, areaData, flatTableData);
        return data;
    }

    var checkSelectedAreaCookieStatus = function (areaId) {
      var lastSelectedArea = TablePlannerUtils.getLastSelectedAreaCookie();
      if (Number(lastSelectedArea) == Number(areaId)) {
        TablePlannerUtils.removeLastSelectedAreaCookie();
      }
    };

    //remove the class from html tag if exists
    var removeHtmlClass = function(moduleNode){
        var htmlElem = moduleNode.closest('html');
        if(htmlElem.hasClass(CLASS_EDIT_MODE_HTML)){
            htmlElem.removeClass(CLASS_EDIT_MODE_HTML); 
        }
    }

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {

            var moduleNode = jQuery(this);
            
            var areaTitle = moduleNode.find(SEL_AREA_TITLE);
            var tablesList = moduleNode.find(SEL_TABLES_LIST);
            var addTableLink = moduleNode.find(SEL_ADD_TABLE_LINK);
            var btnSaveArea = moduleNode.find(BTN_SAVE_AREA);

            // Device detection
            var isDeviceMobile = UserInterfaceUtils.isScreenSize('xs');
            moduleNode.toggleClass("isDeviceMobile", isDeviceMobile);
            var deleteAreaLink = moduleNode.find(SEL_DELETE_AREA_LINK);

            var tempId = 10000;
            var areaTempId = 10000;

            // Init table planner canvas
            var tablePlanner = TablePlannerUtils.initTablePlanner();
            TablePlannerUtils.initCanvasControls(moduleNode, tablePlanner);

            // Get data from BE
            var getAreaUrl = window.config.tableEditPlan.getAreaUrl;
            var hasAreaData = TablePlannerUtils.getAreaData(getAreaUrl, self.createArea, areaTitle, tablesList, tablePlanner);
            if(hasAreaData == false){
                self.deactivateLink(deleteAreaLink, true);
                self.createEmptyArea(areaTitle, areaTempId, tempId, tablesList, tablePlanner, addTableLink);
                tempId++;
                areaTempId++;
            }
            // Click on table in table list
            tablesList.on('click', SEL_TABLE_LIST_ITEM, function() {
                var tableId = +jQuery(this).attr(DATA_TABLE_ID);

                // Set table active in list
                self.setActiveTableInList([tableId], tablesList);

                // Set active table on canvas
                var activeTableOnCanvas = TablePlannerUtils.getTableById(tableId, tablePlanner);
                tablePlanner.setActiveObject(activeTableOnCanvas);

                TablePlannerUtils.scrollCanvasToTable(tablePlanner, activeTableOnCanvas);
            });

            // Changing area name
            areaTitle.on('keyup input', SEL_AREA_NAME, function() {
                var areaNameInput = jQuery(this);
                // if name has no sybmols add error
                areaNameInput.toggleClass(CLASS_ERROR, !areaNameInput.val());
            });

            // Changing area status
            areaTitle.on('change', SEL_AREA_STATUS, function() {
                var areaStatusInput = jQuery(this);
                var isAreaDisabled = !areaStatusInput.prop('checked');
                tablesList.children(SEL_TABLE_LIST_ITEM).find(SEL_TABLE_STATUS).prop('disabled', isAreaDisabled);
                tablesList.children(SEL_TABLE_LIST_ITEM).find(SEL_TABLE_STATUS).prop('checked', !isAreaDisabled).trigger('change', ['isAreaStatusChanged']);

                if(isBlockedTableFeatureToggle){
                    tablesList.children(SEL_TABLE_LIST_ITEM).find(SEL_TABLE_ONLINE_RESERVATION).prop('disabled', isAreaDisabled);
                    tablesList.children(SEL_TABLE_LIST_ITEM).find(SEL_TABLE_ONLINE_RESERVATION).prop('checked', !isAreaDisabled).trigger('change', ['isAreaStatusChanged']);
                }
            });

            // Changing table name
            var timerName;
            tablesList.on('keyup input', SEL_TABLE_NAME, function() {
                var nameInput = jQuery(this);
                var tableItem = nameInput.closest(SEL_TABLE_LIST_ITEM);
                // if name has no sybmols add error
                nameInput.toggleClass(CLASS_ERROR, !nameInput.val());

                // Set table name to data attr for collecting it on save
                tableItem.attr(DATA_TABLE_NAME, nameInput.val());

                // Set timeout for delay beetwen when user finished typing and updating table on canvas
                if(timerName) {
                    clearTimeout(timerName);
                }
                timerName = setTimeout(function() {
                    // Update table
                    self.updateTableOnCanvas(tableItem, tablePlanner);
                }, CONST_DELAY)
                
            });

            // Changing table priority
            tablesList.on('change', SEL_TABLE_PRIORITY, function() {

                var priorityInput = jQuery(this);

                var tableItem = priorityInput.closest(SEL_TABLE_LIST_ITEM);

                // Set table priority to data attr for collecting it on save
                tableItem.attr(DATA_TABLE_PRIORITY, priorityInput.val());

                self.updateTableOnCanvas(tableItem, tablePlanner);
                
            });

            // Changing table shape
            tablesList.on('change', SEL_TABLE_SHAPE, function() {
                var shapeInput = jQuery(this);
                var tableItem = shapeInput.closest(SEL_TABLE_LIST_ITEM);

                // Set table shape to data attr for collecting it on save
                tableItem.attr(DATA_TABLE_SHAPE, shapeInput.val());
                self.updateTableOnCanvas(tableItem, tablePlanner);
            });

            // Changing table capacity
            var timerCapacity;
            tablesList.on('keyup input', SEL_TABLE_CAPACITY, function() {
                var capacityInput = jQuery(this);
                var tableItem = capacityInput.closest(SEL_TABLE_LIST_ITEM);

                // if name has no sybmols add error
                capacityInput.toggleClass(CLASS_ERROR, !capacityInput.val());

                // Allow type only digits
                this.value = this.value.replace(/[^0-9]/g, '');
                // Check max allowed capacity
                var capacityValue = capacityInput.val();
                if (capacityValue > MAX_CAPACITY) {
                    capacityInput.val(MAX_CAPACITY);
                }

                // Set table capacity to data attr for collecting it on save
                tableItem.attr(DATA_TABLE_CAPACITY, capacityInput.val());

                // Set timeout for delay beetwen when user finished typing and updating table on canvas
                if(timerCapacity) {
                    clearTimeout(timerCapacity);
                }
                timerCapacity = setTimeout(function() {
                    // Update table
                    self.updateTableOnCanvas(tableItem, tablePlanner);
                }, CONST_DELAY)

            });

            // Changing table activity
            tablesList.on('change', SEL_TABLE_STATUS, function(event, isAreaStatusChanged) {
                var tableItem = jQuery(this).closest(SEL_TABLE_LIST_ITEM);
                
                // Set table locked to data attr for collecting it on save
                tableItem.attr(DATA_TABLE_LOCKED, !jQuery(this).prop('checked'));

                // disable 'reservable online' toggle in case the table is deactivated
                if(isBlockedTableFeatureToggle){
                    tableItem.attr(DATA_TABLE_BLOCKED, !jQuery(this).prop('checked'));
                    tableItem.find(SEL_TABLE_ONLINE_RESERVATION).prop('checked', jQuery(this).prop('checked'));
                }

                // Update table
                self.updateTableOnCanvas(tableItem, tablePlanner, isAreaStatusChanged);
            });

            // Changing table online reservation (blocked) activity
            tablesList.on('change', SEL_TABLE_ONLINE_RESERVATION, function(event, isAreaStatusChanged) {
                var tableItem = jQuery(this).closest(SEL_TABLE_LIST_ITEM);
                
                // Set table locked to data attr for collecting it on save
                tableItem.attr(DATA_TABLE_BLOCKED, !jQuery(this).prop('checked'));

                // keep the 'reservable online' toggle disabled, until table is activated
                var isActiveTable = jQuery(this).closest('.row').parent().prev().find('.table-status').is(":checked");

                // when active toggle is switched off
                if(!isActiveTable){
                    // Set table blocked to data attr for collecting it on save
                    tableItem.attr(DATA_TABLE_BLOCKED, !isActiveTable);
                    tableItem.find(SEL_TABLE_ONLINE_RESERVATION).prop('checked', isActiveTable);
                }else{
                    // when active toggle is switched on
                    tableItem.attr(DATA_TABLE_BLOCKED, !jQuery(this).is(':checked'));
                }

                // Update table
                self.updateTableOnCanvas(tableItem, tablePlanner, isAreaStatusChanged);
            });

            // Deleting table
            tablesList.on('click', SEL_DELETE_LINK, function() {

                var deleteButton = jQuery(this);
                
                if(deleteButton.hasClass(CLASS_LINK_DISABLED)){
                    e.preventDefault();
                    return false;
                }

                var tableItem = deleteButton.closest(SEL_TABLE_LIST_ITEM);
                var tableId = +tableItem.attr(DATA_TABLE_ID);

                TablePlannerUtils.showConfirm(window.config.tableEditPlan.confirmText, function() {
                    var deactivateLinkCondition;
                    var tableForDeletion = TablePlannerUtils.getTableById(tableId, tablePlanner);
                    var tableTextForDeletion = TablePlannerUtils.getTableTextById(tableId, tablePlanner);

                    TablePlannerUtils.removeActive(tableForDeletion, tablePlanner);
                    TablePlannerUtils.removeActive(tableTextForDeletion, tablePlanner);

                    tableItem.slideUp(500, function() { 
                        jQuery(this).remove();
                        deactivateLinkCondition = deleteAreaLink.attr(DATA_AREA_ID) == null || tablesList.children(SEL_TABLE_LIST_ITEM).length != 0 || deleteAreaLink.attr(DATA_SINGLE_AREA) == "true";
                        self.deactivateLink(deleteAreaLink, deactivateLinkCondition);
                    });
                });
                return false;
            });

            // Add new table
            addTableLink.on('click', function() {
                // Create table item in list
                var newTable = tablesList.find(SEL_TABLE_PATTERN).clone(true).html();
                newTable = jQuery(newTable.replace(new RegExp(CONST_PLACEHOLDER_TABLE_ID, 'g'), tempId));
                tablesList.append(newTable.removeClass(CLASS_PATTERN_ITEM));

                var priorityInput = newTable.find(SEL_TABLE_PRIORITY);
                var shapeInput = newTable.find(SEL_TABLE_SHAPE);

                // Set table priority and shape to data attr for collecting it on save
                newTable.attr(DATA_TABLE_PRIORITY, priorityInput.val());
                newTable.attr(DATA_TABLE_SHAPE, shapeInput.val());

                // Activate or deactivate delete area link
                self.deactivateLink(deleteAreaLink, true);

                // Create table in canvas
                var newRectTable = RectTable.createDefaultRectTable(
                    tempId,
                    tablePlanner
                );
                tablePlanner.setActiveObject(newRectTable);
                TablePlannerUtils.scrollCanvasToTable(tablePlanner, newRectTable);
                // Make new table already active
                newTable.find(SEL_TABLE_STATUS).prop('checked', true).trigger('change');

                // Make new table available for online reservation (not blocked)
                if(isBlockedTableFeatureToggle){
                    newTable.find(SEL_TABLE_ONLINE_RESERVATION).prop('checked', true).trigger('change');
                }

                // Increment temp id for next table
                tempId++;

                return false;
            });

            // Submit data to BE
            var csrf = moduleNode.find(SEL_CSRF).val();
            btnSaveArea.on('click', function() {
                // button can be clickable only once during submission 
                if(saveButtonClickCount == 0){    
                    //check the validation for unique area name
                    uniqueAreaValidation(areaTitle, tablePlanner, moduleNode);                
                    return false;
                }
            });

            /**
             * @description Check the area name - should not be duplicate
             * @param {*} newAreaName 
             */
            var uniqueAreaValidation = function(areaTitle, tablePlanner, moduleNode){
                var areaList = [];
                var isDuplicateArea = false;
                var areaInput = moduleNode.find('.area-name');
                var newAreaName = areaInput.val().trim();
                var tableData = TablePlannerUtils.getAllTablesData(tablePlanner);

                jQuery.ajax({
                    url:  CONST_GET_AREAS_URL,
                    type: 'GET',
                    data: null,
                    dataType: "json",
                    success: function(result, status) {
                        if (result && result.areas && result.areas.length > 0) {

                            // get the area id using current page url
                            var areaId = (window.location.href.indexOf('areaId') > -1) ? window.location.search.split('=')[1] : null;
                            areaList = result.areas;

                            // Remove the edited area in the areaList on the basis of areaId
                            if(areaId != null || areaId != ''){
                                areaList = areaList.filter(function(area){
                                    return Number(area.id) != Number(areaId);
                                })
                            }

                            // Check if the entered area is duplicate or not
                            isDuplicateArea = areaList.some(function(area){
                                var areaName = area.name.trim();
                                return (areaName.toLowerCase() == newAreaName.toLowerCase());
                            });

                            var errorMessage = "";
                            errorMessage = errorMessage + ' ' + window.config.tableEditPlan.tableError;
                            
                            if(isDuplicateArea || tableData.length == 0){
                                if(isDuplicateArea){
                                    errorMessage = errorMessage + '<ul class="text-left"><li>' + window.config.tableEditPlan.duplicateAreaNameError + '</li></ul>';
                                    areaInput.toggleClass(CLASS_ERROR, true);
                                }
    
                                if(tableData.length == 0){
                                    errorMessage = errorMessage + '<ul class="text-left"><li>' + window.config.tableEditPlan.noTableInAreaError + '</li></ul>';
                                }

                                TablePlannerUtils.showAlert(errorMessage);
                            }else{
                                // will call the save area and tables endpoint only if the area name is unique
                                var tablesList = moduleNode.find(SEL_TABLES_LIST);
                                var requestData = self.prepareData(areaTitle, tablePlanner, tablesList);

                                if(!requestData){
                                    return false;
                                }

                                //disable the save button, to avoid multiple clicks
                                jQuery(BTN_SAVE_AREA).attr("disabled", "disabled");

                                //if area name is not duplicate and there is min 1 table in an area, will send the data to BE
                                saveAreaAndTables(requestData);
                            }

                            removeHtmlClass(moduleNode);
                        }
                    }
                });
                return false;
            }

            //Send area and tables data to BE in order to submit the form
            var saveAreaAndTables = function(requestData){
                requestData['_csrf'] = csrf;
                saveButtonClickCount = 1;

                jQuery.ajax({
                    url: window.config.tableEditPlan.saveAreaUrl,
                    type: 'POST',
                    data: requestData,
                    dataType: 'json',
                    success: function(result) {
                        console.log('Success', result)
                        if(result.errors && result.errors.length) {
                            if(result.errors[0].includes('Warning. Table Groups Min.Guests updated')){
                                TablePlannerUtils.showWarning(result.errors[0],function(){
                                    redirectTotableView(result.areaId);
                                });
                            }
                            else{
                            TablePlannerUtils.showResrevationAlert(result.errors[0],function(){
                                redirectTotableView(result.areaId);
                            });
                            }
                            return false;
                        }
                        redirectTotableView(result.areaId);
                    },
                    error: function(result, status) {
                        console.log('Failed')
                    }
                });
            }
            
            //redirectTotableView
            var redirectTotableView = function(areaId){
                window.location = window.config.tableEditPlan.viewAreaWithId + areaId;
                Cookies.set('savedEditPlan', "success", { expires: 10*365});
            }

            //adjust table text position during time of table rotation and table movement
            var adjustTableTextPosition = function(table){
                if(table.tableId != undefined){
                    var tableText = TablePlannerUtils.getTableTextById(table.tableId,tablePlanner);
                    var tableTextPosition = RectTable.setTableNamePosition(table.angle, table.width, table.height, table.left, table.top, table.tableCapacity);
                    if(tableText != null){
                        tableText.left = tableTextPosition[0];
                        tableText.top = tableTextPosition[1];
                    }
                }
            }

            // Delete area
            deleteAreaLink.on("click", function(e){
                if(deleteAreaLink.hasClass(CLASS_LINK_DISABLED)){
                    e.preventDefault();
                    return false;
                } else {
                    TablePlannerUtils.showConfirm(window.config.tableEditPlan.deleteAreaConfirmText, function() {
                        var areaId = deleteAreaLink.attr(DATA_AREA_ID);
                        var deleteUrl = window.config.tableEditPlan.deleteAreaUrl + areaId;
                        jQuery.ajax({
                            url: deleteUrl,
                            type: 'DELETE',
                            data: {'_csrf' : csrf},
                            dataType: 'json',
                            success: function(result) {
                                if(result.errors && result.errors.length) {
                                    TablePlannerUtils.showAlert(result.errors[0]);
                                    if(result.status == "KO_SOME_TABLE_COULD_NOT_BE_DELETED"){
                                        window.location = window.config.tableEditPlan.pageRefreshUrl + areaId;
                                    }
                                    return false;
                                }
                                if(result.status == "OK"){
                                    checkSelectedAreaCookieStatus(areaId);
                                    window.location = window.config.tableEditPlan.deleteAreaRedirectUrl;
                                    Cookies.set('deleteArea', "success", { expires: 10*365});
                                }
                            },
                            error: function(result, status) {
                                TablePlannerUtils.showAlert(window.config.tableEditPlan.deleteAreaError);
                            }
                        });
                    });
                }
            });

            // TODO: Check how we can adapt this to the design
            // Moving the pan view with the mouse is a nice feature for the user but it will block multiselection. 
            // Maybe we can have a toggle to enable it.
            // var panning;
            // tablePlanner.on('mouse:up', function (e) {
            //   jQuery(this).css({
            //     'cursor': 'default'
            //   });
            //   panning = false;
            // });
            // var lastPosX = 0;
            // var lastPosY = 0;
            // tablePlanner.on('mouse:down', function (e) {
            //   if (tablePlanner.getActiveObject() == null) {
            //     jQuery(this).css({
            //       'cursor': 'grabbing'
            //     });
            //     tablePlanner.selection = false;
            //     panning = true;
            //     lastPosX = e.e.clientX;
            //     lastPosY = e.e.clientY;
            //   }
            // });
            // tablePlanner.on('mouse:move', function (opt) {
            //   if (tablePlanner.getActiveObject() == null) {
            //     if (panning) {
            //       jQuery(this).css({
            //         'cursor': 'grabbing'
            //       });
            //     //   var delta = new fabric.Point(e.e.movementX, e.e.movementY);
            //     //   tablePlanner.relativePan(delta);

            //       var e = opt.e;
            //       var zoom = tablePlanner.getZoom();
            //       var vpt = tablePlanner.viewportTransform;
            //       var areaObj = TablePlannerUtils.getAreaObject(tablePlanner)
            //       if (zoom < 0.4) {
            //           vpt[4] = 0;
            //           vpt[5] = 0;
            //       } else {
            //           vpt[4] += e.clientX - lastPosX;
            //           vpt[5] += e.clientY - lastPosY;
            //           if (vpt[4] >= 0) {
            //               vpt[4] = 0;
            //           } else if (vpt[4] < tablePlanner.width - areaObj.width * zoom) {
            //               vpt[4] = tablePlanner.width - areaObj.width * zoom;
            //           }
            //           if (vpt[5] >= 0) {
            //               vpt[5] = 0;
            //           } else if (vpt[5] < tablePlanner.height - areaObj.height * zoom) {
            //               vpt[5] = tablePlanner.height - areaObj.height * zoom;
            //           }
            //       }
            //       tablePlanner.requestRenderAll();
            //       lastPosX = e.clientX;
            //       lastPosY = e.clientY;
            //     }
            //   }
            // });

            tablePlanner.on('object:moving', function (e) {
                if(tablePlanner.getActiveObjects().length == 1){
                    //only for single table movement
                    TablePlannerUtils.preventBoundaries(e.target);
                    self.snapToGrid(e.target);
                }else{
                    //discard the active object selection (in case of multiple table selection)
                    tablePlanner.discardActiveObject();
                }
            });
            
            tablePlanner.on('object:moved',function(e){
                //only for single table movement
                if(tablePlanner.getActiveObjects().length == 1){
                    adjustTableTextPosition(e.target);
                }
            });

            tablePlanner.on('object:rotated', function (e) {
                TablePlannerUtils.preventBoundaries(e.target);
                adjustTableTextPosition(e.target);
            });

            // Update table color depending on active table or not
            tablePlanner.on("selection:created", function(event) {
                var activeSelection = event.target;

                if(tablePlanner.getActiveObjects().length > 1){
                    activeSelection.set({hasRotatingPoint: false})
                } else {
                    activeSelection.set({hasRotatingPoint: true})
                }
                
                TablePlannerUtils.updateActive(event.selected, true, tablePlanner, CONST_CURRENT_MODE);
                
                var selectedTablesIds = event.selected.reduce(function(idsArr, table) {
                    idsArr.push(table.tableId);
                    return idsArr;
                }, []);
                self.setActiveTableInList(selectedTablesIds, tablesList);
            });

            tablePlanner.on("selection:updated", function(event) {
                TablePlannerUtils.updateActive(event.selected, true, tablePlanner, CONST_CURRENT_MODE);
                TablePlannerUtils.updateActive(
                    event.deselected,
                    false,
                    tablePlanner,
                    CONST_CURRENT_MODE
                );

                var selectedTablesIds = event.selected.reduce(function(idsArr, table) {
                    idsArr.push(table.tableId);
                    return idsArr;
                }, []);
                self.setActiveTableInList(selectedTablesIds, tablesList);
            });

            // in order to avoid multiple table rotation
            tablePlanner.on("mouse:up", function(event) {
                var activeSelection = event.target;
                if(tablePlanner.getActiveObjects().length > 1 && activeSelection != null){
                    var totalObjects = tablePlanner.getActiveObjects();
                    totalObjects.shift();
                    event.deselected = totalObjects;
                    event.selected = [];
                    activeSelection.set({hasBorders: false, hasRotatingPoint: false, selectable: false});
                }
            });

            tablePlanner.on("selection:cleared", function(event) {
                if (event.deselected) {
                    TablePlannerUtils.updateActive(
                        event.deselected,
                        false,
                        tablePlanner,
                        CONST_CURRENT_MODE
                    );
                }
                self.setActiveTableInList(false, tablesList);
            });

            jQuery(window).on('resize', function() {
                var isDeviceMobile = UserInterfaceUtils.isScreenSize('xs');
                moduleNode.toggleClass("isDeviceMobile", isDeviceMobile);
                TablePlannerUtils.setCanvasSize(tablePlanner);
            });

            //add a new class in view mode page html tag
            var bodyClass = moduleNode.closest(SEL_PAGE_BODY_CLASS);
            if(window.location.href.indexOf('editMode') != -1 && bodyClass.length){
                moduleNode.closest('html').addClass(CLASS_EDIT_MODE_HTML);
            }else{
                removeHtmlClass(moduleNode);
            }
		});
    };
};

// Make class public to outside world
module.exports = TableEditPlan;

},{"../mediator/mediator":103,"../utils/UserInterfaceUtils":189,"./RectTable":164,"./TablePlannerUtils":166,"cookies":49,"fabric/dist/fabric":7,"jquery/dist/jquery":14}],166:[function(require,module,exports){
/**
* TablePlannerUtils functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
require('fabric/dist/fabric');
var Alert               = require('../modals/Alert');
var Confirm             = require('../modals/Confirm');

// Class definition
TablePlannerUtils = function() {

  var self = this;

  this.CONST_ACTIVE_LAYER = {
    editMode: "#926534",
    viewMode: "#444"
  }

  var SEL_TABLE_PLANNER_ID              = 'table-planner';
  var SEL_MODAL_ALERT                   = '.tablePlan-alertModal';
  var SEL_MODAL_CONFIRM                 = '.tablePlan-confirmModal';
  var SEL_MODAL_SUCCESS                 = '.tablePlan-successModal';
  var SEL_MODAL_INFO                    = '.tablePlan-infoModal';
  var SEL_MODAL_CAPACITY                = '.tablePlan-capacityModal';
  var SEL_CANVAS_HOLDER                 = '.canvas-holder';
  var SEL_MODAL_WARN                    = '.tablePlan-warnModal';

  this.alertModal = new Alert();
  this.confirmModal = new Confirm();
  this.CONST_ZOOM_UNIT = 1.2;
  this.CONST_PAN_UNIT = 20;
  this.CONST_GRID = 30;
  this.CONST_MIN_WIDTH_HEIGHT = 250;

  /**
   * Initialization canvas
   * @return {fabric.Canvas}
   */
  this.initTablePlanner = function(isViewMode) {

    if (canvas) {
      canvas.clear();
      canvas.dispose();
    }
    var canvas = new fabric.Canvas(SEL_TABLE_PLANNER_ID);
    self.setCanvasSize(canvas);

    // Disable all controls for all objects
    fabric.Object.prototype.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      br: false,
      tl: false,
      tr: false,
      bl: false,
      mtr: true
    });

    fabric.Object.prototype.set({
      transparentCorners: false,
      borderColor: 'orange',
      cornerColor: 'orange',
      cornerStrokeColor: 'red',
      cornerSize: 10,
      padding: 5,
      cornerStyle: 'circle',
      borderDashArray: [3,3],
      rotatingPointOffset: 10
    });

    if(isViewMode) {

      canvas.selection = false;
      fabric.Object.prototype.lockMovementX = true;
      fabric.Object.prototype.lockMovementY = true;
      
      fabric.Object.prototype.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
        br: false,
        tl: false,
        tr: false,
        bl: false,
        mtr: false
      });

    }

    canvas.renderAll();

    return canvas;
  };

  /**
   * Update color for active layer
   * @param {array[fabric.Object]} tablesArray
   * @param {boolean} isActive
   * @param {fabric.Canvas} canvas
   */
  this.updateActive = function(tablesArray, isActive, canvas, mode) {
    tablesArray.forEach(function(table) {
      table._objects.forEach(function(obj) {
        if (obj.type && obj.type == "activeLayer") {
          var layerColor = isActive
            ? self.CONST_ACTIVE_LAYER[mode]
            : "transparent";

          obj.set("fill", layerColor);
        }
        if (obj.tableStatus) {
          var tableOpacity = isActive ? 0.7 : 1;

          obj.set("opacity", tableOpacity);
        }
      });
    });
    canvas.renderAll();
  };

  /**
   * Get table by id
   * @param {number} id
   * @param {fabric.Canvas} canvas
   * @return {fabric.Object}
   */
  this.getTableById = function(id, canvas) {
    var selectedObject = null;
    canvas.getObjects().forEach(function (obj) {
      if (obj.tableId && obj.tableId === id) {
        selectedObject = obj;
      }
    });
    return selectedObject;
  };

  /**
   * Get table by id
   * @param {number} id
   * @param {fabric.Canvas} canvas
   * @return {fabric.Object}
   */
   this.getTableTextById = function(id, canvas) {
    var selectedObjectText = null;
    canvas.getObjects().forEach(function (obj) {
      if (obj.tableTextId && obj.tableTextId === id) {
        selectedObjectText = obj;
      }
    });
    return selectedObjectText;
  };

  /**
   * Get all tables objects
   * @param {fabric.Canvas} canvas
   * @return {array[]:fabric.Object}
   */
  this.getTablesObjects = function(canvas) {
    return canvas.getObjects().filter(function(obj) {return obj.type == 'table'});
  };

  /**
   * Remove table from canvas
   * @param {fabric.Object} table
   * @param {fabric.Canvas} canvas
   */
  this.removeActive = function(table, canvas) {
    canvas.remove(table);
    canvas.renderAll();
  };

  /**
   * Get the coordinates of all objects within the canvas
   *
   * @param {Object} canvas The canvas object.
   */
  this.getAllTablesData = function (canvas) {
    var tableDatas = [];
    canvas.getObjects().forEach(function (obj) {
      if(obj.type !== 'table') {
        return false;
      }
      var table = {};
      table.capacity = obj.tableCapacity;
      table.isLocked = obj.isLocked;
      table.priority = obj.priority;
      table.name = obj.tableName;
      table.xPosition = obj.left;
      table.yPosition = obj.top;
      table.angle = obj.angle;
      table.shape = obj.shape;
      table.isBlocked = obj.isBlocked;

      // Don't send temp id to BE
      if(!obj.isNewTable) {
        table.id = obj.tableId;
      } else {
        table.tempId = obj.tableId;
      }
      tableDatas.push(table);
    });
    return tableDatas;
  };

  /**
   * Get table by id
   * @param {number} id
   * @param {fabric.Canvas} canvas
   * @return {Object} 
   */
  this.getTableCoordinatesById = function (id, canvas) {

    var selectedTable = self.getTableById(id, canvas);

    return {
      top: selectedTable.top,
      left: selectedTable.left
    };
  };

  /**
   * Get canvas dimensions
   * @param {fabric.Canvas} canvas
   * @return {Object} 
   */
  this.getCanvasDimensions = function (canvas) {

    return {
      width: Number(canvas.height),
      height: Number(canvas.width)
    };
  };

  /**
   * Update canvas size and background layer
   * @param {canvas} tablePlanner
   * @param {number} canvasNewWidth
   * @param {number} canvasNewHeight
   */
  this.CONST_CANVAS_SIZE_CHANGE_UNIT = 50;
  this.updateCanvasSize = function(tablePlanner, isIncrease) {
    var areaObject = self.getAreaObject(tablePlanner);

    var allTables = tablePlanner.getObjects();

    // Get the table objects with max top and left 
    var maxTop = Math.max.apply(Math, allTables.map(function(o) { return o.top; }));
    var maxTopObject = allTables.find(function(o){ return o.top == maxTop; });
    var maxLeft = Math.max.apply(Math, allTables.map(function(o) { return o.left; }));
    var maxLeftObject = allTables.find(function(o){ return o.left == maxLeft; });

    var newWidth = isIncrease ? areaObject.width + self.CONST_CANVAS_SIZE_CHANGE_UNIT : areaObject.width - self.CONST_CANVAS_SIZE_CHANGE_UNIT;
    var newHeight = isIncrease ? areaObject.height + self.CONST_CANVAS_SIZE_CHANGE_UNIT : areaObject.height - self.CONST_CANVAS_SIZE_CHANGE_UNIT;

    var existedTables = allTables.filter(function(item){
      return item.tableName;
    });

    // check bottom-right corner since increase and decrease only happen in that direction
    if(existedTables.length != 0 && (maxTopObject.getBoundingRect(true).top+maxTopObject.getBoundingRect(true).height  > newHeight || maxLeftObject.getBoundingRect(true).left+maxLeftObject.getBoundingRect(true).width  > newWidth)){
      // we don't change it becasue it's inside the table objects coordinates
      return false;
    }

    areaObject.set({ width: newWidth < self.CONST_MIN_WIDTH_HEIGHT ? self.CONST_MIN_WIDTH_HEIGHT : newWidth , height: newHeight < self.CONST_MIN_WIDTH_HEIGHT ? self.CONST_MIN_WIDTH_HEIGHT : newHeight });
    
    areaObject.setCoords();
    tablePlanner.renderAll();
  }

  /**
   * Get area data from BE
   * @param {string} url
   * @param {function} callback
   * @param {jQuery.DOMElement} areaTitle
   * @param {jQuery.DOMElement} tablesList
   * @param {fabric.Canvas} tablePlanner
   */
  this.getAreaData = function(url, callback, areaTitle, tablesList, tablePlanner) {

    var areaId = self.getUrlParameter('areaId');
    
    if(areaId == undefined){
      return false;
    }
      jQuery.ajax({
        url: url,
        type: 'GET',
        data: {
          areaId: self.getUrlParameter('areaId')
        },
        dataType: 'json',
        success: function(data) {
            callback(data, areaTitle, tablesList, tablePlanner);
        },
        error: function() {
            self.showAlert(window.config.tableEditPlan.areaRequestError);
            console.log(window.config.tableEditPlan.areaRequestError);
        }
    });
  };

  /**
   * Show alert notification
   * @param {string} alertMessage
   */
  this.showAlert = function(alertMessage, callback) {
    var modalAlertPopup = jQuery(SEL_MODAL_ALERT);
    var deferred = jQuery.Deferred();
    self.alertModal.show(modalAlertPopup, alertMessage, true).done(function() {
      deferred.resolve();
    });

    // return the promise
    return deferred.promise();
  };

    /**
   * Show warn notification
   * @param {string} warnMessage
   */
     this.showWarning = function(warnMessage, callback) {
      var modalWarnPopup = jQuery(SEL_MODAL_WARN);
      var deferred = jQuery.Deferred();
      self.alertModal.show(modalWarnPopup, warnMessage, true).done(function() {
        callback();
        deferred.resolve();
      });
  
      // return the promise
      return deferred.promise();
    };

  /**
   * Show succes notification
   * @param {string} successMessage
   */
  this.showSuccess = function(successMessage) {
    var modalSuccessPopup = jQuery(SEL_MODAL_SUCCESS);
    self.alertModal.show(modalSuccessPopup, successMessage);
    jQuery('.modal-backdrop').removeClass("modal-backdrop");
    setTimeout(function() {
      self.alertModal.close(modalSuccessPopup);
    }, 5000);
  };
  this.showResrevationAlert = function(alertMessage, callback) {
    var modalAlertPopup = jQuery(SEL_MODAL_ALERT);

    self.alertModal.show(modalAlertPopup, alertMessage, true).done(function() {
      callback();
      self.showSuccess('test');
    });

  };

  /**
   * Show info notification
   * @param {string} infoMessage
   */
  this.showInfo = function(infoMessage) {
    var modalInfoPopup = jQuery(SEL_MODAL_INFO);
    self.alertModal.show(modalInfoPopup, infoMessage);
    jQuery('.modal-backdrop').removeClass("modal-backdrop");
    setTimeout(function() {
      self.alertModal.close(modalInfoPopup);
    }, 5000);
  };

  /**
   * Show confirm popup
   * @param {string} confirmMessage
   * @param {function} callback
   */
  this.showConfirm = function(confirmMessage, callback) {
    var modalConfirmPopup = jQuery(SEL_MODAL_CONFIRM);
    self.confirmModal.show(modalConfirmPopup, confirmMessage).done(function() {
      callback();
    });
  };

  /**
   * Show capacity exceeded popup
   * @param {string} confirmMessage
   * @param {function} callback
   */
  this.showCapacityExceededConfirm = function(confirmMessage, callback) {
    var modalConfirmPopup = jQuery(SEL_MODAL_CAPACITY);
    self.confirmModal.show(modalConfirmPopup, confirmMessage).done(function() {
      callback();
    });
  };

  /**
   * Get URL parameter 
   * @param {string} sParam
   * @return {string} 
   */
	this.getUrlParameter = function(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;
	
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
	
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
		}
  };
  
  /**
   * Get Area objects 
   * @param {fabric.Canvas} canvas
   * @return {fabric.Object} 
   */
	this.getAreaObject = function(canvas) {
		var bgLayer = null;
    canvas.getObjects().forEach(function (obj) {
        if (obj.type === 'bgCanvas') {
            bgLayer = obj;
        }
    });
    return bgLayer;
	};

  /**
   * Handle mouse zoom for the canvas
   * @param {Object} opt // event object
   * @param {fabric.Object} canvas // the canvas
   */
  this.handleMouseZoom = function (opt, canvas) {
    var delta = opt.e.deltaY;
    var zoom = canvas.getZoom();
    zoom *= Math.pow(0.999, delta);
    self.handleZoom(zoom, canvas);
  };

  /**
   * Handle manual zoom for the canvas
   * @param {fabric.Object} tablePlanner // the canvas
   * @param {Boolean} zoomIn // Zoom in or out
   */
  this.handleManualZoom = function (tablePlanner, zoomIn) {
    var zoom = zoomIn ? (tablePlanner.getZoom() * self.CONST_ZOOM_UNIT) : (tablePlanner.getZoom() / self.CONST_ZOOM_UNIT)
    self.handleZoom(zoom, tablePlanner)
    return false;
  };

  /**
   * Handle zoom for the canvas
   * @param {number} zoom
   * @param {fabric.Object} canvas // the canvas
   */
  this.handleZoom = function (zoom, canvas) {
    var zoom = zoom || canvas.getZoom();
    var areaObj = self.getAreaObject(canvas);

    if (zoom > 2) zoom = 2;
    if (zoom < 0.2) zoom = 0.2;

    canvas.zoomToPoint({ x: 0, y: 0}, zoom);
    var vpt = canvas.viewportTransform;

    if (zoom < 400 / areaObj.width) {
        vpt[4] = 0;
        vpt[5] = 0;
    } else {
        if (vpt[4] >= 0) {
          vpt[4] = 0;
        } else if (vpt[4] < canvas.width - areaObj.width * zoom) {
          vpt[4] = canvas.width - areaObj.width * zoom;
        }
        if (vpt[5] >= 0) {
          vpt[5] = 0;
        } else if (vpt[5] < canvas.height - areaObj.height * zoom) {
          vpt[5] = canvas.height - areaObj.height * zoom;
        }

        // Sometimes it still has a positive offset, reset to zero
        if (vpt[4] >= 0) {
          vpt[4] = 0;
        }
        if (vpt[5] >= 0) {
          vpt[5] = 0;
        }
    }

    canvas.forEachObject(function(object){
      object.setCoords();
    });
  };

  /**
   * Handle manual pan for the canvas
   * @param {fabric.Object} tablePlanner // the canvas
   * @param {String} direction // Pan direction
   */
  this.handleManualPan = function (tablePlanner, direction) {

    if(direction == "right"){
      var delta = new fabric.Point(self.CONST_PAN_UNIT, 0);
    }
    if(direction == "left"){
      var delta = new fabric.Point(-self.CONST_PAN_UNIT, 0);
    }
    if(direction == "up"){
      delta = new fabric.Point(0, -self.CONST_PAN_UNIT);
    }
    if(direction == "down"){
      var delta = new fabric.Point(0, self.CONST_PAN_UNIT);
    }

    tablePlanner.relativePan(delta);

    self.handleZoom(false, tablePlanner)

    return false;
  };

  /**
   * Change the canvas pan to show the selected table
   * @param {fabric.Canvas} canvas
   * @param {fabric.Object} table 
   */
  this.scrollCanvasToTable = function(canvas, table) {
    var appliedZoom = canvas.getZoom();
    var newX = (table.left * appliedZoom) - canvas.width/2 ;
    var newY = (table.top * appliedZoom) -  canvas.height/2;
    var delta = new fabric.Point(newX, newY);
    canvas.absolutePan(delta);
    self.handleZoom(false, canvas);
  }

  /**
   * Prevent the tables from going over the boundaries 
   * @param {fabric.Object} table
   */
  this.preventBoundaries = function(table) {

    if (!table) {
      return
    }
    var area = self.getAreaObject(table.canvas);

    if(table.height > area.height || table.width > area.width){
        return;
    }
     
    var ROTATION_SPACING = 35;
     
    table.setCoords();
    // top-left  corner
    if((table.getBoundingRect(true).top - ROTATION_SPACING) < 0 || (table.getBoundingRect(true).left - ROTATION_SPACING) < 0){
        table.top = Math.max(table.top, table.top-(table.getBoundingRect(true).top - ROTATION_SPACING));
        table.left = Math.max(table.left, table.left-(table.getBoundingRect(true).left - ROTATION_SPACING));
    }

    // bottom-right corner
    if((table.getBoundingRect(true).top + ROTATION_SPACING)+table.getBoundingRect(true).height  > area.height || (table.getBoundingRect(true).left + ROTATION_SPACING)+table.getBoundingRect(true).width  > area.width){
      table.top = Math.min(table.top, area.height-table.getBoundingRect(true).height+table.top-(table.getBoundingRect(true).top + ROTATION_SPACING));
      table.left = Math.min(table.left, area.width-table.getBoundingRect(true).width+table.left-(table.getBoundingRect(true).left + ROTATION_SPACING));
    }

  }
  
  
  var CONST_LAST_SELECTED_AREA_COOKIE_NAME = "lastSelectedAreaId";
  var CONST_SELECTED_VIEW_COOKIE_NAME = "selectedView";

  /**
   * Get the id of the last selected area from the cookie
   */
  this.getLastSelectedAreaCookie = function () {
    return Cookies.get(CONST_LAST_SELECTED_AREA_COOKIE_NAME);
  }

  /**
   * Set the id of the last selected area in a cookie
   * @param {Int} areaId
   */
  this.setLastSelectedAreaCookie = function (areaId) {
    Cookies.set(CONST_LAST_SELECTED_AREA_COOKIE_NAME, areaId, {
      expires: 365
    });
  }

  /**
   * Remove the last selected area cookie
   */
  this.removeLastSelectedAreaCookie = function () {
    Cookies.remove(CONST_LAST_SELECTED_AREA_COOKIE_NAME);
  }

  /**
   * Set the selected view in a cookie
   * @param {String} view
   */
  this.setLastSelectedView = function (view) {
    Cookies.set(CONST_SELECTED_VIEW_COOKIE_NAME, view, {
      expires: 365
    });
  }

  /**
   * Get the selected view from the cookie
   */
  this.getSelectedView = function () {
    return Cookies.get(CONST_SELECTED_VIEW_COOKIE_NAME);
  }

  

  /**
   * Set canvas size depending on parent size 
   * @param {fabric.Canvas} canvas
   */
  this.setCanvasSize = function(canvas) {
    canvas.setDimensions({width: jQuery(SEL_CANVAS_HOLDER).width(), height: jQuery(SEL_CANVAS_HOLDER).height() });
  }

  /**
   * Init canvas controls 
   * @param {fabric.Canvas} canvas
   */
  var SEL_CANVAS_CONTROL_HOLDER = '.canvas-controls-holder';
  var SEL_CANVAS_SIZE_INCREASE = '#increaseSize';
  var SEL_CANVAS_SIZE_DECREASE = '#decreaseSize';
  var SEL_CANVAS_ZOOM_IN = '#zoomIn';
  var SEL_CANVAS_ZOOM_OUT = '#zoomOut';
  var SEL_CANVAS_PAN_UP = '#goUp';
  var SEL_CANVAS_PAN_LEFT = '#goLeft';
  var SEL_CANVAS_PAN_RIGHT = '#goRight';
  var SEL_CANVAS_PAN_DOWN = '#goDown';
  this.initCanvasControls = function(moduleNode, canvas) {
    var canvasControlsHolderNode = moduleNode.find(SEL_CANVAS_CONTROL_HOLDER);
    var canvasSizeIncrease = canvasControlsHolderNode.find(SEL_CANVAS_SIZE_INCREASE);
    var canvasSizeDecrease = canvasControlsHolderNode.find(SEL_CANVAS_SIZE_DECREASE);
    var canvasZoomIn = canvasControlsHolderNode.find(SEL_CANVAS_ZOOM_IN);
    var canvasZoomOut = canvasControlsHolderNode.find(SEL_CANVAS_ZOOM_OUT);
    var canvasPanUp = canvasControlsHolderNode.find(SEL_CANVAS_PAN_UP);
    var canvasPanLeft = canvasControlsHolderNode.find(SEL_CANVAS_PAN_LEFT);
    var canvasPanRight = canvasControlsHolderNode.find(SEL_CANVAS_PAN_RIGHT);
    var canvasPanDown = canvasControlsHolderNode.find(SEL_CANVAS_PAN_DOWN);

    // Canvas size controls 
    canvasSizeIncrease.on("click", function() {
      self.updateCanvasSize(canvas, true);
      return false;
    });

    canvasSizeDecrease.on("click", function() {
      self.updateCanvasSize(canvas, false);
      return false;
    });

    // Zoom controls 
    canvasZoomIn.on("click", function() {
      self.handleManualZoom(canvas, true);
    });

    canvasZoomOut.on("click", function() {
      self.handleManualZoom(canvas, false);
    });
    
    // Pan controls 
    canvasPanUp.on("click", function() {
      self.handleManualPan(canvas, 'up');
    });

    canvasPanRight.on("click", function() {
      self.handleManualPan(canvas, 'right');
    });

    canvasPanLeft.on("click", function() {
      self.handleManualPan(canvas, 'left');
    });

    canvasPanDown.on("click", function() {
      self.handleManualPan(canvas, 'down');
    });
    
    canvas.on('mouse:wheel', function (opt) {
      self.handleMouseZoom(opt, canvas);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });
  }

};



// singleton pattern
var singleton = new TablePlannerUtils();

// Make class public to outside world
module.exports = singleton;

},{"../modals/Alert":110,"../modals/Confirm":111,"fabric/dist/fabric":7,"jquery/dist/jquery":14}],167:[function(require,module,exports){
/**
 * TableViewPlan functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// External libs
jQuery = require('jquery/dist/jquery');
Typeahead  				= require('typeahead');
Bloodhound				= require('bloodhound');
var moment = require('moment/min/moment-with-locales');
var UserInterfaceUtils 		= require('../utils/UserInterfaceUtils');
var TablePlannerUtils     = require('./TablePlannerUtils');
var TimelineUtils     = require('./TimelineUtils');
var StringUtils = require('../utils/StringUtils');
var RectTable             = require('./RectTable');
Cookies = require('cookies');


// Class definition
TableViewPlan = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE                              = '.mod-table-plan-view-mode';
    var SEL_PAGE_BODY_CLASS                     = 'body.page-table-plan-view';
    var SEL_TABLE_VIEW_AREA_NAVIGATION          = '.table-view-areas-navigation';
    var SEL_TABLE_VIEW_AREA_RESERVATIONS        = '.table-view-area-reservations';
    var SEL_LAYER_ICON                          = ".area-title-block i";
    var SEL_AREA_LIST_ITEM_CONTAINER            = ".area-list-item-container";
    var SEL_AREA_LIST_ITEM_MODEL                = ".area-list-item-model";
    var SEL_AREA_LIST_ITEM                      = ".area-list-item";
    var SEL_AREA_TITLE                          = ".area-title";
    var SEL_AREA_CAPACITY                       = ".area-capacity";
    var SEL_AREA_EDIT_LINK                      = ".area-edit-link";
    var SEL_DATE_TIME_PICKER_FIELD              = '.date-time-picker';
    var SEL_DATE_HOLDER                         = '.date-time-picker-holder .date-holder';
    var SEL_TIME_HOLDER                         = '.date-time-picker-holder .time-holder';
    var SEL_ARROW_NEXT                          = '.arrow-next';
    var SEL_ARROW_PREV                          = '.arrow-prev';
    var BTN_NOW                                 = '.btn-now';
    var SEL_CANVAS_VIEW                         = '.mod-table-plan-canvas';
    var SEL_TIMELINE_VIEW                       = '.mod-table-plan-timeline';
    var SEL_TABLE_SWITCH_VIEW                   = '.mod-table-plan-table-switch';
    var BTN_CANVAS_VIEW                         = '#select-canvas';
    var BTN_TIMELINE_VIEW                       = '#select-timeline';
    var SEL_TIMELINE                            = '#timeline-plan';
    var SEL_MEALTIME_ELEMENTS                   = '.select-mealtime';
    var SEL_MEALTIME                            = 'select[name="mealTimes"]';      
    var SEL_MEALTIME_HIDDEN                     = 'select[name="mealTimesHidden"]';      
    
    var SEL_AREA_RESERVATIONS                   = ".area-reservations-container";
    
    var SEL_RESERVATION_TYPE_TEMPLATE           = ".reservation-type-template";
    var SEL_RESERVATION_LIST_ITEM_TEMPLATE      = ".reservation-list-item-template";
    var DATA_TABLE_ID                           = 'data-table-id';
    var DATA_CONNECTED_TABLE_IDS                = 'data-connected-table-ids';
    var DATA_RESERVATION_ID                     = 'data-reservation-id';
    var DATA_RESERVATION_ACCEPT_STATUS          = 'data-reservation-accept-status';
    var DATA_RESERVATION_CAPACITY               = 'data-reservation-capacity';
    var DATA_TABLE_CAPACITY                     = 'data-table-capacity';
    var DATA_TABLE_STATUS                       = 'data-table-status';
    var DATA_TABLE_NAME                         = 'data-table-name';
    var CONST_MAX_CAPACITY                      = 999;
    
    var SEL_RESERVATION_LIST_ITEM               = ".reservation-list-item";
    var SEL_RESERVATION_TYPE_CAPACITY           = ".reservation-type-capacity";
    var SEL_BOOKINGS_SECTION                    = ".bookingsSection";
    var SEL_NEXT_BOOKING_COLLPASE_CONTAINER     = ".bookingsSection #bookingsSection";
    var SEL_BOOKING_ARRIVED_BTN                 = ".booking-arrived-btn";
    var SEL_NO_SHOW_BUTTON                      = ".noShow-btn";
    var SEL_ACCEPT_RES_BUTTON                   = ".unconfirmed_res_accept";
    var SEL_REJECT_RES_BUTTON                   = ".unconfirmed_res_reject";
    var SEL_CANCEL_RES_BUTTON                   = ".unconfirmed_res_cancel";
    var SEL_CSRF                                = 'input[name="_csrf"]';
    var SEL_TEXT_CENTER_BUTTON                  = '.text-center';

    var SEL_TS_AREA_HOLDER_TEMPLATE             = ".area-holder-template";
    var SEL_TS_TABLE_HOLDER_TEMPLATE            = ".table-holder-template";
    var SEL_TS_TABLE_SWITCH_CONTAINER           = "#table-switch";
    var SEL_TS_INPUT_TABLES                     = "input[name='table']";
    var SEL_TS_CHANGE_TABLE_BTN                 = '.ts-change-table-btn';
    var SEL_TS_CONFIRM_CHANGE_BTN               = '.ts-confirm-change-btn';
    var SEL_TS_DONT_SAVE_BTN                    = '.ts-dont-save-btn';
    var SEL_TS_BACK_BTN                         = '.ts-back-btn';
    var SEL_TS_CONNECT_TABLES_BTN               = '.connect-tables-btn';
    var SEL_TS_FORM                             = '#table-switch-form';
    var SEL_ADDITIONAL_COMMENT_SECTION          = '.additional-comments';
    var SEL_ADDITIONAL_COMMENT                  = '.comment';

    var SEL_RESERVATION_FORM                    = '.reservation-form';
    var SEL_WALKIN_RESERVATION_FORM             = '.walkin-reservation-form';
    var SEL_TBL_PLAN_RES_FORM                   = ".tbl-plan-res-form";
    var BTN_BACK_RESERVATION_FORM               = '.btn-reservation-form-back';
    var BTN_ADD_RESERVATION                     = '.btn-add-reservation';
    var BTN_CREATE_RESERVATION                  = '.btn-create-reservation';
    var BTN_SAVE_WALKIN                         = '.btn-save-walkin';
    var BTN_CANCEL_RESERVATION                  = '.btn-cancel-reservation';
    var SEL_CUSTOMER_INFO                       = '.customer-info input:not("[type=hidden]")';
    var SEL_RESERVATION_FIRST_NAME              = 'input[name="firstName"]';
    var SEL_RESERVATION_LAST_NAME               = 'input[name="lastName"]';
    var SEL_RESERVATION_PHONE_NUMBER            = 'input[name="phoneNumber"]';
    var SEL_RESERVATION_CAPACITY                = 'input[name="capacity"]';
    var SEL_RESERVATION_EMAIL                   = 'input[name="email"]';
    var SEL_INPUT_TABLE_ID                      = 'input[name="tableId"]';
    var SEL_INPUT_AREA_ID                       = 'input[name="areaId"]';
    var SEL_INPUT_START_DATE                    = 'input[name="startDateString"]';
    var SEL_TABLE_CAPACITY_WARNING_MESSAGE      = '.table-capacity-warning-message';
    var SEL_TABLE_EMAIL_WARNING_MESSAGE         = '.table-email-warning-message';
    var SEL_SUBMIT_BUTTON					    = "button[type='submit']";
	var SEL_CAPACITY_OVERRIDE_INPUT			    = "input[name='checkGuestCapacityLimits']";
    var SEL_RESERVATION_CREATED_BY_INPUT 	    = "input[name='createdBy']";
    var SEL_LIST_ITEM_MODEL                     = ".list-item-model";
    var SEL_LIST_ITEM_NAME                      = ".list-item-name";
    var SEL_LIST_ITEM_NEXT_RESERVATION          = ".list-item-next-reservation";
    var SEL_ICON_FOLD                           = ".icon-fold";
    var SEL_COLLAPSE_CONTAINER                  = '.collapse-container';
    var SEL_ACTIVE_RESERVATION_LIST_ITEMS       = ".reservation-list-item.active";
    var SEL_END_RESERVATION                     = ".end-reservation-button";
    var SEL_RESERVATION_DETAILS_BUTTON          = ".reservation-details-button";
    var SEL_GUEST_INFO_SHOW_MORE                = "a.user-details-show-more";
    
    var CLASS_VIEW_MODE_HTML                    = 'html-table-plan-view-mode';
    var CSS_CLASS_SHOW_LIST                     = "showList";
    var CLASS_ACTIVE_TABLE                      = 'active';
    var CSS_DISABLED_ARROW                      = 'disabled-arrow';
    var CLASS_IN_PROGRESS                       = 'in-progress';
    var CLASS_REACTIVATE_BUTTON                 = 'reActivate';
    var CLASS_SHOW_WARNING_MESSAGE              = 'show-warning-message';
    var CLASS_EXPAND_ADDITIONAL_COMMENT         = 'expand-comment';
    
    var CONST_GET_AREAS_URL                     = "/tablePlan/areas";
    var CONST_EDIT_MODE_URL                     = "/tablePlan/editMode?areaId=";
    var CONST_GET_TABLE_RESERVATIONS_URL        = "/tablePlan/viewModeData";
    var CONST_GET_ALL_AREAS_TABLES_URL          = "/tablePlan/switchTables/";
    var CONST_GET_TIMELINE_RESERVATIONS_URL     = "/tablePlan/viewTimeLine";
    var CONST_SINGLE_TABLE                      = "single_table";
    var CONST_EMAIL_REG 		                = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var REFRESH_CHECKSUM                        = null;
    var REFRESH_DATETIMESTAMP                   = null;
    var TIMELINE_REFRESH_CHECKSUM               = null;
    var TIMELINE_REFRESH_DATETIMESTAMP          = null;
    var MAX_DURATION_DATETIMESTAMP              = null;
    var TIMELINE_INITIATED                      = false;
    var RESERVATION_IN_CHANGE_MODE_ID           = null;
    var RESERVATION_IN_CHANGE_MODE_CAPACITY     = null;
    var RESERVATION_IN_CHANGE_MODE_CONNECTED_TABLES = null;
    var TS_CONNECT_TABLE_MODE                   = false;
    var TS_SELECTED_TABLES                      = null;
    var TIMELINE_START_DATE_TIME                = null;
    var TIMELINE_END_DATE_TIME                  = null;

    var CONST_DEFAULT_CANVAS_SIZE = 500;
    var CONST_CURRENT_MODE = 'viewMode';
    var SEL_ADD_AREA_BUTTON                     = ".add-areas-link";
    
    var URL_WITHOUT_PARAMS                      = "/tablePlan/editMode";

    var SYSTEM_DATE_TIME_FORMAT					= 'YYYY-MM-DD HH:mm';

    var SYSTEM_DATE_FORMAT                      = 'YYYY-MM-DD';

    var SELECTED_MEAL_SERVICE                   = "";

    var nowBtnClicked                           = false;

    var localConfig     = window.config.tableViewAreaReservations  || {};

    var originWalkin    = localConfig.WALKIN;

    var tableStatus = {
        "AVAILABLE"     : localConfig.AVAILABLE,
        "CONFIRMED"     : localConfig.CONFIRMED,
        "REQUESTED"     : localConfig.UNCONFIRMED,
        "PENDING_CCG"    : localConfig.PENDING_CCG,
        "REJECTED"      : localConfig.REJECTED,
        "CANCELLED"     : localConfig.CANCELLED,
        "NOSHOW"        : localConfig.NO_SHOW,
        "DONE"          : localConfig.DONE,
        "ARRIVED"       : localConfig.ARRIVED
    }

    var showListCondition                       = false;
    var currentLinkedNodeToBack                 = false;
    var updateTime                              = true;
    var alltablesAndReservationsInfo            = [];

    var testData = {
        "areaName":"Main room",
        "tablesInArea":10,
        "areaWidth": 1085,
        "areaHeight": 780,
        "datetimestamp": '2020-07-30T07:00:35.446Z',
        "checksum": '12121212121',
        "tables":[
            {"id":1,"name":"Table 1","isLocked":false,"capacity":2,"xPosition":40,"yPosition":40, "status":"ARRIVED", "nextReservation": "12:00", "reservationIds": [1,3,4,5]},
            {"id":2,"name":"Table 2","isLocked":false,"capacity":4,"xPosition":200.0,"yPosition":40.0, "status":"ARRIVED", "nextReservation": "16:00", "reservationIds": [6]},
            {"id":3,"name":"Table 3","isLocked":false,"capacity":4,"xPosition":350.0,"yPosition":40.0, "status":"ARRIVED", "nextReservation": "21:00", "reservationIds": [7]},
            {"id":4,"name":"Table 4","isLocked":false,"capacity":6,"xPosition":40.0,"yPosition":200.0, "status":"UNCONFIRMED", "nextReservation": "21:00", "reservationIds": [1,2,3,5]},
            {"id":5,"name":"Table 5","isLocked":false,"capacity":6,"xPosition":210.0,"yPosition":200.0, "status":"CONFIRMED", "nextReservation": "12:00", "reservationIds": [1,2]},
            {"id":6,"name":"Table 6","isLocked":false,"capacity":6,"xPosition":420.0,"yPosition":200.0, "status":"AVAILABLE", "nextReservation": "12:00", "reservationIds": [1]},
            {"id":7,"name":"Table 7","isLocked":false,"capacity":6,"xPosition":100.0,"yPosition":440.0, "status":"AVAILABLE", "nextReservation": "12:00", "reservationIds": [2]},
            {"id":8,"name":"Table 8","isLocked":true,"capacity":4,"xPosition":300.0,"yPosition":440.0, "status":"INACTIVE", "nextReservation": "12:00", "reservationIds": [1,2,5,7]},
            {"id":9,"name":"Table 9","isLocked":true,"capacity":4,"xPosition":300.0,"yPosition":300.0, "status":"CONFIRMED", "nextReservation": "12:00", "reservationIds": [5,8]}
            ],
        "reservations": [
            {"id": 1, "startDate": "12:00", "endDate": "13:00", "tableIds": [1,2,3]},
            {"id": 2, "startDate": "14:00", "endDate": "15:00", "tableIds": [5,6]},
            {"id": 3, "startDate": "15:00", "endDate": "16:00", "tableIds": [4]},
            {"id": 4, "startDate": "15:30", "endDate": "16:00", "tableIds": [1]},
            {"id": 5, "startDate": "16:00", "endDate": "17:00", "tableIds": [2]},
            {"id": 6, "startDate": "17:00", "endDate": "17:30", "tableIds": [3]},
            {"id": 7, "startDate": "18:00", "endDate": "19:00", "tableIds": [9]},
            {"id": 8, "startDate": "18:30", "endDate": "19:00", "tableIds": [8,9]},
            ],
        "arrived": [
            {
                "reservationId": "1",
                "customerName": "Peter Sellers",
                "startDate": "10:30",
                "capacity": 5,
                "tablesIds": [1,2,3],
                "hasAllergy": true,
                "hasDiet": true,
                "hasSpecialOccasion": true,
                "customerPhone": 015234567564,
                "customerComment": "Special occasion... Please give us some privacy",
                "status": "Arrived"
            },
            {
                "reservationId": "2",
                "customerName": "John Green",
                "startDate": "11:30",
                "capacity": 3,
                "tablesIds": [4]
            }
            ],
        "bookings": [
            {
                "reservationId": "3",
                "customerName": "Eva Smith",
                "startDate": "20:30",
                "capacity": 5,
                "tablesIds": [5, 9],
                "hasAllergy": true,
                "showCCG" : true,
                "hasDiet": true,
                "hasSpecialOccasion": true,
                "customerPhone": 015235557564,
                "customerComment": "My comment is left here",
                "status": "Confirmed",
                "showArrivedButton": true
            },
            {
                "reservationId": "4",
                "customerName": "Phill Quake",
                "startDate": "21:30",
                "capacity": 4,
                "showArrivedButton": true,
                "tablesIds": [6]
            }
    
            ],
        "availableTablesIds": [7,8]
    }

    var timelineMockData = {
        "startDateTimeString": "2020-08-04 9:00",
        "endDateTimeString": "2020-08-05 02:10",
        "selectedTimeString": "2020-08-03 17:12",

        "tables": [
            {
                "id": "1",
                "name": "Table 1",
                "capacity": 6,
                "reservations": [
                    {"startDate": "2020-08-04 09:00", "endDate": "2020-08-04 12:00", "status": "AVAILABLE"},        
                    {"id":14, "customer":"Peter Sellers", "capacity": 5, "startDate": "2020-08-04 12:00", "endDate": "2020-08-04 14:00", "status":"CONFIRMED"},
                    {"startDate": "2020-08-04 14:00", "endDate": "2020-08-04 17:00", "status": "AVAILABLE"},
                    {"startDate": "2020-08-04 17:00", "endDate": "2020-08-04 20:00", "status": "CLOSED"},
                    {"startDate": "2020-08-04 20:00", "endDate": "2020-08-04 21:00", "status": "AVAILABLE"},        
                    {"id":27, "customer":"John Green", "capacity": 8, "startDate": "2020-08-04 21:00", "endDate": "2020-08-04 23:00", 
                      "status":"UNCONFIRMED"},
                    {"startDate": "2020-08-04 23:00", "endDate": "2020-08-05 02:00", "status": "AVAILABLE"} 
                ]
            },
            {
                "id": "2",
                "name": "Table 2",
                "capacity": 8,
                "reservations": [
                    {"startDate": "2020-08-04 09:00", "endDate": "2020-08-04 12:00", "status": "AVAILABLE"},        
                    {"id":14, "customer":"Peter Sellers", "capacity": 5, "startDate": "2020-08-04 12:00", "endDate": "2020-08-04 14:00", "status":"CONFIRMED"},
                    {"startDate": "2020-08-04 14:00", "endDate": "2020-08-04 17:00", "status": "AVAILABLE"},
                    {"startDate": "2020-08-04 17:00", "endDate": "2020-08-04 20:00", "status": "CLOSED"},
                    {"startDate": "2020-08-04 20:00", "endDate": "2020-08-04 21:00", "status": "AVAILABLE"},        
                    {"id":27, "customer":"John Green", "capacity": 8, "startDate": "2020-08-04 21:00", "endDate": "2020-08-04 23:00", 
                      "status":"UNCONFIRMED"},
                    {"startDate": "2020-08-04 23:00", "endDate": "2020-08-05 02:00", "status": "AVAILABLE"} 
                ]
            },
            {
                "id": "3",
                "name": "Table 3",
                "capacity": 8,
                "reservations": [
                    {"startDate": "2020-08-04 09:00", "endDate": "2020-08-04 12:00", "status": "AVAILABLE"},        
                    {"id":14, "customer":"Peter Sellers", "capacity": 5, "startDate": "2020-08-04 12:00", "endDate": "2020-08-04 14:00", "status":"CONFIRMED"},
                    {"startDate": "2020-08-04 14:00", "endDate": "2020-08-04 17:00", "status": "AVAILABLE"},
                    {"startDate": "2020-08-04 17:00", "endDate": "2020-08-04 20:00", "status": "CLOSED"},
                    {"startDate": "2020-08-04 20:00", "endDate": "2020-08-04 21:00", "status": "AVAILABLE"},        
                    {"id":27, "customer":"John Green", "capacity": 8, "startDate": "2020-08-04 21:00", "endDate": "2020-08-04 23:00", 
                      "status":"UNCONFIRMED"},
                    {"startDate": "2020-08-04 23:00", "endDate": "2020-08-05 02:00", "status": "AVAILABLE"} 
                ]
            },
            {
                "id": "4",
                "name": "Table 4",
                "capacity": 8,
                "reservations": [
                    {"startDate": "2020-08-04 09:00", "endDate": "2020-08-04 12:00", "status": "AVAILABLE"},        
                    {"id":14, "customer":"Peter Sellers", "capacity": 5, "startDate": "2020-08-04 12:00", "endDate": "2020-08-04 14:00", "status":"CONFIRMED"},
                    {"startDate": "2020-08-04 14:00", "endDate": "2020-08-04 17:00", "status": "AVAILABLE"},
                    {"startDate": "2020-08-04 17:00", "endDate": "2020-08-04 20:00", "status": "CLOSED"},
                    {"startDate": "2020-08-04 20:00", "endDate": "2020-08-04 21:00", "status": "AVAILABLE"},        
                    {"id":27, "customer":"John Green", "capacity": 8, "startDate": "2020-08-04 21:00", "endDate": "2020-08-04 23:00", 
                      "status":"UNCONFIRMED"},
                    {"startDate": "2020-08-04 23:00", "endDate": "2020-08-05 02:00", "status": "AVAILABLE"} 
                ]
            }
        ]
    }

    var allAreasWithTablesMockData = {
        "areas": [{
                "id": 1,
                "name": "Area 1",
                "tables": [{
                        "id": 1,
                        "name": "Table 1",
                        "capacity": 2,
                        "nextStartTime": "13:30",
                        "hasConflict": true,
                        "status":"CONFIRMED"
                    },
                    {
                        "id": 2,
                        "name": "Table 2",
                        "capacity": 4,
                        "status":"UNCONFIRMED"
                    },
                    {
                        "id": 3,
                        "name": "Table 3",
                        "capacity": 4,
                        "nextStartTime": "14:00",
                        "hasConflict": true,
                        "status":"AVAILABLE"
                    },
                    {
                        "id": 4,
                        "name": "Table 4",
                        "capacity": 6,
                        "nextStartTime": "15:00",
                        "status":"AVAILABLE"
                    }
                ]
            },
            {
                "id": 2,
                "name": "Area 2",
                "tables": [{
                        "id": 5,
                        "name": "Table 5",
                        "capacity": 4,
                        "nextStartTime": "15:00",
                        "status":"AVAILABLE"
                    },
                    {
                        "id": 6,
                        "name": "Table 6",
                        "capacity": 6,
                        "nextStartTime": "14:00",
                        "hasConflict": true,
                        "status":"CONFIRMED"
                    },
                    {
                        "id": 7,
                        "name": "Table 7",
                        "capacity": 8,
                        "status":"CONFIRMED"
                    },
                    {
                        "id": 8,
                        "name": "Table 8",
                        "capacity": 10,
                        "status":"AVAILABLE"
                    }
                ]
            }

        ]
    }

    /**
     * Init autosuggest for createdBy field
     * @param module
     */
    const initCreatedByAutoSuggest = function (module) {
        let createdBy = module.find(SEL_RESERVATION_CREATED_BY_INPUT);

        // Define auto suggest lookup
        let engine = new Bloodhound({
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            sorter: (a, b) => -1
        });
        fetchDataForCreatedByAutoSuggest(engine);
        bindCreatedByTypeahead(createdBy, engine);
        return engine;
    };

    /**
     * Initialize mealtime-select
     */

    var initializeItem = function(item) {
        item.find(SEL_MEALTIME)
          .selectpicker();
    };

    
    /**
     * Returns the active table (if set) and the current viewport of the canvas
     * @param {fabricjs Object} tablePlanner
     * @return {Object}
     */
    var getStateBeforeRefresh = function (tablePlanner) {
        return {
            activeTable: tablePlanner.getActiveObject(),
            currentViewport: tablePlanner.viewportTransform
        }
    }

    /**
     * Sets the active table (if set) and the current viewport on the canvas
     * @param {fabricjs Object} tablePlanner // the canvas
     * @param {Object} stateBeforeRefresh // contains the active table object and the canvas viewport
     */
    var setStateBeforeRefresh = function (tablePlanner, stateBeforeRefresh) {
        if (stateBeforeRefresh.activeTable != undefined) {
            tablePlanner.setActiveObject(stateBeforeRefresh.activeTable);
        }
        tablePlanner.setViewportTransform(stateBeforeRefresh.currentViewport.map(function(currentViewportValue){
            return currentViewportValue * tablePlanner.getZoom();
        }));
    }
    var refreshTimer = null;
    // Reseting refresh timer
    var clearRefreshTimer = function () {
        if (refreshTimer) {
            clearTimeout(refreshTimer);
        }
    }

    // Handles the automatic refresh call 
    var refreshAutomaticTimer = function (moduleNode, tablePlanner, timeline, areaId) {
        clearRefreshTimer();
        refreshTimer = setTimeout(function () {
            handleAjaxCalls(moduleNode, tablePlanner, timeline, areaId);
        }, window.config.tableViewPlan.refreshFrequency * 1000);
    }


    /**
     * Gets and returns the current date & timestamp as a string value in ISO format
     * @return {String}
     */
    var getCurrentDateTimestamp = function () {
        return new Date().toISOString();
    }

    /**
     * Gets and returns the tomorrow date from the passed param as a string value in ISO format
     * @param {String} date Date in ISO format
     * @return {String}
     */
    var getTomorrowsDateTimestamp = function (date) {
        var day = new Date(date);
        var nextDay = new Date(day);
        nextDay.setDate(nextDay.getDate() + 1);
        return nextDay.toISOString();
    }

    /**
     * Increments a date with seconds and returns it
     * @param {String} date Date in ISO format
     * @param {Number} increment The amount to be incremented in seconds
     * @return {String}
     */
    var incrementDateTimestamp = function (date, increment) {
        // format the date to work in every browser
        var correctDate = date.replace(/-/g, "/");
        var day = new Date(correctDate);
        var newDate = new Date(day);
        newDate.setSeconds(newDate.getSeconds() + Number(increment));
        newDate = moment(newDate).format('YYYY-MM-DD HH:mm:ss');
        return newDate;
    }

    var hasTableUpcomingReservations = function(selectedTableId, allReservationsInfo){
        var isUpcomingReservation =  allReservationsInfo.filter(function(elem){ 
            return (elem.tableIds.indexOf(selectedTableId) != -1);
        });
        return isUpcomingReservation;
    }
    
    /**
     * Setting active table in list by clicking on table in canvas and scroll list to active table
     * @param {number[]} selectedTablesIds
     * @param {jQuery.DOMElement} tablesList
     */
    this.setActiveTableInList = function(selectedTablesIds, tablesList, selectedReservationId) {

        var isUpcomingReservationAvailable = hasTableUpcomingReservations(selectedTablesIds[0], alltablesAndReservationsInfo.reservations);

        tablesList.find(SEL_RESERVATION_LIST_ITEM).removeClass(CLASS_ACTIVE_TABLE);
        var tablesByReservationArray = [];
        
        if(!selectedTablesIds) {
            //close all opened reservation info blocks
            tablesList.find(SEL_COLLAPSE_CONTAINER).removeClass('in').hide();
            return false;
        }

        selectedTablesIds.forEach(function(tableId){
            var activeTableInList = tablesList.find('[' + DATA_TABLE_ID + '="'+ tableId +'"]');
            if (activeTableInList.length > 0 && selectedReservationId) {
                activeTableInList.each(function(index, table) {
                    var reservationId = jQuery(table).attr(DATA_RESERVATION_ID);
                    var list = tablesList.find('[' + DATA_RESERVATION_ID + '="'+ reservationId +'"]');
                    if(selectedReservationId == reservationId) {
                        list.addClass(CLASS_ACTIVE_TABLE);
                    }
                    tablesByReservationArray.push(list)
                });
            }

            if (!selectedReservationId){
                activeTableInList.addClass(CLASS_ACTIVE_TABLE);
                if(isUpcomingReservationAvailable.length !== 0){
                    tablesByReservationArray.push(activeTableInList);
                }
            }
        });

        tablesByReservationArray.forEach(function(reservationTablesArray) {
            if(selectedReservationId && selectedReservationId == reservationTablesArray.first().attr(DATA_RESERVATION_ID)) {
                reservationTablesArray.last().next(SEL_COLLAPSE_CONTAINER).show().collapse('show');
            }

            if(!selectedReservationId) {
                reservationTablesArray.last().next(SEL_COLLAPSE_CONTAINER).show().collapse('show');
            }

            if(reservationTablesArray.hasClass('active')){
                var additionalCommentNode = reservationTablesArray.next('.collapse-container').find(SEL_ADDITIONAL_COMMENT_SECTION);
                var commentNode = additionalCommentNode.find('.comment');
                var commentText = commentNode.text();
                
                //add 'cursor-pointer' class if comment is large, otherwise remove that class
                commentText.length > 41 ? additionalCommentNode.addClass('cursor-pointer') : additionalCommentNode.removeClass('cursor-pointer');
                //crop the comment text, if the characters are > 41
                var updatedCommentText = commentText.length > 41 ? commentText.substring(0, 41) + "..." : commentText;
                commentNode.text(updatedCommentText);

                //remove 'expand-comment' class if already exists
                commentNode.removeClass(CLASS_EXPAND_ADDITIONAL_COMMENT);

                expandAdditionalGuestComment(reservationTablesArray, commentText);
            }
        });

        var tablesInfoNotActive = tablesList.find(SEL_COLLAPSE_CONTAINER).not(jQuery(SEL_ACTIVE_RESERVATION_LIST_ITEMS).next(SEL_COLLAPSE_CONTAINER));
        if (tablesInfoNotActive.hasClass('in')) {
            tablesInfoNotActive.removeClass('in').hide();
        }
        
        self.scrollTableListToActiveTable(tablesList, jQuery(SEL_ACTIVE_RESERVATION_LIST_ITEMS).first());
    }

    /**
     * @description Expand the additional guest comments if exists
     * @param {*} node - active reservation node
     */
    var expandAdditionalGuestComment = function(node, commentText){
        var additionalCommentSection = node.next().find(SEL_ADDITIONAL_COMMENT_SECTION);
        var additionalComment = node.next().find(SEL_ADDITIONAL_COMMENT);

        //expand additional guest comments on click
        if(!additionalComment.hasClass(CLASS_EXPAND_ADDITIONAL_COMMENT)){
            additionalCommentSection.on('click', function(){
                additionalComment.addClass(CLASS_EXPAND_ADDITIONAL_COMMENT);
                additionalComment.text(commentText);
            });
        };
    }

    /**
     * Scrolling tables list to active table
     * @param {jQuery.DOMElement} tablesList
     * @param {jQuery.DOMElement} activeTableInList
     */
    this.scrollTableListToActiveTable = function(tablesList, activeTableInList) {
        var reservationTypeHeader = activeTableInList.parent();
        reservationTypeHeader.collapse('show');

        var otherTopSpaces = 160; // Paddings and margins at the top

        // TODO: Recheck getOffsetTop() function 
        tablesList.stop().animate({ 
            scrollTop: getOffsetTop(activeTableInList[0]) - otherTopSpaces - tablesList.height() / 2 + activeTableInList.height() / 2
        }, 300);
        
    }

    var getOffsetTop = function(element) {
        var offsetTop = 0;
        while(element) {
          offsetTop += element.offsetTop;
          element = element.offsetParent;
        }
        return offsetTop;
    }

    var resetAutomaticOperations = function(){
        REFRESH_CHECKSUM = null;
        REFRESH_DATETIMESTAMP = null;
        TIMELINE_REFRESH_CHECKSUM = null;
        TIMELINE_REFRESH_DATETIMESTAMP = null;
        MAX_DURATION_DATETIMESTAMP = null;
    }

    
    var getTables = function(availableTables, allTables){
        var availableTablesData = availableTables.map(function(data, index){
            var availableTables = allTables.filter(function(table){
                return table.id == data;
            });
            return availableTables[0];
        });
        return availableTablesData;
    }

    var getTableNextReservations = function(reservations, allReservations, reservationStartTime){
        var testDate = '01/01/2011 ';
        var reservationsData = reservations.map(function(data, index){
            var reservations = allReservations.filter(function(table){
                if(table.id == data){
                    if(new Date(testDate + reservationStartTime) < new Date(testDate + table.startDate)){
                        return table;
                    }
                }
            });
            return reservations[0];
        }).filter(function (el) {
            return el != undefined;
        });
        return reservationsData;
    }

    /**
     * @description get current day all reservations list
     */
    var getAllTableNextReservations = function(reservations, allReservations, reservationStartTime, tablesList){
        var testDate = '01/01/2011 ';
        var reservationsData = reservations.map(function(data){
            var reservations = allReservations.filter(function(table){
                if(table.tableIds.indexOf(data) != -1 && table.startDate != reservationStartTime && 
                (new Date(testDate + reservationStartTime) < new Date(testDate + table.startDate))){
                    return table;
                }
            });
            return reservations;
        });

        var upcomingReservations = reservationsData.flat();
        //to remove duplicate entries from an array
        var uniqueReservations = upcomingReservations.filter(function(item, pos) {
            return upcomingReservations.indexOf(item) == pos;
        });

        return getUpdatedAllReservations(getUniqueReservationsById(uniqueReservations, tablesList), uniqueReservations);
    }

    var ellipsize = function(str, maxLength) {
        return str.length > maxLength ? str.substring(0, maxLength) + '...' : str;
    }

    /**
     * @param reservations all upcoming reservations list for selected tables
     * @param tablesList all tables list for which we are checking upcoming reservations
     * @description get all unique reservation by id
     */
    var getUniqueReservationsById = function(reservations, tablesList){
        var reservationObj = {};
        var reservationsById = reservations.filter(function(elem) {
            if(elem.tableIds.length == 1){
                if (reservationObj[elem.tableIds[0]]) {
                    return false;
                }
                reservationObj[elem.tableIds[0]] = true;
                return true;
            }
        });

        return updateReservationByTableName(reservationsById, tablesList);
    }

    /**
     * @param reservationsById id for each reservations
     * @param tablesList all tables list for which we are checking upcoming reservations
     * @description add table name as a key in all unique reservation (by id)
     */
    var updateReservationByTableName = function(reservationsById, tablesList){
        var reservationsByTableName = reservationsById.map(function(item){
            item.tableName = getTableName(item.tableIds[0], tablesList);
            return item;
        });
        return reservationsByTableName;
    }


    /**
     * @param selectedTableId selected table id
     * @param tablesList all tables list for which we are checking upcoming reservations
     * @description get the table name after comparing selectedTableId with the tablesList array
     */
    var getTableName = function(selectedTableId, tablesList){
        var selectedTableName = tablesList.filter(function(table){
            if(table.id == selectedTableId){
                return table;
            }
        });
        return selectedTableName[0].name;
    }

    /**
     * @param reservationsByName selected table id reservations list
     * @param allReservations all upcoming reservations list
     * @description update all unique reservations with the entries after updation of table name
     */
    var getUpdatedAllReservations = function(reservationsByName, allReservations){
        allReservations.filter(function(opt1){
            reservationsByName.map(function(opt2){
                if(opt1.id == opt2.id){
                    opt1 = opt2;
                }
            })
        });
        return allReservations;
    }

    /**
     * @param selectedTableId selected table id reservations list
     * @param allReservations all upcoming reservations list
     * @description compare unique table id reservation with all reservations array and update the entries for which table id matches
     */
    var getAllDayTablesReservations = function(selectedTableId, allReservations){
        var reservationsData = allReservations.filter(function(table){
            if (table.tableIds.indexOf(selectedTableId) != -1) {
                return table;
            }
        });
        return reservationsData;
    }

    /**
	 * Build the areas with their tables list.
	 *
	 * @param {jQuery.DOMElement} moduleNode
	 * @param {Array} result
	 */
    var buildAreasWithTables = function(moduleNode, result, idsToCheck){
        console.log('areas and tables: ', result);

        var tableSwitchContainer = moduleNode.find(SEL_TS_TABLE_SWITCH_CONTAINER);
        // Remove everything apart from the templates
        tableSwitchContainer.find('> *').not(SEL_TS_AREA_HOLDER_TEMPLATE).not(SEL_TS_TABLE_HOLDER_TEMPLATE).remove();
        var areaHolderTemplate = moduleNode.find(SEL_TS_AREA_HOLDER_TEMPLATE).html();
        var tableHolderTemplate = moduleNode.find(SEL_TS_TABLE_HOLDER_TEMPLATE).html();

        result.areas.forEach(function(area) {
            var areaHolderHtml = areaHolderTemplate;
            areaHolderHtml = areaHolderHtml.replace(/{AREA_NAME}/g, area.name);
            areaHolderHtml = areaHolderHtml.replace(/{AREA_ID}/g, area.id);

            var tablesContainer = '';
            area.tables.forEach(function(table) {

                var tableHolderHtml = tableHolderTemplate;
                tableHolderHtml = tableHolderHtml.replace(/{TABLE_ID}/g, table.id);
                tableHolderHtml = tableHolderHtml.replace(/{AREA_ID}/g, area.id);
                tableHolderHtml = tableHolderHtml.replace(/{TABLE_CAPACITY}/g, table.capacity);
                tableHolderHtml = tableHolderHtml.replace(/{TABLE_NAME}/g, table.name);
                tableHolderHtml = tableHolderHtml.replace(/{TABLE_NEXT_START_TIME}/g, table.nextStartTime != undefined ? table.nextStartTime : '-');
                tableHolderHtml = tableHolderHtml.replace(/{TABLE_CONNECTOR}/g, area.tables.length == 1 ? 'hide' : '');

                if(idsToCheck.includes(table.id)){
                    tableHolderHtml = tableHolderHtml.replace(/{TABLE_STATUS}/g, '<img src="'+window.config.tableViewPlan.tsTableStatusPath + 'table_' + table.status + '.png" >');
                }else{
                    if(table.hasConflict == undefined){
                        tableHolderHtml = tableHolderHtml.replace(/{TABLE_STATUS}/g, '<img src="'+window.config.tableViewPlan.tsTableStatusPath + 'table_AVAILABLE.png" >');
                    }else{
                        tableHolderHtml = tableHolderHtml.replace(/{TABLE_STATUS}/g, '<img src="'+window.config.tableViewPlan.tsTableStatusPath + 'table_CONFIRMED.png" >');
                    }
                }
                

                tablesContainer += tableHolderHtml;
            });

            areaHolderHtml = areaHolderHtml.replace(/{TABLE_LIST}/g, tablesContainer);
            tableSwitchContainer.append(areaHolderHtml);
        });
    }


    /**
	 * Generates the tables and reservations list.
	 *
	 * @param {String (html converted to string)} reservationTypeHeaderTemplate The reservation header template
	 * @param {String (html converted to string)} reservationListItemTemplate The reservation list item template
	 * @param {Array} result View area mode results
	 * @param {Array} currRes Current reservation for that section 
	 * @param {String} section the section for which we will generate
     * @return {String (html converted to string)}
	 */
    var generateTableReservations = function(reservationTypeHeaderTemplate, reservationListItemTemplate, result, currRes, section){
        
        var newSection = reservationTypeHeaderTemplate;
        
        // Same for all sections 
        newSection = newSection.replace(/{SECTION}/g, section);
        newSection = newSection.replace(/{SECTION_NAME}/g, window.config.tableViewPlan[section] || 'Area');
        newSection = newSection.replace(/{SECTION_CAPACITY}/g, currRes.length);

        var tablesContainer = '';

        if(section != 'availableSection'){
            
            // Handle the Arrived and Bookings sections 
            if(currRes.length != 0){
                currRes.forEach(function(reservation) {

                    var count = 0; //to remove duplicate entry

                    var guestInfoTextLimit = 200;

                    var reservationTableIds = reservation.tablesIds;

                    var CLASS_CUSTOMER_PHONE = reservation.customerPhone ? "has-customer-phone" : "";

                    var CUSTOMER_PHONE = reservation.customerPhone ? reservation.customerPhone: "--";

                    var CUSTOMER_EMAIL = reservation.customerEmail ? reservation.customerEmail :  "--" ;

                    let CLASS_SHOW_CUSTOMER_VISIT_COUNT = reservation.customerLoyaltyStatus ? '' : "hide";

                    var CUSTOMER_VISIT_COUNT = reservation.customerLoyaltyStatus ? reservation.customerLoyaltyStatus : 0;

                    var GUEST_REQUEST = reservation.customerComment ? ellipsize(reservation.customerComment, guestInfoTextLimit) : 0;

                    var CLASS_GUEST_REQUEST = reservation.customerComment ? '' : "hide";

                    var CLASS_GUEST_REQUEST_SHOW_MORE = reservation.customerComment && reservation.customerComment.length > guestInfoTextLimit ? '' : "hide";

                    var INTERNAL_NOTE = reservation.additionalGuestComment ? ellipsize(reservation.additionalGuestComment, guestInfoTextLimit) : '';

                    var CLASS_INTERNAL_NOTE = reservation.additionalGuestComment ? '' : "hide";

                    var CLASS_INTERNAL_NOTE_SHOW_MORE = reservation.additionalGuestComment && reservation.additionalGuestComment.length > guestInfoTextLimit ? '' : "hide";

                    var INTERNAL_GUEST_INFO = reservation.guestInformation ? ellipsize(reservation.guestInformation, guestInfoTextLimit) : '';

                    var CLASS_INTERNAL_GUEST_INFO = reservation.guestInformation ? '' : "hide";

                    var CLASS_INTERNAL_GUEST_INFO_SHOW_MORE = reservation.guestInformation && reservation.guestInformation.length > guestInfoTextLimit ? '' : "hide";

                    var DIETS = reservation.diets ? reservation.diets : '';

                    var CLASS_DIETS = reservation.diets ? '' : "hide";

                    var ALLERGIES = reservation.allergies ?  reservation.allergies : '';

                    var CLASS_ALLERGIES = reservation.allergies ? '' : "hide";

                    var CLASS_CCG = reservation.showCCG ? '' : "hide";

                    let CLASS_SERIES = reservation.seriesId ? '' : "hide";

                    var CREATED_BY = reservation.createdBy ? reservation.createdBy : '';

                    var CLASS_CREATED_BY = reservation.createdBy ? '' : "hide";

                    var showArrivedButton = reservation.showArrivedButton ? '' : "hide";

                    var showNoShowButton = reservation.showNoShowButton ? '' : "hide";

                    var showEndReservationButton = reservation.showEndReservationButton ? '' : "hide";

                    var showAddReservation = reservation.showAddReservation && section != 'arrivedSection' ? '' : "hide";
                    
                    var showAccessAndRejectButtons = reservation.showAccessAndRejectButtons ? '' : "hide";
                    
                    // Get the tables info for our reservation 
                    var tablesData = getTables(reservation.tablesIds, result.tables);

                    var listItemContainer = ""; 
                    var reservationListItemArray = [];

                    var hasNextReservations = tablesData.some(function(table, index) {
                        var tableNextReservations = getTableNextReservations(table.reservationIds, result.reservations, reservation.startDate);
                        return tableNextReservations.length > 0;
                    });
        
                    tablesData.forEach(function(table, index) {                       
                        // Create HTML
                        var reservationListItem = reservationListItemTemplate;
                        reservationListItem = reservationListItem.replace(/{TABLE_ID}/g, table.id);
                        reservationListItem = reservationListItem.replace(/{RESERVATION_ID}/g, reservation.reservationId);
                        reservationListItem = reservationListItem.replace(/{TABLE_NAME}/g, table.name);
                        reservationListItem = reservationListItem.replace(/{TABLE_NAME_DATA}/g, table.name);
                        reservationListItem = reservationListItem.replace(/{TABLE_CAPACITY}/g, table.capacity);
                        reservationListItem = reservationListItem.replace(/{TABLE_CAPACITY_DATA}/g, table.capacity);
                        reservationListItem = reservationListItem.replace(/{TABLE_STATUS}/g, table.status == 'INACTIVE' ? table.status.toLowerCase() :'');
                        reservationListItem = reservationListItem.replace(/{TABLE_STATUS_DATA}/g, table.status);
                        reservationListItem = reservationListItem.replace(/{RESERVATION_ACCEPT_STATUS}/g, reservation.acceptStatus || '');
                        reservationListItem = reservationListItem.replace(/{SHOW_AVAILABLE_TABLES}/g, '');
                        if(reservation.customerName == '' || reservation.customerName == undefined){
                            reservationListItem = reservationListItem.replace(/{CUSTOMER_NAME}/g, originWalkin);
                        }else{
                            reservationListItem = reservationListItem.replace(/{CUSTOMER_NAME}/g, reservation.customerName);
                        }
                        reservationListItem = reservationListItem.replace(/{RESERVATION_CAPACITY}/g, reservation.capacity);
                        reservationListItem = reservationListItem.replace(/{RESERVATION_TIME}/g, reservation.startDate);
                        reservationListItem = reservationListItem.replace(/{GUEST_REQUEST}/g, GUEST_REQUEST);
                        reservationListItem = reservationListItem.replace(/{CLASS_GUEST_REQUEST}/g, CLASS_GUEST_REQUEST);
                        reservationListItem = reservationListItem.replace(/{CLASS_GUEST_REQUEST_SHOW_MORE}/g, CLASS_GUEST_REQUEST_SHOW_MORE);
                        reservationListItem = reservationListItem.replace(/{INTERNAL_NOTE}/g, INTERNAL_NOTE);
                        reservationListItem = reservationListItem.replace(/{CLASS_INTERNAL_NOTE}/g, CLASS_INTERNAL_NOTE);
                        reservationListItem = reservationListItem.replace(/{CLASS_INTERNAL_NOTE_SHOW_MORE}/g, CLASS_INTERNAL_NOTE_SHOW_MORE);
                        reservationListItem = reservationListItem.replace(/{INTERNAL_GUEST_INFO}/g, INTERNAL_GUEST_INFO);
                        reservationListItem = reservationListItem.replace(/{CLASS_INTERNAL_GUEST_INFO}/g, CLASS_INTERNAL_GUEST_INFO);
                        reservationListItem = reservationListItem.replace(/{CLASS_INTERNAL_GUEST_INFO_SHOW_MORE}/g, CLASS_INTERNAL_GUEST_INFO_SHOW_MORE);
                        reservationListItem = reservationListItem.replace(/{ALLERGIES}/g, ALLERGIES);
                        reservationListItem = reservationListItem.replace(/{CLASS_ALLERGIES}/g, CLASS_ALLERGIES);
                        reservationListItem = reservationListItem.replace(/{CLASS_CCG}/g, CLASS_CCG);
                        reservationListItem = reservationListItem.replace(/{CLASS_SERIES}/g, CLASS_SERIES);
                        reservationListItem = reservationListItem.replace(/{CREATED_BY}/g, CREATED_BY);
                        reservationListItem = reservationListItem.replace(/{CLASS_CREATED_BY}/g, CLASS_CREATED_BY);
                        reservationListItem = reservationListItem.replace(/{DIETS}/g, DIETS);
                        reservationListItem = reservationListItem.replace(/{CLASS_DIETS}/g, CLASS_DIETS);
                        reservationListItem = reservationListItem.replace(/{CUSTOMER_PHONE}/g, CUSTOMER_PHONE);
                        reservationListItem = reservationListItem.replace(/{CUSTOMER_EMAIL}/g, CUSTOMER_EMAIL);
                        reservationListItem = reservationListItem.replace(/{CLASS_SHOW_CUSTOMER_VISIT_COUNT}/g, CLASS_SHOW_CUSTOMER_VISIT_COUNT);
                        reservationListItem = reservationListItem.replace(/{CUSTOMER_VISIT_COUNT}/g, CUSTOMER_VISIT_COUNT);
                        reservationListItem = reservationListItem.replace(/{SHOW_ICON}/g,'');
                        jQuery(document.body).tooltip({ selector: "[title]" });
                        reservationListItem = reservationListItem.replace(/{CLASS_CUSTOMER_PHONE}/g, CLASS_CUSTOMER_PHONE);
                        reservationListItem = reservationListItem.replace(/{RES_STATUS}/g, tableStatus[reservation.status.toUpperCase()]);
                        reservationListItem = reservationListItem.replace(/{RESERVATION_ARRIVED}/g, showArrivedButton);
                        reservationListItem = reservationListItem.replace(/{SHOW_ADD_RESERVATION_BUTTON}/g, showAddReservation);
                        reservationListItem = reservationListItem.replace(/{RESERVATION_NOSHOW}/g, showNoShowButton);
                        reservationListItem = reservationListItem.replace(/{END_RESERVATION}/g, showEndReservationButton);
                        reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_ACCEPT}/g, showAccessAndRejectButtons);
                        reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_REJECT}/g, showAccessAndRejectButtons);
                        
                        //show cancel button for unconfirmed reservations
                        if(reservation.status == "Unconfirmed"){
                            if(reservation.showAccessAndRejectButtons){
                                reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_CANCEL}/g, 'hide');
                            } else {
                                reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_CANCEL}/g, '');
                            }
                        } else{
                            reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_CANCEL}/g, 'hide');
                        }
                        
                        // Handle reservations with connected tables 
                        if(tablesData.length > 1){
                            reservationListItem = reservationListItem.replace(/{SHOW_CONNECTED_MARKER}/g, index == (tablesData.length -1) ? 'hide' : '');
                            reservationListItem = reservationListItem.replace(/{CONNECTED_TABLE_IDS}/g, reservation.tablesIds.toString());
                        }else{
                            reservationListItem = reservationListItem.replace(/{SHOW_CONNECTED_MARKER}/g, 'hide');
                            reservationListItem = reservationListItem.replace(/{CONNECTED_TABLE_IDS}/g, CONST_SINGLE_TABLE);
                        }

                        // Get the next reservations for the table (only if they are later than the current reservation) 
                        var allTableNextReservations = getAllTableNextReservations(reservation.tablesIds, result.reservations, reservation.startDate, tablesData);
                        count++;
                        // If no next reservations and allTableNextReservations List is empty, we hide the section 
                        reservationListItem = reservationListItem.replace(/{NEXT_RESERVATION_STATUS}/g, (hasNextReservations || allTableNextReservations.length > 0) ? '' : 'hide');

                        var listItemModel = jQuery(reservationListItem).find(SEL_LIST_ITEM_MODEL);
                        var listItemClone = jQuery(listItemModel.html());

                        if(allTableNextReservations.length > 0 && count == 1){ // count -> if value is 1 then only loop will iterate otherwise not (it will remove duplicate entries)
                            
                            allTableNextReservations.forEach(function(reservation, index) {
                                
                                var reservationDetailsUrl = '/reservation/'+reservation.id;
    
                                if(reservation.tableIds.length > 1){
                                    // reservation with multiple tables
                                    listItemClone.find('a').attr("href", reservationDetailsUrl);
    
                                    // connected tables name
                                    var reservationTables = getTables(reservation.tableIds, result.tables);
                                    var tableName = reservationTables.map(function(table){
                                        return ' <i class="icon icon_table_connector"></i> ' + table.name + "<br />";
                                    });
                                    listItemClone.find(SEL_LIST_ITEM_NAME).text('');
                                    listItemClone.find(SEL_LIST_ITEM_NEXT_RESERVATION).html(reservation.startDate + '-'+ reservation.endDate + "<br />" + tableName.join(""));
                                    
                                }else{
                                    listItemClone.find(SEL_LIST_ITEM_NAME).text((reservation.tableName != undefined && reservationTableIds.length > 1) ? reservation.tableName : '');
                                    // reservations in a single table
                                    listItemClone.find('a').attr("href", reservationDetailsUrl);
                                    listItemClone.find(SEL_LIST_ITEM_NEXT_RESERVATION).text(reservation.startDate + '-'+ reservation.endDate);
                                }
        
                                listItemContainer += listItemClone.html();
                            });
                        }

                        reservationListItemArray.push(reservationListItem);
                    });

                    reservationListItemArray.forEach(function(listItem){
                        listItem = listItem.replace(/{NEXT_RESERVATION_DATA}/g, listItemContainer);
                        tablesContainer += listItem;
                    });
                });

            }else{
                tablesContainer = '<p>' + window.config.tableViewPlan.noReservations + '</p>'
            }
            
        }else{
            // Available section 

            if(currRes.length != 0){

                var tablesData = getTables(currRes, result.tables);
                var listItemContainer = "";

                tablesData.forEach(function(table) {

                    // Create HTML
                    var reservationListItem = reservationListItemTemplate;
                    
                    reservationListItem = reservationListItem.replace(/{TABLE_ID}/g, table.id);
                    reservationListItem = reservationListItem.replace(/{TABLE_NAME}/g, table.name);
                    reservationListItem = reservationListItem.replace(/{TABLE_NAME_DATA}/g, table.name);
                    reservationListItem = reservationListItem.replace(/{TABLE_CAPACITY}/g, table.capacity);
                    reservationListItem = reservationListItem.replace(/{TABLE_CAPACITY_DATA}/g, table.capacity);
                    reservationListItem = reservationListItem.replace(/{TABLE_STATUS}/g, table.status == 'INACTIVE' ? table.status.toLowerCase() :'');
                    reservationListItem = reservationListItem.replace(/{SHOW_AVAILABLE_TABLES}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{SHOW_CONNECTED_MARKER}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{CONNECTED_TABLE_IDS}/g, CONST_SINGLE_TABLE);
                    reservationListItem = reservationListItem.replace(/{RESERVATION_ID}/g, '');
                    reservationListItem = reservationListItem.replace(/{SHOW_ADD_RESERVATION_BUTTON}/g, table.status == 'INACTIVE' ? 'hide' : '');
                    reservationListItem = reservationListItem.replace(/{TABLE_STATUS_DATA}/g, table.status);

                    reservationListItem = reservationListItem.replace(/{CLASS_CUSTOMER_COMMENT}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{RESERVATION_ARRIVED}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{RESERVATION_NOSHOW}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_ACCEPT}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_REJECT}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{UNCONFIRMED_RESERVATION_CANCEL}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{CUSTOMER_INFORMATION}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{RESERVATION_STATUS}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{CHANGE_TABLE_BTN}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{RESERVATION_DETAILS_BTN_CONTAINER}/g, 'hide');
                    reservationListItem = reservationListItem.replace(/{NEXT_RESERVATION_SEPERATOR}/g, 'hide');

                    var listItemModel = jQuery(reservationListItem).find(SEL_LIST_ITEM_MODEL);
                    var listItemClone = jQuery(listItemModel.html());

                    var selectedTableAllReservations = getAllDayTablesReservations(table.id, result.reservations);

                    if(selectedTableAllReservations.length > 0){
                        listItemContainer = "";
                        selectedTableAllReservations.forEach(function(reservation, index) {
                            var reservationDetailsUrl = '/reservation/'+reservation.id;

                            if(reservation.tableIds.length > 1){
                                // reservation with multiple tables
                                listItemClone.find('a').attr("href", reservationDetailsUrl);

                                // connected tables name
                                var reservationTables = getTables(reservation.tableIds, result.tables);
                                var tableName = reservationTables.map(function(table){
                                    return ' <i class="icon icon_table_connector"></i> ' + table.name + "<br />";
                                });
                                
                                listItemClone.find(SEL_LIST_ITEM_NEXT_RESERVATION).html(reservation.startDate + '-'+ reservation.endDate + "<br />" + tableName.join(""));
                                
                            }else{
                                // reservations in a single table 
                                listItemClone.find('a').attr("href", reservationDetailsUrl);
                                listItemClone.find(SEL_LIST_ITEM_NEXT_RESERVATION).text(reservation.startDate + '-'+ reservation.endDate);
                            }                 
                            
                            listItemContainer += listItemClone.html();
                        });
                    }

                    var selectedTableId = jQuery(reservationListItem).closest(SEL_COLLAPSE_CONTAINER).attr('id').split('-')[1];
                    if(parseInt(selectedTableId) == table.id){
                        reservationListItem = reservationListItem.replace(/{NEXT_RESERVATION_DATA}/g, listItemContainer);
                    }

                    tablesContainer += reservationListItem;
                });

            }else{
                tablesContainer = '<p>' + window.config.tableViewPlan.noTablesAvailable + '</p>'
            }
        }

        newSection = newSection.replace(/{RESERVATION_LIST}/g, tablesContainer);

        return newSection;
    }

    var buildUrlWithParams = function (url, params) {
        var replacements = {};
        for (var name in params) {
            replacements['%%' + name + '%%'] = params[name];
        };
        return StringUtils.findAndReplaceAll(url || '', replacements);
    };

    var updateReservationStatus = function (moduleNode, tablePlanner, timeline, selectedArea, reservationId, newStatus, csrf, btn) {
        if (btn.hasClass(CLASS_IN_PROGRESS)) {
            return false;
        }
        btn.addClass(CLASS_IN_PROGRESS);

        var apiUrl = window.config.tableViewPlan.apiUrlUpdateStatus || '';

        var url = buildUrlWithParams(apiUrl, {
            reservationId: reservationId,
            newStatus: newStatus
        });
        jQuery.ajax({
            url: url,
            method: 'POST',
            data: {
                _csrf: csrf
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response) {
            if(response.status) {
                // Refresh all on success 
                handleAjaxCalls(moduleNode, tablePlanner, timeline, selectedArea);
            }
            btn.removeClass(CLASS_IN_PROGRESS);
        }).fail(function (error) {
            console.log('Error: ', error);
            btn.removeClass(CLASS_IN_PROGRESS);
        });
    };

    var updateReservationEndTime = function (moduleNode, tablePlanner, timeline, selectedArea, reservationId, csrf) {

        var apiUrl = window.config.tableViewPlan.endReservationUrl || '';
        
        var successMessage = window.config.tableViewPlan.successMessage || ''; 

        var url = apiUrl + reservationId;
        
        jQuery.ajax({
            url: url,
            method: 'POST',
            data: {
                _csrf: csrf
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response) {
            if(response.status == "OK") { 
                TablePlannerUtils.showSuccess(successMessage);
                handleAjaxCalls(moduleNode, tablePlanner, timeline, selectedArea);
            }
            if(response.status == "KO") { 
                TablePlannerUtils.showAlert(response.error);
            }
        }).fail(function (error) {
            console.log('Error: ', error);
        });

    };

    var handleAreaTableReservations = function(moduleNode, result){
        console.log('result: ', result);
        
        // Change the area title 
        moduleNode.find(SEL_AREA_TITLE).text(result.areaName);

        var areaReservations = moduleNode.find(SEL_AREA_RESERVATIONS);
        // Remove everything apart from the templates
        areaReservations.find('> *').not(SEL_RESERVATION_TYPE_TEMPLATE).not(SEL_RESERVATION_LIST_ITEM_TEMPLATE).remove();
        var reservationTypeHeaderTemplate = moduleNode.find(SEL_RESERVATION_TYPE_TEMPLATE).html();
        var reservationListItemTemplate = moduleNode.find(SEL_RESERVATION_LIST_ITEM_TEMPLATE).html();

        if(window.config.tableViewPlan && window.config.tableViewPlan.isTableMode == 'true') {
            var arrivedSection = generateTableReservations(reservationTypeHeaderTemplate, reservationListItemTemplate, result, result.arrived, 'arrivedSection');
            var bookingsSection = generateTableReservations(reservationTypeHeaderTemplate, reservationListItemTemplate, result, result.bookings, 'bookingsSection');
            var availableSection = generateTableReservations(reservationTypeHeaderTemplate, reservationListItemTemplate, result, result.availableTablesIds, 'availableSection');
        
            areaReservations.append(arrivedSection);
            areaReservations.append(bookingsSection);
            areaReservations.append(availableSection);
        }
        
        jQuery(SEL_ICON_FOLD).click(function(e) {
            jQuery(this).closest(SEL_COLLAPSE_CONTAINER).slideUp();
        });
    }

    var handleAjaxCalls = function(moduleNode, tablePlanner, timeline, areaId){

        // The automatic refresh will be cleared as soon as the first one reaches max 
        if(MAX_DURATION_DATETIMESTAMP != null){
            if((new Date(REFRESH_DATETIMESTAMP) > new Date(MAX_DURATION_DATETIMESTAMP)) || (new Date(TIMELINE_REFRESH_DATETIMESTAMP) > new Date(MAX_DURATION_DATETIMESTAMP))){
                // refresh limit reached, clear the timeout
                clearRefreshTimer();
                return false;
            }
        }

        // Ajax calls 
        getTableReservations(moduleNode, tablePlanner, areaId);
        getTimelineReservations(moduleNode, timeline, tablePlanner, areaId);

        // Automatic timer refresh 
        refreshAutomaticTimer(moduleNode, tablePlanner, timeline, areaId);

    }

    var showTableSwitcher = function(moduleNode, reservationNode, show){
        var canvasView = moduleNode.find(SEL_CANVAS_VIEW);
        var timelineView = moduleNode.find(SEL_TIMELINE_VIEW);
        var tableSwitcherView = moduleNode.find(SEL_TABLE_SWITCH_VIEW);
        var tablePlanGeneralActions = moduleNode.find('.general-actions');
        
        
        var parentContainer = reservationNode.closest(SEL_COLLAPSE_CONTAINER);
        var confirmChangeBtn = parentContainer.find(SEL_TS_CONFIRM_CHANGE_BTN);
        var dontSaveBtn = parentContainer.find(SEL_TS_DONT_SAVE_BTN);
        var switchTableBtn = parentContainer.find(SEL_TS_CHANGE_TABLE_BTN);

        switchTableBtn.toggleClass('hide');
        confirmChangeBtn.toggleClass('hide');
        dontSaveBtn.toggleClass('hide');

        if(show){
            canvasView.hide();
            timelineView.hide();
            tablePlanGeneralActions.hide();
            tableSwitcherView.show();
        }else{
            tableSwitcherView.hide();
            canvasView.show();
            timelineView.show();
            tablePlanGeneralActions.show();
            // Clear saved id for reservation in change mode
            RESERVATION_IN_CHANGE_MODE_ID = null;
            // Clear selected tables 
            TS_SELECTED_TABLES = null;
        }
        

    }

    // Ajax call to get the timeline reservations
    var getAllAreasWithTables = function(moduleNode, reservationNode, reservationId, idsToCheck){

        // Disable the automatic refresh 
        clearRefreshTimer();

        jQuery.ajax({
			url:  CONST_GET_ALL_AREAS_TABLES_URL + reservationId,
			type: 'GET',
			dataType: "json",
			success: function(result, status) {
                // TODO: mock test data
                // result = allAreasWithTablesMockData;
                console.log('the switch result', result, status)

                if(result && result.status == "KO") {
                    RESERVATION_IN_CHANGE_MODE_ID = null;
                    TablePlannerUtils.showAlert(result.error);
                    enableActionButtons(moduleNode, true);
                    return false;
                }

                if (result && status != 'notmodified') {
                    showTableSwitcher(moduleNode, reservationNode, true);

                    buildAreasWithTables(moduleNode,result, idsToCheck);

                    // Select previosly selected tables 
                    if(TS_SELECTED_TABLES != null){
                        TS_SELECTED_TABLES.map(function(item){
                            jQuery(SEL_TS_FORM).find("input[value='" + item + "']").prop('checked', true);
                        });
                    }  

                }
                
			},
			error: function(e) {
                console.log("an error has occured", e);
			}
        });

    }

    // Confirm change tables in reservation
    var confirmChangeTables = function(moduleNode, tablePlanner, timelineNode, selectedArea, csrf) {

        var apiUrl ='/tablePlan/switchTables';

        TS_SELECTED_TABLES = getSelectedTablesId();

        var requestData = prepareTableSwitchData();
        var canvasView = moduleNode.find(SEL_CANVAS_VIEW);
        var timelineView = moduleNode.find(SEL_TIMELINE_VIEW);
        var canvasViewBtn = moduleNode.find(BTN_CANVAS_VIEW);
        var timelineViewBtn = moduleNode.find(BTN_TIMELINE_VIEW);
        var lastSelectedView = TablePlannerUtils.getSelectedView();
        requestData['reservationId'] = RESERVATION_IN_CHANGE_MODE_ID;
        requestData['_csrf'] = csrf;

        jQuery.ajax({
            url: apiUrl,
            method: 'POST',
            data: requestData,
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response) {

            if(response.status == "OK") {
                showTableSwitcher(moduleNode, currentLinkedNodeToBack, false);
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                // SHow success message 
                TablePlannerUtils.showSuccess(window.config.tableViewPlan.tableSwitched);
                setTablePlanView(canvasView,timelineView,canvasViewBtn,timelineViewBtn,lastSelectedView);

            }

            if(response.status == "KO") {
                TablePlannerUtils.showAlert(response.error).done(function() {
                    handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                });
            }
        }).fail(function (error) {
            console.log('Error: ', error);
            //TODO: Implement unexpected error
            TablePlannerUtils.showAlert('an error has occured SWITCH TABLE').done(function() {
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
            });
        });
    }

    var prefillSwitchMode = function(moduleNode, result) {
        var reservationsArray = result.arrived.concat(result.bookings);
        var isReservationInChangeAvailable = reservationsArray.some(function(reservation) {
            return reservation.reservationId == RESERVATION_IN_CHANGE_MODE_ID;
        });
        if(isReservationInChangeAvailable) {
            jQuery('[' + DATA_RESERVATION_ID + '="'+ RESERVATION_IN_CHANGE_MODE_ID +'"]').next(SEL_COLLAPSE_CONTAINER).find(SEL_TS_CHANGE_TABLE_BTN).trigger('click');
        }else{
            showTableSwitcher(moduleNode, currentLinkedNodeToBack, false);
        }
        
    }

    // Ajax call to get the timeline reservations
    var getTimelineReservations = function(moduleNode, timeline, tablePlanner, areaId){
        var dateTimePickerField = moduleNode.find(SEL_DATE_TIME_PICKER_FIELD);
        var tablesList = moduleNode.find(SEL_AREA_RESERVATIONS);


        var data = (areaId == undefined) ? {} : {areaId:areaId};

        // If checksum and datetimestamp are set, send them as params 
        if(TIMELINE_REFRESH_CHECKSUM != null){
            data['hash'] = TIMELINE_REFRESH_CHECKSUM;
        }
        if(TIMELINE_REFRESH_DATETIMESTAMP != null){
            data['dateTimeString'] = TIMELINE_REFRESH_DATETIMESTAMP;
        }

        if(dateTimePickerField.length > 0 && dateTimePickerField.data("DateTimePicker").date()) {
            data['dateTimeString'] = dateTimePickerField.data("DateTimePicker").date().format(SYSTEM_DATE_TIME_FORMAT);
        }

        jQuery.ajax({
			url:  CONST_GET_TIMELINE_RESERVATIONS_URL,
			type: 'GET',
			data: data,
			dataType: "json",
			success: function(result, status) {
                // TODO: mock test data
                // result = timelineMockData;

                // If status from server 304 - no need to update dom and canvas
                if(status == 'notmodified') {
                    TIMELINE_REFRESH_DATETIMESTAMP = incrementDateTimestamp(TIMELINE_REFRESH_DATETIMESTAMP, window.config.tableViewPlan.refreshFrequency);
                    if(updateTime == true){
                        self.setDateTimePicker(dateTimePickerField, moment(TIMELINE_REFRESH_DATETIMESTAMP));
                        self.fillDateAndTimeText(moduleNode, dateTimePickerField);
                        // Sync the overlay and marker 
                        TimelineUtils.alignOverlayToTimeLine(timeline, TIMELINE_START_DATE_TIME);
                        TimelineUtils.placeMarker(timeline, TIMELINE_START_DATE_TIME, TIMELINE_END_DATE_TIME, TIMELINE_REFRESH_DATETIMESTAMP);
                    }
                }
                if (result && status != 'notmodified') {

                    // Set the timeline startdatetime and enddatetime so it can be used when we receive not modified
                    TIMELINE_START_DATE_TIME = result.startDateTimeString;
                    TIMELINE_END_DATE_TIME = result.endDateTimeString;
                    
                    // Update the checksum 
                    TIMELINE_REFRESH_CHECKSUM = result.hash;

                    //Update the new date/timestamp from the response
                    TIMELINE_REFRESH_DATETIMESTAMP = result.dateTimeString;

                    // Set the max duration of the automatic refresh 
                    if(MAX_DURATION_DATETIMESTAMP == null && result.dateTimeString){
                        MAX_DURATION_DATETIMESTAMP = incrementDateTimestamp(result.dateTimeString, window.config.tableViewPlan.refreshMaxDuration);
                        console.log("max duration is:", MAX_DURATION_DATETIMESTAMP);
                    }
                    
                    if(result.tables == undefined){
                        // Restaurant closed
                        jQuery('.timeline-closed-today').show();
                        timeline.hide();
                    }else{
                        timeline.show();
                        jQuery('.timeline-closed-today').hide();
                        
                        // Get the options and reservations in the correct format 
                        var timelineOptionsAndData = TimelineUtils.buildTimelineOptionsAndData(result);

                        if(!TIMELINE_INITIATED){
                            // Initial build of the timeline 
                            TimelineUtils.buildTimeline(timeline, timelineOptionsAndData);
                            TIMELINE_INITIATED = true;
                        }else{
                            // If data has changed, reload the timeline with the new options
                            TimelineUtils.reloadTimeline(timeline, timelineOptionsAndData);
                            // Sync the overlay and marker 
                            TimelineUtils.alignOverlayToTimeLine(timeline, result.startDateTimeString);
                            TimelineUtils.placeMarker(timeline, result.startDateTimeString, result.endDateTimeString, TIMELINE_REFRESH_DATETIMESTAMP);
                        }

                        timeline.Timeline("openEvent", function (eventSelf, eventData) {
                            TimelineUtils.placeMarker(timeline, TIMELINE_START_DATE_TIME, TIMELINE_END_DATE_TIME, eventSelf.start);
                            dateTimePickerField.val('');
                            // If selected date less then now - put marker at now point
                            var currDate = new Date();
                            var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
                            var nowTime = +moment(currDateWithTimeZone);
                            if (moment(eventSelf.start) < nowTime) {
                                eventSelf.start = nowTime;
                            }
                            MAX_DURATION_DATETIMESTAMP = null;
                            REFRESH_CHECKSUM = null;
                            // We set the refresh datetimestamps to the event start time so that the automatic refresh can continue from there  
                            REFRESH_DATETIMESTAMP = moment(eventSelf.start).format(SYSTEM_DATE_TIME_FORMAT);
                            TIMELINE_REFRESH_DATETIMESTAMP = moment(eventSelf.start).format(SYSTEM_DATE_TIME_FORMAT);
                            
                            var currentTime = dateTimePickerField.data("DateTimePicker").viewDate();
                            self.setUpdateTime(!moment(currentTime).isBefore(eventSelf.start)); 
                            self.setDateTimePicker(dateTimePickerField, currentTime);
                            self.fillDateAndTimeText(moduleNode, dateTimePickerField);

                            getTableReservations(moduleNode, tablePlanner, areaId, 'timelineClick');
                            setTimeout(function(e) {
                                self.setActiveTableInList([eventSelf.extend.tableId], tablesList, eventSelf.extend.reservationId != '-1' ? eventSelf.extend.reservationId : undefined);
                            },300);
                        });
                    }
                }
			},
			error: function(e) {
                console.log("an error has occured", e);
			}
        });

    }

    var getSelectedTablesCapacity = function(){
        var tsForm = jQuery(SEL_TS_FORM + ' *');
        var capacity = 0;
        tsForm.filter(':input').each(function(i, input){
            input = jQuery(input);
            if(input.is(':checked')){
                capacity += Number(input.attr('data-table-capacity'));
            }
        });
        return capacity;
    };

    var getSelectedTablesId = function(){
        var tsForm = jQuery(SEL_TS_FORM).serializeArray();
        var tableIds = [];
        tsForm.map(function(item, i){
            tableIds.push(Number(item.value));
        });
        return tableIds;
    };

    var prepareTableSwitchData = function(){
        var tsForm = jQuery(SEL_TS_FORM).serializeArray();

        return tsForm.reduce(function(acc, input, index) {
            acc['tableIds['+ index +']'] = Number(input.value);
            return acc;
        }, {});
    };
    
    // Ajax call to get the table reservations 
    var getTableReservations = function(moduleNode, tablePlanner, areaId, eventSelf){
        var areaListNavigationNode = moduleNode.find(SEL_TABLE_VIEW_AREA_NAVIGATION);
        var areaReservationsNode = moduleNode.find(SEL_TABLE_VIEW_AREA_RESERVATIONS);
        var dateTimePickerField = moduleNode.find(SEL_DATE_TIME_PICKER_FIELD);

        var data = (areaId == undefined) ? {} : {areaId:areaId};
        
        // If checksum and datetimestamp are set, send them as params 
        if(REFRESH_CHECKSUM != null){
            data['hash'] = REFRESH_CHECKSUM;
        }
        if(REFRESH_DATETIMESTAMP != null){
            data['dateTimeString'] = REFRESH_DATETIMESTAMP;
        } 
        if(dateTimePickerField.length > 0 && dateTimePickerField.data("DateTimePicker").date()) {
            data['dateTimeString'] = dateTimePickerField.data("DateTimePicker").date().format(SYSTEM_DATE_TIME_FORMAT);
        }

        if(MAX_DURATION_DATETIMESTAMP != null){
            if(new Date(REFRESH_DATETIMESTAMP) > new Date(MAX_DURATION_DATETIMESTAMP)){
                // refresh limit reached, clear the timeout
                clearRefreshTimer();
                return false;
            }
        }

        jQuery.ajax({
			url:  CONST_GET_TABLE_RESERVATIONS_URL,
			type: 'GET',
			data: data,
			dataType: "json",
			success: function(result, status) {
                // TODO: mock test data
                // result = testData;

                // hide the area navigation and show the reservations
                areaListNavigationNode.hide();
                areaReservationsNode.show();

                // If status from server 304 - no need to update dom and canvas
                if(status == 'notmodified') {
                    REFRESH_DATETIMESTAMP = incrementDateTimestamp(REFRESH_DATETIMESTAMP, window.config.tableViewPlan.refreshFrequency);
                    if(updateTime == true){
                        self.setDateTimePicker(dateTimePickerField, moment(REFRESH_DATETIMESTAMP));
                        self.fillDateAndTimeText(moduleNode, dateTimePickerField);
                    }
                }
                if (result && status != 'notmodified') {
                    
                    // Update the checksum 
                    REFRESH_CHECKSUM = result.hash;

                    //Update the new date/timestamp from the response
                    REFRESH_DATETIMESTAMP = result.dateTimeString;

                    // Set the max duration of the automatic refresh 
                    if(MAX_DURATION_DATETIMESTAMP == null && result.dateTimeString){
                        MAX_DURATION_DATETIMESTAMP = incrementDateTimestamp(result.dateTimeString, window.config.tableViewPlan.refreshMaxDuration);
                        console.log("max duration is:", MAX_DURATION_DATETIMESTAMP);
                    }

                    var bookingSection = moduleNode.find(SEL_BOOKINGS_SECTION);
                    bookingSection.find(SEL_RESERVATION_TYPE_CAPACITY).each(function(){
                        jQuery(this).val(result.bookings.length);
                    });
                    
                    // Show configured mealtype options
                    var mealTimeSelectElements = moduleNode.find(SEL_MEALTIME_ELEMENTS);
                    var mealTimeSelectHidden = moduleNode.find(SEL_MEALTIME_HIDDEN);
                    var mealTimeSelect = moduleNode.find(SEL_MEALTIME);
                    mealTimeSelectElements.toggleClass("showElement", result.MealTypes.length > 0);
                    if(result.MealTypes.length > 0) {
                        var mealServices = ["BREAKFAST", "BRUNCH", "LUNCH", "DINNER"];
                        mealTimeSelect.find("option").remove();
                        mealTimeSelectHidden.find("option").each(function(){
                            var option = jQuery(this);
                            var optionClone = option.clone();
                            mealTimeSelect.append(optionClone);
                        });
                        var notAvailableOptions = mealServices.filter(function(item) {
                            return !result.MealTypes.some(function(mealItem){
                                return mealItem.MealTypeName == item;
                            });
                        });
                        notAvailableOptions.forEach(function(item){
                            mealTimeSelect.find("option[value='" + item + "']").remove();
                        });
                        result.MealTypes.map(function(mealType){
                            mealTimeSelect.find("option[value='" + mealType.MealTypeName + "']").attr('data-mealtype-start', mealType.StartTime);
                        });
                        if(SELECTED_MEAL_SERVICE != ""){
                            mealTimeSelect.selectpicker('val', SELECTED_MEAL_SERVICE);
                        }
                        mealTimeSelect.selectpicker('refresh');
                    }

                    // Get the current state of the canvas 
                    var stateBeforeRefresh = getStateBeforeRefresh(tablePlanner);
                    alltablesAndReservationsInfo = result;
                    handleAreaTableReservations(moduleNode, result);
                    self.createArea(result, tablePlanner);

                    // Update the canvas with the state before the call
                    setStateBeforeRefresh(tablePlanner, stateBeforeRefresh);

                    if (result.dateTimeString && updateTime == true) {
                        self.setDateTimePicker(dateTimePickerField, moment(result.dateTimeString));
                        self.fillDateAndTimeText(moduleNode, dateTimePickerField);
                    }

                    // Prefilling change mode if we have active reservation id for change
                    if(RESERVATION_IN_CHANGE_MODE_ID) {
                        prefillSwitchMode(moduleNode, result);
                    }
                }

                //expand next booking section automatically on page load if any booking available
                if(result != undefined && eventSelf !== "timelineClick"){
                    automaticExpandingNextBookingSection(moduleNode, result);                
                }
			},
			error: function(e) {
                console.log("an error has occured", e);
			}
        });
    }

    //expand next booking section automatically on page load if any booking available
    var automaticExpandingNextBookingSection = function(moduleNode, result){
        var bookingCollapseContainer = moduleNode.find(SEL_NEXT_BOOKING_COLLPASE_CONTAINER);
        var innerCollapseContainer = bookingCollapseContainer.find(SEL_COLLAPSE_CONTAINER);

        if(result.bookings.length > 0){
            bookingCollapseContainer.collapse('show');
        }

        if(result.bookings.length == 1){
            bookingCollapseContainer.find(SEL_RESERVATION_LIST_ITEM).addClass(CLASS_ACTIVE_TABLE);
            innerCollapseContainer.show();
            innerCollapseContainer.collapse('show');
        }
    }

    // AJAX call to get the rooms list
    var getAreaList = function(moduleNode, showCondition) {
        
		jQuery.ajax({
			url:  CONST_GET_AREAS_URL,
			type: 'GET',
			data: null,
			dataType: "json",
			success: function(result, status) {

				if (result && result.areas && result.areas.length > 0) {

                    var areaList = result.areas;

                    var listItemContainer = moduleNode.find(SEL_AREA_LIST_ITEM_CONTAINER);
                    listItemContainer.toggleClass(CSS_CLASS_SHOW_LIST, !showCondition);
                    
                    listItemContainer.children(SEL_AREA_LIST_ITEM).remove();

                    var listItemModel = listItemContainer.find(SEL_AREA_LIST_ITEM_MODEL);

                    areaList.forEach(function(areaListItem) {
                        var listItemClone = jQuery(listItemModel.html());
		                listItemClone.attr('data-id', areaListItem.id);
		                listItemClone.find(SEL_AREA_TITLE).text(areaListItem.name);
                        listItemClone.find(SEL_AREA_CAPACITY).text(areaListItem.noOfTables);
                        listItemClone.find(SEL_AREA_EDIT_LINK).attr("href", CONST_EDIT_MODE_URL + areaListItem.id);
                        listItemClone.appendTo(listItemContainer);
                    });
                }
			},
			error: function() {
				console.log("an error has occured");
			}
        });
    };
    
    /**
     * Setting the updateTime variable.
     * True if the timepicker should increase automatically.
     * @param {boolean} enableTime
     */
    this.setUpdateTime = function(enableTime){
        updateTime = enableTime;
    }

    /**
     * Creating tables list and drawing tables on canvas
     * @param {object} data
     * @param {jQuery.DOMElement} areaTitle
     * @param {jQuery.DOMElement} tablesList
     * @param {fabric.Canvas} tablePlanner
     */
    this.createArea = function(data, tablePlanner) {

        // TODO: We will add more logic behind this
        // Clear all existing tables 
        tablePlanner.clear();

        // Prepare layer for area background
        var areaObject = new fabric.Rect({
            width: (data.areaWidth || CONST_DEFAULT_CANVAS_SIZE),
            height: (data.areaHeight || CONST_DEFAULT_CANVAS_SIZE),
            fill: "",
            selectable: false,
            type: 'bgCanvas'
        });
        areaObject.fill = new fabric.Pattern(
            {
                source: window.config.tableViewPlan.gridImg,
            },
            function () {
                areaObject.dirty = true;
                tablePlanner.requestRenderAll();
            }
        );
        tablePlanner.add(areaObject);

        var posX = 40;
        var posY = 40;
        var areaNewWidth = 0;
        var areaNewHeight = 0;
        var avarageWidth = 20;
        var avarageHeight = 50;
        var beetwenTables = 150;
        var linkedTables = {};
        var groupedTable;
        var maxwidthTable = 0;
        var maxHeightTable = 0;
        var tableCanvasWidth = 0;
        var staticFactor;

        linkedTables = data.arrived.reduce(function(acc, item) {
            
            if(item.tablesIds.length > 1) {
                item.tablesIds.forEach(function(id, index){
                    var cloneArray = item.tablesIds.slice();
                    cloneArray.splice(index,1)
                    acc[id] = cloneArray;
                });
            }
            return acc;
        }, linkedTables);

        linkedTables = data.bookings.reduce(function(acc, item) {
            
            if(item.tablesIds.length > 1) {
                item.tablesIds.forEach(function(id, index){
                    var cloneArray = item.tablesIds.slice();
                    cloneArray.splice(index,1)
                    acc[id] = cloneArray;
                });
            }
            return acc;
        }, linkedTables);

        (data.tables || []).forEach(function(tableItem, index) {

            tableItem.status = tableItem.status ? tableItem.status : (tableItem.isLocked ? 'INACTIVE' : 'AVAILABLE');

            // Create grid of tables if table has no coordinats
            if(!tableItem.xPosition) {
                tableItem['xPosition'] = posX;
                tableItem['yPosition'] = posY;
                posX += beetwenTables;

                //create area width based on 5 first elements
                if(index < 5) {
                    areaNewWidth += beetwenTables + avarageWidth
                }

                //create area height 
                if((index+1)%5 == 0) {
                    posX = 40;
                    posY += beetwenTables;
                    areaNewHeight += beetwenTables + avarageHeight
                }
            }
            // Draw tabels on canvas

            groupedTable = RectTable.createRectTableWithData(tableItem, tablePlanner);
            maxwidthTable = tableItem.xPosition + groupedTable.width;
            areaNewWidth = areaNewWidth >  maxwidthTable ? areaNewWidth :  maxwidthTable;

            //to display all tables inside the grid (if change all tables room from one to another -> view mode)
            maxHeightTable = tableItem.yPosition + groupedTable.height;
            areaNewHeight = areaNewHeight >  maxHeightTable ? areaNewHeight :  maxHeightTable;             
        });

        if (areaObject.width < areaNewWidth) {
            areaObject.width = areaNewWidth;
        }
        if (areaObject.height < areaNewHeight) {
            areaObject.height = areaNewHeight;
        };

        tablePlanner.mapLinkedIds = linkedTables;

        staticFactor = window.innerWidth > 992 ? (window.innerWidth > 1024 ? 0.7 : 0.65) : 0.55;

        tableCanvasWidth = tablePlanner.getWidth() == 0 ? staticFactor * window.innerWidth : tablePlanner.getWidth();

        areaNewWidth*tablePlanner.getZoom() > tableCanvasWidth ? tablePlanner.setZoom(tableCanvasWidth/areaNewWidth) : tablePlanner.setZoom(1);

        tablePlanner.renderAll();
    }

    /**
     * Initialization datetimepicker
     * @param {jQuery.DOMElement} moduleNode
     * @param {jQuery.DOMElement} dateTimePickerField
     */
    this.closedByApply = false;
    this.initDateTimePicker = function(moduleNode, dateTimePickerField) {
        var currDate = new Date();
        var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
        dateTimePickerField.datetimepicker({
            sideBySide: true,
            minDate: moment(currDateWithTimeZone),
            format: window.config.tableViewPlan.dateFormat + ' ' + window.config.tableViewPlan.timeFormat,
            locale: (window.config.tableViewPlan && window.config.tableViewPlan.calendarLanguageCode),
            toolbarPlacement: 'bottom',
            showClose: true,
            allowInputToggle: true,
            focusOnShow: false,
            icons: {
                up: 'fas fa-chevron-up',
                down: 'fas fa-chevron-down',
                previous: 'fas fa-chevron-left',
                next: 'fas fa-chevron-right',
            },
            tooltips: {
                today: '',
                clear: '',
                close: '',
                selectMonth: '',
                prevMonth: '',
                nextMonth: '',
                selectYear: '',
                prevYear: '',
                nextYear: '',
                selectDecade: '',
                prevDecade: '',
                nextDecade: '',
                prevCentury: '',
                nextCentury: '',
                pickHour: '',
                incrementHour: '',
                decrementHour: '',
                pickMinute: '',
                incrementMinute: '',
                decrementMinute: '',
                pickSecond: '',
                incrementSecond: '',
                decrementSecond: '',
                togglePeriod: '',
                selectTime: ''
            }
        }).on("dp.show", function(e) {
            jQuery('[data-action="close"]').after(jQuery('<a href="#" class="btn-apply">' + window.config.tableViewPlan.btnApply + '</a>'))
        }).on("dp.hide", function(e) {
            if(self.closedByApply) {
                self.fillDateAndTimeText(moduleNode, dateTimePickerField);
            }
            self.closedByApply = false;
        });
    }

    /**
     * Set new date in date time picker
     * @param {jQuery.DOMElement} dateTimePickerField
     * @param {moment.js Date} newDate
     */
    this.setDateTimePicker = function(dateTimePickerField, newDate) {
        dateTimePickerField.length > 0 && dateTimePickerField.data("DateTimePicker").date(newDate);
    }

    /**
     * Fill date and time text
     * @param {jQuery.DOMElement} moduleNode
     * @param {jQuery.DOMElement} dateTimePickerField
     */
    this.fillDateAndTimeText = function(moduleNode, dateTimePickerField) {
        if(dateTimePickerField.length > 0){
            var date = dateTimePickerField.data("DateTimePicker").viewDate();
            moduleNode.find(SEL_DATE_HOLDER).text(date.format(window.config.tableViewPlan.dateFormat));
            moduleNode.find(SEL_TIME_HOLDER).text(date.format(window.config.tableViewPlan.timeFormat));
        }
    }

    var setTablePlanView = function(canvasView,timelineView,canvasViewBtn,timelineViewBtn,view){
        if(view == undefined){
            view = 'canvas'
        }
        TablePlannerUtils.setLastSelectedView(view);
        if(view == 'canvas'){
            canvasView.show();
            timelineView.hide();
            canvasViewBtn.addClass('active');
            timelineViewBtn.removeClass('active');
        }else{
            timelineView.show();
            canvasView.hide();
            timelineViewBtn.addClass('active');
            canvasViewBtn.removeClass('active');

            var markerOffset = jQuery('.timeline-marker').css('left');
            markerOffset = parseFloat(markerOffset);
            var offset = jQuery('.jqtl-container').width() / 2;
            jQuery('.jqtl-container').scrollLeft( markerOffset - offset );

        }
    }

    var enablePreviousArrow = function(moduleNode, dateTimePickerField){
        //disable the previous arrow if the date is equal to moment()
        var currentDatePickerVal= dateTimePickerField.data("DateTimePicker").date();
        var momentCurrentDatePickerData = moment(currentDatePickerVal, 'dddd DD-MM-YYYY hh:mm A').format(SYSTEM_DATE_FORMAT);
        var currDate = new Date();
        var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
        var currentDate = moment(currDateWithTimeZone).format(SYSTEM_DATE_FORMAT);
        if(momentCurrentDatePickerData == currentDate){
            moduleNode.find(SEL_ARROW_PREV).addClass(CSS_DISABLED_ARROW);
        }else{
            moduleNode.find(SEL_ARROW_PREV).removeClass(CSS_DISABLED_ARROW);
        }
    };

    /**
     * Show add reservation form
     */
    this.showAddReservationForm = function(reservationForm, walkinReservationForm, table, dateTime, areaId, moduleNode) {
        var tableId = table.attr(DATA_TABLE_ID);
        
        jQuery.ajax({
			url:  window.config.tableViewPlan.addReservationUrl,
			type: 'GET',
			data: {
                tableId: tableId,
                dateTimeString: dateTime
            },
			dataType: "json",
			success: function(result, status) {
                
                // TODO: Remove these 
                // result = {"status":"OK", "startDateString": "2020-08-14 14:30", duration: 90 };

                if(result.status == "OK") {
                    
                    var resForm = !!result.showWalkinDesign ? walkinReservationForm : reservationForm;

                    // Remove any previous error - message from the capacity or email input of the form
                    var tableCapacityWarningMessage = resForm.find(SEL_TABLE_CAPACITY_WARNING_MESSAGE);
                    var tableEmailWarningMessage = resForm.find(SEL_TABLE_EMAIL_WARNING_MESSAGE);
                    tableCapacityWarningMessage.removeClass(CLASS_SHOW_WARNING_MESSAGE);
                    tableEmailWarningMessage.removeClass(CLASS_SHOW_WARNING_MESSAGE);

                    resForm.show();
                    self.fillAddReservationForm(resForm, table, result.startDateString, result.duration, areaId, dateTime, moduleNode);

                } 
                if(result.status == "KO") { 
                    TablePlannerUtils.showAlert(result.error);
                }
			},
			error: function(e) {
                console.log("an error has occured Create reservation", e);
			}
        });
    }

    /**
     * Fill reservation form
     */
    this.fillAddReservationForm = function(reservationForm, table, reservationTime, duration, areaId, startDate, moduleNode) {
        var tableName = table.attr(DATA_TABLE_NAME);
        var tableCapacity = table.attr(DATA_TABLE_CAPACITY);
        var nextReservations = table.next(SEL_COLLAPSE_CONTAINER).find('.next-reservation-section > .list-item').clone();
        var tableStatusData = table.attr(DATA_TABLE_STATUS);
        reservationForm.find('.table-name').text(tableName);
        reservationForm.find('.table-capacity p').text(tableCapacity);
        var dateTimePickerField = moduleNode.find(SEL_DATE_TIME_PICKER_FIELD);
        reservationForm.find('.reservation-time').text(dateTimePickerField.find('.time-holder').text());
        reservationForm.find(SEL_RESERVATION_CAPACITY).attr(DATA_TABLE_CAPACITY, tableCapacity);
        
        if(nextReservations.length) {
            reservationForm.find('.next-reservation').show();
            reservationForm.find('.next-reservation .next-resrvation-time').html(nextReservations);
        } else {
            reservationForm.find('.next-reservation').hide();
        }
        reservationForm.find('.duration-info input').val(duration);
        reservationForm.find('.table-status').text(tableStatus[tableStatusData]);

        reservationForm.find(SEL_INPUT_TABLE_ID).val(table.attr(DATA_TABLE_ID));
        reservationForm.find(SEL_INPUT_AREA_ID).val(areaId);
        reservationForm.find(SEL_INPUT_START_DATE).val(reservationTime);
        
    }

    /**
     * Cancel Reservation form
     */
    this.cancelReservationForm = function(reservationForm) {
        reservationForm.hide();
        reservationForm.find(SEL_CUSTOMER_INFO).val('');
        reservationForm.find(BTN_CREATE_RESERVATION).prop('disabled', true);
        reservationForm.find(SEL_INPUT_TABLE_ID).val('');
        reservationForm.find(SEL_INPUT_AREA_ID).val('');
        reservationForm.find(SEL_INPUT_START_DATE).val('');
        reservationForm.find(SEL_RESERVATION_CREATED_BY_INPUT).typeahead('val', '');
    }

    /**
     * Submit reservation form
     */
    this.submitReservationForm = (formNode, reservationForm, moduleNode, tablePlanner, timelineNode, selectedArea) => {
        let data = formNode.serialize();

        return new Promise((resolve, reject) => {
            jQuery.ajax({
                url: window.config.tableViewPlan.addReservationUrl,
                method: 'POST',
                data: data,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).done((response) => {

                if (response.status === 'OK') {
                    TablePlannerUtils.showSuccess(window.config.tableViewPlan.addReservationSuccess);
                    self.cancelReservationForm(reservationForm);
                    handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                    formNode.find(SEL_CAPACITY_OVERRIDE_INPUT).attr("value", "true");
                    resolve(response)
                }
                if (response.status === "KO") {
                    if (response.kitchenCapacityExceeded) {
                        TablePlannerUtils.showCapacityExceededConfirm(window.config.tableViewPlan.capacityExceeded, function () {
                            setTimeout(function () {
                                formNode.find(SEL_CAPACITY_OVERRIDE_INPUT).attr("value", "false");
                                formNode.find(SEL_SUBMIT_BUTTON).click();
                            }, 1000);
                        });
                    } else {
                        let formattedErrors = buildErrorsHTML(response.errors);
                        TablePlannerUtils.showAlert(formattedErrors);
                    }
                }
            }).fail((error) => {
                console.log('Error: ', error);
                reject(error);
            });
        });
    }

    var buildErrorsHTML = function(errors){
        var builtHTML = jQuery('<ul class="multiple-errors">');
        errors.map(function(error){
            builtHTML.append('<li>'+error+'</li>')
        });
        return builtHTML;
    }

    var enableActionButtons = function(moduleNode, show, btnArray){
        
        //when hiding the buttons we mark them so we know which ones we have to display again
        if(!show){
            for(var index = 0; index < btnArray.length; index++){
                var item = btnArray[index];
                item.hide();
                item.addClass(CLASS_REACTIVATE_BUTTON);
            }
        }else{
            moduleNode.find(SEL_TEXT_CENTER_BUTTON).each(function(){
                var item = jQuery(this);
                item.find('.btn').each(function(){
                    if(jQuery(this).hasClass(CLASS_REACTIVATE_BUTTON)){
                        jQuery(this).show();
                    }
                });
            });
        }
    }

    var escapeMealServices = function(moduleNode){
        nowBtnClicked = true;
        var mealServicesDropdown = moduleNode.find(SEL_MEALTIME);
        mealServicesDropdown.selectpicker('val', 'ALL');
        SELECTED_MEAL_SERVICE = "ALL";
    }
    
    //remove the class from html tag if exists
    var removeHtmlClass = function(moduleNode){
        var htmlElem = moduleNode.closest('html');
        if(htmlElem.hasClass(CLASS_VIEW_MODE_HTML)){
            htmlElem.removeClass(CLASS_VIEW_MODE_HTML); 
        }
    }

    const fetchDataForCreatedByAutoSuggest = function (engine) {
        jQuery.ajax({
            url: window.config.apiUrlCreatedByAutoSuggest,
            method: 'GET',
            success: data => {
                engine.clear();
                engine.add(data);
            },
            error: error => console.error('Error fetching createdby suggestions:', error)
        });
    };

    const bindCreatedByTypeahead = function (inputField, engine) {
        inputField.typeahead(
            {
                minLength: 0,
                classNames: {menu: 'tt-menu tt-menu-createdby'}
            },
            {
                source: (query, syncResults) => {
                    if (query === '') {
                        syncResults(engine.sorter(engine.all()));
                    } else {
                        engine.search(query, syncResults);
                    }
                },
                displayKey: 'name',
                limit: 15,
                templates: {
                    suggestion: item => `<div><b>${xssEscape(item).name}</b></div>`
                }
            }
        );
    };

    /**
     * Initialize.
     */
    this.init = function(initNode) {

        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		
		// Init all matching nodes
		moduleNodes.each(function() {

            var moduleNode = jQuery(this);
            var areaListNavigationNode = moduleNode.find(SEL_TABLE_VIEW_AREA_NAVIGATION);
            var areaReservationsNode = moduleNode.find(SEL_TABLE_VIEW_AREA_RESERVATIONS);
            var tablesList = moduleNode.find(SEL_AREA_RESERVATIONS);
            var layerIcon = moduleNode.find(SEL_LAYER_ICON);
            var addAreaButton = moduleNode.find(SEL_ADD_AREA_BUTTON);
            var canvasView = moduleNode.find(SEL_CANVAS_VIEW);
            var timelineView = moduleNode.find(SEL_TIMELINE_VIEW);
            var canvasViewBtn = moduleNode.find(BTN_CANVAS_VIEW);
            var timelineViewBtn = moduleNode.find(BTN_TIMELINE_VIEW);
            var timelineNode = moduleNode.find(SEL_TIMELINE);
            var tableSwitchContainer = moduleNode.find(SEL_TS_TABLE_SWITCH_CONTAINER);
            let reservationCreatorBloodHound= null;
            // Auto-suggest for createdBy
            let reservationCreatorRequired = localConfig.reservationCreatorRequired === 'true';
            if (reservationCreatorRequired) {
                reservationCreatorBloodHound = initCreatedByAutoSuggest(moduleNode);
            }


            initializeItem(moduleNode);
            var csrf = moduleNode.find(SEL_CSRF).val();

            var lastSelectedView = TablePlannerUtils.getSelectedView();
            setTablePlanView(canvasView,timelineView,canvasViewBtn,timelineViewBtn,lastSelectedView);

            addAreaButton.parent().attr('href', URL_WITHOUT_PARAMS);

            // Init table planner canvas
            var tablePlanner = TablePlannerUtils.initTablePlanner(true);
            TablePlannerUtils.initCanvasControls(moduleNode, tablePlanner);

            // Init date time picker
            var dateTimePickerField = moduleNode.find(SEL_DATE_TIME_PICKER_FIELD);
            var btnNow = moduleNode.find(BTN_NOW);

            if(window.config.tableViewPlan && window.config.tableViewPlan.isTableMode == 'true'){
                self.initDateTimePicker(moduleNode, dateTimePickerField);
                self.fillDateAndTimeText(moduleNode, dateTimePickerField);

                //Adding customer autosuggestion for firstName, lastName and phoneNumber fields
                initCustomerAutoSuggest(moduleNode);
    
                // Set the initial time to timepicker considering the establishment timezone
                var currDate = new Date();
                var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
                self.setDateTimePicker(dateTimePickerField, moment(currDateWithTimeZone));
            }

            var selectedAreaCookie = TablePlannerUtils.getLastSelectedAreaCookie();
            var selectedAreaQuery = TablePlannerUtils.getUrlParameter('areaId');
            // Query param areaId will take higher priority
            var selectedArea = (selectedAreaQuery != undefined) ? selectedAreaQuery : selectedAreaCookie;

            canvasViewBtn.on("click", function(){
                setTablePlanView(canvasView,timelineView,canvasViewBtn,timelineViewBtn, 'canvas');
                TablePlannerUtils.setCanvasSize(tablePlanner);
            });

            timelineViewBtn.on("click", function(){
                setTablePlanView(canvasView,timelineView,canvasViewBtn,timelineViewBtn, 'timeline');
            });

            handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);

            // Device detection
            var isDeviceMobile = UserInterfaceUtils.isScreenSize('xs');
            moduleNode.toggleClass("isDeviceMobile", isDeviceMobile);
            
            layerIcon.on("click", function(){
                areaReservationsNode.hide();
                //Empty the previous area titles in order to avoid the issue to display the same area name in all areas for one second 
                areaListNavigationNode.find(SEL_AREA_TITLE).text('');
                areaListNavigationNode.show();
                getAreaList(moduleNode, showListCondition);
            });

            // Click on area in area list
            areaListNavigationNode.on('click', SEL_AREA_TITLE, function() {
                // Get the selected area ID 
                var areaId = jQuery(this).closest(SEL_AREA_LIST_ITEM).data("id");
                selectedArea = areaId;
                // Set this ID in a cookie
                TablePlannerUtils.setLastSelectedAreaCookie(areaId);
                // Get tables, reservations and timeline for the selected area
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
            });

            // Click on table in table list
            tablesList.on('click', SEL_RESERVATION_LIST_ITEM, function() {
                var canvasView = moduleNode.find(SEL_CANVAS_VIEW);
                var timelineView = moduleNode.find(SEL_TIMELINE_VIEW);
                var canvasViewBtn = moduleNode.find(BTN_CANVAS_VIEW);
                var timelineViewBtn = moduleNode.find(BTN_TIMELINE_VIEW);
                var lastSelectedView = TablePlannerUtils.getSelectedView();
                var tableId = Number(jQuery(this).attr(DATA_TABLE_ID));
                var connectedTableIds = jQuery(this).attr(DATA_CONNECTED_TABLE_IDS);
                var reservationId = jQuery(this).attr(DATA_RESERVATION_ID);
                var tableIdArr = (connectedTableIds == CONST_SINGLE_TABLE) ? [tableId] : connectedTableIds.split(",").map(Number);
                var selectedReservationId = jQuery(this).attr(DATA_RESERVATION_ID);

                // Get out of switch mode when clicking on another table 
                var idsToCheck = connectedTableIds == CONST_SINGLE_TABLE ? tableId : connectedTableIds;
                if(currentLinkedNodeToBack != false && RESERVATION_IN_CHANGE_MODE_CONNECTED_TABLES != idsToCheck){
                    jQuery(SEL_TS_BACK_BTN).trigger('click');
                }

                // Set active table on canvas
                tablePlanner.discardActiveObject();
                tablePlanner.requestRenderAll();
                var activeTableOnCanvas = TablePlannerUtils.getTableById(tableId, tablePlanner);
                activeTableOnCanvas.connectedTables = tableIdArr;
                tablePlanner.setActiveObject(activeTableOnCanvas);

                TablePlannerUtils.scrollCanvasToTable(tablePlanner, activeTableOnCanvas);

                // Set table/s active in list
                self.setActiveTableInList(tableIdArr, tablesList, selectedReservationId);
                setTablePlanView(canvasView,timelineView,canvasViewBtn,timelineViewBtn,lastSelectedView);
                self.setUpdateTime(false);
            });

            var openReservationDetails = function () {
                // Get the reservation id
                var reservationId = Number(jQuery(this).closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_ID));
                var reservationUrl = "/reservation/" + reservationId;
                window.open(
                    reservationUrl,
                    '_blank'
                );
            }

            // Click on reservation details button
            tablesList.on('click', SEL_RESERVATION_DETAILS_BUTTON, openReservationDetails);
            // Click on show more links in guest information pane
            tablesList.on('click', SEL_GUEST_INFO_SHOW_MORE, openReservationDetails);

            // Handle change table
            tablesList.on('click', SEL_TS_CHANGE_TABLE_BTN, function() {
                // Get the reservation id 
                var reservationId = Number(jQuery(this).closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_ID));
                // Get the table id 
                var tableId = Number(jQuery(this).closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_TABLE_ID));
                var connectedTableId = jQuery(this).closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_CONNECTED_TABLE_IDS);
                var idsToCheck = connectedTableId == CONST_SINGLE_TABLE ? [tableId] : connectedTableId.split(',').map( Number );
                // Save the current jquery dom element 
                currentLinkedNodeToBack = jQuery(this);

                //check what buttons have to hidden
                var btnArray = [];
                currentLinkedNodeToBack.parent().parent().find(SEL_TEXT_CENTER_BUTTON).each(function(){
                    var item = jQuery(this);
                    item.find('.btn').each(function(){
                        if(!jQuery(this).hasClass('hide')){
                            btnArray.push(jQuery(this));
                        }
                    });
                });

                enableActionButtons(moduleNode, false, btnArray);

                // Set values for global vars 
                RESERVATION_IN_CHANGE_MODE_CONNECTED_TABLES = connectedTableId == CONST_SINGLE_TABLE ? tableId : connectedTableId;
                RESERVATION_IN_CHANGE_MODE_ID = reservationId;
                RESERVATION_IN_CHANGE_MODE_CAPACITY = Number(jQuery(this).closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_CAPACITY));
            
                getAllAreasWithTables(moduleNode, jQuery(this), reservationId, idsToCheck);
            });

            tableSwitchContainer.on('change', SEL_TS_INPUT_TABLES, function() {
                var currentTable = jQuery(this);

                // check the selected table type
                var selectedTableType = currentTable.attr('type');

                if(selectedTableType == 'radio' && TS_CONNECT_TABLE_MODE){
                    // We selected a radio type while we are on connect table mode, 
                    // it means we have selected in another area and we should convert all tables to radio type

                    // Remove the "unfocus" classes from the other areas and from itself
                    currentTable.closest('.area-holder').removeClass('unfocused').siblings().removeClass('unfocused');

                    // Restore connect table buttons to their initial state 
                    currentTable.closest('.area-holder').siblings().find(SEL_TS_CONNECT_TABLES_BTN).removeClass('hide');

                    // Uncheck all the already checked checkboxes
                    currentTable.closest('.area-holder').siblings().find(SEL_TS_INPUT_TABLES).attr("checked", false);
                    
                    // Turn the area siblings checkbox buttons to radio
                    currentTable.closest('.area-holder').siblings().find(SEL_TS_INPUT_TABLES).attr("type", "radio");

                    // Select the current table 
                    currentTable.prop('checked', true);
                    
                    // Set connect table mode to false 
                    TS_CONNECT_TABLE_MODE = false;

                }else if(selectedTableType == 'checkbox'){
                    // console.log('checkbox click');
                }else{
                    // console.log('normal radio click');
                }

                var selectedTablesCapacity = getSelectedTablesCapacity();

                var confirmChangeBtn = currentLinkedNodeToBack.closest(SEL_COLLAPSE_CONTAINER).find(SEL_TS_CONFIRM_CHANGE_BTN);
                if(RESERVATION_IN_CHANGE_MODE_CAPACITY <= selectedTablesCapacity){
                    confirmChangeBtn.attr("disabled", false);
                }else{
                    confirmChangeBtn.attr("disabled", true);
                }

            });

            // Handle connect tables
            tableSwitchContainer.on('click', SEL_TS_CONNECT_TABLES_BTN, function(e) {
                var currentTable = jQuery(this);
                // Enable connect mode 
                TS_CONNECT_TABLE_MODE = true;

                // Un focus the other areas 
                currentTable.closest('.area-holder').siblings().addClass('unfocused');

                // Turn the area radio buttons to checkboxes
                currentTable.closest('.area-holder').find(SEL_TS_INPUT_TABLES).attr("type", "checkbox");

                // Keep the current table selection 
                currentTable.closest('label').find(SEL_TS_INPUT_TABLES).trigger('click');

                // Hide the connect table buttons for this area
                currentTable.closest('.area-holder').find(SEL_TS_CONNECT_TABLES_BTN).addClass('hide');
            });
            
            // Handle confirm change tables
            tablesList.on('click', SEL_TS_CONFIRM_CHANGE_BTN, function() {
                if(jQuery(this).attr("disabled")){
                    return false;
                }
                confirmChangeTables(moduleNode, tablePlanner, timelineNode, selectedArea, csrf);
            });

            // Handle don't save button click
            tablesList.on('click', SEL_TS_DONT_SAVE_BTN, function() {
                showTableSwitcher(moduleNode, jQuery(this), false);
                // Restart the automatic refresh 
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                setTablePlanView(canvasView,timelineView,canvasViewBtn,timelineViewBtn, canvasViewBtn.hasClass('active') ? 'canvas' : 'timeline');
                enableActionButtons(moduleNode, true);
            });

            // Handle back button click
            moduleNode.on('click', SEL_TS_BACK_BTN, function() {
                if(currentLinkedNodeToBack != false){
                    showTableSwitcher(moduleNode, currentLinkedNodeToBack, false);
                    // Restart the automatic refresh 
                    handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                    setTablePlanView(canvasView,timelineView,canvasViewBtn,timelineViewBtn, canvasViewBtn.hasClass('active') ? 'canvas' : 'timeline');
                    enableActionButtons(moduleNode, true);
                }
            });

            // Click on arrived button on reservation details
            tablesList.on('click', SEL_BOOKING_ARRIVED_BTN, function() {
                var btn = jQuery(this);
                // Get the reservation id 
                var reservationId = Number(btn.closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_ID));

                updateReservationStatus(moduleNode, tablePlanner, timelineNode, selectedArea, reservationId, 'DONE', csrf, btn);
            });

            var reservationForm = moduleNode.find(SEL_RESERVATION_FORM);
            var walkinReservationForm = moduleNode.find(SEL_WALKIN_RESERVATION_FORM);
            
            // Click add reservation button
            tablesList.on('click', BTN_ADD_RESERVATION, function() {

                var table = jQuery(this).closest(SEL_RESERVATION_LIST_ITEM);

                var dateTimeFromPicker = dateTimePickerField.data("DateTimePicker").viewDate().format(SYSTEM_DATE_TIME_FORMAT);
                
                // Show the right form and add respective logic
                self.showAddReservationForm(reservationForm, walkinReservationForm, table, dateTimeFromPicker, selectedArea, moduleNode);
                
                return false;

            });

            var btnBackReservationForm = moduleNode.find(BTN_BACK_RESERVATION_FORM);
            var btnCancelReservation = moduleNode.find(BTN_CANCEL_RESERVATION);

            btnCancelReservation.on('click', function() {
                var resForm = jQuery(this).closest(SEL_TBL_PLAN_RES_FORM);
                self.cancelReservationForm(resForm);
                return false;
            });
            
            btnBackReservationForm.on('click', function() {
                var resForm = jQuery(this).closest(SEL_TBL_PLAN_RES_FORM);
                self.cancelReservationForm(resForm);
                return false;
            });

            reservationForm.add(walkinReservationForm).on('submit', function () {
                let resForm = jQuery(this);
                let formNode = resForm.find("form");
                self.submitReservationForm(formNode, resForm, moduleNode, tablePlanner, timelineNode, selectedArea)
                    .then(() => {
                        if (reservationCreatorRequired) {
                            let createdByField = moduleNode.find(SEL_RESERVATION_CREATED_BY_INPUT);
                            reservationCreatorBloodHound.clear();
                            fetchDataForCreatedByAutoSuggest(reservationCreatorBloodHound);
                            // Fix: After creating the new item, it did not appear in the creator dropdown on focus,
                            // so we had to reset the field and rebind the typeahead to the creator field.
                            createdByField.typeahead('destroy');
                            bindCreatedByTypeahead(createdByField, reservationCreatorBloodHound);
                        }
                    });
                return false;
            });

            reservationForm.add(walkinReservationForm).on('keyup input', SEL_CUSTOMER_INFO, function() {

                var currentInput = jQuery(this);
                var resForm = jQuery(this).closest(SEL_TBL_PLAN_RES_FORM);

                var reservationFormFirstNameField = resForm.find(SEL_RESERVATION_FIRST_NAME);
                var reservationFormLastNameField = resForm.find(SEL_RESERVATION_LAST_NAME);
                var reservationFormCapacityField = resForm.find(SEL_RESERVATION_CAPACITY);
                var reservationFormEmailField = resForm.find(SEL_RESERVATION_EMAIL);

                // Input fields validation
                var isNameFilled = reservationFormFirstNameField.val() != '' || reservationFormLastNameField.val() != '';
                var isCapacityFilled = reservationFormCapacityField.val() != '';
                var isEmailValid = true;
                if(reservationFormEmailField.val() != ''){
                    isEmailValid = CONST_EMAIL_REG.test(reservationFormEmailField.val());
                }

                // Btn selection and status change on the UI 
                var reservationBtnCreate = resForm.find(BTN_CREATE_RESERVATION);
                var btnSaveWalkin = resForm.find(BTN_SAVE_WALKIN);
                reservationBtnCreate.prop('disabled', !(isNameFilled && isCapacityFilled && isEmailValid));
                btnSaveWalkin.prop('disabled', !(isCapacityFilled));

                // Warning messages selection
                var tableCapacityWarningMessage = resForm.find(SEL_TABLE_CAPACITY_WARNING_MESSAGE);
                var tableEmailWarningMessage = resForm.find(SEL_TABLE_EMAIL_WARNING_MESSAGE);

                // Capacity input field validation
                if(currentInput.attr('name') == 'capacity') {
                    //Allow type only digits
                    this.value = this.value.replace(/[^0-9]/g, '');
                    // Check max allowed capacity
                    var capacityValue = currentInput.val();
                    if (capacityValue > CONST_MAX_CAPACITY) {
                        currentInput.val(CONST_MAX_CAPACITY);
                    }
                    var warningMessageCondition = +capacityValue > +currentInput.attr(DATA_TABLE_CAPACITY);
                    tableCapacityWarningMessage.toggleClass(CLASS_SHOW_WARNING_MESSAGE, warningMessageCondition);
                }

                // Email field validation
                if(currentInput.attr('name') == 'email') {
                    var warningMessageCondition = !isEmailValid;
                    tableEmailWarningMessage.toggleClass(CLASS_SHOW_WARNING_MESSAGE, warningMessageCondition);
                }

            });
            
            //Click on no-show button on reservation details
            tablesList.on('click', SEL_NO_SHOW_BUTTON, function() {
                var btn = jQuery(this);
                // Get the reservation id 
                var reservationId = Number(btn.closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_ID));

                TablePlannerUtils.showConfirm(window.config.tableViewPlan.confirmNoShowText, function() {
                    updateReservationStatus(moduleNode, tablePlanner, timelineNode, selectedArea, reservationId, 'NO_SHOW', csrf, btn);
                });
            });
            
            //Click on accept reservation button on reservation details
            tablesList.on('click', SEL_ACCEPT_RES_BUTTON, function() {
                var btn = jQuery(this);
                // Get the reservation id 
                var reservationItem = btn.closest(SEL_COLLAPSE_CONTAINER).prev();
                var reservationId = Number(reservationItem.attr(DATA_RESERVATION_ID));
                var acceptStatus = reservationItem.attr(DATA_RESERVATION_ACCEPT_STATUS);

                updateReservationStatus(moduleNode, tablePlanner, timelineNode, selectedArea, reservationId, acceptStatus, csrf, btn);
            });

            //Click on reject reservation button on reservation details
            tablesList.on('click', SEL_REJECT_RES_BUTTON, function() {
                var btn = jQuery(this);
                // Get the reservation id 
                var reservationId = Number(btn.closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_ID));

                updateReservationStatus(moduleNode, tablePlanner, timelineNode, selectedArea, reservationId, 'REJECTED', csrf, btn);
            });

            //Click on cancel reservation button on reservation details
            tablesList.on('click', SEL_CANCEL_RES_BUTTON, function() {
                var btn = jQuery(this);
                // Get the reservation id 
                var reservationId = Number(btn.closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_ID));

                updateReservationStatus(moduleNode, tablePlanner, timelineNode, selectedArea, reservationId, 'CANCELLED', csrf, btn);
            });
            
            // Click on end reservation button on reservation details
            tablesList.on('click', SEL_END_RESERVATION, function() {
                var reservationId = Number(jQuery(this).closest(SEL_COLLAPSE_CONTAINER).prev().attr(DATA_RESERVATION_ID));
                TablePlannerUtils.showConfirm(window.config.tableViewPlan.endReservationText, function() {
                    updateReservationEndTime(moduleNode, tablePlanner, timelineNode, selectedArea, reservationId, csrf);
                })
            });

            if(Cookies.get('savedEditPlan') === 'success') {
                TablePlannerUtils.showSuccess(window.config.tableViewPlan.areaSaved);
                Cookies.remove('savedEditPlan');
            }

            jQuery(window).on('resize', function() {
                var isDeviceMobile = UserInterfaceUtils.isScreenSize('xs');
                moduleNode.toggleClass("isDeviceMobile", isDeviceMobile);
                TablePlannerUtils.setCanvasSize(tablePlanner);
            });


            // Update table color depending on active table or not
            tablePlanner.on("selection:created", function(event) {
                // Add linked tables to actives
                // if(tablePlanner.mapLinkedIds[event.selected[0]['tableId']] && selectedFromList) {
                //     tablePlanner.mapLinkedIds[event.selected[0]['tableId']].forEach(function(id) {
                //         var linkedTable = TablePlannerUtils.getTableById(id, tablePlanner);
                //         event.selected.push(linkedTable)
                //     })
                // }
                var selectedFromList = false;
                // Check if table was selected from table list and activate all connected tables
                if(event.selected[0].connectedTables && event.selected[0].connectedTables.length) {
                    event.selected[0].connectedTables.forEach(function(id) {
                        if (id == event.selected[0].tableId) {
                            return false;
                        }
                        var linkedTable = TablePlannerUtils.getTableById(id, tablePlanner);
                        event.selected.push(linkedTable)
                    });
                    selectedFromList = true;
                    delete event.selected[0].connectedTables;
                }

                TablePlannerUtils.updateActive(event.selected, true, tablePlanner, CONST_CURRENT_MODE);

                var selectedTablesIds = event.selected.reduce(function(idsArr, table) {
                    idsArr.push(table.tableId);
                    return idsArr;
                }, []);

                if(!selectedFromList) {
                    var reservationId = event.selected[0].reservationIds ? event.selected[0].reservationIds[0] : false;
                    self.setActiveTableInList(selectedTablesIds, tablesList, reservationId);
                }

            });
            tablePlanner.on("selection:updated", function(event) {
                var allTables = TablePlannerUtils.getTablesObjects(tablePlanner);
                // Deselect all tabels
                TablePlannerUtils.updateActive(
                    allTables,
                    false,
                    tablePlanner,
                    CONST_CURRENT_MODE
                );

                var selectedFromList = false;
                // Check if table was selected from table list and activate all connected tables
                if(event.selected[0].connectedTables && event.selected[0].connectedTables.length) {
                    event.selected[0].connectedTables.forEach(function(id) {
                        if (id == event.selected[0].tableId) {
                            return false;
                        }
                        var linkedTable = TablePlannerUtils.getTableById(id, tablePlanner);
                        event.selected.push(linkedTable)
                    });
                    selectedFromList = true;
                    delete event.selected[0].connectedTables;
                }

                TablePlannerUtils.updateActive(event.selected, true, tablePlanner, CONST_CURRENT_MODE);

                var selectedTablesIds = event.selected.reduce(function(idsArr, table) {
                    idsArr.push(table.tableId);
                    return idsArr;
                }, []);

                if(!selectedFromList) {
                    var reservationId = event.selected[0].reservationIds ? event.selected[0].reservationIds[0] : false;
                    self.setActiveTableInList(selectedTablesIds, tablesList, reservationId);
                }

            });
            tablePlanner.on("selection:cleared", function(event) {
                var allTables = TablePlannerUtils.getTablesObjects(tablePlanner);
                // Deselect all tabels
                TablePlannerUtils.updateActive(
                    allTables,
                    false,
                    tablePlanner,
                    CONST_CURRENT_MODE
                );
                self.setActiveTableInList(false, tablesList);
            });
            
            if(Cookies.get('deleteArea') === 'success') {
                TablePlannerUtils.showSuccess(window.config.tableViewPlan.deleteAreaSuccessText);
                Cookies.remove('deleteArea');
            }

            moduleNode.on('click', '.btn-apply', function(e) {
                // Reset the max duration and refresh datetimestamp since it's a user action
                resetAutomaticOperations();
                self.setUpdateTime(false);
                self.closedByApply = true;
                dateTimePickerField.data("DateTimePicker").hide();
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                enablePreviousArrow(moduleNode, dateTimePickerField);
                escapeMealServices(moduleNode);
                return false;
            });

            //select previous day on datepicker
            moduleNode.on('click', SEL_ARROW_PREV, function(e) {
                
                // Reset the max duration and refresh datetimestamp since it's a user action 
                resetAutomaticOperations();
                var currentDatePickerVal= dateTimePickerField.data("DateTimePicker").date();

                // As time progresses, the minDate becomes bigger than the new datetime we want to set
                // In that case we do a check, if minDate + 1 day is the same as the current date 
                // If yes we update the datetimepicker to now
                var minDate = moment(dateTimePickerField.data("DateTimePicker").minDate()).add(1,'days').format('L');
                var currentDateToCheck = currentDatePickerVal.format('L');
                if(minDate === currentDateToCheck){
                    btnNow.trigger('click');
                    return false;
                }

                dateTimePickerField.val('');
                var momentCurrentDatePickerData = moment(currentDatePickerVal, 'dddd DD-MM-YYYY hh:mm A');
                self.setDateTimePicker(dateTimePickerField, moment(momentCurrentDatePickerData).subtract(1,'days'));
                self.fillDateAndTimeText(moduleNode, dateTimePickerField);
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                enablePreviousArrow(moduleNode, dateTimePickerField);
                escapeMealServices(moduleNode);
                return false;
            });

            //select next day on datepicker
            moduleNode.on('click', SEL_ARROW_NEXT, function(e) {

                // Reset the max duration and refresh datetimestamp since it's a user action 
                resetAutomaticOperations();
                self.setUpdateTime(false);
                var currentDatePickerVal= dateTimePickerField.data("DateTimePicker").date();
                var currDate = new Date();
                var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
                if(currentDatePickerVal == null){
                    var momentCurrentDatePickerData = moment(currDateWithTimeZone);
                }else{
                    var momentCurrentDatePickerData = moment(currentDatePickerVal, 'dddd DD-MM-YYYY hh:mm A');
                }
                dateTimePickerField.val('');
                self.setDateTimePicker(dateTimePickerField, moment(momentCurrentDatePickerData).add(1,'days'));
                self.fillDateAndTimeText(moduleNode, dateTimePickerField);
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                enablePreviousArrow(moduleNode, dateTimePickerField);
                escapeMealServices(moduleNode);
                return false;
            });

            btnNow.on('click', function() {
                // Reset the max duration and refresh datetimestamp since it's a user action
                resetAutomaticOperations();
                self.setUpdateTime(true);
                dateTimePickerField.val('');
                var currDate = new Date();
                var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
                self.setDateTimePicker(dateTimePickerField, moment(currDateWithTimeZone));
                self.fillDateAndTimeText(moduleNode, dateTimePickerField);
                handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                enablePreviousArrow(moduleNode, dateTimePickerField);
                escapeMealServices(moduleNode);
                return false;
            });

            moduleNode.on('change', SEL_MEALTIME, function(){
                if(nowBtnClicked){
                    nowBtnClicked = false;
                    return;
                }
                var mealServicesDropdown = jQuery(this);
                var selectedValue = mealServicesDropdown.selectpicker('val');
                if(SELECTED_MEAL_SERVICE != selectedValue){
                    SELECTED_MEAL_SERVICE = selectedValue;
                } else {
                    return;
                }
                var startTime = mealServicesDropdown.find("option[value='" + SELECTED_MEAL_SERVICE + "']").attr('data-mealtype-start');
                if(startTime){
                    var currDate = new Date();
                    var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
                    var evaluatedCondition = moment(startTime).toDate() < moment(currDateWithTimeZone).toDate()
                    var dateTimeUsed = evaluatedCondition ? currDateWithTimeZone : startTime;
                    self.setDateTimePicker(dateTimePickerField, moment(dateTimeUsed));
                    self.fillDateAndTimeText(moduleNode, dateTimePickerField);
                    resetAutomaticOperations();
                    self.setUpdateTime(false);
                    self.closedByApply = true;
                    dateTimePickerField.data("DateTimePicker").hide();
                    handleAjaxCalls(moduleNode, tablePlanner, timelineNode, selectedArea);
                    enablePreviousArrow(moduleNode, dateTimePickerField);
                    return false;
                } else {
                    btnNow.trigger('click');
                }
            });

            //add a new class in view mode page html tag
            var bodyClass = moduleNode.closest(SEL_PAGE_BODY_CLASS);
            if(window.location.href.indexOf('viewMode') != -1 && bodyClass.length){
                moduleNode.closest('html').addClass(CLASS_VIEW_MODE_HTML);
            }else{
                removeHtmlClass(moduleNode);
            }

    	});

    };

    const initCustomerAutoSuggest = (module) => {

        const firstName 	= module.find(SEL_RESERVATION_FIRST_NAME);
        const lastName 		= module.find(SEL_RESERVATION_LAST_NAME);
        const phoneNumber 	= module.find(SEL_RESERVATION_PHONE_NUMBER);
        const email         = module.find(SEL_RESERVATION_EMAIL);

        const createTypeaheadEngine = (field) => {
            return new Bloodhound({
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('firstName', 'lastName', 'phoneNumber','email'),
                remote: {
                    url: `${window.config.apiUrlCustomerAutoSuggest}${field}/%QUERY`,
                    wildcard: '%QUERY',
                    transform: (data) => data.results || [],
                    cache: false
                },
            });
        };

        const setupTypeahead = (inputElement, engine, displayKey) => {
            inputElement.typeahead(
                {minLength: 3},
                {
                    source: engine,
                    displayKey: displayKey,
                    limit: Infinity,
                    templates: {
                        suggestion: (item) => {
                            let escapedItem = xssEscape(item);
                            return `<div><span class="fullname"><span>${escapedItem.lastName || ''}</span><span>${escapedItem.firstName || ''}</span></span>
                            <span>${escapedItem.phoneNumber || ''}</span><span>${escapedItem.email || ''}</span></div>`;
                        },
                    },
                }
            );

            inputElement.bind('typeahead:select', (ev, suggestion) => {
                firstName.val(suggestion.firstName);
                lastName.val(suggestion.lastName);
                phoneNumber.val(suggestion.phoneNumber);
                email.val(suggestion.email);

                // Indicate change by visual effect
                [firstName, lastName, phoneNumber, email].forEach((inputField) => {
                    inputField.hide().fadeIn();
                });
            });
        };

        setupTypeahead(lastName, createTypeaheadEngine('lastname'), 'lastName');
        setupTypeahead(firstName, createTypeaheadEngine('firstname'), 'firstName');
        setupTypeahead(phoneNumber, createTypeaheadEngine('phonenumber'), 'phoneNumber');

    };
    
};

// Make class public to outside world
module.exports = TableViewPlan;

},{"../mediator/mediator":103,"../utils/StringUtils":187,"../utils/UserInterfaceUtils":189,"./RectTable":164,"./TablePlannerUtils":166,"./TimelineUtils":168,"bloodhound":25,"cookies":49,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15,"typeahead":51}],168:[function(require,module,exports){
/**
 * RectTable functionality.
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');
var moment = require('moment/min/moment-with-locales');
require('jquery.timeline');
var UserInterfaceUtils = require('../utils/UserInterfaceUtils');

// Class definition
TimelineUtils = function () {

  var self = this;

  this.CONST_MAP_TABLES_STATUSES_COLORS = {
    "ARRIVED": "#c3425f",
    "CONFIRMED": "#fbac24",
    "UNCONFIRMED": "#143c34",
    "AVAILABLE": "#42c3a6",
    "INACTIVE": "#393938",
    "CLOSED": "#000"
  };

  this.SEL_RESERVATION_LABEL_HOLDER = '.reservation-label-holder';
  this.SEL_SIDELINE_TABLE_ROW_HOLDER = '.sideline-table-row-holder';
  this.SEL_TIMELINE_RESERVATION_CONTAINER = '.timeline-reservation-label-container';
  this.DATA_START_DATE = "data-start-date";
  this.DATA_TABLE_ID = "data-table-id";

  this.SEL_TIMELINE_OVERLAY = '.timeline-overlay';
  this.SEL_JQTL_EVENTS = '.jqtl-events';

  this.SEL_TIMELINE_MARKER = '.timeline-marker';
  this.SEL_TIME_LABEL = '.time-label';
  this.SEL_JQTL_EVENT_CONTAINER = '.jqtl-event-container';

  this.TABLE_TIMELINE_HEIGHT = 70.5;

  /**
   * Build timeline options
   * @param {Object} data // response from ajax call
   * @return {Object}
   */
  this.buildTimelineOptionsAndData = function (data) {
    var sidelineRows = self.buildSidelineTableRow(data.tables);
    var timelineReservations = self.getTimelineReservations(data.tables);
    var is12HourFormat = self.is12HourFormat();

    return {
      startDatetime: data.startDateTimeString,
      endDatetime: data.endDateTimeString,
      seletedDateTime: data.dateTimeString,
      //rows: data.tables.length,
      type: "bar",
      scale: "hour",
      rows: "auto",
      rowHeight: 70,
      minGridSize: 250,
      headline: {
        display: false,
        title: "Timeline plan",
        range: false,
        locale: "en"
      },
      footer: {
        display: false
      },
      sidebar: {
        sticky: true,
        list: sidelineRows
      },
      ruler: {
        top: {
          lines: [
            "hour"
          ],
          height: 50,
          fontSize: 13,
          color: "#fff",
          background: "#000",
          locale: "en",
          format: {
            hour12: is12HourFormat,
            hour: "fulltime"
          }
        },
        bottom: {}
      },
      eventMeta: {
        display: false,
        scale: "day",
        locale: "en-US",
        format: {
          hour12: false
        },
        content: ""
      },
      eventData: timelineReservations,
      /*effects: {
        presentTime: true,
        hoverEvent: true,
        stripedGridRow: false,
        horizontalGridStyle: "solid",
        verticalGridStyle: "solid",
        horizontalGridColor: "rgba( 221, 221, 221, 0.8 )",
        verticalGridColor: "rgba( 0, 128, 0, 0 )"
      },*/
      colorScheme: {
        event: {
          text: "#000",
          border: "#000",
          background: "#000"
        },
        hookEventColors: function hookEventColors() {
          return null;
        }
    
      },
      rangeAlign: "left",
      reloadCacheKeep: false,
      zoom: false,
      debug: false,
      effects: {
        presentTime: false,
      }
    };
  }

  /**
   * Build timeline
   * @param {jQuery.Object} timeline
   * @param {Object} options
   * @return {timeline.Object}
   */
  this.buildTimeline = function (timeline, options) {
    return timeline.Timeline(options).Timeline("initialized", function (timelineSelf, data) {
      console.log(["user's callback", timelineSelf, data]);
      // TODO: Replace timeout with after render event
      setTimeout(function (e) {
          // Get area name 
          var areaName = jQuery('h4.area-title').text();
          jQuery('.jqtl-side-index-margin').text(areaName);

          self.setFixedSafariHeight(data);

          self.alignOverlayToTimeLine(timeline, data.startDatetime);
          self.placeMarker(timeline, data.startDatetime, data.endDatetime, data.seletedDateTime);
      }, 1000);
    });
  }

  /**
   * Reload timeline
   * @param {jQuery.Object} timeline
   * @param {Object} newOptions
   * @return {timeline.Object}
   */
  this.reloadTimeline = function (timeline, newOptions) {
    return timeline.Timeline("reload", newOptions, function (eventSelf, eventData) {
      console.log('testing the reload', eventSelf, eventData);
      // Get area name 
      var areaName = jQuery('h4.area-title').text();
      jQuery('.jqtl-side-index-margin').text(areaName);

      self.setFixedSafariHeight(eventData);
      // Most likely not needed 
      // self.placeMarker(timeline, data.startDatetime, eventSelf.start);
    });
  }

  /**
   * Set the fixed container height for safari 14 and above
   * @param {timeline.Object} data
   */
  this.setFixedSafariHeight = function (data) {

    var browserDetails = UserInterfaceUtils.getBrowser();

    // Only add the inline height for Safari browser version 14 and above 
    if (browserDetails.name == "Safari" && browserDetails.version >= 14) {
      var eventsNode = jQuery(".jqtl-events");
      var eventsHeight = eventsNode.height();
      if (eventsHeight == 0) {
        eventsHeight = data.eventData.length * self.TABLE_TIMELINE_HEIGHT; // for any number of tables (number of tables * 70.5px per table)
      }
      eventsNode.css({
        "height": eventsHeight - 10, // 10 is the extra space from paddings/margins
        "opacity": 1,
        "visibility": "visible"
      });
    }

  }

  /**
   * Check the time format the esatblishment uses
   * @return {Boolean}
   */
  this.is12HourFormat = function () {
    var exampleDate = moment().format(window.config.tableViewPlan.dateFormat + ' ' + window.config.tableViewPlan.timeFormat);
    var hourFormats = ['am','pm'];
    var regex = new RegExp( hourFormats.join( "|" ), "i");
    return regex.test( exampleDate ); 
  }

  /**
   * Align overlay to time line
   * @param {JQueryDOMObject} timeline
   * @param {Date} startDatetime
   */
  this.alignOverlayToTimeLine = function(timeline, startDatetime) {
    var currDate = new Date();
    var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
    var nowTime = +moment(currDateWithTimeZone);
    var startTime = +moment(startDatetime);
    var overlay = timeline.find(self.SEL_TIMELINE_OVERLAY);
    var additionalOverlayWidth = 0;

    // if selected day in the future don't add overlay
    if (nowTime < startTime) {
      return false;
    }
    
    // if overlay doesn't exist - create it
    if (!overlay.length) {
      overlay = jQuery(self.SEL_TIMELINE_OVERLAY).clone();
      timeline.find(self.SEL_JQTL_EVENTS).append(overlay);
    }

    //if the start time is not a full hour, we add more overlay so it fits the actual time.
    //the timeslots in timeline have a min-width of 250px. this means that each minute equals to 250/60
    if(moment(startTime).format('mm') != '00'){  
      var minutes = parseInt(moment(startTime).format('mm'));
      additionalOverlayWidth = minutes * (250/60);
    }
    overlayWidth= (Math.abs(startTime - nowTime) / 3600000) * 250;
    overlay.width(overlayWidth+additionalOverlayWidth);
  }

  /**
   * Place marker on timeline
   * @param {JQueryDOMObject} timeline
   * @param {Date} startDatetime
   * @param {Date} selectedDatetime
   * @return {number} markerOffset
   */
  this.placeMarker = function(timeline, startDatetime, endDatetime, selectedDatetime) {
    var timelineMarker = timeline.find(self.SEL_TIMELINE_MARKER);

    // If marker exist - delete it
    if (timelineMarker.length) {
      timelineMarker.remove();
    }

    var selectedDatetime = +moment(selectedDatetime);
    var startTime = +moment(startDatetime);
    var endTime = +moment(endDatetime);
    var currDate = new Date();
    var currDateWithTimeZone = currDate.toLocaleString('en-US', { timeZone: window.config.tableViewPlan.establishmentTimeZone });
    var nowTime = +moment(currDateWithTimeZone);
    
    
    // If start datetime bigger then now - don't show the marker
    if (startTime > selectedDatetime) {
      return false;
    }

    // If end datetime less then now - don't show the marker
    if (endTime < selectedDatetime) {
      return false;
    }


    // If selected date less then now - put marker at now point
    if (selectedDatetime < nowTime) {
      selectedDatetime = nowTime;
      self.alignOverlayToTimeLine(timeline, startDatetime);
    }

    //if the start time is not a full hour, we add more overlay so the marker fits the actual time.
    //the timeslots in timeline have a min-width of 250px. this means that each minute equals to 250/60
    var additionalWidth = 0;
    if(moment(startTime).format('mm') != '00'){
      var minutes = parseInt(moment(startTime).format('mm'));
      additionalWidth = minutes * (250/60);
    }
    
    var markerLeft = ((Math.abs(selectedDatetime - startTime) / 3600000) * 250) + additionalWidth;
    var markerTime = moment(selectedDatetime).format(window.config.tableViewPlan.timeFormat);

    timelineMarker = jQuery(self.SEL_TIMELINE_MARKER).clone();
    timeline.find(self.SEL_JQTL_EVENT_CONTAINER).append(timelineMarker);
    timelineMarker.css('left', markerLeft);
    timelineMarker.find(self.SEL_TIME_LABEL).text(markerTime);

    if(markerLeft < 35){
      timelineMarker.find(self.SEL_TIME_LABEL).css({'border-radius':'5px 5px 5px 0','transform':'translate(0, -100%)'})
    }

    var offset = jQuery('.jqtl-container').width() / 2;
    jQuery('.jqtl-container').scrollLeft( markerLeft - offset );

    return markerLeft;
  }

  /**
   * Get timeline reservations per table
   * @param {Object} data
   * @return {Array}
   */
  this.getTimelineReservations = function (data) {
    var allReservations = [];
    data.map(function (table, index) {
      table.reservations.map(function (reservation) {
        // TODO: Align with the backend if we will get "closed" status 
        if(reservation.status != "CLOSED"){
          var timelineReservation = {
            start: reservation.startDate,
            end: reservation.endDate,
            label: self.buildReservationLabel(reservation, table.id),
            row: index + 1,
            bgColor: self.CONST_MAP_TABLES_STATUSES_COLORS[reservation.status],
            color: '#fff',
            extend:{
              reservationId: reservation.id != undefined ? reservation.id : '-1',
              tableId: table.id != undefined ? table.id : '-1'
            }
          }
          allReservations.push(timelineReservation);
        }
      })
    });
    return allReservations
  }

  /**
   * Build sideline table row
   * @param {Array} tables
   * @return {Array}
   */
  this.buildSidelineTableRow = function (tables) {
    var sideLineRows = [];
    tables.forEach(function (table) {
      var sideLineRowNode = jQuery(self.SEL_SIDELINE_TABLE_ROW_HOLDER);
      sideLineRowNode.find('.table-name').text(table.name);
      sideLineRowNode.find('.table-capacity').text(table.capacity);
      sideLineRows.push(sideLineRowNode.html());
    });
    return sideLineRows;
  }



  /**
   * Add timeline reservations
   * @param {timeline.Object} timeline
   * @param {Array} reservations // Array of objects to be added to the timeline
   * @return {Object}
   */
  this.addTimelineReservations = function (timeline, reservations) {
    timeline.Timeline()
      .Timeline('addEvent', reservations,
        function (self, dataa) {
          console.log('Events added successfully!');
        });
  }

  /**
   * Build timeline reservation label
   * @param {Object} reservation
   * @return {String}
   */
  this.buildReservationLabel = function (reservation, tableId) {
    
    var walkin = window.config.tableViewPlan.walkin || "";
    reservation.customer = reservation.customer != undefined ? reservation.customer != '' ? reservation.customer : walkin : window.config.tableViewPlan.reservationStatusAvailable;
    reservation.capacity = reservation.capacity != undefined ? reservation.capacity : '-';
    var reservationDuration = self.getReservationDuration(reservation.startDate, reservation.endDate);
    var reservationLabelNode = jQuery(self.SEL_RESERVATION_LABEL_HOLDER);

    // If it's inactive we remove all the details 
    if(reservation.status == 'INACTIVE'){
      reservation.customer = '';
      reservation.capacity = '';
      reservationDuration = '';
      reservationLabelNode.find('.res-name-capacity').hide();
      reservationLabelNode.find('.res-duration').hide();
    }else{
      reservationLabelNode.find('.res-name-capacity').show();
      reservationLabelNode.find('.res-duration').show();
    }

    reservationLabelNode.find('.reservation-name').text(reservation.customer);
    reservationLabelNode.find('.reservation-capacity').text(reservation.capacity);
    reservationLabelNode.find('.reservation-duration').text(reservationDuration);

    var timelineReservation = reservationLabelNode.find(self.SEL_TIMELINE_RESERVATION_CONTAINER);
    timelineReservation.attr(self.DATA_START_DATE, reservation.startDate);
    timelineReservation.attr(self.DATA_TABLE_ID, tableId);
    return reservationLabelNode.html();
  }

    /**
   * Get the reservation duration between 2 dates
   * @param {Date} startDate
   * @param {Date} endDate
   * @return {String}
   */
  this.getReservationDuration = function (startDate, endDate) {
    var diff = Math.abs(moment(startDate) - moment(endDate));
    return Math.floor((diff/1000)/60); // return in minutes
  }

};



// singleton pattern
var singleton = new TimelineUtils();

// Make class public to outside world
module.exports = singleton;

},{"../utils/UserInterfaceUtils":189,"jquery.timeline":45,"jquery/dist/jquery":14,"moment/min/moment-with-locales":15}],169:[function(require,module,exports){
/**
 * Table Plan functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
TableEditPlan                 = require('./TableEditPlan');
TableViewPlan                 = require('./TableViewPlan');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

  // Instanciate implementing class
  var tableEditPlan     = new TableEditPlan();
  var tableViewPlan     = new TableViewPlan();
  
  // Trigger onload activities
  tableEditPlan.init(initNode);
  tableViewPlan.init(initNode);

});
},{"../mediator/mediator":103,"./TableEditPlan":165,"./TableViewPlan":167}],170:[function(require,module,exports){
/**
 * DataPrivacy functionality.
*
*/


// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
var CapacitySimpleMode = function() {

    // self references
    var self;

	// selector constants
    var SEL_MODULE										= '.mod-table-setup-alternative-simple-mode';
    var SEL_TABLE_MODE_SEATS_INPUT                      = '#reservables-capacity';
	var SEL_CAPACITY_MODE                               = '.mod-table-setup-alternative-capacity-mode';


	var SEL_TABLE_MODE_TOGGLE							= '.mod-table-setup-alternative-toggle #reservables-is-reservable-mode';
	var SEL_TABLE_MODE_TOGGLE_WARNING					= '.mod-table-setup-alternative-toggle .reservable-mode-change-warning';

	var CSS_NOT_ENOUGH_SEATS_TABLE_MODE					= 'has-notEnough-seats-table-mode';
	var CSS_TO_MANY_SEATS								= 'has-too-many-seats';


	var CSS_TABLE_MODE_ACTIVE							= 'table-mode-active';
	var CSS_HIDE_SAVE_BUTTON							= 'hide-save-button';
	var CSS_HIDDEN										= 'hidden';
    var CSS_NOT_ENOUGH_SEATS_TABLE_MODE					= 'has-notEnough-seats-table-mode';
    
	var SEL_FORM										= 'form';


    var initTableModeToggle = function(moduleNode) {
		var initialTableModeActive = moduleNode.hasClass(CSS_TABLE_MODE_ACTIVE);
		var warningCard = moduleNode.find(SEL_TABLE_MODE_TOGGLE_WARNING);

		moduleNode.find(SEL_TABLE_MODE_TOGGLE).on('change', function() { 
			var toggle = jQuery(this);

			if (toggle.is(':checked')) {
				moduleNode.addClass(CSS_TABLE_MODE_ACTIVE);
			} else {
				moduleNode.removeClass(CSS_TABLE_MODE_ACTIVE);
			}
			moduleNode.removeClass(CSS_HIDE_SAVE_BUTTON);

			// show warning
		});
    };
    
	var initValidation = function(moduleNode) {

        var form = moduleNode.find(SEL_FORM);
        var capacitySimpleMode = moduleNode.find(SEL_CAPACITY_MODE)
		var tableModeSeatsInputed = moduleNode.find(SEL_TABLE_MODE_SEATS_INPUT);
		var toggleSwitch = moduleNode.find(SEL_TABLE_MODE_TOGGLE);

		form.on('submit', function(e) {
            var totalSeats = parseInt(tableModeSeatsInputed.val());
			
			if(jQuery(toggleSwitch).is(':checked')){
				return false;
			}
			if(totalSeats < 4)
            {
				capacitySimpleMode.addClass(CSS_NOT_ENOUGH_SEATS_TABLE_MODE);
				capacitySimpleMode.removeClass(CSS_TO_MANY_SEATS);
                return false;
            }else if(totalSeats > 9999){
				capacitySimpleMode.addClass(CSS_TO_MANY_SEATS);
				capacitySimpleMode.removeClass(CSS_NOT_ENOUGH_SEATS_TABLE_MODE);
				return false;
			}
		});
	};

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;
		
		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {
			
			var moduleNode 			= jQuery(this);
            
            initTableModeToggle(moduleNode);

			initValidation(moduleNode);

		});
		
	};

};

// Make class public to outside world
module.exports = CapacitySimpleMode;

},{"jquery/dist/jquery":14}],171:[function(require,module,exports){
/**
 * DataPrivacy functionality.
*
*/


// External libs
jQuery = require('jquery/dist/jquery');
Tracking       = require('../../utils/Tracking');

var Confirm					= require('../../modals/Confirm');
var Alert					= require('../../modals/Alert');
var UserInterfaceUtils		= require('../../utils/UserInterfaceUtils');
var FormInputFilter			= require('../../form/FormInputFilter');

// Class definition
var TableSetupAlternative = function() {

    // self references
    var self;

	// selector constants
	var SEL_MODULE										= '.mod-table-setup-alternative';

	var SEL_TABLE_SETUP_MODAL							= '.mod-modal-tablesetup';

	var SEL_FORM										= 'form';
	var SEL_WIZARD_MODULE								= '.wizard-step-content';
	var SEL_CONTINUE_BUTTON								= '.mod-wizard-buttons .btn-continue';

	var SEL_TABLE_MODE_TOGGLE							= '.mod-table-setup-alternative-toggle #reservables-is-reservable-mode';
	var SEL_TABLE_MODE_TOGGLE_WARNING					= '.mod-table-setup-alternative-toggle .reservable-mode-change-warning';
	var SEL_TABLE_MODE 									= '.mod-table-setup-alternative-capacity-mode';
	var SEL_TABLE_MODE_INPUT_WRAP 						= '.form-group-input-wrap';
	var SEL_TABLE_MODE_SEATS_INPUT						= '#reservables-capacity';
	var SEL_SEAT_CONFIGURATION_CARD_WIZARD				= '.seatConfigurationCard';
	var SEL_WIZARD_SEAT_NUMBERS							= '#wizard-seatNumbers-seatNumbers';

	var SEL_SUMMARY_EDITING_SECTION						= '.summary-editing-section';
	var SEL_SUMMARY_EDITING_SECTION_TOGGLE				= '.summary-editing-toggle';
	var SEL_SUMMARY_EDITING_SECTION_VALUE				= '.summary-editing-value';
	var SEL_SUMMARY_EDITING_SECTION_AREAS				= '.summary-editing-section.reservable-mode-areas';
	var SEL_SUMMARY_EDITING_SECTION_TABLES				= '.summary-editing-section.reservable-mode-tables';
	var SEL_SUMMARY_EDITING_SECTION_TABLECOMB			= '.summary-editing-section.reservable-mode-tablecomb';

	var SEL_MODAL_VALIDATION_ALERT						= '.validationAlertModal';
	var SEL_MODAL_DELETE_CONFIRM						= '.deleteConfirmModal';
	var SEL_MODAL_DELETE_CONFIRM_MESSAGE				= '.confirm-message';

	var SEL_AREA_EDITING								= '.reservable-mode-areas.summary-section-editing .mod-table-setup-alternative-area-edit';
	var SEL_TABLES_EDITING								= '.mod-table-setup-alternative-table-edit';

	var SEL_AREA_EDIT_CARD								= '.mod-table-setup-alternative-area-edit';
	var SEL_AREA_EDIT_TEMPLATE							= '.areas-list-item-template';
	var SEL_AREA_EDIT_DATA								= '.areas-list-data';
	var SEL_AREA_EDIT_ADD_BUTTON						= '.add-new-button';
	var SEL_AREA_EDIT_DELETE_BUTTON						= '.delete-button';
	var SEL_AREA_EDIT_ITEM_CONTAINER					= '.areas-list-body';
	var SEL_AREA_EDIT_ITEM								= '.areas-list-item';
	var SEL_AREA_EDIT_ITEM_NAME							= '.input-name';
	var SEL_AREA_EDIT_ITEM_ACTIVE						= '.input-active';
	var SEL_AREA_EDIT_ITEM_ACTIVE_WRAP					= '.active-wrap';
	var SEL_AREA_EDIT_ITEM_SELECTABLE_WRAP				= '.selectable-wrap';
	var SEL_AREA_EDIT_ITEM_SELECTABLE_INPUT 			= 'input#selectable';

	var SEL_TABLE_EDIT_CARD								= '.mod-table-setup-alternative-table-edit';
	var SEL_TABLE_EDIT_CARD_TOTAL_SEATS					= '.total-seats-count';
	var SEL_TABLE_EDIT_TEMPLATE							= '.tables-list-item-template';
	var SEL_TABLE_EDIT_DATA								= '.tables-list-data';
	var SEL_TABLE_EDIT_ADD_BUTTON						= '.add-new-button';
	var SEL_TABLE_EDIT_DELETE_BUTTON					= '.delete-button';
	var SEL_TABLE_EDIT_ITEM_CONTAINER					= '.tables-list-container';
	var SEL_TABLE_EDIT_ITEM								= '.tables-list-item';
	var SEL_TABLE_EDIT_ITEM_NAME						= '.input-name';
	var SEL_TABLE_EDIT_ITEM_ACTIVE						= '.input-active';
	var SEL_TABLE_EDIT_ITEM_PAUSED_ACTIVE				= '.paused-table-active';
	var SEL_TABLE_EDIT_ITEM_BLOCKED_ACTIVE				= '.blocked-table-active';
	var SEL_TABLE_EDIT_ITEM_PAUSED_TABLE_ACTIVE_WRAP 	= '.paused-table-active-wrap';
	var SEL_TABLE_EDIT_ITEM_BLOCKED_TABLE_ACTIVE_WRAP 	= '.blocked-table-active-wrap';
	var SEL_TABLE_EDIT_ITEM_AREA_NAME					= 'select.input-area-name';
	var SEL_TABLE_EDIT_ITEM_PRIORITY					= 'select.input-priority';
	var SEL_TABLE_EDIT_ITEM_SEATS						= '.input-seats';

	var SEL_TABLECOMB_EDIT_CARD							= '.mod-table-setup-alternative-tablecomb-edit';
	var SEL_TABLE_SUMMARY_CARD							= '.mod-table-setup-alternative-table-summary';
	var SEL_TABLE_SUMMARY_CARD_TOTAL_SEATS				= 'thead .total-seats';
	var SEL_TABLE_SUMMARY_CARD_ITEM						= '.table-item';
	var SEL_TABLE_SUMMARY_CARD_ITEM_AREA_NAME			= '.table-area-name';
	var SEL_TABLE_SUMMARY_CARD_ITEM_STATUS				= '.table-status';
	var SEL_TABLE_SUMMARY_CARD_BLOCKED_TABLE_STATUS 	= '.blocked-table-status';
	var SEL_TABLECOMB_EDIT_ITEM_CONTAINER				= '.tablecomb-list-container';
	var SEL_TABLECOMB_EDIT_ITEM							= '.tablecomb-list-item';
	var SEL_TABLECOMB_EDIT_TEMPLATE						= '.tablecomb-list-item-template';
	var SEL_TABLECOMB_EDIT_ADD_BUTTON					= '.add-new-button';
	var SEL_TABLECOMB_EDIT_ITEM_MINIMUMCAPACITY			= '.input-minguests';
	var SEL_TABLECOMB_EDIT_ITEM_MAXIMUMCAPACITY			= '.input-maxguests';
	var SEL_TABLECOMB_EDIT_ITEM_PRIORITY				= 'select.input-priority';
	var SEL_TABLECOMB_EDIT_DATA							= '.tablecomb-list-data';
	var SEL_TABLECOMB_EDIT_DELETE_BUTTON				= '.delete-button';
	var SEL_SWITCH_TOGGLE								= '.switch-input.input-active';

	var SEL_SELECT_TABLES_ON_WIZARD						= '#wizard-tables-useTablesConfiguration-true';
	var SEL_DATA_ITEM									= '.data-item';

	var SEL_SWITCH_INPUT								= '.switch .switch-input';
	var SEL_SWITCH_LABEL								= '.switch label';

	var SEL_VALIDATE_REQUIRED							= '.validate-required';

	var ATTR_DATA_ID									= 'data-id';
	var ATTR_DATA_NAME									= 'data-name';
	var ATTR_DATA_PATH_PREFIX							= 'data-path-prefix';
	var ATTR_DATA_SEATS									= 'data-seats';
	var ATTR_DATA_GROUP									= 'data-group';
	var ATTR_DATA_PAUSED								= 'data-paused';
	var ATTR_DATA_BLOCKED								= 'data-blocked';
	var ATTR_DATA_STATUS_PAUSED							= 'data-status-paused';
	var ATTR_DATA_STATUS_BLOCKED 						= 'data-status-blocked';
	var ATTR_DATA_STATUS_ACTIVE							= 'data-status-unpaused';
	var ATTR_DATA_ORIG_TITLE							= 'data-original-title';
	var ATTR_DATA_RESERVABLE							= 'data-reservable';

	var DATA_ATTR_HIDDEN_ITEM							= 'hiddenItem';

	var CSS_TABLE_MODE_ACTIVE							= 'table-mode-active';
	var CSS_SUMMARY_SECTION_EDITING						= 'summary-section-editing';
	var CSS_HIDE_SAVE_BUTTON							= 'hide-save-button';
	var CSS_HIDDEN										= 'hidden';
	var CSS_DATA_ITEM									= 'data-item';
	var CSS_HAS_UNSAVED_CHANGES							= 'has-unsaved-changes';
	var CSS_HAS_ERROR									= 'has-error';
	var CSS_DISABLED									= 'disabled';
	var CSS_NOT_ENOUGH_SEATS							= 'has-notEnough-seats';
	var CSS_NOT_ENOUGH_SEATS_TABLE_MODE 				= 'has-notEnough-seats-table-mode';
	var CSS_NOT_VALID_SEATS_INPUT 						= 'has-invalidSeatsInput-table-mode';

	var PAUSED_TRUE										= 'true';
	var PAUSED_FALSE									= 'false';
	var SELECTABLE_TRUE									= 'true';
	var SELECTABLE_FALSE								= 'false';

	var EDITING_TRUE									= 'true';

	var EVENT_AREA_CHANGED								= 'area:changed';
	var EVENT_TABLE_AREA_CHANGED						= 'table:area:changed';

	var SWITCH_ID_PREFIX								= 'generated-switch-id-';

	var SCROLL_TO_ELEMENT_OFFSET						= 15; // 15 pixels => default spacing

	var MAX_CAPACITY_LIMIT								= 20;
	var ZERO_CAPACITY_LIMIT								= 0;
	var MIN_CAPACITY_LIMIT								= 1;

	var FORM_ERROR_TYPE									= "form-error";
	var FORM_EVENT_TYPE									= "error-form";
	var FORM_EVENT_NAME									= "error";
	var FORM_ERROR_FIELD_NAME							= "Area Name";
	var FORM_ERROR_MESSAGE								= "Your inputs could not be saved,please correct the highlighted errors first.";

	var FILTER_POSITIVE_INTEGERS_ONLY  = function(value) {
		return value === '' || /^\d*$/.test(value);
	};

	var confirmModal = new Confirm();
	var alertModal = new Alert();

	var inputFilter = new FormInputFilter();

	var newAreaIdCounter = -1;
	var newSwitchCounter = 0;
	var totalTablesSeats = 0;

	var isFeatureToggleEnable = (window.config && window.config.reservableList && window.config.reservableList.isFeatureToggle) ? window.config.reservableList.isFeatureToggle == "true" : false;
	var isBlockedTableFeatureToggle = (window.config.reservableList && window.config.reservableList.isBlockedOnlineEnabled) ?  window.config.reservableList.isBlockedOnlineEnabled == 'true' : false;

	//initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.error = window._adl.error || {};

	var getNewAreaId = function() {
		newAreaIdCounter--; // move backwards in negative
		return newAreaIdCounter;
	};

	var getNewTableId = function() {
		newAreaIdCounter--; // move backwards in negative
		return newAreaIdCounter;
		//return 0; // we always set 0 for new items
	};

	var getNewTablecombId = function() {
		return 0; // we always set 0 for new items
	};

	var getNewSwitchId = function() {
		return SWITCH_ID_PREFIX + (newSwitchCounter++);
	};

	var makeToggleIdUnique = function(parentElement) {
		var newId = getNewSwitchId();
		parentElement.find(SEL_SWITCH_INPUT).attr('id', newId);
		parentElement.find(SEL_SWITCH_LABEL).attr('for', newId);
	};

	var isTablePaused = function(areaItem, originalTablePause) {
		// table has to be paused, if area is paused
		if (areaItem && areaItem.paused) {
			return true;
		}
		return originalTablePause;
	};

	var showTablePlanPopoup = function(moduleNode, showModal){
		var tableSetupPopup = moduleNode.find(SEL_TABLE_SETUP_MODAL);

		if(showModal == 'true'){
			tableSetupPopup.modal('show');
		}
	}

	var initTableModeToggle = function(moduleNode) {
		var initialTableModeActive = moduleNode.hasClass(CSS_TABLE_MODE_ACTIVE);
		var warningCard = moduleNode.find(SEL_TABLE_MODE_TOGGLE_WARNING);

		moduleNode.find(SEL_TABLE_MODE_TOGGLE).on('change', function() {
			var toggle = jQuery(this);

			if (toggle.is(':checked')) {
				moduleNode.addClass(CSS_TABLE_MODE_ACTIVE);
				if (!initialTableModeActive) {
					warningCard.removeClass(CSS_HIDDEN);
				} else {
					warningCard.addClass(CSS_HIDDEN);
				}
			} else {
				moduleNode.removeClass(CSS_TABLE_MODE_ACTIVE);
				if (initialTableModeActive) {
					warningCard.removeClass(CSS_HIDDEN);
				} else {
					warningCard.addClass(CSS_HIDDEN);
				}
			}
			moduleNode.removeClass(CSS_HIDE_SAVE_BUTTON);

			// show warning
		});
	};

	var initSummaryEditingSections = function(moduleNode) {

		var localConfig = window.config.reservableList || [];
		if(localConfig == ''){
			localConfig = window.config.areaEditWizard || [];
		}
		var initialReseravableGroups = localConfig.reservableGroups || [];
		var initialReseravables = localConfig.reservables || [];
		var initialReservableCombinations = localConfig.reservableCombinations || [];

		var sections = moduleNode.find(SEL_SUMMARY_EDITING_SECTION);

		var showEditMode = function(section) {
			section.toggleClass(CSS_SUMMARY_SECTION_EDITING);
			section.find(SEL_SUMMARY_EDITING_SECTION_VALUE).val(EDITING_TRUE);
			moduleNode.removeClass(CSS_HIDE_SAVE_BUTTON);
		};

		sections.each(function() {
			var section = jQuery(this);
			section.find(SEL_SUMMARY_EDITING_SECTION_TOGGLE).on('click', function() {
				showEditMode(section);
				moduleNode.removeClass(CSS_HIDE_SAVE_BUTTON);
			});
		});

		// enable editing for first time
		var areaSection = sections.filter(SEL_SUMMARY_EDITING_SECTION_AREAS);
		var isAreasEditing = areaSection.find(SEL_SUMMARY_EDITING_SECTION_VALUE).val() === EDITING_TRUE;
		if (initialReseravableGroups.length === 0 || isAreasEditing) {
			showEditMode(areaSection);
		}
		
		var tableSection = sections.filter(SEL_SUMMARY_EDITING_SECTION_TABLES);
		var isTablesEditing = tableSection.find(SEL_SUMMARY_EDITING_SECTION_VALUE).val() === EDITING_TRUE;
		if (initialReseravables.length === 0 || isTablesEditing) {
			showEditMode(tableSection);
		}

		var tablecombSection = sections.filter(SEL_SUMMARY_EDITING_SECTION_TABLECOMB);
		var isTablecombsEditing = tablecombSection.find(SEL_SUMMARY_EDITING_SECTION_VALUE).val() === EDITING_TRUE;
		if (initialReservableCombinations.length === 0 || isTablecombsEditing) {
			showEditMode(tablecombSection);
		}
	};

	var showDeletePopup = function(moduleNode, message) {
		var modal = moduleNode.find(SEL_MODAL_DELETE_CONFIRM)
					.clone()
					.removeClass(CSS_HIDDEN);
		modal.find(SEL_MODAL_DELETE_CONFIRM_MESSAGE).text(message);
		return confirmModal.show(modal);
	};

	var addHiddenInput = function(dataItem, name, value) {
		return jQuery('<input />')
					.attr('type', 'hidden')
					.attr('value', value)
					.attr(ATTR_DATA_NAME, name) // this will be used to generate the name later
					.appendTo(dataItem);
	};

	var updateHiddenInput = function(dataItem, name, value) {
		dataItem.find('[' + ATTR_DATA_NAME + '="' + name + '"]').attr('value', value);
	};

	var removeItem = function(displayItem) {
		// let's try and remove any linked items
		var dataItem = displayItem.data(DATA_ATTR_HIDDEN_ITEM);
		if (dataItem) {
			dataItem.remove();
		}
		displayItem.remove();
	};

	var deleteTableInTableCombinations = function(moduleNode, allItems){
	
		var tcContainer = moduleNode.find(".tablecomb-list-item");

		tcContainer.each(function(){
			var optionList = jQuery(this).find(".tbl-combination-dropdown option");
			var selectedOptions = jQuery(this).find(".tbl-combination-dropdown option:selected");
			var tcAreaId;
			var specificAreaTables = [];

			optionList.each(function() {
				tcAreaId = jQuery(this).attr("data-table-area-id");
			})

			if(selectedOptions.length != 0){

				var optionIds = [];
				// get all the ids of existing options
				optionList.each(function(){
					optionIds.push(jQuery(this).attr("data-table-id"));
				})

				Object.values(allItems).forEach(function(item) {
					if(item.groupId == tcAreaId){
						specificAreaTables.push(item);
					}
				})
				
				var tableIds = [];
				// get all the ids of existing tables
				specificAreaTables.forEach(function(item){
					tableIds.push(item.id);
				});

				var selectedOptionIds = [];
				selectedOptions.each(function(){
					selectedOptionIds.push(jQuery(this).attr("data-table-id"));
				});

				// if found extra option in multi select dropdown which doesn't exist in table row
				var deletedSelectedItemTableRow = selectedOptionIds.filter(function(item){ return !tableIds.includes(item) })

				if(deletedSelectedItemTableRow.length > 0){
					var currentItem = jQuery(this);
					removeItem(currentItem);
				}else{
					// if found extra option in multi select dropdown which doesn't exist in table row
					var deletedTableRow = optionIds.filter(function(item){ return !tableIds.includes(item) })
	
					if(deletedTableRow.length > 0){
						optionList.each(function(){
							var item = jQuery(this);
							if(item.attr("data-table-id") == deletedTableRow[0]){
								item.remove();
							}
						})
					}
				}

			}
			
			if(selectedOptions.length == 0){
				var checkExtraOption = Object.values(optionList).filter(function(obj) {
					return !Object.values(allItems).some(function(obj2) {
						return (jQuery(obj).attr("data-table-id") == obj2.id && 
								jQuery(obj).attr("data-table-area-id") == obj2.groupId &&
								obj.value == obj2.name && 
								jQuery(obj).attr("data-table-capacity") == obj2.capacity && 
								jQuery(obj).attr("data-table-priority") == obj2.priority);
					});
				});

				if(checkExtraOption.length > 0){
					checkExtraOption[0].remove();
				}
			}
		});
	};

	var cleanUpInputNames = function(dataNode, pathPrefix) {
		dataNode.find(SEL_DATA_ITEM).each(function(index) {
			jQuery(this).find('input').each(function() {
				var input = jQuery(this);
				var name = input.attr(ATTR_DATA_NAME) || '';
				if (name !== '') {
					input.attr('name', pathPrefix + '[' + index + '].' + name);
				}
			});
		});
	};

	var addOptionToSelect = function(select, value, label, disabled) {
		return jQuery('<option />')
				.appendTo(select)
				.text(label)
				.attr('value', value)
				.prop('disabled', !!disabled);
	};

	var addAreaDisplayItem = function(container, template, areaItem, dataItem) {
		var item = template.find(SEL_AREA_EDIT_ITEM).clone();

		item.attr(ATTR_DATA_ID, areaItem.id).appendTo(container);
		item.find(SEL_AREA_EDIT_ITEM_NAME).val(areaItem.name);

		// clean up active toggle
		var activeToggle = item.find(SEL_AREA_EDIT_ITEM_ACTIVE);
		var activeToggleWrap = activeToggle.parents(SEL_AREA_EDIT_ITEM_ACTIVE_WRAP);
		activeToggle.prop('checked', !areaItem.paused);
		makeToggleIdUnique(activeToggleWrap);

		// enable/disable selectable toggle based on the value
		var selectableToggle = item.find(SEL_AREA_EDIT_ITEM_SELECTABLE_INPUT);
		selectableToggle.prop('checked', areaItem.selectable);

		// remember the linked data item node
		item.data(DATA_ATTR_HIDDEN_ITEM, dataItem);
		return item;
	};

	var getAreaItemFromDisplayItem = function(displayItem) {
		var areaItem = {};
		areaItem.id = displayItem.attr(ATTR_DATA_ID) || '';
		areaItem.name = displayItem.find(SEL_AREA_EDIT_ITEM_NAME).val() || '';
		areaItem.paused = !displayItem.find(SEL_AREA_EDIT_ITEM_ACTIVE).prop('checked');
		areaItem.selectable = displayItem.find(SEL_AREA_EDIT_ITEM_SELECTABLE_INPUT).prop('checked');
		return areaItem;
	};

	var updateAreaOptionsInTableItem = function(areaSelect, areaOptions, localConfig) {
		areaSelect.empty();
		// has options
		if (Object.keys(areaOptions).length) {
			for (var areaId in areaOptions) {
				var areaItem = areaOptions[areaId] || {};
				var areaName = areaItem.name || '';
				if (areaName !== '') {
					addOptionToSelect(areaSelect, areaId, areaName);
				}
			}
		} else {
			// no options?
			var noItemsLabel = localConfig.msg.tableNoAreas;
			addOptionToSelect(areaSelect, '', noItemsLabel, true);
		}
		areaSelect.selectpicker('refresh');
	};

	var addTablecombDisplayItem = function(container, template, tablecombItem, dataItem, moduleNode, localConfig) {
		var item = template.find(SEL_TABLECOMB_EDIT_ITEM).clone();
		item.attr(ATTR_DATA_ID, tablecombItem.id).appendTo(container);

		// Fill out TABLE COMBINATIONS
		var allTableOptions = item.find(".tbl-combination-dropdown option");
		var newReservables = tablecombItem.reservables;

		// to display reservables in edit mode
		if(newReservables.length > 0){
			Object.values(allTableOptions).forEach(function(e1) {
				newReservables.forEach(function(e2) {
					if(e1.value == e2.name){
						jQuery(e1).attr("selected", true);
					}
				});
			});

			// remove other area tables which are not in the same area as selected tables
			allTableOptions.each(function(){
				if(tablecombItem.areaId != parseInt(jQuery(this).attr("data-table-area-id"))){
					jQuery(this).remove();
				}
			});
		}


		// Fill out minguests and maxguests
		var minCapacity = item.find(SEL_TABLECOMB_EDIT_ITEM_MINIMUMCAPACITY);
		minCapacity.val(tablecombItem.minimumCapacity);
		inputFilter.init(minCapacity, FILTER_POSITIVE_INTEGERS_ONLY);

		var maxCapacity = item.find(SEL_TABLECOMB_EDIT_ITEM_MAXIMUMCAPACITY);
		maxCapacity.val(tablecombItem.maximumCapacity);
		inputFilter.init(maxCapacity, FILTER_POSITIVE_INTEGERS_ONLY);

		// Fill out priority
		var prioritySelect = item.find(SEL_TABLECOMB_EDIT_ITEM_PRIORITY);
		prioritySelect.selectpicker('val', tablecombItem.priority);

		// remember the linked data item node
		item.data(DATA_ATTR_HIDDEN_ITEM, dataItem);

		initMultiSelect(moduleNode);
		

		if(tablecombItem.reservables.length == 0){
			updateAllTablesOnAddButton(moduleNode, item);
		}

		return item;
	};

	var addTableDisplayItem = function(container, template, tableItem, dataItem, areaOptions, localConfig) {
		var item = template.find(SEL_TABLE_EDIT_ITEM).clone();

		item.attr(ATTR_DATA_ID, tableItem.id).appendTo(container);
		item.find(SEL_TABLE_EDIT_ITEM_NAME).val(tableItem.name);

		// make sure seats are only positive numbers
		var seats = item.find(SEL_TABLE_EDIT_ITEM_SEATS);
		seats.val(tableItem.capacity);
		inputFilter.init(seats, FILTER_POSITIVE_INTEGERS_ONLY);

		// populate area names, then select it
		var areaSelect = item.find(SEL_TABLE_EDIT_ITEM_AREA_NAME).empty();
		updateAreaOptionsInTableItem(areaSelect, areaOptions, localConfig);
		areaSelect.selectpicker('val', tableItem.groupId);

		// Fill out priority
		var prioritySelect = item.find(SEL_TABLE_EDIT_ITEM_PRIORITY);
		prioritySelect.selectpicker('val', tableItem.priority);

		// clean up active toggle
		var activeToggle = item.find(SEL_TABLE_EDIT_ITEM_PAUSED_ACTIVE);
		var activeToggleWrap = activeToggle.parents(SEL_TABLE_EDIT_ITEM_PAUSED_TABLE_ACTIVE_WRAP);
		activeToggle.prop('checked', !tableItem.paused);
		makeToggleIdUnique(activeToggleWrap);

		// clean up blocked table toggle

		if(isBlockedTableFeatureToggle){
			var blockedToggle = item.find(SEL_TABLE_EDIT_ITEM_BLOCKED_ACTIVE);
			var blockedToggleWrap = blockedToggle.parents(SEL_TABLE_EDIT_ITEM_BLOCKED_TABLE_ACTIVE_WRAP);
			blockedToggle.prop('checked', !tableItem.blocked);
			makeToggleIdUnique(blockedToggleWrap);
		}

		// remember the linked data item node
		item.data(DATA_ATTR_HIDDEN_ITEM, dataItem);

		// disable/enable delete button
		var deleteButton = item.find(SEL_TABLE_EDIT_DELETE_BUTTON);
		if (!tableItem.canBeRemoved) {
			virtuallySetButtonDisabled(deleteButton, true);
			deleteButton.attr(ATTR_DATA_ORIG_TITLE, localConfig.msg.tableHasReservations);
		} else {
			deleteButton.attr(ATTR_DATA_ORIG_TITLE, localConfig.msg.tableDelete);
		}
		deleteButton.tooltip();

		return item;

	};

	var getTableItemFromDisplayItem = function(displayItem) {
		var tableItem = {};
		tableItem.id = displayItem.attr(ATTR_DATA_ID) || '';
		tableItem.name = displayItem.find(SEL_TABLE_EDIT_ITEM_NAME).val() || '';
		tableItem.capacity = displayItem.find(SEL_TABLE_EDIT_ITEM_SEATS).val() || '';
		tableItem.paused = !displayItem.find(SEL_TABLE_EDIT_ITEM_PAUSED_ACTIVE).prop('checked');

		if(isBlockedTableFeatureToggle){
			tableItem.blocked = !displayItem.find(SEL_TABLE_EDIT_ITEM_BLOCKED_ACTIVE).prop('checked');
		}

		tableItem.groupId = displayItem.find(SEL_TABLE_EDIT_ITEM_AREA_NAME).selectpicker('val') || '';
		tableItem.priority = displayItem.find(SEL_TABLE_EDIT_ITEM_PRIORITY).selectpicker('val') || '';
		return tableItem;
	};

	var getTableCombItemFromDisplayItem = function(displayItem) {
		var tablecombItem = {};
		tablecombItem.id = displayItem.attr(ATTR_DATA_ID) || '';
		tablecombItem.minimumCapacity = displayItem.find(SEL_TABLECOMB_EDIT_ITEM_MINIMUMCAPACITY).val() || '';
		tablecombItem.maximumCapacity = displayItem.find(SEL_TABLECOMB_EDIT_ITEM_MAXIMUMCAPACITY).val() || '';
		tablecombItem.priority = displayItem.find(SEL_TABLECOMB_EDIT_ITEM_PRIORITY).selectpicker('val') || '';
		
		tablecombItem.reservables = [];
		displayItem.find(".tbl-combination-dropdown option:selected").each(function(){
			var tableOption = jQuery(this);
			var tableObj = {
				id: 0,
				name: '',
				capacity: 0
			};
			tableObj.id = tableOption.attr("data-table-id");
			tableObj.name = tableOption.val();
			tableObj.capacity = tableOption.attr("data-table-capacity");
			tablecombItem.areaId = displayItem.find(".tbl-combination-dropdown option:selected").attr("data-table-area-id");
			tablecombItem.reservables.push(tableObj);
		});
		
		return tablecombItem;
	};

	var addAreaDataItem = function(dataNode, areaItem) {

		var dataItem = jQuery('<div />')
						.addClass(CSS_DATA_ITEM)
						.attr(ATTR_DATA_ID, areaItem.id)
						.appendTo(dataNode);

		// add input values
		addHiddenInput(dataItem, 'id', areaItem.id);
		addHiddenInput(dataItem, 'name', areaItem.name || '');
		addHiddenInput(dataItem, 'paused', areaItem.paused ? PAUSED_TRUE : PAUSED_FALSE);
		addHiddenInput(dataItem, 'selectable', areaItem.selectable ? SELECTABLE_TRUE : SELECTABLE_FALSE);

		return dataItem;
	};

	var updateAreaDataItem = function(dataItem, areaItem) {
		updateHiddenInput(dataItem, 'name', areaItem.name || '');
		updateHiddenInput(dataItem, 'paused', areaItem.paused ? PAUSED_TRUE : PAUSED_FALSE);
		updateHiddenInput(dataItem, 'selectable', areaItem.selectable ? SELECTABLE_TRUE : SELECTABLE_FALSE);
	};

	var addTableDataItem = function(dataNode, tableItem) {
		var id = tableItem.id || getNewTableId();

		var dataItem = jQuery('<div />')
						.addClass(CSS_DATA_ITEM)
						.attr(ATTR_DATA_ID, id)
						.appendTo(dataNode);

		// add input values
		addHiddenInput(dataItem, 'id', id);
		addHiddenInput(dataItem, 'name', tableItem.name || '');
		addHiddenInput(dataItem, 'capacity', tableItem.capacity || '0');
		addHiddenInput(dataItem, 'priority', tableItem.priority || '0');
		addHiddenInput(dataItem, 'groupId', tableItem.groupId || '0');
		addHiddenInput(dataItem, 'paused', tableItem.paused ? PAUSED_TRUE : PAUSED_FALSE);

		if(isBlockedTableFeatureToggle){
			addHiddenInput(dataItem, 'blocked', tableItem.blocked ? PAUSED_TRUE : PAUSED_FALSE);
		}

		return dataItem;
	};

	var updateTableDataItem = function(dataItem, tableItem) {
		//if user doesn't have access of table priority feature, will set priority with 2
		if(tableItem.priority && tableItem.priority.length == 0){
			tableItem.priority = 2;
		}
		updateHiddenInput(dataItem, 'name', tableItem.name || '');
		updateHiddenInput(dataItem, 'capacity', tableItem.capacity || '0');
		updateHiddenInput(dataItem, 'groupId', tableItem.groupId || '0');
		updateHiddenInput(dataItem, 'priority', tableItem.priority || '0');
		updateHiddenInput(dataItem, 'paused', tableItem.paused ? PAUSED_TRUE : PAUSED_FALSE);

		if(isBlockedTableFeatureToggle){
			updateHiddenInput(dataItem, 'blocked', tableItem.blocked ? PAUSED_TRUE : PAUSED_FALSE);
		}
	};

	var addTablecombDataItem = function(dataNode, tablecombItem) {
		var id = tablecombItem.id || 0;
		var dataId = tablecombItem.id || getNewAreaId;

		var dataItem = jQuery('<div />')
						.addClass(CSS_DATA_ITEM)
						.attr(ATTR_DATA_ID, dataId)
						.appendTo(dataNode);

		// add input values
		addHiddenInput(dataItem, 'id', id);
		addHiddenInput(dataItem, 'minimumCapacity', tablecombItem.minimumCapacity || '1');
		addHiddenInput(dataItem, 'maximumCapacity', tablecombItem.maximumCapacity || '20');
		addHiddenInput(dataItem, 'priority', tablecombItem.priority || '2');
		addHiddenInput(dataItem, 'areaId', tablecombItem.areaId || '2');
		
		if(tablecombItem.reservables.length != 0){
			tablecombItem.reservables.forEach(function(item, i) {
				addReservaleHiddenInput(dataItem, buildReservablePath(i, 'id'), item.id || '0');
				addReservaleHiddenInput(dataItem, buildReservablePath(i, 'name'), item.name || "");
				addReservaleHiddenInput(dataItem, buildReservablePath(i, 'capacity'), item.capacity || "");
			});
		}

		return dataItem;
	};

	var buildReservablePath = function(subIndex, name) {
		return 'reservables[' + subIndex + '].' + name;
	};

	var updateTableCombDataItem = function(dataItem, tablecombItem) {
		//if user doesn't have access of tablegroup priority feature, will set priority with 2
		if(window.config.reservableList && window.config.reservableList.hasTablePriorityRole == ''){
			tablecombItem.priority = 2;
		}
		updateHiddenInput(dataItem, 'id', tablecombItem.id || '0');
		updateHiddenInput(dataItem, 'minimumCapacity', tablecombItem.minimumCapacity || '1');
		updateHiddenInput(dataItem, 'maximumCapacity', tablecombItem.maximumCapacity);
		updateHiddenInput(dataItem, 'priority', tablecombItem.priority || '2');
		updateHiddenInput(dataItem, 'areaId', tablecombItem.areaId || '2');
		
		// remove previous added hidden inputs for reservables which have "data-reservable" attribute
		dataItem.find("input[type=hidden]").each(function(){
			if(jQuery(this).attr("data-reservable")){
				jQuery(this).remove();
			}
		});
		
		// create hidden inputs for all reservables
		if(tablecombItem.reservables.length > 0){
			tablecombItem.reservables.forEach(function(item, i) {
				addReservaleHiddenInput(dataItem, buildReservablePath(i, 'id'), item.id || '0');
				addReservaleHiddenInput(dataItem, buildReservablePath(i, 'name'), item.name || "");
				addReservaleHiddenInput(dataItem, buildReservablePath(i, 'capacity'), item.capacity || "");
			});
		}
	};

	var addReservaleHiddenInput = function(dataItem, name, value) {
		return jQuery('<input />')
					.attr('type', 'hidden')
					.attr('value', value)
					.attr(ATTR_DATA_NAME, name) // this will be used to generate the name later
					.attr(ATTR_DATA_RESERVABLE, 'reservable')
					.appendTo(dataItem);
	};

	var getAllAreaItems = function(areaCard) {
		var areas = {};
		areaCard.find(SEL_AREA_EDIT_ITEM).each(function() {
			var areaItem = getAreaItemFromDisplayItem(jQuery(this));
			if (areaItem.name !== '') {
				areas[areaItem.id] = areaItem;
			}
		});
		return areas;
	};

	var getAllTableItems = function(tableCard) {
		var tables = {};
		tableCard.find(SEL_TABLE_EDIT_ITEM).each(function() {
			var tableItem = getTableItemFromDisplayItem(jQuery(this));
			if (tableItem.name !== '') {
				tables[tableItem.id] = tableItem;
			}
		});
		return tables;
	};

	var getAreasWithTables = function(tableCard) {
		var areasWithTables = {};
		tableCard.find(SEL_TABLE_EDIT_ITEM).each(function() {
			var item = jQuery(this);
			var areaId = item.find(SEL_TABLE_EDIT_ITEM_AREA_NAME).selectpicker('val') || '';
			if (areaId !== '') {
				areasWithTables[areaId] = (areasWithTables[areaId] || 0) + 1;
			}
		});
		return areasWithTables;
	};

	/*
	 * We cannot disable the button in normal ways, as this affects
	 * the bootstrap tooltip functionality.
	 */
	var virtuallySetButtonDisabled = function(button, disabled) {
		if (disabled) {
			button.addClass(CSS_DISABLED);
		} else {
			button.removeClass(CSS_DISABLED);
		}
	};

	var refreshAreaDeleteButtons = function(areaCard, areasWithTables, localConfig) {
		var totalItems = areaCard.find(SEL_AREA_EDIT_ITEM).length;

		areaCard.find(SEL_AREA_EDIT_ITEM).each(function() {
			var item = jQuery(this);
			var deleteButton = item.find(SEL_AREA_EDIT_DELETE_BUTTON);

			var areaItem = getAreaItemFromDisplayItem(item);
			var hasTables = !!areasWithTables[areaItem.id];

			if (hasTables) {
				virtuallySetButtonDisabled(deleteButton, true);
				deleteButton.attr(ATTR_DATA_ORIG_TITLE, localConfig.msg.areaDisableHasTables);
			} else if (totalItems === 1) { // is one and only item
				virtuallySetButtonDisabled(deleteButton, true);
				deleteButton.attr(ATTR_DATA_ORIG_TITLE, localConfig.msg.areaDisableLastActive);
			} else {
				virtuallySetButtonDisabled(deleteButton, false);
				deleteButton.attr(ATTR_DATA_ORIG_TITLE, localConfig.msg.areaDelete);
			}
			deleteButton.tooltip();

		});
	};

	var getInitialAreasWithTables = function(localConfig) {
		var initialReseravables = localConfig.reservables || [];
		var areasWithTables = {};
		initialReseravables.forEach(function(tableItem) {
			var groupId = tableItem.groupId || '';
			if (groupId !== '') {
				areasWithTables[groupId] = (areasWithTables[groupId] || 0) + 1;
			}
		});
		return areasWithTables;
	};

	var initAreaEditing = function(moduleNode) {

		var localConfig = window.config.reservableList || [];
		if(localConfig == ''){
			localConfig = window.config.areaEditWizard || [];
		}	

		var initialReseravableGroups = localConfig.reservableGroups || [];
		var initialAreasWithTables = getInitialAreasWithTables(localConfig);
		
		var areaCard 		= moduleNode.find(SEL_AREA_EDIT_CARD);
		var itemContainer 	= areaCard.find(SEL_AREA_EDIT_ITEM_CONTAINER).empty();
		var dataNode 		= areaCard.find(SEL_AREA_EDIT_DATA).empty();
		var template 		= areaCard.find(SEL_AREA_EDIT_TEMPLATE).remove();
		
		var deleteConfirmMsg = localConfig.msg.areaDeleteConfirm;
		
		var addNewBlankArea = function(initialCall) {
			// default values
			var areaItem = {
				id: initialCall ? -1 : getNewAreaId(),
				name: '',
				paused: false,
				selectable: true
			};
			var dataItem = addAreaDataItem(dataNode, areaItem);
			addAreaDisplayItem(itemContainer, template, areaItem, dataItem);
		};

		if (initialReseravableGroups.length === 0) {
			// if there are no areas, add an empty card
			addNewBlankArea(true);
		} else {
			// populate the initial data
			initialReseravableGroups.forEach(function(areaItem) {
				var dataItem = addAreaDataItem(dataNode, areaItem);
				addAreaDisplayItem(itemContainer, template, areaItem, dataItem);
			});
		}
		var pathPrefix = dataNode.attr(ATTR_DATA_PATH_PREFIX) || '';
		cleanUpInputNames(dataNode, pathPrefix);

		var triggerItemsUpdatedEvent = function(areaItem) {
			var allAreaItems = getAllAreaItems(areaCard);
			moduleNode.trigger(EVENT_AREA_CHANGED, [ areaItem, allAreaItems ]);
			areaCard.addClass(CSS_HAS_UNSAVED_CHANGES);
		};

		// add new items
		areaCard.on('click', SEL_AREA_EDIT_ADD_BUTTON, function() {
			addNewBlankArea(false);
			cleanUpInputNames(dataNode, pathPrefix);
		});

		// delete handler
		areaCard.on('click', SEL_AREA_EDIT_DELETE_BUTTON, function() {
			var button = jQuery(this);
			if (!button.hasClass(CSS_DISABLED)) {
				showDeletePopup(moduleNode, deleteConfirmMsg).done(function() {
					var displayItem = button.parents(SEL_AREA_EDIT_ITEM);
					removeItem(displayItem);
					cleanUpInputNames(dataNode, pathPrefix);
					triggerItemsUpdatedEvent();
				});
			}
		});

		// handle any input change in the items (use event bubbling)
		areaCard.on('change', SEL_AREA_EDIT_ITEM, function() {
			var item = jQuery(this);
			var areaItem = getAreaItemFromDisplayItem(item);
			var dataItem = item.data(DATA_ATTR_HIDDEN_ITEM);
			if (dataItem) {
				updateAreaDataItem(dataItem, areaItem);
			}
			// if the user removes the name, don't show update
			if (areaItem.name !== '') {
				triggerItemsUpdatedEvent(areaItem);
			}
		});

		// listen to any area list changes
		moduleNode.on(EVENT_TABLE_AREA_CHANGED, function(e, areasWithTables) {
			refreshAreaDeleteButtons(areaCard, areasWithTables, localConfig);
		});

		// refresh delete buttons
		refreshAreaDeleteButtons(areaCard, initialAreasWithTables, localConfig);
	};

	// initialize table combination
	var initTablecombEditing = function(moduleNode) {

		var localConfig = window.config.reservableList || [];
		if(localConfig == ''){
			localConfig = window.config.areaEditWizard || [];
		}

		var initialReservableCombinations = localConfig.reservableCombinations || [];
		
		var tablecombCard 	= moduleNode.find(SEL_TABLECOMB_EDIT_CARD);
		var itemContainer 	= tablecombCard.find(SEL_TABLECOMB_EDIT_ITEM_CONTAINER).empty();
		var dataNode 		= tablecombCard.find(SEL_TABLECOMB_EDIT_DATA).empty();
		var template 		= tablecombCard.find(SEL_TABLECOMB_EDIT_TEMPLATE).remove();
		
		var isUpdatingAreasOnOtherEvent = false;
		var deleteConfirmMsg = localConfig.msg.tableGroupDeleteConfirm;
		
		var addNewBlankTablecomb = function() {

			// default values
			var tablecombItem = {
				id: getNewTablecombId(),
				reservables: [],
				minimumCapacity: '',
				maximumCapacity: '',
				priority: '',
				areaId: '',
			};
			var dataItem = addTablecombDataItem(dataNode, tablecombItem);
			addTablecombDisplayItem(itemContainer, template, tablecombItem, dataItem, moduleNode, localConfig);
		};

		if (initialReservableCombinations.length === 0) {
			// if there are no existing rows, add an empty card
		} else {
			// populate the initial data
			initialReservableCombinations.forEach(function(tablecombItem) {
				var dataItem = addTablecombDataItem(dataNode, tablecombItem);
				addTablecombDisplayItem(itemContainer, template, tablecombItem, dataItem, moduleNode, localConfig);
			});
		}

		var pathPrefix = dataNode.attr(ATTR_DATA_PATH_PREFIX) || '';
		cleanUpInputNames(dataNode, pathPrefix);

		// add new items
		tablecombCard.on('click', SEL_TABLECOMB_EDIT_ADD_BUTTON, function() {
			addNewBlankTablecomb();
			cleanUpInputNames(dataNode, pathPrefix);
		});

		// delete specific table combination row
		tablecombCard.on('click', SEL_TABLECOMB_EDIT_DELETE_BUTTON, function() {
			var button = jQuery(this);
			if (!button.hasClass(CSS_DISABLED)) {
				showDeletePopup(moduleNode, deleteConfirmMsg).done(function() {
					var displayItem = button.parents(SEL_TABLECOMB_EDIT_ITEM);
					removeItem(displayItem);
					cleanUpInputNames(dataNode, pathPrefix);
				});
			}
		});

		var refreshTableCombItem = function(item) {
			var tableCombItem = getTableCombItemFromDisplayItem(item);
			var dataItem = item.data(DATA_ATTR_HIDDEN_ITEM);
			if (dataItem) {
				updateTableCombDataItem(dataItem, tableCombItem);
				cleanUpInputNames(dataNode, pathPrefix);
			}
		};

		tablecombCard.on('change', SEL_TABLECOMB_EDIT_ITEM, function() {
			if (!isUpdatingAreasOnOtherEvent) {
				var item = jQuery(this);
				refreshTableCombItem(item);
				tablecombCard.addClass(CSS_HAS_UNSAVED_CHANGES);
			}
		});
	};

	var getInitailGroupsById = function(localConfig) {
		var initialReseravableGroups = localConfig.reservableGroups || [];
		var areaOptions = {};
		initialReseravableGroups.forEach(function(areaItem) {
			var id = areaItem.id || '';
			if (id !== '') {
				areaOptions[id] = areaItem;
			}
		});
		return areaOptions;
	};

	var updateTableCombWithTables = function(moduleNode, allItems){
		var tcContainer = moduleNode.find(".tablecomb-list-item");

		tcContainer.each(function(){
			var optionList = jQuery(this).find(".tbl-combination-dropdown option");
			var selectedOptions = jQuery(this).find(".tbl-combination-dropdown option:selected");
			var item = jQuery(this);
			var tcAreaId;
			var specificAreaTables = [];
			var newOptions = [];
			var isExistingRowUpdated = false;
			var getAllExistingRows = [];

			optionList.each(function() {
				tcAreaId = jQuery(this).attr("data-table-area-id");
			})

			if(selectedOptions.length != 0){

				Object.values(allItems).forEach(function(item) {
					if(item.groupId == tcAreaId){
						specificAreaTables.push(item);
					}
				})

				var uniqueResultOne = specificAreaTables.filter(function(obj) {
					return !Object.values(optionList).some(function(obj2) {
						return (obj.id == jQuery(obj2).attr("data-table-id") && 
								obj.groupId == jQuery(obj2).attr("data-table-area-id") &&
								obj.name == obj2.value && 
								obj.capacity == jQuery(obj2).attr("data-table-capacity") && 
								obj.priority == jQuery(obj2).attr("data-table-priority"));
					});
				});


				if(uniqueResultOne.length > 0){

					var optionIds = [];

					// get all the ids of existing options
					optionList.each(function(){
						optionIds.push(jQuery(this).attr("data-table-id"));
					})

					// search the uniqueResultOne row element in optionIds array (existing element)
					var existedTableRow = uniqueResultOne.filter(function(item){ return optionIds.includes(item.id) });
					getAllExistingRows = existedTableRow;

					// search the uniqueResultOne row element is not exist in optionIds array (new element)
					var newTableRow = uniqueResultOne.filter(function(item){ return !optionIds.includes(item.id) })

					if(existedTableRow.length > 0){
						// edit row
						optionList.each(function() {
							var e1 = jQuery(this);
							existedTableRow.forEach(function(e2){
								if((e1.attr("data-table-id") == e2.id) && e1.attr("data-table-area-id") == e2.groupId){
									e1.val(e2.name);
									e1.attr("data-table-capacity", e2.capacity);
									e1.attr("data-table-area-id", e2.groupId);
									e1.attr("data-table-priority", e2.priority);
									e1.text(e2.name);
								}
							});
						});

						isExistingRowUpdated = true;
					}

					if(newTableRow.length > 0){
						// add row
						newTableRow.forEach(function(item){
							if(item.id != '' && item.name != '' && item.capacity != '' && item.groupId != '' && item.priority != ''){
								newOptions += '<option data-table-id="'+ item.id +'" value="' + item.name + '" value="' + item.id + '" data-table-area-id="' + item.groupId + '" data-table-priority="' + item.priority + '" data-table-capacity="' + item.capacity + '">' + item.name + '</option>';
							}
						})
					}
				}else{
					if(optionList.length > specificAreaTables.length){
						var checkExtraOption = Object.values(optionList).filter(function(obj) {
							return !specificAreaTables.some(function(obj2) {
								return (jQuery(obj).attr("data-table-id") == obj2.id && 
										jQuery(obj).attr("data-table-area-id") == obj2.groupId &&
										obj.value == obj2.name && 
										jQuery(obj).attr("data-table-capacity") == obj2.capacity && 
										jQuery(obj).attr("data-table-priority") == obj2.priority);
							});
						});
	
						if(checkExtraOption.length > 0){
							checkExtraOption[0].remove();
							//check if the option (which area id changed) is the only one which is selected 
							var selectDropdown = optionList.closest(".tbl-combination-dropdown");
							var tableCombOptions = []

							if(selectDropdown.find("option:selected").length == 0){
								Object.values(allItems).forEach(function(item) {
									tableCombOptions += '<option data-table-id="'+ item.id +'" value="' + item.name + '" value="' + item.id + '" data-table-area-id="' + item.groupId + '" data-table-priority="' + item.priority + '" data-table-capacity="' + item.capacity + '">' + item.name + '</option>';
								});
								selectDropdown.empty().append(tableCombOptions);
							}
						}
					}
				}
				
				// refresh multi select autosuggestion after all changes
				jQuery(this).find(".tbl-combination-dropdown").select2({
					allowClear: true,
					refresh: true,
					minimumResultsForSearch: -1,
					placeholder: window.config.reservableList.msg.tableGroupNamePlaceholder,
				});

				if(newOptions.length != 0){
					jQuery(this).find(".tbl-combination-dropdown").append(newOptions);
				}


				if(isExistingRowUpdated && selectedOptions.length > 0 && getAllExistingRows.length > 0){
					updateTableCapacity(selectedOptions, getAllExistingRows);
				}
			}


			if(selectedOptions.length == 0){
				updateAllTablesOnAddButton(moduleNode, item);
			}

		});
	}

	var updateTableCapacity = function(selectedOptions, getAllExistingRows){
		var inputList = [];
		var capacityInput = "";
		selectedOptions.each(function(){
			var item = jQuery(this);    
			getAllExistingRows.forEach(function(subItem){
				if(item.attr("data-table-id") == subItem.id){
					var hiddenItem = item.closest(".tablecomb-list-item").data(DATA_ATTR_HIDDEN_ITEM);
					var hiddenInputs = hiddenItem.find("input[type=hidden]");
					inputList = hiddenInputs;
					hiddenInputs.each(function(){
						var input = jQuery(this);
						if(input.val() == subItem.name){
							var str = input.attr("data-name");
							var index_num = parseInt(str.replace(/[^0-9.]/g, ""));
							capacityInput = "reservables["+index_num+"].capacity";
						}
					});
				}
				if(inputList.length > 0){
					inputList.each(function(){
						var inputField = jQuery(this);
						if(inputField.attr("data-name") == capacityInput){
							inputField.val(subItem.capacity);
						}
					})
				}
			})
		})
	}

	var updateAllTablesOnAddButton = function(moduleNode, item){
		var tableCard = moduleNode.find(SEL_TABLE_EDIT_CARD);
		var allTables = getAllTableItems(tableCard);
		
		var tableCombOptions = [];
		Object.values(allTables).forEach(function(item) {
			if(item.id != '' && item.name != '' && item.priority != '' && item.groupId != ''){
				tableCombOptions += '<option data-table-id="'+ item.id +'" value="' + item.name + '" value="' + item.id + '" data-table-area-id="' + item.groupId + '" data-table-priority="' + item.priority + '" data-table-capacity="' + item.capacity + '">' + item.name + '</option>';
			}
		})
		item.find(".tbl-combination-dropdown").empty().append(tableCombOptions);
	}

	var initTableEditing = function(moduleNode) {

		var localConfig = window.config.reservableList || [];
		if(localConfig == ''){
			localConfig = window.config.areaEditWizard || [];
		}
		var initialReseravables = localConfig.reservables || [];
		var initialAreaOptions = getInitailGroupsById(localConfig);

		var tableCard 		= moduleNode.find(SEL_TABLE_EDIT_CARD);
		var areaCard		= moduleNode.find(SEL_AREA_EDIT_CARD);
		var totalSeats 		= tableCard.find(SEL_TABLE_EDIT_CARD_TOTAL_SEATS);
		var itemContainer 	= tableCard.find(SEL_TABLE_EDIT_ITEM_CONTAINER).empty();
		var dataNode 		= tableCard.find(SEL_TABLE_EDIT_DATA).empty();
		var template 		= tableCard.find(SEL_TABLE_EDIT_TEMPLATE).remove();

		var isUpdatingAreasOnOtherEvent = false;

		var deleteTablewithTableCombinationMsg = localConfig.msg.tableWithTableCombDeleteConfirm;
		var deleteConfirmMsg = localConfig.msg.tableDeleteConfirm;

		var addNewBlankTable = function() {
			// default values
			var tableItem = {
				id: getNewTableId(),
				name: '',
				capacity: '',
				priority: '',
				groupId: '',
				paused: false,
				canBeRemoved: true
			};

			if(isBlockedTableFeatureToggle){
				tableItem.blocked = false;
			}

			var dataItem = addTableDataItem(dataNode, tableItem);
			initialAreaOptions = getAllAreaItems(areaCard);
			addTableDisplayItem(itemContainer, template, tableItem, dataItem, initialAreaOptions, localConfig);
		};

		if (initialReseravables.length === 0) {
			// if there are no areas, add an empty card
			addNewBlankTable();
		} else {
			// populate the initial data
			initialReseravables.forEach(function(tableItem) {
				var dataItem = addTableDataItem(dataNode, tableItem);
				addTableDisplayItem(itemContainer, template, tableItem, dataItem, initialAreaOptions, localConfig);
			});
		}
		var pathPrefix = dataNode.attr(ATTR_DATA_PATH_PREFIX) || '';
		cleanUpInputNames(dataNode, pathPrefix);

		var triggerItemsUpdatedEvent = function(eventType) {
			var tableCard = moduleNode.find(SEL_TABLE_EDIT_CARD);
			var activeAreas = getAreasWithTables(tableCard);
			moduleNode.trigger(EVENT_TABLE_AREA_CHANGED, [ activeAreas ]);
			tableCard.addClass(CSS_HAS_UNSAVED_CHANGES);

			if(eventType == 'delete'){
				var allItems = getAllTableItems(tableCard);
				deleteTableInTableCombinations(moduleNode, allItems);
			}
		};

		var refreshTotalSeats = function() {
			var total = 0;
			tableCard.find(SEL_TABLE_EDIT_ITEM).each(function() {
				var item = jQuery(this);
				var seats = parseInt(item.find(SEL_TABLE_EDIT_ITEM_SEATS).val() || 0);
				var activeToggle = item.find(SEL_TABLE_EDIT_ITEM_ACTIVE);
				var isTableActive = activeToggle.prop('checked');
				if(isTableActive == true){
					if (!isNaN(seats) && seats > 0) {
						total += seats;
					}
				}
			});
			var label = total;
			totalTablesSeats = total;
			totalSeats.text(label);
		};

		// add new items
		tableCard.on('click', SEL_TABLE_EDIT_ADD_BUTTON, function() {
			addNewBlankTable();
			cleanUpInputNames(dataNode, pathPrefix);
		});

		// delete handler
		tableCard.on('click', SEL_TABLE_EDIT_DELETE_BUTTON, function() {
			var button = jQuery(this);

			var tableCombinations = moduleNode.find(".tablecomb-list-item");
			deleteMsg = (tableCombinations.length > 0) ? deleteTablewithTableCombinationMsg : deleteConfirmMsg;

			if (!button.hasClass(CSS_DISABLED)) {
				showDeletePopup(moduleNode, deleteMsg).done(function() {
					var displayItem = button.parents(SEL_TABLE_EDIT_ITEM);
					removeItem(displayItem);
					cleanUpInputNames(dataNode, pathPrefix);
					triggerItemsUpdatedEvent('delete');
					refreshTotalSeats();
				});
			}
		});

		var refreshItem = function(item) {
			var tableItem = getTableItemFromDisplayItem(item);
			var dataItem = item.data(DATA_ATTR_HIDDEN_ITEM);
			if (dataItem) {
				updateTableDataItem(dataItem, tableItem);
			}
		};
		
		//if area is paused then the table has to be paused and cannot be activate unless the area is activated.
		var checkIfAreaActive = function(item){
			var tableItem = getTableItemFromDisplayItem(item);
			var areaCard = moduleNode.find(SEL_AREA_EDIT_CARD);
			var allAreaItems = getAllAreaItems(areaCard);
			var areaSelect = item.find(SEL_TABLE_EDIT_ITEM_AREA_NAME);
			var activeToggle = item.find(SEL_TABLE_EDIT_ITEM_PAUSED_ACTIVE);

			if(isBlockedTableFeatureToggle){
				var activeBlockedTableToggle = item.find(SEL_TABLE_EDIT_ITEM_BLOCKED_ACTIVE);
			}

			var selectedGroupId = areaSelect.selectpicker('val') || '';
			var selectedArea = allAreaItems[selectedGroupId];

			if (selectedArea) {
				var isAreaPaused = isTablePaused(selectedArea, false);
				if(isAreaPaused == true && selectedArea.id == tableItem.groupId){
					activeToggle.prop('checked', !isAreaPaused);

					if(isBlockedTableFeatureToggle){
						activeBlockedTableToggle.prop('checked', !isAreaPaused);
					}
				}

				if(!activeToggle.is(':checked')){
					isBlockedTableFeatureToggle && activeBlockedTableToggle.prop('checked', activeToggle.is(':checked'));
				}
			}
		}
		// handle any input change in the items (use event bubbling)
		tableCard.on('change', SEL_TABLE_EDIT_ITEM, function() {
			if (!isUpdatingAreasOnOtherEvent) {
				var item = jQuery(this);
				checkIfAreaActive(item);
				refreshItem(item);

				var allTableItems = getAllTableItems(tableCard);
				updateTableCombWithTables(moduleNode, allTableItems);

				tableCard.addClass(CSS_HAS_UNSAVED_CHANGES);
			}
			refreshTotalSeats();
		});

		// when seats change, we have to recalculate the total seats
		tableCard.on('change', SEL_TABLE_EDIT_ITEM_SEATS, function() {
			refreshTotalSeats();
		});

		tableCard.on('changed.bs.select',SEL_TABLE_EDIT_ITEM, function(){
			if (!isUpdatingAreasOnOtherEvent) {
				var item = jQuery(this);
				var tableItem = getTableItemFromDisplayItem(item);
				var allAreaItems = getAllAreaItems(areaCard);
				var areaSelect = item.find(SEL_TABLE_EDIT_ITEM_AREA_NAME);
				var activeToggle = item.find(SEL_TABLE_EDIT_ITEM_PAUSED_ACTIVE);

				if(isBlockedTableFeatureToggle){
					var activeBlockedTableToggle = item.find(SEL_TABLE_EDIT_ITEM_BLOCKED_ACTIVE);
				}

				var selectedGroupId = areaSelect.selectpicker('val') || '';
				var selectedArea = allAreaItems[selectedGroupId];
				var isAreaPaused = isTablePaused(selectedArea, false);
				if(!isAreaPaused && selectedArea && selectedArea.id == tableItem.groupId){
					activeToggle.prop('checked', !isAreaPaused);

					if(isBlockedTableFeatureToggle){
						activeBlockedTableToggle.prop('checked', !isAreaPaused);
					}
				}
			}
		});

		// listen to any area name selection changes in table items
		tableCard.on('changed.bs.select', function(e, clickedIndex, isSelected, previousValue) {
			if (!isUpdatingAreasOnOtherEvent) {
				var areaSelect = jQuery(e.target);
				var currentSelection = areaSelect.selectpicker('val') || '';
				if (currentSelection !== previousValue) {
					triggerItemsUpdatedEvent('update');
				}
			}
		});

		// listen to any area list changes
		moduleNode.on(EVENT_AREA_CHANGED, function(e, areaItem, allAreaItems) {
			// mark as a reactive change
			isUpdatingAreasOnOtherEvent = true;

			tableCard.find(SEL_TABLE_EDIT_ITEM).each(function() {
				var item = jQuery(this);

				var tableItem = getTableItemFromDisplayItem(item);
				var areaSelect = item.find(SEL_TABLE_EDIT_ITEM_AREA_NAME);
				var activeToggle = item.find(SEL_TABLE_EDIT_ITEM_PAUSED_ACTIVE);

				if(isBlockedTableFeatureToggle){
					var activeBlockedTableToggle = item.find(SEL_TABLE_EDIT_ITEM_BLOCKED_ACTIVE);
				}
				
				// remember current values
				var selectedGroupId = areaSelect.selectpicker('val') || '';
				updateAreaOptionsInTableItem(areaSelect, allAreaItems, localConfig);
				// try to reselect area name
				areaSelect.selectpicker('val', selectedGroupId);
				selectedGroupId = areaSelect.selectpicker('val') || '';
				
				// update pausing table
				var selectedArea = allAreaItems[selectedGroupId];
				if (selectedArea && areaItem != undefined && tableItem != undefined) {
					if( areaItem.id == tableItem.groupId ){
						var previousPaused = false; // we want this to be active if area is active
						var isPaused = isTablePaused(selectedArea, previousPaused);
						activeToggle.prop('checked', !isPaused);

						if(isBlockedTableFeatureToggle){
							activeBlockedTableToggle.prop('checked', !isPaused);
						}

						refreshTotalSeats();
					}
				}
				
				refreshItem(item);
			});

			// we are done, now unmark
			isUpdatingAreasOnOtherEvent = false;
		});

		// calculate current number of seats
		refreshTotalSeats();

	};

	var valiadateRequiredInput = function(input) {
		var parent = input.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
		var value = input.val() || '';
		if (value.trim() === '' || (input.hasClass('input-seats') && parseInt(value) > MAX_CAPACITY_LIMIT)
		|| (input.hasClass('input-seats') && parseInt(value) == ZERO_CAPACITY_LIMIT) 

		|| (input.hasClass('input-minguests') && parseInt(value) < MIN_CAPACITY_LIMIT)) {
			parent.addClass(CSS_HAS_ERROR);
			return false;
		}
		return true;
	};

	var getInvalidAreaItems = function(areaCard) {
		var invalidItems = [];
		var uniqueAreaError = false;

		var allAreas = getAllAreaItems(areaCard);

		areaCard.find(SEL_AREA_EDIT_ITEM).each(function() {
			var item = jQuery(this);
			var areaName = item.find(SEL_AREA_EDIT_ITEM_NAME);
			if (!valiadateRequiredInput(areaName)) {
				invalidItems.push(item);
			}

			if(!validateUniqueAreaName(Object.values(allAreas), areaName)){
				invalidItems.push(item);
				uniqueAreaError = true;
			}
		});

		return {
			invalidItems: invalidItems,
			uniqueAreaError: uniqueAreaError
		};
	};

	var validateUniqueAreaName = function(allAreas, areaName){
		//var inputName = item.find(".name-wrap .input-name");
		var count = 0;

		for (var i = 0; i < allAreas.length; i++) {
            var existingAreaName = allAreas[i].name.trim();
            var inputVal = areaName.val().trim();
            if (existingAreaName.toLowerCase() === inputVal.toLowerCase()) {
                count++;
            }
        }

		if(count > 1){
			var parent = areaName.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
			parent.addClass(CSS_HAS_ERROR);
			return false;
		}

		return true;
	}

	var validateUniqueTableName = function(allTables, item){

		var inputName = item.find(".name-wrap .input-name");
		var areaName = item.find(".area-wrap .btn").attr("title");
		var areaId;

		item.find(".area-wrap select.input-area-name option").each(function(){
			var item = jQuery(this);
			if(item.text() == areaName){
				areaId = item.val()
			}
		});

		var specificAreaTables = [];
		Object.values(allTables).forEach(function(item) {
			if(item.groupId == areaId){
				specificAreaTables.push(item);
			}
		});

		var count = 0;
		for (var i = 0; i < specificAreaTables.length; i++) {
            var existingTableName = specificAreaTables[i].name.trim();
            var inputVal = inputName.val().trim();
            if (existingTableName.toLowerCase() === inputVal.toLowerCase()) {
                count++;
            }
        }

		if(count > 1){
			var parent = inputName.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
			parent.addClass(CSS_HAS_ERROR);
			return false;
		}

		return true;
	}

	var validateTableNameLimit = function(input){
		var name = input.val() || '';
		if(name.trim().length > 64){
			var parent = input.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
			parent.addClass(CSS_HAS_ERROR);
			return false;
		}

		return true;
	}

	var valiadateEmptyTableName = function(input){
		var parent = input.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
		var name = input.val() || '';
		if(name.trim() === ''){
			parent.addClass(CSS_HAS_ERROR);
			return false;
		}

		return true;
	}

	var getInvalidTableItems = function(tableCard) {
		var invalidItems = [];
		var hasCapacityError = false;
		var zeroCapacityError = false;
		var uniqueTableError = false;
		var tableCharLimitError = false;
		var emptyTableNameError = false;

		// skip if not editing
		if (!tableCard.is(SEL_TABLES_EDITING)) {
			return invalidItems;
		}

		var allTables = getAllTableItems(tableCard);
		
		tableCard.find(SEL_TABLE_EDIT_ITEM).each(function() {
			var item = jQuery(this);

			var valid = true;

			var name = item.find(SEL_TABLE_EDIT_ITEM_NAME);
			if (!valiadateRequiredInput(name)) {
				valid = false;
			}

			if (!valiadateEmptyTableName(name)) {
				valid = false;
				emptyTableNameError = true;
			}

			if(!validateUniqueTableName(allTables, item)){
				valid = false;
				uniqueTableError = true;
			}

			if(!validateTableNameLimit(name)){
				valid = false;
				tableCharLimitError = true;
			}

			// Has capacity error implementation
			var seats = item.find(SEL_TABLE_EDIT_ITEM_SEATS);
			var value = seats.val();
			if(value.trim() !== '' && parseInt(value) > MAX_CAPACITY_LIMIT){
				hasCapacityError = true;
			}
			
			
			if(value.trim() !== '' && parseInt(value) == ZERO_CAPACITY_LIMIT){
				zeroCapacityError = true;
			}
			if (!valiadateRequiredInput(seats)) {
				valid = false;
			}

			var areaName = item.find(SEL_TABLE_EDIT_ITEM_AREA_NAME);
			if (!valiadateRequiredInput(areaName)) {
				valid = false;
			}

			// if ROLE_RES_TBLPRIO exist only in that case will check priority validation otherwise not
			if(window.config.reservableList && window.config.reservableList.hasTablePriorityRole == 'true'){
				var prioritySelect = item.find(SEL_TABLE_EDIT_ITEM_PRIORITY);
				if (!valiadateRequiredInput(prioritySelect)) {
					valid = false;
				}
			}

			if (!valid) {
				invalidItems.push(item);
			}
		});

		return {
			invalidItems: invalidItems,
			hasCapacityError: hasCapacityError,
			zeroCapacityError: zeroCapacityError,
			uniqueTableError: uniqueTableError,
			tableCharLimitError: tableCharLimitError,
			emptyTableNameError: emptyTableNameError
		};
	};

	var getInvalidTablecombItems = function(tablecombCard) {
		var invalidItems = [];
		var hasCapacityError = {
			exceedTotalCapacity: false,
			zeroValue: false,
			minGreaterMax: false,
			minimumTableComb: false
		};

		// skip if not editing
		if (!tablecombCard.is(SEL_TABLECOMB_EDIT_CARD)) {
			return invalidItems;
		}
		
		tablecombCard.find(SEL_TABLECOMB_EDIT_ITEM).each(function() {
			var item = jQuery(this);
			var valid = true;

			// Has minimumcapacity error implementation
			var minguests = item.find(SEL_TABLECOMB_EDIT_ITEM_MINIMUMCAPACITY)
			var minValue = minguests.val();
			if (!valiadateRequiredInput(minguests)) {
				valid = false;
			}

			// Has maximumcapacity error implementation
			var maxguests = item.find(SEL_TABLECOMB_EDIT_ITEM_MAXIMUMCAPACITY)
			var maxValue = maxguests.val();
			if (!valiadateRequiredInput(maxguests)) {
				valid = false;
			}
			
			// when both min guests or max guests capacity are zero
			if(parseInt(minValue) == 0 || parseInt(maxValue) == 0){
				var minParent = minguests.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
				var maxParent = maxguests.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);

				if(parseInt(minValue) == 0){
					minParent.addClass(CSS_HAS_ERROR);
				}
				if(parseInt(maxValue) == 0){
					maxParent.addClass(CSS_HAS_ERROR);
				}

				hasCapacityError.zeroValue = true;
				valid = false;
			}

			var totalCapacity = null;
			item.find(".tbl-combination-dropdown option:selected").each(function(){
				totalCapacity += parseInt(jQuery(this).attr("data-table-capacity"));
			});

			// when min guests or max guests capacity are > total capacity
			if(parseInt(minValue) > totalCapacity || parseInt(maxValue) > totalCapacity){
				var minParent = minguests.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
				var maxParent = maxguests.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);

				if(parseInt(minValue) > totalCapacity){
					minParent.addClass(CSS_HAS_ERROR);
				}
				if(parseInt(maxValue) > totalCapacity){
					maxParent.addClass(CSS_HAS_ERROR);
				}

				hasCapacityError.exceedTotalCapacity = true;
				valid = false;
			}

			// when max guests capacity is less than min guests
			if(parseInt(minValue) > parseInt(maxValue)){
				hasCapacityError.minGreaterMax = true;
				valid = false;
				var minParent = minguests.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
				var maxParent = maxguests.parents(SEL_VALIDATE_REQUIRED).removeClass(CSS_HAS_ERROR);
				minParent.addClass(CSS_HAS_ERROR);
				maxParent.addClass(CSS_HAS_ERROR);
			}

			// table combinations error check
			var reservables = item.find(".tbl-combination-dropdown option:selected");
			if(reservables.length == 0 || reservables.length == 1){
				valid = false;
				hasCapacityError.minimumTableComb = true;
				jQuery(this).find(".select2-selection.select2-selection--multiple").addClass(CSS_HAS_ERROR);
			}else{
				jQuery(this).find(".select2-selection.select2-selection--multiple").removeClass(CSS_HAS_ERROR);
			}

			// priority error check
			// if ROLE_RES_TBLPRIO exist only in that case will check priority validation otherwise not
			if(window.config.reservableList && window.config.reservableList.hasTablePriorityRole == 'true'){
				var prioritySelect = item.find(SEL_TABLECOMB_EDIT_ITEM_PRIORITY);
				if (!valiadateRequiredInput(prioritySelect)) {
					valid = false;
				}
			}

			if (!valid) {
				invalidItems.push(item);
			}
		});

		return {
			invalidItems: invalidItems,
			hasCapacityError: hasCapacityError,
			
		};
	};

	//to update error tracking in adobe datalayer with event info
	var updateDatalayerErrorTracking = function(){
		if (window._satellite && window._adl) {
		  //push eventInfo in _adl
		  _adl.eventInfo = {
			eventName: FORM_EVENT_NAME,
			eventType: FORM_EVENT_TYPE
		  }
	
		  //push all the errors in adobe data layer
		  _adl.error = {
			errorType: FORM_ERROR_TYPE,
			errorMessage: FORM_ERROR_MESSAGE,
			errorFields: FORM_ERROR_FIELD_NAME
		  }
	
		  //fire direct call
		  window._satellite.track('errorCall');
		}
	}

	var initValidation = function(moduleNode, wizardNode) {
		var localConfig = window.config.reservableList || [];
		if(localConfig == ''){
			localConfig = window.config.areaEditWizard || [];
		}

		MAX_CAPACITY_LIMIT = localConfig.tableCapacityLimit ? parseInt(localConfig.tableCapacityLimit) : 20;
		
		var form = moduleNode.find(SEL_FORM);
		var tableModeOn = moduleNode.find(SEL_TABLE_MODE);
		var capacityInputWrap = moduleNode.find(SEL_TABLE_MODE_INPUT_WRAP);
		var areaCard = moduleNode.find(SEL_AREA_EDIT_CARD);
		var tableCard = moduleNode.find(SEL_TABLE_EDIT_CARD);
		var tablecombCard = moduleNode.find(SEL_TABLECOMB_EDIT_CARD);
		var validationAlertModal = moduleNode.find(SEL_MODAL_VALIDATION_ALERT);
		var validationAlertModalWizard = wizardNode.find(SEL_MODAL_VALIDATION_ALERT);
		var buttonContinue = wizardNode.find(SEL_CONTINUE_BUTTON);
		var selectTablesWizard = wizardNode.find(SEL_SELECT_TABLES_ON_WIZARD);
		var tableModeSeatsInputed = moduleNode.find(SEL_TABLE_MODE_SEATS_INPUT);
		var seatConfigurationCard = wizardNode.find(SEL_SEAT_CONFIGURATION_CARD_WIZARD);

		buttonContinue.on('click',function(e){
			// validate only if reservable mode
			if(selectTablesWizard.is(':checked')){
				var areaCard = wizardNode.find(SEL_AREA_EDIT_CARD);
				var tableCard = wizardNode.find(SEL_TABLE_EDIT_CARD);

				var returnAreaValue = getInvalidAreaItems(areaCard);
				var invalidAreaItems = returnAreaValue.invalidItems;
				var hasUniqueAreaError = returnAreaValue.uniqueAreaError;
				//var invalidAreaItems =  getInvalidAreaItems(areaCard);

				var returnValue = getInvalidTableItems(tableCard);
				var invalidTableItems = returnValue.invalidItems;
				var hasCapacityError = returnValue.hasCapacityError;
				var zeroCapacityError = returnValue.zeroCapacityError;
				var uniqueTableError = returnValue.uniqueTableError;
				var tableCharLimitError = returnValue.tableCharLimitError;
				var emptyTableNameError = returnValue.emptyTableNameError;

				var invalidItems = jQuery.merge(invalidAreaItems, invalidTableItems);

				// has at least one invalid item?
				if (invalidItems.length) {

					e.preventDefault();
					e.stopImmediatePropagation();

					var errorMessage = localConfig.msg.validationError;
					if(errorMessage == undefined){
						errorMessage = window.config.areaEditWizard.msg.validationError || [];
					}

					var newMessage = window.config.areaEditWizard.msg.capacityError || "";
					var newZeroMessage = window.config.areaEditWizard.msg.zeroCapacityError || "";

					var emptyTableNameMsg = window.config.areaEditWizard.msg.emptyTableName || "";
					var uniqueTableNameMsg = window.config.areaEditWizard.msg.uniqueTableName || "";
					var maxLengthTableNameMsg = window.config.areaEditWizard.msg.maxLengthTableName || "";

					var uniqueAreaNameMsg = window.config.areaEditWizard.msg.uniqueAreaName || "";

					if(hasUniqueAreaError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + uniqueAreaNameMsg + '</li></ul>';	
					}

					if(hasCapacityError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + newMessage + '</li></ul>';
					}

					if(zeroCapacityError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + newZeroMessage + '</li></ul>';
					}

					if(uniqueTableError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + uniqueTableNameMsg + '</li></ul>';
					}

					if(tableCharLimitError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + maxLengthTableNameMsg + '</li></ul>';
					}

					if(emptyTableNameError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + emptyTableNameMsg + '</li></ul>';
					}

					alertModal.show(validationAlertModalWizard, errorMessage, true).done(function() {
						// scroll to first item
						UserInterfaceUtils.scrollToElementConsiderNavbar(
							invalidItems[0],
							SCROLL_TO_ELEMENT_OFFSET
							);
						});
						
					return false;
				}

				if(totalTablesSeats < 4){
					tableCard.addClass(CSS_NOT_ENOUGH_SEATS);
					return false;
				}
			}
		});

		form.on('submit', function(e) {
			var totalSeatsInTableMode = parseInt(tableModeSeatsInputed.val());
			if (isNaN(totalSeatsInTableMode)) {
				tableModeOn.removeClass(CSS_NOT_ENOUGH_SEATS_TABLE_MODE);
				tableModeOn.addClass(CSS_NOT_VALID_SEATS_INPUT);
				capacityInputWrap.addClass(CSS_HAS_ERROR);
				return false;
			};

			// validate only if reservable mode
			if (moduleNode.hasClass(CSS_TABLE_MODE_ACTIVE)) {
				var invalidItems = [];
				invalidItems = jQuery.merge(invalidItems, getInvalidAreaItems(areaCard));

				var returnAreaValue = getInvalidAreaItems(areaCard);
				var invalidAreaItems = returnAreaValue.invalidItems;
				var hasUniqueAreaError = returnAreaValue.uniqueAreaError;

				var returnValue = getInvalidTableItems(tableCard);
				var invalidTableItems = returnValue.invalidItems;
				var hasCapacityError = returnValue.hasCapacityError;
				var zeroCapacityError = returnValue.zeroCapacityError;
				var uniqueTableError = returnValue.uniqueTableError;
				var tableCharLimitError = returnValue.tableCharLimitError;
				var emptyTableNameError = returnValue.emptyTableNameError;
				
				if(isFeatureToggleEnable){
					var returnTableCombValue = getInvalidTablecombItems(tablecombCard);
					var invalidTablecombItems = returnTableCombValue.invalidItems;
	
					var hasExceedTotalCapacityError = returnTableCombValue.hasCapacityError.exceedTotalCapacity;
					var hasZeroValueError = returnTableCombValue.hasCapacityError.zeroValue;
					var hasMinGreaterMaxError  = returnTableCombValue.hasCapacityError.minGreaterMax;
					var hasMinimumTableCombError = returnTableCombValue.hasCapacityError.minimumTableComb;

					invalidItems = jQuery.merge(invalidItems, invalidAreaItems);
					invalidItems = jQuery.merge(invalidItems, invalidTableItems);
					invalidItems = jQuery.merge(invalidItems, invalidTablecombItems);
				}

				invalidItems = jQuery.merge(invalidItems, invalidAreaItems);
				invalidItems = jQuery.merge(invalidItems, invalidTableItems);

				// has at least one invalid item?
				if (invalidItems.length) {

					e.preventDefault();
					e.stopImmediatePropagation();

					var errorMessage = localConfig.msg.validationError;

					var newMessage = localConfig.msg.capacityError || "";
					var newZeroMessage = localConfig.msg.zeroCapacityError || "";

					var emptyTableNameMsg = window.config.reservableList.msg.emptyTableName || "";
					var uniqueTableNameMsg = window.config.reservableList.msg.uniqueTableName || "";
					var maxLengthTableNameMsg = window.config.reservableList.msg.maxLengthTableName || "";

					var uniqueAreaNameMsg = window.config.reservableList.msg.uniqueAreaName || "";

					if(hasUniqueAreaError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + uniqueAreaNameMsg + '</li></ul>';	
					}

					if(hasCapacityError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + newMessage + '</li></ul>';
					}
					if(zeroCapacityError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + newZeroMessage + '</li></ul>';
					}

					if(uniqueTableError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + uniqueTableNameMsg +'</li></ul>';
					}

					if(tableCharLimitError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + maxLengthTableNameMsg + '</li></ul>';
					}

					if(emptyTableNameError){
						errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + emptyTableNameMsg +'</li></ul>';
					}
					
					if(isFeatureToggleEnable){
						var minMaxCapacityMessage = window.config.reservableList.msg.minMaxCapacityExceeded;
						var minGreaterMaxMessage = window.config.reservableList.msg.minGreaterMaxCapacity;
						var minMaxZeroMessage  = window.config.reservableList.msg.minMaxZeroCapacity;
						var minTableCombMessage  = window.config.reservableList.msg.minTableCombination;
						
						//if any error comes in tc after changing the table capacity, edit mode should enable in table combination
						var section = moduleNode.find(SEL_SUMMARY_EDITING_SECTION_TABLECOMB);
						var isEditMode = section.hasClass(CSS_SUMMARY_SECTION_EDITING);
						if(!isEditMode){
							section.find(SEL_SUMMARY_EDITING_SECTION_TOGGLE).trigger( "click" );
						}

						if(hasExceedTotalCapacityError){
							errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + minMaxCapacityMessage + '</li></ul>';
						} if(hasZeroValueError || hasMinGreaterMaxError){
							if((hasZeroValueError && hasMinGreaterMaxError) || hasZeroValueError){
								errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + minMaxZeroMessage + '</li></ul>';
							}
							else if(hasMinGreaterMaxError){
								errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + minGreaterMaxMessage + '</li></ul>';
							}
						} if(hasMinimumTableCombError){
							errorMessage = errorMessage + '<ul class="multi-error-list"><li>' + minTableCombMessage + '</li></ul>';
						}
					}

					alertModal.show(validationAlertModal, errorMessage, true).done(function() {
						// scroll to first item
						UserInterfaceUtils.scrollToElementConsiderNavbar(
							invalidItems[0],
							SCROLL_TO_ELEMENT_OFFSET
						);
					});

					if(errorMessage !== ""){
						updateDatalayerErrorTracking();
					}

					return false;
				}

				// if all areas are deactivated (then number of seats would be 0), will display the warning/error message
				if(totalTablesSeats == 0){
					var errorMessage = localConfig.msg.validationError;
					var allAreasDeactivationError = window.config.reservableList.msg.deactivateAllAreas || "";
					errorMessage += ' ' + allAreasDeactivationError;
					alertModal.show(validationAlertModal, errorMessage, true).done(function() {
						// scroll to first item
						UserInterfaceUtils.scrollToElementConsiderNavbar(
							moduleNode,
							SCROLL_TO_ELEMENT_OFFSET
						);
					});
					return false;
				}

				if(totalTablesSeats < 4){
					tableCard.addClass(CSS_NOT_ENOUGH_SEATS);
					UserInterfaceUtils.scrollToElementConsiderNavbar(
						tableCard,
						SCROLL_TO_ELEMENT_OFFSET
					);
					return false;
				}

				}else {
					if (totalSeatsInTableMode < 4) {
						tableModeOn.removeClass(CSS_NOT_VALID_SEATS_INPUT);
						capacityInputWrap.removeClass(CSS_HAS_ERROR);
						tableModeOn.addClass(CSS_NOT_ENOUGH_SEATS_TABLE_MODE);
						return false;
					}
				}
		});
	};

	var initTableSummary = function(moduleNode) {

		var summaryCard = moduleNode.find(SEL_TABLE_SUMMARY_CARD);
		var totalSeats = summaryCard.find(SEL_TABLE_SUMMARY_CARD_TOTAL_SEATS);

		var statusLabelPaused = summaryCard.attr(ATTR_DATA_STATUS_PAUSED);

		if(isBlockedTableFeatureToggle){
			var statusLabelBlocked = summaryCard.attr(ATTR_DATA_STATUS_BLOCKED);
		}

		var statusLabelActive = summaryCard.attr(ATTR_DATA_STATUS_ACTIVE);

		var refreshTotalSeats = function() {
			var total = 0;
			summaryCard.find(SEL_TABLE_SUMMARY_CARD_ITEM).each(function() {
				var item = jQuery(this);
				var seats = parseInt(item.attr(ATTR_DATA_SEATS) || 0);
				var tableActive = item.attr(ATTR_DATA_PAUSED);
				if(tableActive == 'false'){
					if (!isNaN(seats) && seats > 0) {
						total += seats;
					}
				}
			});
			var label = '(' + total + ')';
			totalSeats.text(label);
		};

		var refreshAreaInfo = function(areasItems) {
			summaryCard.find(SEL_TABLE_SUMMARY_CARD_ITEM).each(function() {
				var item = jQuery(this);
				var areaItem = areasItems && areasItems[(item.attr(ATTR_DATA_GROUP) || '')] || null;
				if (areaItem) {
					var areaName = areaItem.name || '';
					if (areaName !== '') {
						item.find(SEL_TABLE_SUMMARY_CARD_ITEM_AREA_NAME).text(areaName);
					}
					var tablePaused = item.attr(ATTR_DATA_PAUSED) === PAUSED_TRUE;
					tablePaused = isTablePaused(areaItem, false);
					item.find(SEL_TABLE_SUMMARY_CARD_ITEM_STATUS).text(tablePaused ? statusLabelPaused : statusLabelActive);

					if(isBlockedTableFeatureToggle){
						var tableBlocked = item.attr(ATTR_DATA_BLOCKED) === PAUSED_TRUE;
						tableBlocked = isTablePaused(areaItem, false);
						item.find(SEL_TABLE_SUMMARY_CARD_BLOCKED_TABLE_STATUS).text(tableBlocked ? statusLabelBlocked : statusLabelActive);
					}
				}
			});
		};

		// listen to any area name changes
		moduleNode.on(EVENT_AREA_CHANGED, function(e, allAreaItems) {
			refreshAreaInfo(allAreaItems);
		});

		// refresh totals
		refreshTotalSeats();
	};

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;
		
		// Retrieve and cache dom nodes
		var moduleNodes 					= initNode.find(SEL_MODULE);
		var wizardNode						= initNode.find(SEL_WIZARD_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {
			
			var moduleNode 			= jQuery(this);

			var showTableSetupModal = window.config.reservableList ? window.config.reservableList.showTablePlanPopUp ? window.config.reservableList.showTablePlanPopUp: "" : "";
			
			showTablePlanPopoup(moduleNode, showTableSetupModal);

			initTableModeToggle(moduleNode);
			
			initSummaryEditingSections(moduleNode);
			
			initAreaEditing(moduleNode);

			initTableEditing(moduleNode);
			
			initTableSummary(moduleNode);
			
			initValidation(moduleNode, wizardNode);			
			
			if(isFeatureToggleEnable){
				initTablecombEditing(moduleNode);
				initMultiSelect(moduleNode);
			}
		});
	};

	// for autosuggestion multi-select functionality
	var initMultiSelect = function(moduleNode){

		moduleNode.find('.tbl-combination-dropdown').select2({
			allowClear: true,
			minimumResultsForSearch: -1,
			placeholder: window.config.reservableList.msg.tableGroupNamePlaceholder
		});

		// event if any selection happens
		moduleNode.find(".tbl-combination-dropdown").on("select2:select", function(evt) {
			
			var selectedGroupId = parseInt(jQuery(this).find("option:selected").attr("data-table-area-id"));
			
			if(jQuery(this).find("option:selected").length == 1){
				jQuery(this).find("option").each(function(){
					
					if(selectedGroupId != jQuery(this).attr("data-table-area-id")){
						jQuery(this).remove();
					}
				});
			}			
		});

		// event if deselection happens for any selection
		moduleNode.find(".tbl-combination-dropdown").on("select2:unselecting", function(evt) {

			if(jQuery(this).find("option:selected").length == 1){
				
				var recentItemsAreaId = parseInt(jQuery(this).find("option").attr("data-table-area-id"));
				var tableCombOptions;

				var oldItems = window.config.reservableList.reservables.filter(function(op) {
					return (op.groupId == recentItemsAreaId)
				});

				var newItems = window.config.reservableList.reservables.filter(function(op) {
					return (op.groupId !== recentItemsAreaId)
				});

				allItems = oldItems.concat(newItems);

				for (var i = 0; i < allItems.length; i++) {
					tableCombOptions += '<option data-table-id="'+ allItems[i].id +'" value="' + allItems[i].name + '" value="' + allItems[i].id + '" data-table-area-id="' + allItems[i].groupId + '" data-table-priority="' + allItems[i].priority + '" data-table-capacity="' + allItems[i].capacity + '">' + allItems[i].name + '</option>';
				}
				
				jQuery(this).empty().append(tableCombOptions);
			}

			if(jQuery(this).find("option:selected").length == 0){
				var item = jQuery(this).closest('.tablecomb-list-item');
				updateAllTablesOnAddButton(moduleNode, item);
			}
		});
		
	}
};

// Make class public to outside world
module.exports = TableSetupAlternative;
},{"../../form/FormInputFilter":86,"../../modals/Alert":110,"../../modals/Confirm":111,"../../utils/Tracking":188,"../../utils/UserInterfaceUtils":189,"jquery/dist/jquery":14}],172:[function(require,module,exports){
/**
 * AreasData functionality.
 *
 */

// Class definition
var AreasData = function(id, name) {
	this.id = id;
	this.name = name;
};

// Make class public to outside world
module.exports = AreasData;

},{}],173:[function(require,module,exports){
/**
 * AreasForm functionality.
*
*/


// External libs
jQuery = require('jquery/dist/jquery');
var ClassUtils              = require('../../utils/ClassUtils');
var AbstractForm            = require('../../itemEditor/AbstractForm');
var AreasData               = require('./AreasData');

var SEL_FORM_INPUT_ID               = '.hidden-input-id';
var SEL_FORM_INPUT_NAME             = '.form-group-field-areaName input[type="text"]';

// Class definition
var AreasForm = ClassUtils.extendClass(AbstractForm, function() {

  var self = this;

  /**
   * @override
   */
  this.getDataObjectFromValues = function() {
    var formNode = this.getNode();
    var id = formNode.find(SEL_FORM_INPUT_ID).val();
    var name = formNode.find(SEL_FORM_INPUT_NAME).val();
    return new AreasData(id, name);
  };

  /**
   * @override
   */
  this.setValues = function(row, dataObjectExtractor) {
    var formNode = this.getNode();
    var data = dataObjectExtractor(row);

    formNode.find(SEL_FORM_INPUT_ID).val(data.id || '');
    formNode.find(SEL_FORM_INPUT_NAME).val(data.name || '');

    this.markAsEditing();
    this.clearValidationErrors();
    this.rememberCurrentRow(row);
  }

  /**
   * @override
   */
  this.clear = function() {
    var formNode = this.getNode();

    formNode.find(SEL_FORM_INPUT_ID).val('');
    formNode.find(SEL_FORM_INPUT_NAME).val('');

    this.markAsNotEditing();
    this.clearValidationErrors();
    this.forgetCurrentRow();
  };

  /**
   * @override
   */
  this.validate = function() {
    var errors = [];
    var formNode = this.getNode();

    var name = formNode.find(SEL_FORM_INPUT_NAME);

    if (name.val().trim() === '') {
      errors.push(name);
    }

    this.markFieldsWithErrors(errors);

    return !errors.length;
  };

  /**
   * @override
   */
  this.focusOnFirstInput = function() {
    var formNode = this.getNode();
    var firstInput = formNode.find(SEL_FORM_INPUT_NAME);
    firstInput.focus();
  };

});

// Make class public to outside world
module.exports = AreasForm;

},{"../../itemEditor/AbstractForm":96,"../../utils/ClassUtils":184,"./AreasData":172,"jquery/dist/jquery":14}],174:[function(require,module,exports){
/**
 * AreasList functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var ClassUtils              = require('../../utils/ClassUtils');
var AbstractList            = require('../../itemEditor/AbstractList');
var AreasData               = require('./AreasData');

var SEL_LIST_INPUT_ID               = '.hidden-input-id';
var SEL_LIST_INPUT_NAME             = '.hidden-input-name';
var SEL_LIST_INPUT_PAUSED           = '.hidden-input-paused';

var SEL_LIST_TEXT_NAME              = 'td.name .text';

var SEL_LIST_BTN_DELETE             = '.itemEditor-itemList-rowAction-delete';

var SEL_LIST_BTN_PAUSE              = '.actionPause';
var SEL_LIST_BTN_UNPAUSE            = '.actionUnpause';

var ATTR_DATA_PATH                          = 'data-path';
var ATTR_DATA_TITLE_PAUSE_DISABLED_LAST     = 'data-title-disabled-last';
var ATTR_DATA_TITLE_PAUSE_ENABLED           = 'data-title-enabled';
var ATTR_DATA_TITLE_DELETE_DISABLED_LAST    = 'data-title-disabled-last';
var ATTR_DATA_TITLE_DELETE_DISABLED_IN_USE  = 'data-title-disabled-in-use';
var ATTR_DATA_TITLE_DELETE_ENABLED          = 'data-title-enabled';

var RGX_ROW_INDEX_REPLACEMENT       = /%%ROW_INDEX%%/;

var CSS_CLASS_PAUSED                = 'area-paused';
var VALUE_PAUSED                    = 'true';
var VALUE_UNPAUSED                  = 'false';

var updateDeleteButtonStatus = function(button, isAreaNotPaused, isAreaInUse, hasOnlyOneActiveTable) {
  var disabled, titleDataAttr;
  if (isAreaInUse) {
    disabled = true;
    titleDataAttr = ATTR_DATA_TITLE_DELETE_DISABLED_IN_USE;
  } else if (isAreaNotPaused && hasOnlyOneActiveTable) {
    disabled = true;
    titleDataAttr = ATTR_DATA_TITLE_DELETE_DISABLED_LAST;
  } else {
    disabled = false;
    titleDataAttr = ATTR_DATA_TITLE_DELETE_ENABLED;
  }
  var title = button.attr(titleDataAttr);
  button.prop('disabled', disabled).attr('title', title);
};

var updatePauseButtonStatus = function(button, disabled) {
  var title = button.attr(disabled ? ATTR_DATA_TITLE_PAUSE_DISABLED_LAST : ATTR_DATA_TITLE_PAUSE_ENABLED);
  button.prop('disabled', disabled).attr('title', title);
};

// Class definition
var AreasList = ClassUtils.extendClass(AbstractList, function() {

  var self = this;

  var newItemCount = 0;

  var getNewItemId = function() {
    newItemCount++;
    return -newItemCount; // return negative value
  };

  /**
   * @override
   */
  this.init = function() {
    this._parent.init();

    var listNode = this.getNode();

    listNode.on('click', SEL_LIST_BTN_PAUSE, function() {
      var row = self.getRowFromActionButton(jQuery(this));
      self.pauseRow(row);
      var areaChanges = [ self.getRowId(row) ];
      self.refresh(areaChanges);
    });
    listNode.on('click', SEL_LIST_BTN_UNPAUSE, function() {
      var row = self.getRowFromActionButton(jQuery(this));
      self.unpauseRow(row);
      var areaChanges = [ self.getRowId(row) ];
      self.refresh(areaChanges);
    });
  };

  /**
   * @override
   */
  this.updateRow = function(row, dataObject) {
    var id = dataObject.id;
    if (!id) {
      id = getNewItemId();
    }
    row.find(SEL_LIST_INPUT_ID).val(id);
    row.find(SEL_LIST_INPUT_NAME).val(dataObject.name || '');
    row.find(SEL_LIST_TEXT_NAME).text(dataObject.name || '');
  };

  /**
   * @override
   */
  this.buildDataObjectFromRow = function(row) {
    var id = row.find(SEL_LIST_INPUT_ID).val();
    var name = row.find(SEL_LIST_INPUT_NAME).val();
    return new AreasData(id, name);
  };

  /**
   * @override
   * Creates the input name with proper indexes
   * @param {element} inputNode The input element
   * @returns {int} index Row index
   */
  this.generateInputName = function(inputNode, index) {
    var path = inputNode.attr(ATTR_DATA_PATH) || '';
    return path.replace(RGX_ROW_INDEX_REPLACEMENT, index);
  };

  /**
   * @override
   */
  this.getRowValueItems = function(row) {
    return [
      row.find(SEL_LIST_INPUT_ID),
      row.find(SEL_LIST_INPUT_NAME)
    ];
  };

  /**
   * Go through the areas list and update any statuses
   */
  this.updateAreasInUse = function(areasInUse) {
    var rows = this.getAllRows();
    var unpausedAreas = self.getUnpausedAreas(rows);
    var hasOnlyOneActiveTable = unpausedAreas.length === 1;
    rows.each(function() {
      var row = jQuery(this);
      var id = self.getRowId(row);

      var isAreaInUse = areasInUse.length && (areasInUse.indexOf(id) >= 0);
      var isAreaNotPaused = unpausedAreas.length && (unpausedAreas.indexOf(id) >= 0);

      var deleteButton = row.find(SEL_LIST_BTN_DELETE);
      updateDeleteButtonStatus(deleteButton, isAreaNotPaused, isAreaInUse, hasOnlyOneActiveTable);
      var pauseButton = row.find(SEL_LIST_BTN_PAUSE);
      updatePauseButtonStatus(pauseButton, hasOnlyOneActiveTable);
    });
  };

  /**
   * Get key/value pairs of area id/name
   */
  this.getAreasData = function() {
    var rows = this.getAllRows();
    var areas = {};
    rows.each(function() {
      var row = jQuery(this);
      var id = self.getRowId(row);
      var name = row.find(SEL_LIST_INPUT_NAME).val();
      var paused = self.isRowPaused(row);
      areas[id] = {
        name: name,
        paused: paused
      };
    });
    return areas;
  };

  this.pauseRow = function(row) {
    row.find(SEL_LIST_INPUT_PAUSED).val(VALUE_PAUSED);
    row.addClass(CSS_CLASS_PAUSED);
  };

  this.unpauseRow = function(row) {
    row.find(SEL_LIST_INPUT_PAUSED).val(VALUE_UNPAUSED);
    row.removeClass(CSS_CLASS_PAUSED);
  };

  this.isRowPaused = function(row) {
    return row.hasClass(CSS_CLASS_PAUSED);
  };

  this.getRowId = function(row) {
    return String(row.find(SEL_LIST_INPUT_ID).val()); // convert to string
  };

  this.getUnpausedAreas = function(rows) {
    var unpausedAreas = [];
    rows.each(function() {
      var row = jQuery(this);
      if (!self.isRowPaused(row)) {
        unpausedAreas.push(self.getRowId(row));
      }
    });
    return unpausedAreas;
  };

});

// Make class public to outside world
module.exports = AreasList;

},{"../../itemEditor/AbstractList":98,"../../utils/ClassUtils":184,"./AreasData":172,"jquery/dist/jquery":14}],175:[function(require,module,exports){
/**
 * TableSetup functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

var ScrollHelper = require('../../itemEditor/ScrollHelper');
var Confirm   = require('../../modals/Confirm');
var Alert     = require('../../modals/Alert');
var AreasForm = require('./AreasForm');
var AreasList = require('./AreasList');

// Class definition
var AreasSetup = function() {

  // selector constants
  var SEL_MODULE                      = '.mod-areas-setup';

  var SEL_TEMPLATE_ROW                = '.areasSetupRowTemplate';

  var SEL_FORM                        = '.areasSetup-addEditForm';
  var SEL_LIST                        = '.areasSetup-areasList';
  var SEL_TABLES_LIST                 = '.tableSetup-tablesList';

  var SEL_DELETE_CONFIRM_MODAL        = '.areasSetup-deleteConfirmModal';
  var SEL_ERROR_ALERT_MODAL           = '.areasSetup-alertModal';

  var confirmModal = new Confirm();
  var alertModal = new Alert();

  var handleFormButtonAddClick = function(areasList, tablesForm, modal) {
    var onSuccess = function() {
      var dataObject = tablesForm.getDataObjectFromValues();
      var newRow = areasList.addRow(dataObject);
      var areaChanges = [ areasList.getRowId(newRow) ];
      areasList.refresh(areaChanges);
      tablesForm.clear();
      ScrollHelper.scrollToElement(areasList.getNode());
    };
    var onFail = function(errorMessage) {
      alertModal.show(modal, errorMessage);
    };
    tablesForm.validateAndProcess(onSuccess, onFail);
  };

  var handleFormButtonCancelClick = function(areasList, tablesForm) {
    areasList.markAllRowsAsNotEditing();
    tablesForm.clear();
  };

  var handleFormButtonSaveClick = function(areasList, tablesForm, modal) {
    var onSuccess = function() {
      var currentRow = tablesForm.getCurrentEditingRow();
      if (currentRow) {
        var dataObject = tablesForm.getDataObjectFromValues();
        areasList.updateRow(currentRow, dataObject);
        ScrollHelper.scrollToElement(currentRow);
      }
      var areaChanges = [ areasList.getRowId(currentRow) ];
      areasList.refresh(areaChanges);
      tablesForm.clear();
    };
    var onFail = function(errorMessage) {
      alertModal.show(modal, errorMessage);
    };
    tablesForm.validateAndProcess(onSuccess, onFail);
  };

  var handleListButtonEditClick = function(row, areasList, tablesForm) {
    areasList.markAllRowsAsNotEditing();
    areasList.editRow(row, tablesForm);
    ScrollHelper.scrollToElement(tablesForm.getNode());
  };

  var handleListButtonDeleteClick = function(row, areasList, tablesForm, modal) {
    var confirmMessage = areasList.getDeleteConfirmMessage();
    confirmModal.show(modal, confirmMessage).done(function() {
      areasList.deleteRow(row);
      tablesForm.clear();
      var areaChanges = [ areasList.getRowId(row) ];
      areasList.refresh(areaChanges);
    });
  };

  var handleListButtonCopyClick = function(row, areasList, tablesForm) {
    var dataObject = areasList.buildDataObjectFromRow(row);
    // remove id from data object
    delete dataObject.id;

    // add to list
    var newRow = areasList.addRow(dataObject);
    var areaChanges = [ areasList.getRowId(newRow) ];
    areasList.refresh(areaChanges);
    areasList.editRow(newRow, tablesForm);
    ScrollHelper.scrollToElement(tablesForm.getNode());
  };

  var handleTablesListRefreshed = function(areasList, tablesList, cache) {
    var areasInUse = tablesList.getInUseAreas();
    cache.areasInUse = areasInUse; // update cache
    areasList.updateAreasInUse(areasInUse);
    var areaChanges = [];
    areasList.refresh(areaChanges);
  };

  var handleAreasListRefreshed = function(areasList, cache) {
    areasList.updateAreasInUse(cache.areasInUse || []);
  };

  /**
   * Initialize.
   */
  this.init = function(initNode, tablesNodes) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var cacheObject = {};

      var listRowTemplate = moduleNode.find(SEL_TEMPLATE_ROW).remove();

      var formNode = moduleNode.find(SEL_FORM);
      var areasListNode = moduleNode.find(SEL_LIST);

      var addEditForm = new AreasForm(formNode);
      var areasList = new AreasList(areasListNode, listRowTemplate);

      var deleteConfirmModal = moduleNode.find(SEL_DELETE_CONFIRM_MODAL);
      var errorAlertModal = moduleNode.find(SEL_ERROR_ALERT_MODAL);

      // form events
      formNode.on('itemEditor:editForm:create', function(event) {
        handleFormButtonAddClick(areasList, addEditForm, errorAlertModal);
      });
      formNode.on('itemEditor:editForm:cancel', function(event) {
        handleFormButtonCancelClick(areasList, addEditForm);
      });
      formNode.on('itemEditor:editForm:save', function(event) {
        handleFormButtonSaveClick(areasList, addEditForm, errorAlertModal);
      });

      // list events
      areasListNode.on('itemEditor:itemsList:rowEdit', function(event, row) {
        handleListButtonEditClick(row, areasList, addEditForm);
      });
      areasListNode.on('itemEditor:itemsList:rowDelete', function(event, row) {
        handleListButtonDeleteClick(row, areasList, addEditForm, deleteConfirmModal);
      });
      areasListNode.on('itemEditor:itemsList:rowCopy', function(event, row) {
        handleListButtonCopyClick(row, areasList, addEditForm);
      });
      areasListNode.on('itemEditor:itemsList:listRefreshed', function(event, areasList) {
        handleAreasListRefreshed(areasList, cacheObject);
      });

      // on tables change event
      tablesNodes.on('itemEditor:itemsList:listRefreshed', SEL_TABLES_LIST, function(event, tablesList) {
        handleTablesListRefreshed(areasList, tablesList, cacheObject);
      });

      // init
      addEditForm.init();
      areasList.init();

    });

  };

  // get the module nodes
  this.getModules = function(initNode) {
    return initNode.find(SEL_MODULE);
  };

  // refresh the module
  this.refresh = function(initNode) {

    var moduleNodes = initNode.find(SEL_MODULE);

    moduleNodes.each(function() {
      var areasList = jQuery(this).find(SEL_LIST);
      areasList.trigger('itemEditor:itemsList:forceRefresh');
    });

  };

};

// Make class public to outside world
module.exports = AreasSetup;

},{"../../itemEditor/ScrollHelper":99,"../../modals/Alert":110,"../../modals/Confirm":111,"./AreasForm":173,"./AreasList":174,"jquery/dist/jquery":14}],176:[function(require,module,exports){


/**
 * TableSetup functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
var Areas                       = require('./areas');
var Tables                      = require('./tables');
var TableSetupAlternative       = require('./alternative/TableSetupAlternative');
var CapacitySimpleMode          = require('./alternative/CapacitySimpleMode');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var areas                     = new Areas();
  var tables                    = new Tables();
  var tableSetupAlternative     = new TableSetupAlternative();
  var capacitySimpleMode        = new CapacitySimpleMode();

  var areasNodes = areas.getModules(initNode);
  var tablesNodes = tables.getModules(initNode);

  // Trigger onload activities
  areas.init(initNode, tablesNodes);
  tables.init(initNode, areasNodes);

  // alternative
  tableSetupAlternative.init(initNode);
  capacitySimpleMode.init(initNode);

  // force refresh once both are intialised
  areas.refresh(initNode);
  tables.refresh(initNode);

});

},{"../mediator/mediator":103,"./alternative/CapacitySimpleMode":170,"./alternative/TableSetupAlternative":171,"./areas":175,"./tables":180}],177:[function(require,module,exports){
/**
 * TableData functionality.
 *
 */

// Class definition
var TableData = function(id, name, capacity, groupId, groupName) {
  this.id = id;
  this.name = name;
  this.capacity = capacity;
  this.groupId = groupId;
  this.groupName = groupName;
};

// Make class public to outside world
module.exports = TableData;

},{}],178:[function(require,module,exports){
/**
 * TablesForm functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var FormInputFilter       = require('../../form/FormInputFilter');
var ClassUtils            = require('../../utils/ClassUtils');
var AbstractForm          = require('../../itemEditor/AbstractForm');
var TableData             = require('./TableData');

var SEL_FORM_INPUT_ID               = '.hidden-input-id';
var SEL_FORM_INPUT_NAME             = '.form-group-field-tableName input[type="text"]';
var SEL_FORM_INPUT_CAPACITY         = '.form-group-field-tableCapacity input[type="text"]';
var SEL_FORM_INPUT_AREA             = '.form-group-field-tableGroup select';

var FILTER_POSITIVE_INTEGERS_ONLY  = function(value) {
  return value === '' || /^\d*$/.test(value);
};

var addSelectOption = function(select, value, label) {
  return jQuery('<option />')
    .attr('value', value)
    .text(label)
    .appendTo(select);
};

var addDefaultSelectOption = function(select) {
  var defaultText = select.attr('title');
  var option = addSelectOption(select, '', defaultText);
  option.attr('disabled', 'disabled');
};

// Class definition
var TablesForm = ClassUtils.extendClass(AbstractForm, function() {

  var self = this;

  var inputFilter = new FormInputFilter();

  this._cachedAreas = {};

  /**
   * @override
   */
  this.init = function() {

    this._parent.init(); // call super class init

    var formNode = this.getNode();
    inputFilter.init(formNode.find(SEL_FORM_INPUT_CAPACITY), FILTER_POSITIVE_INTEGERS_ONLY);

    // initialise selectpicker
    var areaSelect = formNode.find(SEL_FORM_INPUT_AREA);
    addDefaultSelectOption(areaSelect);
    areaSelect.selectpicker();

  };

  /**
   * @override
   */
  this.getDataObjectFromValues = function() {
    var formNode = this.getNode();
    var id = formNode.find(SEL_FORM_INPUT_ID).val();
    var name = formNode.find(SEL_FORM_INPUT_NAME).val();
    var capacity = formNode.find(SEL_FORM_INPUT_CAPACITY).val();

    var areaSelect = formNode.find(SEL_FORM_INPUT_AREA);
    var groupId = areaSelect.selectpicker('val');
    var groupName = this.getAreaNameFromId(groupId);

    return new TableData(id, name, capacity, groupId, groupName);
  };

  /**
   * @override
   */
  this.setValues = function(row, dataObjectExtractor) {
    var formNode = this.getNode();
    var data = dataObjectExtractor(row);

    formNode.find(SEL_FORM_INPUT_ID).val(data.id || '');
    formNode.find(SEL_FORM_INPUT_NAME).val(data.name || '');

    formNode.find(SEL_FORM_INPUT_AREA).selectpicker('val', data.groupId || '');

    var capacityInput = formNode.find(SEL_FORM_INPUT_CAPACITY).val(data.capacity || '');
    inputFilter.clearPreviousValues(capacityInput);

    this.markAsEditing();
    this.clearValidationErrors();
    this.rememberCurrentRow(row);
  }

  /**
   * @override
   */
  this.clear = function() {
    var formNode = this.getNode();

    formNode.find(SEL_FORM_INPUT_ID).val('');
    formNode.find(SEL_FORM_INPUT_NAME).val('');

    formNode.find(SEL_FORM_INPUT_AREA).selectpicker('val', '');

    var capacityInput = formNode.find(SEL_FORM_INPUT_CAPACITY).val('');
    inputFilter.clearPreviousValues(capacityInput);

    this.markAsNotEditing();
    this.clearValidationErrors();
    this.forgetCurrentRow();
  };

  /**
   * @override
   */
  this.validate = function() {
    var errors = [];
    var formNode = this.getNode();

    var name = formNode.find(SEL_FORM_INPUT_NAME);
    var capacity = formNode.find(SEL_FORM_INPUT_CAPACITY);
    var area = formNode.find(SEL_FORM_INPUT_AREA);

    if (name.val().trim() === '') {
      errors.push(name);
    }
    if (capacity.val().trim() === '') {
      errors.push(capacity);
    }
    var selectedArea = area.selectpicker('val') || '';
    if (selectedArea.trim() === '') {
      errors.push(area);
    }

    this.markFieldsWithErrors(errors);

    return !errors.length;
  };

  /**
   * @override
   */
  this.focusOnFirstInput = function() {
    var formNode = this.getNode();
    var firstInput = formNode.find(SEL_FORM_INPUT_NAME);
    firstInput.focus();
  };

  /**
   * Update the list of areas in the drop down
   */
  this.updateAvailableAreas = function(areas, areaChanges) {
    this._cachedAreas = areas;
    var formNode = this.getNode();
    var areaSelect = formNode.find(SEL_FORM_INPUT_AREA);
    var currentValue = areaSelect.selectpicker('val');

    areaSelect.empty();
    addDefaultSelectOption(areaSelect);
    for (var id in areas) {
      addSelectOption(areaSelect, id, areas[id].name);
    }
    areaSelect.selectpicker('refresh');

    // replace the previous value
    areaSelect.selectpicker('val', currentValue);
  };

  this.getAreaNameFromId = function(areaId) {
    var area = this._cachedAreas[areaId] || {};
    return area.name || '';
  };

});

// Make class public to outside world
module.exports = TablesForm;

},{"../../form/FormInputFilter":86,"../../itemEditor/AbstractForm":96,"../../utils/ClassUtils":184,"./TableData":177,"jquery/dist/jquery":14}],179:[function(require,module,exports){
/**
 * TablesList functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');
var ClassUtils              = require('../../utils/ClassUtils');
var AbstractList            = require('../../itemEditor/AbstractList');
var TableData               = require('./TableData');

var SEL_LIST_INPUT_ID               = '.hidden-input-id';
var SEL_LIST_INPUT_NAME             = '.hidden-input-name';
var SEL_LIST_INPUT_CAPACITY         = '.hidden-input-capacity';
var SEL_LIST_INPUT_GROUP            = '.hidden-input-group';
var SEL_LIST_INPUT_PAUSED           = '.hidden-input-paused';

var SEL_LIST_TEXT_NAME              = 'td.name .text';
var SEL_LIST_TEXT_CAPACITY          = 'td.capacity';
var SEL_LIST_TEXT_GROUP             = 'td.groupName';

var SEL_LIST_BTN_PAUSE              = '.actionPause';
var SEL_LIST_BTN_UNPAUSE            = '.actionUnpause';

var ATTR_DATA_PATH                  = 'data-path';

var RGX_ROW_INDEX_REPLACEMENT       = /%%ROW_INDEX%%/;

var DEFAULT_ID_FOR_NEW_ROW          = 0;

var CSS_CLASS_PAUSED                = 'table-paused';
var VALUE_PAUSED                    = 'true';
var VALUE_UNPAUSED                  = 'false';


// Class definition
var TablesList = ClassUtils.extendClass(AbstractList, function() {

  var self = this;

  /**
   * @override
   */
  this.init = function() {
    this._parent.init();

    var listNode = this.getNode();

    listNode.on('click', SEL_LIST_BTN_PAUSE, function() {
      var row = self.getRowFromActionButton(jQuery(this));
      self.pauseRow(row);
      self.refresh();
    });
    listNode.on('click', SEL_LIST_BTN_UNPAUSE, function() {
      var row = self.getRowFromActionButton(jQuery(this));
      self.unpauseRow(row);
      self.refresh();
    });
  };

  /**
   * @override
   */
  this.updateRow = function(row, dataObject) {
    row.find(SEL_LIST_INPUT_ID).val(dataObject.id || DEFAULT_ID_FOR_NEW_ROW);
    row.find(SEL_LIST_INPUT_NAME).val(dataObject.name || '');
    row.find(SEL_LIST_INPUT_CAPACITY).val(dataObject.capacity || '');
    row.find(SEL_LIST_INPUT_GROUP).val(dataObject.groupId || '');

    row.find(SEL_LIST_TEXT_NAME).text(dataObject.name || '');
    row.find(SEL_LIST_TEXT_CAPACITY).text(dataObject.capacity || '');
    row.find(SEL_LIST_TEXT_GROUP).text(dataObject.groupName || '');
  };

  /**
   * @override
   */
  this.buildDataObjectFromRow = function(row) {
    var id = row.find(SEL_LIST_INPUT_ID).val();
    var name = row.find(SEL_LIST_INPUT_NAME).val();
    var capacity = row.find(SEL_LIST_INPUT_CAPACITY).val();
    var groupId = row.find(SEL_LIST_INPUT_GROUP).val();
    var groupName = row.find(SEL_LIST_TEXT_GROUP).text();
    return new TableData(id, name, capacity, groupId, groupName);
  };

  /**
   * @override
   */
  this.generateInputName = function(inputNode, index) {
    var path = inputNode.attr(ATTR_DATA_PATH) || '';
    return path.replace(RGX_ROW_INDEX_REPLACEMENT, index);
  };

  /**
   * @override
   */
  this.getRowValueItems = function(row) {
    return [
      row.find(SEL_LIST_INPUT_ID),
      row.find(SEL_LIST_INPUT_NAME),
      row.find(SEL_LIST_INPUT_CAPACITY),
      row.find(SEL_LIST_INPUT_GROUP),
      row.find(SEL_LIST_INPUT_PAUSED),
    ];
  };

  /**
   * Update areas in the list
   */
  this.updateAvailableAreas = function(areas, areaChanges) {
    var rows = this.getAllRows();
    var hasAreaChanges = areaChanges && areaChanges.length;
    rows.each(function() {
      var row = jQuery(this);
      var groupId = String(row.find(SEL_LIST_INPUT_GROUP).val()); // convert to string
      var group = areas[groupId] || {};
      var groupName = group.name || '';
      row.find(SEL_LIST_TEXT_GROUP).text(groupName);

      var isGroupOfRowChanging = hasAreaChanges && areaChanges.indexOf(groupId) >= 0;
      if (isGroupOfRowChanging) {
        var unpauseButton = row.find(SEL_LIST_BTN_UNPAUSE);
        if (group.paused) {
          self.pauseRow(row);
          unpauseButton.prop('disabled', true);
        } else if (self.isRowPaused(row)) {
          self.unpauseRow(row);
          unpauseButton.prop('disabled', false);
        }
      }
    });
  };

  /**
   * Get a list of AREA IDs that are currently being used by tables list
   */
  this.getInUseAreas = function() {
    var rows = this.getAllRows();
    var areas = [];
    rows.each(function() {
      var row = jQuery(this);
      var groupId = String(row.find(SEL_LIST_INPUT_GROUP).val()); // convert to string
      areas.push(groupId);
    });
    return areas;
  };

  this.pauseRow = function(row) {
    row.find(SEL_LIST_INPUT_PAUSED).val(VALUE_PAUSED);
    row.addClass(CSS_CLASS_PAUSED);
  };

  this.unpauseRow = function(row) {
    row.find(SEL_LIST_INPUT_PAUSED).val(VALUE_UNPAUSED);
    row.removeClass(CSS_CLASS_PAUSED);
  };

  this.isRowPaused = function(row) {
    return row.hasClass(CSS_CLASS_PAUSED);
  };

  /**
   * Get a sum of all capacities, using only ACTIVE (unpaused) rows
   */
  this.getTotalCapacity = function() {
    var rows = this.getAllRows();
    var total = 0;
    rows.each(function() {
      var row = jQuery(this);
      if (!row.hasClass(CSS_CLASS_PAUSED)) {
        var capacity = parseInt(row.find(SEL_LIST_INPUT_CAPACITY).val() || 0);
        if (!isNaN(capacity) && capacity) {
          total += capacity;
        }
      }
    });
    return total;
  };

});

// Make class public to outside world
module.exports = TablesList;

},{"../../itemEditor/AbstractList":98,"../../utils/ClassUtils":184,"./TableData":177,"jquery/dist/jquery":14}],180:[function(require,module,exports){
/**
 * TableSetup functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');

var ScrollHelper = require('../../itemEditor/ScrollHelper');
var Confirm     = require('../../modals/Confirm');
var Alert       = require('../../modals/Alert');
var TablesForm  = require('./TablesForm');
var TablesList  = require('./TablesList');

// Class definition
var TableSetup = function() {

  // selector constants
  var SEL_MODULE                      = '.mod-table-setup';

  var SEL_TEMPLATE_ROW                = '.tableSetupRowTemplate';

  var SEL_FORM                        = '.tableSetup-addEditForm';
  var SEL_LIST                        = '.tableSetup-tablesList';
  var SEL_AREAS_LIST                  = '.areasSetup-areasList';
  var SEL_TOTAL_SEATS                 = '.tableSetup-tablesList th.capacity .totalSeats';

  var SEL_DELETE_CONFIRM_MODAL        = '.tableSetup-deleteConfirmModal';
  var SEL_ERROR_ALERT_MODAL           = '.tableSetup-alertModal';

  var confirmModal = new Confirm();
  var alertModal = new Alert();

  var handleFormButtonAddClick = function(tablesList, tablesForm, modal) {
    var onSuccess = function() {
      var dataObject = tablesForm.getDataObjectFromValues();
      tablesList.addRow(dataObject);
      tablesList.refresh();
      tablesForm.clear();
      ScrollHelper.scrollToElement(tablesList.getNode());
    };
    var onFail = function(errorMessage) {
      alertModal.show(modal, errorMessage);
    };
    tablesForm.validateAndProcess(onSuccess, onFail);
  };

  var handleFormButtonCancelClick = function(tablesList, tablesForm) {
    tablesList.markAllRowsAsNotEditing();
    tablesForm.clear();
  };

  var handleFormButtonSaveClick = function(tablesList, tablesForm, modal) {
    var onSuccess = function() {
      var currentRow = tablesForm.getCurrentEditingRow();
      if (currentRow) {
        var dataObject = tablesForm.getDataObjectFromValues();
        tablesList.updateRow(currentRow, dataObject);
        ScrollHelper.scrollToElement(currentRow);
      }
      tablesList.refresh();
      tablesForm.clear();
    };
    var onFail = function(errorMessage) {
      alertModal.show(modal, errorMessage);
    };
    tablesForm.validateAndProcess(onSuccess, onFail);
  };

  var handleListButtonEditClick = function(row, tablesList, tablesForm) {
    tablesList.markAllRowsAsNotEditing();
    tablesList.editRow(row, tablesForm);
    ScrollHelper.scrollToElement(tablesForm.getNode());
  };

  var handleListButtonDeleteClick = function(row, tablesList, tablesForm, modal) {
    var confirmMessage = tablesList.getDeleteConfirmMessage();
    confirmModal.show(modal, confirmMessage).done(function() {
      tablesList.deleteRow(row);
      tablesForm.clear();
      tablesList.refresh();
    });
  };

  var handleListButtonCopyClick = function(row, tablesList, tablesForm) {
    var dataObject = tablesList.buildDataObjectFromRow(row);
    // remove id from data object
    delete dataObject.id;

    // add to list
    var newRow = tablesList.addRow(dataObject);
    tablesList.refresh();
    tablesList.editRow(newRow, tablesForm);
    ScrollHelper.scrollToElement(tablesForm.getNode());
  };

  var handleListRefreshed = function(tablesList, moduleNode) {
    // updte total seat count
    var totalCapacity = tablesList.getTotalCapacity();
    moduleNode.find(SEL_TOTAL_SEATS).text('(' + totalCapacity + ')');
  };

  var handleAreasListRefreshed = function(areasList, tablesList, tablesForm, areaChanges) {
    var areas = areasList.getAreasData();
    tablesList.updateAvailableAreas(areas, areaChanges);
    tablesForm.updateAvailableAreas(areas, areaChanges);
  };

  /**
   * Initialize.
   */
  this.init = function(initNode, areasNodes) {

    self = this;

    // Retrieve and cache dom nodes
    var moduleNodes = initNode.find(SEL_MODULE);

    // Init all matching nodes
    moduleNodes.each(function() {

      var moduleNode = jQuery(this);

      var listRowTemplate = moduleNode.find(SEL_TEMPLATE_ROW).remove();

      var formNode = moduleNode.find(SEL_FORM);
      var tablesListNode = moduleNode.find(SEL_LIST);

      var addEditForm = new TablesForm(formNode);
      var tablesList = new TablesList(tablesListNode, listRowTemplate);

      var deleteConfirmModal = moduleNode.find(SEL_DELETE_CONFIRM_MODAL);
      var errorAlertModal = moduleNode.find(SEL_ERROR_ALERT_MODAL);

      // form events
      formNode.on('itemEditor:editForm:create', function(event) {
        handleFormButtonAddClick(tablesList, addEditForm, errorAlertModal);
      });
      formNode.on('itemEditor:editForm:cancel', function(event) {
        handleFormButtonCancelClick(tablesList, addEditForm);
      });
      formNode.on('itemEditor:editForm:save', function(event) {
        handleFormButtonSaveClick(tablesList, addEditForm, errorAlertModal);
      });

      // list events
      tablesListNode.on('itemEditor:itemsList:rowEdit', function(event, row) {
        handleListButtonEditClick(row, tablesList, addEditForm);
      });
      tablesListNode.on('itemEditor:itemsList:rowDelete', function(event, row) {
        handleListButtonDeleteClick(row, tablesList, addEditForm, deleteConfirmModal);
      });
      tablesListNode.on('itemEditor:itemsList:rowCopy', function(event, row) {
        handleListButtonCopyClick(row, tablesList, addEditForm);
      });
      tablesListNode.on('itemEditor:itemsList:listRefreshed', function(event) {
        handleListRefreshed(tablesList, moduleNode);
      });

      // on areas change event
      areasNodes.on('itemEditor:itemsList:listRefreshed', SEL_AREAS_LIST, function(event, areasList, eventData) {
        var areaChanges = eventData;
        handleAreasListRefreshed(areasList, tablesList, addEditForm, areaChanges);
      });

      // init
      addEditForm.init();
      tablesList.init();

    });

  };

  // get the module nodes
  this.getModules = function(initNode) {
    return initNode.find(SEL_MODULE);
  };

  // refresh the module
  this.refresh = function(initNode) {

    var moduleNodes = initNode.find(SEL_MODULE);

    moduleNodes.each(function() {
      var tablesListNode = jQuery(this).find(SEL_LIST);
      tablesListNode.trigger('itemEditor:itemsList:forceRefresh');
    });

  };

};

// Make class public to outside world
module.exports = TableSetup;

},{"../../itemEditor/ScrollHelper":99,"../../modals/Alert":110,"../../modals/Confirm":111,"./TablesForm":178,"./TablesList":179,"jquery/dist/jquery":14}],181:[function(require,module,exports){
/**
 * Welcome functionality.
*
*/

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');
Tracking = require('../utils/Tracking');

// External libs
jQuery = require('jquery/dist/jquery');

// Class definition
UserNotFound = function() {

    // selector constants
    var SEL_MODULE             	= ".page-home";

	var FORM_ERROR_TYPE			= "form-authentication-error";
	var FORM_EVENT_TYPE			= "error-pageload";
	var FORM_EVENT_NAME			= "error";
	var FORM_ERROR_FIELD_NAME	= "no-field";
	var FORM_ERROR_MESSAGE		= "The user was not found.";

    //initialize adobe datalayer properties
	window._adl.eventInfo = window._adl.eventInfo || {};
	window._adl.error = window._adl.error || {};

    //to update error tracking in adobe datalayer with event info
	var updateDatalayerErrorTracking = function(){
		if (window._satellite && window._adl) {
		  //push eventInfo in _adl
		  _adl.eventInfo = {
			eventName: FORM_EVENT_NAME,
			eventType: FORM_EVENT_TYPE
		  }
	
		  //push all the errors in adobe data layer
		  _adl.error = {
			errorType: FORM_ERROR_TYPE,
			errorMessage: FORM_ERROR_MESSAGE,
			errorFields: FORM_ERROR_FIELD_NAME
		  }
	
		  //fire direct call
		  window._satellite.track('errorCall');
		}
	}

    /**
     * Initialize.
     */
    this.init = function(initNode) {
        self = this;

		// Retrieve and cache dom nodes
		var moduleNodes = initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {
            if(window.config.msg.errorCall === window.config.msg.errorMsg){
                updateDatalayerErrorTracking();
            }
        });
		
    };

};

// Make class public to outside world
module.exports = UserNotFound;
},{"../mediator/mediator":103,"../utils/Tracking":188,"jquery/dist/jquery":14}],182:[function(require,module,exports){


/**
 * User functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
UserNotFound = require('./UserNotFound');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var userNotFound = new UserNotFound();
	
	// Trigger onload activities
	userNotFound.init(initNode);
});
},{"../mediator/mediator":103,"./UserNotFound":181}],183:[function(require,module,exports){
/**
 * ArrayUtils functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');



// Class definition
ArrayUtils = function() {

	/**
	 * Filter and get only the unique values
	 * @param {[]} array Non-null array, can be empty
	 */
	this.unique = function(array) {
		var uniqueValues = [];
		jQuery.each(array, function(index, item) {
			if (jQuery.inArray(item, uniqueValues) === -1) {
				uniqueValues.push(item);
			}
		});
		return uniqueValues;
	};

	/**
	 * Checks if an item is in the given array
	 * @param {[]} array Non-null array, can be empty
	 * @param item Item to be tested for
	 * @param notStrict Equality checking should not be strict, defaults to false
	 */
	this.inArray = function(array, item, notStrict) {
		var found = false;
		jQuery.each(array, function(index, itemInArray) {
			if (notStrict) {
				// loose equals
				if (itemInArray == item) {
					found = true;
					return false; // break loop
				}
			} else {
				// strict equals
				if (itemInArray === item) {
					found = true;
					return false; // break loop
				}
			}
		});
		return found;
	};

};

// singleton pattern
var singleton = new ArrayUtils();

// Make class public to outside world
module.exports = singleton;
},{"jquery/dist/jquery":14}],184:[function(require,module,exports){
/**
 * ClassUtils functionality.
*
*/

// External libs
jQuery = require('jquery/dist/jquery');



var createParentReference = function(instance) {
  var parent = {};
  for (var prop in instance) {
    rememeberMethod(prop, instance, parent);
  }
  return parent;
};

var rememeberMethod = function(prop, instance, parent) {
  var property = instance[prop];
  if (jQuery.isFunction(property)) {
    // make sure context is on the instance and not the copy
    parent[prop] = function() {
      property.apply(instance, arguments);
    };
  }
};

// Class definition
ClassUtils = function() {

  /**
   * Extend class functionality
   * @param {Function} clazz Class definition to extend
   * @param {Function} extension Extension logic
   */
  this.extendClass = function(clazz, extension) {
    return function() {
      clazz.apply(this, arguments);
      this._parent = createParentReference(this); // create copy of function references
      extension.apply(this, arguments);
      return this;
    }
  };

  /**
   * Throw error for method not implemented
   * @param {string} methodName Method name that is unimplemented
   */
  this.throwUnimplementedError = function(methodName) {
    throw '"' + methodName + '" method needs to be implemented for extending class';
  };

};

// singleton pattern
var singleton = new ClassUtils();

// Make class public to outside world
module.exports = singleton;

},{"jquery/dist/jquery":14}],185:[function(require,module,exports){
/**
 * DateUtils functionality.
*
*/



// Class definition
DateUtils = function() {
	
	
	
	/**
	 * Parse a date string with JS - includes fallback for Safari,
	 * which has an odd understanding of how an ISO date should look like.
	 *  
	 * @param date
	 * @returns
	 */
	this.parseDate = function(dateString) {
		var parsed = Date.parse(dateString);
		if (!isNaN(parsed)) {
			//console.log("Parsing date '" + dateString + "' succeeded, result is: " + parsed);
			return parsed; 
		}
		parsed = Date.parse(dateString.replace(/-/g, '/').replace(/[a-z]+/gi,  ' '));
		//console.log("Parsing date '" + dateString + "' failed, used -/ replacement fallback instead: " + parsed);
		return parsed; 
	};
	
	
	
	/**
	 * Formats the given hours and minutes with the given format string.
	 * Supported are:
	 * 
	 *  - HH for 24-hour hours (2 digit)
	 *  - H  for 24-hour hours (1 to 2 digits)
	 *  - hh for 12-hour-clock hours (2 digit)
	 *  - h  for 12-hour-clock hours (1 to 2 digits)
	 *  - mm for minutes (2 digit)
	 *  - m  for minutes (1 to 2 digits)
	 *  - a  for AM/PM
	 *  
	 *  You can use balanced single-quotes to escape text, for example:
	 *  HH:mm 'Uhr'
	 *  
	 * @param hours
	 * @param minutes
	 * @param format
	 * @returns formatted time
	 */
	this.formatTime = function(hours, minutes, format) {

		var hours = parseInt(hours);
		var minutes = parseInt(minutes);

		var amPM = (hours >= 12) ? "pm" : "am";
		
		var hoursPm = hours;
		if (hoursPm > 12) {
			hoursPm -= 12;
		} else  if (hoursPm == 0) {
			hoursPm = 12;
		}
		
		var hoursPadded 	= (hours	< 10 ? "0" + hours		: hours);
		var hoursPmPadded 	= (hoursPm	< 10 ? "0" + hoursPm	: hoursPm);
		var minutesPadded 	= (minutes	< 10 ? "0" + minutes	: minutes);
		
		var formattedTime 	= format;
		formattedTime 		= formattedTime.replace(/HH(?=(?:(?:[^']*'){2})*[^']*$)/,	hoursPadded);
		formattedTime 		= formattedTime.replace(/H(?=(?:(?:[^']*'){2})*[^']*$)/, 	hours);
		formattedTime 		= formattedTime.replace(/hh(?=(?:(?:[^']*'){2})*[^']*$)/, 	hoursPmPadded);
		formattedTime 		= formattedTime.replace(/h(?=(?:(?:[^']*'){2})*[^']*$)/, 	hoursPm);
		formattedTime		= formattedTime.replace(/mm(?=(?:(?:[^']*'){2})*[^']*$)/,	 minutesPadded);
		formattedTime 		= formattedTime.replace(/m(?=(?:(?:[^']*'){2})*[^']*$)/, 	minutes);
		formattedTime 		= formattedTime.replace(/a(?=(?:(?:[^']*'){2})*[^']*$)/, 	amPM);		
		formattedTime 		= formattedTime.replace(/'/g, '');
		
		return formattedTime;
	};
	
	
	
	/**
	 * Returns a date from a string, based on parseDate().
	 * 
	 * @param dateString
	 * @returns
	 */
	this.toDate = function(dateString) {
		return new Date(this.parseDate(dateString));
	};



};

// Make class public to outside world
module.exports = DateUtils;
},{}],186:[function(require,module,exports){
/**
 * GradientTableUtils functionality.
*
*/

jQuery = require('jquery/dist/jquery');

// Class definition
GradientTableUtils = function() {

    /**
     * @param gradientShowcase the module where the gradient example is built 
     * @param gradientArray array that holds the strings with colors of the gradient
     * 
     */
    this.showGradientTable = function(gradientShowcase, gradientArray){
      var gradientTable_body = '<table class="gradientTable" >';

      for(var j = 0; j < gradientArray.length; j++){
        gradientTable_body += '<td class="gradientCell" style="background-color: ' + gradientArray[j] + ';"> </td>';
      }
      gradientTable_body += '</table>'
      gradientShowcase.html(gradientTable_body);
    }

    /**
    * @param reservationTable the module where the table is built
    * @param numberofRows number of rows of the table
    * @param numberOfCols number of cols of the table
    * @param minYear minimum year to be displayed
    * @param monthsArray array that holds the strings with the names of the months (short names)
    * @returns
    */
    this.BuildTable = function(reservationTable, numberofRows, numberOfCols, minYear, monthsArray){

      var table_body = '<table class="reservationTableGradient" "cellspacing="0" cellpadding="0">';

      for(var i = 0; i <= numberofRows; i++){ 
          table_body += '<tr class="tableCellRow">';

        for(var j = 0; j < numberOfCols; j++){
            if(i == 0 && j == 0){
              table_body += '<td class="tableHeader"> </td>'; 
            }
            if(i==0){
              table_body += '<td class="tableHeader">' + monthsArray[j] + '</td>'; 
              continue;
            }
            if(j==0){
              table_body += '<td class="tableYearCell" >' + minYear  + '</td>';
              minYear = minYear + 1;
              
            }
            table_body += '<td class = "tableCellColumn">' + ' </td>';
        }
        table_body +='</tr>'
      }
      table_body += '</table>';

      reservationTable.html(table_body);
    };

    /**
     * @param minYear minimum year to take into consideration 
     * @param maxYear maximum year to take into consideration 
     * @param minNumber min number to take into consideration when calculating the average
     * @param maxNumber max number to take into consideration when calculating the average
     * @param datesMap array that holds data for calculating the numbers { (month, nb per month)}
     * @param gradientArray array that holds the strings with colors of the gradient
     * @returns
    */
    this.BuildGradient = function(minYear, maxYear, minNumber, maxNumber, datesMap, gradientArray){
      
      var keysArrayFromMap = jQuery.map(datesMap, function(value, index){
        return [index]
      });
      
      var valueArrayFromMap = jQuery.map(datesMap, function(value, index){
          return [value]
      });

      if(keysArrayFromMap == null){
        return;
      }
      getValue = function (key) {
        var index = 0;
        for(var index = 0; index < keysArrayFromMap.length; index++){
          if(keysArrayFromMap[index] == key){
            return valueArrayFromMap[index];
          }
        }
      }
      var tableColumn = jQuery('.reservationTableGradient > tbody > tr').children(".tableCellColumn");
      var cellColor;
      var textColor;
      var startMonth;
      
      if(keysArrayFromMap.length > 0){
        startMonth = parseInt(keysArrayFromMap[0].split("-")[1]);
      }

      var tableCellIndex = 0;

      for(var year = minYear; year <= maxYear; year++){
        for(var month = 1; month <= 12; month++){
            var stringMonth =  (month < 10 ? "0" : "") + month;  
            var key = year + "-" + stringMonth;
            var numberReservations = getValue(key);
            if(numberReservations == null && tableCellIndex > startMonth-1){

              numberReservations = 0;
            }else{
              ColorCell(tableColumn, tableCellIndex, "transparent", "white", '');
            }
            
            if(numberReservations == 0){
              ColorCell(tableColumn, tableCellIndex, gradientArray[0], "black", numberReservations);
            }else{
              cellColor  = GetCellColor(minNumber,maxNumber,getValue(key), gradientArray);
              textColor  = GetTextColor(minNumber,maxNumber,getValue(key));
              ColorCell(tableColumn, tableCellIndex, cellColor, textColor, numberReservations);
            }
            
            tableCellIndex++;
           }  
      } 
    }

    GetCellColor = function(minNumber, maxNumber ,actualReservation, gradientArray){
        var median = maxNumber + minNumber;
        var percent = (actualReservation/median) * 100;
        switch(true){
          case percent < 20:
              return gradientArray[0];
          case percent < 40:
              return gradientArray[1];
          case percent < 60:
              return gradientArray[2];
          case percent < 80:
              return gradientArray[3];
          case percent <= 100:
              return gradientArray[4];
        }
    }

    GetTextColor = function(minNumber, maxNumber ,actualReservation){
      var median = maxNumber + minNumber;
      var percent = (actualReservation/median) * 100;
      switch(true){
        case percent < 60:
            return "black";
        case percent <= 100:
              return "white";
        }
    }
    
    ColorCell = function(tableColumn, cellIndex, cellColor, textColor, colorInput){
      jQuery(tableColumn[cellIndex]).css("background-color", cellColor); 
      jQuery(tableColumn[cellIndex]).css("color", textColor); 
      jQuery(tableColumn[cellIndex]).text(colorInput);
    }

};

// Make class public to outside world
module.exports = GradientTableUtils;

},{"jquery/dist/jquery":14}],187:[function(require,module,exports){
/**
 * StringUtils functionality.
*
*/



// Class definition
StringUtils = function() {

	/**
	 * Find an replace all instances of multiple replacements.
	 * e.g.
	 * var replacements = { '%%FIRST_NAME%%': 'Bob', '%%LAST_NAME%%': 'Smith' };
	 * var replaced = findAndReplaceAll('Hello %%FIRST_NAME%% %%LAST_NAME%%, replacements);
	 * replaced === 'Hello Bob Smith'
	 *
	 * @param {*} text Original text to be changed
	 * @param {Object} searchReplacements Key-value pairs
	 */
	this.findAndReplaceAll = function(text, searchReplacements) {
		for (var search in searchReplacements) {
			var replacement = searchReplacements[search];
			text = text.replace(new RegExp(search, 'g'), replacement);
		}
		return text;
	};

	/**
	 * Pad a number from the left to a given length.
	 * @param {*} num A number to be padded
	 * @param {int} length Min-length of the padded number
	 * @param {String} pad Character for padding, defaults to '0' (zero)
	 */
	this.numLeftPad = function(num, length, pad) {
		pad = pad || '0';
		num = ('' + (num || '')).trim();
		var lengthDiff = length - num.length;
		while (lengthDiff > 0) {
			lengthDiff--;
			num = pad + num;
		}
		return num;
	};

};

// singleton pattern
var singleton = new StringUtils();

// Make class public to outside world
module.exports = singleton;
},{}],188:[function(require,module,exports){
/**
 * Tracking functionality.
*
*/

/**
 * Helper method for pretty printing
 */
var displayLog = function(trackerName, args) {
  var firstArg = args.shift();
  args.unshift('color: #0000ff');
  args.unshift('background: #222; color: #bada55');
  args.unshift('%c ' + trackerName + ': %c ' + firstArg); // this should be the first, unshift happens in reverse
  console.log.apply(window, args);
};

var getArgsArray = function(rawArgs) {
  var args = [];
  for (var i = 0; i < rawArgs.length; i++) {
    args.push(rawArgs[i]);
  }
  return args;
};

var isLocal = function() {
  return window.location.hostname === "localhost";
};


Adobe = function() {

  var self = this;

  var DEBUG_TRACKER_NAME = 'ADOBE TRACKER';

  self._isTrackerLoaded = false;
  self._isTrackingEnabled = true;

  self._eventsForWhenReady = [];

  self._isDebugging = isLocal();

  document.addEventListener('tracking:loaded', function(e) {
    self._isTrackerLoaded = true;
    self._debug('loaded');
    self._triggerEventsAtReady();
  }, false);

  this._getTracker = function() {
    return window._satellite;
  };

  this._addEventForWhenReady = function(func, args) {
    // only do this when tracker is not loaded,
    // since we will be calling the original methods again
    // and we want to avoid an infinite loop
    if (!self._isTrackerLoaded) {
      self._eventsForWhenReady.push({
        func: func,
        args: args
      });
    }
  };

  this._triggerEventsAtReady = function() {
    // execute each event
    var events = self._eventsForWhenReady;
    events.forEach(function(event) {
      var func = self[event.func];
      if (func) {
        func.apply(self, event.args);
      }
    });
    // clear events list
    self._eventsForWhenReady = [];
  };

  this._debug = function() {
    if (self._isDebugging && arguments.length) {
      displayLog(DEBUG_TRACKER_NAME, getArgsArray(arguments));
    }
  };

  /**
   * If debugging is enabled, the tracking data will be logged to JS console.
   * @param {boolean} isDebugging Flag to set debugging on or off
   */
  this.setDebugging = function(isDebugging) {
    self._isDebugging = isDebugging;
  };

  /**
   * Manually set vars for "satellite" tracking
   * @param {Object} vars An object with key-value pairs
   */
  this.setVars = function(vars) {
    if (!vars) {
      return;
    }

    var funcName = 'setVars'; // update this if this method name changes

    var tracker = self._getTracker();
    if (tracker) {
      // tracker is ready, proceed
      for (var key in vars) {
        if (vars.hasOwnProperty(key)) {
          if (self._isTrackingEnabled) {
            tracker.setVar(key, vars[key]);
          }
          self._debug(funcName, key, vars[key]);
        }
      }
    } else {
      // be ready for when tracker is ready
      self._addEventForWhenReady(funcName, getArgsArray(arguments));
    }
  };

  /**
   * Trigger the "satellite" tracking.
   * @param {string} event The name of the event to track
   * @param {Object} vars An object with key-value pairs to be set as "vars" before triggering the tracking
   */
  this.track = function(event, vars) {
    if (!event) {
      return;
    }

    var funcName = 'track'; // update this if this method name changes

    var tracker = self._getTracker();
    if (tracker) {
      // tracker is ready, proceed
      self.setVars(vars);
      if (self._isTrackingEnabled) {
        tracker.track(event);
      }
      self._debug(funcName, event);
    } else {
      // be ready for when tracker is ready
      self._addEventForWhenReady(funcName, getArgsArray(arguments));
    }
  };


    /**
     * Trigger the ADV tracking.
     * @param {string} status The status of the ADV toogle (on, off)
     */
    this.ADVToggle = function(status) {
      if (!status) {
        return;
      }
  
      var funcName = 'ADVToggle'; // update this if this method name changes
  
      var tracker = self._getTracker();
      if (tracker) {
        // tracker is ready, proceed
        if (self._isTrackingEnabled) {
          /* commenting as no marketing cookie available */
          //window.ADVToggle(status);
        }
        self._debug(funcName, status);
      } else {
        // be ready for when tracker is ready
        self._addEventForWhenReady(funcName, getArgsArray(arguments));
      }
    };

};


// Class definition
Tracking = function() {

  this.adobe = new Adobe();

};

var trackingSingleton = new Tracking();

// Make the singleton public to outside world
module.exports = trackingSingleton;

},{}],189:[function(require,module,exports){
/**
 * UserInterfaceUtils functionality.
*
*/

jQuery = require('jquery/dist/jquery');

var SEL_NAVBAR = '.navbar';


var SCROLL_TO_ELEMENT_DELAY			= 800;
var MAX_NUM 						= Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1; // 9007199254740991



// we can cache this, since device will not change
var isDeviceMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)

var screenSizes = {
	'xs': { min: 0, max: 767 },
	'sm': { min: 768, max: 991 },
	'md': { min: 992, max: 1199 },
	'lg': { min: 1200, max: MAX_NUM }
};



// Class definition
UserInterfaceUtils = function() {

	var self = this;

	/**
	 * Smooth scrolls to a given element.
	 *
	 * @param {*} element The element to scroll to.
	 * @param {number} offsetTop An offset to handle anything at the top, such as navbar
	 * @param {number} delay The time taken (in milliseconds) for the scrolling transition, defaults to 800
	 */
	this.scrollToElement = function(element, offsetTop, delay) {
		var elem = jQuery(element)
		if (elem.length) {
			offsetTop = offsetTop || 0;
			delay = delay === undefined ? SCROLL_TO_ELEMENT_DELAY : delay;
			var scrollTop = elem.first().offset().top - offsetTop;
			jQuery('html, body').animate({
				scrollTop: scrollTop
			}, delay);
		}
	};

	
	/**
	 * Detect the browser and its version
	*/
	this.getBrowser = function() {
		var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
		if(/trident/i.test(M[1])){
			tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
			return {name:'IE',version:(tem[1]||'')};
			}   
		if(M[1]==='Chrome'){
			tem=ua.match(/\bOPR|Edge\/(\d+)/)
			if(tem!=null)   {return {name:'Opera', version:tem[1]};}
			}   
		M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
		if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
		return {
		name: M[0],
		version: M[1]
		};
	}

	/**
	 * Smooth scrolls to a given element, but considering navbar height.
	 * The scrolling only happens in XS device size.
	 *
	 * @param {*} element The element to scroll to.
	 * @param {number} offsetTop An offset to handle anything at the top in additional to navbar
	 * @param {number} delay The time taken (in milliseconds) for the scrolling transition, defaults to 800
	 */
	this.scrollToElementXsConsiderNavbar = function(element, offsetTop, delay) {
		if (self.isScreenSize('xs')) {
			self.scrollToElementConsiderNavbar(element, offsetTop, delay);
		}
	};

	/**
	 * Smooth scrolls to a given element, but considering navbar height.
	 *
	 * @param {*} element The element to scroll to.
	 * @param {number} offsetTop An offset to handle anything at the top in additional to navbar
	 * @param {number} delay The time taken (in milliseconds) for the scrolling transition, defaults to 800
	 */
	this.scrollToElementConsiderNavbar = function(element, offsetTop, delay) {
		offsetTop = offsetTop || 0;
		offsetTop += jQuery(SEL_NAVBAR).outerHeight();
		self.scrollToElement(element, offsetTop, delay);
	};

	/**
	 * Checks if the current device is a mobile device by looking at the userAgent string
	 */
	this.isDeviceMobile = function() {
		return isDeviceMobile;
	};

	/**
	 * Checks if the current screensize fits the Bootstrap breakpoints
	 *
	 * @param {string} size The boostrap size code ('xs', 'sm', 'md', 'lg')
	 */
	this.isScreenSize = function(size) {
		var sizeBreakPoints = screenSizes[size];
		if (!sizeBreakPoints) {
			return false;
		}
		return window.innerWidth >= sizeBreakPoints.min && window.innerWidth <= sizeBreakPoints.max;
	};

};

// singleton pattern
var singleton = new UserInterfaceUtils();

// Make class public to outside world
module.exports = singleton;

},{"jquery/dist/jquery":14}],190:[function(require,module,exports){
/**
 * WizardButtons functionality.
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');

// selector constants
var SEL_MODULE						= '.mod-wizard-buttons';

var SEL_PARENT_CONTAINER			= '.wizard-step-content';

var SEL_AUTO_VALIDATE				= '.auto-validate-continue-button';
var SEL_CUSTOM_VALIDATE				= '.custom-validate-continue-button';
var SEL_REQUIRED_TO_CONTINUE		= '.required-to-continue';

var SEL_CONTINUE_BUTTON				= '.btn-continue';

var initValidateInputs = function(container, buttonContinue) {
	container.on('change keyup', SEL_REQUIRED_TO_CONTINUE, function() {
		buttonContinue.prop('disabled', !allowToContinue(container));
	});
	buttonContinue.prop('disabled', !allowToContinue(container));
};

var allowToContinue = function(container) {
	var requiredFields = container.find(SEL_REQUIRED_TO_CONTINUE);

	// no required fields? then we can continue
	if (!requiredFields.length) {
		return true;
	}

	var isValid = true;
	requiredFields.each(function() {
		var field = jQuery(this);
		if (!isRequiredFieldValid(field)) {
			isValid = false;
			return false;
		}
	});

	return isValid;
};

var isRequiredFieldValid = function(field) {
	var value = field.val() || '';

	// is checkbox? is it selected?
	if (field.is(':checkbox')) {
		return field.is(':checked');
	}

	// other field, basically text/select and is not empty value
	return value.trim() !== '';
};

// Class definition
WizardButtons = function() {

	// self references
	var self;

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 			= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode = jQuery(this);

			var parentContainer = moduleNode.parents(SEL_PARENT_CONTAINER);
			var autoValidateContainer = parentContainer.find(SEL_AUTO_VALIDATE);
			var buttonContinue = moduleNode.find(SEL_CONTINUE_BUTTON);

			// should auto validate?
			if (autoValidateContainer.length) {
				initValidateInputs(autoValidateContainer, buttonContinue);
			} else if (!parentContainer.find(SEL_CUSTOM_VALIDATE).length) {
				// only enable is there are no custom validations
				buttonContinue.prop('disabled', false);
			}

		});

	};

};

// Make class public to outside world
module.exports = WizardButtons;
},{"jquery/dist/jquery":14}],191:[function(require,module,exports){
/**
 * WizardDiscountHours functionality.
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');


// Class definition
WizardDiscountHours = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-wizard-discount-hours';
	var SEL_MAIN_FORM					= '#wizardFlowStepForm'

	var SEL_POST_BUTTONS_SECTION		= '#post-buttons-block'

	var SEL_DISCOUNT_LIST				= '.discountHours-itemsList';


	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 			= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode 			= jQuery(this);
			var mainForm 			= moduleNode.parents(SEL_MAIN_FORM);

			var postButtonsSection	= mainForm.find(SEL_POST_BUTTONS_SECTION);

			var discountsList		= moduleNode.find(SEL_DISCOUNT_LIST);
			
			discountsList.trigger('itemEditor:itemsList:forceRefresh');


		});

	};

};

// Make class public to outside world
module.exports = WizardDiscountHours;
},{"jquery/dist/jquery":14}],192:[function(require,module,exports){
/**
 * WizardGroupSizes functionality.
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');

// FormInputFilter, to handle the input for seat numbers
FormInputFilter = require('../form/FormInputFilter');


// Class definition
WizardGroupSizes = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-wizard-group-sizes';
	var SEL_WIZARD_STEP_NODE			= '.wizard-step-content';
	var SEL_CONTINUE_BUTTON				= '.mod-wizard-buttons .btn-continue';


	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 			= initNode.find(SEL_MODULE);
		var wizardStepNode 			= initNode.find(SEL_WIZARD_STEP_NODE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var buttonContinue		= wizardStepNode.find(SEL_CONTINUE_BUTTON);

			buttonContinue.prop('disabled',false);

		});

	};

};

// Make class public to outside world
module.exports = WizardGroupSizes;
},{"../form/FormInputFilter":86,"jquery/dist/jquery":14}],193:[function(require,module,exports){
/**
 * WizardReservationHours functionality.
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');
FormInputFilter  = require('../form/FormInputFilter');

// Class definition
WizardReservationHours = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-wizard-reservation-hours';

	var SEL_RESERVATION_HOURS_MODULE	= '.mod-reservation-hours-alternative';
	var SEL_PARENT_CONTAINER			= '.wizard-step-content';
	var SEL_RESERVATION_HOURS_ITEM 		= '.reservation-hours-item';
	var SEL_CONTINUE_BUTTON				= '.mod-wizard-buttons .btn-continue';


	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 			= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode		= jQuery(this);

			var reservationHoursAlternativeNode = moduleNode.find(SEL_RESERVATION_HOURS_MODULE);
			var parentContainer = moduleNode.parents(SEL_PARENT_CONTAINER);
			var buttonContinue = parentContainer.find(SEL_CONTINUE_BUTTON);

			reservationHoursAlternativeNode.on('reservationHours:wizard:listRefreshed', function(event, list) {
				var reservationHoursList = moduleNode.find(SEL_RESERVATION_HOURS_ITEM);
				var hasItems = reservationHoursList.length > 0;
				buttonContinue.prop('disabled', !hasItems);
			});

			reservationHoursAlternativeNode.trigger('reservationHours:wizard:listRefreshed');

		});

	};

};

// Make class public to outside world
module.exports = WizardReservationHours;
},{"../form/FormInputFilter":86,"jquery/dist/jquery":14}],194:[function(require,module,exports){
/**
 * WizardTables functionality.
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');
FormInputFilter  		= require('../form/FormInputFilter');
TableSetupAlternative 	= require('../tableSetup/alternative/TableSetupAlternative');

var Alert					= require('../modals/Alert');

// Class definition
WizardTables = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-wizard-tables';
	var SEL_PARENT_CONTAINER			= '.wizard-step-content';
	var SEL_CONTINUE_BUTTON				= '.mod-wizard-buttons .btn-continue';
	var SEL_MODAL_VALIDATION_ALERT		= '.validationAlertModal';

	var SEL_RADIO_OPTIONS				= '.form-radio-button';
	var SEL_RADIO_BUTTON				= 'input[type="radio"]';

	var SEL_SEAT_CONFIGURATION			= '#wizard-tables-useTablesConfiguration-false';
	var SEL_TABLE_CONFIGURATION			= '#wizard-tables-useTablesConfiguration-true';

	var SEL_SEAT_NUMBER					= '#wizard-seatNumbers-seatNumbers';
	var SEL_TABLES_LIST					= '.mod-table-setup .itemEditor-itemList';
	var SEL_SEAT_CONFIGURATION_CARD_WIZARD	= '.seatConfigurationCard';
	var SEL_WIZARD_SEAT_NUMBERS				= '#wizard-seatNumbers-seatNumbers';

	var DATA_ATTR_EXTRA					= 'extraSelector';



	var inputFilter = new FormInputFilter();	
	var alertModal = new Alert();
	/**
	 * Show the extra block for a given radio button. By default, the extra block will slide down.
	 * @param {*} radioNode Radio button node
	 * @param {*} disableAnimation Disables the sliding down and instantly displays the extra block. Defaults to false.
	 */
	var showExtraBlock = function(moduleNode, radioNode, disableAnimation) {
		var extraBlockSelector = radioNode.closest(SEL_RADIO_OPTIONS).data(DATA_ATTR_EXTRA);
		var extraBlock = moduleNode.find(extraBlockSelector);
		if (disableAnimation) {
			extraBlock.show();
		} else {
			extraBlock.slideDown();
		}
	};

	/**
	 * Hide all the given extra blocks.
	 * @param {*} extraBlock List of all the extra nodes.
	 */
	var hideExtraBlock = function(extraBlock) {
		extraBlock.each(function() {
			jQuery(this).slideUp();
		});
	};


	// enable/disable continue button when setting up tables
	var initTableSetupValidation = function(tableSelect, tablesList, buttonContinue) {

		// enable/disable continue button when setting up tables
		tablesList.on('itemEditor:itemsList:listRefreshed', function(event, list) {
			if (tableSelect.is(':checked')) {
				var hasItems = list.getAllRows().length > 0;
				buttonContinue.prop('disabled', !hasItems);
			}
		});
		tablesList.trigger('itemEditor:itemsList:forceRefresh');

		tableSelect.on('change', function() {
			// check before force refresh, as this is a heavy refresh
			if (tableSelect.is(':checked')) {
				tablesList.trigger('itemEditor:itemsList:forceRefresh');
			}
		});

	};

	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 			= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {
			
			var moduleNode		= jQuery(this);
			var parentContainer = moduleNode.parents(SEL_PARENT_CONTAINER);
			var validationAlertModal = moduleNode.find(SEL_MODAL_VALIDATION_ALERT);
			var buttonContinue	= parentContainer.find(SEL_CONTINUE_BUTTON);

			var radioButtons	= moduleNode.find(SEL_RADIO_BUTTON);

			var seatSelect			= moduleNode.find(SEL_SEAT_CONFIGURATION);
			var tableSelect			= moduleNode.find(SEL_TABLE_CONFIGURATION);
			
			var seatInput			= moduleNode.find(SEL_SEAT_NUMBER);
			var defaultSeatNumbers	= seatInput.val();
			
			var tablesList			= moduleNode.find(SEL_TABLES_LIST);
			var seatConfigurationCard = moduleNode.find(SEL_SEAT_CONFIGURATION_CARD_WIZARD);

			var radioExtras		= moduleNode.find(SEL_RADIO_OPTIONS).map(function() {
				var extraBlockSelector = jQuery(this).data(DATA_ATTR_EXTRA);
				return moduleNode.find(extraBlockSelector);
			});
			
			radioButtons.each(function() {
				var radioButton = jQuery(this);
				if (radioButton.prop('checked')) {
					showExtraBlock(moduleNode, radioButton, true);
				}
			});

			radioButtons.on('change', function() {
				var radioButton = jQuery(this);
				var extraBlockSelector = radioButton.closest(SEL_RADIO_OPTIONS).data(DATA_ATTR_EXTRA);
				var extraBlock = moduleNode.find(extraBlockSelector);
				var extraBlockElement = extraBlock.length > 0 ? extraBlock.get(0) : null;

				var otherExtras = radioExtras.filter(function() {
					return jQuery(this).get(0) !== extraBlockElement;
				});
				hideExtraBlock(otherExtras);
				showExtraBlock(moduleNode, radioButton);
			});

			if (tableSelect.is(':checked')) {
				jQuery('.edit-card').show();
			}
			
			tableSelect.on('change',function(){
				jQuery('.edit-card').show();
			});

			initTableSetupValidation(tableSelect, tablesList, buttonContinue);
			// if table reservations selected,
			// reset the seat input upon submitting
			buttonContinue.bind('click', function(){
				if (tableSelect.is(':checked')) {
					seatInput.val(defaultSeatNumbers);
				}
			});

			buttonContinue.prop('disabled',false);
		});

	};

};

// Make class public to outside world
module.exports = WizardTables;
},{"../form/FormInputFilter":86,"../modals/Alert":110,"../tableSetup/alternative/TableSetupAlternative":171,"jquery/dist/jquery":14}],195:[function(require,module,exports){
/**
 * WizardWebsiteIntegration functionality.
 *
 */

// External libs
jQuery = require('jquery/dist/jquery');


// Class definition
WizardWebsiteIntegration = function() {

	// self references
	var self;

	// selector constants
	var SEL_MODULE						= '.mod-wizard-website-integration';
	var SEL_RADIO_OPTIONS				= '.form-radio-button';
	var SEL_RADIO_BUTTON				= 'input[type="radio"]';
	var SEL_RADIO_EXTRA					= '.form-radio-button-extra';
	var SEL_RADIO_BUTTON_YES			= '#wizard-websiteIntegration-usingInternetPresence-yes';
	var SEL_INPUT_DEV_EMAIL				= '#wizard-websiteIntegration-developerEmail';

	var SEL_PARENT_CONTAINER			= '.wizard-step-content';
	var SEL_CONTINUE_BUTTON				= '.mod-wizard-buttons .btn-continue';


	/**
	 * Show the extra block for a given radio button. By default, the extra block will slide down.
	 * @param {*} radioNode Radio button node
	 * @param {*} disableAnimation Disables the sliding down and instantly displays the extra block. Defaults to false.
	 */
	var showExtraBlock = function(radioNode, disableAnimation) {
		var extraBlock = radioNode.closest(SEL_RADIO_OPTIONS).find(SEL_RADIO_EXTRA);
		if (disableAnimation) {
			extraBlock.show();
		} else {
			extraBlock.slideDown();
		}
	};

	/**
	 * Hide all the given extra blocks.
	 * @param {*} extraBlock List of all the extra nodes.
	 */
	var hideExtraBlock = function(extraBlock) {
		extraBlock.slideUp();
	};

	/**
	 * Enable / disable continue buttons depending on at least one radio being selected.
	 * @param {*} buttonContinue
	 * @param {*} radioButtons
	 */
	var updateContinueButtonStatus = function(buttonContinue, radioButtons) {
		var hasSelection = radioButtons.filter(':checked').length > 0;
		buttonContinue.prop('disabled', !hasSelection);
	};


	/**
	 * Initialize.
	 */
	this.init = function(initNode) {

		self = this;

		// Retrieve and cache dom nodes
		var moduleNodes 			= initNode.find(SEL_MODULE);

		// Init all matching nodes
		moduleNodes.each(function() {

			var moduleNode		= jQuery(this);
			var radioButtons	= moduleNode.find(SEL_RADIO_BUTTON);
			var radioExtras		= moduleNode.find(SEL_RADIO_EXTRA);

			var radioButtonYes	= radioButtons.filter(SEL_RADIO_BUTTON_YES);
			var inputDevEmail	= moduleNode.find(SEL_INPUT_DEV_EMAIL);

			var parentContainer = moduleNode.parents(SEL_PARENT_CONTAINER);
			var buttonContinue = parentContainer.find(SEL_CONTINUE_BUTTON);

			var clearDevEmailIfYesIsSelected = function() {
				if (radioButtonYes.prop('checked')) {
					inputDevEmail.val('');
				}
			};

			radioButtons.each(function() {
				var radioButton = jQuery(this);
				if (radioButton.prop('checked')) {
					showExtraBlock(radioButton, true);
				}
			});

			radioButtons.on('change', function() {
				var radioButton = jQuery(this);
				hideExtraBlock(radioExtras);
				showExtraBlock(radioButton);
				clearDevEmailIfYesIsSelected();
				updateContinueButtonStatus(buttonContinue, radioButtons);
			});

			updateContinueButtonStatus(buttonContinue, radioButtons);

		});

	};

};

// Make class public to outside world
module.exports = WizardWebsiteIntegration;
},{"jquery/dist/jquery":14}],196:[function(require,module,exports){


/**
 * User functionality.
 */

// Mediator module (handles event delegation)
var mediator = require('../mediator/mediator');

// Modules
WizardGroupSizes = require('./WizardGroupSizes');
WizardWebsiteIntegration = require('./WizardWebsiteIntegration');
WizardReservationHours = require('./WizardReservationHours');
WizardTables = require('./WizardTables');
WizardButtons = require('./WizardButtons');
WizardDiscountHours = require('./WizardDiscountHours');

// Handle application start
mediator.subscribe("app:started", function(initNode) {

	// Instanciate implementing class
	var wizardGroupSizes = new WizardGroupSizes();
	var wizardWebsiteIntegration = new WizardWebsiteIntegration();
	var wizardReservationHours = new WizardReservationHours();
	var wizardTables = new WizardTables();
	var wizardButtons = new WizardButtons();
	var wizardDiscountHours = new WizardDiscountHours();

	// Trigger onload activities
	wizardGroupSizes.init(initNode);
	wizardWebsiteIntegration.init(initNode);
	wizardReservationHours.init(initNode);
	wizardTables.init(initNode);
	wizardButtons.init(initNode);
	wizardDiscountHours.init(initNode);

});

},{"../mediator/mediator":103,"./WizardButtons":190,"./WizardDiscountHours":191,"./WizardGroupSizes":192,"./WizardReservationHours":193,"./WizardTables":194,"./WizardWebsiteIntegration":195}]},{},[22]);
